/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(579);
	__webpack_require__(1254);
	module.exports = __webpack_require__(549);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(124);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(52);
	var hide = __webpack_require__(36);
	var redefine = __webpack_require__(37);
	var ctx = __webpack_require__(53);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PRODUCTION = ("production") === 'production';
	
	// export const API_PATH = PRODUCTION ? 'https://api.blayzr.com/api/v1' : '/api/v1'
	var API_PATH = exports.API_PATH = 'https://api.blayzr.com/api/v1';
	
	var PICASSO_SOCKET_PRODUCTION = window.location.host === 'blayzr.com' ? 'wss://picasso.blayzr.com/ws' : 'ws://ec2-52-208-98-63.eu-west-1.compute.amazonaws.com:8888/ws';
	var PICASSO_SOCKET = exports.PICASSO_SOCKET = PRODUCTION ? PICASSO_SOCKET_PRODUCTION : 'ws://localhost:8888/ws';
	
	var ORCHESTRA_SOCKET = exports.ORCHESTRA_SOCKET = PRODUCTION ? 'wss://api.blayzr.com:8765' : 'ws://localhost:8765';
	var ORCHESTRA_SOCKET_2 = exports.ORCHESTRA_SOCKET_2 = PRODUCTION ? 'wss://api.blayzr.com:8766' : 'ws://localhost:8766';
	var ORCHESTRA_TV_SOCKET = exports.ORCHESTRA_TV_SOCKET = PRODUCTION ? 'wss://api.blayzr.com:8865' : 'ws://localhost:8865';
	var ORCHESTRA_TV_SOCKET_2 = exports.ORCHESTRA_TV_SOCKET_2 = PRODUCTION ? 'wss://api.blayzr.com:8866' : 'ws://localhost:8866';
	var ORCHESTRA_PLAYER_HOST = exports.ORCHESTRA_PLAYER_HOST = PRODUCTION ? 'http://player.blayzr.com.s3-website-eu-west-1.amazonaws.com' : 'http://localhost:8080';
	var ORCHESTRA_PLAYER_JOIN_PATH = exports.ORCHESTRA_PLAYER_JOIN_PATH = ORCHESTRA_PLAYER_HOST + '/join/:id';
	var ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH = exports.ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH = ORCHESTRA_PLAYER_HOST + '/join-with-code/:code';
	
	var SUPER_ADMINS = exports.SUPER_ADMINS = [1, 3, 38]; // Hardcoded superadmin user IDs
	
	var ENDPOINT_LOGIN = exports.ENDPOINT_LOGIN = '/user/login';
	var ENDPOINT_SHARING = exports.ENDPOINT_SHARING = '/sharing/:code';
	var ENDPOINT_FETCH_EXTERNAL_SHARES = exports.ENDPOINT_FETCH_EXTERNAL_SHARES = '/sharing/all';
	var ENDPOINT_EXTEND_EXTERNAL_SHARE = exports.ENDPOINT_EXTEND_EXTERNAL_SHARE = '/tokens/sharing/extend/:code';
	var ENDPOINT_REFRESH_TOKENS = exports.ENDPOINT_REFRESH_TOKENS = '/refresh/session';
	var ENDPOINT_REFRESH_AWS = exports.ENDPOINT_REFRESH_AWS = '/refresh/aws';
	var ENDPOINT_ALBUMS = exports.ENDPOINT_ALBUMS = '/albums';
	var ENDPOINT_FAVOURITE_ALBUMS = exports.ENDPOINT_FAVOURITE_ALBUMS = '/favourites';
	var ENDPOINT_ALBUM = exports.ENDPOINT_ALBUM = '/album/:id';
	var ENDPOINT_NEW_ALBUM = exports.ENDPOINT_NEW_ALBUM = '/album';
	var ENDPOINT_IMAGE_SEARCH = exports.ENDPOINT_IMAGE_SEARCH = '/search';
	var ENDPOINT_IMAGE = exports.ENDPOINT_IMAGE = '/image/:id';
	var ENDPOINT_FLAG_IMAGE = exports.ENDPOINT_FLAG_IMAGE = '/image/:id/flag';
	var ENDPOINT_RATE_IMAGE = exports.ENDPOINT_RATE_IMAGE = '/image/:id/rate/:rating';
	var ENDPOINT_HIERARCHY = exports.ENDPOINT_HIERARCHY = '/albums/hierarchy';
	var ENDPOINT_KEYWORD_PARENTS = exports.ENDPOINT_KEYWORD_PARENTS = '/keywords/parents';
	var ENDPOINT_KEYWORD_HIERARCHY = exports.ENDPOINT_KEYWORD_HIERARCHY = '/keywords/hierarchy';
	var ENDPOINT_KEYWORD_GRAPH = exports.ENDPOINT_KEYWORD_GRAPH = '/graph';
	var ENDPOINT_SET_FAVOURITE_ALBUM = exports.ENDPOINT_SET_FAVOURITE_ALBUM = '/favourite/album/:id';
	var ENDPOINT_USERS = exports.ENDPOINT_USERS = '/users';
	var ENDPOINT_USER = exports.ENDPOINT_USER = '/user/:id';
	var ENDPOINT_NEW_USER = exports.ENDPOINT_NEW_USER = '/user/create';
	var ENDPOINT_PERMS = exports.ENDPOINT_PERMS = '/perms';
	var ENDPOINT_FETCH_ALBUM_SHARE = exports.ENDPOINT_FETCH_ALBUM_SHARE = '/album/:id/share';
	var ENDPOINT_ALBUM_SHARE = exports.ENDPOINT_ALBUM_SHARE = '/album/:album_id/share/user/:user_id';
	var ENDPOINT_SHARE_CODE = exports.ENDPOINT_SHARE_CODE = '/tokens/sharing';
	var ENDPOINT_PLAYLISTS = exports.ENDPOINT_PLAYLISTS = '/playlists';
	var ENDPOINT_PLAYLIST = exports.ENDPOINT_PLAYLIST = '/playlist/:id';
	var ENDPOINT_NEW_PLAYLIST = exports.ENDPOINT_NEW_PLAYLIST = '/playlist';
	var ENDPOINT_QUEUES = exports.ENDPOINT_QUEUES = '/queues';
	var ENDPOINT_QUEUE = exports.ENDPOINT_QUEUE = '/queue/:id';
	var ENDPOINT_NEW_QUEUE = exports.ENDPOINT_NEW_QUEUE = '/queue';
	var ENDPOINT_DYNAMIC_LINKS = exports.ENDPOINT_DYNAMIC_LINKS = '/dynamic_links';
	var ENDPOINT_DYNAMIC_LINK = exports.ENDPOINT_DYNAMIC_LINK = '/dynamic_link/:id';
	var ENDPOINT_NEW_DYNAMIC_LINK = exports.ENDPOINT_NEW_DYNAMIC_LINK = '/dynamic_link';
	var ENDPOINT_SHARE_IMAGES = exports.ENDPOINT_SHARE_IMAGES = '/images/share/:user_id';
	var ENDPOINT_LIBRARIES = exports.ENDPOINT_LIBRARIES = '/libraries';
	var ENDPOINT_LIBRARY = exports.ENDPOINT_LIBRARY = '/library/:id';
	var ENDPOINT_NEW_LIBRARY = exports.ENDPOINT_NEW_LIBRARY = '/library';
	var ENDPOINT_GLOBAL_SETTINGS = exports.ENDPOINT_GLOBAL_SETTINGS = '/settings/global';
	var ENDPOINT_ALBUM_PATH_COUNTS = exports.ENDPOINT_ALBUM_PATH_COUNTS = '/album_paths';
	var ENDPOINT_CONFIG = exports.ENDPOINT_CONFIG = '/config';
	var ENDPOINT_PRESENT_TOKEN = exports.ENDPOINT_PRESENT_TOKEN = '/present/token';
	var ENDPOINT_ORCHESTRA_TOKEN = exports.ENDPOINT_ORCHESTRA_TOKEN = '/orchestra/token';
	var ENDPOINT_PICASSO = exports.ENDPOINT_PICASSO = '/picasso';
	var ENDPOINT_AGGREGATION = exports.ENDPOINT_AGGREGATION = '/search/aggregations';
	var ENDPOINT_SCRIPTS_INFO = exports.ENDPOINT_SCRIPTS_INFO = '/services_info';
	var ENDPOINT_USER_SESSIONS = exports.ENDPOINT_USER_SESSIONS = '/user/:id/sessions';
	var ENDPOINT_ALL_USER_SESSIONS = exports.ENDPOINT_ALL_USER_SESSIONS = '/users/sessions';
	var ENDPOINT_LOGOUT_ALL = exports.ENDPOINT_LOGOUT_ALL = '/user/logout';
	
	var AUTH_COOKIE_KEY = exports.AUTH_COOKIE_KEY = 'auth';
	var AUTH_COOKIE_EXPIRY = exports.AUTH_COOKIE_EXPIRY = 86400; // seconds
	var REFRESH_TOKENS_DELAY = exports.REFRESH_TOKENS_DELAY = 10; // seconds
	
	var AWS_BUCKET = exports.AWS_BUCKET = 'blayzr-processed';
	var AWS_EXPIRY_TIME = exports.AWS_EXPIRY_TIME = 86400; // seconds
	
	var QUERY_CACHE_KEY = exports.QUERY_CACHE_KEY = 'query-cache';
	var QUERY_CACHE_EXPIRY = exports.QUERY_CACHE_EXPIRY = 60; // One hour
	var SETTINGS_CACHE_KEY = exports.SETTINGS_CACHE_KEY = 'settings';
	var KEYWORD_VISIBILITY_CONFIG_KEY = exports.KEYWORD_VISIBILITY_CONFIG_KEY = 'keyword-visibility';
	var KEYWORD_WEIGHTING_CONFIG_KEY = exports.KEYWORD_WEIGHTING_CONFIG_KEY = 'keyword-weighting';
	var KEYWORD_IGNORE_FILTER_PREFIX = exports.KEYWORD_IGNORE_FILTER_PREFIX = 'Tag-';
	
	var AUTOCOMPLETE_MINIMUM_CHARACTERS = exports.AUTOCOMPLETE_MINIMUM_CHARACTERS = 2;
	var AUTOCOMPLETE_PAGE_SIZE = exports.AUTOCOMPLETE_PAGE_SIZE = 10;
	
	var DOUBLE_TAP_ZOOM_LEVEL = exports.DOUBLE_TAP_ZOOM_LEVEL = 2; // Amount to zoom image on double tap
	
	var IMAGE_SIZES = exports.IMAGE_SIZES = {
	  t75: 240,
	  s75: 640,
	  m75: 1024,
	  l75: 1920
	
	  // NOTE: The variants here must be kept in sync with the scripts config: /scripts/config.py.sample
	};var IMAGE_VARIANTS = exports.IMAGE_VARIANTS = ['i100', 't75', 's75', 'm75', 'l75', 'o'];
	var DEFAULT_SETTINGS = exports.DEFAULT_SETTINGS = {
	  aws: true,
	  imagePath: '',
	  iconVariant: 'i100',
	  thumbVariant: 't75',
	  displayVariant: 's75',
	  presentVariant: 's75'
	};
	
	var PRIMARY_COLOR = exports.PRIMARY_COLOR = '#144450';
	var MOBILE_BREAKPOINT = exports.MOBILE_BREAKPOINT = 768;
	var MAX_FIXED_COUNT = exports.MAX_FIXED_COUNT = 2000; // Maximum number of images for fixed album
	
	var MAPS_API_KEY = exports.MAPS_API_KEY = 'AIzaSyAUXuR7UzbaNhIGm8dE-9ygdKumMDb4EWs';
	var MAPS_API_CALLBACK = exports.MAPS_API_CALLBACK = 'mapsReady';
	var MAPS_API_URL = exports.MAPS_API_URL = 'https://maps.googleapis.com/maps/api/js?key=' + MAPS_API_KEY + '&callback=' + MAPS_API_CALLBACK;
	var GEO_LOOKUP_URL = exports.GEO_LOOKUP_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
	
	// http://openweathermap.org/current
	var WEATHER_API_KEY = exports.WEATHER_API_KEY = '197dd4cf16bfdf371af9b5bfe6a9c060';
	var WEATHER_REFRESH_INTERVAL = exports.WEATHER_REFRESH_INTERVAL = 30 * 1000;
	
	// http://openweathermap.org/weather-conditions
	var WEATHER_ARRAY = exports.WEATHER_ARRAY = ['Clear', 'Clouds', 'Drizzle', 'Rain', 'Thunderstorm', 'Snow'];
	
	var DYNAMIC_ALBUMS = exports.DYNAMIC_ALBUMS = {
	  'on-this-day': 'On This Day',
	  'recent': 'Recent Pictures'
	};
	
	var MONTH_ARRAY = exports.MONTH_ARRAY = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	var DEFAULT_START_DATE = exports.DEFAULT_START_DATE = '1900-01-01';
	var AUTO_PLAYLIST_SUFFIX = exports.AUTO_PLAYLIST_SUFFIX = ' (autoplaylist)';
	
	var PRESENTATION_ARRAY = exports.PRESENTATION_ARRAY = [{ value: 'kenburns', name: 'Ken Burns' }, { value: 'floating', name: 'Floating' }];
	
	var SORT_ARRAY = exports.SORT_ARRAY = [{ value: 'relevance', name: 'Relevance' }, { value: 'rating-asc', name: 'Rating (asc)' }, { value: 'rating-desc', name: 'Rating (desc)' }, { value: 'date-asc', name: 'Date (asc)' }, { value: 'date-desc', name: 'Date (desc)' }, { value: 'filename-asc', name: 'Filename (asc)' }, { value: 'filename-desc', name: 'Filename (desc)' }, { value: 'manual', name: 'Manual' }, { value: 'random', name: 'Random' }];
	
	var UNKNOWN_SEASON = exports.UNKNOWN_SEASON = '6. Unknown Season';
	var YEAR_SELECTS = exports.YEAR_SELECTS = '7. Year Selects';
	var TIMELINE_SEASONS = exports.TIMELINE_SEASONS = ['1. Winter (Year Start)', '2. Spring', '3. Summer', '4. Autumn', '5. Winter (Year End)', UNKNOWN_SEASON, YEAR_SELECTS];
	
	var FIX_WARNING = exports.FIX_WARNING = 'Locking an album will fix the album to the current set of images. Editing will be disabled until the album is unlocked. Are you sure you want to continue?';
	var UNFIX_WARNING = exports.UNFIX_WARNING = 'Unlocking an album will reset the album back to the original search query, new images may appear in your album. Are you sure you want to continue?';
	
	var SPECIAL_ALBUM_PATH_TITLE = exports.SPECIAL_ALBUM_PATH_TITLE = {
	  'null': 'Images Without Album Path',
	  'event:null': 'Images Without Event Path',
	  'keyword:null': 'Images Without Keywords'
	};
	
	var IS_IOS = exports.IS_IOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	var _interopRequireWildcard = __webpack_require__(198);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(1128));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(453));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(1129));
	
	exports.connect = _connect.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoadingSpinner;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingSpinner = __webpack_require__(805);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingSpinner(_ref) {
	  var style = _ref.style,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$show = _ref.show,
	      show = _ref$show === undefined ? true : _ref$show,
	      white = _ref.white;
	
	  var spinnerClass = show ? _LoadingSpinner2.default.spinnerShowing : _LoadingSpinner2.default.spinner;
	  if (white) {
	    spinnerClass += ' ' + _LoadingSpinner2.default.white;
	  }
	  if (className) {
	    spinnerClass += ' ' + className;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: spinnerClass, style: style },
	    _react2.default.createElement('div', { className: _LoadingSpinner2.default.topLeft }),
	    _react2.default.createElement('div', { className: _LoadingSpinner2.default.topRight }),
	    _react2.default.createElement('div', { className: _LoadingSpinner2.default.bottomLeft }),
	    _react2.default.createElement('div', { className: _LoadingSpinner2.default.bottomRight })
	  );
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Icon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ICON_PATHS = {
	  'close': 'M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z',
	  'chevron-right': 'M563.2 512l-160.819-175.104c-13.722-13.824-13.722-36.198 0-50.074 13.722-13.824 35.891-13.824 49.613 0l196.096 200.090c13.722 13.875 13.722 36.301 0 50.125l-196.096 200.090c-13.67 13.926-35.891 13.824-49.613 0-13.722-13.773-13.722-36.198 0-50.074l160.819-175.053z',
	  'chevron-left': 'M621.619 687.002c13.722 13.875 13.722 36.301 0 50.074-13.722 13.824-35.891 13.926-49.613 0l-196.096-200.090c-13.722-13.824-13.722-36.198 0-50.125l196.096-200.090c13.67-13.824 35.891-13.824 49.613 0 13.722 13.875 13.722 36.301 0 50.074l-160.819 175.155 160.819 175.002z',
	  'chevron-down': 'M891.802 312.781c13.926-13.722 36.301-13.722 50.125 0s13.875 35.891 0 49.613l-404.89 400.896c-13.824 13.722-36.198 13.722-50.125 0l-404.89-400.896c-13.824-13.722-13.824-35.891 0-49.613 13.875-13.722 36.301-13.722 50.125 0l379.853 365.619 379.802-365.619z',
	  'chevron-up': 'M132.198 711.219c-13.926 13.722-36.301 13.722-50.125 0s-13.875-35.891 0-49.613l404.89-400.896c13.824-13.722 36.198-13.722 50.125 0l404.89 400.896c13.824 13.722 13.824 35.891 0 49.613-13.875 13.722-36.301 13.722-50.074 0l-379.904-365.619-379.802 365.619z',
	  'home': 'M512 128c0 0-263.936 227.84-411.435 351.232-8.661 7.851-15.232 19.285-15.232 32.768 0 23.595 19.072 42.667 42.667 42.667h85.333v298.667c0 23.595 19.072 42.667 42.667 42.667h128c23.595 0 42.667-19.115 42.667-42.667v-170.667h170.667v170.667c0 23.552 19.072 42.667 42.667 42.667h128c23.595 0 42.667-19.072 42.667-42.667v-298.667h85.333c23.595 0 42.667-19.072 42.667-42.667 0-13.483-6.571-24.917-16.341-32.768-146.475-123.392-410.325-351.232-410.325-351.232z',
	  'heart': 'M512 950.857c-9.143 0-18.286-3.429-25.143-10.286l-356.571-344c-4.571-4-130.286-118.857-130.286-256 0-167.429 102.286-267.429 273.143-267.429 100 0 193.714 78.857 238.857 123.429 45.143-44.571 138.857-123.429 238.857-123.429 170.857 0 273.143 100 273.143 267.429 0 137.143-125.714 252-130.857 257.143l-356 342.857c-6.857 6.857-16 10.286-25.143 10.286z',
	  'heart-outline': 'M950.857 340.571c0-160.571-108.571-194.286-200-194.286-85.143 0-181.143 92-210.857 127.429-13.714 16.571-42.286 16.571-56 0-29.714-35.429-125.714-127.429-210.857-127.429-91.429 0-200 33.714-200 194.286 0 104.571 105.714 201.714 106.857 202.857l332 320 331.429-319.429c1.714-1.714 107.429-98.857 107.429-203.429zM1024 340.571c0 137.143-125.714 252-130.857 257.143l-356 342.857c-6.857 6.857-16 10.286-25.143 10.286s-18.286-3.429-25.143-10.286l-356.571-344c-4.571-4-130.286-118.857-130.286-256 0-167.429 102.286-267.429 273.143-267.429 100 0 193.714 78.857 238.857 123.429 45.143-44.571 138.857-123.429 238.857-123.429 170.857 0 273.143 100 273.143 267.429z',
	  'search': 'M1014.88 926.496c12.192 12.192 12.192 31.968 0 44.192l-44.192 44.192c-12.224 12.192-32 12.192-44.192 0l-309.376-309.376c-3.36-3.36-5.6-7.328-7.104-11.552-63.456 46.368-141.376 74.048-226.016 74.048-212.064 0-384-171.936-384-384s171.936-384 384-384c212.064 0 384 171.936 384 384 0 84.64-27.68 162.56-74.048 226.016 4.224 1.504 8.192 3.712 11.552 7.104l309.376 309.376zM384 128c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256c0-141.376-114.624-256-256-256z',
	  'plus': 'M512 85.333q17.667 0 30.167 12.5t12.5 30.167v341.333h341.333q17.667 0 30.167 12.5t12.5 30.167-12.5 30.167-30.167 12.5h-341.333v341.333q0 17.667-12.5 30.167t-30.167 12.5-30.167-12.5-12.5-30.167v-341.333h-341.333q-17.667 0-30.167-12.5t-12.5-30.167 12.5-30.167 30.167-12.5h341.333v-341.333q0-17.667 12.5-30.167t30.167-12.5z',
	  'plus-small': 'M819.2 512c0 28.314-2.458 51.2-30.771 51.2h-225.229v225.229c0 28.262-22.886 30.771-51.2 30.771s-51.2-2.509-51.2-30.771v-225.229h-225.229c-28.262 0-30.771-22.886-30.771-51.2s2.509-51.2 30.771-51.2h225.229v-225.229c0-28.314 22.886-30.771 51.2-30.771s51.2 2.458 51.2 30.771v225.229h225.229c28.314 0 30.771 22.886 30.771 51.2z',
	  'minus': 'M128 469.333h768q17.667 0 30.167 12.5t12.5 30.167-12.5 30.167-30.167 12.5h-768q-17.667 0-30.167-12.5t-12.5-30.167 12.5-30.167 30.167-12.5z',
	  'star': 'M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z',
	  'star-outline': 'M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-223.462 117.48 42.676-248.83-180.786-176.222 249.84-36.304 111.732-226.396 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z',
	  'bars': 'M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z',
	  'settings': 'M64 896h128v-192h-128v192zM192 128h-128v320h128v-320zM512 128h-128v128h128v-128zM0 640h256v-128h-256v128zM384 896h128v-384h-128v384zM320 448h256v-128h-256v128zM832 128h-128v384h128v-384zM640 576v128h256v-128h-256zM704 896h128v-128h-128v128z',
	  'edit': 'M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z',
	  'spinner': 'M1024 512c-1.278-66.862-15.784-133.516-42.576-194.462-26.704-61-65.462-116.258-113.042-161.92-47.552-45.696-103.944-81.82-164.984-105.652-61.004-23.924-126.596-35.352-191.398-33.966-64.81 1.282-129.332 15.374-188.334 41.356-59.048 25.896-112.542 63.47-156.734 109.576-44.224 46.082-79.16 100.708-102.186 159.798-23.114 59.062-34.128 122.52-32.746 185.27 1.286 62.76 14.964 125.148 40.134 182.206 25.088 57.1 61.476 108.828 106.11 151.548 44.61 42.754 97.472 76.504 154.614 98.72 57.118 22.304 118.446 32.902 179.142 31.526 60.708-1.29 120.962-14.554 176.076-38.914 55.15-24.282 105.116-59.48 146.366-102.644 41.282-43.14 73.844-94.236 95.254-149.43 13.034-33.458 21.88-68.4 26.542-103.798 1.246 0.072 2.498 0.12 3.762 0.12 35.346 0 64-28.652 64-64 0-1.796-0.094-3.572-0.238-5.332h0.238zM922.306 681.948c-23.472 53.202-57.484 101.4-99.178 141.18-41.67 39.81-91 71.186-144.244 91.79-53.228 20.678-110.29 30.452-166.884 29.082-56.604-1.298-112.596-13.736-163.82-36.474-51.25-22.666-97.684-55.49-135.994-95.712-38.338-40.198-68.528-87.764-88.322-139.058-19.87-51.284-29.228-106.214-27.864-160.756 1.302-54.552 13.328-108.412 35.254-157.69 21.858-49.3 53.498-93.97 92.246-130.81 38.73-36.868 84.53-65.87 133.874-84.856 49.338-19.060 102.136-28.006 154.626-26.644 52.5 1.306 104.228 12.918 151.562 34.034 47.352 21.050 90.256 51.502 125.624 88.782 35.396 37.258 63.21 81.294 81.39 128.688 18.248 47.392 26.782 98.058 25.424 148.496h0.238c-0.144 1.76-0.238 3.536-0.238 5.332 0 33.012 24.992 60.174 57.086 63.624-6.224 34.822-16.53 68.818-30.78 100.992z',
	  'tag': 'M976 0h-384c-26.4 0-63.274 15.274-81.942 33.942l-476.116 476.116c-18.668 18.668-18.668 49.214 0 67.882l412.118 412.118c18.668 18.668 49.214 18.668 67.882 0l476.118-476.118c18.666-18.666 33.94-55.54 33.94-81.94v-384c0-26.4-21.6-48-48-48zM736 384c-53.020 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96z',
	  'dot': 'M399.36 512c0 62.208 50.483 112.64 112.691 112.64s112.589-50.483 112.589-112.64c0-62.208-50.381-112.589-112.589-112.589s-112.691 50.381-112.691 112.589z',
	  'sort': 'M680.571 233.143h101.143l-41.143-124.571-6.857-26.857q-1.143-9.143-1.143-11.429h-2.286l-1.714 11.429q0 0.571-2 10.286t-4.286 16.571zM420.571 822.857q0 6.857-5.714 13.714l-182.286 182.286q-5.714 5.143-13.143 5.143-6.857 0-13.143-5.143l-182.857-182.857q-8.571-9.143-4-20 4.571-11.429 17.143-11.429h109.714v-786.286q0-8 5.143-13.143t13.143-5.143h109.714q8 0 13.143 5.143t5.143 13.143v786.286h109.714q8 0 13.143 5.143t5.143 13.143zM898.286 890.857v133.143h-333.714v-51.429l210.857-302.286q6.857-10.286 12-15.429l6.286-5.143v-1.714q-1.143 0-3.714 0.286t-4.286 0.286q-6.857 1.714-17.143 1.714h-132.571v65.714h-68.571v-130.857h324v50.857l-210.857 302.857q-3.429 4.571-12 14.857l-6.286 6.286v1.143l8-1.143q5.143-1.143 17.143-1.143h141.714v-68h69.143zM949.143 378.286v60.571h-164.571v-60.571h42.857l-26.857-82.286h-138.857l-26.857 82.286h42.857v60.571h-164v-60.571h40l131.429-378.286h92.571l131.429 378.286h40z',
	  'shuffle': 'M512 0q18 0 30.333 12.333l150.667 151q12.667 12.667 12.667 30.333t-12.5 30.167-30.167 12.5-30.333-12.667l-78-78v323.667h323.667l-78-78q-12.667-12.667-12.667-30.333t12.5-30.167 30.167-12.5 30.333 12.667l151 150.667q12.333 12.333 12.333 30.333t-12.333 30l-151 151q-12.667 12.667-30.333 12.667t-30.167-12.5-12.5-30.167 12.667-30.333l78-78h-323.667v323.667l78-78q12.667-12.667 30.333-12.667t30.167 12.5 12.5 30.167-12.667 30.333l-150.667 151q-12.333 12.333-30.333 12.333-17.667 0-30-12.333l-151-151q-12.667-12.667-12.667-30.333t12.5-30.167 30.167-12.5 30.333 12.667l78 78v-323.667h-323.667l78 78q12.667 12.667 12.667 30.333t-12.5 30.167-30.167 12.5-30.333-12.667l-151-150.667q-12.333-12.333-12.333-30.333t12.333-30.333l151-150.667q12.667-12.667 30.333-12.667t30.167 12.5 12.5 30.167-12.667 30.333l-78 78h323.667v-323.667l-78 78q-12.667 12.667-30.333 12.667t-30.167-12.5-12.5-30.167 12.667-30.333l150.667-151q12.333-12.333 30.333-12.333z',
	  'camera': 'M304 608c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 256h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 892c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 448h-128v-64h128v64z',
	  'share': 'M864 704c-45.16 0-85.92 18.738-115.012 48.83l-431.004-215.502c1.314-8.252 2.016-16.706 2.016-25.328s-0.702-17.076-2.016-25.326l431.004-215.502c29.092 30.090 69.852 48.828 115.012 48.828 88.366 0 160-71.634 160-160s-71.634-160-160-160-160 71.634-160 160c0 8.622 0.704 17.076 2.016 25.326l-431.004 215.504c-29.092-30.090-69.852-48.83-115.012-48.83-88.366 0-160 71.636-160 160 0 88.368 71.634 160 160 160 45.16 0 85.92-18.738 115.012-48.828l431.004 215.502c-1.312 8.25-2.016 16.704-2.016 25.326 0 88.368 71.634 160 160 160s160-71.632 160-160c0-88.364-71.634-160-160-160z',
	  'tick': 'M864 128l-480 480-224-224-160 160 384 384 640-640z',
	  'marker': 'M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z',
	  'info': 'M470 384v-86h84v86h-84zM512 854c188 0 342-154 342-342s-154-342-342-342-342 154-342 342 154 342 342 342zM512 86c236 0 426 190 426 426s-190 426-426 426-426-190-426-426 190-426 426-426zM470 726v-256h84v256h-84z',
	  'flag': 'M784.341 184.235c-15.957-6.613-34.304-2.944-46.507 9.259-53.931 53.888-141.696 53.931-195.669 0-87.253-87.168-229.12-87.168-316.331 0-8.021 7.979-12.501 18.859-12.501 30.165v554.667c0 23.552 19.072 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-194.261c54.229-42.539 133.163-38.869 183.168 11.093 87.253 87.168 229.163 87.168 316.331 0 8.021-8.021 12.501-18.859 12.501-30.165v-341.333c0-17.28-10.411-32.811-26.325-39.424z',
	  'play': 'M192 128l640 384-640 384z',
	  'pause': 'M352 0h-192c-17.696 0-32 14.336-32 32v960c0 17.696 14.304 32 32 32h192c17.696 0 32-14.304 32-32v-960c0-17.664-14.304-32-32-32zM864 0h-192c-17.696 0-32 14.336-32 32v960c0 17.696 14.304 32 32 32h192c17.696 0 32-14.304 32-32v-960c0-17.664-14.304-32-32-32z',
	  'rewind': 'M576 160v320l320-320v704l-320-320v320l-352-352z',
	  'forward': 'M512 864v-320l-320 320v-704l320 320v-320l352 352z',
	  'skip': 'M768 128v768h-128v-352l-320 320v-704l320 320v-352z',
	  'skip-back': 'M256 896v-768h128v352l320-320v704l-320-320v352z',
	  'duplicate': 'M810 896v-598h-468v598h468zM810 214c46 0 86 38 86 84v598c0 46-40 86-86 86h-468c-46 0-86-40-86-86v-598c0-46 40-84 86-84h468zM682 42v86h-512v598h-84v-598c0-46 38-86 84-86h512z',
	  'restart': 'M190.912 536.544l130.88-130.88h-76.704c0.704-1.92 1.44-3.808 2.144-5.696 45.504-115.264 157.888-196.8 289.28-196.8 171.712 0 310.912 139.2 310.912 310.88 0 171.712-139.2 310.912-310.912 310.912-126.272 0-234.976-75.328-283.616-183.456-0.48-0.992-0.768-2.112-1.248-3.168l-83.36 82.848c0.576 0.96 0.96 2.048 1.536 3.072 0.128 0.224 0.256 0.448 0.384 0.64 73.568 127.104 211.008 212.576 368.416 212.576 234.944 0 425.408-190.464 425.408-425.408s-190.496-425.472-425.44-425.472c-196.416 0-361.696 133.056-410.656 313.984-0.48 1.664-0.64 3.424-1.024 5.088h-66.912l130.912 130.88z',
	  'lock-open': 'M808.96 409.6h-92.16v-122.88c0-148.326-68.352-235.52-204.8-235.52-136.499 0-204.8 87.194-204.8 235.52v20.48h102.4v-41.011c0-73.984 40.806-112.589 102.4-112.589s102.4 38.605 102.4 112.589v143.411h-409.6c-28.314 0-51.2 33.075-51.2 61.389v399.411c0 28.109 21.914 58.317 48.691 66.918l61.286 19.814c26.829 8.55 71.782 15.667 99.942 15.667h296.96c28.109 0 73.114-7.117 99.891-15.718l61.235-19.814c26.829-8.55 48.794-38.758 48.794-66.867v-399.411c0-28.314-33.178-61.389-61.44-61.389z',
	  'lock': 'M808.96 409.6h-92.16v-122.88c0-148.326-68.352-235.52-204.8-235.52-136.499 0-204.8 87.194-204.8 235.52v122.88h-102.4c-28.314 0-51.2 33.075-51.2 61.389v399.411c0 28.109 21.914 58.317 48.691 66.918l61.286 19.814c26.829 8.55 71.782 15.667 99.942 15.667h296.96c28.109 0 73.114-7.117 99.891-15.718l61.235-19.814c26.829-8.55 48.794-38.758 48.794-66.867v-399.411c0-28.314-33.178-61.389-61.44-61.389zM614.4 409.6h-204.8v-143.411c0-73.984 40.806-112.589 102.4-112.589s102.4 38.605 102.4 112.589v143.411z',
	  'fullscreen': 'M598 214h212v212h-84v-128h-128v-84zM726 726v-128h84v212h-212v-84h128zM214 426v-212h212v84h-128v128h-84zM298 598v128h128v84h-212v-212h84z',
	  'dots': 'M512.051 399.36c-62.208 0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 112.64c62.208 0 112.589-50.432 112.589-112.64s-50.381-112.64-112.589-112.64zM512.051 266.24c62.208 0 112.589-50.483 112.589-112.64s-50.381-112.64-112.589-112.64c-62.208 0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 112.64zM512.051 757.76c-62.208 0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 112.64c62.208 0 112.589-50.432 112.589-112.64s-50.381-112.64-112.589-112.64z',
	  'freetext': 'M918 384v128h-128v298h-128v-298h-128v-128h384zM106 170h556v128h-214v512h-128v-512h-214v-128z',
	  'library': 'M621.714 475.429c0-20-16.571-36.571-36.571-36.571h-146.286c-20 0-36.571 16.571-36.571 36.571s16.571 36.571 36.571 36.571h146.286c20 0 36.571-16.571 36.571-36.571zM950.857 365.714v548.571c0 20-16.571 36.571-36.571 36.571h-804.571c-20 0-36.571-16.571-36.571-36.571v-548.571c0-20 16.571-36.571 36.571-36.571h804.571c20 0 36.571 16.571 36.571 36.571zM987.429 109.714v146.286c0 20-16.571 36.571-36.571 36.571h-877.714c-20 0-36.571-16.571-36.571-36.571v-146.286c0-20 16.571-36.571 36.571-36.571h877.714c20 0 36.571 16.571 36.571 36.571z',
	  'limit': 'M416.102 696.32c-35.277 61.286-11.52 111.616 37.478 139.878 48.947 28.314 104.499 23.808 139.878-37.478 35.277-61.184 258.406-607.488 239.002-618.701s-381.030 455.066-416.358 516.301zM512 307.2c22.426 0 44.237 1.894 65.587 5.581 22.426-28.109 47.514-59.085 71.936-88.474-43.622-12.595-89.702-19.507-137.523-19.507-287.078 0-512 242.125-512 551.219 0 18.995 0.819 37.99 2.509 56.474 2.509 28.211 27.648 48.896 55.501 46.49 28.211-2.611 48.998-27.392 46.49-55.603-1.382-15.462-2.099-31.488-2.099-47.36 0-251.699 179.917-448.819 409.6-448.819zM881.613 371.2c-14.285 38.4-29.389 77.517-42.701 111.309 51.968 75.264 82.688 169.677 82.688 273.51 0 16.179-0.768 32.512-2.202 48.282-2.56 28.211 18.176 53.094 46.336 55.706 1.536 0.102 3.123 0.205 4.71 0.205 26.163 0 48.538-20.019 50.944-46.592 1.69-18.944 2.611-38.298 2.611-57.6 0-151.245-53.914-286.208-142.387-384.819z',
	  'eye': 'M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z',
	  'eye-disabled': 'M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342z M768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256z M830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z',
	  'stop': 'M128 128h768v768h-768z',
	  'trash': 'M128 320v640c0 35.2 28.8 64 64 64h576c35.2 0 64-28.8 64-64v-640h-704zM320 896h-64v-448h64v448zM448 896h-64v-448h64v448zM576 896h-64v-448h64v448zM704 896h-64v-448h64v448z M848 128h-208v-80c0-26.4-21.6-48-48-48h-224c-26.4 0-48 21.6-48 48v80h-208c-26.4 0-48 21.6-48 48v80h832v-80c0-26.4-21.6-48-48-48zM576 128h-192v-63.198h192v63.198z',
	  'loop': 'M128 320h640v192l256-256-256-256v192h-768v384h128zM896 704h-640v-192l-256 256 256 256v-192h768v-384h-128z',
	  'date': 'M73.143 950.857h804.571v-585.143h-804.571v585.143zM292.571 256v-164.571c0-10.286-8-18.286-18.286-18.286h-36.571c-10.286 0-18.286 8-18.286 18.286v164.571c0 10.286 8 18.286 18.286 18.286h36.571c10.286 0 18.286-8 18.286-18.286zM731.429 256v-164.571c0-10.286-8-18.286-18.286-18.286h-36.571c-10.286 0-18.286 8-18.286 18.286v164.571c0 10.286 8 18.286 18.286 18.286h36.571c10.286 0 18.286-8 18.286-18.286zM950.857 219.429v731.429c0 40-33.143 73.143-73.143 73.143h-804.571c-40 0-73.143-33.143-73.143-73.143v-731.429c0-40 33.143-73.143 73.143-73.143h73.143v-54.857c0-50.286 41.143-91.429 91.429-91.429h36.571c50.286 0 91.429 41.143 91.429 91.429v54.857h219.429v-54.857c0-50.286 41.143-91.429 91.429-91.429h36.571c50.286 0 91.429 41.143 91.429 91.429v54.857h73.143c40 0 73.143 33.143 73.143 73.143z'
	};
	
	function Icon(_ref) {
	  var icon = _ref.icon,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 22 : _ref$size,
	      props = _objectWithoutProperties(_ref, ['icon', 'size']);
	
	  if (icon === 'sort-handle') {
	    return _react2.default.createElement(
	      'svg',
	      { width: size, height: size, viewBox: '0 0 32 32' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('rect', { y: '10', width: '32', height: '4' }),
	        _react2.default.createElement('rect', { y: '20', width: '32', height: '4' })
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'svg',
	    _extends({ width: size, height: size, viewBox: '0 0 1024 1024' }, props),
	    _react2.default.createElement('path', { d: ICON_PATHS[icon], vectorEffect: 'non-scaling-stroke' })
	  );
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(86);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(291);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(122);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1150);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(460);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1146);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1161);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1147);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1148);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(462);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1149);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(292);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1159);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(467);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1152);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1153);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1157);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(464);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.schemas = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetch = fetch;
	exports.picassoFetch = picassoFetch;
	
	var _normalizr = __webpack_require__(103);
	
	var _queryString = __webpack_require__(430);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _auth = __webpack_require__(42);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetch(endpoint) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$method = _ref.method,
	      method = _ref$method === undefined ? 'get' : _ref$method,
	      _ref$query = _ref.query,
	      query = _ref$query === undefined ? {} : _ref$query,
	      body = _ref.body,
	      token = _ref.token,
	      schema = _ref.schema,
	      cache = _ref.cache,
	      cacheKey = _ref.cacheKey;
	
	  var dispatch = arguments[2];
	
	  var querystring = query ? '?' + (0, _queryString.stringify)(query) : '';
	  var options = {
	    method: method,
	    headers: {
	      'Accept': 'application/json',
	      'Content-Type': 'application/json'
	    },
	    credentials: 'include'
	  };
	  if (body) {
	    options.body = JSON.stringify(body);
	  }
	  if (token) {
	    options.headers['Authorization'] = 'Bearer ' + token;
	  }
	  var url = _constants.API_PATH + endpoint + querystring;
	  var cached = _lscache2.default.get(cacheKey || url);
	  if (cache && cached) {
	    return Promise.resolve(cached);
	  }
	  return window.fetch(url, options).then(function (response) {
	    return checkStatusCode(response, dispatch);
	  }).then(parseJSON).then(function (json) {
	    var result = schema ? (0, _normalizr.normalize)(json, schema) : json;
	    if (cache) {
	      _lscache2.default.set(cacheKey || url, result, cache);
	    }
	    return result;
	  });
	}
	
	function picassoFetch(auth, action, body, dispatch) {
	  return fetch(_constants.ENDPOINT_PICASSO, {
	    method: 'post',
	    token: auth.token,
	    body: _extends({ action: action }, body)
	  }, dispatch);
	}
	
	function checkStatusCode(response, dispatch) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  } else {
	    if (dispatch && response.status === 401) {
	      dispatch((0, _auth.logout)());
	    }
	    var status = response.status,
	        statusText = response.statusText;
	
	    return response.json().then(function (data) {
	      var error = {
	        status: status,
	        statusText: statusText,
	        message: data && (data.message || data.error)
	      };
	      throw error;
	    });
	  }
	}
	
	function parseJSON(response) {
	  if (response.status === 204) {
	    return null;
	  }
	  return response.json();
	}
	
	var node = new _normalizr.Schema('graph', { idAttribute: '_id' });
	node.define({
	  children: (0, _normalizr.arrayOf)(node)
	});
	
	var schemas = exports.schemas = {
	  album: new _normalizr.Schema('albums'),
	  playlist: new _normalizr.Schema('playlists'),
	  queue: new _normalizr.Schema('queues'),
	  image: new _normalizr.Schema('images', { idAttribute: '_id' }),
	  user: new _normalizr.Schema('users'),
	  graph: (0, _normalizr.arrayOf)(node)
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPERSAND_REGEX = exports.AND_REGEX = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.pluralize = pluralize;
	exports.commas = commas;
	exports.isDate = isDate;
	exports.isWeather = isWeather;
	exports.slug = slug;
	exports.tidyAlbumTitle = tidyAlbumTitle;
	exports.getEventTitle = getEventTitle;
	exports.formatMinutes = formatMinutes;
	exports.titleCase = titleCase;
	exports.matchString = matchString;
	
	var _constants = __webpack_require__(3);
	
	function pluralize(number, phrase, plural) {
	  plural = plural || phrase + 's';
	  return commas(number) + ' ' + (number === 1 ? phrase : plural);
	}
	
	function commas(number) {
	  if (!number && number !== 0) return '';
	  return decimalPlaces(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}
	
	function decimalPlaces(number) {
	  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  return parseFloat(parseFloat(number).toFixed(places));
	}
	
	function isDate(string) {
	  return (/\d\d\d\d-\d\d-\d\d/.test(string)
	  );
	}
	
	function isWeather(string) {
	  return _constants.WEATHER_ARRAY.indexOf(string) !== -1;
	}
	
	// https://gist.github.com/mathewbyrne/1280286#gistcomment-1716050
	function slug(string) {
	  return string.toLowerCase().replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
	  .replace(/[\s_-]+/g, '-') // swap any length of whitespace, underscore, hyphen characters with a single -
	  .replace(/^-+|-+$/g, ''); // remove leading, trailing -
	}
	
	function tidyAlbumTitle(title) {
	  if (_constants.SPECIAL_ALBUM_PATH_TITLE[title]) {
	    return _constants.SPECIAL_ALBUM_PATH_TITLE[title];
	  }
	  return title.toString().replace(/^\d+\.? /, '');
	}
	
	function getEventTitle(path, userLibraries) {
	  if (userLibraries && shouldShowEventTitle(path, userLibraries) === false) {
	    return '';
	  }
	  if (!path) {
	    return 'Unknown';
	  }
	  var title = path.split('/').pop().replace(/^\d\d\d /, '');
	  // Check if album path matches standard decade/year/season format
	  var match = path.match(/^\/COLLECTIONS\/.+\/\d\d\d\ds\/(\d\d\d\d)\/\d\. ([a-z]+)/i);
	  if (!match) {
	    return 'Unknown Year \xB7 ' + title;
	  }
	
	  var _match = _slicedToArray(match, 3),
	      year = _match[1],
	      season = _match[2];
	
	  return season + ' ' + year + ' \xB7 ' + title;
	}
	
	// Do not show event titles that a user does not have access to
	function shouldShowEventTitle(path, userLibraries) {
	  if (!path) {
	    return false;
	  }
	  var match = path.match(/^\/COLLECTIONS\/([^/]+)\//);
	  if (!match) {
	    return false;
	  }
	  var library = match[1];
	  return userLibraries.indexOf(library) !== -1;
	}
	
	function formatMinutes(minutes) {
	  if (minutes < 1) {
	    return pluralize(round(minutes * 60), 'second');
	  }
	  if (minutes > 60) {
	    return pluralize(round(minutes / 60), 'hour');
	  }
	  return pluralize(round(minutes), 'minute');
	}
	
	function round(num) {
	  return Math.round(num * 10) / 10;
	}
	
	function titleCase(str) {
	  return str.replace(/\w\S*/g, function (txt) {
	    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	  });
	}
	
	var AND_REGEX = exports.AND_REGEX = /( |^)and( |$)/;
	var AMPERSAND_REGEX = exports.AMPERSAND_REGEX = /( |^)&( |$)/;
	
	function matchString(needle, haystack) {
	  var fuzzyAmpersands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1) {
	    return true;
	  }
	  if (fuzzyAmpersands) {
	    if (AND_REGEX.test(needle)) {
	      var replaced = needle.replace(AND_REGEX, ' & ').trim();
	      if (matchString(replaced, haystack)) {
	        return true;
	      }
	    }
	    if (AMPERSAND_REGEX.test(needle)) {
	      var _replaced = needle.replace(AMPERSAND_REGEX, ' and ').trim();
	      if (matchString(_replaced, haystack)) {
	        return true;
	      }
	    }
	  }
	  return false;
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ErrorMessage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ErrorMessage = __webpack_require__(801);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorMessage(_ref) {
	  var onRetry = _ref.onRetry,
	      _ref$message = _ref.message,
	      message = _ref$message === undefined ? 'There was an error' : _ref$message;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: _ErrorMessage2.default.message },
	      message
	    ),
	    onRetry && _react2.default.createElement(
	      'button',
	      {
	        className: _ErrorMessage2.default.button,
	        onClick: onRetry },
	      'Retry'
	    )
	  );
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(133)('wks');
	var uid = __webpack_require__(98);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAnonymous = isAnonymous;
	exports.isSuperAdmin = isSuperAdmin;
	exports.userHasPerm = userHasPerm;
	exports.canDownload = canDownload;
	exports.restoreSession = restoreSession;
	
	var _jsCookie = __webpack_require__(251);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _auth = __webpack_require__(42);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAnonymous(user) {
	  if (!user) {
	    return false;
	  }
	  return user.id === 0;
	}
	
	function isSuperAdmin(user) {
	  if (!user) {
	    return false;
	  }
	  return _constants.SUPER_ADMINS.indexOf(user.id) !== -1;
	}
	
	function userHasPerm(user, perm) {
	  if (!user) {
	    return false;
	  }
	  return user.perms.findIndex(function (p) {
	    return p.perm.perm_token === perm;
	  }) !== -1;
	}
	
	function canDownload(auth) {
	  if (isAnonymous(auth.user)) {
	    return !auth.no_download;
	  }
	  return userHasPerm(auth.user, 'download');
	}
	
	function restoreSession(store) {
	  // Skip session restore if share parameter is set
	  if (window.location.search === '?share') {
	    return;
	  }
	  // Skip session restore for external share URLs
	  if (/^\/share/.test(window.location.pathname)) {
	    return;
	  }
	  var auth = _jsCookie2.default.getJSON(_constants.AUTH_COOKIE_KEY);
	  if (auth) {
	    if (!auth.path || auth.path === window.location.pathname) {
	      store.dispatch((0, _auth.loginSuccess)(auth));
	    }
	  }
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(55);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1050)();
	}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getHash = getHash;
	exports.isEmptyStructure = isEmptyStructure;
	exports.isEmptyQuery = isEmptyQuery;
	exports.prepareStructure = prepareStructure;
	exports.addLibrariesToStructure = addLibrariesToStructure;
	exports.addLibrariesToQuery = addLibrariesToQuery;
	exports.createImageGetter = createImageGetter;
	exports.getImageSize = getImageSize;
	exports.getDate = getDate;
	exports.getFavouriteImagesAlbum = getFavouriteImagesAlbum;
	exports.getFavouriteImages = getFavouriteImages;
	exports.hasDynamicLink = hasDynamicLink;
	
	var _md = __webpack_require__(1035);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _awsSdk = __webpack_require__(795);
	
	var _awsSdk2 = _interopRequireDefault(_awsSdk);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _jsCookie = __webpack_require__(251);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _defaultCover = __webpack_require__(884);
	
	var _defaultCover2 = _interopRequireDefault(_defaultCover);
	
	var _query = __webpack_require__(50);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getHash(search) {
	  search = typeof search === 'string' ? JSON.parse(search) : search;
	  var structure = prepareStructure(search);
	  structure.timestamp = new Date().getHours();
	  return (0, _md2.default)(JSON.stringify(prepareStructure(structure)));
	}
	
	function isEmptyStructure(structure) {
	  if (structure.queries.length !== 1 || structure.exclude.length !== 0 || structure.include.length !== 0) {
	    return false;
	  }
	  return isEmptyQuery(structure.queries[0]);
	}
	
	// A query is still empty if it has only libraries added to it
	// so we need to remove them from the query we are checking
	function isEmptyQuery(query) {
	  return (0, _lodash2.default)(_extends({}, _query.emptyQuery, query, {
	    library: [],
	    operator: _query.DEFAULT_QUERY_OPERATOR
	  }), _query.emptyQuery);
	}
	
	function prepareStructure(structure) {
	  return _extends({}, structure, {
	    queries: structure.queries.filter(function (query) {
	      return !isEmptyQuery(query);
	    }).map(prepareQuery),
	    exclude: null, // Ignore exclude array for searches and hashes
	    sort: _extends({}, structure.sort, {
	      manual: null // Ignore manual order
	    })
	  });
	}
	
	function prepareQuery(query) {
	  if (query.rating.length === 1 && !query.rating[0].value) {
	    var rating = Object.keys(query.rating[0]).map(function (value) {
	      return {
	        value: parseInt(value),
	        operator: 'should'
	      };
	    });
	    return _extends({}, query, { rating: rating });
	  }
	  return query;
	}
	
	function addLibrariesToStructure(structure, libraries) {
	  return _extends({}, structure, {
	    queries: structure.queries.map(function (query) {
	      return addLibrariesToQuery(query, libraries);
	    })
	  });
	}
	
	function addLibrariesToQuery(query, libraries) {
	  if (!query.library || query.library.length === 0) {
	    return _extends({}, query, {
	      library: libraries.map(function (value) {
	        return {
	          value: value,
	          operator: 'should'
	        };
	      })
	    });
	  }
	  return query;
	}
	
	var cache = {};
	
	// Returns a util function for generating image paths
	// using aws tokens, user settings and a size code:
	// i = icon, t = thumb, d = display, p = presentation
	function createImageGetter(auth) {
	  var aws = auth.aws,
	      user = auth.user;
	  // Guard to prevent error during token expiry logout
	
	  if (!aws || !user) {
	    return function () {};
	  }
	  var settings = user.settings;
	
	  if (!settings.aws) {
	    return function (id) {
	      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 't';
	
	      var suffix = getSuffix(code, settings);
	      return '' + settings.imagePath + id + '_' + suffix + '.jpg';
	    };
	  }
	  var awsCookie = _jsCookie2.default.get('aws');
	  if (awsCookie) {
	    var _awsCookie$split = awsCookie.split('::'),
	        _awsCookie$split2 = _slicedToArray(_awsCookie$split, 3),
	        access_key = _awsCookie$split2[0],
	        secret_key = _awsCookie$split2[1],
	        session_token = _awsCookie$split2[2];
	
	    aws = { access_key: access_key, secret_key: secret_key, session_token: session_token };
	  }
	  var s3 = new _awsSdk2.default.S3({
	    accessKeyId: aws.access_key,
	    secretAccessKey: aws.secret_key,
	    sessionToken: aws.session_token
	  });
	  return function (id) {
	    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 't';
	
	    if (!id) {
	      return _defaultCover2.default;
	    }
	    var suffix = getSuffix(code, settings);
	    var filename = id + '_' + suffix + '.jpg';
	    var cacheKey = aws.expiration + filename;
	    if (!cache[cacheKey]) {
	      cache[cacheKey] = s3.getSignedUrl('getObject', {
	        Bucket: _constants.AWS_BUCKET,
	        Key: filename,
	        Expires: _constants.AWS_EXPIRY_TIME
	      });
	    }
	    return cache[cacheKey];
	  };
	}
	
	function getSuffix(code, settings) {
	  if (code === 'i') return settings.iconVariant;
	  if (code === 't') return settings.thumbVariant;
	  if (code === 'd') return settings.displayVariant;
	  if (code === 'p') return settings.presentVariant;
	  return code; // Return raw code if no match (ie for download links)
	}
	
	function getImageSize(code, width, height) {
	  if (!_constants.IMAGE_SIZES[code]) {
	    return { width: width, height: height };
	  }
	  if (width > height) {
	    return {
	      width: _constants.IMAGE_SIZES[code],
	      height: Math.round(height * _constants.IMAGE_SIZES[code] / width)
	    };
	  }
	  return {
	    width: Math.round(width * _constants.IMAGE_SIZES[code] / height),
	    height: _constants.IMAGE_SIZES[code]
	  };
	}
	
	// Convert from 2014:10:22 17:32:57+00:00 to ISO format
	function getDate(string) {
	  if (!string) {
	    return null;
	  }
	
	  var _string$split = string.split(' '),
	      _string$split2 = _slicedToArray(_string$split, 2),
	      date = _string$split2[0],
	      time = _string$split2[1];
	
	  return (0, _dateformat2.default)(new Date(date.replace(/:/g, '-') + 'T' + (time || '00:00:00')), 'd mmmm yyyy');
	}
	
	function getFavouriteImagesAlbum(_ref) {
	  var auth = _ref.auth,
	      entities = _ref.entities,
	      albums = _ref.albums;
	
	  try {
	    var id = albums.all.data.filter(function (id) {
	      var album = entities.albums[id];
	      return album.favourite && album.user_id === auth.user.id;
	    })[0];
	    return entities.albums[id];
	  } catch (e) {
	    return null;
	  }
	}
	
	function getFavouriteImages(state) {
	  var album = getFavouriteImagesAlbum(state);
	  if (!album) return null;
	  return JSON.parse(album.json_data).include;
	}
	
	function hasDynamicLink(structure) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = structure.queries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var query = _step.value;
	
	      if (query.dynlink && query.dynlink.length !== 0) {
	        return true;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return false;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(11)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var support = __webpack_require__(83);
	var base64 = __webpack_require__(367);
	var nodejsUtils = __webpack_require__(176);
	var setImmediate = __webpack_require__(1233);
	var external = __webpack_require__(136);
	
	
	/**
	 * Convert a string that pass as a "binary string": it should represent a byte
	 * array but may have > 255 char codes. Be sure to take only the first byte
	 * and returns the byte array.
	 * @param {String} str the string to transform.
	 * @return {Array|Uint8Array} the string in a binary format.
	 */
	function string2binary(str) {
	    var result = null;
	    if (support.uint8array) {
	      result = new Uint8Array(str.length);
	    } else {
	      result = new Array(str.length);
	    }
	    return stringToArrayLike(str, result);
	}
	
	/**
	 * Create a new blob with the given content and the given type.
	 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
	 * an Uint8Array because the stock browser of android 4 won't accept it (it
	 * will be silently converted to a string, "[object Uint8Array]").
	 *
	 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
	 * when a large amount of Array is used to create the Blob, the amount of
	 * memory consumed is nearly 100 times the original data amount.
	 *
	 * @param {String} type the mime type of the blob.
	 * @return {Blob} the created blob.
	 */
	exports.newBlob = function(part, type) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([part], {
	            type: type
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(part);
	            return builder.getBlob(type);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * An helper for the function arrayLikeToString.
	 * This contains static information and functions that
	 * can be optimized by the browser JIT compiler.
	 */
	var arrayToStringHelper = {
	    /**
	     * Transform an array of int into a string, chunk by chunk.
	     * See the performances notes on arrayLikeToString.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @param {String} type the type of the array.
	     * @param {Integer} chunk the chunk size.
	     * @return {String} the resulting string.
	     * @throws Error if the chunk is too big for the stack.
	     */
	    stringifyByChunk: function(array, type, chunk) {
	        var result = [], k = 0, len = array.length;
	        // shortcut
	        if (len <= chunk) {
	            return String.fromCharCode.apply(null, array);
	        }
	        while (k < len) {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        return result.join("");
	    },
	    /**
	     * Call String.fromCharCode on every item in the array.
	     * This is the naive implementation, which generate A LOT of intermediate string.
	     * This should be used when everything else fail.
	     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	     * @return {String} the result.
	     */
	    stringifyByChar: function(array){
	        var resultStr = "";
	        for(var i = 0; i < array.length; i++) {
	            resultStr += String.fromCharCode(array[i]);
	        }
	        return resultStr;
	    },
	    applyCanBeUsed : {
	        /**
	         * true if the browser accepts to use String.fromCharCode on Uint8Array
	         */
	        uint8array : (function () {
	            try {
	                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })(),
	        /**
	         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
	         */
	        nodebuffer : (function () {
	            try {
	                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
	            } catch (e) {
	                return false;
	            }
	        })()
	    }
	};
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    // TODO : we now have workers that split the work. Do we still need that ?
	    var chunk = 65536,
	        type = exports.getTypeOf(array),
	        canUseApply = true;
	    if (type === "uint8array") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
	    } else if (type === "nodebuffer") {
	        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
	    }
	
	    if (canUseApply) {
	        while (chunk > 1) {
	            try {
	                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
	            } catch (e) {
	                chunk = Math.floor(chunk / 2);
	            }
	        }
	    }
	
	    // no apply or chunk error : slow and painful algorithm
	    // default browser on android 4.*
	    return arrayToStringHelper.stringifyByChar(array);
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodejsUtils.newBufferFrom(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this platform");
	    }
	};
	
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Defer the call of a function.
	 * @param {Function} callback the function to call asynchronously.
	 * @param {Array} args the arguments to give to the callback.
	 */
	exports.delay = function(callback, args, self) {
	    setImmediate(function () {
	        callback.apply(self || null, args || []);
	    });
	};
	
	/**
	 * Extends a prototype with an other, without calling a constructor with
	 * side effects. Inspired by nodejs' `utils.inherits`
	 * @param {Function} ctor the constructor to augment
	 * @param {Function} superCtor the parent constructor to use
	 */
	exports.inherits = function (ctor, superCtor) {
	    var Obj = function() {};
	    Obj.prototype = superCtor.prototype;
	    ctor.prototype = new Obj();
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transform arbitrary content into a Promise.
	 * @param {String} name a name for the content being processed.
	 * @param {Object} inputData the content to process.
	 * @param {Boolean} isBinary true if the content is not an unicode string
	 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
	 * @param {Boolean} isBase64 true if the string content is encoded with base64.
	 * @return {Promise} a promise in a format usable by JSZip.
	 */
	exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
	
	    // if inputData is already a promise, this flatten it.
	    var promise = external.Promise.resolve(inputData).then(function(data) {
	        
	        
	        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);
	
	        if (isBlob && typeof FileReader !== "undefined") {
	            return new external.Promise(function (resolve, reject) {
	                var reader = new FileReader();
	
	                reader.onload = function(e) {
	                    resolve(e.target.result);
	                };
	                reader.onerror = function(e) {
	                    reject(e.target.error);
	                };
	                reader.readAsArrayBuffer(data);
	            });
	        } else {
	            return data;
	        }
	    });
	
	    return promise.then(function(data) {
	        var dataType = exports.getTypeOf(data);
	
	        if (!dataType) {
	            return external.Promise.reject(
	                new Error("Can't read the data of '" + name + "'. Is it " +
	                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
	            );
	        }
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = exports.transformTo("uint8array", data);
	        } else if (dataType === "string") {
	            if (isBase64) {
	                data = base64.decode(data);
	            }
	            else if (isBinary) {
	                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
	                if (isOptimizedBinaryString !== true) {
	                    // this is a string, not in a base64 format.
	                    // Be sure that this is a correct "binary string"
	                    data = string2binary(data);
	                }
	            }
	        }
	        return data;
	    });
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(459);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(458);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1142);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1141);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var IE8_DOM_DEFINE = __webpack_require__(324);
	var toPrimitive = __webpack_require__(63);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var DOMProperty = __webpack_require__(120);
	var ReactDOMComponentFlags = __webpack_require__(435);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(61);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1069);


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ConfirmButtons;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfirmButtons = __webpack_require__(798);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConfirmButtons(_ref) {
	  var _ref$cancelText = _ref.cancelText,
	      cancelText = _ref$cancelText === undefined ? 'Cancel' : _ref$cancelText,
	      _ref$confirmText = _ref.confirmText,
	      confirmText = _ref$confirmText === undefined ? 'Save' : _ref$confirmText,
	      _ref$onCancel = _ref.onCancel,
	      onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel,
	      _ref$onConfirm = _ref.onConfirm,
	      onConfirm = _ref$onConfirm === undefined ? function () {} : _ref$onConfirm,
	      _ref$confirmDisabled = _ref.confirmDisabled,
	      confirmDisabled = _ref$confirmDisabled === undefined ? false : _ref$confirmDisabled,
	      _ref$confirmDisabledT = _ref.confirmDisabledText,
	      confirmDisabledText = _ref$confirmDisabledT === undefined ? null : _ref$confirmDisabledT,
	      _ref$confirmHidden = _ref.confirmHidden,
	      confirmHidden = _ref$confirmHidden === undefined ? false : _ref$confirmHidden,
	      _ref$middleButtons = _ref.middleButtons,
	      middleButtons = _ref$middleButtons === undefined ? [] : _ref$middleButtons,
	      _ref$appendButtons = _ref.appendButtons,
	      appendButtons = _ref$appendButtons === undefined ? [] : _ref$appendButtons;
	
	  var renderButton = function renderButton(button) {
	    return _react2.default.createElement(
	      'button',
	      {
	        key: button.text,
	        type: 'button',
	        className: button.text === 'Save' ? _ConfirmButtons2.default.confirmButton : _ConfirmButtons2.default.button,
	        onClick: button.onClick,
	        disabled: button.disabled },
	      button.text
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _ConfirmButtons2.default.buttons },
	    _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: _ConfirmButtons2.default.cancelButton,
	        onClick: onCancel },
	      cancelText
	    ),
	    middleButtons.map(renderButton),
	    !confirmHidden && _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: _ConfirmButtons2.default.confirmButton,
	        onClick: onConfirm,
	        disabled: confirmDisabled },
	      confirmDisabled && confirmDisabledText || confirmText
	    ),
	    appendButtons.map(renderButton)
	  );
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(27);
	var createDesc = __webpack_require__(94);
	module.exports = __webpack_require__(24) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(36);
	var has = __webpack_require__(44);
	var SRC = __webpack_require__(98)('src');
	var $toString = __webpack_require__(588);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(52).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(61);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(404);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.albumsRequest = albumsRequest;
	exports.albumsSuccess = albumsSuccess;
	exports.albumsFailure = albumsFailure;
	exports.favouriteAlbumsRequest = favouriteAlbumsRequest;
	exports.favouriteAlbumsSuccess = favouriteAlbumsSuccess;
	exports.favouriteAlbumsFailure = favouriteAlbumsFailure;
	exports.fetchAlbums = fetchAlbums;
	exports.fetchFavouriteAlbums = fetchFavouriteAlbums;
	
	var _normalizr = __webpack_require__(103);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	var _album = __webpack_require__(66);
	
	var _share = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALBUMS_REQUEST = 'blayzr/albums/REQUEST';
	var ALBUMS_SUCCESS = 'blayzr/albums/SUCCESS';
	var ALBUMS_FAILURE = 'blayzr/albums/FAIL';
	
	var FAVOURITE_ALBUMS_REQUEST = 'blayzr/albums/FAVOURITES_REQUEST';
	var FAVOURITE_ALBUMS_SUCCESS = 'blayzr/albums/FAVOURITES_SUCCESS';
	var FAVOURITE_ALBUMS_FAILURE = 'blayzr/albums/FAVOURITES_FAIL';
	
	var initialListState = {
	  data: null,
	  fetching: false,
	  error: null
	};
	
	var initialState = {
	  all: initialListState,
	  favourites: initialListState
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type;
	
	  switch (type) {
	    case ALBUMS_REQUEST:
	    case ALBUMS_SUCCESS:
	    case ALBUMS_FAILURE:
	    case _album.SAVE_ALBUM_SUCCESS:
	    case _share.UNSHARE_ALBUM:
	      return _extends({}, state, {
	        all: listReducer(state.all, action)
	      });
	    case FAVOURITE_ALBUMS_REQUEST:
	    case FAVOURITE_ALBUMS_SUCCESS:
	    case FAVOURITE_ALBUMS_FAILURE:
	    case _album.SET_FAVOURITE_ALBUM:
	    case _album.REMOVE_FAVOURITE_ALBUM:
	      return _extends({}, state, {
	        favourites: listReducer(state.favourites, action)
	      });
	    case _album.DELETE_ALBUM:
	      return {
	        all: listReducer(state.all, action),
	        favourites: listReducer(state.favourites, action)
	      };
	    default:
	      return state;
	  }
	}
	
	function listReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialListState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case ALBUMS_REQUEST:
	    case FAVOURITE_ALBUMS_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case ALBUMS_SUCCESS:
	    case FAVOURITE_ALBUMS_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: (0, _lodash2.default)((state.data || []).concat(payload.result.records))
	      });
	    case ALBUMS_FAILURE:
	    case FAVOURITE_ALBUMS_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case _album.SAVE_ALBUM_SUCCESS:
	    case _album.SET_FAVOURITE_ALBUM:
	      // Append album to album group
	      if (state.data && state.data.indexOf(meta.id) === -1) {
	        return _extends({}, state, {
	          data: state.data.concat(meta.id)
	        });
	      }
	      return state;
	    case _album.DELETE_ALBUM:
	    case _album.REMOVE_FAVOURITE_ALBUM:
	      // Remove album from album group
	      if (state.data) {
	        return _extends({}, state, {
	          data: state.data.filter(function (id) {
	            return id !== meta.id;
	          })
	        });
	      }
	      return state;
	    case _share.UNSHARE_ALBUM:
	      // Remove album that you unshare yourself from
	      console.log('unshare', state, meta);
	      if (state.data && meta.removeFromAlbums) {
	        return _extends({}, state, {
	          data: state.data.filter(function (id) {
	            return id !== meta.albumID;
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function albumsRequest() {
	  return {
	    type: ALBUMS_REQUEST
	  };
	}
	
	function albumsSuccess(data) {
	  return {
	    type: ALBUMS_SUCCESS,
	    payload: data
	  };
	}
	
	function albumsFailure(error) {
	  return {
	    type: ALBUMS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function favouriteAlbumsRequest() {
	  return {
	    type: FAVOURITE_ALBUMS_REQUEST
	  };
	}
	
	function favouriteAlbumsSuccess(data) {
	  return {
	    type: FAVOURITE_ALBUMS_SUCCESS,
	    payload: data
	  };
	}
	
	function favouriteAlbumsFailure(error) {
	  return {
	    type: FAVOURITE_ALBUMS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	var schema = {
	  records: (0, _normalizr.arrayOf)(_fetch.schemas.album)
	};
	
	function fetchAlbums() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      schema: schema
	    };
	    dispatch(albumsRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_ALBUMS, options, dispatch).then(function (data) {
	      dispatch(albumsSuccess(data));
	    }, function (e) {
	      dispatch(albumsFailure(e));
	    });
	  };
	}
	
	function fetchFavouriteAlbums() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      schema: schema
	    };
	    dispatch(favouriteAlbumsRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_FAVOURITE_ALBUMS, options, dispatch).then(function (data) {
	      dispatch(favouriteAlbumsSuccess(data));
	    }, function (e) {
	      dispatch(favouriteAlbumsFailure(e));
	    });
	  };
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.REFRESH_TOKENS_REQUEST = exports.LOGOUT = exports.LOGIN_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.loginRequest = loginRequest;
	exports.loginSuccess = loginSuccess;
	exports.loginFailure = loginFailure;
	exports.logout = logout;
	exports.refreshTokensRequest = refreshTokensRequest;
	exports.login = login;
	exports.shareLogin = shareLogin;
	exports.loginAndJoinOrchestra = loginAndJoinOrchestra;
	exports.refreshTokens = refreshTokens;
	exports.tokenRefreshMiddleware = tokenRefreshMiddleware;
	exports.externalUserMiddleware = externalUserMiddleware;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _jwtDecode = __webpack_require__(915);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _jsCookie = __webpack_require__(251);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _albums = __webpack_require__(41);
	
	var _users = __webpack_require__(68);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGIN_REQUEST = 'blayzr/auth/LOGIN_REQUEST';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'blayzr/auth/LOGIN_SUCCESS';
	var LOGIN_FAILURE = 'blayzr/auth/LOGIN_FAIL';
	var LOGOUT = exports.LOGOUT = 'blayzr/auth/LOGOUT';
	var REFRESH_TOKENS_REQUEST = exports.REFRESH_TOKENS_REQUEST = 'blayzr/auth/REFRESH_TOKENS_REQUEST';
	
	var initialState = {
	  token: null,
	  user: null,
	  aws: null,
	  authenticated: false,
	  authenticating: false,
	  refreshing: false,
	  error: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case LOGIN_REQUEST:
	      return _extends({}, state, {
	        authenticating: true,
	        error: null
	      });
	    case LOGIN_SUCCESS:
	      return _extends({}, state, {
	        token: payload.token,
	        user: payload.user,
	        aws: payload.aws,
	        no_download: payload.no_download,
	        limit_to_path: payload.limit_to_path,
	        authenticated: true,
	        authenticating: false
	      });
	    case LOGIN_FAILURE:
	      return _extends({}, state, {
	        token: null,
	        user: null,
	        authenticated: false,
	        authenticating: false,
	        error: payload.error
	      });
	    case REFRESH_TOKENS_REQUEST:
	      return _extends({}, state, {
	        refreshing: true
	      });
	    case _users.UPDATE_USER_REQUEST:
	      var user = payload.entities.users[state.user.id];
	      if (user) {
	        return _extends({}, state, {
	          user: _extends({}, state.user, {
	            original_settings: JSON.parse(user.settings)
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function loginRequest() {
	  return {
	    type: LOGIN_REQUEST
	  };
	}
	
	var lastLoggedInTime = void 0;
	var logoutCheckTimeout = void 0;
	
	function loginSuccess(data) {
	  return function (dispatch, getState) {
	    _jsCookie2.default.set(_constants.AUTH_COOKIE_KEY, data, {
	      expires: new Date(+new Date() + 1000 * _constants.AUTH_COOKIE_EXPIRY)
	      // TODO: secure: true
	    });
	    var user = (0, _jwtDecode2.default)(data.auth);
	    user.original_settings = JSON.parse(user.settings);
	    user.settings = _extends({}, JSON.parse(user.global_settings), JSON.parse(user.settings), _lscache2.default.get(_constants.SETTINGS_CACHE_KEY));
	    dispatch({
	      type: LOGIN_SUCCESS,
	      payload: {
	        token: data.auth,
	        user: _extends({}, user, {
	          // Append virtual library to user library list
	          libraries: user.libraries.concat({
	            library: {
	              id: 0,
	              library_token: 'virtual_' + user.id
	            }
	          })
	        }),
	        aws: data.aws,
	        no_download: data.no_download,
	        limit_to_path: data.path
	      }
	    });
	
	    var _getState = getState(),
	        albums = _getState.albums,
	        users = _getState.users;
	
	    if (!albums.favourites.data) {
	      dispatch((0, _albums.fetchFavouriteAlbums)());
	    }
	    if (!users.data) {
	      dispatch((0, _users.fetchUsers)());
	    }
	    _lscache2.default.setBucket(user.email);
	
	    lastLoggedInTime = +new Date();
	    logoutCheck(dispatch, getState);
	  };
	}
	
	function logoutCheck(dispatch, getState) {
	  clearTimeout(logoutCheckTimeout);
	  var route = getState().routing.locationBeforeTransitions.pathname;
	  var isPresenting = /^\/present/.test(route);
	  var isArrangingOrchestra = /^\/orchestras/.test(route);
	  var shouldCheck = +new Date() - lastLoggedInTime > 10 * 60 * 1000; // If last login was over 10 minutes ago
	  if (shouldCheck && !isPresenting && !isArrangingOrchestra) {
	    dispatch(logout());
	  } else {
	    logoutCheckTimeout = setTimeout(function () {
	      logoutCheck(dispatch, getState);
	    }, 5000);
	  }
	}
	
	function loginFailure(error) {
	  return {
	    type: LOGIN_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function logout() {
	  _jsCookie2.default.remove(_constants.AUTH_COOKIE_KEY);
	  return {
	    type: LOGOUT
	  };
	}
	
	function refreshTokensRequest() {
	  return {
	    type: REFRESH_TOKENS_REQUEST
	  };
	}
	
	function login(email, password, redirect) {
	  return function (dispatch) {
	    dispatch(loginRequest());
	
	    return (0, _fetch.fetch)(_constants.ENDPOINT_LOGIN, {
	      method: 'post',
	      body: { email: email, password: password }
	    }).then(function (data) {
	      return onLoginResponse(data, dispatch, redirect);
	    }, function (e) {
	      return onLoginError(e, dispatch);
	    });
	  };
	}
	
	function shareLogin(code) {
	  return function (dispatch) {
	    var endpoint = _constants.ENDPOINT_SHARING.replace(':code', code);
	    dispatch(loginRequest());
	    (0, _fetch.fetch)(endpoint).then(function (data) {
	      return onLoginResponse(data, dispatch);
	    }, function (e) {
	      return onLoginError(e, dispatch);
	    });
	  };
	}
	
	function loginAndJoinOrchestra(code) {
	  return function (dispatch) {
	    var endpoint = _constants.ENDPOINT_SHARING.replace(':code', code);
	    dispatch(loginRequest());
	    (0, _fetch.fetch)(endpoint).then(function (data) {
	      return onLoginResponse(data, dispatch);
	    }, function (e) {
	      return onLoginError(e, dispatch);
	    });
	  };
	}
	
	function onLoginResponse(data, dispatch, redirect) {
	  try {
	    (0, _jwtDecode2.default)(data.records.auth); // Validate token
	    dispatch(loginSuccess(data.records));
	    if (data.records.path) {
	      dispatch((0, _reactRouterRedux.push)(data.records.path));
	    } else if (redirect) {
	      dispatch((0, _reactRouterRedux.push)(redirect));
	    }
	  } catch (e) {
	    dispatch(loginFailure({
	      response: {
	        status: 403,
	        statusText: 'Invalid token'
	      }
	    }));
	  }
	}
	
	function onLoginError(e, dispatch) {
	  console.error(e);
	  dispatch(loginFailure(e));
	  throw e;
	}
	
	function refreshTokens() {
	  return function (dispatch, getState) {
	    var token = getState().auth.token;
	
	    if (!token) {
	      return;
	    }
	    var options = { method: 'post', token: token };
	    return Promise.all([(0, _fetch.fetch)(_constants.ENDPOINT_REFRESH_TOKENS, options, dispatch), (0, _fetch.fetch)(_constants.ENDPOINT_REFRESH_AWS, options, dispatch)]).then(function () {
	      lastLoggedInTime = +new Date();
	    });
	    // dispatch(refreshTokensRequest())
	    // return fetch(ENDPOINT_REFRESH_TOKENS, { token }, dispatch).then(data => {
	    //   dispatch(loginSuccess(data.records))
	    // })
	  };
	}
	
	// Redux middleware to refresh tokens a short time after a change to the store
	// Thunks and the refresh actions themselves are ignored to prevent an infinite loop
	var refreshTokenTimeout = void 0;
	function tokenRefreshMiddleware(store) {
	  return function (next) {
	    return function (action) {
	      if (store.getState().auth.authenticated && store.getState().auth.user.id !== 0 && typeof action !== 'function' && action.type !== REFRESH_TOKENS_REQUEST && action.type !== LOGIN_SUCCESS) {
	        clearTimeout(refreshTokenTimeout);
	        refreshTokenTimeout = setTimeout(function () {
	          return next(refreshTokens());
	        }, _constants.REFRESH_TOKENS_DELAY * 1000);
	      }
	      return next(action);
	    };
	  };
	}
	
	// Prevent external users from navigating anywhere
	function externalUserMiddleware(store) {
	  return function (next) {
	    return function (action) {
	      if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
	        var state = store.getState();
	        if (state.auth.user && state.auth.user.id === 0 && state.auth.limit_to_path !== action.payload.pathname) {
	          next(logout());
	          return;
	        }
	      }
	      return next(action);
	    };
	  };
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.playlistsRequest = playlistsRequest;
	exports.playlistsSuccess = playlistsSuccess;
	exports.playlistsFailure = playlistsFailure;
	exports.savePlaylistRequest = savePlaylistRequest;
	exports.savePlaylistSuccess = savePlaylistSuccess;
	exports.savePlaylistFailure = savePlaylistFailure;
	exports.fetchPlaylists = fetchPlaylists;
	exports.saveList = saveList;
	exports.savePlaylist = savePlaylist;
	exports.deletePlaylist = deletePlaylist;
	exports.addAlbumToList = addAlbumToList;
	exports.removeAlbumFromList = removeAlbumFromList;
	exports.updateListOrder = updateListOrder;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _normalizr = __webpack_require__(103);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(381);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PLAYLISTS_REQUEST = 'blayzr/playlists/REQUEST';
	var PLAYLISTS_SUCCESS = 'blayzr/playlists/SUCCESS';
	var PLAYLISTS_FAILURE = 'blayzr/playlists/FAIL';
	
	var SAVE_PLAYLIST_REQUEST = 'blayzr/playlists/SAVE_REQUEST';
	var SAVE_PLAYLIST_SUCCESS = 'blayzr/playlists/SAVE_SUCCESS';
	var SAVE_PLAYLIST_FAILURE = 'blayzr/playlists/SAVE_FAIL';
	
	var DELETE_PLAYLIST = 'blayzr/playlists/DELETE';
	var REORDER_LISTS = 'blayzr/playlists/REORDER_LISTS';
	
	var initialState = {
	  playlists: null,
	  lists: null,
	  fetching: false,
	  error: null,
	  submitting: false,
	  submitError: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case PLAYLISTS_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case PLAYLISTS_SUCCESS:
	      var sortPlaylists = function sortPlaylists(a, b) {
	        var playlistA = payload.entities.playlists[a];
	        var playlistB = payload.entities.playlists[b];
	        return new Date(playlistA.created_at) > new Date(playlistB.created_at) ? -1 : 1;
	      };
	      var playlists = payload.result.records.filter(function (id) {
	        return payload.entities.playlists[id].playlist;
	      }).sort(sortPlaylists);
	      var lists = payload.result.records.filter(function (id) {
	        return !payload.entities.playlists[id].playlist;
	      }).sort(function (a, b) {
	        var playlistsOnlyA = /"playlistsOnly":true/.test(payload.entities.playlists[a].json_data);
	        var playlistsOnlyB = /"playlistsOnly":true/.test(payload.entities.playlists[b].json_data);
	        if (playlistsOnlyA && !playlistsOnlyB) return 1;
	        if (!playlistsOnlyA && playlistsOnlyB) return -1;
	        return 0;
	      });
	      return _extends({}, state, {
	        fetching: false,
	        playlists: state.playlists ? (0, _lodash2.default)(state.playlists.concat(playlists)) : playlists,
	        lists: state.lists ? (0, _lodash2.default)(state.lists.concat(lists)) : lists
	      });
	    case PLAYLISTS_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case SAVE_PLAYLIST_REQUEST:
	      return _extends({}, state, {
	        submitting: true,
	        submitError: false
	      });
	    case SAVE_PLAYLIST_SUCCESS:
	      return _extends({}, state, {
	        submitting: false,
	        playlists: state.playlists && meta.playlist ? (0, _lodash2.default)([meta.id].concat(state.playlists)) : state.playlists,
	        lists: state.lists && !meta.playlist ? (0, _lodash2.default)([meta.id].concat(state.lists)) : state.lists
	      });
	    case SAVE_PLAYLIST_FAILURE:
	      return _extends({}, state, {
	        submitting: false,
	        submitError: payload
	      });
	    case DELETE_PLAYLIST:
	      if (state.playlists) {
	        return _extends({}, state, {
	          playlists: state.playlists.filter(function (id) {
	            return id !== meta.id;
	          }),
	          lists: state.lists.filter(function (id) {
	            return id !== meta.id;
	          })
	        });
	      }
	      return state;
	    case REORDER_LISTS:
	      return _extends({}, state, {
	        lists: payload
	      });
	    default:
	      return state;
	  }
	}
	
	function playlistsRequest() {
	  return {
	    type: PLAYLISTS_REQUEST
	  };
	}
	
	function playlistsSuccess(data) {
	  return {
	    type: PLAYLISTS_SUCCESS,
	    payload: data
	  };
	}
	
	function playlistsFailure(error) {
	  return {
	    type: PLAYLISTS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function savePlaylistRequest() {
	  return {
	    type: SAVE_PLAYLIST_REQUEST
	  };
	}
	
	function savePlaylistSuccess(id, data) {
	  var playlist = data.entities.playlists[id];
	  return {
	    type: SAVE_PLAYLIST_SUCCESS,
	    payload: { entities: { playlists: _defineProperty({}, id, playlist) } },
	    meta: {
	      id: id,
	      playlist: playlist.playlist
	    }
	  };
	}
	
	function savePlaylistFailure(error) {
	  return {
	    type: SAVE_PLAYLIST_FAILURE,
	    payload: error
	  };
	}
	
	function fetchPlaylists() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      schema: {
	        records: (0, _normalizr.arrayOf)(_fetch.schemas.playlist)
	      }
	    };
	    dispatch(playlistsRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_PLAYLISTS, options, dispatch).then(function (data) {
	      dispatch(playlistsSuccess(data));
	    }, function (e) {
	      dispatch(playlistsFailure(e));
	    });
	  };
	}
	
	function saveList(data, structure, id) {
	  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/playlists/:id';
	
	  return function (dispatch, getState) {
	    var endpoint = id ? _constants.ENDPOINT_PLAYLIST.replace(':id', id) : _constants.ENDPOINT_NEW_PLAYLIST;
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      schema: {
	        records: _fetch.schemas.playlist
	      },
	      body: _extends({}, data, {
	        albums: undefined, // Albums property is added by mapStateToLists util, so remove here
	        json_data: JSON.stringify(structure)
	      })
	    };
	    dispatch(savePlaylistRequest());
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      var id = data.result.records;
	      dispatch(savePlaylistSuccess(id, data));
	      if (redirect) {
	        dispatch((0, _reactRouterRedux.push)(redirect.replace(':id', id)));
	      }
	      return data.entities.playlists[id];
	    }, function (e) {
	      dispatch(savePlaylistFailure(e));
	    });
	  };
	}
	
	function savePlaylist(data) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return saveList.apply(undefined, [_extends({}, data, { playlist: true })].concat(args));
	}
	
	function deletePlaylist(id) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var endpoint = _constants.ENDPOINT_PLAYLIST.replace(':id', id);
	    (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: state.auth.token
	    });
	    dispatch({
	      type: DELETE_PLAYLIST,
	      meta: { id: id },
	      payload: {
	        entities: {
	          playlists: _defineProperty({}, id, undefined),
	          // Remove playlist ID from any queues
	          queues: (0, _lodash4.default)(state.entities.queues || {}, function (queue) {
	            var data = JSON.parse(queue.json_data);
	            return _extends({}, queue, {
	              json_data: JSON.stringify(_extends({}, data, {
	                playlists: data.playlists.filter(function (playlistID) {
	                  return playlistID !== id;
	                })
	              }))
	            });
	          })
	        }
	      }
	    });
	    dispatch((0, _reactRouterRedux.push)('/playlists'));
	  };
	}
	
	function addAlbumToList(albumID, list) {
	  var structure = JSON.parse(list.json_data);
	  if (structure.albums.map(function (a) {
	    return a.album;
	  }).indexOf(albumID) === -1) {
	    structure.albums.push({ album: albumID });
	  }
	  return saveList(list, structure, list.id, null);
	}
	
	function removeAlbumFromList(albumID, list) {
	  var structure = JSON.parse(list.json_data);
	  structure.albums = structure.albums.filter(function (a) {
	    return a.album !== albumID;
	  });
	  return saveList(list, structure, list.id, null);
	}
	
	function updateListOrder(ids) {
	  return function (dispatch, getState) {
	    (0, _fetch.fetch)(_constants.ENDPOINT_PLAYLISTS, {
	      method: 'put',
	      token: getState().auth.token,
	      body: { sort: ids }
	    });
	    dispatch({
	      type: REORDER_LISTS,
	      payload: ids
	    });
	  };
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(132);
	var createDesc = __webpack_require__(94);
	var toIObject = __webpack_require__(47);
	var toPrimitive = __webpack_require__(63);
	var has = __webpack_require__(44);
	var IE8_DOM_DEFINE = __webpack_require__(324);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(24) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(44);
	var toObject = __webpack_require__(29);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(131);
	var defined = __webpack_require__(61);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A worker that does nothing but passing chunks to the next one. This is like
	 * a nodejs stream but with some differences. On the good side :
	 * - it works on IE 6-9 without any issue / polyfill
	 * - it weights less than the full dependencies bundled with browserify
	 * - it forwards errors (no need to declare an error handler EVERYWHERE)
	 *
	 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
	 * object containing anything (`percent` for example), see each worker for more
	 * details. The latter is the real data (String, Uint8Array, etc).
	 *
	 * @constructor
	 * @param {String} name the name of the stream (mainly used for debugging purposes)
	 */
	function GenericWorker(name) {
	    // the name of the worker
	    this.name = name || "default";
	    // an object containing metadata about the workers chain
	    this.streamInfo = {};
	    // an error which happened when the worker was paused
	    this.generatedError = null;
	    // an object containing metadata to be merged by this worker into the general metadata
	    this.extraStreamInfo = {};
	    // true if the stream is paused (and should not do anything), false otherwise
	    this.isPaused = true;
	    // true if the stream is finished (and should not do anything), false otherwise
	    this.isFinished = false;
	    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
	    this.isLocked = false;
	    // the event listeners
	    this._listeners = {
	        'data':[],
	        'end':[],
	        'error':[]
	    };
	    // the previous worker, if any
	    this.previous = null;
	}
	
	GenericWorker.prototype = {
	    /**
	     * Push a chunk to the next workers.
	     * @param {Object} chunk the chunk to push
	     */
	    push : function (chunk) {
	        this.emit("data", chunk);
	    },
	    /**
	     * End the stream.
	     * @return {Boolean} true if this call ended the worker, false otherwise.
	     */
	    end : function () {
	        if (this.isFinished) {
	            return false;
	        }
	
	        this.flush();
	        try {
	            this.emit("end");
	            this.cleanUp();
	            this.isFinished = true;
	        } catch (e) {
	            this.emit("error", e);
	        }
	        return true;
	    },
	    /**
	     * End the stream with an error.
	     * @param {Error} e the error which caused the premature end.
	     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
	     */
	    error : function (e) {
	        if (this.isFinished) {
	            return false;
	        }
	
	        if(this.isPaused) {
	            this.generatedError = e;
	        } else {
	            this.isFinished = true;
	
	            this.emit("error", e);
	
	            // in the workers chain exploded in the middle of the chain,
	            // the error event will go downward but we also need to notify
	            // workers upward that there has been an error.
	            if(this.previous) {
	                this.previous.error(e);
	            }
	
	            this.cleanUp();
	        }
	        return true;
	    },
	    /**
	     * Add a callback on an event.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Function} listener the function to call when the event is triggered
	     * @return {GenericWorker} the current object for chainability
	     */
	    on : function (name, listener) {
	        this._listeners[name].push(listener);
	        return this;
	    },
	    /**
	     * Clean any references when a worker is ending.
	     */
	    cleanUp : function () {
	        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
	        this._listeners = [];
	    },
	    /**
	     * Trigger an event. This will call registered callback with the provided arg.
	     * @param {String} name the name of the event (data, end, error)
	     * @param {Object} arg the argument to call the callback with.
	     */
	    emit : function (name, arg) {
	        if (this._listeners[name]) {
	            for(var i = 0; i < this._listeners[name].length; i++) {
	                this._listeners[name][i].call(this, arg);
	            }
	        }
	    },
	    /**
	     * Chain a worker with an other.
	     * @param {Worker} next the worker receiving events from the current one.
	     * @return {worker} the next worker for chainability
	     */
	    pipe : function (next) {
	        return next.registerPrevious(this);
	    },
	    /**
	     * Same as `pipe` in the other direction.
	     * Using an API with `pipe(next)` is very easy.
	     * Implementing the API with the point of view of the next one registering
	     * a source is easier, see the ZipFileWorker.
	     * @param {Worker} previous the previous worker, sending events to this one
	     * @return {Worker} the current worker for chainability
	     */
	    registerPrevious : function (previous) {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	
	        // sharing the streamInfo...
	        this.streamInfo = previous.streamInfo;
	        // ... and adding our own bits
	        this.mergeStreamInfo();
	        this.previous =  previous;
	        var self = this;
	        previous.on('data', function (chunk) {
	            self.processChunk(chunk);
	        });
	        previous.on('end', function () {
	            self.end();
	        });
	        previous.on('error', function (e) {
	            self.error(e);
	        });
	        return this;
	    },
	    /**
	     * Pause the stream so it doesn't send events anymore.
	     * @return {Boolean} true if this call paused the worker, false otherwise.
	     */
	    pause : function () {
	        if(this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = true;
	
	        if(this.previous) {
	            this.previous.pause();
	        }
	        return true;
	    },
	    /**
	     * Resume a paused stream.
	     * @return {Boolean} true if this call resumed the worker, false otherwise.
	     */
	    resume : function () {
	        if(!this.isPaused || this.isFinished) {
	            return false;
	        }
	        this.isPaused = false;
	
	        // if true, the worker tried to resume but failed
	        var withError = false;
	        if(this.generatedError) {
	            this.error(this.generatedError);
	            withError = true;
	        }
	        if(this.previous) {
	            this.previous.resume();
	        }
	
	        return !withError;
	    },
	    /**
	     * Flush any remaining bytes as the stream is ending.
	     */
	    flush : function () {},
	    /**
	     * Process a chunk. This is usually the method overridden.
	     * @param {Object} chunk the chunk to process.
	     */
	    processChunk : function(chunk) {
	        this.push(chunk);
	    },
	    /**
	     * Add a key/value to be added in the workers chain streamInfo once activated.
	     * @param {String} key the key to use
	     * @param {Object} value the associated value
	     * @return {Worker} the current worker for chainability
	     */
	    withStreamInfo : function (key, value) {
	        this.extraStreamInfo[key] = value;
	        this.mergeStreamInfo();
	        return this;
	    },
	    /**
	     * Merge this worker's streamInfo into the chain's streamInfo.
	     */
	    mergeStreamInfo : function () {
	        for(var key in this.extraStreamInfo) {
	            if (!this.extraStreamInfo.hasOwnProperty(key)) {
	                continue;
	            }
	            this.streamInfo[key] = this.extraStreamInfo[key];
	        }
	    },
	
	    /**
	     * Lock the stream to prevent further updates on the workers chain.
	     * After calling this method, all calls to pipe will fail.
	     */
	    lock: function () {
	        if (this.isLocked) {
	            throw new Error("The stream '" + this + "' has already been used.");
	        }
	        this.isLocked = true;
	        if (this.previous) {
	            this.previous.lock();
	        }
	    },
	
	    /**
	     *
	     * Pretty print the workers chain.
	     */
	    toString : function () {
	        var me = "Worker " + this.name;
	        if (this.previous) {
	            return this.previous + " -> " + me;
	        } else {
	            return me;
	        }
	    }
	};
	
	module.exports = GenericWorker;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(826);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.body.style.overflow = 'hidden';
	      if (_constants.IS_IOS && window.scrollY === 0) {
	        document.body.style.position = 'fixed';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.style.overflow = '';
	      document.body.style.position = '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          onClose = _props.onClose,
	          children = _props.children,
	          style = _props.style;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Modal2.default.modal, style: style },
	        title && _react2.default.createElement(
	          'header',
	          { className: _Modal2.default.header },
	          onClose && _react2.default.createElement(
	            'button',
	            { className: _Modal2.default.close, onClick: onClose },
	            _react2.default.createElement(_Icon2.default, { icon: 'close' })
	          ),
	          title
	        ),
	        children
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	exports.default = Modal;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryFormPlugin = exports.emptyStructure = exports.emptyQuery = exports.DEFAULT_QUERY_OPERATOR = exports.DEFAULT_OPERATOR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.selectQuery = selectQuery;
	exports.removeQuery = removeQuery;
	exports.addTerm = addTerm;
	exports.removeTerm = removeTerm;
	exports.editTerm = editTerm;
	exports.updateTerm = updateTerm;
	exports.updateOperator = updateOperator;
	exports.updateRating = updateRating;
	exports.updateSortOrder = updateSortOrder;
	exports.updateManualOrder = updateManualOrder;
	exports.setRootProperty = setRootProperty;
	exports.updateTargetDate = updateTargetDate;
	exports.replaceStructure = replaceStructure;
	exports.enableImageSelect = enableImageSelect;
	exports.disableImageSelect = disableImageSelect;
	exports.enableImageReorder = enableImageReorder;
	exports.selectImage = selectImage;
	exports.deselectImage = deselectImage;
	exports.excludeImages = excludeImages;
	exports.unexcludeAllImages = unexcludeAllImages;
	exports.unincludeAllImages = unincludeAllImages;
	exports.removeAllCameras = removeAllCameras;
	exports.resetLibraries = resetLibraries;
	exports.clearEditingState = clearEditingState;
	exports.openAdvancedSearch = openAdvancedSearch;
	exports.updateThumbSize = updateThumbSize;
	exports.fixAlbum = fixAlbum;
	exports.unfixAlbum = unfixAlbum;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _lodash = __webpack_require__(382);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(71);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _lodash5 = __webpack_require__(383);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	var _auth = __webpack_require__(42);
	
	var _banners = __webpack_require__(67);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var QUERY_SELECT = 'blayzr/query/QUERY_SELECT';
	var QUERY_REMOVE = 'blayzr/query/QUERY_REMOVE';
	var QUERY_ADD_TERM = 'blayzr/query/ADD_TERM';
	var QUERY_REMOVE_TERM = 'blayzr/query/REMOVE_TERM';
	var QUERY_EDIT_TERM = 'blayzr/query/EDIT_TERM';
	var QUERY_UPDATE_TERM = 'blayzr/query/UPDATE_TERM';
	var QUERY_UPDATE_OPERATOR = 'blayzr/query/UPDATE_OPERATOR';
	var QUERY_UPDATE_SORT_ORDER = 'blayzr/query/UPDATE_SORT_ORDER';
	var QUERY_UPDATE_RATING = 'blayzr/query/UPDATE_RATING';
	var QUERY_REMOVE_ALL_CAMERAS = 'blayzr/query/REMOVE_ALL_CAMERAS';
	var QUERY_RESET_LIBRARIES = 'blayzr/query/RESET_LIBRARIES';
	var QUERY_SET_ROOT_PROPERTY = 'blayzr/query/SET_ROOT_PROPERTY';
	var QUERY_UPDATE_TARGET_DATE = 'blayzr/query/UPDATE_TARGET_DATE';
	var QUERY_CLEAR_EDITING_STATE = 'blayzr/query/CLEAR_EDITING_STATE';
	var REPLACE_STRUCTURE = 'blayzr/query/REPLACE_STRUCTURE';
	
	var SET_IMAGE_SELECT_MODE = 'blayzr/query/SET_IMAGE_SELECT_MODE';
	var SET_IMAGE_REORDER_MODE = 'blayzr/query/SET_IMAGE_REORDER_MODE';
	var SELECT_IMAGE = 'blayzr/query/SELECT_IMAGE';
	var DESELECT_IMAGE = 'blayzr/query/DESELECT_IMAGE';
	var EXCLUDE_IMAGES = 'blayzr/query/EXCLUDE_IMAGES';
	var UNEXCLUDE_ALL_IMAGES = 'blayzr/query/UNEXCLUDE_ALL_IMAGES';
	var UNINCLUDE_ALL_IMAGES = 'blayzr/query/UNINCLUDE_ALL_IMAGES';
	var OPEN_ADVANCED_SEARCH = 'blayzr/query/OPEN_ADVANCED_SEARCH';
	var UPDATE_THUMB_SIZE = 'blayzr/query/UPDATE_THUMB_SIZE';
	var FIX_ALBUM = 'blayzr/query/FIX_ALBUM';
	var UNFIX_ALBUM = 'blayzr/query/UNFIX_ALBUM';
	
	var DEFAULT_OPERATOR = exports.DEFAULT_OPERATOR = 'must';
	var DEFAULT_QUERY_OPERATOR = exports.DEFAULT_QUERY_OPERATOR = 'should';
	
	var emptyQuery = exports.emptyQuery = {
	  operator: DEFAULT_QUERY_OPERATOR,
	  freetext: [],
	  keyword: [],
	  tags: [],
	  camera: [],
	  rating: [],
	  date: [],
	  location: [],
	  other: [],
	  library: [],
	  album: [],
	  path: [],
	  dynlink: []
	};
	
	var emptyStructure = exports.emptyStructure = {
	  queries: [emptyQuery],
	  include: [],
	  exclude: [],
	  sort: {
	    value: 'relevance',
	    operator: null,
	    manual: null
	  }
	};
	
	var initialState = {
	  selectedIndex: 0,
	  structure: emptyStructure,
	  libraries: [],
	  selectImageMode: false,
	  reorderImageMode: false,
	  selectedImages: [],
	  thumbSize: 120,
	  editing: {
	    type: null,
	    index: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var selectedIndex = state.selectedIndex,
	      structure = state.structure,
	      libraries = state.libraries;
	  var queries = structure.queries;
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case QUERY_SELECT:
	      if (payload < 0) {
	        return state;
	      }
	      return _extends({}, state, {
	        selectedIndex: payload,
	        structure: _extends({}, structure, {
	          queries: [].concat(_toConsumableArray(queries.slice(0, payload)), [_extends({}, queries[payload] || (0, _images.addLibrariesToQuery)(emptyQuery, libraries))], _toConsumableArray(queries.slice(payload + 1)))
	        })
	      });
	    case QUERY_REMOVE:
	      if (queries.length === 1) {
	        return state;
	      }
	      return _extends({}, state, {
	        selectedIndex: Math.min(selectedIndex, queries.length - 2),
	        structure: _extends({}, structure, {
	          queries: [].concat(_toConsumableArray(queries.slice(0, payload)), _toConsumableArray(queries.slice(payload + 1)))
	        })
	      });
	    case QUERY_ADD_TERM:
	    case QUERY_REMOVE_TERM:
	    case QUERY_EDIT_TERM:
	    case QUERY_UPDATE_TERM:
	    case QUERY_UPDATE_OPERATOR:
	    case QUERY_UPDATE_RATING:
	    case QUERY_REMOVE_ALL_CAMERAS:
	    case QUERY_RESET_LIBRARIES:
	      var newState = _extends({}, state, {
	        structure: _extends({}, structure, {
	          queries: [].concat(_toConsumableArray(queries.slice(0, selectedIndex)), [queryReducer(queries[selectedIndex], action, state.libraries, state.editing)], _toConsumableArray(queries.slice(selectedIndex + 1)))
	        })
	      });
	      if (type === QUERY_EDIT_TERM && meta.type === 'dynlink') {
	        newState.editing = {
	          type: meta.type,
	          index: meta.termIndex
	        };
	      }
	      if (type === QUERY_ADD_TERM || type === QUERY_UPDATE_TERM) {
	        // Reset editing state
	        newState.editing = initialState.editing;
	      }
	      return newState;
	    case QUERY_CLEAR_EDITING_STATE:
	      return _extends({}, state, {
	        editing: initialState.editing
	      });
	    case QUERY_SET_ROOT_PROPERTY:
	      return _extends({}, state, {
	        structure: _extends({}, structure, _defineProperty({}, meta.key, payload))
	      });
	    case QUERY_UPDATE_TARGET_DATE:
	      return _extends({}, state, {
	        structure: _extends({}, structure, {
	          date_target: payload
	        })
	      });
	    case REPLACE_STRUCTURE:
	      return _extends({}, state, {
	        selectedIndex: 0,
	        structure: (0, _lodash2.default)({}, (0, _images.addLibrariesToStructure)(emptyStructure, libraries), payload, structureMerger),
	        selectImageMode: false,
	        reorderImageMode: false,
	        selectedImages: []
	      });
	    case _auth.LOGIN_SUCCESS:
	      var libs = payload.user.libraries.map(function (library) {
	        return library.library.library_token;
	      });
	      return _extends({}, state, {
	        libraries: libs,
	        structure: (0, _images.addLibrariesToStructure)(structure, libs)
	      });
	    case SET_IMAGE_SELECT_MODE:
	      return _extends({}, state, {
	        selectImageMode: payload,
	        selectedImages: [],
	        reorderImageMode: false
	      });
	    case SET_IMAGE_REORDER_MODE:
	      return _extends({}, state, {
	        reorderImageMode: payload
	      });
	    case SELECT_IMAGE:
	      return _extends({}, state, {
	        selectImageMode: true,
	        selectedImages: (0, _lodash4.default)(state.selectedImages.concat(payload))
	      });
	    case DESELECT_IMAGE:
	      var selectedImages = state.selectedImages.filter(function (id) {
	        return id !== payload;
	      });
	      return _extends({}, state, {
	        selectedImages: selectedImages,
	        selectImageMode: selectedImages.length !== 0
	      });
	    case EXCLUDE_IMAGES:
	      return _extends({}, state, {
	        structure: _extends({}, structure, {
	          exclude: structure.exclude.concat(payload)
	        }),
	        selectImageMode: false,
	        reorderImageMode: false,
	        selectedImages: []
	      });
	    case UNEXCLUDE_ALL_IMAGES:
	      return _extends({}, state, {
	        structure: _extends({}, structure, {
	          exclude: []
	        })
	      });
	    case UNINCLUDE_ALL_IMAGES:
	      return _extends({}, state, {
	        structure: _extends({}, structure, {
	          include: []
	        })
	      });
	    case QUERY_UPDATE_SORT_ORDER:
	      return _extends({}, state, {
	        structure: _extends({}, structure, {
	          sort: {
	            value: payload,
	            operator: meta.operator,
	            manual: meta.manual ? [].concat(_toConsumableArray(meta.manual), _toConsumableArray((structure.sort.manual || []).slice(meta.manual.length))) : structure.sort.manual
	          }
	        }),
	        selectImageMode: false,
	        reorderImageMode: false,
	        selectedImages: []
	      });
	    case _reactRouterRedux.LOCATION_CHANGE:
	      return _extends({}, state, {
	        selectImageMode: false,
	        reorderImageMode: false,
	        selectedImages: []
	      });
	    case UPDATE_THUMB_SIZE:
	      return _extends({}, state, {
	        thumbSize: payload
	      });
	    case FIX_ALBUM:
	      return _extends({}, state, {
	        structure: _extends({}, state.structure, {
	          fixed: payload
	        })
	      });
	    case UNFIX_ALBUM:
	      return _extends({}, state, {
	        structure: _extends({}, state.structure, {
	          fixed: undefined
	        })
	      });
	    default:
	      return state;
	  }
	}
	
	function structureMerger(obj, src, key) {
	  // Do not do anything funky when merging libraries
	  if (key === 'library' && src.length !== 0) {
	    return src;
	  }
	  return undefined;
	}
	
	function queryReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyQuery;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var userLibraries = arguments[2];
	  var editing = arguments[3];
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case QUERY_ADD_TERM:
	      var array = state[meta.type].concat(payload);
	      if (meta.type === 'library') {
	        // Ensure libraries are not repeated
	        array = (0, _lodash6.default)(array, 'value');
	      }
	      return _extends({}, state, _defineProperty({}, meta.type, array));
	    case QUERY_REMOVE_TERM:
	    case QUERY_EDIT_TERM:
	      if (type === QUERY_EDIT_TERM && ['rating', 'dynlink'].indexOf(meta.type) !== -1) {
	        // Do not remove rating or dynlinks when editing
	        return state;
	      }
	      return _extends({}, state, _defineProperty({}, meta.type, [].concat(_toConsumableArray(state[meta.type].slice(0, meta.termIndex)), _toConsumableArray(state[meta.type].slice(meta.termIndex + 1)))));
	    case QUERY_UPDATE_TERM:
	      // If in editing mode, update at editing index
	      var index = editing.type === meta.type ? editing.index : meta.termIndex;
	      return _extends({}, state, _defineProperty({}, meta.type, [].concat(_toConsumableArray(state[meta.type].slice(0, index)), [payload], _toConsumableArray(state[meta.type].slice(index + 1)))));
	    case QUERY_UPDATE_OPERATOR:
	      return _extends({}, state, {
	        operator: payload
	      });
	    case QUERY_UPDATE_RATING:
	      return _extends({}, state, {
	        rating: payload
	      });
	    case QUERY_REMOVE_ALL_CAMERAS:
	      return _extends({}, state, {
	        camera: []
	      });
	    case QUERY_RESET_LIBRARIES:
	      return _extends({}, state, {
	        library: userLibraries.map(function (value) {
	          return { value: value, operator: 'should' };
	        })
	      });
	    default:
	      return state;
	  }
	}
	
	function selectQuery(index) {
	  return {
	    type: QUERY_SELECT,
	    payload: index
	  };
	}
	
	function removeQuery(index) {
	  return {
	    type: QUERY_REMOVE,
	    payload: index
	  };
	}
	
	function addTerm(type, value) {
	  var operator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPERATOR;
	
	  return {
	    type: QUERY_ADD_TERM,
	    payload: { value: value, operator: operator },
	    meta: { type: type }
	  };
	}
	
	function removeTerm(type) {
	  var termIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return {
	    type: QUERY_REMOVE_TERM,
	    meta: { type: type, termIndex: termIndex }
	  };
	}
	
	function editTerm(type) {
	  var termIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var value = arguments[2];
	
	  return {
	    type: QUERY_EDIT_TERM,
	    payload: value,
	    meta: { type: type, termIndex: termIndex }
	  };
	}
	
	function updateTerm(_ref) {
	  var type = _ref.type,
	      value = _ref.value,
	      _ref$termIndex = _ref.termIndex,
	      termIndex = _ref$termIndex === undefined ? 0 : _ref$termIndex;
	
	  return {
	    type: QUERY_UPDATE_TERM,
	    payload: value,
	    meta: { type: type, termIndex: termIndex }
	  };
	}
	
	function updateOperator(value) {
	  return {
	    type: QUERY_UPDATE_OPERATOR,
	    payload: value
	  };
	}
	
	function updateRating(value) {
	  return {
	    type: QUERY_UPDATE_RATING,
	    payload: value
	  };
	}
	
	function updateSortOrder(value) {
	  var operator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var manual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    type: QUERY_UPDATE_SORT_ORDER,
	    payload: value,
	    meta: {
	      operator: operator,
	      manual: manual
	    }
	  };
	}
	
	function updateManualOrder(array) {
	  return updateSortOrder('manual', null, array);
	}
	
	function setRootProperty(key, value) {
	  return {
	    type: QUERY_SET_ROOT_PROPERTY,
	    payload: value,
	    meta: { key: key }
	  };
	}
	
	function updateTargetDate(value) {
	  return setRootProperty('date_target', value);
	}
	
	function replaceStructure(payload) {
	  return {
	    type: REPLACE_STRUCTURE,
	    payload: payload
	  };
	}
	
	function enableImageSelect() {
	  return {
	    type: SET_IMAGE_SELECT_MODE,
	    payload: true
	  };
	}
	
	function disableImageSelect() {
	  return {
	    type: SET_IMAGE_SELECT_MODE,
	    payload: false
	  };
	}
	
	function enableImageReorder() {
	  return {
	    type: SET_IMAGE_REORDER_MODE,
	    payload: true
	  };
	}
	
	function selectImage(payload) {
	  return {
	    type: SELECT_IMAGE,
	    payload: payload
	  };
	}
	
	function deselectImage(payload) {
	  return {
	    type: DESELECT_IMAGE,
	    payload: payload
	  };
	}
	
	function excludeImages(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: EXCLUDE_IMAGES,
	      payload: payload
	    });
	    dispatch((0, _banners.showBanner)((0, _string.pluralize)(payload.length, 'image') + ' removed from album'));
	  };
	}
	
	function unexcludeAllImages() {
	  return {
	    type: UNEXCLUDE_ALL_IMAGES
	  };
	}
	
	function unincludeAllImages() {
	  return {
	    type: UNINCLUDE_ALL_IMAGES
	  };
	}
	
	function removeAllCameras() {
	  return {
	    type: QUERY_REMOVE_ALL_CAMERAS
	  };
	}
	
	function resetLibraries() {
	  return {
	    type: QUERY_RESET_LIBRARIES
	  };
	}
	
	function clearEditingState() {
	  return {
	    type: QUERY_CLEAR_EDITING_STATE
	  };
	}
	
	function openAdvancedSearch(type) {
	  return {
	    type: OPEN_ADVANCED_SEARCH,
	    meta: { type: type }
	  };
	}
	
	function updateThumbSize(size) {
	  return {
	    type: UPDATE_THUMB_SIZE,
	    payload: size
	  };
	}
	
	function fixAlbum(images) {
	  return {
	    type: FIX_ALBUM,
	    payload: images
	  };
	}
	
	function unfixAlbum() {
	  return {
	    type: UNFIX_ALBUM
	  };
	}
	
	var queryFormPlugin = exports.queryFormPlugin = {
	  query: function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	      case QUERY_ADD_TERM:
	      case QUERY_UPDATE_TERM:
	      case QUERY_SET_ROOT_PROPERTY:
	      case QUERY_SELECT:
	        if (action.meta && ['library', 'camera', 'rating'].indexOf(action.meta.type) !== -1) {
	          return state;
	        }
	        if (action.type === QUERY_SET_ROOT_PROPERTY && action.meta.key === 'diversity') {
	          return state;
	        }
	        return _extends({}, state, {
	          values: _extends({}, state.values, {
	            search: {}
	          })
	        });
	      case QUERY_EDIT_TERM:
	        return _extends({}, state, {
	          values: editReducer(state.values, action)
	        });
	      case OPEN_ADVANCED_SEARCH:
	        return _extends({}, state, {
	          values: _extends({}, state.values, {
	            search: _extends({}, state.values ? state.values.search : null, {
	              dropdown: true,
	              option: action.meta.type
	            })
	          })
	        });
	      case QUERY_UPDATE_RATING:
	        // Clear ratings stored by redux-form when removing all ratings
	        return _extends({}, state, {
	          values: _extends({}, state.values, {
	            rating: action.payload.length === 0 ? [] : state.values.rating
	          })
	        });
	      default:
	        return state;
	    }
	  }
	};
	
	function editReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.meta.type) {
	    case 'freetext':
	    case 'keyword':
	      return _extends({}, state, {
	        search: {
	          text: action.payload.value,
	          operator: action.payload.operator
	        }
	      });
	    case 'rating':
	    case 'location':
	    case 'camera':
	    case 'date':
	    case 'other':
	    case 'dynlink':
	      return _extends({}, state, _defineProperty({
	        search: {
	          dropdown: true,
	          option: action.meta.type
	        }
	      }, action.meta.type, action.payload));
	    default:
	      return state;
	  }
	}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(33);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(11);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(351);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.imageSearchRequest = imageSearchRequest;
	exports.imageSearchSuccess = imageSearchSuccess;
	exports.imageSearchFailure = imageSearchFailure;
	exports.optionsSuccess = optionsSuccess;
	exports.addImagesToEntities = addImagesToEntities;
	exports.searchImages = searchImages;
	exports.fetchSearchOptions = fetchSearchOptions;
	
	var _normalizr = __webpack_require__(103);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _traverse = __webpack_require__(1242);
	
	var _traverse2 = _interopRequireDefault(_traverse);
	
	var _fetch = __webpack_require__(14);
	
	var _images = __webpack_require__(23);
	
	var _auth = __webpack_require__(20);
	
	var _dynlinks = __webpack_require__(154);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IMAGE_SEARCH_REQUEST = 'blayzr/search/REQUEST';
	var IMAGE_SEARCH_SUCCESS = 'blayzr/search/SUCCESS';
	var IMAGE_SEARCH_FAILURE = 'blayzr/search/FAIL';
	
	var SEARCH_OPTIONS_SUCCESS = 'blayzr/search/OPTIONS_SUCCESS';
	var ADD_IMAGES_TO_ENTITIES = 'blayzr/search/ADD_IMAGES_TO_ENTITIES';
	
	var DEFAULT_PAGE_SIZE = 48;
	
	var initialState = {
	  options: {
	    keywords: null,
	    cameras: null,
	    keywordMap: null,
	    keywordArray: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case IMAGE_SEARCH_REQUEST:
	    case IMAGE_SEARCH_SUCCESS:
	    case IMAGE_SEARCH_FAILURE:
	      return _extends({}, state, _defineProperty({}, meta.key, searchReducer(state[meta.key], action)));
	    case SEARCH_OPTIONS_SUCCESS:
	      return _extends({}, state, {
	        options: payload
	      });
	    case _dynlinks.SAVE_DYNAMIC_LINK_SUCCESS:
	      return {
	        options: state.options
	      };
	    default:
	      return state;
	  }
	}
	
	var initialSearchState = {
	  data: null,
	  fetching: false,
	  error: null
	};
	
	function searchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSearchState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case IMAGE_SEARCH_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case IMAGE_SEARCH_SUCCESS:
	      var _payload$result$recor = payload.result.records,
	          photos = _payload$result$recor.photos,
	          total_hits = _payload$result$recor.total_hits,
	          aggs = _payload$result$recor.aggs;
	
	      return _extends({}, state, {
	        fetching: false,
	        data: state.data ? (0, _lodash2.default)(state.data.concat(photos)) : photos,
	        count: total_hits,
	        keywords: state.keywords || (aggs && aggs.ExpandedKeywords ? aggs.ExpandedKeywords.buckets.sort(sortBuckets) : null),
	        resolvedKeywords: (0, _traverse2.default)(payload.result.query).reduce(function (array, value) {
	          if (this.key === 'ExpandedKeywords') array.push(value);
	          return array;
	        }, [])
	      });
	    case IMAGE_SEARCH_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload
	      });
	    default:
	      return state;
	  }
	}
	
	function sortBuckets(a, b) {
	  return b.doc_count - a.doc_count;
	}
	
	function notWhitespace(string) {
	  return (/^\s+$/.test(string) === false
	  );
	}
	
	function imageSearchRequest(key) {
	  return {
	    type: IMAGE_SEARCH_REQUEST,
	    meta: { key: key }
	  };
	}
	
	function imageSearchSuccess(key, data) {
	  return {
	    type: IMAGE_SEARCH_SUCCESS,
	    payload: data,
	    meta: { key: key }
	  };
	}
	
	function imageSearchFailure(key, error) {
	  return {
	    type: IMAGE_SEARCH_FAILURE,
	    payload: error,
	    meta: { key: key }
	  };
	}
	
	function optionsSuccess(data) {
	  return {
	    type: SEARCH_OPTIONS_SUCCESS,
	    payload: data
	  };
	}
	
	function addImagesToEntities(images) {
	  return {
	    type: ADD_IMAGES_TO_ENTITIES,
	    payload: (0, _normalizr.normalize)(images, (0, _normalizr.arrayOf)(_fetch.schemas.image))
	  };
	}
	
	var schema = {
	  records: {
	    photos: (0, _normalizr.arrayOf)(_fetch.schemas.image)
	  }
	};
	
	function searchImages(structure) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var limit = arguments[2];
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  return function (dispatch, getState) {
	    if (!limit) {
	      if (structure.sort.manual) {
	        limit = Math.max(structure.sort.manual.length, DEFAULT_PAGE_SIZE);
	      } else {
	        limit = DEFAULT_PAGE_SIZE;
	      }
	    }
	
	    var _getState = getState(),
	        auth = _getState.auth,
	        query = _getState.query;
	
	    var hash = (0, _images.getHash)(structure);
	
	    var body = (0, _images.addLibrariesToStructure)(structure, query.libraries);
	    body = (0, _images.prepareStructure)(body);
	
	    var adminSearch = void 0;
	    if ((0, _auth.isSuperAdmin)(auth.user)) {
	      if (body.queries.length === 1 && body.queries[0].path.length !== 0) {
	        adminSearch = true;
	      }
	    }
	
	    var fetchOptions = {
	      method: 'post',
	      query: {
	        limit: limit,
	        offset: offset,
	        simple: options.simple,
	        admin_search: adminSearch
	      },
	      body: body,
	      token: auth.token,
	      schema: schema,
	      cache: options.cache,
	      cacheKey: hash
	    };
	
	    dispatch(imageSearchRequest(hash));
	    return (0, _fetch.fetch)(_constants.ENDPOINT_IMAGE_SEARCH, fetchOptions, dispatch).then(function (data) {
	      dispatch(imageSearchSuccess(hash, data));
	    }, function (e) {
	      dispatch(imageSearchFailure(hash, e));
	    });
	  };
	}
	
	function fetchSearchOptions() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        auth = _getState2.auth;
	
	    var options = {
	      query: { fields: 'keyword,camera,dayperiod,season,tags' },
	      token: auth.token
	    };
	    (0, _fetch.fetch)(_constants.ENDPOINT_AGGREGATION, options, dispatch).then(function (options) {
	      var keywords = options.buckets.keyword.filter(function (item) {
	        return options.keyword_map[item.key];
	      });
	      dispatch(optionsSuccess({
	        cameras: options.buckets.camera.map(function (item) {
	          return item.key;
	        }).filter(notWhitespace),
	        keywords: keywords.map(function (item) {
	          return options.keyword_map[item.key].name;
	        }),
	        keywordMap: options.keyword_map,
	        keywordArray: keywords.map(function (item) {
	          var info = options.keyword_map[item.key];
	          return {
	            id: item.key,
	            doc_count: item.doc_count,
	            keyword: info.name,
	            direct_parent_name: info.direct_parent_name,
	            top_parent_name: info.top_parent_name,
	            synonyms: info.synonyms
	          };
	        }),
	        timesOfDay: options.buckets.dayperiod.map(function (item) {
	          return item.key;
	        }),
	        seasons: options.buckets.season.map(function (item) {
	          return item.key;
	        }),
	        tags: options.buckets.tags.map(function (item) {
	          return item.key;
	        })
	      }));
	    });
	  };
	}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(53);
	var IObject = __webpack_require__(131);
	var toObject = __webpack_require__(29);
	var toLength = __webpack_require__(21);
	var asc = __webpack_require__(216);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(52);
	var fails = __webpack_require__(11);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(12);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var CallbackQueue = __webpack_require__(433);
	var PooledClass = __webpack_require__(104);
	var ReactFeatureFlags = __webpack_require__(438);
	var ReactReconciler = __webpack_require__(121);
	var Transaction = __webpack_require__(191);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.REMOVE_FAVOURITE_ALBUM = exports.SET_FAVOURITE_ALBUM = exports.DELETE_ALBUM = exports.SAVE_ALBUM_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.deleteAlbum = deleteAlbum;
	exports.fetchAlbum = fetchAlbum;
	exports.saveAlbum = saveAlbum;
	exports.setFavouriteAlbum = setFavouriteAlbum;
	exports.setFavouriteImage = setFavouriteImage;
	exports.addImagesToAlbum = addImagesToAlbum;
	exports.setAlbumCover = setAlbumCover;
	exports.shareImages = shareImages;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(381);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _banners = __webpack_require__(67);
	
	var _fetch = __webpack_require__(14);
	
	var _images = __webpack_require__(23);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FETCH_ALBUM_REQUEST = 'blayzr/album/REQUEST';
	var FETCH_ALBUM_SUCCESS = 'blayzr/album/SUCCESS';
	var FETCH_ALBUM_FAILURE = 'blayzr/album/FAILURE';
	
	var SAVE_ALBUM_REQUEST = 'blayzr/album/SAVE_REQUEST';
	var SAVE_ALBUM_SUCCESS = exports.SAVE_ALBUM_SUCCESS = 'blayzr/album/SAVE_SUCCESS';
	var SAVE_ALBUM_FAILURE = 'blayzr/album/SAVE_FAILURE';
	
	var DELETE_ALBUM = exports.DELETE_ALBUM = 'blayzr/album/DELETE';
	
	var SET_FAVOURITE_ALBUM = exports.SET_FAVOURITE_ALBUM = 'blayzr/album/SET_FAVOURITE';
	var REMOVE_FAVOURITE_ALBUM = exports.REMOVE_FAVOURITE_ALBUM = 'blayzr/album/REMOVE_FAVOURITE';
	
	var NEW_ALBUM_ID = '__NEW__';
	
	// No reducer needed because everything is
	// handled by the entities reducer
	
	// The entities get merged by the entities reducer
	// so this util lets us easily create an action that
	// updates album data
	function createAction(type, id, data) {
	  return {
	    type: type,
	    payload: { entities: { albums: _defineProperty({}, id, data) } },
	    meta: { id: id }
	  };
	}
	
	function fetchAlbumRequest(id) {
	  return createAction(FETCH_ALBUM_REQUEST, id, {
	    fetching: true,
	    fetchError: null
	  });
	}
	
	function fetchAlbumSuccess(id, data) {
	  return createAction(FETCH_ALBUM_SUCCESS, id, _extends({}, data.entities.albums[id], {
	    fetching: false
	  }));
	}
	
	function fetchAlbumFailure(id, error) {
	  return createAction(FETCH_ALBUM_FAILURE, id, {
	    fetchError: error,
	    fetching: false
	  });
	}
	
	function saveAlbumRequest(id, data, structure) {
	  return createAction(SAVE_ALBUM_REQUEST, id, _extends({}, data, {
	    json_data: JSON.stringify(structure),
	    saving: true,
	    saveError: null
	  }));
	}
	
	function saveAlbumSuccess(id, data) {
	  return createAction(SAVE_ALBUM_SUCCESS, id, _extends({}, data.entities.albums[id], {
	    saving: false
	  }));
	}
	
	function saveAlbumFailure(id, error) {
	  return createAction(SAVE_ALBUM_FAILURE, id, {
	    saveError: error,
	    saving: false
	  });
	}
	
	function deleteAlbum(id) {
	  return function (dispatch, getState) {
	    var state = getState();
	    var endpoint = _constants.ENDPOINT_ALBUM.replace(':id', id);
	    (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: state.auth.token
	    });
	    dispatch({
	      type: DELETE_ALBUM,
	      payload: {
	        entities: {
	          albums: _defineProperty({}, id, undefined),
	          // Remove album ID from any playlists
	          playlists: (0, _lodash4.default)(state.entities.playlists || {}, function (playlist) {
	            var data = JSON.parse(playlist.json_data);
	            return _extends({}, playlist, {
	              json_data: JSON.stringify(_extends({}, data, {
	                albums: data.albums.filter(function (a) {
	                  return a.album !== id;
	                })
	              }))
	            });
	          })
	        }
	      },
	      meta: { id: id }
	    });
	    dispatch((0, _reactRouterRedux.push)('/'));
	    dispatch((0, _banners.showBanner)('Album deleted'));
	  };
	}
	
	var schema = {
	  records: _fetch.schemas.album
	};
	
	function fetchAlbum(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_ALBUM.replace(':id', id);
	
	    var _getState = getState(),
	        token = _getState.auth.token;
	
	    dispatch(fetchAlbumRequest(id));
	    return (0, _fetch.fetch)(endpoint, { token: token, schema: schema }, dispatch).then(function (data) {
	      dispatch(fetchAlbumSuccess(id, data));
	      return data.entities.albums[id];
	    }, function (e) {
	      dispatch(fetchAlbumFailure(id, e));
	    });
	  };
	}
	
	function saveAlbum(data, structure) {
	  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NEW_ALBUM_ID;
	  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/album/:id';
	
	  return function (dispatch, getState) {
	    var endpoint = id === NEW_ALBUM_ID ? _constants.ENDPOINT_NEW_ALBUM : _constants.ENDPOINT_ALBUM.replace(':id', id);
	
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      schema: schema,
	      body: _extends({}, data, {
	        json_data: JSON.stringify(structure)
	      })
	    };
	    dispatch(saveAlbumRequest(id, data, structure));
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      var id = data.result.records;
	      dispatch(saveAlbumSuccess(id, data));
	      if (redirect) {
	        dispatch((0, _reactRouterRedux.push)(redirect.replace(':id', id)));
	      }
	      return data.entities.albums[id];
	    }, function (e) {
	      dispatch(saveAlbumFailure(id, e));
	    });
	  };
	}
	
	function setFavouriteAlbum(id, favourite) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_SET_FAVOURITE_ALBUM.replace(':id', id);
	    var method = favourite ? 'post' : 'delete';
	    var action = favourite ? SET_FAVOURITE_ALBUM : REMOVE_FAVOURITE_ALBUM;
	    var options = {
	      method: method,
	      token: getState().auth.token
	    };
	    dispatch({
	      type: action,
	      meta: { id: id }
	    });
	    (0, _fetch.fetch)(endpoint, options, dispatch);
	  };
	}
	
	function setFavouriteImage(id, favourite) {
	  return function (dispatch, getState) {
	    var album = (0, _images.getFavouriteImagesAlbum)(getState());
	    if (!album) {
	      console.warn('Image could not be favourited. No Favourite Images album was found');
	      return;
	    }
	    var structure = JSON.parse(album.json_data);
	    if (favourite) {
	      structure.include = structure.include.concat(id);
	    } else {
	      structure.include = structure.include.filter(function (imageID) {
	        return imageID !== id;
	      });
	    }
	    var cover = album.cover || structure.include[structure.include.length - 1];
	    dispatch(saveAlbum({ name: album.name, cover: cover }, structure, album.id, false));
	  };
	}
	
	function addImagesToAlbum(album, images) {
	  return function (dispatch, getState) {
	    var structure = JSON.parse(album.json_data);
	    structure.include = (0, _lodash2.default)(structure.include.concat(images));
	    return dispatch(saveAlbum({ name: album.name }, structure, album.id, false));
	  };
	}
	
	function setAlbumCover(album, imageID) {
	  return function (dispatch) {
	    return dispatch(saveAlbum({
	      name: album.name,
	      cover: imageID
	    }, JSON.parse(album.json_data), album.id, false)).then(function () {
	      dispatch((0, _banners.showBanner)('Album cover updated'));
	    });
	  };
	}
	
	function shareImages(images, userID) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_SHARE_IMAGES.replace(':user_id', userID);
	    var options = {
	      method: 'post',
	      body: images,
	      token: getState().auth.token
	    };
	    return (0, _fetch.fetch)(endpoint, options, dispatch);
	  };
	}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	exports.showBanner = showBanner;
	exports.hideBanner = hideBanner;
	var SHOW_BANNER = 'blayzr/banners/SHOW_BANNER';
	var HIDE_BANNER = 'blayzr/banners/HIDE_BANNER';
	
	var BANNER_TIMEOUT = 3000;
	
	var initialState = [];
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case SHOW_BANNER:
	      return state.concat(payload);
	    case HIDE_BANNER:
	      return state.filter(function (banner) {
	        return banner.id !== meta.id;
	      });
	    default:
	      return state;
	  }
	}
	
	var counter = 0;
	
	function showBanner(text) {
	  var id = counter++;
	  return function (dispatch) {
	    dispatch({
	      type: SHOW_BANNER,
	      payload: { id: id, text: text }
	    });
	    setTimeout(function () {
	      dispatch({
	        type: HIDE_BANNER,
	        meta: { id: id }
	      });
	    }, BANNER_TIMEOUT);
	  };
	}
	
	function hideBanner(id) {
	  return {
	    type: HIDE_BANNER,
	    meta: { id: id }
	  };
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UPDATE_USER_REQUEST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.fetchUsers = fetchUsers;
	exports.updateUser = updateUser;
	exports.createUser = createUser;
	exports.deleteUser = deleteUser;
	exports.updateGlobalSettings = updateGlobalSettings;
	
	var _normalizr = __webpack_require__(103);
	
	var _banners = __webpack_require__(67);
	
	var _fetch = __webpack_require__(14);
	
	var _auth = __webpack_require__(42);
	
	var _constants = __webpack_require__(3);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FETCH_USERS_REQUEST = 'blayzr/users/LIST_REQUEST';
	var FETCH_USERS_SUCCESS = 'blayzr/users/LIST_SUCCESS';
	var FETCH_USERS_FAILURE = 'blayzr/users/LIST_FAIL';
	
	var UPDATE_USER_REQUEST = exports.UPDATE_USER_REQUEST = 'blayzr/users/UPDATE_REQUEST';
	var UPDATE_USER_SUCCESS = 'blayzr/users/UPDATE_SUCCESS';
	var UPDATE_USER_FAILURE = 'blayzr/users/UPDATE_FAIL';
	
	var CREATE_USER_REQUEST = 'blayzr/users/CREATE_REQUEST';
	var CREATE_USER_SUCCESS = 'blayzr/users/CREATE_SUCCESS';
	var CREATE_USER_FAILURE = 'blayzr/users/CREATE_FAIL';
	
	var DELETE_USER = 'blayzr/users/DELETE';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null,
	  create: {
	    creating: false,
	    error: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case FETCH_USERS_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case FETCH_USERS_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload.result.records
	      });
	    case FETCH_USERS_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case CREATE_USER_REQUEST:
	      return _extends({}, state, {
	        create: {
	          creating: true,
	          error: null
	        }
	      });
	    case CREATE_USER_SUCCESS:
	      return _extends({}, state, {
	        data: state.data ? state.data.concat(payload.result.records) : null,
	        create: {
	          creating: false,
	          error: null
	        }
	      });
	    case CREATE_USER_FAILURE:
	      return _extends({}, state, {
	        create: {
	          creating: false,
	          error: payload.error
	        }
	      });
	    case DELETE_USER:
	      if (state.data) {
	        return _extends({}, state, {
	          data: state.data.filter(function (id) {
	            return id !== meta.id;
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function fetchUsersRequest() {
	  return {
	    type: FETCH_USERS_REQUEST
	  };
	}
	
	function fetchUsersSuccess(data) {
	  return {
	    type: FETCH_USERS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchUsersFailure(error) {
	  return {
	    type: FETCH_USERS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function updateUserRequest(id, data) {
	  return {
	    type: UPDATE_USER_REQUEST,
	    payload: { entities: { users: _defineProperty({}, id, _extends({}, data, {
	          saving: true,
	          error: null
	        })) } }
	  };
	}
	
	function updateUserSuccess(id, data) {
	  return {
	    type: UPDATE_USER_SUCCESS,
	    payload: { entities: { users: _defineProperty({}, id, _extends({}, data.entities.users[id], {
	          saving: false
	        })) } }
	  };
	}
	
	function updateUserFailure(id, data, error) {
	  return {
	    type: UPDATE_USER_FAILURE,
	    payload: { entities: { users: _defineProperty({}, id, {
	          saving: false,
	          error: error
	        }) } }
	  };
	}
	
	function createUserRequest() {
	  return {
	    type: CREATE_USER_REQUEST
	  };
	}
	
	function createUserSuccess(data) {
	  return {
	    type: CREATE_USER_SUCCESS,
	    payload: data
	  };
	}
	
	function createUserFailure(error) {
	  return {
	    type: CREATE_USER_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function fetchUsers() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      schema: {
	        records: (0, _normalizr.arrayOf)(_fetch.schemas.user)
	      }
	    };
	    dispatch(fetchUsersRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_USERS, options, dispatch).then(function (data) {
	      dispatch(fetchUsersSuccess(data));
	    }, function (e) {
	      dispatch(fetchUsersFailure(e));
	    });
	  };
	}
	
	function updateUser(id, data) {
	  var showBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  return function (dispatch, getState) {
	    var state = getState();
	    var endpoint = _constants.ENDPOINT_USER.replace(':id', id);
	    var body = processUserData(data);
	    var options = {
	      method: 'post',
	      token: state.auth.token,
	      schema: {
	        records: _fetch.schemas.user
	      },
	      body: body
	    };
	    dispatch(updateUserRequest(id, body));
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      dispatch(updateUserSuccess(id, data));
	      if (showBanner) {
	        dispatch(showBanner(state.auth.user.id === data.result.records ? 'Profile updated' : 'User updated'));
	      }
	      if (state.auth.user.id === id) {
	        dispatch((0, _auth.refreshTokens)());
	      }
	      return data;
	    }, function (e) {
	      dispatch(updateUserFailure(id, e));
	    });
	  };
	}
	
	function createUser(data) {
	  return function (dispatch, getState) {
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      schema: {
	        records: _fetch.schemas.user
	      },
	      body: processUserData(data)
	    };
	    dispatch(createUserRequest());
	    // Don't send dispatch to fetch as we want to display
	    // an error instead of redirect if not authorized
	    return (0, _fetch.fetch)(_constants.ENDPOINT_NEW_USER, options).then(function (data) {
	      dispatch(createUserSuccess(data));
	      dispatch((0, _banners.showBanner)('User created'));
	      return data;
	    }, function (e) {
	      dispatch(createUserFailure(e));
	    });
	  };
	}
	
	function processUserData(data) {
	  return _extends({}, data, {
	    location: data.location.lat ? data.location.lat + ',' + data.location.lon : undefined,
	    location_address: data.location.address,
	    libraries: data.libraries.filter(function (lib) {
	      return (/^virtual_/.test(lib.library.library_token) === false
	      );
	    })
	  });
	}
	
	function deleteUser(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_USER.replace(':id', id);
	    dispatch({
	      type: DELETE_USER,
	      meta: { id: id }
	    });
	    return (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: getState().auth.token
	    }).then(function (data) {
	      dispatch((0, _banners.showBanner)('User deleted'));
	      return data;
	    });
	  };
	}
	
	function updateGlobalSettings(settings) {
	  return function (dispatch, getState) {
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: {
	        settings: JSON.stringify(settings)
	      }
	    };
	    return (0, _fetch.fetch)(_constants.ENDPOINT_GLOBAL_SETTINGS, options, dispatch).then(function (data) {
	      dispatch((0, _auth.refreshTokens)());
	    });
	  };
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(346);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(133)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(350))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(24)) {
	  var LIBRARY = __webpack_require__(80);
	  var global = __webpack_require__(8);
	  var fails = __webpack_require__(11);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(167);
	  var $buffer = __webpack_require__(237);
	  var ctx = __webpack_require__(53);
	  var anInstance = __webpack_require__(89);
	  var propertyDesc = __webpack_require__(94);
	  var hide = __webpack_require__(36);
	  var redefineAll = __webpack_require__(95);
	  var toInteger = __webpack_require__(55);
	  var toLength = __webpack_require__(21);
	  var toIndex = __webpack_require__(344);
	  var toAbsoluteIndex = __webpack_require__(97);
	  var toPrimitive = __webpack_require__(63);
	  var has = __webpack_require__(44);
	  var classof = __webpack_require__(110);
	  var isObject = __webpack_require__(12);
	  var toObject = __webpack_require__(29);
	  var isArrayIter = __webpack_require__(223);
	  var create = __webpack_require__(91);
	  var getPrototypeOf = __webpack_require__(46);
	  var gOPN = __webpack_require__(92).f;
	  var getIterFn = __webpack_require__(239);
	  var uid = __webpack_require__(98);
	  var wks = __webpack_require__(18);
	  var createArrayMethod = __webpack_require__(60);
	  var createArrayIncludes = __webpack_require__(155);
	  var speciesConstructor = __webpack_require__(134);
	  var ArrayIterators = __webpack_require__(240);
	  var Iterators = __webpack_require__(111);
	  var $iterDetect = __webpack_require__(160);
	  var setSpecies = __webpack_require__(96);
	  var arrayFill = __webpack_require__(215);
	  var arrayCopyWithin = __webpack_require__(316);
	  var $DP = __webpack_require__(27);
	  var $GOPD = __webpack_require__(45);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    Set = getNative(root, 'Set'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each
	 * element is kept.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length)
	    ? baseUniq(array)
	    : [];
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = uniq;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.5
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
	        // not the initial event target in the shadow tree. Note that not all events cross the
	        // shadow boundary.
	        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
	        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
	        // target cannot be obtained.
	        if ('composedPath' in e && typeof e.composedPath === 'function') {
	            // For open shadow trees, update `element` so that the following check works.
	            var initialEventTarget = e.composedPath()[0];
	            if (initialEventTarget !== e.target) {
	                element = initialEventTarget;
	            }
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var PooledClass = __webpack_require__(104);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(15);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.values = exports.untouch = exports.touch = exports.SubmissionError = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitFailed = exports.reset = exports.propTypes = exports.initialize = exports.reduxForm = exports.reducer = exports.formValueSelector = exports.focus = exports.FieldArray = exports.Field = exports.destroy = exports.change = exports.blur = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = undefined;
	
	var _createAll2 = __webpack_require__(1202);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	var _plain = __webpack_require__(147);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createAll = (0, _createAll3.default)(_plain2.default);
	
	var actionTypes = _createAll.actionTypes;
	var arrayInsert = _createAll.arrayInsert;
	var arrayMove = _createAll.arrayMove;
	var arrayPop = _createAll.arrayPop;
	var arrayPush = _createAll.arrayPush;
	var arrayRemove = _createAll.arrayRemove;
	var arrayRemoveAll = _createAll.arrayRemoveAll;
	var arrayShift = _createAll.arrayShift;
	var arraySplice = _createAll.arraySplice;
	var arraySwap = _createAll.arraySwap;
	var arrayUnshift = _createAll.arrayUnshift;
	var blur = _createAll.blur;
	var change = _createAll.change;
	var destroy = _createAll.destroy;
	var Field = _createAll.Field;
	var FieldArray = _createAll.FieldArray;
	var focus = _createAll.focus;
	var formValueSelector = _createAll.formValueSelector;
	var reducer = _createAll.reducer;
	var reduxForm = _createAll.reduxForm;
	var initialize = _createAll.initialize;
	var propTypes = _createAll.propTypes;
	var reset = _createAll.reset;
	var setSubmitFailed = _createAll.setSubmitFailed;
	var startAsyncValidation = _createAll.startAsyncValidation;
	var startSubmit = _createAll.startSubmit;
	var stopAsyncValidation = _createAll.stopAsyncValidation;
	var stopSubmit = _createAll.stopSubmit;
	var SubmissionError = _createAll.SubmissionError;
	var touch = _createAll.touch;
	var untouch = _createAll.untouch;
	var values = _createAll.values;
	exports.actionTypes = actionTypes;
	exports.arrayInsert = arrayInsert;
	exports.arrayMove = arrayMove;
	exports.arrayPop = arrayPop;
	exports.arrayPush = arrayPush;
	exports.arrayRemove = arrayRemove;
	exports.arrayRemoveAll = arrayRemoveAll;
	exports.arrayShift = arrayShift;
	exports.arraySplice = arraySplice;
	exports.arraySwap = arraySwap;
	exports.arrayUnshift = arrayUnshift;
	exports.blur = blur;
	exports.change = change;
	exports.destroy = destroy;
	exports.Field = Field;
	exports.FieldArray = FieldArray;
	exports.focus = focus;
	exports.formValueSelector = formValueSelector;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.initialize = initialize;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.setSubmitFailed = setSubmitFailed;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.SubmissionError = SubmissionError;
	exports.touch = touch;
	exports.untouch = untouch;
	exports.values = values;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(18)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(36)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(98)('meta');
	var isObject = __webpack_require__(12);
	var has = __webpack_require__(44);
	var setDesc = __webpack_require__(27).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(11)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	try {
	    exports.nodestream = !!__webpack_require__(370).Readable;
	} catch(e) {
	    exports.nodestream = false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109).Buffer))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(137),
	    getRawTag = __webpack_require__(969),
	    objectToString = __webpack_require__(1001);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNSHARE_ALBUM = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.fetchAlbumSharedUsers = fetchAlbumSharedUsers;
	exports.shareAlbum = shareAlbum;
	exports.unshareAlbum = unshareAlbum;
	exports.fetchExternalShares = fetchExternalShares;
	exports.deleteExternalShare = deleteExternalShare;
	exports.setExternalShareDuration = setExternalShareDuration;
	
	var _normalizr = __webpack_require__(103);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FETCH_ALBUM_SHARE_REQUEST = 'blayzr/share/FETCH_ALBUM_REQUEST';
	var FETCH_ALBUM_SHARE_SUCCESS = 'blayzr/share/FETCH_ALBUM_SUCCESS';
	var FETCH_ALBUM_SHARE_FAILURE = 'blayzr/share/FETCH_ALBUM_FAILURE';
	
	var SHARE_ALBUM = 'blayzr/share/SHARE_ALBUM';
	var UNSHARE_ALBUM = exports.UNSHARE_ALBUM = 'blayzr/share/UNSHARE_ALBUM';
	
	var FETCH_EXTERNAL_SHARES_REQUEST = 'blayzr/share/FETCH_EXTERNAL_SHARES_REQUEST';
	var FETCH_EXTERNAL_SHARES_SUCCESS = 'blayzr/share/FETCH_EXTERNAL_SHARES_SUCCESS';
	var FETCH_EXTERNAL_SHARES_FAILURE = 'blayzr/share/FETCH_EXTERNAL_SHARES_FAILURE';
	
	var DELETE_EXTERNAL_SHARE_CODE = 'blayzr/share/DELETE_EXTERNAL_SHARE_CODE';
	var SET_EXTERNAL_CODE_DURATION = 'blayzr/share/SET_EXTERNAL_CODE_DURATION';
	
	var initialState = {
	  internal: {},
	  external: {}
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case FETCH_ALBUM_SHARE_REQUEST:
	    case FETCH_ALBUM_SHARE_SUCCESS:
	    case FETCH_ALBUM_SHARE_FAILURE:
	    case SHARE_ALBUM:
	    case UNSHARE_ALBUM:
	      return _extends({}, state, {
	        internal: _extends({}, state.internal, _defineProperty({}, meta.albumID, listReducer(state.internal[meta.albumID], action)))
	      });
	    case FETCH_EXTERNAL_SHARES_REQUEST:
	      return _extends({}, state, {
	        external: {
	          fetching: true,
	          error: null
	        }
	      });
	    case FETCH_EXTERNAL_SHARES_SUCCESS:
	      return _extends({}, state, {
	        external: {
	          fetching: false,
	          data: payload
	        }
	      });
	    case FETCH_EXTERNAL_SHARES_FAILURE:
	      return _extends({}, state, {
	        external: {
	          fetching: false,
	          error: payload
	        }
	      });
	    case DELETE_EXTERNAL_SHARE_CODE:
	      return _extends({}, state, {
	        external: _extends({}, state.external, {
	          data: state.external.data.filter(function (share) {
	            return share.external_id !== payload;
	          })
	        })
	      });
	    case SET_EXTERNAL_CODE_DURATION:
	      var index = state.external.data.findIndex(function (share) {
	        return share.external_id === meta.code;
	      });
	      if (index === -1) {
	        return state;
	      }
	      return _extends({}, state, {
	        external: _extends({}, state.external, {
	          data: [].concat(_toConsumableArray(state.external.data.slice(0, index)), [_extends({}, state.external.data[index], {
	            duration: payload
	          })], _toConsumableArray(state.external.data.slice(index + 1)))
	        })
	      });
	    default:
	      return state;
	  }
	}
	
	var initialListState = {
	  data: null,
	  fetching: false,
	  error: null
	};
	
	function listReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialListState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case FETCH_ALBUM_SHARE_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case FETCH_ALBUM_SHARE_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload.result.records
	      });
	    case FETCH_ALBUM_SHARE_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case SHARE_ALBUM:
	      return _extends({}, state, {
	        fetching: false,
	        data: state.data.concat(meta.userID)
	      });
	    case UNSHARE_ALBUM:
	      return _extends({}, state, {
	        fetching: false,
	        data: state.data && state.data.filter(function (id) {
	          return id !== meta.userID;
	        })
	      });
	    default:
	      return state;
	  }
	}
	
	function fetchAlbumSharedUsersRequest(albumID) {
	  return {
	    type: FETCH_ALBUM_SHARE_REQUEST,
	    meta: { albumID: albumID }
	  };
	}
	
	function fetchAlbumSharedUsersSuccess(albumID, data) {
	  return {
	    type: FETCH_ALBUM_SHARE_SUCCESS,
	    payload: data,
	    meta: { albumID: albumID }
	  };
	}
	
	function fetchAlbumSharedUsersFailure(albumID, error) {
	  return {
	    type: FETCH_ALBUM_SHARE_FAILURE,
	    payload: error,
	    meta: { albumID: albumID }
	  };
	}
	
	function fetchExternalSharesRequest() {
	  return {
	    type: FETCH_EXTERNAL_SHARES_REQUEST
	  };
	}
	
	function fetchExternalSharesSuccess(data) {
	  return {
	    type: FETCH_EXTERNAL_SHARES_SUCCESS,
	    payload: data.records
	  };
	}
	
	function fetchExternalSharesFailure(error) {
	  return {
	    type: FETCH_EXTERNAL_SHARES_FAILURE,
	    payload: error
	  };
	}
	
	var schema = {
	  records: (0, _normalizr.arrayOf)(_fetch.schemas.user)
	};
	
	function fetchAlbumSharedUsers(albumID) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_FETCH_ALBUM_SHARE.replace(':id', albumID);
	    var options = {
	      token: getState().auth.token,
	      schema: schema
	    };
	    dispatch(fetchAlbumSharedUsersRequest(albumID));
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      dispatch(fetchAlbumSharedUsersSuccess(albumID, data));
	      return data.result.records;
	    }, function (e) {
	      dispatch(fetchAlbumSharedUsersFailure(albumID, e));
	    });
	  };
	}
	
	function shareAlbum(albumID, userID) {
	  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
	  var action = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SHARE_ALBUM;
	
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_ALBUM_SHARE.replace(':album_id', albumID).replace(':user_id', userID);
	
	    var auth = getState().auth;
	
	    dispatch({
	      type: action,
	      meta: {
	        albumID: albumID,
	        userID: userID,
	        removeFromAlbums: action === UNSHARE_ALBUM && userID === auth.user.id
	      }
	    });
	    return (0, _fetch.fetch)(endpoint, { method: method, token: auth.token });
	  };
	}
	
	function unshareAlbum(albumID, userID) {
	  return shareAlbum(albumID, userID, 'delete', UNSHARE_ALBUM);
	}
	
	function fetchExternalShares() {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_FETCH_EXTERNAL_SHARES;
	    var options = {
	      token: getState().auth.token
	    };
	    dispatch(fetchExternalSharesRequest());
	    (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      dispatch(fetchExternalSharesSuccess(data));
	    }, function (e) {
	      dispatch(fetchExternalSharesFailure(e));
	    });
	  };
	}
	
	function deleteExternalShare(code) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_SHARING.replace(':code', code);
	    var options = {
	      method: 'delete',
	      token: getState().auth.token
	    };
	    (0, _fetch.fetch)(endpoint, options);
	    dispatch({
	      type: DELETE_EXTERNAL_SHARE_CODE,
	      payload: code
	    });
	  };
	}
	
	function setExternalShareDuration(code, duration) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_EXTEND_EXTERNAL_SHARE.replace(':code', code);
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: { duration: duration }
	    };
	    (0, _fetch.fetch)(endpoint, options);
	    dispatch({
	      type: SET_EXTERNAL_CODE_DURATION,
	      payload: duration,
	      meta: { code: code }
	    });
	  };
	}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapStateToLists = mapStateToLists;
	exports.updateAlbumLists = updateAlbumLists;
	function mapStateToLists(playlists, entities) {
	  return playlists.lists && playlists.lists.map(function (id) {
	    var list = entities.playlists[id];
	    return _extends({}, list, {
	      albums: JSON.parse(list.json_data).albums.map(function (item) {
	        return entities.albums[item.album];
	      }).filter(function (a) {
	        return a;
	      })
	    });
	  });
	}
	
	function updateAlbumLists(_ref) {
	  var albumID = _ref.albumID,
	      checked = _ref.checked,
	      createList = _ref.createList,
	      lists = _ref.lists,
	      addAlbumToList = _ref.addAlbumToList,
	      removeAlbumFromList = _ref.removeAlbumFromList,
	      saveList = _ref.saveList;
	
	  var promises = [];
	  if (checked) {
	    lists.forEach(function (list) {
	      var isChecked = checked.indexOf(list.id) !== -1;
	      var inList = list.albums.map(function (a) {
	        return a.id;
	      }).indexOf(albumID) !== -1;
	      if (isChecked && !inList) {
	        // console.log('adding', albumID, 'to', list.id)
	        promises.push(addAlbumToList(albumID, list));
	      }
	      if (!isChecked && inList) {
	        // console.log('removing', albumID, 'from', list.id)
	        promises.push(removeAlbumFromList(albumID, list));
	      }
	    });
	  }
	  if (createList) {
	    var structure = { albums: [{ album: albumID }] };
	    promises.push(saveList({ name: createList }, structure, null, null));
	  }
	  return Promise.all(promises);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(53);
	var call = __webpack_require__(327);
	var isArrayIter = __webpack_require__(223);
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(21);
	var getIterFn = __webpack_require__(239);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(6);
	var dPs = __webpack_require__(333);
	var enumBugKeys = __webpack_require__(219);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(218)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(221).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(335);
	var hiddenKeys = __webpack_require__(219).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(335);
	var enumBugKeys = __webpack_require__(219);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(37);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var dP = __webpack_require__(27);
	var DESCRIPTORS = __webpack_require__(24);
	var SPECIES = __webpack_require__(18)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(55);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(943),
	    getValue = __webpack_require__(972);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * lscache library
	 * Copyright (c) 2011, Pamela Fox
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *       http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* jshint undef:true, browser:true, node:true */
	/* global define */
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== "undefined" && module.exports) {
	        // CommonJS/Node module
	        module.exports = factory();
	    } else {
	        // Browser globals
	        root.lscache = factory();
	    }
	}(this, function () {
	
	  // Prefix for all lscache keys
	  var CACHE_PREFIX = 'lscache-';
	
	  // Suffix for the key name on the expiration items in localStorage
	  var CACHE_SUFFIX = '-cacheexpiration';
	
	  // expiration date radix (set to Base-36 for most space savings)
	  var EXPIRY_RADIX = 10;
	
	  // time resolution in milliseconds
	  var expiryMilliseconds = 60 * 1000;
	  // ECMAScript max Date (epoch + 1e8 days)
	  var maxDate = calculateMaxDate(expiryMilliseconds);
	
	  var cachedStorage;
	  var cachedJSON;
	  var cacheBucket = '';
	  var warnings = false;
	
	  // Determines if localStorage is supported in the browser;
	  // result is cached for better performance instead of being run each time.
	  // Feature detection is based on how Modernizr does it;
	  // it's not straightforward due to FF4 issues.
	  // It's not run at parse-time as it takes 200ms in Android.
	  function supportsStorage() {
	    var key = '__lscachetest__';
	    var value = key;
	
	    if (cachedStorage !== undefined) {
	      return cachedStorage;
	    }
	
	    // some browsers will throw an error if you try to access local storage (e.g. brave browser)
	    // hence check is inside a try/catch
	    try {
	      if (!localStorage) {
	        return false;
	      }
	    } catch (ex) {
	      return false;
	    }
	
	    try {
	      setItem(key, value);
	      removeItem(key);
	      cachedStorage = true;
	    } catch (e) {
	        // If we hit the limit, and we don't have an empty localStorage then it means we have support
	        if (isOutOfSpace(e) && localStorage.length) {
	            cachedStorage = true; // just maxed it out and even the set test failed.
	        } else {
	            cachedStorage = false;
	        }
	    }
	    return cachedStorage;
	  }
	
	  // Check to set if the error is us dealing with being out of space
	  function isOutOfSpace(e) {
	    return e && (
	      e.name === 'QUOTA_EXCEEDED_ERR' ||
	      e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
	      e.name === 'QuotaExceededError'
	    );
	  }
	
	  // Determines if native JSON (de-)serialization is supported in the browser.
	  function supportsJSON() {
	    /*jshint eqnull:true */
	    if (cachedJSON === undefined) {
	      cachedJSON = (window.JSON != null);
	    }
	    return cachedJSON;
	  }
	
	  /**
	   * Returns a string where all RegExp special characters are escaped with a \.
	   * @param {String} text
	   * @return {string}
	   */
	  function escapeRegExpSpecialCharacters(text) {
	    return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
	  }
	
	  /**
	   * Returns the full string for the localStorage expiration item.
	   * @param {String} key
	   * @return {string}
	   */
	  function expirationKey(key) {
	    return key + CACHE_SUFFIX;
	  }
	
	  /**
	   * Returns the number of minutes since the epoch.
	   * @return {number}
	   */
	  function currentTime() {
	    return Math.floor((new Date().getTime())/expiryMilliseconds);
	  }
	
	  /**
	   * Wrapper functions for localStorage methods
	   */
	
	  function getItem(key) {
	    return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
	  }
	
	  function setItem(key, value) {
	    // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
	    localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
	    localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
	  }
	
	  function removeItem(key) {
	    localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
	  }
	
	  function eachKey(fn) {
	    var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
	    // Loop in reverse as removing items will change indices of tail
	    for (var i = localStorage.length-1; i >= 0 ; --i) {
	      var key = localStorage.key(i);
	      key = key && key.match(prefixRegExp);
	      key = key && key[1];
	      if (key && key.indexOf(CACHE_SUFFIX) < 0) {
	        fn(key, expirationKey(key));
	      }
	    }
	  }
	
	  function flushItem(key) {
	    var exprKey = expirationKey(key);
	
	    removeItem(key);
	    removeItem(exprKey);
	  }
	
	  function flushExpiredItem(key) {
	    var exprKey = expirationKey(key);
	    var expr = getItem(exprKey);
	
	    if (expr) {
	      var expirationTime = parseInt(expr, EXPIRY_RADIX);
	
	      // Check if we should actually kick item out of storage
	      if (currentTime() >= expirationTime) {
	        removeItem(key);
	        removeItem(exprKey);
	        return true;
	      }
	    }
	  }
	
	  function warn(message, err) {
	    if (!warnings) return;
	    if (!('console' in window) || typeof window.console.warn !== 'function') return;
	    window.console.warn("lscache - " + message);
	    if (err) window.console.warn("lscache - The error was: " + err.message);
	  }
	
	  function calculateMaxDate(expiryMilliseconds) {
	    return Math.floor(8.64e15/expiryMilliseconds);
	  }
	
	  var lscache = {
	    /**
	     * Stores the value in localStorage. Expires after specified number of minutes.
	     * @param {string} key
	     * @param {Object|string} value
	     * @param {number} time
	     * @return true if the value was inserted successfully
	     */
	    set: function(key, value, time) {
	      if (!supportsStorage()) return false;
	
	      // If we don't get a string value, try to stringify
	      // In future, localStorage may properly support storing non-strings
	      // and this can be removed.
	
	      if (!supportsJSON()) return false;
	      try {
	        value = JSON.stringify(value);
	      } catch (e) {
	        // Sometimes we can't stringify due to circular refs
	        // in complex objects, so we won't bother storing then.
	        return false;
	      }
	
	      try {
	        setItem(key, value);
	      } catch (e) {
	        if (isOutOfSpace(e)) {
	          // If we exceeded the quota, then we will sort
	          // by the expire time, and then remove the N oldest
	          var storedKeys = [];
	          var storedKey;
	          eachKey(function(key, exprKey) {
	            var expiration = getItem(exprKey);
	            if (expiration) {
	              expiration = parseInt(expiration, EXPIRY_RADIX);
	            } else {
	              // TODO: Store date added for non-expiring items for smarter removal
	              expiration = maxDate;
	            }
	            storedKeys.push({
	              key: key,
	              size: (getItem(key) || '').length,
	              expiration: expiration
	            });
	          });
	          // Sorts the keys with oldest expiration time last
	          storedKeys.sort(function(a, b) { return (b.expiration-a.expiration); });
	
	          var targetSize = (value||'').length;
	          while (storedKeys.length && targetSize > 0) {
	            storedKey = storedKeys.pop();
	            warn("Cache is full, removing item with key '" + key + "'");
	            flushItem(storedKey.key);
	            targetSize -= storedKey.size;
	          }
	          try {
	            setItem(key, value);
	          } catch (e) {
	            // value may be larger than total quota
	            warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
	            return false;
	          }
	        } else {
	          // If it was some other error, just give up.
	          warn("Could not add item with key '" + key + "'", e);
	          return false;
	        }
	      }
	
	      // If a time is specified, store expiration info in localStorage
	      if (time) {
	        setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
	      } else {
	        // In case they previously set a time, remove that info from localStorage.
	        removeItem(expirationKey(key));
	      }
	      return true;
	    },
	
	    /**
	     * Retrieves specified value from localStorage, if not expired.
	     * @param {string} key
	     * @return {string|Object}
	     */
	    get: function(key) {
	      if (!supportsStorage()) return null;
	
	      // Return the de-serialized item if not expired
	      if (flushExpiredItem(key)) { return null; }
	
	      // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
	      var value = getItem(key);
	      if (!value || !supportsJSON()) {
	        return value;
	      }
	
	      try {
	        // We can't tell if its JSON or a string, so we try to parse
	        return JSON.parse(value);
	      } catch (e) {
	        // If we can't parse, it's probably because it isn't an object
	        return value;
	      }
	    },
	
	    /**
	     * Removes a value from localStorage.
	     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
	     * @param {string} key
	     */
	    remove: function(key) {
	      if (!supportsStorage()) return;
	
	      flushItem(key);
	    },
	
	    /**
	     * Returns whether local storage is supported.
	     * Currently exposed for testing purposes.
	     * @return {boolean}
	     */
	    supported: function() {
	      return supportsStorage();
	    },
	
	    /**
	     * Flushes all lscache items and expiry markers without affecting rest of localStorage
	     */
	    flush: function() {
	      if (!supportsStorage()) return;
	
	      eachKey(function(key) {
	        flushItem(key);
	      });
	    },
	
	    /**
	     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
	     */
	    flushExpired: function() {
	      if (!supportsStorage()) return;
	
	      eachKey(function(key) {
	        flushExpiredItem(key);
	      });
	    },
	
	    /**
	     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
	     * @param {string} bucket
	     */
	    setBucket: function(bucket) {
	      cacheBucket = bucket;
	    },
	
	    /**
	     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
	     */
	    resetBucket: function() {
	      cacheBucket = '';
	    },
	
	    /**
	     * @returns {number} The currently set number of milliseconds each time unit represents in
	     *   the set() function's "time" argument.
	     */
	    getExpiryMilliseconds: function() {
	      return expiryMilliseconds;
	    },
	
	    /**
	     * Sets the number of milliseconds each time unit represents in the set() function's
	     *   "time" argument.
	     * Sample values:
	     *  1: each time unit = 1 millisecond
	     *  1000: each time unit = 1 second
	     *  60000: each time unit = 1 minute (Default value)
	     *  360000: each time unit = 1 hour
	     * @param {number} milliseconds
	     */
	    setExpiryMilliseconds: function(milliseconds) {
	        expiryMilliseconds = milliseconds;
	        maxDate = calculateMaxDate(expiryMilliseconds);
	    },
	
	    /**
	     * Sets whether to display warnings when an item is removed from the cache or not.
	     */
	    enableWarnings: function(enabled) {
	      warnings = enabled;
	    }
	  };
	
	  // Return the module
	  return lscache;
	}));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.arrayOf = arrayOf;
	exports.valuesOf = valuesOf;
	exports.unionOf = unionOf;
	exports.normalize = normalize;
	
	var _EntitySchema = __webpack_require__(1036);
	
	var _EntitySchema2 = _interopRequireDefault(_EntitySchema);
	
	var _IterableSchema = __webpack_require__(1037);
	
	var _IterableSchema2 = _interopRequireDefault(_IterableSchema);
	
	var _UnionSchema = __webpack_require__(422);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	var _isEqual = __webpack_require__(1021);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isObject = __webpack_require__(64);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultAssignEntity(normalized, key, entity) {
	  normalized[key] = entity;
	}
	
	function visitObject(obj, schema, bag, options, collectionKey) {
	  var _options$assignEntity = options.assignEntity,
	      assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;
	
	
	  var defaults = schema && schema.getDefaults && schema.getDefaults();
	  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
	  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      var resolvedSchema = typeof schema[key] === 'function' ? schema[key].call(null, obj) : schema[key];
	      var entity = visit(obj[key], resolvedSchema, bag, options, collectionKey);
	      assignEntity.call(null, normalized, key, entity, obj, schema);
	      if (schemaAssignEntity) {
	        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
	      }
	    }
	  }
	  return normalized;
	}
	
	function defaultMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj, key) {
	    return visit(obj, itemSchema, bag, options, key);
	  };
	}
	
	function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj, key) {
	    var schemaKey = iterableSchema.getSchemaKey(obj);
	    var result = visit(obj, itemSchema[schemaKey], bag, options, key);
	    return { id: result, schema: schemaKey };
	  };
	}
	
	function visitIterable(obj, iterableSchema, bag, options) {
	  var itemSchema = iterableSchema.getItemSchema();
	  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);
	
	  if (Array.isArray(obj)) {
	    return obj.map(curriedItemMapper);
	  } else {
	    return Object.keys(obj).reduce(function (objMap, key) {
	      objMap[key] = curriedItemMapper(obj[key], key);
	      return objMap;
	    }, {});
	  }
	}
	
	function visitUnion(obj, unionSchema, bag, options) {
	  var itemSchema = unionSchema.getItemSchema();
	  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
	}
	
	function defaultMergeIntoEntity(entityA, entityB, entityKey) {
	  for (var key in entityB) {
	    if (!entityB.hasOwnProperty(key)) {
	      continue;
	    }
	
	    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
	      entityA[key] = entityB[key];
	      continue;
	    }
	
	    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
	  }
	}
	
	function visitEntity(entity, entitySchema, bag, options, collectionKey) {
	  var _options$mergeIntoEnt = options.mergeIntoEntity,
	      mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;
	
	
	  var entityKey = entitySchema.getKey();
	  var id = entitySchema.getId(entity, collectionKey);
	
	  if (!bag.hasOwnProperty(entityKey)) {
	    bag[entityKey] = {};
	  }
	
	  if (!bag[entityKey].hasOwnProperty(id)) {
	    bag[entityKey][id] = {};
	  }
	
	  var stored = bag[entityKey][id];
	  var normalized = visitObject(entity, entitySchema, bag, options, collectionKey);
	  mergeIntoEntity(stored, normalized, entityKey);
	
	  return id;
	}
	
	function visit(obj, schema, bag, options, collectionKey) {
	  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
	    return obj;
	  }
	
	  if (schema instanceof _EntitySchema2.default) {
	    return visitEntity(obj, schema, bag, options, collectionKey);
	  } else if (schema instanceof _IterableSchema2.default) {
	    return visitIterable(obj, schema, bag, options);
	  } else if (schema instanceof _UnionSchema2.default) {
	    return visitUnion(obj, schema, bag, options);
	  } else {
	    return visitObject(obj, schema, bag, options, collectionKey);
	  }
	}
	
	function normalizeResult(result) {
	  if ((0, _isObject2.default)(result) && (0, _isEqual2.default)(Object.keys(result), Object.keys(result).map(function (key) {
	    return result[key];
	  }))) {
	    return Object.keys(result);
	  }
	  return result;
	}
	
	function arrayOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function valuesOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function unionOf(schema, options) {
	  return new _UnionSchema2.default(schema, options);
	}
	
	exports.Schema = _EntitySchema2.default;
	function normalize(obj, schema) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!(0, _isObject2.default)(obj)) {
	    throw new Error('Normalize accepts an object or an array as its input.');
	  }
	
	  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
	    throw new Error('Normalize accepts an object for schema.');
	  }
	
	  var bag = {};
	  var result = visit(obj, schema, bag, options);
	
	  return {
	    entities: bag,
	    result: normalizeResult(result)
	  };
	}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(188);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(135));
	util.inherits = __webpack_require__(116);
	/*</replacement>*/
	
	var Readable = __webpack_require__(477);
	var Writable = __webpack_require__(294);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(490);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1229);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1228);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1227);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(489);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.toggleExpanded = toggleExpanded;
	exports.fetchKeywordParents = fetchKeywordParents;
	exports.fetchKeywordHierarchy = fetchKeywordHierarchy;
	exports.fetchKeywordGraph = fetchKeywordGraph;
	exports.updateGraphNodes = updateGraphNodes;
	exports.mergeNodes = mergeNodes;
	exports.deleteNode = deleteNode;
	exports.touchNode = touchNode;
	exports.touchNodeVisibility = touchNodeVisibility;
	exports.touchNodeWeighting = touchNodeWeighting;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FETCH_KEYWORD_PARENTS_REQUEST = 'blayzr/keywords/FETCH_PARENTS_REQUEST';
	var FETCH_KEYWORD_PARENTS_SUCCESS = 'blayzr/keywords/FETCH_PARENTS_SUCCESS';
	var FETCH_KEYWORD_PARENTS_FAILURE = 'blayzr/keywords/FETCH_PARENTS_FAIL';
	
	var FETCH_KEYWORD_HIERARCHY_REQUEST = 'blayzr/keywords/FETCH_HIERARCHY_REQUEST';
	var FETCH_KEYWORD_HIERARCHY_SUCCESS = 'blayzr/keywords/FETCH_HIERARCHY_SUCCESS';
	var FETCH_KEYWORD_HIERARCHY_FAILURE = 'blayzr/keywords/FETCH_HIERARCHY_FAIL';
	
	var FETCH_KEYWORD_GRAPH_REQUEST = 'blayzr/keywords/FETCH_GRAPH_REQUEST';
	var FETCH_KEYWORD_GRAPH_SUCCESS = 'blayzr/keywords/FETCH_GRAPH_SUCCESS';
	var FETCH_KEYWORD_GRAPH_FAILURE = 'blayzr/keywords/FETCH_GRAPH_FAIL';
	
	var UPDATE_GRAPH_NODES = 'blayzr/keywords/UPDATE_GRAPH_NODES';
	var TOGGLE_EXPANDED = 'blayzr/keywords/TOGGLE_EXPANDED';
	
	var initialState = {
	  parents: {
	    data: null,
	    fetching: false,
	    error: null
	  },
	  hierarchy: {
	    data: null,
	    fetching: false,
	    error: null,
	    expanded: []
	  },
	  graph: {
	    data: null,
	    fetching: false,
	    error: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type;
	
	  switch (type) {
	    case FETCH_KEYWORD_PARENTS_REQUEST:
	    case FETCH_KEYWORD_PARENTS_SUCCESS:
	    case FETCH_KEYWORD_PARENTS_FAILURE:
	      return _extends({}, state, {
	        parents: subreducer(state.parents, action)
	      });
	    case FETCH_KEYWORD_HIERARCHY_REQUEST:
	    case FETCH_KEYWORD_HIERARCHY_SUCCESS:
	    case FETCH_KEYWORD_HIERARCHY_FAILURE:
	    case TOGGLE_EXPANDED:
	      return _extends({}, state, {
	        hierarchy: subreducer(state.hierarchy, action)
	      });
	    case FETCH_KEYWORD_GRAPH_REQUEST:
	    case FETCH_KEYWORD_GRAPH_SUCCESS:
	    case FETCH_KEYWORD_GRAPH_FAILURE:
	    case UPDATE_GRAPH_NODES:
	      return _extends({}, state, {
	        graph: subreducer(state.graph, action)
	      });
	    default:
	      return state;
	  }
	}
	
	function subreducer(state) {
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case FETCH_KEYWORD_PARENTS_REQUEST:
	    case FETCH_KEYWORD_HIERARCHY_REQUEST:
	    case FETCH_KEYWORD_GRAPH_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case FETCH_KEYWORD_PARENTS_SUCCESS:
	    case FETCH_KEYWORD_HIERARCHY_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload
	      });
	    case FETCH_KEYWORD_GRAPH_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload.result
	      });
	    case FETCH_KEYWORD_PARENTS_FAILURE:
	    case FETCH_KEYWORD_HIERARCHY_FAILURE:
	    case FETCH_KEYWORD_GRAPH_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload
	      });
	    case TOGGLE_EXPANDED:
	      var expanded = state.expanded.indexOf(payload) === -1 ? state.expanded.concat(payload) : state.expanded.filter(function (path) {
	        return path !== payload;
	      });
	      return _extends({}, state, {
	        expanded: expanded
	      });
	    default:
	      return state;
	  }
	}
	
	function updateGraphState(graph, data, successNodes) {
	  var updateNode = function updateNode(node) {
	    var update = {};
	    if (successNodes.indexOf(node._id.toString()) !== -1 && data[node._id]) {
	      update = data[node._id];
	    }
	    return _extends({}, node, update, {
	      children: node.children.map(updateNode)
	    });
	  };
	  return graph.map(updateNode);
	}
	
	function fetchKeywordParentsRequest() {
	  return {
	    type: FETCH_KEYWORD_PARENTS_REQUEST
	  };
	}
	
	function fetchKeywordParentsSuccess(data) {
	  return {
	    type: FETCH_KEYWORD_PARENTS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchKeywordParentsFailure(error) {
	  return {
	    type: FETCH_KEYWORD_PARENTS_FAILURE,
	    payload: error
	  };
	}
	
	function fetchKeywordHierarchyRequest() {
	  return {
	    type: FETCH_KEYWORD_HIERARCHY_REQUEST
	  };
	}
	
	function fetchKeywordHierarchySuccess(data) {
	  return {
	    type: FETCH_KEYWORD_HIERARCHY_SUCCESS,
	    payload: data['PHOTO PROJECT']
	  };
	}
	
	function fetchKeywordHierarchyFailure(error) {
	  return {
	    type: FETCH_KEYWORD_HIERARCHY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchKeywordGraphRequest() {
	  return {
	    type: FETCH_KEYWORD_GRAPH_REQUEST
	  };
	}
	
	function fetchKeywordGraphSuccess(data) {
	  return {
	    type: FETCH_KEYWORD_GRAPH_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchKeywordGraphFailure(error) {
	  return {
	    type: FETCH_KEYWORD_GRAPH_FAILURE,
	    payload: error
	  };
	}
	
	function toggleExpanded(keyword) {
	  return {
	    type: TOGGLE_EXPANDED,
	    payload: keyword
	  };
	}
	
	function fetchKeywordParents() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      cache: 60 * 24 * 7 // Cache result for one week
	    };
	    dispatch(fetchKeywordParentsRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_PARENTS, options, dispatch).then(function (data) {
	      dispatch(fetchKeywordParentsSuccess(data));
	    }, function (e) {
	      dispatch(fetchKeywordParentsFailure(e));
	    });
	  };
	}
	
	function fetchKeywordHierarchy() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      cache: 60 * 24 * 7 // Cache result for one week
	    };
	    dispatch(fetchKeywordHierarchyRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_HIERARCHY, options, dispatch).then(function (data) {
	      dispatch(fetchKeywordHierarchySuccess(data));
	    }, function (e) {
	      dispatch(fetchKeywordHierarchyFailure(e));
	    });
	  };
	}
	
	function fetchKeywordGraph() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      query: {
	        mode: 'array'
	      },
	      schema: {
	        keywords: _fetch.schemas.graph,
	        tags: _fetch.schemas.graph
	      }
	    };
	    dispatch(fetchKeywordGraphRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(function (data) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(data.entities.graph)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var id = _step.value;
	
	          var node = data.entities.graph[id];
	          data.entities.graph[node.id] = node;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      dispatch(fetchKeywordGraphSuccess(data));
	    }, function (e) {
	      dispatch(fetchKeywordGraphFailure(e));
	    });
	  };
	}
	
	function updateGraphNodes(body) {
	  return function (dispatch, getState) {
	    var options = {
	      method: 'put',
	      token: getState().auth.token,
	      body: body
	    };
	    return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(function (response) {
	      response.nodes_ignored.forEach(function (id) {
	        return delete body[id];
	      });
	      dispatch({
	        type: UPDATE_GRAPH_NODES,
	        payload: {
	          entities: {
	            graph: body
	          }
	        }
	      });
	    });
	  };
	}
	
	function mergeNodes(id1, id2) {
	  return function (dispatch, getState) {
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: {
	        merge_node: [id1, id2]
	      },
	      schema: {
	        parent_update: {
	          keywords: _fetch.schemas.graph,
	          tags: _fetch.schemas.graph
	        }
	      }
	    };
	    return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(function (data) {
	      if (data.entities.graph) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = Object.keys(data.entities.graph)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var id = _step2.value;
	
	            var node = data.entities.graph[id];
	            data.entities.graph[node.id] = node;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	      dispatch({
	        type: UPDATE_GRAPH_NODES,
	        payload: {
	          entities: {
	            graph: data.entities.graph
	          }
	        }
	      });
	      return data;
	    });
	  };
	}
	
	function deleteNode(id) {
	  return function (dispatch, getState) {
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: {
	        delete_node: id
	      }
	    };
	    return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(function () {
	      dispatch({
	        type: UPDATE_GRAPH_NODES,
	        payload: {
	          entities: {
	            graph: _defineProperty({}, id, null)
	          }
	        }
	      });
	    });
	  };
	}
	
	function touchNode(node, key) {
	  return function (dispatch, getState) {
	    var _graph2;
	
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: {
	        touch_node: node._id,
	        key: key
	      }
	    };
	    var timestamp = Math.round(new Date() / 1000);
	    dispatch({
	      type: UPDATE_GRAPH_NODES,
	      payload: {
	        entities: {
	          graph: (_graph2 = {}, _defineProperty(_graph2, node.id, _defineProperty({}, key, timestamp)), _defineProperty(_graph2, node._id, _defineProperty({}, key, timestamp)), _graph2)
	        }
	      }
	    });
	    return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, options, dispatch);
	  };
	}
	
	function touchNodeVisibility(node) {
	  return touchNode(node, 'display__updated_at');
	}
	
	function touchNodeWeighting(node) {
	  return touchNode(node, 'discover__updated_at');
	}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.queuesRequest = queuesRequest;
	exports.queuesSuccess = queuesSuccess;
	exports.queuesFailure = queuesFailure;
	exports.saveQueueRequest = saveQueueRequest;
	exports.saveQueueSuccess = saveQueueSuccess;
	exports.saveQueueFailure = saveQueueFailure;
	exports.fetchQueues = fetchQueues;
	exports.saveQueue = saveQueue;
	exports.deleteQueue = deleteQueue;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _normalizr = __webpack_require__(103);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var QUEUES_REQUEST = 'blayzr/queues/REQUEST';
	var QUEUES_SUCCESS = 'blayzr/queues/SUCCESS';
	var QUEUES_FAILURE = 'blayzr/queues/FAIL';
	
	var SAVE_QUEUE_REQUEST = 'blayzr/queues/SAVE_REQUEST';
	var SAVE_QUEUE_SUCCESS = 'blayzr/queues/SAVE_SUCCESS';
	var SAVE_QUEUE_FAILURE = 'blayzr/queues/SAVE_FAIL';
	
	var DELETE_QUEUE = 'blayzr/queues/DELETE';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null,
	  submitting: false,
	  submitError: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case QUEUES_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case QUEUES_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: state.data ? (0, _lodash2.default)(state.data.concat(payload.result.records)) : payload.result.records
	      });
	    case QUEUES_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case SAVE_QUEUE_REQUEST:
	      return _extends({}, state, {
	        submitting: true,
	        submitError: false
	      });
	    case SAVE_QUEUE_SUCCESS:
	      return _extends({}, state, {
	        submitting: false,
	        data: state.data && state.data.indexOf(meta.id) === -1 ? [meta.id].concat(state.data) : state.data
	      });
	    case SAVE_QUEUE_FAILURE:
	      return _extends({}, state, {
	        submitting: false,
	        submitError: payload
	      });
	    case DELETE_QUEUE:
	      if (state.data) {
	        return _extends({}, state, {
	          data: state.data.filter(function (id) {
	            return id !== meta.id;
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function queuesRequest() {
	  return {
	    type: QUEUES_REQUEST
	  };
	}
	
	function queuesSuccess(data) {
	  return {
	    type: QUEUES_SUCCESS,
	    payload: data
	  };
	}
	
	function queuesFailure(error) {
	  return {
	    type: QUEUES_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function saveQueueRequest() {
	  return {
	    type: SAVE_QUEUE_REQUEST
	  };
	}
	
	function saveQueueSuccess(id, data) {
	  return {
	    type: SAVE_QUEUE_SUCCESS,
	    payload: { entities: { queues: _defineProperty({}, id, data.entities.queues[id]) } },
	    meta: { id: id }
	  };
	}
	
	function saveQueueFailure(error) {
	  return {
	    type: SAVE_QUEUE_FAILURE,
	    payload: error
	  };
	}
	
	function fetchQueues() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token,
	      schema: {
	        records: (0, _normalizr.arrayOf)(_fetch.schemas.queue)
	      }
	    };
	    dispatch(queuesRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_QUEUES, options, dispatch).then(function (data) {
	      dispatch(queuesSuccess(data));
	    }, function (e) {
	      dispatch(queuesFailure(e));
	    });
	  };
	}
	
	function saveQueue(data, structure, id) {
	  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  return function (dispatch, getState) {
	    var endpoint = id ? _constants.ENDPOINT_QUEUE.replace(':id', id) : _constants.ENDPOINT_NEW_QUEUE;
	    var body = _extends({}, data, {
	      json_data: JSON.stringify(structure)
	    });
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      schema: {
	        records: _fetch.schemas.queue
	      },
	      body: body
	    };
	    dispatch(saveQueueRequest());
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      var id = data.result.records;
	      dispatch(saveQueueSuccess(id, data));
	      if (redirect) {
	        dispatch((0, _reactRouterRedux.push)('/queues/' + id));
	      }
	      return data.entities.queues[id];
	    }, function (e) {
	      dispatch(saveQueueFailure(e));
	    });
	  };
	}
	
	function deleteQueue(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_QUEUE.replace(':id', id);
	    (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: getState().auth.token
	    });
	    dispatch({
	      type: DELETE_QUEUE,
	      meta: { id: id },
	      payload: {
	        entities: {
	          queues: _defineProperty({}, id, undefined)
	        }
	      }
	    });
	    dispatch((0, _reactRouterRedux.push)('/queues'));
	  };
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(580)
	var ieee754 = __webpack_require__(896)
	var isArray = __webpack_require__(366)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(51);
	var TAG = __webpack_require__(18)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(27).f;
	var has = __webpack_require__(44);
	var TAG = __webpack_require__(18)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(61);
	var fails = __webpack_require__(11);
	var spaces = __webpack_require__(235);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? 'a'  : 'p',
	          tt:   H < 12 ? 'am' : 'pm',
	          T:    H < 12 ? 'A'  : 'P',
	          TT:   H < 12 ? 'AM' : 'PM',
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occurred and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(82);
	
	var _Actions = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	var support = __webpack_require__(83);
	var nodejsUtils = __webpack_require__(176);
	var GenericWorker = __webpack_require__(48);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodejsUtils.newBufferFrom(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    return buf2string(buf);
	};
	
	/**
	 * A worker to decode utf8 encoded binary chunks into string chunks.
	 * @constructor
	 */
	function Utf8DecodeWorker() {
	    GenericWorker.call(this, "utf-8 decode");
	    // the last bytes if a chunk didn't end with a complete codepoint.
	    this.leftOver = null;
	}
	utils.inherits(Utf8DecodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8DecodeWorker.prototype.processChunk = function (chunk) {
	
	    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);
	
	    // 1st step, re-use what's left of the previous chunk
	    if (this.leftOver && this.leftOver.length) {
	        if(support.uint8array) {
	            var previousData = data;
	            data = new Uint8Array(previousData.length + this.leftOver.length);
	            data.set(this.leftOver, 0);
	            data.set(previousData, this.leftOver.length);
	        } else {
	            data = this.leftOver.concat(data);
	        }
	        this.leftOver = null;
	    }
	
	    var nextBoundary = utf8border(data);
	    var usableData = data;
	    if (nextBoundary !== data.length) {
	        if (support.uint8array) {
	            usableData = data.subarray(0, nextBoundary);
	            this.leftOver = data.subarray(nextBoundary, data.length);
	        } else {
	            usableData = data.slice(0, nextBoundary);
	            this.leftOver = data.slice(nextBoundary, data.length);
	        }
	    }
	
	    this.push({
	        data : exports.utf8decode(usableData),
	        meta : chunk.meta
	    });
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	Utf8DecodeWorker.prototype.flush = function () {
	    if(this.leftOver && this.leftOver.length) {
	        this.push({
	            data : exports.utf8decode(this.leftOver),
	            meta : {}
	        });
	        this.leftOver = null;
	    }
	};
	exports.Utf8DecodeWorker = Utf8DecodeWorker;
	
	/**
	 * A worker to endcode string chunks into utf8 encoded binary chunks.
	 * @constructor
	 */
	function Utf8EncodeWorker() {
	    GenericWorker.call(this, "utf-8 encode");
	}
	utils.inherits(Utf8EncodeWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Utf8EncodeWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : exports.utf8encode(chunk.data),
	        meta : chunk.meta
	    });
	};
	exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(272);
	var setInnerHTML = __webpack_require__(193);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(280);
	var setTextContent = __webpack_require__(451);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1092);
	var ReactInstrumentation = __webpack_require__(58);
	
	var warning = __webpack_require__(15);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var ReactBaseClasses = __webpack_require__(472);
	var ReactChildren = __webpack_require__(1174);
	var ReactDOMFactories = __webpack_require__(1175);
	var ReactElement = __webpack_require__(125);
	var ReactPropTypes = __webpack_require__(1176);
	var ReactVersion = __webpack_require__(1177);
	
	var createReactClass = __webpack_require__(1178);
	var onlyChild = __webpack_require__(1182);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(75);
	
	var warning = __webpack_require__(15);
	var canDefineProperty = __webpack_require__(476);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(474);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checklist = __webpack_require__(797);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checklist = function (_Component) {
	  _inherits(Checklist, _Component);
	
	  function Checklist() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Checklist);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checklist.__proto__ || Object.getPrototypeOf(Checklist)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          onChange = _this$props.onChange;
	
	      var isChecked = value.indexOf(item.value) !== -1;
	      var onCheck = function onCheck() {
	        return onChange(value.concat(item.value), item);
	      };
	      var onUncheck = function onUncheck() {
	        return onChange(value.filter(function (i) {
	          return i !== item.value;
	        }), item);
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: item.value },
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: isChecked ? _Checklist2.default.itemChecked : _Checklist2.default.item,
	            onClick: isChecked ? onUncheck : onCheck },
	          _react2.default.createElement(
	            'div',
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              'div',
	              { className: _Checklist2.default.title },
	              item.title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Checklist2.default.subtitle },
	              item.subtitle,
	              item.extra
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: isChecked ? _Checklist2.default.checkboxChecked : _Checklist2.default.checkbox },
	            isChecked && _react2.default.createElement(_Icon2.default, { icon: 'tick', className: _Checklist2.default.tick, size: 16 })
	          )
	        ),
	        item.append
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Checklist, [{
	    key: 'render',
	    value: function render() {
	      var items = this.props.items;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _Checklist2.default.list },
	        items.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return Checklist;
	}(_react.Component);
	
	exports.default = Checklist;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EmptyNotice;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmptyNotice = __webpack_require__(800);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyNotice(_ref) {
	  var heading = _ref.heading,
	      text = _ref.text;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _EmptyNotice2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _EmptyNotice2.default.heading },
	      heading
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      text
	    )
	  );
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExamplePercentageGroup = exports.ExamplePercentage = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _reactSticky = __webpack_require__(293);
	
	var _InteractiveHierarchy = __webpack_require__(354);
	
	var _InteractiveHierarchy2 = _interopRequireDefault(_InteractiveHierarchy);
	
	var _keywords = __webpack_require__(107);
	
	var _search = __webpack_require__(59);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _auth = __webpack_require__(20);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeywordGraphPicker = function (_Component) {
	  _inherits(KeywordGraphPicker, _Component);
	
	  function KeywordGraphPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, KeywordGraphPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KeywordGraphPicker.__proto__ || Object.getPrototypeOf(KeywordGraphPicker)).call.apply(_ref, [this].concat(args))), _this), _this.isSelected = function (node) {
	      var _this$props = _this.props,
	          selected = _this$props.selected,
	          showGrouping = _this$props.showGrouping;
	
	      if (selected) {
	        if (selected.indexOf(node._id) !== -1 || selected.indexOf(node.id) !== -1) {
	          return true;
	        }
	      }
	      if (showGrouping) {
	        return _this.getData(node, 'display__grouped');
	      }
	    }, _this.isExcluded = function (node) {
	      var _this$props2 = _this.props,
	          excluded = _this$props2.excluded,
	          showWeighting = _this$props2.showWeighting,
	          showGrouping = _this$props2.showGrouping;
	
	      if (excluded) {
	        if (excluded.indexOf(node._id) !== -1 || excluded.indexOf(node.id) !== -1) {
	          return true;
	        }
	      }
	      if (showWeighting) {
	        return parseInt(_this.getData(node, 'discover__weight')) === 0;
	      }
	      if (showGrouping) {
	        return _this.getData(node, 'display__exclude');
	      }
	    }, _this.filterNode = function (node) {
	      var _this$props3 = _this.props,
	          options = _this$props3.options,
	          ignoreFilter = _this$props3.ignoreFilter;
	
	      if (!node) {
	        return false;
	      }
	      if (ignoreFilter) {
	        return true;
	      }
	      if (node.name.indexOf(_constants.KEYWORD_IGNORE_FILTER_PREFIX) === 0) {
	        return true;
	      }
	      return options.keywords.indexOf(node.name) !== -1;
	    }, _this.updateData = function (id, key, v) {
	      var _this$props4 = _this.props,
	          value = _this$props4.value,
	          onChange = _this$props4.onChange;
	
	      if (!onChange) return;
	      if (typeof v === 'undefined') {
	        onChange(_extends({}, value, _defineProperty({}, id, _extends({}, value[id], key))));
	      } else {
	        onChange(_extends({}, value, _defineProperty({}, id, _extends({}, value[id], _defineProperty({}, key, v)))));
	      }
	    }, _this.isNodeOld = function (node) {
	      return node.updated_at !== _this.props.graph.data.updated_at;
	    }, _this.isNodeNew = function (node) {
	      return node.created_at === node.updated_at;
	    }, _this.isNodeBrandNew = function (node) {
	      return _this.isNodeNew(node) && !node.structure__updated_at;
	    }, _this.isNodeResolve = function (node) {
	      var showResolveIndicator = _this.props.showResolveIndicator;
	
	      if (!showResolveIndicator) {
	        return false;
	      }
	      if (!_this.isNodeNew(node)) {
	        return false;
	      }
	      return showResolveIndicator(node);
	    }, _this.isNodeHighlighted = function (node) {
	      var highlightNodes = _this.props.highlightNodes;
	
	      if (!highlightNodes) {
	        return false;
	      }
	      if (highlightNodes.indexOf(node.id) !== -1) {
	        return true;
	      }
	      return false;
	    }, _this.countChildren = function (node, fn) {
	      var nodes = _this.props.nodes;
	
	      var count = 0;
	      for (var i = 0; i !== node.children.length; i++) {
	        var id = node.children[i];
	        if (!nodes[id]) continue;
	        if (fn(nodes[id])) {
	          count++;
	        }
	        count += _this.countChildren(nodes[id], fn);
	      }
	      return count;
	    }, _this.reduceTotalWeight = function (weight, id) {
	      var node = (typeof id === 'undefined' ? 'undefined' : _typeof(id)) !== 'object' ? _this.props.nodes[id] : id;
	      var nodeWeight = _this.getData(node, 'discover__weight', 1);
	      return weight + nodeWeight;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(KeywordGraphPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          graph = _props.graph,
	          fetchKeywordGraph = _props.fetchKeywordGraph,
	          options = _props.options,
	          fetchSearchOptions = _props.fetchSearchOptions;
	
	      if (this.props.disableFetch) {
	        return;
	      }
	      if (!graph.data && !graph.fetching) {
	        fetchKeywordGraph();
	      }
	      if (!options.keywords) {
	        fetchSearchOptions();
	      }
	      if (this.props.enabledKeywords && !this.props.parentMap) {
	        this.props.fetchKeywordParents();
	      }
	    }
	  }, {
	    key: 'isExpanded',
	    value: function isExpanded(keyword) {
	      var expanded = this.props.expanded;
	
	      return expanded.indexOf(keyword) !== -1;
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled(keyword, expandable, isOld, isNew, isBrandNew) {
	      var _props2 = this.props,
	          enableOld = _props2.enableOld,
	          enableNew = _props2.enableNew,
	          enableAllNew = _props2.enableAllNew,
	          tags = _props2.tags;
	
	      if (tags) {
	        return true;
	      }
	      if (enableOld || enableNew || enableAllNew) {
	        if (enableOld && isOld) {
	          return false;
	        }
	        if (enableNew && isBrandNew) {
	          return false;
	        }
	        if (enableAllNew && isNew) {
	          return false;
	        }
	        return true;
	      }
	      var _props3 = this.props,
	          enabledKeywords = _props3.enabledKeywords,
	          parentMap = _props3.parentMap;
	
	      if (enabledKeywords) {
	        var enabled = enabledKeywords.reduce(function (array, keyword) {
	          return array.concat(parentMap[keyword]);
	        }, []);
	        if (enabled.indexOf(keyword) === -1) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'getData',
	    value: function getData(keyword, key, defaultValue) {
	      var value = this.props.value;
	
	      var combined = _extends({}, keyword, value[keyword._id]);
	      if (typeof combined[key] === 'undefined') {
	        return defaultValue;
	      }
	      return combined[key];
	    }
	  }, {
	    key: 'sortNodes',
	    value: function sortNodes(a, b) {
	      return a.name > b.name ? 1 : -1;
	    }
	  }, {
	    key: 'renderTree',
	    value: function renderTree(tree, parent, zeroWeight) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          nodes = _props4.nodes,
	          toggleExpanded = _props4.toggleExpanded,
	          showWeighting = _props4.showWeighting,
	          showGrouping = _props4.showGrouping,
	          showTitles = _props4.showTitles,
	          showIndicators = _props4.showIndicators;
	
	      var weightSiblingsParent = void 0;
	      if (showWeighting) {
	        weightSiblingsParent = tree.reduce(this.reduceTotalWeight, 0);
	        if (parent) {
	          weightSiblingsParent += this.getData(parent, 'discover__weight_group', 1);
	        }
	      }
	      var items = tree.map(function (id) {
	        return nodes[id];
	      }).filter(this.filterNode).sort(this.sortNodes).map(function (node) {
	        var id = node._id;
	        var keyword = node.name;
	        var expanded = _this2.isExpanded(keyword);
	        var selected = _this2.isSelected(node);
	        var excluded = _this2.isExcluded(node);
	        var children = node.children.map(function (id) {
	          return nodes[id];
	        }).filter(_this2.filterNode);
	        var expandable = children.length !== 0;
	        var isNew = _this2.isNodeNew(node);
	        var isBrandNew = _this2.isNodeBrandNew(node);
	        var isOld = _this2.isNodeOld(node);
	        var isResolve = _this2.isNodeResolve(node);
	        var isHighlighted = _this2.isNodeHighlighted(node);
	        var disabled = _this2.isDisabled(keyword, expandable, isOld, isNew, isBrandNew);
	        var hasOldChildren = !!_this2.countChildren(node, _this2.isNodeOld);
	        var hasBrandNewChildren = !!_this2.countChildren(node, _this2.isNodeBrandNew);
	        var hasResolveChildren = !!_this2.countChildren(node, _this2.isNodeResolve);
	        var hasHighlightedChildren = !!_this2.countChildren(node, _this2.isNodeHighlighted);
	        var hasSelectedChildren = _this2.props.showSelectedChildrenIndicator && !!_this2.countChildren(node, _this2.isSelected);
	        var hasExcludedChildren = _this2.props.showSelectedChildrenIndicator && !!_this2.countChildren(node, _this2.isExcluded);
	        var weight = void 0;
	        var weightGroup = void 0;
	        var weightChildren = void 0;
	        if (showWeighting) {
	          weight = _this2.getData(node, 'discover__weight', 1);
	          weightGroup = _this2.getData(node, 'discover__weight_group', 1);
	          weightChildren = weightGroup + children.reduce(_this2.reduceTotalWeight, 0);
	        }
	        var numberInputClass = _InteractiveHierarchy2.default.numberInput;
	        var weightPercent = Math.round(weight / weightSiblingsParent * 100);
	        var weightGroupPercent = Math.round(weightGroup / weightChildren * 100);
	        if (weight === 0 || zeroWeight) {
	          numberInputClass = _InteractiveHierarchy2.default.numberInputRed;
	          weightPercent = 0;
	          weightGroupPercent = 0;
	        }
	
	        var iconClass = expanded ? _InteractiveHierarchy2.default.collapseIcon : _InteractiveHierarchy2.default.icon;
	        var buttonClass = excluded ? _InteractiveHierarchy2.default.buttonExcluded : selected ? _InteractiveHierarchy2.default.buttonActive : _InteractiveHierarchy2.default.button;
	        var icon = expandable ? expanded ? 'minus' : 'plus' : 'dot';
	        var onToggleExpanded = function onToggleExpanded() {
	          return toggleExpanded(keyword);
	        };
	        var onToggleSelected = function onToggleSelected() {
	          console.log(_extends({}, node, { isOld: isOld, isNew: isNew, isBrandNew: isBrandNew, parent: parent }));
	          _this2.props.onSelect && _this2.props.onSelect(_extends({}, node, { isOld: isOld, isNew: isNew, parent: parent }));
	          if (showWeighting) {
	            _this2.updateData(id, 'discover__weight', weight === 0 ? 1 : 0);
	          } else if (showGrouping) {
	            if (selected) {
	              _this2.updateData(id, {
	                display__grouped: false,
	                display__exclude: true,
	                display__title: ''
	              });
	            } else if (excluded) {
	              _this2.updateData(id, 'display__exclude', false);
	            } else {
	              _this2.updateData(id, 'display__grouped', true);
	            }
	          }
	        };
	        var onClickSelectAllChildren = function onClickSelectAllChildren() {
	          if (_this2.props.onSelectAllChildren) {
	            if (!expanded) {
	              onToggleExpanded();
	            }
	            _this2.props.onSelectAllChildren(node.children.map(function (id) {
	              return nodes[id];
	            }));
	          }
	        };
	        return _react2.default.createElement(
	          'li',
	          { key: keyword, className: _InteractiveHierarchy2.default.item },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: onToggleExpanded, className: iconClass, tabIndex: -1 },
	            _react2.default.createElement(_Icon2.default, { icon: icon, size: 16 })
	          ),
	          showWeighting && _react2.default.createElement('input', {
	            type: 'number',
	            min: 0,
	            placeholder: 'w',
	            value: weight,
	            className: numberInputClass,
	            onChange: function onChange(e) {
	              return _this2.updateData(id, 'discover__weight', e.target.value === '' ? '' : parseInt(e.target.value));
	            }
	          }),
	          showWeighting && _react2.default.createElement('input', {
	            type: 'number',
	            min: 0,
	            placeholder: 'wg',
	            value: _this2.getData(node, 'discover__weight_group', 1),
	            className: numberInputClass,
	            onChange: function onChange(e) {
	              return _this2.updateData(id, 'discover__weight_group', e.target.value === '' ? '' : parseInt(e.target.value));
	            }
	          }),
	          showGrouping && _react2.default.createElement('input', {
	            type: 'number',
	            min: 0,
	            placeholder: 'ind',
	            value: _this2.getData(node, 'display__index', ''),
	            className: _InteractiveHierarchy2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this2.updateData(id, 'display__index', e.target.value === '' ? '' : parseInt(e.target.value));
	            }
	          }),
	          _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: onToggleSelected, className: buttonClass, disabled: disabled, tabIndex: -1 },
	            keyword,
	            node.synonyms && _react2.default.createElement(
	              'span',
	              { className: _InteractiveHierarchy2.default.synonyms },
	              '(',
	              node.synonyms.join(', '),
	              ')'
	            ),
	            node.tags && _react2.default.createElement(
	              'span',
	              { className: _InteractiveHierarchy2.default.tags },
	              node.tags.join(', ')
	            )
	          ),
	          showTitles && selected && _react2.default.createElement('input', {
	            type: 'text',
	            placeholder: 'Optional Title',
	            value: _this2.getData(node, 'display__title', ''),
	            className: _InteractiveHierarchy2.default.titleInput,
	            onChange: function onChange(e) {
	              return _this2.updateData(id, 'display__title', e.target.value);
	            }
	          }),
	          showWeighting && _react2.default.createElement(
	            'span',
	            { className: _InteractiveHierarchy2.default.percent },
	            weightPercent,
	            '%'
	          ),
	          showWeighting && children.length !== 0 && _react2.default.createElement(
	            'span',
	            { className: _InteractiveHierarchy2.default.percentGroup },
	            weightGroupPercent,
	            '%'
	          ),
	          showIndicators && isOld && _react2.default.createElement(
	            'span',
	            { className: _InteractiveHierarchy2.default.oldAlert },
	            'Deleted or Moved'
	          ),
	          showIndicators && isBrandNew && _react2.default.createElement(
	            'span',
	            { className: _InteractiveHierarchy2.default.newAlert },
	            'New'
	          ),
	          isResolve && _react2.default.createElement(
	            'button',
	            { className: _InteractiveHierarchy2.default.resolveAlert, onClick: function onClick() {
	                return _this2.props.onClickResolve(node);
	              } },
	            'Resolve'
	          ),
	          isHighlighted && _react2.default.createElement(
	            'button',
	            { className: _InteractiveHierarchy2.default.newAlert },
	            'Selected'
	          ),
	          (showIndicators && hasBrandNewChildren || hasHighlightedChildren) && _react2.default.createElement('span', { className: _InteractiveHierarchy2.default.newAlert }),
	          (showIndicators && hasOldChildren || hasExcludedChildren) && _react2.default.createElement('span', { className: _InteractiveHierarchy2.default.oldAlert }),
	          hasSelectedChildren && _react2.default.createElement('button', { className: _InteractiveHierarchy2.default.selectedAlert }),
	          hasResolveChildren && _react2.default.createElement('span', { className: _InteractiveHierarchy2.default.resolveAlert }),
	          _this2.props.onSelectAllChildren && node.children.length > 1 && _react2.default.createElement(
	            'button',
	            { type: 'button', className: _InteractiveHierarchy2.default.specialSelect, onClick: onClickSelectAllChildren },
	            'Select Children'
	          ),
	          expanded && _this2.renderTree(node.children, node, weight === 0 || zeroWeight)
	        );
	      });
	      return _react2.default.createElement(
	        'ul',
	        { className: _InteractiveHierarchy2.default.list },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          graph = _props5.graph,
	          parentMap = _props5.parentMap,
	          options = _props5.options,
	          fetchKeywordGraph = _props5.fetchKeywordGraph,
	          enabledKeywords = _props5.enabledKeywords;
	
	      if (graph.error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'The keyword graph could not be loaded',
	          onRetry: fetchKeywordGraph
	        });
	      }
	      if (!graph.data || !options.keywords) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      if (enabledKeywords && !parentMap) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      if (this.props.tags) {
	        return this.renderTree(graph.data.tags);
	      }
	      var totalOld = this.countChildren({ children: graph.data.keywords }, this.isNodeOld);
	      var totalNew = this.countChildren({ children: graph.data.keywords }, this.isNodeBrandNew);
	      var totalNeedResolve = this.props.showResolveIndicator && this.countChildren({ children: graph.data.keywords }, this.isNodeResolve);
	      var showHeader = totalNeedResolve || totalNeedResolve === 0 || this.props.showOldNewCounts || this.props.showOldNewCounts || this.props.headerButtons;
	      return _react2.default.createElement(
	        _reactSticky.StickyContainer,
	        null,
	        showHeader && _react2.default.createElement(
	          _reactSticky.Sticky,
	          { className: _InteractiveHierarchy2.default.header, stickyClassName: _InteractiveHierarchy2.default.headerFloating, stickyStyle: { top: this.props.stickyBarTop || '0px' } },
	          _react2.default.createElement(
	            'ul',
	            { className: _InteractiveHierarchy2.default.info },
	            (totalNeedResolve || totalNeedResolve === 0) && _react2.default.createElement(
	              'li',
	              null,
	              'Nodes to resolve: ',
	              totalNeedResolve
	            ),
	            this.props.showOldNewCounts && _react2.default.createElement(
	              'li',
	              null,
	              'Deleted/moved nodes: ',
	              totalOld
	            ),
	            this.props.showOldNewCounts && _react2.default.createElement(
	              'li',
	              null,
	              'New nodes: ',
	              totalNew
	            )
	          ),
	          this.props.headerButtons
	        ),
	        this.renderTree(graph.data.keywords),
	        _react2.default.createElement(
	          'ul',
	          { className: _InteractiveHierarchy2.default.info, style: { marginTop: '20px' } },
	          this.props.showUpdatedTime && _react2.default.createElement(
	            'li',
	            null,
	            'Last updated: ',
	            timestampToDate(graph.data[this.props.showUpdatedTime])
	          ),
	          this.props.showBackupTime && _react2.default.createElement(
	            'li',
	            null,
	            'Last backup: ',
	            timestampToDate(graph.data.backup__updated_at)
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Keyword hierarchy upload from LR: ',
	            timestampToDate(graph.data.hierarchy_created_at)
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Date of the data that was uploaded: ',
	            timestampToDate(graph.data.updated_at)
	          ),
	          this.props.showIndicators && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              { onClick: this.props.fetchKeywordGraph, disabled: graph.fetching, className: _InteractiveHierarchy2.default.refreshButton },
	              graph.fetching ? 'Refreshing…' : 'Refresh graph'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return KeywordGraphPicker;
	}(_react.Component);
	
	var timestampToDate = function timestampToDate(timestamp) {
	  return timestamp ? (0, _dateformat2.default)(new Date(timestamp * 1000), 'HH:MM, d mmmm yyyy') : 'Unknown';
	};
	
	var ExamplePercentage = exports.ExamplePercentage = function ExamplePercentage() {
	  return _react2.default.createElement(
	    'span',
	    { className: _InteractiveHierarchy2.default.percent },
	    '50%'
	  );
	};
	var ExamplePercentageGroup = exports.ExamplePercentageGroup = function ExamplePercentageGroup() {
	  return _react2.default.createElement(
	    'span',
	    { className: _InteractiveHierarchy2.default.percentGroup },
	    '25%'
	  );
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var keywords = _ref2.keywords,
	      search = _ref2.search,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	  return {
	    graph: keywords.graph,
	    parentMap: keywords.parents.data,
	    options: search.options,
	    expanded: keywords.hierarchy.expanded,
	    nodes: entities.graph,
	    ignoreFilter: (0, _auth.isSuperAdmin)(auth.user)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchKeywordGraph: _keywords.fetchKeywordGraph,
	  fetchKeywordParents: _keywords.fetchKeywordParents,
	  fetchSearchOptions: _search.fetchSearchOptions,
	  toggleExpanded: _keywords.toggleExpanded,
	  touchNode: _keywords.touchNode
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KeywordGraphPicker);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.hierarchyRequest = hierarchyRequest;
	exports.hierarchySuccess = hierarchySuccess;
	exports.hierarchyFailure = hierarchyFailure;
	exports.toggleExpanded = toggleExpanded;
	exports.collapseAll = collapseAll;
	exports.pathCountsRequest = pathCountsRequest;
	exports.pathCountsSuccess = pathCountsSuccess;
	exports.pathCountsFailure = pathCountsFailure;
	exports.fetchHierarchy = fetchHierarchy;
	exports.fetchAlbumPathCounts = fetchAlbumPathCounts;
	
	var _fetch = __webpack_require__(14);
	
	var _auth = __webpack_require__(20);
	
	var _constants = __webpack_require__(3);
	
	var HIERARCHY_REQUEST = 'blayzr/hierarchy/REQUEST';
	var HIERARCHY_SUCCESS = 'blayzr/hierarchy/SUCCESS';
	var HIERARCHY_FAILURE = 'blayzr/hierarchy/FAIL';
	
	var PATH_COUNTS_REQUEST = 'blayzr/hierarchy/PATH_COUNTS_REQUEST';
	var PATH_COUNTS_SUCCESS = 'blayzr/hierarchy/PATH_COUNTS_SUCCESS';
	var PATH_COUNTS_FAILURE = 'blayzr/hierarchy/PATH_COUNTS_FAIL';
	
	var TOGGLE_EXPANDED = 'blayzr/hierarchy/TOGGLE_EXPANDED';
	var COLLAPSE_ALL = 'blayzr/hierarchy/COLLAPSE_ALL';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null,
	  expanded: [],
	  paths: {
	    data: null,
	    fetching: false,
	    error: null
	  }
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case HIERARCHY_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case HIERARCHY_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: getHierarchy(payload, meta.libraries),
	        full: meta.superAdmin ? payload[''] : undefined
	      });
	    case HIERARCHY_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: meta.error
	      });
	    case TOGGLE_EXPANDED:
	      var expanded = state.expanded.indexOf(payload) === -1 ? state.expanded.concat(payload) : state.expanded.filter(function (path) {
	        return path !== payload;
	      });
	      return _extends({}, state, {
	        expanded: expanded
	      });
	    case COLLAPSE_ALL:
	      return _extends({}, state, {
	        expanded: []
	      });
	    case PATH_COUNTS_REQUEST:
	      return _extends({}, state, {
	        paths: { fetching: true, error: null }
	      });
	    case PATH_COUNTS_SUCCESS:
	      return _extends({}, state, {
	        paths: { fetching: false, data: payload }
	      });
	    case PATH_COUNTS_FAILURE:
	      return _extends({}, state, {
	        paths: { fetching: false, error: meta.error }
	      });
	    default:
	      return state;
	  }
	}
	
	function getHierarchy(data, libraries) {
	  return _extends({}, data[''].COLLECTIONS, {
	    '<leaves>': libraries.map(function (library) {
	      return library.library.library_token;
	    }).filter(function (library) {
	      return (/^virtual_/.test(library) === false
	      );
	    })
	  });
	}
	
	function hierarchyRequest() {
	  return {
	    type: HIERARCHY_REQUEST
	  };
	}
	
	function hierarchySuccess(data, user) {
	  return {
	    type: HIERARCHY_SUCCESS,
	    payload: data,
	    meta: {
	      libraries: user.libraries,
	      superAdmin: (0, _auth.isSuperAdmin)(user)
	    }
	  };
	}
	
	function hierarchyFailure(error) {
	  return {
	    type: HIERARCHY_FAILURE,
	    meta: { error: error }
	  };
	}
	
	function toggleExpanded(path) {
	  return {
	    type: TOGGLE_EXPANDED,
	    payload: path
	  };
	}
	
	function collapseAll() {
	  return {
	    type: COLLAPSE_ALL
	  };
	}
	
	function pathCountsRequest() {
	  return {
	    type: PATH_COUNTS_REQUEST
	  };
	}
	
	function pathCountsSuccess(data) {
	  return {
	    type: PATH_COUNTS_SUCCESS,
	    payload: data
	  };
	}
	
	function pathCountsFailure(error) {
	  return {
	    type: PATH_COUNTS_FAILURE,
	    meta: { error: error }
	  };
	}
	
	function fetchHierarchy() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        auth = _getState.auth;
	
	    var options = {
	      token: auth.token
	    };
	    dispatch(hierarchyRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_HIERARCHY, options, dispatch).then(function (data) {
	      dispatch(hierarchySuccess(data, auth.user));
	    }, function (e) {
	      dispatch(hierarchyFailure(e));
	    });
	  };
	}
	
	function fetchAlbumPathCounts() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        auth = _getState2.auth;
	
	    var options = {
	      token: auth.token
	    };
	    dispatch(pathCountsRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_ALBUM_PATH_COUNTS, options, dispatch).then(function (data) {
	      dispatch(pathCountsSuccess(data, auth.user));
	    }, function (e) {
	      dispatch(pathCountsFailure(e));
	    });
	  };
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(6);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(51);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(52);
	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(80) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(33);
	var SPECIES = __webpack_require__(18)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109).Buffer))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/* global Promise */
	'use strict';
	
	// load the global object first:
	// - it should be better integrated in the system (unhandledRejection in node)
	// - the environment may have a custom Promise implementation (see zone.js)
	var ES6Promise = null;
	if (typeof Promise !== "undefined") {
	    ES6Promise = Promise;
	} else {
	    ES6Promise = __webpack_require__(916);
	}
	
	/**
	 * Let the user use/change some implementations.
	 */
	module.exports = {
	    Promise: ES6Promise
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(39);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(140);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var EventPluginRegistry = __webpack_require__(273);
	var EventPluginUtils = __webpack_require__(274);
	var ReactErrorUtils = __webpack_require__(278);
	
	var accumulateInto = __webpack_require__(444);
	var forEachAccumulated = __webpack_require__(445);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(141);
	var EventPluginUtils = __webpack_require__(274);
	
	var accumulateInto = __webpack_require__(444);
	var forEachAccumulated = __webpack_require__(445);
	var warning = __webpack_require__(15);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	var getEventTarget = __webpack_require__(283);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(22);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _some2 = __webpack_require__(1028);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _splice = __webpack_require__(1222);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(488);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(1221);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(1219);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(1220);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  empty: {},
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: _some3.default,
	  splice: _splice2.default
	};
	
	exports.default = structure;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _reactOnclickoutside = __webpack_require__(195);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _DropMenu = __webpack_require__(799);
	
	var _DropMenu2 = _interopRequireDefault(_DropMenu);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropMenu = function (_Component) {
	  _inherits(DropMenu, _Component);
	
	  function DropMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropMenu.__proto__ || Object.getPrototypeOf(DropMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function (e) {
	      var _this$props = _this.props,
	          open = _this$props.open,
	          toggle = _this$props.toggle;
	
	      if (open) {
	        if (!toggle || e.target.getAttribute('data-toggle') !== toggle) {
	          _this.props.closeMenu();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DropMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _mousetrap2.default.bind('escape', this.props.closeMenu);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _mousetrap2.default.unbind('escape');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          items = _props.items,
	          closeMenu = _props.closeMenu,
	          fixed = _props.fixed,
	          style = _props.style;
	
	      var className = open ? _DropMenu2.default.open : _DropMenu2.default.closed;
	      if (fixed) {
	        className += ' ' + _DropMenu2.default.fixed;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', {
	          className: open ? _DropMenu2.default.overlayActive : _DropMenu2.default.overlay,
	          onClick: closeMenu
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: className, onClick: closeMenu, style: style },
	          items.map(renderItem)
	        )
	      );
	    }
	  }]);
	
	  return DropMenu;
	}(_react.Component);
	
	function renderItem(_ref2) {
	  var key = _ref2.key,
	      text = _ref2.text,
	      onClick = _ref2.onClick,
	      href = _ref2.href,
	      shouldShow = _ref2.shouldShow,
	      disabled = _ref2.disabled,
	      disabledMessage = _ref2.disabledMessage,
	      extra = _ref2.extra,
	      heading = _ref2.heading,
	      props = _objectWithoutProperties(_ref2, ['key', 'text', 'onClick', 'href', 'shouldShow', 'disabled', 'disabledMessage', 'extra', 'heading']);
	
	  if (typeof shouldShow !== 'undefined' && !shouldShow) {
	    return null;
	  }
	  if (heading) {
	    return _react2.default.createElement(
	      'li',
	      { key: heading, className: _DropMenu2.default.headingItem },
	      heading
	    );
	  }
	  var style = disabled ? { opacity: 0.5 } : {};
	  if (disabled) {
	    onClick = function onClick(e) {
	      e.stopPropagation();
	      window.alert(disabledMessage);
	    };
	  }
	  if (href) {
	    return _react2.default.createElement(
	      'li',
	      { key: key || text, className: _DropMenu2.default.item },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        _extends({ to: disabled ? null : href, className: _DropMenu2.default.link, style: style, onClick: disabled ? onClick : undefined }, props),
	        text
	      )
	    );
	  }
	  var linkClass = extra ? _DropMenu2.default.linkWithExtra : _DropMenu2.default.link;
	  return _react2.default.createElement(
	    'li',
	    { key: key || text, className: _DropMenu2.default.item },
	    _react2.default.createElement(
	      'button',
	      _extends({ onClick: onClick, className: linkClass, style: style }, props),
	      text
	    ),
	    extra && _react2.default.createElement(
	      'div',
	      { className: _DropMenu2.default.extra },
	      extra.map(function (item) {
	        return _react2.default.createElement(
	          'button',
	          { key: item.icon, onClick: item.onClick },
	          _react2.default.createElement(_Icon2.default, { icon: item.icon })
	        );
	      })
	    )
	  );
	}
	
	exports.default = (0, _reactOnclickoutside2.default)(DropMenu);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToggleForm = __webpack_require__(812);
	
	var _ToggleForm2 = _interopRequireDefault(_ToggleForm);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToggleForm = function (_Component) {
	  _inherits(ToggleForm, _Component);
	
	  function ToggleForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ToggleForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleForm.__proto__ || Object.getPrototypeOf(ToggleForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: _this.props.initialOpen || false
	    }, _this.toggleOpen = function () {
	      var open = _this.state.open;
	
	      _this.setState({ open: !open });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ToggleForm, [{
	    key: 'shouldShowIndicator',
	    value: function shouldShowIndicator() {
	      if (!this.props.indicatorValues) {
	        return false;
	      }
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.indicatorValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var value = _step.value;
	
	          if (value instanceof Array) {
	            if (value.length !== 0) {
	              return true;
	            }
	          } else if (value) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showLabel = _props.showLabel,
	          hideLabel = _props.hideLabel,
	          description = _props.description,
	          children = _props.children;
	      var open = this.state.open;
	
	      var showIndicator = this.shouldShowIndicator();
	      return _react2.default.createElement(
	        'div',
	        { className: open ? _ToggleForm2.default.wrapperOpen : _ToggleForm2.default.wrapper },
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: _ToggleForm2.default.button, onClick: this.toggleOpen },
	          _react2.default.createElement(_Icon2.default, { icon: open ? 'chevron-up' : 'chevron-down', size: 16 }),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            open && hideLabel ? hideLabel : showLabel
	          ),
	          showIndicator && _react2.default.createElement('span', { className: _ToggleForm2.default.filledIndicator })
	        ),
	        open && description && _react2.default.createElement(
	          'div',
	          { className: _ToggleForm2.default.description },
	          description
	        ),
	        open && children
	      );
	    }
	  }]);
	
	  return ToggleForm;
	}(_react.Component);
	
	exports.default = ToggleForm;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _SortableBar = __webpack_require__(832);
	
	var _SortableBar2 = _interopRequireDefault(_SortableBar);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortableBar = function (_Component) {
	  _inherits(SortableBar, _Component);
	
	  function SortableBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SortableBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortableBar.__proto__ || Object.getPrototypeOf(SortableBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuOpen: false
	    }, _this.toggleMenu = function () {
	      _this.setState({
	        menuOpen: !_this.state.menuOpen
	      });
	    }, _this.closeMenu = function () {
	      _this.setState({
	        menuOpen: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SortableBar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          title = _props.title,
	          thumb = _props.thumb,
	          subtitle = _props.subtitle,
	          onEdit = _props.onEdit,
	          onRemove = _props.onRemove,
	          onMute = _props.onMute,
	          muted = _props.muted,
	          _props$showHandle = _props.showHandle,
	          showHandle = _props$showHandle === undefined ? true : _props$showHandle,
	          titleLink = _props.titleLink,
	          dotsMenu = _props.dotsMenu;
	
	      var className = muted ? _SortableBar2.default.barMuted : _SortableBar2.default.bar;
	      if (this.props.className) {
	        className += ' ' + this.props.className;
	      }
	      var TitleComponent = titleLink ? _reactRouter.Link : 'div';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: className },
	          thumb && _react2.default.createElement('div', { className: _SortableBar2.default.thumb, style: { backgroundImage: 'url(' + thumb + ')' } }),
	          _react2.default.createElement(
	            TitleComponent,
	            { className: _SortableBar2.default.title, to: titleLink },
	            title,
	            subtitle && _react2.default.createElement(
	              'div',
	              { className: _SortableBar2.default.subtitle },
	              subtitle
	            )
	          ),
	          dotsMenu && _react2.default.createElement(
	            'button',
	            { onClick: this.toggleMenu, className: _SortableBar2.default.button },
	            _react2.default.createElement(_Icon2.default, { icon: 'dots', size: 14 })
	          ),
	          !dotsMenu && onEdit && _react2.default.createElement(
	            'button',
	            { onClick: onEdit, className: _SortableBar2.default.button },
	            _react2.default.createElement(_Icon2.default, { icon: 'edit', size: 14 })
	          ),
	          !dotsMenu && onRemove && _react2.default.createElement(
	            'button',
	            { onClick: onRemove, className: _SortableBar2.default.button },
	            _react2.default.createElement(_Icon2.default, { icon: 'trash', size: 16 })
	          ),
	          showHandle && _react2.default.createElement(
	            'button',
	            { className: 'handle ' + _SortableBar2.default.button },
	            _react2.default.createElement(_Icon2.default, { icon: 'sort-handle', size: 16 })
	          ),
	          onMute && _react2.default.createElement(
	            'button',
	            { onClick: onMute, className: _SortableBar2.default.muteButton },
	            muted ? 'Unmute' : 'Mute'
	          )
	        ),
	        dotsMenu && _react2.default.createElement(
	          'div',
	          { className: this.state.menuOpen ? _SortableBar2.default.menuOpen : _SortableBar2.default.menu },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                _this2.closeMenu();
	                onEdit();
	              },
	              className: _SortableBar2.default.menuButton },
	            'Modify'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onRemove,
	              className: _SortableBar2.default.menuButton },
	            'Remove'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SortableBar;
	}(_react.Component);
	
	exports.default = SortableBar;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAnythingSortable = __webpack_require__(1055);
	
	var _reactAnythingSortable2 = _interopRequireDefault(_reactAnythingSortable);
	
	__webpack_require__(871);
	
	__webpack_require__(833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortableList = function (_Component) {
	  _inherits(SortableList, _Component);
	
	  function SortableList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SortableList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item, index) {
	      var renderItem = _this.props.renderItem;
	
	      return _react2.default.createElement(
	        SortableItem,
	        { key: index, sortData: item, style: { width: '100%' } },
	        renderItem(item, index)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SortableList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          items = _props.items,
	          onSort = _props.onSort,
	          sortHandle = _props.sortHandle;
	
	      return _react2.default.createElement(
	        _reactAnythingSortable2.default,
	        { dynamic: true, onSort: onSort, sortHandle: sortHandle },
	        items.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return SortableList;
	}(_react.Component);
	
	exports.default = SortableList;
	
	
	var Item = function Item(_ref2) {
	  var className = _ref2.className,
	      style = _ref2.style,
	      onMouseDown = _ref2.onMouseDown,
	      onTouchStart = _ref2.onTouchStart,
	      children = _ref2.children;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: style,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart },
	    children
	  );
	};
	
	var SortableItem = (0, _reactAnythingSortable.sortable)(Item);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getAlbumStructure = getAlbumStructure;
	exports.ensureImages = ensureImages;
	exports.canPlay = canPlay;
	exports.checkSchedule = checkSchedule;
	exports.generateDynamicAlbum = generateDynamicAlbum;
	exports.getItemName = getItemName;
	exports.isDynamicAlbum = isDynamicAlbum;
	
	var _constants = __webpack_require__(3);
	
	var _string = __webpack_require__(16);
	
	var _images = __webpack_require__(23);
	
	var _query = __webpack_require__(50);
	
	var DATE_DAYS_ARRAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	function getAlbumStructure(item, entities) {
	  var album = void 0;
	  if (isDynamicAlbum(item)) {
	    album = generateDynamicAlbum(item);
	  } else if (entities.albums[item.album]) {
	    album = JSON.parse(entities.albums[item.album].json_data);
	  }
	  if (item.albumSort) {
	    var _item$albumSort$split = item.albumSort.split('-'),
	        _item$albumSort$split2 = _slicedToArray(_item$albumSort$split, 2),
	        value = _item$albumSort$split2[0],
	        operator = _item$albumSort$split2[1];
	
	    album.sort.value = value;
	    album.sort.operator = operator || null;
	  }
	  return album;
	}
	
	function ensureImages(structure, search, searchImages) {
	  var images = search[(0, _images.getHash)(structure)];
	  if (!images || !images.data && !images.fetching) {
	    return searchImages(structure);
	  }
	  return Promise.resolve();
	}
	
	function canPlay(id, thing, alreadyPlayed, externals) {
	  console.log('Checking if I can play ', thing, externals);
	  if (thing.scheduleHour) {
	    console.log('NO: Scheduled for hour of day ' + thing.scheduleHour);
	    return false;
	  }
	  if (alreadyPlayed.indexOf(id) !== -1) {
	    console.log('NO: Already played');
	    return false;
	  }
	  if (isLimited(thing, externals)) {
	    return false;
	  }
	  return true;
	}
	
	function isLimited(thing, externals) {
	  var date = new Date();
	  if (thing.limitHours && thing.limitHours.indexOf(date.getHours()) === -1) {
	    console.log('NO: Hour of day does not match');
	    return true;
	  }
	  if (thing.limitDate && thing.limitDate.indexOf(date.getDate()) === -1) {
	    console.log('NO: Day of month does not match');
	    return true;
	  }
	  var day = DATE_DAYS_ARRAY[date.getDay()];
	  if (thing.limitDay && thing.limitDay.indexOf(day) === -1) {
	    console.log('NO: Day of week does not match');
	    return true;
	  }
	  var month = _constants.MONTH_ARRAY[date.getMonth()];
	  if (thing.limitMonth && thing.limitMonth.indexOf(month) === -1) {
	    console.log('NO: Month does not match');
	    return true;
	  }
	  if (externals.weather && thing.limitWeather && thing.limitWeather.indexOf(externals.weather) === -1) {
	    console.log('NO: Weather does not match');
	    return true;
	  }
	  return false;
	}
	
	// Returns true if a scheduled thing is found
	// Returns false if not
	function checkSchedule(things, externals, onSuccess) {
	  var date = new Date();
	  var minutes = date.getMinutes();
	  var hour = date.getHours();
	  console.log('Checking schedule', hour, minutes);
	  if (minutes === 0) {
	    for (var i = 0; i !== things.length; i++) {
	      var thing = things[i];
	      if (thing.scheduleHour && thing.scheduleHour.indexOf(hour) !== -1 && isLimited(thing, externals) === false) {
	        onSuccess(thing);
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function generateDynamicAlbum(item) {
	  if (item.album === 'images') {
	    return _extends({}, _query.emptyStructure, {
	      queries: [],
	      include: item.images
	    });
	  }
	}
	
	function getItemName(item, entities) {
	  if (!item) return '';
	  if (item.name) {
	    return item.name;
	  }
	  // Playlist structure
	  if (item.albums) {
	    if (item.albums.length === 1) {
	      return getItemName(item.albums[0], entities);
	    }
	    return (0, _string.pluralize)(item.albums.length, 'album');
	  }
	  // Album in playlist
	  if (item.album) {
	    if (entities.albums[item.album]) {
	      return entities.albums[item.album].name;
	    }
	    if (item.album === 'images') {
	      return (0, _string.pluralize)(item.images.length, 'image');
	    }
	    if (_constants.DYNAMIC_ALBUMS[item.album]) {
	      return _constants.DYNAMIC_ALBUMS[item.album];
	    }
	  }
	  return '';
	}
	
	var DYNAMIC_ALBUM_KEYS = Object.keys(_constants.DYNAMIC_ALBUMS);
	
	function isDynamicAlbum(item) {
	  return DYNAMIC_ALBUM_KEYS.indexOf(item.album) !== -1;
	}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(380);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _AreaPicker = __webpack_require__(356);
	
	var _AreaPicker2 = _interopRequireDefault(_AreaPicker);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEARCH_DELAY = 500;
	
	var LocationPicker = function (_Component) {
	  _inherits(LocationPicker, _Component);
	
	  function LocationPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LocationPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocationPicker.__proto__ || Object.getPrototypeOf(LocationPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchTerm: '',
	      fetching: false,
	      results: []
	    }, _this.searchTimeout = null, _this.onMapClick = function (e) {
	      var onChange = _this.props.onChange;
	
	      onChange({
	        lat: e.latLng.lat(),
	        lon: e.latLng.lng()
	      });
	    }, _this.onSearchChange = function (e) {
	      clearTimeout(_this.searchTimeout);
	      _this.setState({ searchTerm: e.target.value });
	      _this.searchTimeout = setTimeout(_this.fetchLocations, SEARCH_DELAY);
	    }, _this.fetchLocations = function () {
	      var searchTerm = _this.state.searchTerm;
	
	      var url = _constants.GEO_LOOKUP_URL + '?address=' + searchTerm;
	      _this.setState({ fetching: true });
	      window.fetch(url).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        if (searchTerm !== _this.state.searchTerm) {
	          // Search term has changed, so bail out
	          return;
	        }
	        _this.setState({
	          fetching: false,
	          results: data.results
	        });
	      });
	    }, _this.renderResult = function (result, value, onChange) {
	      var onClick = function onClick() {
	        _this.setState({
	          searchTerm: '',
	          results: []
	        });
	        onChange(_extends({}, value, {
	          lat: result.geometry.location.lat,
	          lon: result.geometry.location.lng,
	          address: result.formatted_address
	        }));
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: result.place_id, className: _AreaPicker2.default.resultItem },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClick, className: _AreaPicker2.default.resultButton },
	          result.formatted_address
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LocationPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          hideMap = _props.hideMap,
	          _props$value = _props.value,
	          lat = _props$value.lat,
	          lon = _props$value.lon;
	
	      if (hideMap) {
	        return;
	      }
	      getMapsSDK().then(function (maps) {
	        _this2.map = new maps.Map(_this2.refs.map, {
	          center: { lat: lat, lng: lon },
	          zoom: 10,
	          disableDefaultUI: true,
	          zoomControl: true
	        });
	        _this2.marker = new maps.Marker({
	          map: _this2.map,
	          position: { lat: lat, lng: lon }
	        });
	        _this2.map.addListener('click', _this2.onMapClick);
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          value = _props2.value,
	          hideMap = _props2.hideMap;
	
	      if (hideMap) {
	        return;
	      }
	      if (value.lat !== nextProps.value.lat || value.lon !== nextProps.value.lon) {
	        var coords = {
	          lat: nextProps.value.lat,
	          lng: nextProps.value.lon
	        };
	        this.map.panTo(coords);
	        this.marker.setPosition(coords);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          value = _props3.value,
	          onChange = _props3.onChange,
	          disabled = _props3.disabled,
	          hideMap = _props3.hideMap;
	      var _state = this.state,
	          searchTerm = _state.searchTerm,
	          fetching = _state.fetching,
	          results = _state.results;
	
	      return _react2.default.createElement(
	        'div',
	        { className: disabled ? _AreaPicker2.default.pickerDisabled : _AreaPicker2.default.picker },
	        _react2.default.createElement(
	          'div',
	          { className: _AreaPicker2.default.searchWrapper },
	          _react2.default.createElement('input', {
	            type: 'text',
	            value: searchTerm,
	            onChange: this.onSearchChange,
	            placeholder: 'Search for a location'
	          }),
	          results.length !== 0 && _react2.default.createElement(
	            'ul',
	            { className: _AreaPicker2.default.resultList },
	            results.map(function (result) {
	              return _this3.renderResult(result, value, onChange);
	            })
	          ),
	          fetching && _react2.default.createElement(_LoadingSpinner2.default, { className: _AreaPicker2.default.spinner })
	        ),
	        !hideMap && _react2.default.createElement('div', { ref: 'map', className: _AreaPicker2.default.map }),
	        _react2.default.createElement(
	          'label',
	          { className: _AreaPicker2.default.noMargin },
	          'Selected location',
	          _react2.default.createElement(
	            'div',
	            { className: _AreaPicker2.default.currentLocation },
	            value.address || (value.lat && value.lon ? value.lat.toFixed(3) + ', ' + value.lon.toFixed(3) : 'None')
	          )
	        )
	      );
	    }
	  }]);
	
	  return LocationPicker;
	}(_react.Component);
	
	LocationPicker.defaultProps = {
	  value: {
	    lat: 51.509,
	    lon: -0.197
	  }
	};
	exports.default = LocationPicker;
	
	
	function getMapsSDK() {
	  return new Promise(function (resolve) {
	    if (window.google) {
	      resolve(window.google.maps);
	    } else {
	      window[_constants.MAPS_API_CALLBACK] = function () {
	        return resolve(window.google.maps);
	      };
	      (0, _loadScript2.default)(_constants.MAPS_API_URL);
	    }
	  });
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SAVE_DYNAMIC_LINK_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.dynamicLinksRequest = dynamicLinksRequest;
	exports.dynamicLinksSuccess = dynamicLinksSuccess;
	exports.dynamicLinksFailure = dynamicLinksFailure;
	exports.saveDynamicLinkRequest = saveDynamicLinkRequest;
	exports.saveDynamicLinkSuccess = saveDynamicLinkSuccess;
	exports.saveDynamicLinkFailure = saveDynamicLinkFailure;
	exports.fetchDynamicLinks = fetchDynamicLinks;
	exports.saveDynamicLink = saveDynamicLink;
	exports.deleteDynamicLink = deleteDynamicLink;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	var DYNAMIC_LINKS_REQUEST = 'blayzr/dynlinks/REQUEST';
	var DYNAMIC_LINKS_SUCCESS = 'blayzr/dynlinks/SUCCESS';
	var DYNAMIC_LINKS_FAILURE = 'blayzr/dynlinks/FAIL';
	
	var SAVE_DYNAMIC_LINK_REQUEST = 'blayzr/dynlinks/SAVE_REQUEST';
	var SAVE_DYNAMIC_LINK_SUCCESS = exports.SAVE_DYNAMIC_LINK_SUCCESS = 'blayzr/dynlinks/SAVE_SUCCESS';
	var SAVE_DYNAMIC_LINK_FAILURE = 'blayzr/dynlinks/SAVE_FAIL';
	
	var DELETE_DYNAMIC_LINK = 'blayzr/dynlinks/DELETE';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null,
	  submitting: false,
	  submitError: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case DYNAMIC_LINKS_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case DYNAMIC_LINKS_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload
	      });
	    case DYNAMIC_LINKS_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case SAVE_DYNAMIC_LINK_REQUEST:
	      return _extends({}, state, {
	        submitting: true,
	        submitError: false
	      });
	    case SAVE_DYNAMIC_LINK_SUCCESS:
	      return _extends({}, state, {
	        submitting: false,
	        data: state.data.map(function (link) {
	          return link.id === meta.id ? _extends({}, link, payload) : link;
	        }).concat(meta.id ? [] : payload)
	      });
	    case SAVE_DYNAMIC_LINK_FAILURE:
	      return _extends({}, state, {
	        submitting: false,
	        submitError: payload
	      });
	    case DELETE_DYNAMIC_LINK:
	      if (state.data) {
	        return _extends({}, state, {
	          data: state.data.filter(function (link) {
	            return link.id !== meta.id;
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function dynamicLinksRequest() {
	  return {
	    type: DYNAMIC_LINKS_REQUEST
	  };
	}
	
	function dynamicLinksSuccess(data) {
	  return {
	    type: DYNAMIC_LINKS_SUCCESS,
	    payload: data
	  };
	}
	
	function dynamicLinksFailure(error) {
	  return {
	    type: DYNAMIC_LINKS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function saveDynamicLinkRequest(data, id) {
	  return {
	    type: SAVE_DYNAMIC_LINK_REQUEST,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function saveDynamicLinkSuccess(data, id) {
	  return {
	    type: SAVE_DYNAMIC_LINK_SUCCESS,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function saveDynamicLinkFailure(error) {
	  return {
	    type: SAVE_DYNAMIC_LINK_FAILURE,
	    payload: error
	  };
	}
	
	function fetchDynamicLinks() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token
	    };
	    dispatch(dynamicLinksRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_DYNAMIC_LINKS, options, dispatch).then(function (data) {
	      dispatch(dynamicLinksSuccess(data.records));
	      return data.records;
	    }, function (e) {
	      dispatch(dynamicLinksFailure(e));
	    });
	  };
	}
	
	function saveDynamicLink(data, id) {
	  return function (dispatch, getState) {
	    var endpoint = id ? _constants.ENDPOINT_DYNAMIC_LINK.replace(':id', id) : _constants.ENDPOINT_NEW_DYNAMIC_LINK;
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: data
	    };
	    dispatch(saveDynamicLinkRequest(data, id));
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      dispatch(saveDynamicLinkSuccess(data.records, id));
	    }, function (e) {
	      dispatch(saveDynamicLinkFailure(e));
	    });
	  };
	}
	
	function deleteDynamicLink(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_DYNAMIC_LINK.replace(':id', id);
	    (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: getState().auth.token
	    });
	    dispatch({
	      type: DELETE_DYNAMIC_LINK,
	      meta: { id: id }
	    });
	  };
	}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(47);
	var toLength = __webpack_require__(21);
	var toAbsoluteIndex = __webpack_require__(97);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(37);
	var redefineAll = __webpack_require__(95);
	var meta = __webpack_require__(81);
	var forOf = __webpack_require__(90);
	var anInstance = __webpack_require__(89);
	var isObject = __webpack_require__(12);
	var fails = __webpack_require__(11);
	var $iterDetect = __webpack_require__(160);
	var setToStringTag = __webpack_require__(112);
	var inheritIfRequired = __webpack_require__(222);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(347);
	var redefine = __webpack_require__(37);
	var hide = __webpack_require__(36);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(61);
	var wks = __webpack_require__(18);
	var regexpExec = __webpack_require__(230);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(51);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(12);
	var cof = __webpack_require__(51);
	var MATCH = __webpack_require__(18)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(18)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(80) || !__webpack_require__(11)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(8)[K];
	});


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(110);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(33);
	var ctx = __webpack_require__(53);
	var forOf = __webpack_require__(90);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(55);
	var defined = __webpack_require__(61);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(36);
	var uid = __webpack_require__(98);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_36DQt","backButton":"_2aU1S","page":"_3NVdb","heading":"_1Lzpe","user":"KJN86","userChecked":"_2Jy_m KJN86","checkbox":"j_3M1","checkboxChecked":"_1cg3K j_3M1","tick":"_3S5wR","userName":"_2zX9w","userEmail":"_10ios","note":"_2Py_u","buttons":"_3VBtT","label":"_21ijD","link":"_3SvFN","editLink":"_3jVfk _3SvFN"};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_65Oih","activeButton":"WaHP0","smallButton":"_27-AC","form":"_3Bt9P","error":"_3KWGP","centerError":"eiU2M _3KWGP","noBottomMargin":"f8Yu0","noTopMargin":"_3iNFO","note":"_14AbU","centerNote":"c8dQ3 _14AbU","label":"_1VdAc","numberInput":"_2GhLQ","weatherSelect":"_2x6Ax"};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	module.exports = {
	    /**
	     * True if this is running in Nodejs, will be undefined in a browser.
	     * In a browser, browserify won't include this file and the whole module
	     * will be resolved an empty object.
	     */
	    isNode : typeof Buffer !== "undefined",
	    /**
	     * Create a new nodejs Buffer from an existing content.
	     * @param {Object} data the data to pass to the constructor.
	     * @param {String} encoding the encoding to use.
	     * @return {Buffer} a new Buffer.
	     */
	    newBufferFrom: function(data, encoding) {
	        if (Buffer.from && Buffer.from !== Uint8Array.from) {
	            return Buffer.from(data, encoding);
	        } else {
	            if (typeof data === "number") {
	                // Safeguard for old Node.js versions. On newer versions,
	                // Buffer.from(number) / Buffer(number, encoding) already throw.
	                throw new Error("The \"data\" argument must not be a number");
	            }
	            return new Buffer(data, encoding);
	        }
	    },
	    /**
	     * Create a new nodejs Buffer with the specified size.
	     * @param {Integer} size the size of the buffer.
	     * @return {Buffer} a new Buffer.
	     */
	    allocBuffer: function (size) {
	        if (Buffer.alloc) {
	            return Buffer.alloc(size);
	        } else {
	            var buf = new Buffer(size);
	            buf.fill(0);
	            return buf;
	        }
	    },
	    /**
	     * Find out if an object is a Buffer.
	     * @param {Object} b the object to test.
	     * @return {Boolean} true if the object is a Buffer, false otherwise.
	     */
	    isBuffer : function(b){
	        return Buffer.isBuffer(b);
	    },
	
	    isStream : function (obj) {
	        return obj &&
	            typeof obj.on === "function" &&
	            typeof obj.pause === "function" &&
	            typeof obj.resume === "function";
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109).Buffer))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(987),
	    listCacheDelete = __webpack_require__(988),
	    listCacheGet = __webpack_require__(989),
	    listCacheHas = __webpack_require__(990),
	    listCacheSet = __webpack_require__(991);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(262);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(940),
	    isObjectLike = __webpack_require__(72);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(258),
	    isObject = __webpack_require__(64);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(983);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(393),
	    createWrap = __webpack_require__(401),
	    getHolder = __webpack_require__(181),
	    replaceHolders = __webpack_require__(138);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(387),
	    copyArray = __webpack_require__(260),
	    isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(140),
	    stringToPath = __webpack_require__(415),
	    toKey = __webpack_require__(139),
	    toString = __webpack_require__(268);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var EventPluginRegistry = __webpack_require__(273);
	var ReactEventEmitterMixin = __webpack_require__(1084);
	var ViewportMetrics = __webpack_require__(443);
	
	var getVendorPrefixedEventName = __webpack_require__(1116);
	var isEventSupported = __webpack_require__(284);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	var ViewportMetrics = __webpack_require__(443);
	
	var getEventModifierState = __webpack_require__(282);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	var DOMNamespaces = __webpack_require__(272);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(280);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1126);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(32),__webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(109)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(497);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLORS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _KeywordList = __webpack_require__(299);
	
	var _KeywordList2 = _interopRequireDefault(_KeywordList);
	
	var _Toggle = __webpack_require__(203);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CACHE_KEY_SORT = 'sort-keywords';
	
	var COLORS = exports.COLORS = [[140, 152, 210], [154, 187, 221], [169, 224, 234], [216, 238, 233], [181, 238, 225]];
	
	var GroupedKeywords = function (_Component) {
	  _inherits(GroupedKeywords, _Component);
	
	  function GroupedKeywords() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupedKeywords);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupedKeywords.__proto__ || Object.getPrototypeOf(GroupedKeywords)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      groups: null,
	      sortByFrequency: _lscache2.default.get(CACHE_KEY_SORT)
	    }, _this.fetchGroups = function () {
	      _this.props.fetchGroups().then(function (groups) {
	        return _this.setState({ groups: groups });
	      }, function (error) {
	        return _this.setState({ error: error });
	      });
	    }, _this.toggleSort = function () {
	      _this.setState({ sortByFrequency: !_this.state.sortByFrequency });
	      _lscache2.default.set(CACHE_KEY_SORT, !_this.state.sortByFrequency);
	    }, _this.sortKeywords = function (a, b) {
	      if (_this.props.albumID && _this.state.sortByFrequency && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) === 'object') {
	        return b.doc_count - a.doc_count;
	      }
	      // Nodes with no custom sort will have an index ending in "999"
	      // so we can sort alphabetically if this is the case
	      a = /999$/.test(a.index) ? a.key : a.index;
	      b = /999$/.test(b.index) ? b.key : b.index;
	      return b > a ? -1 : 1;
	    }, _this.renderTopGroup = function (group, groupIndex) {
	      var maxCount = _this.getMaxCount();
	      var groups = group.groups.map(function (group, index) {
	        return _this.renderGroup(group, index, groupIndex, maxCount);
	      });
	      if (_this.props.imageID) {
	        var keywords = group.groups.reduce(function (keywords, group) {
	          return keywords.concat(group.keywords);
	        }, []);
	        groups = _this.renderGroup({ keywords: keywords }, 0, groupIndex);
	      }
	      return [_react2.default.createElement(
	        'dt',
	        { key: 'dt' },
	        group.title || group.name
	      ), _react2.default.createElement(
	        'dd',
	        { key: 'dd' },
	        groups
	      )];
	    }, _this.renderGroup = function (group, index, groupIndex, maxCount) {
	      if (!group.keywords || group.keywords.length === 0) {
	        return null;
	      }
	
	      var _COLORS = _slicedToArray(COLORS[groupIndex % COLORS.length], 3),
	          r = _COLORS[0],
	          g = _COLORS[1],
	          b = _COLORS[2];
	
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        group.title && _react2.default.createElement(
	          'dt',
	          null,
	          group.title
	        ),
	        _react2.default.createElement(_KeywordList2.default, {
	          key: index,
	          keywords: group.keywords.sort(_this.sortKeywords),
	          maxCount: maxCount,
	          r: r, g: g, b: b
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupedKeywords, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.state.groups) {
	        this.fetchGroups();
	      }
	    }
	  }, {
	    key: 'getMaxCount',
	    value: function getMaxCount() {
	      var max = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.state.groups.graph[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var top = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = top.groups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var group = _step2.value;
	              var _iteratorNormalCompletion3 = true;
	              var _didIteratorError3 = false;
	              var _iteratorError3 = undefined;
	
	              try {
	                for (var _iterator3 = group.keywords[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                  var keyword = _step3.value;
	
	                  if (keyword.doc_count > max) {
	                    max = keyword.doc_count;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                  }
	                } finally {
	                  if (_didIteratorError3) {
	                    throw _iteratorError3;
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return max;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          groups = _state.groups,
	          error = _state.error;
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'The keyword data could not be loaded',
	          onRetry: this.fetchGroups
	        });
	      }
	      if (!groups) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.albumID && _react2.default.createElement(
	          'button',
	          { onClick: this.toggleSort, style: { marginBottom: '20px', fontSize: '13px' } },
	          'Alphabetical ',
	          _react2.default.createElement(_Toggle2.default, { value: this.state.sortByFrequency }),
	          ' Most Frequent'
	        ),
	        groups.graph.map(this.renderTopGroup)
	      );
	    }
	  }]);
	
	  return GroupedKeywords;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var auth = _ref2.auth;
	  var albumID = _ref3.albumID,
	      imageID = _ref3.imageID;
	  return {
	    fetchGroups: function fetchGroups() {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_KEYWORD_GRAPH, {
	        query: {
	          grouped: 1,
	          album_id: albumID,
	          image_id: imageID
	        },
	        token: auth.token
	      });
	    }
	  };
	};
	
	var mapDispatchToProps = {};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupedKeywords);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _ShareButton = __webpack_require__(808);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _fetch = __webpack_require__(14);
	
	var _auth = __webpack_require__(20);
	
	var _album = __webpack_require__(66);
	
	var _share = __webpack_require__(87);
	
	var _query = __webpack_require__(50);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _constants = __webpack_require__(3);
	
	var _ExternalShares = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareButton = function (_Component) {
	  _inherits(ShareButton, _Component);
	
	  function ShareButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareButton.__proto__ || Object.getPrototypeOf(ShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      noDownload: false,
	      fetching: false,
	      fetchingPrivileged: false,
	      error: null,
	      createdCodes: [],
	      createdPrivilegedCodes: []
	    }, _this.fetchLink = function () {
	      var _this$props = _this.props,
	          path = _this$props.path,
	          images = _this$props.images,
	          getShareCode = _this$props.getShareCode,
	          onFetch = _this$props.onFetch;
	      var noDownload = _this.state.noDownload;
	
	      onFetch && onFetch();
	      _this.setState({
	        fetching: true,
	        error: null
	      });
	      if (path) {
	        getShareCode(path, noDownload).then(_this.onSuccess, _this.onError);
	      } else if (images) {
	        _this.createExternalImagesAlbum(images).then(function (album) {
	          return getShareCode('/album/' + album.id, noDownload);
	        }).then(_this.onSuccess, _this.onError);
	      }
	    }, _this.fetchPrivilegedLink = function () {
	      var _this$props2 = _this.props,
	          path = _this$props2.path,
	          images = _this$props2.images,
	          getShareCode = _this$props2.getShareCode,
	          onFetch = _this$props2.onFetch;
	      var noDownload = _this.state.noDownload;
	
	      onFetch && onFetch();
	      _this.setState({
	        fetchingPrivileged: true,
	        error: null
	      });
	      if (path) {
	        var yearInSecs = 31536000;
	        getShareCode(path, noDownload, true, yearInSecs).then(_this.onSuccess, _this.onError);
	      } else if (images) {
	        _this.createExternalImagesAlbum(images).then(function (album) {
	          return getShareCode('/album/' + album.id, noDownload);
	        }).then(_this.onSuccess, _this.onError);
	      }
	    }, _this.createExternalImagesAlbum = function (images) {
	      var _this$props3 = _this.props,
	          name = _this$props3.name,
	          saveAlbum = _this$props3.saveAlbum;
	
	      var data = {
	        name: 'Shared Images From ' + name,
	        user_id: 0,
	        presentation_type: null,
	        presentation_speed: null,
	        presentation_transition: null,
	        presentation_sort: null
	      };
	      var structure = _extends({}, _query.emptyStructure, {
	        include: images
	      });
	      return saveAlbum(data, structure, undefined, false);
	    }, _this.onSuccess = function (data) {
	      var newState = {
	        fetching: false,
	        fetchingPrivileged: false
	      };
	      if (data.records.share_creator_perms == true) {
	        newState.createdPrivilegedCodes = _this.state.createdPrivilegedCodes.concat(data.records);
	      } else {
	        newState.createdCodes = _this.state.createdCodes.concat(data.records);
	      }
	
	      _this.setState(newState);
	    }, _this.onError = function (error) {
	      _this.setState({
	        error: error,
	        fetching: false,
	        fetchingPrivileged: false
	      });
	    }, _this.onLinkClick = function (e) {
	      e.target.setSelectionRange(0, 9999);
	    }, _this.onExtendShare = function (share, timeLeft) {
	      (0, _ExternalShares.extendShare)(share, timeLeft, _this.props.setExternalShareDuration);
	      _this.setState({
	        createdCodes: _this.state.createdCodes.map(function (s) {
	          if (s.id === share.id) {
	            return _extends({}, s, { duration: s.duration + 604800 });
	          }
	          return s;
	        })
	      });
	    }, _this.onSuspendShare = function (share) {
	      _this.props.setExternalShareDuration(share.external_id, null);
	      _this.setState({
	        createdCodes: _this.state.createdCodes.map(function (s) {
	          if (s.id === share.id) {
	            return _extends({}, s, { duration: null });
	          }
	          return s;
	        })
	      });
	    }, _this.renderShare = function (share) {
	      var codeType = share.share_creator_perms ? 'orchestra' : 'regular';
	      console.log(share);
	      return _react2.default.createElement(
	        'div',
	        { className: _ShareButton2.default.share },
	        _this.renderCode(share.external_id, codeType),
	        _this.getExpiryText(share)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShareButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchExternalShares();
	    }
	  }, {
	    key: 'getExpiryText',
	    value: function getExpiryText(share) {
	      var _this2 = this;
	
	      if (share) {
	        var timeLeft = (0, _ExternalShares.getShareTimeLeft)(share);
	        return _react2.default.createElement(
	          'p',
	          { className: _ShareButton2.default.info },
	          timeLeft === Infinity && 'Link will never expire',
	          timeLeft !== 0 && timeLeft !== Infinity && 'Link will expire in ' + (0, _ExternalShares.getShareDaysLeft)(timeLeft),
	          timeLeft === 0 && 'Link has expired',
	          this.props.canExtend && _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this2.onExtendShare(share, timeLeft);
	              } },
	            timeLeft === Infinity ? 'Reset' : 'Extend'
	          ),
	          this.props.canSuspend && _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this2.onSuspendShare(share);
	              }, disabled: timeLeft === Infinity },
	            'Suspend'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'p',
	        { className: _ShareButton2.default.info },
	        'Links will expire after one week'
	      );
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton() {
	      var _this3 = this;
	
	      var _state = this.state,
	          fetching = _state.fetching,
	          noDownload = _state.noDownload;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: this.fetchLink, className: _ShareButton2.default.button, disabled: fetching },
	          fetching ? 'Generating public link…' : 'Generate public link'
	        ),
	        !this.props.hideDownloadToggle && _react2.default.createElement(
	          'label',
	          { className: _ShareButton2.default.downloadLabel },
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: noDownload,
	            onChange: function onChange() {
	              return _this3.setState({ noDownload: !noDownload });
	            },
	            disabled: fetching
	          }),
	          'Prevent downloads'
	        )
	      );
	    }
	  }, {
	    key: 'renderPrivilegedButton',
	    value: function renderPrivilegedButton() {
	      var fetchingPrivileged = this.state.fetchingPrivileged;
	
	      return _react2.default.createElement(
	        'button',
	        { onClick: this.fetchPrivilegedLink, className: _ShareButton2.default.button, disabled: fetchingPrivileged },
	        fetchingPrivileged ? 'Generating Orchestra code…' : 'Generate Orchestra code'
	      );
	    }
	  }, {
	    key: 'renderCode',
	    value: function renderCode(code, type) {
	      var _window$location = window.location,
	          protocol = _window$location.protocol,
	          host = _window$location.host;
	
	      if (type == 'regular') {
	        return _react2.default.createElement('input', {
	          type: 'text',
	          className: _ShareButton2.default.code,
	          value: protocol + '//' + host + '/share/' + code,
	          onClick: this.onLinkClick,
	          readOnly: true
	        });
	      } else if (type == 'orchestra') {
	        return _react2.default.createElement('input', {
	          type: 'text',
	          className: _ShareButton2.default.orchestraCode,
	          value: code,
	          onClick: this.onLinkClick,
	          readOnly: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.fetchingExisting) {
	        return _react2.default.createElement(
	          'div',
	          { className: _ShareButton2.default.wrapper, style: this.props.style },
	          _react2.default.createElement(_LoadingSpinner2.default, null)
	        );
	      }
	      var existingShares = this.props.existingShares;
	      var regular = existingShares.regular,
	          privileged = existingShares.privileged;
	
	      var privilegedSection = void 0;
	      if (this.props.allowPrivileged) {
	        privilegedSection = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Orchestra Codes'
	          ),
	          privileged.map(this.renderShare),
	          this.state.createdPrivilegedCodes.map(this.renderShare),
	          this.renderPrivilegedButton()
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _ShareButton2.default.wrapper, style: this.props.style },
	        regular.map(this.renderShare),
	        this.state.createdCodes.map(this.renderShare),
	        this.renderButton(),
	        this.getExpiryText(),
	        privilegedSection
	      );
	    }
	  }]);
	
	  return ShareButton;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var auth = _ref2.auth,
	      share = _ref2.share;
	  var path = _ref3.path;
	  return {
	    fetchingExisting: share.external.fetching,
	    existingShares: getExistingShares(share.external.data, path, auth),
	    getShareCode: function getShareCode(path, noDownload, privileged, duration) {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_SHARE_CODE, {
	        token: auth.token,
	        query: {
	          path: path,
	          no_download: noDownload,
	          share_creator_perms: privileged || false,
	          duration: duration
	        }
	      });
	    },
	    name: auth.user.name,
	    canExtend: (0, _auth.userHasPerm)(auth.user, 'extend_external_share') || (0, _auth.userHasPerm)(auth.user, 'admin'),
	    canSuspend: (0, _auth.userHasPerm)(auth.user, 'admin')
	  };
	};
	
	function getExistingShares(data, path, auth) {
	  console.log(data);
	  if (!data) {
	    return { regular: [], privileged: [] };
	  }
	  var all = data.filter(function (share) {
	    return share.path === path && share.user_id === auth.user.id;
	  });
	  var regular = all.filter(function (share) {
	    return share.share_creator_perms != true;
	  });
	  var privileged = all.filter(function (share) {
	    return share.share_creator_perms;
	  });
	
	  return { regular: regular, privileged: privileged };
	}
	
	var mapDispatchToProps = {
	  saveAlbum: _album.saveAlbum,
	  fetchExternalShares: _share.fetchExternalShares,
	  setExternalShareDuration: _share.setExternalShareDuration
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShareButton);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Stars = __webpack_require__(809);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _image = __webpack_require__(210);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FlagImageModal = __webpack_require__(306);
	
	var _FlagImageModal2 = _interopRequireDefault(_FlagImageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stars = function (_Component) {
	  _inherits(Stars, _Component);
	
	  function Stars() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Stars);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Stars.__proto__ || Object.getPrototypeOf(Stars)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showFlagModal: false
	    }, _this.onClickStar = function (rating) {
	      var _this$props = _this.props,
	          rateImage = _this$props.rateImage,
	          image = _this$props.image;
	
	      rateImage(image._id, rating);
	    }, _this.flagImage = function (options) {
	      var _this$props2 = _this.props,
	          flagImage = _this$props2.flagImage,
	          image = _this$props2.image;
	
	      return flagImage(image._id, options).then(_this.closeFlagModal);
	    }, _this.closeFlagModal = function () {
	      _this.setState({ showFlagModal: false });
	      _this.props.onCloseFlag && _this.props.onCloseFlag();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Stars, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          rating = _props.rating,
	          image = _props.image,
	          showFlag = _props.showFlag,
	          clickable = _props.clickable,
	          showInfo = _props.showInfo,
	          whiteStars = _props.whiteStars,
	          onFlag = _props.onFlag;
	      var showFlagModal = this.state.showFlagModal;
	
	      var rated = image && image.rated;
	
	      var stars = [];
	
	      var _loop = function _loop(i) {
	        var selected = rated === i || ((typeof rating === 'undefined' ? 'undefined' : _typeof(rating)) === 'object' ? rating[i] : i <= rating);
	        var icon = selected ? 'star' : 'star-outline';
	        var starClass = selected ? _Stars2.default.star : _Stars2.default.starOutline;
	        var hoverClass = clickable && !rated ? ' ' + _Stars2.default.clickable : '';
	        var clickedClass = rated === i ? ' ' + _Stars2.default.clicked : '';
	        var onClick = clickable && !rated ? function () {
	          return _this2.onClickStar(i);
	        } : null;
	
	        stars.push(_react2.default.createElement(_Icon2.default, {
	          key: i,
	          icon: icon,
	          className: starClass + hoverClass + clickedClass,
	          onClick: onClick
	        }));
	      };
	
	      for (var i = 1; i <= 5; i++) {
	        _loop(i);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className + (whiteStars ? ' ' + _Stars2.default.white : '') },
	        stars,
	        showFlag && _react2.default.createElement(_Icon2.default, {
	          icon: 'flag',
	          className: image.flagged ? _Stars2.default.flagged : _Stars2.default.flag,
	          onClick: function onClick() {
	            _this2.setState({ showFlagModal: true });
	            if (onFlag) onFlag();
	          }
	        }),
	        showInfo && _react2.default.createElement(
	          'p',
	          { className: _Stars2.default.info },
	          image.rated ? 'You have flagged this image to be rated ' + image.rated + ' stars' : 'Select a rating to flag image to be rated'
	        ),
	        showFlagModal && _react2.default.createElement(_FlagImageModal2.default, {
	          closeModal: this.closeFlagModal,
	          onSubmit: this.flagImage
	        })
	      );
	    }
	  }]);
	
	  return Stars;
	}(_react.Component);
	
	var mapDispatchToProps = {
	  rateImage: _image.rateImage,
	  flagImage: _image.flagImage
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Stars);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Toggle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toggle = __webpack_require__(811);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Toggle(_ref) {
	  var value = _ref.value;
	
	  return _react2.default.createElement(
	    'div',
	    { className: value ? _Toggle2.default.wrapChecked : _Toggle2.default.wrap },
	    _react2.default.createElement('div', { className: value ? _Toggle2.default.dotChecked : _Toggle2.default.dot })
	  );
	}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactOnclickoutside = __webpack_require__(195);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _AlbumPicker = __webpack_require__(355);
	
	var _AlbumPicker2 = _interopRequireDefault(_AlbumPicker);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumPicker = function (_Component) {
	  _inherits(AlbumPicker, _Component);
	
	  function AlbumPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumPicker.__proto__ || Object.getPrototypeOf(AlbumPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      text: _this.props.initialValue || '',
	      showAlbumList: false,
	      selected: -1
	    }, _this.onKeyDown = function (e) {
	      e.preventDefault();
	      _this.setState({ selected: _this.state.selected + 1 });
	    }, _this.onKeyUp = function (e) {
	      e.preventDefault();
	      if (_this.state.selected === 0) {
	        _this.refs.search.focus();
	      }
	      _this.setState({ selected: Math.max(-1, _this.state.selected - 1) });
	    }, _this.handleClickOutside = function () {
	      _this.setState({
	        showAlbumList: false,
	        selected: -1
	      });
	      _this.refs.search && _this.refs.search.blur();
	    }, _this.onChangeText = function (e) {
	      _this.setState({
	        text: e.target.value,
	        selected: -1
	      });
	    }, _this.selectAlbum = function (key, name) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          resetOnChange = _this$props.resetOnChange,
	          collapseOnSelect = _this$props.collapseOnSelect;
	
	      onChange(key);
	      _this.setState({
	        text: resetOnChange ? '' : name,
	        showAlbumList: collapseOnSelect ? false : !!resetOnChange,
	        selected: -1
	      });
	      if (resetOnChange && !collapseOnSelect) {
	        _this.refs.search.focus();
	      }
	    }, _this.showAlbumList = function () {
	      _this.setState({
	        showAlbumList: true
	      });
	    }, _this.clearSearch = function () {
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          resetOnChange = _this$props2.resetOnChange;
	
	      if (!resetOnChange) {
	        onChange(undefined);
	      }
	      _this.setState({
	        text: '',
	        selected: -1,
	        showAlbumList: false
	      });
	      _this.refs.search.blur();
	    }, _this.searchString = function (substring, string) {
	      return string.toLowerCase().indexOf(substring.toLowerCase()) !== -1;
	    }, _this.renderAlbumLists = function (lists, albums, text) {
	      var exclude = _this.props.exclude;
	
	      var nodes = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = lists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var list = _step.value;
	
	          var matches = list.albums.filter(function (album) {
	            if (exclude && exclude.indexOf(album.id) !== -1) return false;
	            return _this.searchString(text, album.name);
	          });
	          if (matches.length !== 0) {
	            nodes.push(_react2.default.createElement(
	              'li',
	              { key: 'list' + list.id, className: _AlbumPicker2.default.autoCompleteHeading },
	              list.name
	            ));
	            nodes = nodes.concat(matches.map(_this.renderAlbum));
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return nodes;
	    }, _this.renderAlbum = function (_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name,
	          cover = _ref2.cover;
	      var getImageSource = _this.props.getImageSource;
	
	      var onClick = function onClick() {
	        return _this.selectAlbum(id, name);
	      };
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: onClick, style: { width: '100%' } },
	          _react2.default.createElement(
	            'div',
	            { className: _AlbumPicker2.default.autoCompleteItem },
	            getImageSource && _react2.default.createElement('div', {
	              className: _AlbumPicker2.default.cover,
	              style: { backgroundImage: 'url(' + _this.props.getImageSource(cover) + ')' }
	            }),
	            name
	          )
	        )
	      );
	    }, _this.renderAutocomplete = function () {
	      var _this$props3 = _this.props,
	          albums = _this$props3.albums,
	          lists = _this$props3.lists,
	          exclude = _this$props3.exclude,
	          isOwner = _this$props3.isOwner;
	      var text = _this.state.text;
	
	
	      var saved = [];
	      var shared = [];
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = albums[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var album = _step2.value;
	
	          if (!_this.searchString(text, album.name)) {
	            continue;
	          }
	          if (exclude && exclude.indexOf(album.id) !== -1) {
	            continue;
	          }
	          if (isOwner(album)) {
	            saved.push(album);
	          } else {
	            shared.push(album);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _AlbumPicker2.default.autoComplete },
	        _this.props.onCreateNewAlbum && _react2.default.createElement(
	          'li',
	          null,
	          _this.props.createNewAlbumLink && _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: { pathname: '/search', query: { playlist: _this.props.playlistID || 'create' } },
	              className: _AlbumPicker2.default.autoCompleteItem,
	              onClick: _this.props.onCreateNewAlbum },
	            _react2.default.createElement('div', { className: _AlbumPicker2.default.addAlbumCover }),
	            'Create New Album'
	          ),
	          !_this.props.createNewAlbumLink && _react2.default.createElement(
	            'button',
	            { onClick: _this.props.onCreateNewAlbum, style: { width: '100%' } },
	            _react2.default.createElement(
	              'div',
	              { className: _AlbumPicker2.default.autoCompleteItem },
	              _react2.default.createElement('div', { className: _AlbumPicker2.default.addAlbumCover }),
	              'Create New Album'
	            )
	          )
	        ),
	        lists && _this.renderAlbumLists(lists, albums, text),
	        saved.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AlbumPicker2.default.autoCompleteHeading },
	          'All albums'
	        ),
	        saved.map(_this.renderAlbum),
	        shared.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AlbumPicker2.default.autoCompleteHeading },
	          'Albums shared with you'
	        ),
	        shared.map(_this.renderAlbum)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.node = (0, _reactDom.findDOMNode)(this);
	      _mousetrap2.default.bind('up', this.onKeyUp);
	      _mousetrap2.default.bind('down', this.onKeyDown);
	      _mousetrap2.default.bind('escape', this.clearSearch);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var selected = this.state.selected;
	
	      if (prevState.selected !== selected) {
	        var button = this.node.querySelectorAll('.' + _AlbumPicker2.default.autoCompleteItem)[selected].parentNode;
	        button && button.focus();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _mousetrap2.default.unbind(['up', 'down', 'escape']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          text = _state.text,
	          showAlbumList = _state.showAlbumList;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _AlbumPicker2.default.wrapper },
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: text,
	          onChange: this.onChangeText,
	          onClick: this.showAlbumList,
	          className: 'mousetrap ' + _AlbumPicker2.default.input,
	          placeholder: this.props.placeholder || 'Choose from your albums or create new',
	          ref: 'search'
	        }),
	        (text !== '' || showAlbumList) && _react2.default.createElement(
	          'button',
	          { onClick: this.clearSearch, className: _AlbumPicker2.default.clearButton },
	          _react2.default.createElement(_Icon2.default, { icon: 'close' })
	        ),
	        showAlbumList && this.renderAutocomplete()
	      );
	    }
	  }]);
	
	  return AlbumPicker;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(AlbumPicker);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ChannelMenuItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChannelMenuItem = __webpack_require__(836);
	
	var _ChannelMenuItem2 = _interopRequireDefault(_ChannelMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChannelMenuItem(_ref) {
	  var channel = _ref.channel;
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    channel.name,
	    channel.data && channel.data._state === 'present' && _react2.default.createElement(
	      'span',
	      { className: _ChannelMenuItem2.default.info },
	      channel.data.name
	    ),
	    channel.data && channel.data.schedule_start_time && channel.data.schedule_end_time && _react2.default.createElement(
	      'span',
	      { className: _ChannelMenuItem2.default.info },
	      !channel.data.schedule_end_time && 'Starts ',
	      channel.data.schedule_start_time,
	      channel.data.schedule_end_time && ' - ' + channel.data.schedule_end_time
	    )
	  );
	}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PresentOptionsFields = PresentOptionsFields;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _PresentOptionsForm = __webpack_require__(839);
	
	var _PresentOptionsForm2 = _interopRequireDefault(_PresentOptionsForm);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _string = __webpack_require__(16);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function PresentOptionsForm(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      onCancel = _ref.onCancel,
	      confirmText = _ref.confirmText,
	      fieldProps = _objectWithoutProperties(_ref, ['handleSubmit', 'onCancel', 'confirmText']);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: 'Presentation Options', onClose: onCancel },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit, className: _PresentOptionsForm2.default.form },
	      _react2.default.createElement(PresentOptionsFields, fieldProps),
	      _react2.default.createElement(_ConfirmButtons2.default, {
	        confirmText: confirmText,
	        onConfirm: handleSubmit,
	        onCancel: onCancel
	      })
	    )
	  );
	}
	
	function PresentOptionsFields(_ref2) {
	  var imageSelection = _ref2.imageSelection,
	      defaultSort = _ref2.defaultSort,
	      presentTypeSelected = _ref2.presentTypeSelected,
	      hideSort = _ref2.hideSort,
	      rangeInputType = _ref2.rangeInputType;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      null,
	      'Presentation Type',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _reduxForm.Field,
	        { component: 'select', name: 'presentation_type', className: _PresentOptionsForm2.default.select },
	        _react2.default.createElement(
	          'option',
	          { value: 'kenburns' },
	          'Ken Burns'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 'floating' },
	          'Floating'
	        )
	      )
	    ),
	    !hideSort && _react2.default.createElement(
	      'label',
	      null,
	      'Presentation Sort Order',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _reduxForm.Field,
	        { component: 'select', name: 'presentation_sort', className: _PresentOptionsForm2.default.select },
	        imageSelection ? _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Selection order'
	        ) : _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Album Default (',
	          defaultSort,
	          ')'
	        ),
	        _constants.SORT_ARRAY.map(function (option) {
	          return _react2.default.createElement(
	            'option',
	            { key: option.value, value: option.value },
	            option.name
	          );
	        })
	      )
	    ),
	    (!presentTypeSelected || presentTypeSelected === 'kenburns') && _react2.default.createElement(
	      'label',
	      null,
	      'Slide duration',
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Slider,
	        name: 'presentation_speed',
	        defaultValue: 3,
	        props: { min: 1, max: 30, step: 1, rangeInputType: rangeInputType }
	      })
	    ),
	    (!presentTypeSelected || presentTypeSelected === 'kenburns') && _react2.default.createElement(
	      'label',
	      null,
	      'Transition speed',
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Slider,
	        name: 'presentation_transition',
	        defaultValue: 1,
	        props: { min: 0.5, max: 20, step: 0.5, rangeInputType: rangeInputType }
	      })
	    ),
	    presentTypeSelected === 'floating' && _react2.default.createElement(
	      'label',
	      null,
	      'Average slide duration',
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Slider,
	        name: 'presentation_speed',
	        defaultValue: 30,
	        props: { min: 20, max: 60, step: 1, rangeInputType: rangeInputType }
	      })
	    ),
	    presentTypeSelected === 'floating' && _react2.default.createElement(
	      'label',
	      null,
	      'Slide frequency',
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Slider,
	        name: 'presentation_transition',
	        defaultValue: 5,
	        props: { min: 1, max: 10, step: 1, prefix: 'Every ', rangeInputType: rangeInputType }
	      })
	    )
	  );
	}
	
	var Slider = function Slider(_ref3) {
	  var value = _ref3.value,
	      onChange = _ref3.onChange,
	      min = _ref3.min,
	      max = _ref3.max,
	      step = _ref3.step,
	      _ref3$prefix = _ref3.prefix,
	      prefix = _ref3$prefix === undefined ? '' : _ref3$prefix,
	      _ref3$rangeInputType = _ref3.rangeInputType,
	      rangeInputType = _ref3$rangeInputType === undefined ? 'range' : _ref3$rangeInputType;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: _PresentOptionsForm2.default.optionValue },
	      prefix,
	      (0, _string.pluralize)(value, 'second')
	    ),
	    _react2.default.createElement('input', {
	      value: value,
	      onChange: onChange,
	      type: rangeInputType,
	      min: min,
	      max: max,
	      step: step,
	      className: _PresentOptionsForm2.default.slider
	    })
	  );
	};
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'present' })(PresentOptionsForm);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _DiversityPicker = __webpack_require__(844);
	
	var _DiversityPicker2 = _interopRequireDefault(_DiversityPicker);
	
	var _fetch = __webpack_require__(14);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiversityPicker = function (_Component) {
	  _inherits(DiversityPicker, _Component);
	
	  function DiversityPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DiversityPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiversityPicker.__proto__ || Object.getPrototypeOf(DiversityPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false,
	      suggestedLimit: null
	    }, _this.fetchStats = function (diversity) {
	      _this.setState({
	        loading: true,
	        suggestedLimit: null
	      });
	      _this.props.fetchStats(diversity).then(function (data) {
	        _this.setState({
	          loading: false,
	          suggestedLimit: data.stats.diversity.natural_diversity
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DiversityPicker, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange;
	
	      var onMouseUp = function onMouseUp(e) {
	        _this2.props.onMouseUp && _this2.props.onMouseUp(e);
	        _this2.props.showSuggestedLimit && _this2.fetchStats(parseFloat(e.target.value));
	      };
	      return _react2.default.createElement(
	        'label',
	        null,
	        'Diversity',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _DiversityPicker2.default.percentage, style: { float: 'right' } },
	          this.state.loading && 'Loading…',
	          this.state.suggestedLimit && 'Natural diversity limit: ' + (0, _string.commas)(this.state.suggestedLimit)
	        ),
	        _react2.default.createElement('input', {
	          className: _DiversityPicker2.default.range,
	          type: 'range',
	          value: value || 0,
	          min: 0,
	          max: 1,
	          step: 0.1,
	          onChange: onChange,
	          onMouseUp: onMouseUp
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: _DiversityPicker2.default.percentage },
	          Math.round(value * 100),
	          '%'
	        )
	      );
	    }
	  }]);
	
	  return DiversityPicker;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth,
	      query = _ref2.query;
	  return {
	    fetchStats: function fetchStats(diversity) {
	      var body = _extends({}, query.structure, {
	        diversity: diversity
	      });
	      return (0, _fetch.fetch)('/search/stats', {
	        method: 'post',
	        body: (0, _images.prepareStructure)((0, _images.addLibrariesToStructure)(body, query.libraries)),
	        token: auth.token
	      });
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DiversityPicker);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Image = __webpack_require__(856);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _image = __webpack_require__(210);
	
	var _albums = __webpack_require__(41);
	
	var _album = __webpack_require__(66);
	
	var _search = __webpack_require__(59);
	
	var _images = __webpack_require__(23);
	
	var _auth = __webpack_require__(20);
	
	var _GroupedKeywords = __webpack_require__(200);
	
	var _GroupedKeywords2 = _interopRequireDefault(_GroupedKeywords);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Gallery = __webpack_require__(303);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  function Image() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Image);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Image.__proto__ || Object.getPrototypeOf(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showAll: false,
	      showFlagModal: false
	    }, _this.toggleInfo = function () {
	      _this.setState({
	        showAll: !_this.state.showAll
	      });
	    }, _this.getAlbumPaths = function (paths) {
	      var userLibraries = _this.props.userLibraries;
	
	      if (!paths || paths.length === 0) {
	        return null;
	      }
	      return paths.filter(function (path) {
	        // Filter out paths in libraries the user cannot access
	        var split = path.split('/');
	        if (split.length >= 3 && userLibraries.indexOf(split[2]) === -1) {
	          return false;
	        }
	        // Filter out paths that are a substring of the full path
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var p = _step.value;
	
	            if (p.indexOf(path + '/') !== -1) {
	              return false;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return true;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Image, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          favouriteImages = _props.favouriteImages,
	          fetchAlbums = _props.fetchAlbums;
	
	      this.fetch();
	
	      if (!favouriteImages) {
	        fetchAlbums();
	      }
	      if (!this.props.keywordMap) {
	        this.props.fetchSearchOptions();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var params = this.props.params;
	
	      if (params.id !== nextProps.params.id) {
	        this.fetch(nextProps);
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	          params = _ref2.params,
	          image = _ref2.image,
	          fetchImage = _ref2.fetchImage;
	
	      if (!image.Filename) {
	        fetchImage(params.id);
	      }
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          image = _props2.image,
	          favouriteImages = _props2.favouriteImages,
	          setFavouriteImage = _props2.setFavouriteImage,
	          canFlag = _props2.canFlag;
	
	      var favourited = favouriteImages && favouriteImages.indexOf(image._id) !== -1;
	      return _react2.default.createElement(
	        'div',
	        { className: _Image2.default.icons },
	        canFlag && _react2.default.createElement(
	          'button',
	          {
	            className: _Image2.default.iconButton,
	            onClick: function onClick() {
	              return _this2.setState({ showFlagModal: true });
	            } },
	          _react2.default.createElement(_Icon2.default, { icon: 'flag', className: image.flagged ? null : _Image2.default.outline })
	        ),
	        favouriteImages && _react2.default.createElement(
	          'button',
	          {
	            className: _Image2.default.iconButton,
	            onClick: function onClick() {
	              return setFavouriteImage(image._id, !favourited);
	            } },
	          _react2.default.createElement(_Icon2.default, { icon: favourited ? 'heart' : 'heart-outline' })
	        )
	      );
	    }
	  }, {
	    key: 'renderInfo',
	    value: function renderInfo(key, value) {
	      if (key === 'AlbumPaths') {
	        value = this.getAlbumPaths(value);
	      }
	      return [_react2.default.createElement(
	        'dt',
	        { key: 'dt' },
	        key
	      ), _react2.default.createElement(
	        'dd',
	        { key: 'dd' },
	        this.renderValue(key, value)
	      )];
	    }
	  }, {
	    key: 'renderValue',
	    value: function renderValue(key, value) {
	      var keywordMap = this.props.keywordMap;
	
	      if (!value) {
	        return 'Unknown';
	      }
	      if (value instanceof Array) {
	        return _react2.default.createElement(
	          'ul',
	          { className: _Image2.default.infoList },
	          value.map(function (item) {
	            if (keywordMap && (key === '_keywords' || key === 'ExpandedKeywords')) {
	              return _react2.default.createElement(
	                'li',
	                { key: item },
	                keywordMap[item] ? keywordMap[item].name : item
	              );
	            }
	            return _react2.default.createElement(
	              'li',
	              { key: item },
	              item
	            );
	          })
	        );
	      }
	      return value;
	    }
	  }, {
	    key: 'renderAllInfo',
	    value: function renderAllInfo(image) {
	      var _this3 = this;
	
	      return Object.keys(image).map(function (key) {
	        if (key === 'Albums') {
	          return null;
	        }
	        if (typeof image[key] === 'string' || typeof image[key] === 'number' || image[key] instanceof Array) {
	          return _this3.renderInfo(key, image[key]);
	        }
	        return null;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          image = _props3.image,
	          getImageSource = _props3.getImageSource,
	          userLibraries = _props3.userLibraries,
	          canViewAdvanced = _props3.canViewAdvanced,
	          onClickThumbnail = _props3.onClickThumbnail;
	      var showAll = this.state.showAll;
	
	
	      var keywords = image._keywords;
	      if (typeof keywords === 'string') {
	        keywords = [keywords];
	      }
	
	      var libraries = (image.LibraryName || []).filter(function (lib) {
	        return userLibraries.indexOf(lib) !== -1;
	      }).join(', ');
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Image2.default.page },
	        !onClickThumbnail && image._id && _react2.default.createElement(_Gallery2.default, {
	          style: { padding: '0 0 20px 0' },
	          images: [image],
	          getImageSource: getImageSource,
	          showInfoLink: false,
	          entities: this.props.entities,
	          canShareImagesInternal: this.props.canShareInternal,
	          canShareImagesExternal: this.props.canShareExternal
	        }),
	        onClickThumbnail && image._id && _react2.default.createElement(Thumb, {
	          onClick: onClickThumbnail,
	          className: _Image2.default.thumb,
	          style: { backgroundImage: 'url(' + getImageSource(image._id) + ')' }
	        }),
	        image.fetching && _react2.default.createElement(_LoadingSpinner2.default, null),
	        image.error && _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching image information',
	          onRetry: function onRetry() {
	            return _this4.fetch();
	          }
	        }),
	        image.Filename && _react2.default.createElement(
	          'ul',
	          { className: _Image2.default.info },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Filename'
	            ),
	            ' ',
	            image.Filename
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Blayzr ID'
	            ),
	            ' ',
	            image._id
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Image date'
	            ),
	            ' ',
	            (0, _images.getDate)(image._date) || 'Unknown'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Event path'
	            ),
	            ' ',
	            image._event || 'No event path'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Library'
	            ),
	            ' ',
	            libraries.length !== 0 ? libraries : 'Shared with you'
	          )
	        ),
	        image.Filename && _react2.default.createElement(_GroupedKeywords2.default, { imageID: image._id }),
	        canViewAdvanced && image.Filename && _react2.default.createElement(
	          'button',
	          { className: _Image2.default.button, onClick: this.toggleInfo },
	          showAll ? 'Hide advanced fields' : 'Show advanced fields'
	        ),
	        showAll && this.renderAllInfo(image),
	        showAll && _react2.default.createElement(
	          'button',
	          { className: _Image2.default.button, onClick: this.toggleInfo },
	          'Hide advanced fields'
	        )
	      );
	    }
	  }]);
	
	  return Image;
	}(_react.Component);
	
	var Thumb = function (_Component2) {
	  _inherits(Thumb, _Component2);
	
	  function Thumb() {
	    _classCallCheck(this, Thumb);
	
	    return _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));
	  }
	
	  _createClass(Thumb, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', this.props);
	    }
	  }]);
	
	  return Thumb;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, _ref3) {
	  var params = _ref3.params;
	
	  return {
	    entities: state.entities,
	    image: state.entities.images[params.id] || {},
	    getImageSource: (0, _images.createImageGetter)(state.auth),
	    favouriteImages: (0, _images.getFavouriteImages)(state),
	    canShareInternal: (0, _auth.userHasPerm)(state.auth.user, 'internal_share'),
	    canShareExternal: (0, _auth.userHasPerm)(state.auth.user, 'external_share'),
	    canFlag: (0, _auth.userHasPerm)(state.auth.user, 'flag_image'),
	    canViewAdvanced: (0, _auth.userHasPerm)(state.auth.user, 'advanced_info'),
	    anonymousUser: (0, _auth.isAnonymous)(state.auth.user),
	    userLibraries: state.auth.user.libraries.map(function (l) {
	      return l.library.library_token;
	    }),
	    keywordMap: state.search.options.keywordMap
	  };
	};
	
	var mapDispatchToProps = {
	  fetchImage: _image.fetchImage,
	  flagImage: _image.flagImage,
	  fetchAlbums: _albums.fetchAlbums,
	  setFavouriteImage: _album.setFavouriteImage,
	  fetchSearchOptions: _search.fetchSearchOptions
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Image);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.clearPlaylistEditorCache = clearPlaylistEditorCache;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _humanizeList = __webpack_require__(365);
	
	var _humanizeList2 = _interopRequireDefault(_humanizeList);
	
	var _PlaylistEditor = __webpack_require__(358);
	
	var _PlaylistEditor2 = _interopRequireDefault(_PlaylistEditor);
	
	var _playlists = __webpack_require__(43);
	
	var _albums = __webpack_require__(41);
	
	var _queues = __webpack_require__(108);
	
	var _search = __webpack_require__(59);
	
	var _banners = __webpack_require__(67);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _SortableList = __webpack_require__(151);
	
	var _SortableList2 = _interopRequireDefault(_SortableList);
	
	var _SortableBar = __webpack_require__(150);
	
	var _SortableBar2 = _interopRequireDefault(_SortableBar);
	
	var _AlbumEditModal = __webpack_require__(526);
	
	var _AlbumEditModal2 = _interopRequireDefault(_AlbumEditModal);
	
	var _AlbumPicker = __webpack_require__(204);
	
	var _AlbumPicker2 = _interopRequireDefault(_AlbumPicker);
	
	var _ConstraintsForm = __webpack_require__(308);
	
	var _ConstraintsForm2 = _interopRequireDefault(_ConstraintsForm);
	
	var _PlaylistMenu = __webpack_require__(528);
	
	var _PlaylistMenu2 = _interopRequireDefault(_PlaylistMenu);
	
	var _ToggleForm = __webpack_require__(149);
	
	var _ToggleForm2 = _interopRequireDefault(_ToggleForm);
	
	var _DiversityPicker = __webpack_require__(207);
	
	var _DiversityPicker2 = _interopRequireDefault(_DiversityPicker);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	var _lists = __webpack_require__(88);
	
	var _fetch = __webpack_require__(14);
	
	var _utils = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATE_CACHE_KEY = 'playlist-editor-state';
	
	function clearPlaylistEditorCache() {
	  _lscache2.default.remove(STATE_CACHE_KEY);
	}
	
	var PlaylistEditor = function (_Component) {
	  _inherits(PlaylistEditor, _Component);
	
	  function PlaylistEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlaylistEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlaylistEditor.__proto__ || Object.getPrototypeOf(PlaylistEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: _this.props.playlist ? _this.props.playlist.name : '',
	      structure: _this.props.playlist ? JSON.parse(_this.props.playlist.json_data) : { albums: [] },
	      editIndex: null,
	      conflicts: null,
	      saving: false,
	      success: false
	    }, _this.routerWillLeave = function () {
	      if (_this.isUnsaved() && !_this.preventSaveAlert) {
	        return 'Your changes have not been saved. Are you sure you want to leave?';
	      }
	    }, _this.isUnsaved = function () {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          playlist = _this$props.playlist;
	      var _this$state = _this.state,
	          name = _this$state.name,
	          structure = _this$state.structure;
	
	      if (!name || structure.albums.length === 0) {
	        return false;
	      }
	      if (params.id) {
	        return name && name !== playlist.name || (0, _lodash2.default)(structure, JSON.parse(playlist.json_data)) === false;
	      }
	      return true;
	    }, _this.goBack = function () {
	      if (_this.props.backToQueueEditor) {
	        window.history.back();
	      } else {
	        _this.props.push('/playlists');
	      }
	    }, _this.onReorder = function (albums) {
	      _this.setState({
	        success: false,
	        conflicts: null,
	        structure: _extends({}, _this.state.structure, {
	          albums: albums
	        })
	      });
	    }, _this.updateName = function (e) {
	      _this.setState({
	        name: e.target.value,
	        success: false
	      });
	    }, _this.addAlbum = function () {
	      var album = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var structure = _this.state.structure;
	
	      _this.updateStructure('albums', structure.albums.concat(album));
	    }, _this.removeAlbum = function (index) {
	      var albums = _this.state.structure.albums;
	
	      _this.setState({ conflicts: null });
	      _this.updateStructure('albums', [].concat(_toConsumableArray(albums.slice(0, index)), _toConsumableArray(albums.slice(index + 1))));
	    }, _this.updateAlbum = function (index, key, value) {
	      var albums = _this.state.structure.albums;
	
	      _this.updateStructure('albums', [].concat(_toConsumableArray(albums.slice(0, index)), [_extends({}, albums[index], _defineProperty({}, key, value))], _toConsumableArray(albums.slice(index + 1))));
	    }, _this.updateStructure = function (key, value) {
	      var structure = _this.state.structure;
	
	      _this.setState({
	        structure: _extends({}, structure, _defineProperty({}, key, value)),
	        success: false
	      });
	    }, _this.openEditModal = function (index) {
	      _this.setState({
	        editIndex: index,
	        albumSnapshot: _this.state.structure.albums[index]
	      });
	    }, _this.closeEditModalAndRestore = function () {
	      var _this$state2 = _this.state,
	          structure = _this$state2.structure,
	          editIndex = _this$state2.editIndex,
	          albumSnapshot = _this$state2.albumSnapshot;
	      var albums = structure.albums;
	
	      _this.updateStructure('albums', [].concat(_toConsumableArray(albums.slice(0, editIndex)), [albumSnapshot], _toConsumableArray(albums.slice(editIndex + 1))));
	      _this.closeEditModal();
	    }, _this.closeEditModal = function () {
	      _this.setState({
	        editIndex: null
	      });
	    }, _this.onCreateNewAlbum = function () {
	      _this.preventSaveAlert = true;
	      _lscache2.default.set(STATE_CACHE_KEY, _this.state);
	    }, _this.previewPlaylist = function () {
	      _this.setState({ loadingPreview: true });
	      var _this$props2 = _this.props,
	          params = _this$props2.params,
	          sendToPlayNow = _this$props2.sendToPlayNow,
	          presentChannel = _this$props2.presentChannel;
	
	      _this.savePlaylist().then(function () {
	        return sendToPlayNow(undefined, { playlist_id: params.id });
	      }).then(function (data) {
	        presentChannel(data.channel);
	      }).catch(function () {
	        _this.setState({ loadingPreview: false });
	      });
	    }, _this.savePlaylist = function () {
	      var _this$props3 = _this.props,
	          params = _this$props3.params,
	          savePlaylist = _this$props3.savePlaylist;
	      var _this$state3 = _this.state,
	          name = _this$state3.name,
	          structure = _this$state3.structure;
	
	      var redirect = _this.props.playlist ? null : undefined;
	      _this.preventSaveAlert = true;
	      _this.setState({
	        conflicts: null,
	        saving: true,
	        checkingForConflicts: false,
	        conflictCheckError: null
	      });
	      return savePlaylist({ name: name }, structure, params.id, redirect).then(function (playlist) {
	        _this.setState({
	          checkingForConflicts: true,
	          saving: false,
	          success: true
	        });
	        _this.props.showBanner('Playlist saved');
	        _this.props.checkForConflicts(playlist).then(function (response) {
	          _this.setState({
	            conflicts: response.conflicts,
	            checkingForConflicts: false
	          });
	        }, function (e) {
	          return _this.setState({
	            checkingForConflicts: false,
	            conflictCheckError: e
	          });
	        });
	      });
	    }, _this.saveAsNew = function () {
	      var _this$props4 = _this.props,
	          playlist = _this$props4.playlist,
	          savePlaylist = _this$props4.savePlaylist;
	      var _this$state4 = _this.state,
	          name = _this$state4.name,
	          structure = _this$state4.structure;
	
	      var newName = playlist.name === name ? name + ' copy' : name;
	      _this.preventSaveAlert = true;
	      _this.setState({ savingNew: true });
	      return savePlaylist({ name: newName }, structure).then(function () {
	        _this.props.showBanner('New playlist saved');
	        _this.setState({ savingNew: false });
	      });
	    }, _this.deletePlaylist = function () {
	      var message = 'Are you sure you want to delete ' + _this.props.playlist.name + '?';
	      if (_this.props.playlistQueues.length !== 0) {
	        message += ' It is part of ' + (0, _humanizeList2.default)(_this.props.playlistQueues.map(function (list) {
	          return list.name;
	        }));
	      }
	      if (window.confirm(message)) {
	        _this.preventSaveAlert = true;
	        _this.props.deletePlaylist(_this.props.playlist.id);
	        _this.props.showBanner('Playlist deleted');
	      }
	    }, _this.renderAlbum = function (album, index, simple) {
	      var conflicts = _this.state.conflicts;
	
	      var subtitle = _react2.default.createElement(
	        'div',
	        null,
	        _this.renderDuration(album),
	        simple && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/album/' + album.album + '/edit', className: _PlaylistEditor2.default.textLink },
	          'Edit underlying album'
	        ),
	        !simple && conflicts && conflicts.filter(function (c) {
	          return c.album === index;
	        }).map(_this.renderConflict)
	      );
	      if (simple) {
	        return _react2.default.createElement(_SortableBar2.default, {
	          title: (0, _utils.getItemName)(album, _this.props.entities),
	          thumb: _this.getAlbumThumb(album),
	          subtitle: subtitle,
	          showHandle: false,
	          className: _PlaylistEditor2.default.simpleAlbum
	        });
	      }
	      return _react2.default.createElement(_SortableBar2.default, {
	        key: index + album.album,
	        title: (0, _utils.getItemName)(album, _this.props.entities),
	        thumb: _this.getAlbumThumb(album),
	        subtitle: subtitle,
	        onEdit: function onEdit() {
	          return _this.openEditModal(index);
	        },
	        onRemove: function onRemove() {
	          return _this.removeAlbum(index);
	        },
	        dotsMenu: true
	      });
	    }, _this.renderDuration = function (item) {
	      if (!item.album) {
	        return 'Unknown';
	      }
	      if ((0, _utils.isDynamicAlbum)(item)) {
	        return 'Dynamic';
	      }
	      var _this$props5 = _this.props,
	          entities = _this$props5.entities,
	          search = _this$props5.search;
	
	      var album = entities.albums[item.album];
	      if (!album) {
	        return 'This album has been deleted and should be removed from the playlist';
	      }
	      if (item.presentationLimitImages) {
	        return (0, _string.pluralize)(item.presentationLimitImages, 'image') + ', ' + _this.renderMinutesCount(item, album, item.presentationLimitImages) + ' (limited)';
	      }
	      if (item.albumLimit) {
	        return (0, _string.pluralize)(item.albumLimit, 'image') + ', ' + _this.renderMinutesCount(item, album, item.albumLimit) + ' (limited)';
	      }
	      var hash = (0, _images.getHash)(album.json_data);
	      if (!search[hash] || search[hash].fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, { className: _PlaylistEditor2.default.spinner, style: { width: '10px', height: '10px', margin: '2px' } });
	      }
	      if (search[hash].error) {
	        return 'Error retrieving images';
	      }
	      return (0, _string.pluralize)(search[hash].count, 'image') + ', ' + _this.renderMinutesCount(item, album, search[hash].count);
	    }, _this.getAlbumImageCount = function (item) {
	      if (!item.album) {
	        return null;
	      }
	      var _this$props6 = _this.props,
	          entities = _this$props6.entities,
	          search = _this$props6.search;
	
	      var album = entities.albums[item.album];
	      if (!album) {
	        return null;
	      }
	      if (item.presentationLimitImages && item.albumLimit) {
	        return Math.min(item.presentationLimitImages, item.albumLimit);
	      }
	      if (item.presentationLimitImages || item.albumLimit) {
	        return item.presentationLimitImages || item.albumLimit;
	      }
	      var hash = (0, _images.getHash)(album.json_data);
	      if (!search[hash] || search[hash].fetching || search[hash].error) {
	        return null;
	      }
	      return search[hash].count;
	    }, _this.getAlbumDuration = function (item) {
	      var count = _this.getAlbumImageCount(item);
	      if (!count) return 0;
	
	      var entities = _this.props.entities;
	
	      var album = entities.albums[item.album];
	      if (!album) return 0;
	
	      var multiplier = item.repeatTimes ? item.repeatTimes + 1 : 1;
	      var delay = item.presentationSpeed || album.presentation_speed || 3;
	
	      var minutes = delay * count * multiplier / 60;
	      if (item.presentationLimitMinutes) {
	        return Math.min(item.presentationLimitMinutes, minutes);
	      }
	      return minutes;
	    }, _this.renderConflict = function (conflict) {
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.conflict },
	        conflict.conflict
	      );
	    }, _this.renderPlaylistConflict = function (conflict) {
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.conflict },
	        conflict.album !== undefined && 'Album at index ' + conflict.album + ': ',
	        conflict.conflict
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PlaylistEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          location = _props.location,
	          albums = _props.albums,
	          fetchAlbums = _props.fetchAlbums,
	          removeLocationQuery = _props.removeLocationQuery;
	
	      if (!albums) fetchAlbums();
	
	      var _props2 = this.props,
	          lists = _props2.lists,
	          fetchPlaylists = _props2.fetchPlaylists;
	
	      if (!lists) fetchPlaylists();
	
	      var _props3 = this.props,
	          playlistQueues = _props3.playlistQueues,
	          fetchQueues = _props3.fetchQueues;
	
	      if (!playlistQueues) fetchQueues();
	
	      var cache = _lscache2.default.get(STATE_CACHE_KEY);
	      if (cache && (!params.id || this.props.playlist)) {
	        if (location.query.addAlbum) {
	          cache.structure.albums.push({ album: location.query.addAlbum });
	        }
	        this.setState(cache);
	        this.fetchCounts(cache.structure);
	        clearPlaylistEditorCache();
	        removeLocationQuery(params.id);
	      } else if (params.id) {
	        var playlist = this.props.playlist;
	        var structure = this.state.structure;
	
	        if (playlist && albums) {
	          this.fetchCounts(structure);
	        }
	      }
	
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var albums = this.props.albums;
	
	      if (albums) {
	        this.fetchCounts(this.state.structure);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var playlist = this.props.playlist;
	
	      if (!playlist && nextProps.playlist || playlist && nextProps.playlist && playlist.id !== nextProps.playlist.id) {
	        var structure = JSON.parse(nextProps.playlist.json_data);
	        this.setState({
	          name: nextProps.playlist.name,
	          structure: structure
	        });
	      }
	    }
	  }, {
	    key: 'fetchCounts',
	    value: function fetchCounts(structure) {
	      var _props4 = this.props,
	          entities = _props4.entities,
	          search = _props4.search,
	          searchImages = _props4.searchImages;
	
	      structure.albums.forEach(function (item) {
	        var album = entities.albums[item.album];
	        if (album) {
	          var images = search[(0, _images.getHash)(album.json_data)] || {};
	          if (!images.data && !images.fetching && !images.error) {
	            searchImages(JSON.parse(album.json_data));
	          }
	        }
	      });
	    }
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading(heading, extra) {
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.heading },
	        heading,
	        extra
	      );
	    }
	  }, {
	    key: 'getAlbumThumb',
	    value: function getAlbumThumb(item) {
	      var entities = this.props.entities;
	
	      var album = entities.albums[item.album];
	      if (!album) {
	        return null;
	      }
	      return this.props.getImageSource(album.cover);
	    }
	  }, {
	    key: 'renderMinutesCount',
	    value: function renderMinutesCount(item, album, count) {
	      var multiplier = item.repeatTimes ? item.repeatTimes + 1 : 1;
	      var delay = item.presentationSpeed || album.presentation_speed || 3;
	      // const type = item.presentationType || album.presentation_type || 'kenburns'
	      var minutes = delay * count * multiplier / 60;
	      if (item.presentationLimitMinutes) {
	        minutes = Math.min(item.presentationLimitMinutes, minutes);
	      }
	      return (0, _string.formatMinutes)(minutes);
	    }
	  }, {
	    key: 'getDefaultSortSuffix',
	    value: function getDefaultSortSuffix(item) {
	      if (!item.album || (0, _utils.isDynamicAlbum)(item)) {
	        return '';
	      }
	      var entities = this.props.entities;
	
	      var album = entities.albums[item.album];
	      var structure = JSON.parse(album.json_data);
	      var operator = structure.sort.operator ? '-' + structure.sort.operator : '';
	      return ' (' + structure.sort.value + operator + ')';
	    }
	  }, {
	    key: 'getAlbumPropertySuffix',
	    value: function getAlbumPropertySuffix(item, field) {
	      if (!item.album || (0, _utils.isDynamicAlbum)(item)) return '';
	      var entities = this.props.entities;
	
	      var album = entities.albums[item.album];
	      return album[field] ? ' (' + album[field] + ')' : '';
	    }
	  }, {
	    key: 'renderEditModal',
	    value: function renderEditModal(album, index) {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          params = _props5.params,
	          albums = _props5.albums,
	          lists = _props5.lists,
	          isOwner = _props5.isOwner;
	
	      return _react2.default.createElement(_AlbumEditModal2.default, {
	        renderAlbum: this.renderAlbum,
	        params: params,
	        albums: albums,
	        lists: lists,
	        album: album,
	        update: function update(key, value) {
	          return _this2.updateAlbum(index, key, value);
	        },
	        isOwner: isOwner,
	        renderHeading: this.renderHeading,
	        initialValue: (0, _utils.getItemName)(album, this.props.entities),
	        duration: this.renderDuration(album),
	        onCancel: this.closeEditModalAndRestore,
	        onSave: this.closeEditModal,
	        onCreateNewAlbum: this.onCreateNewAlbum,
	        defaultSortSuffix: this.getDefaultSortSuffix(album),
	        defaultPresentationSortSuffix: this.getAlbumPropertySuffix(album, 'presentation_sort') || this.getDefaultSortSuffix(album),
	        defaultPresentationTypeSuffix: this.getAlbumPropertySuffix(album, 'presentation_type') || ' (kenburns)',
	        playlistName: this.state.name,
	        counts: this.renderCounts([album]),
	        getImageSource: this.props.getImageSource
	      });
	    }
	  }, {
	    key: 'albumsTotal',
	    value: function albumsTotal(albums, fn) {
	      return albums.reduce(function (total, item) {
	        if (total === null) {
	          return null;
	        }
	        return total + fn(item);
	      }, 0);
	    }
	  }, {
	    key: 'getCheckConflictLabel',
	    value: function getCheckConflictLabel() {
	      if (this.state.saving) {
	        return 'Saving playlist…';
	      }
	      if (this.state.checkingForConflicts) {
	        return 'Checking for conflicts…';
	      }
	      if (this.isUnsaved()) {
	        return 'Save and check for conflicts';
	      }
	      if (this.state.conflicts && this.state.conflicts.length === 0) {
	        return 'No conflicts found';
	      }
	      return 'Check for conflicts';
	    }
	  }, {
	    key: 'renderCounts',
	    value: function renderCounts(albums, limitImages, limitMinutes) {
	      var playlist = this.props.playlist;
	
	      var count = this.albumsTotal(albums, this.getAlbumImageCount);
	      var limitImagesNote = void 0;
	      var limitMinutesNote = void 0;
	      var limitImagesPercentage = void 0;
	      var limitMinutesPercentage = void 0;
	      if (limitImages && limitImages < count) {
	        if (!limitMinutes) {
	          // Store percentage of images limited to roughly adjust duration
	          limitImagesPercentage = limitImages / count;
	        }
	        count = limitImages;
	        limitImagesNote = ' (limited)';
	      }
	      var duration = this.albumsTotal(albums, this.getAlbumDuration);
	      if (limitMinutes && limitMinutes < duration) {
	        if (!limitImages) {
	          // Store percentage of minutes limited to roughly adjust image count
	          limitMinutesPercentage = limitMinutes / duration;
	        }
	        duration = limitMinutes;
	        limitMinutesNote = ' (limited)';
	      }
	      if (limitImagesPercentage) {
	        duration = duration * limitImagesPercentage;
	        limitMinutesNote = ' (estimate)';
	      }
	      if (limitMinutesPercentage) {
	        count = count * limitMinutesPercentage;
	        limitImagesNote = ' (estimate)';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.count },
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _string.pluralize)(count, 'photo'),
	          limitImagesNote,
	          ', ',
	          (0, _string.formatMinutes)(duration),
	          limitMinutesNote
	        ),
	        playlist && playlist.id && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.previewPlaylist,
	            className: _PlaylistEditor2.default.previewButton,
	            disabled: this.state.loadingPreview },
	          this.state.loadingPreview ? 'Loading…' : 'Preview'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          params = _props6.params,
	          playlist = _props6.playlist,
	          albums = _props6.albums,
	          error = _props6.error,
	          fetchPlaylists = _props6.fetchPlaylists;
	
	      if (!albums) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      if (params.id) {
	        if (!playlist) {
	          return _react2.default.createElement(_LoadingSpinner2.default, null);
	        }
	        if (error) {
	          return _react2.default.createElement(_ErrorMessage2.default, { message: 'Playlist could not be loaded', onRetry: fetchPlaylists });
	        }
	      }
	      var _state = this.state,
	          name = _state.name,
	          structure = _state.structure,
	          editIndex = _state.editIndex,
	          conflicts = _state.conflicts;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.page },
	        params.id && _react2.default.createElement(
	          'p',
	          { className: _PlaylistEditor2.default.intro },
	          'Modifying a playlist will affect all queues that contain this playlist.'
	        ),
	        this.renderHeading('Playlist name'),
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: name,
	          onChange: this.updateName,
	          autoFocus: !params.id
	        }),
	        this.renderHeading('Albums'),
	        _react2.default.createElement(_SortableList2.default, {
	          items: structure.albums,
	          renderItem: this.renderAlbum,
	          sortHandle: 'handle',
	          onSort: this.onReorder
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: structure.albums.length !== 0 ? _PlaylistEditor2.default.pickerWrapper : _PlaylistEditor2.default.pickerWrapperNoAlbums },
	          _react2.default.createElement(_AlbumPicker2.default, {
	            albums: albums,
	            lists: this.props.lists,
	            isOwner: this.props.isOwner,
	            onChange: function onChange(album) {
	              return _this3.addAlbum({ album: album });
	            },
	            resetOnChange: true,
	            collapseOnSelect: true,
	            onCreateNewAlbum: this.onCreateNewAlbum,
	            createNewAlbumLink: true,
	            playlistID: params.id,
	            getImageSource: this.props.getImageSource,
	            placeholder: 'Add an album to playlist'
	          })
	        ),
	        structure.albums.length !== 0 && this.renderCounts(structure.albums, structure.presentationLimitImages, structure.presentationLimitMinutes),
	        this.renderHeading('Playlist options'),
	        _react2.default.createElement(
	          _ToggleForm2.default,
	          {
	            showLabel: 'Apply a limit or repeat',
	            description: 'Limits will ensure the playlist is played only up to a certain number of images or minutes.',
	            indicatorValues: [structure.presentationLimitImages, structure.presentationLimitMinutes] },
	          this.renderHeading('Limit playlist to number of photos'),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: structure.presentationLimitImages || '',
	            min: 1,
	            className: _PlaylistEditor2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this3.updateStructure('presentationLimitImages', parseInt(e.target.value) || undefined);
	            }
	          }),
	          this.renderHeading('Limit playlist to number of minutes'),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: structure.presentationLimitMinutes || '',
	            min: 0.1,
	            className: _PlaylistEditor2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this3.updateStructure('presentationLimitMinutes', parseFloat(e.target.value) || undefined);
	            }
	          }),
	          this.renderHeading('Repeat number of times'),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: structure.repeat || '',
	            min: 1,
	            className: _PlaylistEditor2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this3.updateStructure('repeat', parseInt(e.target.value) || undefined);
	            }
	          }),
	          _react2.default.createElement(_DiversityPicker2.default, {
	            value: structure.diversity || '',
	            onChange: function onChange(e) {
	              return _this3.updateStructure('diversity', parseFloat(e.target.value) || undefined);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: structure.allow_duplicates,
	            onChange: function onChange() {
	              return _this3.updateStructure('allow_duplicates', !structure.allow_duplicates);
	            }
	          }),
	          ' Allow duplicate images'
	        ),
	        _react2.default.createElement(_ConstraintsForm2.default, {
	          values: structure,
	          update: this.updateStructure,
	          renderHeading: this.renderHeading,
	          title: 'Schedule this playlist (optional)',
	          showLocationPicker: true,
	          hideAlbumLimit: true,
	          userDefaultLocation: this.props.userDefaultLocation
	        }),
	        conflicts && conflicts.length !== 0 && this.renderHeading('Playlist conflicts'),
	        conflicts && conflicts.map(this.renderPlaylistConflict),
	        _react2.default.createElement(
	          'div',
	          { className: _PlaylistEditor2.default.buttons },
	          this.props.playlist && _react2.default.createElement(
	            'button',
	            {
	              onClick: this.deletePlaylist,
	              className: _PlaylistEditor2.default.deleteButton },
	            'Delete Playlist'
	          ),
	          !this.state.saving && _react2.default.createElement(
	            'button',
	            { onClick: this.goBack, className: _PlaylistEditor2.default.cancelButton },
	            'Cancel'
	          ),
	          !this.state.saving && _react2.default.createElement(
	            'button',
	            {
	              onClick: this.saveAsNew,
	              className: _PlaylistEditor2.default.cancelButton,
	              disabled: this.state.savingNew || this.state.saving },
	            this.state.savingNew ? 'Saving…' : 'Save as new'
	          ),
	          !this.state.success && _react2.default.createElement(
	            'button',
	            {
	              onClick: this.savePlaylist,
	              className: _PlaylistEditor2.default.saveButton,
	              disabled: this.state.saving || this.state.savingNew || !this.isUnsaved() },
	            this.state.saving ? 'Saving…' : 'Save'
	          ),
	          this.state.success && _react2.default.createElement(
	            'button',
	            {
	              onClick: this.goBack,
	              className: _PlaylistEditor2.default.saveButton },
	            'Done'
	          ),
	          playlist && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.savePlaylist,
	                disabled: this.state.checkingForConflicts || this.state.saving || structure.albums.length === 0 || !name,
	                className: _PlaylistEditor2.default.conflictCheckButton },
	              this.getCheckConflictLabel()
	            ),
	            this.state.conflictCheckError && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'small',
	                null,
	                'There was an error checking for conflicts'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_PlaylistMenu2.default, _extends({
	          id: playlist && playlist.id,
	          structure: structure,
	          playlistName: name
	        }, this.props)),
	        editIndex !== null && this.renderEditModal(structure.albums[editIndex], editIndex)
	      );
	    }
	  }]);
	
	  return PlaylistEditor;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var entities = _ref2.entities,
	      albums = _ref2.albums,
	      auth = _ref2.auth,
	      playlists = _ref2.playlists,
	      search = _ref2.search,
	      queues = _ref2.queues,
	      nav = _ref2.nav;
	  var params = _ref3.params;
	  return {
	    entities: entities,
	    search: search,
	    playlist: params.id ? entities.playlists[params.id] : null,
	    error: playlists.error,
	    albums: albums.all.data && albums.all.data.map(function (id) {
	      return entities.albums[id];
	    }),
	    lists: (0, _lists.mapStateToLists)(playlists, entities),
	    isOwner: function isOwner(album) {
	      return album.user_id === auth.user.id;
	    },
	    submitting: playlists.submitting,
	    submitError: playlists.submitError,
	    getImageSource: (0, _images.createImageGetter)(auth),
	    backToQueueEditor: /\/queues\/.+/.test(nav.previousPath),
	    // for PlaylistMenu:
	    fetchChannels: function fetchChannels() {
	      return (0, _fetch.picassoFetch)(auth, 'list_channels').then(function (data) {
	        return data.channels.filter(function (c) {
	          return parseInt(c.owner_id) === auth.user.id;
	        });
	      });
	    },
	    sendToPlayNext: function sendToPlayNext(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'add_playlist', _extends({
	        channel_id: channelID
	      }, body));
	    },
	    sendToPlayNow: function sendToPlayNow(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'play_playlist', _extends({
	        channel_id: channelID
	      }, body));
	    },
	    checkForConflicts: function checkForConflicts(playlist) {
	      return (0, _fetch.picassoFetch)(auth, 'validate_playlist', { playlist_id: playlist.id });
	    },
	    userDefaultLocation: auth.user.location_address || auth.user.location,
	    playlistQueues: queues.data && queues.data.map(function (id) {
	      return entities.queues[id];
	    }).filter(function (queue) {
	      return JSON.parse(queue.json_data).playlists.indexOf(params.id) !== -1;
	    })
	  };
	};
	
	var mapDispatchToProps = {
	  push: _reactRouterRedux.push,
	  fetchAlbums: _albums.fetchAlbums,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  savePlaylist: _playlists.savePlaylist,
	  deletePlaylist: _playlists.deletePlaylist,
	  searchImages: _search.searchImages,
	  showBanner: _banners.showBanner,
	  removeLocationQuery: function removeLocationQuery(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/playlists/' + (id || 'create')));
	    };
	  },
	  // for PlaylistMenu:
	  fetchQueues: _queues.fetchQueues,
	  saveQueue: _queues.saveQueue,
	  presentChannel: function presentChannel(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/present/' + id));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(PlaylistEditor));

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchImage = fetchImage;
	exports.flagImage = flagImage;
	exports.rateImage = rateImage;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FETCH_IMAGE_REQUEST = 'blayzr/image/REQUEST';
	var FETCH_IMAGE_SUCCESS = 'blayzr/image/SUCCESS';
	var FETCH_IMAGE_FAILURE = 'blayzr/image/FAILURE';
	
	var FLAG_IMAGE = 'blayzr/image/FLAG';
	var RATE_IMAGE = 'blayzr/image/RATE';
	
	// No reducer needed because everything is
	// handled by the entities reducer
	
	function fetchImageRequest(id) {
	  return {
	    type: FETCH_IMAGE_REQUEST,
	    payload: { entities: { images: _defineProperty({}, id, {
	          fetching: true,
	          error: null
	        }) } }
	  };
	}
	
	function fetchImageSuccess(id, data) {
	  return {
	    type: FETCH_IMAGE_SUCCESS,
	    payload: { entities: { images: _defineProperty({}, id, _extends({}, data.entities.images[id], {
	          fetching: false
	        })) } }
	  };
	}
	
	function fetchImageFailure(id, error) {
	  return {
	    type: FETCH_IMAGE_FAILURE,
	    payload: { entities: { images: _defineProperty({}, id, {
	          error: error,
	          fetching: false
	        }) } }
	  };
	}
	
	var schema = {
	  records: _fetch.schemas.image
	};
	
	function fetchImage(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_IMAGE.replace(':id', id);
	
	    var _getState = getState(),
	        token = _getState.auth.token;
	
	    dispatch(fetchImageRequest(id));
	    (0, _fetch.fetch)(endpoint, { token: token, schema: schema }, dispatch).then(function (data) {
	      dispatch(fetchImageSuccess(id, data));
	    }, function (e) {
	      dispatch(fetchImageFailure(id, e));
	    });
	  };
	}
	
	function flagImage(id, body) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_FLAG_IMAGE.replace(':id', id);
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: body
	    };
	    dispatch({
	      type: FLAG_IMAGE,
	      payload: { entities: { images: _defineProperty({}, id, {
	            flagged: true
	          }) } }
	    });
	    return (0, _fetch.fetch)(endpoint, options, dispatch);
	  };
	}
	
	function rateImage(id, rating) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_RATE_IMAGE.replace(':id', id).replace(':rating', rating);
	
	    var _getState2 = getState(),
	        token = _getState2.auth.token;
	
	    dispatch({
	      type: RATE_IMAGE,
	      payload: { entities: { images: _defineProperty({}, id, {
	            rated: rating
	          }) } }
	    });
	    return (0, _fetch.fetch)(endpoint, { token: token }, dispatch);
	  };
	}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.librariesRequest = librariesRequest;
	exports.librariesSuccess = librariesSuccess;
	exports.librariesFailure = librariesFailure;
	exports.saveLibraryRequest = saveLibraryRequest;
	exports.saveLibrarySuccess = saveLibrarySuccess;
	exports.saveLibraryFailure = saveLibraryFailure;
	exports.fetchLibraries = fetchLibraries;
	exports.saveLibrary = saveLibrary;
	exports.deleteLibrary = deleteLibrary;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	var LIBRARIES_REQUEST = 'blayzr/libraries/REQUEST';
	var LIBRARIES_SUCCESS = 'blayzr/libraries/SUCCESS';
	var LIBRARIES_FAILURE = 'blayzr/libraries/FAIL';
	
	var SAVE_LIBRARY_REQUEST = 'blayzr/libraries/SAVE_REQUEST';
	var SAVE_LIBRARY_SUCCESS = 'blayzr/libraries/SAVE_SUCCESS';
	var SAVE_LIBRARY_FAILURE = 'blayzr/libraries/SAVE_FAIL';
	
	var DELETE_LIBRARY = 'blayzr/libraries/DELETE';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null,
	  submitting: false,
	  submitError: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  switch (type) {
	    case LIBRARIES_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case LIBRARIES_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload
	      });
	    case LIBRARIES_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    case SAVE_LIBRARY_REQUEST:
	      return _extends({}, state, {
	        submitting: true,
	        submitError: false
	      });
	    case SAVE_LIBRARY_SUCCESS:
	      return _extends({}, state, {
	        submitting: false,
	        data: state.data.map(function (library) {
	          return library.id === meta.id ? _extends({}, library, payload) : library;
	        }).concat(meta.id ? [] : payload)
	      });
	    case SAVE_LIBRARY_FAILURE:
	      return _extends({}, state, {
	        submitting: false,
	        submitError: payload
	      });
	    case DELETE_LIBRARY:
	      if (state.data) {
	        return _extends({}, state, {
	          data: state.data.filter(function (library) {
	            return library.id !== meta.id;
	          })
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	}
	
	function librariesRequest() {
	  return {
	    type: LIBRARIES_REQUEST
	  };
	}
	
	function librariesSuccess(data) {
	  return {
	    type: LIBRARIES_SUCCESS,
	    payload: data
	  };
	}
	
	function librariesFailure(error) {
	  return {
	    type: LIBRARIES_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function saveLibraryRequest(data, id) {
	  return {
	    type: SAVE_LIBRARY_REQUEST,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function saveLibrarySuccess(data, id) {
	  return {
	    type: SAVE_LIBRARY_SUCCESS,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function saveLibraryFailure(error) {
	  return {
	    type: SAVE_LIBRARY_FAILURE,
	    payload: error
	  };
	}
	
	function fetchLibraries() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token
	    };
	    dispatch(librariesRequest());
	    return (0, _fetch.fetch)(_constants.ENDPOINT_LIBRARIES, options, dispatch).then(function (data) {
	      dispatch(librariesSuccess(data.records));
	      return data.records;
	    }, function (e) {
	      dispatch(librariesFailure(e));
	    });
	  };
	}
	
	function saveLibrary(data, id) {
	  return function (dispatch, getState) {
	    var endpoint = id ? _constants.ENDPOINT_LIBRARY.replace(':id', id) : _constants.ENDPOINT_NEW_LIBRARY;
	    var options = {
	      method: 'post',
	      token: getState().auth.token,
	      body: _extends({}, data, { id: id })
	    };
	    dispatch(saveLibraryRequest(data, id));
	    return (0, _fetch.fetch)(endpoint, options, dispatch).then(function (data) {
	      dispatch(saveLibrarySuccess(data.records, id));
	    }, function (e) {
	      dispatch(saveLibraryFailure(e));
	    });
	  };
	}
	
	function deleteLibrary(id) {
	  return function (dispatch, getState) {
	    var endpoint = _constants.ENDPOINT_LIBRARY.replace(':id', id);
	    (0, _fetch.fetch)(endpoint, {
	      method: 'delete',
	      token: getState().auth.token
	    });
	    dispatch({
	      type: DELETE_LIBRARY,
	      meta: { id: id }
	    });
	  };
	}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.closeModal = exports.openModal = exports.DOWNLOAD_IMAGES_MODAL_KEY = exports.SAVE_ALBUM_MODAL_KEY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MODAL_OPEN = 'blayzr/modals/OPEN';
	var MODAL_CLOSE = 'blayzr/modals/CLOSE';
	
	var SAVE_ALBUM_MODAL_KEY = exports.SAVE_ALBUM_MODAL_KEY = 'SAVE_ALBUM';
	var DOWNLOAD_IMAGES_MODAL_KEY = exports.DOWNLOAD_IMAGES_MODAL_KEY = 'DOWNLOAD_IMAGES';
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      meta = action.meta;
	
	  switch (type) {
	    case MODAL_OPEN:
	      return _extends({}, state, _defineProperty({}, meta.key, true));
	    case MODAL_CLOSE:
	      return _extends({}, state, _defineProperty({}, meta.key, false));
	    case _reactRouterRedux.LOCATION_CHANGE:
	      return {};
	    default:
	      return state;
	  }
	}
	
	var openModal = exports.openModal = function openModal(key) {
	  return {
	    type: MODAL_OPEN,
	    meta: { key: key }
	  };
	};
	
	var closeModal = exports.closeModal = function closeModal(key) {
	  return {
	    type: MODAL_CLOSE,
	    meta: { key: key }
	  };
	};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.guideSort = guideSort;
	exports.shuffle = shuffle;
	// Sort images using a given array as a guide
	function guideSort(guide, key) {
	  return function (a, b) {
	    a = key ? a[key] : a;
	    b = key ? b[key] : b;
	    var indexA = guide.indexOf(a);
	    var indexB = guide.indexOf(b);
	    if (indexA !== -1 && indexB === -1) return -1;
	    if (indexA === -1 && indexB !== -1) return 1;
	    if (indexA < indexB) return -1;
	    if (indexA > indexB) return 1;
	    return 0;
	  };
	}
	
	// http://stackoverflow.com/a/6274381
	function shuffle(a) {
	  var j = void 0,
	      x = void 0,
	      i = void 0;
	  for (i = a.length; i; i--) {
	    j = Math.floor(Math.random() * i);
	    x = a[i - 1];
	    a[i - 1] = a[j];
	    a[j] = x;
	  }
	  return a;
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(166)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(97);
	var toLength = __webpack_require__(21);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(584);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(27);
	var createDesc = __webpack_require__(94);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(18)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var setPrototypeOf = __webpack_require__(231).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(111);
	var ITERATOR = __webpack_require__(18)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(91);
	var descriptor = __webpack_require__(94);
	var setToStringTag = __webpack_require__(112);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(36)(IteratorPrototype, __webpack_require__(18)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(80);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(37);
	var hide = __webpack_require__(36);
	var Iterators = __webpack_require__(111);
	var $iterCreate = __webpack_require__(224);
	var setToStringTag = __webpack_require__(112);
	var getPrototypeOf = __webpack_require__(46);
	var ITERATOR = __webpack_require__(18)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(236).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(51)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(33);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(130);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(12);
	var anObject = __webpack_require__(6);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(53)(Function.call, __webpack_require__(45).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(133)('keys');
	var uid = __webpack_require__(98);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(159);
	var defined = __webpack_require__(61);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(55);
	var defined = __webpack_require__(61);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(53);
	var invoke = __webpack_require__(325);
	var html = __webpack_require__(221);
	var cel = __webpack_require__(218);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(51)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(24);
	var LIBRARY = __webpack_require__(80);
	var $typed = __webpack_require__(167);
	var hide = __webpack_require__(36);
	var redefineAll = __webpack_require__(95);
	var fails = __webpack_require__(11);
	var anInstance = __webpack_require__(89);
	var toInteger = __webpack_require__(55);
	var toLength = __webpack_require__(21);
	var toIndex = __webpack_require__(344);
	var gOPN = __webpack_require__(92).f;
	var dP = __webpack_require__(27).f;
	var arrayFill = __webpack_require__(215);
	var setToStringTag = __webpack_require__(112);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(52);
	var LIBRARY = __webpack_require__(80);
	var wksExt = __webpack_require__(345);
	var defineProperty = __webpack_require__(27).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(110);
	var ITERATOR = __webpack_require__(18)('iterator');
	var Iterators = __webpack_require__(111);
	module.exports = __webpack_require__(52).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(79);
	var step = __webpack_require__(328);
	var Iterators = __webpack_require__(111);
	var toIObject = __webpack_require__(47);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(225)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"arrangerContainer":"_1_JDM","scene":"_2hzFM","player":"h6atc","inactive":"fU3PI","selected":"_2XNVh","spawner":"Du-Xx","spawnAngle":"_2-Dx_","spawnBreadth":"_1O2gM","arrangerMenu":"RupFn","numberInput":"FH00N"};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form":"_2L1JM","advancedInput":"_2l2gR","label":"_12JIE","numberInput":"_2gsMC","note":"McHty"};

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"saveButton":"_3pjKy","page":"_1YR2-","note":"_28IR0","noteOld":"_2NNUf","noteNew":"_1yYsz _2NNUf","selectedExample":"_10QT6","excludedExample":"-WHXt","header":"_3ektf","headerNode":"_2VjBL","headerNodeEmpty":"Jn_ks _2VjBL","headerNodeHeading":"_3P4vP","deleteButton":"_2GqZR _3pjKy","resetButton":"_2mK59 _3pjKy","error":"_3y7g-","disabled":"_9cd1N"};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(115);
	
	var _DOMUtils = __webpack_require__(175);
	
	var _DOMStateStorage = __webpack_require__(246);
	
	var _PathUtils = __webpack_require__(82);
	
	var _ExecutionEnvironment = __webpack_require__(247);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(890);
	
	var _PathUtils = __webpack_require__(82);
	
	var _runTransitionHook = __webpack_require__(249);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(174);
	
	var _LocationUtils = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var external = __webpack_require__(136);
	var DataWorker = __webpack_require__(378);
	var DataLengthProbe = __webpack_require__(377);
	var Crc32Probe = __webpack_require__(376);
	var DataLengthProbe = __webpack_require__(377);
	
	/**
	 * Represent a compressed object, with everything needed to decompress it.
	 * @constructor
	 * @param {number} compressedSize the size of the data compressed.
	 * @param {number} uncompressedSize the size of the data after decompression.
	 * @param {number} crc32 the crc32 of the decompressed file.
	 * @param {object} compression the type of compression, see lib/compressions.js.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
	 */
	function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
	    this.compressedSize = compressedSize;
	    this.uncompressedSize = uncompressedSize;
	    this.crc32 = crc32;
	    this.compression = compression;
	    this.compressedContent = data;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Create a worker to get the uncompressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getContentWorker : function () {
	        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
	        .pipe(this.compression.uncompressWorker())
	        .pipe(new DataLengthProbe("data_length"));
	
	        var that = this;
	        worker.on("end", function () {
	            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	        });
	        return worker;
	    },
	    /**
	     * Create a worker to get the compressed content.
	     * @return {GenericWorker} the worker.
	     */
	    getCompressedWorker : function () {
	        return new DataWorker(external.Promise.resolve(this.compressedContent))
	        .withStreamInfo("compressedSize", this.compressedSize)
	        .withStreamInfo("uncompressedSize", this.uncompressedSize)
	        .withStreamInfo("crc32", this.crc32)
	        .withStreamInfo("compression", this.compression)
	        ;
	    }
	};
	
	/**
	 * Chain the given worker with other workers to compress the content with the
	 * given compression.
	 * @param {GenericWorker} uncompressedWorker the worker to pipe.
	 * @param {Object} compression the compression object.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {GenericWorker} the new worker compressing the content.
	 */
	CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
	    return uncompressedWorker
	    .pipe(new Crc32Probe())
	    .pipe(new DataLengthProbe("uncompressedSize"))
	    .pipe(compression.compressWorker(compressionOptions))
	    .pipe(new DataLengthProbe("compressedSize"))
	    .withStreamInfo("compression", compression);
	};
	
	module.exports = CompressedObject;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	
	/**
	 * The following functions come from pako, from pako/lib/zlib/crc32.js
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	    var c, table = [];
	
	    for(var n =0; n < 256; n++){
	        c = n;
	        for(var k =0; k < 8; k++){
	            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	        }
	        table[n] = c;
	    }
	
	    return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	// That's all for the pako functions.
	
	/**
	 * Compute the crc32 of a string.
	 * This is almost the same as the function crc32, but for strings. Using the
	 * same function for the two use cases leads to horrible performances.
	 * @param {Number} crc the starting value of the crc.
	 * @param {String} str the string to use.
	 * @param {Number} len the length of the string.
	 * @param {Number} pos the starting position for the crc32 computation.
	 * @return {Number} the computed crc32.
	 */
	function crc32str(crc, str, len, pos) {
	    var t = crcTable, end = pos + len;
	
	    crc = crc ^ (-1);
	
	    for (var i = pos; i < end; i++ ) {
	        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
	    }
	
	    return (crc ^ (-1)); // >>> 0;
	}
	
	module.exports = function crc32wrapper(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if(isArray) {
	        return crc32(crc|0, input, input.length, 0);
	    } else {
	        return crc32str(crc|0, input, input.length, 0);
	    }
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(258),
	    baseLodash = __webpack_require__(259);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(992),
	    mapCacheDelete = __webpack_require__(993),
	    mapCacheGet = __webpack_require__(994),
	    mapCacheHas = __webpack_require__(995),
	    mapCacheSet = __webpack_require__(996);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(64);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(140);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(939),
	    isObjectLike = __webpack_require__(72);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(418),
	    isLength = __webpack_require__(265);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(930),
	    baseKeys = __webpack_require__(946),
	    isArrayLike = __webpack_require__(264);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(931),
	    baseForOwn = __webpack_require__(390),
	    baseIteratee = __webpack_require__(392);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(954);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(173);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(119);
	var Danger = __webpack_require__(1061);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactInstrumentation = __webpack_require__(58);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(280);
	var setInnerHTML = __webpack_require__(193);
	var setTextContent = __webpack_require__(451);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactErrorUtils = __webpack_require__(278);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactPropTypesSecret = __webpack_require__(1090);
	var propTypesFactory = __webpack_require__(428);
	
	var React = __webpack_require__(124);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactInstrumentation = __webpack_require__(58);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(15);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(32), __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['react-dom', 'react'], factory) :
		(global.ReactDraggable = factory(global.ReactDOM,global.React));
	}(this, (function (ReactDOM,React) { 'use strict';
	
		ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
		React = React && React.hasOwnProperty('default') ? React['default'] : React;
	
		function createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		var emptyFunction_1 = emptyFunction;
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		{
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		var invariant_1 = invariant;
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction_1;
	
		{
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
	
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
	
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
	
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
	
		var warning_1 = warning;
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
		{
		  var invariant$1 = invariant_1;
		  var warning$1 = warning_1;
		  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
		        } catch (ex) {
		          error = ex;
		        }
		        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		var checkPropTypes_1 = checkPropTypes;
	
		var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret_1) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant_1(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if ("development" !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning_1(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
		      return emptyFunction_1.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
		      return emptyFunction_1.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning_1(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction_1.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = objectAssign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
	
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes_1;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
		var propTypes = createCommonjsModule(function (module) {
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
	
		{
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
		}
		});
	
		var classnames = createCommonjsModule(function (module) {
		/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
	
		(function () {
	
			var hasOwn = {}.hasOwnProperty;
	
			function classNames () {
				var classes = [];
	
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
	
					var argType = typeof arg;
	
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
	
				return classes.join(' ');
			}
	
			if ('object' !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (false) {
				// register as 'classnames', consistent with npm package name
				undefined('classnames', [], function () {
					return classNames;
				});
			} else {
				window.classNames = classNames;
			}
		}());
		});
	
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
	
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
	
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
	
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
	
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
	
		  var style = window.document.documentElement.style;
	
		  if (prop in style) return '';
	
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
	
		  return '';
		}
	
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
	
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
	
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		var browserPrefix = getPrefix();
	
		var classCallCheck = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
		var createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];
		      descriptor.enumerable = descriptor.enumerable || false;
		      descriptor.configurable = true;
		      if ("value" in descriptor) descriptor.writable = true;
		      Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }
	
		  return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);
		    if (staticProps) defineProperties(Constructor, staticProps);
		    return Constructor;
		  };
		}();
	
		var defineProperty = function (obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, {
		      value: value,
		      enumerable: true,
		      configurable: true,
		      writable: true
		    });
		  } else {
		    obj[key] = value;
		  }
	
		  return obj;
		};
	
		var _extends = Object.assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];
	
		    for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  return target;
		};
	
		var inherits = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		  }
	
		  subClass.prototype = Object.create(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
		var possibleConstructorReturn = function (self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && (typeof call === "object" || typeof call === "function") ? call : self;
		};
	
		var slicedToArray = function () {
		  function sliceIterator(arr, i) {
		    var _arr = [];
		    var _n = true;
		    var _d = false;
		    var _e = undefined;
	
		    try {
		      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
		        _arr.push(_s.value);
	
		        if (i && _arr.length === i) break;
		      }
		    } catch (err) {
		      _d = true;
		      _e = err;
		    } finally {
		      try {
		        if (!_n && _i["return"]) _i["return"]();
		      } finally {
		        if (_d) throw _e;
		      }
		    }
	
		    return _arr;
		  }
	
		  return function (arr, i) {
		    if (Array.isArray(arr)) {
		      return arr;
		    } else if (Symbol.iterator in Object(arr)) {
		      return sliceIterator(arr, i);
		    } else {
		      throw new TypeError("Invalid attempt to destructure non-iterable instance");
		    }
		  };
		}();
	
		/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/
	
	
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = findInArray(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return isFunction(el[method]);
		    });
		  }
	
		  // Might not be found entirely (not an Element?) - in that case, bail
		  // $FlowIgnore: Doesn't think elements are indexable
		  if (!isFunction(el[matchesSelectorFunc])) return false;
	
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc](selector);
		}
	
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
	
		  return false;
		}
	
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
	
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
	
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += int(computedStyle.borderTopWidth);
		  height += int(computedStyle.borderBottomWidth);
		  return height;
		}
	
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += int(computedStyle.borderLeftWidth);
		  width += int(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= int(computedStyle.paddingTop);
		  height -= int(computedStyle.paddingBottom);
		  return height;
		}
	
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= int(computedStyle.paddingLeft);
		  width -= int(computedStyle.paddingRight);
		  return width;
		}
	
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
	
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
	
		  return { x: x, y: y };
		}
	
		function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/ {
		  var translation = getTranslation(controlPos, positionOffset, 'px');
		  return defineProperty({}, browserPrefixToKey('transform', browserPrefix), translation);
		}
	
		function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/ {
		  var translation = getTranslation(controlPos, positionOffset, '');
		  return translation;
		}
		function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/ {
		  var x = _ref2.x,
		      y = _ref2.y;
	
		  var translation = 'translate(' + x + unitSuffix + ',' + y + unitSuffix + ')';
		  if (positionOffset) {
		    var defaultX = '' + (typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
		    var defaultY = '' + (typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
		    translation = 'translate(' + defaultX + ', ' + defaultY + ')' + translation;
		  }
		  return translation;
		}
	
		function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && findInArray(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && findInArray(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
	
		function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
	
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
	
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(doc /*: ?Document*/) {
		  if (!doc) return;
		  var styleEl = doc.getElementById('react-draggable-style-el');
		  if (!styleEl) {
		    styleEl = doc.createElement('style');
		    styleEl.type = 'text/css';
		    styleEl.id = 'react-draggable-style-el';
		    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
		    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
		    doc.getElementsByTagName('head')[0].appendChild(styleEl);
		  }
		  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
		}
	
		function removeUserSelectStyles(doc /*: ?Document*/) {
		  try {
		    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
		    // $FlowIgnore: IE
		    if (doc.selection) {
		      // $FlowIgnore: IE
		      doc.selection.empty();
		    } else {
		      window.getSelection().removeAllRanges(); // remove selection caused by scroll
		    }
		  } catch (e) {
		    // probably IE
		  }
		}
	
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
		function addClassName(el /*: HTMLElement*/, className /*: string*/) {
		  if (el.classList) {
		    el.classList.add(className);
		  } else {
		    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
		      el.className += ' ' + className;
		    }
		  }
		}
	
		function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
		  if (el.classList) {
		    el.classList.remove(className);
		  } else {
		    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
		  }
		}
	
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
	
	
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
	
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
	
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = findDOMNode(draggable);
	
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
	
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		    }
		    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
		      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
		      top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
		      right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
		      bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
		    };
		  }
	
		  // Keep x and y below right and bottom limits...
		  if (isNum(bounds.right)) x = Math.min(x, bounds.right);
		  if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
	
		  // But above left and top limits.
		  if (isNum(bounds.left)) x = Math.max(x, bounds.left);
		  if (isNum(bounds.top)) y = Math.max(y, bounds.top);
	
		  return [x, y];
		}
	
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
	
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
	
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
	
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return offsetXYFromParent(touchObj || e, offsetParent);
		}
	
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  var state = draggable.state;
		  var isStart = !isNum(state.lastX);
		  var node = findDOMNode(draggable);
	
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: node,
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: node,
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
	
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  var scale = draggable.props.scale;
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX / scale,
		    y: draggable.state.y + coreData.deltaY / scale,
		    deltaX: coreData.deltaX / scale,
		    deltaY: coreData.deltaY / scale,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
	
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
		function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
		  var node = ReactDOM.findDOMNode(draggable);
		  if (!node) {
		    throw new Error('<DraggableCore>: Unmounted during event!');
		  }
		  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
		  return node;
		}
	
		/*eslint no-console:0*/
		function log() {
		}
	
		/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/
	
	
		// Simple abstraction for dragging events names.
		/*:: import type {Element as ReactElement} from 'react';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
	
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
	
		/*:: type DraggableCoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		/*:: export type DraggableBounds = {
		  left: number,
		  right: number,
		  top: number,
		  bottom: number,
		};*/
		/*:: export type DraggableData = {
		  node: HTMLElement,
		  x: number, y: number,
		  deltaX: number, deltaY: number,
		  lastX: number, lastY: number,
		};*/
		/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
		/*:: export type ControlPosition = {x: number, y: number};*/
		/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
	
		/*:: export type DraggableCoreProps = {
		  allowAnyClick: boolean,
		  cancel: string,
		  children: ReactElement<any>,
		  disabled: boolean,
		  enableUserSelectHack: boolean,
		  offsetParent: HTMLElement,
		  grid: [number, number],
		  handle: string,
		  onStart: DraggableEventHandler,
		  onDrag: DraggableEventHandler,
		  onStop: DraggableEventHandler,
		  onMouseDown: (e: MouseEvent) => void,
		};*/
	
		var DraggableCore = function (_React$Component) {
		  inherits(DraggableCore, _React$Component);
	
		  function DraggableCore() {
		    var _ref;
	
		    var _temp, _this, _ret;
	
		    classCallCheck(this, DraggableCore);
	
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
	
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
	
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var thisNode = ReactDOM.findDOMNode(_this);
		      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
		        throw new Error('<DraggableCore> not mounted on DragStart!');
		      }
		      var ownerDocument = thisNode.ownerDocument;
	
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) {
		        return;
		      }
	
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = getTouchIdentifier(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
	
		      // Get the current drag point from the event. This is used as the offset.
		      var position = getControlPosition(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x,
		          y = position.y;
	
		      // Create an event object with all the data parents need to make a decision here.
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      // Call event handler. If it returns explicit false, cancel.
		      log('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
	
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);
	
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
	
		        lastX: x,
		        lastY: y
		      });
	
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
		      addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
	
		      // Prevent scrolling on mobile devices, like ipad/iphone.
		      if (e.type === 'touchmove') e.preventDefault();
	
		      // Get the current drag point from the event. This is used as the offset.
		      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
	
		      // Snap to grid if prop has been provided
	
		      if (Array.isArray(_this.props.grid)) {
		        var _deltaX = x - _this.state.lastX,
		            _deltaY = y - _this.state.lastY;
	
		        var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);
	
		        var _snapToGrid2 = slicedToArray(_snapToGrid, 2);
	
		        _deltaX = _snapToGrid2[0];
		        _deltaY = _snapToGrid2[1];
	
		        if (!_deltaX && !_deltaY) return; // skip useless drag
		        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
		      }
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          // $FlowIgnore
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
	
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
	
		      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
	
		      var coreEvent = createCoreData(_this, x, y);
	
		      var thisNode = ReactDOM.findDOMNode(_this);
		      if (thisNode) {
		        // Remove user-select hack
		        if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
		      }
	
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
	
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
	
		      if (thisNode) {
		        removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
		        removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
		      }
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
	
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
	
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
	
		      return _this.handleDragStop(e);
		    }, _temp), possibleConstructorReturn(_this, _ret);
		  }
	
		  createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		      var thisNode = ReactDOM.findDOMNode(this);
		      if (thisNode) {
		        var ownerDocument = thisNode.ownerDocument;
	
		        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
		        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
		      }
		    }
	
		    // Same as onMouseDown (start drag), but now consider this a touch device.
	
		  }, {
		    key: 'render',
		    value: function render() {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return React.cloneElement(React.Children.only(this.props.children), {
		        style: styleHacks(this.props.children.props.style),
	
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		  return DraggableCore;
		}(React.Component);
	
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: propTypes.bool,
	
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: propTypes.bool,
	
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: propTypes.bool,
	
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
		    if (props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
	
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: propTypes.arrayOf(propTypes.number),
	
		  /**
		   * `scale` specifies the scale of the area you are dragging inside of. It allows
		   * the drag deltas to scale correctly with how far zoomed in/out you are.
		   */
		  scale: propTypes.number,
	
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: propTypes.string,
	
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: propTypes.string,
	
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: propTypes.func,
	
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: propTypes.func,
	
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: propTypes.func,
	
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: propTypes.func,
	
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: dontSetMe,
		  style: dontSetMe,
		  transform: dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
	
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: import type {Element as ReactElement} from 'react';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
	
	
		//
		// Define <Draggable>
		//
	
		/*:: export type DraggableProps = {
		  ...$Exact<DraggableCoreProps>,
		  axis: 'both' | 'x' | 'y' | 'none',
		  bounds: DraggableBounds | string | false,
		  defaultClassName: string,
		  defaultClassNameDragging: string,
		  defaultClassNameDragged: string,
		  defaultPosition: ControlPosition,
		  positionOffset: PositionOffsetControlPosition,
		  position: ControlPosition,
		  scale: number
		};*/
	
		var Draggable = function (_React$Component) {
		  inherits(Draggable, _React$Component);
	
		  function Draggable(props /*: DraggableProps*/) {
		    classCallCheck(this, Draggable);
	
		    var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
	
		    _this.onDragStart = function (e, coreData) {
	
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
	
		      _this.setState({ dragging: true, dragged: true });
		    };
	
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
	
		      var uiData = createDraggableData(_this, coreData);
	
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
	
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x,
		            _y = newState.y;
	
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
	
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
	
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
	
		        var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y),
		            _getBoundPosition2 = slicedToArray(_getBoundPosition, 2),
		            newStateX = _getBoundPosition2[0],
		            newStateY = _getBoundPosition2[1];
	
		        newState.x = newStateX;
		        newState.y = newStateY;
	
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
	
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = newState.x;
		        uiData.y = newState.y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
	
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
	
		      _this.setState(newState);
		    };
	
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
	
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
		      if (shouldStop === false) return false;
	
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
	
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position,
		            _x2 = _this$props$position.x,
		            _y2 = _this$props$position.y;
	
		        newState.x = _x2;
		        newState.y = _y2;
		      }
	
		      _this.setState(newState);
		    };
	
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
	
		      // Whether or not we have been dragged before.
		      dragged: false,
	
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
	
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
	
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
	
		    if (props.position && !(props.onDrag || props.onStop)) {
		      // eslint-disable-next-line no-console
		      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		    }
		    return _this;
		  }
	
		  createClass(Draggable, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof window.SVGElement !== 'undefined' && ReactDOM.findDOMNode(this) instanceof window.SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() /*: ReactElement<any>*/ {
		      var _classNames;
	
		      var style = {},
		          svgTransform = null;
	
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
	
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: canDragX(this) && draggable ? this.state.x : position.x,
	
		        // Set top if vertical drag is enabled
		        y: canDragY(this) && draggable ? this.state.y : position.y
		      };
	
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = createCSSTransform(transformOpts, this.props.positionOffset);
		      }
	
		      var _props = this.props,
		          defaultClassName = _props.defaultClassName,
		          defaultClassNameDragging = _props.defaultClassNameDragging,
		          defaultClassNameDragged = _props.defaultClassNameDragged;
	
	
		      var children = React.Children.only(this.props.children);
	
		      // Mark with class while dragging
		      var className = classnames(children.props.className || '', defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
	
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return React.createElement(
		        DraggableCore,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        React.cloneElement(children, {
		          className: className,
		          style: _extends({}, children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		  return Draggable;
		}(React.Component);
	
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, DraggableCore.propTypes, {
	
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: propTypes.oneOf(['both', 'x', 'y', 'none']),
	
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: propTypes.oneOfType([propTypes.shape({
		    left: propTypes.number,
		    right: propTypes.number,
		    top: propTypes.number,
		    bottom: propTypes.number
		  }), propTypes.string, propTypes.oneOf([false])]),
	
		  defaultClassName: propTypes.string,
		  defaultClassNameDragging: propTypes.string,
		  defaultClassNameDragged: propTypes.string,
	
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: propTypes.shape({
		    x: propTypes.number,
		    y: propTypes.number
		  }),
		  positionOffset: propTypes.shape({
		    x: propTypes.oneOfType([propTypes.number, propTypes.string]),
		    y: propTypes.oneOfType([propTypes.number, propTypes.string])
		  }),
	
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: propTypes.shape({
		    x: propTypes.number,
		    y: propTypes.number
		  }),
	
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: dontSetMe,
		  style: dontSetMe,
		  transform: dontSetMe
		});
		Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null,
		  scale: 1
		});
	
		// Previous versions of this lib exported <Draggable> as the root export. As to not break
		// them, or TypeScript, we export *both* as the root and as 'default'.
		// See https://github.com/mzabriskie/react-draggable/pull/254
		// and https://github.com/mzabriskie/react-draggable/issues/266
		Draggable.default = Draggable;
		Draggable.DraggableCore = DraggableCore;
	
		return Draggable;
	
	})));
	//# sourceMappingURL=react-draggable.js.map


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(22);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(194);
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _getRouteParams = __webpack_require__(1156);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(290);
	
	var _RouteUtils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Channel = exports.StickyContainer = exports.Sticky = undefined;
	
	var _sticky = __webpack_require__(1163);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(1162);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _channel = __webpack_require__(468);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _sticky2.default;
	exports.StickyContainer = _container2.default;
	exports.Channel = _channel2.default;
	exports.default = _sticky2.default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(188);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(135));
	util.inherits = __webpack_require__(116);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1250)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(480);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(196).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(479);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118), __webpack_require__(495).setImmediate, (function() { return this; }())))

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(477);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(294);
	exports.Duplex = __webpack_require__(105);
	exports.Transform = __webpack_require__(478);
	exports.PassThrough = __webpack_require__(1185);


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ARRAY_INSERT = exports.ARRAY_INSERT = 'redux-form/ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = 'redux-form/ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = 'redux-form/ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = 'redux-form/ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = 'redux-form/ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = 'redux-form/ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = 'redux-form/ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = 'redux-form/ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = 'redux-form/ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = 'redux-form/ARRAY_SWAP';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = 'redux-form/REGISTER_FIELD';
	var RESET = exports.RESET = 'redux-form/RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = 'redux-form/SET_SUBMIT_FAILED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = 'redux-form/UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactOnclickoutside = __webpack_require__(195);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _GenericAutocomplete = __webpack_require__(802);
	
	var _GenericAutocomplete2 = _interopRequireDefault(_GenericAutocomplete);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GenericAutocomplete = function (_Component) {
	  _inherits(GenericAutocomplete, _Component);
	
	  function GenericAutocomplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GenericAutocomplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GenericAutocomplete.__proto__ || Object.getPrototypeOf(GenericAutocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showSuggestions: false,
	      selected: -1
	    }, _this.onKeyDown = function (e) {
	      e.preventDefault();
	      _this.setState({ selected: _this.state.selected + 1 });
	    }, _this.onKeyUp = function (e) {
	      e.preventDefault();
	      if (_this.state.selected === 0) {
	        _this.refs.input.focus();
	      }
	      _this.setState({ selected: Math.max(-1, _this.state.selected - 1) });
	    }, _this.handleClickOutside = function () {
	      _this.setState({
	        showSuggestions: false,
	        selected: -1
	      });
	    }, _this.selectSuggestion = function (item) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSelect = _this$props.onSelect;
	
	      if (onSelect) {
	        onSelect(item);
	      } else {
	        onChange(item);
	      }
	      _this.setState({
	        showSuggestions: false,
	        selected: -1
	      });
	    }, _this.showSuggestions = function () {
	      _this.setState({
	        showSuggestions: true
	      });
	    }, _this.clearSearch = function () {
	      _this.props.onChange('');
	      _this.refs.input.focus();
	    }, _this.onChangeText = function (e) {
	      _this.props.onChange(e.target.value);
	      _this.setState({
	        selected: -1
	      });
	    }, _this.renderSuggestion = function (item) {
	      return _react2.default.createElement(
	        'li',
	        { key: item.id, className: _GenericAutocomplete2.default.autoCompleteItem },
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return _this.selectSuggestion(item);
	            }, className: _GenericAutocomplete2.default.autoCompleteButton },
	          item.value || item.keyword
	        )
	      );
	    }, _this.renderSuggestions = function () {
	      var _this$props2 = _this.props,
	          value = _this$props2.value,
	          suggestions = _this$props2.suggestions,
	          limit = _this$props2.limit;
	
	
	      var groups = suggestions.map(function (group) {
	        return {
	          title: group.title,
	          items: group.items.filter(function (item) {
	            return (0, _string.matchString)(value, item.value || item.keyword, true);
	          }).slice(0, limit)
	        };
	      });
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _GenericAutocomplete2.default.autoComplete },
	        groups.map(function (group) {
	          if (group.items.length === 0) {
	            return null;
	          }
	          return [_react2.default.createElement(
	            'li',
	            { key: 'heading', className: _GenericAutocomplete2.default.autoCompleteHeading },
	            group.title
	          ), group.items.map(_this.renderSuggestion)];
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GenericAutocomplete, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.node = (0, _reactDom.findDOMNode)(this);
	      _mousetrap2.default.bind('up', this.onKeyUp);
	      _mousetrap2.default.bind('down', this.onKeyDown);
	      _mousetrap2.default.bind('escape', function () {
	        _this2.clearSearch();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var selected = this.state.selected;
	
	      if (prevState.selected !== selected) {
	        var button = this.node.querySelectorAll('.' + _GenericAutocomplete2.default.autoCompleteButton)[selected];
	        button && button.focus();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _mousetrap2.default.unbind(['up', 'down', 'escape']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          minLength = _props.minLength;
	      var showSuggestions = this.state.showSuggestions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _GenericAutocomplete2.default.wrapper, style: this.props.style },
	        _react2.default.createElement('input', {
	          type: 'text',
	          ref: 'input',
	          value: value,
	          onChange: this.onChangeText,
	          onFocus: this.showSuggestions,
	          className: 'mousetrap ' + _GenericAutocomplete2.default.input,
	          placeholder: placeholder
	        }),
	        value !== '' && _react2.default.createElement(
	          'button',
	          { onClick: this.clearSearch, className: _GenericAutocomplete2.default.clearButton },
	          _react2.default.createElement(_Icon2.default, { icon: 'close' })
	        ),
	        showSuggestions && value.length >= minLength && this.renderSuggestions()
	      );
	    }
	  }]);
	
	  return GenericAutocomplete;
	}(_react.Component);
	
	GenericAutocomplete.defaultProps = {
	  limit: 20,
	  minLength: 2
	};
	exports.default = (0, _reactOnclickoutside2.default)(GenericAutocomplete);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeywordList = __webpack_require__(804);
	
	var _KeywordList2 = _interopRequireDefault(_KeywordList);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeywordList = function (_Component) {
	  _inherits(KeywordList, _Component);
	
	  function KeywordList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, KeywordList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KeywordList.__proto__ || Object.getPrototypeOf(KeywordList)).call.apply(_ref, [this].concat(args))), _this), _this.initialLimit = window.innerWidth < _constants.MOBILE_BREAKPOINT ? 10 : 40, _this.state = {
	      limit: _this.initialLimit
	    }, _this.toggleLimit = function () {
	      var keywords = _this.props.keywords;
	      var limit = _this.state.limit;
	
	      if (limit === keywords.length) {
	        _this.setState({
	          limit: _this.initialLimit
	        });
	      } else {
	        _this.setState({
	          limit: keywords.length
	        });
	      }
	    }, _this.renderKeyword = function (keyword, index) {
	      var _this$props = _this.props,
	          onClickKeyword = _this$props.onClickKeyword,
	          maxCount = _this$props.maxCount,
	          r = _this$props.r,
	          g = _this$props.g,
	          b = _this$props.b;
	
	      var string = (typeof keyword === 'undefined' ? 'undefined' : _typeof(keyword)) === 'object' ? keyword.name || keyword.key : keyword;
	      var onClick = onClickKeyword ? function () {
	        return onClickKeyword(string, index);
	      } : null;
	      var className = onClickKeyword ? _KeywordList2.default.keywordClickable : _KeywordList2.default.keyword;
	      var opacity = 0.6;
	      if (keyword.doc_count && maxCount && maxCount !== 1) {
	        opacity = 0.2 + Math.log(keyword.doc_count) / Math.log(maxCount) * 0.9;
	      }
	      var backgroundColor = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
	      return _react2.default.createElement(
	        'li',
	        { key: string, className: className, onClick: onClick, style: { backgroundColor: backgroundColor } },
	        string
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(KeywordList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          keywords = _props.keywords,
	          r = _props.r,
	          g = _props.g,
	          b = _props.b;
	      var limit = this.state.limit;
	
	      if (!keywords || keywords.length === 0) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'ul',
	        { className: _KeywordList2.default.list },
	        keywords.slice(0, limit).map(this.renderKeyword),
	        keywords.length > this.initialLimit && _react2.default.createElement(
	          'button',
	          { className: _KeywordList2.default.button, onClick: this.toggleLimit, style: { backgroundColor: 'rgb(' + r + ', ' + g + ', ' + b + ')' } },
	          keywords.length > limit ? '+' + (keywords.length - limit) : '-' + (keywords.length - this.initialLimit)
	        )
	      );
	    }
	  }]);
	
	  return KeywordList;
	}(_react.Component);
	
	exports.default = KeywordList;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimezonePicker(props) {
	  var DEFAULT_TIMEZONE = '0';
	  var primaryValue = /^-?\d+$/.test(props.value) ? DEFAULT_TIMEZONE : props.value;
	  var customValue = props.value === 'custom' ? DEFAULT_TIMEZONE : props.value;
	  var deviceTimezone = new Date().toString().slice(-14, -6).replace('+0000', '');
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      null,
	      typeof props.label !== 'undefined' ? props.label : 'Timezone',
	      _react2.default.createElement(
	        'select',
	        { value: primaryValue, onChange: props.onChange },
	        _react2.default.createElement(
	          'option',
	          { value: 'device' },
	          'Set by viewing device (',
	          deviceTimezone,
	          ')'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 'default' },
	          'User default (',
	          props.user && props.user.timezone,
	          ')'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '0' },
	          'Custom timezone'
	        )
	      )
	    ),
	    primaryValue === DEFAULT_TIMEZONE && _react2.default.createElement(
	      'label',
	      null,
	      _react2.default.createElement(
	        'select',
	        { value: customValue, onChange: props.onChange },
	        _react2.default.createElement(
	          'option',
	          { value: '-43200' },
	          '(GMT -12:00) Eniwetok, Kwajalein'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-39600' },
	          '(GMT -11:00) Midway Island, Samoa'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-36000' },
	          '(GMT -10:00) Hawaii'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-32400' },
	          '(GMT -9:00) Alaska'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-28800' },
	          '(GMT -8:00) Pacific Time (US & Canada)'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-25200' },
	          '(GMT -7:00) Mountain Time (US & Canada)'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-21600' },
	          '(GMT -6:00) Central Time (US & Canada), Mexico City'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-18000' },
	          '(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-14400' },
	          '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-12600' },
	          '(GMT -3:30) Newfoundland'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-10800' },
	          '(GMT -3:00) Brazil, Buenos Aires, Georgetown'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-7200' },
	          '(GMT -2:00) Mid-Atlantic'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '-3600' },
	          '(GMT -1:00 hour) Azores, Cape Verde Islands'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '0' },
	          '(GMT) Western Europe Time, London, Lisbon, Casablanca'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '3600' },
	          '(GMT +1:00 hour) Brussels, Copenhagen, Madrid, Paris'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '7200' },
	          '(GMT +2:00) Kaliningrad, South Africa'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '10800' },
	          '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '12600' },
	          '(GMT +3:30) Tehran'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '14400' },
	          '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '16200' },
	          '(GMT +4:30) Kabul'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '18000' },
	          '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '19800' },
	          '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '20700' },
	          '(GMT +5:45) Kathmandu'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '21600' },
	          '(GMT +6:00) Almaty, Dhaka, Colombo'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '25200' },
	          '(GMT +7:00) Bangkok, Hanoi, Jakarta'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '28800' },
	          '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '32400' },
	          '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '34200' },
	          '(GMT +9:30) Adelaide, Darwin'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '36000' },
	          '(GMT +10:00) Eastern Australia, Guam, Vladivostok'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '39600' },
	          '(GMT +11:00) Magadan, Solomon Islands, New Caledonia'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: '43200' },
	          '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka'
	        )
	      )
	    ),
	    props.touched && props.error && _react2.default.createElement(
	      'div',
	      { className: props.errorClass },
	      props.error
	    )
	  );
	}
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var auth = _ref.auth;
	  return {
	    user: auth.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TimezonePicker);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _albums = __webpack_require__(41);
	
	var _playlists = __webpack_require__(43);
	
	var _album = __webpack_require__(66);
	
	var _query = __webpack_require__(50);
	
	var _common = __webpack_require__(170);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _AddImagesToAlbum = __webpack_require__(813);
	
	var _AddImagesToAlbum2 = _interopRequireDefault(_AddImagesToAlbum);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AlbumPicker = __webpack_require__(204);
	
	var _AlbumPicker2 = _interopRequireDefault(_AlbumPicker);
	
	var _lists = __webpack_require__(88);
	
	var _images = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddImagesToAlbum = function (_Component) {
	  _inherits(AddImagesToAlbum, _Component);
	
	  function AddImagesToAlbum() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddImagesToAlbum);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddImagesToAlbum.__proto__ || Object.getPrototypeOf(AddImagesToAlbum)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selected: [],
	      showNewAlbumInput: false,
	      newAlbum: '',
	      submitting: false,
	      success: false,
	      error: null
	    }, _this.onSubmit = function () {
	      var _this$props = _this.props,
	          entities = _this$props.entities,
	          images = _this$props.images,
	          addImagesToAlbum = _this$props.addImagesToAlbum,
	          saveAlbum = _this$props.saveAlbum;
	      var _this$state = _this.state,
	          selected = _this$state.selected,
	          newAlbum = _this$state.newAlbum;
	
	      _this.setState({
	        submitting: true
	      });
	      var promises = selected.map(function (id) {
	        var album = entities.albums[id];
	        return addImagesToAlbum(album, images);
	      });
	      if (newAlbum) {
	        var structure = _extends({}, _query.emptyStructure, {
	          include: images
	        });
	        promises.push(saveAlbum({
	          name: newAlbum,
	          cover: images[0],
	          presentation_type: null,
	          presentation_speed: null,
	          presentation_transition: null,
	          presentation_sort: null
	        }, structure, undefined, false));
	      }
	      Promise.all(promises).then(_this.props.onCancel).catch(function (error) {
	        _this.setState({
	          error: error,
	          submitting: false
	        });
	      });
	    }, _this.onSelectAlbum = function (id) {
	      _this.setState({
	        selected: _this.state.selected.concat(id),
	        success: false
	      }, _this.onSubmit); // Submit on select
	    }, _this.onRemoveAlbum = function (id) {
	      _this.setState({
	        selected: _this.state.selected.filter(function (s) {
	          return s !== id;
	        })
	      });
	    }, _this.renderItem = function (id) {
	      var _this$props2 = _this.props,
	          entities = _this$props2.entities,
	          getImageSource = _this$props2.getImageSource,
	          isOwner = _this$props2.isOwner,
	          getOwner = _this$props2.getOwner;
	
	      var album = entities.albums[id];
	      var info = isOwner(album) ? null : 'Shared by ' + getOwner(album);
	      return _react2.default.createElement(
	        'li',
	        { key: album.id, className: _AddImagesToAlbum2.default.album },
	        _react2.default.createElement('div', {
	          className: _AddImagesToAlbum2.default.thumb,
	          style: { backgroundImage: 'url(' + getImageSource(album.cover) + ')' }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _AddImagesToAlbum2.default.name },
	          album.name,
	          info && _react2.default.createElement(
	            'div',
	            { className: _AddImagesToAlbum2.default.info },
	            info
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return _this.onRemoveAlbum(id);
	            }, className: _AddImagesToAlbum2.default.button },
	          _react2.default.createElement(_Icon2.default, { icon: 'close' })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddImagesToAlbum, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          albums = _props.albums,
	          fetchAlbums = _props.fetchAlbums,
	          lists = _props.lists,
	          fetchPlaylists = _props.fetchPlaylists;
	
	      if (!albums) {
	        fetchAlbums();
	      }
	      if (!lists) {
	        fetchPlaylists();
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          albums = _props2.albums,
	          lists = _props2.lists,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchAlbums = _props2.fetchAlbums;
	
	
	      if (fetching || !albums || !lists) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (error) {
	        _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching albums',
	          onRetry: fetchAlbums
	        });
	      }
	
	      var _props3 = this.props,
	          isOwner = _props3.isOwner,
	          onCancel = _props3.onCancel;
	      var _state = this.state,
	          selected = _state.selected,
	          newAlbum = _state.newAlbum,
	          success = _state.success,
	          submitting = _state.submitting;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.label },
	          'Select an album to add images'
	        ),
	        selected.length !== 0 && _react2.default.createElement(
	          'ul',
	          { className: _AddImagesToAlbum2.default.list },
	          selected.map(this.renderItem)
	        ),
	        !this.state.showNewAlbumInput && _react2.default.createElement(_AlbumPicker2.default, {
	          albums: albums,
	          lists: lists,
	          isOwner: isOwner,
	          onChange: this.onSelectAlbum,
	          exclude: selected,
	          resetOnChange: true,
	          collapseOnSelect: true,
	          placeholder: 'Choose from your albums or create new',
	          getImageSource: this.props.getImageSource,
	          onCreateNewAlbum: function onCreateNewAlbum() {
	            return _this2.setState({ showNewAlbumInput: true });
	          }
	        }),
	        this.state.showNewAlbumInput && _react2.default.createElement('input', {
	          type: 'text',
	          value: newAlbum,
	          onChange: function onChange(e) {
	            return _this2.setState({ newAlbum: e.target.value });
	          },
	          placeholder: 'Enter a new album name'
	        }),
	        success && _react2.default.createElement(
	          'p',
	          { className: _common2.default.note },
	          'Images successfully added to albums'
	        ),
	        error && _react2.default.createElement(
	          'p',
	          { className: _common2.default.note },
	          'There was an error adding images to albums'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.buttons },
	          _react2.default.createElement(
	            'button',
	            { onClick: onCancel, className: success ? _common2.default.button : _common2.default.backButton },
	            success ? 'Done' : 'Cancel'
	          ),
	          !success && _react2.default.createElement(
	            'button',
	            { onClick: this.onSubmit, className: _common2.default.button, disabled: submitting },
	            submitting ? 'Adding Images…' : 'Add Images'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: 'Add images to album', onClose: this.props.onCancel },
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.page },
	          this.renderContent()
	        )
	      );
	    }
	  }]);
	
	  return AddImagesToAlbum;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var albums = _ref2.albums,
	      playlists = _ref2.playlists,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	  return {
	    lists: (0, _lists.mapStateToLists)(playlists, entities),
	    albums: albums.all.data && albums.all.data.map(function (id) {
	      return entities.albums[id];
	    }).filter(function (album) {
	      return album.user_id === auth.user.id && !album.image_share && !album.favourite;
	    }),
	    isOwner: function isOwner(album) {
	      return album.user_id === auth.user.id;
	    },
	    getOwner: function getOwner(album) {
	      return entities.users[album.user_id];
	    },
	    getImageSource: (0, _images.createImageGetter)(auth),
	    fetching: albums.all.fetching,
	    error: albums.all.error,
	    entities: entities
	  };
	};
	
	var mapDispatchToProps = {
	  fetchAlbums: _albums.fetchAlbums,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  addImagesToAlbum: _album.addImagesToAlbum,
	  saveAlbum: _album.saveAlbum
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddImagesToAlbum);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _common = __webpack_require__(170);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _album = __webpack_require__(66);
	
	var _users = __webpack_require__(68);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ShareButton = __webpack_require__(201);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageShare = function (_Component) {
	  _inherits(ImageShare, _Component);
	
	  function ImageShare() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageShare);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageShare.__proto__ || Object.getPrototypeOf(ImageShare)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      checked: [],
	      success: false,
	      submitting: false
	    }, _this.onSubmit = function () {
	      var _this$props = _this.props,
	          images = _this$props.images,
	          users = _this$props.users,
	          shareImages = _this$props.shareImages;
	      var checked = _this.state.checked;
	
	      var promises = [];
	      _this.setState({ submitting: true });
	      users.forEach(function (user) {
	        if (checked.indexOf(user.id) !== -1) {
	          promises.push(shareImages(images, user.id));
	        }
	      });
	      Promise.all(promises).then(function () {
	        _this.setState({
	          success: true,
	          submitting: false
	        });
	      });
	    }, _this.renderUser = function (user) {
	      var checked = _this.state.checked;
	
	      var isChecked = checked.indexOf(user.id) !== -1;
	      var onCheck = function onCheck() {
	        return _this.setState({ checked: checked.concat(user.id), success: false });
	      };
	      var onUncheck = function onUncheck() {
	        return _this.setState({ checked: checked.filter(function (id) {
	            return id !== user.id;
	          }), success: false });
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: user.id },
	        _react2.default.createElement(
	          'button',
	          {
	            className: isChecked ? _common2.default.userChecked : _common2.default.user,
	            onClick: isChecked ? onUncheck : onCheck },
	          _react2.default.createElement(
	            'div',
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userName },
	              user.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userEmail },
	              user.email
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: isChecked ? _common2.default.checkboxChecked : _common2.default.checkbox },
	            isChecked && _react2.default.createElement(_Icon2.default, { icon: 'tick', className: _common2.default.tick, size: 16 })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageShare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          users = _props.users,
	          fetchUsers = _props.fetchUsers;
	
	      if (!users) {
	        fetchUsers();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          users = _props2.users,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchUsers = _props2.fetchUsers,
	          onCancel = _props2.onCancel;
	
	
	      if (!users || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching all users',
	          onRetry: fetchUsers
	        });
	      }
	
	      var _props3 = this.props,
	          images = _props3.images,
	          canShareInternal = _props3.canShareInternal,
	          canShareExternal = _props3.canShareExternal,
	          externalPath = _props3.externalPath;
	      var _state = this.state,
	          success = _state.success,
	          submitting = _state.submitting;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: images.length === 1 ? 'Share image' : 'Share images', onClose: onCancel },
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.page },
	          canShareExternal && _react2.default.createElement(_ShareButton2.default, {
	            images: images,
	            path: externalPath
	          }),
	          canShareInternal && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.heading },
	              'Within Blayzr'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              users.map(this.renderUser)
	            ),
	            success && _react2.default.createElement(
	              'p',
	              { className: _common2.default.note },
	              'Images were successfully shared'
	            ),
	            _react2.default.createElement(_ConfirmButtons2.default, {
	              onConfirm: this.onSubmit,
	              onCancel: onCancel,
	              confirmText: 'Share',
	              confirmDisabledText: 'Sharing\u2026',
	              confirmDisabled: submitting
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImageShare;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, props) {
	  var users = _ref2.users,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	
	  return {
	    users: users.data && users.data.filter(function (id) {
	      return id !== auth.user.id;
	    }).map(function (id) {
	      return entities.users[id];
	    }),
	    fetching: users.fetching,
	    error: users.error
	  };
	};
	
	var mapDispatchToProps = {
	  fetchUsers: _users.fetchUsers,
	  shareImages: _album.shareImages
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImageShare);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactDom = __webpack_require__(32);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _screenfull = __webpack_require__(492);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _photoswipe = __webpack_require__(1048);
	
	var _photoswipe2 = _interopRequireDefault(_photoswipe);
	
	var _photoswipeUiDefault = __webpack_require__(1047);
	
	var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);
	
	__webpack_require__(870);
	
	__webpack_require__(869);
	
	var _Gallery = __webpack_require__(819);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Thumbnail = __webpack_require__(514);
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	var _ImageMenu = __webpack_require__(304);
	
	var _ImageMenu2 = _interopRequireDefault(_ImageMenu);
	
	var _ImageFavouriteButton = __webpack_require__(517);
	
	var _ImageFavouriteButton2 = _interopRequireDefault(_ImageFavouriteButton);
	
	var _ImageFlagButton = __webpack_require__(518);
	
	var _ImageFlagButton2 = _interopRequireDefault(_ImageFlagButton);
	
	var _Stars = __webpack_require__(202);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Image = __webpack_require__(208);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _string = __webpack_require__(16);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Gallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openImage: null,
	      openInfo: null,
	      showControls: true
	    }, _this.openPhotoSwipe = function (index) {
	      var _this$props = _this.props,
	          images = _this$props.images,
	          getImageSource = _this$props.getImageSource;
	
	      var pswp = (0, _reactDom.findDOMNode)(_this).querySelector('.pswp');
	      var items = getItems(images, getImageSource);
	      var options = {
	        index: index,
	        galleryPIDs: true,
	        zoomEl: false,
	        fullscreenEl: false,
	        shareEl: false,
	        showHideOpacity: true,
	        history: false,
	        getThumbBoundsFn: function getThumbBoundsFn() {},
	        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
	          return item.initialZoomLevel * _constants.DOUBLE_TAP_ZOOM_LEVEL;
	        },
	        timeToIdle: null,
	        barsSize: { top: 44, bottom: 64 }
	      };
	      _this.setState({
	        openImage: images[index]
	      });
	      _this.photoswipe = new _photoswipe2.default(pswp, _photoswipeUiDefault2.default, items, options);
	      _this.photoswipe.listen('beforeChange', function () {
	        var _this$props2 = _this.props,
	            images = _this$props2.images,
	            loadMoreImages = _this$props2.loadMoreImages;
	
	        var index = _this.photoswipe.getCurrentIndex();
	        if (loadMoreImages && images.length - index <= 3) {
	          loadMoreImages();
	        }
	        _this.setState({
	          openImage: images[index]
	        });
	      });
	      _this.photoswipe.listen('close', function () {
	        _this.setState({
	          openImage: null,
	          openInfo: null
	        });
	        if (_screenfull2.default.isFullscreen) {
	          _screenfull2.default.exit();
	        }
	      });
	      _this.photoswipe.init();
	      _this.photoswipe.framework.bind(_this.photoswipe.scrollWrap, 'pswpTap', function (e) {
	        if ('ontouchstart' in window) {
	          _this.setState({
	            // Do not use ! here because the --hidden class hasn't been set by photoswipe yet
	            showControls: pswp.querySelector('.pswp__ui').classList.contains('pswp__ui--hidden')
	          });
	        }
	      });
	      _this.photoswipe.framework.bind(_this.photoswipe.scrollWrap, 'click', _this.showControls);
	    }, _this.onClickInfo = function (id) {
	      _this.setState({ openInfo: id });
	    }, _this.onCloseInfo = function () {
	      _this.setState({ openInfo: null });
	    }, _this.hideControls = function () {
	      if (_this.state.openImage) {
	        _this.setState({ showControls: false });
	        _this.photoswipe && _this.photoswipe.ui.setIdle(true);
	      }
	    }, _this.showControls = function () {
	      _this.setState({ showControls: true });
	      _this.photoswipe && _this.photoswipe.ui.setIdle(false);
	    }, _this.onClickFullscreen = function () {
	      _screenfull2.default.toggle();
	      _this.hideControls();
	    }, _this.reorderImages = function (index) {
	      var _this$props3 = _this.props,
	          images = _this$props3.images,
	          selectedImages = _this$props3.selectedImages,
	          updateManualOrder = _this$props3.updateManualOrder;
	
	
	      var ids = images.map(function (image) {
	        return image._id;
	      });
	
	      // Create array with selected images removed
	      var order = ids.filter(function (id) {
	        return selectedImages.indexOf(id) === -1;
	      });
	
	      // Insert selected image array at adjusted index
	      order.splice.apply(order, [index, 0].concat(_toConsumableArray(selectedImages)));
	
	      updateManualOrder(order);
	    }, _this.renderThumbnail = function (image, index) {
	      var _this$props4 = _this.props,
	          getImageSource = _this$props4.getImageSource,
	          selectImageMode = _this$props4.selectImageMode,
	          reorderImageMode = _this$props4.reorderImageMode,
	          selectedImages = _this$props4.selectedImages,
	          selectImage = _this$props4.selectImage,
	          deselectImage = _this$props4.deselectImage,
	          anonymousUser = _this$props4.anonymousUser,
	          showInfoLink = _this$props4.showInfoLink,
	          enableEditing = _this$props4.enableEditing,
	          confirmReorder = _this$props4.confirmReorder,
	          thumbSize = _this$props4.thumbSize;
	
	      var id = image._id;
	      var selected = selectedImages.indexOf(id) !== -1;
	      var onClick = function onClick() {
	        if (reorderImageMode) {
	          if (!confirmReorder || window.confirm('This will override the existing manual order. Are you sure you want to do this?')) {
	            _this.reorderImages(index);
	          }
	          return;
	        }
	        if (selectImageMode) {
	          if (selected) {
	            deselectImage(id);
	          } else {
	            selectImage(id);
	          }
	          return;
	        }
	        if ('activeElement' in document && document.activeElement.tagName === 'INPUT') {
	          document.activeElement.blur(); // Ensure soft keyboard is hidden
	          setTimeout(function () {
	            _this.openPhotoSwipe(index); // Delay opening until soft keyboard is hidden
	          }, 300);
	        } else {
	          _this.openPhotoSwipe(index);
	        }
	      };
	      var onPress = function onPress() {
	        if (_this.props.canEdit) {
	          enableEditing();
	        }
	        selectImage(id);
	      };
	      return _react2.default.createElement(_Thumbnail2.default, {
	        key: id,
	        id: id,
	        src: getImageSource(id, thumbSize > 240 ? 'd' : 't'),
	        selected: selected,
	        selectImageMode: selectImageMode,
	        reorderImageMode: reorderImageMode,
	        onClick: onClick,
	        onPress: onPress,
	        showInfoLink: showInfoLink && !anonymousUser,
	        onClickInfo: function onClickInfo() {
	          onClick();
	          _this.onClickInfo(id);
	        },
	        size: thumbSize
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Gallery, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (window.location.search === '?expand') {
	        this.openPhotoSwipe(0);
	      }
	      _mousetrap2.default.bind('left', this.hideControls);
	      _mousetrap2.default.bind('right', this.hideControls);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _props = this.props,
	          images = _props.images,
	          selectedImages = _props.selectedImages,
	          selectImageMode = _props.selectImageMode,
	          reorderImageMode = _props.reorderImageMode,
	          entities = _props.entities,
	          thumbSize = _props.thumbSize;
	      var _state = this.state,
	          openImage = _state.openImage,
	          openInfo = _state.openInfo,
	          showControls = _state.showControls;
	
	      if (openImage !== nextState.openImage || openInfo !== nextState.openInfo || showControls !== nextState.showControls || selectedImages.length !== nextProps.selectedImages.length || selectImageMode !== nextProps.selectImageMode || reorderImageMode !== nextProps.reorderImageMode || thumbSize !== nextProps.thumbSize) {
	        return true;
	      }
	      if (!images && nextProps.images || images && !nextProps.images) {
	        return true;
	      }
	      if (images && nextProps.images) {
	        if (images.length !== nextProps.images.length) {
	          return true;
	        }
	        for (var i = 0; i !== images.length; i++) {
	          if (images[i]._id !== nextProps.images[i]._id) {
	            return true;
	          }
	        }
	      }
	      // Update if image rating/flag changes
	      if (nextState.openImage) {
	        var image = entities.images[nextState.openImage._id];
	        var nextImage = nextProps.entities.images[nextState.openImage._id];
	        if (!(0, _lodash2.default)(image, nextImage)) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props2 = this.props,
	          images = _props2.images,
	          getImageSource = _props2.getImageSource;
	
	      var newImageCount = prevProps.images && images && images.length - prevProps.images.length;
	      if (this.photoswipe && this.state.openImage) {
	        if (newImageCount > 0) {
	          // Images have been added
	          var items = getItems(images, getImageSource);
	          for (var i = prevProps.images.length; i !== images.length; i++) {
	            this.photoswipe.items.push(items[i]);
	          }
	          this.photoswipe.ui.update();
	        }
	        if (newImageCount < 0) {
	          // Images have been removed
	          this.photoswipe.close();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _mousetrap2.default.unbind(['left', 'right']);
	    }
	    // TODO: Should this be moved to redux logic?
	
	  }, {
	    key: 'renderImages',
	    value: function renderImages(images) {
	      var _props3 = this.props,
	          showEventHeadings = _props3.showEventHeadings,
	          userLibraries = _props3.userLibraries;
	
	      var nodes = [];
	      var previous = void 0;
	      for (var i = 0; i !== images.length; i++) {
	        var image = images[i];
	        if (showEventHeadings && (!previous || previous._event !== image._event)) {
	          nodes.push(_react2.default.createElement(
	            'h2',
	            { key: image._event, className: _Gallery2.default.heading },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/album?path=' + image._event },
	              (0, _string.getEventTitle)(image._event, userLibraries)
	            )
	          ));
	        }
	        nodes.push(this.renderThumbnail(image, i));
	        previous = image;
	      }
	      return nodes;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          images = _props4.images,
	          getImageSource = _props4.getImageSource,
	          setCover = _props4.setCover,
	          anonymousUser = _props4.anonymousUser,
	          title = _props4.title,
	          showInfoLink = _props4.showInfoLink;
	      var _state2 = this.state,
	          openImage = _state2.openImage,
	          openInfo = _state2.openInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        images && images.length === 0 && _react2.default.createElement(_ErrorMessage2.default, { message: 'No images found' }),
	        images && images.length !== 0 && _react2.default.createElement(
	          'ul',
	          { className: _Gallery2.default.thumbnails, style: this.props.style },
	          this.renderImages(images)
	        ),
	        _react2.default.createElement(PhotoSwipeMarkup, { title: title }),
	        openImage && _react2.default.createElement(
	          'div',
	          { className: this.state.showControls ? _Gallery2.default.controlsShown : _Gallery2.default.controlsHidden },
	          !openInfo && !anonymousUser && _react2.default.createElement(_Stars2.default, {
	            className: _Gallery2.default.stars,
	            rating: openImage._rating,
	            image: this.props.entities.images[openImage._id],
	            whiteStars: true,
	            clickable: true
	          }),
	          !openInfo && !anonymousUser && _react2.default.createElement(_ImageFavouriteButton2.default, { id: openImage._id, className: _Gallery2.default.favButton }),
	          openInfo && _react2.default.createElement('button', {
	            className: _Gallery2.default.infoOverlay,
	            onClick: this.onCloseInfo
	          }),
	          openInfo && _react2.default.createElement(
	            _Modal2.default,
	            { style: { 'top': '44px' } },
	            _react2.default.createElement(_Image2.default, { params: { id: openInfo }, onClickThumbnail: this.onCloseInfo })
	          ),
	          !anonymousUser && _react2.default.createElement(_ImageMenu2.default, {
	            image: openImage,
	            getImageSource: getImageSource,
	            setCover: setCover,
	            showInfoLink: showInfoLink,
	            onClickInfo: openInfo ? this.onCloseInfo : function () {
	              return _this2.onClickInfo(openImage._id);
	            },
	            canShareInternal: this.props.canShareImagesInternal,
	            canShareExternal: this.props.canShareImagesExternal,
	            onClickFullscreen: this.onClickFullscreen,
	            albumID: this.props.albumID,
	            images: this.props.images.map(function (i) {
	              return i._id;
	            }),
	            canRemove: this.props.canRemove,
	            excludeImages: this.props.excludeImages
	          }),
	          !openInfo && this.props.canFlag && _react2.default.createElement(_ImageFlagButton2.default, { id: openImage._id, className: _Gallery2.default.flagButton })
	        )
	      );
	    }
	  }]);
	
	  return Gallery;
	}(_react.Component);
	
	Gallery.defaultProps = {
	  selectedImages: [],
	  showInfoLink: true
	};
	exports.default = Gallery;
	
	
	function getItems(images, getImageSource) {
	  return images.map(function (image) {
	    return {
	      pid: image._id,
	      src: getImageSource(image._id, 'd'),
	      thumbnail: getImageSource(image._id),
	      w: image._width,
	      h: image._height
	    };
	  });
	}
	
	// http://photoswipe.com/documentation/getting-started.html#init-add-pswp-to-dom
	var PhotoSwipeMarkup = function PhotoSwipeMarkup(_ref2) {
	  var title = _ref2.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'pswp', tabIndex: '-1', role: 'dialog', 'aria-hidden': 'true' },
	    _react2.default.createElement('div', { className: 'pswp__bg' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'pswp__scroll-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pswp__container' },
	        _react2.default.createElement('div', { className: 'pswp__item' }),
	        _react2.default.createElement('div', { className: 'pswp__item' }),
	        _react2.default.createElement('div', { className: 'pswp__item' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'pswp__ui pswp__ui--hidden' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pswp__top-bar' },
	          _react2.default.createElement('div', { className: 'pswp__counter' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'pswp__title' },
	            title
	          ),
	          _react2.default.createElement('button', { className: 'pswp__button pswp__button--close', title: 'Close (Esc)' }),
	          _react2.default.createElement('button', { className: 'pswp__button pswp__button--share', title: 'Share' }),
	          _react2.default.createElement('button', { className: 'pswp__button pswp__button--fs', title: 'Toggle fullscreen' }),
	          _react2.default.createElement('button', { className: 'pswp__button pswp__button--zoom', title: 'Zoom in/out' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'pswp__preloader' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pswp__preloader__icn' },
	              _react2.default.createElement(
	                'div',
	                { className: 'pswp__preloader__cut' },
	                _react2.default.createElement('div', { className: 'pswp__preloader__donut' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pswp__share-modal pswp__share-modal--hidden pswp__single-tap' },
	          _react2.default.createElement('div', { className: 'pswp__share-tooltip' })
	        ),
	        _react2.default.createElement('button', { className: 'pswp__button pswp__button--arrow--left', title: 'Previous (arrow left)' }),
	        _react2.default.createElement('button', { className: 'pswp__button pswp__button--arrow--right', title: 'Next (arrow right)' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'pswp__caption' },
	          _react2.default.createElement('div', { className: 'pswp__caption__center' })
	        )
	      )
	    )
	  );
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _ImageMenu = __webpack_require__(823);
	
	var _ImageMenu2 = _interopRequireDefault(_ImageMenu);
	
	var _queues = __webpack_require__(108);
	
	var _banners = __webpack_require__(67);
	
	var _DropMenu = __webpack_require__(148);
	
	var _DropMenu2 = _interopRequireDefault(_DropMenu);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AddImagesToAlbum = __webpack_require__(301);
	
	var _AddImagesToAlbum2 = _interopRequireDefault(_AddImagesToAlbum);
	
	var _ImageShare = __webpack_require__(302);
	
	var _ImageShare2 = _interopRequireDefault(_ImageShare);
	
	var _ChannelMenuItem = __webpack_require__(205);
	
	var _ChannelMenuItem2 = _interopRequireDefault(_ChannelMenuItem);
	
	var _images = __webpack_require__(23);
	
	var _auth = __webpack_require__(20);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageMenu = function (_Component) {
	  _inherits(ImageMenu, _Component);
	
	  function ImageMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageMenu.__proto__ || Object.getPrototypeOf(ImageMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false,
	      downloadMenuOpen: false,
	      shareMenuOpen: false,
	      addMenuOpen: false,
	      playNowMenuOpen: false,
	      playNextMenuOpen: false,
	      channels: null
	    }, _this.onAddToChannel = function (channel, playNow) {
	      var _this$props = _this.props,
	          sendToPlayNow = _this$props.sendToPlayNow,
	          sendToPlayNext = _this$props.sendToPlayNext,
	          showBanner = _this$props.showBanner;
	
	      var structure = _this.props.albumID ? { album: { album: _this.props.albumID } } : { images: _this.props.images };
	      var success = function success(data) {
	        if (!channel.id && playNow) {
	          _this.props.presentChannel(data.channel);
	        } else {
	          showBanner(_this.props.albumID ? 'Album added to channel' : 'Images added to channel');
	        }
	      };
	      if (playNow) {
	        sendToPlayNow(channel.id, structure).then(success);
	      } else {
	        sendToPlayNext(channel.id, structure).then(success);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageMenu, [{
	    key: 'getPresentMenuItems',
	    value: function getPresentMenuItems() {
	      var _this2 = this;
	
	      var _state = this.state,
	          channels = _state.channels,
	          playNowMenuOpen = _state.playNowMenuOpen;
	
	      if (!channels) {
	        return [{
	          text: _react2.default.createElement(_LoadingSpinner2.default, { style: { width: '12px', height: '12px', margin: 0 } })
	        }];
	      }
	      var items = [];
	      if (playNowMenuOpen) {
	        items.push({
	          key: 'blank',
	          text: 'Play on this device',
	          onClick: function onClick() {
	            return _this2.onAddToChannel({}, playNowMenuOpen);
	          }
	        });
	      }
	      if (channels.length !== 0) {
	        items.push({
	          heading: 'Add to channel'
	        });
	      }
	      return items.concat(channels.map(function (channel) {
	        return {
	          key: channel.id,
	          text: _react2.default.createElement(_ChannelMenuItem2.default, { channel: channel }),
	          onClick: function onClick() {
	            return _this2.onAddToChannel(channel, playNowMenuOpen);
	          }
	        };
	      }));
	    }
	  }, {
	    key: 'getDownloadItem',
	    value: function getDownloadItem(text, code) {
	      var _props = this.props,
	          image = _props.image,
	          getImageSource = _props.getImageSource;
	
	      var _getImageSize = (0, _images.getImageSize)(code, image._width, image._height),
	          width = _getImageSize.width,
	          height = _getImageSize.height;
	
	      return {
	        text: text + ' (' + width + ' x ' + height + ')',
	        href: getImageSource(image._id, code),
	        target: '_blank',
	        download: true
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          image = _props2.image,
	          setCover = _props2.setCover,
	          showInfoLink = _props2.showInfoLink,
	          anonymousUser = _props2.anonymousUser,
	          canEditPlaylists = _props2.canEditPlaylists,
	          fetchChannels = _props2.fetchChannels,
	          onClickInfo = _props2.onClickInfo;
	
	      var state = this.state;
	      var presentMenuItems = this.getPresentMenuItems();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _ImageMenu2.default.menu, style: this.props.style },
	          this.props.onClickFullscreen && !_constants.IS_IOS && _react2.default.createElement(
	            'button',
	            { onClick: this.props.onClickFullscreen },
	            _react2.default.createElement(_Icon2.default, { icon: 'fullscreen', size: 24 })
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                _this3.setState({ open: !state.open });
	                _this3.props.onOpen && _this3.props.onOpen();
	              }, 'data-toggle': 'image-menu' },
	            _react2.default.createElement(_Icon2.default, { icon: 'dots' })
	          ),
	          showInfoLink && _react2.default.createElement(
	            'button',
	            { onClick: onClickInfo },
	            _react2.default.createElement(_Icon2.default, { icon: 'info' })
	          )
	        ),
	        _react2.default.createElement(_DropMenu2.default, {
	          toggle: 'image-menu',
	          fixed: true,
	          style: { top: '44px' },
	          open: state.open,
	          closeMenu: function closeMenu() {
	            _this3.setState({ open: false });
	            _this3.props.onClose && _this3.props.onClose();
	          },
	          items: [{
	            text: 'Play ' + (this.props.albumID ? 'album' : 'images') + ' now',
	            onClick: function onClick() {
	              _this3.setState({
	                channels: null,
	                playNowMenuOpen: true
	              });
	              fetchChannels().then(function (channels) {
	                return _this3.setState({ channels: channels });
	              });
	            },
	            shouldShow: canEditPlaylists && !this.props.hidePresentOptions
	          }, {
	            text: 'Play ' + (this.props.albumID ? 'album' : 'images') + ' next',
	            onClick: function onClick() {
	              _this3.setState({
	                channels: null,
	                playNextMenuOpen: true
	              });
	              fetchChannels().then(function (channels) {
	                return _this3.setState({ channels: channels });
	              });
	            },
	            shouldShow: canEditPlaylists && !this.props.hidePresentOptions
	          }, {
	            text: 'Add image to album',
	            onClick: function onClick() {
	              return _this3.setState({ addMenuOpen: true });
	            },
	            shouldShow: !anonymousUser
	          }, {
	            text: 'Share image',
	            onClick: function onClick() {
	              return _this3.setState({ shareMenuOpen: true });
	            },
	            shouldShow: this.props.canShareInternal || this.props.canShareExternal
	          }, {
	            text: 'Download',
	            onClick: function onClick() {
	              return _this3.setState({ downloadMenuOpen: true });
	            },
	            shouldShow: this.props.canDownload
	          }, {
	            text: 'Remove image from album',
	            onClick: function onClick() {
	              _this3.props.excludeImages([image._id]);
	              _this3.setState({ open: false });
	            },
	            shouldShow: this.props.canRemove
	          }, {
	            text: 'Set image as album cover',
	            onClick: function onClick() {
	              return setCover(image._id);
	            },
	            shouldShow: !!setCover
	          }]
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          fixed: true,
	          style: { top: '44px' },
	          open: state.downloadMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ downloadMenuOpen: false });
	          },
	          items: [this.getDownloadItem('Small', 's75'), this.getDownloadItem('Medium', 'm75'), this.getDownloadItem('Large', 'l75'), this.getDownloadItem('Original', 'o')]
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          fixed: true,
	          style: { top: '44px' },
	          open: state.playNowMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNowMenuOpen: false });
	          },
	          items: presentMenuItems
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          fixed: true,
	          style: { top: '44px' },
	          open: state.playNextMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNextMenuOpen: false });
	          },
	          items: presentMenuItems
	        }),
	        state.addMenuOpen && _react2.default.createElement(_AddImagesToAlbum2.default, {
	          images: [image._id],
	          onCancel: function onCancel() {
	            return _this3.setState({ addMenuOpen: false });
	          }
	        }),
	        state.shareMenuOpen && _react2.default.createElement(_ImageShare2.default, {
	          images: [image._id],
	          canShareInternal: this.props.canShareInternal,
	          canShareExternal: this.props.canShareExternal,
	          onCancel: function onCancel() {
	            return _this3.setState({ shareMenuOpen: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return ImageMenu;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var queues = _ref2.queues,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	
	  return {
	    queues: queues.data && queues.data.map(function (id) {
	      return entities.queues[id];
	    }),
	    fetchingQueues: queues.fetching,
	    canEditPlaylists: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    canDownload: (0, _auth.canDownload)(auth),
	    fetchChannels: function fetchChannels() {
	      return (0, _fetch.picassoFetch)(auth, 'list_channels').then(function (data) {
	        return data.channels.filter(function (c) {
	          return parseInt(c.owner_id) === auth.user.id;
	        });
	      });
	    },
	    sendToPlayNext: function sendToPlayNext(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'add_to_play_next', _extends({
	        channel_id: channelID
	      }, body));
	    },
	    sendToPlayNow: function sendToPlayNow(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'add_to_play_now', _extends({
	        channel_id: channelID
	      }, body));
	    }
	  };
	};
	
	var mapDispatchToProps = {
	  fetchQueues: _queues.fetchQueues,
	  saveQueue: _queues.saveQueue,
	  showBanner: _banners.showBanner,
	  presentChannel: function presentChannel(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/present/' + id));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImageMenu);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _common = __webpack_require__(171);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Checklist = __webpack_require__(126);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	var _LocationPicker = __webpack_require__(153);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _array = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditUser(_ref) {
	  var invalid = _ref.invalid,
	      createError = _ref.createError,
	      handleSubmit = _ref.handleSubmit,
	      submitting = _ref.submitting,
	      onCancel = _ref.onCancel,
	      title = _ref.title,
	      showPasswordField = _ref.showPasswordField,
	      requirePassword = _ref.requirePassword,
	      perms = _ref.perms,
	      libraries = _ref.libraries,
	      hideAdminPerm = _ref.hideAdminPerm,
	      autoFocus = _ref.autoFocus;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: title, onClose: onCancel },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit, className: _common2.default.form, autoComplete: 'off' },
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: { label: 'Name' },
	        type: 'text',
	        name: 'name',
	        required: true,
	        autoFocus: autoFocus
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: { label: 'Email' },
	        type: 'text',
	        name: 'email',
	        required: true
	      }),
	      showPasswordField && _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: {
	          label: 'Password',
	          note: 'Passwords must be at least 8 characters long, and have at least one symbol, one uppercase letter and one lowercase letter.'
	        },
	        type: 'text',
	        name: 'password',
	        required: requirePassword
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: {
	          label: 'Default Location',
	          component: _LocationPicker2.default,
	          hideMap: true
	        },
	        name: 'location',
	        defaultValue: '51.5,-0.13'
	      }),
	      perms && _react2.default.createElement(_reduxForm.Field, {
	        component: PermPicker,
	        name: 'perms',
	        defaultValue: [],
	        props: { perms: perms, hideAdminPerm: hideAdminPerm }
	      }),
	      libraries && _react2.default.createElement(_reduxForm.Field, {
	        component: LibraryPicker,
	        name: 'libraries',
	        defaultValue: [],
	        props: { libraries: libraries }
	      }),
	      invalid && _react2.default.createElement(
	        'p',
	        { className: _common2.default.error, style: { marginTop: '30px' } },
	        'There is a problem with one or more fields, please fix the problem and try again'
	      ),
	      _react2.default.createElement(_ConfirmButtons2.default, {
	        onCancel: onCancel,
	        onConfirm: handleSubmit,
	        confirmDisabled: submitting || invalid
	      }),
	      createError && _react2.default.createElement(
	        'p',
	        { className: _common2.default.centerError },
	        getError(createError)
	      ),
	      _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	    )
	  );
	}
	
	function Input(props) {
	  var Component = props.component || 'input';
	  return _react2.default.createElement(
	    'label',
	    null,
	    props.label,
	    props.note && _react2.default.createElement(
	      'div',
	      { className: _common2.default.note },
	      props.note
	    ),
	    _react2.default.createElement(Component, props),
	    props.touched && props.error && _react2.default.createElement(
	      'div',
	      { className: _common2.default.error },
	      props.error
	    )
	  );
	}
	
	var PERM_ORDER = ['view_collections', 'search_and_save', 'internal_share', 'external_share', 'extend_external_share', 'flag_image', 'download', 'view_shared_channels', 'create_channels', 'dynamic_links', 'image_config',
	// Admin perms
	'admin', 'edit_collections', 'internal_share_all', 'no_download_restriction', 'advanced_search', 'advanced_info', 'view_hierarchy'];
	
	// Map perms that should be selected when another perm is checked
	var AUTO_SELECT_PERM = {
	  'internal_share_all': 'internal_share',
	  'search_and_save': 'view_collections'
	};
	
	function PermPicker(_ref2) {
	  var error = _ref2.error,
	      touched = _ref2.touched,
	      value = _ref2.value,
	      _onChange = _ref2.onChange,
	      perms = _ref2.perms,
	      hideAdminPerm = _ref2.hideAdminPerm;
	
	  var items = perms.filter(function (perm) {
	    if (hideAdminPerm && perm.perm_token === 'admin') {
	      return false;
	    }
	    return true;
	  }).sort((0, _array.guideSort)(PERM_ORDER, 'perm_token')).map(function (perm) {
	    return {
	      value: perm.id,
	      title: perm.perm_token,
	      subtitle: perm.perm_desc,
	      // Token here must be the token before admin section in PERM_ORDER
	      append: perm.perm_token === 'image_config' ? _react2.default.createElement(
	        'label',
	        null,
	        'Admin permissions'
	      ) : undefined
	    };
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { className: _common2.default.noBottomMargin },
	      'Permissions'
	    ),
	    _react2.default.createElement(_Checklist2.default, {
	      items: items,
	      value: value.map(function (perm) {
	        return perm.perm.id;
	      }),
	      onChange: function onChange(array, item) {
	        var newPerms = perms.filter(function (perm) {
	          return array.indexOf(perm.id) !== -1;
	        }).map(function (perm) {
	          return { perm: perm };
	        });
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var key = _step.value;
	
	            if (item.title === key && newPerms.findIndex(function (p) {
	              return p.perm.perm_token === AUTO_SELECT_PERM[key];
	            }) === -1) {
	              var sharePermIndex = perms.findIndex(function (p) {
	                return p.perm_token === AUTO_SELECT_PERM[key];
	              });
	              newPerms.push({ perm: perms[sharePermIndex] });
	            }
	          };
	
	          for (var _iterator = Object.keys(AUTO_SELECT_PERM)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        _onChange(newPerms);
	      }
	    }),
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: _common2.default.error },
	      error
	    )
	  );
	}
	
	function LibraryPicker(_ref3) {
	  var touched = _ref3.touched,
	      error = _ref3.error,
	      value = _ref3.value,
	      onChange = _ref3.onChange,
	      libraries = _ref3.libraries;
	
	  var items = libraries.map(function (library) {
	    var id = library.library.id;
	    var checked = value.findIndex(function (userLibrary) {
	      return userLibrary.library.id === id;
	    }) !== -1;
	    var onClick = function onClick() {
	      if (checked) {
	        onChange(value.filter(function (userLibrary) {
	          return userLibrary.library.id !== id;
	        }));
	      } else {
	        onChange(value.concat(library).sort(sortByID));
	      }
	    };
	    return _react2.default.createElement(
	      'button',
	      {
	        key: id,
	        type: 'button',
	        onClick: onClick,
	        className: checked ? _common2.default.activeButton : _common2.default.button },
	      library.library.library_token
	    );
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'label',
	      { className: _common2.default.noBottomMargin },
	      'Libaries'
	    ),
	    items,
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: _common2.default.error },
	      error
	    )
	  );
	}
	
	function getError(error) {
	  if (!error) return null;
	  if (error.status === 409) {
	    return 'A user with that email address already exists';
	  }
	  if (error.message) {
	    return error.message;
	  }
	  return 'Error ' + error.status + ': ' + error.statusText;
	}
	
	function sortByID(a, b) {
	  return a.id - b.id;
	}
	
	function validate(values, props) {
	  var errors = {};
	  if (!values.name) {
	    errors.name = 'A name is required';
	  }
	  if (!values.email || /.+@.+\..+/.test(values.email) === false) {
	    errors.email = 'A valid email address is required';
	  }
	  if (!values.perms || !values.perms.length === 0) {
	    errors.perms = 'At least one permission is required';
	  }
	  if (!values.libraries || !values.libraries.libraries === 0) {
	    errors.libraries = 'At least one library is required';
	  }
	  if (props.requirePassword && !values.password) {
	    errors.password = 'A password is required';
	  }
	  if (values.password) {
	    if (/[^a-zA-Z0-9]/.test(values.password) === false) {
	      errors.password = 'Password must have at least one symbol';
	    }
	    if (/[a-z]/.test(values.password) === false) {
	      errors.password = 'Password must have at least one lowercase letter';
	    }
	    if (/[A-Z]/.test(values.password) === false) {
	      errors.password = 'Password must have at least one uppercase letter';
	    }
	    if (values.password.length < 8) {
	      errors.password = 'Password must be at least 8 characters long';
	    }
	  }
	  return errors;
	}
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'user', validate: validate })(EditUser);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _common = __webpack_require__(171);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FlagImageModal(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      submitting = _ref.submitting,
	      closeModal = _ref.closeModal;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: 'Flag Image', onClose: closeModal },
	    _react2.default.createElement(
	      'form',
	      { className: _common2.default.form },
	      _react2.default.createElement(
	        'label',
	        null,
	        'Reason (optional)',
	        _react2.default.createElement(_reduxForm.Field, {
	          component: ReasonInput,
	          name: 'reason',
	          placeholder: 'Enter a reason for flagging this image',
	          autoFocus: true
	        })
	      ),
	      _react2.default.createElement(_ConfirmButtons2.default, {
	        onCancel: closeModal,
	        onConfirm: handleSubmit,
	        confirmText: 'Flag Image',
	        confirmDisabled: submitting
	      }),
	      _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	    )
	  );
	}
	
	function ReasonInput(_ref2) {
	  var value = _ref2.value,
	      _onChange = _ref2.onChange;
	
	  var onClickButton = function onClickButton(e) {
	    _onChange(value + e.target.value + '\n');
	    e.target.parentNode.querySelector('textarea').focus();
	  };
	  var Button = function Button(_ref3) {
	    var value = _ref3.value;
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        onClick: onClickButton,
	        className: _common2.default.smallButton,
	        value: value },
	      value
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('textarea', {
	      value: value,
	      onChange: function onChange(e) {
	        return _onChange(e.target.value);
	      }
	    }),
	    _react2.default.createElement(Button, { value: 'noupload' }),
	    _react2.default.createElement(Button, { value: 'orientation' }),
	    _react2.default.createElement(Button, { value: 'album path' }),
	    _react2.default.createElement(Button, { value: 'keywords' })
	  );
	}
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'flagImage' })(FlagImageModal);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _common = __webpack_require__(171);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ToggleForm = __webpack_require__(149);
	
	var _ToggleForm2 = _interopRequireDefault(_ToggleForm);
	
	var _Checklist = __webpack_require__(126);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	var _PresentOptionsForm = __webpack_require__(206);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SaveAlbum(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      onSubmit = _ref.onSubmit,
	      submitting = _ref.submitting,
	      closeModal = _ref.closeModal,
	      title = _ref.title,
	      canSave = _ref.canSave,
	      addingToPlaylist = _ref.addingToPlaylist,
	      lists = _ref.lists,
	      albumLists = _ref.albumLists,
	      defaultSort = _ref.defaultSort,
	      presentTypeSelected = _ref.presentTypeSelected;
	
	  var isOnSearchPage = /\/search$/.test(window.location.pathname);
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: title, onClose: closeModal },
	    _react2.default.createElement(
	      'form',
	      { className: _common2.default.form },
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: { label: 'Album Name' },
	        type: 'text',
	        name: 'name',
	        required: true,
	        autoFocus: isOnSearchPage
	      }),
	      _react2.default.createElement(
	        _ToggleForm2.default,
	        {
	          showLabel: 'Set Presentation Defaults'
	          // Hacky way of showing the presentation options when opening the save
	          // modal from the 'edit presentation options' button in the info page
	          , initialOpen: /\/info$/.test(window.location.pathname) },
	        _react2.default.createElement(_PresentOptionsForm.PresentOptionsFields, {
	          defaultSort: defaultSort,
	          presentTypeSelected: presentTypeSelected
	        })
	      ),
	      _react2.default.createElement(
	        _ToggleForm2.default,
	        { showLabel: 'Add album to groups', hideLabel: 'Hide album groups' },
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.label },
	          'Album Groups',
	          _react2.default.createElement(_reduxForm.Field, {
	            component: ListPicker,
	            name: 'lists',
	            props: { lists: lists },
	            defaultValue: albumLists || []
	          }),
	          _react2.default.createElement(_reduxForm.Field, {
	            component: Input,
	            type: 'text',
	            name: 'createList',
	            placeholder: 'New group'
	          })
	        )
	      ),
	      addingToPlaylist && _react2.default.createElement(
	        'p',
	        { className: _common2.default.centerNote },
	        'Adding album to playlist: ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          addingToPlaylist.name || 'New playlist'
	        )
	      ),
	      _react2.default.createElement(_ConfirmButtons2.default, {
	        onCancel: closeModal,
	        onConfirm: handleSubmit,
	        confirmDisabled: submitting,
	        confirmHidden: !canSave || isOnSearchPage,
	        middleButtons: [{
	          onClick: handleSubmit(function (data) {
	            return onSubmit(_extends({}, data, { id: undefined }));
	          }),
	          text: isOnSearchPage ? 'Save' : 'Save As New Album',
	          disabled: submitting
	        }]
	      }),
	      _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	    )
	  );
	}
	
	function Input(props) {
	  return _react2.default.createElement(
	    'label',
	    null,
	    props.label,
	    _react2.default.createElement('input', props),
	    props.touched && props.error && _react2.default.createElement(
	      'div',
	      { className: _common2.default.error },
	      props.error
	    )
	  );
	}
	
	function ListPicker(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange,
	      lists = _ref2.lists;
	
	  if (!lists) {
	    return _react2.default.createElement(_LoadingSpinner2.default, null);
	  }
	  return _react2.default.createElement(_Checklist2.default, {
	    items: lists.map(getListOptions),
	    value: value,
	    onChange: onChange
	  });
	}
	
	function getListOptions(list) {
	  return {
	    value: list.id,
	    title: list.name,
	    subtitle: (0, _string.pluralize)(JSON.parse(list.json_data).albums.length, 'album')
	  };
	}
	
	function validate(values) {
	  if (!values.name) {
	    return {
	      name: 'An album name is required'
	    };
	  }
	  return {};
	}
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'saveAlbum', validate: validate })(SaveAlbum);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConstraintsForm = __webpack_require__(830);
	
	var _ConstraintsForm2 = _interopRequireDefault(_ConstraintsForm);
	
	var _ArrayPicker = __webpack_require__(527);
	
	var _ArrayPicker2 = _interopRequireDefault(_ArrayPicker);
	
	var _Toggle = __webpack_require__(203);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _ToggleForm = __webpack_require__(149);
	
	var _ToggleForm2 = _interopRequireDefault(_ToggleForm);
	
	var _LocationPicker = __webpack_require__(153);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var HOUR_OF_DAY_ARRAY = [].concat(_toConsumableArray(Array(24).keys()));
	var DATE_ARRAY = [].concat(_toConsumableArray(Array(32).keys())).slice(1);
	var DAY_ARRAY = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	
	var ConstraintsForm = function (_Component) {
	  _inherits(ConstraintsForm, _Component);
	
	  function ConstraintsForm() {
	    _classCallCheck(this, ConstraintsForm);
	
	    return _possibleConstructorReturn(this, (ConstraintsForm.__proto__ || Object.getPrototypeOf(ConstraintsForm)).apply(this, arguments));
	  }
	
	  _createClass(ConstraintsForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          values = _props.values,
	          update = _props.update,
	          renderHeading = _props.renderHeading,
	          showLocationPicker = _props.showLocationPicker,
	          title = _props.title;
	
	      var renderToggle = function renderToggle(key) {
	        return _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return update(key, !values[key] || undefined);
	            }, className: _ConstraintsForm2.default.toggle },
	          _react2.default.createElement(_Toggle2.default, { value: values[key] }),
	          values[key] ? ' Start and finish in this period' : ' Start in this period'
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _ConstraintsForm2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          _ToggleForm2.default,
	          {
	            showLabel: 'Apply a viewing time period',
	            description: 'Limits will ensure the album or playlist is played only within a certain period of time or weather.',
	            indicatorValues: [values.limitHour, values.limitDate, values.limitDay, values.limitMonth, values.limitWeather] },
	          renderHeading('View during time of day', renderToggle('limitHourStartEnd')),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: HOUR_OF_DAY_ARRAY,
	            selected: values.limitHour,
	            onChange: function onChange(array) {
	              return update('limitHour', array);
	            }
	          }),
	          renderHeading('View during day of month', renderToggle('limitDateStartEnd')),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: DATE_ARRAY,
	            selected: values.limitDate,
	            onChange: function onChange(array) {
	              return update('limitDate', array);
	            }
	          }),
	          renderHeading('View during day of week', renderToggle('limitDayStartEnd')),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: DAY_ARRAY,
	            selected: values.limitDay,
	            onChange: function onChange(array) {
	              return update('limitDay', array);
	            }
	          }),
	          renderHeading('View during month', renderToggle('limitMonthStartEnd')),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: _constants.MONTH_ARRAY,
	            selected: values.limitMonth,
	            onChange: function onChange(array) {
	              return update('limitMonth', array);
	            }
	          }),
	          renderHeading('View during weather'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: _constants.WEATHER_ARRAY,
	            selected: values.limitWeather,
	            onChange: function onChange(array) {
	              return update('limitWeather', array);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _ToggleForm2.default,
	          {
	            showLabel: 'Apply a fixed schedule',
	            description: 'Schedules allow you to schedule an album or playlist to play at a certain time, or when a certain weather type occurs.',
	            indicatorValues: [values.scheduleHour, values.scheduleDate, values.scheduleDay, values.scheduleMonth, values.scheduleWeather] },
	          renderHeading('Schedule at time of day'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: HOUR_OF_DAY_ARRAY,
	            selected: values.scheduleHour,
	            onChange: function onChange(array) {
	              return update('scheduleHour', array);
	            }
	          }),
	          renderHeading('Schedule on day of month'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: DATE_ARRAY,
	            selected: values.scheduleDate,
	            onChange: function onChange(array) {
	              return update('scheduleDate', array);
	            }
	          }),
	          renderHeading('Schedule on day of week'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: DAY_ARRAY,
	            selected: values.scheduleDay,
	            onChange: function onChange(array) {
	              return update('scheduleDay', array);
	            }
	          }),
	          renderHeading('Schedule on month'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: _constants.MONTH_ARRAY,
	            selected: values.scheduleMonth,
	            onChange: function onChange(array) {
	              return update('scheduleMonth', array);
	            }
	          }),
	          renderHeading('Schedule on weather'),
	          _react2.default.createElement(_ArrayPicker2.default, {
	            array: _constants.WEATHER_ARRAY,
	            selected: values.scheduleWeather,
	            onChange: function onChange(array) {
	              return update('scheduleWeather', array);
	            }
	          })
	        ),
	        showLocationPicker && _react2.default.createElement(
	          'div',
	          null,
	          renderHeading('Set location for dynamic links (if any)'),
	          _react2.default.createElement(
	            'select',
	            {
	              value: values.locationOverride || undefined,
	              onChange: function onChange(e) {
	                return update('locationOverride', e.target.value || undefined);
	              }
	            },
	            _react2.default.createElement(
	              'option',
	              { value: undefined },
	              'Use locations set in albums'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'user' },
	              'Override all with default location (',
	              this.props.userDefaultLocation,
	              ')'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'custom' },
	              'Override all with custom location'
	            )
	          ),
	          values.locationOverride === 'custom' && _react2.default.createElement(_LocationPicker2.default, {
	            value: values.location,
	            onChange: function onChange(value) {
	              return update('location', value);
	            },
	            disabled: !values.locationOverride,
	            hideMap: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ConstraintsForm;
	}(_react.Component);
	
	exports.default = ConstraintsForm;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChannelInfo = __webpack_require__(835);
	
	var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChannelInfo = function (_Component) {
	  _inherits(ChannelInfo, _Component);
	
	  function ChannelInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChannelInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChannelInfo.__proto__ || Object.getPrototypeOf(ChannelInfo)).call.apply(_ref, [this].concat(args))), _this), _this.renderPlaylist = function (playlist, playlistIndex) {
	      var albums = playlist.albums.filter(function (album) {
	        return !album._temporary && (album._state === 'present' || album._state === 'skipped');
	      });
	      if (albums.length === 0) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _ChannelInfo2.default.heading },
	          playlist.name
	        ),
	        albums.map(function (album, index) {
	          return _this.renderAlbum(album, index, playlistIndex);
	        })
	      );
	    }, _this.renderAlbum = function (album, albumIndex, playlistIndex) {
	      var _this$props = _this.props,
	          getImageSource = _this$props.getImageSource,
	          onSkip = _this$props.onSkip,
	          onUnskip = _this$props.onUnskip;
	
	      var skipped = album._state === 'skipped';
	      var conflicts = _this.props.conflicts.filter(function (c) {
	        return c.playlist === playlistIndex && c.album === albumIndex;
	      }).map(function (c) {
	        return c.conflict;
	      });
	      var external = album._temporary;
	      return _react2.default.createElement(
	        'div',
	        { key: album._id, className: _ChannelInfo2.default.album },
	        _react2.default.createElement('div', { className: _ChannelInfo2.default.albumThumb, style: { backgroundImage: 'url(' + getImageSource(album.cover) + ')' } }),
	        _react2.default.createElement(
	          'div',
	          { className: _ChannelInfo2.default.albumInfo },
	          album.name,
	          _react2.default.createElement(
	            'div',
	            { className: _ChannelInfo2.default.albumCount },
	            album._total_images,
	            ' photos',
	            external && ', added via Play Next'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            conflicts.map(_this.renderConflict)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _ChannelInfo2.default.tools },
	          _this.props.isOwner && _react2.default.createElement(
	            'button',
	            { onClick: skipped ? onUnskip : onSkip, value: album._id },
	            skipped ? 'Unskip' : external ? 'Remove' : 'Skip'
	          )
	        )
	      );
	    }, _this.renderReason = function (reason) {
	      return _react2.default.createElement(
	        'li',
	        { key: reason, className: _ChannelInfo2.default.reason },
	        reason
	      );
	    }, _this.renderConflict = function (conflict) {
	      return _react2.default.createElement(
	        'li',
	        { key: conflict, className: _ChannelInfo2.default.conflict },
	        conflict
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChannelInfo, [{
	    key: 'filterAlbums',
	    value: function filterAlbums(fn) {
	      var albums = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.props.data.playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var playlist = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = playlist.albums[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var album = _step2.value;
	
	              if (fn(album)) {
	                albums.push(album);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return albums;
	    }
	  }, {
	    key: 'renderPlayNow',
	    value: function renderPlayNow() {
	      // let albums = this.filterAlbums(album => album._origin === 'play_now')
	      // if (albums.length === 0) {
	      //   albums = this.filterAlbums(album => album._state === 'playing')
	      // }
	      var albums = this.filterAlbums(function (album) {
	        return album._state === 'playing';
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _ChannelInfo2.default.mainHeading },
	          'Now playing'
	        ),
	        albums.length === 0 ? 'None' : albums.map(this.renderAlbum)
	      );
	    }
	  }, {
	    key: 'renderPlayNext',
	    value: function renderPlayNext() {
	      var albums = this.filterAlbums(function (album) {
	        return album._temporary && album._state !== 'playing';
	      });
	      if (albums.length === 0) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        albums.map(this.renderAlbum)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.data) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      var _props = this.props,
	          data = _props.data,
	          padded = _props.padded;
	
	      var upNext = this.renderPlayNext();
	      return _react2.default.createElement(
	        'div',
	        { className: padded ? _ChannelInfo2.default.paddedWrapper : _ChannelInfo2.default.wrapper },
	        this.renderPlayNow(),
	        upNext && _react2.default.createElement(
	          'div',
	          { className: _ChannelInfo2.default.mainHeading },
	          'Up next'
	        ),
	        upNext,
	        data.playlists.map(this.renderPlaylist)
	      );
	    }
	  }]);
	
	  return ChannelInfo;
	}(_react.Component);
	
	exports.default = ChannelInfo;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getShareTimeLeft = getShareTimeLeft;
	exports.getShareDaysLeft = getShareDaysLeft;
	exports.extendShare = extendShare;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _ExternalShares = __webpack_require__(357);
	
	var _ExternalShares2 = _interopRequireDefault(_ExternalShares);
	
	var _share = __webpack_require__(87);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EmptyNotice = __webpack_require__(127);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	var _string = __webpack_require__(16);
	
	var _auth = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalShares = function (_Component) {
	  _inherits(ExternalShares, _Component);
	
	  function ExternalShares() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ExternalShares);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExternalShares.__proto__ || Object.getPrototypeOf(ExternalShares)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedCode: 'your_code_here',
	      sortBy: 'external_id',
	      sortDesc: false
	    }, _this.getName = function (id) {
	      var entities = _this.props.entities;
	
	      if (entities.users[id]) {
	        return entities.users[id].name;
	      }
	      return 'Unknown';
	    }, _this.sortShares = function (a, b) {
	      var _this$state = _this.state,
	          sortBy = _this$state.sortBy,
	          sortDesc = _this$state.sortDesc;
	
	      var compareA = sortBy === 'duration' ? getShareTimeLeft(a) : a[sortBy];
	      var compareB = sortBy === 'duration' ? getShareTimeLeft(b) : b[sortBy];
	      if (sortDesc) {
	        return compareA > compareB ? -1 : 1;
	      }
	      return compareA > compareB ? 1 : -1;
	    }, _this.renderShare = function (share) {
	      var creationDate = new Date(share.created_at);
	      var timeLeft = getShareTimeLeft(share);
	      var onClickDelete = function onClickDelete() {
	        return _this.props.deleteExternalShare(share.external_id);
	      };
	      var onClickExtend = function onClickExtend() {
	        return extendShare(share, timeLeft, _this.props.setExternalShareDuration);
	      };
	      var onClickSuspend = function onClickSuspend() {
	        return _this.props.setExternalShareDuration(share.external_id, null);
	      };
	      return _react2.default.createElement(
	        'tr',
	        { key: share.external_id },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this.setState({ selectedCode: share.external_id });
	              } },
	            share.external_id
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: share.path },
	            share.path
	          )
	        ),
	        _this.props.isAdmin && _react2.default.createElement(
	          'td',
	          null,
	          _this.getName(share.user_id)
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          (0, _dateformat2.default)(creationDate, 'HH:MM, d mmm yyyy')
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          getShareDaysLeft(timeLeft)
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _this.props.canExtend && _react2.default.createElement(
	            'button',
	            { onClick: onClickExtend, className: _ExternalShares2.default.button },
	            timeLeft === Infinity ? 'Reset' : 'Extend'
	          ),
	          _this.props.canSuspend && _react2.default.createElement(
	            'button',
	            { onClick: onClickSuspend, className: _ExternalShares2.default.button, disabled: timeLeft === Infinity },
	            'Suspend'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: onClickDelete, className: _ExternalShares2.default.deleteButton },
	            'Delete'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ExternalShares, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetchExternalShares();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          fetching = _props.fetching,
	          error = _props.error,
	          fetchExternalShares = _props.fetchExternalShares;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching external share codes',
	          onRetry: fetchExternalShares
	        });
	      }
	
	      if (!data || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: _ExternalShares2.default.page },
	          _react2.default.createElement(_EmptyNotice2.default, {
	            heading: 'You have no external shares',
	            text: 'Anything you share externally will appear here.'
	          })
	        );
	      }
	
	      var _window$location = window.location,
	          protocol = _window$location.protocol,
	          host = _window$location.host;
	
	
	      var setSort = function setSort(value) {
	        return function () {
	          return _this2.setState({
	            sortBy: value,
	            sortDesc: _this2.state.sortBy === value && !_this2.state.sortDesc
	          });
	        };
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ExternalShares2.default.page },
	        _react2.default.createElement(
	          'table',
	          { className: _ExternalShares2.default.table },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { onClick: setSort('external_id') },
	                'Code'
	              ),
	              _react2.default.createElement(
	                'th',
	                { onClick: setSort('path') },
	                'Path'
	              ),
	              this.props.isAdmin && _react2.default.createElement(
	                'th',
	                { onClick: setSort('user_id') },
	                'Created By'
	              ),
	              _react2.default.createElement(
	                'th',
	                { onClick: setSort('created_at') },
	                'Created'
	              ),
	              _react2.default.createElement(
	                'th',
	                { onClick: setSort('duration') },
	                'Expires'
	              ),
	              _react2.default.createElement('th', null)
	            ),
	            data.sort(this.sortShares).map(this.renderShare)
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Click a code to display the full link below',
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: _ExternalShares2.default.code,
	            value: protocol + '//' + host + '/share/' + this.state.selectedCode,
	            onClick: function onClick(e) {
	              return e.target.setSelectionRange(0, 9999);
	            },
	            readOnly: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ExternalShares;
	}(_react.Component);
	
	function getShareTimeLeft(share) {
	  if (!share.duration) {
	    return Infinity;
	  }
	  var creationDate = new Date(share.created_at);
	  var expiryDate = new Date(creationDate.getTime() + share.duration * 1000);
	  return Math.max(0, expiryDate - new Date());
	}
	
	function getShareDaysLeft(timeLeft) {
	  if (timeLeft === Infinity) {
	    return 'Never';
	  }
	  var days = Math.round(timeLeft / (1000 * 60 * 60 * 24));
	  if (days > 0) {
	    return (0, _string.pluralize)(Math.max(1, days), 'day');
	  }
	  return 'Expired';
	}
	
	// TODO: should probably be in redux action
	function extendShare(share, timeLeft, setExternalShareDuration) {
	  // Add one week to duration
	  var newDuration = share.duration + 604800;
	  if (!timeLeft || timeLeft === Infinity) {
	    // Share is expired
	    // Calculate new duration so that expiry is one week from now
	    var secondsDifference = Math.round((new Date().getTime() - new Date(share.created_at)) / 1000);
	    newDuration = secondsDifference + 604800;
	  }
	  setExternalShareDuration(share.external_id, newDuration);
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth,
	      share = _ref2.share,
	      users = _ref2.users,
	      entities = _ref2.entities;
	  return {
	    data: share.external.data,
	    fetching: share.external.fetching,
	    error: share.external.error,
	    entities: entities,
	    isAdmin: (0, _auth.userHasPerm)(auth.user, 'admin'),
	    canExtend: (0, _auth.userHasPerm)(auth.user, 'extend_external_share') || (0, _auth.userHasPerm)(auth.user, 'admin'),
	    canSuspend: (0, _auth.userHasPerm)(auth.user, 'admin')
	  };
	};
	
	var mapDispatchToProps = {
	  fetchExternalShares: _share.fetchExternalShares,
	  deleteExternalShare: _share.deleteExternalShare,
	  setExternalShareDuration: _share.setExternalShareDuration
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExternalShares);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.filterAlbums = filterAlbums;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _List = __webpack_require__(858);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _playlists = __webpack_require__(43);
	
	var _albums = __webpack_require__(41);
	
	var _share = __webpack_require__(87);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _images = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LIST_NAMES = {
	  all: 'All Albums',
	  favourites: 'Favourite Albums',
	  shared: 'Shared With Me',
	  recent: 'Recent'
	};
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      sortBy: 'name',
	      sortDesc: false
	    }, _this.sortAlbums = function (a, b) {
	      var _this$state = _this.state,
	          sortBy = _this$state.sortBy,
	          sortDesc = _this$state.sortDesc;
	
	      if (sortDesc) {
	        return a[sortBy] > b[sortBy] ? -1 : 1;
	      }
	      return a[sortBy] > b[sortBy] ? 1 : -1;
	    }, _this.renderAlbum = function (album) {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          getImageSource = _this$props.getImageSource,
	          getAlbumInfo = _this$props.getAlbumInfo,
	          unshareAlbum = _this$props.unshareAlbum,
	          me = _this$props.me;
	
	      var info = getAlbumInfo(album);
	      return _react2.default.createElement(
	        'li',
	        { key: album.id, className: _List2.default.album },
	        _react2.default.createElement('div', {
	          className: _List2.default.thumb,
	          style: { backgroundImage: 'url(' + getImageSource(album.cover) + ')' }
	        }),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/album/' + album.id, className: _List2.default.name },
	          album.name,
	          info && _react2.default.createElement(
	            'div',
	            { className: _List2.default.info },
	            info
	          )
	        ),
	        params.id === 'shared' && album.user_id !== me.id && _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return unshareAlbum(album.id, me.id);
	            }, className: _List2.default.button },
	          _react2.default.createElement(_Icon2.default, { icon: 'close' })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(List, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          shouldFetchLists = _props.shouldFetchLists,
	          fetchPlaylists = _props.fetchPlaylists,
	          shouldFetchAlbums = _props.shouldFetchAlbums,
	          fetchAlbums = _props.fetchAlbums;
	
	      if (shouldFetchLists) fetchPlaylists();
	      if (shouldFetchAlbums) fetchAlbums();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          list = _props2.list,
	          name = _props2.name,
	          listAlbums = _props2.listAlbums,
	          error = _props2.error,
	          fetchPlaylists = _props2.fetchPlaylists,
	          fetchAlbums = _props2.fetchAlbums;
	
	      if (error.lists) {
	        return _react2.default.createElement(_ErrorMessage2.default, { message: 'List could not be loaded', onRetry: fetchPlaylists });
	      }
	      if (error.albums) {
	        return _react2.default.createElement(_ErrorMessage2.default, { message: 'Albums could not be loaded', onRetry: fetchAlbums });
	      }
	      if (!listAlbums) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      var setSort = function setSort(value) {
	        return function () {
	          return _this2.setState({
	            sortBy: value,
	            sortDesc: _this2.state.sortBy === value && !_this2.state.sortDesc
	          });
	        };
	      };
	      var sortStyle = function sortStyle(value) {
	        return _this2.state.sortBy === value ? { textDecoration: 'underline' } : null;
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: _List2.default.page },
	        list && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/groups/' + list.id, className: _List2.default.editButton },
	          'Edit group'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: '12px', margin: '5px 0' } },
	          'Sort by:',
	          ' ',
	          _react2.default.createElement(
	            'button',
	            { style: sortStyle('name'), onClick: setSort('name') },
	            'Name'
	          ),
	          ' · ',
	          _react2.default.createElement(
	            'button',
	            { style: sortStyle('created_at'), onClick: setSort('created_at') },
	            'Creation Date'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          listAlbums.sort(this.sortAlbums).map(this.renderAlbum)
	        )
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var entities = _ref2.entities,
	      albums = _ref2.albums,
	      auth = _ref2.auth,
	      playlists = _ref2.playlists;
	  var params = _ref3.params;
	
	  var list = entities.playlists[params.id];
	  var name = void 0;
	  var listAlbums = void 0;
	  if (list) {
	    name = list.name;
	    listAlbums = JSON.parse(list.json_data).albums.map(function (i) {
	      return entities.albums[i.album];
	    }).filter(function (a) {
	      return a;
	    });
	  } else if (albums.all.data && albums.favourites.data) {
	    name = LIST_NAMES[params.id];
	    listAlbums = filterAlbums(params.id, albums, entities, auth);
	  }
	  return {
	    list: list,
	    name: name,
	    listAlbums: listAlbums,
	    shouldFetchLists: /^\d+$/.test(params.id) && !list,
	    shouldFetchAlbums: !albums.all.data,
	    error: {
	      lists: playlists.error,
	      albums: albums.all.error
	    },
	    getImageSource: (0, _images.createImageGetter)(auth),
	    getAlbumInfo: function getAlbumInfo(album) {
	      if (album.user_id === auth.user.id || !entities.users[album.user_id]) {
	        return null;
	      }
	      var user = entities.users[album.user_id];
	      return 'Shared by ' + user.name;
	    },
	    me: auth.user
	  };
	};
	
	function filterAlbums(id, albums, entities, auth) {
	  if (!albums.all.data || !albums.favourites.data) {
	    return [];
	  }
	  var denormalize = function denormalize(id) {
	    return entities.albums[id];
	  };
	  var all = albums.all.data.map(denormalize);
	  var mine = all.filter(function (a) {
	    return a.user_id === auth.user.id;
	  });
	  if (id === 'favourites') {
	    return [].concat(_toConsumableArray(mine.filter(function (a) {
	      return a.favourite;
	    })), _toConsumableArray(albums.favourites.data.map(denormalize)));
	  }
	  if (id === 'all') {
	    return mine;
	  }
	  if (id === 'shared') {
	    return [].concat(_toConsumableArray(mine.filter(function (a) {
	      return a.image_share;
	    })), _toConsumableArray(all.filter(function (a) {
	      return a.user_id !== auth.user.id;
	    })));
	  }
	  if (id === 'recent') {
	    return all.filter(filterRecent).sort(sortRecent);
	  }
	}
	
	function filterRecent(album) {
	  var date = new Date();
	  date.setDate(date.getDate() - 7);
	  return new Date(album.created_at) > date || new Date(album.updated_at) > date;
	}
	
	function sortRecent(a, b) {
	  a = a.updated_at || a.created_at;
	  b = b.updated_at || b.created_at;
	  return new Date(b) - new Date(a);
	}
	
	var mapDispatchToProps = {
	  fetchAlbums: _albums.fetchAlbums,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  unshareAlbum: _share.unshareAlbum
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.toggleNav = toggleNav;
	exports.closeNav = closeNav;
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var NAV_TOGGLE = 'blayzr/nav/TOGGLE';
	var NAV_CLOSE = 'blayzr/nav/CLOSE';
	
	var initialState = {
	  open: false
	};
	
	var previousPath = void 0;
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case NAV_TOGGLE:
	      return _extends({}, state, {
	        open: !state.open
	      });
	    case NAV_CLOSE:
	      return _extends({}, state, {
	        open: false
	      });
	    case _reactRouterRedux.LOCATION_CHANGE:
	      var newState = _extends({}, state, {
	        open: false,
	        previousPath: previousPath // Note we are using the previously set path here..
	      });
	      previousPath = payload.pathname; // and then setting the new path as the previous one here
	      return newState;
	    default:
	      return state;
	  }
	}
	
	function toggleNav() {
	  return {
	    type: NAV_TOGGLE
	  };
	}
	
	function closeNav() {
	  return {
	    type: NAV_CLOSE
	  };
	}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.fetchPerms = fetchPerms;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	var FETCH_PERMS_REQUEST = 'blayzr/perms/REQUEST';
	var FETCH_PERMS_SUCCESS = 'blayzr/perms/SUCCESS';
	var FETCH_PERMS_FAILURE = 'blayzr/perms/FAIL';
	
	var initialState = {
	  data: null,
	  fetching: false,
	  error: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case FETCH_PERMS_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case FETCH_PERMS_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload.records
	      });
	    case FETCH_PERMS_FAILURE:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload.error
	      });
	    default:
	      return state;
	  }
	}
	
	function fetchPermsRequest() {
	  return {
	    type: FETCH_PERMS_REQUEST
	  };
	}
	
	function fetchPermsSuccess(data) {
	  return {
	    type: FETCH_PERMS_SUCCESS,
	    payload: data
	  };
	}
	
	function fetchPermsFailure(error) {
	  return {
	    type: FETCH_PERMS_FAILURE,
	    payload: { error: error }
	  };
	}
	
	function fetchPerms() {
	  return function (dispatch, getState) {
	    var options = {
	      token: getState().auth.token
	    };
	    dispatch(fetchPermsRequest());
	    (0, _fetch.fetch)(_constants.ENDPOINT_PERMS, options, dispatch).then(function (data) {
	      dispatch(fetchPermsSuccess(data));
	    }, function (e) {
	      dispatch(fetchPermsFailure(e));
	    });
	  };
	}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(51);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(97);
	var toLength = __webpack_require__(21);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(90);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(33);
	var toObject = __webpack_require__(29);
	var IObject = __webpack_require__(131);
	var toLength = __webpack_require__(21);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(33);
	var isObject = __webpack_require__(12);
	var invoke = __webpack_require__(325);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(27).f;
	var create = __webpack_require__(91);
	var redefineAll = __webpack_require__(95);
	var ctx = __webpack_require__(53);
	var anInstance = __webpack_require__(89);
	var forOf = __webpack_require__(90);
	var $iterDefine = __webpack_require__(225);
	var step = __webpack_require__(328);
	var setSpecies = __webpack_require__(96);
	var DESCRIPTORS = __webpack_require__(24);
	var fastKey = __webpack_require__(81).fastKey;
	var validate = __webpack_require__(99);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(110);
	var from = __webpack_require__(317);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(95);
	var getWeak = __webpack_require__(81).getWeak;
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(12);
	var anInstance = __webpack_require__(89);
	var forOf = __webpack_require__(90);
	var createArrayMethod = __webpack_require__(60);
	var $has = __webpack_require__(44);
	var validate = __webpack_require__(99);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(158);
	var isObject = __webpack_require__(12);
	var toLength = __webpack_require__(21);
	var ctx = __webpack_require__(53);
	var IS_CONCAT_SPREADABLE = __webpack_require__(18)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(24) && !__webpack_require__(11)(function () {
	  return Object.defineProperty(__webpack_require__(218)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(12);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(6);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(227);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(24);
	var getKeys = __webpack_require__(93);
	var gOPS = __webpack_require__(162);
	var pIE = __webpack_require__(132);
	var toObject = __webpack_require__(29);
	var IObject = __webpack_require__(131);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(11)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(27);
	var anObject = __webpack_require__(6);
	var getKeys = __webpack_require__(93);
	
	module.exports = __webpack_require__(24) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(47);
	var gOPN = __webpack_require__(92).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(44);
	var toIObject = __webpack_require__(47);
	var arrayIndexOf = __webpack_require__(155)(false);
	var IE_PROTO = __webpack_require__(232)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(24);
	var getKeys = __webpack_require__(93);
	var toIObject = __webpack_require__(47);
	var isEnum = __webpack_require__(132).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(92);
	var gOPS = __webpack_require__(162);
	var anObject = __webpack_require__(6);
	var Reflect = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat;
	var $trim = __webpack_require__(113).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(235) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt;
	var $trim = __webpack_require__(113).trim;
	var ws = __webpack_require__(235);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(12);
	var newPromiseCapability = __webpack_require__(229);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(21);
	var repeat = __webpack_require__(234);
	var defined = __webpack_require__(61);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(55);
	var toLength = __webpack_require__(21);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(18);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(320);
	var validate = __webpack_require__(99);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(156)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(230);
	__webpack_require__(2)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(24) && /./g.flags != 'g') __webpack_require__(27).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(130)
	});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(320);
	var validate = __webpack_require__(99);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(156)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var each = __webpack_require__(60)(0);
	var redefine = __webpack_require__(37);
	var meta = __webpack_require__(81);
	var assign = __webpack_require__(332);
	var weak = __webpack_require__(322);
	var isObject = __webpack_require__(12);
	var validate = __webpack_require__(99);
	var NATIVE_WEAK_MAP = __webpack_require__(99);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(156)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var emptyObject = __webpack_require__(172);
	var _invariant = __webpack_require__(7);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(169));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_1OZl3","item":"_1L6TD","icon":"_3jNxQ","collapseIcon":"_3sx52 _3jNxQ","button":"_2zVIn","buttonActive":"_34SHw _2zVIn","buttonExcluded":"_1bdTv _2zVIn","numberInput":"_1IRBY","numberInputRed":"o9fvg _1IRBY","titleInput":"_1oo7z","oldAlert":"_3ZVUj","newAlert":"_2tJRy _3ZVUj","resolveAlert":"_3ZDYP _3ZVUj","selectedAlert":"_2x812 _3ZVUj","percent":"_3urm8 _3ZVUj","percentGroup":"_21Ypw _3urm8 _3ZVUj","header":"wpT_s","headerFloating":"_2YkzO wpT_s","info":"_1zdxZ","specialSelect":"_33RV1 _3ZVUj","refreshButton":"_2Tp9i","synonyms":"_1lrZh","tags":"_3iJk3"};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_334s1","input":"_20hZC","autoComplete":"_1Xgjk","autoCompleteHeading":"_1PPZB","autoCompleteItem":"_1N3cK","cover":"_3rs-7","addAlbumCover":"Vy9eP _3rs-7","meta":"WC4Ya","clearButton":"_3xPmm"};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"picker":"_170Q7","pickerDisabled":"_1Qtmj","map":"_8ZQRX","currentLocation":"_3RQyn","searchLabel":"w5_J8","radiusLabel":"NAO8_","searchWrapper":"_10-vc","resultList":"_3lX1I","resultItem":"_1i5uC","resultButton":"_3jxmZ","spinner":"_4iFsm","noMargin":"xNdgo"};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_28WJZ","table":"_2moCo","button":"_3XaY7","deleteButton":"_2k8vB _3XaY7"};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"saveButton":"_25bP2","page":"_3Oajo","heading":"rJ2_f","addAlbumButton":"_7dfxp","buttons":"_3IVBU","cancelButton":"_3uLdo _25bP2","deleteButton":"_3mu7a _3uLdo _25bP2","previewButton":"_29tko","spinner":"_3ooNi","conflict":"_2H3Vp","column":"_2OHs-","count":"_2sPur","pickerWrapper":"_3Rz3D","pickerWrapperNoAlbums":"_2ECjM _3Rz3D","intro":"_3m4bO","simpleAlbum":"r2YEv","textLink":"_36k5l","conflictCheckButton":"_3mGB5","numberInput":"_2uETX"};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(249);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(430);
	
	var _runTransitionHook = __webpack_require__(249);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(115);
	
	var _PathUtils = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(194);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = function humanizeList (list, options) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('humanize-list expected an array')
	  }
	
	  options = options || {}
	  options.conjunction = options.conjunction || 'and'
	
	  var listLength = list.length
	
	  if (listLength === 1) {
	    return list[0]
	  }
	
	  if (options.skipConjunction) {
	    return list.join(', ')
	  }
	
	  var humanizedList = ''
	  for (var i = 0; i < listLength; i++) {
	    if (i === listLength - 1) {
	      if (options.oxfordComma) {
	        humanizedList += ','
	      }
	
	      humanizedList += ' ' + options.conjunction + ' '
	    } else if (i !== 0) {
	      humanizedList += ', '
	    }
	
	    humanizedList += list[i]
	  }
	
	  return humanizedList
	}


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(25);
	var support = __webpack_require__(83);
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input) {
	    var output = [];
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0, len = input.length, remainingBytes = len;
	
	    var isArray = utils.getTypeOf(input) !== "string";
	    while (i < input.length) {
	        remainingBytes = len - i;
	
	        if (!isArray) {
	            chr1 = input.charCodeAt(i++);
	            chr2 = i < len ? input.charCodeAt(i++) : 0;
	            chr3 = i < len ? input.charCodeAt(i++) : 0;
	        } else {
	            chr1 = input[i++];
	            chr2 = i < len ? input[i++] : 0;
	            chr3 = i < len ? input[i++] : 0;
	        }
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
	        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;
	
	        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));
	
	    }
	
	    return output.join("");
	};
	
	// public method for decoding
	exports.decode = function(input) {
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0, resultIndex = 0;
	
	    var dataUrlPrefix = "data:";
	
	    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
	        // This is a common error: people give a data url
	        // (data:image/png;base64,iVBOR...) with a {base64: true} and
	        // wonders why things don't work.
	        // We can detect that the string input looks like a data url but we
	        // *can't* be sure it is one: removing everything up to the comma would
	        // be too dangerous.
	        throw new Error("Invalid base64 input, it looks like a data url.");
	    }
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    var totalLength = input.length * 3 / 4;
	    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
	        totalLength--;
	    }
	    if (totalLength % 1 !== 0) {
	        // totalLength is not an integer, the length does not match a valid
	        // base64 content. That can happen if:
	        // - the input is not a base64 content
	        // - the input is *almost* a base64 content, with a extra chars at the
	        //   beginning or at the end
	        // - the input uses a base64 variant (base64url for example)
	        throw new Error("Invalid base64 input, bad content length.");
	    }
	    var output;
	    if (support.uint8array) {
	        output = new Uint8Array(totalLength|0);
	    } else {
	        output = new Array(totalLength|0);
	    }
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output[resultIndex++] = chr1;
	
	        if (enc3 !== 64) {
	            output[resultIndex++] = chr2;
	        }
	        if (enc4 !== 64) {
	            output[resultIndex++] = chr3;
	        }
	
	    }
	
	    return output;
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(48);
	
	exports.STORE = {
	    magic: "\x00\x00",
	    compressWorker : function (compressionOptions) {
	        return new GenericWorker("STORE compression");
	    },
	    uncompressWorker : function () {
	        return new GenericWorker("STORE decompression");
	    }
	};
	exports.DEFLATE = __webpack_require__(899);


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = true;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * This file is used by module bundlers (browserify/webpack/etc) when
	 * including a stream implementation. We use "readable-stream" to get a
	 * consistent behavior between nodejs versions but bundlers often have a shim
	 * for "stream". Using this shim greatly improve the compatibility and greatly
	 * reduce the final size of the bundle (only one stream implementation, not
	 * two).
	 */
	module.exports = __webpack_require__(1237);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(372);
	var utils = __webpack_require__(25);
	
	function ArrayReader(data) {
	    DataReader.call(this, data);
		for(var i = 0; i < this.data.length; i++) {
			data[i] = data[i] & 0xFF;
		}
	}
	utils.inherits(ArrayReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	ArrayReader.prototype.readAndCheckSignature = function (sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3),
	        data = this.readData(4);
	    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(25);
	
	function DataReader(data) {
	    this.data = data; // type : see implementation
	    this.length = data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specified index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurrence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurrence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Read the signature (4 bytes) at the current position and compare it with sig.
	     * @param {string} sig the expected signature
	     * @return {boolean} true if the signature matches, false otherwise.
	     */
	    readAndCheckSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(Date.UTC(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1)); // second
	    }
	};
	module.exports = DataReader;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayReader = __webpack_require__(371);
	var utils = __webpack_require__(25);
	
	function Uint8ArrayReader(data) {
	    ArrayReader.call(this, data);
	}
	utils.inherits(Uint8ArrayReader, ArrayReader);
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	var support = __webpack_require__(83);
	var ArrayReader = __webpack_require__(371);
	var StringReader = __webpack_require__(908);
	var NodeBufferReader = __webpack_require__(907);
	var Uint8ArrayReader = __webpack_require__(373);
	
	/**
	 * Create a reader adapted to the data.
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
	 * @return {DataReader} the data reader.
	 */
	module.exports = function (data) {
	    var type = utils.getTypeOf(data);
	    utils.checkSupport(type);
	    if (type === "string" && !support.uint8array) {
	        return new StringReader(data);
	    }
	    if (type === "nodebuffer") {
	        return new NodeBufferReader(data);
	    }
	    if (support.uint8array) {
	        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
	    }
	    return new ArrayReader(utils.transformTo("array", data));
	};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(48);
	var crc32 = __webpack_require__(253);
	var utils = __webpack_require__(25);
	
	/**
	 * A worker which calculate the crc32 of the data flowing through.
	 * @constructor
	 */
	function Crc32Probe() {
	    GenericWorker.call(this, "Crc32Probe");
	    this.withStreamInfo("crc32", 0);
	}
	utils.inherits(Crc32Probe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	Crc32Probe.prototype.processChunk = function (chunk) {
	    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
	    this.push(chunk);
	};
	module.exports = Crc32Probe;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	
	/**
	 * A worker which calculate the total length of the data flowing through.
	 * @constructor
	 * @param {String} propName the name used to expose the length
	 */
	function DataLengthProbe(propName) {
	    GenericWorker.call(this, "DataLengthProbe for " + propName);
	    this.propName = propName;
	    this.withStreamInfo(propName, 0);
	}
	utils.inherits(DataLengthProbe, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	DataLengthProbe.prototype.processChunk = function (chunk) {
	    if(chunk) {
	        var length = this.streamInfo[this.propName] || 0;
	        this.streamInfo[this.propName] = length + chunk.data.length;
	    }
	    GenericWorker.prototype.processChunk.call(this, chunk);
	};
	module.exports = DataLengthProbe;
	


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	
	// the size of the generated chunks
	// TODO expose this as a public variable
	var DEFAULT_BLOCK_SIZE = 16 * 1024;
	
	/**
	 * A worker that reads a content and emits chunks.
	 * @constructor
	 * @param {Promise} dataP the promise of the data to split
	 */
	function DataWorker(dataP) {
	    GenericWorker.call(this, "DataWorker");
	    var self = this;
	    this.dataIsReady = false;
	    this.index = 0;
	    this.max = 0;
	    this.data = null;
	    this.type = "";
	
	    this._tickScheduled = false;
	
	    dataP.then(function (data) {
	        self.dataIsReady = true;
	        self.data = data;
	        self.max = data && data.length || 0;
	        self.type = utils.getTypeOf(data);
	        if(!self.isPaused) {
	            self._tickAndRepeat();
	        }
	    }, function (e) {
	        self.error(e);
	    });
	}
	
	utils.inherits(DataWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.cleanUp
	 */
	DataWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this.data = null;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	DataWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this._tickScheduled && this.dataIsReady) {
	        this._tickScheduled = true;
	        utils.delay(this._tickAndRepeat, [], this);
	    }
	    return true;
	};
	
	/**
	 * Trigger a tick a schedule an other call to this function.
	 */
	DataWorker.prototype._tickAndRepeat = function() {
	    this._tickScheduled = false;
	    if(this.isPaused || this.isFinished) {
	        return;
	    }
	    this._tick();
	    if(!this.isFinished) {
	        utils.delay(this._tickAndRepeat, [], this);
	        this._tickScheduled = true;
	    }
	};
	
	/**
	 * Read and push a chunk.
	 */
	DataWorker.prototype._tick = function() {
	
	    if(this.isPaused || this.isFinished) {
	        return false;
	    }
	
	    var size = DEFAULT_BLOCK_SIZE;
	    var data = null, nextIndex = Math.min(this.max, this.index + size);
	    if (this.index >= this.max) {
	        // EOF
	        return this.end();
	    } else {
	        switch(this.type) {
	            case "string":
	                data = this.data.substring(this.index, nextIndex);
	            break;
	            case "uint8array":
	                data = this.data.subarray(this.index, nextIndex);
	            break;
	            case "array":
	            case "nodebuffer":
	                data = this.data.slice(this.index, nextIndex);
	            break;
	        }
	        this.index = nextIndex;
	        return this.push({
	            data : data,
	            meta : {
	                percent : this.max ? this.index / this.max * 100 : 0
	            }
	        });
	    }
	};
	
	module.exports = DataWorker;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var utils = __webpack_require__(25);
	var ConvertWorker = __webpack_require__(909);
	var GenericWorker = __webpack_require__(48);
	var base64 = __webpack_require__(367);
	var support = __webpack_require__(83);
	var external = __webpack_require__(136);
	
	var NodejsStreamOutputAdapter = null;
	if (support.nodestream) {
	    try {
	        NodejsStreamOutputAdapter = __webpack_require__(905);
	    } catch(e) {}
	}
	
	/**
	 * Apply the final transformation of the data. If the user wants a Blob for
	 * example, it's easier to work with an U8intArray and finally do the
	 * ArrayBuffer/Blob conversion.
	 * @param {String} type the name of the final type
	 * @param {String|Uint8Array|Buffer} content the content to transform
	 * @param {String} mimeType the mime type of the content, if applicable.
	 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
	 */
	function transformZipOutput(type, content, mimeType) {
	    switch(type) {
	        case "blob" :
	            return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
	        case "base64" :
	            return base64.encode(content);
	        default :
	            return utils.transformTo(type, content);
	    }
	}
	
	/**
	 * Concatenate an array of data of the given type.
	 * @param {String} type the type of the data in the given array.
	 * @param {Array} dataArray the array containing the data chunks to concatenate
	 * @return {String|Uint8Array|Buffer} the concatenated data
	 * @throws Error if the asked type is unsupported
	 */
	function concat (type, dataArray) {
	    var i, index = 0, res = null, totalLength = 0;
	    for(i = 0; i < dataArray.length; i++) {
	        totalLength += dataArray[i].length;
	    }
	    switch(type) {
	        case "string":
	            return dataArray.join("");
	          case "array":
	            return Array.prototype.concat.apply([], dataArray);
	        case "uint8array":
	            res = new Uint8Array(totalLength);
	            for(i = 0; i < dataArray.length; i++) {
	                res.set(dataArray[i], index);
	                index += dataArray[i].length;
	            }
	            return res;
	        case "nodebuffer":
	            return Buffer.concat(dataArray);
	        default:
	            throw new Error("concat : unsupported type '"  + type + "'");
	    }
	}
	
	/**
	 * Listen a StreamHelper, accumulate its content and concatenate it into a
	 * complete block.
	 * @param {StreamHelper} helper the helper to use.
	 * @param {Function} updateCallback a callback called on each update. Called
	 * with one arg :
	 * - the metadata linked to the update received.
	 * @return Promise the promise for the accumulation.
	 */
	function accumulate(helper, updateCallback) {
	    return new external.Promise(function (resolve, reject){
	        var dataArray = [];
	        var chunkType = helper._internalType,
	            resultType = helper._outputType,
	            mimeType = helper._mimeType;
	        helper
	        .on('data', function (data, meta) {
	            dataArray.push(data);
	            if(updateCallback) {
	                updateCallback(meta);
	            }
	        })
	        .on('error', function(err) {
	            dataArray = [];
	            reject(err);
	        })
	        .on('end', function (){
	            try {
	                var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
	                resolve(result);
	            } catch (e) {
	                reject(e);
	            }
	            dataArray = [];
	        })
	        .resume();
	    });
	}
	
	/**
	 * An helper to easily use workers outside of JSZip.
	 * @constructor
	 * @param {Worker} worker the worker to wrap
	 * @param {String} outputType the type of data expected by the use
	 * @param {String} mimeType the mime type of the content, if applicable.
	 */
	function StreamHelper(worker, outputType, mimeType) {
	    var internalType = outputType;
	    switch(outputType) {
	        case "blob":
	        case "arraybuffer":
	            internalType = "uint8array";
	        break;
	        case "base64":
	            internalType = "string";
	        break;
	    }
	
	    try {
	        // the type used internally
	        this._internalType = internalType;
	        // the type used to output results
	        this._outputType = outputType;
	        // the mime type
	        this._mimeType = mimeType;
	        utils.checkSupport(internalType);
	        this._worker = worker.pipe(new ConvertWorker(internalType));
	        // the last workers can be rewired without issues but we need to
	        // prevent any updates on previous workers.
	        worker.lock();
	    } catch(e) {
	        this._worker = new GenericWorker("error");
	        this._worker.error(e);
	    }
	}
	
	StreamHelper.prototype = {
	    /**
	     * Listen a StreamHelper, accumulate its content and concatenate it into a
	     * complete block.
	     * @param {Function} updateCb the update callback.
	     * @return Promise the promise for the accumulation.
	     */
	    accumulate : function (updateCb) {
	        return accumulate(this, updateCb);
	    },
	    /**
	     * Add a listener on an event triggered on a stream.
	     * @param {String} evt the name of the event
	     * @param {Function} fn the listener
	     * @return {StreamHelper} the current helper.
	     */
	    on : function (evt, fn) {
	        var self = this;
	
	        if(evt === "data") {
	            this._worker.on(evt, function (chunk) {
	                fn.call(self, chunk.data, chunk.meta);
	            });
	        } else {
	            this._worker.on(evt, function () {
	                utils.delay(fn, arguments, self);
	            });
	        }
	        return this;
	    },
	    /**
	     * Resume the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    resume : function () {
	        utils.delay(this._worker.resume, [], this._worker);
	        return this;
	    },
	    /**
	     * Pause the flow of chunks.
	     * @return {StreamHelper} the current helper.
	     */
	    pause : function () {
	        this._worker.pause();
	        return this;
	    },
	    /**
	     * Return a nodejs stream for this helper.
	     * @param {Function} updateCb the update callback.
	     * @return {NodejsStreamOutputAdapter} the nodejs stream.
	     */
	    toNodejsStream : function (updateCb) {
	        utils.checkSupport("nodestream");
	        if (this._outputType !== "nodebuffer") {
	            // an object stream containing blob/arraybuffer/uint8array/string
	            // is strange and I don't know if it would be useful.
	            // I you find this comment and have a good usecase, please open a
	            // bug report !
	            throw new Error(this._outputType + " is not supported by this method");
	        }
	
	        return new NodejsStreamOutputAdapter(this, {
	            objectMode : this._outputType !== "nodebuffer"
	        }, updateCb);
	    }
	};
	
	
	module.exports = StreamHelper;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109).Buffer))

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = mapValues;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = mergeWith;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity]
	 *  The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length)
	    ? baseUniq(array, baseIteratee(iteratee, 2))
	    : [];
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = uniqBy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(258),
	    baseLodash = __webpack_require__(259);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177),
	    stackClear = __webpack_require__(1008),
	    stackDelete = __webpack_require__(1009),
	    stackGet = __webpack_require__(1010),
	    stackHas = __webpack_require__(1011),
	    stackSet = __webpack_require__(1012);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(935),
	    keys = __webpack_require__(266);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(396),
	    toKey = __webpack_require__(139);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(947),
	    baseMatchesProperty = __webpack_require__(948),
	    identity = __webpack_require__(185),
	    isArray = __webpack_require__(40),
	    property = __webpack_require__(1027);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(185),
	    overRest = __webpack_require__(1002),
	    setToString = __webpack_require__(412);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(185),
	    metaMap = __webpack_require__(408);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isKey = __webpack_require__(261),
	    stringToPath = __webpack_require__(415),
	    toString = __webpack_require__(268);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(397),
	    composeArgsRight = __webpack_require__(398),
	    countHolders = __webpack_require__(957),
	    createCtor = __webpack_require__(180),
	    createRecurry = __webpack_require__(400),
	    getHolder = __webpack_require__(181),
	    reorder = __webpack_require__(1004),
	    replaceHolders = __webpack_require__(138),
	    root = __webpack_require__(39);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(984),
	    setData = __webpack_require__(411),
	    setWrapToString = __webpack_require__(413);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(394),
	    createBind = __webpack_require__(960),
	    createCurry = __webpack_require__(961),
	    createHybrid = __webpack_require__(399),
	    createPartial = __webpack_require__(962),
	    getData = __webpack_require__(405),
	    mergeData = __webpack_require__(999),
	    setData = __webpack_require__(411),
	    setWrapToString = __webpack_require__(413),
	    toInteger = __webpack_require__(1032);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(925),
	    arraySome = __webpack_require__(389),
	    cacheHas = __webpack_require__(955);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(408),
	    noop = __webpack_require__(421);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(64);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(386);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(404);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)(module)))

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(394),
	    shortOut = __webpack_require__(414);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(951),
	    shortOut = __webpack_require__(414);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(973),
	    insertWrapDetails = __webpack_require__(980),
	    setToString = __webpack_require__(412),
	    updateWrapDetails = __webpack_require__(1014);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(998);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
	    stubFalse = __webpack_require__(1030);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)(module)))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObject = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    getPrototype = __webpack_require__(968),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(945),
	    baseUnary = __webpack_require__(395),
	    nodeUtil = __webpack_require__(409);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(64);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnionSchema = function () {
	  function UnionSchema(itemSchema, options) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('UnionSchema requires item schema to be an object.');
	    }
	
	    if (!options || !options.schemaAttribute) {
	      throw new Error('UnionSchema requires schemaAttribute option.');
	    }
	
	    this._itemSchema = itemSchema;
	
	    var schemaAttribute = options.schemaAttribute;
	    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
	      return x[schemaAttribute];
	    };
	  }
	
	  _createClass(UnionSchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }, {
	    key: 'getSchemaKey',
	    value: function getSchemaKey(item) {
	      return this._getSchema(item);
	    }
	  }]);
	
	  return UnionSchema;
	}();
	
	exports.default = UnionSchema;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(85);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1051);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 429 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1238);
	var objectAssign = __webpack_require__(19);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1168);


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(104);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactInstrumentation = __webpack_require__(58);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1117);
	var warning = __webpack_require__(15);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var LinkedValueUtils = __webpack_require__(276);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(65);
	
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1077);
	
	var containsNode = __webpack_require__(874);
	var focusNode = __webpack_require__(360);
	var getActiveElement = __webpack_require__(361);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var DOMLazyTree = __webpack_require__(119);
	var DOMProperty = __webpack_require__(120);
	var React = __webpack_require__(124);
	var ReactBrowserEventEmitter = __webpack_require__(189);
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactDOMContainerInfo = __webpack_require__(1071);
	var ReactDOMFeatureFlags = __webpack_require__(1073);
	var ReactFeatureFlags = __webpack_require__(438);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactInstrumentation = __webpack_require__(58);
	var ReactMarkupChecksum = __webpack_require__(1087);
	var ReactReconciler = __webpack_require__(121);
	var ReactUpdateQueue = __webpack_require__(279);
	var ReactUpdates = __webpack_require__(65);
	
	var emptyObject = __webpack_require__(172);
	var instantiateReactComponent = __webpack_require__(449);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(193);
	var shouldUpdateReactComponent = __webpack_require__(285);
	var warning = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var React = __webpack_require__(124);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(442);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(28);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var ReactCompositeComponent = __webpack_require__(1068);
	var ReactEmptyComponent = __webpack_require__(437);
	var ReactHostComponent = __webpack_require__(439);
	
	var getNextDebugID = __webpack_require__(1180);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	var escapeTextContentForBrowser = __webpack_require__(192);
	var setInnerHTML = __webpack_require__(193);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var REACT_ELEMENT_TYPE = __webpack_require__(1083);
	
	var getIteratorFn = __webpack_require__(1114);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(275);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(198);
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(297));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(496));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(197));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(199));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(364));
	
	var _invariant = _interopRequireDefault(__webpack_require__(30));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(194);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(1135));
	
	var _PropTypes = __webpack_require__(455);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(456));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(22));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1136));
	
	var _warning = _interopRequireDefault(__webpack_require__(288));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDraggable = __webpack_require__(287);
	
	var _cloneElement = __webpack_require__(1139);
	
	var _cloneElement2 = _interopRequireDefault(_cloneElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Resizable = function (_React$Component) {
	  _inherits(Resizable, _React$Component);
	
	  function Resizable() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Resizable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      resizing: false,
	      width: _this.props.width, height: _this.props.height,
	      slackW: 0, slackH: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Resizable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // If parent changes height/width, set that in our state.
	    if (!this.state.resizing && (nextProps.width !== this.props.width || nextProps.height !== this.props.height)) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  Resizable.prototype.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  };
	
	  // If you do this, be careful of constraints
	
	
	  Resizable.prototype.runConstraints = function runConstraints(width, height) {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	
	
	    if (this.props.lockAspectRatio) {
	      var ratio = this.state.width / this.state.height;
	      height = width / ratio;
	      width = height * ratio;
	    }
	
	    if (!min && !max) return [width, height];
	
	    var oldW = width,
	        oldH = height;
	
	    // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _state = this.state,
	        slackW = _state.slackW,
	        slackH = _state.slackH;
	
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    }
	
	    // If the numbers changed, we must have introduced some slack. Record it for the next iteration.
	    slackW += oldW - width;
	    slackH += oldH - height;
	    if (slackW !== this.state.slackW || slackH !== this.state.slackH) {
	      this.setState({ slackW: slackW, slackH: slackH });
	    }
	
	    return [width, height];
	  };
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	
	
	  Resizable.prototype.resizeHandler = function resizeHandler(handlerName) {
	    var _this2 = this;
	
	    return function (e, _ref2) {
	      var node = _ref2.node,
	          deltaX = _ref2.deltaX,
	          deltaY = _ref2.deltaY;
	
	
	      // Axis restrictions
	      var canDragX = _this2.props.axis === 'both' || _this2.props.axis === 'x';
	      var canDragY = _this2.props.axis === 'both' || _this2.props.axis === 'y';
	
	      // Update w/h
	      var width = _this2.state.width + (canDragX ? deltaX : 0);
	      var height = _this2.state.height + (canDragY ? deltaY : 0);
	
	      // Early return if no change
	      var widthChanged = width !== _this2.state.width,
	          heightChanged = height !== _this2.state.height;
	      if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;
	
	      // Set the appropriate state for this handler.
	      var _runConstraints = _this2.runConstraints(width, height);
	
	      width = _runConstraints[0];
	      height = _runConstraints[1];
	      var newState = {};
	      if (handlerName === 'onResizeStart') {
	        newState.resizing = true;
	      } else if (handlerName === 'onResizeStop') {
	        newState.resizing = false;
	        newState.slackW = newState.slackH = 0;
	      } else {
	        // Early return if no change after constraints
	        if (width === _this2.state.width && height === _this2.state.height) return;
	        newState.width = width;
	        newState.height = height;
	      }
	
	      var hasCb = typeof _this2.props[handlerName] === 'function';
	      if (hasCb) {
	        if (typeof e.persist === 'function') e.persist();
	        _this2.setState(newState, function () {
	          return _this2.props[handlerName](e, { node: node, size: { width: width, height: height } });
	        });
	      } else {
	        _this2.setState(newState);
	      }
	    };
	  };
	
	  Resizable.prototype.render = function render() {
	    // eslint-disable-next-line no-unused-vars
	    var _props = this.props,
	        children = _props.children,
	        draggableOpts = _props.draggableOpts,
	        width = _props.width,
	        height = _props.height,
	        handleSize = _props.handleSize,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        onResize = _props.onResize,
	        onResizeStop = _props.onResizeStop,
	        onResizeStart = _props.onResizeStart,
	        p = _objectWithoutProperties(_props, ['children', 'draggableOpts', 'width', 'height', 'handleSize', 'lockAspectRatio', 'axis', 'minConstraints', 'maxConstraints', 'onResize', 'onResizeStop', 'onResizeStart']);
	
	    var className = p.className ? p.className + ' react-resizable' : 'react-resizable';
	
	    // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // A draggable handle.
	    return (0, _cloneElement2.default)(children, _extends({}, p, {
	      className: className,
	      children: [children.props.children, _react2.default.createElement(
	        _reactDraggable.DraggableCore,
	        _extends({}, draggableOpts, {
	          key: 'resizableHandle',
	          onStop: this.resizeHandler('onResizeStop'),
	          onStart: this.resizeHandler('onResizeStart'),
	          onDrag: this.resizeHandler('onResize')
	        }),
	        _react2.default.createElement('span', { className: 'react-resizable-handle' })
	      )]
	    }));
	  };
	
	  return Resizable;
	}(_react2.default.Component);
	
	Resizable.propTypes = {
	  //
	  // Required Props
	  //
	
	  // Require that one and only one child be present.
	  children: _propTypes2.default.element.isRequired,
	
	  // Initial w/h
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	
	  //
	  // Optional props
	  //
	
	  // If you change this, be sure to update your css
	  handleSize: _propTypes2.default.array,
	
	  // If true, will only allow width/height to move in lockstep
	  lockAspectRatio: _propTypes2.default.bool,
	
	  // Restricts resizing to a particular axis (default: 'both')
	  // 'both' - allows resizing by width or height
	  // 'x' - only allows the width to be changed
	  // 'y' - only allows the height to be changed
	  // 'none' - disables resizing altogether
	  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),
	
	  // Min/max size
	  minConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  maxConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  // Callbacks
	  onResizeStop: _propTypes2.default.func,
	  onResizeStart: _propTypes2.default.func,
	  onResize: _propTypes2.default.func,
	
	  // These will be passed wholesale to react-draggable's DraggableCore
	  draggableOpts: _propTypes2.default.object
	};
	Resizable.defaultProps = {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity]
	};
	exports.default = Resizable;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(291);
	
	var _ContextUtils = __webpack_require__(290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(86);
	
	var _PatternUtils = __webpack_require__(122);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(363);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(362);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(895);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(467);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1154);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1151);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1158);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1155);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1160);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(363);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(362);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Channel = function Channel(data) {
	  _classCallCheck(this, Channel);
	
	  var listeners = [];
	  data = data || {};
	
	  this.subscribe = function (fn) {
	    listeners.push(fn);
	  };
	
	  this.unsubscribe = function (fn) {
	    var idx = listeners.indexOf(fn);
	    if (idx !== -1) listeners.splice(idx, 1);
	  };
	
	  this.update = function (fn) {
	    if (fn) fn(data);
	    listeners.forEach(function (l) {
	      return l(data);
	    });
	  };
	};
	
	exports.default = Channel;
	module.exports = exports['default'];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var TappableMixin = __webpack_require__(1166);
	var PinchableMixin = __webpack_require__(1165);
	var getComponent = __webpack_require__(1167);
	var touchStyles = __webpack_require__(470);
	
	var Component = getComponent([TappableMixin, PinchableMixin]);
	
	module.exports = Component;
	module.exports.touchStyles = touchStyles;
	module.exports.Mixin = _extends({}, TappableMixin, {
	  onPinchStart: PinchableMixin.onPinchStart,
	  onPinchMove: PinchableMixin.onPinchMove,
	  onPinchEnd: PinchableMixin.onPinchEnd
	});

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	var touchStyles = {
	  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	  WebkitTouchCallout: 'none',
	  WebkitUserSelect: 'none',
	  KhtmlUserSelect: 'none',
	  MozUserSelect: 'none',
	  msUserSelect: 'none',
	  userSelect: 'none',
	  cursor: 'pointer'
	};
	
	module.exports = touchStyles;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(146),
	    _assign = __webpack_require__(19);
	
	var ReactNoopUpdateQueue = __webpack_require__(475);
	
	var canDefineProperty = __webpack_require__(476);
	var emptyObject = __webpack_require__(172);
	var invariant = __webpack_require__(7);
	var lowPriorityWarning = __webpack_require__(1181);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(146);
	
	var ReactCurrentOwner = __webpack_require__(75);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(188);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(366);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(241).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(480);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(196).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(135));
	util.inherits = __webpack_require__(116);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1255);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1186);
	var destroyImpl = __webpack_require__(479);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(493).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(493).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(105);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(135));
	util.inherits = __webpack_require__(116);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(188);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(241).EventEmitter;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(793);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SubmissionError).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;
	
	var _actionTypes = __webpack_require__(296);
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
	  return { type: _actionTypes.ARRAY_INSERT, meta: { form: form, field: field, index: index }, payload: value };
	};
	
	var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
	  return { type: _actionTypes.ARRAY_MOVE, meta: { form: form, field: field, from: from, to: to } };
	};
	
	var arrayPop = exports.arrayPop = function arrayPop(form, field) {
	  return { type: _actionTypes.ARRAY_POP, meta: { form: form, field: field } };
	};
	
	var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
	  return { type: _actionTypes.ARRAY_PUSH, meta: { form: form, field: field }, payload: value };
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
	  return { type: _actionTypes.ARRAY_REMOVE, meta: { form: form, field: field, index: index } };
	};
	
	var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return { type: _actionTypes.ARRAY_REMOVE_ALL, meta: { form: form, field: field } };
	};
	
	var arrayShift = exports.arrayShift = function arrayShift(form, field) {
	  return { type: _actionTypes.ARRAY_SHIFT, meta: { form: form, field: field } };
	};
	
	var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
	  return { type: _actionTypes.ARRAY_UNSHIFT, meta: { form: form, field: field }, payload: value };
	};
	
	var blur = exports.blur = function blur(form, field, value, touch) {
	  return { type: _actionTypes.BLUR, meta: { form: form, field: field, touch: touch }, payload: value };
	};
	
	var change = exports.change = function change(form, field, value, touch) {
	  return { type: _actionTypes.CHANGE, meta: { form: form, field: field, touch: touch }, payload: value };
	};
	
	var destroy = exports.destroy = function destroy(form) {
	  return { type: _actionTypes.DESTROY, meta: { form: form } };
	};
	
	var focus = exports.focus = function focus(form, field) {
	  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
	};
	
	var initialize = exports.initialize = function initialize(form, values) {
	  return { type: _actionTypes.INITIALIZE, meta: { form: form }, payload: values };
	};
	
	var registerField = exports.registerField = function registerField(form, name, type) {
	  return { type: _actionTypes.REGISTER_FIELD, meta: { form: form }, payload: { name: name, type: type } };
	};
	
	var reset = exports.reset = function reset(form) {
	  return { type: _actionTypes.RESET, meta: { form: form } };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, meta: { form: form, field: field } };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit(form) {
	  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    fields[_key - 1] = arguments[_key];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_FAILED, meta: { form: form, fields: fields }, error: true };
	};
	
	var touch = exports.touch = function touch(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.TOUCH, meta: { form: form, fields: fields } };
	};
	
	var unregisterField = exports.unregisterField = function unregisterField(form, name) {
	  return { type: _actionTypes.UNREGISTER_FIELD, meta: { form: form }, payload: { name: name } };
	};
	
	var untouch = exports.untouch = function untouch(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return { type: _actionTypes.UNTOUCH, meta: { form: form, fields: fields } };
	};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, value) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, value);
	  };
	};
	
	exports.default = createOnDragStart;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(485);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target;
	    var type = _event$target.type;
	    var value = _event$target.value;
	    var checked = _event$target.checked;
	    var files = _event$target.files;
	    var dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (type === 'number' || type === 'range') {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(485);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(187);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getInWithPath = function getInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (!state) {
	    return state;
	  }
	  var next = state[first];
	  return rest.length ? getInWithPath.apply(undefined, [next].concat(rest)) : next;
	};
	
	var getIn = function getIn(state, field) {
	  return getInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = getIn;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(419);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1239);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v3.3.3 - 2018-09-04
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(196).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	!function(t,e){"object"==typeof module&&module.exports?module.exports=e(t):t.timeago=e(t)}("undefined"!=typeof window?window:this,function(){function t(t){return t instanceof Date?t:isNaN(t)?/^\d+$/.test(t)?new Date(e(t)):(t=(t||"").trim().replace(/\.\d+/,"").replace(/-/,"/").replace(/-/,"/").replace(/(\d)T(\d)/,"$1 $2").replace(/Z/," UTC").replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"),new Date(t)):new Date(e(t))}function e(t){return parseInt(t)}function n(t,n,r){n=d[n]?n:d[r]?r:"en";var i=0,a=t<0?1:0;for(t=Math.abs(t);t>=l[i]&&i<h;i++)t/=l[i];return t=e(t),i*=2,t>(0===i?9:1)&&(i+=1),d[n](t,i)[a].replace("%s",t)}function r(e,n){return n=n?t(n):new Date,(n-t(e))/1e3}function i(t){for(var e=1,n=0,r=Math.abs(t);t>=l[n]&&n<h;n++)t/=l[n],e*=l[n];return r%=e,r=r?e-r:e,Math.ceil(r)}function a(t){return t.dataset.timeago?t.dataset.timeago:t.getAttribute?t.getAttribute(p):t.attr?t.attr(p):void 0}function o(t,e){function o(a,c,f,s){var d=r(c,t);a.innerHTML=n(d,f,e),u["k"+s]=setTimeout(function(){o(a,c,f,s)},Math.min(1e3*i(d),2147483647))}var u={};return e||(e="en"),this.format=function(i,a){return n(r(i,t),a,e)},this.render=function(t,e){void 0===t.length&&(t=[t]);for(var n=0;n<t.length;n++)o(t[n],a(t[n]),e,++c)},this.cancel=function(){for(var t in u)clearTimeout(u[t]);u={}},this.setLocale=function(t){e=t},this}function u(t,e){return new o(t,e)}var c=0,f="second_minute_hour_day_week_month_year".split("_"),s="秒_分钟_小时_天_周_月_年".split("_"),d={en:function(t,e){if(0===e)return["just now","right now"];var n=f[parseInt(e/2)];return t>1&&(n+="s"),[t+" "+n+" ago","in "+t+" "+n]},zh_CN:function(t,e){if(0===e)return["刚刚","片刻后"];var n=s[parseInt(e/2)];return[t+n+"前",t+n+"后"]}},l=[60,60,24,7,365/7/12,12],h=6,p="datetime";return u.register=function(t,e){d[t]=e},u});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1234);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(431);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _banners = __webpack_require__(67);
	
	var _Banners = __webpack_require__(796);
	
	var _Banners2 = _interopRequireDefault(_Banners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banners = function (_Component) {
	  _inherits(Banners, _Component);
	
	  function Banners() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Banners);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Banners.__proto__ || Object.getPrototypeOf(Banners)).call.apply(_ref, [this].concat(args))), _this), _this.renderBanner = function (_ref2) {
	      var id = _ref2.id,
	          text = _ref2.text;
	
	      var onClick = function onClick() {
	        return _this.props.hideBanner(id);
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: id, className: _Banners2.default.banner, onClick: onClick },
	        text
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Banners, [{
	    key: 'render',
	    value: function render() {
	      var banners = this.props.banners;
	
	      var transitionName = {
	        enter: _Banners2.default.enter,
	        enterActive: _Banners2.default.enterActive,
	        leave: _Banners2.default.leave,
	        leaveActive: _Banners2.default.leaveActive
	      };
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          className: _Banners2.default.banners,
	          component: 'ul',
	          transitionName: transitionName,
	          transitionEnterTimeout: 500,
	          transitionLeaveTimeout: 700 },
	        banners.map(this.renderBanner)
	      );
	    }
	  }]);
	
	  return Banners;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var banners = _ref3.banners;
	  return {
	    banners: banners
	  };
	};
	
	var mapDispatchToProps = {
	  hideBanner: _banners.hideBanner
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Banners);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Header = __webpack_require__(803);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MATCH_LOGIN_PATH = /^\/?(login|share\/)/;
	var MATCH_BACK_PATH = /^\/?(image|timeline|queues|playlists|groups?)\/.+/;
	var MATCH_QUEUES = /^\/?queues\/.+/;
	var MATCH_PLAYLISTS = /^\/?playlists\/.+/;
	var MATCH_CHANNELS = /^\/?channels\/.+/;
	var MATCH_ALBUM_PATH = /^\/?album[^s]?/;
	var MATCH_ALBUM_LIST_PATH = /^\/?list\/.+/;
	var MATCH_ALBUM_EDIT_PATH = /^\/?album\/.+\/edit$/;
	var MATCH_SEARCH_PATH = /^\/?search$/;
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	
	      var className = _Header2.default.header;
	      if (props.path === '/') {
	        className = _Header2.default.headerHome;
	      }
	      if (MATCH_ALBUM_PATH.test(props.path) && !MATCH_ALBUM_EDIT_PATH.test(props.path)) {
	        className = _Header2.default.headerAlbum;
	      }
	      if (MATCH_ALBUM_EDIT_PATH.test(props.path) || MATCH_SEARCH_PATH.test(props.path)) {
	        className = _Header2.default.headerAlbumEdit;
	      }
	      if (MATCH_QUEUES.test(props.path)) {
	        className = _Header2.default.headerQueues;
	      }
	      if (MATCH_PLAYLISTS.test(props.path)) {
	        className = _Header2.default.headerPlaylists;
	      }
	      if (MATCH_CHANNELS.test(props.path)) {
	        className = _Header2.default.headerChannels;
	      }
	      if (MATCH_LOGIN_PATH.test(props.path)) {
	        return _react2.default.createElement('header', { className: _Header2.default.headerLogin });
	      }
	      return _react2.default.createElement(
	        'header',
	        { className: className },
	        _react2.default.createElement(LeftIcon, props),
	        _react2.default.createElement(
	          'h1',
	          { className: _Header2.default.title },
	          props.title
	        ),
	        RightIcon(props)
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	
	
	function LeftIcon(_ref) {
	  var path = _ref.path,
	      previousPath = _ref.previousPath,
	      toggleNav = _ref.toggleNav,
	      anonymousUser = _ref.anonymousUser;
	
	  if (MATCH_LOGIN_PATH.test(path)) {
	    return null;
	  }
	  if (shouldDisplayBackButton(path, previousPath)) {
	    return _react2.default.createElement(
	      'button',
	      { className: _Header2.default.backIcon, onClick: function onClick() {
	          return window.history.back();
	        } },
	      _react2.default.createElement(_Icon2.default, { icon: 'chevron-left', size: 32 })
	    );
	  }
	  return _react2.default.createElement(
	    'button',
	    { className: _Header2.default.icon, onClick: toggleNav },
	    _react2.default.createElement(_Icon2.default, { icon: 'bars', size: 24 })
	  );
	}
	
	function RightIcon(_ref2) {
	  var path = _ref2.path,
	      previousPath = _ref2.previousPath,
	      params = _ref2.params,
	      anonymousUser = _ref2.anonymousUser,
	      canSearch = _ref2.canSearch;
	
	  if (MATCH_LOGIN_PATH.test(path)) {
	    return null;
	  }
	  if (!canSearch || anonymousUser || shouldDisplayBackButton(path, previousPath)) {
	    // Empty icon to ensure header title is centered
	    return _react2.default.createElement(_Icon2.default, { icon: '', size: 24, className: _Header2.default.icon });
	  }
	  var edit = void 0;
	  if (MATCH_ALBUM_LIST_PATH.test(path)) {
	    edit = _react2.default.createElement(
	      _reactRouter.Link,
	      { key: 'edit', className: _Header2.default.icon, to: '/groups/' + params.id },
	      _react2.default.createElement(_Icon2.default, { icon: 'edit', size: 18 })
	    );
	  }
	  return [edit, _react2.default.createElement(
	    _reactRouter.Link,
	    { key: 'search', className: _Header2.default.icon, to: '/search' },
	    _react2.default.createElement(_Icon2.default, { icon: 'search', size: 18 })
	  )];
	}
	
	function shouldDisplayBackButton(path, previousPath) {
	  if (window.history.length <= 1) {
	    return false;
	  }
	  if (previousPath === '/login') {
	    return false;
	  }
	  return MATCH_BACK_PATH.test(path);
	}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _InteractiveHierarchy = __webpack_require__(354);
	
	var _InteractiveHierarchy2 = _interopRequireDefault(_InteractiveHierarchy);
	
	var _hierarchy = __webpack_require__(129);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MATCH_NUMERIC = /(\d+)\. .+/;
	
	var InteractiveHierarchy = function (_Component) {
	  _inherits(InteractiveHierarchy, _Component);
	
	  function InteractiveHierarchy() {
	    _classCallCheck(this, InteractiveHierarchy);
	
	    return _possibleConstructorReturn(this, (InteractiveHierarchy.__proto__ || Object.getPrototypeOf(InteractiveHierarchy)).apply(this, arguments));
	  }
	
	  _createClass(InteractiveHierarchy, [{
	    key: 'isExpanded',
	    value: function isExpanded(path) {
	      var expanded = this.props.expanded;
	
	      return expanded.indexOf(path) !== -1;
	    }
	  }, {
	    key: 'renderTree',
	    value: function renderTree(tree) {
	      var _this2 = this;
	
	      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
	      var toggleExpanded = this.props.toggleExpanded;
	
	      var sort = function sort(a, b) {
	        if (tree[a] && !tree[b]) return -1;
	        if (tree[b] && !tree[a]) return 1;
	        if (MATCH_NUMERIC.test(a) && MATCH_NUMERIC.test(b)) {
	          var numA = parseInt(a.match(MATCH_NUMERIC)[1]);
	          var numB = parseInt(b.match(MATCH_NUMERIC)[1]);
	          return numA > numB ? 1 : -1;
	        }
	        return a > b ? 1 : -1;
	      };
	      var items = tree['<leaves>'].sort(sort).map(function (name) {
	        var separator = prefix === '/' ? '' : '/';
	        var path = '' + prefix + separator + name;
	        var expanded = _this2.isExpanded(path);
	        var buttonClass = expanded ? _InteractiveHierarchy2.default.collapseIcon : _InteractiveHierarchy2.default.icon;
	        var icon = tree[name] ? expanded ? 'minus' : 'plus' : 'dot';
	        return _react2.default.createElement(
	          'li',
	          { key: path, className: _InteractiveHierarchy2.default.item },
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return toggleExpanded(path);
	              }, className: buttonClass, disabled: !tree[name] },
	            _react2.default.createElement(_Icon2.default, { icon: icon, size: 16 })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: { pathname: '/album', query: { path: path, referrer: 'hierarchy' } }, className: _InteractiveHierarchy2.default.button },
	            name
	          ),
	          expanded && _this2.renderTree(tree[name], path)
	        );
	      });
	      if (prefix === '/' && this.props.appendItems) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.props.appendItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            items.push(_react2.default.createElement(
	              'li',
	              { key: item.text, className: _InteractiveHierarchy2.default.item },
	              _react2.default.createElement(
	                'button',
	                { className: _InteractiveHierarchy2.default.icon, disabled: true },
	                _react2.default.createElement(_Icon2.default, { icon: 'dot', size: 16 })
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: { pathname: item.href, query: item.query }, className: _InteractiveHierarchy2.default.button },
	                item.text
	              )
	            ));
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      return _react2.default.createElement(
	        'ul',
	        { className: _InteractiveHierarchy2.default.list },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.renderTree(this.props.hierarchy, this.props.prefix);
	    }
	  }]);
	
	  return InteractiveHierarchy;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var hierarchy = _ref.hierarchy,
	      auth = _ref.auth;
	  return {
	    expanded: hierarchy.expanded
	  };
	};
	
	var mapDispatchToProps = {
	  toggleExpanded: _hierarchy.toggleExpanded
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InteractiveHierarchy);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _Menu = __webpack_require__(806);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _mousetrap2.default.bind('escape', this.props.closeMenu);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.open && nextProps.open) {
	        document.body.style.overflow = 'hidden';
	      }
	      if (this.props.open && !nextProps.open) {
	        document.body.style.overflow = '';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.style.overflow = '';
	      _mousetrap2.default.unbind('escape');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          items = _props.items,
	          closeMenu = _props.closeMenu;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: open ? _Menu2.default.open : _Menu2.default.closed, onClick: closeMenu },
	        items.map(renderItem)
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	
	
	function renderItem(_ref) {
	  var text = _ref.text,
	      onClick = _ref.onClick,
	      href = _ref.href,
	      shouldShow = _ref.shouldShow,
	      props = _objectWithoutProperties(_ref, ['text', 'onClick', 'href', 'shouldShow']);
	
	  if (typeof shouldShow !== 'undefined' && !shouldShow) {
	    return null;
	  }
	  if (href) {
	    return _react2.default.createElement(
	      'li',
	      { key: text, className: _Menu2.default.item },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        _extends({ to: href, className: _Menu2.default.link }, props),
	        text
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'li',
	    { key: text, className: _Menu2.default.item },
	    _react2.default.createElement(
	      'button',
	      _extends({ onClick: onClick, className: _Menu2.default.link }, props),
	      text
	    )
	  );
	}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Navigation = __webpack_require__(807);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _EditUser = __webpack_require__(305);
	
	var _EditUser2 = _interopRequireDefault(_EditUser);
	
	var _auth = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showProfile: false
	    }, _this.hideProfile = function () {
	      _this.setState({ showProfile: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Navigation, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      document.body.style.overflow = nextProps.open ? 'hidden' : '';
	    }
	  }, {
	    key: 'getSections',
	    value: function getSections() {
	      var _this2 = this;
	
	      var _props = this.props,
	          logout = _props.logout,
	          user = _props.user,
	          anonymousUser = _props.anonymousUser;
	
	      return [{
	        title: 'Browse',
	        shouldShow: !anonymousUser,
	        items: [{
	          text: 'Home',
	          href: '/'
	        }, {
	          text: 'Albums',
	          href: '/albums'
	        }, {
	          text: 'Search',
	          href: '/search',
	          shouldShow: (0, _auth.userHasPerm)(user, 'search_and_save')
	        }, {
	          text: 'Timeline',
	          href: '/timeline',
	          shouldShow: (0, _auth.userHasPerm)(user, 'search_and_save')
	        }, {
	          text: 'Album Hierarchy',
	          href: '/hierarchy',
	          shouldShow: (0, _auth.userHasPerm)(user, 'view_hierarchy')
	        }]
	      }, {
	        title: 'Manage',
	        shouldShow: !anonymousUser,
	        items: [{
	          text: 'Album Groups',
	          href: '/groups'
	        }, {
	          text: 'Playlists',
	          href: '/playlists',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels')
	        }, {
	          text: 'Queues',
	          href: '/queues',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels')
	        }, {
	          text: 'Channels',
	          href: '/channels',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels')
	        }, {
	          text: 'Orchestra 1',
	          href: '/orchestras',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
	        }, {
	          text: 'Orchestra 2',
	          href: '/orchestras2',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
	        }, {
	          text: 'Orchestra TV 1',
	          href: '/orchestra-tv',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
	        }, {
	          text: 'Orchestra TV 2',
	          href: '/orchestra-tv2',
	          shouldShow: (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels') // TODO: create dedicated Orchestra permissions
	        }]
	      }, {
	        title: 'Admin',
	        shouldShow: (0, _auth.userHasPerm)(user, 'admin') || (0, _auth.userHasPerm)(user, 'dynamic_links') || (0, _auth.userHasPerm)(user, 'external_share') || (0, _auth.isSuperAdmin)(user),
	        items: [{
	          text: 'Manage Users',
	          href: '/users',
	          shouldShow: (0, _auth.userHasPerm)(user, 'admin')
	        }, {
	          text: 'Manage External Share Codes',
	          href: '/shares',
	          shouldShow: (0, _auth.userHasPerm)(user, 'external_share')
	        }, {
	          text: 'Manage Dynamic Tables',
	          href: '/dynamics',
	          shouldShow: (0, _auth.userHasPerm)(user, 'dynamic_links')
	        }, {
	          text: 'Manage Libraries',
	          href: '/libraries',
	          shouldShow: (0, _auth.isSuperAdmin)(user)
	        }, {
	          text: 'Manage Keyword Visibility',
	          href: '/manage-keyword-visibility',
	          shouldShow: (0, _auth.isSuperAdmin)(user)
	        }, {
	          text: 'Manage Keyword Weighting',
	          href: '/manage-keyword-weighting',
	          shouldShow: (0, _auth.isSuperAdmin)(user)
	        }, {
	          text: 'Manage Keyword Updates',
	          href: '/manage-keyword-updates',
	          shouldShow: (0, _auth.isSuperAdmin)(user)
	        }, {
	          text: 'Scripts Info',
	          href: '/scripts',
	          shouldShow: (0, _auth.isSuperAdmin)(user)
	        }]
	      }, {
	        title: 'User',
	        items: [{
	          text: 'Edit Profile',
	          onClick: function onClick() {
	            return _this2.setState({ showProfile: true });
	          },
	          shouldShow: !anonymousUser
	        }, {
	          text: 'Image Configuration',
	          href: '/settings',
	          shouldShow: (0, _auth.userHasPerm)(user, 'image_config') || (0, _auth.isSuperAdmin)(user)
	        }, {
	          text: 'Manage Sessions',
	          href: '/sessions',
	          shouldShow: !anonymousUser
	        }, {
	          text: 'Log out',
	          onClick: logout
	        }]
	      }];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          open = _props2.open,
	          closeNav = _props2.closeNav,
	          user = _props2.user,
	          updateUser = _props2.updateUser;
	
	      var wrapperClass = open ? _Navigation2.default.wrapperOpen : _Navigation2.default.wrapper;
	      var navClass = open ? _Navigation2.default.navOpen : _Navigation2.default.nav;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: wrapperClass, onClick: closeNav },
	          _react2.default.createElement(
	            'nav',
	            { className: navClass },
	            open && this.getSections().map(renderSection)
	          )
	        ),
	        this.state.showProfile && _react2.default.createElement(_EditUser2.default, {
	          title: 'Profile',
	          showPasswordField: true,
	          onSubmit: function onSubmit(data) {
	            return updateUser(user.id, data).then(function (success) {
	              return success && _this3.hideProfile();
	            });
	          },
	          onCancel: this.hideProfile,
	          initialValues: {
	            name: user.name,
	            email: user.email,
	            password: user.password,
	            location: user.location
	          }
	        })
	      );
	    }
	  }]);
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	
	
	function renderSection(_ref2) {
	  var shouldShow = _ref2.shouldShow,
	      title = _ref2.title,
	      items = _ref2.items;
	
	  if (typeof shouldShow !== 'undefined' && !shouldShow) {
	    return null;
	  }
	  return _react2.default.createElement(
	    'section',
	    { key: title },
	    _react2.default.createElement(
	      'div',
	      { className: _Navigation2.default.heading },
	      title
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: _Navigation2.default.list },
	      items.map(renderItem)
	    )
	  );
	}
	
	// Stolen from components/Menu
	function renderItem(_ref3) {
	  var text = _ref3.text,
	      onClick = _ref3.onClick,
	      href = _ref3.href,
	      shouldShow = _ref3.shouldShow,
	      props = _objectWithoutProperties(_ref3, ['text', 'onClick', 'href', 'shouldShow']);
	
	  if (typeof shouldShow !== 'undefined' && !shouldShow) {
	    return null;
	  }
	  if (href) {
	    return _react2.default.createElement(
	      'li',
	      { key: text, className: _Navigation2.default.item },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        _extends({ to: href, className: _Navigation2.default.link }, props),
	        text
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'li',
	    { key: text, className: _Navigation2.default.item },
	    _react2.default.createElement(
	      'button',
	      _extends({ onClick: onClick, className: _Navigation2.default.link }, props),
	      text
	    )
	  );
	}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _TimelinePeriod = __webpack_require__(810);
	
	var _TimelinePeriod2 = _interopRequireDefault(_TimelinePeriod);
	
	var _query = __webpack_require__(50);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cache = {};
	
	var TimelinePeriod = function (_Component) {
	  _inherits(TimelinePeriod, _Component);
	
	  function TimelinePeriod() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimelinePeriod);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelinePeriod.__proto__ || Object.getPrototypeOf(TimelinePeriod)).call.apply(_ref, [this].concat(args))), _this), _this.structure = _extends({}, _query.emptyStructure, {
	      queries: [_extends({}, _query.emptyQuery, {
	        album: _this.props.terms.map(function (value) {
	          return {
	            value: value,
	            operator: 'must'
	          };
	        }),
	        path: _this.props.path.map(function (value) {
	          return {
	            value: value,
	            operator: 'must'
	          };
	        })
	      })]
	    }), _this.hash = (0, _images.getHash)(_this.structure), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimelinePeriod, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          searchImages = _props.searchImages,
	          search = _props.search;
	
	      var images = search[this.hash];
	      if (!images || !images.data && !images.fetching) {
	        searchImages(this.structure, 0, 65, { simple: true });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props2 = this.props,
	          expanded = _props2.expanded,
	          search = _props2.search;
	
	      var images = search[this.hash];
	      var nextImages = nextProps.search[this.hash];
	      if (images && nextImages && !images.data && nextImages.data) {
	        return true;
	      }
	      return expanded !== nextProps.expanded;
	    }
	  }, {
	    key: 'getThumbLimit',
	    value: function getThumbLimit(count) {
	      if (!count) return 0;
	      return Math.min(count, 5 + Math.round(Math.log(count) / Math.log(100000) * 60));
	    }
	  }, {
	    key: 'renderThumbs',
	    value: function renderThumbs(limit, images) {
	      var getImageSource = this.props.getImageSource;
	
	      var thumbs = [];
	      for (var i = 0; i !== limit; i++) {
	        var style = void 0;
	        var id = images && images[i];
	        if (id && !cache[id]) {
	          cache[id] = getImageSource(id, 'i');
	        }
	        if (cache[id]) {
	          style = { backgroundImage: 'url(' + cache[id] + ')' };
	        }
	        thumbs.push(_react2.default.createElement('div', {
	          key: i,
	          className: _TimelinePeriod2.default.thumbnail,
	          style: style
	        }));
	      }
	      return thumbs;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          href = _props3.href,
	          title = _props3.title,
	          search = _props3.search,
	          count = _props3.count,
	          expanded = _props3.expanded,
	          onClickExpand = _props3.onClickExpand,
	          subevent = _props3.subevent;
	
	      var images = search[this.hash] || {};
	      var limit = this.getThumbLimit(count);
	      var className = subevent ? _TimelinePeriod2.default.subperiod : _TimelinePeriod2.default.period;
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: href, className: _TimelinePeriod2.default.title },
	          title
	        ),
	        onClickExpand && _react2.default.createElement(
	          'button',
	          { onClick: onClickExpand, className: _TimelinePeriod2.default.expandButton },
	          expanded ? 'Hide' : 'View',
	          ' sub-events'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _TimelinePeriod2.default.count },
	          (0, _string.pluralize)(count, 'image')
	        ),
	        !expanded && _react2.default.createElement(
	          _reactRouter.Link,
	          { to: href, className: _TimelinePeriod2.default.link },
	          _react2.default.createElement(
	            'ul',
	            { className: _TimelinePeriod2.default.thumbnails },
	            this.renderThumbs(limit, images.data)
	          )
	        )
	      );
	    }
	  }]);
	
	  return TimelinePeriod;
	}(_react.Component);
	
	TimelinePeriod.defaultProps = {
	  terms: [],
	  path: []
	};
	exports.default = TimelinePeriod;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _users = __webpack_require__(68);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Checklist = __webpack_require__(126);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserChecklist = function (_Component) {
	  _inherits(UserChecklist, _Component);
	
	  function UserChecklist() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserChecklist);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserChecklist.__proto__ || Object.getPrototypeOf(UserChecklist)).call.apply(_ref, [this].concat(args))), _this), _this.getUserItem = function (_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name,
	          email = _ref2.email;
	      var getExtra = _this.props.getExtra;
	
	      return {
	        value: id,
	        title: name,
	        subtitle: email,
	        extra: getExtra && getExtra(id)
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserChecklist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          users = _props.users,
	          fetchUsers = _props.fetchUsers;
	
	      if (!users) {
	        fetchUsers();
	      }
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      var _props2 = this.props,
	          users = _props2.users,
	          getExtra = _props2.getExtra,
	          showExternalUsers = _props2.showExternalUsers,
	          appendToExternal = _props2.appendToExternal;
	
	      var items = users.map(this.getUserItem);
	      if (showExternalUsers) {
	        var external = {
	          value: 0,
	          title: 'External Users',
	          subtitle: this.props.externalSubtitle,
	          append: appendToExternal,
	          extra: getExtra && getExtra(0)
	        };
	        return [external].concat(items);
	      }
	      return items;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          users = _props3.users,
	          value = _props3.value,
	          onChange = _props3.onChange;
	
	      if (!users) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      return _react2.default.createElement(_Checklist2.default, {
	        items: this.getItems(),
	        value: value,
	        onChange: onChange
	      });
	    }
	  }]);
	
	  return UserChecklist;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
	  var users = _ref3.users,
	      entities = _ref3.entities,
	      auth = _ref3.auth;
	  var channelUsersOnly = _ref4.channelUsersOnly;
	  return {
	    users: users.data && users.data.filter(function (id) {
	      return id !== auth.user.id;
	    }).map(function (id) {
	      return entities.users[id];
	    }).filter(function (user) {
	      if (channelUsersOnly) {
	        return user.canViewChannels;
	      }
	      return true;
	    })
	  };
	};
	
	var mapDispatchToProps = {
	  fetchUsers: _users.fetchUsers
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserChecklist);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _AlbumBreadcrumbs = __webpack_require__(814);
	
	var _AlbumBreadcrumbs2 = _interopRequireDefault(_AlbumBreadcrumbs);
	
	var _string = __webpack_require__(16);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumBreadcrumbs = function (_Component) {
	  _inherits(AlbumBreadcrumbs, _Component);
	
	  function AlbumBreadcrumbs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumBreadcrumbs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumBreadcrumbs.__proto__ || Object.getPrototypeOf(AlbumBreadcrumbs)).call.apply(_ref, [this].concat(args))), _this), _this.renderBreadcrumb = function (_ref2) {
	      var title = _ref2.title,
	          href = _ref2.href;
	
	      if (!href) {
	        return _react2.default.createElement(
	          'span',
	          { key: href, className: _AlbumBreadcrumbs2.default.breadcrumb },
	          title
	        );
	      }
	      return [_react2.default.createElement(
	        _reactRouter.Link,
	        { key: href, to: href, className: _AlbumBreadcrumbs2.default.breadcrumb },
	        title
	      ), ' '];
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumBreadcrumbs, [{
	    key: 'render',
	    value: function render() {
	      var location = this.props.location;
	      var _location$query = location.query,
	          path = _location$query.path,
	          referrer = _location$query.referrer;
	
	      if (!path) {
	        return null;
	      }
	      var split = path.split('/');
	      var crumbs = [];
	      if (referrer) {
	        crumbs.push({
	          title: referrer.toUpperCase(),
	          href: '/' + referrer
	        });
	      }
	      for (var i = 0; i !== split.length; i++) {
	        var name = split[i];
	        // Skip empty or top level crumbs
	        if (!name || name === 'COLLECTIONS') {
	          continue;
	        }
	        // Skip library crumbs
	        if (split.length > 3 && i === 2 && split[1] === 'COLLECTIONS') {
	          continue;
	        }
	        // Link to timeline for decades
	        if (i === 3 && /^\d\d\d\ds$/.test(name)) {
	          crumbs.push({
	            title: name,
	            href: '/timeline/' + name.slice(0, 4)
	          });
	          continue;
	        }
	        // Link to timeline for years
	        if (i === 4 && /^\d\d\d\d$/.test(name)) {
	          crumbs.push({
	            title: name,
	            href: '/timeline/' + split[3].slice(0, 4) + '/' + name
	          });
	          continue;
	        }
	        // Link to timeline for seasons
	        if (i === 5 && _constants.TIMELINE_SEASONS.indexOf(name) !== -1) {
	          crumbs.push({
	            title: (0, _string.tidyAlbumTitle)(name),
	            href: '/timeline/' + split[3].slice(0, 4) + '/' + split[4] + '/' + name
	          });
	          continue;
	        }
	        crumbs.push({
	          title: (0, _string.tidyAlbumTitle)(name),
	          href: '/album?path=' + split.slice(0, i + 1).join('/') + (referrer ? '&referrer=' + referrer : '')
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _AlbumBreadcrumbs2.default.breadcrumbs },
	        crumbs.map(this.renderBreadcrumb)
	      );
	    }
	  }]);
	
	  return AlbumBreadcrumbs;
	}(_react.Component);
	
	exports.default = AlbumBreadcrumbs;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _AlbumHeader = __webpack_require__(815);
	
	var _AlbumHeader2 = _interopRequireDefault(_AlbumHeader);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumHeader = function (_Component) {
	  _inherits(AlbumHeader, _Component);
	
	  function AlbumHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumHeader.__proto__ || Object.getPrototypeOf(AlbumHeader)).call.apply(_ref, [this].concat(args))), _this), _this.coverSrc = _this.props.getImageSource(_this.props.cover, 'd'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.cover !== nextProps.cover) {
	        this.coverSrc = this.props.getImageSource(nextProps.cover, 'd');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          title = _props.title,
	          task = _props.task,
	          setFavouriteAlbum = _props.setFavouriteAlbum,
	          hasFavourited = _props.hasFavourited,
	          anonymousUser = _props.anonymousUser,
	          isOwnAlbum = _props.isOwnAlbum,
	          owner = _props.owner,
	          isFixed = _props.isFixed;
	
	      var iconClassNames = {
	        info: task === 'info' ? _AlbumHeader2.default.active : null,
	        edit: task === 'edit' ? _AlbumHeader2.default.active : null,
	        favourite: hasFavourited ? _AlbumHeader2.default.active : null
	      };
	      var paths = {
	        info: task === 'info' ? '/album/' + id : '/album/' + id + '/info',
	        edit: task === 'edit' ? '/album/' + id : '/album/' + id + '/edit'
	      };
	      var gradient = 'linear-gradient(180deg, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.8) 100%)';
	      var style = {
	        backgroundImage: this.coverSrc && gradient + ', url(' + this.coverSrc + ')'
	      };
	      return _react2.default.createElement(
	        'header',
	        { className: _AlbumHeader2.default.header, style: style },
	        _react2.default.createElement(
	          'h2',
	          { className: _AlbumHeader2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AlbumHeader2.default.subtitle },
	          !this.props.hideCount && (this.props.count === 0 || this.props.count ? (0, _string.pluralize)(this.props.count, 'image') : 'Loading…'),
	          !isOwnAlbum && owner ? ' \xB7 Shared by ' + owner.name : '',
	          isFixed && _react2.default.createElement(
	            'span',
	            { style: { marginLeft: '20px' } },
	            _react2.default.createElement(_Icon2.default, { icon: 'lock', size: 13, style: { marginRight: '3px' } }),
	            ' Locked'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AlbumHeader2.default.bottomLeft },
	          this.props.canEdit && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: paths.edit, className: _AlbumHeader2.default.iconButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'edit', className: iconClassNames.edit, size: 20 })
	          ),
	          id && !anonymousUser && _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return setFavouriteAlbum(id, !hasFavourited);
	              },
	              className: _AlbumHeader2.default.iconButton,
	              style: { marginRight: '2px' } },
	            _react2.default.createElement(_Icon2.default, { icon: hasFavourited ? 'heart' : 'heart-outline', size: 24, className: iconClassNames.favourite })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AlbumHeader2.default.bottomRight },
	          _react2.default.createElement('input', {
	            className: _AlbumHeader2.default.slider,
	            type: 'range',
	            min: 80,
	            max: 640,
	            defaultValue: this.props.thumbSize,
	            onMouseUp: function onMouseUp(e) {
	              return _this2.props.updateThumbSize(parseInt(e.target.value));
	            }
	          }),
	          this.props.renderMenuToggle(_AlbumHeader2.default.iconButton),
	          id && !anonymousUser && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: paths.info, className: _AlbumHeader2.default.infoButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'info', className: iconClassNames.info, size: 28 })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbumHeader;
	}(_react.Component);
	
	exports.default = AlbumHeader;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AlbumInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _AlbumInfo = __webpack_require__(816);
	
	var _AlbumInfo2 = _interopRequireDefault(_AlbumInfo);
	
	var _GroupedKeywords = __webpack_require__(200);
	
	var _GroupedKeywords2 = _interopRequireDefault(_GroupedKeywords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AlbumInfo(props) {
	  var params = props.params,
	      album = props.album,
	      owner = props.owner,
	      lists = props.lists,
	      resolvedKeywords = props.resolvedKeywords;
	
	  var inLists = lists ? getLists(album, lists) : [];
	  var getKeywordName = function getKeywordName(id) {
	    return props.keywordMap[id].name;
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _AlbumInfo2.default.page },
	    _react2.default.createElement(
	      'ul',
	      { className: _AlbumInfo2.default.info },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Created by'
	        ),
	        ' ',
	        owner && owner.name
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Created'
	        ),
	        ' ',
	        getDate(album.created_at)
	      ),
	      album.updated_at && _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Last updated'
	        ),
	        ' ',
	        getDate(album.updated_at)
	      ),
	      inLists.length !== 0 && _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Lists'
	        ),
	        ' ',
	        inLists
	      ),
	      props.hasDynamicLink && props.keywordMap && resolvedKeywords && resolvedKeywords.length !== 0 && _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Resolved keywords'
	        ),
	        ' ',
	        resolvedKeywords.map(getKeywordName).join(', ')
	      )
	    ),
	    _react2.default.createElement(_GroupedKeywords2.default, { albumID: params.id })
	  );
	}
	
	function getDate(string) {
	  if (!string) return string;
	  return (0, _dateformat2.default)(new Date(string), 'HH:MM, d mmmm yyyy');
	}
	
	function getLists(album, lists) {
	  return lists.filter(function (list) {
	    return list.albums.findIndex(function (a) {
	      return a.id === album.id;
	    }) !== -1;
	  }).map(function (list, index, array) {
	    var comma = index === array.length - 1 ? null : ', ';
	    return [_react2.default.createElement(
	      _reactRouter.Link,
	      { key: 'link', to: '/group/' + list.id },
	      list.name
	    ), comma];
	  });
	}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactTappable = __webpack_require__(469);
	
	var _reactTappable2 = _interopRequireDefault(_reactTappable);
	
	var _AlbumList = __webpack_require__(817);
	
	var _AlbumList2 = _interopRequireDefault(_AlbumList);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LIMIT_ALBUMS = 10;
	var PRESS_DELAY = 500;
	
	var AlbumList = function (_Component) {
	  _inherits(AlbumList, _Component);
	
	  function AlbumList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumList.__proto__ || Object.getPrototypeOf(AlbumList)).call.apply(_ref, [this].concat(args))), _this), _this.renderAlbum = function (album) {
	      if (!album) return null;
	      var _this$props = _this.props,
	          getImageSource = _this$props.getImageSource,
	          getAlbumInfo = _this$props.getAlbumInfo,
	          isFavourite = _this$props.isFavourite,
	          viewAlbum = _this$props.viewAlbum,
	          editAlbum = _this$props.editAlbum;
	
	      var structure = JSON.parse(album.json_data);
	      var fixed = structure.fixed && structure.fixed.length !== 0;
	      return _react2.default.createElement(
	        _reactTappable2.default,
	        { key: album.id, onTap: function onTap() {
	            return viewAlbum(album.id);
	          }, onPress: function onPress() {
	            return editAlbum(album.id);
	          }, pressDelay: PRESS_DELAY },
	        _react2.default.createElement(Album, {
	          album: album,
	          info: getAlbumInfo(album),
	          getImageSource: getImageSource,
	          favourite: isFavourite(album.id),
	          fixed: fixed
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          albums = _props.albums,
	          moreLink = _props.moreLink,
	          showCreateAlbum = _props.showCreateAlbum;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _AlbumList2.default.list },
	        showCreateAlbum && _react2.default.createElement(
	          'li',
	          { className: _AlbumList2.default.item },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/search', className: _AlbumList2.default.addLink },
	            _react2.default.createElement(_Icon2.default, { icon: 'plus', className: _AlbumList2.default.addLinkIcon, size: 40 }),
	            _react2.default.createElement(
	              'div',
	              { className: _AlbumList2.default.title },
	              'Create Album'
	            )
	          )
	        ),
	        albums.slice(0, LIMIT_ALBUMS).map(this.renderAlbum),
	        albums.length > LIMIT_ALBUMS && _react2.default.createElement(
	          'li',
	          { className: _AlbumList2.default.item },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: moreLink, className: _AlbumList2.default.moreLink },
	            _react2.default.createElement(
	              'div',
	              { className: _AlbumList2.default.moreCount },
	              '+',
	              albums.length - LIMIT_ALBUMS
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _AlbumList2.default.moreText },
	              'View more'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbumList;
	}(_react.Component);
	
	exports.default = AlbumList;
	
	var Album = function (_Component2) {
	  _inherits(Album, _Component2);
	
	  function Album() {
	    _classCallCheck(this, Album);
	
	    return _possibleConstructorReturn(this, (Album.__proto__ || Object.getPrototypeOf(Album)).apply(this, arguments));
	  }
	
	  _createClass(Album, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          album = _props2.album,
	          getImageSource = _props2.getImageSource,
	          info = _props2.info,
	          favourite = _props2.favourite,
	          fixed = _props2.fixed;
	
	      if (!album) {
	        return null;
	      }
	      var name = album.name,
	          id = album.id,
	          cover = album.cover;
	
	      var style = { backgroundImage: 'url(' + getImageSource(cover) + ')' };
	      return _react2.default.createElement(
	        'li',
	        { className: _AlbumList2.default.item },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/album/' + id, className: _AlbumList2.default.link, style: style },
	          _react2.default.createElement(
	            'div',
	            { className: fixed ? _AlbumList2.default.titleLocked : _AlbumList2.default.title },
	            name,
	            info && _react2.default.createElement(
	              'div',
	              { className: _AlbumList2.default.info },
	              info
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _AlbumList2.default.icons },
	            favourite && _react2.default.createElement(_Icon2.default, { icon: 'heart', size: 18 })
	          ),
	          fixed && _react2.default.createElement(_Icon2.default, { icon: 'lock', size: 13, className: _AlbumList2.default.lock })
	        )
	      );
	    }
	  }]);
	
	  return Album;
	}(_react.Component);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _common = __webpack_require__(170);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _playlists = __webpack_require__(43);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _string = __webpack_require__(16);
	
	var _lists = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumLists = function (_Component) {
	  _inherits(AlbumLists, _Component);
	
	  function AlbumLists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumLists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumLists.__proto__ || Object.getPrototypeOf(AlbumLists)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      checked: _this.props.albumLists,
	      createList: '',
	      success: false,
	      submitting: false
	    }, _this.onSubmit = function () {
	      var _this$props = _this.props,
	          id = _this$props.id,
	          lists = _this$props.lists,
	          addAlbumToList = _this$props.addAlbumToList,
	          removeAlbumFromList = _this$props.removeAlbumFromList,
	          saveList = _this$props.saveList;
	      var _this$state = _this.state,
	          checked = _this$state.checked,
	          createList = _this$state.createList;
	
	      _this.setState({
	        submitting: true
	      });
	      return (0, _lists.updateAlbumLists)({
	        albumID: id,
	        checked: checked,
	        createList: createList,
	        lists: lists,
	        addAlbumToList: addAlbumToList,
	        removeAlbumFromList: removeAlbumFromList,
	        saveList: saveList
	      }).then(function () {
	        _this.setState({
	          success: true,
	          submitting: false,
	          createList: ''
	        });
	      });
	    }, _this.renderList = function (list) {
	      var checked = _this.state.checked;
	
	      var isChecked = checked.indexOf(list.id) !== -1;
	      var onCheck = function onCheck() {
	        return _this.setState({ checked: checked.concat(list.id), success: false });
	      };
	      var onUncheck = function onUncheck() {
	        return _this.setState({ checked: checked.filter(function (id) {
	            return id !== list.id;
	          }), success: false });
	      };
	      var structure = JSON.parse(list.json_data);
	      return _react2.default.createElement(
	        'li',
	        { key: list.id },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _common2.default.user,
	            onClick: isChecked ? onUncheck : onCheck },
	          _react2.default.createElement(
	            'div',
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userName },
	              list.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userEmail },
	              (0, _string.pluralize)(structure.albums.length, 'album'),
	              structure.playlistsOnly && ', for playlist albums only',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/groups/' + list.id, className: _common2.default.editLink },
	                'Edit'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: isChecked ? _common2.default.checkboxChecked : _common2.default.checkbox },
	            isChecked && _react2.default.createElement(_Icon2.default, { icon: 'tick', className: _common2.default.tick, size: 16 })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumLists, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          lists = _props.lists,
	          fetchPlaylists = _props.fetchPlaylists;
	
	      if (!lists) {
	        fetchPlaylists();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var albumLists = this.props.albumLists;
	
	      if (!albumLists && nextProps.albumLists) {
	        this.setState({
	          checked: nextProps.albumLists
	        });
	      }
	      if (albumLists && nextProps.albumLists && nextProps.albumLists.length - albumLists.length === 1) {
	        // New list created
	        // Add new list ID to checked state array
	        // WARNING: This assumes new list is last in the array, if default list order changes this will break
	        this.setState({
	          checked: this.state.checked.concat(nextProps.albumLists[nextProps.albumLists.length - 1])
	        });
	      }
	    }
	    // TODO: Replace this list with Checklist component
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          lists = _props2.lists,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchPlaylists = _props2.fetchPlaylists,
	          id = _props2.id;
	
	
	      if (!lists || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching album groups',
	          onRetry: fetchPlaylists
	        });
	      }
	
	      var _state = this.state,
	          createList = _state.createList,
	          success = _state.success,
	          submitting = _state.submitting;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _common2.default.page },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Album groups'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          lists.map(this.renderList)
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Add to new group',
	          _react2.default.createElement('input', {
	            type: 'text',
	            value: createList,
	            onChange: function onChange(e) {
	              return _this2.setState({ createList: e.target.value });
	            }
	          })
	        ),
	        success && _react2.default.createElement(
	          'p',
	          { className: _common2.default.note },
	          'Album groups were successfully updated'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _common2.default.buttons },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/album/' + id, className: success ? _common2.default.button : _common2.default.backButton },
	            success ? 'Done' : 'Cancel'
	          ),
	          !success && _react2.default.createElement(
	            'button',
	            { onClick: this.onSubmit, className: _common2.default.button, disabled: submitting },
	            submitting ? 'Adding To Groups…' : 'Add To Groups'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbumLists;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var playlists = _ref2.playlists;
	
	  return {
	    fetching: playlists.fetching,
	    error: playlists.error
	  };
	};
	
	var mapDispatchToProps = {
	  fetchPlaylists: _playlists.fetchPlaylists,
	  addAlbumToList: _playlists.addAlbumToList,
	  removeAlbumFromList: _playlists.removeAlbumFromList,
	  saveList: _playlists.saveList
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlbumLists);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _humanizeList = __webpack_require__(365);
	
	var _humanizeList2 = _interopRequireDefault(_humanizeList);
	
	var _banners = __webpack_require__(67);
	
	var _album = __webpack_require__(66);
	
	var _share = __webpack_require__(87);
	
	var _query = __webpack_require__(50);
	
	var _playlists = __webpack_require__(43);
	
	var _modals = __webpack_require__(212);
	
	var _SaveAlbum = __webpack_require__(307);
	
	var _SaveAlbum2 = _interopRequireDefault(_SaveAlbum);
	
	var _DownloadImages = __webpack_require__(520);
	
	var _DownloadImages2 = _interopRequireDefault(_DownloadImages);
	
	var _AddImagesToAlbum = __webpack_require__(301);
	
	var _AddImagesToAlbum2 = _interopRequireDefault(_AddImagesToAlbum);
	
	var _ImageShare = __webpack_require__(302);
	
	var _ImageShare2 = _interopRequireDefault(_ImageShare);
	
	var _PresentMenu = __webpack_require__(534);
	
	var _PresentMenu2 = _interopRequireDefault(_PresentMenu);
	
	var _DropMenu = __webpack_require__(148);
	
	var _DropMenu2 = _interopRequireDefault(_DropMenu);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ChannelMenuItem = __webpack_require__(205);
	
	var _ChannelMenuItem2 = _interopRequireDefault(_ChannelMenuItem);
	
	var _fetch = __webpack_require__(14);
	
	var _string = __webpack_require__(16);
	
	var _images = __webpack_require__(23);
	
	var _auth = __webpack_require__(20);
	
	var _lists = __webpack_require__(88);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumMenu = function (_Component) {
	  _inherits(AlbumMenu, _Component);
	
	  function AlbumMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumMenu.__proto__ || Object.getPrototypeOf(AlbumMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      presentMenuOpen: false,
	      downloadMenuOpen: false,
	      shareImagesMenuOpen: false,
	      downloadSizeSelected: null,
	      playNowMenuOpen: false,
	      playNextMenuOpen: false,
	      addImagesMenuOpen: false,
	      addToChannel: null,
	      playNow: false,
	      tempCover: null
	    }, _this.onSave = function (data) {
	      var _this$props = _this.props,
	          lists = _this$props.lists,
	          addAlbumToList = _this$props.addAlbumToList,
	          removeAlbumFromList = _this$props.removeAlbumFromList,
	          saveList = _this$props.saveList;
	
	      var albumData = _extends({}, data, {
	        lists: undefined,
	        createList: undefined
	      });
	      return _this.saveAlbum(albumData).then(function (album) {
	        return (0, _lists.updateAlbumLists)({
	          albumID: album.id,
	          checked: data.lists,
	          createList: data.createList,
	          lists: lists,
	          addAlbumToList: addAlbumToList,
	          removeAlbumFromList: removeAlbumFromList,
	          saveList: saveList
	        });
	      }).then(function () {
	        _lscache2.default.remove(_constants.QUERY_CACHE_KEY);
	      }).catch(function (e) {
	        return console.log(e);
	      });
	    }, _this.saveAlbum = function (data) {
	      var _this$props2 = _this.props,
	          addingToPlaylist = _this$props2.addingToPlaylist,
	          query = _this$props2.query,
	          saveAlbum = _this$props2.saveAlbum;
	
	      if (query.selectedImages.length !== 0) {
	        return saveAlbum(data, _extends({}, _query.emptyStructure, {
	          include: query.selectedImages
	        }));
	      }
	      if (data.id) {
	        return saveAlbum(data, query.structure, data.id);
	      }
	      if (addingToPlaylist) {
	        var redirect = '/playlists/' + addingToPlaylist.id + '?addAlbum=:id';
	        return saveAlbum(data, query.structure, undefined, redirect);
	      }
	      return saveAlbum(data, query.structure);
	    }, _this.onDelete = function () {
	      var _this$props3 = _this.props,
	          me = _this$props3.me,
	          album = _this$props3.album,
	          deleteAlbum = _this$props3.deleteAlbum,
	          saveAlbum = _this$props3.saveAlbum;
	
	      if (album.user_id !== me.id) {
	        // Unshare album from myself
	        _this.props.unshareAlbum(album.id, me.id);
	        _this.props.goHome();
	      } else if (album.favourite || album.image_share) {
	        // Empty special albums instead of deleting them
	        saveAlbum({ name: album.name, cover: '' }, _extends({}, _query.emptyStructure, { queries: [] }), album.id, '/');
	      } else {
	        deleteAlbum(album.id);
	      }
	    }, _this.onAddToChannel = function (channel, options) {
	      var _this$props4 = _this.props,
	          sendToPlayNow = _this$props4.sendToPlayNow,
	          sendToPlayNext = _this$props4.sendToPlayNext,
	          showBanner = _this$props4.showBanner,
	          album = _this$props4.album,
	          editing = _this$props4.editing;
	      var playNow = _this.state.playNow;
	
	      var picassoStructure = _this.generatePicassoStructure(options || {});
	      var success = function success(data) {
	        if (!channel.id && playNow) {
	          _this.props.presentChannel(data.channel_id);
	        } else {
	          showBanner(album && !editing ? 'Album added to channel' : 'Images added to channel');
	        }
	      };
	      if (playNow || !channel.id) {
	        sendToPlayNow(channel.id, picassoStructure).then(success);
	      } else {
	        sendToPlayNext(channel.id, picassoStructure).then(success);
	      }
	    }, _this.enableImageReorder = function () {
	      var _this$props5 = _this.props,
	          query = _this$props5.query,
	          enableImageReorder = _this$props5.enableImageReorder,
	          shouldSearchImages = _this$props5.shouldSearchImages,
	          searchImages = _this$props5.searchImages;
	
	      enableImageReorder();
	      // Preload manual search structure to prevent another spinner when reordering
	      var structure = _extends({}, query.structure, {
	        sort: _extends({}, query.structure.sort, {
	          value: 'manual',
	          operator: null
	        })
	      });
	      if (shouldSearchImages(structure)) {
	        searchImages(structure);
	      }
	    }, _this.toggleLock = function (e) {
	      e.stopPropagation();
	      var _this$props6 = _this.props,
	          query = _this$props6.query,
	          images = _this$props6.images,
	          count = _this$props6.count,
	          loadMoreImages = _this$props6.loadMoreImages,
	          fixAlbum = _this$props6.fixAlbum,
	          unfixAlbum = _this$props6.unfixAlbum;
	
	      if (query.structure.fixed) {
	        if (window.confirm(_constants.UNFIX_WARNING) === false) {
	          return;
	        }
	        unfixAlbum();
	      } else {
	        if (window.confirm(_constants.FIX_WARNING) === false) {
	          return;
	        }
	        if (images.length !== count) {
	          _this.setState({ loadingAll: true });
	          loadMoreImages(count).then(function () {
	            fixAlbum(_this.props.images.map(function (image) {
	              return image._id;
	            }));
	            _this.setState({ loadingAll: false });
	          });
	        } else {
	          fixAlbum(images.map(function (image) {
	            return image._id;
	          }));
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          lists = _props.lists,
	          fetchPlaylists = _props.fetchPlaylists;
	
	      if (!lists) fetchPlaylists();
	    }
	  }, {
	    key: 'generatePicassoStructure',
	    value: function generatePicassoStructure(presentOptions) {
	      var _props2 = this.props,
	          album = _props2.album,
	          editing = _props2.editing,
	          images = _props2.images,
	          query = _props2.query;
	      var selectedImages = query.selectedImages;
	
	      var present = {
	        presentationType: presentOptions.presentation_type,
	        presentationSpeed: presentOptions.presentation_speed,
	        presentationTransition: presentOptions.presentation_transition,
	        presentationSort: presentOptions.presentation_sort
	      };
	      if (album && !editing) {
	        return {
	          album_id: album.id,
	          album: _extends({
	            album: album.id
	          }, present)
	        };
	      }
	      return _extends({
	        images: selectedImages.length !== 0 ? selectedImages : images.map(function (image) {
	          return image._id;
	        })
	      }, present);
	    }
	  }, {
	    key: 'getPresentMenuItems',
	    value: function getPresentMenuItems() {
	      var _this2 = this;
	
	      var canEditPlaylists = this.props.canEditPlaylists;
	      var _state = this.state,
	          playNow = _state.playNow,
	          channels = _state.channels;
	
	      if (canEditPlaylists && !channels) {
	        return [{ text: _react2.default.createElement(_LoadingSpinner2.default, { style: { width: '12px', height: '12px', margin: 0 } }) }];
	      }
	      var items = [];
	      items.push({
	        text: playNow ? 'Present on this device' : 'New channel (auto-generated)',
	        // Use empty object for channel so that id is undefined and picasso creates one on the fly
	        onClick: function onClick() {
	          return _this2.onAddToChannel({}, _this2.props.album);
	        },
	        extra: [{
	          icon: 'settings',
	          onClick: function onClick() {
	            return _this2.setState({ presentMenuOpen: true, addToChannel: {} });
	          }
	        }]
	      });
	      if (!canEditPlaylists) {
	        return items;
	      }
	      if (channels.length !== 0) {
	        items.push({
	          heading: 'Add to channel'
	        });
	      }
	      return items.concat(channels.map(function (channel) {
	        return {
	          key: channel.id,
	          text: _react2.default.createElement(_ChannelMenuItem2.default, { channel: channel }),
	          onClick: function onClick() {
	            return _this2.onAddToChannel(channel, _this2.props.album);
	          },
	          extra: [{
	            icon: 'settings',
	            onClick: function onClick() {
	              return _this2.setState({ presentMenuOpen: true, addToChannel: channel });
	            }
	          }]
	        };
	      }));
	    }
	  }, {
	    key: 'getCover',
	    value: function getCover(album, images, selectedImages) {
	      if (selectedImages.length !== 0) {
	        return selectedImages[0];
	      }
	      if (album && album.cover) {
	        return album.cover;
	      }
	      return this.state.tempCover || images && images[0] && images[0]._id;
	    }
	  }, {
	    key: 'getLockText',
	    value: function getLockText() {
	      var query = this.props.query;
	      var loadingAll = this.state.loadingAll;
	
	      if (loadingAll) {
	        return _react2.default.createElement(_LoadingSpinner2.default, { style: { width: '12px', height: '12px', margin: 0 } });
	      }
	      return query.structure.fixed ? 'Unlock album' : 'Lock album';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          album = _props3.album,
	          query = _props3.query,
	          modals = _props3.modals,
	          images = _props3.images,
	          count = _props3.count,
	          loadMoreImages = _props3.loadMoreImages,
	          canSave = _props3.canSave,
	          canShare = _props3.canShare,
	          canDelete = _props3.canDelete,
	          anonymousUser = _props3.anonymousUser,
	          openModal = _props3.openModal,
	          _closeModal = _props3.closeModal,
	          excludeImages = _props3.excludeImages,
	          setCover = _props3.setCover,
	          getImageSource = _props3.getImageSource,
	          fetchChannels = _props3.fetchChannels,
	          addingToPlaylist = _props3.addingToPlaylist;
	      var selectedImages = query.selectedImages,
	          selectImageMode = query.selectImageMode;
	      var _state2 = this.state,
	          presentMenuOpen = _state2.presentMenuOpen,
	          downloadMenuOpen = _state2.downloadMenuOpen,
	          downloadSizeSelected = _state2.downloadSizeSelected,
	          playNowMenuOpen = _state2.playNowMenuOpen,
	          playNextMenuOpen = _state2.playNextMenuOpen,
	          addToChannel = _state2.addToChannel,
	          shareImagesMenuOpen = _state2.shareImagesMenuOpen,
	          addImagesMenuOpen = _state2.addImagesMenuOpen;
	
	
	      var imagesAvailable = !!images && images.length !== 0 && (!selectImageMode || selectedImages.length !== 0);
	
	      var canShareImages = this.props.canShareImagesInternal || this.props.canShareImagesExternal;
	
	      var mainMenuItems = [{
	        text: this.getLockText(),
	        onClick: this.toggleLock,
	        shouldShow: this.props.canLock && count,
	        disabled: count > _constants.MAX_FIXED_COUNT,
	        disabledMessage: 'Album must be less that ' + _constants.MAX_FIXED_COUNT + ' images to be locked'
	      }, {
	        text: 'Save as new album',
	        onClick: function onClick() {
	          return _this3.props.saveAlbum({
	            name: _this3.props.title,
	            cover: images[0]._id
	          }, query.structure);
	        },
	        shouldShow: !!this.props.location.query.path
	      }, {
	        text: 'Play now',
	        onClick: function onClick() {
	          if (_this3.props.canEditPlaylists) {
	            _this3.setState({
	              channels: null,
	              playNowMenuOpen: true,
	              playNow: true
	            });
	            fetchChannels().then(function (channels) {
	              return _this3.setState({ channels: channels });
	            });
	          } else {
	            _this3.setState({ presentMenuOpen: true });
	          }
	        },
	        shouldShow: imagesAvailable
	      }, {
	        text: 'Play next',
	        onClick: function onClick() {
	          _this3.setState({
	            channels: null,
	            playNextMenuOpen: true,
	            playNow: false
	          });
	          fetchChannels().then(function (channels) {
	            return _this3.setState({ channels: channels });
	          });
	        },
	        shouldShow: imagesAvailable && !anonymousUser && this.props.canEditPlaylists
	      }, {
	        text: 'Update Album Name/Settings',
	        onClick: function onClick() {
	          return openModal(_modals.SAVE_ALBUM_MODAL_KEY);
	        },
	        shouldShow: album && selectedImages.length === 0 && this.props.isOwnAlbum && this.props.canEdit
	      }, {
	        text: 'Add ' + (0, _string.pluralize)(selectedImages.length, 'image') + ' to album',
	        onClick: function onClick() {
	          return _this3.setState({ addImagesMenuOpen: true });
	        },
	        shouldShow: selectedImages.length !== 0
	      }, {
	        text: 'Add to groups',
	        href: album && '/album/' + album.id + '/groups',
	        shouldShow: album && !anonymousUser && selectedImages.length === 0
	      }, {
	        text: 'Share album',
	        href: album && '/album/' + album.id + '/share',
	        shouldShow: album && this.props.showShare && selectedImages.length === 0,
	        disabled: !canShare,
	        disabledMessage: 'You do not have permission to share this album'
	      }, {
	        text: 'Share ' + (0, _string.pluralize)(selectedImages.length, 'image'),
	        onClick: function onClick() {
	          return _this3.setState({ shareImagesMenuOpen: true });
	        },
	        shouldShow: canShareImages && selectedImages.length !== 0
	      }, {
	        text: selectedImages.length !== 0 ? 'Download ' + (0, _string.pluralize)(selectedImages.length, 'image') : album ? 'Download album' : 'Download all images',
	        onClick: function onClick(e) {
	          if (_this3.props.restrictDownload) {
	            if (selectedImages.length >= 20 || selectedImages.length === 0 && count >= 20) {
	              if (window.confirm('You are downloading a large number of images, which may take a long time on slow connections. Are you sure you want to continue?')) {
	                _this3.setState({ downloadMenuOpen: true });
	              }
	              return;
	            }
	          }
	          _this3.setState({ downloadMenuOpen: true });
	        },
	        shouldShow: imagesAvailable && this.props.canDownload,
	        disabled: this.props.restrictDownload && (selectedImages.length > 100 || selectedImages.length === 0 && count > 100),
	        disabledMessage: 'You cannot download more than 100 images at once'
	      }, {
	        text: 'Remove ' + (0, _string.pluralize)(selectedImages.length, 'image') + ' from album',
	        onClick: function onClick() {
	          return excludeImages(selectedImages);
	        },
	        shouldShow: this.props.canRemove && selectedImages.length !== 0
	      }, {
	        text: 'Delete album',
	        onClick: function onClick() {
	          var message = 'Are you sure you want to delete ' + album.name + '?';
	          var lists = _this3.props.albumLists.map(function (id) {
	            return _this3.props.entities.playlists[id].name;
	          });
	          if (lists.length !== 0) {
	            message += ' It is part of ' + (0, _humanizeList2.default)(lists);
	          }
	          if (window.confirm(message)) {
	            _this3.onDelete();
	          }
	        },
	        disabled: !canDelete,
	        disabledMessage: 'You do not have permission to delete this album'
	      }, {
	        text: 'Select all',
	        onClick: function onClick() {
	          return _this3.props.selectImage(images.map(function (i) {
	            return i._id;
	          }));
	        },
	        shouldShow: selectImageMode && images.length !== selectedImages.length
	      }, {
	        text: 'Select none',
	        onClick: this.props.disableImageSelect,
	        shouldShow: anonymousUser
	      }, {
	        text: 'Set image as album cover',
	        onClick: function onClick() {
	          if (album) {
	            setCover(selectedImages[0]);
	          } else {
	            _this3.setState({ tempCover: selectedImages[0] });
	          }
	        },
	        shouldShow: this.props.canEdit && selectedImages.length === 1
	      }];
	
	      var prefill = album && selectedImages.length === 0;
	      var initialFormValues = {
	        id: prefill ? album.id : undefined,
	        name: prefill ? album.name : '',
	        cover: this.getCover(album, images, selectedImages),
	        presentation_type: prefill && album.presentation_type || null,
	        presentation_speed: prefill && album.presentation_speed || null,
	        presentation_transition: prefill && album.presentation_transition || null,
	        presentation_sort: prefill && album.presentation_sort || null
	      };
	
	      var presentMenuItems = this.getPresentMenuItems();
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_DropMenu2.default, {
	          open: this.props.open,
	          closeMenu: this.props.closeMenu,
	          fixed: this.props.fixed,
	          items: mainMenuItems,
	          toggle: 'album-menu'
	        }),
	        presentMenuOpen && _react2.default.createElement(_PresentMenu2.default, {
	          closeMenu: function closeMenu() {
	            return _this3.setState({ presentMenuOpen: false, addToChannel: null });
	          },
	          images: selectedImages.length !== 0 ? selectedImages : (images || []).map(function (image) {
	            return image._id;
	          }),
	          selectedImages: selectedImages,
	          count: selectedImages.length || count,
	          loadMoreImages: loadMoreImages,
	          getImageSource: getImageSource,
	          presentTypeSelected: this.props.presentTypeSelected,
	          addToChannel: addToChannel,
	          onAddToChannel: this.onAddToChannel,
	          album: album,
	          entities: this.props.entities
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          open: downloadMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ downloadMenuOpen: false });
	          },
	          fixed: this.props.fixed,
	          items: [{ text: 'Small', onClick: function onClick() {
	              return _this3.setState({ downloadSizeSelected: 's75' });
	            } }, { text: 'Medium', onClick: function onClick() {
	              return _this3.setState({ downloadSizeSelected: 'm75' });
	            } }, { text: 'Large', onClick: function onClick() {
	              return _this3.setState({ downloadSizeSelected: 'l75' });
	            } }, { text: 'Original', onClick: function onClick() {
	              return _this3.setState({ downloadSizeSelected: 'o' });
	            } }]
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          open: playNowMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNowMenuOpen: false });
	          },
	          fixed: this.props.fixed,
	          items: presentMenuItems
	        }),
	        _react2.default.createElement(_DropMenu2.default, {
	          open: playNextMenuOpen,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNextMenuOpen: false });
	          },
	          fixed: this.props.fixed,
	          items: presentMenuItems
	        }),
	        modals[_modals.SAVE_ALBUM_MODAL_KEY] && _react2.default.createElement(_SaveAlbum2.default, {
	          title: selectedImages.length !== 0 ? 'Save images as album' : 'Save album',
	          onSubmit: this.onSave,
	          closeModal: function closeModal() {
	            return _closeModal(_modals.SAVE_ALBUM_MODAL_KEY);
	          },
	          initialValues: initialFormValues,
	          canSave: canSave && selectedImages.length === 0,
	          addingToPlaylist: addingToPlaylist,
	          lists: this.props.lists,
	          albumLists: this.props.albumLists,
	          defaultSort: query.structure.sort.value + (query.structure.sort.operator ? '-' + query.structure.sort.operator : ''),
	          presentTypeSelected: this.props.presentTypeSelected
	        }),
	        downloadSizeSelected && _react2.default.createElement(_DownloadImages2.default, {
	          size: downloadSizeSelected,
	          album: album,
	          count: count,
	          images: images.map(function (image) {
	            return image._id;
	          }),
	          selectedImages: selectedImages,
	          getImageSource: getImageSource,
	          entities: this.props.entities,
	          fetchAllImages: function fetchAllImages() {
	            return _this3.props.searchImages(query.structure, 0, _this3.props.trueCount);
	          },
	          onCancel: function onCancel() {
	            return _this3.setState({ downloadSizeSelected: false });
	          }
	        }),
	        shareImagesMenuOpen && _react2.default.createElement(_ImageShare2.default, {
	          images: selectedImages,
	          canShareInternal: this.props.canShareImagesInternal,
	          canShareExternal: this.props.canShareImagesExternal,
	          onCancel: function onCancel() {
	            return _this3.setState({ shareImagesMenuOpen: false });
	          }
	        }),
	        addImagesMenuOpen && _react2.default.createElement(_AddImagesToAlbum2.default, {
	          images: selectedImages,
	          onCancel: function onCancel() {
	            return _this3.setState({ addImagesMenuOpen: false });
	          }
	        })
	      );
	    }
	  }]);
	
	  return AlbumMenu;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var playlists = _ref2.playlists,
	      entities = _ref2.entities,
	      form = _ref2.form,
	      search = _ref2.search,
	      auth = _ref2.auth;
	  var album = _ref3.album,
	      location = _ref3.location,
	      canEdit = _ref3.canEdit;
	
	  return {
	    entities: entities,
	    me: auth.user,
	    presentTypeSelected: form.present && form.present.values && form.present.values.presentation_type || form.saveAlbum && form.saveAlbum.values && form.saveAlbum.values.presentation_type,
	    shouldSearchImages: function shouldSearchImages(structure) {
	      var hash = (0, _images.getHash)(structure);
	      return !search[hash] || !search[hash].data;
	    },
	    restrictDownload: !(0, _auth.userHasPerm)(auth.user, 'no_download_restriction'),
	    canEditPlaylists: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    canReorder: canEdit && !location.query.path,
	    canRemove: canEdit && !location.query.path,
	    fetchChannels: function fetchChannels() {
	      return (0, _fetch.picassoFetch)(auth, 'list_channels').then(function (data) {
	        return data.channels.filter(function (c) {
	          return parseInt(c.owner_id) === auth.user.id;
	        });
	      });
	    },
	    sendToPlayNext: function sendToPlayNext(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'add_album', _extends({
	        channel_id: channelID
	      }, body));
	    },
	    sendToPlayNow: function sendToPlayNow(channelID, body) {
	      return (0, _fetch.picassoFetch)(auth, 'play_album', _extends({
	        channel_id: channelID
	      }, body));
	    }
	  };
	};
	
	var mapDispatchToProps = {
	  saveAlbum: _album.saveAlbum,
	  deleteAlbum: _album.deleteAlbum,
	  unshareAlbum: _share.unshareAlbum,
	  openModal: _modals.openModal,
	  closeModal: _modals.closeModal,
	  excludeImages: _query.excludeImages,
	  enableImageReorder: _query.enableImageReorder,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  saveList: _playlists.saveList,
	  addAlbumToList: _playlists.addAlbumToList,
	  removeAlbumFromList: _playlists.removeAlbumFromList,
	  fixAlbum: _query.fixAlbum,
	  unfixAlbum: _query.unfixAlbum,
	  showBanner: _banners.showBanner,
	  presentChannel: function presentChannel(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/present/' + id));
	    };
	  },
	  goHome: function goHome(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/'));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlbumMenu);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _common = __webpack_require__(170);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _share = __webpack_require__(87);
	
	var _users = __webpack_require__(68);
	
	var _query = __webpack_require__(50);
	
	var _album = __webpack_require__(66);
	
	var _playlists = __webpack_require__(43);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ShareButton = __webpack_require__(201);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _SaveAlbum = __webpack_require__(307);
	
	var _SaveAlbum2 = _interopRequireDefault(_SaveAlbum);
	
	var _lists = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumShare = function (_Component) {
	  _inherits(AlbumShare, _Component);
	
	  function AlbumShare() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumShare);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumShare.__proto__ || Object.getPrototypeOf(AlbumShare)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      checked: _this.props.sharedUserIDs || [],
	      success: false,
	      submitting: false,
	      savingFixed: false
	    }, _this.isFormValid = function () {
	      var _this$props = _this.props,
	          users = _this$props.users,
	          sharedUserIDs = _this$props.sharedUserIDs;
	      var checked = _this.state.checked;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = users[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var user = _step.value;
	
	          if (checked.indexOf(user.id) !== -1 && sharedUserIDs.indexOf(user.id) === -1) {
	            return true;
	          }
	          if (checked.indexOf(user.id) === -1 && sharedUserIDs.indexOf(user.id) !== -1) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return false;
	    }, _this.onSubmit = function () {
	      var _this$props2 = _this.props,
	          id = _this$props2.id,
	          users = _this$props2.users,
	          sharedUserIDs = _this$props2.sharedUserIDs,
	          shareAlbum = _this$props2.shareAlbum,
	          unshareAlbum = _this$props2.unshareAlbum;
	      var checked = _this.state.checked;
	
	      var promises = [];
	      users.forEach(function (user) {
	        if (checked.indexOf(user.id) !== -1 && sharedUserIDs.indexOf(user.id) === -1) {
	          promises.push(shareAlbum(id, user.id));
	        }
	        if (checked.indexOf(user.id) === -1 && sharedUserIDs.indexOf(user.id) !== -1) {
	          promises.push(unshareAlbum(id, user.id));
	        }
	      });
	      if (promises.length === 0) {
	        return;
	      }
	      _this.setState({ submitting: true, success: false, error: null });
	      Promise.all(promises).then(function () {
	        _this.setState({
	          success: true,
	          submitting: false
	        });
	      }, function (error) {
	        _this.setState({
	          error: error,
	          submitting: false,
	          checked: _this.props.sharedUserIDs
	        });
	      });
	    }, _this.onClickFixHint = function () {
	      _this.setState({
	        loadingAll: true
	      });
	      var _this$props3 = _this.props,
	          loadAllImages = _this$props3.loadAllImages,
	          fixAlbum = _this$props3.fixAlbum;
	
	      loadAllImages().then(function () {
	        fixAlbum(_this.props.images.map(function (i) {
	          return i._id;
	        }));
	        _this.setState({
	          savingFixed: true,
	          loadingAll: false
	        });
	      });
	    }, _this.saveFixed = function (data) {
	      var _this$props4 = _this.props,
	          saveAlbum = _this$props4.saveAlbum,
	          query = _this$props4.query;
	
	      var albumData = _extends({}, data, {
	        lists: undefined,
	        createList: undefined
	      });
	      return saveAlbum(albumData, query.structure, data.id, '/album/:id/share').then(function (album) {
	        return (0, _lists.updateAlbumLists)({
	          albumID: album.id,
	          checked: data.lists,
	          createList: data.createList,
	          lists: _this.props.lists,
	          addAlbumToList: _this.props.addAlbumToList,
	          removeAlbumFromList: _this.props.removeAlbumFromList,
	          saveList: _this.props.saveList
	        });
	      }).then(function () {
	        _this.setState({
	          savingFixed: false
	        });
	      });
	    }, _this.getInitalSaveFormValues = function () {
	      var album = _this.props.album;
	
	      return {
	        id: album.id,
	        name: album.name,
	        cover: album.cover,
	        presentation_type: album.presentation_type,
	        presentation_speed: album.presentation_speed,
	        presentation_transition: album.presentation_transition,
	        presentation_sort: album.presentation_sort
	      };
	    }, _this.renderUser = function (user) {
	      var checked = _this.state.checked;
	
	      var isChecked = checked.indexOf(user.id) !== -1;
	      var onCheck = function onCheck() {
	        return _this.setState({ checked: checked.concat(user.id), success: false });
	      };
	      var onUncheck = function onUncheck() {
	        return _this.setState({ checked: checked.filter(function (id) {
	            return id !== user.id;
	          }), success: false });
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: user.id },
	        _react2.default.createElement(
	          'button',
	          {
	            className: isChecked ? _common2.default.userChecked : _common2.default.user,
	            onClick: isChecked ? onUncheck : onCheck },
	          _react2.default.createElement(
	            'div',
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userName },
	              user.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _common2.default.userEmail },
	              user.email
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: isChecked ? _common2.default.checkboxChecked : _common2.default.checkbox },
	            isChecked && _react2.default.createElement(_Icon2.default, { icon: 'tick', className: _common2.default.tick, size: 16 })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumShare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          users = _props.users,
	          fetchUsers = _props.fetchUsers,
	          sharedUserIDs = _props.sharedUserIDs,
	          fetchAlbumSharedUsers = _props.fetchAlbumSharedUsers,
	          id = _props.id;
	
	      if (!users) {
	        fetchUsers();
	      }
	      if (!sharedUserIDs) {
	        fetchAlbumSharedUsers(id).then(function (ids) {
	          _this2.setState({
	            checked: ids
	          });
	        });
	      }
	      if (!this.props.lists) {
	        this.props.fetchPlaylists();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          fetchAlbumSharedUsers = _props2.fetchAlbumSharedUsers;
	
	      if (id !== nextProps.id) {
	        fetchAlbumSharedUsers(nextProps.id).then(function (ids) {
	          _this3.setState({
	            checked: ids
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          users = _props3.users,
	          sharedUserIDs = _props3.sharedUserIDs,
	          fetching = _props3.fetching,
	          error = _props3.error,
	          fetchUsers = _props3.fetchUsers,
	          fetchAlbumSharedUsers = _props3.fetchAlbumSharedUsers,
	          id = _props3.id;
	
	
	      if (!users || !sharedUserIDs || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (error.users) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching all users',
	          onRetry: fetchUsers
	        });
	      }
	
	      if (error.shared) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching the list of users this album is shared with',
	          onRetry: function onRetry() {
	            return fetchAlbumSharedUsers(id);
	          }
	        });
	      }
	
	      var _props4 = this.props,
	          canShareInternal = _props4.canShareInternal,
	          canShareExternal = _props4.canShareExternal,
	          showFixHint = _props4.showFixHint;
	      var _state = this.state,
	          success = _state.success,
	          submitting = _state.submitting,
	          savingFixed = _state.savingFixed;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _common2.default.page },
	        canShareExternal && _react2.default.createElement(_ShareButton2.default, { path: '/album/' + id }),
	        canShareInternal && _react2.default.createElement(
	          'div',
	          null,
	          showFixHint && _react2.default.createElement(
	            'p',
	            { className: _common2.default.note },
	            'Note that you are sharing an unlocked album.'
	          ),
	          showFixHint && _react2.default.createElement(
	            'p',
	            { className: _common2.default.note },
	            'Images added later that match the search pattern will appear in the album.'
	          ),
	          showFixHint && _react2.default.createElement(
	            'p',
	            { className: _common2.default.note },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.onClickFixHint, className: _common2.default.link },
	              'Click here'
	            ),
	            ' to save the album as locked.'
	          ),
	          this.state.loadingAll && _react2.default.createElement(_LoadingSpinner2.default, null),
	          _react2.default.createElement(
	            'ul',
	            null,
	            users.map(this.renderUser)
	          ),
	          success && _react2.default.createElement(
	            'p',
	            { className: _common2.default.note },
	            'Album sharing was successfully updated'
	          ),
	          this.state.error && _react2.default.createElement(
	            'p',
	            { className: _common2.default.error },
	            'There was an error sharing the album'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _common2.default.buttons },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/album/' + id, className: success ? _common2.default.button : _common2.default.backButton },
	              success ? 'Done' : 'Cancel'
	            ),
	            !success && _react2.default.createElement(
	              'button',
	              { onClick: this.onSubmit, className: _common2.default.button, disabled: submitting || !this.isFormValid() },
	              submitting ? ' Submitting…' : 'Submit'
	            )
	          )
	        ),
	        savingFixed && _react2.default.createElement(_SaveAlbum2.default, {
	          title: 'Save fixed album',
	          onSubmit: this.saveFixed,
	          closeModal: function closeModal() {
	            _this4.setState({ savingFixed: false });
	            _this4.props.unfixAlbum();
	          },
	          initialValues: this.getInitalSaveFormValues(),
	          canSave: this.props.canSave,
	          lists: this.props.lists,
	          albumLists: this.props.albumLists,
	          defaultSort: this.props.sort.value + (this.props.sort.operator ? '-' + this.props.sort.operator : '')
	        })
	      );
	    }
	  }]);
	
	  return AlbumShare;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, props) {
	  var users = _ref2.users,
	      share = _ref2.share,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	
	  var sharedUsers = share.internal[props.id] || {};
	  return {
	    users: users.data && users.data.filter(function (id) {
	      return id !== entities.albums[props.id].user_id;
	    }).map(function (id) {
	      return entities.users[id];
	    }),
	    sharedUserIDs: sharedUsers.data,
	    fetching: users.fetching || sharedUsers.fetching,
	    error: {
	      users: users.error,
	      shared: sharedUsers.error
	    }
	  };
	};
	
	var mapDispatchToProps = {
	  fetchUsers: _users.fetchUsers,
	  fetchAlbumSharedUsers: _share.fetchAlbumSharedUsers,
	  shareAlbum: _share.shareAlbum,
	  unshareAlbum: _share.unshareAlbum,
	  fixAlbum: _query.fixAlbum,
	  unfixAlbum: _query.unfixAlbum,
	  saveAlbum: _album.saveAlbum,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  addAlbumToList: _playlists.addAlbumToList,
	  removeAlbumFromList: _playlists.removeAlbumFromList,
	  saveList: _playlists.saveList
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlbumShare);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropMenu = __webpack_require__(148);
	
	var _DropMenu2 = _interopRequireDefault(_DropMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortMenu = function (_Component) {
	  _inherits(SortMenu, _Component);
	
	  function SortMenu() {
	    _classCallCheck(this, SortMenu);
	
	    return _possibleConstructorReturn(this, (SortMenu.__proto__ || Object.getPrototypeOf(SortMenu)).apply(this, arguments));
	  }
	
	  _createClass(SortMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          closeMenu = _props.closeMenu,
	          updateSortOrder = _props.updateSortOrder,
	          manualDisabled = _props.manualDisabled;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DropMenu2.default, {
	          style: { right: 'auto', marginTop: '10px', marginLeft: '10px' },
	          open: open,
	          closeMenu: closeMenu,
	          items: [{
	            text: 'Relevance',
	            onClick: function onClick() {
	              return updateSortOrder('relevance');
	            }
	          }, {
	            text: 'Rating',
	            onClick: function onClick() {
	              return updateSortOrder('rating', 'desc');
	            },
	            extra: [{
	              icon: 'chevron-down',
	              onClick: function onClick() {
	                return updateSortOrder('rating', 'desc');
	              }
	            }, {
	              icon: 'chevron-up',
	              onClick: function onClick() {
	                return updateSortOrder('rating', 'asc');
	              }
	            }]
	          }, {
	            text: 'Date',
	            onClick: function onClick() {
	              return updateSortOrder('date', 'desc');
	            },
	            extra: [{
	              icon: 'chevron-down',
	              onClick: function onClick() {
	                return updateSortOrder('date', 'desc');
	              }
	            }, {
	              icon: 'chevron-up',
	              onClick: function onClick() {
	                return updateSortOrder('date', 'asc');
	              }
	            }]
	          }, {
	            text: 'Event',
	            onClick: function onClick() {
	              return updateSortOrder('event', 'desc');
	            },
	            extra: [{
	              icon: 'chevron-down',
	              onClick: function onClick() {
	                return updateSortOrder('event', 'desc');
	              }
	            }, {
	              icon: 'chevron-up',
	              onClick: function onClick() {
	                return updateSortOrder('event', 'asc');
	              }
	            }]
	          }, {
	            text: 'Filename',
	            onClick: function onClick() {
	              return updateSortOrder('filename', 'desc');
	            },
	            extra: [{
	              icon: 'chevron-down',
	              onClick: function onClick() {
	                return updateSortOrder('filename', 'desc');
	              }
	            }, {
	              icon: 'chevron-up',
	              onClick: function onClick() {
	                return updateSortOrder('filename', 'asc');
	              }
	            }]
	          }, {
	            text: 'Manual',
	            onClick: function onClick() {
	              return updateSortOrder('manual');
	            },
	            disabled: manualDisabled
	          }]
	        })
	      );
	    }
	  }]);
	
	  return SortMenu;
	}(_react.Component);
	
	exports.default = SortMenu;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _ChannelTabs = __webpack_require__(818);
	
	var _ChannelTabs2 = _interopRequireDefault(_ChannelTabs);
	
	var _TimezonePicker = __webpack_require__(300);
	
	var _TimezonePicker2 = _interopRequireDefault(_TimezonePicker);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChannelTabs = function (_Component) {
	  _inherits(ChannelTabs, _Component);
	
	  function ChannelTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChannelTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChannelTabs.__proto__ || Object.getPrototypeOf(ChannelTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openTab: null
	    }, _this.toggleSchedule = function () {
	      _this.setState({
	        openTab: _this.state.openTab === 'schedule' ? null : 'schedule'
	      });
	    }, _this.toggleTimezone = function () {
	      _this.setState({
	        openTab: _this.state.openTab === 'timezone' ? null : 'timezone'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChannelTabs, [{
	    key: 'renderSchedulePanel',
	    value: function renderSchedulePanel(data) {
	      var updateData = this.props.updateData;
	
	      var timeUpdater = function timeUpdater(key) {
	        return function (e) {
	          var value = e.target.value;
	          if (value === data[key]) return;
	          if (e.target.value && /^\d\d:\d\d$/.test(e.target.value) === false) return;
	          updateData(key, e.target.value || null);
	        };
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: _ChannelTabs2.default.panel },
	        _react2.default.createElement(
	          'div',
	          { className: _ChannelTabs2.default.flex },
	          'Schedule / View Period',
	          _react2.default.createElement('input', {
	            type: 'text',
	            defaultValue: data.schedule_from,
	            onBlur: timeUpdater('schedule_from'),
	            placeholder: 'hh:mm',
	            className: _ChannelTabs2.default.scheduleInput
	          }),
	          ' to ',
	          _react2.default.createElement('input', {
	            type: 'text',
	            defaultValue: data.schedule_to,
	            onBlur: timeUpdater('schedule_to'),
	            placeholder: 'hh:mm',
	            className: _ChannelTabs2.default.scheduleInput
	          }),
	          '(optional)'
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: data.schedule_reset,
	            onChange: function onChange() {
	              return updateData('schedule_reset', !data.schedule_reset);
	            }
	          }),
	          'Reset the queue when schedule starts'
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: data.schedule_force,
	            onChange: function onChange() {
	              return updateData('schedule_force', !data.schedule_force);
	            }
	          }),
	          'Play at any time within this view period'
	        )
	      );
	    }
	  }, {
	    key: 'renderTimezonePanel',
	    value: function renderTimezonePanel(data) {
	      var updateData = this.props.updateData;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ChannelTabs2.default.panel },
	        _react2.default.createElement(_TimezonePicker2.default, {
	          value: data.time_offset,
	          onChange: function onChange(e) {
	            return updateData('time_offset', e.target.value);
	          },
	          label: ''
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          channel = _props.channel,
	          clients = _props.clients,
	          mine = _props.mine,
	          onClickShare = _props.onClickShare;
	      var openTab = this.state.openTab;
	
	      var data = channel.data || {};
	      var shareCount = channel.members ? channel.members.length : 0;
	      if (!mine) {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/present/' + channel.id, className: _ChannelTabs2.default.fullWidthTab },
	          'View'
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _ChannelTabs2.default.tabs },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/present/' + channel.id, className: _ChannelTabs2.default.tab },
	          'View',
	          clients.length !== 0 && _react2.default.createElement(
	            'span',
	            { onClick: onClickShare, className: _ChannelTabs2.default.bubbleButton, title: (0, _string.pluralize)(shareCount, 'person', 'people') + ' currently viewing this channel' },
	            clients.length
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: _ChannelTabs2.default.tab, onClick: onClickShare },
	          'Share',
	          channel.disabled && ' disabled',
	          !channel.disabled && shareCount !== 0 && _react2.default.createElement(
	            'span',
	            { className: _ChannelTabs2.default.bubble, title: 'Shared with ' + (0, _string.pluralize)(shareCount, 'person', 'people') },
	            shareCount
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: openTab === 'schedule' ? _ChannelTabs2.default.openTab : _ChannelTabs2.default.tab, onClick: this.toggleSchedule },
	          getScheduleLabel(data.schedule_from, data.schedule_to)
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: openTab === 'timezone' ? _ChannelTabs2.default.openTab : _ChannelTabs2.default.tab, onClick: this.toggleTimezone },
	          getTimezoneLabel(parseInt(data.time_offset))
	        ),
	        openTab === 'schedule' && this.renderSchedulePanel(data),
	        openTab === 'timezone' && this.renderTimezonePanel(data)
	      );
	    }
	  }]);
	
	  return ChannelTabs;
	}(_react.Component);
	
	exports.default = ChannelTabs;
	
	
	function getScheduleLabel(start, end) {
	  if (start && end) {
	    return [start, _react2.default.createElement(
	      'span',
	      { key: '' },
	      ' to '
	    ), end];
	  }
	  if (start && !end) {
	    return 'Starts ' + start;
	  }
	  return 'Schedule';
	}
	
	function getTimezoneLabel(offset) {
	  if (offset === 'device' || offset === 'default') {
	    return 'Timezone';
	  }
	  if (!offset) {
	    return 'GMT';
	  }
	  var sign = offset > 0 ? '+' : '-';
	  var hours = Math.abs(offset) / 60 / 60;
	  return 'GMT' + sign + hours;
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTappable = __webpack_require__(469);
	
	var _reactTappable2 = _interopRequireDefault(_reactTappable);
	
	var _Thumbnail = __webpack_require__(820);
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRESS_DELAY = 500;
	
	var Thumbnail = function (_Component) {
	  _inherits(Thumbnail, _Component);
	
	  function Thumbnail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Thumbnail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Thumbnail.__proto__ || Object.getPrototypeOf(Thumbnail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loaded: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Thumbnail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var src = this.props.src;
	
	      this.img = new window.Image();
	      this.img.onload = function () {
	        return _this2.setState({ loaded: true });
	      };
	      this.img.src = src;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.img.src = '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          src = _props.src,
	          onClick = _props.onClick,
	          onPress = _props.onPress,
	          selected = _props.selected,
	          size = _props.size,
	          showInfoLink = _props.showInfoLink,
	          selectImageMode = _props.selectImageMode,
	          onClickInfo = _props.onClickInfo;
	      var loaded = this.state.loaded;
	
	      var imageClassName = loaded ? _Thumbnail2.default.imageLoaded : _Thumbnail2.default.image;
	      return _react2.default.createElement(
	        'li',
	        { className: _Thumbnail2.default.thumbnail, style: { maxWidth: size + 'px' } },
	        _react2.default.createElement(
	          _reactTappable2.default,
	          { onTap: onClick, onPress: onPress, pressDelay: PRESS_DELAY },
	          _react2.default.createElement(Image, { id: id, className: imageClassName, style: { backgroundImage: 'url(' + src + ')' }, size: size })
	        ),
	        showInfoLink && loaded && !selectImageMode && _react2.default.createElement(
	          'button',
	          { onClick: onClickInfo, className: _Thumbnail2.default.infoLink },
	          'i'
	        ),
	        selectImageMode && _react2.default.createElement('div', { className: selected ? _Thumbnail2.default.selectedOverlayActive : _Thumbnail2.default.selectedOverlay })
	      );
	    }
	  }]);
	
	  return Thumbnail;
	}(_react.Component);
	
	exports.default = Thumbnail;
	
	var Image = function (_Component2) {
	  _inherits(Image, _Component2);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.id !== nextProps.id || this.props.className !== nextProps.className || this.props.size !== nextProps.size;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', this.props);
	    }
	  }]);
	
	  return Image;
	}(_react.Component);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _FeaturedAlbum = __webpack_require__(821);
	
	var _FeaturedAlbum2 = _interopRequireDefault(_FeaturedAlbum);
	
	var _array = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeaturedAlbum = function (_Component) {
	  _inherits(FeaturedAlbum, _Component);
	
	  function FeaturedAlbum() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FeaturedAlbum);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeaturedAlbum.__proto__ || Object.getPrototypeOf(FeaturedAlbum)).call.apply(_ref, [this].concat(args))), _this), _this.album = (0, _array.shuffle)(_this.props.albums)[0], _this.state = {
	      loaded: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FeaturedAlbum, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var getImageSource = this.props.getImageSource;
	
	      this.img = new window.Image();
	      this.img.onload = function () {
	        return _this2.setState({ loaded: true });
	      };
	      this.img.src = getImageSource(this.album.cover, 'd');
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !this.state.loaded && nextState.loaded;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.img.src = '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getImageSource = this.props.getImageSource;
	      var loaded = this.state.loaded;
	
	      var coverClass = loaded ? _FeaturedAlbum2.default.coverLoaded : _FeaturedAlbum2.default.cover;
	      var coverStyle = {
	        backgroundImage: 'url(' + getImageSource(this.album.cover, 'd') + ')'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: _FeaturedAlbum2.default.album },
	        _react2.default.createElement('div', { className: coverClass, style: coverStyle }),
	        _react2.default.createElement(
	          'div',
	          { className: _FeaturedAlbum2.default.title },
	          'Featured Album'
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/album/' + this.album.id, className: _FeaturedAlbum2.default.name },
	          this.album.name
	        )
	      );
	    }
	  }]);
	
	  return FeaturedAlbum;
	}(_react.Component);
	
	exports.default = FeaturedAlbum;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Welcome = __webpack_require__(822);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _logoTransparent = __webpack_require__(886);
	
	var _logoTransparent2 = _interopRequireDefault(_logoTransparent);
	
	var _logoTransparentBlank = __webpack_require__(885);
	
	var _logoTransparentBlank2 = _interopRequireDefault(_logoTransparentBlank);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Welcome = function (_Component) {
	  _inherits(Welcome, _Component);
	
	  function Welcome() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Welcome);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Welcome.__proto__ || Object.getPrototypeOf(Welcome)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      page: _this.props.shareOnly ? 2 : 0
	    }, _this.nextPage = function () {
	      _this.setState({
	        page: _this.state.page + 1
	      });
	    }, _this.prevPage = function () {
	      _this.setState({
	        page: _this.state.page - 1
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Welcome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          canSearch = _props.canSearch,
	          canShare = _props.canShare;
	      var page = this.state.page;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Welcome2.default.wrapper },
	        page === 0 && _react2.default.createElement(
	          'div',
	          { className: _Welcome2.default.window },
	          _react2.default.createElement('img', { src: _logoTransparent2.default, className: _Welcome2.default.logo }),
	          _react2.default.createElement(
	            'h1',
	            { className: _Welcome2.default.heading },
	            'Welcome to Blayzr!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Welcome2.default.text },
	            _react2.default.createElement(
	              'p',
	              null,
	              'A living catalogue of favourite moments and best memories.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Crafted with love just for you!'
	            )
	          ),
	          canSearch && _react2.default.createElement(
	            'button',
	            { onClick: this.nextPage, className: _Welcome2.default.button },
	            'Next'
	          ),
	          !canSearch && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/albums', onClick: this.props.onClose, className: _Welcome2.default.button },
	            'Happy Hunting!'
	          )
	        ),
	        page === 1 && _react2.default.createElement(
	          'div',
	          { className: _Welcome2.default.window },
	          _react2.default.createElement(
	            'div',
	            { className: _Welcome2.default.logoOverlay },
	            _react2.default.createElement('img', { src: _logoTransparentBlank2.default, className: _Welcome2.default.logo }),
	            _react2.default.createElement(_Icon2.default, { icon: 'search', size: 36, style: { marginTop: '-3px', marginLeft: '-1px' } })
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: _Welcome2.default.heading },
	            'Make it yours'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Welcome2.default.text },
	            _react2.default.createElement(
	              'p',
	              { className: _Welcome2.default.biggerMargin },
	              'Across thousands of images, easily find People, Places, Events, Actions, Objects ',
	              _react2.default.createElement('br', null),
	              '\u2026or anything else you can think of!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Search for images and save albums'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Play slideshows'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Create your own collections and customise your experience'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.prevPage, className: _Welcome2.default.backButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'chevron-left', size: 30 })
	          ),
	          canShare && _react2.default.createElement(
	            'button',
	            { onClick: this.nextPage, className: _Welcome2.default.button },
	            'Next'
	          ),
	          !canShare && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/albums', onClick: this.props.onClose, className: _Welcome2.default.button },
	            'Happy Hunting!'
	          )
	        ),
	        page === 2 && _react2.default.createElement(
	          'div',
	          { className: _Welcome2.default.window },
	          _react2.default.createElement(
	            'div',
	            { className: _Welcome2.default.logoOverlay },
	            _react2.default.createElement('img', { src: _logoTransparentBlank2.default, className: _Welcome2.default.logo }),
	            _react2.default.createElement(_Icon2.default, { icon: 'heart', size: 36 })
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: _Welcome2.default.heading },
	            'Sharing and Caring'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Welcome2.default.text },
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is a private shared trove for everyone to enjoy and also respect'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Share your favourites with me!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Please remember to be wise sharing online generally and ask for permission from family before posting on social media etc.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Keep your password secure and do not share it with others.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Let me know asap if there is an issue.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Build it with me \u2013 this will always be a work in progress \u2013 if you see something that doesn\'t make sense, let me know; or if you spot someone who is missing, please flag the image with specific info so we can fix it for everyone.'
	            )
	          ),
	          !this.props.shareOnly && _react2.default.createElement(
	            'button',
	            { onClick: this.prevPage, className: _Welcome2.default.backButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'chevron-left', size: 30 })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/albums', onClick: this.props.onClose, className: _Welcome2.default.button },
	            'Happy Hunting!'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Welcome;
	}(_react.Component);
	
	exports.default = Welcome;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _album = __webpack_require__(66);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _images = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageFavouriteButton = function (_Component) {
	  _inherits(ImageFavouriteButton, _Component);
	
	  function ImageFavouriteButton() {
	    _classCallCheck(this, ImageFavouriteButton);
	
	    return _possibleConstructorReturn(this, (ImageFavouriteButton.__proto__ || Object.getPrototypeOf(ImageFavouriteButton)).apply(this, arguments));
	  }
	
	  _createClass(ImageFavouriteButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          favouriteImages = _props.favouriteImages,
	          setFavouriteImage = _props.setFavouriteImage,
	          className = _props.className;
	
	      var favourited = favouriteImages && favouriteImages.indexOf(id) !== -1;
	      return _react2.default.createElement(
	        'button',
	        {
	          className: className,
	          onClick: function onClick() {
	            return setFavouriteImage(id, !favourited);
	          } },
	        _react2.default.createElement(_Icon2.default, { icon: favourited ? 'heart' : 'heart-outline' })
	      );
	    }
	  }]);
	
	  return ImageFavouriteButton;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    favouriteImages: (0, _images.getFavouriteImages)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setFavouriteImage: _album.setFavouriteImage
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImageFavouriteButton);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _image = __webpack_require__(210);
	
	var _FlagImageModal = __webpack_require__(306);
	
	var _FlagImageModal2 = _interopRequireDefault(_FlagImageModal);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageFlagButton = function (_Component) {
	  _inherits(ImageFlagButton, _Component);
	
	  function ImageFlagButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageFlagButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageFlagButton.__proto__ || Object.getPrototypeOf(ImageFlagButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showModal: false
	    }, _this.openModal = function () {
	      _this.setState({
	        showModal: true
	      });
	    }, _this.closeModal = function () {
	      _this.setState({
	        showModal: false
	      });
	    }, _this.flagImage = function (options) {
	      console.log(options);
	      var _this$props = _this.props,
	          flagImage = _this$props.flagImage,
	          id = _this$props.id;
	
	      return flagImage(id, options).then(_this.closeModal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageFlagButton, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	      var showModal = this.state.showModal;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'button',
	          {
	            className: className,
	            onClick: this.openModal },
	          _react2.default.createElement(_Icon2.default, { icon: 'flag' })
	        ),
	        showModal && _react2.default.createElement(_FlagImageModal2.default, {
	          closeModal: this.closeModal,
	          onSubmit: this.flagImage
	        })
	      );
	    }
	  }]);
	
	  return ImageFlagButton;
	}(_react.Component);
	
	var mapDispatchToProps = {
	  flagImage: _image.flagImage
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ImageFlagButton);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FooterMenu;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _FooterMenu = __webpack_require__(824);
	
	var _FooterMenu2 = _interopRequireDefault(_FooterMenu);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FooterMenu(_ref) {
	  var items = _ref.items;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _FooterMenu2.default.menu },
	    items.map(renderItem)
	  );
	}
	
	function renderItem(_ref2) {
	  var icon = _ref2.icon,
	      size = _ref2.size,
	      onClick = _ref2.onClick,
	      href = _ref2.href,
	      shouldShow = _ref2.shouldShow,
	      disabled = _ref2.disabled;
	
	  if (typeof shouldShow !== 'undefined' && !shouldShow) {
	    return null;
	  }
	  var linkClassName = typeof disabled !== 'undefined' && disabled ? _FooterMenu2.default.linkDisabled : _FooterMenu2.default.link;
	  var itemClassName = icon === 'spinner' ? _FooterMenu2.default.itemSpinner : _FooterMenu2.default.item;
	  if (href) {
	    return _react2.default.createElement(
	      'li',
	      { key: icon, className: itemClassName },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: href, className: linkClassName },
	        _react2.default.createElement(_Icon2.default, { icon: icon, size: size })
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'li',
	    { key: icon, className: itemClassName },
	    _react2.default.createElement(
	      'button',
	      { onClick: onClick, className: linkClassName },
	      _react2.default.createElement(_Icon2.default, { icon: icon, size: size })
	    )
	  );
	}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jszip = __webpack_require__(902);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var _fileSaver = __webpack_require__(887);
	
	var _DownloadImages = __webpack_require__(825);
	
	var _DownloadImages2 = _interopRequireDefault(_DownloadImages);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadImages = function (_Component) {
	  _inherits(DownloadImages, _Component);
	
	  function DownloadImages() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadImages);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DownloadImages.__proto__ || Object.getPrototypeOf(DownloadImages)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      downloaded: 0
	    }, _this.filenames = {}, _this.getFilename = function (id) {
	      var filename = _this.props.entities.images[id]._filename;
	      if (_this.filenames[filename]) {
	        // Duplicate filename detected
	        var base = filename.replace(/\.[^/.]+$/, '');
	        var ext = filename.split('.').pop();
	        var count = 1;
	        while (_this.filenames[filename]) {
	          filename = base + ' (' + count + ').' + ext;
	          count++;
	        }
	      }
	      _this.filenames[filename] = true;
	      return filename;
	    }, _this.getFolderName = function () {
	      var _this$props = _this.props,
	          album = _this$props.album,
	          selectedImages = _this$props.selectedImages;
	
	      if (album) {
	        var suffix = selectedImages.length !== 0 ? '-selection' : '';
	        return '' + (0, _string.slug)(album.name) + suffix + '.zip';
	      }
	      return 'images.zip';
	    }, _this.getImageBlob = function (id) {
	      var _this$props2 = _this.props,
	          size = _this$props2.size,
	          getImageSource = _this$props2.getImageSource;
	
	      return window.fetch(getImageSource(id, size)).then(function (response) {
	        return response.blob();
	      }).then(function (blob) {
	        if (!_this.mounted) {
	          return Promise.reject();
	        }
	        _this.setState({ downloaded: _this.state.downloaded + 1 });
	        return { id: id, blob: blob };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DownloadImages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted = true;
	      var _props = this.props,
	          images = _props.images,
	          count = _props.count,
	          selectedImages = _props.selectedImages,
	          fetchAllImages = _props.fetchAllImages;
	
	      if (selectedImages.length !== 0) {
	        this.startDownload(selectedImages);
	      } else if (images.length === count) {
	        this.startDownload(images);
	      } else {
	        fetchAllImages().then(function () {
	          _this2.startDownload(_this2.props.images);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'startDownload',
	    value: function startDownload(images) {
	      var _this3 = this;
	
	      var blobs = [];
	      images.reduce(function (promise, id) {
	        return promise.then(function () {
	          if (!_this3.mounted) {
	            return Promise.reject();
	          }
	          return _this3.getImageBlob(id).then(function (blob) {
	            blobs.push(blob);
	          });
	        });
	      }, Promise.resolve()).then(function () {
	        var zip = new _jszip2.default();
	        blobs.forEach(function (image) {
	          zip.file(_this3.getFilename(image.id), image.blob);
	        });
	        zip.generateAsync({ type: 'blob' }).then(function (content) {
	          (0, _fileSaver.saveAs)(content, _this3.getFolderName());
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          count = _props2.count,
	          selectedImages = _props2.selectedImages,
	          onCancel = _props2.onCancel;
	      var downloaded = this.state.downloaded;
	
	      var total = selectedImages.length || count;
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: 'Download Images', onClose: onCancel },
	        _react2.default.createElement(
	          'div',
	          { className: _DownloadImages2.default.info },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('progress', { max: total, value: downloaded }),
	            _react2.default.createElement('br', null),
	            'Preparing ',
	            downloaded,
	            ' of ',
	            total,
	            ' images'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: onCancel, className: _DownloadImages2.default.button },
	            downloaded === total ? 'Done' : 'Cancel'
	          ),
	          _react2.default.createElement(_LoadingSpinner2.default, { show: downloaded !== total })
	        )
	      );
	    }
	  }]);
	
	  return DownloadImages;
	}(_react.Component);
	
	exports.default = DownloadImages;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _common = __webpack_require__(171);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _GenericAutocomplete = __webpack_require__(298);
	
	var _GenericAutocomplete2 = _interopRequireDefault(_GenericAutocomplete);
	
	var _KeywordList = __webpack_require__(299);
	
	var _KeywordList2 = _interopRequireDefault(_KeywordList);
	
	var _KeywordGraphPicker = __webpack_require__(128);
	
	var _KeywordGraphPicker2 = _interopRequireDefault(_KeywordGraphPicker);
	
	var _GroupedKeywords = __webpack_require__(200);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var INPUT_MAX_WIDTH = '280px';
	
	function EditDynamicLink(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      submitting = _ref.submitting,
	      onCancel = _ref.onCancel,
	      title = _ref.title,
	      types = _ref.types,
	      keywordArray = _ref.keywordArray,
	      useDates = _ref.useDates,
	      toggleUseDates = _ref.toggleUseDates,
	      useWeather = _ref.useWeather,
	      toggleUseWeather = _ref.toggleUseWeather,
	      getKeywordName = _ref.getKeywordName,
	      getKeywordGroup = _ref.getKeywordGroup;
	
	  var conditionType = useDates ? 'date' : 'text';
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: title, onClose: onCancel },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit, className: _common2.default.form, autoComplete: 'off' },
	      _react2.default.createElement(
	        _reduxForm.Field,
	        {
	          component: Input,
	          props: {
	            label: 'Table',
	            component: 'select',
	            className: _common2.default.weatherSelect
	          },
	          type: 'text',
	          name: 'type',
	          required: true
	        },
	        types.map(function (value) {
	          return _react2.default.createElement(
	            'option',
	            { key: value, value: value },
	            value
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: _common2.default.noBottomMargin },
	        _react2.default.createElement('input', { type: 'checkbox', checked: useDates, onChange: toggleUseDates }),
	        'Use a date condition'
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: _common2.default.noTopMargin },
	        _react2.default.createElement('input', { type: 'checkbox', checked: useWeather, onChange: toggleUseWeather }),
	        'Use a weather condition'
	      ),
	      !useWeather && _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: {
	          label: 'Condition' + (useDates ? ' (yyyy-mm-dd)' : ''),
	          style: { maxWidth: useDates ? '160px' : INPUT_MAX_WIDTH }
	        },
	        type: conditionType,
	        name: 'condition',
	        required: true,
	        placeholder: useDates ? 'yyyy-mm-dd' : 'Enter a condition'
	      }),
	      useWeather && _react2.default.createElement(
	        _reduxForm.Field,
	        {
	          component: Input,
	          props: {
	            component: 'select',
	            label: 'Condition',
	            className: _common2.default.weatherSelect,
	            style: { maxWidth: INPUT_MAX_WIDTH }
	          },
	          type: conditionType,
	          name: 'condition',
	          required: true
	        },
	        _constants.WEATHER_ARRAY.map(function (value) {
	          return _react2.default.createElement(
	            'option',
	            { key: value, value: value },
	            value
	          );
	        })
	      ),
	      _react2.default.createElement(_reduxForm.Field, {
	        component: Input,
	        props: {
	          label: 'Keywords',
	          component: KeywordPicker,
	          keywordArray: keywordArray,
	          getKeywordName: getKeywordName,
	          getKeywordGroup: getKeywordGroup
	        },
	        type: 'text',
	        name: 'keywords',
	        defaultValue: {
	          search: '',
	          keywords: []
	        }
	      }),
	      _react2.default.createElement(_ConfirmButtons2.default, {
	        onCancel: onCancel,
	        onConfirm: handleSubmit,
	        confirmDisabled: submitting,
	        confirmText: submitting ? 'Saving…' : 'Save'
	      }),
	      _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	    )
	  );
	}
	
	function Input(_ref2) {
	  var label = _ref2.label,
	      component = _ref2.component,
	      props = _objectWithoutProperties(_ref2, ['label', 'component']);
	
	  var Component = component || 'input';
	  return _react2.default.createElement(
	    'div',
	    { className: _common2.default.label },
	    label,
	    _react2.default.createElement(Component, props),
	    props.touched && props.error && _react2.default.createElement(
	      'div',
	      { className: _common2.default.error },
	      props.error
	    )
	  );
	}
	
	function KeywordPicker(_ref3) {
	  var value = _ref3.value,
	      onChange = _ref3.onChange,
	      keywordArray = _ref3.keywordArray,
	      getKeywordName = _ref3.getKeywordName,
	      getKeywordGroup = _ref3.getKeywordGroup;
	
	  var onChangeSearch = function onChangeSearch(text) {
	    onChange(_extends({}, value, {
	      search: text
	    }));
	  };
	  var onSelectKeyword = function onSelectKeyword(keyword) {
	    onChange({
	      search: '',
	      keywords: value.keywords.concat(keyword.id)
	    });
	  };
	  var onClickKeyword = function onClickKeyword(keyword, index) {
	    onChange(_extends({}, value, {
	      keywords: value.keywords.filter(function (id) {
	        return getKeywordName(id) !== keyword;
	      })
	    }));
	  };
	  var onSelectGraphKeyword = function onSelectGraphKeyword(node) {
	    if (value.keywords.indexOf(node.id) === -1) {
	      onChange(_extends({}, value, { keywords: value.keywords.concat(node.id) }));
	    } else {
	      onChange(_extends({}, value, { keywords: value.keywords.filter(function (id) {
	          return id !== node.id;
	        }) }));
	    }
	  };
	  var onSelectAllChildren = function onSelectAllChildren(nodes) {
	    var allChildrenSelected = true;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var node = _step.value;
	
	        if (value.keywords.indexOf(node.id) === -1) {
	          allChildrenSelected = false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (allChildrenSelected) {
	      onChange(_extends({}, value, {
	        keywords: value.keywords.filter(function (id) {
	          return nodes.findIndex(function (n) {
	            return n.id === id;
	          }) === -1;
	        })
	      }));
	    } else {
	      onChange(_extends({}, value, {
	        keywords: (0, _lodash2.default)(value.keywords.concat(nodes.map(function (n) {
	          return n.id;
	        })))
	      }));
	    }
	  };
	  var keywordGroups = {};
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = value.keywords[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var id = _step2.value;
	
	      var group = getKeywordGroup(id);
	      keywordGroups[group] = keywordGroups[group] || [];
	      keywordGroups[group].push(getKeywordName(id));
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  var keywords = Object.keys(keywordGroups).sort().map(function (key, index) {
	    var _COLORS = _slicedToArray(_GroupedKeywords.COLORS[index % _GroupedKeywords.COLORS.length], 3),
	        r = _COLORS[0],
	        g = _COLORS[1],
	        b = _COLORS[2];
	
	    return _react2.default.createElement(_KeywordList2.default, { keywords: keywordGroups[key], onClickKeyword: onClickKeyword, r: r, g: g, b: b });
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    value.keywords.length !== 0 && _react2.default.createElement(
	      'div',
	      { className: _common2.default.note },
	      'Click a keyword to remove'
	    ),
	    keywords,
	    _react2.default.createElement(_GenericAutocomplete2.default, {
	      value: value.search,
	      onChange: onChangeSearch,
	      onSelect: onSelectKeyword,
	      placeholder: 'Search for a keyword',
	      suggestions: [{
	        title: 'Keywords',
	        items: keywordArray
	      }],
	      style: { maxWidth: INPUT_MAX_WIDTH }
	    }),
	    _react2.default.createElement(_KeywordGraphPicker2.default, {
	      selected: value.keywords,
	      onSelect: onSelectGraphKeyword,
	      onSelectAllChildren: onSelectAllChildren
	    })
	  );
	}
	
	function validate(values, props) {
	  var errors = {};
	  if (!values.type) {
	    errors.type = 'A table is required';
	  }
	  if (!values.condition) {
	    errors.condition = 'A condition is required';
	  }
	  if (_constants.WEATHER_ARRAY.indexOf(values.condition) === -1 && /\d\d\d\d-\d\d-\d\d/.test(values.condition) === false) {
	    errors.condition = 'Condition must be a date or weather type';
	  }
	  if (!values.keywords || values.keywords.keywords.length === 0) {
	    errors.keywords = 'At least one keyword is required';
	  }
	  return errors;
	}
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'dynlink', validate: validate })(EditDynamicLink);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrchestraArrangePlayer = __webpack_require__(523);
	
	var _OrchestraArrangePlayer2 = _interopRequireDefault(_OrchestraArrangePlayer);
	
	var _reactResizable = __webpack_require__(1140);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _OrchestraArrange = __webpack_require__(242);
	
	var _OrchestraArrange2 = _interopRequireDefault(_OrchestraArrange);
	
	var _OrchestraArrangeSpawner = __webpack_require__(524);
	
	var _OrchestraArrangeSpawner2 = _interopRequireDefault(_OrchestraArrangeSpawner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrchestraArrange = function (_Component) {
	  _inherits(OrchestraArrange, _Component);
	
	  function OrchestraArrange() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrchestraArrange);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrchestraArrange.__proto__ || Object.getPrototypeOf(OrchestraArrange)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loaded: false,
	      dimensions: null,
	      scaleFactor: 1
	    }, _this.getContainerDimensions = function () {
	      if (_this.mounted) {
	        _this.setState({
	          dimensions: {
	            width: _this.container.offsetWidth,
	            height: _this.container.offsetHeight
	          }
	        }, _this.calculateScaleFactor);
	      }
	    }, _this.onPlayerMove = function (playerId, playerPos) {
	      var formation = _this.props.sceneFormation;
	      var scaleFactor = _this.state.scaleFactor;
	
	      // update the player position
	
	      var player = formation.players.find(function (player) {
	        return player.id === playerId;
	      });
	      player.x_pos = playerPos.x_pos * scaleFactor;
	      player.y_pos = playerPos.y_pos * scaleFactor;
	
	      // send to server
	      _this.props.onFormationChange(formation);
	    }, _this.onSceneResizeEnd = function (e, data) {
	      var scaleFactor = _this.state.scaleFactor;
	      var sceneFormation = _this.props.sceneFormation;
	
	      sceneFormation.scene_width = data.size.width * scaleFactor;
	      sceneFormation.scene_height = data.size.height * scaleFactor;
	      _this.props.onFormationChange(sceneFormation);
	    }, _this.onSceneWidthChange = function (newWidth) {
	      var sceneFormation = _this.props.sceneFormation;
	
	      sceneFormation.scene_width = newWidth;
	      _this.props.onFormationChange(sceneFormation);
	    }, _this.onSceneHeightChange = function (newHeight) {
	      var sceneFormation = _this.props.sceneFormation;
	
	      sceneFormation.scene_height = newHeight;
	      _this.props.onFormationChange(sceneFormation);
	    }, _this.onSceneScaleChange = function (newScale) {
	      _this.setState({ scaleFactor: newScale });
	    }, _this.onSpawnPosDrag = function (_, data) {
	      var sceneFormation = _this.props.sceneFormation;
	
	      sceneFormation.scene_preferences.spawn_x.value = data.x * _this.state.scaleFactor;
	      sceneFormation.scene_preferences.spawn_y.value = data.y * _this.state.scaleFactor;
	      _this.props.onPrefChange(sceneFormation.scene_preferences);
	    }, _this.calculateScaleFactor = function () {
	      var _this$state$dimension = _this.state.dimensions,
	          width = _this$state$dimension.width,
	          height = _this$state$dimension.height;
	      var _this$props$sceneForm = _this.props.sceneFormation,
	          scene_width = _this$props$sceneForm.scene_width,
	          scene_height = _this$props$sceneForm.scene_height;
	
	      var scaleFactor = 1;
	
	      // increase scale factor until everything fits!
	      while (scene_width / scaleFactor >= width || scene_height / scaleFactor >= height) {
	        scaleFactor++;
	      }
	      _this.setState({ scaleFactor: scaleFactor });
	    }, _this.scaleDimension = function (dimensionValue) {
	      var scaled = Math.floor(dimensionValue / _this.state.scaleFactor);
	      return scaled;
	    }, _this.renderExtraForSceneType = function (type, formation) {
	      if (type.toLowerCase() === 'floating') {
	        var prefs = formation.scene_preferences;
	        if (prefs && prefs.spawn_x) {
	          return _react2.default.createElement(_OrchestraArrangeSpawner2.default, {
	            xPos: _this.scaleDimension(prefs.spawn_x.value),
	            yPos: _this.scaleDimension(prefs.spawn_y.value),
	            angleRad: prefs.spawn_angle.value,
	            breadth: _this.scaleDimension(prefs.spawn_breadth.value),
	            onStop: _this.onSpawnPosDrag
	          });
	        }
	      }
	    }, _this.renderActions = function (actions) {
	      if (actions.length) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Actions'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _OrchestraArrange2.default.arrangerMenu },
	            _react2.default.createElement(
	              'button',
	              { onClick: _this.props.getJoinLink },
	              'Create join link'
	            )
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrchestraArrange, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.getContainerDimensions();
	      // window.addEventListener('resize', this.getContainerDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // window.removeEventListener('resize', this.getContainerDimensions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          sceneFormation = _props.sceneFormation,
	          selectedPlayerId = _props.selectedPlayerId;
	      var scaleFactor = this.state.scaleFactor;
	
	
	      if (sceneFormation) {
	        // TODO: only render actions if there are any...
	        var actions = [];
	        return _react2.default.createElement(
	          'div',
	          { className: _OrchestraArrange2.default.arrangerContainer, ref: function ref(el) {
	              return _this2.container = el;
	            } },
	          this.renderActions(actions),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Width: '
	          ),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: sceneFormation.scene_width,
	            min: 1,
	            className: _OrchestraArrange2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this2.onSceneWidthChange(parseInt(e.target.value));
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Height: '
	          ),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: sceneFormation.scene_height,
	            min: 1,
	            className: _OrchestraArrange2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this2.onSceneHeightChange(parseInt(e.target.value));
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Scale: '
	          ),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: scaleFactor,
	            min: 1,
	            max: 10,
	            step: 1,
	            className: _OrchestraArrange2.default.numberInput,
	            onChange: function onChange(e) {
	              return _this2.onSceneScaleChange(parseFloat(e.target.value));
	            }
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Layout'
	          ),
	          _react2.default.createElement(
	            _reactResizable.ResizableBox,
	            {
	              width: this.scaleDimension(sceneFormation.scene_width),
	              height: this.scaleDimension(sceneFormation.scene_height),
	              minConstraints: [this.scaleDimension(100), this.scaleDimension(100)],
	              onResizeStop: this.onSceneResizeEnd
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: _OrchestraArrange2.default.scene },
	                this.props.sceneFormation.players.map(function (player) {
	                  var playerStyle = {
	                    width: _this2.scaleDimension(player.width),
	                    height: _this2.scaleDimension(player.height)
	                  };
	                  var selected = player.id == selectedPlayerId;
	                  return _react2.default.createElement(_OrchestraArrangePlayer2.default, {
	                    key: player.id,
	                    style: playerStyle,
	                    id: player.id,
	                    name: player.name,
	                    connected: player.connected,
	                    selected: selected,
	                    position: { x: _this2.scaleDimension(player.x_pos), y: _this2.scaleDimension(player.y_pos) },
	                    onPlayerMove: _this2.onPlayerMove,
	                    identifyPlayer: _this2.props.identifyPlayer,
	                    onPlayerClicked: _this2.props.onPlayerClicked,
	                    width: player.width,
	                    height: player.height
	                  });
	                })
	              )
	            ),
	            this.renderExtraForSceneType(sceneFormation.scene_type, sceneFormation)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { ref: function ref(el) {
	              return _this2.container = el;
	            } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Connecting to Orchestra websocket...'
	          ),
	          _react2.default.createElement(_LoadingSpinner2.default, null)
	        );
	      }
	    }
	  }]);
	
	  return OrchestraArrange;
	}(_react.Component);
	
	exports.default = OrchestraArrange;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(287);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _OrchestraArrange = __webpack_require__(242);
	
	var _OrchestraArrange2 = _interopRequireDefault(_OrchestraArrange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrchestraArrangePlayer = function (_Component) {
	  _inherits(OrchestraArrangePlayer, _Component);
	
	  function OrchestraArrangePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrchestraArrangePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrchestraArrangePlayer.__proto__ || Object.getPrototypeOf(OrchestraArrangePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loaded: false,
	      x_pos: _this.props.left,
	      y_pos: _this.props.top
	    }, _this.handleStop = function (e, data) {
	      var pos = {
	        x_pos: data.x,
	        y_pos: data.y
	      };
	      _this.setState(pos, function () {
	        return _this.props.onPlayerMove(_this.props.id, pos);
	      });
	    }, _this.handleStart = function (e, data) {
	      _this.props.onPlayerClicked(_this.props.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrchestraArrangePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.connected ? [_OrchestraArrange2.default.player] : [_OrchestraArrange2.default.player, _OrchestraArrange2.default.inactive];
	      if (this.props.selected) {
	        className.push(_OrchestraArrange2.default.selected);
	      }
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        {
	          onStop: this.handleStop,
	          onStart: this.handleStart,
	          bounds: 'parent',
	          position: this.props.position
	        },
	        _react2.default.createElement(
	          'div',
	          { className: className, style: this.props.style },
	          _react2.default.createElement(
	            'div',
	            null,
	            'id: ',
	            this.props.id
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.width,
	            'x',
	            this.props.height
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrchestraArrangePlayer;
	}(_react.Component);
	
	exports.default = OrchestraArrangePlayer;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(287);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _OrchestraArrange = __webpack_require__(242);
	
	var _OrchestraArrange2 = _interopRequireDefault(_OrchestraArrange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrchestraArrangeSpawner = function (_Component) {
	  _inherits(OrchestraArrangeSpawner, _Component);
	
	  function OrchestraArrangeSpawner() {
	    _classCallCheck(this, OrchestraArrangeSpawner);
	
	    return _possibleConstructorReturn(this, (OrchestraArrangeSpawner.__proto__ || Object.getPrototypeOf(OrchestraArrangeSpawner)).apply(this, arguments));
	  }
	
	  _createClass(OrchestraArrangeSpawner, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          xPos = _props.xPos,
	          yPos = _props.yPos,
	          angleRad = _props.angleRad,
	          breadth = _props.breadth,
	          onStop = _props.onStop;
	
	      var spawnPos = { x: xPos, y: yPos };
	      var angleStyle = {
	        transform: 'rotate(' + angleRad + 'rad)',
	        transformOrigin: 'top left'
	      };
	      var breadthStyle = {
	        transformOrigin: 'top left',
	        transform: 'rotate(' + (angleRad + Math.PI / 2) + 'rad) translate(-' + breadth / 2.0 + 'px, 0px)',
	        width: breadth + 'px'
	      };
	
	      return _react2.default.createElement(
	        _reactDraggable2.default,
	        {
	          onStop: onStop,
	          bounds: 'parent',
	          position: spawnPos
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _OrchestraArrange2.default.spawner },
	          _react2.default.createElement('div', { className: _OrchestraArrange2.default.spawnAngle, style: angleStyle }),
	          _react2.default.createElement('div', { className: _OrchestraArrange2.default.spawnBreadth, style: breadthStyle })
	        )
	      );
	    }
	  }]);
	
	  return OrchestraArrangeSpawner;
	}(_react.Component);
	
	exports.default = OrchestraArrangeSpawner;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrchestraPreferences = __webpack_require__(827);
	
	var _OrchestraPreferences2 = _interopRequireDefault(_OrchestraPreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrchestraPreferences = function (_Component) {
	  _inherits(OrchestraPreferences, _Component);
	
	  function OrchestraPreferences() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrchestraPreferences);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrchestraPreferences.__proto__ || Object.getPrototypeOf(OrchestraPreferences)).call.apply(_ref, [this].concat(args))), _this), _this.parsePref = function (key, rawVal) {
	      var valType = _this.props.items[key].type;
	      switch (valType) {
	        case 'int':
	          {
	            return parseInt(rawVal);
	          }
	        case 'float':
	          {
	            return parseFloat(rawVal);
	          }
	        case 'bool':
	          {
	            return rawVal === 'true';
	          }
	        default:
	          {
	            return rawVal;
	          }
	      }
	    }, _this.onPrefChange = function (e) {
	      var items = _this.props.items;
	
	      var prefKey = e.target.getAttribute('name');
	      var parsedVal = _this.parsePref(prefKey, e.target.value);
	
	      // guard against invalid values
	      if (parsedVal == null) return;
	      if (parsedVal == undefined) return;
	      if (isNaN(parsedVal)) return;
	
	      // overwrite existing value with new one
	      items[prefKey].value = parsedVal;
	
	      // send update to server
	      _this.props.onPrefChange(items);
	    }, _this.onPrefInc = function (e) {
	      var items = _this.props.items;
	
	      var prefKey = e.target.getAttribute('name');
	      var item = items[prefKey];
	      item.value = item.value + item.granularity;
	
	      // send update to server
	      _this.props.onPrefChange(items);
	    }, _this.onPrefDec = function (e) {
	      var items = _this.props.items;
	
	      var prefKey = e.target.getAttribute('name');
	      var item = items[prefKey];
	      item.value = item.value - item.granularity;
	
	      // send update to server
	      _this.props.onPrefChange(items);
	    }, _this.renderItems = function () {
	      if (!_this.props.items) return [];
	      var items = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(_this.props.items)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              key = _step$value[0],
	              value = _step$value[1];
	
	          items.push(_this.renderItem(key, value));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return items;
	    }, _this.renderItem = function (pref_key, data) {
	      var control_type = data.control_type;
	
	      // generate some help / tooltip for known preferences
	
	      var helpTextForKey = {
	        // floating
	        'layer_count': 'Number of overlapping vertical layers',
	        'base_speed': 'Movement speed of images',
	        'spawn_x': 'X coordinate of the spawn point',
	        'spawn_y': 'Y coordinate of the spawn point',
	        'spawn_angle': 'The direction or angle images will travel from the spawn point',
	        'spawn_breadth': 'If the images flow in a stream from the spawn point, this is the width of that stream (positions chosen at random)',
	        'spawn_interval': 'The length of time in seconds before new images are spawned',
	        // ken burns
	        'travel': 'Distance the images will drift from center as they animate',
	        'dwell_time': 'The amount of time an image will persist before beginning to fade out (in seconds)',
	        'transition_time': 'The amount of time taken for the image to fade away (in seconds)',
	        'end_scale': 'The final scale of the image as it animates expressed as a coefficient - 1.0 means no scaling at all, 2.0 means the image will grow to twice the size'
	      };
	      var helpText = helpTextForKey[pref_key] || '';
	
	      switch (control_type) {
	        case 'slider':
	          {
	            return _react2.default.createElement(
	              'li',
	              { key: pref_key },
	              _react2.default.createElement(Slider, {
	                name: pref_key,
	                value: data.value,
	                prefix: data.nice_name,
	                min: data.min,
	                max: data.max,
	                step: data.granularity,
	                onChange: _this.onPrefChange,
	                onInc: _this.onPrefInc,
	                onDec: _this.onPrefDec
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _OrchestraPreferences2.default.prefHelpText },
	                helpText
	              )
	            );
	          }
	        case 'field':
	          {
	            return _react2.default.createElement(
	              'li',
	              { key: pref_key },
	              _react2.default.createElement(
	                'span',
	                null,
	                data.nice_name,
	                ': '
	              ),
	              _react2.default.createElement('input', {
	                name: pref_key,
	                type: 'number',
	                value: data.value,
	                min: data.bounded ? data.min : '',
	                max: data.bounded ? data.max : '',
	                className: _OrchestraPreferences2.default.numberInput,
	                onChange: _this.onPrefChange
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _OrchestraPreferences2.default.prefHelpText },
	                helpText
	              )
	            );
	          }
	        case 'select':
	          {
	            return;
	          }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrchestraPreferences, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: _OrchestraPreferences2.default.prefList },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return OrchestraPreferences;
	}(_react.Component);
	
	exports.default = OrchestraPreferences;
	
	
	var Slider = function Slider(_ref2) {
	  var name = _ref2.name,
	      value = _ref2.value,
	      onChange = _ref2.onChange,
	      onInc = _ref2.onInc,
	      onDec = _ref2.onDec,
	      min = _ref2.min,
	      max = _ref2.max,
	      _ref2$step = _ref2.step,
	      step = _ref2$step === undefined ? 1 : _ref2$step,
	      _ref2$prefix = _ref2.prefix,
	      prefix = _ref2$prefix === undefined ? '' : _ref2$prefix,
	      _ref2$rangeInputType = _ref2.rangeInputType,
	      rangeInputType = _ref2$rangeInputType === undefined ? 'range' : _ref2$rangeInputType;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: _OrchestraPreferences2.default.optionValue },
	      prefix,
	      ': ',
	      value
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('input', { className: _OrchestraPreferences2.default.sliderButton, name: name, type: "button", value: "-", onClick: onDec }),
	      _react2.default.createElement('input', {
	        value: value,
	        onChange: onChange,
	        type: rangeInputType,
	        min: min,
	        max: max,
	        step: step,
	        className: _OrchestraPreferences2.default.slider,
	        name: name
	      }),
	      _react2.default.createElement('input', { className: _OrchestraPreferences2.default.sliderButton, name: name, type: "button", value: "+", onClick: onInc })
	    )
	  );
	};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlbumEditModal = __webpack_require__(828);
	
	var _AlbumEditModal2 = _interopRequireDefault(_AlbumEditModal);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ConstraintsForm = __webpack_require__(308);
	
	var _ConstraintsForm2 = _interopRequireDefault(_ConstraintsForm);
	
	var _ToggleForm = __webpack_require__(149);
	
	var _ToggleForm2 = _interopRequireDefault(_ToggleForm);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _DiversityPicker = __webpack_require__(207);
	
	var _DiversityPicker2 = _interopRequireDefault(_DiversityPicker);
	
	var _utils = __webpack_require__(152);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbumEditModal = function (_Component) {
	  _inherits(AlbumEditModal, _Component);
	
	  function AlbumEditModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AlbumEditModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumEditModal.__proto__ || Object.getPrototypeOf(AlbumEditModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      saving: false
	    }, _this.onConfirm = function () {
	      _this.setState({ saving: true });
	      setTimeout(_this.props.onSave, 500);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AlbumEditModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          album = _props.album,
	          update = _props.update,
	          renderHeading = _props.renderHeading,
	          onCancel = _props.onCancel;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: 'Modify Album In This Playlist', onClose: onCancel },
	        _react2.default.createElement(
	          'div',
	          { className: _AlbumEditModal2.default.page },
	          this.props.renderAlbum(album, null, true),
	          renderHeading('Modify this album’s settings (for playlist only)'),
	          _react2.default.createElement(
	            _ToggleForm2.default,
	            {
	              showLabel: 'Find image settings',
	              description: 'This overrides limits and order from search',
	              indicatorValues: [album.albumLimit, album.albumSort] },
	            renderHeading('Find up to this number of photos'),
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: album.albumLimit || '',
	              min: 1,
	              className: _AlbumEditModal2.default.numberInput,
	              onChange: function onChange(e) {
	                return update('albumLimit', parseInt(e.target.value) || undefined);
	              }
	            }),
	            _react2.default.createElement(_DiversityPicker2.default, {
	              value: album.diversity || '',
	              onChange: function onChange(e) {
	                return update('diversity', parseFloat(e.target.value) || undefined);
	              }
	            }),
	            renderHeading('Find in this order'),
	            _react2.default.createElement(
	              'select',
	              { value: album.albumSort, onChange: function onChange(e) {
	                  return update('albumSort', e.target.value || undefined);
	                } },
	              !(0, _utils.isDynamicAlbum)(album) && _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Album default',
	                this.props.defaultSortSuffix
	              ),
	              _constants.SORT_ARRAY.map(function (option) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: option.value, value: option.value },
	                  option.name
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _ToggleForm2.default,
	            {
	              showLabel: 'Present image settings',
	              description: 'This applies to the set of images returned from the search request.',
	              indicatorValues: [album.presentationType, album.presentationSort, album.presentationLimitImages, album.presentationLimitMinutes, album.repeatTimes] },
	            renderHeading('Presentation mode'),
	            _react2.default.createElement(
	              'select',
	              { value: album.presentationType, onChange: function onChange(e) {
	                  return update('presentationType', e.target.value || undefined);
	                } },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Album default',
	                this.props.defaultPresentationTypeSuffix
	              ),
	              _constants.PRESENTATION_ARRAY.map(function (option) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: option.value, value: option.value },
	                  option.name
	                );
	              })
	            ),
	            renderHeading('Presentation sort order'),
	            _react2.default.createElement(
	              'select',
	              { value: album.presentationSort, onChange: function onChange(e) {
	                  return update('presentationSort', e.target.value || undefined);
	                } },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                'Album default',
	                this.props.defaultPresentationSortSuffix
	              ),
	              _constants.SORT_ARRAY.map(function (option) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: option.value, value: option.value },
	                  option.name
	                );
	              })
	            ),
	            renderHeading('Limit presentation to number of photos'),
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: album.presentationLimitImages || '',
	              min: 1,
	              className: _AlbumEditModal2.default.numberInput,
	              onChange: function onChange(e) {
	                return update('presentationLimitImages', parseInt(e.target.value) || undefined);
	              }
	            }),
	            renderHeading('Limit to number of minutes'),
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: album.presentationLimitMinutes || '',
	              min: 0.1,
	              className: _AlbumEditModal2.default.numberInput,
	              onChange: function onChange(e) {
	                return update('presentationLimitMinutes', parseFloat(e.target.value) || undefined);
	              }
	            }),
	            renderHeading('Repeat number of times'),
	            _react2.default.createElement('input', {
	              type: 'number',
	              value: album.repeatTimes || '',
	              min: 1,
	              className: _AlbumEditModal2.default.numberInput,
	              onChange: function onChange(e) {
	                return update('repeatTimes', parseInt(e.target.value) || undefined);
	              }
	            }),
	            album.repeatTimes >= 1 && _react2.default.createElement(
	              'div',
	              null,
	              renderHeading('Presentation sort order (when repeated)'),
	              _react2.default.createElement(
	                'select',
	                { value: album.presentationRepeatSort, onChange: function onChange(e) {
	                    return update('presentationRepeatSort', e.target.value);
	                  } },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  'Default'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'random' },
	                  'Random'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_ConstraintsForm2.default, {
	            values: album,
	            update: update,
	            renderHeading: renderHeading,
	            title: 'Schedule this album (optional)'
	          }),
	          _react2.default.createElement(_ConfirmButtons2.default, {
	            onCancel: onCancel,
	            onConfirm: this.onConfirm,
	            confirmText: this.state.saving ? 'Updating…' : 'Update',
	            confirmDisabled: this.state.saving
	          })
	        )
	      );
	    }
	  }]);
	
	  return AlbumEditModal;
	}(_react.Component);
	
	exports.default = AlbumEditModal;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArrayPicker = __webpack_require__(829);
	
	var _ArrayPicker2 = _interopRequireDefault(_ArrayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrayPicker = function (_Component) {
	  _inherits(ArrayPicker, _Component);
	
	  function ArrayPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArrayPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArrayPicker.__proto__ || Object.getPrototypeOf(ArrayPicker)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item) {
	      var _this$props = _this.props,
	          selected = _this$props.selected,
	          onChange = _this$props.onChange;
	
	      var active = selected.indexOf(item) !== -1;
	      var onClick = function onClick() {
	        if (active) {
	          if (selected.length === 1) {
	            onChange(undefined);
	          } else {
	            onChange(selected.filter(function (value) {
	              return value !== item;
	            }));
	          }
	        } else {
	          onChange(selected.concat(item));
	        }
	      };
	      return _react2.default.createElement(
	        'button',
	        {
	          key: item,
	          className: active ? _ArrayPicker2.default.button : _ArrayPicker2.default.greyButton,
	          onClick: onClick },
	        item
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ArrayPicker, [{
	    key: 'render',
	    value: function render() {
	      var array = this.props.array;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        array.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return ArrayPicker;
	}(_react.Component);
	
	ArrayPicker.defaultProps = {
	  selected: []
	};
	exports.default = ArrayPicker;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FooterMenu = __webpack_require__(519);
	
	var _FooterMenu2 = _interopRequireDefault(_FooterMenu);
	
	var _Menu = __webpack_require__(501);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ChannelMenuItem = __webpack_require__(205);
	
	var _ChannelMenuItem2 = _interopRequireDefault(_ChannelMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaylistMenu = function (_Component) {
	  _inherits(PlaylistMenu, _Component);
	
	  function PlaylistMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlaylistMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlaylistMenu.__proto__ || Object.getPrototypeOf(PlaylistMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      channels: null,
	      presentMenu: false,
	      playNowMenu: false,
	      playNextMenu: false,
	      presenting: false
	    }, _this.onAddToChannel = function (channel, playNow) {
	      var _this$props = _this.props,
	          id = _this$props.id,
	          sendToPlayNow = _this$props.sendToPlayNow,
	          sendToPlayNext = _this$props.sendToPlayNext,
	          showBanner = _this$props.showBanner;
	
	      var success = function success(data) {
	        if (!channel.id && playNow) {
	          _this.props.presentChannel(data.channel);
	        } else {
	          showBanner('Playlist added to channel');
	        }
	      };
	      if (playNow || !channel.id) {
	        sendToPlayNow(channel.id, { playlist_id: id }).then(success);
	      } else {
	        sendToPlayNext(channel.id, { playlist_id: id }).then(success);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PlaylistMenu, [{
	    key: 'getPresentMenuItems',
	    value: function getPresentMenuItems() {
	      var _this2 = this;
	
	      var _state = this.state,
	          playNowMenu = _state.playNowMenu,
	          channels = _state.channels;
	
	      if (!channels) {
	        return [{ text: _react2.default.createElement(_LoadingSpinner2.default, null) }];
	      }
	      var items = [{
	        text: playNowMenu ? 'Present on this device' : 'New channel (auto-generated)',
	        onClick: function onClick() {
	          return _this2.onAddToChannel({}, playNowMenu);
	        } // Empty channel to cause auto-generation
	      }];
	      return items.concat(channels.map(function (channel) {
	        return {
	          key: channel.id,
	          text: _react2.default.createElement(_ChannelMenuItem2.default, { channel: channel }),
	          onClick: function onClick() {
	            return _this2.onAddToChannel(channel, playNowMenu);
	          }
	        };
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          structure = _props.structure,
	          fetchChannels = _props.fetchChannels;
	      var _state2 = this.state,
	          presentMenu = _state2.presentMenu,
	          playNowMenu = _state2.playNowMenu,
	          playNextMenu = _state2.playNextMenu,
	          presenting = _state2.presenting;
	
	
	      var presentMenuItems = this.getPresentMenuItems();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Menu2.default, {
	          open: presentMenu,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ presentMenu: false });
	          },
	          items: [{
	            text: 'Play now',
	            onClick: function onClick() {
	              _this3.setState({
	                channels: null,
	                playNowMenu: true
	              });
	              fetchChannels().then(function (channels) {
	                return _this3.setState({ channels: channels });
	              });
	            }
	          }, {
	            text: 'Play next',
	            onClick: function onClick() {
	              _this3.setState({
	                channels: null,
	                playNextMenu: true
	              });
	              fetchChannels().then(function (channels) {
	                return _this3.setState({ channels: channels });
	              });
	            }
	          }]
	        }),
	        _react2.default.createElement(_Menu2.default, {
	          open: playNowMenu,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNowMenu: false });
	          },
	          items: presentMenuItems
	        }),
	        _react2.default.createElement(_Menu2.default, {
	          open: playNextMenu,
	          closeMenu: function closeMenu() {
	            return _this3.setState({ playNextMenu: false });
	          },
	          items: presentMenuItems
	        })
	      );
	    }
	  }]);
	
	  return PlaylistMenu;
	}(_react.Component);
	
	exports.default = PlaylistMenu;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactOnclickoutside = __webpack_require__(195);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _AlbumPicker = __webpack_require__(355);
	
	var _AlbumPicker2 = _interopRequireDefault(_AlbumPicker);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaylistPicker = function (_Component) {
	  _inherits(PlaylistPicker, _Component);
	
	  function PlaylistPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlaylistPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlaylistPicker.__proto__ || Object.getPrototypeOf(PlaylistPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      text: '',
	      showAutocomplete: false,
	      selected: -1
	    }, _this.onKeyDown = function (e) {
	      e.preventDefault();
	      _this.setState({ selected: _this.state.selected + 1 });
	    }, _this.onKeyUp = function (e) {
	      e.preventDefault();
	      if (_this.state.selected === 0) {
	        _this.refs.search.focus();
	      }
	      _this.setState({ selected: Math.max(-1, _this.state.selected - 1) });
	    }, _this.handleClickOutside = function () {
	      _this.setState({
	        showAutocomplete: false,
	        selected: -1
	      });
	    }, _this.onChangeText = function (e) {
	      _this.setState({
	        text: e.target.value,
	        selected: -1
	      });
	    }, _this.selectPlaylist = function (id) {
	      var onChange = _this.props.onChange;
	
	      onChange(id);
	      _this.setState({
	        text: '',
	        selected: -1,
	        showAutocomplete: false
	      });
	    }, _this.showAutocomplete = function () {
	      _this.setState({
	        showAutocomplete: true
	      });
	    }, _this.clearSearch = function () {
	      _this.setState({
	        text: '',
	        selected: -1,
	        showAutocomplete: false
	      });
	    }, _this.searchString = function (substring, string) {
	      return string.toLowerCase().indexOf(substring.toLowerCase()) !== -1;
	    }, _this.renderPlaylist = function (_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name,
	          json_data = _ref2.json_data;
	      var getImageSource = _this.props.getImageSource;
	
	      var onClick = function onClick() {
	        return _this.selectPlaylist(id);
	      };
	      var cover = null;
	      try {
	        var albumID = JSON.parse(json_data).albums[0].album;
	        cover = _this.props.albums.filter(function (a) {
	          return a.id === albumID;
	        })[0].cover;
	      } catch (e) {}
	      return _react2.default.createElement(
	        'li',
	        { key: id },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClick, className: _AlbumPicker2.default.autoCompleteItem },
	          getImageSource && _react2.default.createElement('div', {
	            className: _AlbumPicker2.default.cover,
	            style: { backgroundImage: 'url(' + _this.props.getImageSource(cover) + ')' }
	          }),
	          name
	        )
	      );
	    }, _this.renderAlbum = function (_ref3) {
	      var id = _ref3.id,
	          name = _ref3.name,
	          cover = _ref3.cover;
	      var _this$props = _this.props,
	          savePlaylist = _this$props.savePlaylist,
	          getImageSource = _this$props.getImageSource;
	
	      var onClick = function onClick() {
	        var data = { name: name + _constants.AUTO_PLAYLIST_SUFFIX };
	        var structure = { albums: [{ album: id }] };
	        _this.setState({
	          showAutocomplete: false
	        });
	        savePlaylist(data, structure, null, false).then(function (playlist) {
	          _this.selectPlaylist(playlist.id);
	        });
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: id },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClick, className: _AlbumPicker2.default.autoCompleteItem },
	          getImageSource && _react2.default.createElement('div', {
	            className: _AlbumPicker2.default.cover,
	            style: { backgroundImage: 'url(' + _this.props.getImageSource(cover) + ')' }
	          }),
	          name
	        )
	      );
	    }, _this.renderAutocomplete = function () {
	      var _this$props2 = _this.props,
	          playlists = _this$props2.playlists,
	          albums = _this$props2.albums;
	      var text = _this.state.text;
	
	
	      var filteredPlaylists = playlists.filter(function (playlist) {
	        return _this.searchString(text, playlist.name);
	      }).filter(function (playlist) {
	        return playlist.name.indexOf(_constants.AUTO_PLAYLIST_SUFFIX) === -1;
	      }).map(_this.renderPlaylist);
	
	      var filteredAlbums = albums.filter(function (album) {
	        return _this.searchString(text, album.name);
	      }).map(_this.renderAlbum);
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _AlbumPicker2.default.autoComplete },
	        filteredPlaylists.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AlbumPicker2.default.autoCompleteHeading },
	          'Playlists'
	        ),
	        filteredPlaylists,
	        filteredAlbums.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AlbumPicker2.default.autoCompleteHeading },
	          'Albums ',
	          _react2.default.createElement(
	            'span',
	            null,
	            '(Auto-create playlist)'
	          )
	        ),
	        filteredAlbums
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PlaylistPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.node = (0, _reactDom.findDOMNode)(this);
	      _mousetrap2.default.bind('up', this.onKeyUp);
	      _mousetrap2.default.bind('down', this.onKeyDown);
	      _mousetrap2.default.bind('escape', function () {
	        _this2.clearSearch();
	        _this2.setState({ showAlbumList: false });
	        _this2.refs.search.blur();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var selected = this.state.selected;
	
	      if (prevState.selected !== selected) {
	        var button = this.node.querySelectorAll('.' + _AlbumPicker2.default.autoCompleteItem)[selected];
	        button && button.focus();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _mousetrap2.default.unbind(['up', 'down', 'escape']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          text = _state.text,
	          showAutocomplete = _state.showAutocomplete;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _AlbumPicker2.default.wrapper },
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: text,
	          onChange: this.onChangeText,
	          onClick: this.showAutocomplete,
	          className: 'mousetrap ' + _AlbumPicker2.default.input,
	          placeholder: 'Add a playlist or album',
	          ref: 'search'
	        }),
	        (text !== '' || showAutocomplete) && _react2.default.createElement(
	          'button',
	          { onClick: this.clearSearch, className: _AlbumPicker2.default.clearButton },
	          _react2.default.createElement(_Icon2.default, { icon: 'close' })
	        ),
	        showAutocomplete && this.renderAutocomplete()
	      );
	    }
	  }]);
	
	  return PlaylistPicker;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(PlaylistPicker);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _QueueEditor = __webpack_require__(831);
	
	var _QueueEditor2 = _interopRequireDefault(_QueueEditor);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _SortableList = __webpack_require__(151);
	
	var _SortableList2 = _interopRequireDefault(_SortableList);
	
	var _SortableBar = __webpack_require__(150);
	
	var _SortableBar2 = _interopRequireDefault(_SortableBar);
	
	var _PlaylistPicker = __webpack_require__(529);
	
	var _PlaylistPicker2 = _interopRequireDefault(_PlaylistPicker);
	
	var _LocationPicker = __webpack_require__(153);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _string = __webpack_require__(16);
	
	var _utils = __webpack_require__(152);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BASE_STRUCTURE = {
	  playlists: [],
	  muted: []
	};
	
	function getStructure(props) {
	  if (props.queue) {
	    return _extends({}, BASE_STRUCTURE, JSON.parse(props.queue.json_data));
	  }
	  return BASE_STRUCTURE;
	}
	
	var QueueEditor = function (_Component) {
	  _inherits(QueueEditor, _Component);
	
	  function QueueEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QueueEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QueueEditor.__proto__ || Object.getPrototypeOf(QueueEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: _this.props.queue ? _this.props.queue.name : '',
	      structure: getStructure(_this.props),
	      conflicts: [],
	      checkingForConflicts: false,
	      conflictCheckError: null,
	      saveSuccess: false,
	      saving: false
	      // Used by queues page
	    }, _this.isUnsaved = function () {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          queue = _this$props.queue;
	      var _this$state = _this.state,
	          name = _this$state.name,
	          structure = _this$state.structure;
	
	      if (params.id && queue) {
	        return name && name !== queue.name || (0, _lodash2.default)(structure, JSON.parse(queue.json_data)) === false;
	      }
	      return name && structure.playlists.length !== 0;
	    }, _this.previewQueue = function () {
	      var onError = function onError(e) {
	        window.alert('There was an error loading the preview');
	        console.log(e);
	        _this.setState({ loadingPreview: false });
	      };
	      _this.setState({ loadingPreview: true });
	      _this.saveQueue().then(function (data) {
	        console.log('queue saved', data);
	        return _this.props.sendToPlayNow(_this.props.params.id);
	      }).then(function (data) {
	        console.log('channel opened', data);
	        _this.props.presentChannel(data.channel);
	      }, onError);
	    }, _this.onReorder = function (playlists) {
	      var structure = _this.state.structure;
	
	      _this.setState({
	        conflicts: [],
	        structure: _extends({}, structure, {
	          playlists: playlists
	        })
	      });
	    }, _this.deletePlaylist = function (index) {
	      var structure = _this.state.structure;
	
	      var id = structure.playlists[index];
	      _this.setState({
	        conflicts: [],
	        structure: _extends({}, structure, {
	          playlists: [].concat(_toConsumableArray(structure.playlists.slice(0, index)), _toConsumableArray(structure.playlists.slice(index + 1))),
	          muted: structure.muted.filter(function (i) {
	            return i !== id;
	          })
	        })
	      });
	    }, _this.addPlaylist = function (id) {
	      var structure = _this.state.structure;
	
	      _this.setState({
	        structure: _extends({}, structure, {
	          playlists: structure.playlists.concat(id)
	        })
	      });
	    }, _this.updateQueue = function (key, value) {
	      var structure = _this.state.structure;
	
	      _this.setState({
	        structure: _extends({}, structure, _defineProperty({}, key, value))
	      });
	    }, _this.togglePlaylistMuted = function (id) {
	      var structure = _this.state.structure;
	
	      if (structure.muted.indexOf(id) === -1) {
	        _this.updateQueue('muted', structure.muted.concat(id));
	      } else {
	        _this.updateQueue('muted', structure.muted.filter(function (i) {
	          return i !== id;
	        }));
	      }
	    }, _this.saveQueue = function () {
	      var _this$props2 = _this.props,
	          params = _this$props2.params,
	          saveQueue = _this$props2.saveQueue;
	      var _this$state2 = _this.state,
	          name = _this$state2.name,
	          structure = _this$state2.structure;
	
	      var id = params.id === 'create' ? undefined : params.id;
	      _this.preventSaveAlert = true;
	      _this.setState({
	        checkingForConflicts: false,
	        conflictCheckError: null,
	        saveSuccess: false,
	        saving: true
	      });
	      return saveQueue({ name: name }, structure, id, params.id === 'create').then(function (queue) {
	        _this.setState({
	          checkingForConflicts: true,
	          saveSuccess: true,
	          saving: false
	        });
	        _this.props.checkForConflicts(queue).then(function (response) {
	          _this.setState({
	            conflicts: response.validation,
	            checkingForConflicts: false
	          });
	        }, function (e) {
	          return _this.setState({
	            checkingForConflicts: false,
	            conflictCheckError: e
	          });
	        });
	      });
	    }, _this.deleteQueue = function () {
	      if (window.confirm('Are you sure you want to delete ' + _this.props.queue.name + '?')) {
	        _this.preventSaveAlert = true;
	        _this.props.deleteQueue(_this.props.queue.id);
	      }
	    }, _this.getCover = function (item) {
	      var _this$props3 = _this.props,
	          entities = _this$props3.entities,
	          getImageSource = _this$props3.getImageSource;
	
	      var album = entities.albums[item.album];
	      if (!album) {
	        return null;
	      }
	      return _react2.default.createElement('div', {
	        key: album.cover,
	        className: _QueueEditor2.default.cover,
	        style: { backgroundImage: 'url(' + getImageSource(album.cover, 'i') + ')' }
	      });
	    }, _this.renderPlaylist = function (id, index) {
	      var _this$props4 = _this.props,
	          editPlaylist = _this$props4.editPlaylist,
	          entities = _this$props4.entities;
	
	      var playlist = entities.playlists[id];
	      if (!playlist) {
	        return _react2.default.createElement(_SortableBar2.default, {
	          key: id,
	          title: 'Deleted playlist',
	          subtitle: 'This playlist has been deleted and should be removed from the queue',
	          onRemove: function onRemove() {
	            return _this.deletePlaylist(index);
	          },
	          className: _QueueEditor2.default.playlist
	        });
	      }
	      var conflicts = _this.state.conflicts.filter(function (c) {
	        return c.playlist === index;
	      });
	      var autoIndicator = playlist.name.indexOf(_constants.AUTO_PLAYLIST_SUFFIX) !== -1 ? _react2.default.createElement(
	        'small',
	        { key: 'auto' },
	        ' (autoplaylist)'
	      ) : null;
	      var name = playlist.name.replace(_constants.AUTO_PLAYLIST_SUFFIX, '');
	      return _react2.default.createElement(_SortableBar2.default, {
	        key: id,
	        title: [name, autoIndicator],
	        subtitle: _this.renderPlaylistSubtitle(playlist, conflicts),
	        muted: _this.state.structure.muted.indexOf(id) !== -1,
	        onMute: function onMute() {
	          return _this.togglePlaylistMuted(playlist.id);
	        },
	        onEdit: function onEdit() {
	          return editPlaylist(id);
	        },
	        onRemove: function onRemove() {
	          return _this.deletePlaylist(index);
	        },
	        className: _QueueEditor2.default.playlist
	      });
	    }, _this.renderConflict = function (conflict) {
	      return _react2.default.createElement(
	        'div',
	        { className: _QueueEditor2.default.conflict },
	        typeof conflict.album === 'number' ? 'Album ' + (conflict.album + 1) : 'Playlist',
	        ': ',
	        conflict.conflict
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QueueEditor, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var queue = this.props.queue;
	
	      if (!queue && nextProps.queue) {
	        this.setState({
	          name: nextProps.queue.name,
	          structure: getStructure(nextProps)
	        });
	      }
	      if (queue && !nextProps.queue) {
	        this.setState({
	          name: '',
	          structure: getStructure(nextProps)
	        });
	      }
	      if (queue && nextProps.queue && queue.json_data !== nextProps.queue.json_data) {
	        if ((0, _lodash2.default)(this.state.structure, JSON.parse(queue.json_data))) {
	          this.setState({
	            name: nextProps.queue.name,
	            structure: getStructure(nextProps)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'renderPlaylistSubtitle',
	    value: function renderPlaylistSubtitle(playlist, conflicts) {
	      var albums = JSON.parse(playlist.json_data).albums;
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _string.pluralize)(albums.length, 'album'),
	        _react2.default.createElement('br', null),
	        albums.map(this.getCover),
	        _react2.default.createElement('br', null),
	        conflicts.map(this.renderConflict)
	      );
	    }
	  }, {
	    key: 'renderSettings',
	    value: function renderSettings() {
	      var _this2 = this;
	
	      var structure = this.state.structure;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _QueueEditor2.default.settings },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Set location for dynamic links (if any)',
	          _react2.default.createElement(
	            'select',
	            {
	              value: structure.locationOverride || undefined,
	              onChange: function onChange(e) {
	                return _this2.updateQueue('locationOverride', e.target.value || undefined);
	              }
	            },
	            _react2.default.createElement(
	              'option',
	              { value: '' },
	              'Use locations set in albums'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'user' },
	              'Override all with default location (',
	              this.props.userDefaultLocation,
	              ')'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'custom' },
	              'Override all with custom location'
	            )
	          )
	        ),
	        structure.locationOverride === 'custom' && _react2.default.createElement(_LocationPicker2.default, {
	          value: structure.location || { lat: 51.5, lon: -0.13, address: 'London, UK' },
	          onChange: function onChange(value) {
	            return _this2.updateQueue('location', value);
	          },
	          hideMap: true
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          playlists = _props.playlists,
	          submitting = _props.submitting,
	          savePlaylist = _props.savePlaylist,
	          albums = _props.albums;
	      var _state = this.state,
	          name = _state.name,
	          structure = _state.structure;
	
	
	      var availablePlaylists = playlists.filter(function (p) {
	        return structure.playlists.indexOf(p.id) === -1;
	      });
	
	      var saveButton = _react2.default.createElement(
	        'button',
	        {
	          onClick: this.saveQueue,
	          className: _QueueEditor2.default.button,
	          disabled: !name || structure.playlists.length === 0 || submitting },
	        submitting ? 'Saving…' : 'Save Queue'
	      );
	      if (this.state.saveSuccess && !this.isUnsaved()) {
	        saveButton = _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return window.history.back();
	            }, className: _QueueEditor2.default.button },
	          'Done'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _QueueEditor2.default.page },
	        this.props.queue && _react2.default.createElement(
	          'button',
	          { onClick: this.previewQueue, className: _QueueEditor2.default.previewButton },
	          this.state.loadingPreview ? 'Loading Preview…' : 'Preview Queue'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _QueueEditor2.default.heading },
	          'Queue Name'
	        ),
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: name,
	          onChange: function onChange(e) {
	            return _this3.setState({ name: e.target.value });
	          },
	          autoFocus: !this.props.queue
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _QueueEditor2.default.heading },
	          'Playlists'
	        ),
	        structure.playlists.length !== 0 && _react2.default.createElement(_SortableList2.default, {
	          items: structure.playlists,
	          renderItem: this.renderPlaylist,
	          sortHandle: 'handle',
	          onSort: this.onReorder,
	          itemClass: _QueueEditor2.default.album
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _QueueEditor2.default.pickerWrapper },
	          _react2.default.createElement(_PlaylistPicker2.default, {
	            playlists: availablePlaylists,
	            albums: albums,
	            onChange: this.addPlaylist,
	            savePlaylist: savePlaylist,
	            getImageSource: this.props.getImageSource
	          })
	        ),
	        this.renderSettings(),
	        this.props.queue && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.deleteQueue,
	            className: _QueueEditor2.default.deleteButton },
	          'Delete Queue'
	        ),
	        saveButton,
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return window.history.back();
	            }, className: _QueueEditor2.default.cancelButton },
	          'Cancel'
	        ),
	        _react2.default.createElement(
	          'small',
	          { style: { clear: 'both', float: 'right' } },
	          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: '&nbsp;' } }),
	          this.state.checkingForConflicts && 'Checking for conflicts…',
	          this.state.conflictCheckError && 'There was an error checking for conflicts'
	        )
	      );
	    }
	  }]);
	
	  return QueueEditor;
	}(_react.Component);
	
	exports.default = QueueEditor;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChannelDebug = __webpack_require__(834);
	
	var _ChannelDebug2 = _interopRequireDefault(_ChannelDebug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChannelDebug = function (_Component) {
	  _inherits(ChannelDebug, _Component);
	
	  function ChannelDebug() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChannelDebug);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChannelDebug.__proto__ || Object.getPrototypeOf(ChannelDebug)).call.apply(_ref, [this].concat(args))), _this), _this.renderLog = function (_ref2) {
	      var message = _ref2.message,
	          source = _ref2.source;
	
	      var className = _ChannelDebug2.default.log;
	      if (source === 'frontend') className = _ChannelDebug2.default.frontend;
	      if (/^playing/i.test(message)) className = _ChannelDebug2.default.playing;
	      if (/^skipped/i.test(message)) className = _ChannelDebug2.default.skipped;
	      if (/^skipped due to/i.test(message)) className = _ChannelDebug2.default.skippedDue;
	      if (/^skipped\. /i.test(message)) className = _ChannelDebug2.default.skippedReasons;
	      if (/^error/i.test(message)) className = _ChannelDebug2.default.error;
	      if (/^conflict/i.test(message)) className = _ChannelDebug2.default.conflict;
	      return _react2.default.createElement(
	        'li',
	        { className: className },
	        source,
	        ': ',
	        message
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChannelDebug, [{
	    key: 'render',
	    value: function render() {
	      var logs = this.props.logs;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ChannelDebug2.default.page },
	        _react2.default.createElement(
	          'ul',
	          null,
	          logs.map(this.renderLog)
	        )
	      );
	    }
	  }]);
	
	  return ChannelDebug;
	}(_react.Component);
	
	exports.default = ChannelDebug;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Floating = __webpack_require__(837);
	
	var _Floating2 = _interopRequireDefault(_Floating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_WIDTH = 15; // %
	var MAX_WIDTH = 45; // %
	
	var Floating = function (_Component) {
	  _inherits(Floating, _Component);
	
	  function Floating() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Floating);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Floating.__proto__ || Object.getPrototypeOf(Floating)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: null,
	      activeImages: []
	    }, _this.onAnimationEnd = function () {
	      var _this$props = _this.props,
	          images = _this$props.images,
	          count = _this$props.count,
	          onFinish = _this$props.onFinish;
	      var activeImages = _this.state.activeImages;
	
	      if (activeImages.length === 1 && images.length === count && onFinish) {
	        onFinish();
	      } else {
	        _this.setState({
	          activeImages: _this.state.activeImages.slice(1)
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Floating, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted = true;
	      var _props = this.props,
	          images = _props.images,
	          count = _props.count,
	          loadMoreImages = _props.loadMoreImages,
	          onFinish = _props.onFinish;
	
	      if (images.length === 0) {
	        if (count !== 0) {
	          loadMoreImages().then(function () {
	            return _this2.loadSlide(0, 0);
	          });
	        } else {
	          // No images to show so just finish immediately
	          console.warn('Skipping presentation with no images');
	          onFinish();
	        }
	      } else {
	        this.loadSlide(0, 0);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var paused = this.props.paused;
	
	      if (paused && !nextProps.paused && this.loadSlideOnPlay) {
	        this.loadSlide(this.state.index + 1, 1000);
	        this.loadSlideOnPlay = false;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.delayTimeout);
	      this.mounted = false;
	    }
	  }, {
	    key: 'loadSlide',
	    value: function loadSlide(index, delay) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          options = _props2.options,
	          getImageSource = _props2.getImageSource,
	          images = _props2.images,
	          count = _props2.count,
	          loadMoreImages = _props2.loadMoreImages,
	          onChangeSlide = _props2.onChangeSlide;
	
	      var nextImageID = images[index];
	      delay = typeof delay !== 'undefined' ? delay : options.transition * 1000;
	
	      var delayPromise = new Promise(function (resolve) {
	        _this3.delayTimeout = setTimeout(resolve, delay);
	      });
	
	      var loadPromise = new Promise(function (resolve) {
	        var img = new window.Image();
	        img.onload = resolve;
	        img.onerror = resolve;
	        img.src = getImageSource(nextImageID, 'p');
	      });
	
	      return Promise.all([delayPromise, loadPromise]).then(function () {
	        if (!_this3.mounted) {
	          return;
	        }
	        if (_this3.props.paused) {
	          _this3.loadSlideOnPlay = true;
	          return;
	        }
	        if (onChangeSlide) {
	          onChangeSlide(index);
	        }
	        _this3.setState({
	          index: index,
	          activeImages: _this3.state.activeImages.concat(_extends({
	            id: nextImageID
	          }, _this3.randomPosition(index)))
	        });
	        var nextIndex = index + 1;
	
	        if (images[nextIndex]) {
	          _this3.loadSlide(nextIndex);
	        } else {
	          if (images.length === count) {
	            var remainingLoops = _this3.state.remainingLoops;
	
	            if (remainingLoops) {
	              _this3.loadSlide(0);
	              _this3.setState({
	                remainingLoops: remainingLoops - 1
	              });
	            } else {
	              _this3.loadSlide(0); // Loop back around by default
	            }
	          } else {
	            loadMoreImages().then(function () {
	              return _this3.loadSlide(nextIndex);
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'nextSlide',
	    value: function nextSlide() {
	      var images = this.props.images;
	      var index = this.state.index;
	
	      if (index < images.length - 1) {
	        clearTimeout(this.delayTimeout);
	        this.loadSlide(this.state.index + 1, 0);
	      }
	    }
	  }, {
	    key: 'prevSlide',
	    value: function prevSlide() {
	      // const { index } = this.state
	      // if (index > 0) {
	      //   clearTimeout(this.delayTimeout)
	      //   this.loadSlide(index - 1, 0)
	      // }
	    }
	  }, {
	    key: 'randomPosition',
	    value: function randomPosition(index) {
	      var options = this.props.options;
	
	      // Random left position
	
	      var columns = 3;
	      var gutter = 10;
	      var column = index % columns;
	      var columnSize = (100 - gutter * 2) / columns;
	      var left = gutter + column * columnSize + Math.floor(Math.random() * columnSize) + '%';
	
	      // Random size and speed
	      var random = Math.random();
	      var width = MIN_WIDTH + random * (MAX_WIDTH - MIN_WIDTH) + '%';
	      var duration = Math.max(10, Math.round(options.delay + (10 - (1 - random) * 20)));
	      var zIndex = Math.floor(random * 100);
	      return { left: left, width: width, duration: duration, zIndex: zIndex };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          paused = _props3.paused,
	          getImageSource = _props3.getImageSource;
	      var activeImages = this.state.activeImages;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        activeImages.map(function (image) {
	          var style = {
	            animationDuration: image.duration + 's',
	            animationPlayState: paused ? 'paused' : undefined,
	            maxWidth: image.width,
	            left: image.left,
	            zIndex: image.zIndex
	          };
	          return _react2.default.createElement('img', {
	            key: image.id,
	            className: _Floating2.default.image,
	            style: style,
	            src: getImageSource(image.id, 'p'),
	            onAnimationEnd: _this4.onAnimationEnd,
	            onClick: function onClick(e) {
	              return _this4.props.openImageInfo(e, image.id);
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return Floating;
	}(_react.Component);
	
	Floating.defaultProps = {
	  options: {
	    delay: 30,
	    transition: 5
	  }
	};
	exports.default = Floating;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(431);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _KenBurns = __webpack_require__(838);
	
	var _KenBurns2 = _interopRequireDefault(_KenBurns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RANDOM_CLASSNAME = [_KenBurns2.default.imageTopLeft, _KenBurns2.default.imageTopRight, _KenBurns2.default.imageBottomLeft, _KenBurns2.default.imageBottomRight];
	
	var KenBurns = function (_Component) {
	  _inherits(KenBurns, _Component);
	
	  function KenBurns() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, KenBurns);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KenBurns.__proto__ || Object.getPrototypeOf(KenBurns)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: null,
	      remainingLoops: _this.props.repeat
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(KenBurns, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted = true;
	      var _props = this.props,
	          images = _props.images,
	          count = _props.count,
	          loadMoreImages = _props.loadMoreImages,
	          onFinish = _props.onFinish;
	
	      if (images.length === 0) {
	        if (count !== 0) {
	          loadMoreImages().then(function () {
	            return _this2.loadSlide(0, 0);
	          });
	        } else {
	          // No images to show so just finish immediately
	          console.warn('Skipping presentation with no images');
	          onFinish();
	        }
	      } else {
	        this.loadSlide(0, 0);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var paused = this.props.paused;
	
	      if (paused && !nextProps.paused && this.loadSlideOnPlay) {
	        clearTimeout(this.delayTimeout);
	        this.loadSlide(this.state.index + 1, 1000);
	        this.loadSlideOnPlay = false;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.delayTimeout);
	      clearTimeout(this.finishTimeout);
	      this.mounted = false;
	    }
	    // shouldComponentUpdate (nextProps, nextState) {
	    //   const { index } = this.state
	    //   if (index !== nextState.index) {
	    //     return true
	    //   }
	    //   return false
	    // }
	
	  }, {
	    key: 'loadSlide',
	    value: function loadSlide(index, delay) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          options = _props2.options,
	          getImageSource = _props2.getImageSource,
	          images = _props2.images,
	          count = _props2.count,
	          loadMoreImages = _props2.loadMoreImages,
	          onChangeSlide = _props2.onChangeSlide,
	          onFinish = _props2.onFinish;
	
	      var nextImageID = images[index];
	      delay = typeof delay !== 'undefined' ? delay : options.delay * 1000;
	
	      var delayPromise = new Promise(function (resolve) {
	        _this3.delayTimeout = setTimeout(resolve, delay);
	      });
	
	      var loadPromise = new Promise(function (resolve) {
	        var img = new window.Image();
	        img.onload = resolve;
	        img.onerror = resolve;
	        img.src = getImageSource(nextImageID, 'p');
	      });
	
	      return Promise.all([delayPromise, loadPromise]).then(function () {
	        if (!_this3.mounted) {
	          return;
	        }
	        if (_this3.props.paused && delay !== 0) {
	          _this3.loadSlideOnPlay = true;
	          return;
	        }
	        if (onChangeSlide) {
	          onChangeSlide(index);
	        }
	        _this3.setState({
	          index: index,
	          imageClassName: RANDOM_CLASSNAME[Math.floor(Math.random() * RANDOM_CLASSNAME.length)]
	        });
	        var nextIndex = index + 1;
	
	        if (images[nextIndex]) {
	          _this3.loadSlide(nextIndex);
	        } else {
	          if (images.length === count) {
	            var remainingLoops = _this3.state.remainingLoops;
	
	            if (remainingLoops) {
	              _this3.loadSlide(0);
	              _this3.setState({
	                remainingLoops: remainingLoops - 1
	              });
	            } else if (onFinish) {
	              _this3.finishTimeout = setTimeout(function () {
	                _this3.setState({
	                  index: null
	                });
	                _this3.finishTimeout = setTimeout(onFinish, options.transition * 1000);
	              }, options.delay * 1000);
	            } else {
	              _this3.loadSlide(0); // Loop back around by default
	            }
	          } else {
	            loadMoreImages().then(function () {
	              return _this3.loadSlide(nextIndex);
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'nextSlide',
	    value: function nextSlide() {
	      var images = this.props.images;
	      var index = this.state.index;
	
	      if (index < images.length - 1) {
	        clearTimeout(this.delayTimeout);
	        this.loadSlide(index + 1, 0);
	      }
	    }
	  }, {
	    key: 'prevSlide',
	    value: function prevSlide() {
	      var index = this.state.index;
	
	      if (index > 0) {
	        clearTimeout(this.delayTimeout);
	        this.loadSlide(index - 1, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          images = _props3.images,
	          paused = _props3.paused,
	          getImageSource = _props3.getImageSource,
	          options = _props3.options;
	      var _state = this.state,
	          index = _state.index,
	          imageClassName = _state.imageClassName;
	
	      var id = images[index];
	      var transitionName = {
	        enter: _KenBurns2.default.enter,
	        enterActive: _KenBurns2.default.enterActive,
	        leave: _KenBurns2.default.leave,
	        leaveActive: _KenBurns2.default.leaveActive
	      };
	      var imageStyle = {
	        backgroundImage: id && 'url(' + getImageSource(id, 'p') + ')',
	        animationDuration: options.delay + options.transition + 's',
	        animationPlayState: paused ? 'paused' : undefined,
	        transitionDuration: options.transition + 's'
	      };
	
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: transitionName,
	          transitionEnterTimeout: 1000,
	          transitionLeaveTimeout: 1000 },
	        id && _react2.default.createElement('div', { key: id, className: imageClassName, style: imageStyle })
	      );
	    }
	  }]);
	
	  return KenBurns;
	}(_react.Component);
	
	KenBurns.defaultProps = {
	  options: {
	    delay: 3,
	    transition: 1
	  }
	};
	exports.default = KenBurns;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PresentOptionsForm = __webpack_require__(206);
	
	var _PresentOptionsForm2 = _interopRequireDefault(_PresentOptionsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PresentMenu = function (_Component) {
	  _inherits(PresentMenu, _Component);
	
	  function PresentMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PresentMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PresentMenu.__proto__ || Object.getPrototypeOf(PresentMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      options: null
	    }, _this.startPresenting = function (options) {
	      var _this$props = _this.props,
	          addToChannel = _this$props.addToChannel,
	          onAddToChannel = _this$props.onAddToChannel,
	          closeMenu = _this$props.closeMenu;
	
	      onAddToChannel(addToChannel, options);
	      closeMenu();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PresentMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          closeMenu = _props.closeMenu,
	          presentTypeSelected = _props.presentTypeSelected,
	          addToChannel = _props.addToChannel,
	          album = _props.album,
	          selectedImages = _props.selectedImages;
	
	
	      var defaultType = album && album.presentation_type || 'kenburns';
	      var albumStructure = album && JSON.parse(album.json_data);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PresentOptionsForm2.default, {
	          onSubmit: this.startPresenting,
	          onCancel: closeMenu,
	          presentTypeSelected: presentTypeSelected,
	          initialValues: {
	            presentation_type: defaultType,
	            presentation_speed: album && album.presentation_speed || (defaultType === 'floating' ? 30 : 3),
	            presentation_transition: album && album.presentation_transition || (defaultType === 'floating' ? 5 : 1),
	            presentation_sort: album && album.presentation_sort || null
	          },
	          defaultSort: albumStructure ? albumStructure.sort.value + (albumStructure.sort.operator ? '-' + albumStructure.sort.operator : '') : null,
	          confirmText: addToChannel ? 'Add to Channel' : 'Present',
	          imageSelection: selectedImages.length !== 0
	        })
	      );
	    }
	  }]);
	
	  return PresentMenu;
	}(_react.Component);
	
	exports.default = PresentMenu;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _screenfull = __webpack_require__(492);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _hammerjs = __webpack_require__(889);
	
	var _hammerjs2 = _interopRequireDefault(_hammerjs);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _Presentation = __webpack_require__(840);
	
	var _Presentation2 = _interopRequireDefault(_Presentation);
	
	var _KenBurns = __webpack_require__(533);
	
	var _KenBurns2 = _interopRequireDefault(_KenBurns);
	
	var _Floating = __webpack_require__(532);
	
	var _Floating2 = _interopRequireDefault(_Floating);
	
	var _PresentOptionsForm = __webpack_require__(206);
	
	var _PresentOptionsForm2 = _interopRequireDefault(_PresentOptionsForm);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Stars = __webpack_require__(202);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _Image = __webpack_require__(208);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageMenu = __webpack_require__(304);
	
	var _ImageMenu2 = _interopRequireDefault(_ImageMenu);
	
	var _date = __webpack_require__(578);
	
	var _array = __webpack_require__(213);
	
	var _string = __webpack_require__(16);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Presentation = function (_Component) {
	  _inherits(Presentation, _Component);
	
	  function Presentation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Presentation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Presentation.__proto__ || Object.getPrototypeOf(Presentation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showControls: false,
	      showPresentOptions: false,
	      paused: false,
	      showImageInfo: null,
	      index: 0, // Controlled by deeper presentation component
	      // Present options overrides
	      type: null,
	      speed: null,
	      transition: null
	    }, _this.images = getImages(_this.props), _this.onClickPresentation = function (e) {
	      var preventHide = isDescendant(_this.refs.topbar, e.target);
	      if (_this.state.showControls && !preventHide) {
	        _this.setState({ showControls: false });
	      } else {
	        _this.setState({ showControls: true });
	      }
	    }, _this.onClickPresentOptions = function () {
	      _this.setState({ showPresentOptions: true });
	      _this.onOpenOverlay();
	    }, _this.onCancelPresentOptions = function () {
	      _this.setState({ showPresentOptions: false });
	      _this.onCloseOverlay();
	    }, _this.onSubmitPresentOptions = function (data) {
	      _this.setState({
	        type: data.presentation_type,
	        speed: data.presentation_speed,
	        transition: data.presentation_transition
	      });
	      _this.onCancelPresentOptions();
	    }, _this.onChangeSlide = function (index) {
	      _this.setState({ index: index });
	    }, _this.onToggleFullscreen = function () {
	      _screenfull2.default.toggle();
	    }, _this.onClose = function () {
	      if (_screenfull2.default.isFullscreen) {
	        _screenfull2.default.exit();
	      }
	      _this.props.onClose();
	    }, _this.openImageInfo = function (e, id) {
	      e.stopPropagation();
	      _this.setState({ showImageInfo: id });
	      _this.onOpenOverlay();
	    }, _this.closeImageInfo = function (e) {
	      e.stopPropagation();
	      _this.setState({ showImageInfo: null });
	      _this.onCloseOverlay();
	    }, _this.onOpenOverlay = function () {
	      _this.setState({
	        paused: true,
	        pausedInBackground: _this.state.paused
	      });
	    }, _this.onCloseOverlay = function () {
	      _this.setState({
	        paused: _this.state.pausedInBackground
	      });
	    }, _this.pause = function () {
	      _this.setState({ paused: true });
	      _this.props.onPause && _this.props.onPause();
	    }, _this.play = function () {
	      _this.setState({ paused: false });
	      _this.props.onPlay && _this.props.onPlay();
	    }, _this.prevSlide = function () {
	      return _this.refs.presentation.prevSlide();
	    }, _this.nextSlide = function () {
	      return _this.refs.presentation.nextSlide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Presentation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.hammer = new _hammerjs2.default((0, _reactDom.findDOMNode)(this));
	      this.hammer.on('swipeleft', this.prevSlide);
	      this.hammer.on('swiperight', this.nextSlide);
	      _mousetrap2.default.bind('left', this.prevSlide);
	      _mousetrap2.default.bind('right', this.nextSlide);
	      _mousetrap2.default.bind('escape', this.onClose);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.images = getImages(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.hammer.destroy();
	    }
	    // Methods called from outide
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onSkip = _props.onSkip,
	          onStartAgain = _props.onStartAgain,
	          queueName = _props.queueName,
	          playlistName = _props.playlistName,
	          albumName = _props.albumName,
	          props = _objectWithoutProperties(_props, ['onSkip', 'onStartAgain', 'queueName', 'playlistName', 'albumName']);
	
	      var _state = this.state,
	          showControls = _state.showControls,
	          paused = _state.paused,
	          index = _state.index;
	
	      var image = props.entities && props.entities.images[this.images[index]];
	      var type = this.state.type || this.props.type;
	      var options = {
	        delay: this.state.speed || this.props.options.delay,
	        transition: this.state.transition || this.props.options.transition
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: _Presentation2.default.wrapper, onClick: this.onClickPresentation },
	        type === 'kenburns' && _react2.default.createElement(_KenBurns2.default, _extends({
	          ref: 'presentation'
	        }, props, {
	          options: options,
	          images: this.images,
	          paused: paused,
	          onChangeSlide: this.onChangeSlide
	        })),
	        type === 'floating' && _react2.default.createElement(_Floating2.default, _extends({
	          ref: 'presentation'
	        }, props, {
	          options: options,
	          images: this.images,
	          paused: paused,
	          onChangeSlide: this.onChangeSlide,
	          openImageInfo: this.openImageInfo
	        })),
	        _react2.default.createElement(
	          'div',
	          { className: showControls ? _Presentation2.default.controls : _Presentation2.default.controlsHidden },
	          _react2.default.createElement(
	            'div',
	            { className: _Presentation2.default.topBar, ref: 'topbar' },
	            _react2.default.createElement(
	              'div',
	              { className: _Presentation2.default.progress },
	              this.props.imagesPlayedCount + index + 1,
	              ' of ',
	              props.showTotalCount || props.count
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.controlButton, onClick: onStartAgain, disabled: !onStartAgain },
	              _react2.default.createElement(_Icon2.default, { icon: 'restart' })
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: _Presentation2.default.controlButton,
	                onClick: function onClick() {
	                  return _this2.refs.presentation.prevSlide();
	                },
	                disabled: type === 'floating' },
	              _react2.default.createElement(_Icon2.default, { icon: 'rewind' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.controlButton, onClick: paused ? this.play : this.pause },
	              _react2.default.createElement(_Icon2.default, { icon: paused ? 'play' : 'pause' })
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: _Presentation2.default.controlButton,
	                onClick: function onClick() {
	                  return _this2.refs.presentation.nextSlide();
	                },
	                disabled: type === 'floating' },
	              _react2.default.createElement(_Icon2.default, { icon: 'forward' })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.controlButton, onClick: onSkip, disabled: !onSkip },
	              _react2.default.createElement(_Icon2.default, { icon: 'skip' })
	            ),
	            _screenfull2.default.enabled && !_constants.IS_IOS && _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.controlButton, onClick: this.onToggleFullscreen },
	              _react2.default.createElement(_Icon2.default, { icon: 'fullscreen', size: 24 })
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: this.props.anonymousUser ? _Presentation2.default.settingsButtonCorner : _Presentation2.default.settingsButton, onClick: this.onClickPresentOptions },
	              _react2.default.createElement(_Icon2.default, { icon: 'settings' })
	            ),
	            !this.props.anonymousUser && _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.closeButton, onClick: this.onClose },
	              _react2.default.createElement(_Icon2.default, { icon: 'close', size: 28 })
	            ),
	            this.props.channelDebug && !this.props.anonymousUser && _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.debugButton, onClick: this.props.onShowDebugOverlay },
	              'Debug'
	            ),
	            this.props.channelInfo && !this.props.anonymousUser && _react2.default.createElement(
	              'button',
	              { className: _Presentation2.default.infoButton, onClick: this.props.onShowInfoOverlay },
	              'Info'
	            )
	          ),
	          !this.props.anonymousUser && _react2.default.createElement(
	            'ul',
	            { className: _Presentation2.default.bottomBar },
	            image && image._keywords && type === 'kenburns' && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Event:'
	              ),
	              ' ',
	              (0, _string.getEventTitle)(image._event)
	            ),
	            albumName && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Album:'
	              ),
	              ' ',
	              albumName
	            ),
	            playlistName && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Playlist:'
	              ),
	              ' ',
	              playlistName
	            ),
	            queueName && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Queue:'
	              ),
	              ' ',
	              queueName
	            )
	          ),
	          image && type === 'kenburns' && _react2.default.createElement(
	            'div',
	            { className: _Presentation2.default.tools, onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            !this.props.anonymousUser && _react2.default.createElement(_ImageMenu2.default, {
	              image: image,
	              getImageSource: this.props.getImageSource,
	              hidePresentOptions: true,
	              showInfoLink: false,
	              canShareInternal: this.props.canShareImagesInternal,
	              canShareExternal: this.props.canShareImagesExternal,
	              style: { right: '40px' },
	              onOpen: this.onOpenOverlay,
	              onClose: this.onCloseOverlay
	            }),
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick(e) {
	                  return _this2.openImageInfo(e, _this2.images[index]);
	                }, className: _Presentation2.default.info },
	              _react2.default.createElement(_Icon2.default, { icon: 'info' })
	            ),
	            _react2.default.createElement(_Stars2.default, {
	              className: _Presentation2.default.stars,
	              rating: image._rating,
	              image: image,
	              clickable: true,
	              whiteStars: true,
	              showFlag: true,
	              onFlag: this.onOpenOverlay,
	              onCloseFlag: this.onCloseOverlay
	            })
	          )
	        ),
	        this.state.showImageInfo && _react2.default.createElement(
	          'div',
	          { className: _Presentation2.default.imageInfoOverlay, onClick: this.closeImageInfo },
	          _react2.default.createElement(
	            'div',
	            { className: _Presentation2.default.imageInfo, onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(_Image2.default, { params: { id: this.state.showImageInfo }, onClickThumbnail: function onClickThumbnail() {} })
	          )
	        ),
	        this.props.showDebugOverlay && _react2.default.createElement(
	          'div',
	          { className: _Presentation2.default.imageInfoOverlay, onClick: this.props.onHideDebugOverlay },
	          _react2.default.createElement(
	            'div',
	            { className: _Presentation2.default.debugModal, onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            this.props.channelDebug
	          )
	        ),
	        this.props.showInfoOverlay && _react2.default.createElement(
	          'div',
	          { className: _Presentation2.default.imageInfoOverlay, onClick: this.props.onHideInfoOverlay },
	          _react2.default.createElement(
	            'div',
	            { className: _Presentation2.default.debugModal, onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            this.props.channelInfo
	          )
	        ),
	        this.state.showPresentOptions && _react2.default.createElement(
	          'div',
	          { className: _Presentation2.default.imageInfoOverlay, onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(_PresentOptionsForm2.default, {
	            onSubmit: this.onSubmitPresentOptions,
	            onCancel: this.onCancelPresentOptions,
	            presentTypeSelected: this.props.presentTypeSelected,
	            initialValues: {
	              presentation_type: type,
	              presentation_speed: options.delay,
	              presentation_transition: options.transition
	            },
	            confirmText: 'Update',
	            hideSort: true,
	            rangeInputType: _constants.IS_IOS ? 'number' : 'range'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Presentation;
	}(_react.Component);
	
	exports.default = Presentation;
	
	
	function getImages(_ref2) {
	  var images = _ref2.images,
	      entities = _ref2.entities,
	      options = _ref2.options,
	      count = _ref2.count;
	
	  return sortImages(images, entities, options).slice(0, count);
	}
	
	function sortImages(images, entities, options) {
	  if (!options || !options.sort) {
	    return images;
	  }
	
	  var _options$sort$split = options.sort.split('-'),
	      _options$sort$split2 = _slicedToArray(_options$sort$split, 2),
	      sort = _options$sort$split2[0],
	      operator = _options$sort$split2[1];
	
	  if (sort === 'date') {
	    return images.sort(function (a, b) {
	      var dateA = (0, _date.imageDate)(entities.images[a]);
	      var dateB = (0, _date.imageDate)(entities.images[b]);
	      if (dateA && dateB) {
	        return operator === 'asc' ? dateA > dateB : dateA < dateB;
	      }
	      return 0;
	    });
	  }
	  if (sort === 'rating') {
	    return images.sort(function (a, b) {
	      var ratingA = entities.images[a]._rating;
	      var ratingB = entities.images[b]._rating;
	      if (ratingA && ratingB) {
	        return operator === 'asc' ? ratingA > ratingB : ratingA < ratingB;
	      }
	      return 0;
	    });
	  }
	  if (sort === 'random') {
	    return (0, _array.shuffle)(images);
	  }
	  return images;
	}
	
	function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdvancedForm = __webpack_require__(243);
	
	var _AdvancedForm2 = _interopRequireDefault(_AdvancedForm);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function AdvancedForm(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange,
	      onCancel = _ref.onCancel,
	      updateTerm = _ref.updateTerm,
	      pristine = _ref.pristine;
	
	  var input = function input(key, label) {
	    return _react2.default.createElement(
	      'label',
	      null,
	      label,
	      _react2.default.createElement('input', {
	        type: 'text',
	        value: value[key] || '',
	        onChange: function onChange(e) {
	          return _onChange(_extends({}, value, _defineProperty({}, key, e.target.value || undefined)));
	        },
	        className: _AdvancedForm2.default.advancedInput
	      })
	    );
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _AdvancedForm2.default.form },
	    input('filename', 'Filename'),
	    input('transmissionReference', 'Transmission Reference'),
	    input('orientation', 'Orientation (1-8)'),
	    _react2.default.createElement(_ConfirmButtons2.default, {
	      onCancel: onCancel,
	      confirmText: 'Submit',
	      onConfirm: function onConfirm() {
	        return updateTerm({ type: 'other', value: value });
	      },
	      confirmDisabled: pristine
	    })
	  );
	}
	exports.default = AdvancedForm;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(380);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _AreaPicker = __webpack_require__(356);
	
	var _AreaPicker2 = _interopRequireDefault(_AreaPicker);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEARCH_DELAY = 500;
	var METERS_PER_MILE = 1609.34;
	
	var AreaPicker = function (_Component) {
	  _inherits(AreaPicker, _Component);
	
	  function AreaPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AreaPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AreaPicker.__proto__ || Object.getPrototypeOf(AreaPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchTerm: '',
	      fetching: false,
	      results: []
	    }, _this.searchTimeout = null, _this.onMapClick = function (e) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          onChange = _this$props.onChange;
	
	      onChange({
	        lat: e.latLng.lat(),
	        lon: e.latLng.lng(),
	        radius: value.radius
	      });
	    }, _this.onSearchChange = function (e) {
	      clearTimeout(_this.searchTimeout);
	      _this.setState({ searchTerm: e.target.value });
	      _this.searchTimeout = setTimeout(_this.fetchLocations, SEARCH_DELAY);
	    }, _this.fetchLocations = function () {
	      var searchTerm = _this.state.searchTerm;
	
	      var url = _constants.GEO_LOOKUP_URL + '?address=' + searchTerm;
	      _this.setState({ fetching: true });
	      window.fetch(url).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        _this.setState({
	          fetching: false,
	          results: data.results
	        });
	      });
	    }, _this.renderResult = function (result, value, onChange) {
	      var onClick = function onClick() {
	        _this.setState({
	          searchTerm: '',
	          results: []
	        });
	        onChange(_extends({}, value, {
	          address: result.formatted_address,
	          lat: result.geometry.location.lat,
	          lon: result.geometry.location.lng
	        }));
	      };
	      return _react2.default.createElement(
	        'li',
	        { key: result.place_id, className: _AreaPicker2.default.resultItem },
	        _react2.default.createElement(
	          'button',
	          { onClick: onClick, className: _AreaPicker2.default.resultButton },
	          result.formatted_address
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AreaPicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props$value = this.props.value,
	          lat = _props$value.lat,
	          lon = _props$value.lon,
	          radius = _props$value.radius;
	
	      getMapsSDK().then(function (maps) {
	        _this2.map = new maps.Map(_this2.refs.map, {
	          center: { lat: lat, lng: lon }
	        });
	        _this2.circle = new maps.Circle({
	          map: _this2.map,
	          center: { lat: lat, lng: lon },
	          radius: radius * METERS_PER_MILE,
	          strokeWeight: 0,
	          fillColor: _constants.PRIMARY_COLOR,
	          fillOpacity: 0.2
	        });
	        _this2.map.fitBounds(_this2.circle.getBounds());
	        _this2.map.addListener('click', _this2.onMapClick);
	        _this2.circle.addListener('click', _this2.onMapClick);
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = this.props.value;
	
	      if (value.lat !== nextProps.value.lat || value.lon !== nextProps.value.lon) {
	        var coords = {
	          lat: nextProps.value.lat,
	          lng: nextProps.value.lon
	        };
	        this.map.panTo(coords);
	        this.circle.setCenter(coords);
	      }
	      if (value.radius !== nextProps.value.radius && nextProps.value.radius) {
	        this.circle.setRadius(nextProps.value.radius * METERS_PER_MILE);
	        this.map.fitBounds(this.circle.getBounds());
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          _onChange = _props.onChange,
	          updateTerm = _props.updateTerm,
	          onCancel = _props.onCancel,
	          style = _props.style;
	      var _state = this.state,
	          searchTerm = _state.searchTerm,
	          fetching = _state.fetching,
	          results = _state.results;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _AreaPicker2.default.picker, style: style },
	        _react2.default.createElement(
	          'label',
	          { className: _AreaPicker2.default.searchLabel },
	          'Location search',
	          _react2.default.createElement(
	            'div',
	            { className: _AreaPicker2.default.searchWrapper },
	            _react2.default.createElement('input', {
	              type: 'text',
	              value: searchTerm,
	              onChange: this.onSearchChange,
	              placeholder: 'Search for a location'
	            }),
	            results.length !== 0 && _react2.default.createElement(
	              'ul',
	              { className: _AreaPicker2.default.resultList },
	              results.map(function (result) {
	                return _this3.renderResult(result, value, _onChange);
	              })
	            ),
	            fetching && _react2.default.createElement(_LoadingSpinner2.default, { className: _AreaPicker2.default.spinner })
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: _AreaPicker2.default.radiusLabel },
	          'Radius (m)',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('input', {
	            type: 'number',
	            value: value.radius,
	            min: 1,
	            max: 1000,
	            onChange: function onChange(e) {
	              return _onChange(_extends({}, value, { radius: parseInt(e.target.value) }));
	            },
	            className: _AreaPicker2.default.radiusInput
	          })
	        ),
	        _react2.default.createElement('div', { ref: 'map', className: _AreaPicker2.default.map }),
	        _react2.default.createElement(
	          'label',
	          null,
	          'Current location',
	          _react2.default.createElement(
	            'div',
	            { className: _AreaPicker2.default.currentLocation },
	            value.address || value.lat.toFixed(3) + ', ' + value.lon.toFixed(3)
	          )
	        ),
	        _react2.default.createElement(_ConfirmButtons2.default, {
	          onCancel: onCancel,
	          confirmText: 'Submit',
	          onConfirm: function onConfirm() {
	            return updateTerm({ type: 'location', value: value });
	          },
	          confirmDisabled: !value.lat || !value.lon || !value.radius
	        })
	      );
	    }
	  }]);
	
	  return AreaPicker;
	}(_react.Component);
	
	exports.default = AreaPicker;
	
	
	function getMapsSDK() {
	  return new Promise(function (resolve) {
	    if (window.google) {
	      resolve(window.google.maps);
	    } else {
	      window[_constants.MAPS_API_CALLBACK] = function () {
	        return resolve(window.google.maps);
	      };
	      (0, _loadScript2.default)(_constants.MAPS_API_URL);
	    }
	  });
	}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactHighlighter = __webpack_require__(1119);
	
	var _reactHighlighter2 = _interopRequireDefault(_reactHighlighter);
	
	var _fuzzy = __webpack_require__(888);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _AutoComplete = __webpack_require__(841);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _constants = __webpack_require__(3);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGINATION_SENSITIVITY = 40; // Higher means more keywords load earlier
	
	var AutoComplete = function (_Component) {
	  _inherits(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      limit: _constants.AUTOCOMPLETE_PAGE_SIZE,
	      matches: [],
	      fuzzyMatches: [],
	      selected: 0
	    }, _this.onKeyDown = function (e) {
	      var _this$state = _this.state,
	          selected = _this$state.selected,
	          matches = _this$state.matches,
	          fuzzyMatches = _this$state.fuzzyMatches;
	
	      if (selected < matches.length + fuzzyMatches.length) {
	        e.preventDefault();
	        _this.setState({
	          selected: selected + 1
	        });
	      }
	    }, _this.onKeyUp = function (e) {
	      e.preventDefault();
	      if (_this.state.selected === 1) {
	        _this.props.focusInput();
	      }
	      _this.setState({
	        selected: Math.max(0, _this.state.selected - 1)
	      });
	    }, _this.onKeyEnter = function (e) {
	      var _this$props = _this.props,
	          addTerm = _this$props.addTerm,
	          text = _this$props.text;
	
	      if (_this.state.selected === 0) {
	        e.preventDefault();
	        addTerm('freetext', text);
	      }
	    }, _this.onScroll = function () {
	      var _this$state2 = _this.state,
	          matches = _this$state2.matches,
	          fuzzyMatches = _this$state2.fuzzyMatches,
	          limit = _this$state2.limit;
	
	      var diff = _this.node.scrollHeight - (_this.node.scrollTop + _this.node.offsetHeight);
	      var more = matches.length + fuzzyMatches.length > limit;
	      if (more && diff <= PAGINATION_SENSITIVITY) {
	        _this.setState({
	          limit: limit + _constants.AUTOCOMPLETE_PAGE_SIZE
	        });
	      }
	    }, _this.filterMatches = function (item) {
	      var exclude = _this.props.exclude;
	
	      return exclude.indexOf(item.id) === -1;
	    }, _this.getTagMatches = function (text) {
	      var options = _this.props.options;
	
	      if (!_this.shouldDisplayMatches(_this.props)) {
	        return [];
	      }
	      return options.tags.filter(function (tag) {
	        return (0, _string.matchString)(text, tag);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AutoComplete, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.node = (0, _reactDom.findDOMNode)(this);
	      this.node.addEventListener('scroll', this.onScroll);
	      _mousetrap2.default.bind('up', this.onKeyUp);
	      _mousetrap2.default.bind('down', this.onKeyDown);
	      _mousetrap2.default.bind('enter', this.onKeyEnter);
	      _mousetrap2.default.bind('escape', this.props.onClose);
	
	      var matches = this.getMatches(this.props);
	      this.setState({
	        matches: matches,
	        fuzzyMatches: this.getFuzzyMatches(this.props, matches)
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.node.removeEventListener('scroll', this.onScroll);
	      _mousetrap2.default.unbind(['up', 'down', 'enter', 'escape']);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var _props = this.props,
	          text = _props.text,
	          options = _props.options;
	
	      if (text !== nextProps.text || !options.keywordArray && nextProps.options.keywordArray) {
	        var matches = this.getMatches(nextProps);
	        this.setState({
	          limit: _constants.AUTOCOMPLETE_PAGE_SIZE,
	          matches: matches,
	          fuzzyMatches: this.getFuzzyMatches(nextProps, matches),
	          selected: 0
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var selected = this.state.selected;
	
	      if (prevState.selected !== selected && selected !== 0) {
	        var button = this.node.querySelectorAll('button')[selected];
	        button && button.focus();
	      }
	    }
	  }, {
	    key: 'shouldDisplayMatches',
	    value: function shouldDisplayMatches(props) {
	      var text = props.text,
	          options = props.options;
	
	      return options.keywordArray && text.length >= _constants.AUTOCOMPLETE_MINIMUM_CHARACTERS;
	    }
	  }, {
	    key: 'getMatches',
	    value: function getMatches(props) {
	      var text = props.text,
	          options = props.options;
	
	      if (!this.shouldDisplayMatches(props)) {
	        return [];
	      }
	      var exactMatches = options.keywordArray.filter(function (item) {
	        return (0, _string.matchString)(text, item.keyword, true);
	      });
	      var synMatches = options.keywordArray.filter(function (item) {
	        return item.synonyms && (0, _string.matchString)(text, item.synonyms.join(' '));
	      });
	      return exactMatches.concat(synMatches).filter(this.filterMatches);
	    }
	  }, {
	    key: 'getFuzzyMatches',
	    value: function getFuzzyMatches(props, exactMatches) {
	      var text = props.text,
	          options = props.options;
	
	      if (!this.shouldDisplayMatches(props)) {
	        return [];
	      }
	      var fuzzyOptions = {
	        extract: function extract(item) {
	          return item.keyword;
	        }
	      };
	      var matches = (0, _fuzzy.filter)(text, options.keywordArray, fuzzyOptions);
	      return (0, _lodash2.default)(matches.map(function (match) {
	        return match.original;
	      })).filter(this.filterMatches).filter(function (item) {
	        return exactMatches.findIndex(function (i) {
	          return i.id === item.id;
	        }) === -1;
	      });
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(type, item) {
	      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      var isDuplicate = arguments[3];
	      var _props2 = this.props,
	          operator = _props2.operator,
	          addTerm = _props2.addTerm,
	          focusInput = _props2.focusInput;
	      var selected = this.state.selected;
	
	      var onClick = function onClick() {
	        addTerm(type, item.id, operator);
	        focusInput();
	      };
	      var buttonClass = type === 'freetext' && selected === 0 ? _AutoComplete2.default.buttonActive : _AutoComplete2.default.button;
	      var isPrimaryMatch = (0, _string.matchString)(text, item.keyword);
	      var synMatches = !isPrimaryMatch && item.synonyms && item.synonyms.filter(function (syn) {
	        return (0, _string.matchString)(text, syn);
	      });
	      var highlightText = text || '';
	      if (_string.AMPERSAND_REGEX.test(text) && (0, _string.matchString)(text.replace(_string.AMPERSAND_REGEX, ' and '), item.keyword)) {
	        highlightText = text.replace(_string.AMPERSAND_REGEX, ' and ');
	      }
	      if (_string.AND_REGEX.test(text) && (0, _string.matchString)(text.replace(_string.AND_REGEX, ' & '), item.keyword)) {
	        highlightText = text.replace(_string.AND_REGEX, ' & ');
	      }
	      return _react2.default.createElement(
	        'li',
	        { key: item.id, className: _AutoComplete2.default.item },
	        _react2.default.createElement(
	          'button',
	          { className: buttonClass, onClick: onClick },
	          _react2.default.createElement(
	            _reactHighlighter2.default,
	            { search: highlightText, matchElement: 'span', matchClass: _AutoComplete2.default.match },
	            item.keyword
	          ),
	          isDuplicate && _react2.default.createElement(
	            'span',
	            { className: _AutoComplete2.default.parentNotice },
	            item.direct_parent_name
	          ),
	          synMatches && synMatches.length !== 0 && _react2.default.createElement(
	            _reactHighlighter2.default,
	            { className: _AutoComplete2.default.parentNotice, search: text || '', matchElement: 'span', matchClass: _AutoComplete2.default.match },
	            synMatches[0]
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var text = this.props.text;
	      var _state = this.state,
	          matches = _state.matches,
	          fuzzyMatches = _state.fuzzyMatches,
	          limit = _state.limit;
	
	      var limitedMatches = matches.slice(0, limit);
	      var limitFuzzy = Math.max(0, limit - limitedMatches.length);
	      var limitedFuzzyMatches = limitFuzzy !== 0 ? fuzzyMatches.slice(0, limitFuzzy) : [];
	      var tagMatches = this.getTagMatches(text);
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _AutoComplete2.default.list },
	        _react2.default.createElement(
	          'li',
	          { className: _AutoComplete2.default.heading },
	          'Free search'
	        ),
	        this.renderItem('freetext', { id: text, keyword: text }),
	        limitedMatches.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AutoComplete2.default.heading },
	          'Tags'
	        ),
	        tagMatches.map(function (tag) {
	          return _this2.renderItem('tags', { id: tag, keyword: 'Tag: ' + tag }, text);
	        }),
	        limitedMatches.map(function (item) {
	          return _this2.renderItem('keyword', item, text, checkDuplicate(item, limitedMatches));
	        }),
	        limitedFuzzyMatches.length !== 0 && _react2.default.createElement(
	          'li',
	          { className: _AutoComplete2.default.heading },
	          'Did you mean'
	        ),
	        limitedFuzzyMatches.map(function (item) {
	          return _this2.renderItem('keyword', item, text, checkDuplicate(item, limitedFuzzyMatches));
	        })
	      );
	    }
	  }]);
	
	  return AutoComplete;
	}(_react.Component);
	
	exports.default = AutoComplete;
	
	
	function checkDuplicate(item, matches) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var match = _step.value;
	
	      if (match.keyword === item.keyword && match.id !== item.id) {
	        return true;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return false;
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CameraPicker;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CameraPicker = __webpack_require__(842);
	
	var _CameraPicker2 = _interopRequireDefault(_CameraPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CameraPicker(_ref) {
	  var addTerm = _ref.addTerm,
	      removeTerm = _ref.removeTerm,
	      cameras = _ref.cameras,
	      selected = _ref.selected;
	
	  function renderCamera(camera, label) {
	    var index = selected.findIndex(function (c) {
	      return c.value === camera;
	    });
	    var active = index !== -1;
	    var onClick = function onClick() {
	      if (active) {
	        removeTerm('camera', index);
	      } else {
	        addTerm('camera', camera, 'should');
	      }
	    };
	    return _react2.default.createElement(
	      'button',
	      {
	        key: camera,
	        className: active ? _CameraPicker2.default.activeButton : _CameraPicker2.default.button,
	        onClick: onClick },
	      label || camera
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _CameraPicker2.default.picker },
	    renderCamera('null', 'No Camera'),
	    cameras.map(function (camera) {
	      return renderCamera(camera);
	    })
	  );
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DatePicker = __webpack_require__(843);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _GenericIncludeExcludePicker = __webpack_require__(542);
	
	var _GenericIncludeExcludePicker2 = _interopRequireDefault(_GenericIncludeExcludePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function DatePicker(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      _onCancel = _ref.onCancel,
	      addTerm = _ref.addTerm,
	      showDynamic = _ref.showDynamic,
	      options = _ref.options,
	      targetDate = _ref.targetDate,
	      updateTargetDate = _ref.updateTargetDate;
	
	  var onChangeType = function onChangeType(e) {
	    return onChange(_extends({}, value, {
	      dynamic: e.target.value === 'filter-only' ? undefined : e.target.value,
	      margin: undefined,
	      filterOnly: e.target.value === 'filter-only' ? true : undefined
	    }));
	  };
	  var onChangeFactory = function onChangeFactory(key) {
	    return function (e) {
	      return onChange(_extends({}, value, _defineProperty({}, key, e.target.value || undefined)));
	    };
	  };
	  var onChangeNumberFactory = function onChangeNumberFactory(key) {
	    return function (e) {
	      return onChange(_extends({}, value, _defineProperty({}, key, parseInt(e.target.value) || undefined)));
	    };
	  };
	  var onChangeValueFactory = function onChangeValueFactory(key) {
	    return function (newValue) {
	      return onChange(_extends({}, value, _defineProperty({}, key, newValue || undefined)));
	    };
	  };
	  var defaultToday = new Date().toISOString().slice(0, 10);
	  return _react2.default.createElement(
	    'div',
	    { className: _DatePicker2.default.picker },
	    _react2.default.createElement(
	      'label',
	      null,
	      'Type',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'select',
	        { onChange: onChangeType, value: value.dynamic },
	        _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Date Range'
	        ),
	        showDynamic && _react2.default.createElement(
	          'option',
	          { value: 'recent' },
	          'Recent Pictures'
	        ),
	        showDynamic && _react2.default.createElement(
	          'option',
	          { value: 'on-this-day' },
	          'On This Day'
	        ),
	        _react2.default.createElement(
	          'option',
	          { value: 'filter-only' },
	          'Time of day/season only'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      !value.dynamic && !value.filterOnly && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        'Start date',
	        _react2.default.createElement('input', {
	          type: 'date',
	          value: value.start || '',
	          onChange: onChangeFactory('start'),
	          placeholder: 'yyyy-mm-dd'
	        })
	      ),
	      value.dynamic && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        value.dynamic === 'recent' ? 'Backwards from' : 'Target date',
	        !value.start && _react2.default.createElement(
	          'div',
	          { className: _DatePicker2.default.todayPlaceholder },
	          'Today',
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: _DatePicker2.default.setDateButton, onClick: onChangeFactory('start'), value: defaultToday },
	            'Fix to date'
	          )
	        ),
	        value.start && _react2.default.createElement('input', {
	          type: 'date',
	          value: value.start,
	          onChange: onChangeFactory('start'),
	          placeholder: 'yyyy-mm-dd'
	        })
	      ),
	      !value.dynamic && !value.filterOnly && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        'End date',
	        !value.end && _react2.default.createElement(
	          'div',
	          { className: _DatePicker2.default.todayPlaceholder },
	          'Today',
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: _DatePicker2.default.setDateButton, onClick: onChangeFactory('end'), value: defaultToday },
	            'Fix to date'
	          )
	        ),
	        value.end && _react2.default.createElement('input', {
	          type: 'date',
	          value: value.end,
	          onChange: onChangeFactory('end'),
	          placeholder: 'yyyy-mm-dd'
	        })
	      ),
	      value.dynamic && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        value.dynamic === 'recent' ? 'Number of months back' : '+/- number of days',
	        _react2.default.createElement('input', {
	          type: 'number',
	          value: value.margin || (value.dynamic === 'recent' ? 1 : 0),
	          onChange: onChangeNumberFactory('margin'),
	          className: _DatePicker2.default.numberInput,
	          min: 0
	        })
	      ),
	      value.dynamic === 'on-this-day' && value.start && value.margin > 0 && _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          checked: targetDate === value.start,
	          onChange: function onChange() {
	            return updateTargetDate(targetDate === value.start ? undefined : value.start);
	          }
	        }),
	        'Sort by date accuracy (exact date first)'
	      ),
	      value.dynamic === 'on-this-day' && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        'Year',
	        _react2.default.createElement(
	          'select',
	          { onChange: onChangeFactory('yearType'), value: value.yearType },
	          _react2.default.createElement(
	            'option',
	            { value: 'since' },
	            'Since'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'exact' },
	            'Exact Year'
	          )
	        )
	      ),
	      value.dynamic === 'on-this-day' && _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.column },
	        ' '.replace(/ /g, '\xA0'),
	        _react2.default.createElement('input', {
	          type: 'number',
	          value: value.year || '',
	          onChange: onChangeNumberFactory('year'),
	          className: _DatePicker2.default.numberInput,
	          placeholder: 'yyyy'
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.noBottomMargin },
	        'Time of Day'
	      ),
	      _react2.default.createElement(_GenericIncludeExcludePicker2.default, {
	        options: options.timesOfDay,
	        value: value.dayperiod || [],
	        onChange: onChangeValueFactory('dayperiod')
	      }),
	      _react2.default.createElement(
	        'label',
	        { className: _DatePicker2.default.noBottomMargin },
	        'Season'
	      ),
	      _react2.default.createElement(_GenericIncludeExcludePicker2.default, {
	        options: options.seasons,
	        value: value.season || [],
	        onChange: onChangeValueFactory('season')
	      }),
	      !value.filterOnly && _react2.default.createElement(
	        'label',
	        null,
	        'Date Confidence',
	        _react2.default.createElement(
	          'select',
	          { value: value.confidence, onChange: onChangeFactory('confidence'), style: { width: 'auto' } },
	          _react2.default.createElement(
	            'option',
	            { value: undefined },
	            'Exact'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'months' },
	            'Loosen Day'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'seasons' },
	            'Loosen Month'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'years' },
	            'Loosen Season'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'decades' },
	            'Loosen Year'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ConfirmButtons2.default, {
	      onCancel: function onCancel() {
	        _onCancel();
	        onChange({});
	      },
	      confirmText: 'Submit',
	      onConfirm: function onConfirm() {
	        addTerm('date', value);
	        onChange({});
	      }
	    })
	  );
	}
	exports.default = DatePicker;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AdvancedForm = __webpack_require__(243);
	
	var _AdvancedForm2 = _interopRequireDefault(_AdvancedForm);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _GenericAutocomplete = __webpack_require__(298);
	
	var _GenericAutocomplete2 = _interopRequireDefault(_GenericAutocomplete);
	
	var _LocationPicker = __webpack_require__(153);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _TimezonePicker = __webpack_require__(300);
	
	var _TimezonePicker2 = _interopRequireDefault(_TimezonePicker);
	
	var _KeywordGraphPicker = __webpack_require__(128);
	
	var _KeywordGraphPicker2 = _interopRequireDefault(_KeywordGraphPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function DynamicLinkForm(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange,
	      _onCancel = _ref.onCancel,
	      addTerm = _ref.addTerm,
	      pristine = _ref.pristine,
	      dynlinks = _ref.dynlinks;
	
	  var input = function input(key, label) {
	    return _react2.default.createElement(
	      'label',
	      null,
	      label,
	      _react2.default.createElement('input', {
	        type: 'text',
	        value: value[key] || '',
	        onChange: function onChange(e) {
	          return _onChange(_extends({}, value, _defineProperty({}, key, e.target.value)));
	        }
	      })
	    );
	  };
	  var onChangeType = function onChangeType(e) {
	    return _onChange(_extends({}, value, {
	      type: e.target.value
	    }));
	  };
	  var onSelectKeyword = function onSelectKeyword(node) {
	    var index = value.keywordType && value.keywordType.findIndex(function (k) {
	      return k.value === node.id;
	    });
	    if (!value.keywordType || index === -1) {
	      _onChange(_extends({}, value, {
	        keywordType: (value.keywordType || []).concat({ value: node.id, operator: 'include' })
	      }));
	    } else {
	      if (value.keywordType[index].operator === 'include') {
	        _onChange(_extends({}, value, {
	          keywordType: [].concat(_toConsumableArray(value.keywordType.slice(0, index)), [_extends({}, value.keywordType[index], {
	            operator: 'exclude'
	          })], _toConsumableArray(value.keywordType.slice(index + 1)))
	        }));
	      } else {
	        _onChange(_extends({}, value, {
	          keywordType: value.keywordType.filter(function (k) {
	            return k.value !== node.id;
	          })
	        }));
	      }
	    }
	  };
	  var onChangeDateMargin = function onChangeDateMargin(e) {
	    return _onChange(_extends({}, value, {
	      dateMargin: parseInt(e.target.value)
	    }));
	  };
	  var toggleLocationOverride = function toggleLocationOverride() {
	    return _onChange(_extends({}, value, {
	      locationOverride: !value.locationOverride || undefined
	    }));
	  };
	  var onChangeLocation = function onChangeLocation(location) {
	    return _onChange(_extends({}, value, { location: location }));
	  };
	  var conditions = value.type && dynlinks.filter(function (d) {
	    return d.type === value.type;
	  }).map(function (d) {
	    return d.condition;
	  });
	  var dateCondition = conditions && /^\d\d\d\d-\d\d-\d\d$/.test(conditions[0]);
	  var highlightKeywords = (dynlinks || []).filter(function (d) {
	    return d.type === value.type;
	  }).reduce(getDynlinkKeywords, []);
	  return _react2.default.createElement(
	    'div',
	    { className: _AdvancedForm2.default.form },
	    _react2.default.createElement(
	      'label',
	      { className: _AdvancedForm2.default.label },
	      'Pick dynamic table to set condition'
	    ),
	    _react2.default.createElement(
	      'select',
	      { value: value.type || '', onChange: onChangeType, style: { width: 'auto' } },
	      _react2.default.createElement(
	        'option',
	        { value: '', disabled: true },
	        'Select a table'
	      ),
	      (0, _lodash2.default)((dynlinks || []).map(function (link) {
	        return link.type;
	      })).map(function (value) {
	        return _react2.default.createElement(
	          'option',
	          { key: value, value: value },
	          value
	        );
	      })
	    ),
	    conditions && _react2.default.createElement(
	      'p',
	      { className: _AdvancedForm2.default.note },
	      'When one of the dynamic conditions are met, the keywords for that condition will be used for the image search.'
	    ),
	    conditions && _react2.default.createElement(
	      'p',
	      { className: _AdvancedForm2.default.note },
	      'The possible conditions are: ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        dateCondition ? 'dates' : conditions.join(', ')
	      )
	    ),
	    dateCondition && _react2.default.createElement(
	      'label',
	      null,
	      'Plus or minus days (for date conditions)',
	      _react2.default.createElement('input', {
	        type: 'number',
	        className: _AdvancedForm2.default.numberInput,
	        value: value.dateMargin || '',
	        onChange: onChangeDateMargin
	      })
	    ),
	    dateCondition && _react2.default.createElement(_TimezonePicker2.default, {
	      value: value.time_offset,
	      onChange: function onChange(e) {
	        return _onChange(_extends({}, value, { time_offset: e.target.value }));
	      },
	      label: 'Timezone (for date conditions)'
	    }),
	    _react2.default.createElement(
	      'label',
	      { className: _AdvancedForm2.default.label },
	      'Filter by Keyword Type to match condition'
	    ),
	    _react2.default.createElement(_KeywordGraphPicker2.default, {
	      selected: (value.keywordType || []).filter(function (k) {
	        return k.operator === 'include';
	      }).map(function (k) {
	        return k.value;
	      }),
	      excluded: (value.keywordType || []).filter(function (k) {
	        return k.operator === 'exclude';
	      }).map(function (k) {
	        return k.value;
	      }),
	      onSelect: onSelectKeyword,
	      highlightNodes: highlightKeywords,
	      showSelectedChildrenIndicator: true
	    }),
	    !dateCondition && value.type && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { className: _AdvancedForm2.default.label },
	        'Location override (for weather conditions)'
	      ),
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          checked: !value.locationOverride,
	          onChange: toggleLocationOverride
	        }),
	        'Use default device location'
	      ),
	      value.locationOverride && _react2.default.createElement(_LocationPicker2.default, {
	        value: value.location,
	        onChange: onChangeLocation,
	        disabled: !value.locationOverride
	      })
	    ),
	    _react2.default.createElement(_ConfirmButtons2.default, {
	      onCancel: function onCancel() {
	        _onCancel();
	        _onChange({});
	      },
	      confirmText: 'Submit',
	      onConfirm: function onConfirm() {
	        addTerm('dynlink', value);
	        _onChange({});
	      },
	      confirmDisabled: pristine
	    })
	  );
	}
	
	exports.default = DynamicLinkForm;
	function getDynlinkKeywords(array, dynlink) {
	  return array.concat(JSON.parse(dynlink.keywords));
	}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GenericIncludeExcludePicker = __webpack_require__(845);
	
	var _GenericIncludeExcludePicker2 = _interopRequireDefault(_GenericIncludeExcludePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GenericIncludeExcludePicker = function (_Component) {
	  _inherits(GenericIncludeExcludePicker, _Component);
	
	  function GenericIncludeExcludePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GenericIncludeExcludePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GenericIncludeExcludePicker.__proto__ || Object.getPrototypeOf(GenericIncludeExcludePicker)).call.apply(_ref, [this].concat(args))), _this), _this.selectItem = function (e) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          onChange = _this$props.onChange;
	
	      onChange(value.concat({ value: e.target.value, operator: 'should' }));
	    }, _this.excludeItem = function (e) {
	      var _this$props2 = _this.props,
	          value = _this$props2.value,
	          onChange = _this$props2.onChange;
	
	      var index = value.findIndex(function (t) {
	        return t.value === e.target.value;
	      });
	      var newValue = value.slice(0);
	      newValue[index].operator = 'must_not';
	      onChange(newValue);
	    }, _this.removeItem = function (e) {
	      var _this$props3 = _this.props,
	          value = _this$props3.value,
	          onChange = _this$props3.onChange;
	
	      if (value.length === 1) {
	        onChange(undefined);
	        return;
	      }
	      onChange(value.filter(function (t) {
	        return t.value !== e.target.value;
	      }));
	    }, _this.renderOption = function (option) {
	      var selected = _this.isValue(option, 'should');
	      var excluded = _this.isValue(option, 'must_not');
	      var className = _GenericIncludeExcludePicker2.default[selected ? 'buttonSelected' : excluded ? 'buttonExcluded' : 'button'];
	      var onClick = selected ? _this.excludeItem : excluded ? _this.removeItem : _this.selectItem;
	      return _react2.default.createElement(
	        'button',
	        { key: option, className: className, onClick: onClick, value: option },
	        option
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GenericIncludeExcludePicker, [{
	    key: 'isValue',
	    value: function isValue(key, operator) {
	      return this.props.value.findIndex(function (t) {
	        return t.value === key && t.operator === operator;
	      }) !== -1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.options ? this.props.options.map(this.renderOption) : 'Loading options…'
	      );
	    }
	  }]);
	
	  return GenericIncludeExcludePicker;
	}(_react.Component);
	
	exports.default = GenericIncludeExcludePicker;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _redux = __webpack_require__(106);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(76);
	
	var _ImageSearch = __webpack_require__(846);
	
	var _ImageSearch2 = _interopRequireDefault(_ImageSearch);
	
	var _query = __webpack_require__(50);
	
	var _search = __webpack_require__(59);
	
	var _dynlinks = __webpack_require__(154);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	var _auth = __webpack_require__(20);
	
	var _ImageSearchInput = __webpack_require__(544);
	
	var _ImageSearchInput2 = _interopRequireDefault(_ImageSearchInput);
	
	var _OperatorButton = __webpack_require__(547);
	
	var _OperatorButton2 = _interopRequireDefault(_OperatorButton);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Stars = __webpack_require__(202);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLOSE_ICON_SIZE = 18;
	
	var ImageSearch = function (_Component) {
	  _inherits(ImageSearch, _Component);
	
	  function ImageSearch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageSearch.__proto__ || Object.getPrototypeOf(ImageSearch)).call.apply(_ref, [this].concat(args))), _this), _this.focusInput = function () {
	      (0, _reactDom.findDOMNode)(_this).querySelector('input').focus();
	    }, _this.openCameraPicker = function () {
	      _this.props.openAdvancedSearch('camera');
	    }, _this.openLibraries = function () {
	      _this.props.openAdvancedSearch('library');
	    }, _this.openRating = function () {
	      _this.props.openAdvancedSearch('rating');
	    }, _this.openLimit = function () {
	      _this.props.openAdvancedSearch('limit');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageSearch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          options = _props.options,
	          fetchSearchOptions = _props.fetchSearchOptions,
	          dynlinks = _props.dynlinks,
	          fetchDynamicLinks = _props.fetchDynamicLinks;
	
	      if (!options.keywords) {
	        fetchSearchOptions();
	      }
	      if (!dynlinks) {
	        fetchDynamicLinks();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          query = _props2.query,
	          options = _props2.options,
	          dynlinks = _props2.dynlinks,
	          selectQuery = _props2.selectQuery,
	          removeQuery = _props2.removeQuery,
	          addTerm = _props2.addTerm,
	          updateTerm = _props2.updateTerm,
	          updateRating = _props2.updateRating,
	          removeTerm = _props2.removeTerm,
	          setRootProperty = _props2.setRootProperty,
	          clearEditingState = _props2.clearEditingState,
	          updateTargetDate = _props2.updateTargetDate,
	          updateOperator = _props2.updateOperator,
	          unexcludeAllImages = _props2.unexcludeAllImages,
	          unincludeAllImages = _props2.unincludeAllImages,
	          removeAllCameras = _props2.removeAllCameras,
	          resetLibraries = _props2.resetLibraries,
	          userHasPerm = _props2.userHasPerm;
	
	
	      var activeQuery = query.structure.queries[query.selectedIndex];
	      var isFixed = query.structure.fixed && query.structure.fixed.length !== 0;
	      var wrapperClass = isFixed ? ' ' + _ImageSearch2.default.fixedWrapper : '';
	      var queryRowClass = query.selectedIndex % 2 ? _ImageSearch2.default.queryRowDarker : _ImageSearch2.default.queryRow;
	
	      var onRemoveLimit = function onRemoveLimit() {
	        setRootProperty('limit', undefined);
	        setRootProperty('diversity', undefined);
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: className + wrapperClass },
	        query.structure.queries.length > 1 && _react2.default.createElement(
	          'div',
	          { className: queryRowClass },
	          _react2.default.createElement(
	            'div',
	            { className: _ImageSearch2.default.queryLeft },
	            _react2.default.createElement(
	              'button',
	              {
	                className: _ImageSearch2.default.queryButton,
	                onClick: function onClick() {
	                  return selectQuery(query.selectedIndex - 1);
	                },
	                disabled: query.selectedIndex === 0,
	                title: 'Previous query' },
	              _react2.default.createElement(_Icon2.default, { icon: 'chevron-left' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _ImageSearch2.default.queryTitle },
	              'Query ',
	              query.selectedIndex + 1,
	              '/',
	              query.structure.queries.length
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: _ImageSearch2.default.queryButton,
	                onClick: function onClick() {
	                  return selectQuery(query.selectedIndex + 1);
	                },
	                title: 'Next query' },
	              query.selectedIndex === query.structure.queries.length - 1 && _react2.default.createElement(_Icon2.default, { icon: 'plus-small', size: 20, style: { opacity: 0.5, marginLeft: '2px' } }),
	              query.selectedIndex !== query.structure.queries.length - 1 && _react2.default.createElement(_Icon2.default, { icon: 'chevron-right' })
	            )
	          ),
	          _react2.default.createElement(_OperatorButton2.default, {
	            className: _ImageSearch2.default.operatorButton,
	            onChange: function onChange(value) {
	              return updateOperator(value);
	            },
	            value: activeQuery.operator
	          }),
	          _react2.default.createElement(
	            'button',
	            {
	              className: _ImageSearch2.default.queryCloseButton,
	              onClick: function onClick() {
	                return removeQuery(query.selectedIndex);
	              },
	              disabled: query.structure.queries.length === 1,
	              title: 'Remove query' },
	            _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          isFixed && renderFixed(query.structure.fixed.length, this.props.unfixAlbum),
	          !!(query.structure.limit || query.structure.diversity) && renderLimit(query.structure.limit, query.structure.diversity, this.openLimit, onRemoveLimit),
	          renderTerms(activeQuery, this.focusInput, this.props, this.openRating, options.keywordMap),
	          activeQuery.camera.length !== 0 && renderCameras(activeQuery.camera.length, this.openCameraPicker, removeAllCameras),
	          activeQuery.library.length !== 0 && activeQuery.library.length !== query.libraries.length && renderLibraries(activeQuery.library, this.openLibraries, resetLibraries),
	          query.structure.include.length !== 0 && renderIncludes(query.structure.include.length, unincludeAllImages),
	          query.structure.exclude.length !== 0 && renderExcludes(query.structure.exclude.length, unexcludeAllImages)
	        ),
	        _react2.default.createElement(_reduxForm.Field, {
	          component: _ImageSearchInput2.default,
	          name: 'search',
	          defaultValue: {},
	          props: {
	            query: query,
	            activeQuery: activeQuery,
	            options: options,
	            dynlinks: dynlinks,
	            addTerm: addTerm,
	            updateTerm: updateTerm,
	            updateRating: updateRating,
	            removeTerm: removeTerm,
	            userHasPerm: userHasPerm,
	            setRootProperty: setRootProperty,
	            clearEditingState: clearEditingState,
	            updateTargetDate: updateTargetDate,
	            autoFocus: this.props.autoFocus,
	            focusInput: this.focusInput,
	            libraries: query.libraries,
	            addNewQuery: !(0, _images.isEmptyQuery)(activeQuery) && function () {
	              return selectQuery(query.selectedIndex + 1);
	            },
	            disabled: isFixed
	          }
	        })
	      );
	    }
	  }]);
	
	  return ImageSearch;
	}(_react.Component);
	
	function renderTerms(activeQuery, focusInput, _ref2, openRating, keywordMap) {
	  var removeTerm = _ref2.removeTerm,
	      editTerm = _ref2.editTerm,
	      updateTerm = _ref2.updateTerm,
	      updateRating = _ref2.updateRating;
	
	  var operatorTypes = ['freetext', 'keyword', 'tags', 'date', 'dynlink', 'path'];
	  return Object.keys(activeQuery).map(function (type) {
	    if (type === 'library' || type === 'camera') {
	      return null;
	    }
	    if (activeQuery[type] instanceof Array === false) {
	      return null;
	    }
	    if (type === 'rating' && activeQuery.rating.length !== 0) {
	      var _updateOperator = function _updateOperator(value) {
	        for (var i = 0; i !== activeQuery.rating.length; i++) {
	          updateTerm({
	            type: type,
	            termIndex: i,
	            value: _extends({}, activeQuery.rating[i], {
	              operator: value
	            })
	          });
	        }
	      };
	      return _react2.default.createElement(
	        'li',
	        { className: _ImageSearch2.default.termRow },
	        _react2.default.createElement(
	          'button',
	          { className: _ImageSearch2.default.termButton, type: 'button', onClick: openRating },
	          renderTermValue('rating', activeQuery.rating)
	        ),
	        _react2.default.createElement(_OperatorButton2.default, {
	          className: _ImageSearch2.default.operatorButton,
	          onChange: _updateOperator,
	          value: activeQuery.rating[0].operator
	        }),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _ImageSearch2.default.queryCloseButton,
	            type: 'button',
	            onClick: function onClick() {
	              return updateRating([]);
	            },
	            title: 'Remove search term' },
	          _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	        )
	      );
	    }
	    return activeQuery[type].map(function (term, termIndex) {
	      var showOperator = operatorTypes.indexOf(type) !== -1;
	      var onRemove = function onRemove() {
	        removeTerm(type, termIndex);
	        focusInput();
	      };
	      var onEdit = function onEdit() {
	        editTerm(type, termIndex, type === 'keyword' ? getKeywordName(term, keywordMap) : term);
	        if (type === 'freetext' || type === 'keyword') {
	          focusInput();
	        }
	      };
	      var editDisabled = type === 'freetext' || type === 'keyword';
	      var updateOperator = function updateOperator(value) {
	        return updateTerm({
	          type: type,
	          termIndex: termIndex,
	          value: _extends({}, term, { operator: value })
	        });
	      };
	      return _react2.default.createElement(
	        'li',
	        { className: _ImageSearch2.default.termRow },
	        _react2.default.createElement(
	          'button',
	          { className: _ImageSearch2.default.termButton, type: 'button', onClick: onEdit, disabled: editDisabled },
	          renderTermIcon(type),
	          renderTermValue(type, term, keywordMap)
	        ),
	        showOperator && _react2.default.createElement(_OperatorButton2.default, {
	          className: _ImageSearch2.default.operatorButton,
	          onChange: updateOperator,
	          value: term.operator
	        }),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _ImageSearch2.default.queryCloseButton,
	            type: 'button',
	            onClick: onRemove,
	            title: 'Remove search term' },
	          _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	        )
	      );
	    });
	  });
	}
	
	function renderTermIcon(type) {
	  switch (type) {
	    case 'freetext':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'freetext', size: 16 });
	    case 'keyword':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'tag', size: 16 });
	    case 'camera':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'camera', size: 16 });
	    case 'location':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'marker', size: 16 });
	    case 'library':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'library', size: 16 });
	    case 'date':
	      return _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'date', size: 16 });
	  }
	  return null;
	}
	
	function renderTermValue(type, term, keywordMap) {
	  switch (type) {
	    case 'freetext':
	    case 'camera':
	      return term.value;
	    case 'tags':
	      return 'Tag: ' + term.value;
	    case 'keyword':
	      if (keywordMap) {
	        return getKeywordName(term.value, keywordMap);
	      }
	      return 'Loading Keywords…';
	    case 'location':
	      return term.address || term.lat.toFixed(3) + ', ' + term.lon.toFixed(3);
	    case 'date':
	      if (term.dynamic) {
	        return _constants.DYNAMIC_ALBUMS[term.dynamic];
	      }
	      if (term.filterOnly) {
	        return 'Timeframe Search';
	      }
	      if (!term.start && !term.end) {
	        return 'Any Date';
	      }
	      return (term.start || _constants.DEFAULT_START_DATE) + ' - ' + (term.end || 'Today');
	    case 'rating':
	      var rating = term.reduce(function (o, r) {
	        o[r.value] = true;
	        return o;
	      }, {});
	      return _react2.default.createElement(_Stars2.default, { rating: rating });
	    case 'other':
	      return 'Advanced';
	    case 'dynlink':
	      return 'Dynamic link: ' + term.type;
	    case 'path':
	      return 'Album: ' + (term.value || '').split('/').pop();
	  }
	}
	
	function getKeywordName(id, keywordMap) {
	  return keywordMap[id] ? keywordMap[id].name : 'Unknown Keyword';
	}
	
	function renderCameras(count, onClick, onRemove) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRow },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button', onClick: onClick },
	      renderTermIcon('camera'),
	      (0, _string.pluralize)(count, 'camera')
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: onRemove,
	        title: 'Remove all camera filters' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	function renderLibraries(libraries, onClick, onRemove) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRow },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button', onClick: onClick },
	      renderTermIcon('library'),
	      'Libraries: ',
	      libraries.map(function (l) {
	        return (/^virtual_/.test(l.value) ? 'Shared' : (0, _string.titleCase)(l.value)
	        );
	      }).join(', ')
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: onRemove,
	        title: 'Reset library filters' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	function renderExcludes(count, onRemove) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRow },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button' },
	      'Excluding ',
	      (0, _string.pluralize)(count, 'image')
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: onRemove,
	        title: 'Restore all excluded images' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	function renderIncludes(count, onRemove) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRow },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button' },
	      'Including ',
	      (0, _string.pluralize)(count, 'image')
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: onRemove,
	        title: 'Remove all included images' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	function renderFixed(count, unFix) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRowDarker },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button' },
	      _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'lock', size: 16 }),
	      'Unlock album to modify search'
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: function onClick() {
	          window.confirm(_constants.UNFIX_WARNING) && unFix();
	        },
	        title: 'Unfix album' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	function renderLimit(limit, diversity, onClick, onRemove) {
	  return _react2.default.createElement(
	    'li',
	    { className: _ImageSearch2.default.termRowDarker },
	    _react2.default.createElement(
	      'button',
	      { className: _ImageSearch2.default.termButton, type: 'button', onClick: onClick },
	      _react2.default.createElement(_Icon2.default, { className: _ImageSearch2.default.termIcon, icon: 'limit', size: 16 }),
	      limit && 'Find Limit: ' + limit,
	      limit && diversity && ', ',
	      diversity && 'Diversity: ' + Math.round(diversity * 100) + '%'
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: _ImageSearch2.default.queryCloseButton,
	        type: 'button',
	        onClick: onRemove,
	        title: 'Remove find limit' },
	      _react2.default.createElement(_Icon2.default, { icon: 'close', size: CLOSE_ICON_SIZE })
	    )
	  );
	}
	
	var ReduxImageSearch = (0, _reduxForm.reduxForm)({ form: 'query' })(ImageSearch);
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var search = _ref3.search,
	      dynlinks = _ref3.dynlinks,
	      auth = _ref3.auth;
	  return {
	    options: search.options,
	    dynlinks: dynlinks.data,
	    userHasPerm: function userHasPerm(perm) {
	      return (0, _auth.userHasPerm)(auth.user, perm);
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    selectQuery: _query.selectQuery,
	    removeQuery: _query.removeQuery,
	    addTerm: _query.addTerm,
	    removeTerm: _query.removeTerm,
	    editTerm: _query.editTerm,
	    updateTerm: _query.updateTerm,
	    updateOperator: _query.updateOperator,
	    updateRating: _query.updateRating,
	    fetchSearchOptions: _search.fetchSearchOptions,
	    unexcludeAllImages: _query.unexcludeAllImages,
	    unincludeAllImages: _query.unincludeAllImages,
	    removeAllCameras: _query.removeAllCameras,
	    resetLibraries: _query.resetLibraries,
	    fetchDynamicLinks: _dynlinks.fetchDynamicLinks,
	    openAdvancedSearch: _query.openAdvancedSearch,
	    unfixAlbum: _query.unfixAlbum,
	    setRootProperty: _query.setRootProperty,
	    clearEditingState: _query.clearEditingState,
	    updateTargetDate: _query.updateTargetDate
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxImageSearch);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(76);
	
	var _ImageSearchInput = __webpack_require__(847);
	
	var _ImageSearchInput2 = _interopRequireDefault(_ImageSearchInput);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AutoComplete = __webpack_require__(538);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _RatingPicker = __webpack_require__(548);
	
	var _RatingPicker2 = _interopRequireDefault(_RatingPicker);
	
	var _DatePicker = __webpack_require__(540);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _AreaPicker = __webpack_require__(537);
	
	var _AreaPicker2 = _interopRequireDefault(_AreaPicker);
	
	var _CameraPicker = __webpack_require__(539);
	
	var _CameraPicker2 = _interopRequireDefault(_CameraPicker);
	
	var _LibraryPicker = __webpack_require__(545);
	
	var _LibraryPicker2 = _interopRequireDefault(_LibraryPicker);
	
	var _AdvancedForm = __webpack_require__(536);
	
	var _AdvancedForm2 = _interopRequireDefault(_AdvancedForm);
	
	var _LimitForm = __webpack_require__(546);
	
	var _LimitForm2 = _interopRequireDefault(_LimitForm);
	
	var _DynamicLinkForm = __webpack_require__(541);
	
	var _DynamicLinkForm2 = _interopRequireDefault(_DynamicLinkForm);
	
	var _query = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageSearchInput(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange,
	      disabled = _ref.disabled,
	      options = _ref.options,
	      addTerm = _ref.addTerm,
	      updateTerm = _ref.updateTerm,
	      updateRating = _ref.updateRating,
	      removeTerm = _ref.removeTerm,
	      query = _ref.query,
	      activeQuery = _ref.activeQuery,
	      focusInput = _ref.focusInput,
	      libraries = _ref.libraries,
	      userHasPerm = _ref.userHasPerm,
	      dynlinks = _ref.dynlinks,
	      addNewQuery = _ref.addNewQuery,
	      autoFocus = _ref.autoFocus,
	      setRootProperty = _ref.setRootProperty,
	      clearEditingState = _ref.clearEditingState,
	      updateTargetDate = _ref.updateTargetDate;
	
	  var onChangeText = function onChangeText(e) {
	    return _onChange(_extends({}, value, {
	      text: e.target.value,
	      dropdown: false,
	      option: null
	    }));
	  };
	  var onClickText = function onClickText(e) {
	    return _onChange(_extends({}, value, {
	      dropdown: false,
	      option: null
	    }));
	  };
	  var toggleDropdown = function toggleDropdown() {
	    if (value.dropdown) {
	      focusInput();
	    }
	    _onChange(_extends({}, value, {
	      dropdown: value.option ? true : !value.dropdown,
	      text: '',
	      option: null,
	      operator: _query.DEFAULT_OPERATOR
	    }));
	  };
	  var onCancel = function onCancel() {
	    focusInput();
	    _onChange({});
	  };
	  var cancelLabel = 'Cancel';
	  if (value.option === 'camera' && activeQuery.camera.length !== 0) {
	    cancelLabel = 'Done';
	  }
	  if (value.option === 'rating') {
	    cancelLabel = 'Done';
	  }
	  if (value.option === 'library') {
	    cancelLabel = 'Done';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: disabled ? _ImageSearchInput2.default.wrapperDisabled : _ImageSearchInput2.default.wrapper },
	    _react2.default.createElement(
	      'form',
	      { className: _ImageSearchInput2.default.text, action: '', onSubmit: function onSubmit(e) {
	          return e.preventDefault();
	        } },
	      _react2.default.createElement('input', {
	        className: 'mousetrap ' + (value.dropdown ? _ImageSearchInput2.default.textInputDisabled : _ImageSearchInput2.default.textInput),
	        type: 'search',
	        value: value.text || '',
	        onChange: onChangeText,
	        onClick: onClickText,
	        autoFocus: autoFocus,
	        placeholder: getPlaceholder(value),
	        autoComplete: 'off',
	        autoCorrect: 'off',
	        autoCapitalize: 'off'
	      }),
	      _react2.default.createElement(_Icon2.default, { icon: 'search', size: 18, className: _ImageSearchInput2.default.searchIcon }),
	      _react2.default.createElement(
	        'div',
	        { className: _ImageSearchInput2.default.inputTools },
	        _react2.default.createElement(
	          'button',
	          { className: _ImageSearchInput2.default.inputButton, onClick: toggleDropdown },
	          _react2.default.createElement(_Icon2.default, { icon: value.dropdown ? 'chevron-up' : 'chevron-down', size: 18 })
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _ImageSearchInput2.default.cancelButton,
	            onClick: onCancel,
	            disabled: !value.text && !value.dropdown && !value.option },
	          cancelLabel
	        )
	      )
	    ),
	    !value.dropdown && value.text && _react2.default.createElement(_AutoComplete2.default, {
	      text: value.text.trim(),
	      operator: value.operator,
	      options: options,
	      exclude: activeQuery.keyword.map(function (k) {
	        return k.value;
	      }),
	      addTerm: addTerm,
	      focusInput: focusInput,
	      onClose: onCancel
	    }),
	    value.dropdown && _react2.default.createElement(Dropdown, {
	      value: value.option,
	      onChange: function onChange(option) {
	        if (option === null) clearEditingState();
	        _onChange(_extends({}, value, { option: option }));
	      },
	      addTerm: addTerm,
	      updateTerm: updateTerm,
	      updateRating: updateRating,
	      removeTerm: removeTerm,
	      query: query,
	      activeQuery: activeQuery,
	      libraries: libraries,
	      options: options,
	      userHasPerm: userHasPerm,
	      dynlinks: dynlinks,
	      addNewQuery: addNewQuery && function () {
	        addNewQuery();
	        onCancel();
	      },
	      setRootProperty: setRootProperty,
	      updateTargetDate: updateTargetDate
	    })
	  );
	}
	
	exports.default = ImageSearchInput;
	var ADVANCED_TYPES = [{ type: 'rating', name: 'Rating' }, { type: 'date', name: 'Timeframe', perm: 'advanced_search' }, { type: 'location', name: 'Location', perm: 'advanced_search' }, { type: 'camera', name: 'Camera' }, { type: 'library', name: 'Libraries' }, { type: 'dynlink', name: 'Dynamic Link', perm: 'dynamic_links' }, { type: 'other', name: 'Other' }, { type: 'limit', name: 'Limit' }];
	
	var Dropdown = function Dropdown(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange,
	      addTerm = _ref2.addTerm,
	      updateTerm = _ref2.updateTerm,
	      updateRating = _ref2.updateRating,
	      removeTerm = _ref2.removeTerm,
	      query = _ref2.query,
	      activeQuery = _ref2.activeQuery,
	      addNewQuery = _ref2.addNewQuery,
	      libraries = _ref2.libraries,
	      options = _ref2.options,
	      userHasPerm = _ref2.userHasPerm,
	      dynlinks = _ref2.dynlinks,
	      setRootProperty = _ref2.setRootProperty,
	      updateTargetDate = _ref2.updateTargetDate;
	  return _react2.default.createElement(
	    'div',
	    { className: _ImageSearchInput2.default.dropdown },
	    !value && _react2.default.createElement(
	      'div',
	      { className: _ImageSearchInput2.default.dropdownButtons },
	      ADVANCED_TYPES.map(function (_ref3) {
	        var type = _ref3.type,
	            name = _ref3.name,
	            perm = _ref3.perm;
	
	        if (type === 'library' && libraries.length === 1) {
	          return null;
	        }
	        if (perm && userHasPerm(perm) === false) {
	          return null;
	        }
	        return _react2.default.createElement(
	          'button',
	          { key: type, className: _ImageSearchInput2.default.dropdownButton, onClick: function onClick() {
	              return onChange(type);
	            } },
	          name
	        );
	      }),
	      _react2.default.createElement(
	        'button',
	        { className: _ImageSearchInput2.default.addQueryButton, onClick: addNewQuery, disabled: !addNewQuery },
	        'Add query'
	      )
	    ),
	    value === 'rating' && _react2.default.createElement(_reduxForm.Field, {
	      component: _RatingPicker2.default,
	      name: 'rating',
	      props: {
	        updateRating: updateRating,
	        onCancel: function onCancel() {
	          return onChange(null);
	        }
	      },
	      defaultValue: activeQuery.rating
	    }),
	    value === 'date' && _react2.default.createElement(_reduxForm.Field, {
	      component: _DatePicker2.default,
	      name: 'date',
	      props: {
	        addTerm: function addTerm(type, value) {
	          return updateTerm({
	            type: type,
	            value: _extends({}, value, { operator: _query.DEFAULT_OPERATOR }),
	            termIndex: activeQuery.date.length
	          });
	        },
	        onCancel: function onCancel() {
	          return onChange(null);
	        },
	        showDynamic: userHasPerm('advanced_search'),
	        options: options,
	        targetDate: query.structure.date_target,
	        updateTargetDate: updateTargetDate
	      },
	      defaultValue: {}
	    }),
	    value === 'location' && _react2.default.createElement(_reduxForm.Field, {
	      component: _AreaPicker2.default,
	      name: 'location',
	      props: {
	        updateTerm: updateTerm,
	        onCancel: function onCancel() {
	          return onChange(null);
	        },
	        style: { padding: '10px' }
	      },
	      defaultValue: activeQuery.location[0] || {
	        lat: 51.509,
	        lon: -0.197,
	        radius: 25
	      }
	    }),
	    value === 'camera' && _react2.default.createElement(_reduxForm.Field, {
	      component: _CameraPicker2.default,
	      name: 'camera',
	      props: {
	        addTerm: addTerm,
	        removeTerm: removeTerm,
	        cameras: options.cameras,
	        selected: activeQuery.camera
	      }
	    }),
	    value === 'library' && _react2.default.createElement(_reduxForm.Field, {
	      component: _LibraryPicker2.default,
	      name: 'library',
	      props: {
	        addTerm: addTerm,
	        removeTerm: removeTerm,
	        libraries: libraries,
	        onCancel: function onCancel() {
	          return onChange(null);
	        }
	      },
	      defaultValue: activeQuery.library
	    }),
	    value === 'limit' && _react2.default.createElement(_reduxForm.Field, {
	      component: _LimitForm2.default,
	      name: 'limit',
	      props: {
	        setRootProperty: setRootProperty,
	        onCancel: function onCancel() {
	          return onChange(null);
	        }
	      },
	      defaultValue: {
	        limit: query.structure.limit || '',
	        diversity: query.structure.diversity || 0,
	        seed: query.structure.seed || ''
	      }
	    }),
	    value === 'other' && _react2.default.createElement(_reduxForm.Field, {
	      component: _AdvancedForm2.default,
	      name: 'other',
	      props: {
	        updateTerm: updateTerm,
	        onCancel: function onCancel() {
	          return onChange(null);
	        }
	      },
	      defaultValue: activeQuery.other[0] || {
	        filename: '',
	        transmissionReference: ''
	      }
	    }),
	    value === 'dynlink' && _react2.default.createElement(_reduxForm.Field, {
	      component: _DynamicLinkForm2.default,
	      name: 'dynlink',
	      props: {
	        addTerm: function addTerm(type, value) {
	          return updateTerm({
	            type: type,
	            value: _extends({}, value, { operator: _query.DEFAULT_OPERATOR }),
	            termIndex: activeQuery.dynlink.length
	          });
	        },
	        dynlinks: dynlinks,
	        onCancel: function onCancel() {
	          return onChange(null);
	        }
	      }
	    })
	  );
	};
	
	function getPlaceholder(_ref4) {
	  var dropdown = _ref4.dropdown,
	      option = _ref4.option;
	
	  if (!dropdown) {
	    return 'Find images';
	  }
	  if (!option) {
	    return 'Select an advanced search type';
	  }
	  if (option === 'rating') {
	    return 'Select a star rating';
	  }
	  if (option === 'camera') {
	    return 'Select a camera';
	  }
	  if (option === 'date') {
	    return 'Select a timeframe';
	  }
	  if (option === 'library') {
	    return 'Toggle to filter by library';
	  }
	  if (option === 'location') {
	    return 'Search by location';
	  }
	  if (option === 'dynlink') {
	    return 'Create/edit dynamic link';
	  }
	  if (option === 'limit') {
	    return 'Limit the number of images';
	  }
	  if (option === 'other') {
	    return 'Other search';
	  }
	  return '';
	}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LibraryPicker;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LibraryPicker = __webpack_require__(848);
	
	var _LibraryPicker2 = _interopRequireDefault(_LibraryPicker);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LibraryPicker(_ref) {
	  var value = _ref.value,
	      onCancel = _ref.onCancel,
	      addTerm = _ref.addTerm,
	      removeTerm = _ref.removeTerm,
	      libraries = _ref.libraries;
	
	  var renderLibrary = function renderLibrary(name) {
	    var index = value.findIndex(function (library) {
	      return library.value === name;
	    });
	    var active = index !== -1;
	    var onRemove = function onRemove() {
	      return removeTerm('library', index);
	    };
	    var onAdd = function onAdd() {
	      return addTerm('library', name, 'should');
	    };
	    var isVirtual = /^virtual_/.test(name);
	    return _react2.default.createElement(
	      'button',
	      {
	        key: name,
	        className: active ? _LibraryPicker2.default.button : _LibraryPicker2.default.greyButton,
	        onClick: active ? onRemove : onAdd },
	      isVirtual ? 'Shared' : (0, _string.titleCase)(name)
	    );
	  };
	  var removeAll = function removeAll() {
	    value.map(function () {
	      return removeTerm('library', 0);
	    });
	  };
	  var selectAll = function selectAll() {
	    libraries.map(function (name) {
	      return addTerm('library', name, 'should');
	    });
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _LibraryPicker2.default.buttons },
	    libraries.map(renderLibrary),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'button',
	      { className: _LibraryPicker2.default.tool, onClick: selectAll },
	      'Select all'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: _LibraryPicker2.default.tool, onClick: removeAll },
	      'Select none'
	    )
	  );
	}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdvancedForm = __webpack_require__(243);
	
	var _AdvancedForm2 = _interopRequireDefault(_AdvancedForm);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _DiversityPicker = __webpack_require__(207);
	
	var _DiversityPicker2 = _interopRequireDefault(_DiversityPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LimitForm(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange,
	      onCancel = _ref.onCancel,
	      setRootProperty = _ref.setRootProperty,
	      pristine = _ref.pristine;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _AdvancedForm2.default.form },
	    _react2.default.createElement(
	      'label',
	      null,
	      'Limit',
	      _react2.default.createElement('input', {
	        type: 'number',
	        value: value.limit || '',
	        onChange: function onChange(e) {
	          return _onChange(_extends({}, value, { limit: parseInt(e.target.value) }));
	        },
	        className: _AdvancedForm2.default.numberInput
	      })
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: _AdvancedForm2.default.note },
	      'Limit is reapplied every time sort changes'
	    ),
	    _react2.default.createElement(_DiversityPicker2.default, {
	      value: value.diversity || 0,
	      onChange: function onChange(e) {
	        return _onChange(_extends({}, value, { diversity: parseFloat(e.target.value) }));
	      },
	      onMouseUp: function onMouseUp(e) {
	        return setRootProperty('diversity', parseFloat(e.target.value));
	      },
	      showSuggestedLimit: true
	    }),
	    _react2.default.createElement(
	      'label',
	      null,
	      'Custom seed for random sort',
	      _react2.default.createElement('input', {
	        type: 'text',
	        value: value.seed || '',
	        onChange: function onChange(e) {
	          return _onChange(_extends({}, value, { seed: e.target.value }));
	        },
	        className: _AdvancedForm2.default.numberInput
	      })
	    ),
	    _react2.default.createElement(_ConfirmButtons2.default, {
	      onCancel: onCancel,
	      confirmText: 'Submit',
	      onConfirm: function onConfirm() {
	        setRootProperty('limit', value.limit || undefined);
	        setRootProperty('seed', value.seed || undefined);
	      },
	      confirmDisabled: pristine
	    })
	  );
	}
	exports.default = LimitForm;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OperatorButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPERATORS = {
	  must: 'Require',
	  should: 'Include',
	  must_not: 'Exclude'
	};
	
	var NEXT_OPERATOR = {
	  must: 'should',
	  should: 'must_not',
	  must_not: 'must'
	};
	
	function OperatorButton(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      className = _ref.className;
	
	  var onClick = function onClick() {
	    onChange(NEXT_OPERATOR[value]);
	  };
	  return _react2.default.createElement(
	    'button',
	    { type: 'button', onClick: onClick, className: className },
	    OPERATORS[value]
	  );
	}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RatingPicker;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RatingPicker = __webpack_require__(849);
	
	var _RatingPicker2 = _interopRequireDefault(_RatingPicker);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RatingPicker(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      onCancel = _ref.onCancel,
	      updateRating = _ref.updateRating;
	
	  var addRating = function addRating(n) {
	    var operator = value.length !== 0 ? value[0].operator : 'should';
	    var newValue = value.concat({ value: n, operator: operator });
	    onChange(newValue);
	    updateRating(newValue);
	  };
	  var removeRating = function removeRating(n) {
	    var newValue = value.filter(function (r) {
	      return r.value !== n;
	    });
	    onChange(newValue);
	    updateRating(newValue);
	  };
	  var stars = [];
	
	  var nullSelected = value.findIndex(function (r) {
	    return r.value === null;
	  }) !== -1;
	  var onClickNull = nullSelected ? function () {
	    return removeRating(null);
	  } : function () {
	    return addRating(null);
	  };
	  stars.push(_react2.default.createElement(
	    'button',
	    { key: 'null', onClick: onClickNull, className: nullSelected ? _RatingPicker2.default.nullButtonSelected : _RatingPicker2.default.nullButton },
	    'No rating'
	  ));
	
	  var _loop = function _loop(i) {
	    var selected = value.findIndex(function (r) {
	      return r.value === i;
	    }) !== -1;
	    var onClick = selected ? function () {
	      return removeRating(i);
	    } : function () {
	      return addRating(i);
	    };
	    stars.push(_react2.default.createElement(
	      'button',
	      { key: i, onClick: onClick },
	      _react2.default.createElement(_Icon2.default, {
	        size: 30,
	        icon: selected ? 'star' : 'star-outline',
	        className: selected ? _RatingPicker2.default.star : _RatingPicker2.default.starOutline
	      })
	    ));
	  };
	
	  for (var i = 1; i <= 5; i++) {
	    _loop(i);
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: _RatingPicker2.default.picker },
	    stars
	  );
	}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactHotLoader = __webpack_require__(1121);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _redboxReact = __webpack_require__(1190);
	
	var _redboxReact2 = _interopRequireDefault(_redboxReact);
	
	var _webfontloader = __webpack_require__(1251);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	var _store = __webpack_require__(577);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Root = __webpack_require__(564);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _auth = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_webfontloader2.default.load({
	  google: {
	    families: ['Lato:300,400,700', 'BenchNine:400']
	  },
	  classes: false
	});
	
	_reactRouter.browserHistory.listen(function (location) {
	  var path = (/#\/(.*)$/.exec(location.hash) || [])[1];
	  if (path) _reactRouter.browserHistory.replace(path);
	});
	
	var store = (0, _store2.default)(_reactRouter.browserHistory);
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	(0, _auth.restoreSession)(store);
	
	function renderApp(Component) {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactHotLoader.AppContainer,
	    { errorReporter: _redboxReact2.default },
	    _react2.default.createElement(Component, { store: store, history: history })
	  ), document.getElementById('app'));
	}
	
	renderApp(_Root2.default);
	
	if (false) {
	  module.hot.accept('./pages/Root', function () {
	    renderApp(require('./pages/Root').default);
	  });
	}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _Album = __webpack_require__(851);
	
	var _Album2 = _interopRequireDefault(_Album);
	
	var _album = __webpack_require__(66);
	
	var _albums = __webpack_require__(41);
	
	var _search = __webpack_require__(59);
	
	var _query = __webpack_require__(50);
	
	var _modals = __webpack_require__(212);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	var _auth = __webpack_require__(20);
	
	var _lists = __webpack_require__(88);
	
	var _Gallery = __webpack_require__(303);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _ImageSearch = __webpack_require__(543);
	
	var _ImageSearch2 = _interopRequireDefault(_ImageSearch);
	
	var _AlbumMenu = __webpack_require__(510);
	
	var _AlbumMenu2 = _interopRequireDefault(_AlbumMenu);
	
	var _SortMenu = __webpack_require__(512);
	
	var _SortMenu2 = _interopRequireDefault(_SortMenu);
	
	var _AlbumHeader = __webpack_require__(506);
	
	var _AlbumHeader2 = _interopRequireDefault(_AlbumHeader);
	
	var _AlbumInfo = __webpack_require__(507);
	
	var _AlbumInfo2 = _interopRequireDefault(_AlbumInfo);
	
	var _AlbumShare = __webpack_require__(511);
	
	var _AlbumShare2 = _interopRequireDefault(_AlbumShare);
	
	var _AlbumLists = __webpack_require__(509);
	
	var _AlbumLists2 = _interopRequireDefault(_AlbumLists);
	
	var _AlbumBreadcrumbs = __webpack_require__(505);
	
	var _AlbumBreadcrumbs2 = _interopRequireDefault(_AlbumBreadcrumbs);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGINATION_SENSITIVITY = 40; // Higher means more images load earlier
	var TOP_BAR_HEIGHT = 44; // Should match $header-height in variables.css
	
	var Album = function (_Component) {
	  _inherits(Album, _Component);
	
	  function Album() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Album);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Album.__proto__ || Object.getPrototypeOf(Album)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      sortMenuOpen: false,
	      saveSuccess: false
	    }, _this.routerWillLeave = function () {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          modals = _this$props.modals;
	
	      if (params.task === 'edit' && _this.isUnsaved() && !modals[_modals.SAVE_ALBUM_MODAL_KEY]) {
	        return 'Your changes have not been saved. Are you sure you want to leave?';
	      }
	    }, _this.onScroll = function () {
	      var error = _this.props.error;
	
	      clearTimeout(_this.scrollTimeout);
	      _this.scrollTimeout = setTimeout(function () {
	        var _window = window,
	            innerHeight = _window.innerHeight;
	        var scrollHeight = window.document.body.scrollHeight;
	
	        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	        var diff = scrollHeight - (scrollTop + innerHeight);
	        if (_this.shouldLoadMoreImages() && !error && diff < PAGINATION_SENSITIVITY) {
	          _this.loadMoreImages();
	        }
	      }, 200);
	    }, _this.loadMoreImages = function (limit) {
	      var _this$props2 = _this.props,
	          searchImages = _this$props2.searchImages,
	          query = _this$props2.query,
	          images = _this$props2.images;
	
	      return searchImages(query.structure, (images || []).length, limit);
	    }, _this.setCover = function (imageID) {
	      var _this$props3 = _this.props,
	          album = _this$props3.album,
	          setAlbumCover = _this$props3.setAlbumCover;
	
	      setAlbumCover(album, imageID);
	    }, _this.enableEditing = function () {
	      var _this$props4 = _this.props,
	          params = _this$props4.params,
	          push = _this$props4.push;
	
	      if (params.id && params.task !== 'edit') {
	        var headerHeight = (0, _reactDom.findDOMNode)(_this.refs.header).clientHeight;
	        push('/album/' + params.id + '/edit');
	        var searchHeight = (0, _reactDom.findDOMNode)(_this.refs.search).clientHeight;
	
	        // Going into edit mode will push the gallery downwards due to the
	        // query form appearing above, so here we use the height difference
	        // to scroll upwards and keep the gallery in the same position
	        if (window.innerWidth < _constants.MOBILE_BREAKPOINT) {
	          window.scrollBy(0, searchHeight - headerHeight + TOP_BAR_HEIGHT);
	        }
	      }
	    }, _this.enableImageReorder = function () {
	      var _this$props5 = _this.props,
	          query = _this$props5.query,
	          enableImageReorder = _this$props5.enableImageReorder,
	          shouldSearchImages = _this$props5.shouldSearchImages,
	          searchImages = _this$props5.searchImages;
	
	      enableImageReorder();
	      // Preload manual search structure to prevent another spinner when reordering
	      var structure = _extends({}, query.structure, {
	        sort: _extends({}, query.structure.sort, {
	          value: 'manual',
	          operator: null
	        })
	      });
	      if (shouldSearchImages(structure)) {
	        searchImages(structure);
	      }
	    }, _this.renderMenuToggle = function (className) {
	      return _react2.default.createElement(
	        'button',
	        {
	          'data-toggle': 'album-menu',
	          className: className,
	          onClick: function onClick() {
	            return _this.setState({ menuOpen: !_this.state.menuOpen });
	          } },
	        _react2.default.createElement(_Icon2.default, { icon: 'dots' })
	      );
	    }, _this.renderMenu = function () {
	      var _this$props6 = _this.props,
	          location = _this$props6.location,
	          params = _this$props6.params,
	          album = _this$props6.album,
	          canShareInternal = _this$props6.canShareInternal,
	          canShareExternal = _this$props6.canShareExternal,
	          query = _this$props6.query;
	
	      var editing = _this.isEditing();
	      return _react2.default.createElement(_AlbumMenu2.default, _extends({}, _this.props, {
	        fixed: editing || query.selectImageMode,
	        open: _this.state.menuOpen,
	        closeMenu: function closeMenu() {
	          return _this.setState({ menuOpen: false });
	        },
	        album: params.id ? album : null,
	        title: _this.getTitle(),
	        editing: editing,
	        loadMoreImages: _this.loadMoreImages,
	        setCover: _this.setCover,
	        canShare: canShareInternal || canShareExternal,
	        canLock: location.pathname === '/search' || editing && _this.props.isOwnAlbum
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Album, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          album = _props.album,
	          fetchAlbum = _props.fetchAlbum,
	          replaceStructure = _props.replaceStructure;
	
	      // Fetch album if we need to
	
	      if (params.id && !album.id) {
	        fetchAlbum(params.id).then(function (album) {
	          if (!album) {
	            return;
	          }
	          var cached = _lscache2.default.get(_constants.QUERY_CACHE_KEY + params.id);
	          if (params.task === 'edit' && cached) {
	            replaceStructure(cached);
	          } else {
	            replaceStructure(JSON.parse(album.json_data));
	          }
	        });
	      }
	
	      // Replace query with album data if we already have it
	      if (album.json_data) {
	        replaceStructure(JSON.parse(album.json_data));
	      }
	
	      // Check query cache if mounting a search page
	      if (location.pathname === '/search') {
	        var cached = _lscache2.default.get(_constants.QUERY_CACHE_KEY);
	        if (cached) {
	          replaceStructure(cached);
	        } else {
	          replaceStructure(_query.emptyStructure);
	        }
	      }
	
	      if (location.query.path) {
	        this.loadPath(location.query.path);
	      }
	
	      if (this.props.shouldFetchAlbums) {
	        this.props.fetchAlbums();
	      }
	
	      if (params.task === 'info' && !this.props.keywordMap) {
	        this.props.fetchSearchOptions();
	      }
	
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
	
	      window.addEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          location = _props2.location,
	          params = _props2.params,
	          album = _props2.album,
	          hash = _props2.hash,
	          fetchAlbum = _props2.fetchAlbum,
	          replaceStructure = _props2.replaceStructure,
	          searchImages = _props2.searchImages,
	          images = _props2.images;
	
	      // Fetch album if we need to
	
	      if (nextProps.params.id && !nextProps.album.id && !nextProps.album.fetching && !nextProps.album.fetchError) {
	        fetchAlbum(nextProps.params.id).then(function (album) {
	          if (!album) return;
	          replaceStructure(JSON.parse(album.json_data));
	        });
	      }
	
	      // Navigating from album page to new search
	      if (params.id && !nextProps.params.id || location.query.path && !nextProps.location.query.path) {
	        var cached = _lscache2.default.get(_constants.QUERY_CACHE_KEY);
	        if (cached) {
	          replaceStructure(cached);
	        } else {
	          replaceStructure(_query.emptyStructure);
	        }
	      }
	
	      // Navigating between albums
	      if (nextProps.params.id && params.id !== nextProps.params.id) {
	        replaceStructure(JSON.parse(nextProps.album.json_data));
	      }
	      if (nextProps.location.query.path && location.query.path !== nextProps.location.query.path) {
	        this.loadPath(nextProps.location.query.path);
	      }
	
	      // Load original album structure when coming back from edit mode
	      if (params.id === nextProps.params.id && params.task === 'edit' && nextProps.params.task !== 'edit') {
	        replaceStructure(JSON.parse(nextProps.album.json_data));
	      }
	
	      // Whenever hash changes
	      if (hash !== nextProps.hash && !nextProps.images && !(0, _images.isEmptyStructure)(nextProps.query.structure)) {
	        searchImages(nextProps.query.structure);
	
	        // If editing album or searching, save query to localStorage
	        if (params.task === 'edit' || location.pathname === '/search') {
	          _lscache2.default.set(_constants.QUERY_CACHE_KEY + (params.id || ''), nextProps.query.structure, _constants.QUERY_CACHE_EXPIRY);
	        }
	      }
	
	      if (album.saving && !nextProps.album.saving) {
	        this.setState({ saveSuccess: true });
	      }
	
	      // Forced pagination check on image load
	      if (nextProps.images && (!images || images.length !== nextProps.images.length)) {
	        this.onScroll();
	      }
	
	      if (params.task !== 'info' && nextProps.params.task === 'info' && !this.props.keywordMap) {
	        this.props.fetchSearchOptions();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props3 = this.props,
	          location = _props3.location,
	          params = _props3.params,
	          replaceStructure = _props3.replaceStructure;
	
	      if (params.id) {
	        replaceStructure(_query.emptyStructure);
	      }
	      if (location.pathname === '/search') {
	        _lscache2.default.remove(_constants.QUERY_CACHE_KEY);
	      }
	      window.removeEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'loadPath',
	    value: function loadPath(path) {
	      var replaceStructure = this.props.replaceStructure;
	
	      if (path === 'event:null') {
	        replaceStructure({
	          queries: [_extends({}, _query.emptyQuery, {
	            event: [{ value: null, operator: 'must' }]
	          })]
	        });
	        return;
	      }
	      if (path === 'keyword:null') {
	        replaceStructure({
	          queries: [_extends({}, _query.emptyQuery, {
	            keyword: [{ value: null, operator: 'must' }]
	          })]
	        });
	        return;
	      }
	      replaceStructure({
	        queries: [_extends({}, _query.emptyQuery, {
	          path: [{
	            value: path === 'null' ? null : path,
	            operator: 'must'
	          }]
	        })]
	      });
	    }
	  }, {
	    key: 'shouldLoadMoreImages',
	    value: function shouldLoadMoreImages() {
	      var _props4 = this.props,
	          params = _props4.params,
	          images = _props4.images,
	          count = _props4.count,
	          fetching = _props4.fetching;
	
	      if (fetching) {
	        return false;
	      }
	      if (params.task && params.task !== 'edit') {
	        return false;
	      }
	      return images && count > images.length;
	    }
	  }, {
	    key: 'isUnsaved',
	    value: function isUnsaved() {
	      var _props5 = this.props,
	          params = _props5.params,
	          location = _props5.location,
	          query = _props5.query,
	          album = _props5.album;
	
	      if ((0, _images.isEmptyStructure)(query.structure)) {
	        return false;
	      }
	      if (location.pathname === '/search') {
	        return true;
	      }
	      if (params.task !== 'edit') {
	        return false;
	      }
	      return album.json_data && !(0, _lodash2.default)(query.structure, JSON.parse(album.json_data));
	    }
	  }, {
	    key: 'isEditing',
	    value: function isEditing() {
	      var _props6 = this.props,
	          location = _props6.location,
	          params = _props6.params;
	
	      return location.pathname === '/search' || params.task === 'edit';
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var _props7 = this.props,
	          album = _props7.album,
	          location = _props7.location;
	
	      if (location.query.path) {
	        if (_constants.SPECIAL_ALBUM_PATH_TITLE[location.query.path]) {
	          return _constants.SPECIAL_ALBUM_PATH_TITLE[location.query.path];
	        }
	        return location.query.path.split('/').pop().replace(/^\d+\.? /, '');
	      }
	      return album.name;
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(title) {
	      var _props8 = this.props,
	          params = _props8.params,
	          album = _props8.album,
	          images = _props8.images,
	          query = _props8.query;
	
	
	      var cover = void 0;
	      if (album.cover) {
	        cover = album.cover;
	      } else if (images && images.length !== 0) {
	        cover = images[0]._id;
	      }
	
	      return _react2.default.createElement(_AlbumHeader2.default, _extends({}, this.props, {
	        ref: 'header',
	        id: params.id,
	        title: title,
	        task: params.task,
	        thumbSize: query.thumbSize,
	        isFixed: query.structure.fixed && query.structure.fixed.length !== 0,
	        cover: cover,
	        menuOpen: this.state.menuOpen,
	        renderMenuToggle: this.renderMenuToggle,
	        hideCount: album.id && (0, _images.isEmptyStructure)(query.structure)
	      }));
	    }
	  }, {
	    key: 'renderGallery',
	    value: function renderGallery() {
	      var _props9 = this.props,
	          album = _props9.album,
	          params = _props9.params,
	          images = _props9.images,
	          query = _props9.query,
	          anonymousUser = _props9.anonymousUser,
	          entities = _props9.entities,
	          getImageSource = _props9.getImageSource,
	          selectImage = _props9.selectImage,
	          deselectImage = _props9.deselectImage,
	          updateManualOrder = _props9.updateManualOrder,
	          updateThumbSize = _props9.updateThumbSize;
	
	      var limit = !images || params.task === 'info' ? 4 : images.length;
	      if (album.id && (0, _images.isEmptyStructure)(query.structure)) {
	        if (album.image_share) {
	          return _react2.default.createElement(_ErrorMessage2.default, { message: 'No images have been shared with you' });
	        }
	        return _react2.default.createElement(_ErrorMessage2.default, { message: 'There are no search terms for this album' });
	      }
	      return _react2.default.createElement(_Gallery2.default, {
	        entities: entities,
	        images: images ? images.slice(0, limit) : null,
	        getImageSource: getImageSource,
	        selectImageMode: query.selectImageMode,
	        reorderImageMode: query.reorderImageMode,
	        selectedImages: query.selectedImages,
	        selectImage: selectImage,
	        deselectImage: deselectImage,
	        updateManualOrder: updateManualOrder,
	        anonymousUser: anonymousUser,
	        setCover: this.setCover,
	        enableEditing: this.enableEditing,
	        title: this.getTitle() || 'Search results',
	        confirmReorder: query.structure.sort.value !== 'manual' && query.structure.sort.manual,
	        showEventHeadings: query.structure.sort.value === 'event',
	        loadMoreImages: this.shouldLoadMoreImages() ? this.loadMoreImages : null,
	        canShareImagesInternal: this.props.canShareImagesInternal,
	        canShareImagesExternal: this.props.canShareImagesExternal,
	        thumbSize: query.thumbSize,
	        updateThumbSize: updateThumbSize,
	        userLibraries: query.libraries,
	        albumID: params.id,
	        canEdit: this.props.canEdit,
	        canFlag: this.props.canFlag,
	        canRemove: this.props.canEdit && !this.props.location.query.path,
	        excludeImages: this.props.excludeImages
	      });
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton() {
	      var _props10 = this.props,
	          album = _props10.album,
	          previousPath = _props10.previousPath;
	
	      if (album && album.id) {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/album/' + album.id },
	          'Cancel'
	        );
	      }
	      if (!previousPath || previousPath === '/login') {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/' },
	          'Cancel'
	        );
	      }
	      return _react2.default.createElement(
	        'button',
	        { onClick: function onClick() {
	            return window.history.back();
	          } },
	        'Cancel'
	      );
	    }
	  }, {
	    key: 'renderEditHeader',
	    value: function renderEditHeader() {
	      var _props11 = this.props,
	          location = _props11.location,
	          openModal = _props11.openModal,
	          images = _props11.images;
	
	      var search = location.pathname === '/search';
	      return _react2.default.createElement(
	        'div',
	        { className: _Album2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerButtonsLeft },
	          this.renderCancelButton()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerTitle },
	          search ? 'Search' : 'Edit Album'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerButtonsRight },
	          images && images.length !== 0 && this.renderMenuToggle(),
	          (!search || this.isUnsaved()) && _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return openModal(_modals.SAVE_ALBUM_MODAL_KEY);
	              } },
	            'Save'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSelectHeader',
	    value: function renderSelectHeader() {
	      var _props12 = this.props,
	          query = _props12.query,
	          disableImageSelect = _props12.disableImageSelect,
	          openModal = _props12.openModal,
	          canSaveSelected = _props12.canSaveSelected;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Album2.default.selectHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerButtonsLeft },
	          _react2.default.createElement(
	            'button',
	            { onClick: disableImageSelect },
	            _react2.default.createElement(_Icon2.default, { icon: 'close' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerTitleLeft },
	          query.reorderImageMode ? 'Select new position' : query.selectedImages.length + ' selected'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Album2.default.headerButtonsRight },
	          !query.reorderImageMode && _react2.default.createElement(
	            'button',
	            { onClick: this.enableImageReorder },
	            _react2.default.createElement(_Icon2.default, { icon: 'shuffle' })
	          ),
	          this.renderMenuToggle(),
	          canSaveSelected && _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return openModal(_modals.SAVE_ALBUM_MODAL_KEY);
	              } },
	            'Save As'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCount',
	    value: function renderCount(editing) {
	      var _this2 = this;
	
	      var _props13 = this.props,
	          count = _props13.count,
	          query = _props13.query,
	          params = _props13.params;
	      var sort = query.structure.sort;
	
	
	      var value = sort.value;
	      if (sort.operator) {
	        value += ' (' + sort.operator + ')';
	      }
	      if (!query.selectImageMode) {
	        value = _react2.default.createElement(
	          'button',
	          {
	            key: 'link',
	            className: _Album2.default.sortLink,
	            onClick: function onClick() {
	              return _this2.setState({ sortMenuOpen: true });
	            } },
	          value
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: _Album2.default.count },
	        editing && (0, _string.pluralize)(count, 'image') + ' found',
	        sort.value && params.task !== 'info' && [editing ? ', sorted by ' : 'Sorted by ', value]
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this3 = this;
	
	      var _props14 = this.props,
	          location = _props14.location,
	          params = _props14.params,
	          album = _props14.album,
	          owner = _props14.owner,
	          query = _props14.query,
	          images = _props14.images,
	          keywords = _props14.keywords,
	          count = _props14.count,
	          fetching = _props14.fetching,
	          error = _props14.error,
	          getImageSource = _props14.getImageSource,
	          fetchAlbum = _props14.fetchAlbum,
	          canShareInternal = _props14.canShareInternal,
	          canShareExternal = _props14.canShareExternal,
	          updateSortOrder = _props14.updateSortOrder,
	          canSave = _props14.canSave;
	      var _state = this.state,
	          sortMenuOpen = _state.sortMenuOpen,
	          saveSuccess = _state.saveSuccess;
	
	
	      var editing = this.isEditing();
	      var unsaved = this.isUnsaved();
	
	      if (params.task === 'share') {
	        return _react2.default.createElement(_AlbumShare2.default, {
	          id: params.id,
	          album: album,
	          canShareInternal: canShareInternal,
	          canShareExternal: canShareExternal,
	          lists: this.props.lists,
	          albumLists: this.props.albumLists,
	          sort: query.structure.sort,
	          canSave: canSave && query.selectedImages.length === 0,
	          showFixHint: this.props.canEdit && this.props.isOwnAlbum && (!query.structure.fixed || query.structure.fixed.length === 0 && count <= _constants.MAX_FIXED_COUNT),
	          loadAllImages: function loadAllImages() {
	            if (images.length === count) {
	              return Promise.resolve();
	            }
	            return _this3.loadMoreImages(count);
	          },
	          images: images,
	          query: query
	        });
	      }
	
	      if (params.task === 'groups') {
	        return _react2.default.createElement(_AlbumLists2.default, {
	          id: params.id,
	          lists: this.props.lists,
	          albumLists: this.props.albumLists
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.location.pathname === '/search' && count > 0 && _react2.default.createElement('input', {
	          className: _Album2.default.slider,
	          type: 'range',
	          min: 80,
	          max: 640,
	          defaultValue: query.thumbSize,
	          onMouseUp: function onMouseUp(e) {
	            return _this3.props.updateThumbSize(parseInt(e.target.value));
	          }
	        }),
	        editing && _react2.default.createElement(_ImageSearch2.default, {
	          ref: 'search',
	          query: query,
	          autoFocus: this.props.location.pathname === '/search',
	          className: _Album2.default.search
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          unsaved && count > 0 && _react2.default.createElement(
	            'span',
	            { className: _Album2.default.unsaved },
	            'Unsaved'
	          ),
	          !unsaved && !editing && saveSuccess && _react2.default.createElement(
	            'span',
	            { className: _Album2.default.saveSuccess },
	            'Saved'
	          ),
	          _react2.default.createElement(_AlbumBreadcrumbs2.default, { location: this.props.location }),
	          count > 0 && params.task !== 'info' && this.renderCount(editing),
	          _react2.default.createElement(_SortMenu2.default, {
	            open: sortMenuOpen,
	            closeMenu: function closeMenu() {
	              return _this3.setState({ sortMenuOpen: false });
	            },
	            updateSortOrder: updateSortOrder,
	            manualDisabled: !query.structure.sort.manual
	          }),
	          params.task !== 'info' && album.fetching && _react2.default.createElement(_LoadingSpinner2.default, null),
	          album.fetchError && _react2.default.createElement(_ErrorMessage2.default, {
	            message: album.fetchError.status === 403 ? 'You do not have permission to view this album' : 'There was an error fetching the album',
	            onRetry: function onRetry() {
	              return fetchAlbum(params.id);
	            }
	          }),
	          params.task !== 'info' && this.renderGallery(),
	          error && _react2.default.createElement(_ErrorMessage2.default, {
	            message: 'There was an error fetching images',
	            onRetry: function onRetry() {
	              return _this3.loadMoreImages();
	            }
	          }),
	          params.task !== 'info' && _react2.default.createElement(_LoadingSpinner2.default, { show: !!fetching }),
	          params.task === 'info' && _react2.default.createElement(_AlbumInfo2.default, _extends({}, this.props, {
	            loadMoreImages: this.loadMoreImages,
	            onClickSave: function onClickSave() {
	              return _this3.props.openModal(_modals.SAVE_ALBUM_MODAL_KEY);
	            }
	          })),
	          editing && this.renderEditHeader(),
	          query.selectImageMode && !location.query.path && (!params.id || this.props.canEdit) && this.renderSelectHeader()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var editing = this.isEditing();
	      var title = this.getTitle();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        title && !editing && this.renderHeader(title),
	        this.renderMenu(),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return Album;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var entities = _ref2.entities,
	      search = _ref2.search,
	      auth = _ref2.auth,
	      query = _ref2.query,
	      albums = _ref2.albums,
	      modals = _ref2.modals,
	      playlists = _ref2.playlists,
	      nav = _ref2.nav;
	  var params = _ref3.params,
	      location = _ref3.location;
	
	  var album = entities.albums[params.id] || {};
	  var hash = (0, _images.getHash)(query.structure);
	
	  var _getImages = getImages(search, hash, query, entities, album),
	      images = _getImages.images,
	      keywords = _getImages.keywords,
	      count = _getImages.count,
	      fetching = _getImages.fetching,
	      error = _getImages.error,
	      resolvedKeywords = _getImages.resolvedKeywords;
	
	  var isOwnAlbum = auth.user && album.user_id === auth.user.id;
	  var locked = album.favourite || album.image_share;
	  var anonymousUser = (0, _auth.isAnonymous)(auth.user);
	  var lists = (0, _lists.mapStateToLists)(playlists, entities);
	  return {
	    lists: lists,
	    entities: entities,
	    album: album,
	    hash: hash,
	    query: query,
	    images: images,
	    keywords: keywords,
	    count: getCount(count, query),
	    trueCount: count, // Used when fetching all images
	    fetching: fetching,
	    error: error,
	    modals: modals,
	    isOwnAlbum: isOwnAlbum,
	    owner: entities.users[album.user_id],
	    getImageSource: (0, _images.createImageGetter)(auth),
	    hasFavourited: (albums.favourites.data || []).indexOf(params.id) !== -1,
	    canEdit: !!params.id && !anonymousUser && (0, _auth.userHasPerm)(auth.user, 'search_and_save'),
	    canSave: !album.favourite && (isOwnAlbum || (0, _auth.userHasPerm)(auth.user, 'edit_collections')),
	    canSaveSelected: (0, _auth.userHasPerm)(auth.user, 'search_and_save'),
	    canDelete: !!params.id && !query.selectImageMode && !anonymousUser,
	    canShareInternal: canShareInternal(params, auth, isOwnAlbum),
	    canShareExternal: !!params.id && isOwnAlbum && (0, _auth.userHasPerm)(auth.user, 'external_share'),
	    showShare: !!params.id && ((0, _auth.userHasPerm)(auth.user, 'external_share') || (0, _auth.userHasPerm)(auth.user, 'internal_share') || (0, _auth.userHasPerm)(auth.user, 'internal_share_all')),
	    canShareImagesInternal: (0, _auth.userHasPerm)(auth.user, 'internal_share'),
	    canShareImagesExternal: (0, _auth.userHasPerm)(auth.user, 'external_share'),
	    canDownload: (0, _auth.canDownload)(auth),
	    canFlag: (0, _auth.userHasPerm)(auth.user, 'flag_image'),
	    anonymousUser: anonymousUser,
	    addingToPlaylist: location.query.playlist ? entities.playlists[location.query.playlist] || { id: 'create' } : null,
	    albumLists: params.id && lists && lists.filter(function (list) {
	      return list.albums.map(function (a) {
	        return a.id;
	      }).indexOf(album.id) !== -1;
	    }).map(function (list) {
	      return list.id;
	    }),
	    shouldSearchImages: function shouldSearchImages(structure) {
	      var hash = (0, _images.getHash)(structure);
	      return !search[hash] || !search[hash].data;
	    },
	    shouldFetchAlbums: !albums.all.data,
	    previousPath: nav.previousPath,
	    resolvedKeywords: resolvedKeywords,
	    keywordMap: search.options.keywordMap,
	    hasDynamicLink: (0, _images.hasDynamicLink)(query.structure)
	  };
	};
	
	function canShareInternal(params, auth, isOwnAlbum) {
	  if (!params.id) return false;
	  if ((0, _auth.userHasPerm)(auth.user, 'internal_share_all')) return true;
	  if ((0, _auth.userHasPerm)(auth.user, 'internal_share')) return isOwnAlbum;
	  return false;
	}
	
	function getImages(search, hash, query, entities, album) {
	  if ((0, _images.isEmptyStructure)(query.structure) || !search[hash]) {
	    return {};
	  }
	  if (!search[hash].data) {
	    return search[hash];
	  }
	
	  var images = search[hash].data.filter(function (id) {
	    return query.structure.exclude.indexOf(id) === -1;
	  });
	
	  var sort = query.structure.sort;
	  if (sort.value === 'manual' && sort.manual) {
	    images = sortWithGuide(images, sort.manual);
	  } else if (album.image_share) {
	    images = sortWithGuide(images, query.structure.include);
	  }
	
	  return _extends({}, search[hash], {
	    images: images.map(function (id) {
	      return entities.images[id];
	    })
	  });
	}
	
	function sortWithGuide(array, order) {
	  return array.slice(0).sort(function (a, b) {
	    // Sort images using the manual sort array as a guide
	    var indexA = order.indexOf(a);
	    var indexB = order.indexOf(b);
	    if (indexA !== -1 && indexB === -1) return -1;
	    if (indexA === -1 && indexB !== -1) return 1;
	    if (indexA < indexB) return -1;
	    if (indexA > indexB) return 1;
	    return 0;
	  });
	}
	
	function getCount(count, query) {
	  var _query$structure = query.structure,
	      fixed = _query$structure.fixed,
	      exclude = _query$structure.exclude;
	
	  if (fixed && fixed.length !== 0) {
	    return fixed.length;
	  }
	  return count - exclude.length;
	}
	
	var mapDispatchToProps = {
	  fetchAlbum: _album.fetchAlbum,
	  fetchAlbums: _albums.fetchAlbums,
	  setFavouriteAlbum: _album.setFavouriteAlbum,
	  searchImages: _search.searchImages,
	  replaceStructure: _query.replaceStructure,
	  selectImage: _query.selectImage,
	  deselectImage: _query.deselectImage,
	  disableImageSelect: _query.disableImageSelect,
	  updateSortOrder: _query.updateSortOrder,
	  updateManualOrder: _query.updateManualOrder,
	  updateThumbSize: _query.updateThumbSize,
	  setAlbumCover: _album.setAlbumCover,
	  openModal: _modals.openModal,
	  push: _reactRouterRedux.push,
	  enableImageReorder: _query.enableImageReorder,
	  fixAlbum: _query.fixAlbum,
	  unfixAlbum: _query.unfixAlbum,
	  excludeImages: _query.excludeImages,
	  fetchSearchOptions: _search.fetchSearchOptions
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(Album));

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	__webpack_require__(868);
	
	__webpack_require__(850);
	
	var _auth = __webpack_require__(42);
	
	var _nav = __webpack_require__(312);
	
	var _users = __webpack_require__(68);
	
	var _auth2 = __webpack_require__(20);
	
	var _Header = __webpack_require__(499);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Navigation = __webpack_require__(502);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Banners = __webpack_require__(498);
	
	var _Banners2 = _interopRequireDefault(_Banners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          location = _props.location,
	          params = _props.params,
	          nav = _props.nav,
	          user = _props.user,
	          toggleNav = _props.toggleNav,
	          closeNav = _props.closeNav,
	          logout = _props.logout,
	          anonymousUser = _props.anonymousUser,
	          updateUser = _props.updateUser;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Header2.default, {
	          path: location.pathname,
	          title: children.props.route.title,
	          toggleNav: toggleNav,
	          anonymousUser: anonymousUser,
	          previousPath: nav.previousPath,
	          canSearch: this.props.canSearch,
	          params: params
	        }),
	        children,
	        _react2.default.createElement(_Banners2.default, null),
	        _react2.default.createElement(_Navigation2.default, {
	          open: nav.open,
	          closeNav: closeNav,
	          logout: logout,
	          anonymousUser: anonymousUser,
	          user: user,
	          updateUser: updateUser
	        })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var nav = _ref.nav,
	      auth = _ref.auth;
	  return {
	    nav: nav,
	    user: auth.user,
	    anonymousUser: (0, _auth2.isAnonymous)(auth.user),
	    canSearch: (0, _auth2.userHasPerm)(auth.user, 'search_and_save')
	  };
	};
	
	var mapDispatchToProps = {
	  toggleNav: _nav.toggleNav,
	  closeNav: _nav.closeNav,
	  logout: _auth.logout,
	  updateUser: _users.updateUser
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Channels = __webpack_require__(852);
	
	var _Channels2 = _interopRequireDefault(_Channels);
	
	var _fetch = __webpack_require__(14);
	
	var _string = __webpack_require__(16);
	
	var _auth = __webpack_require__(20);
	
	var _images = __webpack_require__(23);
	
	var _queues = __webpack_require__(108);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Modal = __webpack_require__(49);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _UserChecklist = __webpack_require__(504);
	
	var _UserChecklist2 = _interopRequireDefault(_UserChecklist);
	
	var _ConfirmButtons = __webpack_require__(34);
	
	var _ConfirmButtons2 = _interopRequireDefault(_ConfirmButtons);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _ShareButton = __webpack_require__(201);
	
	var _ShareButton2 = _interopRequireDefault(_ShareButton);
	
	var _DropMenu = __webpack_require__(148);
	
	var _DropMenu2 = _interopRequireDefault(_DropMenu);
	
	var _Toggle = __webpack_require__(203);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _ChannelInfo = __webpack_require__(309);
	
	var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);
	
	var _ChannelTabs = __webpack_require__(513);
	
	var _ChannelTabs2 = _interopRequireDefault(_ChannelTabs);
	
	var _EmptyNotice = __webpack_require__(127);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Channels = function (_Component) {
	  _inherits(Channels, _Component);
	
	  function Channels() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Channels);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Channels.__proto__ || Object.getPrototypeOf(Channels)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      channels: null,
	      channelsError: null,
	      shareChannel: null,
	      usersChecked: null,
	      renameChannel: null,
	      editChannelQueue: null,
	      fetching: false,
	      showCreateChannelModal: false,
	      showInfo: null,
	      addingQueueToChannel: false
	    }, _this.fetchChannels = function () {
	      _this.setState({
	        channelsError: null,
	        fetching: true
	      });
	      _this.props.fetchChannels(_this.props.dispatch).then(function (data) {
	        _this.setState({
	          channels: data.channels,
	          fetching: false
	        });
	      }, function (e) {
	        _this.setState({
	          channelsError: e,
	          fetching: false
	        });
	      });
	    }, _this.updateEntireChannel = function (channel) {
	      var index = _this.state.channels.findIndex(function (c) {
	        return c.id === channel.id;
	      });
	      _this.setState({
	        channels: [].concat(_toConsumableArray(_this.state.channels.slice(0, index)), [channel], _toConsumableArray(_this.state.channels.slice(index + 1)))
	      });
	    }, _this.updateChannel = function (id, key, value, deep) {
	      var channels = _this.state.channels.slice(0);
	      var index = channels.findIndex(function (c) {
	        return c.id === id;
	      });
	      if (typeof deep !== 'undefined') {
	        if (!channels[index][key]) {
	          channels[index][key] = {};
	        }
	        channels[index][key][value] = deep;
	      } else {
	        channels[index][key] = value;
	      }
	      _this.setState({ channels: channels });
	    }, _this.updateChannelData = function (id, key, value) {
	      if (key === 'time_offset' && value === 'device') {
	        // Use device offset
	        value = new Date().getTimezoneOffset() * -60;
	      }
	      _this.updateChannel(id, 'data', key, value); // Update local state
	      _this.props.updateChannel(id, _defineProperty({}, key, value)); // Send update to picasso
	    }, _this.onClickDeleteChannel = function (id, mine) {
	      if (window.confirm('Are you sure you want to ' + (mine ? 'delete' : 'remove') + ' this channel?') === false) {
	        return;
	      }
	      var _this$props = _this.props,
	          deleteChannel = _this$props.deleteChannel,
	          channelAction = _this$props.channelAction;
	
	      if (mine) {
	        deleteChannel(id);
	      } else {
	        channelAction(id, 'unshare_user');
	      }
	      _this.setState({
	        channels: _this.state.channels.filter(function (c) {
	          return c.id !== id;
	        })
	      });
	    }, _this.onSubmitCreateChannel = function (e) {
	      e.preventDefault();
	      _this.setState({ creatingChannel: true });
	      var name = _this.refs.name.value;
	      var queueID = _this.refs.createChannelQueue.value;
	      _this.props.createChannel(name, queueID).then(function (data) {
	        _this.setState({
	          channels: [].concat(_toConsumableArray(_this.state.channels), [data.channel]),
	          creatingChannel: false,
	          showCreateChannelModal: false
	        });
	      });
	    }, _this.onSubmitRenameChannel = function (e) {
	      e.preventDefault();
	      var id = _this.state.renameChannel;
	      var name = _this.refs.rename.value;
	      _this.props.renameChannel(id, name);
	      _this.updateChannel(id, 'name', name);
	      _this.setState({ renameChannel: null });
	    }, _this.onConfirmShareChannel = function () {
	      var _this$state = _this.state,
	          shareChannel = _this$state.shareChannel,
	          usersChecked = _this$state.usersChecked;
	
	      _this.props.updateChannel(shareChannel.id, { members: usersChecked });
	      _this.updateChannel(shareChannel.id, 'members', usersChecked);
	      _this.setState({
	        shareChannel: null,
	        usersChecked: null
	      });
	    }, _this.onClickShareChannel = function (channel) {
	      _this.setState({
	        shareChannel: channel,
	        usersChecked: channel.data ? channel.members.map(function (s) {
	          return parseInt(s);
	        }) : []
	      });
	    }, _this.addQueueToChannel = function (channelID, queueID) {
	      _this.setState({ addingQueueToChannel: true });
	      _this.getLocation().then(function (position) {
	        return _this.props.sendQueueToChannel(channelID, queueID, position);
	      }).then(function (data) {
	        _this.setState({
	          addingQueueToChannel: false,
	          editChannelQueue: null
	        });
	        _this.updateEntireChannel(data.channel);
	      }, function () {
	        _this.setState({ addingQueueToChannel: false, editChannelQueue: null });
	        window.alert('There was an error adding to the channel');
	      });
	    }, _this.onClickToggleChannelEnabled = function (channel) {
	      if (channel.disabled) {
	        _this.props.enableChannel(channel.id);
	        _this.updateChannel(channel.id, 'disabled', false);
	      } else {
	        _this.props.disableChannel(channel.id);
	        _this.updateChannel(channel.id, 'disabled', true);
	      }
	    }, _this.onClickClearPlayNow = function (id) {
	      _this.props.channelAction(id, '`clear_queue_externals`', { origin: 'play_now' });
	      _this.updateChannel(id, 'external_count', 'play_now', 0);
	    }, _this.onClickClearPlayNext = function (id) {
	      _this.props.channelAction(id, '`clear_queue_externals`', { origin: 'play_next' });
	      _this.updateChannel(id, 'external_count', 'play_next', 0);
	    }, _this.onClickResetChannel = function (id) {
	      _this.props.channelAction(id, 'reset_queue').then(function (data) {
	        _this.updateEntireChannel(data.channel);
	      });
	      _this.setState({
	        showInfo: null
	      });
	    }, _this.onToggleSkip = function (channel, id) {
	      _this.props.channelAction(channel.id, 'skip_album', { album_id: id }).then(function (data) {
	        _this.updateEntireChannel(data.channel);
	      });
	    }, _this.onToggleUnskip = function (channel, id) {
	      _this.props.channelAction(channel.id, 'unmute_album', { album_id: id }).then(function (data) {
	        _this.updateEntireChannel(data.channel);
	      });
	    }, _this.getPlayingNow = function (channel) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = channel.data.playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var playlist = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = playlist.albums[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var album = _step2.value;
	
	              if (album._state === 'playing' || album._state === 'paused') {
	                return album.name;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return 'None';
	    }, _this.getPlayingNext = function (channel) {
	      if (!channel || !channel.data || !channel.data.playlists) {
	        return null;
	      }
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = channel.data.playlists[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var playlist = _step3.value;
	          var _iteratorNormalCompletion4 = true;
	          var _didIteratorError4 = false;
	          var _iteratorError4 = undefined;
	
	          try {
	            for (var _iterator4 = playlist.albums[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	              var album = _step4.value;
	
	              if (album._state === 'present' || album._state === 'external') {
	                return album.name;
	              }
	            }
	          } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	              }
	            } finally {
	              if (_didIteratorError4) {
	                throw _iteratorError4;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return null;
	    }, _this.renderChannel = function (channel) {
	      var _this$state2 = _this.state,
	          renameChannel = _this$state2.renameChannel,
	          editChannelQueue = _this$state2.editChannelQueue;
	
	
	      var mine = _this.props.me.id === parseInt(channel.owner_id);
	      var owner = _this.props.getOwner(channel);
	
	      if (!_this.props.canCreateChannels && mine) {
	        // Do not display own channels for users who cannot create them
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { key: channel.id, className: _Channels2.default.channel },
	        renameChannel !== channel.id && _this.renderTools(channel, mine),
	        renameChannel === channel.id ? _this.renderRenameForm(channel) : _this.renderChannelName(channel, mine, owner),
	        _react2.default.createElement(_ChannelTabs2.default, {
	          channel: channel,
	          updateData: function updateData(key, value) {
	            return _this.updateChannelData(channel.id, key, value);
	          },
	          mine: mine,
	          clients: channel.clients || [],
	          onClickShare: function onClickShare(e) {
	            e.preventDefault();
	            _this.onClickShareChannel(channel);
	          }
	        }),
	        _this.renderChannelQueue(channel, mine),
	        editChannelQueue !== channel.id && _this.renderControls(channel, mine)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Channels, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var channels = this.state.channels;
	
	      if (!channels) {
	        this.fetchChannels();
	      }
	      var _props = this.props,
	          queues = _props.queues,
	          fetchQueues = _props.fetchQueues;
	
	      if (!queues) {
	        fetchQueues(this.props.dispatch);
	      }
	    }
	  }, {
	    key: 'getLocation',
	    value: function getLocation() {
	      if (!window.navigator.geolocation) {
	        return Promise.resolve({});
	      }
	      return new Promise(function (resolve) {
	        window.navigator.geolocation.getCurrentPosition(function (location) {
	          resolve({
	            lat: location.coords.latitude,
	            lon: location.coords.longitude
	          });
	        }, function () {
	          return resolve({});
	        });
	      });
	    }
	  }, {
	    key: 'renderChannelName',
	    value: function renderChannelName(channel, mine, owner) {
	      var _this2 = this;
	
	      var shared = !mine && owner ? _react2.default.createElement(
	        'span',
	        null,
	        ' shared by ',
	        owner.name
	      ) : null;
	      var stopped = !channel.data || channel.data._state === 'stopped';
	      var onClickStop = function onClickStop() {
	        _this2.props.channelAction(channel.id, 'deactivate_channel');
	        _this2.updateChannel(channel.id, 'data', '_state', 'stopped');
	      };
	      var onClickPlay = function onClickPlay() {
	        _this2.props.channelAction(channel.id, 'activate_channel');
	        _this2.updateChannel(channel.id, 'data', '_state', 'playing');
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.channelName },
	          channel.name,
	          shared,
	          mine && _react2.default.createElement(
	            'button',
	            { onClick: stopped ? onClickPlay : onClickStop, className: _Channels2.default.channelToggle },
	            _react2.default.createElement(_Toggle2.default, { value: !stopped }),
	            ' Channel ',
	            stopped ? 'off' : 'on'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderControls',
	    value: function renderControls(channel, mine) {
	      var _this3 = this;
	
	      var onClick = function onClick(event, newState) {
	        if (['play_next_album', 'play_queue', 'pause_queue'].indexOf(event) !== -1) {
	          _this3.props.channelAction(channel.id, event);
	        } else {
	          _this3.props.channelEvent(channel.id, event);
	        }
	        if (newState) {
	          _this3.updateChannel(channel.id, 'data', '_state', newState);
	        }
	      };
	      var controlsDisabled = !channel.data || !channel.data._state || channel.data._state === 'stopped';
	      var controlClass = controlsDisabled ? _Channels2.default.controlDisabled : _Channels2.default.control;
	
	      var progressWidth = 0;
	      if (channel.progress) {
	        var played = channel.progress.duration_played;
	        var total = channel.progress.duration;
	        progressWidth = Math.round(played / total * 100);
	      }
	
	      var looped = channel.data && channel.data.loop;
	
	      var renderControl = function renderControl(icon, onClick) {
	        var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	        return _react2.default.createElement(
	          'button',
	          { onClick: onClick, className: controlClass },
	          _react2.default.createElement(_Icon2.default, { icon: icon, size: size }),
	          icon === 'restart' && _react2.default.createElement(
	            'div',
	            null,
	            'Reset'
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Channels2.default.controls },
	        _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.progressWrapper },
	          _react2.default.createElement('div', { className: _Channels2.default.progressBar, style: { width: Math.min(100, progressWidth) + '%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.controlButtons },
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this3.onClickResetChannel(channel.id);
	              }, className: _Channels2.default.control, disabled: !mine },
	            _react2.default.createElement(_Icon2.default, { icon: 'restart', size: 16 }),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Reset'
	            )
	          ),
	          renderControl('skip-back', function () {
	            return onClick('prev');
	          }),
	          renderControl('rewind', function () {
	            return onClick('prev-image');
	          }),
	          channel.data && channel.data._state === 'paused' ? renderControl('play', function () {
	            return onClick('play_queue', 'playing');
	          }) : renderControl('pause', function () {
	            return onClick('pause_queue', 'paused');
	          }),
	          renderControl('forward', function () {
	            return onClick('next-image');
	          }),
	          renderControl('skip', function () {
	            return onClick('play_next_album');
	          }),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this3.updateChannelData(channel.id, 'loop', !looped);
	              }, className: looped ? _Channels2.default.controlActive : _Channels2.default.control, disabled: !mine },
	            _react2.default.createElement(_Icon2.default, { icon: 'loop', size: 16 }),
	            _react2.default.createElement(
	              'div',
	              null,
	              looped ? 'Looped' : 'Loop'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRenameForm',
	    value: function renderRenameForm(channel) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: this.onSubmitRenameChannel },
	        _react2.default.createElement('input', {
	          ref: 'rename',
	          type: 'text',
	          defaultValue: channel.name,
	          placeholder: 'New channel name',
	          className: _Channels2.default.renameInput,
	          autoFocus: true
	        }),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: _Channels2.default.cancelButton,
	            onClick: function onClick() {
	              return _this4.setState({ renameChannel: null });
	            }
	          },
	          'Cancel'
	        ),
	        _react2.default.createElement('input', {
	          type: 'submit',
	          value: 'Rename',
	          className: _Channels2.default.renameButton
	        })
	      );
	    }
	  }, {
	    key: 'renderTools',
	    value: function renderTools(channel, mine) {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Channels2.default.tools },
	        _react2.default.createElement(
	          'button',
	          { key: 'dots', onClick: function onClick() {
	              return _this5.setState({ dropMenuOpen: channel.id });
	            }, className: _Channels2.default.tool },
	          _react2.default.createElement(_Icon2.default, { icon: 'dots' })
	        ),
	        _react2.default.createElement(_DropMenu2.default, {
	          open: this.state.dropMenuOpen === channel.id,
	          closeMenu: function closeMenu() {
	            return _this5.setState({ dropMenuOpen: null });
	          },
	          style: { marginTop: '10px' },
	          items: [{
	            text: channel.disabled ? 'Enable Current Shares' : 'Disable Current Shares',
	            onClick: function onClick() {
	              return _this5.onClickToggleChannelEnabled(channel);
	            },
	            shouldShow: mine
	          }, {
	            text: 'Debug Channel',
	            href: '/present/' + channel.id + '?debug=1',
	            shouldShow: mine
	          }, {
	            text: 'Rename Channel',
	            onClick: function onClick() {
	              return _this5.setState({ renameChannel: channel.id });
	            },
	            shouldShow: mine
	          }, {
	            text: mine ? 'Delete Channel' : 'Remove Shared Channel',
	            onClick: function onClick() {
	              return _this5.onClickDeleteChannel(channel.id, mine);
	            }
	          }]
	        })
	      );
	    }
	  }, {
	    key: 'renderChannelQueue',
	    value: function renderChannelQueue(channel, mine) {
	      var _this6 = this;
	
	      var _state = this.state,
	          editChannelQueue = _state.editChannelQueue,
	          addingQueueToChannel = _state.addingQueueToChannel;
	
	      var onAddQueue = function onAddQueue(e) {
	        return _this6.addQueueToChannel(channel.id, _this6.refs.queue.value);
	      };
	      var onClickChangeQueue = function onClickChangeQueue() {
	        _this6.setState({ editChannelQueue: channel.id }, function () {
	          if (channel.data) {
	            _this6.refs.queue.value = channel.data.id;
	          }
	        });
	      };
	      var onClickCancel = function onClickCancel() {
	        return _this6.setState({ editChannelQueue: null });
	      };
	      var onClickClear = function onClickClear() {
	        if (window.confirm('Are you sure you want to clear this channel?')) {
	          _this6.props.channelAction(channel.id, 'remove_queue');
	          _this6.updateChannel(channel.id, 'data', undefined);
	          _this6.updateChannel(channel.id, 'progress', undefined);
	        }
	      };
	      var hasQueue = channel.data && channel.data._id;
	      var infoOpen = this.state.showInfo === channel.id;
	      var upNext = channel.data && this.getPlayingNext(channel);
	      var nowPlayingText = channel.state === 'playing' ? 'Now playing' : 'Currently paused';
	      return _react2.default.createElement(
	        'div',
	        null,
	        editChannelQueue !== channel.id && !hasQueue && _react2.default.createElement(
	          'button',
	          { className: _Channels2.default.addQueueButton, onClick: onClickChangeQueue, disabled: !mine },
	          mine ? 'Add Queue' : 'No Queue'
	        ),
	        editChannelQueue !== channel.id && hasQueue && _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.channelQueue },
	          _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.channelQueueName },
	            channel.data.name || channel.name
	          ),
	          channel.progress && _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.channelQueueDuration },
	            (0, _string.pluralize)(channel.progress.total_images, 'image'),
	            ', ',
	            (0, _string.formatMinutes)(channel.progress.duration / 60),
	            _react2.default.createElement('br', { className: _Channels2.default.linkButtonLineBreak }),
	            mine && channel.data && channel.data.id && _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/queues/' + channel.data.id, className: _Channels2.default.linkButton },
	              'Edit Queue'
	            )
	          ),
	          channel.data && channel.data.playlists && this.state.showInfo !== channel.id && _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.playingNow },
	            nowPlayingText,
	            ': ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              this.getPlayingNow(channel)
	            ),
	            _react2.default.createElement('br', null),
	            upNext && _react2.default.createElement(
	              'span',
	              null,
	              'Up next: ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                this.getPlayingNext(channel)
	              )
	            )
	          ),
	          infoOpen && _react2.default.createElement(_ChannelInfo2.default, {
	            data: channel.queue,
	            conflicts: [],
	            onSkip: function onSkip(e) {
	              return _this6.onToggleSkip(channel, e.target.value);
	            },
	            onUnskip: function onUnskip(e) {
	              return _this6.onToggleUnskip(channel, e.target.value);
	            },
	            getImageSource: this.props.getImageSource,
	            isOwner: mine
	          }),
	          channel.data && channel.data.name && _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.channelQueueTopRight },
	            mine && _react2.default.createElement(
	              'button',
	              { onClick: onClickClear, className: _Channels2.default.iconButton, disabled: infoOpen },
	              _react2.default.createElement(_Icon2.default, { icon: 'close' })
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'button',
	              { className: _Channels2.default.linkButton, onClick: function onClick() {
	                  return _this6.setState({ showInfo: infoOpen ? null : channel.id });
	                } },
	              infoOpen ? 'Hide Info' : 'Show Info'
	            )
	          ),
	          mine && _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.channelQueueBottomRight },
	            channel.progress && _react2.default.createElement(
	              'div',
	              { className: _Channels2.default.timeRemaining },
	              (0, _string.formatMinutes)((channel.progress.duration - channel.progress.duration_played) / 60).replace('minute', 'min'),
	              ' remaining'
	            )
	          )
	        ),
	        editChannelQueue === channel.id && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'select',
	            { ref: 'queue', className: _Channels2.default.addQueueSelect, defaultValue: '' },
	            _react2.default.createElement(
	              'option',
	              { disabled: true, value: '' },
	              'Choose a queue'
	            ),
	            this.props.queues.map(function (queue) {
	              return _react2.default.createElement(
	                'option',
	                { key: queue.id, value: queue.id },
	                queue.name
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: onClickCancel, className: _Channels2.default.cancelButton },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: onAddQueue, disabled: addingQueueToChannel, className: _Channels2.default.renameButton },
	            addingQueueToChannel ? 'Updating…' : 'Update'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderShareModal',
	    value: function renderShareModal(channel) {
	      var _this7 = this;
	
	      var clients = channel.clients || [];
	      var usersChecked = this.state.usersChecked;
	
	      var myClients = clients.filter(function (c) {
	        return parseInt(c.user_id) === _this7.props.me.id;
	      });
	      var getExtra = function getExtra(id) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          clients.filter(function (c) {
	            return parseInt(c.user_id) === id;
	          }).map(renderClient)
	        );
	      };
	      var onGeneratePublic = function onGeneratePublic() {
	        if (_this7.state.usersChecked.indexOf(0) === -1) {
	          _this7.setState({
	            usersChecked: _this7.state.usersChecked.concat(0)
	          });
	        }
	      };
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: 'Share Channel' },
	        _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.page },
	          myClients.length !== 0 && _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.heading },
	            'Your clients viewing ',
	            channel.name
	          ),
	          myClients.map(renderClient),
	          myClients.length !== 0 && _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this7.onClickToggleChannelEnabled(channel);
	              }, className: _Channels2.default.disableToggle },
	            _react2.default.createElement(_Toggle2.default, { value: channel.disabled }),
	            channel.disabled ? ' Channel shares disabled' : 'Temporarily disable channel shares'
	          ),
	          _react2.default.createElement(_UserChecklist2.default, {
	            value: usersChecked,
	            onChange: function onChange(users) {
	              return _this7.setState({ usersChecked: users });
	            },
	            getExtra: getExtra,
	            showExternalUsers: true,
	            channelUsersOnly: true,
	            appendToExternal: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_ShareButton2.default, {
	                style: { textAlign: 'left' },
	                path: '/present/' + channel.id,
	                hideDownloadToggle: true,
	                onFetch: onGeneratePublic,
	                allowPrivileged: true
	              })
	            ),
	            externalSubtitle: 'Anyone with a public link will have access to the channel'
	          }),
	          _react2.default.createElement(_ConfirmButtons2.default, {
	            onConfirm: this.onConfirmShareChannel,
	            onCancel: function onCancel() {
	              return _this7.setState({ shareChannel: null, usersChecked: null });
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderCreateModal',
	    value: function renderCreateModal() {
	      var _this8 = this;
	
	      var queues = this.props.queues;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        { title: 'Create Channel', onClose: function onClose() {
	            return _this8.setState({ showCreateChannelModal: false });
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: _Channels2.default.page },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.onSubmitCreateChannel },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Name',
	              _react2.default.createElement('input', {
	                ref: 'name',
	                type: 'text',
	                placeholder: 'eg My Photo Frame',
	                className: _Channels2.default.createInput,
	                required: true
	              })
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Queue',
	              _react2.default.createElement(
	                'select',
	                { ref: 'createChannelQueue', defaultValue: '' },
	                _react2.default.createElement(
	                  'option',
	                  { disabled: true, value: '' },
	                  'Choose a queue'
	                ),
	                queues.map(function (queue) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: queue.id, value: queue.id },
	                    queue.name
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Channels2.default.buttons },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this8.setState({ showCreateChannelModal: false });
	                  },
	                  className: _Channels2.default.cancelButton },
	                'Cancel'
	              ),
	              _react2.default.createElement('input', {
	                type: 'submit',
	                value: this.state.creatingChannel ? 'Creating…' : 'Create',
	                className: _Channels2.default.createButton,
	                disabled: this.state.creatingChannel
	              })
	            )
	          ),
	          this.state.creatingChannel && _react2.default.createElement(_LoadingSpinner2.default, null)
	        )
	      );
	    }
	  }, {
	    key: 'renderEmpty',
	    value: function renderEmpty() {
	      if (this.props.canCreateChannels) {
	        return _react2.default.createElement(_EmptyNotice2.default, {
	          heading: 'Create channels of photo presentations to display on external screens',
	          text: 'Connect to photo frames, create URLs for others, and control them all here.'
	        });
	      }
	      return _react2.default.createElement(_EmptyNotice2.default, {
	        heading: 'Shared channels will appear here',
	        text: 'Here\u2019s where other users can present their images to you.'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props2 = this.props,
	          queues = _props2.queues,
	          canCreateChannels = _props2.canCreateChannels;
	      var _state2 = this.state,
	          channels = _state2.channels,
	          channelsError = _state2.channelsError,
	          shareChannel = _state2.shareChannel,
	          fetching = _state2.fetching;
	
	      if (channelsError) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching channels',
	          onRetry: this.fetchChannels
	        });
	      }
	      if (!queues || !channels) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      var myChannels = channels.filter(function (c) {
	        return _this9.props.me.id === parseFloat(c.owner_id);
	      });
	      var sharedChannels = channels.filter(function (c) {
	        return _this9.props.me.id !== parseFloat(c.owner_id);
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: _Channels2.default.page },
	        channels.length === 0 && this.renderEmpty(),
	        canCreateChannels && _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return _this9.setState({ showCreateChannelModal: true });
	            }, className: _Channels2.default.addButton },
	          'Create new channel'
	        ),
	        myChannels.length !== 0 && _react2.default.createElement(
	          'ul',
	          null,
	          myChannels.map(this.renderChannel)
	        ),
	        sharedChannels.length !== 0 && _react2.default.createElement(
	          'h2',
	          null,
	          'Channels shared with me'
	        ),
	        sharedChannels.length !== 0 && _react2.default.createElement(
	          'ul',
	          null,
	          sharedChannels.map(this.renderChannel)
	        ),
	        myChannels.length !== 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Channels2.default.heading },
	            'Notes'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: _Channels2.default.notes },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Playing a stopped channel will immediately start presenting the queue to all connected clients'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Stopping a channel will pause the queue until a channel is played again'
	            )
	          )
	        ),
	        channels.length !== 0 && _react2.default.createElement(
	          'button',
	          { onClick: this.fetchChannels, className: _Channels2.default.refreshButton },
	          fetching ? 'Refreshing…' : 'Refresh channels'
	        ),
	        shareChannel && this.renderShareModal(shareChannel),
	        this.state.showCreateChannelModal && this.renderCreateModal()
	      );
	    }
	  }]);
	
	  return Channels;
	}(_react.Component);
	
	function renderClient(client) {
	  return _react2.default.createElement(
	    'div',
	    { className: _Channels2.default.client },
	    client.os,
	    ' - ',
	    client.browser
	  );
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var queues = _ref2.queues,
	      entities = _ref2.entities,
	      auth = _ref2.auth;
	  return {
	    entities: entities,
	    me: auth.user,
	    queues: queues.data && queues.data.map(function (id) {
	      return entities.queues[id];
	    }),
	    canCreateChannels: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    fetchQueues: function fetchQueues(dispatch) {
	      return dispatch((0, _queues.fetchQueues)());
	    },
	    fetchChannels: function fetchChannels(dispatch) {
	      return (0, _fetch.picassoFetch)(auth, 'list_channels', undefined, dispatch);
	    },
	    createChannel: function createChannel(name, queueID) {
	      return (0, _fetch.picassoFetch)(auth, 'create_channel', {
	        name: name,
	        queue_id: queueID || undefined,
	        time_offset: new Date().getTimezoneOffset() * -60
	      });
	    },
	    deleteChannel: function deleteChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'remove_channel', { channel_id: id });
	    },
	    sendQueueToChannel: function sendQueueToChannel(channelID, queueID, position) {
	      return (0, _fetch.picassoFetch)(auth, 'set_queue', {
	        channel_id: channelID,
	        queue_id: queueID,
	        location: position.lat ? position.lat + ',' + position.lon : undefined,
	        time_offset: new Date().getTimezoneOffset() * -60
	      });
	    },
	    renameChannel: function renameChannel(id, name) {
	      return (0, _fetch.picassoFetch)(auth, 'rename_channel', {
	        channel_id: id,
	        name: name
	      });
	    },
	    updateChannel: function updateChannel(id, values) {
	      return (0, _fetch.picassoFetch)(auth, 'update_channel', {
	        channel_id: id,
	        update: values
	      });
	    },
	    channelAction: function channelAction(id, action, extra) {
	      return (0, _fetch.picassoFetch)(auth, action, _extends({ channel_id: id }, extra));
	    },
	    channelEvent: function channelEvent(id, event) {
	      return (0, _fetch.picassoFetch)(auth, 'send_event', { channel_id: id, event: event });
	    },
	    disableChannel: function disableChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'disable_channel', { channel_id: id });
	    },
	    enableChannel: function enableChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'enable_channel', { channel_id: id });
	    },
	    getOwner: function getOwner(channel) {
	      return entities.users[channel.owner_id];
	    },
	    getImageSource: (0, _images.createImageGetter)(auth)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Channels);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _DynamicLinks = __webpack_require__(853);
	
	var _DynamicLinks2 = _interopRequireDefault(_DynamicLinks);
	
	var _dynlinks = __webpack_require__(154);
	
	var _search = __webpack_require__(59);
	
	var _keywords = __webpack_require__(107);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EditDynamicLink = __webpack_require__(521);
	
	var _EditDynamicLink2 = _interopRequireDefault(_EditDynamicLink);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _string = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DynamicLinks = function (_Component) {
	  _inherits(DynamicLinks, _Component);
	
	  function DynamicLinks() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DynamicLinks);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DynamicLinks.__proto__ || Object.getPrototypeOf(DynamicLinks)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      creatingTable: false,
	      createdTables: [],
	      creating: false,
	      editing: null,
	      useDates: false,
	      useWeather: false
	    }, _this.saveDynamicLink = function (_ref2) {
	      var type = _ref2.type,
	          condition = _ref2.condition,
	          keywords = _ref2.keywords;
	      var saveDynamicLink = _this.props.saveDynamicLink;
	      var _this$state = _this.state,
	          creating = _this$state.creating,
	          editing = _this$state.editing;
	
	      var id = creating ? undefined : editing.id;
	      var link = {
	        type: type,
	        condition: condition,
	        keywords: JSON.stringify(keywords.keywords)
	      };
	      return saveDynamicLink(link, id).then(_this.closeEditForm);
	    }, _this.closeEditForm = function () {
	      _this.setState({
	        creating: false,
	        editing: null
	      });
	    }, _this.onCreateTable = function (e) {
	      e.preventDefault();
	      _this.setState({
	        creatingTable: false,
	        createdTables: [e.target.elements.name.value].concat(_this.state.createdTables)
	      });
	    }, _this.getInitialValues = function () {
	      var _this$state2 = _this.state,
	          creating = _this$state2.creating,
	          editing = _this$state2.editing;
	
	      if (editing) {
	        return _extends({}, editing, {
	          keywords: {
	            search: '',
	            keywords: JSON.parse(editing.keywords)
	          }
	        });
	      }
	      return {
	        type: typeof creating === 'string' ? creating : ''
	      };
	    }, _this.sortTables = function (a, b) {
	      if (a.length === 0 && b.length === 0) return 0;
	      if (a.length === 0 && b.length !== 0) return -1;
	      if (a.length !== 0 && b.length === 0) return 1;
	      var earliestA = Math.min.apply(Math, _toConsumableArray(a.map(function (d) {
	        return new Date(d.created_at);
	      })));
	      var earliestB = Math.min.apply(Math, _toConsumableArray(b.map(function (d) {
	        return new Date(d.created_at);
	      })));
	      return earliestA < earliestB ? 1 : -1;
	    }, _this.getKeywordName = function (id) {
	      var keywordMap = _this.props.keywordMap;
	
	      return keywordMap[id] ? keywordMap[id].name : 'Unknown Keyword';
	    }, _this.getKeywordGroup = function (id) {
	      var keywordMap = _this.props.keywordMap;
	
	      return keywordMap[id] ? keywordMap[id].top_parent_name || keywordMap[id].name : 'Unknown';
	    }, _this.renderDynamicLink = function (link) {
	      var deleteDynamicLink = _this.props.deleteDynamicLink;
	
	      var onEdit = function onEdit() {
	        return _this.setState({
	          creatingTable: false,
	          editing: link,
	          useDates: !(0, _string.isWeather)(link.condition),
	          useWeather: (0, _string.isWeather)(link.condition)
	        });
	      };
	      var onDelete = function onDelete() {
	        if (window.confirm('Are you sure you want to delete this dynamic link?')) {
	          deleteDynamicLink(link.id);
	        }
	      };
	      return _react2.default.createElement(
	        'tr',
	        { key: link.id },
	        _react2.default.createElement(
	          'td',
	          { className: _DynamicLinks2.default.condition },
	          link.condition
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: _DynamicLinks2.default.keywords },
	          JSON.parse(link.keywords).map(_this.getKeywordName).join(', ')
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: _DynamicLinks2.default.tools },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onEdit,
	              className: _DynamicLinks2.default.iconButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'edit', size: 16 })
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onDelete,
	              className: _DynamicLinks2.default.iconButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'close' })
	          )
	        )
	      );
	    }, _this.renderTable = function (type, links) {
	      var onClickAdd = function onClickAdd() {
	        _this.setState({
	          creatingTable: false,
	          creating: type,
	          useDates: links.length === 0 || !(0, _string.isWeather)(links[0].condition),
	          useWeather: links.length !== 0 && (0, _string.isWeather)(links[0].condition)
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        { key: type },
	        _react2.default.createElement(
	          'h2',
	          null,
	          type,
	          ' Table'
	        ),
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            links.map(_this.renderDynamicLink)
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: onClickAdd, className: _DynamicLinks2.default.addAnotherButton },
	          '+ Add condition'
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DynamicLinks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          fetchDynamicLinks = _props.fetchDynamicLinks,
	          keywords = _props.keywords,
	          fetchSearchOptions = _props.fetchSearchOptions;
	
	      if (!data) fetchDynamicLinks();
	      if (!keywords) fetchSearchOptions();
	      if (this.props.shouldFetchGraph) this.props.fetchKeywordGraph();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchDynamicLinks = _props2.fetchDynamicLinks,
	          keywordArray = _props2.keywordArray;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching dynamic links',
	          onRetry: fetchDynamicLinks
	        });
	      }
	
	      if (!data || !keywordArray || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var _state = this.state,
	          creatingTable = _state.creatingTable,
	          createdTables = _state.createdTables,
	          creating = _state.creating,
	          editing = _state.editing,
	          useDates = _state.useDates,
	          useWeather = _state.useWeather;
	
	
	      var types = data.reduce(function (types, link) {
	        types[link.type] = types[link.type] || [];
	        types[link.type].push(link);
	        return types;
	      }, {});
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = createdTables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var name = _step.value;
	
	          types[name] = types[name] || [];
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _DynamicLinks2.default.page },
	        _react2.default.createElement(
	          'p',
	          { className: _DynamicLinks2.default.intro },
	          'You can create albums that change dynamically based on certain variables, like date and weather.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _DynamicLinks2.default.intro },
	          'These dynamic tables are used by dynamic albums to set up all the conditions.'
	        ),
	        !creatingTable && _react2.default.createElement(
	          'button',
	          { className: _DynamicLinks2.default.createButton, onClick: function onClick() {
	              return _this2.setState({ creatingTable: true });
	            } },
	          'Create New Dynamic Table'
	        ),
	        creatingTable && _react2.default.createElement(
	          'form',
	          { onSubmit: this.onCreateTable, className: _DynamicLinks2.default.createForm },
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'name',
	            placeholder: 'Enter a table name'
	          }),
	          _react2.default.createElement('input', { type: 'submit', value: 'Create', className: _DynamicLinks2.default.createSubmit })
	        ),
	        Object.keys(types).sort(function (a, b) {
	          return _this2.sortTables(types[a], types[b]);
	        }).map(function (type) {
	          return _this2.renderTable(type, types[type]);
	        }),
	        (editing || creating) && _react2.default.createElement(_EditDynamicLink2.default, {
	          title: creating ? 'Add Condition to Match' : 'Edit Condition to Match',
	          onSubmit: this.saveDynamicLink,
	          onCancel: this.closeEditForm,
	          initialValues: this.getInitialValues(),
	          types: Object.keys(types),
	          keywordArray: keywordArray,
	          useDates: useDates,
	          toggleUseDates: function toggleUseDates() {
	            return _this2.setState({ useDates: true, useWeather: false });
	          },
	          useWeather: useWeather,
	          toggleUseWeather: function toggleUseWeather() {
	            return _this2.setState({ useWeather: true, useDates: false });
	          },
	          getKeywordName: this.getKeywordName,
	          getKeywordGroup: this.getKeywordGroup
	        })
	      );
	    }
	  }]);
	
	  return DynamicLinks;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var dynlinks = _ref3.dynlinks,
	      search = _ref3.search,
	      keywords = _ref3.keywords,
	      entities = _ref3.entities;
	  return _extends({}, dynlinks, {
	    entities: entities,
	    fetching: dynlinks.fetching || keywords.graph.fetching,
	    keywordArray: search.options.keywordArray,
	    keywordMap: search.options.keywordMap,
	    shouldFetchGraph: !keywords.graph.data
	  });
	};
	
	var mapDispatchToProps = {
	  fetchDynamicLinks: _dynlinks.fetchDynamicLinks,
	  saveDynamicLink: _dynlinks.saveDynamicLink,
	  deleteDynamicLink: _dynlinks.deleteDynamicLink,
	  fetchSearchOptions: _search.fetchSearchOptions,
	  fetchKeywordGraph: _keywords.fetchKeywordGraph
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DynamicLinks);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Hierarchy = __webpack_require__(854);
	
	var _Hierarchy2 = _interopRequireDefault(_Hierarchy);
	
	var _hierarchy = __webpack_require__(129);
	
	var _InteractiveHierarchy = __webpack_require__(500);
	
	var _InteractiveHierarchy2 = _interopRequireDefault(_InteractiveHierarchy);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPECIAL_ALBUMS = [{
	  text: _constants.SPECIAL_ALBUM_PATH_TITLE['null'],
	  href: '/album',
	  query: {
	    path: 'null',
	    referrer: 'hierarchy'
	  }
	}, {
	  text: _constants.SPECIAL_ALBUM_PATH_TITLE['event:null'],
	  href: '/album',
	  query: {
	    path: 'event:null',
	    referrer: 'hierarchy'
	  }
	}, {
	  text: _constants.SPECIAL_ALBUM_PATH_TITLE['keyword:null'],
	  href: '/album',
	  query: {
	    path: 'keyword:null',
	    referrer: 'hierarchy'
	  }
	}];
	
	var Hierarchy = function (_Component) {
	  _inherits(Hierarchy, _Component);
	
	  function Hierarchy() {
	    _classCallCheck(this, Hierarchy);
	
	    return _possibleConstructorReturn(this, (Hierarchy.__proto__ || Object.getPrototypeOf(Hierarchy)).apply(this, arguments));
	  }
	
	  _createClass(Hierarchy, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          hierarchy = _props.hierarchy,
	          fetchHierarchy = _props.fetchHierarchy;
	
	      if (!hierarchy) {
	        fetchHierarchy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          hierarchy = _props2.hierarchy,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchHierarchy = _props2.fetchHierarchy;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching the hierarchy',
	          onRetry: fetchHierarchy
	        });
	      }
	
	      if (!hierarchy || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var full = this.props.full;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Hierarchy2.default.page },
	        _react2.default.createElement(_InteractiveHierarchy2.default, { hierarchy: hierarchy, prefix: '/COLLECTIONS' }),
	        full && _react2.default.createElement(
	          'div',
	          { className: _Hierarchy2.default.heading },
	          'Raw hierarchy'
	        ),
	        full && _react2.default.createElement(_InteractiveHierarchy2.default, { hierarchy: full, appendItems: SPECIAL_ALBUMS })
	      );
	    }
	  }]);
	
	  return Hierarchy;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var hierarchy = _ref.hierarchy,
	      auth = _ref.auth;
	  return {
	    hierarchy: hierarchy.data,
	    full: hierarchy.full,
	    expanded: hierarchy.expanded,
	    fetching: hierarchy.fetching,
	    error: hierarchy.error
	  };
	};
	
	var mapDispatchToProps = {
	  fetchHierarchy: _hierarchy.fetchHierarchy,
	  toggleExpanded: _hierarchy.toggleExpanded,
	  collapseAll: _hierarchy.collapseAll
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Hierarchy);

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _Home = __webpack_require__(855);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _images = __webpack_require__(23);
	
	var _lists = __webpack_require__(88);
	
	var _auth = __webpack_require__(20);
	
	var _albums = __webpack_require__(41);
	
	var _playlists = __webpack_require__(43);
	
	var _AlbumList = __webpack_require__(508);
	
	var _AlbumList2 = _interopRequireDefault(_AlbumList);
	
	var _Welcome = __webpack_require__(516);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _FeaturedAlbum = __webpack_require__(515);
	
	var _FeaturedAlbum2 = _interopRequireDefault(_FeaturedAlbum);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EmptyNotice = __webpack_require__(127);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cache = {
	  welcomeSeen: false
	};
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Home);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Home.__proto__ || Object.getPrototypeOf(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      welcomeSeen: cache.welcomeSeen
	    }, _this.onCloseWelcome = function () {
	      cache.welcomeSeen = true;
	    }, _this.renderCustomList = function (list) {
	      var structure = JSON.parse(list.json_data);
	      if (structure.playlistsOnly) {
	        return null;
	      }
	      return _this.renderList(list.name, list.albums, list.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Home, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          fetchAlbums = _props.fetchAlbums,
	          lists = _props.lists,
	          fetchPlaylists = _props.fetchPlaylists;
	
	      if (!data) {
	        fetchAlbums();
	      }
	      if (!lists) {
	        fetchPlaylists();
	      }
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(heading, albums, id) {
	      if (!albums || albums.length === 0) {
	        // No albums, but we still want to show when
	        // id is 'all' and user can search
	        if (!this.props.canSearch || id !== 'all') {
	          return null;
	        }
	      }
	      var href = '/group/' + id;
	      return [_react2.default.createElement(
	        'h2',
	        { key: 'heading', className: _Home2.default.heading },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: href },
	          heading
	        )
	      ), _react2.default.createElement(_AlbumList2.default, {
	        key: 'list',
	        albums: albums,
	        moreLink: href,
	        getImageSource: this.props.getImageSource,
	        getAlbumInfo: this.props.getAlbumInfo,
	        isFavourite: this.props.isFavourite,
	        viewAlbum: this.props.viewAlbum,
	        editAlbum: this.props.editAlbum,
	        showCreateAlbum: id === 'all'
	      })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          route = _props2.route,
	          mine = _props2.mine,
	          fetching = _props2.fetching,
	          lists = _props2.lists,
	          error = _props2.error,
	          fetchAlbums = _props2.fetchAlbums;
	
	
	      if (route.showFeaturedAlbum && (this.props.showWelcome || this.props.showWelcomeSharing) && !this.state.welcomeSeen) {
	        return _react2.default.createElement(_Welcome2.default, {
	          onClose: this.onCloseWelcome,
	          canSearch: this.props.canSearch,
	          canShare: this.props.canShare,
	          shareOnly: this.props.showWelcomeSharing
	        });
	      }
	
	      if (!mine || !lists || fetching) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Home2.default.loadingWrapper },
	          _react2.default.createElement(_LoadingSpinner2.default, null)
	        );
	      }
	
	      if (error) {
	        _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching the albums',
	          onRetry: fetchAlbums
	        });
	      }
	
	      var _props3 = this.props,
	          getImageSource = _props3.getImageSource,
	          shared = _props3.shared,
	          recent = _props3.recent,
	          favourites = _props3.favourites;
	
	
	      var noAlbums = arraysAreEmpty(lists, favourites, shared, mine, recent);
	      var albumsWithCovers = mine.filter(function (album) {
	        return album.cover;
	      });
	      var emptyHome = noAlbums && !this.props.canSearch;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        route.showFeaturedAlbum && albumsWithCovers.length !== 0 && _react2.default.createElement(_FeaturedAlbum2.default, {
	          albums: albumsWithCovers,
	          getImageSource: getImageSource
	        }),
	        route.showFeaturedAlbum && mine.length === 0 && _react2.default.createElement('div', { className: _Home2.default.fakeHeader }),
	        _react2.default.createElement(
	          'div',
	          { className: _Home2.default.page },
	          !emptyHome && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/groups', className: _Home2.default.editListsLink },
	            'Manage album groups'
	          ),
	          !emptyHome && _react2.default.createElement(
	            'h1',
	            { className: _Home2.default.title },
	            'Albums'
	          ),
	          emptyHome && _react2.default.createElement(_EmptyNotice2.default, {
	            heading: 'Shared albums will appear here',
	            text: 'Albums will appear here when other users share with you.'
	          }),
	          lists.map(this.renderCustomList),
	          this.renderList('Favourites', favourites, 'favourites'),
	          this.renderList('Shared with me', shared, 'shared'),
	          this.renderList('Recent', recent, 'recent'),
	          this.renderList('All albums', mine, 'all')
	        )
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var albums = _ref2.albums,
	      playlists = _ref2.playlists,
	      entities = _ref2.entities,
	      auth = _ref2.auth,
	      nav = _ref2.nav;
	
	  var fromLogin = nav.previousPath === '/login';
	  var denormalize = function denormalize(id) {
	    return entities.albums[id];
	  };
	  var all = (albums.all.data || []).map(denormalize);
	  var mine = all.filter(function (a) {
	    return a.user_id === auth.user.id;
	  }).filter(filterAlbum);
	  var sharedImages = mine.filter(function (a) {
	    return a.image_share;
	  });
	  var favouriteImages = mine.filter(function (a) {
	    return a.favourite;
	  });
	  var daysSinceLastLogin = auth.user.last_login && (new Date() - new Date(auth.user.last_login)) / 1000 / 60 / 60 / 24;
	  return {
	    data: albums.all.data,
	    mine: mine,
	    shared: sharedImages.concat(all.filter(function (a) {
	      return a.user_id !== auth.user.id;
	    })),
	    recent: all.filter(filterAlbum).filter(filterRecent).sort(sortRecent),
	    favourites: favouriteImages.concat((albums.favourites.data || []).map(denormalize)),
	    fetching: albums.all.fetching || albums.favourites.fetching || playlists.fetching,
	    error: albums.all.error || albums.favourites.error,
	    getImageSource: (0, _images.createImageGetter)(auth),
	    lists: (0, _lists.mapStateToLists)(playlists, entities),
	    isFavourite: function isFavourite(id) {
	      return (albums.favourites.data || []).indexOf(id) !== -1;
	    },
	    canSearch: (0, _auth.userHasPerm)(auth.user, 'search_and_save'),
	    canShare: (0, _auth.userHasPerm)(auth.user, 'internal_share') || (0, _auth.userHasPerm)(auth.user, 'external_share'),
	    getAlbumInfo: function getAlbumInfo(album) {
	      if (album.user_id === auth.user.id || !entities.users[album.user_id]) return null;
	      var user = entities.users[album.user_id];
	      return 'by ' + user.name;
	    },
	    showWelcome: fromLogin && auth.user.count_login <= 3 || daysSinceLastLogin > 30,
	    showWelcomeSharing: fromLogin && auth.user.count_login > 0 && auth.user.count_login % 20 === 0
	  };
	};
	
	function filterAlbum(album) {
	  if (album.image_share || album.favourite) {
	    return JSON.parse(album.json_data).include.length !== 0;
	  }
	  return true;
	}
	
	function filterRecent(album) {
	  var date = new Date();
	  date.setDate(date.getDate() - 7);
	  return new Date(album.created_at) > date || new Date(album.updated_at) > date;
	}
	
	function sortRecent(a, b) {
	  a = a.updated_at || a.created_at;
	  b = b.updated_at || b.created_at;
	  return new Date(b) - new Date(a);
	}
	
	function arraysAreEmpty() {
	  for (var _len2 = arguments.length, arrays = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    arrays[_key2] = arguments[_key2];
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = arrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var array = _step.value;
	
	      if (array.length !== 0) {
	        return false;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return true;
	}
	
	var mapDispatchToProps = {
	  fetchAlbums: _albums.fetchAlbums,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  viewAlbum: function viewAlbum(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/album/' + id));
	    };
	  },
	  editAlbum: function editAlbum(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/album/' + id + '/edit'));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _auth = __webpack_require__(20);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinOrchestra = function (_Component) {
	  _inherits(JoinOrchestra, _Component);
	
	  function JoinOrchestra() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinOrchestra);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinOrchestra.__proto__ || Object.getPrototypeOf(JoinOrchestra)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinOrchestra, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          shareLogin = _props.shareLogin;
	
	      var code = params.code;
	      var orch_id = params.id;
	      // this.props.getToken().then(auth => {
	      //   if (auth) {
	      //     console.log('Token received');
	
	      //     // open up player with token and orchestra id
	      //     const redirect_url = ORCHESTRA_PLAYER_JOIN_PATH.replace(':id', orch_id) + '?token=' + auth.token;
	      //     window.open(redirect_url);
	      //   } else {
	      //     console.log('No token returned from /present/token')
	      //   }
	      // })
	
	      // just support joining with share code for now
	      var redirect_url = _constants.ORCHESTRA_PLAYER_JOIN_WITH_CODE_PATH.replace(':code', code);
	      this.setState({ redirect_url: redirect_url });
	      window.location = redirect_url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var redirect_url = this.state.redirect_url;
	
	      return _react2.default.createElement(_LoadingSpinner2.default, null);
	    }
	  }]);
	
	  return JoinOrchestra;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var entities = _ref2.entities,
	      auth = _ref2.auth,
	      form = _ref2.form,
	      nav = _ref2.nav;
	  var params = _ref3.params;
	  return {
	    entities: entities,
	    getToken: function getToken() {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_PRESENT_TOKEN, {
	        method: 'post',
	        token: auth.token
	      });
	    },
	    userID: auth.user && auth.user.id,
	    anonymousUser: auth.user && auth.user.id === 0,
	    canShareImagesInternal: (0, _auth.userHasPerm)(auth.user, 'internal_share'),
	    canShareImagesExternal: (0, _auth.userHasPerm)(auth.user, 'external_share'),
	    presentTypeSelected: form.present && form.present.values && form.present.values.presentation_type,
	    shouldGoBack: /\/login/.test(nav.previousPath) === false
	  };
	};
	
	var mapDispatchToProps = {};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(JoinOrchestra);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Libraries = __webpack_require__(857);
	
	var _Libraries2 = _interopRequireDefault(_Libraries);
	
	var _libraries = __webpack_require__(211);
	
	var _hierarchy = __webpack_require__(129);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Icon = __webpack_require__(9);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Libraries = function (_Component) {
	  _inherits(Libraries, _Component);
	
	  function Libraries() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Libraries);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Libraries.__proto__ || Object.getPrototypeOf(Libraries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      editing: null,
	      saving: false
	    }, _this.onCreate = function (e) {
	      var saveLibrary = _this.props.saveLibrary;
	
	      e.preventDefault();
	      saveLibrary({ library_token: _this.state.createName });
	      _this.setState({ createName: '' });
	    }, _this.renderLibrary = function (library) {
	      var _this$props = _this.props,
	          saveLibrary = _this$props.saveLibrary,
	          deleteLibrary = _this$props.deleteLibrary;
	      var _this$state = _this.state,
	          editing = _this$state.editing,
	          editName = _this$state.editName;
	
	      var isEditing = editing && editing.id === library.id;
	      var onEdit = function onEdit() {
	        _this.setState({
	          editing: library,
	          editName: library.library_token
	        });
	      };
	      var onDelete = function onDelete() {
	        if (window.confirm('Are you sure you want to delete ' + library.library_token + '? This action cannot be undone.')) {
	          deleteLibrary(library.id);
	        }
	      };
	      var onSave = function onSave() {
	        saveLibrary({ library_token: editName }, library.id).then(function () {
	          _this.setState({
	            editing: null
	          });
	        });
	      };
	      return _react2.default.createElement(
	        'tr',
	        { key: library.id },
	        _react2.default.createElement(
	          'td',
	          null,
	          library.id
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          isEditing ? _react2.default.createElement('input', {
	            type: 'text',
	            value: editName,
	            onChange: function onChange(e) {
	              return _this.setState({ editName: e.target.value });
	            },
	            className: _Libraries2.default.input,
	            autoFocus: true
	          }) : library.library_token
	        ),
	        isEditing ? _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onSave,
	              className: _Libraries2.default.iconButton,
	              disabled: !editName },
	            _react2.default.createElement(_Icon2.default, { icon: 'tick' })
	          )
	        ) : _react2.default.createElement(
	          'td',
	          { className: _Libraries2.default.nowrap },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onEdit,
	              className: _Libraries2.default.iconButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'edit', size: 16 })
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onDelete,
	              className: _Libraries2.default.iconButton },
	            _react2.default.createElement(_Icon2.default, { icon: 'close' })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Libraries, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          fetchLibraries = _props.fetchLibraries,
	          hierarchy = _props.hierarchy,
	          fetchHierarchy = _props.fetchHierarchy;
	
	      if (!data) fetchLibraries();
	      if (!hierarchy) fetchHierarchy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchLibraries = _props2.fetchLibraries;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching libraries',
	          onRetry: fetchLibraries
	        });
	      }
	
	      if (!data || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var _props3 = this.props,
	          submitting = _props3.submitting,
	          extra = _props3.extra;
	      var createName = this.state.createName;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Libraries2.default.page },
	        _react2.default.createElement(
	          'table',
	          { className: _Libraries2.default.table },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'ID'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Tools'
	              )
	            ),
	            data.map(this.renderLibrary)
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.onCreate },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Add Library',
	            _react2.default.createElement('input', {
	              type: 'text',
	              value: createName,
	              className: _Libraries2.default.input,
	              onChange: function onChange(e) {
	                return _this2.setState({ createName: e.target.value });
	              },
	              autoFocus: true
	            })
	          ),
	          _react2.default.createElement('input', {
	            type: 'submit',
	            value: 'Add Library',
	            className: _Libraries2.default.createButton,
	            disabled: !createName
	          })
	        ),
	        submitting && _react2.default.createElement(_LoadingSpinner2.default, null),
	        this.props.submitError && _react2.default.createElement(
	          'p',
	          { className: _Libraries2.default.error },
	          'An unknown error occured'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            { className: _Libraries2.default.heading },
	            'Available Libraries'
	          ),
	          !extra && _react2.default.createElement(_LoadingSpinner2.default, null),
	          extra && extra.map(function (key) {
	            var className = data.map(function (lib) {
	              return lib.library_token;
	            }).indexOf(key) !== -1 ? _Libraries2.default.existing : '';
	            return _react2.default.createElement(
	              'li',
	              { key: key, className: className },
	              key
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Libraries;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var libraries = _ref2.libraries,
	      hierarchy = _ref2.hierarchy;
	  return _extends({}, libraries, {
	    extra: hierarchy.data && Object.keys(hierarchy.data).filter(function (key) {
	      return key !== '<leaves>';
	    })
	  });
	};
	
	var mapDispatchToProps = {
	  fetchLibraries: _libraries.fetchLibraries,
	  saveLibrary: _libraries.saveLibrary,
	  deleteLibrary: _libraries.deleteLibrary,
	  fetchHierarchy: _hierarchy.fetchHierarchy
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Libraries);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PlaylistEditor = __webpack_require__(358);
	
	var _PlaylistEditor2 = _interopRequireDefault(_PlaylistEditor);
	
	var _playlists = __webpack_require__(43);
	
	var _albums = __webpack_require__(41);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Checklist = __webpack_require__(126);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	var _SortableList = __webpack_require__(151);
	
	var _SortableList2 = _interopRequireDefault(_SortableList);
	
	var _SortableBar = __webpack_require__(150);
	
	var _SortableBar2 = _interopRequireDefault(_SortableBar);
	
	var _AlbumPicker = __webpack_require__(204);
	
	var _AlbumPicker2 = _interopRequireDefault(_AlbumPicker);
	
	var _utils = __webpack_require__(152);
	
	var _auth = __webpack_require__(20);
	
	var _images = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListEditor = function (_Component) {
	  _inherits(ListEditor, _Component);
	
	  function ListEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListEditor.__proto__ || Object.getPrototypeOf(ListEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: _this.props.list ? _this.props.list.name : '',
	      structure: _this.props.list ? JSON.parse(_this.props.list.json_data) : { albums: [] }
	    }, _this.onReorder = function (albums) {
	      _this.setState({
	        structure: _extends({}, _this.state.structure, {
	          albums: albums
	        })
	      });
	    }, _this.updateName = function (e) {
	      _this.setState({
	        name: e.target.value
	      });
	    }, _this.addAlbum = function () {
	      var album = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var structure = _this.state.structure;
	
	      _this.updateStructure('albums', structure.albums.concat(album));
	      _this.setState({
	        editIndex: structure.albums.length
	      });
	    }, _this.removeAlbum = function (index) {
	      var albums = _this.state.structure.albums;
	
	      _this.updateStructure('albums', [].concat(_toConsumableArray(albums.slice(0, index)), _toConsumableArray(albums.slice(index + 1))));
	    }, _this.updateStructure = function (key, value) {
	      var structure = _this.state.structure;
	
	      _this.setState({
	        structure: _extends({}, structure, _defineProperty({}, key, value))
	      });
	    }, _this.onSave = function () {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          saveList = _this$props.saveList;
	      var _this$state = _this.state,
	          name = _this$state.name,
	          structure = _this$state.structure;
	
	      saveList({ name: name }, structure, params.id, '/groups');
	    }, _this.isFormValid = function () {
	      var _this$props2 = _this.props,
	          params = _this$props2.params,
	          list = _this$props2.list,
	          submitting = _this$props2.submitting;
	      var _this$state2 = _this.state,
	          name = _this$state2.name,
	          structure = _this$state2.structure;
	
	      if (submitting) {
	        return false;
	      }
	      if (params.id) {
	        return name && name !== list.name || (0, _lodash2.default)(structure, JSON.parse(list.json_data)) === false;
	      }
	      return name;
	    }, _this.getCover = function (item) {
	      var album = _this.props.entities.albums[item.album];
	      if (!album) {
	        return null;
	      }
	      return _this.props.getImageSource(album.cover);
	    }, _this.renderAlbum = function (album, index) {
	      return _react2.default.createElement(_SortableBar2.default, {
	        key: index,
	        title: (0, _utils.getItemName)(album, _this.props.entities),
	        onRemove: function onRemove() {
	          return _this.removeAlbum(index);
	        },
	        thumb: _this.getCover(album)
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          location = _props.location,
	          albums = _props.albums,
	          fetchAlbums = _props.fetchAlbums,
	          removeLocationQuery = _props.removeLocationQuery;
	
	      if (!albums) fetchAlbums();
	
	      if (params.id) {
	        var _props2 = this.props,
	            list = _props2.list,
	            _fetchPlaylists = _props2.fetchPlaylists;
	
	        if (!list) {
	          _fetchPlaylists();
	        }
	      }
	
	      if (location.query.addAlbum) {
	        this.addAlbum({ album: location.query.addAlbum });
	        removeLocationQuery(params.id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.list && nextProps.list) {
	        this.setState({
	          name: nextProps.list.name,
	          structure: JSON.parse(nextProps.list.json_data)
	        });
	      }
	    }
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading(heading) {
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.heading },
	        heading
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          params = _props3.params,
	          list = _props3.list,
	          albums = _props3.albums,
	          isOwner = _props3.isOwner,
	          error = _props3.error,
	          fetchPlaylists = _props3.fetchPlaylists;
	
	      if (!albums) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	      if (params.id) {
	        if (!list) {
	          return _react2.default.createElement(_LoadingSpinner2.default, null);
	        }
	        if (error) {
	          return _react2.default.createElement(_ErrorMessage2.default, { message: 'Group could not be loaded', onRetry: fetchPlaylists });
	        }
	      }
	      var _props4 = this.props,
	          submitting = _props4.submitting,
	          canEditPlaylists = _props4.canEditPlaylists;
	      var _state = this.state,
	          name = _state.name,
	          structure = _state.structure;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _PlaylistEditor2.default.page },
	        this.renderHeading('Group name'),
	        _react2.default.createElement('input', {
	          type: 'text',
	          value: name,
	          onChange: this.updateName,
	          autoFocus: !params.id
	        }),
	        this.renderHeading('Albums'),
	        _react2.default.createElement(_SortableList2.default, {
	          items: structure.albums,
	          renderItem: this.renderAlbum,
	          sortHandle: 'handle',
	          onSort: this.onReorder,
	          itemClass: _PlaylistEditor2.default.album
	        }),
	        _react2.default.createElement(_AlbumPicker2.default, {
	          albums: albums,
	          exclude: structure.albums.map(function (item) {
	            return item.album;
	          }),
	          isOwner: isOwner,
	          onChange: function onChange(id) {
	            return _this2.addAlbum({ album: id });
	          },
	          resetOnChange: true,
	          collapseOnSelect: true,
	          getImageSource: this.props.getImageSource,
	          placeholder: 'Add album to group'
	        }),
	        canEditPlaylists && this.renderHeading('Options'),
	        canEditPlaylists && _react2.default.createElement(_Checklist2.default, {
	          items: [{
	            value: true,
	            title: 'Playlist Albums Only',
	            subtitle: 'Album group will not appear on home page'
	          }],
	          value: structure.playlistsOnly ? [true] : [],
	          onChange: function onChange(array) {
	            return _this2.updateStructure('playlistsOnly', array.length !== 0);
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _PlaylistEditor2.default.buttons },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/groups', className: _PlaylistEditor2.default.cancelButton },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: this.onSave,
	              className: _PlaylistEditor2.default.saveButton,
	              disabled: !this.isFormValid() },
	            'Save Group'
	          )
	        ),
	        _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	      );
	    }
	  }]);
	
	  return ListEditor;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var entities = _ref2.entities,
	      albums = _ref2.albums,
	      auth = _ref2.auth,
	      playlists = _ref2.playlists,
	      search = _ref2.search,
	      queues = _ref2.queues;
	  var params = _ref3.params;
	  return {
	    entities: entities,
	    search: search,
	    list: params.id ? entities.playlists[params.id] : null,
	    error: playlists.error,
	    albums: albums.all.data && albums.all.data.map(function (id) {
	      return entities.albums[id];
	    }),
	    isOwner: function isOwner(album) {
	      return album.user_id === auth.user.id;
	    },
	    submitting: playlists.submitting,
	    submitError: playlists.submitError,
	    canEditPlaylists: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    getImageSource: (0, _images.createImageGetter)(auth)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchAlbums: _albums.fetchAlbums,
	  fetchPlaylists: _playlists.fetchPlaylists,
	  saveList: _playlists.saveList,
	  removeLocationQuery: function removeLocationQuery(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/groups/' + id));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ListEditor);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxForm = __webpack_require__(76);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reactLinkify = __webpack_require__(1127);
	
	var _reactLinkify2 = _interopRequireDefault(_reactLinkify);
	
	var _Login = __webpack_require__(859);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _auth = __webpack_require__(42);
	
	var _albums = __webpack_require__(41);
	
	var _playlists = __webpack_require__(43);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Login(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      submitting = _ref.submitting,
	      loginError = _ref.loginError,
	      dirty = _ref.dirty;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _Login2.default.wrapper },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit, className: _Login2.default.form },
	      _react2.default.createElement(
	        'h1',
	        { className: _Login2.default.heading },
	        'Blayzr'
	      ),
	      _react2.default.createElement(_reduxForm.Field, { component: Input, type: 'email', name: 'email', props: { label: 'Email' } }),
	      _react2.default.createElement(_reduxForm.Field, { component: Input, type: 'password', name: 'password', props: { label: 'Password' } }),
	      loginError && _react2.default.createElement(
	        'div',
	        { className: _Login2.default.error },
	        'There was an error logging in',
	        (loginError.statusText || loginError.message) && _react2.default.createElement(
	          _reactLinkify2.default,
	          null,
	          ': ',
	          loginError.message || loginError.statusText
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'submit', disabled: submitting || !dirty, className: _Login2.default.submit },
	        'Log in'
	      ),
	      _react2.default.createElement(_LoadingSpinner2.default, { white: true, show: submitting })
	    )
	  );
	}
	
	function Input(props) {
	  return _react2.default.createElement(
	    'label',
	    null,
	    props.label,
	    _react2.default.createElement('input', props),
	    props.touched && props.error && _react2.default.createElement(
	      'div',
	      { className: _Login2.default.error },
	      props.error
	    )
	  );
	}
	
	function validate(values) {
	  var error = {};
	  if (!values.email) {
	    error.email = 'Please enter an email address';
	  }
	  if (!values.password) {
	    error.password = 'Please enter a password';
	  }
	  return error;
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth;
	  return {
	    authenticating: auth.authenticating,
	    loginError: auth.error
	  };
	};
	
	// redux-form uses onSubmit, but passes handleSubmit down to the decorated component
	var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
	  return {
	    onSubmit: function onSubmit(data) {
	      return dispatch((0, _auth.login)(data.email, data.password)).then(function () {
	        if (props.location.query.redirect === '/') {
	          return Promise.all([dispatch((0, _albums.fetchAlbums)()), dispatch((0, _playlists.fetchPlaylists)())]);
	        }
	        return true;
	      }).then(function () {
	        dispatch((0, _reactRouterRedux.push)(props.location.query.redirect));
	      });
	    }
	  };
	};
	
	var LoginForm = (0, _reduxForm.reduxForm)({ form: 'login', validate: validate })(Login);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginForm);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Orchestras = __webpack_require__(860);
	
	var _Orchestras2 = _interopRequireDefault(_Orchestras);
	
	var _fetch = __webpack_require__(14);
	
	var _auth = __webpack_require__(20);
	
	var _images = __webpack_require__(23);
	
	var _queues = __webpack_require__(108);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _OrchestraArrange = __webpack_require__(522);
	
	var _OrchestraArrange2 = _interopRequireDefault(_OrchestraArrange);
	
	var _OrchestraPreferences = __webpack_require__(525);
	
	var _OrchestraPreferences2 = _interopRequireDefault(_OrchestraPreferences);
	
	var _constants = __webpack_require__(3);
	
	var _mousetrap = __webpack_require__(73);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCENE_TYPES = ['Floating', 'Ken Burns'];
	
	var Orchestras = function (_Component) {
	  _inherits(Orchestras, _Component);
	
	  function Orchestras() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Orchestras);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Orchestras.__proto__ || Object.getPrototypeOf(Orchestras)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      channels: null,
	      channelsError: null,
	      shareChannel: null,
	      usersChecked: null,
	      renameChannel: null,
	      editChannelQueue: null,
	      fetching: false,
	      showCreateChannelModal: false,
	      showInfo: null,
	      addingQueueToChannel: false,
	      formation: null,
	      scenePreferences: {},
	      orchestraPreferences: { 'scene_type': SCENE_TYPES[0] },
	      selectedPlayerId: null
	    }, _this.log = function (message) {
	      // if (this.mounted) {
	      //   console.log(source, message)
	      //   this.setState({
	      //     logs: this.state.logs.concat({ message, source })
	      //   })
	      // }
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'frontend';
	    }, _this.onKeyRemove = function (e) {
	      e.preventDefault();
	      var playerId = _this.state.selectedPlayerId;
	
	      // bail if no player is selected
	      if (playerId == null || playerId == '') {
	        return;
	      }
	
	      // only remove inactive players
	      if (_this.playerActive(playerId)) {
	        window.alert('You can only delete inactive players!');
	        return;
	      }
	
	      _this.wsSendRemovePlayer(playerId);
	      _this.setState({
	        selectedPlayerId: null
	      });
	    }, _this.playerActive = function (playerId) {
	      var player = _this.playerForId(playerId);
	      return player && player.connected;
	    }, _this.playerForId = function (playerId) {
	      var match;
	      _this.state.formation.players.forEach(function (player) {
	        if (player.id == playerId) {
	          match = player;
	        }
	      });
	
	      return match;
	    }, _this.onKeyIdentify = function (e) {
	      e.preventDefault();
	      console.log('IDENTIFY');
	
	      var playerId = _this.state.selectedPlayerId;
	      if (_this.playerActive(playerId)) {
	        _this.identifyPlayer(playerId);
	      }
	    }, _this.fetchChannels = function () {
	      _this.setState({
	        channelsError: null,
	        fetching: true
	      });
	      _this.props.fetchChannels(_this.props.dispatch).then(function (data) {
	        _this.setState({
	          channels: data.channels,
	          fetching: false
	        });
	      }, function (e) {
	        _this.setState({
	          channelsError: e,
	          fetching: false
	        });
	      });
	    }, _this.fetchOrchestras = function () {
	      // just get the one for the time being
	    }, _this.openSocket = function (auth) {
	      _this.log('Connecting to websocket');
	      _this.ws = new window.WebSocket(_this.props.route.socket);
	      _this.ws.onopen = function () {
	        _this.log('Socket open, saying hello!');
	        _this.wsSayHello();
	      };
	      _this.ws.onmessage = _this.wsHandleMessage;
	      _this.ws.onclose = function (e) {
	        _this.log('Socket closed');
	        if (_this.mounted) {
	          _this.setState({ showDebug: true });
	          _this.setState({ orchestraName: null, formation: null });
	          setTimeout(function () {
	            _this.openSocket();
	          }, 1000);
	        }
	      };
	      _this.ws.onerror = function (e) {
	        _this.log('Socket error');
	        if (_this.mounted) {
	          _this.setState({ showDebug: true });
	        }
	      };
	      window.ws = _this.ws; // TMP
	    }, _this.wsSayHello = function () {
	      _this.wsSendMessage({
	        topic: 'hello'
	      });
	    }, _this.onFormationChange = function (formation) {
	      _this.setState({ formation: formation });
	      _this.wsSendFormationUpdate(formation);
	    }, _this.wsSendFormationUpdate = function (formation) {
	      _this.wsSendMessage({
	        topic: 'reposition',
	        data: formation
	      });
	    }, _this.identifyPlayer = function (playerId) {
	      _this.wsSendMessage({
	        topic: 'identify',
	        data: {
	          scene_id: 0,
	          player_id: playerId
	        }
	      });
	    }, _this.onPlayerClicked = function (playerId) {
	      _this.setState({
	        selectedPlayerId: playerId
	      });
	    }, _this.wsSendRemovePlayer = function (playerId) {
	      _this.wsSendMessage({
	        topic: 'remove-player',
	        data: {
	          player_id: playerId
	        }
	      });
	    }, _this.wsSendShrinkWrap = function () {
	      _this.wsSendMessage({
	        topic: 'shrinkwrap',
	        data: {
	          scene_id: 0
	        }
	      });
	    }, _this.wsSendScenePrefsUpdate = function (prefs) {
	      // get preference values without metadata
	      var slimPrefs = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(prefs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              key = _step$value[0],
	              value = _step$value[1];
	
	          slimPrefs[key] = value.value;
	        }
	        // send to server
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _this.wsSendMessage({
	        topic: 'adjust-scene-preferences',
	        data: {
	          scene_id: 0,
	          preferences: slimPrefs
	        }
	      });
	    }, _this.wsSendOrchestraPrefsUpdate = function () {
	      _this.wsSendMessage({
	        topic: 'adjust-orchestra-preferences',
	        data: {
	          orchestra_id: 0,
	          preferences: _this.state.orchestraPreferences
	        }
	      });
	    }, _this.wsSendMessage = function (data) {
	      data['client'] = 'admin';
	      _this.ws.send(JSON.stringify(data));
	    }, _this.wsHandleMessage = function (e) {
	      var msg = JSON.parse(e.data);
	      if (msg.topic === 'formation') {
	        var formation = msg.data;
	        var orchPrefs = _this.state.orchestraPreferences;
	        orchPrefs['scene_type'] = formation.scene_type;
	        _this.setState({
	          formation: formation,
	          orchestraName: formation.orchestra_name,
	          scenePreferences: formation.scene_preferences,
	          orchestraPreferences: orchPrefs
	        });
	      }
	      if (msg.topic == 'orchestra-preferences') {
	        _this.setState({ 'orchestraPreferences': msg.data });
	      }
	    }, _this.updateOrchPref = function (key, value) {
	      var orchestraPreferences = _this.state.orchestraPreferences;
	
	      orchestraPreferences[key] = value;
	      _this.setState({ orchestraPreferences: orchestraPreferences });
	      _this.wsSendOrchestraPrefsUpdate();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Orchestras, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      var channels = this.state.channels;
	
	      if (!channels) {
	        this.fetchChannels();
	      }
	      this.openSocket();
	
	      // set up key handling
	      _mousetrap2.default.bind('d', this.onKeyRemove);
	      _mousetrap2.default.bind('i', this.onKeyIdentify);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          queues = _props.queues,
	          canCreateChannels = _props.canCreateChannels;
	      var _state = this.state,
	          channels = _state.channels,
	          channelsError = _state.channelsError,
	          orchestraPreferences = _state.orchestraPreferences,
	          shareChannel = _state.shareChannel,
	          fetching = _state.fetching;
	
	      if (channelsError) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching channels',
	          onRetry: this.fetchChannels
	        });
	      }
	      if (!channels) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Connecting to Picasso...'
	          ),
	          _react2.default.createElement(_LoadingSpinner2.default, null)
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _Orchestras2.default.page },
	        _react2.default.createElement(
	          'span',
	          { className: _Orchestras2.default.orchestraAdminHelpText },
	          'Click to select Player',
	          _react2.default.createElement('br', null),
	          'Press \'I\' to Identify',
	          _react2.default.createElement('br', null),
	          'Press \'D\' to delete selected Player'
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Installation: ',
	          this.state.orchestraName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Orchestras2.default.orchestraPageFlexContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _Orchestras2.default.scenePreferencesPanel },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Scene Type'
	            ),
	            _react2.default.createElement(SceneTypePicker, {
	              value: orchestraPreferences.scene_type,
	              onChange: function onChange(value) {
	                return _this2.updateOrchPref('scene_type', value);
	              }
	            }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Scene Preferences'
	            ),
	            _react2.default.createElement(_OrchestraPreferences2.default, { items: this.state.scenePreferences, onPrefChange: this.wsSendScenePrefsUpdate })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Orchestras2.default.sceneArrangePanel },
	            _react2.default.createElement(_OrchestraArrange2.default, {
	              selectedPlayerId: this.state.selectedPlayerId,
	              sceneFormation: this.state.formation,
	              onFormationChange: this.onFormationChange,
	              onPrefChange: this.wsSendScenePrefsUpdate,
	              identifyPlayer: this.identifyPlayer,
	              onPlayerClicked: this.onPlayerClicked,
	              sendShrinkWrap: this.wsSendShrinkWrap,
	              onOrchPrefChange: this.wsSendOrchestraPrefsUpdate
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Orchestras;
	}(_react.Component);
	
	function SceneTypePicker(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange;
	
	  console.log(value);
	  var sceneDescripion = '';
	  if (value == 'Floating') {
	    sceneDescripion = 'Images float across the screen on different layers';
	  }
	  if (value == 'Ken Burns') {
	    sceneDescripion = 'Images fade from one to the next, zooming and panning subtly';
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      SCENE_TYPES.map(function (st) {
	        return _react2.default.createElement(
	          'button',
	          {
	            key: st,
	            type: 'button',
	            onClick: function onClick() {
	              return onChange(st);
	            },
	            className: value === st ? _Orchestras2.default.smallButtonActive : _Orchestras2.default.smallButton },
	          st
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Orchestras2.default.sceneTypeDescription },
	      _react2.default.createElement(
	        'p',
	        null,
	        sceneDescripion
	      )
	    )
	  );
	}
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var queues = _ref3.queues,
	      entities = _ref3.entities,
	      auth = _ref3.auth;
	  return {
	    entities: entities,
	    me: auth.user,
	    queues: queues.data && queues.data.map(function (id) {
	      return entities.queues[id];
	    }),
	    canCreateChannels: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    fetchQueues: function fetchQueues(dispatch) {
	      return dispatch((0, _queues.fetchQueues)());
	    },
	    fetchChannels: function fetchChannels(dispatch) {
	      return (0, _fetch.picassoFetch)(auth, 'list_channels', undefined, dispatch);
	    },
	    createChannel: function createChannel(name, queueID) {
	      return (0, _fetch.picassoFetch)(auth, 'create_channel', {
	        name: name,
	        queue_id: queueID || undefined,
	        time_offset: new Date().getTimezoneOffset() * -60
	      });
	    },
	    deleteChannel: function deleteChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'remove_channel', { channel_id: id });
	    },
	    sendQueueToChannel: function sendQueueToChannel(channelID, queueID, position) {
	      return (0, _fetch.picassoFetch)(auth, 'set_queue', {
	        channel_id: channelID,
	        queue_id: queueID,
	        location: position.lat ? position.lat + ',' + position.lon : undefined,
	        time_offset: new Date().getTimezoneOffset() * -60
	      });
	    },
	    renameChannel: function renameChannel(id, name) {
	      return (0, _fetch.picassoFetch)(auth, 'rename_channel', {
	        channel_id: id,
	        name: name
	      });
	    },
	    updateChannel: function updateChannel(id, values) {
	      return (0, _fetch.picassoFetch)(auth, 'update_channel', {
	        channel_id: id,
	        update: values
	      });
	    },
	    channelAction: function channelAction(id, action, extra) {
	      return (0, _fetch.picassoFetch)(auth, action, _extends({ channel_id: id }, extra));
	    },
	    channelEvent: function channelEvent(id, event) {
	      return (0, _fetch.picassoFetch)(auth, 'send_event', { channel_id: id, event: event });
	    },
	    disableChannel: function disableChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'disable_channel', { channel_id: id });
	    },
	    enableChannel: function enableChannel(id) {
	      return (0, _fetch.picassoFetch)(auth, 'enable_channel', { channel_id: id });
	    },
	    getOwner: function getOwner(channel) {
	      return entities.users[channel.owner_id];
	    },
	    getImageSource: (0, _images.createImageGetter)(auth)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Orchestras);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(106);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _Playlists = __webpack_require__(861);
	
	var _Playlists2 = _interopRequireDefault(_Playlists);
	
	var _playlists = __webpack_require__(43);
	
	var _users = __webpack_require__(68);
	
	var _albums = __webpack_require__(41);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EmptyNotice = __webpack_require__(127);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	var _SortableList = __webpack_require__(151);
	
	var _SortableList2 = _interopRequireDefault(_SortableList);
	
	var _SortableBar = __webpack_require__(150);
	
	var _SortableBar2 = _interopRequireDefault(_SortableBar);
	
	var _PlaylistEditor = __webpack_require__(209);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	var _auth = __webpack_require__(20);
	
	var _List = __webpack_require__(311);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Playlists = function (_Component) {
	  _inherits(Playlists, _Component);
	
	  function Playlists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Playlists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Playlists.__proto__ || Object.getPrototypeOf(Playlists)).call.apply(_ref, [this].concat(args))), _this), _this.getCover = function (item) {
	      var _this$props = _this.props,
	          entities = _this$props.entities,
	          getImageSource = _this$props.getImageSource;
	
	      var album = entities.albums[item.album];
	      if (!album) {
	        return null;
	      }
	      return _react2.default.createElement('div', {
	        key: album.cover,
	        className: _Playlists2.default.cover,
	        style: { backgroundImage: 'url(' + getImageSource(album.cover, 'i') + ')' }
	      });
	    }, _this.renderPlaylist = function (playlist) {
	      var _this$props2 = _this.props,
	          route = _this$props2.route,
	          editPlaylist = _this$props2.editPlaylist;
	
	      if (route.playlists) {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: 'playlists/' + playlist.id, className: _Playlists2.default.playlist },
	          _react2.default.createElement(
	            'div',
	            { className: _Playlists2.default.name },
	            playlist.name
	          ),
	          _this.getDescription(playlist)
	        );
	      }
	      return _react2.default.createElement(_SortableBar2.default, {
	        title: playlist.name,
	        subtitle: _this.getDescription(playlist),
	        onEdit: function onEdit() {
	          return editPlaylist(playlist.id);
	        },
	        onRemove: function onRemove() {
	          return _this.deletePlaylist(playlist);
	        },
	        titleLink: '/group/' + playlist.id
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Playlists, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          fetchPlaylists = _props.fetchPlaylists,
	          albums = _props.albums,
	          fetchAlbums = _props.fetchAlbums;
	
	      if (!data) fetchPlaylists();
	      if (!albums) fetchAlbums();
	
	      (0, _PlaylistEditor.clearPlaylistEditorCache)();
	    }
	  }, {
	    key: 'deletePlaylist',
	    value: function deletePlaylist(playlist) {
	      if (window.confirm('Are you sure you want to delete ' + playlist.name + '?')) {
	        this.props.deletePlaylist(playlist.id);
	      }
	    }
	  }, {
	    key: 'getDescription',
	    value: function getDescription(playlist) {
	      var structure = JSON.parse(playlist.json_data);
	      var description = (0, _string.pluralize)(structure.albums.length, 'album');
	      if (structure.playlistsOnly) {
	        description += ', for playlist albums only';
	      }
	      if (this.props.route.playlists) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Playlists2.default.description },
	          description,
	          _react2.default.createElement('br', null),
	          structure.albums.map(this.getCover)
	        );
	      }
	      return description;
	    }
	  }, {
	    key: 'renderFixedLists',
	    value: function renderFixedLists() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Playlists2.default.fixedLists },
	        [{ key: 'favourites', title: 'Favourite Albums' }, { key: 'shared', title: 'Shared With Me' }, { key: 'recent', title: 'Recent' }, { key: 'all', title: 'All Albums' }].map(function (list) {
	          return _react2.default.createElement(_SortableBar2.default, {
	            key: list.key,
	            title: list.title,
	            titleLink: '/group/' + list.key,
	            subtitle: (0, _string.pluralize)(_this2.props.counts[list.key], 'album'),
	            showHandle: false
	          });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          route = _props2.route,
	          data = _props2.data,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          fetchPlaylists = _props2.fetchPlaylists,
	          submitting = _props2.submitting;
	
	
	      var thing = route.playlists ? 'playlist' : 'album group';
	      var createPath = route.playlists ? '/playlists/create' : '/groups/create';
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching ' + thing + 's',
	          onRetry: fetchPlaylists
	        });
	      }
	
	      if (!data || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Playlists2.default.page },
	          route.playlists && _react2.default.createElement(_EmptyNotice2.default, {
	            heading: 'Create a playlist of albums',
	            text: 'Build a playlist from a list of albums and use them when building queues.'
	          }),
	          !route.playlists && _react2.default.createElement(_EmptyNotice2.default, {
	            heading: 'Create an album group',
	            text: 'Albums can be added to groups for easy access and organisation.'
	          }),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: createPath, className: _Playlists2.default.button, style: { margin: '20px auto' } },
	            'Create new ',
	            thing
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Playlists2.default.page },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: createPath, className: _Playlists2.default.button },
	          'Create new ',
	          thing
	        ),
	        _react2.default.createElement(_SortableList2.default, {
	          items: data,
	          renderItem: this.renderPlaylist,
	          sortHandle: 'handle',
	          onSort: function onSort(data) {
	            return _this3.props.updateListOrder(data.map(function (p) {
	              return p.id;
	            }));
	          }
	        }),
	        !route.playlists && this.renderFixedLists(),
	        _react2.default.createElement(_LoadingSpinner2.default, { show: submitting })
	      );
	    }
	  }]);
	
	  return Playlists;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var playlists = _ref2.playlists,
	      entities = _ref2.entities,
	      auth = _ref2.auth,
	      users = _ref2.users,
	      albums = _ref2.albums;
	  var route = _ref3.route;
	
	  var denormalize = function denormalize(id) {
	    return entities.playlists[id];
	  };
	  var data = route.playlists ? playlists.playlists : playlists.lists;
	  function filterList(list) {
	    return list.name.indexOf(_constants.AUTO_PLAYLIST_SUFFIX) === -1;
	  }
	  return {
	    entities: entities,
	    data: data && data.map(denormalize).filter(filterList),
	    fetching: playlists.fetching || users.fetching,
	    error: playlists.error,
	    user: auth.user,
	    getImageSource: (0, _images.createImageGetter)(auth),
	    albums: albums.all.data,
	    submitting: playlists.submitting,
	    canEditPlaylists: (0, _auth.userHasPerm)(auth.user, 'create_channels'),
	    counts: {
	      all: (0, _List.filterAlbums)('all', albums, entities, auth).length,
	      favourites: (0, _List.filterAlbums)('favourites', albums, entities, auth).length,
	      shared: (0, _List.filterAlbums)('shared', albums, entities, auth).length,
	      recent: (0, _List.filterAlbums)('recent', albums, entities, auth).length
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref4) {
	  var route = _ref4.route;
	
	  var editPath = route.playlists ? '/playlists' : '/groups';
	  return _extends({}, (0, _redux.bindActionCreators)({
	    fetchPlaylists: _playlists.fetchPlaylists,
	    deletePlaylist: _playlists.deletePlaylist,
	    savePlaylist: _playlists.savePlaylist,
	    updateUser: _users.updateUser,
	    fetchAlbums: _albums.fetchAlbums,
	    updateListOrder: _playlists.updateListOrder
	  }, dispatch), {
	    editPlaylist: function editPlaylist(id) {
	      return dispatch((0, _reactRouterRedux.push)(editPath + '/' + id));
	    }
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Playlists);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _lodash = __webpack_require__(383);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactStringReplace = __webpack_require__(1164);
	
	var _reactStringReplace2 = _interopRequireDefault(_reactStringReplace);
	
	var _PresentChannel = __webpack_require__(862);
	
	var _PresentChannel2 = _interopRequireDefault(_PresentChannel);
	
	var _fetch = __webpack_require__(14);
	
	var _images = __webpack_require__(23);
	
	var _auth = __webpack_require__(20);
	
	var _search = __webpack_require__(59);
	
	var _auth2 = __webpack_require__(42);
	
	var _Presentation = __webpack_require__(535);
	
	var _Presentation2 = _interopRequireDefault(_Presentation);
	
	var _ChannelInfo = __webpack_require__(309);
	
	var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);
	
	var _ChannelDebug = __webpack_require__(531);
	
	var _ChannelDebug2 = _interopRequireDefault(_ChannelDebug);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBUG_TIMEOUT = 10; // Time to wait for images before showing logs
	var REFRESH_TOKENS_INTERVAL = 82800000; // 23 hours
	
	var PresentChannel = function (_Component) {
	  _inherits(PresentChannel, _Component);
	
	  function PresentChannel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PresentChannel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PresentChannel.__proto__ || Object.getPrototypeOf(PresentChannel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      images: [],
	      logs: [],
	      conflicts: [],
	      showDebug: false,
	      showDebugOverlay: false,
	      showInfoOverlay: false,
	      isOwner: false,
	      alert: null,
	      imagesPlayedCount: null
	    }, _this.log = function (message) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'frontend';
	
	      if (_this.mounted) {
	        console.log(source, message);
	        _this.setState({
	          logs: _this.state.logs.concat({ message: message, source: source })
	        });
	      }
	    }, _this.openSocket = function (auth) {
	      _this.log('Connecting to websocket');
	      _this.ws = new window.WebSocket(_constants.PICASSO_SOCKET);
	      _this.ws.onopen = function () {
	        _this.log('Socket open, logging in');
	        _this.login(auth.user, auth.token);
	      };
	      _this.ws.onmessage = _this.onSocketMessage;
	      _this.ws.onclose = function (e) {
	        _this.log('Socket closed');
	        if (_this.mounted) {
	          _this.setState({ showDebug: true });
	        }
	      };
	      _this.ws.onerror = function (e) {
	        _this.log('Socket error');
	        if (_this.mounted) {
	          _this.setState({ showDebug: true });
	        }
	      };
	      window.ws = _this.ws; // TMP
	    }, _this.sendMessage = function (data) {
	      _this.ws.send(JSON.stringify(data));
	    }, _this.login = function (user, token) {
	      _this.sendMessage({
	        type: 'login',
	        instance_id: _this.props.params.instance_id,
	        state: _this.props.location.query.debug || _this.props.params.task === 'info' ? 'absent' : 'present',
	        user: user,
	        token: token,
	        time_offset: new Date().getTimezoneOffset() * -60
	      });
	    }, _this.requestInfo = function () {
	      _this.sendMessage({
	        type: 'info',
	        action: 'data'
	      });
	    }, _this.sendMod = function (action, extra) {
	      _this.sendMessage(_extends({
	        type: 'mod',
	        action: action
	      }, extra));
	    }, _this.sendEvent = function (action) {
	      _this.sendMessage({ type: 'event', action: action });
	    }, _this.onSocketMessage = function (e) {
	      var message = JSON.parse(e.data);
	      if (message.error) {
	        _this.log('Error: ' + message.error, 'picasso');
	        _this.setState({ showDebug: true });
	      }
	      if (message.alert) {
	        _this.log('Alert: ' + message.alert, 'picasso');
	        if (message.key === 'channel_finished_owner') {
	          // Channel is finished, so show the alert after last image has played
	          var channel = _this.state.channel;
	
	          var delay = channel.playing_album.presentation_speed + channel.playing_album.presentation_transition;
	          setTimeout(function () {
	            _this.setState({ alert: message.alert });
	          }, delay * 1000);
	        } else {
	          _this.setState({ alert: message.alert });
	        }
	        clearTimeout(_this.debugTimeout);
	      }
	      if (message.images) {
	        if (message.images.length === 0) {
	          if (message.queue.state === 'played') {
	            _this.onFinish();
	          }
	        } else {
	          _this.onReceiveImages(message);
	        }
	      }
	      if (message.user) {
	        _this.log('User state: ' + message.user.state, 'picasso');
	        message.user.why && _this.log('User state reason: ' + message.user.why, 'picasso');
	        if (message.user.state === 'online') {
	          _this.onAuthed();
	          _this.log('User authorized');
	        }
	        _this.setState({
	          isOwner: message.user.owner
	        });
	      }
	      if (message.channel) {
	        if (message.channel.data) {
	          _this.setState({
	            info: message.channel.data
	          });
	        }
	      }
	      if (message.conflicts) {
	        _this.setState({
	          conflicts: message.conflicts
	        });
	      }
	      if (message.event && _this.refs.presentation) {
	        if (message.event.action === 'play') {
	          _this.refs.presentation.play();
	        }
	        if (message.event.action === 'pause') {
	          _this.refs.presentation.pause();
	        }
	        if (message.event.action === 'prev-image') {
	          _this.refs.presentation.prevSlide();
	        }
	        if (message.event.action === 'next-image') {
	          _this.refs.presentation.nextSlide();
	        }
	        if (message.event.action === 'next') {
	          _this.onSkip();
	        }
	      }
	      if (message.debug) {
	        message.debug.forEach(function (message) {
	          return _this.log(message, 'picasso');
	        });
	      }
	    }, _this.onAuthed = function () {
	      var params = _this.props.params;
	
	      if (params.task === 'info') {
	        _this.requestInfo();
	        _this.sendMessage({ type: 'validation' });
	      } else {
	        // Play message is no longer required here
	        _this.debugTimeout = setTimeout(function () {
	          return _this.setState({ showDebug: true });
	        }, DEBUG_TIMEOUT * 1000);
	      }
	    }, _this.onReceiveImages = function (message) {
	      _this.log('Received ' + message.images.length + ' images');
	      clearTimeout(_this.debugTimeout);
	
	      _this.props.addImagesToEntities(message.images);
	
	      _this.setState({
	        channel: message.channel,
	        showDebug: false
	      });
	
	      if (_this.state.imagesPlayedCount === null) {
	        _this.setState({
	          imagesPlayedCount: Math.max(0, message.channel.progress.total_images_played - message.images.length)
	        });
	      }
	
	      // If the playlist/album has changed, reset images to this new array
	      if (!_this.state.channel || message.channel.playing_album.id !== _this.state.channel.playing_album.id) {
	        _this.setState({
	          images: message.images
	        });
	        return;
	      }
	
	      // Otherwise, append images to the current array
	      _this.setState({
	        images: (0, _lodash2.default)(_this.state.images.concat(message.images), '_id')
	      }, _this.resolveOnImages);
	    }, _this.loadMoreImages = function () {
	      return new Promise(function (resolve) {
	        _this.sendMod('consume_queue');
	        _this.resolveOnImages = resolve;
	      });
	    }, _this.onSkip = function () {
	      _this.sendMod('play_next_album');
	    }, _this.onReset = function () {
	      _this.sendMod('reset_queue');
	    }, _this.onPause = function () {
	      _this.sendMessage({ type: 'state', state: 'absent' });
	    }, _this.onPlay = function () {
	      _this.sendMessage({ type: 'state', state: 'present' });
	    }, _this.onClose = function () {
	      if (_this.props.shouldGoBack) {
	        window.history.back();
	      } else {
	        _this.props.goHome();
	      }
	    }, _this.onToggleSkip = function (e) {
	      _this.sendMod('skip_album', { album_id: e.target.value });
	      _this.requestInfo();
	    }, _this.onToggleUnskip = function (e) {
	      _this.sendMod('unmute_album', { album_id: e.target.value });
	      _this.requestInfo();
	    }, _this.onFinish = function () {
	      window.history.back();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PresentChannel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mounted = true;
	      var userID = this.props.userID;
	
	      this.log('Getting auth token from picasso');
	      this.props.getToken().then(function (auth) {
	        if (auth) {
	          _this2.log('Token received');
	          _this2.openSocket({ token: auth.token, user: userID });
	        } else {
	          _this2.log('No token returned from /present/token');
	        }
	      });
	      this.refreshInterval = setInterval(this.props.refreshTokens, REFRESH_TOKENS_INTERVAL);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.ws && this.ws.close();
	      this.mounted = false;
	      clearInterval(this.refreshInterval);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          getImageSource = _props.getImageSource;
	      var _state = this.state,
	          images = _state.images,
	          channel = _state.channel,
	          info = _state.info,
	          conflicts = _state.conflicts,
	          alert = _state.alert,
	          isOwner = _state.isOwner;
	
	      if (params.task === 'info') {
	        if (!info) {
	          return _react2.default.createElement(_LoadingSpinner2.default, null);
	        }
	        return _react2.default.createElement(_ChannelInfo2.default, {
	          data: info,
	          conflicts: conflicts,
	          onSkip: this.onToggleSkip,
	          onUnskip: this.onToggleUnskip,
	          getImageSource: getImageSource,
	          isOwner: isOwner
	        });
	      }
	
	      if (alert) {
	        var backLink = function backLink(match) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/channels' },
	            match
	          );
	        };
	        var reloadButton = function reloadButton(match) {
	          return _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return window.location.reload();
	              } },
	            match
	          );
	        };
	        var text = (0, _reactStringReplace2.default)(alert, 'go back to channels', backLink);
	        text = (0, _reactStringReplace2.default)(text, 'reloading the page', reloadButton);
	        return _react2.default.createElement(
	          'div',
	          { className: _PresentChannel2.default.blackOverlay },
	          _react2.default.createElement(
	            'p',
	            null,
	            text
	          ),
	          !this.props.anonymousUser && /back to channels/.test(alert) === false && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/channels', className: _PresentChannel2.default.button },
	            'Back to Channels'
	          )
	        );
	      }
	
	      if (location.query.debug || this.state.showDebug) {
	        return _react2.default.createElement(_ChannelDebug2.default, { logs: this.state.logs });
	      }
	
	      if (images.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: _PresentChannel2.default.blackOverlay },
	          'Loading your images\u2026',
	          _react2.default.createElement(_LoadingSpinner2.default, { style: { opacity: 0.8 } })
	        );
	      }
	
	      return _react2.default.createElement(_Presentation2.default, {
	        ref: 'presentation',
	        key: channel.playing_album.id,
	        type: channel.playing_album.presentation_type,
	        options: {
	          delay: channel.playing_album.presentation_speed,
	          transition: channel.playing_album.presentation_transition
	        },
	        images: images.map(function (image) {
	          return image._id;
	        }),
	        count: channel.playing_album.album_count,
	        showTotalCount: channel.progress.total_images,
	        imagesPlayedCount: this.state.imagesPlayedCount,
	        getImageSource: getImageSource,
	        loadMoreImages: this.loadMoreImages,
	        onClose: this.onClose,
	        onSkip: isOwner && this.onSkip,
	        onStartAgain: isOwner && this.onReset,
	        onPause: this.onPause,
	        onPlay: this.onPlay,
	        onFinish: this.loadMoreImages,
	        entities: this.props.entities,
	        albumName: channel.playing_album.name,
	        playlistName: channel.playing_playlist.name,
	        queueName: channel.queue.name,
	        channelInfo: _react2.default.createElement(_ChannelInfo2.default, {
	          data: info,
	          conflicts: conflicts,
	          onSkip: this.onToggleSkip,
	          onUnskip: this.onToggleUnskip,
	          getImageSource: getImageSource,
	          isOwner: isOwner,
	          padded: true
	        }),
	        anonymousUser: this.props.anonymousUser,
	        channelDebug: _react2.default.createElement(_ChannelDebug2.default, { logs: this.state.logs }),
	        canShareImagesInternal: this.props.canShareImagesInternal,
	        canShareImagesExternal: this.props.canShareImagesExternal,
	        presentTypeSelected: this.props.presentTypeSelected,
	        showInfoOverlay: this.state.showInfoOverlay,
	        onShowInfoOverlay: function onShowInfoOverlay() {
	          _this3.requestInfo();
	          _this3.setState({ showInfoOverlay: true });
	        },
	        onHideInfoOverlay: function onHideInfoOverlay() {
	          return _this3.setState({ showInfoOverlay: false });
	        },
	        showDebugOverlay: this.state.showDebugOverlay,
	        onShowDebugOverlay: function onShowDebugOverlay() {
	          return _this3.setState({ showDebugOverlay: true });
	        },
	        onHideDebugOverlay: function onHideDebugOverlay() {
	          return _this3.setState({ showDebugOverlay: false });
	        }
	      });
	    }
	  }]);
	
	  return PresentChannel;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	  var queues = _ref2.queues,
	      entities = _ref2.entities,
	      auth = _ref2.auth,
	      form = _ref2.form,
	      nav = _ref2.nav;
	  var params = _ref3.params;
	  return {
	    entities: entities,
	    getToken: function getToken() {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_PRESENT_TOKEN, {
	        method: 'post',
	        token: auth.token
	      });
	    },
	    getImageSource: (0, _images.createImageGetter)(auth),
	    userID: auth.user && auth.user.id,
	    anonymousUser: auth.user && auth.user.id === 0,
	    canShareImagesInternal: (0, _auth.userHasPerm)(auth.user, 'internal_share'),
	    canShareImagesExternal: (0, _auth.userHasPerm)(auth.user, 'external_share'),
	    presentTypeSelected: form.present && form.present.values && form.present.values.presentation_type,
	    shouldGoBack: /\/login/.test(nav.previousPath) === false
	  };
	};
	
	var mapDispatchToProps = {
	  addImagesToEntities: _search.addImagesToEntities,
	  refreshTokens: _auth2.refreshTokens,
	  goHome: function goHome(id) {
	    return function (dispatch) {
	      return dispatch((0, _reactRouterRedux.push)('/'));
	    };
	  }
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PresentChannel);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(106);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _Queues = __webpack_require__(863);
	
	var _Queues2 = _interopRequireDefault(_Queues);
	
	var _queues = __webpack_require__(108);
	
	var _playlists = __webpack_require__(43);
	
	var _albums = __webpack_require__(41);
	
	var _search = __webpack_require__(59);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EmptyNotice = __webpack_require__(127);
	
	var _EmptyNotice2 = _interopRequireDefault(_EmptyNotice);
	
	var _QueueEditor = __webpack_require__(530);
	
	var _QueueEditor2 = _interopRequireDefault(_QueueEditor);
	
	var _PlaylistEditor = __webpack_require__(209);
	
	var _images = __webpack_require__(23);
	
	var _fetch = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Queues = function (_Component) {
	  _inherits(Queues, _Component);
	
	  function Queues() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Queues);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Queues.__proto__ || Object.getPrototypeOf(Queues)).call.apply(_ref, [this].concat(args))), _this), _this.routerWillLeave = function () {
	      if (_this.refs.editor && _this.refs.editor.isUnsaved() && !_this.refs.editor.preventSaveAlert) {
	        return 'Your changes have not been saved. Are you sure you want to leave?';
	      }
	    }, _this.renderQueue = function (queue) {
	      var entities = _this.props.entities;
	
	      var playlists = JSON.parse(queue.json_data).playlists;
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { key: queue.id, to: '/queues/' + queue.id, className: _Queues2.default.queue },
	        _react2.default.createElement(
	          'div',
	          { className: _Queues2.default.name },
	          queue.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Queues2.default.info },
	          _react2.default.createElement(
	            'div',
	            { className: _Queues2.default.heading },
	            'Playlists:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Queues2.default.playlists },
	            playlists.map(function (id) {
	              var playlist = entities.playlists[id];
	              if (!playlist) return null;
	              return _react2.default.createElement(
	                'span',
	                { className: _Queues2.default.playlist },
	                playlist.name
	              );
	            })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Queues, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          queues = _props.queues,
	          fetchQueues = _props.fetchQueues,
	          playlists = _props.playlists,
	          fetchPlaylists = _props.fetchPlaylists,
	          albums = _props.albums,
	          fetchAlbums = _props.fetchAlbums;
	
	      if (!queues) fetchQueues();
	      if (!playlists) fetchPlaylists();
	      if (!albums) fetchAlbums();
	
	      (0, _PlaylistEditor.clearPlaylistEditorCache)();
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          queues = _props2.queues,
	          playlists = _props2.playlists,
	          error = _props2.error,
	          fetchQueues = _props2.fetchQueues,
	          fetchPlaylists = _props2.fetchPlaylists;
	
	
	      if (error.queues) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching queue',
	          onRetry: fetchQueues
	        });
	      }
	
	      if (error.playlists) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching playlists',
	          onRetry: fetchPlaylists
	        });
	      }
	
	      if (!queues || !playlists) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var _props3 = this.props,
	          params = _props3.params,
	          entities = _props3.entities;
	
	
	      if (params.id) {
	        return _react2.default.createElement(_QueueEditor2.default, _extends({
	          ref: 'editor',
	          queue: params.id === 'create' ? null : entities.queues[params.id]
	        }, this.props));
	      }
	
	      if (queues.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Queues2.default.page },
	          _react2.default.createElement(_EmptyNotice2.default, {
	            heading: 'Create a queue',
	            text: 'A queue is a list of playlists to be presented in a channel.'
	          }),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/queues/create', className: _Queues2.default.button, style: { margin: '20px auto' } },
	            'Create a queue'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Queues2.default.page },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/queues/create', className: _Queues2.default.button },
	          'Create new queue'
	        ),
	        queues.map(this.renderQueue)
	      );
	    }
	  }]);
	
	  return Queues;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var queues = _ref2.queues,
	      playlists = _ref2.playlists,
	      albums = _ref2.albums,
	      entities = _ref2.entities,
	      search = _ref2.search,
	      auth = _ref2.auth;
	
	  return {
	    queues: queues.data && queues.data.map(function (id) {
	      return entities.queues[id];
	    }),
	    playlists: playlists.playlists && playlists.playlists.map(function (id) {
	      return entities.playlists[id];
	    }),
	    albums: albums.all.data && albums.all.data.map(function (id) {
	      return entities.albums[id];
	    }),
	    submitting: queues.submitting,
	    error: {
	      queues: queues.error,
	      playlists: playlists.error
	    },
	    entities: entities,
	    search: search,
	    getImageSource: (0, _images.createImageGetter)(auth),
	    checkForConflicts: function checkForConflicts(queue) {
	      return (0, _fetch.picassoFetch)(auth, 'validate_queue', { queue_id: queue.id });
	    },
	    sendToPlayNow: function sendToPlayNow(id) {
	      return (0, _fetch.picassoFetch)(auth, 'add_to_play_now', { queue_id: id });
	    },
	    userDefaultLocation: auth.user.location_address || auth.user.location
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return _extends({}, (0, _redux.bindActionCreators)({
	    fetchQueues: _queues.fetchQueues,
	    saveQueue: _queues.saveQueue,
	    deleteQueue: _queues.deleteQueue,
	    fetchPlaylists: _playlists.fetchPlaylists,
	    savePlaylist: _playlists.savePlaylist,
	    fetchAlbums: _albums.fetchAlbums,
	    searchImages: _search.searchImages
	  }, dispatch), {
	    editPlaylist: function editPlaylist(id) {
	      return dispatch((0, _reactRouterRedux.push)('/playlists/' + id));
	    },
	    presentChannel: function presentChannel(id) {
	      return dispatch((0, _reactRouterRedux.push)('/present/' + id));
	    }
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(Queues));

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Root;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(10);
	
	var _useScroll = __webpack_require__(1145);
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reduxAuthWrapper = __webpack_require__(1193);
	
	var _constants = __webpack_require__(3);
	
	var _App = __webpack_require__(551);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(555);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Login = __webpack_require__(559);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Album = __webpack_require__(550);
	
	var _Album2 = _interopRequireDefault(_Album);
	
	var _Image = __webpack_require__(208);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Hierarchy = __webpack_require__(554);
	
	var _Hierarchy2 = _interopRequireDefault(_Hierarchy);
	
	var _Timeline = __webpack_require__(568);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Users = __webpack_require__(573);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _Share = __webpack_require__(567);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _ExternalShares = __webpack_require__(310);
	
	var _ExternalShares2 = _interopRequireDefault(_ExternalShares);
	
	var _Playlists = __webpack_require__(561);
	
	var _Playlists2 = _interopRequireDefault(_Playlists);
	
	var _PlaylistEditor = __webpack_require__(209);
	
	var _PlaylistEditor2 = _interopRequireDefault(_PlaylistEditor);
	
	var _ListEditor = __webpack_require__(558);
	
	var _ListEditor2 = _interopRequireDefault(_ListEditor);
	
	var _List = __webpack_require__(311);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Queues = __webpack_require__(563);
	
	var _Queues2 = _interopRequireDefault(_Queues);
	
	var _DynamicLinks = __webpack_require__(553);
	
	var _DynamicLinks2 = _interopRequireDefault(_DynamicLinks);
	
	var _Libraries = __webpack_require__(557);
	
	var _Libraries2 = _interopRequireDefault(_Libraries);
	
	var _Channels = __webpack_require__(552);
	
	var _Channels2 = _interopRequireDefault(_Channels);
	
	var _PresentChannel = __webpack_require__(562);
	
	var _PresentChannel2 = _interopRequireDefault(_PresentChannel);
	
	var _Settings = __webpack_require__(566);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _UpdateKeywordVisibility = __webpack_require__(570);
	
	var _UpdateKeywordVisibility2 = _interopRequireDefault(_UpdateKeywordVisibility);
	
	var _UpdateKeywordStructure = __webpack_require__(569);
	
	var _UpdateKeywordStructure2 = _interopRequireDefault(_UpdateKeywordStructure);
	
	var _UpdateKeywordWeighting = __webpack_require__(571);
	
	var _UpdateKeywordWeighting2 = _interopRequireDefault(_UpdateKeywordWeighting);
	
	var _ScriptsInfo = __webpack_require__(565);
	
	var _ScriptsInfo2 = _interopRequireDefault(_ScriptsInfo);
	
	var _UserSessions = __webpack_require__(572);
	
	var _UserSessions2 = _interopRequireDefault(_UserSessions);
	
	var _Orchestras = __webpack_require__(560);
	
	var _Orchestras2 = _interopRequireDefault(_Orchestras);
	
	var _JoinOrchestra = __webpack_require__(556);
	
	var _JoinOrchestra2 = _interopRequireDefault(_JoinOrchestra);
	
	var _auth = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MATCH_ALBUM_PATH = /\/album\/[a-z0-9]+/i;
	var MATCH_ALBUM_EDIT_PATH = /\/album\/[a-z0-9]+\/edit/i;
	
	var routerMiddeware = (0, _useScroll2.default)(function (prevProps, props) {
	  if (!prevProps) return true;
	  if (MATCH_ALBUM_PATH.test(prevProps.location.pathname) && MATCH_ALBUM_EDIT_PATH.test(props.location.pathname)) {
	    return false;
	  }
	  return true;
	});
	
	var RequireAuth = (0, _reduxAuthWrapper.UserAuthWrapper)({
	  authSelector: function authSelector(state) {
	    return state.auth;
	  },
	  predicate: function predicate(auth) {
	    return auth.authenticated;
	  },
	  redirectAction: _reactRouterRedux.push,
	  failureRedirectPath: '/login'
	});
	
	function createAuthWrapper(fn) {
	  return (0, _reduxAuthWrapper.UserAuthWrapper)({
	    authSelector: function authSelector(state) {
	      return state.auth;
	    },
	    predicate: function predicate(auth) {
	      return auth.authenticated && (!fn || fn(auth.user));
	    },
	    redirectAction: _reactRouterRedux.push,
	    failureRedirectPath: '/',
	    allowRedirectBack: false
	  });
	}
	
	var RequireAdmin = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'admin');
	});
	var RequireSuperAdmin = createAuthWrapper(function (user) {
	  return (0, _auth.isSuperAdmin)(user);
	});
	var RequirePlaylistPerm = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'create_channels');
	});
	var RequireExternalShare = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'external_share');
	});
	var RequireChannels = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'create_channels') || (0, _auth.userHasPerm)(user, 'view_shared_channels');
	});
	var RequireSearchPerm = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'search_and_save');
	});
	var RequireDynamicLinks = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'dynamic_links');
	});
	var RequireHierarchy = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'view_hierarchy');
	});
	var RequireSettings = createAuthWrapper(function (user) {
	  return (0, _auth.userHasPerm)(user, 'image_config') || (0, _auth.isSuperAdmin)(user);
	});
	
	function Root(_ref) {
	  var store = _ref.store,
	      history = _ref.history;
	
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	      _reactRouter.Router,
	      { history: history, render: (0, _reactRouter.applyRouterMiddleware)(routerMiddeware) },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _App2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: RequireAuth(_Home2.default), title: '', showFeaturedAlbum: true }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _Login2.default, title: 'Login' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'search', component: RequireAuth(RequireSearchPerm(_Album2.default)), title: 'Search' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'timeline(/:decade)(/:year)(/:season)', component: RequireAuth(_Timeline2.default), title: 'Timeline' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'hierarchy', component: RequireAuth(RequireHierarchy(_Hierarchy2.default)), title: 'Album Hierarchy' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'album(/:id)(/:task)', component: RequireAuth(_Album2.default) }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'albums', component: RequireAuth(_Home2.default), title: 'Albums' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'image/:id', component: RequireAuth(_Image2.default), title: 'Image' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'users', component: RequireAuth(RequireAdmin(_Users2.default)), title: 'Users' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shares', component: RequireAuth(RequireExternalShare(_ExternalShares2.default)), title: 'Manage External Shares' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'share/:code', component: _Share2.default, title: 'Login' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'playlists', component: RequireAuth(RequirePlaylistPerm(_Playlists2.default)), title: 'Manage Playlists', playlists: true }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'playlists/create', component: RequireAuth(RequirePlaylistPerm(_PlaylistEditor2.default)), title: 'Create Playlist' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'playlists/:id', component: RequireAuth(RequirePlaylistPerm(_PlaylistEditor2.default)), title: 'Edit Playlist' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'groups', component: RequireAuth(_Playlists2.default), title: 'Manage Album Groups' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'groups/create', component: RequireAuth(_ListEditor2.default), title: 'Create New Group' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'groups/:id', component: RequireAuth(_ListEditor2.default), title: 'Edit Album Group' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'group/:id', component: RequireAuth(_List2.default), title: 'Album Group' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'queues', component: RequireAuth(RequirePlaylistPerm(_Queues2.default)), title: 'Manage Queues' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'queues/:id', component: RequireAuth(RequirePlaylistPerm(_Queues2.default)), title: 'Edit Queue' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'dynamics', component: RequireAuth(RequireDynamicLinks(_DynamicLinks2.default)), title: 'Manage Dynamic Tables' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'libraries', component: RequireAuth(RequireSuperAdmin(_Libraries2.default)), title: 'Manage Libraries' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'manage-keyword-visibility', component: RequireAuth(RequireSuperAdmin(_UpdateKeywordVisibility2.default)), title: 'Manage Keyword Visibility' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'manage-keyword-weighting', component: RequireAuth(RequireSuperAdmin(_UpdateKeywordWeighting2.default)), title: 'Manage Keyword Weighting' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'manage-keyword-updates', component: RequireAuth(RequireSuperAdmin(_UpdateKeywordStructure2.default)), title: 'Manage Keyword Updates' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'channels', component: RequireAuth(RequireChannels(_Channels2.default)), title: 'Manage Channels' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orchestras', component: RequireAuth(RequireChannels(_Orchestras2.default)), title: 'Manage Orchestras', socket: _constants.ORCHESTRA_SOCKET }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orchestras2', component: RequireAuth(RequireChannels(_Orchestras2.default)), title: 'Manage Orchestras 2', socket: _constants.ORCHESTRA_SOCKET_2 }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orchestra-tv', component: RequireAuth(RequireChannels(_Orchestras2.default)), title: 'Manage Orchestra TV', socket: _constants.ORCHESTRA_TV_SOCKET }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orchestra-tv2', component: RequireAuth(RequireChannels(_Orchestras2.default)), title: 'Manage Orchestra TV 2', socket: _constants.ORCHESTRA_TV_SOCKET_2 }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orchestras/join/:code', component: _JoinOrchestra2.default, title: 'Redirecting...' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'present/:instance_id(/:task)', component: RequireAuth(_PresentChannel2.default) }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: RequireAuth(RequireSettings(_Settings2.default)), title: 'Manage Image Configuration' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'scripts', component: RequireAuth(RequireSuperAdmin(_ScriptsInfo2.default)), title: 'Scripts Info' }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'sessions', component: RequireAuth(_UserSessions2.default), title: 'Manage Sessions' })
	      )
	    )
	  );
	}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _timeago = __webpack_require__(494);
	
	var _timeago2 = _interopRequireDefault(_timeago);
	
	var _lodash = __webpack_require__(919);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ScriptsInfo = __webpack_require__(864);
	
	var _ScriptsInfo2 = _interopRequireDefault(_ScriptsInfo);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatTimeAgo = new _timeago2.default().format;
	
	var KEY_CLEANUP_S3 = 'blayzr-cleanup-s3.py';
	var KEY_CREATE_ALBUMS = 'blayzr-create-albums.py';
	var KEY_CREATE_CANDIDATES = 'blayzr-create-candidates.py';
	var KEY_CREATE_IMAGE_VARIANTS = 'blayzr-create-image-variants.py';
	var KEY_CREATE_KEYWORDS = 'blayzr-create-keywords.py';
	var KEY_DATES = 'dates.py';
	var KEY_EVENT_PATH = 'eventpath.py';
	var KEY_BACKUP = 'backup.py';
	var KEY_GRAPH_BACKUP_UPDATED = 'graph_backup__updated_at';
	var KEY_GRAPH_DISCOVER_UPDATED = 'graph_discover__updated_at';
	var KEY_GRAPH_DISPLAY_UPDATED = 'graph_display__updated_at';
	var KEY_GRAPH_NEW_NODES = 'graph_new_nodes';
	var KEY_GRAPH_OLD_NODES = 'graph_old_nodes';
	var KEY_GRAPH_RESTORE = 'graph.py_restore';
	var KEY_GRAPH_STRUCTURE_UPDATED = 'graph_structure__updated_at';
	var KEY_GRAPH_UPDATED = 'graph_updated_date';
	var KEY_GRAPH_UPLOAD = 'graph.py_upload';
	var KEY_GRAPH_HIERARCHY_CREATED = 'graph_hierarchy_created_at';
	var KEY_S3_TO_ELASTICSEARCH = 'blayzr-s3-to-elasticsearch.py';
	var KEY_SET_ALBUM_COVERS = 'set-dynamic-albums-cover';
	var KEY_SET_ALBUMPATH_COUNTS = 'set_albumpath_counts.py';
	var KEY_UPLOAD_ALBUMPATHS = 'blayzr-upload-albumpaths.py';
	var KEY_UPLOAD_CANDIDATES = 'blayzr-upload-candidates.py';
	var KEY_UPLOAD_KEYWORD_HIERARCHY = 'blayzr-upload-keyword_hierarchy.py';
	
	var SCRIPT_LIST = [{
	  title: 'Data',
	  scripts: [KEY_DATES, KEY_EVENT_PATH, KEY_BACKUP]
	}, {
	  title: 'Scripts',
	  scripts: [KEY_CREATE_CANDIDATES, KEY_UPLOAD_CANDIDATES, KEY_CLEANUP_S3, KEY_CREATE_IMAGE_VARIANTS, KEY_SET_ALBUMPATH_COUNTS, KEY_SET_ALBUM_COVERS, KEY_CREATE_ALBUMS, KEY_CREATE_KEYWORDS, KEY_S3_TO_ELASTICSEARCH, KEY_UPLOAD_KEYWORD_HIERARCHY, KEY_UPLOAD_ALBUMPATHS]
	}, {
	  title: 'Graph',
	  scripts: [KEY_GRAPH_BACKUP_UPDATED, KEY_GRAPH_UPLOAD, KEY_GRAPH_RESTORE, KEY_GRAPH_NEW_NODES, KEY_GRAPH_OLD_NODES, KEY_GRAPH_DISPLAY_UPDATED, KEY_GRAPH_DISCOVER_UPDATED, KEY_GRAPH_STRUCTURE_UPDATED, KEY_GRAPH_UPDATED, KEY_GRAPH_HIERARCHY_CREATED]
	}];
	
	// Data
	// dates.py
	// eventpath.py
	// (both red if before s3-to-elasticsearch)
	
	// Scripts
	// Create candidates
	// Upload candidates (red if create is after it)
	// Cleanup S3 (red if upload cand is after)
	// Create image variants (red if upload cand is after it)
	// set album path counts (red if before upload cands)
	// set dyn album cover
	// Create albums (red if upload cand is after it)
	// Create keywords (red if upload cand is after it)
	// s3-to-elasticsearch (red if graph upload is before) (red if upload cand is after) (red if create keywords is after or create albums is after)
	
	// Graph
	// graph_last_backup (red if old node count is zero and backup is before last graph update time)
	// graph_upload (red if create keywords is after it)
	// graph_new_nodes
	// graph_old_nodes
	// graph_visibility_update (red if before last graph update)
	// graph_weighting_update (red if before last graph update)
	// graph_structure_update (red if before last graph update)
	
	var ScriptsInfo = function (_Component) {
	  _inherits(ScriptsInfo, _Component);
	
	  function ScriptsInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScriptsInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScriptsInfo.__proto__ || Object.getPrototypeOf(ScriptsInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: null,
	      error: null
	    }, _this.fetchData = function () {
	      _this.setState({
	        error: null,
	        fetching: true
	      });
	      _this.props.fetchData().then(function (data) {
	        return _this.setState({ data: data, fetching: false });
	      }, function (error) {
	        return _this.setState({ error: error, fetching: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScriptsInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(title, scripts, data) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { key: title },
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'tbody',
	            null,
	            scripts.map(function (key) {
	              return _this2.renderScript(key, data);
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderScript',
	    value: function renderScript(key, data) {
	      var flags = getFlags(key, data);
	      var rowClass = flags.length !== 0 ? _ScriptsInfo2.default.red : _ScriptsInfo2.default.row;
	      var isDate = typeof data[key] === 'string';
	      return _react2.default.createElement(
	        'tr',
	        { key: key, className: rowClass, title: flags.join(', ') || undefined },
	        _react2.default.createElement(
	          'td',
	          null,
	          key
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          isDate ? (0, _dateformat2.default)(new Date(data[key]), 'HH:MM, d mmm yyyy') : data[key]
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          isDate ? formatTimeAgo(new Date(data[key])) : null
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          fetching = _state.fetching,
	          error = _state.error;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching script info',
	          onRetry: this.fetchData
	        });
	      }
	
	      if (!data) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var allScripts = SCRIPT_LIST.reduce(function (array, list) {
	        return array.concat(list.scripts);
	      }, []);
	      var other = (0, _lodash2.default)(Object.keys(data), allScripts);
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ScriptsInfo2.default.page },
	        SCRIPT_LIST.map(function (list) {
	          return _this3.renderList(list.title, list.scripts, data);
	        }),
	        other.length !== 0 && this.renderList('Other', other, data),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.fetchData, disabled: fetching },
	          fetching ? 'Refreshing…' : 'Refresh Data'
	        )
	      );
	    }
	  }]);
	
	  return ScriptsInfo;
	}(_react.Component);
	
	function getFlags(key, data) {
	  var isEarlier = function isEarlier(k) {
	    return new Date(data[k]) < new Date(data[key]);
	  };
	  var isLater = function isLater(k) {
	    return new Date(data[k]) > new Date(data[key]);
	  };
	  var flags = [];
	  if (key === KEY_DATES || key === KEY_EVENT_PATH) {
	    if (isLater(KEY_S3_TO_ELASTICSEARCH)) {
	      flags.push(KEY_S3_TO_ELASTICSEARCH + ' should not be later than ' + key);
	    }
	  }
	  if (key === KEY_UPLOAD_CANDIDATES) {
	    if (isLater(KEY_CREATE_CANDIDATES)) {
	      flags.push(KEY_CREATE_CANDIDATES + ' should not be later than ' + key);
	    }
	  }
	  if ([KEY_CLEANUP_S3, KEY_CREATE_IMAGE_VARIANTS, KEY_SET_ALBUMPATH_COUNTS, KEY_CREATE_ALBUMS, KEY_CREATE_KEYWORDS, KEY_S3_TO_ELASTICSEARCH].indexOf(key) !== -1) {
	    if (isLater(KEY_UPLOAD_CANDIDATES)) {
	      flags.push(KEY_UPLOAD_CANDIDATES + ' should not be later than ' + key);
	    }
	  }
	  if (key === KEY_S3_TO_ELASTICSEARCH) {
	    if (isEarlier(KEY_GRAPH_UPLOAD)) {
	      flags.push(KEY_GRAPH_UPLOAD + ' should not be earlier than ' + key);
	    }
	    if (isLater(KEY_CREATE_KEYWORDS)) {
	      flags.push(KEY_CREATE_KEYWORDS + ' should not be later than ' + key);
	    }
	    if (isLater(KEY_CREATE_ALBUMS)) {
	      flags.push(KEY_CREATE_ALBUMS + ' should not be later than ' + key);
	    }
	  }
	  if (key === 'KEY_GRAPH_BACKUP_UPDATED') {
	    if (data[KEY_GRAPH_OLD_NODES] === 0 && isLater(KEY_GRAPH_UPDATED)) {
	      flags.push(KEY_GRAPH_UPDATED + ' should not be later than ' + key + ' when ' + KEY_GRAPH_OLD_NODES + ' is zero');
	    }
	  }
	  if (key === KEY_GRAPH_UPLOAD) {
	    if (isLater(KEY_CREATE_KEYWORDS)) {
	      flags.push(KEY_CREATE_KEYWORDS + ' should not be later than ' + key);
	    }
	  }
	  if ([KEY_GRAPH_DISPLAY_UPDATED, KEY_GRAPH_DISCOVER_UPDATED, KEY_GRAPH_STRUCTURE_UPDATED].indexOf(key) !== -1) {
	    if (isLater(KEY_GRAPH_UPDATED)) {
	      flags.push(KEY_GRAPH_UPDATED + ' should not be later than ' + key);
	    }
	  }
	  return flags;
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth;
	  return {
	    fetchData: function fetchData() {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_SCRIPTS_INFO, {
	        token: auth.token
	      });
	    }
	  };
	};
	
	var mapDispatchToProps = {};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ScriptsInfo);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _lscache = __webpack_require__(102);
	
	var _lscache2 = _interopRequireDefault(_lscache);
	
	var _lodash = __webpack_require__(100);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Settings = __webpack_require__(865);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _users = __webpack_require__(68);
	
	var _auth = __webpack_require__(42);
	
	var _banners = __webpack_require__(67);
	
	var _auth2 = __webpack_require__(20);
	
	var _Checklist = __webpack_require__(126);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TAB = 'user';
	
	var Settings = function (_Component) {
	  _inherits(Settings, _Component);
	
	  function Settings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Settings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Settings.__proto__ || Object.getPrototypeOf(Settings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tab: DEFAULT_TAB,
	      data: getData(_this.props, DEFAULT_TAB),
	      submitting: false
	    }, _this.updateData = function (key, value) {
	      _this.setState({
	        data: _extends({}, _this.state.data, _defineProperty({}, key, value))
	      });
	    }, _this.switchTab = function (e) {
	      var tab = e.target.value;
	      _this.setState({
	        tab: tab,
	        data: getData(_this.props, tab)
	      });
	    }, _this.isUnsaved = function () {
	      return (0, _lodash2.default)(getData(_this.props, _this.state.tab), _this.state.data) === false;
	    }, _this.onSubmit = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          user = _this$props.user,
	          updateUser = _this$props.updateUser,
	          updateGlobalSettings = _this$props.updateGlobalSettings,
	          refreshTokens = _this$props.refreshTokens;
	      var _this$state = _this.state,
	          tab = _this$state.tab,
	          data = _this$state.data;
	
	      _this.setState({ submitting: true });
	      if (tab === 'user') {
	        updateUser(user.id, _extends({}, user, {
	          settings: JSON.stringify(data)
	        }), false).then(_this.onSuccess);
	      }
	      if (tab === 'global') {
	        updateGlobalSettings(data).then(_this.onSuccess);
	      }
	      if (tab === 'local') {
	        _lscache2.default.set(_constants.SETTINGS_CACHE_KEY, data);
	        refreshTokens().then(_this.onSuccess);
	      }
	    }, _this.onSuccess = function () {
	      _this.setState({
	        submitting: false
	      });
	      _this.props.showBanner('Settings updated');
	    }, _this.onReset = function () {
	      var _this$props2 = _this.props,
	          refreshTokens = _this$props2.refreshTokens,
	          global = _this$props2.global;
	      var tab = _this.state.tab;
	
	      _this.setState({
	        data: tab === 'global' ? _constants.DEFAULT_SETTINGS : global
	      });
	      if (tab === 'local') {
	        _lscache2.default.remove(_constants.SETTINGS_CACHE_KEY);
	        refreshTokens();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Settings, [{
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _this2 = this;
	
	      var canEditGlobal = this.props.canEditGlobal;
	      var tab = this.state.tab;
	
	      var renderButton = function renderButton(value) {
	        return _react2.default.createElement(
	          'button',
	          {
	            key: value,
	            type: 'button',
	            onClick: _this2.switchTab,
	            value: value,
	            className: tab === value ? _Settings2.default.smallButtonActive : _Settings2.default.smallButton },
	          value
	        );
	      };
	      return _react2.default.createElement(
	        'header',
	        { className: _Settings2.default.header },
	        renderButton('local'),
	        renderButton('user'),
	        canEditGlobal ? renderButton('global') : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var error = this.props.error;
	      var _state = this.state,
	          tab = _state.tab,
	          data = _state.data,
	          submitting = _state.submitting;
	
	      return _react2.default.createElement(
	        'form',
	        { className: _Settings2.default.page, onSubmit: this.onSubmit },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'p',
	          { className: _Settings2.default.note },
	          tab === 'local' && 'Local settings will apply to only this device.',
	          tab === 'user' && 'User settings will apply to all devices you use.',
	          tab === 'global' && 'Global settings will apply to all users.'
	        ),
	        _react2.default.createElement(_Checklist2.default, {
	          value: data.aws ? [true] : [],
	          items: [{
	            value: true,
	            title: 'Use S3 for images'
	          }],
	          onChange: function onChange(data) {
	            return _this3.updateData('aws', data.length === 1);
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _Settings2.default.label },
	          'Local image path',
	          _react2.default.createElement('input', {
	            type: 'text',
	            disabled: data.aws,
	            value: data.imagePath || '',
	            onChange: function onChange(e) {
	              return _this3.updateData('imagePath', e.target.value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Settings2.default.label },
	          'Icon variant',
	          _react2.default.createElement(VariantPicker, {
	            value: data.iconVariant,
	            onChange: function onChange(value) {
	              return _this3.updateData('iconVariant', value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Settings2.default.label },
	          'Thumbnail variant',
	          _react2.default.createElement(VariantPicker, {
	            value: data.thumbVariant,
	            onChange: function onChange(value) {
	              return _this3.updateData('thumbVariant', value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Settings2.default.label },
	          'Display variant',
	          _react2.default.createElement(VariantPicker, {
	            value: data.displayVariant,
	            onChange: function onChange(value) {
	              return _this3.updateData('displayVariant', value);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Settings2.default.label },
	          'Present variant',
	          _react2.default.createElement(VariantPicker, {
	            value: data.presentVariant,
	            onChange: function onChange(value) {
	              return _this3.updateData('presentVariant', value);
	            }
	          })
	        ),
	        _react2.default.createElement('input', {
	          type: 'submit',
	          value: 'Save',
	          disabled: submitting || !this.isUnsaved(),
	          className: _Settings2.default.submit
	        }),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            onClick: this.onReset,
	            className: _Settings2.default.reset },
	          'Reset to ',
	          tab === 'global' ? 'system' : 'global',
	          ' defaults'
	        ),
	        _react2.default.createElement(_LoadingSpinner2.default, { show: submitting }),
	        error && _react2.default.createElement(
	          'p',
	          { className: _Settings2.default.error },
	          'There was an error saving settings'
	        )
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react.Component);
	
	function VariantPicker(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _constants.IMAGE_VARIANTS.map(function (variant) {
	      return _react2.default.createElement(
	        'button',
	        {
	          key: variant,
	          type: 'button',
	          onClick: function onClick() {
	            return onChange(variant);
	          },
	          className: value === variant ? _Settings2.default.smallButtonActive : _Settings2.default.smallButton },
	        variant
	      );
	    })
	  );
	}
	
	function getData(props, tab) {
	  var settings = void 0;
	  if (tab === 'user') {
	    settings = props.user.original_settings;
	  }
	  if (tab === 'local') {
	    settings = _lscache2.default.get(_constants.SETTINGS_CACHE_KEY);
	  }
	  if (tab === 'global') {
	    settings = props.global;
	  }
	  return _extends({}, _constants.DEFAULT_SETTINGS, props.global, settings);
	}
	
	var mapStateToProps = function mapStateToProps(_ref3) {
	  var auth = _ref3.auth,
	      users = _ref3.users;
	  return {
	    user: auth.user,
	    global: JSON.parse(auth.user.global_settings),
	    local: _lscache2.default.get(_constants.SETTINGS_CACHE_KEY),
	    canEditGlobal: (0, _auth2.isSuperAdmin)(auth.user),
	    error: users.error
	  };
	};
	
	var mapDispatchToProps = {
	  updateUser: _users.updateUser,
	  updateGlobalSettings: _users.updateGlobalSettings,
	  refreshTokens: _auth.refreshTokens,
	  showBanner: _banners.showBanner
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Settings);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _auth = __webpack_require__(42);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Share = function (_Component) {
	  _inherits(Share, _Component);
	
	  function Share() {
	    _classCallCheck(this, Share);
	
	    return _possibleConstructorReturn(this, (Share.__proto__ || Object.getPrototypeOf(Share)).apply(this, arguments));
	  }
	
	  _createClass(Share, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          params = _props.params,
	          location = _props.location,
	          shareLogin = _props.shareLogin;
	
	      shareLogin(params.code, location.query.path);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var error = this.props.error;
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, { message: 'The code given is invalid or has expired.' });
	      }
	      return _react2.default.createElement(_LoadingSpinner2.default, null);
	    }
	  }]);
	
	  return Share;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var auth = _ref.auth;
	  return {
	    error: auth.error
	  };
	};
	
	var mapDispatchToProps = {
	  shareLogin: _auth.shareLogin
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Share);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactSticky = __webpack_require__(293);
	
	var _Timeline = __webpack_require__(866);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _search = __webpack_require__(59);
	
	var _hierarchy = __webpack_require__(129);
	
	var _images = __webpack_require__(23);
	
	var _string = __webpack_require__(16);
	
	var _TimelinePeriod = __webpack_require__(503);
	
	var _TimelinePeriod2 = _interopRequireDefault(_TimelinePeriod);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STARTING_DECADE = 1880;
	var CURRENT_YEAR = new Date().getFullYear();
	var CURRENT_DECADE = Math.floor(CURRENT_YEAR / 10) * 10;
	
	var Timeline = function (_Component) {
	  _inherits(Timeline, _Component);
	
	  function Timeline() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Timeline);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showNext: 0,
	      showPrevious: 0,
	      expanded: []
	    }, _this.toggleExpanded = function (path) {
	      if (_this.isExpanded(path)) {
	        _this.setState({ expanded: _this.state.expanded.filter(function (p) {
	            return p !== path;
	          }) });
	      } else {
	        _this.setState({ expanded: _this.state.expanded.concat(path) });
	      }
	    }, _this.renderPeriod = function (period, previous) {
	      var _this$props = _this.props,
	          searchImages = _this$props.searchImages,
	          search = _this$props.search,
	          getImageSource = _this$props.getImageSource;
	      var title = period.title,
	          href = period.href,
	          count = period.count,
	          hideIfZero = period.hideIfZero;
	
	      if (count === 0) {
	        if (hideIfZero) {
	          return null;
	        }
	        // Really hacky.. Return null if last 4 array elements are all gaps
	        var prevGaps = previous instanceof Array && previous.slice(-4).filter(function (o) {
	          return !o || /^gap-/.test(o.key);
	        }).length;
	        if (prevGaps === 4) {
	          return null;
	        }
	        return _react2.default.createElement('li', { key: 'gap-' + href, className: _Timeline2.default.gap });
	      }
	      var expanded = period.path && _this.isExpanded(period.path[0]);
	      var onClickExpand = function onClickExpand(e) {
	        e.stopPropagation();
	        _this.toggleExpanded(period.path[0]);
	      };
	      var periods = [_react2.default.createElement(_TimelinePeriod2.default, _extends({}, period, {
	        key: href,
	        title: (0, _string.tidyAlbumTitle)(title),
	        search: search,
	        searchImages: searchImages,
	        getImageSource: getImageSource,
	        expanded: expanded,
	        onClickExpand: period.subevents ? onClickExpand : null
	      }))];
	      if (expanded) {
	        periods = periods.concat(period.subevents.map(_this.renderPeriod));
	      }
	      return periods;
	    }, _this.showPrevious = function () {
	      var prevHeight = document.body.scrollHeight;
	      _this.setState({
	        showPrevious: _this.state.showPrevious - 1
	      }, function () {
	        window.scrollBy(0, document.body.scrollHeight - prevHeight);
	      });
	    }, _this.showNext = function () {
	      _this.setState({
	        showNext: _this.state.showNext + 1
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Timeline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          hierarchy = _props.hierarchy,
	          fetchHierarchy = _props.fetchHierarchy;
	
	      if (!hierarchy.data) {
	        fetchHierarchy();
	      }
	      var _props2 = this.props,
	          pathCounts = _props2.pathCounts,
	          fetchAlbumPathCounts = _props2.fetchAlbumPathCounts;
	
	      if (!pathCounts.data) {
	        fetchAlbumPathCounts();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props$params = this.props.params,
	          season = _props$params.season,
	          year = _props$params.year;
	
	      if (season !== nextProps.params.season || year !== nextProps.params.year) {
	        this.setState({
	          showNext: 0,
	          showPrevious: 0
	        });
	      }
	    }
	  }, {
	    key: 'isExpanded',
	    value: function isExpanded(path) {
	      return this.state.expanded.indexOf(path) !== -1;
	    }
	  }, {
	    key: 'renderBreadcrumbs',
	    value: function renderBreadcrumbs(decade, year, season) {
	      if (!decade) {
	        return null;
	      }
	      var crumbs = [{ text: 'Timeline', href: '/timeline' }, { text: decade + 's', href: '/timeline/' + decade }];
	      if (year) {
	        crumbs.push({ text: year, href: '/timeline/' + decade + '/' + year });
	      }
	      if (season) {
	        crumbs.push({ text: season.slice(3), href: '/timeline/' + decade + '/' + year + '/' + season });
	      }
	      return _react2.default.createElement(
	        _reactSticky.Sticky,
	        { key: 'breadcrumbs' + decade + year + season, className: _Timeline2.default.breadcrumbs },
	        crumbs.map(function (link) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { key: link.href, to: link.href, className: _Timeline2.default.breadcrumb },
	            link.text
	          );
	        })
	      );
	    }
	  }, {
	    key: 'getOthers',
	    value: function getOthers(decade, year) {
	      var _this2 = this;
	
	      var hierarchy = this.props.hierarchy;
	
	
	      if (!hierarchy.data) {
	        return [];
	      }
	      return hierarchy.data['<leaves>'].reduce(function (periods, library) {
	        if (year) {
	          var data = hierarchy.data[library][decade + 's'];
	          if (data && data['<leaves>'].indexOf(year) !== -1 && !data[year]) {
	            var path = '/COLLECTIONS/' + library + '/' + decade + 's/' + year;
	            periods.push(_this2.renderPeriod({
	              title: 'Other pictures in ' + year + ' (' + library + ')',
	              path: [path],
	              href: '/album?path=' + encodeURIComponent(path) + '&referrer=timeline',
	              count: _this2.getCount(decade + 's/' + year)
	            }));
	          }
	          if (data && data[year]) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = data[year]['<leaves>'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var leaf = _step.value;
	
	                if (_constants.TIMELINE_SEASONS.indexOf(leaf) === -1) {
	                  var _path = '/COLLECTIONS/' + library + '/' + decade + 's/' + year + '/' + leaf;
	                  periods.push(_this2.renderPeriod({
	                    title: library + ' \xBB ' + year + ' \xBB ' + leaf,
	                    path: [_path],
	                    href: '/album?path=' + encodeURIComponent(_path) + '&referrer=timeline',
	                    count: _this2.getCount(decade + 's/' + year + '/' + leaf)
	                  }));
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	          }
	        } else {
	          var _data = hierarchy.data[library];
	          if (_data && _data['<leaves>'].indexOf(decade + 's') !== -1 && !_data[decade + 's']) {
	            var _path2 = '/COLLECTIONS/' + library + '/' + decade + 's';
	            periods.push(_this2.renderPeriod({
	              title: 'Other pictures in ' + decade + 's (' + library + ')',
	              path: [_path2],
	              href: '/album?path=' + encodeURIComponent(_path2) + '&referrer=timeline',
	              count: _this2.getCount(decade + 's')
	            }));
	          }
	          if (_data && _data[decade + 's']) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = _data[decade + 's']['<leaves>'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _leaf = _step2.value;
	
	                if (/^\d\d\d\d$/.test(_leaf) === false && _leaf !== 'Unknown Year') {
	                  var _path3 = '/COLLECTIONS/' + library + '/' + decade + 's/' + _leaf;
	                  periods.push(_this2.renderPeriod({
	                    title: library + ' \xBB ' + _leaf,
	                    path: [_path3],
	                    href: '/album?path=' + encodeURIComponent(_path3) + '&referrer=timeline',
	                    count: _this2.getCount(decade + 's/' + _leaf)
	                  }));
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	          }
	        }
	        return periods;
	      }, []);
	    }
	  }, {
	    key: 'getSeason',
	    value: function getSeason(decade, year, season) {
	      var _this3 = this;
	
	      var hierarchy = this.props.hierarchy;
	
	
	      var events = hierarchy.data['<leaves>'].reduce(function (periods, library) {
	        try {
	          var _events = hierarchy.data[library][decade + 's'][year][season]['<leaves>'].sort().filter(filterEvents);
	          periods = periods.concat(_events.filter(filterEvents).map(function (event) {
	            var subevents = hierarchy.data[library][decade + 's'][year][season][event];
	            var path = '/COLLECTIONS/' + library + '/' + decade + 's/' + year + '/' + season + '/' + event;
	            return {
	              title: event,
	              path: [path],
	              href: '/album?path=' + encodeURIComponent(path) + '&referrer=timeline',
	              count: _this3.getCount(decade + 's/' + year + '/' + season + '/' + event),
	              subevents: subevents && subevents['<leaves>'].map(function (subevent) {
	                return {
	                  title: subevent,
	                  path: [path + '/' + subevent],
	                  href: '/album?path=' + encodeURIComponent(path + '/' + subevent) + '&referrer=timeline',
	                  count: _this3.getCount(decade + 's/' + year + '/' + season + '/' + event + '/' + subevent),
	                  subevent: true
	                };
	              })
	            };
	          }));
	          return periods;
	        } catch (e) {
	          return periods;
	        }
	      }, []).map(this.renderPeriod);
	
	      return events;
	    }
	  }, {
	    key: 'getPeriods',
	    value: function getPeriods() {
	      var _this4 = this;
	
	      var params = this.props.params;
	      var decade = params.decade,
	          year = params.year,
	          season = params.season;
	
	
	      var periods = [];
	
	      if (season) {
	        var nodes = [];
	        var _state = this.state,
	            showNext = _state.showNext,
	            showPrevious = _state.showPrevious;
	
	        for (var i = showPrevious; i <= showNext; i++) {
	          var seasonIndex = _constants.TIMELINE_SEASONS.indexOf(season) + i;
	          var newSeason = _constants.TIMELINE_SEASONS[mod(seasonIndex, _constants.TIMELINE_SEASONS.length)];
	          var newYear = parseInt(year) + Math.floor(seasonIndex / _constants.TIMELINE_SEASONS.length);
	          var newDecade = parseInt(newYear / 10, 10) * 10;
	          if (year === 'Unknown Year') {
	            newYear = year;
	            newDecade = decade;
	          }
	          nodes.push(_react2.default.createElement(
	            _reactSticky.StickyContainer,
	            { key: i },
	            this.renderBreadcrumbs(newDecade, newYear, newSeason),
	            this.getSeason(newDecade, newYear, newSeason)
	          ));
	        }
	        return nodes;
	      }
	
	      if (year) {
	        var _nodes = [];
	        var _state2 = this.state,
	            _showNext = _state2.showNext,
	            _showPrevious = _state2.showPrevious;
	
	        var _loop = function _loop(_i) {
	          var newYear = parseInt(year) + _i;
	          var newDecade = parseInt(newYear / 10, 10) * 10;
	          if (year === 'Unknown Year') {
	            newYear = year;
	            newDecade = decade;
	          }
	          var others = _this4.getOthers(newDecade, newYear);
	          _nodes.push(_react2.default.createElement(
	            _reactSticky.StickyContainer,
	            { key: _i },
	            _this4.renderBreadcrumbs(newDecade, newYear),
	            _constants.TIMELINE_SEASONS.map(function (i) {
	              return _this4.renderPeriod({
	                title: i,
	                terms: [newDecade + 's', newYear, i],
	                href: '/timeline/' + newDecade + '/' + newYear + '/' + i,
	                count: _this4.getCount(newDecade + 's/' + newYear + '/' + i),
	                hideIfZero: i === _constants.UNKNOWN_SEASON || i === _constants.YEAR_SELECTS
	              });
	            }),
	            others.length !== 0 && _react2.default.createElement('li', { className: _Timeline2.default.gap }),
	            others
	          ));
	        };
	
	        for (var _i = _showPrevious; _i <= _showNext; _i++) {
	          _loop(_i);
	        }
	        return _nodes;
	      }
	
	      if (decade) {
	        periods.push(this.renderBreadcrumbs(decade));
	        for (var _i2 = parseInt(decade); _i2 < parseInt(decade) + 10; _i2++) {
	          if (_i2 > CURRENT_YEAR) continue;
	          periods.push(this.renderPeriod({
	            title: _i2,
	            terms: [decade + 's', _i2],
	            href: '/timeline/' + decade + '/' + _i2,
	            count: this.getCount(decade + 's/' + _i2)
	          }, periods));
	        }
	        periods.push(this.renderPeriod({
	          title: 'Unknown Year',
	          terms: [decade + 's', 'Unknown Year'],
	          href: '/timeline/' + decade + '/Unknown Year',
	          count: this.getCount(decade + 's/Unknown Year'),
	          hideIfZero: true
	        }));
	        return periods;
	      }
	
	      for (var _i3 = STARTING_DECADE; _i3 <= CURRENT_DECADE; _i3 += 10) {
	        var title = _i3 + 's';
	        var count = this.getCount(title);
	        if (periods.length === 0 && !count) {
	          continue;
	        }
	        periods.push(this.renderPeriod({
	          title: title,
	          terms: [title],
	          href: '/timeline/' + _i3,
	          count: count
	        }));
	      }
	      return periods;
	    }
	  }, {
	    key: 'getCount',
	    value: function getCount(path) {
	      var _props3 = this.props,
	          hierarchy = _props3.hierarchy,
	          pathCounts = _props3.pathCounts;
	
	      if (!pathCounts.data) {
	        return 0;
	      }
	      var count = 0;
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = hierarchy.data['<leaves>'][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var library = _step3.value;
	
	          var key = '/COLLECTIONS/' + library + '/' + path;
	          count += pathCounts.data[key] || 0;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return count;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          params = _props4.params,
	          hierarchy = _props4.hierarchy,
	          pathCounts = _props4.pathCounts;
	      var decade = params.decade,
	          year = params.year,
	          season = params.season;
	
	      var others = !season && !year ? this.getOthers(decade) : [];
	
	      if (!hierarchy.data || !pathCounts.data) {
	        return _react2.default.createElement(
	          'div',
	          { className: _Timeline2.default.page },
	          _react2.default.createElement(_LoadingSpinner2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactSticky.StickyContainer,
	        { className: _Timeline2.default.page },
	        _react2.default.createElement(
	          'ul',
	          { className: _Timeline2.default.periods },
	          year && year !== 'Unknown Year' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              { onClick: this.showPrevious, className: _Timeline2.default.button },
	              'Load earlier'
	            )
	          ),
	          this.getPeriods(),
	          others.length !== 0 && _react2.default.createElement('li', { className: _Timeline2.default.gap }),
	          others,
	          year && year !== 'Unknown Year' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              { onClick: this.showNext, className: _Timeline2.default.button },
	              'Load next'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Timeline;
	}(_react.Component);
	
	// http://stackoverflow.com/a/1082938
	
	
	function mod(x, m) {
	  return (x % m + m) % m;
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var search = _ref2.search,
	      auth = _ref2.auth,
	      hierarchy = _ref2.hierarchy;
	  return {
	    search: search,
	    hierarchy: hierarchy,
	    pathCounts: hierarchy.paths,
	    getImageSource: (0, _images.createImageGetter)(auth)
	  };
	};
	
	var mapDispatchToProps = {
	  searchImages: _search.searchImages,
	  fetchHierarchy: _hierarchy.fetchHierarchy,
	  fetchAlbumPathCounts: _hierarchy.fetchAlbumPathCounts
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Timeline);
	
	
	function filterEvents(event) {
	  return (/^_/.test(event) === false
	  );
	}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactSticky = __webpack_require__(293);
	
	var _UpdateKeywordVisibility = __webpack_require__(244);
	
	var _UpdateKeywordVisibility2 = _interopRequireDefault(_UpdateKeywordVisibility);
	
	var _keywords = __webpack_require__(107);
	
	var _KeywordGraphPicker = __webpack_require__(128);
	
	var _KeywordGraphPicker2 = _interopRequireDefault(_KeywordGraphPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateKeywordStructure = function (_Component) {
	  _inherits(UpdateKeywordStructure, _Component);
	
	  function UpdateKeywordStructure() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UpdateKeywordStructure);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdateKeywordStructure.__proto__ || Object.getPrototypeOf(UpdateKeywordStructure)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selected: [],
	      saving: false,
	      updating: false,
	      error: null,
	      enableAllNewNodes: false
	    }, _this.updateGraph = function () {
	      _this.setState({
	        saving: false,
	        updating: true
	      });
	      return _this.props.fetchKeywordGraph().then(function () {
	        _this.setState({
	          selected: [],
	          updating: false
	        });
	      });
	    }, _this.onSave = function () {
	      _this.setState({
	        saving: true,
	        error: null
	      });
	      _this.props.mergeNodes(_this.state.selected[0]._id, _this.state.selected[1]._id).then(function (data) {
	        if (data.result.nodes_merged && data.result.parent_update.length === 0) {
	          // No common parent, so whole graph must be refreshed
	          return _this.updateGraph();
	        }
	        _this.onSuccess();
	      }, _this.onError);
	    }, _this.onDelete = function () {
	      _this.setState({ saving: true, error: null });
	      _this.props.deleteNode(_this.state.selected[0]._id).then(_this.onSuccess, _this.onError);
	    }, _this.onTouchNode = function () {
	      _this.setState({ saving: true, error: null });
	      _this.props.touchNode(_this.state.selected[0], 'structure__updated_at').then(_this.onSuccess, _this.onError);
	    }, _this.onSuccess = function () {
	      _this.setState({
	        selected: [],
	        saving: false
	      });
	    }, _this.onError = function (error) {
	      _this.setState({
	        saving: false,
	        error: error
	      });
	      window.alert('An error occured: ' + (error.message || error.statusText));
	    }, _this.onSelect = function (node) {
	      var selected = _this.state.selected;
	
	      var index = selected.findIndex(function (n) {
	        return n._id === node._id;
	      });
	      if (index === -1 && selected.length < 2) {
	        if (selected.length === 1) {
	          if (selected[0].isOld && !node.isNew) {
	            return;
	          }
	          if (selected[0].isNew && !node.isOld) {
	            return;
	          }
	        }
	        _this.setState({
	          selected: selected.concat(node).slice(-2),
	          error: null
	        });
	      } else {
	        _this.setState({
	          selected: selected.filter(function (n) {
	            return n._id !== node._id;
	          }),
	          error: null
	        });
	      }
	    }, _this.onCancel = function () {
	      _this.setState({ selected: [] });
	    }, _this.toggleQuiteNewNodes = function () {
	      _this.setState({
	        enableAllNewNodes: !_this.state.enableAllNewNodes
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UpdateKeywordStructure, [{
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var _state = this.state,
	          selected = _state.selected,
	          saving = _state.saving,
	          updating = _state.updating;
	
	
	      var oldNode = selected.filter(function (n) {
	        return n.isOld;
	      })[0];
	      var newNode = selected.filter(function (n) {
	        return n.isNew;
	      })[0];
	
	      return _react2.default.createElement(
	        _reactSticky.Sticky,
	        { className: _UpdateKeywordVisibility2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: oldNode ? _UpdateKeywordVisibility2.default.headerNode : _UpdateKeywordVisibility2.default.headerNodeEmpty },
	          _react2.default.createElement(
	            'div',
	            { className: _UpdateKeywordVisibility2.default.headerNodeHeading },
	            'Old Node'
	          ),
	          oldNode ? oldNode.name : 'None'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: newNode ? _UpdateKeywordVisibility2.default.headerNode : _UpdateKeywordVisibility2.default.headerNodeEmpty },
	          _react2.default.createElement(
	            'div',
	            { className: _UpdateKeywordVisibility2.default.headerNodeHeading },
	            'New Node'
	          ),
	          newNode ? newNode.name : 'None'
	        ),
	        selected.length === 1 && selected[0].isOld && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.onDelete,
	            className: _UpdateKeywordVisibility2.default.deleteButton,
	            disabled: saving || updating },
	          updating ? 'Refreshing…' : saving ? 'Deleting…' : 'Delete'
	        ),
	        selected.length === 1 && selected[0].isNew && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.onTouchNode,
	            className: _UpdateKeywordVisibility2.default.saveButton,
	            disabled: saving || updating },
	          saving ? 'Confirming…' : 'Confirm as new'
	        ),
	        canMerge(selected) && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.onSave,
	            className: _UpdateKeywordVisibility2.default.saveButton,
	            disabled: saving || updating },
	          updating ? 'Refreshing…' : saving ? 'Merging…' : 'Merge'
	        ),
	        selected.length !== 0 && _react2.default.createElement(
	          'button',
	          {
	            onClick: this.onCancel,
	            className: _UpdateKeywordVisibility2.default.resetButton },
	          'Cancel'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          selected = _state2.selected,
	          saving = _state2.saving,
	          updating = _state2.updating,
	          error = _state2.error;
	
	      return _react2.default.createElement(
	        _reactSticky.StickyContainer,
	        { className: _UpdateKeywordVisibility2.default.page },
	        this.renderHeader(),
	        _react2.default.createElement(
	          'p',
	          { className: _UpdateKeywordVisibility2.default.note },
	          'To merge nodes, select a ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.noteOld },
	            'Deleted or Moved'
	          ),
	          ' node and a ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.noteNew },
	            'New'
	          ),
	          ' node and confirm.',
	          _react2.default.createElement('br', null),
	          'To delete a node, select only a ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.noteOld },
	            'Deleted or Moved'
	          ),
	          ' node and confirm.',
	          _react2.default.createElement('br', null),
	          'To mark a node as new, select only a ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.noteNew },
	            'New'
	          ),
	          ' node and confirm.',
	          _react2.default.createElement('br', null),
	          'Where possible, merge top-level nodes first \u2013 children will be automatically resolved.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (saving || updating) && _UpdateKeywordVisibility2.default.disabled },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              checked: this.state.enableAllNewNodes,
	              onChange: this.toggleQuiteNewNodes
	            }),
	            'Enable all new nodes'
	          ),
	          _react2.default.createElement(_KeywordGraphPicker2.default, {
	            selected: selected.map(function (n) {
	              return n._id;
	            }),
	            onSelect: this.onSelect,
	            showIndicators: true,
	            showUpdatedTime: 'structure__updated_at',
	            showBackupTime: true,
	            showOldNewCounts: true,
	            enableOld: true,
	            enableNew: true,
	            enableAllNew: this.state.enableAllNewNodes,
	            stickyBarTop: '59px'
	          }),
	          _react2.default.createElement(
	            'label',
	            { style: { marginBottom: '3px' } },
	            'Tags'
	          ),
	          _react2.default.createElement(_KeywordGraphPicker2.default, { tags: true, disableFetch: true })
	        ),
	        error && _react2.default.createElement(
	          'p',
	          { className: _UpdateKeywordVisibility2.default.error },
	          'Error: ',
	          error.message || error.statusText
	        )
	      );
	    }
	  }]);
	
	  return UpdateKeywordStructure;
	}(_react.Component);
	
	function canMerge(selected) {
	  if (selected.length !== 2) {
	    return false;
	  }
	  if (selected[0].isOld && selected[1].isNew) {
	    return true;
	  }
	  if (selected[1].isOld && selected[0].isNew) {
	    return true;
	  }
	  return false;
	}
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth;
	  return {};
	};
	
	var mapDispatchToProps = {
	  mergeNodes: _keywords.mergeNodes,
	  deleteNode: _keywords.deleteNode,
	  touchNode: _keywords.touchNode,
	  fetchKeywordGraph: _keywords.fetchKeywordGraph
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdateKeywordStructure);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _UpdateKeywordVisibility = __webpack_require__(244);
	
	var _UpdateKeywordVisibility2 = _interopRequireDefault(_UpdateKeywordVisibility);
	
	var _keywords = __webpack_require__(107);
	
	var _KeywordGraphPicker = __webpack_require__(128);
	
	var _KeywordGraphPicker2 = _interopRequireDefault(_KeywordGraphPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateKeywordVisibility = function (_Component) {
	  _inherits(UpdateKeywordVisibility, _Component);
	
	  function UpdateKeywordVisibility() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UpdateKeywordVisibility);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdateKeywordVisibility.__proto__ || Object.getPrototypeOf(UpdateKeywordVisibility)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      updatedNodes: {},
	      saving: false
	    }, _this.updateNodes = function (updatedNodes) {
	      _this.setState({ updatedNodes: updatedNodes });
	    }, _this.onSave = function () {
	      _this.setState({ saving: true });
	      _this.props.updateGraphNodes(_this.state.updatedNodes).then(function () {
	        return _this.setState({
	          saving: false,
	          updatedNodes: {}
	        });
	      });
	    }, _this.onReset = function () {
	      _this.setState({ updatedNodes: {} });
	    }, _this.showResolveIndicator = function (node) {
	      return !node.display__updated_at;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UpdateKeywordVisibility, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _UpdateKeywordVisibility2.default.page },
	        _react2.default.createElement(
	          'p',
	          { className: _UpdateKeywordVisibility2.default.note },
	          'Keyword groups that are ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.selectedExample },
	            'selected'
	          ),
	          ' will be grouped separately. Keyword groups that are ',
	          _react2.default.createElement(
	            'span',
	            { className: _UpdateKeywordVisibility2.default.excludedExample },
	            'excluded'
	          ),
	          ' will not be displayed. Use ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'ind'
	          ),
	          'ex to enter a node rank for custom sorting.'
	        ),
	        _react2.default.createElement(_KeywordGraphPicker2.default, {
	          value: this.state.updatedNodes,
	          onChange: this.updateNodes,
	          showUpdatedTime: 'display__updated_at',
	          showResolveIndicator: this.showResolveIndicator,
	          onClickResolve: this.props.touchNodeVisibility,
	          showIndicators: true,
	          showGrouping: true,
	          showTitles: true,
	          headerButtons: [_react2.default.createElement(
	            'button',
	            {
	              key: 'reset',
	              onClick: this.onReset,
	              className: _UpdateKeywordVisibility2.default.resetButton },
	            'Reset Changes'
	          ), _react2.default.createElement(
	            'button',
	            {
	              key: 'save',
	              onClick: this.onSave,
	              className: _UpdateKeywordVisibility2.default.saveButton,
	              disabled: this.state.saving },
	            this.state.saving ? 'Saving…' : 'Save'
	          )]
	        })
	      );
	    }
	  }]);
	
	  return UpdateKeywordVisibility;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var config = _ref2.config;
	  return {};
	};
	
	var mapDispatchToProps = {
	  updateGraphNodes: _keywords.updateGraphNodes,
	  touchNodeVisibility: _keywords.touchNodeVisibility
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdateKeywordVisibility);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _UpdateKeywordVisibility = __webpack_require__(244);
	
	var _UpdateKeywordVisibility2 = _interopRequireDefault(_UpdateKeywordVisibility);
	
	var _keywords = __webpack_require__(107);
	
	var _KeywordGraphPicker = __webpack_require__(128);
	
	var _KeywordGraphPicker2 = _interopRequireDefault(_KeywordGraphPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateKeywordWeighting = function (_Component) {
	  _inherits(UpdateKeywordWeighting, _Component);
	
	  function UpdateKeywordWeighting() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UpdateKeywordWeighting);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdateKeywordWeighting.__proto__ || Object.getPrototypeOf(UpdateKeywordWeighting)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      updatedNodes: {},
	      saving: false
	    }, _this.updateNodes = function (updatedNodes) {
	      _this.setState({ updatedNodes: updatedNodes });
	    }, _this.onSave = function () {
	      _this.setState({ saving: true });
	      _this.props.updateGraphNodes(_this.state.updatedNodes).then(function () {
	        return _this.setState({
	          saving: false,
	          updatedNodes: {}
	        });
	      });
	    }, _this.onReset = function () {
	      _this.setState({ updatedNodes: {} });
	    }, _this.showResolveIndicator = function (node) {
	      return !node.discover__updated_at;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UpdateKeywordWeighting, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _UpdateKeywordVisibility2.default.page },
	        _react2.default.createElement(
	          'p',
	          { className: _UpdateKeywordVisibility2.default.note },
	          'First input: ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'weight'
	          ),
	          _react2.default.createElement('br', null),
	          'Second input: ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'weight-group'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeywordGraphPicker.ExamplePercentage, null),
	          ': The chance of a node being selected when traversing the graph',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeywordGraphPicker.ExamplePercentageGroup, null),
	          ': The change of a node being selected for use in a generated album'
	        ),
	        _react2.default.createElement(_KeywordGraphPicker2.default, {
	          value: this.state.updatedNodes,
	          onChange: this.updateNodes,
	          showUpdatedTime: 'discover__updated_at',
	          showResolveIndicator: this.showResolveIndicator,
	          onClickResolve: this.props.touchNodeWeighting,
	          showIndicators: true,
	          showWeighting: true,
	          headerButtons: [_react2.default.createElement(
	            'button',
	            {
	              key: 'reset',
	              onClick: this.onReset,
	              className: _UpdateKeywordVisibility2.default.resetButton },
	            'Reset Changes'
	          ), _react2.default.createElement(
	            'button',
	            {
	              key: 'save',
	              onClick: this.onSave,
	              className: _UpdateKeywordVisibility2.default.saveButton,
	              disabled: this.state.saving },
	            this.state.saving ? 'Saving…' : 'Save'
	          )]
	        })
	      );
	    }
	  }]);
	
	  return UpdateKeywordWeighting;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var config = _ref2.config;
	  return {};
	};
	
	var mapDispatchToProps = {
	  updateGraphNodes: _keywords.updateGraphNodes,
	  touchNodeWeighting: _keywords.touchNodeWeighting
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdateKeywordWeighting);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _dateformat = __webpack_require__(114);
	
	var _dateformat2 = _interopRequireDefault(_dateformat);
	
	var _timeago = __webpack_require__(494);
	
	var _timeago2 = _interopRequireDefault(_timeago);
	
	var _ExternalShares = __webpack_require__(357);
	
	var _ExternalShares2 = _interopRequireDefault(_ExternalShares);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _auth = __webpack_require__(42);
	
	var _fetch = __webpack_require__(14);
	
	var _auth2 = __webpack_require__(20);
	
	var _constants = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatTimeAgo = new _timeago2.default().format;
	
	var UserSessions = function (_Component) {
	  _inherits(UserSessions, _Component);
	
	  function UserSessions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserSessions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSessions.__proto__ || Object.getPrototypeOf(UserSessions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: null,
	      fetching: false,
	      error: null,
	      loggingOut: false,
	      filterUser: null
	    }, _this.fetchSessions = function () {
	      _this.setState({ error: null });
	      _this.props.fetchSessions().then(function (data) {
	        return _this.setState({ data: data.records });
	      }, function (error) {
	        return _this.setState({ error: error });
	      });
	    }, _this.onClickLogOutAll = function () {
	      _this.setState({ loggingOut: true });
	      _this.props.logOutAllSessions().then(function () {
	        _this.props.logout();
	      });
	    }, _this.onChangeUserFilter = function (e) {
	      _this.setState({
	        filterUser: parseInt(e.target.value)
	      });
	    }, _this.filterData = function (session) {
	      if (_this.state.filterUser && session.user_id !== _this.state.filterUser) {
	        return false;
	      }
	      if (_this.state.filterActive && session.expired) {
	        return false;
	      }
	      return true;
	    }, _this.getUsers = function (data) {
	      var object = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var session = _step.value;
	
	          object[session.user_id] = session.user_name;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return object;
	    }, _this.renderSession = function (session) {
	      return _react2.default.createElement(
	        'tr',
	        { key: session.id },
	        _react2.default.createElement(
	          'td',
	          null,
	          session.user_name
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          session.expired ? '' : 'yes'
	        ),
	        _react2.default.createElement(
	          'td',
	          { title: (0, _dateformat2.default)(session.date, 'HH:MM, d mmm yyyy') },
	          formatTimeAgo(session.date)
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          session.ip
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          session.os
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          session.browser
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserSessions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchSessions();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          fetching = _state.fetching,
	          error = _state.error;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching user sessions',
	          onRetry: this.fetchSessions
	        });
	      }
	
	      if (!data || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      var users = this.getUsers(data);
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ExternalShares2.default.page, style: { maxWidth: '640px' } },
	        this.props.showAllUsers && _react2.default.createElement(
	          'label',
	          null,
	          'Filter users',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'select',
	            { onChange: this.onChangeUserFilter },
	            _react2.default.createElement(
	              'option',
	              { value: null },
	              'All users'
	            ),
	            Object.keys(users).map(function (id) {
	              return _react2.default.createElement(
	                'option',
	                { value: id },
	                users[id]
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            checked: this.state.filterActive,
	            onChange: function onChange() {
	              return _this2.setState({ filterActive: !_this2.state.filterActive });
	            }
	          }),
	          'Active sessions only'
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: _ExternalShares2.default.table, style: { width: '100%' } },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'User'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Active'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Created'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'IP'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'OS'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Browser'
	              )
	            ),
	            data.filter(this.filterData).map(this.renderSession)
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _ExternalShares2.default.button,
	            style: { display: 'block', margin: '20px auto' },
	            onClick: this.onClickLogOutAll,
	            disabled: this.state.loggingOut },
	          this.state.loggingOut ? 'Logging out…' : 'Log out all of my sessions'
	        )
	      );
	    }
	  }]);
	
	  return UserSessions;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var auth = _ref2.auth,
	      share = _ref2.share,
	      users = _ref2.users,
	      entities = _ref2.entities;
	
	  var showAllUsers = (0, _auth2.isSuperAdmin)(auth.user);
	  var endpoint = showAllUsers ? _constants.ENDPOINT_ALL_USER_SESSIONS : _constants.ENDPOINT_USER_SESSIONS.replace(':id', auth.user.id);
	  return {
	    showAllUsers: showAllUsers,
	    fetchSessions: function fetchSessions() {
	      return (0, _fetch.fetch)(endpoint, { token: auth.token });
	    },
	    logOutAllSessions: function logOutAllSessions() {
	      return (0, _fetch.fetch)(_constants.ENDPOINT_LOGOUT_ALL, {
	        method: 'post',
	        token: auth.token
	      });
	    }
	  };
	};
	
	var mapDispatchToProps = {
	  logout: _auth.logout
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSessions);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Users = __webpack_require__(867);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _auth = __webpack_require__(20);
	
	var _users = __webpack_require__(68);
	
	var _perms = __webpack_require__(313);
	
	var _libraries = __webpack_require__(211);
	
	var _LoadingSpinner = __webpack_require__(5);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ErrorMessage = __webpack_require__(17);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _EditUser = __webpack_require__(305);
	
	var _EditUser2 = _interopRequireDefault(_EditUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Users = function (_Component) {
	  _inherits(Users, _Component);
	
	  function Users() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Users);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Users.__proto__ || Object.getPrototypeOf(Users)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      creating: null,
	      editing: null
	    }, _this.toggleDisabled = function (user) {
	      var updateUser = _this.props.updateUser;
	
	      updateUser(user.id, _extends({}, user, {
	        disabled: !user.disabled
	      }));
	    }, _this.onCreateUser = function (data) {
	      var createUser = _this.props.createUser;
	
	      return createUser(data).then(function (response) {
	        if (response) {
	          _this.setState({ creating: null });
	        }
	      });
	    }, _this.onUpdateUser = function (data) {
	      var updateUser = _this.props.updateUser;
	      var editing = _this.state.editing;
	
	      return updateUser(editing.id, data).then(function (success) {
	        if (success) {
	          _this.setState({ editing: null });
	        }
	      });
	    }, _this.filterUser = function (user) {
	      if (_this.props.superAdmin) {
	        return true;
	      }
	      return user.id === _this.props.me.id || !(0, _auth.userHasPerm)(user, 'admin');
	    }, _this.renderRow = function (user) {
	      var deleteUser = _this.props.deleteUser;
	      var id = user.id,
	          name = user.name,
	          email = user.email,
	          perms = user.perms;
	
	      return _react2.default.createElement(
	        'li',
	        { key: id, className: user.disabled ? _Users2.default.userDisabled : _Users2.default.user },
	        _react2.default.createElement(
	          'div',
	          { className: _Users2.default.name, title: 'ID: ' + id },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Users2.default.email },
	          email
	        ),
	        _react2.default.createElement(PermList, { perms: perms, superAdmin: (0, _auth.isSuperAdmin)(user) }),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _Users2.default.button,
	            onClick: function onClick() {
	              return _this.setState({ editing: user });
	            } },
	          'Edit'
	        ),
	        !(0, _auth.isSuperAdmin)(user) && _react2.default.createElement(
	          'button',
	          {
	            className: _Users2.default.button,
	            onClick: function onClick() {
	              return _this.toggleDisabled(user);
	            } },
	          user.disabled ? 'Enable' : 'Disable'
	        ),
	        !(0, _auth.isSuperAdmin)(user) && _react2.default.createElement(
	          'button',
	          {
	            className: _Users2.default.button,
	            onClick: function onClick() {
	              if (window.confirm('Are you sure you want to delete ' + user.name + '?')) {
	                deleteUser(user.id);
	              }
	            } },
	          'Delete'
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Users, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          users = _props.users,
	          fetchUsers = _props.fetchUsers,
	          perms = _props.perms,
	          fetchPerms = _props.fetchPerms,
	          shouldFetchLibraries = _props.shouldFetchLibraries,
	          fetchLibraries = _props.fetchLibraries;
	
	      if (!users) fetchUsers();
	      if (!perms) fetchPerms();
	      if (shouldFetchLibraries) fetchLibraries();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          users = _props2.users,
	          fetching = _props2.fetching,
	          error = _props2.error,
	          perms = _props2.perms,
	          libraries = _props2.libraries,
	          superAdmin = _props2.superAdmin,
	          fetchUsers = _props2.fetchUsers;
	      var _state = this.state,
	          creating = _state.creating,
	          editing = _state.editing;
	
	
	      if (error) {
	        return _react2.default.createElement(_ErrorMessage2.default, {
	          message: 'There was an error fetching users',
	          onRetry: fetchUsers
	        });
	      }
	
	      if (!users || !perms || fetching) {
	        return _react2.default.createElement(_LoadingSpinner2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _Users2.default.page },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _Users2.default.createButton,
	            onClick: function onClick() {
	              return _this2.setState({ creating: true });
	            } },
	          'Create new user'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          users.filter(this.filterUser).map(this.renderRow)
	        ),
	        superAdmin && _react2.default.createElement(
	          'div',
	          { className: _Users2.default.heading },
	          'Superadmin permissions'
	        ),
	        superAdmin && _react2.default.createElement(
	          'ul',
	          { className: _Users2.default.notes },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Manage libraries'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Manage keyword visibility'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Manage keyword weightings'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Merge keyword nodes and remove old notes'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Edit global user settings'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Edit all user permissions and libraries'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'View raw album hierarchy'
	          )
	        ),
	        creating && _react2.default.createElement(_EditUser2.default, {
	          title: 'New User',
	          showPasswordField: true,
	          requirePassword: true,
	          onSubmit: this.onCreateUser,
	          onCancel: function onCancel() {
	            return _this2.setState({ creating: null });
	          },
	          perms: perms,
	          libraries: libraries,
	          createError: this.props.createError,
	          autoFocus: true
	        }),
	        editing && _react2.default.createElement(_EditUser2.default, {
	          title: 'Edit User',
	          showPasswordField: superAdmin,
	          hideAdminPerm: (0, _auth.isSuperAdmin)(editing),
	          onSubmit: this.onUpdateUser,
	          onCancel: function onCancel() {
	            return _this2.setState({ editing: null });
	          },
	          initialValues: _extends({}, editing, {
	            location: getLocationObject(editing)
	          }),
	          perms: perms,
	          libraries: libraries
	        })
	      );
	    }
	  }]);
	
	  return Users;
	}(_react.Component);
	
	function getLocationObject(user) {
	  var _user$location$split$ = user.location.split(',').map(function (value) {
	    return parseFloat(value);
	  }),
	      _user$location$split$2 = _slicedToArray(_user$location$split$, 2),
	      lat = _user$location$split$2[0],
	      lon = _user$location$split$2[1];
	
	  return {
	    lat: lat,
	    lon: lon,
	    address: user.location_address
	  };
	}
	
	function PermList(_ref2) {
	  var perms = _ref2.perms,
	      superAdmin = _ref2.superAdmin;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _Users2.default.permList },
	    superAdmin && _react2.default.createElement(
	      'li',
	      { className: _Users2.default.permSuperAdmin },
	      'superadmin'
	    ),
	    perms.map(function (_ref3) {
	      var perm = _ref3.perm;
	      return _react2.default.createElement(
	        'li',
	        { key: perm.id, className: _Users2.default.perm },
	        perm.perm_token
	      );
	    })
	  );
	}
	
	var mapStateToProps = function mapStateToProps(_ref4) {
	  var users = _ref4.users,
	      entities = _ref4.entities,
	      perms = _ref4.perms,
	      libraries = _ref4.libraries,
	      auth = _ref4.auth;
	  return {
	    me: auth.user,
	    users: users.data && users.data.map(function (id) {
	      return entities.users[id];
	    }),
	    fetching: users.fetching,
	    error: users.error,
	    perms: perms.data,
	    libraries: (0, _auth.isSuperAdmin)(auth.user) ? libraries.data && libraries.data.map(function (library) {
	      return { library: library };
	    }) : auth.user.libraries,
	    superAdmin: (0, _auth.isSuperAdmin)(auth.user),
	    createError: users.create.error,
	    shouldFetchLibraries: (0, _auth.isSuperAdmin)(auth.user) && !libraries.data
	  };
	};
	
	var mapDispatchToProps = {
	  fetchUsers: _users.fetchUsers,
	  updateUser: _users.updateUser,
	  createUser: _users.createUser,
	  deleteUser: _users.deleteUser,
	  fetchPerms: _perms.fetchPerms,
	  fetchLibraries: _libraries.fetchLibraries
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Users);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.loadConfigRequest = loadConfigRequest;
	exports.loadConfigSuccess = loadConfigSuccess;
	exports.loadConfigError = loadConfigError;
	exports.saveConfigRequest = saveConfigRequest;
	exports.saveConfigSuccess = saveConfigSuccess;
	exports.saveConfigError = saveConfigError;
	exports.loadConfig = loadConfig;
	exports.saveConfig = saveConfig;
	
	var _fetch = __webpack_require__(14);
	
	var _constants = __webpack_require__(3);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LOAD_CONFIG_REQUEST = 'blayzr/config/LOAD_REQUEST';
	var LOAD_CONFIG_SUCCESS = 'blayzr/config/LOAD_SUCCESS';
	var LOAD_CONFIG_ERROR = 'blayzr/config/LOAD_ERROR';
	
	var SAVE_CONFIG_REQUEST = 'blayzr/config/SAVE_REQUEST';
	var SAVE_CONFIG_SUCCESS = 'blayzr/config/SAVE_SUCCESS';
	var SAVE_CONFIG_ERROR = 'blayzr/config/SAVE_ERROR';
	
	var initialConfigState = {
	  data: null,
	  fetching: false,
	  error: null,
	  saving: false,
	  saveError: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = action.type,
	      meta = action.meta;
	
	  switch (type) {
	    case LOAD_CONFIG_REQUEST:
	    case LOAD_CONFIG_SUCCESS:
	    case LOAD_CONFIG_ERROR:
	    case SAVE_CONFIG_REQUEST:
	    case SAVE_CONFIG_SUCCESS:
	    case SAVE_CONFIG_ERROR:
	      return _extends({}, state, _defineProperty({}, meta.id, configReducer(state[meta.id], action)));
	    default:
	      return state;
	  }
	}
	
	function configReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialConfigState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  switch (type) {
	    case LOAD_CONFIG_REQUEST:
	      return _extends({}, state, {
	        fetching: true,
	        error: null
	      });
	    case LOAD_CONFIG_SUCCESS:
	      return _extends({}, state, {
	        fetching: false,
	        data: payload
	      });
	    case LOAD_CONFIG_ERROR:
	      return _extends({}, state, {
	        fetching: false,
	        error: payload
	      });
	    case SAVE_CONFIG_REQUEST:
	      return _extends({}, state, {
	        data: payload,
	        saving: true,
	        saveError: null
	      });
	    case SAVE_CONFIG_SUCCESS:
	      return _extends({}, state, {
	        saving: false
	      });
	    case SAVE_CONFIG_ERROR:
	      return _extends({}, state, {
	        saving: false,
	        saveError: payload
	      });
	    default:
	      return state;
	  }
	}
	
	function loadConfigRequest(id) {
	  return {
	    type: LOAD_CONFIG_REQUEST,
	    meta: { id: id }
	  };
	}
	
	function loadConfigSuccess(id, data) {
	  return {
	    type: LOAD_CONFIG_SUCCESS,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function loadConfigError(id, error) {
	  return {
	    type: LOAD_CONFIG_ERROR,
	    payload: error,
	    meta: { id: id }
	  };
	}
	
	function saveConfigRequest(id, data) {
	  return {
	    type: SAVE_CONFIG_REQUEST,
	    payload: data,
	    meta: { id: id }
	  };
	}
	
	function saveConfigSuccess(id) {
	  return {
	    type: SAVE_CONFIG_SUCCESS,
	    meta: { id: id }
	  };
	}
	
	function saveConfigError(id, error) {
	  return {
	    type: SAVE_CONFIG_ERROR,
	    payload: error,
	    meta: { id: id }
	  };
	}
	
	function loadConfig(id, defaultValue) {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        auth = _getState.auth;
	
	    var options = {
	      token: auth.token,
	      query: { id: id }
	    };
	    dispatch(loadConfigRequest(id));
	    return (0, _fetch.fetch)(_constants.ENDPOINT_CONFIG, options, dispatch).then(function (data) {
	      var value = data.records ? JSON.parse(data.records.value) : defaultValue;
	      dispatch(loadConfigSuccess(id, value));
	      return value;
	    }, function (e) {
	      dispatch(loadConfigError(id, e));
	    });
	  };
	}
	
	function saveConfig(id, data) {
	  console.log(id, data);
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        auth = _getState2.auth;
	
	    var options = {
	      method: 'post',
	      token: auth.token,
	      body: {
	        id: id,
	        value: JSON.stringify(data)
	      }
	    };
	    dispatch(saveConfigRequest(id, data));
	    return (0, _fetch.fetch)(_constants.ENDPOINT_CONFIG, options, dispatch).then(function (data) {
	      dispatch(saveConfigSuccess(id));
	    }, function (e) {
	      dispatch(saveConfigError(id, e));
	    });
	  };
	}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _lodash = __webpack_require__(382);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  albums: {},
	  playlists: {},
	  queues: {},
	  images: {},
	  users: {}
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var payload = action.payload;
	
	  if (payload && payload.entities) {
	    return (0, _lodash2.default)({}, state, payload.entities, customizer);
	  }
	  return state;
	}
	
	function customizer(obj, src, key) {
	  // Merging a longer perms array with a smaller one will return the long array
	  // but we may want to shorten perms, so just return the new one
	  if (key === 'perms' || key === 'libraries') {
	    return src;
	  }
	  // Fix weirdness when merging keyword graph nodes
	  if (key === 'children') {
	    return src;
	  }
	  return undefined;
	}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (state, action) {
	  // Complete store reset on logout
	  if (action.type === _auth.LOGOUT) {
	    return reducer({
	      // Keep some state to not mess up logging out
	      routing: state.routing,
	      form: state.form
	    }, action);
	  }
	  return reducer(state, action);
	};
	
	var _redux = __webpack_require__(106);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reduxForm = __webpack_require__(76);
	
	var _auth = __webpack_require__(42);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _albums = __webpack_require__(41);
	
	var _albums2 = _interopRequireDefault(_albums);
	
	var _search = __webpack_require__(59);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _query = __webpack_require__(50);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _entities = __webpack_require__(575);
	
	var _entities2 = _interopRequireDefault(_entities);
	
	var _nav = __webpack_require__(312);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _modals = __webpack_require__(212);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _hierarchy = __webpack_require__(129);
	
	var _hierarchy2 = _interopRequireDefault(_hierarchy);
	
	var _users = __webpack_require__(68);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _perms = __webpack_require__(313);
	
	var _perms2 = _interopRequireDefault(_perms);
	
	var _share = __webpack_require__(87);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _keywords = __webpack_require__(107);
	
	var _keywords2 = _interopRequireDefault(_keywords);
	
	var _playlists = __webpack_require__(43);
	
	var _playlists2 = _interopRequireDefault(_playlists);
	
	var _queues = __webpack_require__(108);
	
	var _queues2 = _interopRequireDefault(_queues);
	
	var _dynlinks = __webpack_require__(154);
	
	var _dynlinks2 = _interopRequireDefault(_dynlinks);
	
	var _banners = __webpack_require__(67);
	
	var _banners2 = _interopRequireDefault(_banners);
	
	var _libraries = __webpack_require__(211);
	
	var _libraries2 = _interopRequireDefault(_libraries);
	
	var _config = __webpack_require__(574);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = (0, _redux.combineReducers)({
	  auth: _auth2.default,
	  albums: _albums2.default,
	  search: _search2.default,
	  query: _query2.default,
	  entities: _entities2.default,
	  nav: _nav2.default,
	  modals: _modals2.default,
	  hierarchy: _hierarchy2.default,
	  users: _users2.default,
	  perms: _perms2.default,
	  share: _share2.default,
	  keywords: _keywords2.default,
	  playlists: _playlists2.default,
	  queues: _queues2.default,
	  dynlinks: _dynlinks2.default,
	  banners: _banners2.default,
	  libraries: _libraries2.default,
	  config: _config2.default,
	  routing: _reactRouterRedux.routerReducer,
	  form: _reduxForm.reducer.plugin(_query.queryFormPlugin)
	});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(106);
	
	var _reactRouterRedux = __webpack_require__(26);
	
	var _reduxThunk = __webpack_require__(1226);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducer = __webpack_require__(576);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _auth = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(history) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var middleware = (0, _redux.compose)((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history), _auth.externalUserMiddleware, _auth.tokenRefreshMiddleware, _reduxThunk2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	    return f;
	  });
	
	  var store = (0, _redux.createStore)(_reducer2.default, initialState, middleware);
	
	  // Not currently working for some reason
	  // https://github.com/gaearon/react-hot-boilerplate/pull/61#issuecomment-216269339
	  if (false) {
	    module.hot.accept('./auth', function () {
	      store.replaceReducer(require('./reducer').default);
	      return true;
	    });
	  }
	
	  return store;
	}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.imageDate = imageDate;
	function imageDate(image) {
	  var _image$_date$split = image._date.split(' '),
	      _image$_date$split2 = _slicedToArray(_image$_date$split, 2),
	      date = _image$_date$split2[0],
	      time = _image$_date$split2[1];
	
	  return new Date(date.replace(/:/g, '-') + ' ' + time);
	}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(782);
	
	__webpack_require__(1230);
	
	__webpack_require__(583);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = function blacklist (src) {
	  var copy = {}
	  var filter = arguments[1]
	
	  if (typeof filter === 'string') {
	    filter = {}
	    for (var i = 1; i < arguments.length; i++) {
	      filter[arguments[i]] = true
	    }
	  }
	
	  for (var key in src) {
	    // blacklist?
	    if (filter[key]) continue
	
	    copy[key] = src[key]
	  }
	
	  return copy
	}


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(590);
	module.exports = __webpack_require__(52).RegExp.escape;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var isArray = __webpack_require__(158);
	var SPECIES = __webpack_require__(18)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(11);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(63);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(93);
	var gOPS = __webpack_require__(162);
	var pIE = __webpack_require__(132);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(133)('native-function-to-string', Function.toString);


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(589)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(316) });
	
	__webpack_require__(79)('copyWithin');


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(60)(4);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(215) });
	
	__webpack_require__(79)('fill');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(60)(2);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(60)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(79)(KEY);


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(60)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(79)(KEY);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(60)(0);
	var STRICT = __webpack_require__(54)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(53);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var call = __webpack_require__(327);
	var isArrayIter = __webpack_require__(223);
	var toLength = __webpack_require__(21);
	var createProperty = __webpack_require__(217);
	var getIterFn = __webpack_require__(239);
	
	$export($export.S + $export.F * !__webpack_require__(160)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(155)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(158) });


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(47);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(131) != Object || !__webpack_require__(54)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(47);
	var toInteger = __webpack_require__(55);
	var toLength = __webpack_require__(21);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(60)(1);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(217);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(318);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(318);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(221);
	var cof = __webpack_require__(51);
	var toAbsoluteIndex = __webpack_require__(97);
	var toLength = __webpack_require__(21);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(60)(3);
	
	$export($export.P + $export.F * !__webpack_require__(54)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(33);
	var toObject = __webpack_require__(29);
	var fails = __webpack_require__(11);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(54)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(96)('Array');


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(585);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(63);
	
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(18)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(36)(proto, TO_PRIMITIVE, __webpack_require__(586));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(37)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(319) });


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(46);
	var HAS_INSTANCE = __webpack_require__(18)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(27).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(27).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(24) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(330);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(227);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(226);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(329) });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(330) });


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(227) });


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(226);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(226);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var has = __webpack_require__(44);
	var cof = __webpack_require__(51);
	var inheritIfRequired = __webpack_require__(222);
	var toPrimitive = __webpack_require__(63);
	var fails = __webpack_require__(11);
	var gOPN = __webpack_require__(92).f;
	var gOPD = __webpack_require__(45).f;
	var dP = __webpack_require__(27).f;
	var $trim = __webpack_require__(113).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(91)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(24) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(37)(global, NUMBER, $Number);
	}


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(326) });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(326);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(338);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(339);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(55);
	var aNumberValue = __webpack_require__(315);
	var repeat = __webpack_require__(234);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(11)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(11);
	var aNumberValue = __webpack_require__(315);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(332) });


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(91) });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperties: __webpack_require__(333) });


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(27).f });


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(81).onFreeze;
	
	__webpack_require__(62)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(47);
	var $getOwnPropertyDescriptor = __webpack_require__(45).f;
	
	__webpack_require__(62)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(62)('getOwnPropertyNames', function () {
	  return __webpack_require__(334).f;
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(29);
	var $getPrototypeOf = __webpack_require__(46);
	
	__webpack_require__(62)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(62)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(62)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(62)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(342) });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(29);
	var $keys = __webpack_require__(93);
	
	__webpack_require__(62)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(81).onFreeze;
	
	__webpack_require__(62)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(81).onFreeze;
	
	__webpack_require__(62)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(231).set });


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(110);
	var test = {};
	test[__webpack_require__(18)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(37)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(338);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(339);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(80);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(53);
	var classof = __webpack_require__(110);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(12);
	var aFunction = __webpack_require__(33);
	var anInstance = __webpack_require__(89);
	var forOf = __webpack_require__(90);
	var speciesConstructor = __webpack_require__(134);
	var task = __webpack_require__(236).set;
	var microtask = __webpack_require__(228)();
	var newPromiseCapabilityModule = __webpack_require__(229);
	var perform = __webpack_require__(340);
	var userAgent = __webpack_require__(168);
	var promiseResolve = __webpack_require__(341);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(18)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(95)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(112)($Promise, PROMISE);
	__webpack_require__(96)(PROMISE);
	Wrapper = __webpack_require__(52)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(160)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(33);
	var anObject = __webpack_require__(6);
	var rApply = (__webpack_require__(8).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(11)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(91);
	var aFunction = __webpack_require__(33);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(12);
	var fails = __webpack_require__(11);
	var bind = __webpack_require__(319);
	var rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(27);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(63);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(45).f;
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(224)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(45);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(46);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(45);
	var getPrototypeOf = __webpack_require__(46);
	var has = __webpack_require__(44);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(12);
	var anObject = __webpack_require__(6);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(337) });


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(231);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(27);
	var gOPD = __webpack_require__(45);
	var getPrototypeOf = __webpack_require__(46);
	var has = __webpack_require__(44);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(94);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(12);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var inheritIfRequired = __webpack_require__(222);
	var dP = __webpack_require__(27).f;
	var gOPN = __webpack_require__(92).f;
	var isRegExp = __webpack_require__(159);
	var $flags = __webpack_require__(130);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(24) && (!CORRECT_NEW || __webpack_require__(11)(function () {
	  re2[__webpack_require__(18)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(37)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(96)('RegExp');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(21);
	var advanceStringIndex = __webpack_require__(214);
	var regExpExec = __webpack_require__(163);
	
	// @@match logic
	__webpack_require__(157)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toObject = __webpack_require__(29);
	var toLength = __webpack_require__(21);
	var toInteger = __webpack_require__(55);
	var advanceStringIndex = __webpack_require__(214);
	var regExpExec = __webpack_require__(163);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(157)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var sameValue = __webpack_require__(342);
	var regExpExec = __webpack_require__(163);
	
	// @@search logic
	__webpack_require__(157)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(159);
	var anObject = __webpack_require__(6);
	var speciesConstructor = __webpack_require__(134);
	var advanceStringIndex = __webpack_require__(214);
	var toLength = __webpack_require__(21);
	var callRegExpExec = __webpack_require__(163);
	var regexpExec = __webpack_require__(230);
	var fails = __webpack_require__(11);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(157)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(348);
	var anObject = __webpack_require__(6);
	var $flags = __webpack_require__(130);
	var DESCRIPTORS = __webpack_require__(24);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(37)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(38)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(38)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(38)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(38)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(166)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(21);
	var context = __webpack_require__(233);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(220)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(38)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(38)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(38)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(97);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(233);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(220)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(38)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(166)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(225)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(38)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(47);
	var toLength = __webpack_require__(21);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(234)
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(38)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(21);
	var context = __webpack_require__(233);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(220)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(38)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(38)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(38)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(113)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(8);
	var has = __webpack_require__(44);
	var DESCRIPTORS = __webpack_require__(24);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(37);
	var META = __webpack_require__(81).KEY;
	var $fails = __webpack_require__(11);
	var shared = __webpack_require__(133);
	var setToStringTag = __webpack_require__(112);
	var uid = __webpack_require__(98);
	var wks = __webpack_require__(18);
	var wksExt = __webpack_require__(345);
	var wksDefine = __webpack_require__(238);
	var enumKeys = __webpack_require__(587);
	var isArray = __webpack_require__(158);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(12);
	var toObject = __webpack_require__(29);
	var toIObject = __webpack_require__(47);
	var toPrimitive = __webpack_require__(63);
	var createDesc = __webpack_require__(94);
	var _create = __webpack_require__(91);
	var gOPNExt = __webpack_require__(334);
	var $GOPD = __webpack_require__(45);
	var $GOPS = __webpack_require__(162);
	var $DP = __webpack_require__(27);
	var $keys = __webpack_require__(93);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(92).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(132).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(80)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(167);
	var buffer = __webpack_require__(237);
	var anObject = __webpack_require__(6);
	var toAbsoluteIndex = __webpack_require__(97);
	var toLength = __webpack_require__(21);
	var isObject = __webpack_require__(12);
	var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
	var speciesConstructor = __webpack_require__(134);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(96)(ARRAY_BUFFER);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(167).ABV, {
	  DataView: __webpack_require__(237).DataView
	});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(70)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(322);
	var validate = __webpack_require__(99);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(156)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(323);
	var toObject = __webpack_require__(29);
	var toLength = __webpack_require__(21);
	var aFunction = __webpack_require__(33);
	var arraySpeciesCreate = __webpack_require__(216);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(79)('flatMap');


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(323);
	var toObject = __webpack_require__(29);
	var toLength = __webpack_require__(21);
	var toInteger = __webpack_require__(55);
	var arraySpeciesCreate = __webpack_require__(216);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(79)('flatten');


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(155)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(79)('includes');


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(228)();
	var process = __webpack_require__(8).process;
	var isNode = __webpack_require__(51)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(51);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(164)('Map');


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(165)('Map');


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(321)('Map') });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(331);
	var fround = __webpack_require__(329);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(331) });


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var aFunction = __webpack_require__(33);
	var $defineProperty = __webpack_require__(27);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(24) && $export($export.P + __webpack_require__(161), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var aFunction = __webpack_require__(33);
	var $defineProperty = __webpack_require__(27);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(24) && $export($export.P + __webpack_require__(161), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(336)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(337);
	var toIObject = __webpack_require__(47);
	var gOPD = __webpack_require__(45);
	var createProperty = __webpack_require__(217);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(46);
	var getOwnPropertyDescriptor = __webpack_require__(45).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(24) && $export($export.P + __webpack_require__(161), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(29);
	var toPrimitive = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(46);
	var getOwnPropertyDescriptor = __webpack_require__(45).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(24) && $export($export.P + __webpack_require__(161), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(336)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(8);
	var core = __webpack_require__(52);
	var microtask = __webpack_require__(228)();
	var OBSERVABLE = __webpack_require__(18)('observable');
	var aFunction = __webpack_require__(33);
	var anObject = __webpack_require__(6);
	var anInstance = __webpack_require__(89);
	var redefineAll = __webpack_require__(95);
	var hide = __webpack_require__(36);
	var forOf = __webpack_require__(90);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(96)('Observable');


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(52);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(134);
	var promiseResolve = __webpack_require__(341);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(229);
	var perform = __webpack_require__(340);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(349);
	var from = __webpack_require__(317);
	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(46);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(46);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(46);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(69);
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(33);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(164)('Set');


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(165)('Set');


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(321)('Set') });


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(166)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(61);
	var toLength = __webpack_require__(21);
	var isRegExp = __webpack_require__(159);
	var getFlags = __webpack_require__(130);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(224)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(343);
	var userAgent = __webpack_require__(168);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(343);
	var userAgent = __webpack_require__(168);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(113)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(113)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(238)('asyncIterator');


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(238)('observable');


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(164)('WeakMap');


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(165)('WeakMap');


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(164)('WeakSet');


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(165)('WeakSet');


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(240);
	var getKeys = __webpack_require__(93);
	var redefine = __webpack_require__(37);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(36);
	var Iterators = __webpack_require__(111);
	var wks = __webpack_require__(18);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(236);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(168);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(710);
	__webpack_require__(649);
	__webpack_require__(651);
	__webpack_require__(650);
	__webpack_require__(653);
	__webpack_require__(655);
	__webpack_require__(660);
	__webpack_require__(654);
	__webpack_require__(652);
	__webpack_require__(662);
	__webpack_require__(661);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(656);
	__webpack_require__(648);
	__webpack_require__(659);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(616);
	__webpack_require__(618);
	__webpack_require__(617);
	__webpack_require__(666);
	__webpack_require__(665);
	__webpack_require__(636);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(619);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(626);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(697);
	__webpack_require__(702);
	__webpack_require__(709);
	__webpack_require__(700);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(698);
	__webpack_require__(703);
	__webpack_require__(705);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(699);
	__webpack_require__(701);
	__webpack_require__(704);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(611);
	__webpack_require__(613);
	__webpack_require__(612);
	__webpack_require__(615);
	__webpack_require__(614);
	__webpack_require__(600);
	__webpack_require__(598);
	__webpack_require__(604);
	__webpack_require__(601);
	__webpack_require__(607);
	__webpack_require__(609);
	__webpack_require__(597);
	__webpack_require__(603);
	__webpack_require__(594);
	__webpack_require__(608);
	__webpack_require__(592);
	__webpack_require__(606);
	__webpack_require__(605);
	__webpack_require__(599);
	__webpack_require__(602);
	__webpack_require__(591);
	__webpack_require__(593);
	__webpack_require__(596);
	__webpack_require__(595);
	__webpack_require__(610);
	__webpack_require__(240);
	__webpack_require__(682);
	__webpack_require__(347);
	__webpack_require__(687);
	__webpack_require__(348);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(667);
	__webpack_require__(346);
	__webpack_require__(349);
	__webpack_require__(350);
	__webpack_require__(722);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(717);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(715);
	__webpack_require__(718);
	__webpack_require__(716);
	__webpack_require__(719);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(672);
	__webpack_require__(675);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(681);
	__webpack_require__(680);
	__webpack_require__(725);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(766);
	__webpack_require__(769);
	__webpack_require__(768);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(767);
	__webpack_require__(772);
	__webpack_require__(773);
	__webpack_require__(747);
	__webpack_require__(750);
	__webpack_require__(746);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(731);
	__webpack_require__(765);
	__webpack_require__(730);
	__webpack_require__(764);
	__webpack_require__(776);
	__webpack_require__(778);
	__webpack_require__(729);
	__webpack_require__(763);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(728);
	__webpack_require__(774);
	__webpack_require__(727);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(736);
	__webpack_require__(738);
	__webpack_require__(737);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(743);
	__webpack_require__(742);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(757);
	__webpack_require__(756);
	__webpack_require__(759);
	__webpack_require__(758);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(726);
	__webpack_require__(751);
	__webpack_require__(781);
	__webpack_require__(780);
	__webpack_require__(779);
	module.exports = __webpack_require__(52);


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(785));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(169));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(169));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(352));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(352));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(169));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1236)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('stackframe'));
	    } else {
	        root.ErrorStackParser = factory(root.StackFrame);
	    }
	}(this, function ErrorStackParser(StackFrame) {
	    'use strict';
	
	    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	    function _map(array, fn, thisArg) {
	        if (typeof Array.prototype.map === 'function') {
	            return array.map(fn, thisArg);
	        } else {
	            var output = new Array(array.length);
	            for (var i = 0; i < array.length; i++) {
	                output[i] = fn.call(thisArg, array[i]);
	            }
	            return output;
	        }
	    }
	
	    function _filter(array, fn, thisArg) {
	        if (typeof Array.prototype.filter === 'function') {
	            return array.filter(fn, thisArg);
	        } else {
	            var output = [];
	            for (var i = 0; i < array.length; i++) {
	                if (fn.call(thisArg, array[i])) {
	                    output.push(array[i]);
	                }
	            }
	            return output;
	        }
	    }
	
	    function _indexOf(array, target) {
	        if (typeof Array.prototype.indexOf === 'function') {
	            return array.indexOf(target);
	        } else {
	            for (var i = 0; i < array.length; i++) {
	                if (array[i] === target) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }
	
	    return {
	        /**
	         * Given an Error object, extract the most information from it.
	         *
	         * @param {Error} error object
	         * @return {Array} of StackFrames
	         */
	        parse: function ErrorStackParser$$parse(error) {
	            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	                return this.parseOpera(error);
	            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	                return this.parseV8OrIE(error);
	            } else if (error.stack) {
	                return this.parseFFOrSafari(error);
	            } else {
	                throw new Error('Cannot parse given Error object');
	            }
	        },
	
	        // Separate line and column numbers from a string of the form: (URI:Line:Column)
	        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	            // Fail-fast but return locations like "(native)"
	            if (urlLike.indexOf(':') === -1) {
	                return [urlLike];
	            }
	
	            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
	            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
	            return [parts[1], parts[2] || undefined, parts[3] || undefined];
	        },
	
	        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(CHROME_IE_STACK_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                if (line.indexOf('(eval ') > -1) {
	                    // Throw away eval information until we implement stacktrace.js/stackframe#8
	                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	                }
	                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionName = tokens.join(' ') || undefined;
	                var fileName = _indexOf(['eval', '<anonymous>'], locationParts[0]) > -1 ? undefined : locationParts[0];
	
	                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
	            }, this);
	        },
	
	        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                // Throw away eval information until we implement stacktrace.js/stackframe#8
	                if (line.indexOf(' > eval') > -1) {
	                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	                }
	
	                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	                    // Safari eval frames only have function names and nothing else
	                    return new StackFrame(line);
	                } else {
	                    var tokens = line.split('@');
	                    var locationParts = this.extractLocation(tokens.pop());
	                    var functionName = tokens.join('@') || undefined;
	                    return new StackFrame(functionName,
	                        undefined,
	                        locationParts[0],
	                        locationParts[1],
	                        locationParts[2],
	                        line);
	                }
	            }, this);
	        },
	
	        parseOpera: function ErrorStackParser$$parseOpera(e) {
	            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
	                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
	                return this.parseOpera9(e);
	            } else if (!e.stack) {
	                return this.parseOpera10(e);
	            } else {
	                return this.parseOpera11(e);
	            }
	        },
	
	        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	            var lines = e.message.split('\n');
	            var result = [];
	
	            for (var i = 2, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
	                }
	            }
	
	            return result;
	        },
	
	        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	            var lines = e.stacktrace.split('\n');
	            var result = [];
	
	            for (var i = 0, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(
	                        new StackFrame(
	                            match[3] || undefined,
	                            undefined,
	                            match[2],
	                            match[1],
	                            undefined,
	                            lines[i]
	                        )
	                    );
	                }
	            }
	
	            return result;
	        },
	
	        // Opera 10.65+ Error.stack very similar to FF/Safari
	        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
	            }, this);
	
	            return _map(filtered, function(line) {
	                var tokens = line.split('@');
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionCall = (tokens.shift() || '');
	                var functionName = functionCall
	                        .replace(/<anonymous function(: (\w+))?>/, '$2')
	                        .replace(/\([^\)]*\)/g, '') || undefined;
	                var argsRaw;
	                if (functionCall.match(/\(([^\)]*)\)/)) {
	                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	                }
	                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
	                    undefined : argsRaw.split(',');
	                return new StackFrame(
	                    functionName,
	                    args,
	                    locationParts[0],
	                    locationParts[1],
	                    locationParts[2],
	                    line);
	            }, this);
	        }
	    };
	}));
	


/***/ }),
/* 793 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExtendableError = (function (_Error) {
	  _inherits(ExtendableError, _Error);
	
	  function ExtendableError() {
	    var message = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
	    _classCallCheck(this, ExtendableError);
	
	    _get(Object.getPrototypeOf(ExtendableError.prototype), 'constructor', this).call(this, message);
	
	    // extending Error is weird and does not propagate `message`
	    Object.defineProperty(this, 'message', {
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(this, 'name', {
	      enumerable: false,
	      value: this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(this, this.constructor);
	      return;
	    }
	
	    Object.defineProperty(this, 'stack', {
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	  }
	
	  return ExtendableError;
	})(Error);
	
	exports['default'] = ExtendableError;
	module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, Buffer) {_xamzrequire = function e(t, n, r) {
	    function s(o, u) {
	        if (!n[o]) {
	            if (!t[o]) {
	                var a = typeof _xamzrequire == "function" && _xamzrequire;
	                if (!u && a) return a(o, !0);
	                if (i) return i(o, !0);
	                var f = new Error("Cannot find module '" + o + "'");
	                throw f.code = "MODULE_NOT_FOUND", f;
	            }
	            var l = n[o] = {
	                exports: {}
	            };
	            t[o][0].call(l.exports, function(e) {
	                var n = t[o][1][e];
	                return s(n ? n : e);
	            }, l, l.exports, e, t, n, r);
	        }
	        return n[o].exports;
	    }
	    var i = typeof _xamzrequire == "function" && _xamzrequire;
	    for (var o = 0; o < r.length; o++) s(r[o]);
	    return s;
	}({
	    24: [ function(require, module, exports) {
	        var AWS = {
	            util: require("./util")
	        };
	        var _hidden = {};
	        _hidden.toString();
	        module.exports = AWS;
	        AWS.util.update(AWS, {
	            VERSION: "2.4.1",
	            Signers: {},
	            Protocol: {
	                Json: require("./protocol/json"),
	                Query: require("./protocol/query"),
	                Rest: require("./protocol/rest"),
	                RestJson: require("./protocol/rest_json"),
	                RestXml: require("./protocol/rest_xml")
	            },
	            XML: {
	                Builder: require("./xml/builder"),
	                Parser: null
	            },
	            JSON: {
	                Builder: require("./json/builder"),
	                Parser: require("./json/parser")
	            },
	            Model: {
	                Api: require("./model/api"),
	                Operation: require("./model/operation"),
	                Shape: require("./model/shape"),
	                Paginator: require("./model/paginator"),
	                ResourceWaiter: require("./model/resource_waiter")
	            },
	            util: require("./util"),
	            apiLoader: function() {
	                throw new Error("No API loader set");
	            }
	        });
	        require("./service");
	        require("./credentials");
	        require("./credentials/credential_provider_chain");
	        require("./credentials/temporary_credentials");
	        require("./credentials/web_identity_credentials");
	        require("./credentials/cognito_identity_credentials");
	        require("./credentials/saml_credentials");
	        require("./config");
	        require("./http");
	        require("./sequential_executor");
	        require("./event_listeners");
	        require("./request");
	        require("./response");
	        require("./resource_waiter");
	        require("./signers/request_signer");
	        require("./param_validator");
	        AWS.events = new AWS.SequentialExecutor();
	    }, {
	        "./config": 23,
	        "./credentials": 25,
	        "./credentials/cognito_identity_credentials": 26,
	        "./credentials/credential_provider_chain": 27,
	        "./credentials/saml_credentials": 28,
	        "./credentials/temporary_credentials": 29,
	        "./credentials/web_identity_credentials": 30,
	        "./event_listeners": 36,
	        "./http": 37,
	        "./json/builder": 39,
	        "./json/parser": 40,
	        "./model/api": 41,
	        "./model/operation": 43,
	        "./model/paginator": 44,
	        "./model/resource_waiter": 45,
	        "./model/shape": 46,
	        "./param_validator": 47,
	        "./protocol/json": 48,
	        "./protocol/query": 49,
	        "./protocol/rest": 50,
	        "./protocol/rest_json": 51,
	        "./protocol/rest_xml": 52,
	        "./request": 56,
	        "./resource_waiter": 57,
	        "./response": 58,
	        "./sequential_executor": 60,
	        "./service": 61,
	        "./signers/request_signer": 77,
	        "./util": 84,
	        "./xml/builder": 86
	    } ],
	    86: [ function(require, module, exports) {
	        var util = require("../util");
	        var builder = require("xmlbuilder");
	        function XmlBuilder() {}
	        XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
	            var xml = builder.create(rootElement);
	            applyNamespaces(xml, shape);
	            serialize(xml, params, shape);
	            return xml.children.length > 0 || noEmpty ? xml.root().toString() : "";
	        };
	        function serialize(xml, value, shape) {
	            switch (shape.type) {
	              case "structure":
	                return serializeStructure(xml, value, shape);
	
	              case "map":
	                return serializeMap(xml, value, shape);
	
	              case "list":
	                return serializeList(xml, value, shape);
	
	              default:
	                return serializeScalar(xml, value, shape);
	            }
	        }
	        function serializeStructure(xml, params, shape) {
	            util.arrayEach(shape.memberNames, function(memberName) {
	                var memberShape = shape.members[memberName];
	                if (memberShape.location !== "body") return;
	                var value = params[memberName];
	                var name = memberShape.name;
	                if (value !== undefined && value !== null) {
	                    if (memberShape.isXmlAttribute) {
	                        xml.att(name, value);
	                    } else if (memberShape.flattened) {
	                        serialize(xml, value, memberShape);
	                    } else {
	                        var element = xml.ele(name);
	                        applyNamespaces(element, memberShape);
	                        serialize(element, value, memberShape);
	                    }
	                }
	            });
	        }
	        function serializeMap(xml, map, shape) {
	            var xmlKey = shape.key.name || "key";
	            var xmlValue = shape.value.name || "value";
	            util.each(map, function(key, value) {
	                var entry = xml.ele(shape.flattened ? shape.name : "entry");
	                serialize(entry.ele(xmlKey), key, shape.key);
	                serialize(entry.ele(xmlValue), value, shape.value);
	            });
	        }
	        function serializeList(xml, list, shape) {
	            if (shape.flattened) {
	                util.arrayEach(list, function(value) {
	                    var name = shape.member.name || shape.name;
	                    var element = xml.ele(name);
	                    serialize(element, value, shape.member);
	                });
	            } else {
	                util.arrayEach(list, function(value) {
	                    var name = shape.member.name || "member";
	                    var element = xml.ele(name);
	                    serialize(element, value, shape.member);
	                });
	            }
	        }
	        function serializeScalar(xml, value, shape) {
	            xml.txt(shape.toWireFormat(value));
	        }
	        function applyNamespaces(xml, shape) {
	            var uri, prefix = "xmlns";
	            if (shape.xmlNamespaceUri) {
	                uri = shape.xmlNamespaceUri;
	                if (shape.xmlNamespacePrefix) prefix += ":" + shape.xmlNamespacePrefix;
	            } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
	                uri = shape.api.xmlNamespaceUri;
	            }
	            if (uri) xml.att(prefix, uri);
	        }
	        module.exports = XmlBuilder;
	    }, {
	        "../util": 84,
	        xmlbuilder: 104
	    } ],
	    104: [ function(require, module, exports) {
	        (function() {
	            var XMLBuilder, assign;
	            assign = require("lodash/object/assign");
	            XMLBuilder = require("./XMLBuilder");
	            module.exports.create = function(name, xmldec, doctype, options) {
	                options = assign({}, xmldec, doctype, options);
	                return new XMLBuilder(name, options).root();
	            };
	        }).call(this);
	    }, {
	        "./XMLBuilder": 89,
	        "lodash/object/assign": 146
	    } ],
	    146: [ function(require, module, exports) {
	        var baseAssign = require("../internal/baseAssign"), createAssigner = require("../internal/createAssigner");
	        var assign = createAssigner(baseAssign);
	        module.exports = assign;
	    }, {
	        "../internal/baseAssign": 107,
	        "../internal/createAssigner": 125
	    } ],
	    125: [ function(require, module, exports) {
	        var bindCallback = require("./bindCallback"), isIterateeCall = require("./isIterateeCall");
	        function createAssigner(assigner) {
	            return function() {
	                var args = arguments, length = args.length, object = args[0];
	                if (length < 2 || object == null) {
	                    return object;
	                }
	                var customizer = args[length - 2], thisArg = args[length - 1], guard = args[3];
	                if (length > 3 && typeof customizer == "function") {
	                    customizer = bindCallback(customizer, thisArg, 5);
	                    length -= 2;
	                } else {
	                    customizer = length > 2 && typeof thisArg == "function" ? thisArg : null;
	                    length -= customizer ? 1 : 0;
	                }
	                if (guard && isIterateeCall(args[1], args[2], guard)) {
	                    customizer = length == 3 ? null : customizer;
	                    length = 2;
	                }
	                var index = 0;
	                while (++index < length) {
	                    var source = args[index];
	                    if (source) {
	                        assigner(object, source, customizer);
	                    }
	                }
	                return object;
	            };
	        }
	        module.exports = createAssigner;
	    }, {
	        "./bindCallback": 124,
	        "./isIterateeCall": 131
	    } ],
	    107: [ function(require, module, exports) {
	        var baseCopy = require("./baseCopy"), keys = require("../object/keys");
	        function baseAssign(object, source, customizer) {
	            var props = keys(source);
	            if (!customizer) {
	                return baseCopy(source, object, props);
	            }
	            var index = -1, length = props.length;
	            while (++index < length) {
	                var key = props[index], value = object[key], result = customizer(value, source[key], key, object, source);
	                if ((result === result ? result !== value : value === value) || typeof value == "undefined" && !(key in object)) {
	                    object[key] = result;
	                }
	            }
	            return object;
	        }
	        module.exports = baseAssign;
	    }, {
	        "../object/keys": 148,
	        "./baseCopy": 109
	    } ],
	    89: [ function(require, module, exports) {
	        (function() {
	            var XMLBuilder, XMLDeclaration, XMLDocType, XMLElement, XMLStringifier;
	            XMLStringifier = require("./XMLStringifier");
	            XMLDeclaration = require("./XMLDeclaration");
	            XMLDocType = require("./XMLDocType");
	            XMLElement = require("./XMLElement");
	            module.exports = XMLBuilder = function() {
	                function XMLBuilder(name, options) {
	                    var root, temp;
	                    if (name == null) {
	                        throw new Error("Root element needs a name");
	                    }
	                    if (options == null) {
	                        options = {};
	                    }
	                    this.options = options;
	                    this.stringify = new XMLStringifier(options);
	                    temp = new XMLElement(this, "doc");
	                    root = temp.element(name);
	                    root.isRoot = true;
	                    root.documentObject = this;
	                    this.rootObject = root;
	                    if (!options.headless) {
	                        root.declaration(options);
	                        if (options.pubID != null || options.sysID != null) {
	                            root.doctype(options);
	                        }
	                    }
	                }
	                XMLBuilder.prototype.root = function() {
	                    return this.rootObject;
	                };
	                XMLBuilder.prototype.end = function(options) {
	                    return this.toString(options);
	                };
	                XMLBuilder.prototype.toString = function(options) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    r = "";
	                    if (this.xmldec != null) {
	                        r += this.xmldec.toString(options);
	                    }
	                    if (this.doctype != null) {
	                        r += this.doctype.toString(options);
	                    }
	                    r += this.rootObject.toString(options);
	                    if (pretty && r.slice(-newline.length) === newline) {
	                        r = r.slice(0, -newline.length);
	                    }
	                    return r;
	                };
	                return XMLBuilder;
	            }();
	        }).call(this);
	    }, {
	        "./XMLDeclaration": 96,
	        "./XMLDocType": 97,
	        "./XMLElement": 98,
	        "./XMLStringifier": 102
	    } ],
	    102: [ function(require, module, exports) {
	        (function() {
	            var XMLStringifier, bind = function(fn, me) {
	                return function() {
	                    return fn.apply(me, arguments);
	                };
	            }, hasProp = {}.hasOwnProperty;
	            module.exports = XMLStringifier = function() {
	                function XMLStringifier(options) {
	                    this.assertLegalChar = bind(this.assertLegalChar, this);
	                    var key, ref, value;
	                    this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
	                    ref = (options != null ? options.stringify : void 0) || {};
	                    for (key in ref) {
	                        if (!hasProp.call(ref, key)) continue;
	                        value = ref[key];
	                        this[key] = value;
	                    }
	                }
	                XMLStringifier.prototype.eleName = function(val) {
	                    val = "" + val || "";
	                    return this.assertLegalChar(val);
	                };
	                XMLStringifier.prototype.eleText = function(val) {
	                    val = "" + val || "";
	                    return this.assertLegalChar(this.elEscape(val));
	                };
	                XMLStringifier.prototype.cdata = function(val) {
	                    val = "" + val || "";
	                    if (val.match(/]]>/)) {
	                        throw new Error("Invalid CDATA text: " + val);
	                    }
	                    return this.assertLegalChar(val);
	                };
	                XMLStringifier.prototype.comment = function(val) {
	                    val = "" + val || "";
	                    if (val.match(/--/)) {
	                        throw new Error("Comment text cannot contain double-hypen: " + val);
	                    }
	                    return this.assertLegalChar(val);
	                };
	                XMLStringifier.prototype.raw = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.attName = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.attValue = function(val) {
	                    val = "" + val || "";
	                    return this.attEscape(val);
	                };
	                XMLStringifier.prototype.insTarget = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.insValue = function(val) {
	                    val = "" + val || "";
	                    if (val.match(/\?>/)) {
	                        throw new Error("Invalid processing instruction value: " + val);
	                    }
	                    return val;
	                };
	                XMLStringifier.prototype.xmlVersion = function(val) {
	                    val = "" + val || "";
	                    if (!val.match(/1\.[0-9]+/)) {
	                        throw new Error("Invalid version number: " + val);
	                    }
	                    return val;
	                };
	                XMLStringifier.prototype.xmlEncoding = function(val) {
	                    val = "" + val || "";
	                    if (!val.match(/[A-Za-z](?:[A-Za-z0-9._-]|-)*/)) {
	                        throw new Error("Invalid encoding: " + val);
	                    }
	                    return val;
	                };
	                XMLStringifier.prototype.xmlStandalone = function(val) {
	                    if (val) {
	                        return "yes";
	                    } else {
	                        return "no";
	                    }
	                };
	                XMLStringifier.prototype.dtdPubID = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.dtdSysID = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.dtdElementValue = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.dtdAttType = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.dtdAttDefault = function(val) {
	                    if (val != null) {
	                        return "" + val || "";
	                    } else {
	                        return val;
	                    }
	                };
	                XMLStringifier.prototype.dtdEntityValue = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.dtdNData = function(val) {
	                    return "" + val || "";
	                };
	                XMLStringifier.prototype.convertAttKey = "@";
	                XMLStringifier.prototype.convertPIKey = "?";
	                XMLStringifier.prototype.convertTextKey = "#text";
	                XMLStringifier.prototype.convertCDataKey = "#cdata";
	                XMLStringifier.prototype.convertCommentKey = "#comment";
	                XMLStringifier.prototype.convertRawKey = "#raw";
	                XMLStringifier.prototype.convertListKey = "#list";
	                XMLStringifier.prototype.assertLegalChar = function(str) {
	                    var chars, chr;
	                    if (this.allowSurrogateChars) {
	                        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
	                    } else {
	                        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
	                    }
	                    chr = str.match(chars);
	                    if (chr) {
	                        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
	                    }
	                    return str;
	                };
	                XMLStringifier.prototype.elEscape = function(str) {
	                    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
	                };
	                XMLStringifier.prototype.attEscape = function(str) {
	                    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
	                };
	                return XMLStringifier;
	            }();
	        }).call(this);
	    }, {} ],
	    96: [ function(require, module, exports) {
	        (function() {
	            var XMLDeclaration, XMLNode, create, isObject, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            isObject = require("lodash/lang/isObject");
	            XMLNode = require("./XMLNode");
	            module.exports = XMLDeclaration = function(superClass) {
	                extend(XMLDeclaration, superClass);
	                function XMLDeclaration(parent, version, encoding, standalone) {
	                    var ref;
	                    XMLDeclaration.__super__.constructor.call(this, parent);
	                    if (isObject(version)) {
	                        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
	                    }
	                    if (!version) {
	                        version = "1.0";
	                    }
	                    if (version != null) {
	                        this.version = this.stringify.xmlVersion(version);
	                    }
	                    if (encoding != null) {
	                        this.encoding = this.stringify.xmlEncoding(encoding);
	                    }
	                    if (standalone != null) {
	                        this.standalone = this.stringify.xmlStandalone(standalone);
	                    }
	                }
	                XMLDeclaration.prototype.clone = function() {
	                    return create(XMLDeclaration.prototype, this);
	                };
	                XMLDeclaration.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<?xml";
	                    if (this.version != null) {
	                        r += ' version="' + this.version + '"';
	                    }
	                    if (this.encoding != null) {
	                        r += ' encoding="' + this.encoding + '"';
	                    }
	                    if (this.standalone != null) {
	                        r += ' standalone="' + this.standalone + '"';
	                    }
	                    r += "?>";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLDeclaration;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLNode": 99,
	        "lodash/lang/isObject": 143,
	        "lodash/object/create": 147
	    } ],
	    99: [ function(require, module, exports) {
	        (function() {
	            var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLRaw, XMLText, isArray, isEmpty, isFunction, isObject, hasProp = {}.hasOwnProperty;
	            isObject = require("lodash/lang/isObject");
	            isArray = require("lodash/lang/isArray");
	            isFunction = require("lodash/lang/isFunction");
	            isEmpty = require("lodash/lang/isEmpty");
	            XMLElement = null;
	            XMLCData = null;
	            XMLComment = null;
	            XMLDeclaration = null;
	            XMLDocType = null;
	            XMLRaw = null;
	            XMLText = null;
	            module.exports = XMLNode = function() {
	                function XMLNode(parent) {
	                    this.parent = parent;
	                    this.options = this.parent.options;
	                    this.stringify = this.parent.stringify;
	                    if (XMLElement === null) {
	                        XMLElement = require("./XMLElement");
	                        XMLCData = require("./XMLCData");
	                        XMLComment = require("./XMLComment");
	                        XMLDeclaration = require("./XMLDeclaration");
	                        XMLDocType = require("./XMLDocType");
	                        XMLRaw = require("./XMLRaw");
	                        XMLText = require("./XMLText");
	                    }
	                }
	                XMLNode.prototype.clone = function() {
	                    throw new Error("Cannot clone generic XMLNode");
	                };
	                XMLNode.prototype.element = function(name, attributes, text) {
	                    var item, j, key, lastChild, len, ref, val;
	                    lastChild = null;
	                    if (attributes == null) {
	                        attributes = {};
	                    }
	                    attributes = attributes.valueOf();
	                    if (!isObject(attributes)) {
	                        ref = [ attributes, text ], text = ref[0], attributes = ref[1];
	                    }
	                    if (name != null) {
	                        name = name.valueOf();
	                    }
	                    if (isArray(name)) {
	                        for (j = 0, len = name.length; j < len; j++) {
	                            item = name[j];
	                            lastChild = this.element(item);
	                        }
	                    } else if (isFunction(name)) {
	                        lastChild = this.element(name.apply());
	                    } else if (isObject(name)) {
	                        for (key in name) {
	                            if (!hasProp.call(name, key)) continue;
	                            val = name[key];
	                            if (isFunction(val)) {
	                                val = val.apply();
	                            }
	                            if (isObject(val) && isEmpty(val)) {
	                                val = null;
	                            }
	                            if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
	                                lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
	                            } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && key.indexOf(this.stringify.convertPIKey) === 0) {
	                                lastChild = this.instruction(key.substr(this.stringify.convertPIKey.length), val);
	                            } else if (isObject(val)) {
	                                if (!this.options.ignoreDecorators && this.stringify.convertListKey && key.indexOf(this.stringify.convertListKey) === 0 && isArray(val)) {
	                                    lastChild = this.element(val);
	                                } else {
	                                    lastChild = this.element(key);
	                                    lastChild.element(val);
	                                }
	                            } else {
	                                lastChild = this.element(key, val);
	                            }
	                        }
	                    } else {
	                        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
	                            lastChild = this.text(text);
	                        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
	                            lastChild = this.cdata(text);
	                        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
	                            lastChild = this.comment(text);
	                        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
	                            lastChild = this.raw(text);
	                        } else {
	                            lastChild = this.node(name, attributes, text);
	                        }
	                    }
	                    if (lastChild == null) {
	                        throw new Error("Could not create any elements with: " + name);
	                    }
	                    return lastChild;
	                };
	                XMLNode.prototype.insertBefore = function(name, attributes, text) {
	                    var child, i, removed;
	                    if (this.isRoot) {
	                        throw new Error("Cannot insert elements at root level");
	                    }
	                    i = this.parent.children.indexOf(this);
	                    removed = this.parent.children.splice(i);
	                    child = this.parent.element(name, attributes, text);
	                    Array.prototype.push.apply(this.parent.children, removed);
	                    return child;
	                };
	                XMLNode.prototype.insertAfter = function(name, attributes, text) {
	                    var child, i, removed;
	                    if (this.isRoot) {
	                        throw new Error("Cannot insert elements at root level");
	                    }
	                    i = this.parent.children.indexOf(this);
	                    removed = this.parent.children.splice(i + 1);
	                    child = this.parent.element(name, attributes, text);
	                    Array.prototype.push.apply(this.parent.children, removed);
	                    return child;
	                };
	                XMLNode.prototype.remove = function() {
	                    var i, ref;
	                    if (this.isRoot) {
	                        throw new Error("Cannot remove the root element");
	                    }
	                    i = this.parent.children.indexOf(this);
	                    [].splice.apply(this.parent.children, [ i, i - i + 1 ].concat(ref = [])), ref;
	                    return this.parent;
	                };
	                XMLNode.prototype.node = function(name, attributes, text) {
	                    var child, ref;
	                    if (name != null) {
	                        name = name.valueOf();
	                    }
	                    if (attributes == null) {
	                        attributes = {};
	                    }
	                    attributes = attributes.valueOf();
	                    if (!isObject(attributes)) {
	                        ref = [ attributes, text ], text = ref[0], attributes = ref[1];
	                    }
	                    child = new XMLElement(this, name, attributes);
	                    if (text != null) {
	                        child.text(text);
	                    }
	                    this.children.push(child);
	                    return child;
	                };
	                XMLNode.prototype.text = function(value) {
	                    var child;
	                    child = new XMLText(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLNode.prototype.cdata = function(value) {
	                    var child;
	                    child = new XMLCData(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLNode.prototype.comment = function(value) {
	                    var child;
	                    child = new XMLComment(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLNode.prototype.raw = function(value) {
	                    var child;
	                    child = new XMLRaw(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLNode.prototype.declaration = function(version, encoding, standalone) {
	                    var doc, xmldec;
	                    doc = this.document();
	                    xmldec = new XMLDeclaration(doc, version, encoding, standalone);
	                    doc.xmldec = xmldec;
	                    return doc.root();
	                };
	                XMLNode.prototype.doctype = function(pubID, sysID) {
	                    var doc, doctype;
	                    doc = this.document();
	                    doctype = new XMLDocType(doc, pubID, sysID);
	                    doc.doctype = doctype;
	                    return doctype;
	                };
	                XMLNode.prototype.up = function() {
	                    if (this.isRoot) {
	                        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
	                    }
	                    return this.parent;
	                };
	                XMLNode.prototype.root = function() {
	                    var child;
	                    if (this.isRoot) {
	                        return this;
	                    }
	                    child = this.parent;
	                    while (!child.isRoot) {
	                        child = child.parent;
	                    }
	                    return child;
	                };
	                XMLNode.prototype.document = function() {
	                    return this.root().documentObject;
	                };
	                XMLNode.prototype.end = function(options) {
	                    return this.document().toString(options);
	                };
	                XMLNode.prototype.prev = function() {
	                    var i;
	                    if (this.isRoot) {
	                        throw new Error("Root node has no siblings");
	                    }
	                    i = this.parent.children.indexOf(this);
	                    if (i < 1) {
	                        throw new Error("Already at the first node");
	                    }
	                    return this.parent.children[i - 1];
	                };
	                XMLNode.prototype.next = function() {
	                    var i;
	                    if (this.isRoot) {
	                        throw new Error("Root node has no siblings");
	                    }
	                    i = this.parent.children.indexOf(this);
	                    if (i === -1 || i === this.parent.children.length - 1) {
	                        throw new Error("Already at the last node");
	                    }
	                    return this.parent.children[i + 1];
	                };
	                XMLNode.prototype.importXMLBuilder = function(xmlbuilder) {
	                    var clonedRoot;
	                    clonedRoot = xmlbuilder.root().clone();
	                    clonedRoot.parent = this;
	                    clonedRoot.isRoot = false;
	                    this.children.push(clonedRoot);
	                    return this;
	                };
	                XMLNode.prototype.ele = function(name, attributes, text) {
	                    return this.element(name, attributes, text);
	                };
	                XMLNode.prototype.nod = function(name, attributes, text) {
	                    return this.node(name, attributes, text);
	                };
	                XMLNode.prototype.txt = function(value) {
	                    return this.text(value);
	                };
	                XMLNode.prototype.dat = function(value) {
	                    return this.cdata(value);
	                };
	                XMLNode.prototype.com = function(value) {
	                    return this.comment(value);
	                };
	                XMLNode.prototype.doc = function() {
	                    return this.document();
	                };
	                XMLNode.prototype.dec = function(version, encoding, standalone) {
	                    return this.declaration(version, encoding, standalone);
	                };
	                XMLNode.prototype.dtd = function(pubID, sysID) {
	                    return this.doctype(pubID, sysID);
	                };
	                XMLNode.prototype.e = function(name, attributes, text) {
	                    return this.element(name, attributes, text);
	                };
	                XMLNode.prototype.n = function(name, attributes, text) {
	                    return this.node(name, attributes, text);
	                };
	                XMLNode.prototype.t = function(value) {
	                    return this.text(value);
	                };
	                XMLNode.prototype.d = function(value) {
	                    return this.cdata(value);
	                };
	                XMLNode.prototype.c = function(value) {
	                    return this.comment(value);
	                };
	                XMLNode.prototype.r = function(value) {
	                    return this.raw(value);
	                };
	                XMLNode.prototype.u = function() {
	                    return this.up();
	                };
	                return XMLNode;
	            }();
	        }).call(this);
	    }, {
	        "./XMLCData": 90,
	        "./XMLComment": 91,
	        "./XMLDeclaration": 96,
	        "./XMLDocType": 97,
	        "./XMLElement": 98,
	        "./XMLRaw": 101,
	        "./XMLText": 103,
	        "lodash/lang/isArray": 139,
	        "lodash/lang/isEmpty": 140,
	        "lodash/lang/isFunction": 141,
	        "lodash/lang/isObject": 143
	    } ],
	    140: [ function(require, module, exports) {
	        var isArguments = require("./isArguments"), isArray = require("./isArray"), isFunction = require("./isFunction"), isLength = require("../internal/isLength"), isObjectLike = require("../internal/isObjectLike"), isString = require("./isString"), keys = require("../object/keys");
	        function isEmpty(value) {
	            if (value == null) {
	                return true;
	            }
	            var length = value.length;
	            if (isLength(length) && (isArray(value) || isString(value) || isArguments(value) || isObjectLike(value) && isFunction(value.splice))) {
	                return !length;
	            }
	            return !keys(value).length;
	        }
	        module.exports = isEmpty;
	    }, {
	        "../internal/isLength": 132,
	        "../internal/isObjectLike": 133,
	        "../object/keys": 148,
	        "./isArguments": 138,
	        "./isArray": 139,
	        "./isFunction": 141,
	        "./isString": 144
	    } ],
	    144: [ function(require, module, exports) {
	        var isObjectLike = require("../internal/isObjectLike");
	        var stringTag = "[object String]";
	        var objectProto = Object.prototype;
	        var objToString = objectProto.toString;
	        function isString(value) {
	            return typeof value == "string" || isObjectLike(value) && objToString.call(value) == stringTag || false;
	        }
	        module.exports = isString;
	    }, {
	        "../internal/isObjectLike": 133
	    } ],
	    103: [ function(require, module, exports) {
	        (function() {
	            var XMLNode, XMLText, create, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            XMLNode = require("./XMLNode");
	            module.exports = XMLText = function(superClass) {
	                extend(XMLText, superClass);
	                function XMLText(parent, text) {
	                    XMLText.__super__.constructor.call(this, parent);
	                    if (text == null) {
	                        throw new Error("Missing element text");
	                    }
	                    this.value = this.stringify.eleText(text);
	                }
	                XMLText.prototype.clone = function() {
	                    return create(XMLText.prototype, this);
	                };
	                XMLText.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += this.value;
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLText;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLNode": 99,
	        "lodash/object/create": 147
	    } ],
	    101: [ function(require, module, exports) {
	        (function() {
	            var XMLNode, XMLRaw, create, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            XMLNode = require("./XMLNode");
	            module.exports = XMLRaw = function(superClass) {
	                extend(XMLRaw, superClass);
	                function XMLRaw(parent, text) {
	                    XMLRaw.__super__.constructor.call(this, parent);
	                    if (text == null) {
	                        throw new Error("Missing raw text");
	                    }
	                    this.value = this.stringify.raw(text);
	                }
	                XMLRaw.prototype.clone = function() {
	                    return create(XMLRaw.prototype, this);
	                };
	                XMLRaw.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += this.value;
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLRaw;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLNode": 99,
	        "lodash/object/create": 147
	    } ],
	    98: [ function(require, module, exports) {
	        (function() {
	            var XMLAttribute, XMLElement, XMLNode, XMLProcessingInstruction, create, every, isArray, isFunction, isObject, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            isObject = require("lodash/lang/isObject");
	            isArray = require("lodash/lang/isArray");
	            isFunction = require("lodash/lang/isFunction");
	            every = require("lodash/collection/every");
	            XMLNode = require("./XMLNode");
	            XMLAttribute = require("./XMLAttribute");
	            XMLProcessingInstruction = require("./XMLProcessingInstruction");
	            module.exports = XMLElement = function(superClass) {
	                extend(XMLElement, superClass);
	                function XMLElement(parent, name, attributes) {
	                    XMLElement.__super__.constructor.call(this, parent);
	                    if (name == null) {
	                        throw new Error("Missing element name");
	                    }
	                    this.name = this.stringify.eleName(name);
	                    this.children = [];
	                    this.instructions = [];
	                    this.attributes = {};
	                    if (attributes != null) {
	                        this.attribute(attributes);
	                    }
	                }
	                XMLElement.prototype.clone = function() {
	                    var att, attName, clonedSelf, i, len, pi, ref, ref1;
	                    clonedSelf = create(XMLElement.prototype, this);
	                    if (clonedSelf.isRoot) {
	                        clonedSelf.documentObject = null;
	                    }
	                    clonedSelf.attributes = {};
	                    ref = this.attributes;
	                    for (attName in ref) {
	                        if (!hasProp.call(ref, attName)) continue;
	                        att = ref[attName];
	                        clonedSelf.attributes[attName] = att.clone();
	                    }
	                    clonedSelf.instructions = [];
	                    ref1 = this.instructions;
	                    for (i = 0, len = ref1.length; i < len; i++) {
	                        pi = ref1[i];
	                        clonedSelf.instructions.push(pi.clone());
	                    }
	                    clonedSelf.children = [];
	                    this.children.forEach(function(child) {
	                        var clonedChild;
	                        clonedChild = child.clone();
	                        clonedChild.parent = clonedSelf;
	                        return clonedSelf.children.push(clonedChild);
	                    });
	                    return clonedSelf;
	                };
	                XMLElement.prototype.attribute = function(name, value) {
	                    var attName, attValue;
	                    if (name != null) {
	                        name = name.valueOf();
	                    }
	                    if (isObject(name)) {
	                        for (attName in name) {
	                            if (!hasProp.call(name, attName)) continue;
	                            attValue = name[attName];
	                            this.attribute(attName, attValue);
	                        }
	                    } else {
	                        if (isFunction(value)) {
	                            value = value.apply();
	                        }
	                        if (!this.options.skipNullAttributes || value != null) {
	                            this.attributes[name] = new XMLAttribute(this, name, value);
	                        }
	                    }
	                    return this;
	                };
	                XMLElement.prototype.removeAttribute = function(name) {
	                    var attName, i, len;
	                    if (name == null) {
	                        throw new Error("Missing attribute name");
	                    }
	                    name = name.valueOf();
	                    if (isArray(name)) {
	                        for (i = 0, len = name.length; i < len; i++) {
	                            attName = name[i];
	                            delete this.attributes[attName];
	                        }
	                    } else {
	                        delete this.attributes[name];
	                    }
	                    return this;
	                };
	                XMLElement.prototype.instruction = function(target, value) {
	                    var i, insTarget, insValue, instruction, len;
	                    if (target != null) {
	                        target = target.valueOf();
	                    }
	                    if (value != null) {
	                        value = value.valueOf();
	                    }
	                    if (isArray(target)) {
	                        for (i = 0, len = target.length; i < len; i++) {
	                            insTarget = target[i];
	                            this.instruction(insTarget);
	                        }
	                    } else if (isObject(target)) {
	                        for (insTarget in target) {
	                            if (!hasProp.call(target, insTarget)) continue;
	                            insValue = target[insTarget];
	                            this.instruction(insTarget, insValue);
	                        }
	                    } else {
	                        if (isFunction(value)) {
	                            value = value.apply();
	                        }
	                        instruction = new XMLProcessingInstruction(this, target, value);
	                        this.instructions.push(instruction);
	                    }
	                    return this;
	                };
	                XMLElement.prototype.toString = function(options, level) {
	                    var att, child, i, indent, instruction, j, len, len1, name, newline, offset, pretty, r, ref, ref1, ref2, ref3, ref4, ref5, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    ref3 = this.instructions;
	                    for (i = 0, len = ref3.length; i < len; i++) {
	                        instruction = ref3[i];
	                        r += instruction.toString(options, level + 1);
	                    }
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<" + this.name;
	                    ref4 = this.attributes;
	                    for (name in ref4) {
	                        if (!hasProp.call(ref4, name)) continue;
	                        att = ref4[name];
	                        r += att.toString(options);
	                    }
	                    if (this.children.length === 0 || every(this.children, function(e) {
	                        return e.value === "";
	                    })) {
	                        r += "/>";
	                        if (pretty) {
	                            r += newline;
	                        }
	                    } else if (pretty && this.children.length === 1 && this.children[0].value != null) {
	                        r += ">";
	                        r += this.children[0].value;
	                        r += "</" + this.name + ">";
	                        r += newline;
	                    } else {
	                        r += ">";
	                        if (pretty) {
	                            r += newline;
	                        }
	                        ref5 = this.children;
	                        for (j = 0, len1 = ref5.length; j < len1; j++) {
	                            child = ref5[j];
	                            r += child.toString(options, level + 1);
	                        }
	                        if (pretty) {
	                            r += space;
	                        }
	                        r += "</" + this.name + ">";
	                        if (pretty) {
	                            r += newline;
	                        }
	                    }
	                    return r;
	                };
	                XMLElement.prototype.att = function(name, value) {
	                    return this.attribute(name, value);
	                };
	                XMLElement.prototype.ins = function(target, value) {
	                    return this.instruction(target, value);
	                };
	                XMLElement.prototype.a = function(name, value) {
	                    return this.attribute(name, value);
	                };
	                XMLElement.prototype.i = function(target, value) {
	                    return this.instruction(target, value);
	                };
	                return XMLElement;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLAttribute": 88,
	        "./XMLNode": 99,
	        "./XMLProcessingInstruction": 100,
	        "lodash/collection/every": 105,
	        "lodash/lang/isArray": 139,
	        "lodash/lang/isFunction": 141,
	        "lodash/lang/isObject": 143,
	        "lodash/object/create": 147
	    } ],
	    141: [ function(require, module, exports) {
	        (function(global) {
	            var baseIsFunction = require("../internal/baseIsFunction"), isNative = require("./isNative");
	            var funcTag = "[object Function]";
	            var objectProto = Object.prototype;
	            var objToString = objectProto.toString;
	            var Uint8Array = isNative(Uint8Array = global.Uint8Array) && Uint8Array;
	            var isFunction = !(baseIsFunction(/x/) || Uint8Array && !baseIsFunction(Uint8Array)) ? baseIsFunction : function(value) {
	                return objToString.call(value) == funcTag;
	            };
	            module.exports = isFunction;
	        }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	        "../internal/baseIsFunction": 117,
	        "./isNative": 142
	    } ],
	    117: [ function(require, module, exports) {
	        function baseIsFunction(value) {
	            return typeof value == "function" || false;
	        }
	        module.exports = baseIsFunction;
	    }, {} ],
	    105: [ function(require, module, exports) {
	        var arrayEvery = require("../internal/arrayEvery"), baseCallback = require("../internal/baseCallback"), baseEvery = require("../internal/baseEvery"), isArray = require("../lang/isArray");
	        function every(collection, predicate, thisArg) {
	            var func = isArray(collection) ? arrayEvery : baseEvery;
	            if (typeof predicate != "function" || typeof thisArg != "undefined") {
	                predicate = baseCallback(predicate, thisArg, 3);
	            }
	            return func(collection, predicate);
	        }
	        module.exports = every;
	    }, {
	        "../internal/arrayEvery": 106,
	        "../internal/baseCallback": 108,
	        "../internal/baseEvery": 112,
	        "../lang/isArray": 139
	    } ],
	    112: [ function(require, module, exports) {
	        var baseEach = require("./baseEach");
	        function baseEvery(collection, predicate) {
	            var result = true;
	            baseEach(collection, function(value, index, collection) {
	                result = !!predicate(value, index, collection);
	                return result;
	            });
	            return result;
	        }
	        module.exports = baseEvery;
	    }, {
	        "./baseEach": 111
	    } ],
	    111: [ function(require, module, exports) {
	        var baseForOwn = require("./baseForOwn"), isLength = require("./isLength"), toObject = require("./toObject");
	        function baseEach(collection, iteratee) {
	            var length = collection ? collection.length : 0;
	            if (!isLength(length)) {
	                return baseForOwn(collection, iteratee);
	            }
	            var index = -1, iterable = toObject(collection);
	            while (++index < length) {
	                if (iteratee(iterable[index], index, iterable) === false) {
	                    break;
	                }
	            }
	            return collection;
	        }
	        module.exports = baseEach;
	    }, {
	        "./baseForOwn": 114,
	        "./isLength": 132,
	        "./toObject": 137
	    } ],
	    114: [ function(require, module, exports) {
	        var baseFor = require("./baseFor"), keys = require("../object/keys");
	        function baseForOwn(object, iteratee) {
	            return baseFor(object, iteratee, keys);
	        }
	        module.exports = baseForOwn;
	    }, {
	        "../object/keys": 148,
	        "./baseFor": 113
	    } ],
	    113: [ function(require, module, exports) {
	        var toObject = require("./toObject");
	        function baseFor(object, iteratee, keysFunc) {
	            var index = -1, iterable = toObject(object), props = keysFunc(object), length = props.length;
	            while (++index < length) {
	                var key = props[index];
	                if (iteratee(iterable[key], key, iterable) === false) {
	                    break;
	                }
	            }
	            return object;
	        }
	        module.exports = baseFor;
	    }, {
	        "./toObject": 137
	    } ],
	    137: [ function(require, module, exports) {
	        var isObject = require("../lang/isObject");
	        function toObject(value) {
	            return isObject(value) ? value : Object(value);
	        }
	        module.exports = toObject;
	    }, {
	        "../lang/isObject": 143
	    } ],
	    108: [ function(require, module, exports) {
	        var baseMatches = require("./baseMatches"), baseMatchesProperty = require("./baseMatchesProperty"), baseProperty = require("./baseProperty"), bindCallback = require("./bindCallback"), identity = require("../utility/identity"), isBindable = require("./isBindable");
	        function baseCallback(func, thisArg, argCount) {
	            var type = typeof func;
	            if (type == "function") {
	                return typeof thisArg != "undefined" && isBindable(func) ? bindCallback(func, thisArg, argCount) : func;
	            }
	            if (func == null) {
	                return identity;
	            }
	            if (type == "object") {
	                return baseMatches(func);
	            }
	            return typeof thisArg == "undefined" ? baseProperty(func + "") : baseMatchesProperty(func + "", thisArg);
	        }
	        module.exports = baseCallback;
	    }, {
	        "../utility/identity": 152,
	        "./baseMatches": 119,
	        "./baseMatchesProperty": 120,
	        "./baseProperty": 121,
	        "./bindCallback": 124,
	        "./isBindable": 129
	    } ],
	    129: [ function(require, module, exports) {
	        var baseSetData = require("./baseSetData"), isNative = require("../lang/isNative"), support = require("../support");
	        var reFuncName = /^\s*function[ \n\r\t]+\w/;
	        var reThis = /\bthis\b/;
	        var fnToString = Function.prototype.toString;
	        function isBindable(func) {
	            var result = !(support.funcNames ? func.name : support.funcDecomp);
	            if (!result) {
	                var source = fnToString.call(func);
	                if (!support.funcNames) {
	                    result = !reFuncName.test(source);
	                }
	                if (!result) {
	                    result = reThis.test(source) || isNative(func);
	                    baseSetData(func, result);
	                }
	            }
	            return result;
	        }
	        module.exports = isBindable;
	    }, {
	        "../lang/isNative": 142,
	        "../support": 151,
	        "./baseSetData": 122
	    } ],
	    122: [ function(require, module, exports) {
	        var identity = require("../utility/identity"), metaMap = require("./metaMap");
	        var baseSetData = !metaMap ? identity : function(func, data) {
	            metaMap.set(func, data);
	            return func;
	        };
	        module.exports = baseSetData;
	    }, {
	        "../utility/identity": 152,
	        "./metaMap": 135
	    } ],
	    135: [ function(require, module, exports) {
	        (function(global) {
	            var isNative = require("../lang/isNative");
	            var WeakMap = isNative(WeakMap = global.WeakMap) && WeakMap;
	            var metaMap = WeakMap && new WeakMap();
	            module.exports = metaMap;
	        }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	        "../lang/isNative": 142
	    } ],
	    124: [ function(require, module, exports) {
	        var identity = require("../utility/identity");
	        function bindCallback(func, thisArg, argCount) {
	            if (typeof func != "function") {
	                return identity;
	            }
	            if (typeof thisArg == "undefined") {
	                return func;
	            }
	            switch (argCount) {
	              case 1:
	                return function(value) {
	                    return func.call(thisArg, value);
	                };
	
	              case 3:
	                return function(value, index, collection) {
	                    return func.call(thisArg, value, index, collection);
	                };
	
	              case 4:
	                return function(accumulator, value, index, collection) {
	                    return func.call(thisArg, accumulator, value, index, collection);
	                };
	
	              case 5:
	                return function(value, other, key, object, source) {
	                    return func.call(thisArg, value, other, key, object, source);
	                };
	            }
	            return function() {
	                return func.apply(thisArg, arguments);
	            };
	        }
	        module.exports = bindCallback;
	    }, {
	        "../utility/identity": 152
	    } ],
	    152: [ function(require, module, exports) {
	        function identity(value) {
	            return value;
	        }
	        module.exports = identity;
	    }, {} ],
	    121: [ function(require, module, exports) {
	        function baseProperty(key) {
	            return function(object) {
	                return object == null ? undefined : object[key];
	            };
	        }
	        module.exports = baseProperty;
	    }, {} ],
	    120: [ function(require, module, exports) {
	        var baseIsEqual = require("./baseIsEqual"), isStrictComparable = require("./isStrictComparable");
	        function baseMatchesProperty(key, value) {
	            if (isStrictComparable(value)) {
	                return function(object) {
	                    return object != null && object[key] === value;
	                };
	            }
	            return function(object) {
	                return object != null && baseIsEqual(value, object[key], null, true);
	            };
	        }
	        module.exports = baseMatchesProperty;
	    }, {
	        "./baseIsEqual": 115,
	        "./isStrictComparable": 134
	    } ],
	    119: [ function(require, module, exports) {
	        var baseIsMatch = require("./baseIsMatch"), isStrictComparable = require("./isStrictComparable"), keys = require("../object/keys");
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        function baseMatches(source) {
	            var props = keys(source), length = props.length;
	            if (length == 1) {
	                var key = props[0], value = source[key];
	                if (isStrictComparable(value)) {
	                    return function(object) {
	                        return object != null && object[key] === value && hasOwnProperty.call(object, key);
	                    };
	                }
	            }
	            var values = Array(length), strictCompareFlags = Array(length);
	            while (length--) {
	                value = source[props[length]];
	                values[length] = value;
	                strictCompareFlags[length] = isStrictComparable(value);
	            }
	            return function(object) {
	                return baseIsMatch(object, props, values, strictCompareFlags);
	            };
	        }
	        module.exports = baseMatches;
	    }, {
	        "../object/keys": 148,
	        "./baseIsMatch": 118,
	        "./isStrictComparable": 134
	    } ],
	    134: [ function(require, module, exports) {
	        var isObject = require("../lang/isObject");
	        function isStrictComparable(value) {
	            return value === value && (value === 0 ? 1 / value > 0 : !isObject(value));
	        }
	        module.exports = isStrictComparable;
	    }, {
	        "../lang/isObject": 143
	    } ],
	    118: [ function(require, module, exports) {
	        var baseIsEqual = require("./baseIsEqual");
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        function baseIsMatch(object, props, values, strictCompareFlags, customizer) {
	            var length = props.length;
	            if (object == null) {
	                return !length;
	            }
	            var index = -1, noCustomizer = !customizer;
	            while (++index < length) {
	                if (noCustomizer && strictCompareFlags[index] ? values[index] !== object[props[index]] : !hasOwnProperty.call(object, props[index])) {
	                    return false;
	                }
	            }
	            index = -1;
	            while (++index < length) {
	                var key = props[index];
	                if (noCustomizer && strictCompareFlags[index]) {
	                    var result = hasOwnProperty.call(object, key);
	                } else {
	                    var objValue = object[key], srcValue = values[index];
	                    result = customizer ? customizer(objValue, srcValue, key) : undefined;
	                    if (typeof result == "undefined") {
	                        result = baseIsEqual(srcValue, objValue, customizer, true);
	                    }
	                }
	                if (!result) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        module.exports = baseIsMatch;
	    }, {
	        "./baseIsEqual": 115
	    } ],
	    115: [ function(require, module, exports) {
	        var baseIsEqualDeep = require("./baseIsEqualDeep");
	        function baseIsEqual(value, other, customizer, isWhere, stackA, stackB) {
	            if (value === other) {
	                return value !== 0 || 1 / value == 1 / other;
	            }
	            var valType = typeof value, othType = typeof other;
	            if (valType != "function" && valType != "object" && othType != "function" && othType != "object" || value == null || other == null) {
	                return value !== value && other !== other;
	            }
	            return baseIsEqualDeep(value, other, baseIsEqual, customizer, isWhere, stackA, stackB);
	        }
	        module.exports = baseIsEqual;
	    }, {
	        "./baseIsEqualDeep": 116
	    } ],
	    116: [ function(require, module, exports) {
	        var equalArrays = require("./equalArrays"), equalByTag = require("./equalByTag"), equalObjects = require("./equalObjects"), isArray = require("../lang/isArray"), isTypedArray = require("../lang/isTypedArray");
	        var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        var objToString = objectProto.toString;
	        function baseIsEqualDeep(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
	            if (!objIsArr) {
	                objTag = objToString.call(object);
	                if (objTag == argsTag) {
	                    objTag = objectTag;
	                } else if (objTag != objectTag) {
	                    objIsArr = isTypedArray(object);
	                }
	            }
	            if (!othIsArr) {
	                othTag = objToString.call(other);
	                if (othTag == argsTag) {
	                    othTag = objectTag;
	                } else if (othTag != objectTag) {
	                    othIsArr = isTypedArray(other);
	                }
	            }
	            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
	            if (isSameTag && !(objIsArr || objIsObj)) {
	                return equalByTag(object, other, objTag);
	            }
	            var valWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
	            if (valWrapped || othWrapped) {
	                return equalFunc(valWrapped ? object.value() : object, othWrapped ? other.value() : other, customizer, isWhere, stackA, stackB);
	            }
	            if (!isSameTag) {
	                return false;
	            }
	            stackA || (stackA = []);
	            stackB || (stackB = []);
	            var length = stackA.length;
	            while (length--) {
	                if (stackA[length] == object) {
	                    return stackB[length] == other;
	                }
	            }
	            stackA.push(object);
	            stackB.push(other);
	            var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isWhere, stackA, stackB);
	            stackA.pop();
	            stackB.pop();
	            return result;
	        }
	        module.exports = baseIsEqualDeep;
	    }, {
	        "../lang/isArray": 139,
	        "../lang/isTypedArray": 145,
	        "./equalArrays": 126,
	        "./equalByTag": 127,
	        "./equalObjects": 128
	    } ],
	    145: [ function(require, module, exports) {
	        var isLength = require("../internal/isLength"), isObjectLike = require("../internal/isObjectLike");
	        var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
	        var arrayBufferTag = "[object ArrayBuffer]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
	        var typedArrayTags = {};
	        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
	        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	        var objectProto = Object.prototype;
	        var objToString = objectProto.toString;
	        function isTypedArray(value) {
	            return isObjectLike(value) && isLength(value.length) && typedArrayTags[objToString.call(value)] || false;
	        }
	        module.exports = isTypedArray;
	    }, {
	        "../internal/isLength": 132,
	        "../internal/isObjectLike": 133
	    } ],
	    128: [ function(require, module, exports) {
	        var keys = require("../object/keys");
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        function equalObjects(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	            var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
	            if (objLength != othLength && !isWhere) {
	                return false;
	            }
	            var hasCtor, index = -1;
	            while (++index < objLength) {
	                var key = objProps[index], result = hasOwnProperty.call(other, key);
	                if (result) {
	                    var objValue = object[key], othValue = other[key];
	                    result = undefined;
	                    if (customizer) {
	                        result = isWhere ? customizer(othValue, objValue, key) : customizer(objValue, othValue, key);
	                    }
	                    if (typeof result == "undefined") {
	                        result = objValue && objValue === othValue || equalFunc(objValue, othValue, customizer, isWhere, stackA, stackB);
	                    }
	                }
	                if (!result) {
	                    return false;
	                }
	                hasCtor || (hasCtor = key == "constructor");
	            }
	            if (!hasCtor) {
	                var objCtor = object.constructor, othCtor = other.constructor;
	                if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        module.exports = equalObjects;
	    }, {
	        "../object/keys": 148
	    } ],
	    127: [ function(require, module, exports) {
	        var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", numberTag = "[object Number]", regexpTag = "[object RegExp]", stringTag = "[object String]";
	        function equalByTag(object, other, tag) {
	            switch (tag) {
	              case boolTag:
	              case dateTag:
	                return +object == +other;
	
	              case errorTag:
	                return object.name == other.name && object.message == other.message;
	
	              case numberTag:
	                return object != +object ? other != +other : object == 0 ? 1 / object == 1 / other : object == +other;
	
	              case regexpTag:
	              case stringTag:
	                return object == other + "";
	            }
	            return false;
	        }
	        module.exports = equalByTag;
	    }, {} ],
	    126: [ function(require, module, exports) {
	        function equalArrays(array, other, equalFunc, customizer, isWhere, stackA, stackB) {
	            var index = -1, arrLength = array.length, othLength = other.length, result = true;
	            if (arrLength != othLength && !(isWhere && othLength > arrLength)) {
	                return false;
	            }
	            while (result && ++index < arrLength) {
	                var arrValue = array[index], othValue = other[index];
	                result = undefined;
	                if (customizer) {
	                    result = isWhere ? customizer(othValue, arrValue, index) : customizer(arrValue, othValue, index);
	                }
	                if (typeof result == "undefined") {
	                    if (isWhere) {
	                        var othIndex = othLength;
	                        while (othIndex--) {
	                            othValue = other[othIndex];
	                            result = arrValue && arrValue === othValue || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	                            if (result) {
	                                break;
	                            }
	                        }
	                    } else {
	                        result = arrValue && arrValue === othValue || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	                    }
	                }
	            }
	            return !!result;
	        }
	        module.exports = equalArrays;
	    }, {} ],
	    106: [ function(require, module, exports) {
	        function arrayEvery(array, predicate) {
	            var index = -1, length = array.length;
	            while (++index < length) {
	                if (!predicate(array[index], index, array)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        module.exports = arrayEvery;
	    }, {} ],
	    88: [ function(require, module, exports) {
	        (function() {
	            var XMLAttribute, create;
	            create = require("lodash/object/create");
	            module.exports = XMLAttribute = function() {
	                function XMLAttribute(parent, name, value) {
	                    this.stringify = parent.stringify;
	                    if (name == null) {
	                        throw new Error("Missing attribute name of element " + parent.name);
	                    }
	                    if (value == null) {
	                        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
	                    }
	                    this.name = this.stringify.attName(name);
	                    this.value = this.stringify.attValue(value);
	                }
	                XMLAttribute.prototype.clone = function() {
	                    return create(XMLAttribute.prototype, this);
	                };
	                XMLAttribute.prototype.toString = function(options, level) {
	                    return " " + this.name + '="' + this.value + '"';
	                };
	                return XMLAttribute;
	            }();
	        }).call(this);
	    }, {
	        "lodash/object/create": 147
	    } ],
	    97: [ function(require, module, exports) {
	        (function() {
	            var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLProcessingInstruction, create, isObject;
	            create = require("lodash/object/create");
	            isObject = require("lodash/lang/isObject");
	            XMLCData = require("./XMLCData");
	            XMLComment = require("./XMLComment");
	            XMLDTDAttList = require("./XMLDTDAttList");
	            XMLDTDEntity = require("./XMLDTDEntity");
	            XMLDTDElement = require("./XMLDTDElement");
	            XMLDTDNotation = require("./XMLDTDNotation");
	            XMLProcessingInstruction = require("./XMLProcessingInstruction");
	            module.exports = XMLDocType = function() {
	                function XMLDocType(parent, pubID, sysID) {
	                    var ref, ref1;
	                    this.documentObject = parent;
	                    this.stringify = this.documentObject.stringify;
	                    this.children = [];
	                    if (isObject(pubID)) {
	                        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
	                    }
	                    if (sysID == null) {
	                        ref1 = [ pubID, sysID ], sysID = ref1[0], pubID = ref1[1];
	                    }
	                    if (pubID != null) {
	                        this.pubID = this.stringify.dtdPubID(pubID);
	                    }
	                    if (sysID != null) {
	                        this.sysID = this.stringify.dtdSysID(sysID);
	                    }
	                }
	                XMLDocType.prototype.clone = function() {
	                    return create(XMLDocType.prototype, this);
	                };
	                XMLDocType.prototype.element = function(name, value) {
	                    var child;
	                    child = new XMLDTDElement(this, name, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	                    var child;
	                    child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.entity = function(name, value) {
	                    var child;
	                    child = new XMLDTDEntity(this, false, name, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.pEntity = function(name, value) {
	                    var child;
	                    child = new XMLDTDEntity(this, true, name, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.notation = function(name, value) {
	                    var child;
	                    child = new XMLDTDNotation(this, name, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.cdata = function(value) {
	                    var child;
	                    child = new XMLCData(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.comment = function(value) {
	                    var child;
	                    child = new XMLComment(this, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.instruction = function(target, value) {
	                    var child;
	                    child = new XMLProcessingInstruction(this, target, value);
	                    this.children.push(child);
	                    return this;
	                };
	                XMLDocType.prototype.root = function() {
	                    return this.documentObject.root();
	                };
	                XMLDocType.prototype.document = function() {
	                    return this.documentObject;
	                };
	                XMLDocType.prototype.toString = function(options, level) {
	                    var child, i, indent, len, newline, offset, pretty, r, ref, ref1, ref2, ref3, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!DOCTYPE " + this.root().name;
	                    if (this.pubID && this.sysID) {
	                        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	                    } else if (this.sysID) {
	                        r += ' SYSTEM "' + this.sysID + '"';
	                    }
	                    if (this.children.length > 0) {
	                        r += " [";
	                        if (pretty) {
	                            r += newline;
	                        }
	                        ref3 = this.children;
	                        for (i = 0, len = ref3.length; i < len; i++) {
	                            child = ref3[i];
	                            r += child.toString(options, level + 1);
	                        }
	                        r += "]";
	                    }
	                    r += ">";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                XMLDocType.prototype.ele = function(name, value) {
	                    return this.element(name, value);
	                };
	                XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	                    return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
	                };
	                XMLDocType.prototype.ent = function(name, value) {
	                    return this.entity(name, value);
	                };
	                XMLDocType.prototype.pent = function(name, value) {
	                    return this.pEntity(name, value);
	                };
	                XMLDocType.prototype.not = function(name, value) {
	                    return this.notation(name, value);
	                };
	                XMLDocType.prototype.dat = function(value) {
	                    return this.cdata(value);
	                };
	                XMLDocType.prototype.com = function(value) {
	                    return this.comment(value);
	                };
	                XMLDocType.prototype.ins = function(target, value) {
	                    return this.instruction(target, value);
	                };
	                XMLDocType.prototype.up = function() {
	                    return this.root();
	                };
	                XMLDocType.prototype.doc = function() {
	                    return this.document();
	                };
	                return XMLDocType;
	            }();
	        }).call(this);
	    }, {
	        "./XMLCData": 90,
	        "./XMLComment": 91,
	        "./XMLDTDAttList": 92,
	        "./XMLDTDElement": 93,
	        "./XMLDTDEntity": 94,
	        "./XMLDTDNotation": 95,
	        "./XMLProcessingInstruction": 100,
	        "lodash/lang/isObject": 143,
	        "lodash/object/create": 147
	    } ],
	    100: [ function(require, module, exports) {
	        (function() {
	            var XMLProcessingInstruction, create;
	            create = require("lodash/object/create");
	            module.exports = XMLProcessingInstruction = function() {
	                function XMLProcessingInstruction(parent, target, value) {
	                    this.stringify = parent.stringify;
	                    if (target == null) {
	                        throw new Error("Missing instruction target");
	                    }
	                    this.target = this.stringify.insTarget(target);
	                    if (value) {
	                        this.value = this.stringify.insValue(value);
	                    }
	                }
	                XMLProcessingInstruction.prototype.clone = function() {
	                    return create(XMLProcessingInstruction.prototype, this);
	                };
	                XMLProcessingInstruction.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<?";
	                    r += this.target;
	                    if (this.value) {
	                        r += " " + this.value;
	                    }
	                    r += "?>";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLProcessingInstruction;
	            }();
	        }).call(this);
	    }, {
	        "lodash/object/create": 147
	    } ],
	    95: [ function(require, module, exports) {
	        (function() {
	            var XMLDTDNotation, create;
	            create = require("lodash/object/create");
	            module.exports = XMLDTDNotation = function() {
	                function XMLDTDNotation(parent, name, value) {
	                    this.stringify = parent.stringify;
	                    if (name == null) {
	                        throw new Error("Missing notation name");
	                    }
	                    if (!value.pubID && !value.sysID) {
	                        throw new Error("Public or system identifiers are required for an external entity");
	                    }
	                    this.name = this.stringify.eleName(name);
	                    if (value.pubID != null) {
	                        this.pubID = this.stringify.dtdPubID(value.pubID);
	                    }
	                    if (value.sysID != null) {
	                        this.sysID = this.stringify.dtdSysID(value.sysID);
	                    }
	                }
	                XMLDTDNotation.prototype.clone = function() {
	                    return create(XMLDTDNotation.prototype, this);
	                };
	                XMLDTDNotation.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!NOTATION " + this.name;
	                    if (this.pubID && this.sysID) {
	                        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	                    } else if (this.pubID) {
	                        r += ' PUBLIC "' + this.pubID + '"';
	                    } else if (this.sysID) {
	                        r += ' SYSTEM "' + this.sysID + '"';
	                    }
	                    r += ">";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLDTDNotation;
	            }();
	        }).call(this);
	    }, {
	        "lodash/object/create": 147
	    } ],
	    94: [ function(require, module, exports) {
	        (function() {
	            var XMLDTDEntity, create, isObject;
	            create = require("lodash/object/create");
	            isObject = require("lodash/lang/isObject");
	            module.exports = XMLDTDEntity = function() {
	                function XMLDTDEntity(parent, pe, name, value) {
	                    this.stringify = parent.stringify;
	                    if (name == null) {
	                        throw new Error("Missing entity name");
	                    }
	                    if (value == null) {
	                        throw new Error("Missing entity value");
	                    }
	                    this.pe = !!pe;
	                    this.name = this.stringify.eleName(name);
	                    if (!isObject(value)) {
	                        this.value = this.stringify.dtdEntityValue(value);
	                    } else {
	                        if (!value.pubID && !value.sysID) {
	                            throw new Error("Public and/or system identifiers are required for an external entity");
	                        }
	                        if (value.pubID && !value.sysID) {
	                            throw new Error("System identifier is required for a public external entity");
	                        }
	                        if (value.pubID != null) {
	                            this.pubID = this.stringify.dtdPubID(value.pubID);
	                        }
	                        if (value.sysID != null) {
	                            this.sysID = this.stringify.dtdSysID(value.sysID);
	                        }
	                        if (value.nData != null) {
	                            this.nData = this.stringify.dtdNData(value.nData);
	                        }
	                        if (this.pe && this.nData) {
	                            throw new Error("Notation declaration is not allowed in a parameter entity");
	                        }
	                    }
	                }
	                XMLDTDEntity.prototype.clone = function() {
	                    return create(XMLDTDEntity.prototype, this);
	                };
	                XMLDTDEntity.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!ENTITY";
	                    if (this.pe) {
	                        r += " %";
	                    }
	                    r += " " + this.name;
	                    if (this.value) {
	                        r += ' "' + this.value + '"';
	                    } else {
	                        if (this.pubID && this.sysID) {
	                            r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	                        } else if (this.sysID) {
	                            r += ' SYSTEM "' + this.sysID + '"';
	                        }
	                        if (this.nData) {
	                            r += " NDATA " + this.nData;
	                        }
	                    }
	                    r += ">";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLDTDEntity;
	            }();
	        }).call(this);
	    }, {
	        "lodash/lang/isObject": 143,
	        "lodash/object/create": 147
	    } ],
	    93: [ function(require, module, exports) {
	        (function() {
	            var XMLDTDElement, create, isArray;
	            create = require("lodash/object/create");
	            isArray = require("lodash/lang/isArray");
	            module.exports = XMLDTDElement = function() {
	                function XMLDTDElement(parent, name, value) {
	                    this.stringify = parent.stringify;
	                    if (name == null) {
	                        throw new Error("Missing DTD element name");
	                    }
	                    if (!value) {
	                        value = "(#PCDATA)";
	                    }
	                    if (isArray(value)) {
	                        value = "(" + value.join(",") + ")";
	                    }
	                    this.name = this.stringify.eleName(name);
	                    this.value = this.stringify.dtdElementValue(value);
	                }
	                XMLDTDElement.prototype.clone = function() {
	                    return create(XMLDTDElement.prototype, this);
	                };
	                XMLDTDElement.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!ELEMENT " + this.name + " " + this.value + ">";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLDTDElement;
	            }();
	        }).call(this);
	    }, {
	        "lodash/lang/isArray": 139,
	        "lodash/object/create": 147
	    } ],
	    92: [ function(require, module, exports) {
	        (function() {
	            var XMLDTDAttList, create;
	            create = require("lodash/object/create");
	            module.exports = XMLDTDAttList = function() {
	                function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	                    this.stringify = parent.stringify;
	                    if (elementName == null) {
	                        throw new Error("Missing DTD element name");
	                    }
	                    if (attributeName == null) {
	                        throw new Error("Missing DTD attribute name");
	                    }
	                    if (!attributeType) {
	                        throw new Error("Missing DTD attribute type");
	                    }
	                    if (!defaultValueType) {
	                        throw new Error("Missing DTD attribute default");
	                    }
	                    if (defaultValueType.indexOf("#") !== 0) {
	                        defaultValueType = "#" + defaultValueType;
	                    }
	                    if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
	                        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
	                    }
	                    if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
	                        throw new Error("Default value only applies to #FIXED or #DEFAULT");
	                    }
	                    this.elementName = this.stringify.eleName(elementName);
	                    this.attributeName = this.stringify.attName(attributeName);
	                    this.attributeType = this.stringify.dtdAttType(attributeType);
	                    this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
	                    this.defaultValueType = defaultValueType;
	                }
	                XMLDTDAttList.prototype.clone = function() {
	                    return create(XMLDTDAttList.prototype, this);
	                };
	                XMLDTDAttList.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!ATTLIST " + this.elementName + " " + this.attributeName + " " + this.attributeType;
	                    if (this.defaultValueType !== "#DEFAULT") {
	                        r += " " + this.defaultValueType;
	                    }
	                    if (this.defaultValue) {
	                        r += ' "' + this.defaultValue + '"';
	                    }
	                    r += ">";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLDTDAttList;
	            }();
	        }).call(this);
	    }, {
	        "lodash/object/create": 147
	    } ],
	    91: [ function(require, module, exports) {
	        (function() {
	            var XMLComment, XMLNode, create, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            XMLNode = require("./XMLNode");
	            module.exports = XMLComment = function(superClass) {
	                extend(XMLComment, superClass);
	                function XMLComment(parent, text) {
	                    XMLComment.__super__.constructor.call(this, parent);
	                    if (text == null) {
	                        throw new Error("Missing comment text");
	                    }
	                    this.text = this.stringify.comment(text);
	                }
	                XMLComment.prototype.clone = function() {
	                    return create(XMLComment.prototype, this);
	                };
	                XMLComment.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<!-- " + this.text + " -->";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLComment;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLNode": 99,
	        "lodash/object/create": 147
	    } ],
	    90: [ function(require, module, exports) {
	        (function() {
	            var XMLCData, XMLNode, create, extend = function(child, parent) {
	                for (var key in parent) {
	                    if (hasProp.call(parent, key)) child[key] = parent[key];
	                }
	                function ctor() {
	                    this.constructor = child;
	                }
	                ctor.prototype = parent.prototype;
	                child.prototype = new ctor();
	                child.__super__ = parent.prototype;
	                return child;
	            }, hasProp = {}.hasOwnProperty;
	            create = require("lodash/object/create");
	            XMLNode = require("./XMLNode");
	            module.exports = XMLCData = function(superClass) {
	                extend(XMLCData, superClass);
	                function XMLCData(parent, text) {
	                    XMLCData.__super__.constructor.call(this, parent);
	                    if (text == null) {
	                        throw new Error("Missing CDATA text");
	                    }
	                    this.text = this.stringify.cdata(text);
	                }
	                XMLCData.prototype.clone = function() {
	                    return create(XMLCData.prototype, this);
	                };
	                XMLCData.prototype.toString = function(options, level) {
	                    var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	                    pretty = (options != null ? options.pretty : void 0) || false;
	                    indent = (ref = options != null ? options.indent : void 0) != null ? ref : "  ";
	                    offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	                    newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : "\n";
	                    level || (level = 0);
	                    space = new Array(level + offset + 1).join(indent);
	                    r = "";
	                    if (pretty) {
	                        r += space;
	                    }
	                    r += "<![CDATA[" + this.text + "]]>";
	                    if (pretty) {
	                        r += newline;
	                    }
	                    return r;
	                };
	                return XMLCData;
	            }(XMLNode);
	        }).call(this);
	    }, {
	        "./XMLNode": 99,
	        "lodash/object/create": 147
	    } ],
	    147: [ function(require, module, exports) {
	        var baseCopy = require("../internal/baseCopy"), baseCreate = require("../internal/baseCreate"), isIterateeCall = require("../internal/isIterateeCall"), keys = require("./keys");
	        function create(prototype, properties, guard) {
	            var result = baseCreate(prototype);
	            if (guard && isIterateeCall(prototype, properties, guard)) {
	                properties = null;
	            }
	            return properties ? baseCopy(properties, result, keys(properties)) : result;
	        }
	        module.exports = create;
	    }, {
	        "../internal/baseCopy": 109,
	        "../internal/baseCreate": 110,
	        "../internal/isIterateeCall": 131,
	        "./keys": 148
	    } ],
	    148: [ function(require, module, exports) {
	        var isLength = require("../internal/isLength"), isNative = require("../lang/isNative"), isObject = require("../lang/isObject"), shimKeys = require("../internal/shimKeys");
	        var nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys;
	        var keys = !nativeKeys ? shimKeys : function(object) {
	            if (object) {
	                var Ctor = object.constructor, length = object.length;
	            }
	            if (typeof Ctor == "function" && Ctor.prototype === object || typeof object != "function" && (length && isLength(length))) {
	                return shimKeys(object);
	            }
	            return isObject(object) ? nativeKeys(object) : [];
	        };
	        module.exports = keys;
	    }, {
	        "../internal/isLength": 132,
	        "../internal/shimKeys": 136,
	        "../lang/isNative": 142,
	        "../lang/isObject": 143
	    } ],
	    136: [ function(require, module, exports) {
	        var isArguments = require("../lang/isArguments"), isArray = require("../lang/isArray"), isIndex = require("./isIndex"), isLength = require("./isLength"), keysIn = require("../object/keysIn"), support = require("../support");
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        function shimKeys(object) {
	            var props = keysIn(object), propsLength = props.length, length = propsLength && object.length;
	            var allowIndexes = length && isLength(length) && (isArray(object) || support.nonEnumArgs && isArguments(object));
	            var index = -1, result = [];
	            while (++index < propsLength) {
	                var key = props[index];
	                if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) {
	                    result.push(key);
	                }
	            }
	            return result;
	        }
	        module.exports = shimKeys;
	    }, {
	        "../lang/isArguments": 138,
	        "../lang/isArray": 139,
	        "../object/keysIn": 149,
	        "../support": 151,
	        "./isIndex": 130,
	        "./isLength": 132
	    } ],
	    149: [ function(require, module, exports) {
	        var isArguments = require("../lang/isArguments"), isArray = require("../lang/isArray"), isIndex = require("../internal/isIndex"), isLength = require("../internal/isLength"), isObject = require("../lang/isObject"), support = require("../support");
	        var objectProto = Object.prototype;
	        var hasOwnProperty = objectProto.hasOwnProperty;
	        function keysIn(object) {
	            if (object == null) {
	                return [];
	            }
	            if (!isObject(object)) {
	                object = Object(object);
	            }
	            var length = object.length;
	            length = length && isLength(length) && (isArray(object) || support.nonEnumArgs && isArguments(object)) && length || 0;
	            var Ctor = object.constructor, index = -1, isProto = typeof Ctor == "function" && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
	            while (++index < length) {
	                result[index] = index + "";
	            }
	            for (var key in object) {
	                if (!(skipIndexes && isIndex(key, length)) && !(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
	                    result.push(key);
	                }
	            }
	            return result;
	        }
	        module.exports = keysIn;
	    }, {
	        "../internal/isIndex": 130,
	        "../internal/isLength": 132,
	        "../lang/isArguments": 138,
	        "../lang/isArray": 139,
	        "../lang/isObject": 143,
	        "../support": 151
	    } ],
	    151: [ function(require, module, exports) {
	        (function(global) {
	            var isNative = require("./lang/isNative");
	            var reThis = /\bthis\b/;
	            var objectProto = Object.prototype;
	            var document = (document = global.window) && document.document;
	            var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	            var support = {};
	            (function(x) {
	                support.funcDecomp = !isNative(global.WinRTError) && reThis.test(function() {
	                    return this;
	                });
	                support.funcNames = typeof Function.name == "string";
	                try {
	                    support.dom = document.createDocumentFragment().nodeType === 11;
	                } catch (e) {
	                    support.dom = false;
	                }
	                try {
	                    support.nonEnumArgs = !propertyIsEnumerable.call(arguments, 1);
	                } catch (e) {
	                    support.nonEnumArgs = true;
	                }
	            })(0, 0);
	            module.exports = support;
	        }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	        "./lang/isNative": 142
	    } ],
	    139: [ function(require, module, exports) {
	        var isLength = require("../internal/isLength"), isNative = require("./isNative"), isObjectLike = require("../internal/isObjectLike");
	        var arrayTag = "[object Array]";
	        var objectProto = Object.prototype;
	        var objToString = objectProto.toString;
	        var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray;
	        var isArray = nativeIsArray || function(value) {
	            return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag || false;
	        };
	        module.exports = isArray;
	    }, {
	        "../internal/isLength": 132,
	        "../internal/isObjectLike": 133,
	        "./isNative": 142
	    } ],
	    142: [ function(require, module, exports) {
	        var escapeRegExp = require("../string/escapeRegExp"), isObjectLike = require("../internal/isObjectLike");
	        var funcTag = "[object Function]";
	        var reHostCtor = /^\[object .+?Constructor\]$/;
	        var objectProto = Object.prototype;
	        var fnToString = Function.prototype.toString;
	        var objToString = objectProto.toString;
	        var reNative = RegExp("^" + escapeRegExp(objToString).replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
	        function isNative(value) {
	            if (value == null) {
	                return false;
	            }
	            if (objToString.call(value) == funcTag) {
	                return reNative.test(fnToString.call(value));
	            }
	            return isObjectLike(value) && reHostCtor.test(value) || false;
	        }
	        module.exports = isNative;
	    }, {
	        "../internal/isObjectLike": 133,
	        "../string/escapeRegExp": 150
	    } ],
	    150: [ function(require, module, exports) {
	        var baseToString = require("../internal/baseToString");
	        var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g, reHasRegExpChars = RegExp(reRegExpChars.source);
	        function escapeRegExp(string) {
	            string = baseToString(string);
	            return string && reHasRegExpChars.test(string) ? string.replace(reRegExpChars, "\\$&") : string;
	        }
	        module.exports = escapeRegExp;
	    }, {
	        "../internal/baseToString": 123
	    } ],
	    123: [ function(require, module, exports) {
	        function baseToString(value) {
	            if (typeof value == "string") {
	                return value;
	            }
	            return value == null ? "" : value + "";
	        }
	        module.exports = baseToString;
	    }, {} ],
	    138: [ function(require, module, exports) {
	        var isLength = require("../internal/isLength"), isObjectLike = require("../internal/isObjectLike");
	        var argsTag = "[object Arguments]";
	        var objectProto = Object.prototype;
	        var objToString = objectProto.toString;
	        function isArguments(value) {
	            var length = isObjectLike(value) ? value.length : undefined;
	            return isLength(length) && objToString.call(value) == argsTag || false;
	        }
	        module.exports = isArguments;
	    }, {
	        "../internal/isLength": 132,
	        "../internal/isObjectLike": 133
	    } ],
	    133: [ function(require, module, exports) {
	        function isObjectLike(value) {
	            return value && typeof value == "object" || false;
	        }
	        module.exports = isObjectLike;
	    }, {} ],
	    131: [ function(require, module, exports) {
	        var isIndex = require("./isIndex"), isLength = require("./isLength"), isObject = require("../lang/isObject");
	        function isIterateeCall(value, index, object) {
	            if (!isObject(object)) {
	                return false;
	            }
	            var type = typeof index;
	            if (type == "number") {
	                var length = object.length, prereq = isLength(length) && isIndex(index, length);
	            } else {
	                prereq = type == "string" && index in object;
	            }
	            if (prereq) {
	                var other = object[index];
	                return value === value ? value === other : other !== other;
	            }
	            return false;
	        }
	        module.exports = isIterateeCall;
	    }, {
	        "../lang/isObject": 143,
	        "./isIndex": 130,
	        "./isLength": 132
	    } ],
	    132: [ function(require, module, exports) {
	        var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
	        function isLength(value) {
	            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	        }
	        module.exports = isLength;
	    }, {} ],
	    130: [ function(require, module, exports) {
	        var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
	        function isIndex(value, length) {
	            value = +value;
	            length = length == null ? MAX_SAFE_INTEGER : length;
	            return value > -1 && value % 1 == 0 && value < length;
	        }
	        module.exports = isIndex;
	    }, {} ],
	    110: [ function(require, module, exports) {
	        (function(global) {
	            var isObject = require("../lang/isObject");
	            var baseCreate = function() {
	                function Object() {}
	                return function(prototype) {
	                    if (isObject(prototype)) {
	                        Object.prototype = prototype;
	                        var result = new Object();
	                        Object.prototype = null;
	                    }
	                    return result || global.Object();
	                };
	            }();
	            module.exports = baseCreate;
	        }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	        "../lang/isObject": 143
	    } ],
	    143: [ function(require, module, exports) {
	        function isObject(value) {
	            var type = typeof value;
	            return type == "function" || value && type == "object" || false;
	        }
	        module.exports = isObject;
	    }, {} ],
	    109: [ function(require, module, exports) {
	        function baseCopy(source, object, props) {
	            if (!props) {
	                props = object;
	                object = {};
	            }
	            var index = -1, length = props.length;
	            while (++index < length) {
	                var key = props[index];
	                object[key] = source[key];
	            }
	            return object;
	        }
	        module.exports = baseCopy;
	    }, {} ],
	    77: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        AWS.Signers.RequestSigner = inherit({
	            constructor: function RequestSigner(request) {
	                this.request = request;
	            }
	        });
	        AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
	            switch (version) {
	              case "v2":
	                return AWS.Signers.V2;
	
	              case "v3":
	                return AWS.Signers.V3;
	
	              case "v4":
	                return AWS.Signers.V4;
	
	              case "s3":
	                return AWS.Signers.S3;
	
	              case "v3https":
	                return AWS.Signers.V3Https;
	            }
	            throw new Error("Unknown signing version " + version);
	        };
	        require("./v2");
	        require("./v3");
	        require("./v3https");
	        require("./v4");
	        require("./s3");
	        require("./presign");
	    }, {
	        "../core": 24,
	        "./presign": 76,
	        "./s3": 78,
	        "./v2": 79,
	        "./v3": 80,
	        "./v3https": 81,
	        "./v4": 82
	    } ],
	    82: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        var cachedSecret = {};
	        var expiresHeader = "presigned-expires";
	        AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
	            constructor: function V4(request, serviceName, signatureCache) {
	                AWS.Signers.RequestSigner.call(this, request);
	                this.serviceName = serviceName;
	                this.signatureCache = signatureCache;
	            },
	            algorithm: "AWS4-HMAC-SHA256",
	            addAuthorization: function addAuthorization(credentials, date) {
	                var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, "");
	                if (this.isPresigned()) {
	                    this.updateForPresigned(credentials, datetime);
	                } else {
	                    this.addHeaders(credentials, datetime);
	                }
	                this.request.headers["Authorization"] = this.authorization(credentials, datetime);
	            },
	            addHeaders: function addHeaders(credentials, datetime) {
	                this.request.headers["X-Amz-Date"] = datetime;
	                if (credentials.sessionToken) {
	                    this.request.headers["x-amz-security-token"] = credentials.sessionToken;
	                }
	            },
	            updateForPresigned: function updateForPresigned(credentials, datetime) {
	                var credString = this.credentialString(datetime);
	                var qs = {
	                    "X-Amz-Date": datetime,
	                    "X-Amz-Algorithm": this.algorithm,
	                    "X-Amz-Credential": credentials.accessKeyId + "/" + credString,
	                    "X-Amz-Expires": this.request.headers[expiresHeader],
	                    "X-Amz-SignedHeaders": this.signedHeaders()
	                };
	                if (credentials.sessionToken) {
	                    qs["X-Amz-Security-Token"] = credentials.sessionToken;
	                }
	                if (this.request.headers["Content-Type"]) {
	                    qs["Content-Type"] = this.request.headers["Content-Type"];
	                }
	                if (this.request.headers["Content-MD5"]) {
	                    qs["Content-MD5"] = this.request.headers["Content-MD5"];
	                }
	                if (this.request.headers["Cache-Control"]) {
	                    qs["Cache-Control"] = this.request.headers["Cache-Control"];
	                }
	                AWS.util.each.call(this, this.request.headers, function(key, value) {
	                    if (key === expiresHeader) return;
	                    if (this.isSignableHeader(key)) {
	                        var lowerKey = key.toLowerCase();
	                        if (lowerKey.indexOf("x-amz-meta-") === 0) {
	                            qs[lowerKey] = value;
	                        } else if (lowerKey.indexOf("x-amz-") === 0) {
	                            qs[key] = value;
	                        }
	                    }
	                });
	                var sep = this.request.path.indexOf("?") >= 0 ? "&" : "?";
	                this.request.path += sep + AWS.util.queryParamsToString(qs);
	            },
	            authorization: function authorization(credentials, datetime) {
	                var parts = [];
	                var credString = this.credentialString(datetime);
	                parts.push(this.algorithm + " Credential=" + credentials.accessKeyId + "/" + credString);
	                parts.push("SignedHeaders=" + this.signedHeaders());
	                parts.push("Signature=" + this.signature(credentials, datetime));
	                return parts.join(", ");
	            },
	            signature: function signature(credentials, datetime) {
	                var cache = null;
	                if (this.signatureCache) {
	                    var cache = cachedSecret[this.serviceName];
	                }
	                var date = datetime.substr(0, 8);
	                if (!cache || cache.akid !== credentials.accessKeyId || cache.region !== this.request.region || cache.date !== date) {
	                    var kSecret = credentials.secretAccessKey;
	                    var kDate = AWS.util.crypto.hmac("AWS4" + kSecret, date, "buffer");
	                    var kRegion = AWS.util.crypto.hmac(kDate, this.request.region, "buffer");
	                    var kService = AWS.util.crypto.hmac(kRegion, this.serviceName, "buffer");
	                    var kCredentials = AWS.util.crypto.hmac(kService, "aws4_request", "buffer");
	                    if (!this.signatureCache) {
	                        return AWS.util.crypto.hmac(kCredentials, this.stringToSign(datetime), "hex");
	                    }
	                    cachedSecret[this.serviceName] = {
	                        region: this.request.region,
	                        date: date,
	                        key: kCredentials,
	                        akid: credentials.accessKeyId
	                    };
	                }
	                var key = cachedSecret[this.serviceName].key;
	                return AWS.util.crypto.hmac(key, this.stringToSign(datetime), "hex");
	            },
	            stringToSign: function stringToSign(datetime) {
	                var parts = [];
	                parts.push("AWS4-HMAC-SHA256");
	                parts.push(datetime);
	                parts.push(this.credentialString(datetime));
	                parts.push(this.hexEncodedHash(this.canonicalString()));
	                return parts.join("\n");
	            },
	            canonicalString: function canonicalString() {
	                var parts = [], pathname = this.request.pathname();
	                if (this.serviceName !== "s3") pathname = AWS.util.uriEscapePath(pathname);
	                parts.push(this.request.method);
	                parts.push(pathname);
	                parts.push(this.request.search());
	                parts.push(this.canonicalHeaders() + "\n");
	                parts.push(this.signedHeaders());
	                parts.push(this.hexEncodedBodyHash());
	                return parts.join("\n");
	            },
	            canonicalHeaders: function canonicalHeaders() {
	                var headers = [];
	                AWS.util.each.call(this, this.request.headers, function(key, item) {
	                    headers.push([ key, item ]);
	                });
	                headers.sort(function(a, b) {
	                    return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
	                });
	                var parts = [];
	                AWS.util.arrayEach.call(this, headers, function(item) {
	                    var key = item[0].toLowerCase();
	                    if (this.isSignableHeader(key)) {
	                        parts.push(key + ":" + this.canonicalHeaderValues(item[1].toString()));
	                    }
	                });
	                return parts.join("\n");
	            },
	            canonicalHeaderValues: function canonicalHeaderValues(values) {
	                return values.replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
	            },
	            signedHeaders: function signedHeaders() {
	                var keys = [];
	                AWS.util.each.call(this, this.request.headers, function(key) {
	                    key = key.toLowerCase();
	                    if (this.isSignableHeader(key)) keys.push(key);
	                });
	                return keys.sort().join(";");
	            },
	            credentialString: function credentialString(datetime) {
	                var parts = [];
	                parts.push(datetime.substr(0, 8));
	                parts.push(this.request.region);
	                parts.push(this.serviceName);
	                parts.push("aws4_request");
	                return parts.join("/");
	            },
	            hexEncodedHash: function hash(string) {
	                return AWS.util.crypto.sha256(string, "hex");
	            },
	            hexEncodedBodyHash: function hexEncodedBodyHash() {
	                if (this.isPresigned() && this.serviceName === "s3" && !this.request.body) {
	                    return "UNSIGNED-PAYLOAD";
	                } else if (this.request.headers["X-Amz-Content-Sha256"]) {
	                    return this.request.headers["X-Amz-Content-Sha256"];
	                } else {
	                    return this.hexEncodedHash(this.request.body || "");
	                }
	            },
	            unsignableHeaders: [ "authorization", "content-type", "content-length", "user-agent", expiresHeader, "expect" ],
	            isSignableHeader: function isSignableHeader(key) {
	                if (key.toLowerCase().indexOf("x-amz-") === 0) return true;
	                return this.unsignableHeaders.indexOf(key) < 0;
	            },
	            isPresigned: function isPresigned() {
	                return this.request.headers[expiresHeader] ? true : false;
	            }
	        });
	        module.exports = AWS.Signers.V4;
	    }, {
	        "../core": 24
	    } ],
	    81: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        require("./v3");
	        AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
	            authorization: function authorization(credentials) {
	                return "AWS3-HTTPS " + "AWSAccessKeyId=" + credentials.accessKeyId + "," + "Algorithm=HmacSHA256," + "Signature=" + this.signature(credentials);
	            },
	            stringToSign: function stringToSign() {
	                return this.request.headers["X-Amz-Date"];
	            }
	        });
	        module.exports = AWS.Signers.V3Https;
	    }, {
	        "../core": 24,
	        "./v3": 80
	    } ],
	    80: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
	            addAuthorization: function addAuthorization(credentials, date) {
	                var datetime = AWS.util.date.rfc822(date);
	                this.request.headers["X-Amz-Date"] = datetime;
	                if (credentials.sessionToken) {
	                    this.request.headers["x-amz-security-token"] = credentials.sessionToken;
	                }
	                this.request.headers["X-Amzn-Authorization"] = this.authorization(credentials, datetime);
	            },
	            authorization: function authorization(credentials) {
	                return "AWS3 " + "AWSAccessKeyId=" + credentials.accessKeyId + "," + "Algorithm=HmacSHA256," + "SignedHeaders=" + this.signedHeaders() + "," + "Signature=" + this.signature(credentials);
	            },
	            signedHeaders: function signedHeaders() {
	                var headers = [];
	                AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	                    headers.push(h.toLowerCase());
	                });
	                return headers.sort().join(";");
	            },
	            canonicalHeaders: function canonicalHeaders() {
	                var headers = this.request.headers;
	                var parts = [];
	                AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	                    parts.push(h.toLowerCase().trim() + ":" + String(headers[h]).trim());
	                });
	                return parts.sort().join("\n") + "\n";
	            },
	            headersToSign: function headersToSign() {
	                var headers = [];
	                AWS.util.each(this.request.headers, function iterator(k) {
	                    if (k === "Host" || k === "Content-Encoding" || k.match(/^X-Amz/i)) {
	                        headers.push(k);
	                    }
	                });
	                return headers;
	            },
	            signature: function signature(credentials) {
	                return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), "base64");
	            },
	            stringToSign: function stringToSign() {
	                var parts = [];
	                parts.push(this.request.method);
	                parts.push("/");
	                parts.push("");
	                parts.push(this.canonicalHeaders());
	                parts.push(this.request.body);
	                return AWS.util.crypto.sha256(parts.join("\n"));
	            }
	        });
	        module.exports = AWS.Signers.V3;
	    }, {
	        "../core": 24
	    } ],
	    79: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
	            addAuthorization: function addAuthorization(credentials, date) {
	                if (!date) date = AWS.util.date.getDate();
	                var r = this.request;
	                r.params.Timestamp = AWS.util.date.iso8601(date);
	                r.params.SignatureVersion = "2";
	                r.params.SignatureMethod = "HmacSHA256";
	                r.params.AWSAccessKeyId = credentials.accessKeyId;
	                if (credentials.sessionToken) {
	                    r.params.SecurityToken = credentials.sessionToken;
	                }
	                delete r.params.Signature;
	                r.params.Signature = this.signature(credentials);
	                r.body = AWS.util.queryParamsToString(r.params);
	                r.headers["Content-Length"] = r.body.length;
	            },
	            signature: function signature(credentials) {
	                return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), "base64");
	            },
	            stringToSign: function stringToSign() {
	                var parts = [];
	                parts.push(this.request.method);
	                parts.push(this.request.endpoint.host.toLowerCase());
	                parts.push(this.request.pathname());
	                parts.push(AWS.util.queryParamsToString(this.request.params));
	                return parts.join("\n");
	            }
	        });
	        module.exports = AWS.Signers.V2;
	    }, {
	        "../core": 24
	    } ],
	    78: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
	            subResources: {
	                acl: 1,
	                accelerate: 1,
	                cors: 1,
	                lifecycle: 1,
	                "delete": 1,
	                location: 1,
	                logging: 1,
	                notification: 1,
	                partNumber: 1,
	                policy: 1,
	                requestPayment: 1,
	                replication: 1,
	                restore: 1,
	                tagging: 1,
	                torrent: 1,
	                uploadId: 1,
	                uploads: 1,
	                versionId: 1,
	                versioning: 1,
	                versions: 1,
	                website: 1
	            },
	            responseHeaders: {
	                "response-content-type": 1,
	                "response-content-language": 1,
	                "response-expires": 1,
	                "response-cache-control": 1,
	                "response-content-disposition": 1,
	                "response-content-encoding": 1
	            },
	            addAuthorization: function addAuthorization(credentials, date) {
	                if (!this.request.headers["presigned-expires"]) {
	                    this.request.headers["X-Amz-Date"] = AWS.util.date.rfc822(date);
	                }
	                if (credentials.sessionToken) {
	                    this.request.headers["x-amz-security-token"] = credentials.sessionToken;
	                }
	                var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
	                var auth = "AWS " + credentials.accessKeyId + ":" + signature;
	                this.request.headers["Authorization"] = auth;
	            },
	            stringToSign: function stringToSign() {
	                var r = this.request;
	                var parts = [];
	                parts.push(r.method);
	                parts.push(r.headers["Content-MD5"] || "");
	                parts.push(r.headers["Content-Type"] || "");
	                parts.push(r.headers["presigned-expires"] || "");
	                var headers = this.canonicalizedAmzHeaders();
	                if (headers) parts.push(headers);
	                parts.push(this.canonicalizedResource());
	                return parts.join("\n");
	            },
	            canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
	                var amzHeaders = [];
	                AWS.util.each(this.request.headers, function(name) {
	                    if (name.match(/^x-amz-/i)) amzHeaders.push(name);
	                });
	                amzHeaders.sort(function(a, b) {
	                    return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
	                });
	                var parts = [];
	                AWS.util.arrayEach.call(this, amzHeaders, function(name) {
	                    parts.push(name.toLowerCase() + ":" + String(this.request.headers[name]));
	                });
	                return parts.join("\n");
	            },
	            canonicalizedResource: function canonicalizedResource() {
	                var r = this.request;
	                var parts = r.path.split("?");
	                var path = parts[0];
	                var querystring = parts[1];
	                var resource = "";
	                if (r.virtualHostedBucket) resource += "/" + r.virtualHostedBucket;
	                resource += path;
	                if (querystring) {
	                    var resources = [];
	                    AWS.util.arrayEach.call(this, querystring.split("&"), function(param) {
	                        var name = param.split("=")[0];
	                        var value = param.split("=")[1];
	                        if (this.subResources[name] || this.responseHeaders[name]) {
	                            var subresource = {
	                                name: name
	                            };
	                            if (value !== undefined) {
	                                if (this.subResources[name]) {
	                                    subresource.value = value;
	                                } else {
	                                    subresource.value = decodeURIComponent(value);
	                                }
	                            }
	                            resources.push(subresource);
	                        }
	                    });
	                    resources.sort(function(a, b) {
	                        return a.name < b.name ? -1 : 1;
	                    });
	                    if (resources.length) {
	                        querystring = [];
	                        AWS.util.arrayEach(resources, function(res) {
	                            if (res.value === undefined) {
	                                querystring.push(res.name);
	                            } else {
	                                querystring.push(res.name + "=" + res.value);
	                            }
	                        });
	                        resource += "?" + querystring.join("&");
	                    }
	                }
	                return resource;
	            },
	            sign: function sign(secret, string) {
	                return AWS.util.crypto.hmac(secret, string, "base64", "sha1");
	            }
	        });
	        module.exports = AWS.Signers.S3;
	    }, {
	        "../core": 24
	    } ],
	    76: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var inherit = AWS.util.inherit;
	        var expiresHeader = "presigned-expires";
	        function signedUrlBuilder(request) {
	            var expires = request.httpRequest.headers[expiresHeader];
	            var signerClass = request.service.getSignerClass(request);
	            delete request.httpRequest.headers["User-Agent"];
	            delete request.httpRequest.headers["X-Amz-User-Agent"];
	            if (signerClass === AWS.Signers.V4) {
	                if (expires > 604800) {
	                    var message = "Presigning does not support expiry time greater " + "than a week with SigV4 signing.";
	                    throw AWS.util.error(new Error(), {
	                        code: "InvalidExpiryTime",
	                        message: message,
	                        retryable: false
	                    });
	                }
	                request.httpRequest.headers[expiresHeader] = expires;
	            } else if (signerClass === AWS.Signers.S3) {
	                request.httpRequest.headers[expiresHeader] = parseInt(AWS.util.date.unixTimestamp() + expires, 10).toString();
	            } else {
	                throw AWS.util.error(new Error(), {
	                    message: "Presigning only supports S3 or SigV4 signing.",
	                    code: "UnsupportedSigner",
	                    retryable: false
	                });
	            }
	        }
	        function signedUrlSigner(request) {
	            var endpoint = request.httpRequest.endpoint;
	            var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
	            var queryParams = {};
	            if (parsedUrl.search) {
	                queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
	            }
	            AWS.util.each(request.httpRequest.headers, function(key, value) {
	                if (key === expiresHeader) key = "Expires";
	                if (key.indexOf("x-amz-meta-") === 0) {
	                    delete queryParams[key];
	                    key = key.toLowerCase();
	                }
	                queryParams[key] = value;
	            });
	            delete request.httpRequest.headers[expiresHeader];
	            var auth = queryParams["Authorization"].split(" ");
	            if (auth[0] === "AWS") {
	                auth = auth[1].split(":");
	                queryParams["AWSAccessKeyId"] = auth[0];
	                queryParams["Signature"] = auth[1];
	            } else if (auth[0] === "AWS4-HMAC-SHA256") {
	                auth.shift();
	                var rest = auth.join(" ");
	                var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
	                queryParams["X-Amz-Signature"] = signature;
	                delete queryParams["Expires"];
	            }
	            delete queryParams["Authorization"];
	            delete queryParams["Host"];
	            endpoint.pathname = parsedUrl.pathname;
	            endpoint.search = AWS.util.queryParamsToString(queryParams);
	        }
	        AWS.Signers.Presign = inherit({
	            sign: function sign(request, expireTime, callback) {
	                request.httpRequest.headers[expiresHeader] = expireTime || 3600;
	                request.on("build", signedUrlBuilder);
	                request.on("sign", signedUrlSigner);
	                request.removeListener("afterBuild", AWS.EventListeners.Core.SET_CONTENT_LENGTH);
	                request.removeListener("afterBuild", AWS.EventListeners.Core.COMPUTE_SHA256);
	                request.emit("beforePresign", [ request ]);
	                if (callback) {
	                    request.build(function() {
	                        if (this.response.error) callback(this.response.error); else {
	                            callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
	                        }
	                    });
	                } else {
	                    request.build();
	                    if (request.response.error) throw request.response.error;
	                    return AWS.util.urlFormat(request.httpRequest.endpoint);
	                }
	            }
	        });
	        module.exports = AWS.Signers.Presign;
	    }, {
	        "../core": 24
	    } ],
	    61: [ function(require, module, exports) {
	        var AWS = require("./core");
	        var Api = require("./model/api");
	        var regionConfig = require("./region_config");
	        var inherit = AWS.util.inherit;
	        AWS.Service = inherit({
	            constructor: function Service(config) {
	                if (!this.loadServiceClass) {
	                    throw AWS.util.error(new Error(), "Service must be constructed with `new' operator");
	                }
	                var ServiceClass = this.loadServiceClass(config || {});
	                if (ServiceClass) {
	                    var originalConfig = AWS.util.copy(config);
	                    var svc = new ServiceClass(config);
	                    Object.defineProperty(svc, "_originalConfig", {
	                        get: function() {
	                            return originalConfig;
	                        },
	                        enumerable: false,
	                        configurable: true
	                    });
	                    return svc;
	                }
	                this.initialize(config);
	            },
	            initialize: function initialize(config) {
	                var svcConfig = AWS.config[this.serviceIdentifier];
	                this.config = new AWS.Config(AWS.config);
	                if (svcConfig) this.config.update(svcConfig, true);
	                if (config) this.config.update(config, true);
	                this.validateService();
	                if (!this.config.endpoint) regionConfig(this);
	                this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
	                this.setEndpoint(this.config.endpoint);
	            },
	            validateService: function validateService() {},
	            loadServiceClass: function loadServiceClass(serviceConfig) {
	                var config = serviceConfig;
	                if (!AWS.util.isEmpty(this.api)) {
	                    return null;
	                } else if (config.apiConfig) {
	                    return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
	                } else if (!this.constructor.services) {
	                    return null;
	                } else {
	                    config = new AWS.Config(AWS.config);
	                    config.update(serviceConfig, true);
	                    var version = config.apiVersions[this.constructor.serviceIdentifier];
	                    version = version || config.apiVersion;
	                    return this.getLatestServiceClass(version);
	                }
	            },
	            getLatestServiceClass: function getLatestServiceClass(version) {
	                version = this.getLatestServiceVersion(version);
	                if (this.constructor.services[version] === null) {
	                    AWS.Service.defineServiceApi(this.constructor, version);
	                }
	                return this.constructor.services[version];
	            },
	            getLatestServiceVersion: function getLatestServiceVersion(version) {
	                if (!this.constructor.services || this.constructor.services.length === 0) {
	                    throw new Error("No services defined on " + this.constructor.serviceIdentifier);
	                }
	                if (!version) {
	                    version = "latest";
	                } else if (AWS.util.isType(version, Date)) {
	                    version = AWS.util.date.iso8601(version).split("T")[0];
	                }
	                if (Object.hasOwnProperty(this.constructor.services, version)) {
	                    return version;
	                }
	                var keys = Object.keys(this.constructor.services).sort();
	                var selectedVersion = null;
	                for (var i = keys.length - 1; i >= 0; i--) {
	                    if (keys[i][keys[i].length - 1] !== "*") {
	                        selectedVersion = keys[i];
	                    }
	                    if (keys[i].substr(0, 10) <= version) {
	                        return selectedVersion;
	                    }
	                }
	                throw new Error("Could not find " + this.constructor.serviceIdentifier + " API to satisfy version constraint `" + version + "'");
	            },
	            api: {},
	            defaultRetryCount: 3,
	            makeRequest: function makeRequest(operation, params, callback) {
	                if (typeof params === "function") {
	                    callback = params;
	                    params = null;
	                }
	                params = params || {};
	                if (this.config.params) {
	                    var rules = this.api.operations[operation];
	                    if (rules) {
	                        params = AWS.util.copy(params);
	                        AWS.util.each(this.config.params, function(key, value) {
	                            if (rules.input.members[key]) {
	                                if (params[key] === undefined || params[key] === null) {
	                                    params[key] = value;
	                                }
	                            }
	                        });
	                    }
	                }
	                var request = new AWS.Request(this, operation, params);
	                this.addAllRequestListeners(request);
	                if (callback) request.send(callback);
	                return request;
	            },
	            makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
	                if (typeof params === "function") {
	                    callback = params;
	                    params = {};
	                }
	                var request = this.makeRequest(operation, params).toUnauthenticated();
	                return callback ? request.send(callback) : request;
	            },
	            waitFor: function waitFor(state, params, callback) {
	                var waiter = new AWS.ResourceWaiter(this, state);
	                return waiter.wait(params, callback);
	            },
	            addAllRequestListeners: function addAllRequestListeners(request) {
	                var list = [ AWS.events, AWS.EventListeners.Core, this.serviceInterface(), AWS.EventListeners.CorePost ];
	                for (var i = 0; i < list.length; i++) {
	                    if (list[i]) request.addListeners(list[i]);
	                }
	                if (!this.config.paramValidation) {
	                    request.removeListener("validate", AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	                }
	                if (this.config.logger) {
	                    request.addListeners(AWS.EventListeners.Logger);
	                }
	                this.setupRequestListeners(request);
	            },
	            setupRequestListeners: function setupRequestListeners() {},
	            getSignerClass: function getSignerClass() {
	                var version;
	                if (this.config.signatureVersion) {
	                    version = this.config.signatureVersion;
	                } else {
	                    version = this.api.signatureVersion;
	                }
	                return AWS.Signers.RequestSigner.getVersion(version);
	            },
	            serviceInterface: function serviceInterface() {
	                switch (this.api.protocol) {
	                  case "ec2":
	                    return AWS.EventListeners.Query;
	
	                  case "query":
	                    return AWS.EventListeners.Query;
	
	                  case "json":
	                    return AWS.EventListeners.Json;
	
	                  case "rest-json":
	                    return AWS.EventListeners.RestJson;
	
	                  case "rest-xml":
	                    return AWS.EventListeners.RestXml;
	                }
	                if (this.api.protocol) {
	                    throw new Error("Invalid service `protocol' " + this.api.protocol + " in API config");
	                }
	            },
	            successfulResponse: function successfulResponse(resp) {
	                return resp.httpResponse.statusCode < 300;
	            },
	            numRetries: function numRetries() {
	                if (this.config.maxRetries !== undefined) {
	                    return this.config.maxRetries;
	                } else {
	                    return this.defaultRetryCount;
	                }
	            },
	            retryDelays: function retryDelays(retryCount) {
	                var retryDelayOptions = this.config.retryDelayOptions || {};
	                var customBackoff = retryDelayOptions.customBackoff || null;
	                if (typeof customBackoff === "function") {
	                    return customBackoff(retryCount);
	                }
	                var base = retryDelayOptions.base || 30;
	                var delay = Math.random() * (Math.pow(2, retryCount) * base);
	                return delay;
	            },
	            retryableError: function retryableError(error) {
	                if (this.networkingError(error)) return true;
	                if (this.expiredCredentialsError(error)) return true;
	                if (this.throttledError(error)) return true;
	                if (error.statusCode >= 500) return true;
	                return false;
	            },
	            networkingError: function networkingError(error) {
	                return error.code === "NetworkingError";
	            },
	            expiredCredentialsError: function expiredCredentialsError(error) {
	                return error.code === "ExpiredTokenException";
	            },
	            clockSkewError: function clockSkewError(error) {
	                switch (error.code) {
	                  case "RequestTimeTooSkewed":
	                  case "RequestExpired":
	                  case "InvalidSignatureException":
	                  case "SignatureDoesNotMatch":
	                  case "AuthFailure":
	                  case "RequestInTheFuture":
	                    return true;
	
	                  default:
	                    return false;
	                }
	            },
	            throttledError: function throttledError(error) {
	                switch (error.code) {
	                  case "ProvisionedThroughputExceededException":
	                  case "Throttling":
	                  case "ThrottlingException":
	                  case "RequestLimitExceeded":
	                  case "RequestThrottled":
	                    return true;
	
	                  default:
	                    return false;
	                }
	            },
	            endpointFromTemplate: function endpointFromTemplate(endpoint) {
	                if (typeof endpoint !== "string") return endpoint;
	                var e = endpoint;
	                e = e.replace(/\{service\}/g, this.api.endpointPrefix);
	                e = e.replace(/\{region\}/g, this.config.region);
	                e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? "https" : "http");
	                return e;
	            },
	            setEndpoint: function setEndpoint(endpoint) {
	                this.endpoint = new AWS.Endpoint(endpoint, this.config);
	            },
	            paginationConfig: function paginationConfig(operation, throwException) {
	                var paginator = this.api.operations[operation].paginator;
	                if (!paginator) {
	                    if (throwException) {
	                        var e = new Error();
	                        throw AWS.util.error(e, "No pagination configuration for " + operation);
	                    }
	                    return null;
	                }
	                return paginator;
	            }
	        });
	        AWS.util.update(AWS.Service, {
	            defineMethods: function defineMethods(svc) {
	                AWS.util.each(svc.prototype.api.operations, function iterator(method) {
	                    if (svc.prototype[method]) return;
	                    var operation = svc.prototype.api.operations[method];
	                    if (operation.authtype === "none") {
	                        svc.prototype[method] = function(params, callback) {
	                            return this.makeUnauthenticatedRequest(method, params, callback);
	                        };
	                    } else {
	                        svc.prototype[method] = function(params, callback) {
	                            return this.makeRequest(method, params, callback);
	                        };
	                    }
	                });
	            },
	            defineService: function defineService(serviceIdentifier, versions, features) {
	                AWS.Service._serviceMap[serviceIdentifier] = true;
	                if (!Array.isArray(versions)) {
	                    features = versions;
	                    versions = [];
	                }
	                var svc = inherit(AWS.Service, features || {});
	                if (typeof serviceIdentifier === "string") {
	                    AWS.Service.addVersions(svc, versions);
	                    var identifier = svc.serviceIdentifier || serviceIdentifier;
	                    svc.serviceIdentifier = identifier;
	                } else {
	                    svc.prototype.api = serviceIdentifier;
	                    AWS.Service.defineMethods(svc);
	                }
	                return svc;
	            },
	            addVersions: function addVersions(svc, versions) {
	                if (!Array.isArray(versions)) versions = [ versions ];
	                svc.services = svc.services || {};
	                for (var i = 0; i < versions.length; i++) {
	                    if (svc.services[versions[i]] === undefined) {
	                        svc.services[versions[i]] = null;
	                    }
	                }
	                svc.apiVersions = Object.keys(svc.services).sort();
	            },
	            defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
	                var svc = inherit(superclass, {
	                    serviceIdentifier: superclass.serviceIdentifier
	                });
	                function setApi(api) {
	                    if (api.isApi) {
	                        svc.prototype.api = api;
	                    } else {
	                        svc.prototype.api = new Api(api);
	                    }
	                }
	                if (typeof version === "string") {
	                    if (apiConfig) {
	                        setApi(apiConfig);
	                    } else {
	                        try {
	                            setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
	                        } catch (err) {
	                            throw AWS.util.error(err, {
	                                message: "Could not find API configuration " + superclass.serviceIdentifier + "-" + version
	                            });
	                        }
	                    }
	                    if (!superclass.services.hasOwnProperty(version)) {
	                        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
	                    }
	                    superclass.services[version] = svc;
	                } else {
	                    setApi(version);
	                }
	                AWS.Service.defineMethods(svc);
	                return svc;
	            },
	            hasService: function(identifier) {
	                return AWS.Service._serviceMap.hasOwnProperty(identifier);
	            },
	            _serviceMap: {}
	        });
	    }, {
	        "./core": 24,
	        "./model/api": 41,
	        "./region_config": 55
	    } ],
	    55: [ function(require, module, exports) {
	        var util = require("./util");
	        var regionConfig = require("./region_config.json");
	        function generateRegionPrefix(region) {
	            if (!region) return null;
	            var parts = region.split("-");
	            if (parts.length < 3) return null;
	            return parts.slice(0, parts.length - 2).join("-") + "-*";
	        }
	        function derivedKeys(service) {
	            var region = service.config.region;
	            var regionPrefix = generateRegionPrefix(region);
	            var endpointPrefix = service.api.endpointPrefix;
	            return [ [ region, endpointPrefix ], [ regionPrefix, endpointPrefix ], [ region, "*" ], [ regionPrefix, "*" ], [ "*", endpointPrefix ], [ "*", "*" ] ].map(function(item) {
	                return item[0] && item[1] ? item.join("/") : null;
	            });
	        }
	        function applyConfig(service, config) {
	            util.each(config, function(key, value) {
	                if (key === "globalEndpoint") return;
	                if (service.config[key] === undefined || service.config[key] === null) {
	                    service.config[key] = value;
	                }
	            });
	        }
	        function configureEndpoint(service) {
	            var keys = derivedKeys(service);
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                if (!key) continue;
	                if (regionConfig.rules.hasOwnProperty(key)) {
	                    var config = regionConfig.rules[key];
	                    if (typeof config === "string") {
	                        config = regionConfig.patterns[config];
	                    }
	                    service.isGlobalEndpoint = !!config.globalEndpoint;
	                    if (!config.signatureVersion) config.signatureVersion = "v4";
	                    applyConfig(service, config);
	                    return;
	                }
	            }
	        }
	        module.exports = configureEndpoint;
	    }, {
	        "./region_config.json": 54,
	        "./util": 84
	    } ],
	    54: [ function(require, module, exports) {
	        module.exports = {
	            rules: {
	                "*/*": {
	                    endpoint: "{service}.{region}.amazonaws.com"
	                },
	                "cn-*/*": {
	                    endpoint: "{service}.{region}.amazonaws.com.cn"
	                },
	                "*/cloudfront": "globalSSL",
	                "*/iam": "globalSSL",
	                "*/sts": "globalSSL",
	                "*/importexport": {
	                    endpoint: "{service}.amazonaws.com",
	                    signatureVersion: "v2",
	                    globalEndpoint: true
	                },
	                "*/route53": {
	                    endpoint: "https://{service}.amazonaws.com",
	                    signatureVersion: "v3https",
	                    globalEndpoint: true
	                },
	                "*/waf": "globalSSL",
	                "us-gov-*/iam": "globalGovCloud",
	                "us-gov-*/sts": {
	                    endpoint: "{service}.{region}.amazonaws.com"
	                },
	                "us-gov-west-1/s3": "s3dash",
	                "us-west-1/s3": "s3dash",
	                "us-west-2/s3": "s3dash",
	                "eu-west-1/s3": "s3dash",
	                "ap-southeast-1/s3": "s3dash",
	                "ap-southeast-2/s3": "s3dash",
	                "ap-northeast-1/s3": "s3dash",
	                "sa-east-1/s3": "s3dash",
	                "us-east-1/s3": {
	                    endpoint: "{service}.amazonaws.com",
	                    signatureVersion: "s3"
	                },
	                "us-east-1/sdb": {
	                    endpoint: "{service}.amazonaws.com",
	                    signatureVersion: "v2"
	                },
	                "*/sdb": {
	                    endpoint: "{service}.{region}.amazonaws.com",
	                    signatureVersion: "v2"
	                }
	            },
	            patterns: {
	                globalSSL: {
	                    endpoint: "https://{service}.amazonaws.com",
	                    globalEndpoint: true
	                },
	                globalGovCloud: {
	                    endpoint: "{service}.us-gov.amazonaws.com"
	                },
	                s3dash: {
	                    endpoint: "{service}-{region}.amazonaws.com",
	                    signatureVersion: "s3"
	                }
	            }
	        };
	    }, {} ],
	    58: [ function(require, module, exports) {
	        var AWS = require("./core");
	        var inherit = AWS.util.inherit;
	        var jmespath = require("jmespath");
	        AWS.Response = inherit({
	            constructor: function Response(request) {
	                this.request = request;
	                this.data = null;
	                this.error = null;
	                this.retryCount = 0;
	                this.redirectCount = 0;
	                this.httpResponse = new AWS.HttpResponse();
	                if (request) {
	                    this.maxRetries = request.service.numRetries();
	                    this.maxRedirects = request.service.config.maxRedirects;
	                }
	            },
	            nextPage: function nextPage(callback) {
	                var config;
	                var service = this.request.service;
	                var operation = this.request.operation;
	                try {
	                    config = service.paginationConfig(operation, true);
	                } catch (e) {
	                    this.error = e;
	                }
	                if (!this.hasNextPage()) {
	                    if (callback) callback(this.error, null); else if (this.error) throw this.error;
	                    return null;
	                }
	                var params = AWS.util.copy(this.request.params);
	                if (!this.nextPageTokens) {
	                    return callback ? callback(null, null) : null;
	                } else {
	                    var inputTokens = config.inputToken;
	                    if (typeof inputTokens === "string") inputTokens = [ inputTokens ];
	                    for (var i = 0; i < inputTokens.length; i++) {
	                        params[inputTokens[i]] = this.nextPageTokens[i];
	                    }
	                    return service.makeRequest(this.request.operation, params, callback);
	                }
	            },
	            hasNextPage: function hasNextPage() {
	                this.cacheNextPageTokens();
	                if (this.nextPageTokens) return true;
	                if (this.nextPageTokens === undefined) return undefined; else return false;
	            },
	            cacheNextPageTokens: function cacheNextPageTokens() {
	                if (this.hasOwnProperty("nextPageTokens")) return this.nextPageTokens;
	                this.nextPageTokens = undefined;
	                var config = this.request.service.paginationConfig(this.request.operation);
	                if (!config) return this.nextPageTokens;
	                this.nextPageTokens = null;
	                if (config.moreResults) {
	                    if (!jmespath.search(this.data, config.moreResults)) {
	                        return this.nextPageTokens;
	                    }
	                }
	                var exprs = config.outputToken;
	                if (typeof exprs === "string") exprs = [ exprs ];
	                AWS.util.arrayEach.call(this, exprs, function(expr) {
	                    var output = jmespath.search(this.data, expr);
	                    if (output) {
	                        this.nextPageTokens = this.nextPageTokens || [];
	                        this.nextPageTokens.push(output);
	                    }
	                });
	                return this.nextPageTokens;
	            }
	        });
	    }, {
	        "./core": 24,
	        jmespath: 87
	    } ],
	    57: [ function(require, module, exports) {
	        var AWS = require("./core");
	        var inherit = AWS.util.inherit;
	        var jmespath = require("jmespath");
	        function CHECK_ACCEPTORS(resp) {
	            var waiter = resp.request._waiter;
	            var acceptors = waiter.config.acceptors;
	            var acceptorMatched = false;
	            var state = "retry";
	            acceptors.forEach(function(acceptor) {
	                if (!acceptorMatched) {
	                    var matcher = waiter.matchers[acceptor.matcher];
	                    if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
	                        acceptorMatched = true;
	                        state = acceptor.state;
	                    }
	                }
	            });
	            if (!acceptorMatched && resp.error) state = "failure";
	            if (state === "success") {
	                waiter.setSuccess(resp);
	            } else {
	                waiter.setError(resp, state === "retry");
	            }
	        }
	        AWS.ResourceWaiter = inherit({
	            constructor: function constructor(service, state) {
	                this.service = service;
	                this.state = state;
	                this.loadWaiterConfig(this.state);
	            },
	            service: null,
	            state: null,
	            config: null,
	            matchers: {
	                path: function(resp, expected, argument) {
	                    var result = jmespath.search(resp.data, argument);
	                    return jmespath.strictDeepEqual(result, expected);
	                },
	                pathAll: function(resp, expected, argument) {
	                    var results = jmespath.search(resp.data, argument);
	                    if (!Array.isArray(results)) results = [ results ];
	                    var numResults = results.length;
	                    if (!numResults) return false;
	                    for (var ind = 0; ind < numResults; ind++) {
	                        if (!jmespath.strictDeepEqual(results[ind], expected)) {
	                            return false;
	                        }
	                    }
	                    return true;
	                },
	                pathAny: function(resp, expected, argument) {
	                    var results = jmespath.search(resp.data, argument);
	                    if (!Array.isArray(results)) results = [ results ];
	                    var numResults = results.length;
	                    for (var ind = 0; ind < numResults; ind++) {
	                        if (jmespath.strictDeepEqual(results[ind], expected)) {
	                            return true;
	                        }
	                    }
	                    return false;
	                },
	                status: function(resp, expected) {
	                    var statusCode = resp.httpResponse.statusCode;
	                    return typeof statusCode === "number" && statusCode === expected;
	                },
	                error: function(resp, expected) {
	                    if (typeof expected === "string" && resp.error) {
	                        return expected === resp.error.code;
	                    }
	                    return expected === !!resp.error;
	                }
	            },
	            listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
	                add("RETRY_CHECK", "retry", function(resp) {
	                    var waiter = resp.request._waiter;
	                    if (resp.error && resp.error.code === "ResourceNotReady") {
	                        resp.error.retryDelay = (waiter.config.delay || 0) * 1e3;
	                    }
	                });
	                add("CHECK_OUTPUT", "extractData", CHECK_ACCEPTORS);
	                add("CHECK_ERROR", "extractError", CHECK_ACCEPTORS);
	            }),
	            wait: function wait(params, callback) {
	                if (typeof params === "function") {
	                    callback = params;
	                    params = undefined;
	                }
	                var request = this.service.makeRequest(this.config.operation, params);
	                request._waiter = this;
	                request.response.maxRetries = this.config.maxAttempts;
	                request.addListeners(this.listeners);
	                if (callback) request.send(callback);
	                return request;
	            },
	            setSuccess: function setSuccess(resp) {
	                resp.error = null;
	                resp.data = resp.data || {};
	                resp.request.removeAllListeners("extractData");
	            },
	            setError: function setError(resp, retryable) {
	                resp.data = null;
	                resp.error = AWS.util.error(resp.error || new Error(), {
	                    code: "ResourceNotReady",
	                    message: "Resource is not in the state " + this.state,
	                    retryable: retryable
	                });
	            },
	            loadWaiterConfig: function loadWaiterConfig(state) {
	                if (!this.service.api.waiters[state]) {
	                    throw new AWS.util.error(new Error(), {
	                        code: "StateNotFoundError",
	                        message: "State " + state + " not found."
	                    });
	                }
	                this.config = this.service.api.waiters[state];
	            }
	        });
	    }, {
	        "./core": 24,
	        jmespath: 87
	    } ],
	    56: [ function(require, module, exports) {
	        (function(process) {
	            var AWS = require("./core");
	            var AcceptorStateMachine = require("./state_machine");
	            var inherit = AWS.util.inherit;
	            var domain = AWS.util.nodeRequire("domain");
	            var jmespath = require("jmespath");
	            var hardErrorStates = {
	                success: 1,
	                error: 1,
	                complete: 1
	            };
	            function isTerminalState(machine) {
	                return hardErrorStates.hasOwnProperty(machine._asm.currentState);
	            }
	            var fsm = new AcceptorStateMachine();
	            fsm.setupStates = function() {
	                var transition = function(_, done) {
	                    var self = this;
	                    self._haltHandlersOnError = false;
	                    self.emit(self._asm.currentState, function(err) {
	                        if (err) {
	                            if (isTerminalState(self)) {
	                                if (domain && self.domain instanceof domain.Domain) {
	                                    err.domainEmitter = self;
	                                    err.domain = self.domain;
	                                    err.domainThrown = false;
	                                    self.domain.emit("error", err);
	                                } else {
	                                    throw err;
	                                }
	                            } else {
	                                self.response.error = err;
	                                done(err);
	                            }
	                        } else {
	                            done(self.response.error);
	                        }
	                    });
	                };
	                this.addState("validate", "build", "error", transition);
	                this.addState("build", "afterBuild", "restart", transition);
	                this.addState("afterBuild", "sign", "restart", transition);
	                this.addState("sign", "send", "retry", transition);
	                this.addState("retry", "afterRetry", "afterRetry", transition);
	                this.addState("afterRetry", "sign", "error", transition);
	                this.addState("send", "validateResponse", "retry", transition);
	                this.addState("validateResponse", "extractData", "extractError", transition);
	                this.addState("extractError", "extractData", "retry", transition);
	                this.addState("extractData", "success", "retry", transition);
	                this.addState("restart", "build", "error", transition);
	                this.addState("success", "complete", "complete", transition);
	                this.addState("error", "complete", "complete", transition);
	                this.addState("complete", null, null, transition);
	            };
	            fsm.setupStates();
	            AWS.Request = inherit({
	                constructor: function Request(service, operation, params) {
	                    var endpoint = service.endpoint;
	                    var region = service.config.region;
	                    var customUserAgent = service.config.customUserAgent;
	                    if (service.isGlobalEndpoint) region = "us-east-1";
	                    this.domain = domain && domain.active;
	                    this.service = service;
	                    this.operation = operation;
	                    this.params = params || {};
	                    this.httpRequest = new AWS.HttpRequest(endpoint, region, customUserAgent);
	                    this.startTime = AWS.util.date.getDate();
	                    this.response = new AWS.Response(this);
	                    this._asm = new AcceptorStateMachine(fsm.states, "validate");
	                    this._haltHandlersOnError = false;
	                    AWS.SequentialExecutor.call(this);
	                    this.emit = this.emitEvent;
	                },
	                send: function send(callback) {
	                    if (callback) {
	                        this.on("complete", function(resp) {
	                            callback.call(resp, resp.error, resp.data);
	                        });
	                    }
	                    this.runTo();
	                    return this.response;
	                },
	                build: function build(callback) {
	                    return this.runTo("send", callback);
	                },
	                runTo: function runTo(state, done) {
	                    this._asm.runTo(state, done, this);
	                    return this;
	                },
	                abort: function abort() {
	                    this.removeAllListeners("validateResponse");
	                    this.removeAllListeners("extractError");
	                    this.on("validateResponse", function addAbortedError(resp) {
	                        resp.error = AWS.util.error(new Error("Request aborted by user"), {
	                            code: "RequestAbortedError",
	                            retryable: false
	                        });
	                    });
	                    if (this.httpRequest.stream) {
	                        this.httpRequest.stream.abort();
	                        if (this.httpRequest._abortCallback) {
	                            this.httpRequest._abortCallback();
	                        } else {
	                            this.removeAllListeners("send");
	                        }
	                    }
	                    return this;
	                },
	                eachPage: function eachPage(callback) {
	                    callback = AWS.util.fn.makeAsync(callback, 3);
	                    function wrappedCallback(response) {
	                        callback.call(response, response.error, response.data, function(result) {
	                            if (result === false) return;
	                            if (response.hasNextPage()) {
	                                response.nextPage().on("complete", wrappedCallback).send();
	                            } else {
	                                callback.call(response, null, null, AWS.util.fn.noop);
	                            }
	                        });
	                    }
	                    this.on("complete", wrappedCallback).send();
	                },
	                eachItem: function eachItem(callback) {
	                    var self = this;
	                    function wrappedCallback(err, data) {
	                        if (err) return callback(err, null);
	                        if (data === null) return callback(null, null);
	                        var config = self.service.paginationConfig(self.operation);
	                        var resultKey = config.resultKey;
	                        if (Array.isArray(resultKey)) resultKey = resultKey[0];
	                        var items = jmespath.search(data, resultKey);
	                        AWS.util.arrayEach(items, function(item) {
	                            callback(null, item);
	                        });
	                    }
	                    this.eachPage(wrappedCallback);
	                },
	                isPageable: function isPageable() {
	                    return this.service.paginationConfig(this.operation) ? true : false;
	                },
	                createReadStream: function createReadStream() {
	                    var streams = AWS.util.nodeRequire("stream");
	                    var req = this;
	                    var stream = null;
	                    if (AWS.HttpClient.streamsApiVersion === 2) {
	                        stream = new streams.PassThrough();
	                        req.send();
	                    } else {
	                        stream = new streams.Stream();
	                        stream.readable = true;
	                        stream.sent = false;
	                        stream.on("newListener", function(event) {
	                            if (!stream.sent && event === "data") {
	                                stream.sent = true;
	                                process.nextTick(function() {
	                                    req.send();
	                                });
	                            }
	                        });
	                    }
	                    this.on("httpHeaders", function streamHeaders(statusCode, headers, resp) {
	                        if (statusCode < 300) {
	                            req.removeListener("httpData", AWS.EventListeners.Core.HTTP_DATA);
	                            req.removeListener("httpError", AWS.EventListeners.Core.HTTP_ERROR);
	                            req.on("httpError", function streamHttpError(error) {
	                                resp.error = error;
	                                resp.error.retryable = false;
	                            });
	                            var httpStream = resp.httpResponse.createUnbufferedStream();
	                            if (AWS.HttpClient.streamsApiVersion === 2) {
	                                httpStream.pipe(stream);
	                            } else {
	                                httpStream.on("data", function(arg) {
	                                    stream.emit("data", arg);
	                                });
	                                httpStream.on("end", function() {
	                                    stream.emit("end");
	                                });
	                            }
	                            httpStream.on("error", function(err) {
	                                stream.emit("error", err);
	                            });
	                        }
	                    });
	                    this.on("error", function(err) {
	                        stream.emit("error", err);
	                    });
	                    return stream;
	                },
	                emitEvent: function emit(eventName, args, done) {
	                    if (typeof args === "function") {
	                        done = args;
	                        args = null;
	                    }
	                    if (!done) done = function() {};
	                    if (!args) args = this.eventParameters(eventName, this.response);
	                    var origEmit = AWS.SequentialExecutor.prototype.emit;
	                    origEmit.call(this, eventName, args, function(err) {
	                        if (err) this.response.error = err;
	                        done.call(this, err);
	                    });
	                },
	                eventParameters: function eventParameters(eventName) {
	                    switch (eventName) {
	                      case "restart":
	                      case "validate":
	                      case "sign":
	                      case "build":
	                      case "afterValidate":
	                      case "afterBuild":
	                        return [ this ];
	
	                      case "error":
	                        return [ this.response.error, this.response ];
	
	                      default:
	                        return [ this.response ];
	                    }
	                },
	                presign: function presign(expires, callback) {
	                    if (!callback && typeof expires === "function") {
	                        callback = expires;
	                        expires = null;
	                    }
	                    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
	                },
	                isPresigned: function isPresigned() {
	                    return this.httpRequest.headers.hasOwnProperty("presigned-expires");
	                },
	                toUnauthenticated: function toUnauthenticated() {
	                    this.removeListener("validate", AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
	                    this.removeListener("sign", AWS.EventListeners.Core.SIGN);
	                    return this;
	                },
	                toGet: function toGet() {
	                    if (this.service.api.protocol === "query" || this.service.api.protocol === "ec2") {
	                        this.removeListener("build", this.buildAsGet);
	                        this.addListener("build", this.buildAsGet);
	                    }
	                    return this;
	                },
	                buildAsGet: function buildAsGet(request) {
	                    request.httpRequest.method = "GET";
	                    request.httpRequest.path = request.service.endpoint.path + "?" + request.httpRequest.body;
	                    request.httpRequest.body = "";
	                    delete request.httpRequest.headers["Content-Length"];
	                    delete request.httpRequest.headers["Content-Type"];
	                },
	                haltHandlersOnError: function haltHandlersOnError() {
	                    this._haltHandlersOnError = true;
	                }
	            });
	            AWS.util.addPromisesToRequests(AWS.Request);
	            AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);
	        }).call(this, require("_process"));
	    }, {
	        "./core": 24,
	        "./state_machine": 83,
	        _process: 13,
	        jmespath: 87
	    } ],
	    87: [ function(require, module, exports) {
	        (function(exports) {
	            "use strict";
	            function isArray(obj) {
	                if (obj !== null) {
	                    return Object.prototype.toString.call(obj) === "[object Array]";
	                } else {
	                    return false;
	                }
	            }
	            function isObject(obj) {
	                if (obj !== null) {
	                    return Object.prototype.toString.call(obj) === "[object Object]";
	                } else {
	                    return false;
	                }
	            }
	            function strictDeepEqual(first, second) {
	                if (first === second) {
	                    return true;
	                }
	                var firstType = Object.prototype.toString.call(first);
	                if (firstType !== Object.prototype.toString.call(second)) {
	                    return false;
	                }
	                if (isArray(first) === true) {
	                    if (first.length !== second.length) {
	                        return false;
	                    }
	                    for (var i = 0; i < first.length; i++) {
	                        if (strictDeepEqual(first[i], second[i]) === false) {
	                            return false;
	                        }
	                    }
	                    return true;
	                }
	                if (isObject(first) === true) {
	                    var keysSeen = {};
	                    for (var key in first) {
	                        if (hasOwnProperty.call(first, key)) {
	                            if (strictDeepEqual(first[key], second[key]) === false) {
	                                return false;
	                            }
	                            keysSeen[key] = true;
	                        }
	                    }
	                    for (var key2 in second) {
	                        if (hasOwnProperty.call(second, key2)) {
	                            if (keysSeen[key2] !== true) {
	                                return false;
	                            }
	                        }
	                    }
	                    return true;
	                }
	                return false;
	            }
	            function isFalse(obj) {
	                if (obj === "" || obj === false || obj === null) {
	                    return true;
	                } else if (isArray(obj) && obj.length === 0) {
	                    return true;
	                } else if (isObject(obj)) {
	                    for (var key in obj) {
	                        if (obj.hasOwnProperty(key)) {
	                            return false;
	                        }
	                    }
	                    return true;
	                } else {
	                    return false;
	                }
	            }
	            function objValues(obj) {
	                var keys = Object.keys(obj);
	                var values = [];
	                for (var i = 0; i < keys.length; i++) {
	                    values.push(obj[keys[i]]);
	                }
	                return values;
	            }
	            function merge(a, b) {
	                var merged = {};
	                for (var key in a) {
	                    merged[key] = a[key];
	                }
	                for (var key2 in b) {
	                    merged[key2] = b[key2];
	                }
	                return merged;
	            }
	            var trimLeft;
	            if (typeof String.prototype.trimLeft === "function") {
	                trimLeft = function(str) {
	                    return str.trimLeft();
	                };
	            } else {
	                trimLeft = function(str) {
	                    return str.match(/^\s*(.*)/)[1];
	                };
	            }
	            var TYPE_NUMBER = 0;
	            var TYPE_ANY = 1;
	            var TYPE_STRING = 2;
	            var TYPE_ARRAY = 3;
	            var TYPE_OBJECT = 4;
	            var TYPE_BOOLEAN = 5;
	            var TYPE_EXPREF = 6;
	            var TYPE_NULL = 7;
	            var TYPE_ARRAY_NUMBER = 8;
	            var TYPE_ARRAY_STRING = 9;
	            var TOK_EOF = "EOF";
	            var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
	            var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
	            var TOK_RBRACKET = "Rbracket";
	            var TOK_RPAREN = "Rparen";
	            var TOK_COMMA = "Comma";
	            var TOK_COLON = "Colon";
	            var TOK_RBRACE = "Rbrace";
	            var TOK_NUMBER = "Number";
	            var TOK_CURRENT = "Current";
	            var TOK_EXPREF = "Expref";
	            var TOK_PIPE = "Pipe";
	            var TOK_OR = "Or";
	            var TOK_AND = "And";
	            var TOK_EQ = "EQ";
	            var TOK_GT = "GT";
	            var TOK_LT = "LT";
	            var TOK_GTE = "GTE";
	            var TOK_LTE = "LTE";
	            var TOK_NE = "NE";
	            var TOK_FLATTEN = "Flatten";
	            var TOK_STAR = "Star";
	            var TOK_FILTER = "Filter";
	            var TOK_DOT = "Dot";
	            var TOK_NOT = "Not";
	            var TOK_LBRACE = "Lbrace";
	            var TOK_LBRACKET = "Lbracket";
	            var TOK_LPAREN = "Lparen";
	            var TOK_LITERAL = "Literal";
	            var basicTokens = {
	                ".": TOK_DOT,
	                "*": TOK_STAR,
	                ",": TOK_COMMA,
	                ":": TOK_COLON,
	                "{": TOK_LBRACE,
	                "}": TOK_RBRACE,
	                "]": TOK_RBRACKET,
	                "(": TOK_LPAREN,
	                ")": TOK_RPAREN,
	                "@": TOK_CURRENT
	            };
	            var operatorStartToken = {
	                "<": true,
	                ">": true,
	                "=": true,
	                "!": true
	            };
	            var skipChars = {
	                " ": true,
	                "	": true,
	                "\n": true
	            };
	            function isAlpha(ch) {
	                return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch === "_";
	            }
	            function isNum(ch) {
	                return ch >= "0" && ch <= "9" || ch === "-";
	            }
	            function isAlphaNum(ch) {
	                return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9" || ch === "_";
	            }
	            function Lexer() {}
	            Lexer.prototype = {
	                tokenize: function(stream) {
	                    var tokens = [];
	                    this._current = 0;
	                    var start;
	                    var identifier;
	                    var token;
	                    while (this._current < stream.length) {
	                        if (isAlpha(stream[this._current])) {
	                            start = this._current;
	                            identifier = this._consumeUnquotedIdentifier(stream);
	                            tokens.push({
	                                type: TOK_UNQUOTEDIDENTIFIER,
	                                value: identifier,
	                                start: start
	                            });
	                        } else if (basicTokens[stream[this._current]] !== undefined) {
	                            tokens.push({
	                                type: basicTokens[stream[this._current]],
	                                value: stream[this._current],
	                                start: this._current
	                            });
	                            this._current++;
	                        } else if (isNum(stream[this._current])) {
	                            token = this._consumeNumber(stream);
	                            tokens.push(token);
	                        } else if (stream[this._current] === "[") {
	                            token = this._consumeLBracket(stream);
	                            tokens.push(token);
	                        } else if (stream[this._current] === '"') {
	                            start = this._current;
	                            identifier = this._consumeQuotedIdentifier(stream);
	                            tokens.push({
	                                type: TOK_QUOTEDIDENTIFIER,
	                                value: identifier,
	                                start: start
	                            });
	                        } else if (stream[this._current] === "'") {
	                            start = this._current;
	                            identifier = this._consumeRawStringLiteral(stream);
	                            tokens.push({
	                                type: TOK_LITERAL,
	                                value: identifier,
	                                start: start
	                            });
	                        } else if (stream[this._current] === "`") {
	                            start = this._current;
	                            var literal = this._consumeLiteral(stream);
	                            tokens.push({
	                                type: TOK_LITERAL,
	                                value: literal,
	                                start: start
	                            });
	                        } else if (operatorStartToken[stream[this._current]] !== undefined) {
	                            tokens.push(this._consumeOperator(stream));
	                        } else if (skipChars[stream[this._current]] !== undefined) {
	                            this._current++;
	                        } else if (stream[this._current] === "&") {
	                            start = this._current;
	                            this._current++;
	                            if (stream[this._current] === "&") {
	                                this._current++;
	                                tokens.push({
	                                    type: TOK_AND,
	                                    value: "&&",
	                                    start: start
	                                });
	                            } else {
	                                tokens.push({
	                                    type: TOK_EXPREF,
	                                    value: "&",
	                                    start: start
	                                });
	                            }
	                        } else if (stream[this._current] === "|") {
	                            start = this._current;
	                            this._current++;
	                            if (stream[this._current] === "|") {
	                                this._current++;
	                                tokens.push({
	                                    type: TOK_OR,
	                                    value: "||",
	                                    start: start
	                                });
	                            } else {
	                                tokens.push({
	                                    type: TOK_PIPE,
	                                    value: "|",
	                                    start: start
	                                });
	                            }
	                        } else {
	                            var error = new Error("Unknown character:" + stream[this._current]);
	                            error.name = "LexerError";
	                            throw error;
	                        }
	                    }
	                    return tokens;
	                },
	                _consumeUnquotedIdentifier: function(stream) {
	                    var start = this._current;
	                    this._current++;
	                    while (this._current < stream.length && isAlphaNum(stream[this._current])) {
	                        this._current++;
	                    }
	                    return stream.slice(start, this._current);
	                },
	                _consumeQuotedIdentifier: function(stream) {
	                    var start = this._current;
	                    this._current++;
	                    var maxLength = stream.length;
	                    while (stream[this._current] !== '"' && this._current < maxLength) {
	                        var current = this._current;
	                        if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === '"')) {
	                            current += 2;
	                        } else {
	                            current++;
	                        }
	                        this._current = current;
	                    }
	                    this._current++;
	                    return JSON.parse(stream.slice(start, this._current));
	                },
	                _consumeRawStringLiteral: function(stream) {
	                    var start = this._current;
	                    this._current++;
	                    var maxLength = stream.length;
	                    while (stream[this._current] !== "'" && this._current < maxLength) {
	                        var current = this._current;
	                        if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "'")) {
	                            current += 2;
	                        } else {
	                            current++;
	                        }
	                        this._current = current;
	                    }
	                    this._current++;
	                    var literal = stream.slice(start + 1, this._current - 1);
	                    return literal.replace("\\'", "'");
	                },
	                _consumeNumber: function(stream) {
	                    var start = this._current;
	                    this._current++;
	                    var maxLength = stream.length;
	                    while (isNum(stream[this._current]) && this._current < maxLength) {
	                        this._current++;
	                    }
	                    var value = parseInt(stream.slice(start, this._current));
	                    return {
	                        type: TOK_NUMBER,
	                        value: value,
	                        start: start
	                    };
	                },
	                _consumeLBracket: function(stream) {
	                    var start = this._current;
	                    this._current++;
	                    if (stream[this._current] === "?") {
	                        this._current++;
	                        return {
	                            type: TOK_FILTER,
	                            value: "[?",
	                            start: start
	                        };
	                    } else if (stream[this._current] === "]") {
	                        this._current++;
	                        return {
	                            type: TOK_FLATTEN,
	                            value: "[]",
	                            start: start
	                        };
	                    } else {
	                        return {
	                            type: TOK_LBRACKET,
	                            value: "[",
	                            start: start
	                        };
	                    }
	                },
	                _consumeOperator: function(stream) {
	                    var start = this._current;
	                    var startingChar = stream[start];
	                    this._current++;
	                    if (startingChar === "!") {
	                        if (stream[this._current] === "=") {
	                            this._current++;
	                            return {
	                                type: TOK_NE,
	                                value: "!=",
	                                start: start
	                            };
	                        } else {
	                            return {
	                                type: TOK_NOT,
	                                value: "!",
	                                start: start
	                            };
	                        }
	                    } else if (startingChar === "<") {
	                        if (stream[this._current] === "=") {
	                            this._current++;
	                            return {
	                                type: TOK_LTE,
	                                value: "<=",
	                                start: start
	                            };
	                        } else {
	                            return {
	                                type: TOK_LT,
	                                value: "<",
	                                start: start
	                            };
	                        }
	                    } else if (startingChar === ">") {
	                        if (stream[this._current] === "=") {
	                            this._current++;
	                            return {
	                                type: TOK_GTE,
	                                value: ">=",
	                                start: start
	                            };
	                        } else {
	                            return {
	                                type: TOK_GT,
	                                value: ">",
	                                start: start
	                            };
	                        }
	                    } else if (startingChar === "=") {
	                        if (stream[this._current] === "=") {
	                            this._current++;
	                            return {
	                                type: TOK_EQ,
	                                value: "==",
	                                start: start
	                            };
	                        }
	                    }
	                },
	                _consumeLiteral: function(stream) {
	                    this._current++;
	                    var start = this._current;
	                    var maxLength = stream.length;
	                    var literal;
	                    while (stream[this._current] !== "`" && this._current < maxLength) {
	                        var current = this._current;
	                        if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "`")) {
	                            current += 2;
	                        } else {
	                            current++;
	                        }
	                        this._current = current;
	                    }
	                    var literalString = trimLeft(stream.slice(start, this._current));
	                    literalString = literalString.replace("\\`", "`");
	                    if (this._looksLikeJSON(literalString)) {
	                        literal = JSON.parse(literalString);
	                    } else {
	                        literal = JSON.parse('"' + literalString + '"');
	                    }
	                    this._current++;
	                    return literal;
	                },
	                _looksLikeJSON: function(literalString) {
	                    var startingChars = '[{"';
	                    var jsonLiterals = [ "true", "false", "null" ];
	                    var numberLooking = "-0123456789";
	                    if (literalString === "") {
	                        return false;
	                    } else if (startingChars.indexOf(literalString[0]) >= 0) {
	                        return true;
	                    } else if (jsonLiterals.indexOf(literalString) >= 0) {
	                        return true;
	                    } else if (numberLooking.indexOf(literalString[0]) >= 0) {
	                        try {
	                            JSON.parse(literalString);
	                            return true;
	                        } catch (ex) {
	                            return false;
	                        }
	                    } else {
	                        return false;
	                    }
	                }
	            };
	            var bindingPower = {};
	            bindingPower[TOK_EOF] = 0;
	            bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
	            bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
	            bindingPower[TOK_RBRACKET] = 0;
	            bindingPower[TOK_RPAREN] = 0;
	            bindingPower[TOK_COMMA] = 0;
	            bindingPower[TOK_RBRACE] = 0;
	            bindingPower[TOK_NUMBER] = 0;
	            bindingPower[TOK_CURRENT] = 0;
	            bindingPower[TOK_EXPREF] = 0;
	            bindingPower[TOK_PIPE] = 1;
	            bindingPower[TOK_OR] = 2;
	            bindingPower[TOK_AND] = 3;
	            bindingPower[TOK_EQ] = 5;
	            bindingPower[TOK_GT] = 5;
	            bindingPower[TOK_LT] = 5;
	            bindingPower[TOK_GTE] = 5;
	            bindingPower[TOK_LTE] = 5;
	            bindingPower[TOK_NE] = 5;
	            bindingPower[TOK_FLATTEN] = 9;
	            bindingPower[TOK_STAR] = 20;
	            bindingPower[TOK_FILTER] = 21;
	            bindingPower[TOK_DOT] = 40;
	            bindingPower[TOK_NOT] = 45;
	            bindingPower[TOK_LBRACE] = 50;
	            bindingPower[TOK_LBRACKET] = 55;
	            bindingPower[TOK_LPAREN] = 60;
	            function Parser() {}
	            Parser.prototype = {
	                parse: function(expression) {
	                    this._loadTokens(expression);
	                    this.index = 0;
	                    var ast = this.expression(0);
	                    if (this._lookahead(0) !== TOK_EOF) {
	                        var t = this._lookaheadToken(0);
	                        var error = new Error("Unexpected token type: " + t.type + ", value: " + t.value);
	                        error.name = "ParserError";
	                        throw error;
	                    }
	                    return ast;
	                },
	                _loadTokens: function(expression) {
	                    var lexer = new Lexer();
	                    var tokens = lexer.tokenize(expression);
	                    tokens.push({
	                        type: TOK_EOF,
	                        value: "",
	                        start: expression.length
	                    });
	                    this.tokens = tokens;
	                },
	                expression: function(rbp) {
	                    var leftToken = this._lookaheadToken(0);
	                    this._advance();
	                    var left = this.nud(leftToken);
	                    var currentToken = this._lookahead(0);
	                    while (rbp < bindingPower[currentToken]) {
	                        this._advance();
	                        left = this.led(currentToken, left);
	                        currentToken = this._lookahead(0);
	                    }
	                    return left;
	                },
	                _lookahead: function(number) {
	                    return this.tokens[this.index + number].type;
	                },
	                _lookaheadToken: function(number) {
	                    return this.tokens[this.index + number];
	                },
	                _advance: function() {
	                    this.index++;
	                },
	                nud: function(token) {
	                    var left;
	                    var right;
	                    var expression;
	                    switch (token.type) {
	                      case TOK_LITERAL:
	                        return {
	                            type: "Literal",
	                            value: token.value
	                        };
	
	                      case TOK_UNQUOTEDIDENTIFIER:
	                        return {
	                            type: "Field",
	                            name: token.value
	                        };
	
	                      case TOK_QUOTEDIDENTIFIER:
	                        var node = {
	                            type: "Field",
	                            name: token.value
	                        };
	                        if (this._lookahead(0) === TOK_LPAREN) {
	                            throw new Error("Quoted identifier not allowed for function names.");
	                        } else {
	                            return node;
	                        }
	                        break;
	
	                      case TOK_NOT:
	                        right = this.expression(bindingPower.Not);
	                        return {
	                            type: "NotExpression",
	                            children: [ right ]
	                        };
	
	                      case TOK_STAR:
	                        left = {
	                            type: "Identity"
	                        };
	                        right = null;
	                        if (this._lookahead(0) === TOK_RBRACKET) {
	                            right = {
	                                type: "Identity"
	                            };
	                        } else {
	                            right = this._parseProjectionRHS(bindingPower.Star);
	                        }
	                        return {
	                            type: "ValueProjection",
	                            children: [ left, right ]
	                        };
	
	                      case TOK_FILTER:
	                        return this.led(token.type, {
	                            type: "Identity"
	                        });
	
	                      case TOK_LBRACE:
	                        return this._parseMultiselectHash();
	
	                      case TOK_FLATTEN:
	                        left = {
	                            type: TOK_FLATTEN,
	                            children: [ {
	                                type: "Identity"
	                            } ]
	                        };
	                        right = this._parseProjectionRHS(bindingPower.Flatten);
	                        return {
	                            type: "Projection",
	                            children: [ left, right ]
	                        };
	
	                      case TOK_LBRACKET:
	                        if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
	                            right = this._parseIndexExpression();
	                            return this._projectIfSlice({
	                                type: "Identity"
	                            }, right);
	                        } else if (this._lookahead(0) === TOK_STAR && this._lookahead(1) === TOK_RBRACKET) {
	                            this._advance();
	                            this._advance();
	                            right = this._parseProjectionRHS(bindingPower.Star);
	                            return {
	                                type: "Projection",
	                                children: [ {
	                                    type: "Identity"
	                                }, right ]
	                            };
	                        } else {
	                            return this._parseMultiselectList();
	                        }
	                        break;
	
	                      case TOK_CURRENT:
	                        return {
	                            type: TOK_CURRENT
	                        };
	
	                      case TOK_EXPREF:
	                        expression = this.expression(bindingPower.Expref);
	                        return {
	                            type: "ExpressionReference",
	                            children: [ expression ]
	                        };
	
	                      case TOK_LPAREN:
	                        var args = [];
	                        while (this._lookahead(0) !== TOK_RPAREN) {
	                            if (this._lookahead(0) === TOK_CURRENT) {
	                                expression = {
	                                    type: TOK_CURRENT
	                                };
	                                this._advance();
	                            } else {
	                                expression = this.expression(0);
	                            }
	                            args.push(expression);
	                        }
	                        this._match(TOK_RPAREN);
	                        return args[0];
	
	                      default:
	                        this._errorToken(token);
	                    }
	                },
	                led: function(tokenName, left) {
	                    var right;
	                    switch (tokenName) {
	                      case TOK_DOT:
	                        var rbp = bindingPower.Dot;
	                        if (this._lookahead(0) !== TOK_STAR) {
	                            right = this._parseDotRHS(rbp);
	                            return {
	                                type: "Subexpression",
	                                children: [ left, right ]
	                            };
	                        } else {
	                            this._advance();
	                            right = this._parseProjectionRHS(rbp);
	                            return {
	                                type: "ValueProjection",
	                                children: [ left, right ]
	                            };
	                        }
	                        break;
	
	                      case TOK_PIPE:
	                        right = this.expression(bindingPower.Pipe);
	                        return {
	                            type: TOK_PIPE,
	                            children: [ left, right ]
	                        };
	
	                      case TOK_OR:
	                        right = this.expression(bindingPower.Or);
	                        return {
	                            type: "OrExpression",
	                            children: [ left, right ]
	                        };
	
	                      case TOK_AND:
	                        right = this.expression(bindingPower.And);
	                        return {
	                            type: "AndExpression",
	                            children: [ left, right ]
	                        };
	
	                      case TOK_LPAREN:
	                        var name = left.name;
	                        var args = [];
	                        var expression, node;
	                        while (this._lookahead(0) !== TOK_RPAREN) {
	                            if (this._lookahead(0) === TOK_CURRENT) {
	                                expression = {
	                                    type: TOK_CURRENT
	                                };
	                                this._advance();
	                            } else {
	                                expression = this.expression(0);
	                            }
	                            if (this._lookahead(0) === TOK_COMMA) {
	                                this._match(TOK_COMMA);
	                            }
	                            args.push(expression);
	                        }
	                        this._match(TOK_RPAREN);
	                        node = {
	                            type: "Function",
	                            name: name,
	                            children: args
	                        };
	                        return node;
	
	                      case TOK_FILTER:
	                        var condition = this.expression(0);
	                        this._match(TOK_RBRACKET);
	                        if (this._lookahead(0) === TOK_FLATTEN) {
	                            right = {
	                                type: "Identity"
	                            };
	                        } else {
	                            right = this._parseProjectionRHS(bindingPower.Filter);
	                        }
	                        return {
	                            type: "FilterProjection",
	                            children: [ left, right, condition ]
	                        };
	
	                      case TOK_FLATTEN:
	                        var leftNode = {
	                            type: TOK_FLATTEN,
	                            children: [ left ]
	                        };
	                        var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
	                        return {
	                            type: "Projection",
	                            children: [ leftNode, rightNode ]
	                        };
	
	                      case TOK_EQ:
	                      case TOK_NE:
	                      case TOK_GT:
	                      case TOK_GTE:
	                      case TOK_LT:
	                      case TOK_LTE:
	                        return this._parseComparator(left, tokenName);
	
	                      case TOK_LBRACKET:
	                        var token = this._lookaheadToken(0);
	                        if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
	                            right = this._parseIndexExpression();
	                            return this._projectIfSlice(left, right);
	                        } else {
	                            this._match(TOK_STAR);
	                            this._match(TOK_RBRACKET);
	                            right = this._parseProjectionRHS(bindingPower.Star);
	                            return {
	                                type: "Projection",
	                                children: [ left, right ]
	                            };
	                        }
	                        break;
	
	                      default:
	                        this._errorToken(this._lookaheadToken(0));
	                    }
	                },
	                _match: function(tokenType) {
	                    if (this._lookahead(0) === tokenType) {
	                        this._advance();
	                    } else {
	                        var t = this._lookaheadToken(0);
	                        var error = new Error("Expected " + tokenType + ", got: " + t.type);
	                        error.name = "ParserError";
	                        throw error;
	                    }
	                },
	                _errorToken: function(token) {
	                    var error = new Error("Invalid token (" + token.type + '): "' + token.value + '"');
	                    error.name = "ParserError";
	                    throw error;
	                },
	                _parseIndexExpression: function() {
	                    if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
	                        return this._parseSliceExpression();
	                    } else {
	                        var node = {
	                            type: "Index",
	                            value: this._lookaheadToken(0).value
	                        };
	                        this._advance();
	                        this._match(TOK_RBRACKET);
	                        return node;
	                    }
	                },
	                _projectIfSlice: function(left, right) {
	                    var indexExpr = {
	                        type: "IndexExpression",
	                        children: [ left, right ]
	                    };
	                    if (right.type === "Slice") {
	                        return {
	                            type: "Projection",
	                            children: [ indexExpr, this._parseProjectionRHS(bindingPower.Star) ]
	                        };
	                    } else {
	                        return indexExpr;
	                    }
	                },
	                _parseSliceExpression: function() {
	                    var parts = [ null, null, null ];
	                    var index = 0;
	                    var currentToken = this._lookahead(0);
	                    while (currentToken !== TOK_RBRACKET && index < 3) {
	                        if (currentToken === TOK_COLON) {
	                            index++;
	                            this._advance();
	                        } else if (currentToken === TOK_NUMBER) {
	                            parts[index] = this._lookaheadToken(0).value;
	                            this._advance();
	                        } else {
	                            var t = this._lookahead(0);
	                            var error = new Error("Syntax error, unexpected token: " + t.value + "(" + t.type + ")");
	                            error.name = "Parsererror";
	                            throw error;
	                        }
	                        currentToken = this._lookahead(0);
	                    }
	                    this._match(TOK_RBRACKET);
	                    return {
	                        type: "Slice",
	                        children: parts
	                    };
	                },
	                _parseComparator: function(left, comparator) {
	                    var right = this.expression(bindingPower[comparator]);
	                    return {
	                        type: "Comparator",
	                        name: comparator,
	                        children: [ left, right ]
	                    };
	                },
	                _parseDotRHS: function(rbp) {
	                    var lookahead = this._lookahead(0);
	                    var exprTokens = [ TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR ];
	                    if (exprTokens.indexOf(lookahead) >= 0) {
	                        return this.expression(rbp);
	                    } else if (lookahead === TOK_LBRACKET) {
	                        this._match(TOK_LBRACKET);
	                        return this._parseMultiselectList();
	                    } else if (lookahead === TOK_LBRACE) {
	                        this._match(TOK_LBRACE);
	                        return this._parseMultiselectHash();
	                    }
	                },
	                _parseProjectionRHS: function(rbp) {
	                    var right;
	                    if (bindingPower[this._lookahead(0)] < 10) {
	                        right = {
	                            type: "Identity"
	                        };
	                    } else if (this._lookahead(0) === TOK_LBRACKET) {
	                        right = this.expression(rbp);
	                    } else if (this._lookahead(0) === TOK_FILTER) {
	                        right = this.expression(rbp);
	                    } else if (this._lookahead(0) === TOK_DOT) {
	                        this._match(TOK_DOT);
	                        right = this._parseDotRHS(rbp);
	                    } else {
	                        var t = this._lookaheadToken(0);
	                        var error = new Error("Sytanx error, unexpected token: " + t.value + "(" + t.type + ")");
	                        error.name = "ParserError";
	                        throw error;
	                    }
	                    return right;
	                },
	                _parseMultiselectList: function() {
	                    var expressions = [];
	                    while (this._lookahead(0) !== TOK_RBRACKET) {
	                        var expression = this.expression(0);
	                        expressions.push(expression);
	                        if (this._lookahead(0) === TOK_COMMA) {
	                            this._match(TOK_COMMA);
	                            if (this._lookahead(0) === TOK_RBRACKET) {
	                                throw new Error("Unexpected token Rbracket");
	                            }
	                        }
	                    }
	                    this._match(TOK_RBRACKET);
	                    return {
	                        type: "MultiSelectList",
	                        children: expressions
	                    };
	                },
	                _parseMultiselectHash: function() {
	                    var pairs = [];
	                    var identifierTypes = [ TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER ];
	                    var keyToken, keyName, value, node;
	                    for (;;) {
	                        keyToken = this._lookaheadToken(0);
	                        if (identifierTypes.indexOf(keyToken.type) < 0) {
	                            throw new Error("Expecting an identifier token, got: " + keyToken.type);
	                        }
	                        keyName = keyToken.value;
	                        this._advance();
	                        this._match(TOK_COLON);
	                        value = this.expression(0);
	                        node = {
	                            type: "KeyValuePair",
	                            name: keyName,
	                            value: value
	                        };
	                        pairs.push(node);
	                        if (this._lookahead(0) === TOK_COMMA) {
	                            this._match(TOK_COMMA);
	                        } else if (this._lookahead(0) === TOK_RBRACE) {
	                            this._match(TOK_RBRACE);
	                            break;
	                        }
	                    }
	                    return {
	                        type: "MultiSelectHash",
	                        children: pairs
	                    };
	                }
	            };
	            function TreeInterpreter(runtime) {
	                this.runtime = runtime;
	            }
	            TreeInterpreter.prototype = {
	                search: function(node, value) {
	                    return this.visit(node, value);
	                },
	                visit: function(node, value) {
	                    var matched, current, result, first, second, field, left, right, collected, i;
	                    switch (node.type) {
	                      case "Field":
	                        if (value === null) {
	                            return null;
	                        } else if (isObject(value)) {
	                            field = value[node.name];
	                            if (field === undefined) {
	                                return null;
	                            } else {
	                                return field;
	                            }
	                        } else {
	                            return null;
	                        }
	                        break;
	
	                      case "Subexpression":
	                        result = this.visit(node.children[0], value);
	                        for (i = 1; i < node.children.length; i++) {
	                            result = this.visit(node.children[1], result);
	                            if (result === null) {
	                                return null;
	                            }
	                        }
	                        return result;
	
	                      case "IndexExpression":
	                        left = this.visit(node.children[0], value);
	                        right = this.visit(node.children[1], left);
	                        return right;
	
	                      case "Index":
	                        if (!isArray(value)) {
	                            return null;
	                        }
	                        var index = node.value;
	                        if (index < 0) {
	                            index = value.length + index;
	                        }
	                        result = value[index];
	                        if (result === undefined) {
	                            result = null;
	                        }
	                        return result;
	
	                      case "Slice":
	                        if (!isArray(value)) {
	                            return null;
	                        }
	                        var sliceParams = node.children.slice(0);
	                        var computed = this.computeSliceParams(value.length, sliceParams);
	                        var start = computed[0];
	                        var stop = computed[1];
	                        var step = computed[2];
	                        result = [];
	                        if (step > 0) {
	                            for (i = start; i < stop; i += step) {
	                                result.push(value[i]);
	                            }
	                        } else {
	                            for (i = start; i > stop; i += step) {
	                                result.push(value[i]);
	                            }
	                        }
	                        return result;
	
	                      case "Projection":
	                        var base = this.visit(node.children[0], value);
	                        if (!isArray(base)) {
	                            return null;
	                        }
	                        collected = [];
	                        for (i = 0; i < base.length; i++) {
	                            current = this.visit(node.children[1], base[i]);
	                            if (current !== null) {
	                                collected.push(current);
	                            }
	                        }
	                        return collected;
	
	                      case "ValueProjection":
	                        base = this.visit(node.children[0], value);
	                        if (!isObject(base)) {
	                            return null;
	                        }
	                        collected = [];
	                        var values = objValues(base);
	                        for (i = 0; i < values.length; i++) {
	                            current = this.visit(node.children[1], values[i]);
	                            if (current !== null) {
	                                collected.push(current);
	                            }
	                        }
	                        return collected;
	
	                      case "FilterProjection":
	                        base = this.visit(node.children[0], value);
	                        if (!isArray(base)) {
	                            return null;
	                        }
	                        var filtered = [];
	                        var finalResults = [];
	                        for (i = 0; i < base.length; i++) {
	                            matched = this.visit(node.children[2], base[i]);
	                            if (!isFalse(matched)) {
	                                filtered.push(base[i]);
	                            }
	                        }
	                        for (var j = 0; j < filtered.length; j++) {
	                            current = this.visit(node.children[1], filtered[j]);
	                            if (current !== null) {
	                                finalResults.push(current);
	                            }
	                        }
	                        return finalResults;
	
	                      case "Comparator":
	                        first = this.visit(node.children[0], value);
	                        second = this.visit(node.children[1], value);
	                        switch (node.name) {
	                          case TOK_EQ:
	                            result = strictDeepEqual(first, second);
	                            break;
	
	                          case TOK_NE:
	                            result = !strictDeepEqual(first, second);
	                            break;
	
	                          case TOK_GT:
	                            result = first > second;
	                            break;
	
	                          case TOK_GTE:
	                            result = first >= second;
	                            break;
	
	                          case TOK_LT:
	                            result = first < second;
	                            break;
	
	                          case TOK_LTE:
	                            result = first <= second;
	                            break;
	
	                          default:
	                            throw new Error("Unknown comparator: " + node.name);
	                        }
	                        return result;
	
	                      case TOK_FLATTEN:
	                        var original = this.visit(node.children[0], value);
	                        if (!isArray(original)) {
	                            return null;
	                        }
	                        var merged = [];
	                        for (i = 0; i < original.length; i++) {
	                            current = original[i];
	                            if (isArray(current)) {
	                                merged.push.apply(merged, current);
	                            } else {
	                                merged.push(current);
	                            }
	                        }
	                        return merged;
	
	                      case "Identity":
	                        return value;
	
	                      case "MultiSelectList":
	                        if (value === null) {
	                            return null;
	                        }
	                        collected = [];
	                        for (i = 0; i < node.children.length; i++) {
	                            collected.push(this.visit(node.children[i], value));
	                        }
	                        return collected;
	
	                      case "MultiSelectHash":
	                        if (value === null) {
	                            return null;
	                        }
	                        collected = {};
	                        var child;
	                        for (i = 0; i < node.children.length; i++) {
	                            child = node.children[i];
	                            collected[child.name] = this.visit(child.value, value);
	                        }
	                        return collected;
	
	                      case "OrExpression":
	                        matched = this.visit(node.children[0], value);
	                        if (isFalse(matched)) {
	                            matched = this.visit(node.children[1], value);
	                        }
	                        return matched;
	
	                      case "AndExpression":
	                        first = this.visit(node.children[0], value);
	                        if (isFalse(first) === true) {
	                            return first;
	                        }
	                        return this.visit(node.children[1], value);
	
	                      case "NotExpression":
	                        first = this.visit(node.children[0], value);
	                        return isFalse(first);
	
	                      case "Literal":
	                        return node.value;
	
	                      case TOK_PIPE:
	                        left = this.visit(node.children[0], value);
	                        return this.visit(node.children[1], left);
	
	                      case TOK_CURRENT:
	                        return value;
	
	                      case "Function":
	                        var resolvedArgs = [];
	                        for (i = 0; i < node.children.length; i++) {
	                            resolvedArgs.push(this.visit(node.children[i], value));
	                        }
	                        return this.runtime.callFunction(node.name, resolvedArgs);
	
	                      case "ExpressionReference":
	                        var refNode = node.children[0];
	                        refNode.jmespathType = TOK_EXPREF;
	                        return refNode;
	
	                      default:
	                        throw new Error("Unknown node type: " + node.type);
	                    }
	                },
	                computeSliceParams: function(arrayLength, sliceParams) {
	                    var start = sliceParams[0];
	                    var stop = sliceParams[1];
	                    var step = sliceParams[2];
	                    var computed = [ null, null, null ];
	                    if (step === null) {
	                        step = 1;
	                    } else if (step === 0) {
	                        var error = new Error("Invalid slice, step cannot be 0");
	                        error.name = "RuntimeError";
	                        throw error;
	                    }
	                    var stepValueNegative = step < 0 ? true : false;
	                    if (start === null) {
	                        start = stepValueNegative ? arrayLength - 1 : 0;
	                    } else {
	                        start = this.capSliceRange(arrayLength, start, step);
	                    }
	                    if (stop === null) {
	                        stop = stepValueNegative ? -1 : arrayLength;
	                    } else {
	                        stop = this.capSliceRange(arrayLength, stop, step);
	                    }
	                    computed[0] = start;
	                    computed[1] = stop;
	                    computed[2] = step;
	                    return computed;
	                },
	                capSliceRange: function(arrayLength, actualValue, step) {
	                    if (actualValue < 0) {
	                        actualValue += arrayLength;
	                        if (actualValue < 0) {
	                            actualValue = step < 0 ? -1 : 0;
	                        }
	                    } else if (actualValue >= arrayLength) {
	                        actualValue = step < 0 ? arrayLength - 1 : arrayLength;
	                    }
	                    return actualValue;
	                }
	            };
	            function Runtime(interpreter) {
	                this._interpreter = interpreter;
	                this.functionTable = {
	                    abs: {
	                        _func: this._functionAbs,
	                        _signature: [ {
	                            types: [ TYPE_NUMBER ]
	                        } ]
	                    },
	                    avg: {
	                        _func: this._functionAvg,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY_NUMBER ]
	                        } ]
	                    },
	                    ceil: {
	                        _func: this._functionCeil,
	                        _signature: [ {
	                            types: [ TYPE_NUMBER ]
	                        } ]
	                    },
	                    contains: {
	                        _func: this._functionContains,
	                        _signature: [ {
	                            types: [ TYPE_STRING, TYPE_ARRAY ]
	                        }, {
	                            types: [ TYPE_ANY ]
	                        } ]
	                    },
	                    ends_with: {
	                        _func: this._functionEndsWith,
	                        _signature: [ {
	                            types: [ TYPE_STRING ]
	                        }, {
	                            types: [ TYPE_STRING ]
	                        } ]
	                    },
	                    floor: {
	                        _func: this._functionFloor,
	                        _signature: [ {
	                            types: [ TYPE_NUMBER ]
	                        } ]
	                    },
	                    length: {
	                        _func: this._functionLength,
	                        _signature: [ {
	                            types: [ TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT ]
	                        } ]
	                    },
	                    map: {
	                        _func: this._functionMap,
	                        _signature: [ {
	                            types: [ TYPE_EXPREF ]
	                        }, {
	                            types: [ TYPE_ARRAY ]
	                        } ]
	                    },
	                    max: {
	                        _func: this._functionMax,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING ]
	                        } ]
	                    },
	                    merge: {
	                        _func: this._functionMerge,
	                        _signature: [ {
	                            types: [ TYPE_OBJECT ],
	                            variadic: true
	                        } ]
	                    },
	                    max_by: {
	                        _func: this._functionMaxBy,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY ]
	                        }, {
	                            types: [ TYPE_EXPREF ]
	                        } ]
	                    },
	                    sum: {
	                        _func: this._functionSum,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY_NUMBER ]
	                        } ]
	                    },
	                    starts_with: {
	                        _func: this._functionStartsWith,
	                        _signature: [ {
	                            types: [ TYPE_STRING ]
	                        }, {
	                            types: [ TYPE_STRING ]
	                        } ]
	                    },
	                    min: {
	                        _func: this._functionMin,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING ]
	                        } ]
	                    },
	                    min_by: {
	                        _func: this._functionMinBy,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY ]
	                        }, {
	                            types: [ TYPE_EXPREF ]
	                        } ]
	                    },
	                    type: {
	                        _func: this._functionType,
	                        _signature: [ {
	                            types: [ TYPE_ANY ]
	                        } ]
	                    },
	                    keys: {
	                        _func: this._functionKeys,
	                        _signature: [ {
	                            types: [ TYPE_OBJECT ]
	                        } ]
	                    },
	                    values: {
	                        _func: this._functionValues,
	                        _signature: [ {
	                            types: [ TYPE_OBJECT ]
	                        } ]
	                    },
	                    sort: {
	                        _func: this._functionSort,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER ]
	                        } ]
	                    },
	                    sort_by: {
	                        _func: this._functionSortBy,
	                        _signature: [ {
	                            types: [ TYPE_ARRAY ]
	                        }, {
	                            types: [ TYPE_EXPREF ]
	                        } ]
	                    },
	                    join: {
	                        _func: this._functionJoin,
	                        _signature: [ {
	                            types: [ TYPE_STRING ]
	                        }, {
	                            types: [ TYPE_ARRAY_STRING ]
	                        } ]
	                    },
	                    reverse: {
	                        _func: this._functionReverse,
	                        _signature: [ {
	                            types: [ TYPE_STRING, TYPE_ARRAY ]
	                        } ]
	                    },
	                    to_array: {
	                        _func: this._functionToArray,
	                        _signature: [ {
	                            types: [ TYPE_ANY ]
	                        } ]
	                    },
	                    to_string: {
	                        _func: this._functionToString,
	                        _signature: [ {
	                            types: [ TYPE_ANY ]
	                        } ]
	                    },
	                    to_number: {
	                        _func: this._functionToNumber,
	                        _signature: [ {
	                            types: [ TYPE_ANY ]
	                        } ]
	                    },
	                    not_null: {
	                        _func: this._functionNotNull,
	                        _signature: [ {
	                            types: [ TYPE_ANY ],
	                            variadic: true
	                        } ]
	                    }
	                };
	            }
	            Runtime.prototype = {
	                callFunction: function(name, resolvedArgs) {
	                    var functionEntry = this.functionTable[name];
	                    if (functionEntry === undefined) {
	                        throw new Error("Unknown function: " + name + "()");
	                    }
	                    this._validateArgs(name, resolvedArgs, functionEntry._signature);
	                    return functionEntry._func.call(this, resolvedArgs);
	                },
	                _validateArgs: function(name, args, signature) {
	                    var pluralized;
	                    if (signature[signature.length - 1].variadic) {
	                        if (args.length < signature.length) {
	                            pluralized = signature.length === 1 ? " argument" : " arguments";
	                            throw new Error("ArgumentError: " + name + "() " + "takes at least" + signature.length + pluralized + " but received " + args.length);
	                        }
	                    } else if (args.length !== signature.length) {
	                        pluralized = signature.length === 1 ? " argument" : " arguments";
	                        throw new Error("ArgumentError: " + name + "() " + "takes " + signature.length + pluralized + " but received " + args.length);
	                    }
	                    var currentSpec;
	                    var actualType;
	                    var typeMatched;
	                    for (var i = 0; i < signature.length; i++) {
	                        typeMatched = false;
	                        currentSpec = signature[i].types;
	                        actualType = this._getTypeName(args[i]);
	                        for (var j = 0; j < currentSpec.length; j++) {
	                            if (this._typeMatches(actualType, currentSpec[j], args[i])) {
	                                typeMatched = true;
	                                break;
	                            }
	                        }
	                        if (!typeMatched) {
	                            throw new Error("TypeError: " + name + "() " + "expected argument " + (i + 1) + " to be type " + currentSpec + " but received type " + actualType + " instead.");
	                        }
	                    }
	                },
	                _typeMatches: function(actual, expected, argValue) {
	                    if (expected === TYPE_ANY) {
	                        return true;
	                    }
	                    if (expected === TYPE_ARRAY_STRING || expected === TYPE_ARRAY_NUMBER || expected === TYPE_ARRAY) {
	                        if (expected === TYPE_ARRAY) {
	                            return actual === TYPE_ARRAY;
	                        } else if (actual === TYPE_ARRAY) {
	                            var subtype;
	                            if (expected === TYPE_ARRAY_NUMBER) {
	                                subtype = TYPE_NUMBER;
	                            } else if (expected === TYPE_ARRAY_STRING) {
	                                subtype = TYPE_STRING;
	                            }
	                            for (var i = 0; i < argValue.length; i++) {
	                                if (!this._typeMatches(this._getTypeName(argValue[i]), subtype, argValue[i])) {
	                                    return false;
	                                }
	                            }
	                            return true;
	                        }
	                    } else {
	                        return actual === expected;
	                    }
	                },
	                _getTypeName: function(obj) {
	                    switch (Object.prototype.toString.call(obj)) {
	                      case "[object String]":
	                        return TYPE_STRING;
	
	                      case "[object Number]":
	                        return TYPE_NUMBER;
	
	                      case "[object Array]":
	                        return TYPE_ARRAY;
	
	                      case "[object Boolean]":
	                        return TYPE_BOOLEAN;
	
	                      case "[object Null]":
	                        return TYPE_NULL;
	
	                      case "[object Object]":
	                        if (obj.jmespathType === TOK_EXPREF) {
	                            return TYPE_EXPREF;
	                        } else {
	                            return TYPE_OBJECT;
	                        }
	                    }
	                },
	                _functionStartsWith: function(resolvedArgs) {
	                    return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
	                },
	                _functionEndsWith: function(resolvedArgs) {
	                    var searchStr = resolvedArgs[0];
	                    var suffix = resolvedArgs[1];
	                    return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
	                },
	                _functionReverse: function(resolvedArgs) {
	                    var typeName = this._getTypeName(resolvedArgs[0]);
	                    if (typeName === TYPE_STRING) {
	                        var originalStr = resolvedArgs[0];
	                        var reversedStr = "";
	                        for (var i = originalStr.length - 1; i >= 0; i--) {
	                            reversedStr += originalStr[i];
	                        }
	                        return reversedStr;
	                    } else {
	                        var reversedArray = resolvedArgs[0].slice(0);
	                        reversedArray.reverse();
	                        return reversedArray;
	                    }
	                },
	                _functionAbs: function(resolvedArgs) {
	                    return Math.abs(resolvedArgs[0]);
	                },
	                _functionCeil: function(resolvedArgs) {
	                    return Math.ceil(resolvedArgs[0]);
	                },
	                _functionAvg: function(resolvedArgs) {
	                    var sum = 0;
	                    var inputArray = resolvedArgs[0];
	                    for (var i = 0; i < inputArray.length; i++) {
	                        sum += inputArray[i];
	                    }
	                    return sum / inputArray.length;
	                },
	                _functionContains: function(resolvedArgs) {
	                    return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
	                },
	                _functionFloor: function(resolvedArgs) {
	                    return Math.floor(resolvedArgs[0]);
	                },
	                _functionLength: function(resolvedArgs) {
	                    if (!isObject(resolvedArgs[0])) {
	                        return resolvedArgs[0].length;
	                    } else {
	                        return Object.keys(resolvedArgs[0]).length;
	                    }
	                },
	                _functionMap: function(resolvedArgs) {
	                    var mapped = [];
	                    var interpreter = this._interpreter;
	                    var exprefNode = resolvedArgs[0];
	                    var elements = resolvedArgs[1];
	                    for (var i = 0; i < elements.length; i++) {
	                        mapped.push(interpreter.visit(exprefNode, elements[i]));
	                    }
	                    return mapped;
	                },
	                _functionMerge: function(resolvedArgs) {
	                    var merged = {};
	                    for (var i = 0; i < resolvedArgs.length; i++) {
	                        var current = resolvedArgs[i];
	                        for (var key in current) {
	                            merged[key] = current[key];
	                        }
	                    }
	                    return merged;
	                },
	                _functionMax: function(resolvedArgs) {
	                    if (resolvedArgs[0].length > 0) {
	                        var typeName = this._getTypeName(resolvedArgs[0][0]);
	                        if (typeName === TYPE_NUMBER) {
	                            return Math.max.apply(Math, resolvedArgs[0]);
	                        } else {
	                            var elements = resolvedArgs[0];
	                            var maxElement = elements[0];
	                            for (var i = 1; i < elements.length; i++) {
	                                if (maxElement.localeCompare(elements[i]) < 0) {
	                                    maxElement = elements[i];
	                                }
	                            }
	                            return maxElement;
	                        }
	                    } else {
	                        return null;
	                    }
	                },
	                _functionMin: function(resolvedArgs) {
	                    if (resolvedArgs[0].length > 0) {
	                        var typeName = this._getTypeName(resolvedArgs[0][0]);
	                        if (typeName === TYPE_NUMBER) {
	                            return Math.min.apply(Math, resolvedArgs[0]);
	                        } else {
	                            var elements = resolvedArgs[0];
	                            var minElement = elements[0];
	                            for (var i = 1; i < elements.length; i++) {
	                                if (elements[i].localeCompare(minElement) < 0) {
	                                    minElement = elements[i];
	                                }
	                            }
	                            return minElement;
	                        }
	                    } else {
	                        return null;
	                    }
	                },
	                _functionSum: function(resolvedArgs) {
	                    var sum = 0;
	                    var listToSum = resolvedArgs[0];
	                    for (var i = 0; i < listToSum.length; i++) {
	                        sum += listToSum[i];
	                    }
	                    return sum;
	                },
	                _functionType: function(resolvedArgs) {
	                    switch (this._getTypeName(resolvedArgs[0])) {
	                      case TYPE_NUMBER:
	                        return "number";
	
	                      case TYPE_STRING:
	                        return "string";
	
	                      case TYPE_ARRAY:
	                        return "array";
	
	                      case TYPE_OBJECT:
	                        return "object";
	
	                      case TYPE_BOOLEAN:
	                        return "boolean";
	
	                      case TYPE_EXPREF:
	                        return "expref";
	
	                      case TYPE_NULL:
	                        return "null";
	                    }
	                },
	                _functionKeys: function(resolvedArgs) {
	                    return Object.keys(resolvedArgs[0]);
	                },
	                _functionValues: function(resolvedArgs) {
	                    var obj = resolvedArgs[0];
	                    var keys = Object.keys(obj);
	                    var values = [];
	                    for (var i = 0; i < keys.length; i++) {
	                        values.push(obj[keys[i]]);
	                    }
	                    return values;
	                },
	                _functionJoin: function(resolvedArgs) {
	                    var joinChar = resolvedArgs[0];
	                    var listJoin = resolvedArgs[1];
	                    return listJoin.join(joinChar);
	                },
	                _functionToArray: function(resolvedArgs) {
	                    if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
	                        return resolvedArgs[0];
	                    } else {
	                        return [ resolvedArgs[0] ];
	                    }
	                },
	                _functionToString: function(resolvedArgs) {
	                    if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
	                        return resolvedArgs[0];
	                    } else {
	                        return JSON.stringify(resolvedArgs[0]);
	                    }
	                },
	                _functionToNumber: function(resolvedArgs) {
	                    var typeName = this._getTypeName(resolvedArgs[0]);
	                    var convertedValue;
	                    if (typeName === TYPE_NUMBER) {
	                        return resolvedArgs[0];
	                    } else if (typeName === TYPE_STRING) {
	                        convertedValue = +resolvedArgs[0];
	                        if (!isNaN(convertedValue)) {
	                            return convertedValue;
	                        }
	                    }
	                    return null;
	                },
	                _functionNotNull: function(resolvedArgs) {
	                    for (var i = 0; i < resolvedArgs.length; i++) {
	                        if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
	                            return resolvedArgs[i];
	                        }
	                    }
	                    return null;
	                },
	                _functionSort: function(resolvedArgs) {
	                    var sortedArray = resolvedArgs[0].slice(0);
	                    sortedArray.sort();
	                    return sortedArray;
	                },
	                _functionSortBy: function(resolvedArgs) {
	                    var sortedArray = resolvedArgs[0].slice(0);
	                    if (sortedArray.length === 0) {
	                        return sortedArray;
	                    }
	                    var interpreter = this._interpreter;
	                    var exprefNode = resolvedArgs[1];
	                    var requiredType = this._getTypeName(interpreter.visit(exprefNode, sortedArray[0]));
	                    if ([ TYPE_NUMBER, TYPE_STRING ].indexOf(requiredType) < 0) {
	                        throw new Error("TypeError");
	                    }
	                    var that = this;
	                    var decorated = [];
	                    for (var i = 0; i < sortedArray.length; i++) {
	                        decorated.push([ i, sortedArray[i] ]);
	                    }
	                    decorated.sort(function(a, b) {
	                        var exprA = interpreter.visit(exprefNode, a[1]);
	                        var exprB = interpreter.visit(exprefNode, b[1]);
	                        if (that._getTypeName(exprA) !== requiredType) {
	                            throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprA));
	                        } else if (that._getTypeName(exprB) !== requiredType) {
	                            throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprB));
	                        }
	                        if (exprA > exprB) {
	                            return 1;
	                        } else if (exprA < exprB) {
	                            return -1;
	                        } else {
	                            return a[0] - b[0];
	                        }
	                    });
	                    for (var j = 0; j < decorated.length; j++) {
	                        sortedArray[j] = decorated[j][1];
	                    }
	                    return sortedArray;
	                },
	                _functionMaxBy: function(resolvedArgs) {
	                    var exprefNode = resolvedArgs[1];
	                    var resolvedArray = resolvedArgs[0];
	                    var keyFunction = this.createKeyFunction(exprefNode, [ TYPE_NUMBER, TYPE_STRING ]);
	                    var maxNumber = -Infinity;
	                    var maxRecord;
	                    var current;
	                    for (var i = 0; i < resolvedArray.length; i++) {
	                        current = keyFunction(resolvedArray[i]);
	                        if (current > maxNumber) {
	                            maxNumber = current;
	                            maxRecord = resolvedArray[i];
	                        }
	                    }
	                    return maxRecord;
	                },
	                _functionMinBy: function(resolvedArgs) {
	                    var exprefNode = resolvedArgs[1];
	                    var resolvedArray = resolvedArgs[0];
	                    var keyFunction = this.createKeyFunction(exprefNode, [ TYPE_NUMBER, TYPE_STRING ]);
	                    var minNumber = Infinity;
	                    var minRecord;
	                    var current;
	                    for (var i = 0; i < resolvedArray.length; i++) {
	                        current = keyFunction(resolvedArray[i]);
	                        if (current < minNumber) {
	                            minNumber = current;
	                            minRecord = resolvedArray[i];
	                        }
	                    }
	                    return minRecord;
	                },
	                createKeyFunction: function(exprefNode, allowedTypes) {
	                    var that = this;
	                    var interpreter = this._interpreter;
	                    var keyFunc = function(x) {
	                        var current = interpreter.visit(exprefNode, x);
	                        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
	                            var msg = "TypeError: expected one of " + allowedTypes + ", received " + that._getTypeName(current);
	                            throw new Error(msg);
	                        }
	                        return current;
	                    };
	                    return keyFunc;
	                }
	            };
	            function compile(stream) {
	                var parser = new Parser();
	                var ast = parser.parse(stream);
	                return ast;
	            }
	            function tokenize(stream) {
	                var lexer = new Lexer();
	                return lexer.tokenize(stream);
	            }
	            function search(data, expression) {
	                var parser = new Parser();
	                var runtime = new Runtime();
	                var interpreter = new TreeInterpreter(runtime);
	                runtime._interpreter = interpreter;
	                var node = parser.parse(expression);
	                return interpreter.search(node, data);
	            }
	            exports.tokenize = tokenize;
	            exports.compile = compile;
	            exports.search = search;
	            exports.strictDeepEqual = strictDeepEqual;
	        })(typeof exports === "undefined" ? this.jmespath = {} : exports);
	    }, {} ],
	    83: [ function(require, module, exports) {
	        function AcceptorStateMachine(states, state) {
	            this.currentState = state || null;
	            this.states = states || {};
	        }
	        AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
	            if (typeof finalState === "function") {
	                inputError = bindObject;
	                bindObject = done;
	                done = finalState;
	                finalState = null;
	            }
	            var self = this;
	            var state = self.states[self.currentState];
	            state.fn.call(bindObject || self, inputError, function(err) {
	                if (err) {
	                    if (state.fail) self.currentState = state.fail; else return done ? done.call(bindObject, err) : null;
	                } else {
	                    if (state.accept) self.currentState = state.accept; else return done ? done.call(bindObject) : null;
	                }
	                if (self.currentState === finalState) {
	                    return done ? done.call(bindObject, err) : null;
	                }
	                self.runTo(finalState, done, bindObject, err);
	            });
	        };
	        AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
	            if (typeof acceptState === "function") {
	                fn = acceptState;
	                acceptState = null;
	                failState = null;
	            } else if (typeof failState === "function") {
	                fn = failState;
	                failState = null;
	            }
	            if (!this.currentState) this.currentState = name;
	            this.states[name] = {
	                accept: acceptState,
	                fail: failState,
	                fn: fn
	            };
	            return this;
	        };
	        module.exports = AcceptorStateMachine;
	    }, {} ],
	    47: [ function(require, module, exports) {
	        var AWS = require("./core");
	        AWS.ParamValidator = AWS.util.inherit({
	            constructor: function ParamValidator(validation) {
	                if (validation === true || validation === undefined) {
	                    validation = {
	                        min: true
	                    };
	                }
	                this.validation = validation;
	            },
	            validate: function validate(shape, params, context) {
	                this.errors = [];
	                this.validateMember(shape, params || {}, context || "params");
	                if (this.errors.length > 1) {
	                    var msg = this.errors.join("\n* ");
	                    msg = "There were " + this.errors.length + " validation errors:\n* " + msg;
	                    throw AWS.util.error(new Error(msg), {
	                        code: "MultipleValidationErrors",
	                        errors: this.errors
	                    });
	                } else if (this.errors.length === 1) {
	                    throw this.errors[0];
	                } else {
	                    return true;
	                }
	            },
	            fail: function fail(code, message) {
	                this.errors.push(AWS.util.error(new Error(message), {
	                    code: code
	                }));
	            },
	            validateStructure: function validateStructure(shape, params, context) {
	                this.validateType(params, context, [ "object" ], "structure");
	                var paramName;
	                for (var i = 0; shape.required && i < shape.required.length; i++) {
	                    paramName = shape.required[i];
	                    var value = params[paramName];
	                    if (value === undefined || value === null) {
	                        this.fail("MissingRequiredParameter", "Missing required key '" + paramName + "' in " + context);
	                    }
	                }
	                for (paramName in params) {
	                    if (!params.hasOwnProperty(paramName)) continue;
	                    var paramValue = params[paramName], memberShape = shape.members[paramName];
	                    if (memberShape !== undefined) {
	                        var memberContext = [ context, paramName ].join(".");
	                        this.validateMember(memberShape, paramValue, memberContext);
	                    } else {
	                        this.fail("UnexpectedParameter", "Unexpected key '" + paramName + "' found in " + context);
	                    }
	                }
	                return true;
	            },
	            validateMember: function validateMember(shape, param, context) {
	                switch (shape.type) {
	                  case "structure":
	                    return this.validateStructure(shape, param, context);
	
	                  case "list":
	                    return this.validateList(shape, param, context);
	
	                  case "map":
	                    return this.validateMap(shape, param, context);
	
	                  default:
	                    return this.validateScalar(shape, param, context);
	                }
	            },
	            validateList: function validateList(shape, params, context) {
	                if (this.validateType(params, context, [ Array ])) {
	                    this.validateRange(shape, params.length, context, "list member count");
	                    for (var i = 0; i < params.length; i++) {
	                        this.validateMember(shape.member, params[i], context + "[" + i + "]");
	                    }
	                }
	            },
	            validateMap: function validateMap(shape, params, context) {
	                if (this.validateType(params, context, [ "object" ], "map")) {
	                    var mapCount = 0;
	                    for (var param in params) {
	                        if (!params.hasOwnProperty(param)) continue;
	                        this.validateMember(shape.key, param, context + "[key='" + param + "']");
	                        this.validateMember(shape.value, params[param], context + "['" + param + "']");
	                        mapCount++;
	                    }
	                    this.validateRange(shape, mapCount, context, "map member count");
	                }
	            },
	            validateScalar: function validateScalar(shape, value, context) {
	                switch (shape.type) {
	                  case null:
	                  case undefined:
	                  case "string":
	                    return this.validateString(shape, value, context);
	
	                  case "base64":
	                  case "binary":
	                    return this.validatePayload(value, context);
	
	                  case "integer":
	                  case "float":
	                    return this.validateNumber(shape, value, context);
	
	                  case "boolean":
	                    return this.validateType(value, context, [ "boolean" ]);
	
	                  case "timestamp":
	                    return this.validateType(value, context, [ Date, /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, "number" ], "Date object, ISO-8601 string, or a UNIX timestamp");
	
	                  default:
	                    return this.fail("UnkownType", "Unhandled type " + shape.type + " for " + context);
	                }
	            },
	            validateString: function validateString(shape, value, context) {
	                if (this.validateType(value, context, [ "string" ])) {
	                    this.validateEnum(shape, value, context);
	                    this.validateRange(shape, value.length, context, "string length");
	                    this.validatePattern(shape, value, context);
	                }
	            },
	            validatePattern: function validatePattern(shape, value, context) {
	                if (this.validation["pattern"] && shape["pattern"] !== undefined) {
	                    if (!new RegExp(shape["pattern"]).test(value)) {
	                        this.fail("PatternMatchError", 'Provided value "' + value + '" ' + "does not match regex pattern /" + shape["pattern"] + "/ for " + context);
	                    }
	                }
	            },
	            validateRange: function validateRange(shape, value, context, descriptor) {
	                if (this.validation["min"]) {
	                    if (shape["min"] !== undefined && value < shape["min"]) {
	                        this.fail("MinRangeError", "Expected " + descriptor + " >= " + shape["min"] + ", but found " + value + " for " + context);
	                    }
	                }
	                if (this.validation["max"]) {
	                    if (shape["max"] !== undefined && value > shape["max"]) {
	                        this.fail("MaxRangeError", "Expected " + descriptor + " <= " + shape["max"] + ", but found " + value + " for " + context);
	                    }
	                }
	            },
	            validateEnum: function validateRange(shape, value, context) {
	                if (this.validation["enum"] && shape["enum"] !== undefined) {
	                    if (shape["enum"].indexOf(value) === -1) {
	                        this.fail("EnumError", "Found string value of " + value + ", but " + "expected " + shape["enum"].join("|") + " for " + context);
	                    }
	                }
	            },
	            validateType: function validateType(value, context, acceptedTypes, type) {
	                if (value === null || value === undefined) return false;
	                var foundInvalidType = false;
	                for (var i = 0; i < acceptedTypes.length; i++) {
	                    if (typeof acceptedTypes[i] === "string") {
	                        if (typeof value === acceptedTypes[i]) return true;
	                    } else if (acceptedTypes[i] instanceof RegExp) {
	                        if ((value || "").toString().match(acceptedTypes[i])) return true;
	                    } else {
	                        if (value instanceof acceptedTypes[i]) return true;
	                        if (AWS.util.isType(value, acceptedTypes[i])) return true;
	                        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
	                        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
	                    }
	                    foundInvalidType = true;
	                }
	                var acceptedType = type;
	                if (!acceptedType) {
	                    acceptedType = acceptedTypes.join(", ").replace(/,([^,]+)$/, ", or$1");
	                }
	                var vowel = acceptedType.match(/^[aeiou]/i) ? "n" : "";
	                this.fail("InvalidParameterType", "Expected " + context + " to be a" + vowel + " " + acceptedType);
	                return false;
	            },
	            validateNumber: function validateNumber(shape, value, context) {
	                if (value === null || value === undefined) return;
	                if (typeof value === "string") {
	                    var castedValue = parseFloat(value);
	                    if (castedValue.toString() === value) value = castedValue;
	                }
	                if (this.validateType(value, context, [ "number" ])) {
	                    this.validateRange(shape, value, context, "numeric value");
	                }
	            },
	            validatePayload: function validatePayload(value, context) {
	                if (value === null || value === undefined) return;
	                if (typeof value === "string") return;
	                if (value && typeof value.byteLength === "number") return;
	                if (AWS.util.isNode()) {
	                    var Stream = AWS.util.nodeRequire("stream").Stream;
	                    if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
	                }
	                var types = [ "Buffer", "Stream", "File", "Blob", "ArrayBuffer", "DataView" ];
	                if (value) {
	                    for (var i = 0; i < types.length; i++) {
	                        if (AWS.util.isType(value, types[i])) return;
	                        if (AWS.util.typeName(value.constructor) === types[i]) return;
	                    }
	                }
	                this.fail("InvalidParameterType", "Expected " + context + " to be a " + "string, Buffer, Stream, Blob, or typed array object");
	            }
	        });
	    }, {
	        "./core": 24
	    } ],
	    41: [ function(require, module, exports) {
	        var Collection = require("./collection");
	        var Operation = require("./operation");
	        var Shape = require("./shape");
	        var Paginator = require("./paginator");
	        var ResourceWaiter = require("./resource_waiter");
	        var util = require("../util");
	        var property = util.property;
	        var memoizedProperty = util.memoizedProperty;
	        function Api(api, options) {
	            api = api || {};
	            options = options || {};
	            options.api = this;
	            api.metadata = api.metadata || {};
	            property(this, "isApi", true, false);
	            property(this, "apiVersion", api.metadata.apiVersion);
	            property(this, "endpointPrefix", api.metadata.endpointPrefix);
	            property(this, "signingName", api.metadata.signingName);
	            property(this, "globalEndpoint", api.metadata.globalEndpoint);
	            property(this, "signatureVersion", api.metadata.signatureVersion);
	            property(this, "jsonVersion", api.metadata.jsonVersion);
	            property(this, "targetPrefix", api.metadata.targetPrefix);
	            property(this, "protocol", api.metadata.protocol);
	            property(this, "timestampFormat", api.metadata.timestampFormat);
	            property(this, "xmlNamespaceUri", api.metadata.xmlNamespace);
	            property(this, "abbreviation", api.metadata.serviceAbbreviation);
	            property(this, "fullName", api.metadata.serviceFullName);
	            memoizedProperty(this, "className", function() {
	                var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
	                if (!name) return null;
	                name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, "");
	                if (name === "ElasticLoadBalancing") name = "ELB";
	                return name;
	            });
	            property(this, "operations", new Collection(api.operations, options, function(name, operation) {
	                return new Operation(name, operation, options);
	            }, util.string.lowerFirst));
	            property(this, "shapes", new Collection(api.shapes, options, function(name, shape) {
	                return Shape.create(shape, options);
	            }));
	            property(this, "paginators", new Collection(api.paginators, options, function(name, paginator) {
	                return new Paginator(name, paginator, options);
	            }));
	            property(this, "waiters", new Collection(api.waiters, options, function(name, waiter) {
	                return new ResourceWaiter(name, waiter, options);
	            }, util.string.lowerFirst));
	            if (options.documentation) {
	                property(this, "documentation", api.documentation);
	                property(this, "documentationUrl", api.documentationUrl);
	            }
	        }
	        module.exports = Api;
	    }, {
	        "../util": 84,
	        "./collection": 42,
	        "./operation": 43,
	        "./paginator": 44,
	        "./resource_waiter": 45,
	        "./shape": 46
	    } ],
	    45: [ function(require, module, exports) {
	        var util = require("../util");
	        var property = util.property;
	        function ResourceWaiter(name, waiter, options) {
	            options = options || {};
	            property(this, "name", name);
	            property(this, "api", options.api, false);
	            if (waiter.operation) {
	                property(this, "operation", util.string.lowerFirst(waiter.operation));
	            }
	            var self = this;
	            var keys = [ "type", "description", "delay", "maxAttempts", "acceptors" ];
	            keys.forEach(function(key) {
	                var value = waiter[key];
	                if (value) {
	                    property(self, key, value);
	                }
	            });
	        }
	        module.exports = ResourceWaiter;
	    }, {
	        "../util": 84
	    } ],
	    44: [ function(require, module, exports) {
	        var property = require("../util").property;
	        function Paginator(name, paginator) {
	            property(this, "inputToken", paginator.input_token);
	            property(this, "limitKey", paginator.limit_key);
	            property(this, "moreResults", paginator.more_results);
	            property(this, "outputToken", paginator.output_token);
	            property(this, "resultKey", paginator.result_key);
	        }
	        module.exports = Paginator;
	    }, {
	        "../util": 84
	    } ],
	    43: [ function(require, module, exports) {
	        var Shape = require("./shape");
	        var util = require("../util");
	        var property = util.property;
	        var memoizedProperty = util.memoizedProperty;
	        function Operation(name, operation, options) {
	            options = options || {};
	            property(this, "name", operation.name || name);
	            property(this, "api", options.api, false);
	            operation.http = operation.http || {};
	            property(this, "httpMethod", operation.http.method || "POST");
	            property(this, "httpPath", operation.http.requestUri || "/");
	            property(this, "authtype", operation.authtype || "");
	            memoizedProperty(this, "input", function() {
	                if (!operation.input) {
	                    return new Shape.create({
	                        type: "structure"
	                    }, options);
	                }
	                return Shape.create(operation.input, options);
	            });
	            memoizedProperty(this, "output", function() {
	                if (!operation.output) {
	                    return new Shape.create({
	                        type: "structure"
	                    }, options);
	                }
	                return Shape.create(operation.output, options);
	            });
	            memoizedProperty(this, "errors", function() {
	                var list = [];
	                if (!operation.errors) return null;
	                for (var i = 0; i < operation.errors.length; i++) {
	                    list.push(Shape.create(operation.errors[i], options));
	                }
	                return list;
	            });
	            memoizedProperty(this, "paginator", function() {
	                return options.api.paginators[name];
	            });
	            if (options.documentation) {
	                property(this, "documentation", operation.documentation);
	                property(this, "documentationUrl", operation.documentationUrl);
	            }
	        }
	        module.exports = Operation;
	    }, {
	        "../util": 84,
	        "./shape": 46
	    } ],
	    37: [ function(require, module, exports) {
	        var AWS = require("./core");
	        var inherit = AWS.util.inherit;
	        AWS.Endpoint = inherit({
	            constructor: function Endpoint(endpoint, config) {
	                AWS.util.hideProperties(this, [ "slashes", "auth", "hash", "search", "query" ]);
	                if (typeof endpoint === "undefined" || endpoint === null) {
	                    throw new Error("Invalid endpoint: " + endpoint);
	                } else if (typeof endpoint !== "string") {
	                    return AWS.util.copy(endpoint);
	                }
	                if (!endpoint.match(/^http/)) {
	                    var useSSL = config && config.sslEnabled !== undefined ? config.sslEnabled : AWS.config.sslEnabled;
	                    endpoint = (useSSL ? "https" : "http") + "://" + endpoint;
	                }
	                AWS.util.update(this, AWS.util.urlParse(endpoint));
	                if (this.port) {
	                    this.port = parseInt(this.port, 10);
	                } else {
	                    this.port = this.protocol === "https:" ? 443 : 80;
	                }
	            }
	        });
	        AWS.HttpRequest = inherit({
	            constructor: function HttpRequest(endpoint, region, customUserAgent) {
	                endpoint = new AWS.Endpoint(endpoint);
	                this.method = "POST";
	                this.path = endpoint.path || "/";
	                this.headers = {};
	                this.body = "";
	                this.endpoint = endpoint;
	                this.region = region;
	                this.setUserAgent(customUserAgent);
	            },
	            setUserAgent: function setUserAgent(customUserAgent) {
	                var prefix = AWS.util.isBrowser() ? "X-Amz-" : "";
	                var customSuffix = "";
	                if (typeof customUserAgent === "string" && customUserAgent) {
	                    customSuffix += " " + customUserAgent;
	                }
	                this.headers[prefix + "User-Agent"] = AWS.util.userAgent() + customSuffix;
	            },
	            pathname: function pathname() {
	                return this.path.split("?", 1)[0];
	            },
	            search: function search() {
	                var query = this.path.split("?", 2)[1];
	                if (query) {
	                    query = AWS.util.queryStringParse(query);
	                    return AWS.util.queryParamsToString(query);
	                }
	                return "";
	            }
	        });
	        AWS.HttpResponse = inherit({
	            constructor: function HttpResponse() {
	                this.statusCode = undefined;
	                this.headers = {};
	                this.body = undefined;
	                this.streaming = false;
	                this.stream = null;
	            },
	            createUnbufferedStream: function createUnbufferedStream() {
	                this.streaming = true;
	                return this.stream;
	            }
	        });
	        AWS.HttpClient = inherit({});
	        AWS.HttpClient.getInstance = function getInstance() {
	            if (this.singleton === undefined) {
	                this.singleton = new this();
	            }
	            return this.singleton;
	        };
	    }, {
	        "./core": 24
	    } ],
	    36: [ function(require, module, exports) {
	        var AWS = require("./core");
	        var SequentialExecutor = require("./sequential_executor");
	        AWS.EventListeners = {
	            Core: {}
	        };
	        AWS.EventListeners = {
	            Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
	                addAsync("VALIDATE_CREDENTIALS", "validate", function VALIDATE_CREDENTIALS(req, done) {
	                    if (!req.service.api.signatureVersion) return done();
	                    req.service.config.getCredentials(function(err) {
	                        if (err) {
	                            req.response.error = AWS.util.error(err, {
	                                code: "CredentialsError",
	                                message: "Missing credentials in config"
	                            });
	                        }
	                        done();
	                    });
	                });
	                add("VALIDATE_REGION", "validate", function VALIDATE_REGION(req) {
	                    if (!req.service.config.region && !req.service.isGlobalEndpoint) {
	                        req.response.error = AWS.util.error(new Error(), {
	                            code: "ConfigError",
	                            message: "Missing region in config"
	                        });
	                    }
	                });
	                add("VALIDATE_PARAMETERS", "validate", function VALIDATE_PARAMETERS(req) {
	                    var rules = req.service.api.operations[req.operation].input;
	                    var validation = req.service.config.paramValidation;
	                    new AWS.ParamValidator(validation).validate(rules, req.params);
	                });
	                addAsync("COMPUTE_SHA256", "afterBuild", function COMPUTE_SHA256(req, done) {
	                    req.haltHandlersOnError();
	                    if (!req.service.api.signatureVersion) return done();
	                    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	                        var body = req.httpRequest.body || "";
	                        AWS.util.computeSha256(body, function(err, sha) {
	                            if (err) {
	                                done(err);
	                            } else {
	                                req.httpRequest.headers["X-Amz-Content-Sha256"] = sha;
	                                done();
	                            }
	                        });
	                    } else {
	                        done();
	                    }
	                });
	                add("SET_CONTENT_LENGTH", "afterBuild", function SET_CONTENT_LENGTH(req) {
	                    if (req.httpRequest.headers["Content-Length"] === undefined) {
	                        var length = AWS.util.string.byteLength(req.httpRequest.body);
	                        req.httpRequest.headers["Content-Length"] = length;
	                    }
	                });
	                add("SET_HTTP_HOST", "afterBuild", function SET_HTTP_HOST(req) {
	                    req.httpRequest.headers["Host"] = req.httpRequest.endpoint.host;
	                });
	                add("RESTART", "restart", function RESTART() {
	                    var err = this.response.error;
	                    if (!err || !err.retryable) return;
	                    this.httpRequest = new AWS.HttpRequest(this.service.endpoint, this.service.region);
	                    if (this.response.retryCount < this.service.config.maxRetries) {
	                        this.response.retryCount++;
	                    } else {
	                        this.response.error = null;
	                    }
	                });
	                addAsync("SIGN", "sign", function SIGN(req, done) {
	                    if (!req.service.api.signatureVersion) return done();
	                    req.service.config.getCredentials(function(err, credentials) {
	                        if (err) {
	                            req.response.error = err;
	                            return done();
	                        }
	                        try {
	                            var date = AWS.util.date.getDate();
	                            var SignerClass = req.service.getSignerClass(req);
	                            var signer = new SignerClass(req.httpRequest, req.service.api.signingName || req.service.api.endpointPrefix, req.service.config.signatureCache);
	                            delete req.httpRequest.headers["Authorization"];
	                            delete req.httpRequest.headers["Date"];
	                            delete req.httpRequest.headers["X-Amz-Date"];
	                            signer.addAuthorization(credentials, date);
	                            req.signedAt = date;
	                        } catch (e) {
	                            req.response.error = e;
	                        }
	                        done();
	                    });
	                });
	                add("VALIDATE_RESPONSE", "validateResponse", function VALIDATE_RESPONSE(resp) {
	                    if (this.service.successfulResponse(resp, this)) {
	                        resp.data = {};
	                        resp.error = null;
	                    } else {
	                        resp.data = null;
	                        resp.error = AWS.util.error(new Error(), {
	                            code: "UnknownError",
	                            message: "An unknown error occurred."
	                        });
	                    }
	                });
	                addAsync("SEND", "send", function SEND(resp, done) {
	                    resp.httpResponse._abortCallback = done;
	                    resp.error = null;
	                    resp.data = null;
	                    function callback(httpResp) {
	                        resp.httpResponse.stream = httpResp;
	                        httpResp.on("headers", function onHeaders(statusCode, headers) {
	                            resp.request.emit("httpHeaders", [ statusCode, headers, resp ]);
	                            if (!resp.httpResponse.streaming) {
	                                if (AWS.HttpClient.streamsApiVersion === 2) {
	                                    httpResp.on("readable", function onReadable() {
	                                        var data = httpResp.read();
	                                        if (data !== null) {
	                                            resp.request.emit("httpData", [ data, resp ]);
	                                        }
	                                    });
	                                } else {
	                                    httpResp.on("data", function onData(data) {
	                                        resp.request.emit("httpData", [ data, resp ]);
	                                    });
	                                }
	                            }
	                        });
	                        httpResp.on("end", function onEnd() {
	                            resp.request.emit("httpDone");
	                            done();
	                        });
	                    }
	                    function progress(httpResp) {
	                        httpResp.on("sendProgress", function onSendProgress(value) {
	                            resp.request.emit("httpUploadProgress", [ value, resp ]);
	                        });
	                        httpResp.on("receiveProgress", function onReceiveProgress(value) {
	                            resp.request.emit("httpDownloadProgress", [ value, resp ]);
	                        });
	                    }
	                    function error(err) {
	                        resp.error = AWS.util.error(err, {
	                            code: "NetworkingError",
	                            region: resp.request.httpRequest.region,
	                            hostname: resp.request.httpRequest.endpoint.hostname,
	                            retryable: true
	                        });
	                        resp.request.emit("httpError", [ resp.error, resp ], function() {
	                            done();
	                        });
	                    }
	                    function executeSend() {
	                        var http = AWS.HttpClient.getInstance();
	                        var httpOptions = resp.request.service.config.httpOptions || {};
	                        try {
	                            var stream = http.handleRequest(resp.request.httpRequest, httpOptions, callback, error);
	                            progress(stream);
	                        } catch (err) {
	                            error(err);
	                        }
	                    }
	                    var timeDiff = (AWS.util.date.getDate() - this.signedAt) / 1e3;
	                    if (timeDiff >= 60 * 10) {
	                        this.emit("sign", [ this ], function(err) {
	                            if (err) done(err); else executeSend();
	                        });
	                    } else {
	                        executeSend();
	                    }
	                });
	                add("HTTP_HEADERS", "httpHeaders", function HTTP_HEADERS(statusCode, headers, resp) {
	                    resp.httpResponse.statusCode = statusCode;
	                    resp.httpResponse.headers = headers;
	                    resp.httpResponse.body = new AWS.util.Buffer("");
	                    resp.httpResponse.buffers = [];
	                    resp.httpResponse.numBytes = 0;
	                    var dateHeader = headers.date || headers.Date;
	                    if (dateHeader) {
	                        var serverTime = Date.parse(dateHeader);
	                        if (resp.request.service.config.correctClockSkew && AWS.util.isClockSkewed(serverTime)) {
	                            AWS.util.applyClockOffset(serverTime);
	                        }
	                    }
	                });
	                add("HTTP_DATA", "httpData", function HTTP_DATA(chunk, resp) {
	                    if (chunk) {
	                        if (AWS.util.isNode()) {
	                            resp.httpResponse.numBytes += chunk.length;
	                            var total = resp.httpResponse.headers["content-length"];
	                            var progress = {
	                                loaded: resp.httpResponse.numBytes,
	                                total: total
	                            };
	                            resp.request.emit("httpDownloadProgress", [ progress, resp ]);
	                        }
	                        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
	                    }
	                });
	                add("HTTP_DONE", "httpDone", function HTTP_DONE(resp) {
	                    if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
	                        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
	                        resp.httpResponse.body = body;
	                    }
	                    delete resp.httpResponse.numBytes;
	                    delete resp.httpResponse.buffers;
	                });
	                add("FINALIZE_ERROR", "retry", function FINALIZE_ERROR(resp) {
	                    if (resp.httpResponse.statusCode) {
	                        resp.error.statusCode = resp.httpResponse.statusCode;
	                        if (resp.error.retryable === undefined) {
	                            resp.error.retryable = this.service.retryableError(resp.error, this);
	                        }
	                    }
	                });
	                add("INVALIDATE_CREDENTIALS", "retry", function INVALIDATE_CREDENTIALS(resp) {
	                    if (!resp.error) return;
	                    switch (resp.error.code) {
	                      case "RequestExpired":
	                      case "ExpiredTokenException":
	                      case "ExpiredToken":
	                        resp.error.retryable = true;
	                        resp.request.service.config.credentials.expired = true;
	                    }
	                });
	                add("EXPIRED_SIGNATURE", "retry", function EXPIRED_SIGNATURE(resp) {
	                    var err = resp.error;
	                    if (!err) return;
	                    if (typeof err.code === "string" && typeof err.message === "string") {
	                        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
	                            resp.error.retryable = true;
	                        }
	                    }
	                });
	                add("CLOCK_SKEWED", "retry", function CLOCK_SKEWED(resp) {
	                    if (!resp.error) return;
	                    if (this.service.clockSkewError(resp.error) && this.service.config.correctClockSkew && AWS.config.isClockSkewed) {
	                        resp.error.retryable = true;
	                    }
	                });
	                add("REDIRECT", "retry", function REDIRECT(resp) {
	                    if (resp.error && resp.error.statusCode >= 300 && resp.error.statusCode < 400 && resp.httpResponse.headers["location"]) {
	                        this.httpRequest.endpoint = new AWS.Endpoint(resp.httpResponse.headers["location"]);
	                        this.httpRequest.headers["Host"] = this.httpRequest.endpoint.host;
	                        resp.error.redirect = true;
	                        resp.error.retryable = true;
	                    }
	                });
	                add("RETRY_CHECK", "retry", function RETRY_CHECK(resp) {
	                    if (resp.error) {
	                        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	                            resp.error.retryDelay = 0;
	                        } else if (resp.retryCount < resp.maxRetries) {
	                            resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
	                        }
	                    }
	                });
	                addAsync("RESET_RETRY_STATE", "afterRetry", function RESET_RETRY_STATE(resp, done) {
	                    var delay, willRetry = false;
	                    if (resp.error) {
	                        delay = resp.error.retryDelay || 0;
	                        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
	                            resp.retryCount++;
	                            willRetry = true;
	                        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	                            resp.redirectCount++;
	                            willRetry = true;
	                        }
	                    }
	                    if (willRetry) {
	                        resp.error = null;
	                        setTimeout(done, delay);
	                    } else {
	                        done();
	                    }
	                });
	            }),
	            CorePost: new SequentialExecutor().addNamedListeners(function(add) {
	                add("EXTRACT_REQUEST_ID", "extractData", AWS.util.extractRequestId);
	                add("EXTRACT_REQUEST_ID", "extractError", AWS.util.extractRequestId);
	                add("ENOTFOUND_ERROR", "httpError", function ENOTFOUND_ERROR(err) {
	                    if (err.code === "NetworkingError" && err.errno === "ENOTFOUND") {
	                        var message = "Inaccessible host: `" + err.hostname + "'. This service may not be available in the `" + err.region + "' region.";
	                        this.response.error = AWS.util.error(new Error(message), {
	                            code: "UnknownEndpoint",
	                            region: err.region,
	                            hostname: err.hostname,
	                            retryable: true,
	                            originalError: err
	                        });
	                    }
	                });
	            }),
	            Logger: new SequentialExecutor().addNamedListeners(function(add) {
	                add("LOG_REQUEST", "complete", function LOG_REQUEST(resp) {
	                    var req = resp.request;
	                    var logger = req.service.config.logger;
	                    if (!logger) return;
	                    function buildMessage() {
	                        var time = AWS.util.date.getDate().getTime();
	                        var delta = (time - req.startTime.getTime()) / 1e3;
	                        var ansi = logger.isTTY ? true : false;
	                        var status = resp.httpResponse.statusCode;
	                        var params = require("util").inspect(req.params, true, null);
	                        var message = "";
	                        if (ansi) message += "[33m";
	                        message += "[AWS " + req.service.serviceIdentifier + " " + status;
	                        message += " " + delta.toString() + "s " + resp.retryCount + " retries]";
	                        if (ansi) message += "[0;1m";
	                        message += " " + AWS.util.string.lowerFirst(req.operation);
	                        message += "(" + params + ")";
	                        if (ansi) message += "[0m";
	                        return message;
	                    }
	                    var line = buildMessage();
	                    if (typeof logger.log === "function") {
	                        logger.log(line);
	                    } else if (typeof logger.write === "function") {
	                        logger.write(line + "\n");
	                    }
	                });
	            }),
	            Json: new SequentialExecutor().addNamedListeners(function(add) {
	                var svc = require("./protocol/json");
	                add("BUILD", "build", svc.buildRequest);
	                add("EXTRACT_DATA", "extractData", svc.extractData);
	                add("EXTRACT_ERROR", "extractError", svc.extractError);
	            }),
	            Rest: new SequentialExecutor().addNamedListeners(function(add) {
	                var svc = require("./protocol/rest");
	                add("BUILD", "build", svc.buildRequest);
	                add("EXTRACT_DATA", "extractData", svc.extractData);
	                add("EXTRACT_ERROR", "extractError", svc.extractError);
	            }),
	            RestJson: new SequentialExecutor().addNamedListeners(function(add) {
	                var svc = require("./protocol/rest_json");
	                add("BUILD", "build", svc.buildRequest);
	                add("EXTRACT_DATA", "extractData", svc.extractData);
	                add("EXTRACT_ERROR", "extractError", svc.extractError);
	            }),
	            RestXml: new SequentialExecutor().addNamedListeners(function(add) {
	                var svc = require("./protocol/rest_xml");
	                add("BUILD", "build", svc.buildRequest);
	                add("EXTRACT_DATA", "extractData", svc.extractData);
	                add("EXTRACT_ERROR", "extractError", svc.extractError);
	            }),
	            Query: new SequentialExecutor().addNamedListeners(function(add) {
	                var svc = require("./protocol/query");
	                add("BUILD", "build", svc.buildRequest);
	                add("EXTRACT_DATA", "extractData", svc.extractData);
	                add("EXTRACT_ERROR", "extractError", svc.extractError);
	            })
	        };
	    }, {
	        "./core": 24,
	        "./protocol/json": 48,
	        "./protocol/query": 49,
	        "./protocol/rest": 50,
	        "./protocol/rest_json": 51,
	        "./protocol/rest_xml": 52,
	        "./sequential_executor": 60,
	        util: 20
	    } ],
	    60: [ function(require, module, exports) {
	        var AWS = require("./core");
	        AWS.SequentialExecutor = AWS.util.inherit({
	            constructor: function SequentialExecutor() {
	                this._events = {};
	            },
	            listeners: function listeners(eventName) {
	                return this._events[eventName] ? this._events[eventName].slice(0) : [];
	            },
	            on: function on(eventName, listener) {
	                if (this._events[eventName]) {
	                    this._events[eventName].push(listener);
	                } else {
	                    this._events[eventName] = [ listener ];
	                }
	                return this;
	            },
	            onAsync: function onAsync(eventName, listener) {
	                listener._isAsync = true;
	                return this.on(eventName, listener);
	            },
	            removeListener: function removeListener(eventName, listener) {
	                var listeners = this._events[eventName];
	                if (listeners) {
	                    var length = listeners.length;
	                    var position = -1;
	                    for (var i = 0; i < length; ++i) {
	                        if (listeners[i] === listener) {
	                            position = i;
	                        }
	                    }
	                    if (position > -1) {
	                        listeners.splice(position, 1);
	                    }
	                }
	                return this;
	            },
	            removeAllListeners: function removeAllListeners(eventName) {
	                if (eventName) {
	                    delete this._events[eventName];
	                } else {
	                    this._events = {};
	                }
	                return this;
	            },
	            emit: function emit(eventName, eventArgs, doneCallback) {
	                if (!doneCallback) doneCallback = function() {};
	                var listeners = this.listeners(eventName);
	                var count = listeners.length;
	                this.callListeners(listeners, eventArgs, doneCallback);
	                return count > 0;
	            },
	            callListeners: function callListeners(listeners, args, doneCallback, prevError) {
	                var self = this;
	                var error = prevError || null;
	                function callNextListener(err) {
	                    if (err) {
	                        error = AWS.util.error(error || new Error(), err);
	                        if (self._haltHandlersOnError) {
	                            return doneCallback.call(self, error);
	                        }
	                    }
	                    self.callListeners(listeners, args, doneCallback, error);
	                }
	                while (listeners.length > 0) {
	                    var listener = listeners.shift();
	                    if (listener._isAsync) {
	                        listener.apply(self, args.concat([ callNextListener ]));
	                        return;
	                    } else {
	                        try {
	                            listener.apply(self, args);
	                        } catch (err) {
	                            error = AWS.util.error(error || new Error(), err);
	                        }
	                        if (error && self._haltHandlersOnError) {
	                            doneCallback.call(self, error);
	                            return;
	                        }
	                    }
	                }
	                doneCallback.call(self, error);
	            },
	            addListeners: function addListeners(listeners) {
	                var self = this;
	                if (listeners._events) listeners = listeners._events;
	                AWS.util.each(listeners, function(event, callbacks) {
	                    if (typeof callbacks === "function") callbacks = [ callbacks ];
	                    AWS.util.arrayEach(callbacks, function(callback) {
	                        self.on(event, callback);
	                    });
	                });
	                return self;
	            },
	            addNamedListener: function addNamedListener(name, eventName, callback) {
	                this[name] = callback;
	                this.addListener(eventName, callback);
	                return this;
	            },
	            addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
	                callback._isAsync = true;
	                return this.addNamedListener(name, eventName, callback);
	            },
	            addNamedListeners: function addNamedListeners(callback) {
	                var self = this;
	                callback(function() {
	                    self.addNamedListener.apply(self, arguments);
	                }, function() {
	                    self.addNamedAsyncListener.apply(self, arguments);
	                });
	                return this;
	            }
	        });
	        AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;
	        module.exports = AWS.SequentialExecutor;
	    }, {
	        "./core": 24
	    } ],
	    52: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var util = require("../util");
	        var Rest = require("./rest");
	        function populateBody(req) {
	            var input = req.service.api.operations[req.operation].input;
	            var builder = new AWS.XML.Builder();
	            var params = req.params;
	            var payload = input.payload;
	            if (payload) {
	                var payloadMember = input.members[payload];
	                params = params[payload];
	                if (params === undefined) return;
	                if (payloadMember.type === "structure") {
	                    var rootElement = payloadMember.name;
	                    req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
	                } else {
	                    req.httpRequest.body = params;
	                }
	            } else {
	                req.httpRequest.body = builder.toXML(params, input, input.name || input.shape || util.string.upperFirst(req.operation) + "Request");
	            }
	        }
	        function buildRequest(req) {
	            Rest.buildRequest(req);
	            if ([ "GET", "HEAD" ].indexOf(req.httpRequest.method) < 0) {
	                populateBody(req);
	            }
	        }
	        function extractError(resp) {
	            Rest.extractError(resp);
	            var data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
	            if (data.Errors) data = data.Errors;
	            if (data.Error) data = data.Error;
	            if (data.Code) {
	                resp.error = util.error(new Error(), {
	                    code: data.Code,
	                    message: data.Message
	                });
	            } else {
	                resp.error = util.error(new Error(), {
	                    code: resp.httpResponse.statusCode,
	                    message: null
	                });
	            }
	        }
	        function extractData(resp) {
	            Rest.extractData(resp);
	            var parser;
	            var req = resp.request;
	            var body = resp.httpResponse.body;
	            var operation = req.service.api.operations[req.operation];
	            var output = operation.output;
	            var payload = output.payload;
	            if (payload) {
	                var payloadMember = output.members[payload];
	                if (payloadMember.isStreaming) {
	                    resp.data[payload] = body;
	                } else if (payloadMember.type === "structure") {
	                    parser = new AWS.XML.Parser();
	                    resp.data[payload] = parser.parse(body.toString(), payloadMember);
	                } else {
	                    resp.data[payload] = body.toString();
	                }
	            } else if (body.length > 0) {
	                parser = new AWS.XML.Parser();
	                var data = parser.parse(body.toString(), output);
	                util.update(resp.data, data);
	            }
	        }
	        module.exports = {
	            buildRequest: buildRequest,
	            extractError: extractError,
	            extractData: extractData
	        };
	    }, {
	        "../core": 24,
	        "../util": 84,
	        "./rest": 50
	    } ],
	    51: [ function(require, module, exports) {
	        var util = require("../util");
	        var Rest = require("./rest");
	        var Json = require("./json");
	        var JsonBuilder = require("../json/builder");
	        var JsonParser = require("../json/parser");
	        function populateBody(req) {
	            var builder = new JsonBuilder();
	            var input = req.service.api.operations[req.operation].input;
	            if (input.payload) {
	                var params = {};
	                var payloadShape = input.members[input.payload];
	                params = req.params[input.payload];
	                if (params === undefined) return;
	                if (payloadShape.type === "structure") {
	                    req.httpRequest.body = builder.build(params, payloadShape);
	                } else {
	                    req.httpRequest.body = params;
	                }
	            } else {
	                req.httpRequest.body = builder.build(req.params, input);
	            }
	        }
	        function buildRequest(req) {
	            Rest.buildRequest(req);
	            if ([ "GET", "HEAD", "DELETE" ].indexOf(req.httpRequest.method) < 0) {
	                populateBody(req);
	            }
	        }
	        function extractError(resp) {
	            Json.extractError(resp);
	        }
	        function extractData(resp) {
	            Rest.extractData(resp);
	            var req = resp.request;
	            var rules = req.service.api.operations[req.operation].output || {};
	            if (rules.payload) {
	                var payloadMember = rules.members[rules.payload];
	                var body = resp.httpResponse.body;
	                if (payloadMember.isStreaming) {
	                    resp.data[rules.payload] = body;
	                } else if (payloadMember.type === "structure" || payloadMember.type === "list") {
	                    var parser = new JsonParser();
	                    resp.data[rules.payload] = parser.parse(body, payloadMember);
	                } else {
	                    resp.data[rules.payload] = body.toString();
	                }
	            } else {
	                var data = resp.data;
	                Json.extractData(resp);
	                resp.data = util.merge(data, resp.data);
	            }
	        }
	        module.exports = {
	            buildRequest: buildRequest,
	            extractError: extractError,
	            extractData: extractData
	        };
	    }, {
	        "../json/builder": 39,
	        "../json/parser": 40,
	        "../util": 84,
	        "./json": 48,
	        "./rest": 50
	    } ],
	    50: [ function(require, module, exports) {
	        var util = require("../util");
	        function populateMethod(req) {
	            req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
	        }
	        function populateURI(req) {
	            var operation = req.service.api.operations[req.operation];
	            var input = operation.input;
	            var uri = [ req.httpRequest.endpoint.path, operation.httpPath ].join("/");
	            uri = uri.replace(/\/+/g, "/");
	            var queryString = {}, queryStringSet = false;
	            util.each(input.members, function(name, member) {
	                var paramValue = req.params[name];
	                if (paramValue === null || paramValue === undefined) return;
	                if (member.location === "uri") {
	                    var regex = new RegExp("\\{" + member.name + "(\\+)?\\}");
	                    uri = uri.replace(regex, function(_, plus) {
	                        var fn = plus ? util.uriEscapePath : util.uriEscape;
	                        return fn(String(paramValue));
	                    });
	                } else if (member.location === "querystring") {
	                    queryStringSet = true;
	                    if (member.type === "list") {
	                        queryString[member.name] = paramValue.map(function(val) {
	                            return util.uriEscape(String(val));
	                        });
	                    } else if (member.type === "map") {
	                        util.each(paramValue, function(key, value) {
	                            if (Array.isArray(value)) {
	                                queryString[key] = value.map(function(val) {
	                                    return util.uriEscape(String(val));
	                                });
	                            } else {
	                                queryString[key] = util.uriEscape(String(value));
	                            }
	                        });
	                    } else {
	                        queryString[member.name] = util.uriEscape(String(paramValue));
	                    }
	                }
	            });
	            if (queryStringSet) {
	                uri += uri.indexOf("?") >= 0 ? "&" : "?";
	                var parts = [];
	                util.arrayEach(Object.keys(queryString).sort(), function(key) {
	                    if (!Array.isArray(queryString[key])) {
	                        queryString[key] = [ queryString[key] ];
	                    }
	                    for (var i = 0; i < queryString[key].length; i++) {
	                        parts.push(util.uriEscape(String(key)) + "=" + queryString[key][i]);
	                    }
	                });
	                uri += parts.join("&");
	            }
	            req.httpRequest.path = uri;
	        }
	        function populateHeaders(req) {
	            var operation = req.service.api.operations[req.operation];
	            util.each(operation.input.members, function(name, member) {
	                var value = req.params[name];
	                if (value === null || value === undefined) return;
	                if (member.location === "headers" && member.type === "map") {
	                    util.each(value, function(key, memberValue) {
	                        req.httpRequest.headers[member.name + key] = memberValue;
	                    });
	                } else if (member.location === "header") {
	                    value = member.toWireFormat(value).toString();
	                    req.httpRequest.headers[member.name] = value;
	                }
	            });
	        }
	        function buildRequest(req) {
	            populateMethod(req);
	            populateURI(req);
	            populateHeaders(req);
	        }
	        function extractError() {}
	        function extractData(resp) {
	            var req = resp.request;
	            var data = {};
	            var r = resp.httpResponse;
	            var operation = req.service.api.operations[req.operation];
	            var output = operation.output;
	            var headers = {};
	            util.each(r.headers, function(k, v) {
	                headers[k.toLowerCase()] = v;
	            });
	            util.each(output.members, function(name, member) {
	                var header = (member.name || name).toLowerCase();
	                if (member.location === "headers" && member.type === "map") {
	                    data[name] = {};
	                    var location = member.isLocationName ? member.name : "";
	                    var pattern = new RegExp("^" + location + "(.+)", "i");
	                    util.each(r.headers, function(k, v) {
	                        var result = k.match(pattern);
	                        if (result !== null) {
	                            data[name][result[1]] = v;
	                        }
	                    });
	                } else if (member.location === "header") {
	                    if (headers[header] !== undefined) {
	                        data[name] = headers[header];
	                    }
	                } else if (member.location === "statusCode") {
	                    data[name] = parseInt(r.statusCode, 10);
	                }
	            });
	            resp.data = data;
	        }
	        module.exports = {
	            buildRequest: buildRequest,
	            extractError: extractError,
	            extractData: extractData
	        };
	    }, {
	        "../util": 84
	    } ],
	    49: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var util = require("../util");
	        var QueryParamSerializer = require("../query/query_param_serializer");
	        var Shape = require("../model/shape");
	        function buildRequest(req) {
	            var operation = req.service.api.operations[req.operation];
	            var httpRequest = req.httpRequest;
	            httpRequest.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8";
	            httpRequest.params = {
	                Version: req.service.api.apiVersion,
	                Action: operation.name
	            };
	            var builder = new QueryParamSerializer();
	            builder.serialize(req.params, operation.input, function(name, value) {
	                httpRequest.params[name] = value;
	            });
	            httpRequest.body = util.queryParamsToString(httpRequest.params);
	        }
	        function extractError(resp) {
	            var data, body = resp.httpResponse.body.toString();
	            if (body.match("<UnknownOperationException")) {
	                data = {
	                    Code: "UnknownOperation",
	                    Message: "Unknown operation " + resp.request.operation
	                };
	            } else {
	                data = new AWS.XML.Parser().parse(body);
	            }
	            if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
	            if (data.Errors) data = data.Errors;
	            if (data.Error) data = data.Error;
	            if (data.Code) {
	                resp.error = util.error(new Error(), {
	                    code: data.Code,
	                    message: data.Message
	                });
	            } else {
	                resp.error = util.error(new Error(), {
	                    code: resp.httpResponse.statusCode,
	                    message: null
	                });
	            }
	        }
	        function extractData(resp) {
	            var req = resp.request;
	            var operation = req.service.api.operations[req.operation];
	            var shape = operation.output || {};
	            var origRules = shape;
	            if (origRules.resultWrapper) {
	                var tmp = Shape.create({
	                    type: "structure"
	                });
	                tmp.members[origRules.resultWrapper] = shape;
	                tmp.memberNames = [ origRules.resultWrapper ];
	                util.property(shape, "name", shape.resultWrapper);
	                shape = tmp;
	            }
	            var parser = new AWS.XML.Parser();
	            if (shape && shape.members && !shape.members._XAMZRequestId) {
	                var requestIdShape = Shape.create({
	                    type: "string"
	                }, {
	                    api: {
	                        protocol: "query"
	                    }
	                }, "requestId");
	                shape.members._XAMZRequestId = requestIdShape;
	            }
	            var data = parser.parse(resp.httpResponse.body.toString(), shape);
	            resp.requestId = data._XAMZRequestId || data.requestId;
	            if (data._XAMZRequestId) delete data._XAMZRequestId;
	            if (origRules.resultWrapper) {
	                if (data[origRules.resultWrapper]) {
	                    util.update(data, data[origRules.resultWrapper]);
	                    delete data[origRules.resultWrapper];
	                }
	            }
	            resp.data = data;
	        }
	        module.exports = {
	            buildRequest: buildRequest,
	            extractError: extractError,
	            extractData: extractData
	        };
	    }, {
	        "../core": 24,
	        "../model/shape": 46,
	        "../query/query_param_serializer": 53,
	        "../util": 84
	    } ],
	    53: [ function(require, module, exports) {
	        var util = require("../util");
	        function QueryParamSerializer() {}
	        QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
	            serializeStructure("", params, shape, fn);
	        };
	        function ucfirst(shape) {
	            if (shape.isQueryName || shape.api.protocol !== "ec2") {
	                return shape.name;
	            } else {
	                return shape.name[0].toUpperCase() + shape.name.substr(1);
	            }
	        }
	        function serializeStructure(prefix, struct, rules, fn) {
	            util.each(rules.members, function(name, member) {
	                var value = struct[name];
	                if (value === null || value === undefined) return;
	                var memberName = ucfirst(member);
	                memberName = prefix ? prefix + "." + memberName : memberName;
	                serializeMember(memberName, value, member, fn);
	            });
	        }
	        function serializeMap(name, map, rules, fn) {
	            var i = 1;
	            util.each(map, function(key, value) {
	                var prefix = rules.flattened ? "." : ".entry.";
	                var position = prefix + i++ + ".";
	                var keyName = position + (rules.key.name || "key");
	                var valueName = position + (rules.value.name || "value");
	                serializeMember(name + keyName, key, rules.key, fn);
	                serializeMember(name + valueName, value, rules.value, fn);
	            });
	        }
	        function serializeList(name, list, rules, fn) {
	            var memberRules = rules.member || {};
	            if (list.length === 0) {
	                fn.call(this, name, null);
	                return;
	            }
	            util.arrayEach(list, function(v, n) {
	                var suffix = "." + (n + 1);
	                if (rules.api.protocol === "ec2") {
	                    suffix = suffix + "";
	                } else if (rules.flattened) {
	                    if (memberRules.name) {
	                        var parts = name.split(".");
	                        parts.pop();
	                        parts.push(ucfirst(memberRules));
	                        name = parts.join(".");
	                    }
	                } else {
	                    suffix = ".member" + suffix;
	                }
	                serializeMember(name + suffix, v, memberRules, fn);
	            });
	        }
	        function serializeMember(name, value, rules, fn) {
	            if (value === null || value === undefined) return;
	            if (rules.type === "structure") {
	                serializeStructure(name, value, rules, fn);
	            } else if (rules.type === "list") {
	                serializeList(name, value, rules, fn);
	            } else if (rules.type === "map") {
	                serializeMap(name, value, rules, fn);
	            } else {
	                fn(name, rules.toWireFormat(value).toString());
	            }
	        }
	        module.exports = QueryParamSerializer;
	    }, {
	        "../util": 84
	    } ],
	    46: [ function(require, module, exports) {
	        var Collection = require("./collection");
	        var util = require("../util");
	        function property(obj, name, value) {
	            if (value !== null && value !== undefined) {
	                util.property.apply(this, arguments);
	            }
	        }
	        function memoizedProperty(obj, name) {
	            if (!obj.constructor.prototype[name]) {
	                util.memoizedProperty.apply(this, arguments);
	            }
	        }
	        function Shape(shape, options, memberName) {
	            options = options || {};
	            property(this, "shape", shape.shape);
	            property(this, "api", options.api, false);
	            property(this, "type", shape.type);
	            property(this, "enum", shape.enum);
	            property(this, "min", shape.min);
	            property(this, "max", shape.max);
	            property(this, "pattern", shape.pattern);
	            property(this, "location", shape.location || this.location || "body");
	            property(this, "name", this.name || shape.xmlName || shape.queryName || shape.locationName || memberName);
	            property(this, "isStreaming", shape.streaming || this.isStreaming || false);
	            property(this, "isComposite", shape.isComposite || false);
	            property(this, "isShape", true, false);
	            property(this, "isQueryName", shape.queryName ? true : false, false);
	            property(this, "isLocationName", shape.locationName ? true : false, false);
	            if (options.documentation) {
	                property(this, "documentation", shape.documentation);
	                property(this, "documentationUrl", shape.documentationUrl);
	            }
	            if (shape.xmlAttribute) {
	                property(this, "isXmlAttribute", shape.xmlAttribute || false);
	            }
	            property(this, "defaultValue", null);
	            this.toWireFormat = function(value) {
	                if (value === null || value === undefined) return "";
	                return value;
	            };
	            this.toType = function(value) {
	                return value;
	            };
	        }
	        Shape.normalizedTypes = {
	            character: "string",
	            "double": "float",
	            "long": "integer",
	            "short": "integer",
	            biginteger: "integer",
	            bigdecimal: "float",
	            blob: "binary"
	        };
	        Shape.types = {
	            structure: StructureShape,
	            list: ListShape,
	            map: MapShape,
	            "boolean": BooleanShape,
	            timestamp: TimestampShape,
	            "float": FloatShape,
	            integer: IntegerShape,
	            string: StringShape,
	            base64: Base64Shape,
	            binary: BinaryShape
	        };
	        Shape.resolve = function resolve(shape, options) {
	            if (shape.shape) {
	                var refShape = options.api.shapes[shape.shape];
	                if (!refShape) {
	                    throw new Error("Cannot find shape reference: " + shape.shape);
	                }
	                return refShape;
	            } else {
	                return null;
	            }
	        };
	        Shape.create = function create(shape, options, memberName) {
	            if (shape.isShape) return shape;
	            var refShape = Shape.resolve(shape, options);
	            if (refShape) {
	                var filteredKeys = Object.keys(shape);
	                if (!options.documentation) {
	                    filteredKeys = filteredKeys.filter(function(name) {
	                        return !name.match(/documentation/);
	                    });
	                }
	                if (filteredKeys === [ "shape" ]) {
	                    return refShape;
	                }
	                var InlineShape = function() {
	                    refShape.constructor.call(this, shape, options, memberName);
	                };
	                InlineShape.prototype = refShape;
	                return new InlineShape();
	            } else {
	                if (!shape.type) {
	                    if (shape.members) shape.type = "structure"; else if (shape.member) shape.type = "list"; else if (shape.key) shape.type = "map"; else shape.type = "string";
	                }
	                var origType = shape.type;
	                if (Shape.normalizedTypes[shape.type]) {
	                    shape.type = Shape.normalizedTypes[shape.type];
	                }
	                if (Shape.types[shape.type]) {
	                    return new Shape.types[shape.type](shape, options, memberName);
	                } else {
	                    throw new Error("Unrecognized shape type: " + origType);
	                }
	            }
	        };
	        function CompositeShape(shape) {
	            Shape.apply(this, arguments);
	            property(this, "isComposite", true);
	            if (shape.flattened) {
	                property(this, "flattened", shape.flattened || false);
	            }
	        }
	        function StructureShape(shape, options) {
	            var requiredMap = null, firstInit = !this.isShape;
	            CompositeShape.apply(this, arguments);
	            if (firstInit) {
	                property(this, "defaultValue", function() {
	                    return {};
	                });
	                property(this, "members", {});
	                property(this, "memberNames", []);
	                property(this, "required", []);
	                property(this, "isRequired", function() {
	                    return false;
	                });
	            }
	            if (shape.members) {
	                property(this, "members", new Collection(shape.members, options, function(name, member) {
	                    return Shape.create(member, options, name);
	                }));
	                memoizedProperty(this, "memberNames", function() {
	                    return shape.xmlOrder || Object.keys(shape.members);
	                });
	            }
	            if (shape.required) {
	                property(this, "required", shape.required);
	                property(this, "isRequired", function(name) {
	                    if (!requiredMap) {
	                        requiredMap = {};
	                        for (var i = 0; i < shape.required.length; i++) {
	                            requiredMap[shape.required[i]] = true;
	                        }
	                    }
	                    return requiredMap[name];
	                }, false, true);
	            }
	            property(this, "resultWrapper", shape.resultWrapper || null);
	            if (shape.payload) {
	                property(this, "payload", shape.payload);
	            }
	            if (typeof shape.xmlNamespace === "string") {
	                property(this, "xmlNamespaceUri", shape.xmlNamespace);
	            } else if (typeof shape.xmlNamespace === "object") {
	                property(this, "xmlNamespacePrefix", shape.xmlNamespace.prefix);
	                property(this, "xmlNamespaceUri", shape.xmlNamespace.uri);
	            }
	        }
	        function ListShape(shape, options) {
	            var self = this, firstInit = !this.isShape;
	            CompositeShape.apply(this, arguments);
	            if (firstInit) {
	                property(this, "defaultValue", function() {
	                    return [];
	                });
	            }
	            if (shape.member) {
	                memoizedProperty(this, "member", function() {
	                    return Shape.create(shape.member, options);
	                });
	            }
	            if (this.flattened) {
	                var oldName = this.name;
	                memoizedProperty(this, "name", function() {
	                    return self.member.name || oldName;
	                });
	            }
	        }
	        function MapShape(shape, options) {
	            var firstInit = !this.isShape;
	            CompositeShape.apply(this, arguments);
	            if (firstInit) {
	                property(this, "defaultValue", function() {
	                    return {};
	                });
	                property(this, "key", Shape.create({
	                    type: "string"
	                }, options));
	                property(this, "value", Shape.create({
	                    type: "string"
	                }, options));
	            }
	            if (shape.key) {
	                memoizedProperty(this, "key", function() {
	                    return Shape.create(shape.key, options);
	                });
	            }
	            if (shape.value) {
	                memoizedProperty(this, "value", function() {
	                    return Shape.create(shape.value, options);
	                });
	            }
	        }
	        function TimestampShape(shape) {
	            var self = this;
	            Shape.apply(this, arguments);
	            if (this.location === "header") {
	                property(this, "timestampFormat", "rfc822");
	            } else if (shape.timestampFormat) {
	                property(this, "timestampFormat", shape.timestampFormat);
	            } else if (this.api) {
	                if (this.api.timestampFormat) {
	                    property(this, "timestampFormat", this.api.timestampFormat);
	                } else {
	                    switch (this.api.protocol) {
	                      case "json":
	                      case "rest-json":
	                        property(this, "timestampFormat", "unixTimestamp");
	                        break;
	
	                      case "rest-xml":
	                      case "query":
	                      case "ec2":
	                        property(this, "timestampFormat", "iso8601");
	                        break;
	                    }
	                }
	            }
	            this.toType = function(value) {
	                if (value === null || value === undefined) return null;
	                if (typeof value.toUTCString === "function") return value;
	                return typeof value === "string" || typeof value === "number" ? util.date.parseTimestamp(value) : null;
	            };
	            this.toWireFormat = function(value) {
	                return util.date.format(value, self.timestampFormat);
	            };
	        }
	        function StringShape() {
	            Shape.apply(this, arguments);
	            if (this.api) {
	                switch (this.api.protocol) {
	                  case "rest-xml":
	                  case "query":
	                  case "ec2":
	                    this.toType = function(value) {
	                        return value || "";
	                    };
	                }
	            }
	        }
	        function FloatShape() {
	            Shape.apply(this, arguments);
	            this.toType = function(value) {
	                if (value === null || value === undefined) return null;
	                return parseFloat(value);
	            };
	            this.toWireFormat = this.toType;
	        }
	        function IntegerShape() {
	            Shape.apply(this, arguments);
	            this.toType = function(value) {
	                if (value === null || value === undefined) return null;
	                return parseInt(value, 10);
	            };
	            this.toWireFormat = this.toType;
	        }
	        function BinaryShape() {
	            Shape.apply(this, arguments);
	            this.toType = util.base64.decode;
	            this.toWireFormat = util.base64.encode;
	        }
	        function Base64Shape() {
	            BinaryShape.apply(this, arguments);
	        }
	        function BooleanShape() {
	            Shape.apply(this, arguments);
	            this.toType = function(value) {
	                if (typeof value === "boolean") return value;
	                if (value === null || value === undefined) return null;
	                return value === "true";
	            };
	        }
	        Shape.shapes = {
	            StructureShape: StructureShape,
	            ListShape: ListShape,
	            MapShape: MapShape,
	            StringShape: StringShape,
	            BooleanShape: BooleanShape,
	            Base64Shape: Base64Shape
	        };
	        module.exports = Shape;
	    }, {
	        "../util": 84,
	        "./collection": 42
	    } ],
	    42: [ function(require, module, exports) {
	        var memoizedProperty = require("../util").memoizedProperty;
	        function memoize(name, value, fn, nameTr) {
	            memoizedProperty(this, nameTr(name), function() {
	                return fn(name, value);
	            });
	        }
	        function Collection(iterable, options, fn, nameTr) {
	            nameTr = nameTr || String;
	            var self = this;
	            for (var id in iterable) {
	                if (iterable.hasOwnProperty(id)) {
	                    memoize.call(self, id, iterable[id], fn, nameTr);
	                }
	            }
	        }
	        module.exports = Collection;
	    }, {
	        "../util": 84
	    } ],
	    48: [ function(require, module, exports) {
	        var util = require("../util");
	        var JsonBuilder = require("../json/builder");
	        var JsonParser = require("../json/parser");
	        function buildRequest(req) {
	            var httpRequest = req.httpRequest;
	            var api = req.service.api;
	            var target = api.targetPrefix + "." + api.operations[req.operation].name;
	            var version = api.jsonVersion || "1.0";
	            var input = api.operations[req.operation].input;
	            var builder = new JsonBuilder();
	            if (version === 1) version = "1.0";
	            httpRequest.body = builder.build(req.params || {}, input);
	            httpRequest.headers["Content-Type"] = "application/x-amz-json-" + version;
	            httpRequest.headers["X-Amz-Target"] = target;
	        }
	        function extractError(resp) {
	            var error = {};
	            var httpResponse = resp.httpResponse;
	            error.code = httpResponse.headers["x-amzn-errortype"] || "UnknownError";
	            if (typeof error.code === "string") {
	                error.code = error.code.split(":")[0];
	            }
	            if (httpResponse.body.length > 0) {
	                var e = JSON.parse(httpResponse.body.toString());
	                if (e.__type || e.code) {
	                    error.code = (e.__type || e.code).split("#").pop();
	                }
	                if (error.code === "RequestEntityTooLarge") {
	                    error.message = "Request body must be less than 1 MB";
	                } else {
	                    error.message = e.message || e.Message || null;
	                }
	            } else {
	                error.statusCode = httpResponse.statusCode;
	                error.message = httpResponse.statusCode.toString();
	            }
	            resp.error = util.error(new Error(), error);
	        }
	        function extractData(resp) {
	            var body = resp.httpResponse.body.toString() || "{}";
	            if (resp.request.service.config.convertResponseTypes === false) {
	                resp.data = JSON.parse(body);
	            } else {
	                var operation = resp.request.service.api.operations[resp.request.operation];
	                var shape = operation.output || {};
	                var parser = new JsonParser();
	                resp.data = parser.parse(body, shape);
	            }
	        }
	        module.exports = {
	            buildRequest: buildRequest,
	            extractError: extractError,
	            extractData: extractData
	        };
	    }, {
	        "../json/builder": 39,
	        "../json/parser": 40,
	        "../util": 84
	    } ],
	    40: [ function(require, module, exports) {
	        var util = require("../util");
	        function JsonParser() {}
	        JsonParser.prototype.parse = function(value, shape) {
	            return translate(JSON.parse(value), shape);
	        };
	        function translate(value, shape) {
	            if (!shape || value === undefined) return undefined;
	            switch (shape.type) {
	              case "structure":
	                return translateStructure(value, shape);
	
	              case "map":
	                return translateMap(value, shape);
	
	              case "list":
	                return translateList(value, shape);
	
	              default:
	                return translateScalar(value, shape);
	            }
	        }
	        function translateStructure(structure, shape) {
	            if (structure == null) return undefined;
	            var struct = {};
	            var shapeMembers = shape.members;
	            util.each(shapeMembers, function(name, memberShape) {
	                var locationName = memberShape.isLocationName ? memberShape.name : name;
	                if (structure.hasOwnProperty(locationName)) {
	                    var value = structure[locationName];
	                    var result = translate(value, memberShape);
	                    if (result !== undefined) struct[name] = result;
	                }
	            });
	            return struct;
	        }
	        function translateList(list, shape) {
	            if (list == null) return undefined;
	            var out = [];
	            util.arrayEach(list, function(value) {
	                var result = translate(value, shape.member);
	                if (result === undefined) out.push(null); else out.push(result);
	            });
	            return out;
	        }
	        function translateMap(map, shape) {
	            if (map == null) return undefined;
	            var out = {};
	            util.each(map, function(key, value) {
	                var result = translate(value, shape.value);
	                if (result === undefined) out[key] = null; else out[key] = result;
	            });
	            return out;
	        }
	        function translateScalar(value, shape) {
	            return shape.toType(value);
	        }
	        module.exports = JsonParser;
	    }, {
	        "../util": 84
	    } ],
	    39: [ function(require, module, exports) {
	        var util = require("../util");
	        function JsonBuilder() {}
	        JsonBuilder.prototype.build = function(value, shape) {
	            return JSON.stringify(translate(value, shape));
	        };
	        function translate(value, shape) {
	            if (!shape || value === undefined || value === null) return undefined;
	            switch (shape.type) {
	              case "structure":
	                return translateStructure(value, shape);
	
	              case "map":
	                return translateMap(value, shape);
	
	              case "list":
	                return translateList(value, shape);
	
	              default:
	                return translateScalar(value, shape);
	            }
	        }
	        function translateStructure(structure, shape) {
	            var struct = {};
	            util.each(structure, function(name, value) {
	                var memberShape = shape.members[name];
	                if (memberShape) {
	                    if (memberShape.location !== "body") return;
	                    var locationName = memberShape.isLocationName ? memberShape.name : name;
	                    var result = translate(value, memberShape);
	                    if (result !== undefined) struct[locationName] = result;
	                }
	            });
	            return struct;
	        }
	        function translateList(list, shape) {
	            var out = [];
	            util.arrayEach(list, function(value) {
	                var result = translate(value, shape.member);
	                if (result !== undefined) out.push(result);
	            });
	            return out;
	        }
	        function translateMap(map, shape) {
	            var out = {};
	            util.each(map, function(key, value) {
	                var result = translate(value, shape.value);
	                if (result !== undefined) out[key] = result;
	            });
	            return out;
	        }
	        function translateScalar(value, shape) {
	            return shape.toWireFormat(value);
	        }
	        module.exports = JsonBuilder;
	    }, {
	        "../util": 84
	    } ],
	    84: [ function(require, module, exports) {
	        (function(process) {
	            var cryptoLib = require("crypto");
	            var Buffer = require("buffer").Buffer;
	            var AWS;
	            var util = {
	                engine: function engine() {
	                    if (util.isBrowser() && typeof navigator !== "undefined") {
	                        return navigator.userAgent;
	                    } else {
	                        return process.platform + "/" + process.version;
	                    }
	                },
	                userAgent: function userAgent() {
	                    var name = util.isBrowser() ? "js" : "nodejs";
	                    var agent = "aws-sdk-" + name + "/" + require("./core").VERSION;
	                    if (name === "nodejs") agent += " " + util.engine();
	                    return agent;
	                },
	                isBrowser: function isBrowser() {
	                    return process && process.browser;
	                },
	                isNode: function isNode() {
	                    return !util.isBrowser();
	                },
	                nodeRequire: function nodeRequire(module) {
	                    if (util.isNode()) return require(module);
	                },
	                multiRequire: function multiRequire(module1, module2) {
	                    return require(util.isNode() ? module1 : module2);
	                },
	                uriEscape: function uriEscape(string) {
	                    var output = encodeURIComponent(string);
	                    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	                    output = output.replace(/[*]/g, function(ch) {
	                        return "%" + ch.charCodeAt(0).toString(16).toUpperCase();
	                    });
	                    return output;
	                },
	                uriEscapePath: function uriEscapePath(string) {
	                    var parts = [];
	                    util.arrayEach(string.split("/"), function(part) {
	                        parts.push(util.uriEscape(part));
	                    });
	                    return parts.join("/");
	                },
	                urlParse: function urlParse(url) {
	                    return require("url").parse(url);
	                },
	                urlFormat: function urlFormat(url) {
	                    return require("url").format(url);
	                },
	                queryStringParse: function queryStringParse(qs) {
	                    return require("querystring").parse(qs);
	                },
	                queryParamsToString: function queryParamsToString(params) {
	                    var items = [];
	                    var escape = util.uriEscape;
	                    var sortedKeys = Object.keys(params).sort();
	                    util.arrayEach(sortedKeys, function(name) {
	                        var value = params[name];
	                        var ename = escape(name);
	                        var result = ename + "=";
	                        if (Array.isArray(value)) {
	                            var vals = [];
	                            util.arrayEach(value, function(item) {
	                                vals.push(escape(item));
	                            });
	                            result = ename + "=" + vals.sort().join("&" + ename + "=");
	                        } else if (value !== undefined && value !== null) {
	                            result = ename + "=" + escape(value);
	                        }
	                        items.push(result);
	                    });
	                    return items.join("&");
	                },
	                readFileSync: function readFileSync(path) {
	                    if (util.isBrowser()) return null;
	                    return util.nodeRequire("fs").readFileSync(path, "utf-8");
	                },
	                base64: {
	                    encode: function encode64(string) {
	                        return new Buffer(string).toString("base64");
	                    },
	                    decode: function decode64(string) {
	                        return new Buffer(string, "base64");
	                    }
	                },
	                Buffer: Buffer,
	                buffer: {
	                    toStream: function toStream(buffer) {
	                        if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);
	                        var readable = new (util.nodeRequire("stream").Readable)();
	                        var pos = 0;
	                        readable._read = function(size) {
	                            if (pos >= buffer.length) return readable.push(null);
	                            var end = pos + size;
	                            if (end > buffer.length) end = buffer.length;
	                            readable.push(buffer.slice(pos, end));
	                            pos = end;
	                        };
	                        return readable;
	                    },
	                    concat: function(buffers) {
	                        var length = 0, offset = 0, buffer = null, i;
	                        for (i = 0; i < buffers.length; i++) {
	                            length += buffers[i].length;
	                        }
	                        buffer = new Buffer(length);
	                        for (i = 0; i < buffers.length; i++) {
	                            buffers[i].copy(buffer, offset);
	                            offset += buffers[i].length;
	                        }
	                        return buffer;
	                    }
	                },
	                string: {
	                    byteLength: function byteLength(string) {
	                        if (string === null || string === undefined) return 0;
	                        if (typeof string === "string") string = new Buffer(string);
	                        if (typeof string.byteLength === "number") {
	                            return string.byteLength;
	                        } else if (typeof string.length === "number") {
	                            return string.length;
	                        } else if (typeof string.size === "number") {
	                            return string.size;
	                        } else if (typeof string.path === "string") {
	                            return util.nodeRequire("fs").lstatSync(string.path).size;
	                        } else {
	                            throw util.error(new Error("Cannot determine length of " + string), {
	                                object: string
	                            });
	                        }
	                    },
	                    upperFirst: function upperFirst(string) {
	                        return string[0].toUpperCase() + string.substr(1);
	                    },
	                    lowerFirst: function lowerFirst(string) {
	                        return string[0].toLowerCase() + string.substr(1);
	                    }
	                },
	                ini: {
	                    parse: function string(ini) {
	                        var currentSection, map = {};
	                        util.arrayEach(ini.split(/\r?\n/), function(line) {
	                            line = line.split(/(^|\s);/)[0];
	                            var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
	                            if (section) {
	                                currentSection = section[1];
	                            } else if (currentSection) {
	                                var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
	                                if (item) {
	                                    map[currentSection] = map[currentSection] || {};
	                                    map[currentSection][item[1]] = item[2];
	                                }
	                            }
	                        });
	                        return map;
	                    }
	                },
	                fn: {
	                    noop: function() {},
	                    makeAsync: function makeAsync(fn, expectedArgs) {
	                        if (expectedArgs && expectedArgs <= fn.length) {
	                            return fn;
	                        }
	                        return function() {
	                            var args = Array.prototype.slice.call(arguments, 0);
	                            var callback = args.pop();
	                            var result = fn.apply(null, args);
	                            callback(result);
	                        };
	                    }
	                },
	                date: {
	                    getDate: function getDate() {
	                        if (!AWS) AWS = require("./core");
	                        if (AWS.config.systemClockOffset) {
	                            return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	                        } else {
	                            return new Date();
	                        }
	                    },
	                    iso8601: function iso8601(date) {
	                        if (date === undefined) {
	                            date = util.date.getDate();
	                        }
	                        return date.toISOString().replace(/\.\d{3}Z$/, "Z");
	                    },
	                    rfc822: function rfc822(date) {
	                        if (date === undefined) {
	                            date = util.date.getDate();
	                        }
	                        return date.toUTCString();
	                    },
	                    unixTimestamp: function unixTimestamp(date) {
	                        if (date === undefined) {
	                            date = util.date.getDate();
	                        }
	                        return date.getTime() / 1e3;
	                    },
	                    from: function format(date) {
	                        if (typeof date === "number") {
	                            return new Date(date * 1e3);
	                        } else {
	                            return new Date(date);
	                        }
	                    },
	                    format: function format(date, formatter) {
	                        if (!formatter) formatter = "iso8601";
	                        return util.date[formatter](util.date.from(date));
	                    },
	                    parseTimestamp: function parseTimestamp(value) {
	                        if (typeof value === "number") {
	                            return new Date(value * 1e3);
	                        } else if (value.match(/^\d+$/)) {
	                            return new Date(value * 1e3);
	                        } else if (value.match(/^\d{4}/)) {
	                            return new Date(value);
	                        } else if (value.match(/^\w{3},/)) {
	                            return new Date(value);
	                        } else {
	                            throw util.error(new Error("unhandled timestamp format: " + value), {
	                                code: "TimestampParserError"
	                            });
	                        }
	                    }
	                },
	                crypto: {
	                    crc32Table: [ 0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117 ],
	                    crc32: function crc32(data) {
	                        var tbl = util.crypto.crc32Table;
	                        var crc = 0 ^ -1;
	                        if (typeof data === "string") {
	                            data = new Buffer(data);
	                        }
	                        for (var i = 0; i < data.length; i++) {
	                            var code = data.readUInt8(i);
	                            crc = crc >>> 8 ^ tbl[(crc ^ code) & 255];
	                        }
	                        return (crc ^ -1) >>> 0;
	                    },
	                    hmac: function hmac(key, string, digest, fn) {
	                        if (!digest) digest = "binary";
	                        if (digest === "buffer") {
	                            digest = undefined;
	                        }
	                        if (!fn) fn = "sha256";
	                        if (typeof string === "string") string = new Buffer(string);
	                        return cryptoLib.createHmac(fn, key).update(string).digest(digest);
	                    },
	                    md5: function md5(data, digest, callback) {
	                        return util.crypto.hash("md5", data, digest, callback);
	                    },
	                    sha256: function sha256(data, digest, callback) {
	                        return util.crypto.hash("sha256", data, digest, callback);
	                    },
	                    hash: function(algorithm, data, digest, callback) {
	                        var hash = util.crypto.createHash(algorithm);
	                        if (!digest) {
	                            digest = "binary";
	                        }
	                        if (digest === "buffer") {
	                            digest = undefined;
	                        }
	                        if (typeof data === "string") data = new Buffer(data);
	                        var sliceFn = util.arraySliceFn(data);
	                        var isBuffer = Buffer.isBuffer(data);
	                        if (util.isBrowser() && typeof ArrayBuffer !== "undefined" && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
	                        if (callback && typeof data === "object" && typeof data.on === "function" && !isBuffer) {
	                            data.on("data", function(chunk) {
	                                hash.update(chunk);
	                            });
	                            data.on("error", function(err) {
	                                callback(err);
	                            });
	                            data.on("end", function() {
	                                callback(null, hash.digest(digest));
	                            });
	                        } else if (callback && sliceFn && !isBuffer && typeof FileReader !== "undefined") {
	                            var index = 0, size = 1024 * 512;
	                            var reader = new FileReader();
	                            reader.onerror = function() {
	                                callback(new Error("Failed to read data."));
	                            };
	                            reader.onload = function() {
	                                var buf = new Buffer(new Uint8Array(reader.result));
	                                hash.update(buf);
	                                index += buf.length;
	                                reader._continueReading();
	                            };
	                            reader._continueReading = function() {
	                                if (index >= data.size) {
	                                    callback(null, hash.digest(digest));
	                                    return;
	                                }
	                                var back = index + size;
	                                if (back > data.size) back = data.size;
	                                reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	                            };
	                            reader._continueReading();
	                        } else {
	                            if (util.isBrowser() && typeof data === "object" && !isBuffer) {
	                                data = new Buffer(new Uint8Array(data));
	                            }
	                            var out = hash.update(data).digest(digest);
	                            if (callback) callback(null, out);
	                            return out;
	                        }
	                    },
	                    toHex: function toHex(data) {
	                        var out = [];
	                        for (var i = 0; i < data.length; i++) {
	                            out.push(("0" + data.charCodeAt(i).toString(16)).substr(-2, 2));
	                        }
	                        return out.join("");
	                    },
	                    createHash: function createHash(algorithm) {
	                        return cryptoLib.createHash(algorithm);
	                    }
	                },
	                abort: {},
	                each: function each(object, iterFunction) {
	                    for (var key in object) {
	                        if (Object.prototype.hasOwnProperty.call(object, key)) {
	                            var ret = iterFunction.call(this, key, object[key]);
	                            if (ret === util.abort) break;
	                        }
	                    }
	                },
	                arrayEach: function arrayEach(array, iterFunction) {
	                    for (var idx in array) {
	                        if (array.hasOwnProperty(idx)) {
	                            var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	                            if (ret === util.abort) break;
	                        }
	                    }
	                },
	                update: function update(obj1, obj2) {
	                    util.each(obj2, function iterator(key, item) {
	                        obj1[key] = item;
	                    });
	                    return obj1;
	                },
	                merge: function merge(obj1, obj2) {
	                    return util.update(util.copy(obj1), obj2);
	                },
	                copy: function copy(object) {
	                    if (object === null || object === undefined) return object;
	                    var dupe = {};
	                    for (var key in object) {
	                        dupe[key] = object[key];
	                    }
	                    return dupe;
	                },
	                isEmpty: function isEmpty(obj) {
	                    for (var prop in obj) {
	                        if (obj.hasOwnProperty(prop)) {
	                            return false;
	                        }
	                    }
	                    return true;
	                },
	                arraySliceFn: function arraySliceFn(obj) {
	                    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	                    return typeof fn === "function" ? fn : null;
	                },
	                isType: function isType(obj, type) {
	                    if (typeof type === "function") type = util.typeName(type);
	                    return Object.prototype.toString.call(obj) === "[object " + type + "]";
	                },
	                typeName: function typeName(type) {
	                    if (type.hasOwnProperty("name")) return type.name;
	                    var str = type.toString();
	                    var match = str.match(/^\s*function (.+)\(/);
	                    return match ? match[1] : str;
	                },
	                error: function error(err, options) {
	                    var originalError = null;
	                    if (typeof err.message === "string" && err.message !== "") {
	                        if (typeof options === "string" || options && options.message) {
	                            originalError = util.copy(err);
	                            originalError.message = err.message;
	                        }
	                    }
	                    err.message = err.message || null;
	                    if (typeof options === "string") {
	                        err.message = options;
	                    } else if (typeof options === "object" && options !== null) {
	                        util.update(err, options);
	                        if (options.message) err.message = options.message;
	                        if (options.code || options.name) err.code = options.code || options.name;
	                        if (options.stack) err.stack = options.stack;
	                    }
	                    if (typeof Object.defineProperty === "function") {
	                        Object.defineProperty(err, "name", {
	                            writable: true,
	                            enumerable: false
	                        });
	                        Object.defineProperty(err, "message", {
	                            enumerable: true
	                        });
	                    }
	                    err.name = options && options.name || err.name || err.code || "Error";
	                    err.time = new Date();
	                    if (originalError) err.originalError = originalError;
	                    return err;
	                },
	                inherit: function inherit(klass, features) {
	                    var newObject = null;
	                    if (features === undefined) {
	                        features = klass;
	                        klass = Object;
	                        newObject = {};
	                    } else {
	                        var ctor = function ConstructorWrapper() {};
	                        ctor.prototype = klass.prototype;
	                        newObject = new ctor();
	                    }
	                    if (features.constructor === Object) {
	                        features.constructor = function() {
	                            if (klass !== Object) {
	                                return klass.apply(this, arguments);
	                            }
	                        };
	                    }
	                    features.constructor.prototype = newObject;
	                    util.update(features.constructor.prototype, features);
	                    features.constructor.__super__ = klass;
	                    return features.constructor;
	                },
	                mixin: function mixin() {
	                    var klass = arguments[0];
	                    for (var i = 1; i < arguments.length; i++) {
	                        for (var prop in arguments[i].prototype) {
	                            var fn = arguments[i].prototype[prop];
	                            if (prop !== "constructor") {
	                                klass.prototype[prop] = fn;
	                            }
	                        }
	                    }
	                    return klass;
	                },
	                hideProperties: function hideProperties(obj, props) {
	                    if (typeof Object.defineProperty !== "function") return;
	                    util.arrayEach(props, function(key) {
	                        Object.defineProperty(obj, key, {
	                            enumerable: false,
	                            writable: true,
	                            configurable: true
	                        });
	                    });
	                },
	                property: function property(obj, name, value, enumerable, isValue) {
	                    var opts = {
	                        configurable: true,
	                        enumerable: enumerable !== undefined ? enumerable : true
	                    };
	                    if (typeof value === "function" && !isValue) {
	                        opts.get = value;
	                    } else {
	                        opts.value = value;
	                        opts.writable = true;
	                    }
	                    Object.defineProperty(obj, name, opts);
	                },
	                memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	                    var cachedValue = null;
	                    util.property(obj, name, function() {
	                        if (cachedValue === null) {
	                            cachedValue = get();
	                        }
	                        return cachedValue;
	                    }, enumerable);
	                },
	                hoistPayloadMember: function hoistPayloadMember(resp) {
	                    var req = resp.request;
	                    var operation = req.operation;
	                    var output = req.service.api.operations[operation].output;
	                    if (output.payload) {
	                        var payloadMember = output.members[output.payload];
	                        var responsePayload = resp.data[output.payload];
	                        if (payloadMember.type === "structure") {
	                            util.each(responsePayload, function(key, value) {
	                                util.property(resp.data, key, value, false);
	                            });
	                        }
	                    }
	                },
	                computeSha256: function computeSha256(body, done) {
	                    if (util.isNode()) {
	                        var Stream = util.nodeRequire("stream").Stream;
	                        var fs = util.nodeRequire("fs");
	                        if (body instanceof Stream) {
	                            if (typeof body.path === "string") {
	                                var settings = {};
	                                if (typeof body.start === "number") {
	                                    settings.start = body.start;
	                                }
	                                if (typeof body.end === "number") {
	                                    settings.end = body.end;
	                                }
	                                body = fs.createReadStream(body.path, settings);
	                            } else {
	                                return done(new Error("Non-file stream objects are " + "not supported with SigV4"));
	                            }
	                        }
	                    }
	                    util.crypto.sha256(body, "hex", function(err, sha) {
	                        if (err) done(err); else done(null, sha);
	                    });
	                },
	                isClockSkewed: function isClockSkewed(serverTime) {
	                    if (serverTime) {
	                        util.property(AWS.config, "isClockSkewed", Math.abs(new Date().getTime() - serverTime) >= 3e5, false);
	                        return AWS.config.isClockSkewed;
	                    }
	                },
	                applyClockOffset: function applyClockOffset(serverTime) {
	                    if (serverTime) AWS.config.systemClockOffset = serverTime - new Date().getTime();
	                },
	                extractRequestId: function extractRequestId(resp) {
	                    var requestId = resp.httpResponse.headers["x-amz-request-id"] || resp.httpResponse.headers["x-amzn-requestid"];
	                    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	                        requestId = resp.data.ResponseMetadata.RequestId;
	                    }
	                    if (requestId) {
	                        resp.requestId = requestId;
	                    }
	                    if (resp.error) {
	                        resp.error.requestId = requestId;
	                    }
	                },
	                addPromisesToRequests: function addPromisesToRequests(constructor, PromiseDependency) {
	                    PromiseDependency = PromiseDependency || null;
	                    if (!PromiseDependency && typeof Promise !== "undefined") {
	                        PromiseDependency = Promise;
	                    }
	                    if (typeof PromiseDependency !== "function") {
	                        delete constructor.prototype.promise;
	                        return;
	                    }
	                    constructor.prototype.promise = function promise() {
	                        var self = this;
	                        return new PromiseDependency(function(resolve, reject) {
	                            self.on("complete", function(resp) {
	                                if (resp.error) {
	                                    reject(resp.error);
	                                } else {
	                                    resolve(resp.data);
	                                }
	                            });
	                            self.runTo();
	                        });
	                    };
	                }
	            };
	            module.exports = util;
	        }).call(this, require("_process"));
	    }, {
	        "./core": 24,
	        _process: 13,
	        buffer: 1,
	        crypto: 6,
	        querystring: 17,
	        url: 18
	    } ],
	    30: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	            constructor: function WebIdentityCredentials(params) {
	                AWS.Credentials.call(this);
	                this.expired = true;
	                this.params = params;
	                this.params.RoleSessionName = this.params.RoleSessionName || "web-identity";
	                this.data = null;
	            },
	            refresh: function refresh(callback) {
	                var self = this;
	                self.createClients();
	                if (!callback) callback = function(err) {
	                    if (err) throw err;
	                };
	                self.service.assumeRoleWithWebIdentity(function(err, data) {
	                    self.data = null;
	                    if (!err) {
	                        self.data = data;
	                        self.service.credentialsFrom(data, self);
	                    }
	                    callback(err);
	                });
	            },
	            createClients: function() {
	                this.service = this.service || new AWS.STS({
	                    params: this.params
	                });
	            }
	        });
	    }, {
	        "../core": 24
	    } ],
	    29: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	            constructor: function TemporaryCredentials(params) {
	                AWS.Credentials.call(this);
	                this.loadMasterCredentials();
	                this.expired = true;
	                this.params = params || {};
	                if (this.params.RoleArn) {
	                    this.params.RoleSessionName = this.params.RoleSessionName || "temporary-credentials";
	                }
	            },
	            refresh: function refresh(callback) {
	                var self = this;
	                self.createClients();
	                if (!callback) callback = function(err) {
	                    if (err) throw err;
	                };
	                self.service.config.credentials = self.masterCredentials;
	                var operation = self.params.RoleArn ? self.service.assumeRole : self.service.getSessionToken;
	                operation.call(self.service, function(err, data) {
	                    if (!err) {
	                        self.service.credentialsFrom(data, self);
	                    }
	                    callback(err);
	                });
	            },
	            loadMasterCredentials: function loadMasterCredentials() {
	                this.masterCredentials = AWS.config.credentials;
	                while (this.masterCredentials.masterCredentials) {
	                    this.masterCredentials = this.masterCredentials.masterCredentials;
	                }
	            },
	            createClients: function() {
	                this.service = this.service || new AWS.STS({
	                    params: this.params
	                });
	            }
	        });
	    }, {
	        "../core": 24
	    } ],
	    28: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	            constructor: function SAMLCredentials(params) {
	                AWS.Credentials.call(this);
	                this.expired = true;
	                this.params = params;
	            },
	            refresh: function refresh(callback) {
	                var self = this;
	                self.createClients();
	                if (!callback) callback = function(err) {
	                    if (err) throw err;
	                };
	                self.service.assumeRoleWithSAML(function(err, data) {
	                    if (!err) {
	                        self.service.credentialsFrom(data, self);
	                    }
	                    callback(err);
	                });
	            },
	            createClients: function() {
	                this.service = this.service || new AWS.STS({
	                    params: this.params
	                });
	            }
	        });
	    }, {
	        "../core": 24
	    } ],
	    26: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	            localStorageKey: {
	                id: "aws.cognito.identity-id.",
	                providers: "aws.cognito.identity-providers."
	            },
	            constructor: function CognitoIdentityCredentials(params) {
	                AWS.Credentials.call(this);
	                this.expired = true;
	                this.params = params;
	                this.data = null;
	                this.identityId = null;
	                this.loadCachedId();
	            },
	            refresh: function refresh(callback) {
	                var self = this;
	                self.createClients();
	                self.data = null;
	                self.identityId = null;
	                self.getId(function(err) {
	                    if (!err) {
	                        if (!self.params.RoleArn) {
	                            self.getCredentialsForIdentity(callback);
	                        } else {
	                            self.getCredentialsFromSTS(callback);
	                        }
	                    } else {
	                        self.clearCachedId();
	                        callback(err);
	                    }
	                });
	            },
	            clearCachedId: function clearCache() {
	                this.identityId = null;
	                delete this.params.IdentityId;
	                var poolId = this.params.IdentityPoolId;
	                var loginId = this.params.LoginId || "";
	                delete this.storage[this.localStorageKey.id + poolId + loginId];
	                delete this.storage[this.localStorageKey.providers + poolId + loginId];
	            },
	            getId: function getId(callback) {
	                var self = this;
	                if (typeof self.params.IdentityId === "string") {
	                    return callback(null, self.params.IdentityId);
	                }
	                self.cognito.getId(function(err, data) {
	                    if (!err && data.IdentityId) {
	                        self.params.IdentityId = data.IdentityId;
	                        callback(null, data.IdentityId);
	                    } else {
	                        callback(err);
	                    }
	                });
	            },
	            loadCredentials: function loadCredentials(data, credentials) {
	                if (!data || !credentials) return;
	                credentials.expired = false;
	                credentials.accessKeyId = data.Credentials.AccessKeyId;
	                credentials.secretAccessKey = data.Credentials.SecretKey;
	                credentials.sessionToken = data.Credentials.SessionToken;
	                credentials.expireTime = data.Credentials.Expiration;
	            },
	            getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	                var self = this;
	                self.cognito.getCredentialsForIdentity(function(err, data) {
	                    if (!err) {
	                        self.cacheId(data);
	                        self.data = data;
	                        self.loadCredentials(self.data, self);
	                    } else {
	                        self.clearCachedId();
	                    }
	                    callback(err);
	                });
	            },
	            getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	                var self = this;
	                self.cognito.getOpenIdToken(function(err, data) {
	                    if (!err) {
	                        self.cacheId(data);
	                        self.params.WebIdentityToken = data.Token;
	                        self.webIdentityCredentials.refresh(function(webErr) {
	                            if (!webErr) {
	                                self.data = self.webIdentityCredentials.data;
	                                self.sts.credentialsFrom(self.data, self);
	                            } else {
	                                self.clearCachedId();
	                            }
	                            callback(webErr);
	                        });
	                    } else {
	                        self.clearCachedId();
	                        callback(err);
	                    }
	                });
	            },
	            loadCachedId: function loadCachedId() {
	                var self = this;
	                if (AWS.util.isBrowser() && !self.params.IdentityId) {
	                    var id = self.getStorage("id");
	                    if (id && self.params.Logins) {
	                        var actualProviders = Object.keys(self.params.Logins);
	                        var cachedProviders = (self.getStorage("providers") || "").split(",");
	                        var intersect = cachedProviders.filter(function(n) {
	                            return actualProviders.indexOf(n) !== -1;
	                        });
	                        if (intersect.length !== 0) {
	                            self.params.IdentityId = id;
	                        }
	                    } else if (id) {
	                        self.params.IdentityId = id;
	                    }
	                }
	            },
	            createClients: function() {
	                this.webIdentityCredentials = this.webIdentityCredentials || new AWS.WebIdentityCredentials(this.params);
	                this.cognito = this.cognito || new AWS.CognitoIdentity({
	                    params: this.params
	                });
	                this.sts = this.sts || new AWS.STS();
	            },
	            cacheId: function cacheId(data) {
	                this.identityId = data.IdentityId;
	                this.params.IdentityId = this.identityId;
	                if (AWS.util.isBrowser()) {
	                    this.setStorage("id", data.IdentityId);
	                    if (this.params.Logins) {
	                        this.setStorage("providers", Object.keys(this.params.Logins).join(","));
	                    }
	                }
	            },
	            getStorage: function getStorage(key) {
	                return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || "")];
	            },
	            setStorage: function setStorage(key, val) {
	                try {
	                    this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || "")] = val;
	                } catch (_) {}
	            },
	            storage: function() {
	                try {
	                    return AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === "object" ? window.localStorage : {};
	                } catch (_) {
	                    return {};
	                }
	            }()
	        });
	    }, {
	        "../core": 24
	    } ],
	    23: [ function(require, module, exports) {
	        var AWS = require("./core");
	        require("./credentials");
	        require("./credentials/credential_provider_chain");
	        AWS.Config = AWS.util.inherit({
	            constructor: function Config(options) {
	                if (options === undefined) options = {};
	                options = this.extractCredentials(options);
	                AWS.util.each.call(this, this.keys, function(key, value) {
	                    this.set(key, options[key], value);
	                });
	            },
	            getCredentials: function getCredentials(callback) {
	                var self = this;
	                function finish(err) {
	                    callback(err, err ? null : self.credentials);
	                }
	                function credError(msg, err) {
	                    return new AWS.util.error(err || new Error(), {
	                        code: "CredentialsError",
	                        message: msg
	                    });
	                }
	                function getAsyncCredentials() {
	                    self.credentials.get(function(err) {
	                        if (err) {
	                            var msg = "Could not load credentials from " + self.credentials.constructor.name;
	                            err = credError(msg, err);
	                        }
	                        finish(err);
	                    });
	                }
	                function getStaticCredentials() {
	                    var err = null;
	                    if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
	                        err = credError("Missing credentials");
	                    }
	                    finish(err);
	                }
	                if (self.credentials) {
	                    if (typeof self.credentials.get === "function") {
	                        getAsyncCredentials();
	                    } else {
	                        getStaticCredentials();
	                    }
	                } else if (self.credentialProvider) {
	                    self.credentialProvider.resolve(function(err, creds) {
	                        if (err) {
	                            err = credError("Could not load credentials from any providers", err);
	                        }
	                        self.credentials = creds;
	                        finish(err);
	                    });
	                } else {
	                    finish(credError("No credentials to load"));
	                }
	            },
	            update: function update(options, allowUnknownKeys) {
	                allowUnknownKeys = allowUnknownKeys || false;
	                options = this.extractCredentials(options);
	                AWS.util.each.call(this, options, function(key, value) {
	                    if (allowUnknownKeys || this.keys.hasOwnProperty(key) || AWS.Service.hasService(key)) {
	                        this.set(key, value);
	                    }
	                });
	            },
	            loadFromPath: function loadFromPath(path) {
	                this.clear();
	                var options = JSON.parse(AWS.util.readFileSync(path));
	                var fileSystemCreds = new AWS.FileSystemCredentials(path);
	                var chain = new AWS.CredentialProviderChain();
	                chain.providers.unshift(fileSystemCreds);
	                chain.resolve(function(err, creds) {
	                    if (err) throw err; else options.credentials = creds;
	                });
	                this.constructor(options);
	                return this;
	            },
	            clear: function clear() {
	                AWS.util.each.call(this, this.keys, function(key) {
	                    delete this[key];
	                });
	                this.set("credentials", undefined);
	                this.set("credentialProvider", undefined);
	            },
	            set: function set(property, value, defaultValue) {
	                if (value === undefined) {
	                    if (defaultValue === undefined) {
	                        defaultValue = this.keys[property];
	                    }
	                    if (typeof defaultValue === "function") {
	                        this[property] = defaultValue.call(this);
	                    } else {
	                        this[property] = defaultValue;
	                    }
	                } else if (property === "httpOptions" && this[property]) {
	                    this[property] = AWS.util.merge(this[property], value);
	                } else {
	                    this[property] = value;
	                }
	            },
	            keys: {
	                credentials: null,
	                credentialProvider: null,
	                region: null,
	                logger: null,
	                apiVersions: {},
	                apiVersion: null,
	                endpoint: undefined,
	                httpOptions: {
	                    timeout: 12e4
	                },
	                maxRetries: undefined,
	                maxRedirects: 10,
	                paramValidation: true,
	                sslEnabled: true,
	                s3ForcePathStyle: false,
	                s3BucketEndpoint: false,
	                s3DisableBodySigning: true,
	                computeChecksums: true,
	                convertResponseTypes: true,
	                correctClockSkew: false,
	                customUserAgent: null,
	                dynamoDbCrc32: true,
	                systemClockOffset: 0,
	                signatureVersion: null,
	                signatureCache: true,
	                retryDelayOptions: {
	                    base: 100
	                },
	                useAccelerateEndpoint: false
	            },
	            extractCredentials: function extractCredentials(options) {
	                if (options.accessKeyId && options.secretAccessKey) {
	                    options = AWS.util.copy(options);
	                    options.credentials = new AWS.Credentials(options);
	                }
	                return options;
	            },
	            setPromisesDependency: function setPromisesDependency(dep) {
	                AWS.util.addPromisesToRequests(AWS.Request, dep);
	            }
	        });
	        AWS.config = new AWS.Config();
	    }, {
	        "./core": 24,
	        "./credentials": 25,
	        "./credentials/credential_provider_chain": 27
	    } ],
	    27: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {
	            constructor: function CredentialProviderChain(providers) {
	                if (providers) {
	                    this.providers = providers;
	                } else {
	                    this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	                }
	            },
	            resolve: function resolve(callback) {
	                if (this.providers.length === 0) {
	                    callback(new Error("No providers"));
	                    return this;
	                }
	                var index = 0;
	                var providers = this.providers.slice(0);
	                function resolveNext(err, creds) {
	                    if (!err && creds || index === providers.length) {
	                        callback(err, creds);
	                        return;
	                    }
	                    var provider = providers[index++];
	                    if (typeof provider === "function") {
	                        creds = provider.call();
	                    } else {
	                        creds = provider;
	                    }
	                    if (creds.get) {
	                        creds.get(function(getErr) {
	                            resolveNext(getErr, getErr ? null : creds);
	                        });
	                    } else {
	                        resolveNext(null, creds);
	                    }
	                }
	                resolveNext();
	                return this;
	            }
	        });
	        AWS.CredentialProviderChain.defaultProviders = [];
	    }, {
	        "../core": 24
	    } ],
	    25: [ function(require, module, exports) {
	        var AWS = require("./core");
	        AWS.Credentials = AWS.util.inherit({
	            constructor: function Credentials() {
	                AWS.util.hideProperties(this, [ "secretAccessKey" ]);
	                this.expired = false;
	                this.expireTime = null;
	                if (arguments.length === 1 && typeof arguments[0] === "object") {
	                    var creds = arguments[0].credentials || arguments[0];
	                    this.accessKeyId = creds.accessKeyId;
	                    this.secretAccessKey = creds.secretAccessKey;
	                    this.sessionToken = creds.sessionToken;
	                } else {
	                    this.accessKeyId = arguments[0];
	                    this.secretAccessKey = arguments[1];
	                    this.sessionToken = arguments[2];
	                }
	            },
	            expiryWindow: 15,
	            needsRefresh: function needsRefresh() {
	                var currentTime = AWS.util.date.getDate().getTime();
	                var adjustedTime = new Date(currentTime + this.expiryWindow * 1e3);
	                if (this.expireTime && adjustedTime > this.expireTime) {
	                    return true;
	                } else {
	                    return this.expired || !this.accessKeyId || !this.secretAccessKey;
	                }
	            },
	            get: function get(callback) {
	                var self = this;
	                if (this.needsRefresh()) {
	                    this.refresh(function(err) {
	                        if (!err) self.expired = false;
	                        if (callback) callback(err);
	                    });
	                } else if (callback) {
	                    callback();
	                }
	            },
	            refresh: function refresh(callback) {
	                this.expired = false;
	                callback();
	            }
	        });
	    }, {
	        "./core": 24
	    } ],
	    20: [ function(require, module, exports) {
	        (function(process, global) {
	            var formatRegExp = /%[sdj%]/g;
	            exports.format = function(f) {
	                if (!isString(f)) {
	                    var objects = [];
	                    for (var i = 0; i < arguments.length; i++) {
	                        objects.push(inspect(arguments[i]));
	                    }
	                    return objects.join(" ");
	                }
	                var i = 1;
	                var args = arguments;
	                var len = args.length;
	                var str = String(f).replace(formatRegExp, function(x) {
	                    if (x === "%%") return "%";
	                    if (i >= len) return x;
	                    switch (x) {
	                      case "%s":
	                        return String(args[i++]);
	
	                      case "%d":
	                        return Number(args[i++]);
	
	                      case "%j":
	                        try {
	                            return JSON.stringify(args[i++]);
	                        } catch (_) {
	                            return "[Circular]";
	                        }
	
	                      default:
	                        return x;
	                    }
	                });
	                for (var x = args[i]; i < len; x = args[++i]) {
	                    if (isNull(x) || !isObject(x)) {
	                        str += " " + x;
	                    } else {
	                        str += " " + inspect(x);
	                    }
	                }
	                return str;
	            };
	            exports.deprecate = function(fn, msg) {
	                if (isUndefined(global.process)) {
	                    return function() {
	                        return exports.deprecate(fn, msg).apply(this, arguments);
	                    };
	                }
	                if (process.noDeprecation === true) {
	                    return fn;
	                }
	                var warned = false;
	                function deprecated() {
	                    if (!warned) {
	                        if (process.throwDeprecation) {
	                            throw new Error(msg);
	                        } else if (process.traceDeprecation) {
	                            console.trace(msg);
	                        } else {
	                            console.error(msg);
	                        }
	                        warned = true;
	                    }
	                    return fn.apply(this, arguments);
	                }
	                return deprecated;
	            };
	            var debugs = {};
	            var debugEnviron;
	            exports.debuglog = function(set) {
	                if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || "";
	                set = set.toUpperCase();
	                if (!debugs[set]) {
	                    if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
	                        var pid = process.pid;
	                        debugs[set] = function() {
	                            var msg = exports.format.apply(exports, arguments);
	                            console.error("%s %d: %s", set, pid, msg);
	                        };
	                    } else {
	                        debugs[set] = function() {};
	                    }
	                }
	                return debugs[set];
	            };
	            function inspect(obj, opts) {
	                var ctx = {
	                    seen: [],
	                    stylize: stylizeNoColor
	                };
	                if (arguments.length >= 3) ctx.depth = arguments[2];
	                if (arguments.length >= 4) ctx.colors = arguments[3];
	                if (isBoolean(opts)) {
	                    ctx.showHidden = opts;
	                } else if (opts) {
	                    exports._extend(ctx, opts);
	                }
	                if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	                if (isUndefined(ctx.depth)) ctx.depth = 2;
	                if (isUndefined(ctx.colors)) ctx.colors = false;
	                if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	                if (ctx.colors) ctx.stylize = stylizeWithColor;
	                return formatValue(ctx, obj, ctx.depth);
	            }
	            exports.inspect = inspect;
	            inspect.colors = {
	                bold: [ 1, 22 ],
	                italic: [ 3, 23 ],
	                underline: [ 4, 24 ],
	                inverse: [ 7, 27 ],
	                white: [ 37, 39 ],
	                grey: [ 90, 39 ],
	                black: [ 30, 39 ],
	                blue: [ 34, 39 ],
	                cyan: [ 36, 39 ],
	                green: [ 32, 39 ],
	                magenta: [ 35, 39 ],
	                red: [ 31, 39 ],
	                yellow: [ 33, 39 ]
	            };
	            inspect.styles = {
	                special: "cyan",
	                number: "yellow",
	                "boolean": "yellow",
	                undefined: "grey",
	                "null": "bold",
	                string: "green",
	                date: "magenta",
	                regexp: "red"
	            };
	            function stylizeWithColor(str, styleType) {
	                var style = inspect.styles[styleType];
	                if (style) {
	                    return "[" + inspect.colors[style][0] + "m" + str + "[" + inspect.colors[style][1] + "m";
	                } else {
	                    return str;
	                }
	            }
	            function stylizeNoColor(str, styleType) {
	                return str;
	            }
	            function arrayToHash(array) {
	                var hash = {};
	                array.forEach(function(val, idx) {
	                    hash[val] = true;
	                });
	                return hash;
	            }
	            function formatValue(ctx, value, recurseTimes) {
	                if (ctx.customInspect && value && isFunction(value.inspect) && value.inspect !== exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
	                    var ret = value.inspect(recurseTimes, ctx);
	                    if (!isString(ret)) {
	                        ret = formatValue(ctx, ret, recurseTimes);
	                    }
	                    return ret;
	                }
	                var primitive = formatPrimitive(ctx, value);
	                if (primitive) {
	                    return primitive;
	                }
	                var keys = Object.keys(value);
	                var visibleKeys = arrayToHash(keys);
	                if (ctx.showHidden) {
	                    keys = Object.getOwnPropertyNames(value);
	                }
	                if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) {
	                    return formatError(value);
	                }
	                if (keys.length === 0) {
	                    if (isFunction(value)) {
	                        var name = value.name ? ": " + value.name : "";
	                        return ctx.stylize("[Function" + name + "]", "special");
	                    }
	                    if (isRegExp(value)) {
	                        return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
	                    }
	                    if (isDate(value)) {
	                        return ctx.stylize(Date.prototype.toString.call(value), "date");
	                    }
	                    if (isError(value)) {
	                        return formatError(value);
	                    }
	                }
	                var base = "", array = false, braces = [ "{", "}" ];
	                if (isArray(value)) {
	                    array = true;
	                    braces = [ "[", "]" ];
	                }
	                if (isFunction(value)) {
	                    var n = value.name ? ": " + value.name : "";
	                    base = " [Function" + n + "]";
	                }
	                if (isRegExp(value)) {
	                    base = " " + RegExp.prototype.toString.call(value);
	                }
	                if (isDate(value)) {
	                    base = " " + Date.prototype.toUTCString.call(value);
	                }
	                if (isError(value)) {
	                    base = " " + formatError(value);
	                }
	                if (keys.length === 0 && (!array || value.length == 0)) {
	                    return braces[0] + base + braces[1];
	                }
	                if (recurseTimes < 0) {
	                    if (isRegExp(value)) {
	                        return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
	                    } else {
	                        return ctx.stylize("[Object]", "special");
	                    }
	                }
	                ctx.seen.push(value);
	                var output;
	                if (array) {
	                    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	                } else {
	                    output = keys.map(function(key) {
	                        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	                    });
	                }
	                ctx.seen.pop();
	                return reduceToSingleString(output, base, braces);
	            }
	            function formatPrimitive(ctx, value) {
	                if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
	                if (isString(value)) {
	                    var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
	                    return ctx.stylize(simple, "string");
	                }
	                if (isNumber(value)) return ctx.stylize("" + value, "number");
	                if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
	                if (isNull(value)) return ctx.stylize("null", "null");
	            }
	            function formatError(value) {
	                return "[" + Error.prototype.toString.call(value) + "]";
	            }
	            function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	                var output = [];
	                for (var i = 0, l = value.length; i < l; ++i) {
	                    if (hasOwnProperty(value, String(i))) {
	                        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
	                    } else {
	                        output.push("");
	                    }
	                }
	                keys.forEach(function(key) {
	                    if (!key.match(/^\d+$/)) {
	                        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
	                    }
	                });
	                return output;
	            }
	            function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	                var name, str, desc;
	                desc = Object.getOwnPropertyDescriptor(value, key) || {
	                    value: value[key]
	                };
	                if (desc.get) {
	                    if (desc.set) {
	                        str = ctx.stylize("[Getter/Setter]", "special");
	                    } else {
	                        str = ctx.stylize("[Getter]", "special");
	                    }
	                } else {
	                    if (desc.set) {
	                        str = ctx.stylize("[Setter]", "special");
	                    }
	                }
	                if (!hasOwnProperty(visibleKeys, key)) {
	                    name = "[" + key + "]";
	                }
	                if (!str) {
	                    if (ctx.seen.indexOf(desc.value) < 0) {
	                        if (isNull(recurseTimes)) {
	                            str = formatValue(ctx, desc.value, null);
	                        } else {
	                            str = formatValue(ctx, desc.value, recurseTimes - 1);
	                        }
	                        if (str.indexOf("\n") > -1) {
	                            if (array) {
	                                str = str.split("\n").map(function(line) {
	                                    return "  " + line;
	                                }).join("\n").substr(2);
	                            } else {
	                                str = "\n" + str.split("\n").map(function(line) {
	                                    return "   " + line;
	                                }).join("\n");
	                            }
	                        }
	                    } else {
	                        str = ctx.stylize("[Circular]", "special");
	                    }
	                }
	                if (isUndefined(name)) {
	                    if (array && key.match(/^\d+$/)) {
	                        return str;
	                    }
	                    name = JSON.stringify("" + key);
	                    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	                        name = name.substr(1, name.length - 2);
	                        name = ctx.stylize(name, "name");
	                    } else {
	                        name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
	                        name = ctx.stylize(name, "string");
	                    }
	                }
	                return name + ": " + str;
	            }
	            function reduceToSingleString(output, base, braces) {
	                var numLinesEst = 0;
	                var length = output.reduce(function(prev, cur) {
	                    numLinesEst++;
	                    if (cur.indexOf("\n") >= 0) numLinesEst++;
	                    return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
	                }, 0);
	                if (length > 60) {
	                    return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
	                }
	                return braces[0] + base + " " + output.join(", ") + " " + braces[1];
	            }
	            function isArray(ar) {
	                return Array.isArray(ar);
	            }
	            exports.isArray = isArray;
	            function isBoolean(arg) {
	                return typeof arg === "boolean";
	            }
	            exports.isBoolean = isBoolean;
	            function isNull(arg) {
	                return arg === null;
	            }
	            exports.isNull = isNull;
	            function isNullOrUndefined(arg) {
	                return arg == null;
	            }
	            exports.isNullOrUndefined = isNullOrUndefined;
	            function isNumber(arg) {
	                return typeof arg === "number";
	            }
	            exports.isNumber = isNumber;
	            function isString(arg) {
	                return typeof arg === "string";
	            }
	            exports.isString = isString;
	            function isSymbol(arg) {
	                return typeof arg === "symbol";
	            }
	            exports.isSymbol = isSymbol;
	            function isUndefined(arg) {
	                return arg === void 0;
	            }
	            exports.isUndefined = isUndefined;
	            function isRegExp(re) {
	                return isObject(re) && objectToString(re) === "[object RegExp]";
	            }
	            exports.isRegExp = isRegExp;
	            function isObject(arg) {
	                return typeof arg === "object" && arg !== null;
	            }
	            exports.isObject = isObject;
	            function isDate(d) {
	                return isObject(d) && objectToString(d) === "[object Date]";
	            }
	            exports.isDate = isDate;
	            function isError(e) {
	                return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
	            }
	            exports.isError = isError;
	            function isFunction(arg) {
	                return typeof arg === "function";
	            }
	            exports.isFunction = isFunction;
	            function isPrimitive(arg) {
	                return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || typeof arg === "undefined";
	            }
	            exports.isPrimitive = isPrimitive;
	            exports.isBuffer = require("./support/isBuffer");
	            function objectToString(o) {
	                return Object.prototype.toString.call(o);
	            }
	            function pad(n) {
	                return n < 10 ? "0" + n.toString(10) : n.toString(10);
	            }
	            var months = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
	            function timestamp() {
	                var d = new Date();
	                var time = [ pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds()) ].join(":");
	                return [ d.getDate(), months[d.getMonth()], time ].join(" ");
	            }
	            exports.log = function() {
	                console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
	            };
	            exports.inherits = require("inherits");
	            exports._extend = function(origin, add) {
	                if (!add || !isObject(add)) return origin;
	                var keys = Object.keys(add);
	                var i = keys.length;
	                while (i--) {
	                    origin[keys[i]] = add[keys[i]];
	                }
	                return origin;
	            };
	            function hasOwnProperty(obj, prop) {
	                return Object.prototype.hasOwnProperty.call(obj, prop);
	            }
	        }).call(this, require("_process"), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {
	        "./support/isBuffer": 19,
	        _process: 13,
	        inherits: 12
	    } ],
	    19: [ function(require, module, exports) {
	        module.exports = function isBuffer(arg) {
	            return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
	        };
	    }, {} ],
	    18: [ function(require, module, exports) {
	        var punycode = require("punycode");
	        exports.parse = urlParse;
	        exports.resolve = urlResolve;
	        exports.resolveObject = urlResolveObject;
	        exports.format = urlFormat;
	        exports.Url = Url;
	        function Url() {
	            this.protocol = null;
	            this.slashes = null;
	            this.auth = null;
	            this.host = null;
	            this.port = null;
	            this.hostname = null;
	            this.hash = null;
	            this.search = null;
	            this.query = null;
	            this.pathname = null;
	            this.path = null;
	            this.href = null;
	        }
	        var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, delims = [ "<", ">", '"', "`", " ", "\r", "\n", "	" ], unwise = [ "{", "}", "|", "\\", "^", "`" ].concat(delims), autoEscape = [ "'" ].concat(unwise), nonHostChars = [ "%", "/", "?", ";", "#" ].concat(autoEscape), hostEndingChars = [ "/", "?", "#" ], hostnameMaxLen = 255, hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/, unsafeProtocol = {
	            javascript: true,
	            "javascript:": true
	        }, hostlessProtocol = {
	            javascript: true,
	            "javascript:": true
	        }, slashedProtocol = {
	            http: true,
	            https: true,
	            ftp: true,
	            gopher: true,
	            file: true,
	            "http:": true,
	            "https:": true,
	            "ftp:": true,
	            "gopher:": true,
	            "file:": true
	        }, querystring = require("querystring");
	        function urlParse(url, parseQueryString, slashesDenoteHost) {
	            if (url && isObject(url) && url instanceof Url) return url;
	            var u = new Url();
	            u.parse(url, parseQueryString, slashesDenoteHost);
	            return u;
	        }
	        Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	            if (!isString(url)) {
	                throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	            }
	            var rest = url;
	            rest = rest.trim();
	            var proto = protocolPattern.exec(rest);
	            if (proto) {
	                proto = proto[0];
	                var lowerProto = proto.toLowerCase();
	                this.protocol = lowerProto;
	                rest = rest.substr(proto.length);
	            }
	            if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	                var slashes = rest.substr(0, 2) === "//";
	                if (slashes && !(proto && hostlessProtocol[proto])) {
	                    rest = rest.substr(2);
	                    this.slashes = true;
	                }
	            }
	            if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
	                var hostEnd = -1;
	                for (var i = 0; i < hostEndingChars.length; i++) {
	                    var hec = rest.indexOf(hostEndingChars[i]);
	                    if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
	                }
	                var auth, atSign;
	                if (hostEnd === -1) {
	                    atSign = rest.lastIndexOf("@");
	                } else {
	                    atSign = rest.lastIndexOf("@", hostEnd);
	                }
	                if (atSign !== -1) {
	                    auth = rest.slice(0, atSign);
	                    rest = rest.slice(atSign + 1);
	                    this.auth = decodeURIComponent(auth);
	                }
	                hostEnd = -1;
	                for (var i = 0; i < nonHostChars.length; i++) {
	                    var hec = rest.indexOf(nonHostChars[i]);
	                    if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
	                }
	                if (hostEnd === -1) hostEnd = rest.length;
	                this.host = rest.slice(0, hostEnd);
	                rest = rest.slice(hostEnd);
	                this.parseHost();
	                this.hostname = this.hostname || "";
	                var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
	                if (!ipv6Hostname) {
	                    var hostparts = this.hostname.split(/\./);
	                    for (var i = 0, l = hostparts.length; i < l; i++) {
	                        var part = hostparts[i];
	                        if (!part) continue;
	                        if (!part.match(hostnamePartPattern)) {
	                            var newpart = "";
	                            for (var j = 0, k = part.length; j < k; j++) {
	                                if (part.charCodeAt(j) > 127) {
	                                    newpart += "x";
	                                } else {
	                                    newpart += part[j];
	                                }
	                            }
	                            if (!newpart.match(hostnamePartPattern)) {
	                                var validParts = hostparts.slice(0, i);
	                                var notHost = hostparts.slice(i + 1);
	                                var bit = part.match(hostnamePartStart);
	                                if (bit) {
	                                    validParts.push(bit[1]);
	                                    notHost.unshift(bit[2]);
	                                }
	                                if (notHost.length) {
	                                    rest = "/" + notHost.join(".") + rest;
	                                }
	                                this.hostname = validParts.join(".");
	                                break;
	                            }
	                        }
	                    }
	                }
	                if (this.hostname.length > hostnameMaxLen) {
	                    this.hostname = "";
	                } else {
	                    this.hostname = this.hostname.toLowerCase();
	                }
	                if (!ipv6Hostname) {
	                    var domainArray = this.hostname.split(".");
	                    var newOut = [];
	                    for (var i = 0; i < domainArray.length; ++i) {
	                        var s = domainArray[i];
	                        newOut.push(s.match(/[^A-Za-z0-9_-]/) ? "xn--" + punycode.encode(s) : s);
	                    }
	                    this.hostname = newOut.join(".");
	                }
	                var p = this.port ? ":" + this.port : "";
	                var h = this.hostname || "";
	                this.host = h + p;
	                this.href += this.host;
	                if (ipv6Hostname) {
	                    this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	                    if (rest[0] !== "/") {
	                        rest = "/" + rest;
	                    }
	                }
	            }
	            if (!unsafeProtocol[lowerProto]) {
	                for (var i = 0, l = autoEscape.length; i < l; i++) {
	                    var ae = autoEscape[i];
	                    var esc = encodeURIComponent(ae);
	                    if (esc === ae) {
	                        esc = escape(ae);
	                    }
	                    rest = rest.split(ae).join(esc);
	                }
	            }
	            var hash = rest.indexOf("#");
	            if (hash !== -1) {
	                this.hash = rest.substr(hash);
	                rest = rest.slice(0, hash);
	            }
	            var qm = rest.indexOf("?");
	            if (qm !== -1) {
	                this.search = rest.substr(qm);
	                this.query = rest.substr(qm + 1);
	                if (parseQueryString) {
	                    this.query = querystring.parse(this.query);
	                }
	                rest = rest.slice(0, qm);
	            } else if (parseQueryString) {
	                this.search = "";
	                this.query = {};
	            }
	            if (rest) this.pathname = rest;
	            if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
	                this.pathname = "/";
	            }
	            if (this.pathname || this.search) {
	                var p = this.pathname || "";
	                var s = this.search || "";
	                this.path = p + s;
	            }
	            this.href = this.format();
	            return this;
	        };
	        function urlFormat(obj) {
	            if (isString(obj)) obj = urlParse(obj);
	            if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	            return obj.format();
	        }
	        Url.prototype.format = function() {
	            var auth = this.auth || "";
	            if (auth) {
	                auth = encodeURIComponent(auth);
	                auth = auth.replace(/%3A/i, ":");
	                auth += "@";
	            }
	            var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
	            if (this.host) {
	                host = auth + this.host;
	            } else if (this.hostname) {
	                host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
	                if (this.port) {
	                    host += ":" + this.port;
	                }
	            }
	            if (this.query && isObject(this.query) && Object.keys(this.query).length) {
	                query = querystring.stringify(this.query);
	            }
	            var search = this.search || query && "?" + query || "";
	            if (protocol && protocol.substr(-1) !== ":") protocol += ":";
	            if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
	                host = "//" + (host || "");
	                if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
	            } else if (!host) {
	                host = "";
	            }
	            if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
	            if (search && search.charAt(0) !== "?") search = "?" + search;
	            pathname = pathname.replace(/[?#]/g, function(match) {
	                return encodeURIComponent(match);
	            });
	            search = search.replace("#", "%23");
	            return protocol + host + pathname + search + hash;
	        };
	        function urlResolve(source, relative) {
	            return urlParse(source, false, true).resolve(relative);
	        }
	        Url.prototype.resolve = function(relative) {
	            return this.resolveObject(urlParse(relative, false, true)).format();
	        };
	        function urlResolveObject(source, relative) {
	            if (!source) return relative;
	            return urlParse(source, false, true).resolveObject(relative);
	        }
	        Url.prototype.resolveObject = function(relative) {
	            if (isString(relative)) {
	                var rel = new Url();
	                rel.parse(relative, false, true);
	                relative = rel;
	            }
	            var result = new Url();
	            Object.keys(this).forEach(function(k) {
	                result[k] = this[k];
	            }, this);
	            result.hash = relative.hash;
	            if (relative.href === "") {
	                result.href = result.format();
	                return result;
	            }
	            if (relative.slashes && !relative.protocol) {
	                Object.keys(relative).forEach(function(k) {
	                    if (k !== "protocol") result[k] = relative[k];
	                });
	                if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
	                    result.path = result.pathname = "/";
	                }
	                result.href = result.format();
	                return result;
	            }
	            if (relative.protocol && relative.protocol !== result.protocol) {
	                if (!slashedProtocol[relative.protocol]) {
	                    Object.keys(relative).forEach(function(k) {
	                        result[k] = relative[k];
	                    });
	                    result.href = result.format();
	                    return result;
	                }
	                result.protocol = relative.protocol;
	                if (!relative.host && !hostlessProtocol[relative.protocol]) {
	                    var relPath = (relative.pathname || "").split("/");
	                    while (relPath.length && !(relative.host = relPath.shift())) ;
	                    if (!relative.host) relative.host = "";
	                    if (!relative.hostname) relative.hostname = "";
	                    if (relPath[0] !== "") relPath.unshift("");
	                    if (relPath.length < 2) relPath.unshift("");
	                    result.pathname = relPath.join("/");
	                } else {
	                    result.pathname = relative.pathname;
	                }
	                result.search = relative.search;
	                result.query = relative.query;
	                result.host = relative.host || "";
	                result.auth = relative.auth;
	                result.hostname = relative.hostname || relative.host;
	                result.port = relative.port;
	                if (result.pathname || result.search) {
	                    var p = result.pathname || "";
	                    var s = result.search || "";
	                    result.path = p + s;
	                }
	                result.slashes = result.slashes || relative.slashes;
	                result.href = result.format();
	                return result;
	            }
	            var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
	            if (psychotic) {
	                result.hostname = "";
	                result.port = null;
	                if (result.host) {
	                    if (srcPath[0] === "") srcPath[0] = result.host; else srcPath.unshift(result.host);
	                }
	                result.host = "";
	                if (relative.protocol) {
	                    relative.hostname = null;
	                    relative.port = null;
	                    if (relative.host) {
	                        if (relPath[0] === "") relPath[0] = relative.host; else relPath.unshift(relative.host);
	                    }
	                    relative.host = null;
	                }
	                mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
	            }
	            if (isRelAbs) {
	                result.host = relative.host || relative.host === "" ? relative.host : result.host;
	                result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
	                result.search = relative.search;
	                result.query = relative.query;
	                srcPath = relPath;
	            } else if (relPath.length) {
	                if (!srcPath) srcPath = [];
	                srcPath.pop();
	                srcPath = srcPath.concat(relPath);
	                result.search = relative.search;
	                result.query = relative.query;
	            } else if (!isNullOrUndefined(relative.search)) {
	                if (psychotic) {
	                    result.hostname = result.host = srcPath.shift();
	                    var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
	                    if (authInHost) {
	                        result.auth = authInHost.shift();
	                        result.host = result.hostname = authInHost.shift();
	                    }
	                }
	                result.search = relative.search;
	                result.query = relative.query;
	                if (!isNull(result.pathname) || !isNull(result.search)) {
	                    result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
	                }
	                result.href = result.format();
	                return result;
	            }
	            if (!srcPath.length) {
	                result.pathname = null;
	                if (result.search) {
	                    result.path = "/" + result.search;
	                } else {
	                    result.path = null;
	                }
	                result.href = result.format();
	                return result;
	            }
	            var last = srcPath.slice(-1)[0];
	            var hasTrailingSlash = (result.host || relative.host) && (last === "." || last === "..") || last === "";
	            var up = 0;
	            for (var i = srcPath.length; i >= 0; i--) {
	                last = srcPath[i];
	                if (last == ".") {
	                    srcPath.splice(i, 1);
	                } else if (last === "..") {
	                    srcPath.splice(i, 1);
	                    up++;
	                } else if (up) {
	                    srcPath.splice(i, 1);
	                    up--;
	                }
	            }
	            if (!mustEndAbs && !removeAllDots) {
	                for (;up--; up) {
	                    srcPath.unshift("..");
	                }
	            }
	            if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) {
	                srcPath.unshift("");
	            }
	            if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") {
	                srcPath.push("");
	            }
	            var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
	            if (psychotic) {
	                result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
	                var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
	                if (authInHost) {
	                    result.auth = authInHost.shift();
	                    result.host = result.hostname = authInHost.shift();
	                }
	            }
	            mustEndAbs = mustEndAbs || result.host && srcPath.length;
	            if (mustEndAbs && !isAbsolute) {
	                srcPath.unshift("");
	            }
	            if (!srcPath.length) {
	                result.pathname = null;
	                result.path = null;
	            } else {
	                result.pathname = srcPath.join("/");
	            }
	            if (!isNull(result.pathname) || !isNull(result.search)) {
	                result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
	            }
	            result.auth = relative.auth || result.auth;
	            result.slashes = result.slashes || relative.slashes;
	            result.href = result.format();
	            return result;
	        };
	        Url.prototype.parseHost = function() {
	            var host = this.host;
	            var port = portPattern.exec(host);
	            if (port) {
	                port = port[0];
	                if (port !== ":") {
	                    this.port = port.substr(1);
	                }
	                host = host.substr(0, host.length - port.length);
	            }
	            if (host) this.hostname = host;
	        };
	        function isString(arg) {
	            return typeof arg === "string";
	        }
	        function isObject(arg) {
	            return typeof arg === "object" && arg !== null;
	        }
	        function isNull(arg) {
	            return arg === null;
	        }
	        function isNullOrUndefined(arg) {
	            return arg == null;
	        }
	    }, {
	        punycode: 14,
	        querystring: 17
	    } ],
	    17: [ function(require, module, exports) {
	        "use strict";
	        exports.decode = exports.parse = require("./decode");
	        exports.encode = exports.stringify = require("./encode");
	    }, {
	        "./decode": 15,
	        "./encode": 16
	    } ],
	    16: [ function(require, module, exports) {
	        "use strict";
	        var stringifyPrimitive = function(v) {
	            switch (typeof v) {
	              case "string":
	                return v;
	
	              case "boolean":
	                return v ? "true" : "false";
	
	              case "number":
	                return isFinite(v) ? v : "";
	
	              default:
	                return "";
	            }
	        };
	        module.exports = function(obj, sep, eq, name) {
	            sep = sep || "&";
	            eq = eq || "=";
	            if (obj === null) {
	                obj = undefined;
	            }
	            if (typeof obj === "object") {
	                return map(objectKeys(obj), function(k) {
	                    var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	                    if (isArray(obj[k])) {
	                        return map(obj[k], function(v) {
	                            return ks + encodeURIComponent(stringifyPrimitive(v));
	                        }).join(sep);
	                    } else {
	                        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	                    }
	                }).join(sep);
	            }
	            if (!name) return "";
	            return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
	        };
	        var isArray = Array.isArray || function(xs) {
	            return Object.prototype.toString.call(xs) === "[object Array]";
	        };
	        function map(xs, f) {
	            if (xs.map) return xs.map(f);
	            var res = [];
	            for (var i = 0; i < xs.length; i++) {
	                res.push(f(xs[i], i));
	            }
	            return res;
	        }
	        var objectKeys = Object.keys || function(obj) {
	            var res = [];
	            for (var key in obj) {
	                if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	            }
	            return res;
	        };
	    }, {} ],
	    15: [ function(require, module, exports) {
	        "use strict";
	        function hasOwnProperty(obj, prop) {
	            return Object.prototype.hasOwnProperty.call(obj, prop);
	        }
	        module.exports = function(qs, sep, eq, options) {
	            sep = sep || "&";
	            eq = eq || "=";
	            var obj = {};
	            if (typeof qs !== "string" || qs.length === 0) {
	                return obj;
	            }
	            var regexp = /\+/g;
	            qs = qs.split(sep);
	            var maxKeys = 1e3;
	            if (options && typeof options.maxKeys === "number") {
	                maxKeys = options.maxKeys;
	            }
	            var len = qs.length;
	            if (maxKeys > 0 && len > maxKeys) {
	                len = maxKeys;
	            }
	            for (var i = 0; i < len; ++i) {
	                var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
	                if (idx >= 0) {
	                    kstr = x.substr(0, idx);
	                    vstr = x.substr(idx + 1);
	                } else {
	                    kstr = x;
	                    vstr = "";
	                }
	                k = decodeURIComponent(kstr);
	                v = decodeURIComponent(vstr);
	                if (!hasOwnProperty(obj, k)) {
	                    obj[k] = v;
	                } else if (isArray(obj[k])) {
	                    obj[k].push(v);
	                } else {
	                    obj[k] = [ obj[k], v ];
	                }
	            }
	            return obj;
	        };
	        var isArray = Array.isArray || function(xs) {
	            return Object.prototype.toString.call(xs) === "[object Array]";
	        };
	    }, {} ],
	    14: [ function(require, module, exports) {
	        (function(global) {
	            (function(root) {
	                var freeExports = typeof exports == "object" && exports;
	                var freeModule = typeof module == "object" && module && module.exports == freeExports && module;
	                var freeGlobal = typeof global == "object" && global;
	                if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
	                    root = freeGlobal;
	                }
	                var punycode, maxInt = 2147483647, base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", regexPunycode = /^xn--/, regexNonASCII = /[^ -~]/, regexSeparators = /\x2E|\u3002|\uFF0E|\uFF61/g, errors = {
	                    overflow: "Overflow: input needs wider integers to process",
	                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
	                    "invalid-input": "Invalid input"
	                }, baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, key;
	                function error(type) {
	                    throw RangeError(errors[type]);
	                }
	                function map(array, fn) {
	                    var length = array.length;
	                    while (length--) {
	                        array[length] = fn(array[length]);
	                    }
	                    return array;
	                }
	                function mapDomain(string, fn) {
	                    return map(string.split(regexSeparators), fn).join(".");
	                }
	                function ucs2decode(string) {
	                    var output = [], counter = 0, length = string.length, value, extra;
	                    while (counter < length) {
	                        value = string.charCodeAt(counter++);
	                        if (value >= 55296 && value <= 56319 && counter < length) {
	                            extra = string.charCodeAt(counter++);
	                            if ((extra & 64512) == 56320) {
	                                output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
	                            } else {
	                                output.push(value);
	                                counter--;
	                            }
	                        } else {
	                            output.push(value);
	                        }
	                    }
	                    return output;
	                }
	                function ucs2encode(array) {
	                    return map(array, function(value) {
	                        var output = "";
	                        if (value > 65535) {
	                            value -= 65536;
	                            output += stringFromCharCode(value >>> 10 & 1023 | 55296);
	                            value = 56320 | value & 1023;
	                        }
	                        output += stringFromCharCode(value);
	                        return output;
	                    }).join("");
	                }
	                function basicToDigit(codePoint) {
	                    if (codePoint - 48 < 10) {
	                        return codePoint - 22;
	                    }
	                    if (codePoint - 65 < 26) {
	                        return codePoint - 65;
	                    }
	                    if (codePoint - 97 < 26) {
	                        return codePoint - 97;
	                    }
	                    return base;
	                }
	                function digitToBasic(digit, flag) {
	                    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	                }
	                function adapt(delta, numPoints, firstTime) {
	                    var k = 0;
	                    delta = firstTime ? floor(delta / damp) : delta >> 1;
	                    delta += floor(delta / numPoints);
	                    for (;delta > baseMinusTMin * tMax >> 1; k += base) {
	                        delta = floor(delta / baseMinusTMin);
	                    }
	                    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	                }
	                function decode(input) {
	                    var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, baseMinusT;
	                    basic = input.lastIndexOf(delimiter);
	                    if (basic < 0) {
	                        basic = 0;
	                    }
	                    for (j = 0; j < basic; ++j) {
	                        if (input.charCodeAt(j) >= 128) {
	                            error("not-basic");
	                        }
	                        output.push(input.charCodeAt(j));
	                    }
	                    for (index = basic > 0 ? basic + 1 : 0; index < inputLength; ) {
	                        for (oldi = i, w = 1, k = base; ;k += base) {
	                            if (index >= inputLength) {
	                                error("invalid-input");
	                            }
	                            digit = basicToDigit(input.charCodeAt(index++));
	                            if (digit >= base || digit > floor((maxInt - i) / w)) {
	                                error("overflow");
	                            }
	                            i += digit * w;
	                            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	                            if (digit < t) {
	                                break;
	                            }
	                            baseMinusT = base - t;
	                            if (w > floor(maxInt / baseMinusT)) {
	                                error("overflow");
	                            }
	                            w *= baseMinusT;
	                        }
	                        out = output.length + 1;
	                        bias = adapt(i - oldi, out, oldi == 0);
	                        if (floor(i / out) > maxInt - n) {
	                            error("overflow");
	                        }
	                        n += floor(i / out);
	                        i %= out;
	                        output.splice(i++, 0, n);
	                    }
	                    return ucs2encode(output);
	                }
	                function encode(input) {
	                    var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], inputLength, handledCPCountPlusOne, baseMinusT, qMinusT;
	                    input = ucs2decode(input);
	                    inputLength = input.length;
	                    n = initialN;
	                    delta = 0;
	                    bias = initialBias;
	                    for (j = 0; j < inputLength; ++j) {
	                        currentValue = input[j];
	                        if (currentValue < 128) {
	                            output.push(stringFromCharCode(currentValue));
	                        }
	                    }
	                    handledCPCount = basicLength = output.length;
	                    if (basicLength) {
	                        output.push(delimiter);
	                    }
	                    while (handledCPCount < inputLength) {
	                        for (m = maxInt, j = 0; j < inputLength; ++j) {
	                            currentValue = input[j];
	                            if (currentValue >= n && currentValue < m) {
	                                m = currentValue;
	                            }
	                        }
	                        handledCPCountPlusOne = handledCPCount + 1;
	                        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
	                            error("overflow");
	                        }
	                        delta += (m - n) * handledCPCountPlusOne;
	                        n = m;
	                        for (j = 0; j < inputLength; ++j) {
	                            currentValue = input[j];
	                            if (currentValue < n && ++delta > maxInt) {
	                                error("overflow");
	                            }
	                            if (currentValue == n) {
	                                for (q = delta, k = base; ;k += base) {
	                                    t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	                                    if (q < t) {
	                                        break;
	                                    }
	                                    qMinusT = q - t;
	                                    baseMinusT = base - t;
	                                    output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
	                                    q = floor(qMinusT / baseMinusT);
	                                }
	                                output.push(stringFromCharCode(digitToBasic(q, 0)));
	                                bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
	                                delta = 0;
	                                ++handledCPCount;
	                            }
	                        }
	                        ++delta;
	                        ++n;
	                    }
	                    return output.join("");
	                }
	                function toUnicode(domain) {
	                    return mapDomain(domain, function(string) {
	                        return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	                    });
	                }
	                function toASCII(domain) {
	                    return mapDomain(domain, function(string) {
	                        return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
	                    });
	                }
	                punycode = {
	                    version: "1.2.4",
	                    ucs2: {
	                        decode: ucs2decode,
	                        encode: ucs2encode
	                    },
	                    decode: decode,
	                    encode: encode,
	                    toASCII: toASCII,
	                    toUnicode: toUnicode
	                };
	                if (true) {
	                    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                        return punycode;
	                    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	                } else if (freeExports && !freeExports.nodeType) {
	                    if (freeModule) {
	                        freeModule.exports = punycode;
	                    } else {
	                        for (key in punycode) {
	                            punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
	                        }
	                    }
	                } else {
	                    root.punycode = punycode;
	                }
	            })(this);
	        }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {} ],
	    13: [ function(require, module, exports) {
	        var process = module.exports = {};
	        var queue = [];
	        var draining = false;
	        function drainQueue() {
	            if (draining) {
	                return;
	            }
	            draining = true;
	            var currentQueue;
	            var len = queue.length;
	            while (len) {
	                currentQueue = queue;
	                queue = [];
	                var i = -1;
	                while (++i < len) {
	                    currentQueue[i]();
	                }
	                len = queue.length;
	            }
	            draining = false;
	        }
	        process.nextTick = function(fun) {
	            queue.push(fun);
	            if (!draining) {
	                setTimeout(drainQueue, 0);
	            }
	        };
	        process.title = "browser";
	        process.browser = true;
	        process.env = {};
	        process.argv = [];
	        process.version = "";
	        process.versions = {};
	        function noop() {}
	        process.on = noop;
	        process.addListener = noop;
	        process.once = noop;
	        process.off = noop;
	        process.removeListener = noop;
	        process.removeAllListeners = noop;
	        process.emit = noop;
	        process.binding = function(name) {
	            throw new Error("process.binding is not supported");
	        };
	        process.cwd = function() {
	            return "/";
	        };
	        process.chdir = function(dir) {
	            throw new Error("process.chdir is not supported");
	        };
	        process.umask = function() {
	            return 0;
	        };
	    }, {} ],
	    12: [ function(require, module, exports) {
	        if (typeof Object.create === "function") {
	            module.exports = function inherits(ctor, superCtor) {
	                ctor.super_ = superCtor;
	                ctor.prototype = Object.create(superCtor.prototype, {
	                    constructor: {
	                        value: ctor,
	                        enumerable: false,
	                        writable: true,
	                        configurable: true
	                    }
	                });
	            };
	        } else {
	            module.exports = function inherits(ctor, superCtor) {
	                ctor.super_ = superCtor;
	                var TempCtor = function() {};
	                TempCtor.prototype = superCtor.prototype;
	                ctor.prototype = new TempCtor();
	                ctor.prototype.constructor = ctor;
	            };
	        }
	    }, {} ],
	    6: [ function(require, module, exports) {
	        var Buffer = require("buffer").Buffer;
	        var sha = require("./sha");
	        var sha256 = require("./sha256");
	        var rng = require("./rng");
	        var md5 = require("./md5");
	        var algorithms = {
	            sha1: sha,
	            sha256: sha256,
	            md5: md5
	        };
	        var blocksize = 64;
	        var zeroBuffer = new Buffer(blocksize);
	        zeroBuffer.fill(0);
	        function hmac(fn, key, data) {
	            if (!Buffer.isBuffer(key)) key = new Buffer(key);
	            if (!Buffer.isBuffer(data)) data = new Buffer(data);
	            if (key.length > blocksize) {
	                key = fn(key);
	            } else if (key.length < blocksize) {
	                key = Buffer.concat([ key, zeroBuffer ], blocksize);
	            }
	            var ipad = new Buffer(blocksize), opad = new Buffer(blocksize);
	            for (var i = 0; i < blocksize; i++) {
	                ipad[i] = key[i] ^ 54;
	                opad[i] = key[i] ^ 92;
	            }
	            var hash = fn(Buffer.concat([ ipad, data ]));
	            return fn(Buffer.concat([ opad, hash ]));
	        }
	        function hash(alg, key) {
	            alg = alg || "sha1";
	            var fn = algorithms[alg];
	            var bufs = [];
	            var length = 0;
	            if (!fn) error("algorithm:", alg, "is not yet supported");
	            return {
	                update: function(data) {
	                    if (!Buffer.isBuffer(data)) data = new Buffer(data);
	                    bufs.push(data);
	                    length += data.length;
	                    return this;
	                },
	                digest: function(enc) {
	                    var buf = Buffer.concat(bufs);
	                    var r = key ? hmac(fn, key, buf) : fn(buf);
	                    bufs = null;
	                    return enc ? r.toString(enc) : r;
	                }
	            };
	        }
	        function error() {
	            var m = [].slice.call(arguments).join(" ");
	            throw new Error([ m, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify" ].join("\n"));
	        }
	        exports.createHash = function(alg) {
	            return hash(alg);
	        };
	        exports.createHmac = function(alg, key) {
	            return hash(alg, key);
	        };
	        exports.randomBytes = function(size, callback) {
	            if (callback && callback.call) {
	                try {
	                    callback.call(this, undefined, new Buffer(rng(size)));
	                } catch (err) {
	                    callback(err);
	                }
	            } else {
	                return new Buffer(rng(size));
	            }
	        };
	        function each(a, f) {
	            for (var i in a) f(a[i], i);
	        }
	        each([ "createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2" ], function(name) {
	            exports[name] = function() {
	                error("sorry,", name, "is not implemented yet");
	            };
	        });
	    }, {
	        "./md5": 7,
	        "./rng": 8,
	        "./sha": 9,
	        "./sha256": 10,
	        buffer: 1
	    } ],
	    10: [ function(require, module, exports) {
	        var helpers = require("./helpers");
	        var safe_add = function(x, y) {
	            var lsw = (x & 65535) + (y & 65535);
	            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	            return msw << 16 | lsw & 65535;
	        };
	        var S = function(X, n) {
	            return X >>> n | X << 32 - n;
	        };
	        var R = function(X, n) {
	            return X >>> n;
	        };
	        var Ch = function(x, y, z) {
	            return x & y ^ ~x & z;
	        };
	        var Maj = function(x, y, z) {
	            return x & y ^ x & z ^ y & z;
	        };
	        var Sigma0256 = function(x) {
	            return S(x, 2) ^ S(x, 13) ^ S(x, 22);
	        };
	        var Sigma1256 = function(x) {
	            return S(x, 6) ^ S(x, 11) ^ S(x, 25);
	        };
	        var Gamma0256 = function(x) {
	            return S(x, 7) ^ S(x, 18) ^ R(x, 3);
	        };
	        var Gamma1256 = function(x) {
	            return S(x, 17) ^ S(x, 19) ^ R(x, 10);
	        };
	        var core_sha256 = function(m, l) {
	            var K = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298);
	            var HASH = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225);
	            var W = new Array(64);
	            var a, b, c, d, e, f, g, h, i, j;
	            var T1, T2;
	            m[l >> 5] |= 128 << 24 - l % 32;
	            m[(l + 64 >> 9 << 4) + 15] = l;
	            for (var i = 0; i < m.length; i += 16) {
	                a = HASH[0];
	                b = HASH[1];
	                c = HASH[2];
	                d = HASH[3];
	                e = HASH[4];
	                f = HASH[5];
	                g = HASH[6];
	                h = HASH[7];
	                for (var j = 0; j < 64; j++) {
	                    if (j < 16) {
	                        W[j] = m[j + i];
	                    } else {
	                        W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
	                    }
	                    T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
	                    T2 = safe_add(Sigma0256(a), Maj(a, b, c));
	                    h = g;
	                    g = f;
	                    f = e;
	                    e = safe_add(d, T1);
	                    d = c;
	                    c = b;
	                    b = a;
	                    a = safe_add(T1, T2);
	                }
	                HASH[0] = safe_add(a, HASH[0]);
	                HASH[1] = safe_add(b, HASH[1]);
	                HASH[2] = safe_add(c, HASH[2]);
	                HASH[3] = safe_add(d, HASH[3]);
	                HASH[4] = safe_add(e, HASH[4]);
	                HASH[5] = safe_add(f, HASH[5]);
	                HASH[6] = safe_add(g, HASH[6]);
	                HASH[7] = safe_add(h, HASH[7]);
	            }
	            return HASH;
	        };
	        module.exports = function sha256(buf) {
	            return helpers.hash(buf, core_sha256, 32, true);
	        };
	    }, {
	        "./helpers": 5
	    } ],
	    9: [ function(require, module, exports) {
	        var helpers = require("./helpers");
	        function core_sha1(x, len) {
	            x[len >> 5] |= 128 << 24 - len % 32;
	            x[(len + 64 >> 9 << 4) + 15] = len;
	            var w = Array(80);
	            var a = 1732584193;
	            var b = -271733879;
	            var c = -1732584194;
	            var d = 271733878;
	            var e = -1009589776;
	            for (var i = 0; i < x.length; i += 16) {
	                var olda = a;
	                var oldb = b;
	                var oldc = c;
	                var oldd = d;
	                var olde = e;
	                for (var j = 0; j < 80; j++) {
	                    if (j < 16) w[j] = x[i + j]; else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
	                    var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
	                    e = d;
	                    d = c;
	                    c = rol(b, 30);
	                    b = a;
	                    a = t;
	                }
	                a = safe_add(a, olda);
	                b = safe_add(b, oldb);
	                c = safe_add(c, oldc);
	                d = safe_add(d, oldd);
	                e = safe_add(e, olde);
	            }
	            return Array(a, b, c, d, e);
	        }
	        function sha1_ft(t, b, c, d) {
	            if (t < 20) return b & c | ~b & d;
	            if (t < 40) return b ^ c ^ d;
	            if (t < 60) return b & c | b & d | c & d;
	            return b ^ c ^ d;
	        }
	        function sha1_kt(t) {
	            return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
	        }
	        function safe_add(x, y) {
	            var lsw = (x & 65535) + (y & 65535);
	            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	            return msw << 16 | lsw & 65535;
	        }
	        function rol(num, cnt) {
	            return num << cnt | num >>> 32 - cnt;
	        }
	        module.exports = function sha1(buf) {
	            return helpers.hash(buf, core_sha1, 20, true);
	        };
	    }, {
	        "./helpers": 5
	    } ],
	    8: [ function(require, module, exports) {
	        (function() {
	            var _global = this;
	            var mathRNG, whatwgRNG;
	            mathRNG = function(size) {
	                var bytes = new Array(size);
	                var r;
	                for (var i = 0, r; i < size; i++) {
	                    if ((i & 3) == 0) r = Math.random() * 4294967296;
	                    bytes[i] = r >>> ((i & 3) << 3) & 255;
	                }
	                return bytes;
	            };
	            if (_global.crypto && crypto.getRandomValues) {
	                whatwgRNG = function(size) {
	                    var bytes = new Uint8Array(size);
	                    crypto.getRandomValues(bytes);
	                    return bytes;
	                };
	            }
	            module.exports = whatwgRNG || mathRNG;
	        })();
	    }, {} ],
	    7: [ function(require, module, exports) {
	        var helpers = require("./helpers");
	        function md5_vm_test() {
	            return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
	        }
	        function core_md5(x, len) {
	            x[len >> 5] |= 128 << len % 32;
	            x[(len + 64 >>> 9 << 4) + 14] = len;
	            var a = 1732584193;
	            var b = -271733879;
	            var c = -1732584194;
	            var d = 271733878;
	            for (var i = 0; i < x.length; i += 16) {
	                var olda = a;
	                var oldb = b;
	                var oldc = c;
	                var oldd = d;
	                a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
	                d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
	                c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
	                b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
	                a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
	                d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
	                c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
	                b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
	                a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
	                d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
	                c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	                b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	                a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
	                d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	                c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	                b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
	                a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
	                d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
	                c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
	                b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
	                a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
	                d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
	                c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	                b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
	                a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
	                d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
	                c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
	                b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
	                a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
	                d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
	                c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
	                b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
	                a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
	                d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
	                c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
	                b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	                a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
	                d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
	                c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
	                b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	                a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
	                d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
	                c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
	                b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
	                a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
	                d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	                c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
	                b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
	                a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
	                d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
	                c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	                b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
	                a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
	                d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
	                c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	                b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
	                a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
	                d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	                c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
	                b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
	                a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
	                d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	                c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
	                b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
	                a = safe_add(a, olda);
	                b = safe_add(b, oldb);
	                c = safe_add(c, oldc);
	                d = safe_add(d, oldd);
	            }
	            return Array(a, b, c, d);
	        }
	        function md5_cmn(q, a, b, x, s, t) {
	            return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	        }
	        function md5_ff(a, b, c, d, x, s, t) {
	            return md5_cmn(b & c | ~b & d, a, b, x, s, t);
	        }
	        function md5_gg(a, b, c, d, x, s, t) {
	            return md5_cmn(b & d | c & ~d, a, b, x, s, t);
	        }
	        function md5_hh(a, b, c, d, x, s, t) {
	            return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	        }
	        function md5_ii(a, b, c, d, x, s, t) {
	            return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
	        }
	        function safe_add(x, y) {
	            var lsw = (x & 65535) + (y & 65535);
	            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	            return msw << 16 | lsw & 65535;
	        }
	        function bit_rol(num, cnt) {
	            return num << cnt | num >>> 32 - cnt;
	        }
	        module.exports = function md5(buf) {
	            return helpers.hash(buf, core_md5, 16);
	        };
	    }, {
	        "./helpers": 5
	    } ],
	    5: [ function(require, module, exports) {
	        var Buffer = require("buffer").Buffer;
	        var intSize = 4;
	        var zeroBuffer = new Buffer(intSize);
	        zeroBuffer.fill(0);
	        var chrsz = 8;
	        function toArray(buf, bigEndian) {
	            if (buf.length % intSize !== 0) {
	                var len = buf.length + (intSize - buf.length % intSize);
	                buf = Buffer.concat([ buf, zeroBuffer ], len);
	            }
	            var arr = [];
	            var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	            for (var i = 0; i < buf.length; i += intSize) {
	                arr.push(fn.call(buf, i));
	            }
	            return arr;
	        }
	        function toBuffer(arr, size, bigEndian) {
	            var buf = new Buffer(size);
	            var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	            for (var i = 0; i < arr.length; i++) {
	                fn.call(buf, arr[i], i * 4, true);
	            }
	            return buf;
	        }
	        function hash(buf, fn, hashSize, bigEndian) {
	            if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	            var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	            return toBuffer(arr, hashSize, bigEndian);
	        }
	        module.exports = {
	            hash: hash
	        };
	    }, {
	        buffer: 1
	    } ],
	    1: [ function(require, module, exports) {
	        var base64 = require("base64-js");
	        var ieee754 = require("ieee754");
	        var isArray = require("is-array");
	        exports.Buffer = Buffer;
	        exports.SlowBuffer = SlowBuffer;
	        exports.INSPECT_MAX_BYTES = 50;
	        Buffer.poolSize = 8192;
	        var rootParent = {};
	        Buffer.TYPED_ARRAY_SUPPORT = function() {
	            try {
	                var buf = new ArrayBuffer(0);
	                var arr = new Uint8Array(buf);
	                arr.foo = function() {
	                    return 42;
	                };
	                return arr.foo() === 42 && typeof arr.subarray === "function" && new Uint8Array(1).subarray(1, 1).byteLength === 0;
	            } catch (e) {
	                return false;
	            }
	        }();
	        function kMaxLength() {
	            return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
	        }
	        function Buffer(arg) {
	            if (!(this instanceof Buffer)) {
	                if (arguments.length > 1) return new Buffer(arg, arguments[1]);
	                return new Buffer(arg);
	            }
	            this.length = 0;
	            this.parent = undefined;
	            if (typeof arg === "number") {
	                return fromNumber(this, arg);
	            }
	            if (typeof arg === "string") {
	                return fromString(this, arg, arguments.length > 1 ? arguments[1] : "utf8");
	            }
	            return fromObject(this, arg);
	        }
	        function fromNumber(that, length) {
	            that = allocate(that, length < 0 ? 0 : checked(length) | 0);
	            if (!Buffer.TYPED_ARRAY_SUPPORT) {
	                for (var i = 0; i < length; i++) {
	                    that[i] = 0;
	                }
	            }
	            return that;
	        }
	        function fromString(that, string, encoding) {
	            if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
	            var length = byteLength(string, encoding) | 0;
	            that = allocate(that, length);
	            that.write(string, encoding);
	            return that;
	        }
	        function fromObject(that, object) {
	            if (Buffer.isBuffer(object)) return fromBuffer(that, object);
	            if (isArray(object)) return fromArray(that, object);
	            if (object == null) {
	                throw new TypeError("must start with number, buffer, array or string");
	            }
	            if (typeof ArrayBuffer !== "undefined" && object.buffer instanceof ArrayBuffer) {
	                return fromTypedArray(that, object);
	            }
	            if (object.length) return fromArrayLike(that, object);
	            return fromJsonObject(that, object);
	        }
	        function fromBuffer(that, buffer) {
	            var length = checked(buffer.length) | 0;
	            that = allocate(that, length);
	            buffer.copy(that, 0, 0, length);
	            return that;
	        }
	        function fromArray(that, array) {
	            var length = checked(array.length) | 0;
	            that = allocate(that, length);
	            for (var i = 0; i < length; i += 1) {
	                that[i] = array[i] & 255;
	            }
	            return that;
	        }
	        function fromTypedArray(that, array) {
	            var length = checked(array.length) | 0;
	            that = allocate(that, length);
	            for (var i = 0; i < length; i += 1) {
	                that[i] = array[i] & 255;
	            }
	            return that;
	        }
	        function fromArrayLike(that, array) {
	            var length = checked(array.length) | 0;
	            that = allocate(that, length);
	            for (var i = 0; i < length; i += 1) {
	                that[i] = array[i] & 255;
	            }
	            return that;
	        }
	        function fromJsonObject(that, object) {
	            var array;
	            var length = 0;
	            if (object.type === "Buffer" && isArray(object.data)) {
	                array = object.data;
	                length = checked(array.length) | 0;
	            }
	            that = allocate(that, length);
	            for (var i = 0; i < length; i += 1) {
	                that[i] = array[i] & 255;
	            }
	            return that;
	        }
	        function allocate(that, length) {
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                that = Buffer._augment(new Uint8Array(length));
	            } else {
	                that.length = length;
	                that._isBuffer = true;
	            }
	            var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1;
	            if (fromPool) that.parent = rootParent;
	            return that;
	        }
	        function checked(length) {
	            if (length >= kMaxLength()) {
	                throw new RangeError("Attempt to allocate Buffer larger than maximum " + "size: 0x" + kMaxLength().toString(16) + " bytes");
	            }
	            return length | 0;
	        }
	        function SlowBuffer(subject, encoding) {
	            if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding);
	            var buf = new Buffer(subject, encoding);
	            delete buf.parent;
	            return buf;
	        }
	        Buffer.isBuffer = function isBuffer(b) {
	            return !!(b != null && b._isBuffer);
	        };
	        Buffer.compare = function compare(a, b) {
	            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	                throw new TypeError("Arguments must be Buffers");
	            }
	            if (a === b) return 0;
	            var x = a.length;
	            var y = b.length;
	            var i = 0;
	            var len = Math.min(x, y);
	            while (i < len) {
	                if (a[i] !== b[i]) break;
	                ++i;
	            }
	            if (i !== len) {
	                x = a[i];
	                y = b[i];
	            }
	            if (x < y) return -1;
	            if (y < x) return 1;
	            return 0;
	        };
	        Buffer.isEncoding = function isEncoding(encoding) {
	            switch (String(encoding).toLowerCase()) {
	              case "hex":
	              case "utf8":
	              case "utf-8":
	              case "ascii":
	              case "binary":
	              case "base64":
	              case "raw":
	              case "ucs2":
	              case "ucs-2":
	              case "utf16le":
	              case "utf-16le":
	                return true;
	
	              default:
	                return false;
	            }
	        };
	        Buffer.concat = function concat(list, length) {
	            if (!isArray(list)) throw new TypeError("list argument must be an Array of Buffers.");
	            if (list.length === 0) {
	                return new Buffer(0);
	            } else if (list.length === 1) {
	                return list[0];
	            }
	            var i;
	            if (length === undefined) {
	                length = 0;
	                for (i = 0; i < list.length; i++) {
	                    length += list[i].length;
	                }
	            }
	            var buf = new Buffer(length);
	            var pos = 0;
	            for (i = 0; i < list.length; i++) {
	                var item = list[i];
	                item.copy(buf, pos);
	                pos += item.length;
	            }
	            return buf;
	        };
	        function byteLength(string, encoding) {
	            if (typeof string !== "string") string = "" + string;
	            var len = string.length;
	            if (len === 0) return 0;
	            var loweredCase = false;
	            for (;;) {
	                switch (encoding) {
	                  case "ascii":
	                  case "binary":
	                  case "raw":
	                  case "raws":
	                    return len;
	
	                  case "utf8":
	                  case "utf-8":
	                    return utf8ToBytes(string).length;
	
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return len * 2;
	
	                  case "hex":
	                    return len >>> 1;
	
	                  case "base64":
	                    return base64ToBytes(string).length;
	
	                  default:
	                    if (loweredCase) return utf8ToBytes(string).length;
	                    encoding = ("" + encoding).toLowerCase();
	                    loweredCase = true;
	                }
	            }
	        }
	        Buffer.byteLength = byteLength;
	        Buffer.prototype.length = undefined;
	        Buffer.prototype.parent = undefined;
	        function slowToString(encoding, start, end) {
	            var loweredCase = false;
	            start = start | 0;
	            end = end === undefined || end === Infinity ? this.length : end | 0;
	            if (!encoding) encoding = "utf8";
	            if (start < 0) start = 0;
	            if (end > this.length) end = this.length;
	            if (end <= start) return "";
	            while (true) {
	                switch (encoding) {
	                  case "hex":
	                    return hexSlice(this, start, end);
	
	                  case "utf8":
	                  case "utf-8":
	                    return utf8Slice(this, start, end);
	
	                  case "ascii":
	                    return asciiSlice(this, start, end);
	
	                  case "binary":
	                    return binarySlice(this, start, end);
	
	                  case "base64":
	                    return base64Slice(this, start, end);
	
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return utf16leSlice(this, start, end);
	
	                  default:
	                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                    encoding = (encoding + "").toLowerCase();
	                    loweredCase = true;
	                }
	            }
	        }
	        Buffer.prototype.toString = function toString() {
	            var length = this.length | 0;
	            if (length === 0) return "";
	            if (arguments.length === 0) return utf8Slice(this, 0, length);
	            return slowToString.apply(this, arguments);
	        };
	        Buffer.prototype.equals = function equals(b) {
	            if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
	            if (this === b) return true;
	            return Buffer.compare(this, b) === 0;
	        };
	        Buffer.prototype.inspect = function inspect() {
	            var str = "";
	            var max = exports.INSPECT_MAX_BYTES;
	            if (this.length > 0) {
	                str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
	                if (this.length > max) str += " ... ";
	            }
	            return "<Buffer " + str + ">";
	        };
	        Buffer.prototype.compare = function compare(b) {
	            if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
	            if (this === b) return 0;
	            return Buffer.compare(this, b);
	        };
	        Buffer.prototype.indexOf = function indexOf(val, byteOffset) {
	            if (byteOffset > 2147483647) byteOffset = 2147483647; else if (byteOffset < -2147483648) byteOffset = -2147483648;
	            byteOffset >>= 0;
	            if (this.length === 0) return -1;
	            if (byteOffset >= this.length) return -1;
	            if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0);
	            if (typeof val === "string") {
	                if (val.length === 0) return -1;
	                return String.prototype.indexOf.call(this, val, byteOffset);
	            }
	            if (Buffer.isBuffer(val)) {
	                return arrayIndexOf(this, val, byteOffset);
	            }
	            if (typeof val === "number") {
	                if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === "function") {
	                    return Uint8Array.prototype.indexOf.call(this, val, byteOffset);
	                }
	                return arrayIndexOf(this, [ val ], byteOffset);
	            }
	            function arrayIndexOf(arr, val, byteOffset) {
	                var foundIndex = -1;
	                for (var i = 0; byteOffset + i < arr.length; i++) {
	                    if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	                        if (foundIndex === -1) foundIndex = i;
	                        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex;
	                    } else {
	                        foundIndex = -1;
	                    }
	                }
	                return -1;
	            }
	            throw new TypeError("val must be string, number or Buffer");
	        };
	        Buffer.prototype.get = function get(offset) {
	            console.log(".get() is deprecated. Access using array indexes instead.");
	            return this.readUInt8(offset);
	        };
	        Buffer.prototype.set = function set(v, offset) {
	            console.log(".set() is deprecated. Access using array indexes instead.");
	            return this.writeUInt8(v, offset);
	        };
	        function hexWrite(buf, string, offset, length) {
	            offset = Number(offset) || 0;
	            var remaining = buf.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = Number(length);
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	            var strLen = string.length;
	            if (strLen % 2 !== 0) throw new Error("Invalid hex string");
	            if (length > strLen / 2) {
	                length = strLen / 2;
	            }
	            for (var i = 0; i < length; i++) {
	                var parsed = parseInt(string.substr(i * 2, 2), 16);
	                if (isNaN(parsed)) throw new Error("Invalid hex string");
	                buf[offset + i] = parsed;
	            }
	            return i;
	        }
	        function utf8Write(buf, string, offset, length) {
	            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	        }
	        function asciiWrite(buf, string, offset, length) {
	            return blitBuffer(asciiToBytes(string), buf, offset, length);
	        }
	        function binaryWrite(buf, string, offset, length) {
	            return asciiWrite(buf, string, offset, length);
	        }
	        function base64Write(buf, string, offset, length) {
	            return blitBuffer(base64ToBytes(string), buf, offset, length);
	        }
	        function ucs2Write(buf, string, offset, length) {
	            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	        }
	        Buffer.prototype.write = function write(string, offset, length, encoding) {
	            if (offset === undefined) {
	                encoding = "utf8";
	                length = this.length;
	                offset = 0;
	            } else if (length === undefined && typeof offset === "string") {
	                encoding = offset;
	                length = this.length;
	                offset = 0;
	            } else if (isFinite(offset)) {
	                offset = offset | 0;
	                if (isFinite(length)) {
	                    length = length | 0;
	                    if (encoding === undefined) encoding = "utf8";
	                } else {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {
	                var swap = encoding;
	                encoding = offset;
	                offset = length | 0;
	                length = swap;
	            }
	            var remaining = this.length - offset;
	            if (length === undefined || length > remaining) length = remaining;
	            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	                throw new RangeError("attempt to write outside buffer bounds");
	            }
	            if (!encoding) encoding = "utf8";
	            var loweredCase = false;
	            for (;;) {
	                switch (encoding) {
	                  case "hex":
	                    return hexWrite(this, string, offset, length);
	
	                  case "utf8":
	                  case "utf-8":
	                    return utf8Write(this, string, offset, length);
	
	                  case "ascii":
	                    return asciiWrite(this, string, offset, length);
	
	                  case "binary":
	                    return binaryWrite(this, string, offset, length);
	
	                  case "base64":
	                    return base64Write(this, string, offset, length);
	
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return ucs2Write(this, string, offset, length);
	
	                  default:
	                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                    encoding = ("" + encoding).toLowerCase();
	                    loweredCase = true;
	                }
	            }
	        };
	        Buffer.prototype.toJSON = function toJSON() {
	            return {
	                type: "Buffer",
	                data: Array.prototype.slice.call(this._arr || this, 0)
	            };
	        };
	        function base64Slice(buf, start, end) {
	            if (start === 0 && end === buf.length) {
	                return base64.fromByteArray(buf);
	            } else {
	                return base64.fromByteArray(buf.slice(start, end));
	            }
	        }
	        function utf8Slice(buf, start, end) {
	            var res = "";
	            var tmp = "";
	            end = Math.min(buf.length, end);
	            for (var i = start; i < end; i++) {
	                if (buf[i] <= 127) {
	                    res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i]);
	                    tmp = "";
	                } else {
	                    tmp += "%" + buf[i].toString(16);
	                }
	            }
	            return res + decodeUtf8Char(tmp);
	        }
	        function asciiSlice(buf, start, end) {
	            var ret = "";
	            end = Math.min(buf.length, end);
	            for (var i = start; i < end; i++) {
	                ret += String.fromCharCode(buf[i] & 127);
	            }
	            return ret;
	        }
	        function binarySlice(buf, start, end) {
	            var ret = "";
	            end = Math.min(buf.length, end);
	            for (var i = start; i < end; i++) {
	                ret += String.fromCharCode(buf[i]);
	            }
	            return ret;
	        }
	        function hexSlice(buf, start, end) {
	            var len = buf.length;
	            if (!start || start < 0) start = 0;
	            if (!end || end < 0 || end > len) end = len;
	            var out = "";
	            for (var i = start; i < end; i++) {
	                out += toHex(buf[i]);
	            }
	            return out;
	        }
	        function utf16leSlice(buf, start, end) {
	            var bytes = buf.slice(start, end);
	            var res = "";
	            for (var i = 0; i < bytes.length; i += 2) {
	                res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	            }
	            return res;
	        }
	        Buffer.prototype.slice = function slice(start, end) {
	            var len = this.length;
	            start = ~~start;
	            end = end === undefined ? len : ~~end;
	            if (start < 0) {
	                start += len;
	                if (start < 0) start = 0;
	            } else if (start > len) {
	                start = len;
	            }
	            if (end < 0) {
	                end += len;
	                if (end < 0) end = 0;
	            } else if (end > len) {
	                end = len;
	            }
	            if (end < start) end = start;
	            var newBuf;
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                newBuf = Buffer._augment(this.subarray(start, end));
	            } else {
	                var sliceLen = end - start;
	                newBuf = new Buffer(sliceLen, undefined);
	                for (var i = 0; i < sliceLen; i++) {
	                    newBuf[i] = this[i + start];
	                }
	            }
	            if (newBuf.length) newBuf.parent = this.parent || this;
	            return newBuf;
	        };
	        function checkOffset(offset, ext, length) {
	            if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
	            if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
	        }
	        Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) checkOffset(offset, byteLength, this.length);
	            var val = this[offset];
	            var mul = 1;
	            var i = 0;
	            while (++i < byteLength && (mul *= 256)) {
	                val += this[offset + i] * mul;
	            }
	            return val;
	        };
	        Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) {
	                checkOffset(offset, byteLength, this.length);
	            }
	            var val = this[offset + --byteLength];
	            var mul = 1;
	            while (byteLength > 0 && (mul *= 256)) {
	                val += this[offset + --byteLength] * mul;
	            }
	            return val;
	        };
	        Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 1, this.length);
	            return this[offset];
	        };
	        Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 2, this.length);
	            return this[offset] | this[offset + 1] << 8;
	        };
	        Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 2, this.length);
	            return this[offset] << 8 | this[offset + 1];
	        };
	        Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
	        };
	        Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	        };
	        Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) checkOffset(offset, byteLength, this.length);
	            var val = this[offset];
	            var mul = 1;
	            var i = 0;
	            while (++i < byteLength && (mul *= 256)) {
	                val += this[offset + i] * mul;
	            }
	            mul *= 128;
	            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	            return val;
	        };
	        Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) checkOffset(offset, byteLength, this.length);
	            var i = byteLength;
	            var mul = 1;
	            var val = this[offset + --i];
	            while (i > 0 && (mul *= 256)) {
	                val += this[offset + --i] * mul;
	            }
	            mul *= 128;
	            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	            return val;
	        };
	        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 1, this.length);
	            if (!(this[offset] & 128)) return this[offset];
	            return (255 - this[offset] + 1) * -1;
	        };
	        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 2, this.length);
	            var val = this[offset] | this[offset + 1] << 8;
	            return val & 32768 ? val | 4294901760 : val;
	        };
	        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 2, this.length);
	            var val = this[offset + 1] | this[offset] << 8;
	            return val & 32768 ? val | 4294901760 : val;
	        };
	        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	        };
	        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	        };
	        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return ieee754.read(this, offset, true, 23, 4);
	        };
	        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 4, this.length);
	            return ieee754.read(this, offset, false, 23, 4);
	        };
	        Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 8, this.length);
	            return ieee754.read(this, offset, true, 52, 8);
	        };
	        Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	            if (!noAssert) checkOffset(offset, 8, this.length);
	            return ieee754.read(this, offset, false, 52, 8);
	        };
	        function checkInt(buf, value, offset, ext, max, min) {
	            if (!Buffer.isBuffer(buf)) throw new TypeError("buffer must be a Buffer instance");
	            if (value > max || value < min) throw new RangeError("value is out of bounds");
	            if (offset + ext > buf.length) throw new RangeError("index out of range");
	        }
	        Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);
	            var mul = 1;
	            var i = 0;
	            this[offset] = value & 255;
	            while (++i < byteLength && (mul *= 256)) {
	                this[offset + i] = value / mul & 255;
	            }
	            return offset + byteLength;
	        };
	        Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            byteLength = byteLength | 0;
	            if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0);
	            var i = byteLength - 1;
	            var mul = 1;
	            this[offset + i] = value & 255;
	            while (--i >= 0 && (mul *= 256)) {
	                this[offset + i] = value / mul & 255;
	            }
	            return offset + byteLength;
	        };
	        Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
	            if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	            this[offset] = value;
	            return offset + 1;
	        };
	        function objectWriteUInt16(buf, value, offset, littleEndian) {
	            if (value < 0) value = 65535 + value + 1;
	            for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	                buf[offset + i] = (value & 255 << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	            }
	        }
	        Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value;
	                this[offset + 1] = value >>> 8;
	            } else {
	                objectWriteUInt16(this, value, offset, true);
	            }
	            return offset + 2;
	        };
	        Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value >>> 8;
	                this[offset + 1] = value;
	            } else {
	                objectWriteUInt16(this, value, offset, false);
	            }
	            return offset + 2;
	        };
	        function objectWriteUInt32(buf, value, offset, littleEndian) {
	            if (value < 0) value = 4294967295 + value + 1;
	            for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	                buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 255;
	            }
	        }
	        Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset + 3] = value >>> 24;
	                this[offset + 2] = value >>> 16;
	                this[offset + 1] = value >>> 8;
	                this[offset] = value;
	            } else {
	                objectWriteUInt32(this, value, offset, true);
	            }
	            return offset + 4;
	        };
	        Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value >>> 24;
	                this[offset + 1] = value >>> 16;
	                this[offset + 2] = value >>> 8;
	                this[offset + 3] = value;
	            } else {
	                objectWriteUInt32(this, value, offset, false);
	            }
	            return offset + 4;
	        };
	        Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) {
	                var limit = Math.pow(2, 8 * byteLength - 1);
	                checkInt(this, value, offset, byteLength, limit - 1, -limit);
	            }
	            var i = 0;
	            var mul = 1;
	            var sub = value < 0 ? 1 : 0;
	            this[offset] = value & 255;
	            while (++i < byteLength && (mul *= 256)) {
	                this[offset + i] = (value / mul >> 0) - sub & 255;
	            }
	            return offset + byteLength;
	        };
	        Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) {
	                var limit = Math.pow(2, 8 * byteLength - 1);
	                checkInt(this, value, offset, byteLength, limit - 1, -limit);
	            }
	            var i = byteLength - 1;
	            var mul = 1;
	            var sub = value < 0 ? 1 : 0;
	            this[offset + i] = value & 255;
	            while (--i >= 0 && (mul *= 256)) {
	                this[offset + i] = (value / mul >> 0) - sub & 255;
	            }
	            return offset + byteLength;
	        };
	        Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
	            if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	            if (value < 0) value = 255 + value + 1;
	            this[offset] = value;
	            return offset + 1;
	        };
	        Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value;
	                this[offset + 1] = value >>> 8;
	            } else {
	                objectWriteUInt16(this, value, offset, true);
	            }
	            return offset + 2;
	        };
	        Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value >>> 8;
	                this[offset + 1] = value;
	            } else {
	                objectWriteUInt16(this, value, offset, false);
	            }
	            return offset + 2;
	        };
	        Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value;
	                this[offset + 1] = value >>> 8;
	                this[offset + 2] = value >>> 16;
	                this[offset + 3] = value >>> 24;
	            } else {
	                objectWriteUInt32(this, value, offset, true);
	            }
	            return offset + 4;
	        };
	        Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	            value = +value;
	            offset = offset | 0;
	            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	            if (value < 0) value = 4294967295 + value + 1;
	            if (Buffer.TYPED_ARRAY_SUPPORT) {
	                this[offset] = value >>> 24;
	                this[offset + 1] = value >>> 16;
	                this[offset + 2] = value >>> 8;
	                this[offset + 3] = value;
	            } else {
	                objectWriteUInt32(this, value, offset, false);
	            }
	            return offset + 4;
	        };
	        function checkIEEE754(buf, value, offset, ext, max, min) {
	            if (value > max || value < min) throw new RangeError("value is out of bounds");
	            if (offset + ext > buf.length) throw new RangeError("index out of range");
	            if (offset < 0) throw new RangeError("index out of range");
	        }
	        function writeFloat(buf, value, offset, littleEndian, noAssert) {
	            if (!noAssert) {
	                checkIEEE754(buf, value, offset, 4, 3.4028234663852886e38, -3.4028234663852886e38);
	            }
	            ieee754.write(buf, value, offset, littleEndian, 23, 4);
	            return offset + 4;
	        }
	        Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	            return writeFloat(this, value, offset, true, noAssert);
	        };
	        Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	            return writeFloat(this, value, offset, false, noAssert);
	        };
	        function writeDouble(buf, value, offset, littleEndian, noAssert) {
	            if (!noAssert) {
	                checkIEEE754(buf, value, offset, 8, 1.7976931348623157e308, -1.7976931348623157e308);
	            }
	            ieee754.write(buf, value, offset, littleEndian, 52, 8);
	            return offset + 8;
	        }
	        Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	            return writeDouble(this, value, offset, true, noAssert);
	        };
	        Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	            return writeDouble(this, value, offset, false, noAssert);
	        };
	        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	            if (!start) start = 0;
	            if (!end && end !== 0) end = this.length;
	            if (targetStart >= target.length) targetStart = target.length;
	            if (!targetStart) targetStart = 0;
	            if (end > 0 && end < start) end = start;
	            if (end === start) return 0;
	            if (target.length === 0 || this.length === 0) return 0;
	            if (targetStart < 0) {
	                throw new RangeError("targetStart out of bounds");
	            }
	            if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
	            if (end < 0) throw new RangeError("sourceEnd out of bounds");
	            if (end > this.length) end = this.length;
	            if (target.length - targetStart < end - start) {
	                end = target.length - targetStart + start;
	            }
	            var len = end - start;
	            if (len < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT) {
	                for (var i = 0; i < len; i++) {
	                    target[i + targetStart] = this[i + start];
	                }
	            } else {
	                target._set(this.subarray(start, start + len), targetStart);
	            }
	            return len;
	        };
	        Buffer.prototype.fill = function fill(value, start, end) {
	            if (!value) value = 0;
	            if (!start) start = 0;
	            if (!end) end = this.length;
	            if (end < start) throw new RangeError("end < start");
	            if (end === start) return;
	            if (this.length === 0) return;
	            if (start < 0 || start >= this.length) throw new RangeError("start out of bounds");
	            if (end < 0 || end > this.length) throw new RangeError("end out of bounds");
	            var i;
	            if (typeof value === "number") {
	                for (i = start; i < end; i++) {
	                    this[i] = value;
	                }
	            } else {
	                var bytes = utf8ToBytes(value.toString());
	                var len = bytes.length;
	                for (i = start; i < end; i++) {
	                    this[i] = bytes[i % len];
	                }
	            }
	            return this;
	        };
	        Buffer.prototype.toArrayBuffer = function toArrayBuffer() {
	            if (typeof Uint8Array !== "undefined") {
	                if (Buffer.TYPED_ARRAY_SUPPORT) {
	                    return new Buffer(this).buffer;
	                } else {
	                    var buf = new Uint8Array(this.length);
	                    for (var i = 0, len = buf.length; i < len; i += 1) {
	                        buf[i] = this[i];
	                    }
	                    return buf.buffer;
	                }
	            } else {
	                throw new TypeError("Buffer.toArrayBuffer not supported in this browser");
	            }
	        };
	        var BP = Buffer.prototype;
	        Buffer._augment = function _augment(arr) {
	            arr.constructor = Buffer;
	            arr._isBuffer = true;
	            arr._set = arr.set;
	            arr.get = BP.get;
	            arr.set = BP.set;
	            arr.write = BP.write;
	            arr.toString = BP.toString;
	            arr.toLocaleString = BP.toString;
	            arr.toJSON = BP.toJSON;
	            arr.equals = BP.equals;
	            arr.compare = BP.compare;
	            arr.indexOf = BP.indexOf;
	            arr.copy = BP.copy;
	            arr.slice = BP.slice;
	            arr.readUIntLE = BP.readUIntLE;
	            arr.readUIntBE = BP.readUIntBE;
	            arr.readUInt8 = BP.readUInt8;
	            arr.readUInt16LE = BP.readUInt16LE;
	            arr.readUInt16BE = BP.readUInt16BE;
	            arr.readUInt32LE = BP.readUInt32LE;
	            arr.readUInt32BE = BP.readUInt32BE;
	            arr.readIntLE = BP.readIntLE;
	            arr.readIntBE = BP.readIntBE;
	            arr.readInt8 = BP.readInt8;
	            arr.readInt16LE = BP.readInt16LE;
	            arr.readInt16BE = BP.readInt16BE;
	            arr.readInt32LE = BP.readInt32LE;
	            arr.readInt32BE = BP.readInt32BE;
	            arr.readFloatLE = BP.readFloatLE;
	            arr.readFloatBE = BP.readFloatBE;
	            arr.readDoubleLE = BP.readDoubleLE;
	            arr.readDoubleBE = BP.readDoubleBE;
	            arr.writeUInt8 = BP.writeUInt8;
	            arr.writeUIntLE = BP.writeUIntLE;
	            arr.writeUIntBE = BP.writeUIntBE;
	            arr.writeUInt16LE = BP.writeUInt16LE;
	            arr.writeUInt16BE = BP.writeUInt16BE;
	            arr.writeUInt32LE = BP.writeUInt32LE;
	            arr.writeUInt32BE = BP.writeUInt32BE;
	            arr.writeIntLE = BP.writeIntLE;
	            arr.writeIntBE = BP.writeIntBE;
	            arr.writeInt8 = BP.writeInt8;
	            arr.writeInt16LE = BP.writeInt16LE;
	            arr.writeInt16BE = BP.writeInt16BE;
	            arr.writeInt32LE = BP.writeInt32LE;
	            arr.writeInt32BE = BP.writeInt32BE;
	            arr.writeFloatLE = BP.writeFloatLE;
	            arr.writeFloatBE = BP.writeFloatBE;
	            arr.writeDoubleLE = BP.writeDoubleLE;
	            arr.writeDoubleBE = BP.writeDoubleBE;
	            arr.fill = BP.fill;
	            arr.inspect = BP.inspect;
	            arr.toArrayBuffer = BP.toArrayBuffer;
	            return arr;
	        };
	        var INVALID_BASE64_RE = /[^+\/0-9A-z\-]/g;
	        function base64clean(str) {
	            str = stringtrim(str).replace(INVALID_BASE64_RE, "");
	            if (str.length < 2) return "";
	            while (str.length % 4 !== 0) {
	                str = str + "=";
	            }
	            return str;
	        }
	        function stringtrim(str) {
	            if (str.trim) return str.trim();
	            return str.replace(/^\s+|\s+$/g, "");
	        }
	        function toHex(n) {
	            if (n < 16) return "0" + n.toString(16);
	            return n.toString(16);
	        }
	        function utf8ToBytes(string, units) {
	            units = units || Infinity;
	            var codePoint;
	            var length = string.length;
	            var leadSurrogate = null;
	            var bytes = [];
	            var i = 0;
	            for (;i < length; i++) {
	                codePoint = string.charCodeAt(i);
	                if (codePoint > 55295 && codePoint < 57344) {
	                    if (leadSurrogate) {
	                        if (codePoint < 56320) {
	                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                            leadSurrogate = codePoint;
	                            continue;
	                        } else {
	                            codePoint = leadSurrogate - 55296 << 10 | codePoint - 56320 | 65536;
	                            leadSurrogate = null;
	                        }
	                    } else {
	                        if (codePoint > 56319) {
	                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                            continue;
	                        } else if (i + 1 === length) {
	                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                            continue;
	                        } else {
	                            leadSurrogate = codePoint;
	                            continue;
	                        }
	                    }
	                } else if (leadSurrogate) {
	                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                    leadSurrogate = null;
	                }
	                if (codePoint < 128) {
	                    if ((units -= 1) < 0) break;
	                    bytes.push(codePoint);
	                } else if (codePoint < 2048) {
	                    if ((units -= 2) < 0) break;
	                    bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
	                } else if (codePoint < 65536) {
	                    if ((units -= 3) < 0) break;
	                    bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                } else if (codePoint < 2097152) {
	                    if ((units -= 4) < 0) break;
	                    bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                } else {
	                    throw new Error("Invalid code point");
	                }
	            }
	            return bytes;
	        }
	        function asciiToBytes(str) {
	            var byteArray = [];
	            for (var i = 0; i < str.length; i++) {
	                byteArray.push(str.charCodeAt(i) & 255);
	            }
	            return byteArray;
	        }
	        function utf16leToBytes(str, units) {
	            var c, hi, lo;
	            var byteArray = [];
	            for (var i = 0; i < str.length; i++) {
	                if ((units -= 2) < 0) break;
	                c = str.charCodeAt(i);
	                hi = c >> 8;
	                lo = c % 256;
	                byteArray.push(lo);
	                byteArray.push(hi);
	            }
	            return byteArray;
	        }
	        function base64ToBytes(str) {
	            return base64.toByteArray(base64clean(str));
	        }
	        function blitBuffer(src, dst, offset, length) {
	            for (var i = 0; i < length; i++) {
	                if (i + offset >= dst.length || i >= src.length) break;
	                dst[i + offset] = src[i];
	            }
	            return i;
	        }
	        function decodeUtf8Char(str) {
	            try {
	                return decodeURIComponent(str);
	            } catch (err) {
	                return String.fromCharCode(65533);
	            }
	        }
	    }, {
	        "base64-js": 2,
	        ieee754: 3,
	        "is-array": 4
	    } ],
	    4: [ function(require, module, exports) {
	        var isArray = Array.isArray;
	        var str = Object.prototype.toString;
	        module.exports = isArray || function(val) {
	            return !!val && "[object Array]" == str.call(val);
	        };
	    }, {} ],
	    3: [ function(require, module, exports) {
	        exports.read = function(buffer, offset, isLE, mLen, nBytes) {
	            var e, m;
	            var eLen = nBytes * 8 - mLen - 1;
	            var eMax = (1 << eLen) - 1;
	            var eBias = eMax >> 1;
	            var nBits = -7;
	            var i = isLE ? nBytes - 1 : 0;
	            var d = isLE ? -1 : 1;
	            var s = buffer[offset + i];
	            i += d;
	            e = s & (1 << -nBits) - 1;
	            s >>= -nBits;
	            nBits += eLen;
	            for (;nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	            m = e & (1 << -nBits) - 1;
	            e >>= -nBits;
	            nBits += mLen;
	            for (;nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	            if (e === 0) {
	                e = 1 - eBias;
	            } else if (e === eMax) {
	                return m ? NaN : (s ? -1 : 1) * Infinity;
	            } else {
	                m = m + Math.pow(2, mLen);
	                e = e - eBias;
	            }
	            return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	        };
	        exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
	            var e, m, c;
	            var eLen = nBytes * 8 - mLen - 1;
	            var eMax = (1 << eLen) - 1;
	            var eBias = eMax >> 1;
	            var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	            var i = isLE ? 0 : nBytes - 1;
	            var d = isLE ? 1 : -1;
	            var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	            value = Math.abs(value);
	            if (isNaN(value) || value === Infinity) {
	                m = isNaN(value) ? 1 : 0;
	                e = eMax;
	            } else {
	                e = Math.floor(Math.log(value) / Math.LN2);
	                if (value * (c = Math.pow(2, -e)) < 1) {
	                    e--;
	                    c *= 2;
	                }
	                if (e + eBias >= 1) {
	                    value += rt / c;
	                } else {
	                    value += rt * Math.pow(2, 1 - eBias);
	                }
	                if (value * c >= 2) {
	                    e++;
	                    c /= 2;
	                }
	                if (e + eBias >= eMax) {
	                    m = 0;
	                    e = eMax;
	                } else if (e + eBias >= 1) {
	                    m = (value * c - 1) * Math.pow(2, mLen);
	                    e = e + eBias;
	                } else {
	                    m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	                    e = 0;
	                }
	            }
	            for (;mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {}
	            e = e << mLen | m;
	            eLen += mLen;
	            for (;eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {}
	            buffer[offset + i - d] |= s * 128;
	        };
	    }, {} ],
	    2: [ function(require, module, exports) {
	        var lookup = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	        (function(exports) {
	            "use strict";
	            var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
	            var PLUS = "+".charCodeAt(0);
	            var SLASH = "/".charCodeAt(0);
	            var NUMBER = "0".charCodeAt(0);
	            var LOWER = "a".charCodeAt(0);
	            var UPPER = "A".charCodeAt(0);
	            var PLUS_URL_SAFE = "-".charCodeAt(0);
	            var SLASH_URL_SAFE = "_".charCodeAt(0);
	            function decode(elt) {
	                var code = elt.charCodeAt(0);
	                if (code === PLUS || code === PLUS_URL_SAFE) return 62;
	                if (code === SLASH || code === SLASH_URL_SAFE) return 63;
	                if (code < NUMBER) return -1;
	                if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
	                if (code < UPPER + 26) return code - UPPER;
	                if (code < LOWER + 26) return code - LOWER + 26;
	            }
	            function b64ToByteArray(b64) {
	                var i, j, l, tmp, placeHolders, arr;
	                if (b64.length % 4 > 0) {
	                    throw new Error("Invalid string. Length must be a multiple of 4");
	                }
	                var len = b64.length;
	                placeHolders = "=" === b64.charAt(len - 2) ? 2 : "=" === b64.charAt(len - 1) ? 1 : 0;
	                arr = new Arr(b64.length * 3 / 4 - placeHolders);
	                l = placeHolders > 0 ? b64.length - 4 : b64.length;
	                var L = 0;
	                function push(v) {
	                    arr[L++] = v;
	                }
	                for (i = 0, j = 0; i < l; i += 4, j += 3) {
	                    tmp = decode(b64.charAt(i)) << 18 | decode(b64.charAt(i + 1)) << 12 | decode(b64.charAt(i + 2)) << 6 | decode(b64.charAt(i + 3));
	                    push((tmp & 16711680) >> 16);
	                    push((tmp & 65280) >> 8);
	                    push(tmp & 255);
	                }
	                if (placeHolders === 2) {
	                    tmp = decode(b64.charAt(i)) << 2 | decode(b64.charAt(i + 1)) >> 4;
	                    push(tmp & 255);
	                } else if (placeHolders === 1) {
	                    tmp = decode(b64.charAt(i)) << 10 | decode(b64.charAt(i + 1)) << 4 | decode(b64.charAt(i + 2)) >> 2;
	                    push(tmp >> 8 & 255);
	                    push(tmp & 255);
	                }
	                return arr;
	            }
	            function uint8ToBase64(uint8) {
	                var i, extraBytes = uint8.length % 3, output = "", temp, length;
	                function encode(num) {
	                    return lookup.charAt(num);
	                }
	                function tripletToBase64(num) {
	                    return encode(num >> 18 & 63) + encode(num >> 12 & 63) + encode(num >> 6 & 63) + encode(num & 63);
	                }
	                for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
	                    temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
	                    output += tripletToBase64(temp);
	                }
	                switch (extraBytes) {
	                  case 1:
	                    temp = uint8[uint8.length - 1];
	                    output += encode(temp >> 2);
	                    output += encode(temp << 4 & 63);
	                    output += "==";
	                    break;
	
	                  case 2:
	                    temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
	                    output += encode(temp >> 10);
	                    output += encode(temp >> 4 & 63);
	                    output += encode(temp << 2 & 63);
	                    output += "=";
	                    break;
	                }
	                return output;
	            }
	            exports.toByteArray = b64ToByteArray;
	            exports.fromByteArray = uint8ToBase64;
	        })(typeof exports === "undefined" ? this.base64js = {} : exports);
	    }, {} ]
	}, {}, []);
	
	_xamzrequire = function e(t, n, r) {
	    function s(o, u) {
	        if (!n[o]) {
	            if (!t[o]) {
	                var a = typeof _xamzrequire == "function" && _xamzrequire;
	                if (!u && a) return a(o, !0);
	                if (i) return i(o, !0);
	                var f = new Error("Cannot find module '" + o + "'");
	                throw f.code = "MODULE_NOT_FOUND", f;
	            }
	            var l = n[o] = {
	                exports: {}
	            };
	            t[o][0].call(l.exports, function(e) {
	                var n = t[o][1][e];
	                return s(n ? n : e);
	            }, l, l.exports, e, t, n, r);
	        }
	        return n[o].exports;
	    }
	    var i = typeof _xamzrequire == "function" && _xamzrequire;
	    for (var o = 0; o < r.length; o++) s(r[o]);
	    return s;
	}({
	    21: [ function(require, module, exports) {
	        var AWS = require("./core");
	        AWS.apiLoader = function(svc, version) {
	            return AWS.apiLoader.services[svc][version];
	        };
	        AWS.apiLoader.services = {};
	        AWS.XML.Parser = require("./xml/browser_parser");
	        require("./http/xhr");
	        if (typeof window !== "undefined") window.AWS = AWS;
	        if (typeof module !== "undefined") module.exports = AWS;
	        if (typeof self !== "undefined") self.AWS = AWS;
	    }, {
	        "./core": 24,
	        "./http/xhr": 38,
	        "./xml/browser_parser": 85
	    } ],
	    85: [ function(require, module, exports) {
	        var util = require("../util");
	        var Shape = require("../model/shape");
	        function DomXmlParser() {}
	        DomXmlParser.prototype.parse = function(xml, shape) {
	            if (xml.replace(/^\s+/, "") === "") return {};
	            var result, error;
	            try {
	                if (window.DOMParser) {
	                    try {
	                        var parser = new DOMParser();
	                        result = parser.parseFromString(xml, "text/xml");
	                    } catch (syntaxError) {
	                        throw util.error(new Error("Parse error in document"), {
	                            originalError: syntaxError,
	                            code: "XMLParserError",
	                            retryable: true
	                        });
	                    }
	                    if (result.documentElement === null) {
	                        throw util.error(new Error("Cannot parse empty document."), {
	                            code: "XMLParserError",
	                            retryable: true
	                        });
	                    }
	                    var isError = result.getElementsByTagName("parsererror")[0];
	                    if (isError && (isError.parentNode === result || isError.parentNode.nodeName === "body" || isError.parentNode.parentNode === result || isError.parentNode.parentNode.nodeName === "body")) {
	                        var errorElement = isError.getElementsByTagName("div")[0] || isError;
	                        throw util.error(new Error(errorElement.textContent || "Parser error in document"), {
	                            code: "XMLParserError",
	                            retryable: true
	                        });
	                    }
	                } else if (window.ActiveXObject) {
	                    result = new window.ActiveXObject("Microsoft.XMLDOM");
	                    result.async = false;
	                    if (!result.loadXML(xml)) {
	                        throw util.error(new Error("Parse error in document"), {
	                            code: "XMLParserError",
	                            retryable: true
	                        });
	                    }
	                } else {
	                    throw new Error("Cannot load XML parser");
	                }
	            } catch (e) {
	                error = e;
	            }
	            if (result && result.documentElement && !error) {
	                var data = parseXml(result.documentElement, shape);
	                var metadata = result.getElementsByTagName("ResponseMetadata")[0];
	                if (metadata) {
	                    data.ResponseMetadata = parseXml(metadata, {});
	                }
	                return data;
	            } else if (error) {
	                throw util.error(error || new Error(), {
	                    code: "XMLParserError",
	                    retryable: true
	                });
	            } else {
	                return {};
	            }
	        };
	        function parseXml(xml, shape) {
	            if (!shape) shape = {};
	            switch (shape.type) {
	              case "structure":
	                return parseStructure(xml, shape);
	
	              case "map":
	                return parseMap(xml, shape);
	
	              case "list":
	                return parseList(xml, shape);
	
	              case undefined:
	              case null:
	                return parseUnknown(xml);
	
	              default:
	                return parseScalar(xml, shape);
	            }
	        }
	        function parseStructure(xml, shape) {
	            var data = {};
	            if (xml === null) return data;
	            util.each(shape.members, function(memberName, memberShape) {
	                if (memberShape.isXmlAttribute) {
	                    if (xml.attributes.hasOwnProperty(memberShape.name)) {
	                        var value = xml.attributes[memberShape.name].value;
	                        data[memberName] = parseXml({
	                            textContent: value
	                        }, memberShape);
	                    }
	                } else {
	                    var xmlChild = memberShape.flattened ? xml : xml.getElementsByTagName(memberShape.name)[0];
	                    if (xmlChild) {
	                        data[memberName] = parseXml(xmlChild, memberShape);
	                    } else if (!memberShape.flattened && memberShape.type === "list") {
	                        data[memberName] = memberShape.defaultValue;
	                    }
	                }
	            });
	            return data;
	        }
	        function parseMap(xml, shape) {
	            var data = {};
	            var xmlKey = shape.key.name || "key";
	            var xmlValue = shape.value.name || "value";
	            var tagName = shape.flattened ? shape.name : "entry";
	            var child = xml.firstElementChild;
	            while (child) {
	                if (child.nodeName === tagName) {
	                    var key = child.getElementsByTagName(xmlKey)[0].textContent;
	                    var value = child.getElementsByTagName(xmlValue)[0];
	                    data[key] = parseXml(value, shape.value);
	                }
	                child = child.nextElementSibling;
	            }
	            return data;
	        }
	        function parseList(xml, shape) {
	            var data = [];
	            var tagName = shape.flattened ? shape.name : shape.member.name || "member";
	            var child = xml.firstElementChild;
	            while (child) {
	                if (child.nodeName === tagName) {
	                    data.push(parseXml(child, shape.member));
	                }
	                child = child.nextElementSibling;
	            }
	            return data;
	        }
	        function parseScalar(xml, shape) {
	            if (xml.getAttribute) {
	                var encoding = xml.getAttribute("encoding");
	                if (encoding === "base64") {
	                    shape = new Shape.create({
	                        type: encoding
	                    });
	                }
	            }
	            var text = xml.textContent;
	            if (text === "") text = null;
	            if (typeof shape.toType === "function") {
	                return shape.toType(text);
	            } else {
	                return text;
	            }
	        }
	        function parseUnknown(xml) {
	            if (xml === undefined || xml === null) return "";
	            if (!xml.firstElementChild) {
	                if (xml.parentNode.parentNode === null) return {};
	                if (xml.childNodes.length === 0) return ""; else return xml.textContent;
	            }
	            var shape = {
	                type: "structure",
	                members: {}
	            };
	            var child = xml.firstElementChild;
	            while (child) {
	                var tag = child.nodeName;
	                if (shape.members.hasOwnProperty(tag)) {
	                    shape.members[tag].type = "list";
	                } else {
	                    shape.members[tag] = {
	                        name: tag
	                    };
	                }
	                child = child.nextElementSibling;
	            }
	            return parseStructure(xml, shape);
	        }
	        module.exports = DomXmlParser;
	    }, {
	        "../model/shape": 46,
	        "../util": 84
	    } ],
	    38: [ function(require, module, exports) {
	        var AWS = require("../core");
	        var EventEmitter = require("events").EventEmitter;
	        require("../http");
	        AWS.XHRClient = AWS.util.inherit({
	            handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
	                var self = this;
	                var endpoint = httpRequest.endpoint;
	                var emitter = new EventEmitter();
	                var href = endpoint.protocol + "//" + endpoint.hostname;
	                if (endpoint.port !== 80 && endpoint.port !== 443) {
	                    href += ":" + endpoint.port;
	                }
	                href += httpRequest.path;
	                var xhr = new XMLHttpRequest(), headersEmitted = false;
	                httpRequest.stream = xhr;
	                xhr.addEventListener("readystatechange", function() {
	                    try {
	                        if (xhr.status === 0) return;
	                    } catch (e) {
	                        return;
	                    }
	                    if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
	                        try {
	                            xhr.responseType = "arraybuffer";
	                        } catch (e) {}
	                        emitter.statusCode = xhr.status;
	                        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
	                        emitter.emit("headers", emitter.statusCode, emitter.headers);
	                        headersEmitted = true;
	                    }
	                    if (this.readyState === this.DONE) {
	                        self.finishRequest(xhr, emitter);
	                    }
	                }, false);
	                xhr.upload.addEventListener("progress", function(evt) {
	                    emitter.emit("sendProgress", evt);
	                });
	                xhr.addEventListener("progress", function(evt) {
	                    emitter.emit("receiveProgress", evt);
	                }, false);
	                xhr.addEventListener("timeout", function() {
	                    errCallback(AWS.util.error(new Error("Timeout"), {
	                        code: "TimeoutError"
	                    }));
	                }, false);
	                xhr.addEventListener("error", function() {
	                    errCallback(AWS.util.error(new Error("Network Failure"), {
	                        code: "NetworkingError"
	                    }));
	                }, false);
	                callback(emitter);
	                xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
	                AWS.util.each(httpRequest.headers, function(key, value) {
	                    if (key !== "Content-Length" && key !== "User-Agent" && key !== "Host") {
	                        xhr.setRequestHeader(key, value);
	                    }
	                });
	                if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
	                    xhr.timeout = httpOptions.timeout;
	                }
	                if (httpOptions.xhrWithCredentials) {
	                    xhr.withCredentials = true;
	                }
	                try {
	                    xhr.send(httpRequest.body);
	                } catch (err) {
	                    if (httpRequest.body && typeof httpRequest.body.buffer === "object") {
	                        xhr.send(httpRequest.body.buffer);
	                    } else {
	                        throw err;
	                    }
	                }
	                return emitter;
	            },
	            parseHeaders: function parseHeaders(rawHeaders) {
	                var headers = {};
	                AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function(line) {
	                    var key = line.split(":", 1)[0];
	                    var value = line.substring(key.length + 2);
	                    if (key.length > 0) headers[key.toLowerCase()] = value;
	                });
	                return headers;
	            },
	            finishRequest: function finishRequest(xhr, emitter) {
	                var buffer;
	                if (xhr.responseType === "arraybuffer" && xhr.response) {
	                    var ab = xhr.response;
	                    buffer = new AWS.util.Buffer(ab.byteLength);
	                    var view = new Uint8Array(ab);
	                    for (var i = 0; i < buffer.length; ++i) {
	                        buffer[i] = view[i];
	                    }
	                }
	                try {
	                    if (!buffer && typeof xhr.responseText === "string") {
	                        buffer = new AWS.util.Buffer(xhr.responseText);
	                    }
	                } catch (e) {}
	                if (buffer) emitter.emit("data", buffer);
	                emitter.emit("end");
	            }
	        });
	        AWS.HttpClient.prototype = AWS.XHRClient.prototype;
	        AWS.HttpClient.streamsApiVersion = 1;
	    }, {
	        "../core": 24,
	        "../http": 37,
	        events: 11
	    } ],
	    11: [ function(require, module, exports) {
	        function EventEmitter() {
	            this._events = this._events || {};
	            this._maxListeners = this._maxListeners || undefined;
	        }
	        module.exports = EventEmitter;
	        EventEmitter.EventEmitter = EventEmitter;
	        EventEmitter.prototype._events = undefined;
	        EventEmitter.prototype._maxListeners = undefined;
	        EventEmitter.defaultMaxListeners = 10;
	        EventEmitter.prototype.setMaxListeners = function(n) {
	            if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
	            this._maxListeners = n;
	            return this;
	        };
	        EventEmitter.prototype.emit = function(type) {
	            var er, handler, len, args, i, listeners;
	            if (!this._events) this._events = {};
	            if (type === "error") {
	                if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
	                    er = arguments[1];
	                    if (er instanceof Error) {
	                        throw er;
	                    }
	                    throw TypeError('Uncaught, unspecified "error" event.');
	                }
	            }
	            handler = this._events[type];
	            if (isUndefined(handler)) return false;
	            if (isFunction(handler)) {
	                switch (arguments.length) {
	                  case 1:
	                    handler.call(this);
	                    break;
	
	                  case 2:
	                    handler.call(this, arguments[1]);
	                    break;
	
	                  case 3:
	                    handler.call(this, arguments[1], arguments[2]);
	                    break;
	
	                  default:
	                    len = arguments.length;
	                    args = new Array(len - 1);
	                    for (i = 1; i < len; i++) args[i - 1] = arguments[i];
	                    handler.apply(this, args);
	                }
	            } else if (isObject(handler)) {
	                len = arguments.length;
	                args = new Array(len - 1);
	                for (i = 1; i < len; i++) args[i - 1] = arguments[i];
	                listeners = handler.slice();
	                len = listeners.length;
	                for (i = 0; i < len; i++) listeners[i].apply(this, args);
	            }
	            return true;
	        };
	        EventEmitter.prototype.addListener = function(type, listener) {
	            var m;
	            if (!isFunction(listener)) throw TypeError("listener must be a function");
	            if (!this._events) this._events = {};
	            if (this._events.newListener) this.emit("newListener", type, isFunction(listener.listener) ? listener.listener : listener);
	            if (!this._events[type]) this._events[type] = listener; else if (isObject(this._events[type])) this._events[type].push(listener); else this._events[type] = [ this._events[type], listener ];
	            if (isObject(this._events[type]) && !this._events[type].warned) {
	                var m;
	                if (!isUndefined(this._maxListeners)) {
	                    m = this._maxListeners;
	                } else {
	                    m = EventEmitter.defaultMaxListeners;
	                }
	                if (m && m > 0 && this._events[type].length > m) {
	                    this._events[type].warned = true;
	                    console.error("(node) warning: possible EventEmitter memory " + "leak detected. %d listeners added. " + "Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
	                    if (typeof console.trace === "function") {
	                        console.trace();
	                    }
	                }
	            }
	            return this;
	        };
	        EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	        EventEmitter.prototype.once = function(type, listener) {
	            if (!isFunction(listener)) throw TypeError("listener must be a function");
	            var fired = false;
	            function g() {
	                this.removeListener(type, g);
	                if (!fired) {
	                    fired = true;
	                    listener.apply(this, arguments);
	                }
	            }
	            g.listener = listener;
	            this.on(type, g);
	            return this;
	        };
	        EventEmitter.prototype.removeListener = function(type, listener) {
	            var list, position, length, i;
	            if (!isFunction(listener)) throw TypeError("listener must be a function");
	            if (!this._events || !this._events[type]) return this;
	            list = this._events[type];
	            length = list.length;
	            position = -1;
	            if (list === listener || isFunction(list.listener) && list.listener === listener) {
	                delete this._events[type];
	                if (this._events.removeListener) this.emit("removeListener", type, listener);
	            } else if (isObject(list)) {
	                for (i = length; i-- > 0; ) {
	                    if (list[i] === listener || list[i].listener && list[i].listener === listener) {
	                        position = i;
	                        break;
	                    }
	                }
	                if (position < 0) return this;
	                if (list.length === 1) {
	                    list.length = 0;
	                    delete this._events[type];
	                } else {
	                    list.splice(position, 1);
	                }
	                if (this._events.removeListener) this.emit("removeListener", type, listener);
	            }
	            return this;
	        };
	        EventEmitter.prototype.removeAllListeners = function(type) {
	            var key, listeners;
	            if (!this._events) return this;
	            if (!this._events.removeListener) {
	                if (arguments.length === 0) this._events = {}; else if (this._events[type]) delete this._events[type];
	                return this;
	            }
	            if (arguments.length === 0) {
	                for (key in this._events) {
	                    if (key === "removeListener") continue;
	                    this.removeAllListeners(key);
	                }
	                this.removeAllListeners("removeListener");
	                this._events = {};
	                return this;
	            }
	            listeners = this._events[type];
	            if (isFunction(listeners)) {
	                this.removeListener(type, listeners);
	            } else {
	                while (listeners.length) this.removeListener(type, listeners[listeners.length - 1]);
	            }
	            delete this._events[type];
	            return this;
	        };
	        EventEmitter.prototype.listeners = function(type) {
	            var ret;
	            if (!this._events || !this._events[type]) ret = []; else if (isFunction(this._events[type])) ret = [ this._events[type] ]; else ret = this._events[type].slice();
	            return ret;
	        };
	        EventEmitter.listenerCount = function(emitter, type) {
	            var ret;
	            if (!emitter._events || !emitter._events[type]) ret = 0; else if (isFunction(emitter._events[type])) ret = 1; else ret = emitter._events[type].length;
	            return ret;
	        };
	        function isFunction(arg) {
	            return typeof arg === "function";
	        }
	        function isNumber(arg) {
	            return typeof arg === "number";
	        }
	        function isObject(arg) {
	            return typeof arg === "object" && arg !== null;
	        }
	        function isUndefined(arg) {
	            return arg === void 0;
	        }
	    }, {} ]
	}, {}, [ 21 ]);AWS.apiLoader.services["s3"] = {};
	
	AWS.S3 = AWS.Service.defineService("s3", [ "2006-03-01" ]);
	
	_xamzrequire = function e(t, n, r) {
	    function s(o, u) {
	        if (!n[o]) {
	            if (!t[o]) {
	                var a = typeof _xamzrequire == "function" && _xamzrequire;
	                if (!u && a) return a(o, !0);
	                if (i) return i(o, !0);
	                var f = new Error("Cannot find module '" + o + "'");
	                throw f.code = "MODULE_NOT_FOUND", f;
	            }
	            var l = n[o] = {
	                exports: {}
	            };
	            t[o][0].call(l.exports, function(e) {
	                var n = t[o][1][e];
	                return s(n ? n : e);
	            }, l, l.exports, e, t, n, r);
	        }
	        return n[o].exports;
	    }
	    var i = typeof _xamzrequire == "function" && _xamzrequire;
	    for (var o = 0; o < r.length; o++) s(r[o]);
	    return s;
	}({
	    72: [ function(require, module, exports) {
	        var AWS = require("../core");
	        require("../s3/managed_upload");
	        var operationsWith200StatusCodeError = {
	            completeMultipartUpload: true,
	            copyObject: true,
	            uploadPartCopy: true
	        };
	        var regionRedirectErrorCodes = [ "AuthorizationHeaderMalformed", "BadRequest", "PermanentRedirect", 301 ];
	        AWS.util.update(AWS.S3.prototype, {
	            getSignerClass: function getSignerClass(request) {
	                var defaultApiVersion = this.api.signatureVersion;
	                var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
	                var regionDefinedVersion = this.config.signatureVersion;
	                var isPresigned = request ? request.isPresigned() : false;
	                if (userDefinedVersion) {
	                    userDefinedVersion = userDefinedVersion === "v2" ? "s3" : userDefinedVersion;
	                    return AWS.Signers.RequestSigner.getVersion(userDefinedVersion);
	                }
	                if (isPresigned !== true) {
	                    defaultApiVersion = "v4";
	                } else if (regionDefinedVersion) {
	                    defaultApiVersion = regionDefinedVersion;
	                }
	                return AWS.Signers.RequestSigner.getVersion(defaultApiVersion);
	            },
	            validateService: function validateService() {
	                if (!this.config.region) this.config.region = "us-east-1";
	                if (!this.config.endpoint && this.config.s3BucketEndpoint) {
	                    var msg = "An endpoint must be provided when configuring " + "`s3BucketEndpoint` to true.";
	                    throw AWS.util.error(new Error(), {
	                        name: "InvalidEndpoint",
	                        message: msg
	                    });
	                }
	            },
	            shouldDisableBodySigning: function shouldDisableBodySigning(request) {
	                var signerClass = this.getSignerClass();
	                if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4 && request.httpRequest.endpoint.protocol === "https:") {
	                    return true;
	                }
	                return false;
	            },
	            setupRequestListeners: function setupRequestListeners(request) {
	                request.addListener("validate", this.validateScheme);
	                request.addListener("validate", this.validateBucketEndpoint);
	                request.addListener("validate", this.correctBucketRegionFromCache);
	                request.addListener("build", this.addContentType);
	                request.addListener("build", this.populateURI);
	                request.addListener("build", this.computeContentMd5);
	                request.addListener("build", this.computeSseCustomerKeyMd5);
	                request.addListener("afterBuild", this.addExpect100Continue);
	                request.removeListener("validate", AWS.EventListeners.Core.VALIDATE_REGION);
	                request.addListener("extractError", this.extractError);
	                request.onAsync("extractError", this.requestBucketRegion);
	                request.addListener("extractData", this.extractData);
	                request.addListener("extractData", AWS.util.hoistPayloadMember);
	                request.addListener("beforePresign", this.prepareSignedUrl);
	                if (AWS.util.isBrowser()) {
	                    request.onAsync("retry", this.reqRegionForNetworkingError);
	                }
	                if (this.shouldDisableBodySigning(request)) {
	                    request.removeListener("afterBuild", AWS.EventListeners.Core.COMPUTE_SHA256);
	                    request.addListener("afterBuild", this.disableBodySigning);
	                }
	            },
	            validateScheme: function(req) {
	                var params = req.params, scheme = req.httpRequest.endpoint.protocol, sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
	                if (sensitive && scheme !== "https:") {
	                    var msg = "Cannot send SSE keys over HTTP. Set 'sslEnabled'" + "to 'true' in your configuration";
	                    throw AWS.util.error(new Error(), {
	                        code: "ConfigError",
	                        message: msg
	                    });
	                }
	            },
	            validateBucketEndpoint: function(req) {
	                if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
	                    var msg = "Cannot send requests to root API with `s3BucketEndpoint` set.";
	                    throw AWS.util.error(new Error(), {
	                        code: "ConfigError",
	                        message: msg
	                    });
	                }
	            },
	            isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
	                var invalidOperations = [ "createBucket", "deleteBucket", "listBuckets" ];
	                return invalidOperations.indexOf(operation) === -1;
	            },
	            populateURI: function populateURI(req) {
	                var httpRequest = req.httpRequest;
	                var b = req.params.Bucket;
	                var service = req.service;
	                var endpoint = httpRequest.endpoint;
	                if (b) {
	                    if (!service.pathStyleBucketName(b)) {
	                        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
	                            endpoint.hostname = b + ".s3-accelerate.amazonaws.com";
	                        } else if (!service.config.s3BucketEndpoint) {
	                            endpoint.hostname = b + "." + endpoint.hostname;
	                        }
	                        var port = endpoint.port;
	                        if (port !== 80 && port !== 443) {
	                            endpoint.host = endpoint.hostname + ":" + endpoint.port;
	                        } else {
	                            endpoint.host = endpoint.hostname;
	                        }
	                        httpRequest.virtualHostedBucket = b;
	                        service.removeVirtualHostedBucketFromPath(req);
	                    }
	                }
	            },
	            removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
	                var httpRequest = req.httpRequest;
	                var bucket = httpRequest.virtualHostedBucket;
	                if (bucket && httpRequest.path) {
	                    httpRequest.path = httpRequest.path.replace(new RegExp("/" + bucket), "");
	                    if (httpRequest.path[0] !== "/") {
	                        httpRequest.path = "/" + httpRequest.path;
	                    }
	                }
	            },
	            addExpect100Continue: function addExpect100Continue(req) {
	                var len = req.httpRequest.headers["Content-Length"];
	                if (AWS.util.isNode() && len >= 1024 * 1024) {
	                    req.httpRequest.headers["Expect"] = "100-continue";
	                }
	            },
	            addContentType: function addContentType(req) {
	                var httpRequest = req.httpRequest;
	                if (httpRequest.method === "GET" || httpRequest.method === "HEAD") {
	                    delete httpRequest.headers["Content-Type"];
	                    return;
	                }
	                if (!httpRequest.headers["Content-Type"]) {
	                    httpRequest.headers["Content-Type"] = "application/octet-stream";
	                }
	                var contentType = httpRequest.headers["Content-Type"];
	                if (AWS.util.isBrowser()) {
	                    if (typeof httpRequest.body === "string" && !contentType.match(/;\s*charset=/)) {
	                        var charset = "; charset=UTF-8";
	                        httpRequest.headers["Content-Type"] += charset;
	                    } else {
	                        var replaceFn = function(_, prefix, charsetName) {
	                            return prefix + charsetName.toUpperCase();
	                        };
	                        httpRequest.headers["Content-Type"] = contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
	                    }
	                }
	            },
	            computableChecksumOperations: {
	                putBucketCors: true,
	                putBucketLifecycle: true,
	                putBucketLifecycleConfiguration: true,
	                putBucketTagging: true,
	                deleteObjects: true,
	                putBucketReplication: true
	            },
	            willComputeChecksums: function willComputeChecksums(req) {
	                if (this.computableChecksumOperations[req.operation]) return true;
	                if (!this.config.computeChecksums) return false;
	                if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) && typeof req.httpRequest.body !== "string") {
	                    return false;
	                }
	                var rules = req.service.api.operations[req.operation].input.members;
	                if (req.service.shouldDisableBodySigning(req) && !req.httpRequest.headers.hasOwnProperty("presigned-expires")) {
	                    if (rules.ContentMD5 && !req.params.ContentMD5) {
	                        return true;
	                    }
	                }
	                if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	                    if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
	                }
	                if (rules.ContentMD5 && !req.params.ContentMD5) return true;
	            },
	            computeContentMd5: function computeContentMd5(req) {
	                if (req.service.willComputeChecksums(req)) {
	                    var md5 = AWS.util.crypto.md5(req.httpRequest.body, "base64");
	                    req.httpRequest.headers["Content-MD5"] = md5;
	                }
	            },
	            computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
	                var keys = {
	                    SSECustomerKey: "x-amz-server-side-encryption-customer-key-MD5",
	                    CopySourceSSECustomerKey: "x-amz-copy-source-server-side-encryption-customer-key-MD5"
	                };
	                AWS.util.each(keys, function(key, header) {
	                    if (req.params[key]) {
	                        var value = AWS.util.crypto.md5(req.params[key], "base64");
	                        req.httpRequest.headers[header] = value;
	                    }
	                });
	            },
	            pathStyleBucketName: function pathStyleBucketName(bucketName) {
	                if (this.config.s3ForcePathStyle) return true;
	                if (this.config.s3BucketEndpoint) return false;
	                if (this.dnsCompatibleBucketName(bucketName)) {
	                    return this.config.sslEnabled && bucketName.match(/\./) ? true : false;
	                } else {
	                    return true;
	                }
	            },
	            dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
	                var b = bucketName;
	                var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
	                var ipAddress = new RegExp(/(\d+\.){3}\d+/);
	                var dots = new RegExp(/\.\./);
	                return b.match(domain) && !b.match(ipAddress) && !b.match(dots) ? true : false;
	            },
	            successfulResponse: function successfulResponse(resp) {
	                var req = resp.request;
	                var httpResponse = resp.httpResponse;
	                if (operationsWith200StatusCodeError[req.operation] && httpResponse.body.toString().match("<Error>")) {
	                    return false;
	                } else {
	                    return httpResponse.statusCode < 300;
	                }
	            },
	            retryableError: function retryableError(error, request) {
	                if (operationsWith200StatusCodeError[request.operation] && error.statusCode === 200) {
	                    return true;
	                } else if (request._requestRegionForBucket && request.service.bucketRegionCache[request._requestRegionForBucket]) {
	                    return false;
	                } else if (error && error.code === "RequestTimeout") {
	                    return true;
	                } else if (error && regionRedirectErrorCodes.indexOf(error.code) != -1 && error.region && error.region != request.httpRequest.region) {
	                    request.httpRequest.region = error.region;
	                    if (error.statusCode === 301) {
	                        request.service.updateReqBucketRegion(request);
	                    }
	                    return true;
	                } else {
	                    var _super = AWS.Service.prototype.retryableError;
	                    return _super.call(this, error, request);
	                }
	            },
	            updateReqBucketRegion: function updateReqBucketRegion(request, region) {
	                var httpRequest = request.httpRequest;
	                if (typeof region === "string" && region.length) {
	                    httpRequest.region = region;
	                }
	                if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
	                    return;
	                }
	                var service = request.service;
	                var s3Config = service.config;
	                var s3BucketEndpoint = s3Config.s3BucketEndpoint;
	                if (s3BucketEndpoint) {
	                    delete s3Config.s3BucketEndpoint;
	                }
	                var newConfig = AWS.util.copy(s3Config);
	                delete newConfig.endpoint;
	                newConfig.region = httpRequest.region;
	                httpRequest.endpoint = new AWS.S3(newConfig).endpoint;
	                service.populateURI(request);
	                s3Config.s3BucketEndpoint = s3BucketEndpoint;
	                httpRequest.headers.Host = httpRequest.endpoint.host;
	                if (request._asm.currentState === "validate") {
	                    request.removeListener("build", service.populateURI);
	                    request.addListener("build", service.removeVirtualHostedBucketFromPath);
	                }
	            },
	            extractData: function extractData(resp) {
	                var req = resp.request;
	                if (req.operation === "getBucketLocation") {
	                    var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
	                    delete resp.data["_"];
	                    if (match) {
	                        resp.data.LocationConstraint = match[1];
	                    } else {
	                        resp.data.LocationConstraint = "";
	                    }
	                }
	                var bucket = req.params.Bucket || null;
	                if (req.operation === "deleteBucket" && typeof bucket === "string" && !resp.error) {
	                    req.service.clearBucketRegionCache(bucket);
	                } else {
	                    var headers = resp.httpResponse.headers || {};
	                    var region = headers["x-amz-bucket-region"] || null;
	                    if (!region && req.operation === "createBucket" && !resp.error) {
	                        var createBucketConfiguration = req.params.CreateBucketConfiguration;
	                        if (!createBucketConfiguration) {
	                            region = "us-east-1";
	                        } else if (createBucketConfiguration.LocationConstraint === "EU") {
	                            region = "eu-west-1";
	                        } else {
	                            region = createBucketConfiguration.LocationConstraint;
	                        }
	                    }
	                    if (region) {
	                        if (bucket && region !== req.service.bucketRegionCache[bucket]) {
	                            req.service.bucketRegionCache[bucket] = region;
	                        }
	                    }
	                }
	                req.service.extractRequestIds(resp);
	            },
	            extractError: function extractError(resp) {
	                var codes = {
	                    304: "NotModified",
	                    403: "Forbidden",
	                    400: "BadRequest",
	                    404: "NotFound"
	                };
	                var req = resp.request;
	                var code = resp.httpResponse.statusCode;
	                var body = resp.httpResponse.body || "";
	                var headers = resp.httpResponse.headers || {};
	                var region = headers["x-amz-bucket-region"] || null;
	                var bucket = req.params.Bucket || null;
	                var bucketRegionCache = req.service.bucketRegionCache;
	                if (region && bucket && region !== bucketRegionCache[bucket]) {
	                    bucketRegionCache[bucket] = region;
	                }
	                var cachedRegion;
	                if (codes[code] && body.length === 0) {
	                    if (bucket && !region) {
	                        cachedRegion = bucketRegionCache[bucket] || null;
	                        if (cachedRegion !== req.httpRequest.region) {
	                            region = cachedRegion;
	                        }
	                    }
	                    resp.error = AWS.util.error(new Error(), {
	                        code: codes[code],
	                        message: null,
	                        region: region
	                    });
	                } else {
	                    var data = new AWS.XML.Parser().parse(body.toString());
	                    if (data.Region && !region) {
	                        region = data.Region;
	                        if (bucket && region !== bucketRegionCache[bucket]) {
	                            bucketRegionCache[bucket] = region;
	                        }
	                    } else if (bucket && !region && !data.Region) {
	                        cachedRegion = bucketRegionCache[bucket] || null;
	                        if (cachedRegion !== req.httpRequest.region) {
	                            region = cachedRegion;
	                        }
	                    }
	                    resp.error = AWS.util.error(new Error(), {
	                        code: data.Code || code,
	                        message: data.Message || null,
	                        region: region
	                    });
	                }
	                req.service.extractRequestIds(resp);
	            },
	            requestBucketRegion: function requestBucketRegion(resp, done) {
	                var error = resp.error;
	                var req = resp.request;
	                var bucket = req.params.Bucket || null;
	                if (!error || !bucket || error.region || req.operation === "listObjects" || AWS.util.isNode() && req.operation === "headBucket" || error.statusCode === 400 && req.operation !== "headObject" || regionRedirectErrorCodes.indexOf(error.code) === -1) {
	                    return done();
	                }
	                var regionReq = req.service.listObjects({
	                    Bucket: bucket,
	                    MaxKeys: 0
	                });
	                regionReq._requestRegionForBucket = bucket;
	                regionReq.send(function() {
	                    var region = req.service.bucketRegionCache[bucket] || null;
	                    error.region = region;
	                    done();
	                });
	            },
	            reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
	                if (!AWS.util.isBrowser()) {
	                    return done();
	                }
	                var error = resp.error;
	                var request = resp.request;
	                var bucket = request.params.Bucket;
	                if (!error || error.code !== "NetworkingError" || !bucket || request.httpRequest.region === "us-east-1") {
	                    return done();
	                }
	                var service = request.service;
	                var bucketRegionCache = service.bucketRegionCache;
	                var cachedRegion = bucketRegionCache[bucket] || null;
	                if (cachedRegion && cachedRegion !== request.httpRequest.region) {
	                    service.updateReqBucketRegion(request, cachedRegion);
	                    done();
	                } else if (!service.dnsCompatibleBucketName(bucket)) {
	                    service.updateReqBucketRegion(request, "us-east-1");
	                    if (bucketRegionCache[bucket] !== "us-east-1") {
	                        bucketRegionCache[bucket] = "us-east-1";
	                    }
	                    done();
	                } else if (request.httpRequest.virtualHostedBucket) {
	                    var getRegionReq = service.listObjects({
	                        Bucket: bucket,
	                        MaxKeys: 0
	                    });
	                    service.updateReqBucketRegion(getRegionReq, "us-east-1");
	                    getRegionReq._requestRegionForBucket = bucket;
	                    getRegionReq.send(function() {
	                        var region = service.bucketRegionCache[bucket] || null;
	                        if (region && region !== request.httpRequest.region) {
	                            service.updateReqBucketRegion(request, region);
	                        }
	                        done();
	                    });
	                } else {
	                    done();
	                }
	            },
	            bucketRegionCache: {},
	            clearBucketRegionCache: function(buckets) {
	                var bucketRegionCache = this.bucketRegionCache;
	                if (!buckets) {
	                    buckets = Object.keys(bucketRegionCache);
	                } else if (typeof buckets === "string") {
	                    buckets = [ buckets ];
	                }
	                for (var i = 0; i < buckets.length; i++) {
	                    delete bucketRegionCache[buckets[i]];
	                }
	                return bucketRegionCache;
	            },
	            correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
	                var bucket = req.params.Bucket || null;
	                if (bucket) {
	                    var service = req.service;
	                    var requestRegion = req.httpRequest.region;
	                    var cachedRegion = service.bucketRegionCache[bucket];
	                    if (cachedRegion && cachedRegion !== requestRegion) {
	                        service.updateReqBucketRegion(req, cachedRegion);
	                    }
	                }
	            },
	            extractRequestIds: function extractRequestIds(resp) {
	                var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers["x-amz-id-2"] : null;
	                var cfId = resp.httpResponse.headers ? resp.httpResponse.headers["x-amz-cf-id"] : null;
	                resp.extendedRequestId = extendedRequestId;
	                resp.cfId = cfId;
	                if (resp.error) {
	                    resp.error.requestId = resp.requestId || null;
	                    resp.error.extendedRequestId = extendedRequestId;
	                    resp.error.cfId = cfId;
	                }
	            },
	            getSignedUrl: function getSignedUrl(operation, params, callback) {
	                params = AWS.util.copy(params || {});
	                var expires = params.Expires || 900;
	                delete params.Expires;
	                var request = this.makeRequest(operation, params);
	                return request.presign(expires, callback);
	            },
	            prepareSignedUrl: function prepareSignedUrl(request) {
	                request.addListener("validate", request.service.noPresignedContentLength);
	                request.removeListener("build", request.service.addContentType);
	                if (!request.params.Body) {
	                    request.removeListener("build", request.service.computeContentMd5);
	                } else {
	                    request.addListener("afterBuild", AWS.EventListeners.Core.COMPUTE_SHA256);
	                }
	            },
	            disableBodySigning: function disableBodySigning(request) {
	                request.service.validateStreamBody(request.httpRequest.body || "");
	                var headers = request.httpRequest.headers;
	                if (!headers.hasOwnProperty("presigned-expires")) {
	                    headers["X-Amz-Content-Sha256"] = "UNSIGNED-PAYLOAD";
	                }
	            },
	            noPresignedContentLength: function noPresignedContentLength(request) {
	                if (request.params.ContentLength !== undefined) {
	                    throw AWS.util.error(new Error(), {
	                        code: "UnexpectedParameter",
	                        message: "ContentLength is not supported in pre-signed URLs."
	                    });
	                }
	            },
	            validateStreamBody: function validateStreamBody(body) {
	                if (AWS.util.isNode()) {
	                    var Stream = AWS.util.nodeRequire("stream").Stream;
	                    if (body instanceof Stream) {
	                        if (typeof body.path !== "string") {
	                            throw new Error("Non-file stream objects are not supported with SigV4");
	                        }
	                    }
	                }
	            },
	            createBucket: function createBucket(params, callback) {
	                if (typeof params === "function" || !params) {
	                    callback = callback || params;
	                    params = {};
	                }
	                var hostname = this.endpoint.hostname;
	                if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
	                    params.CreateBucketConfiguration = {
	                        LocationConstraint: this.config.region
	                    };
	                }
	                return this.makeRequest("createBucket", params, callback);
	            },
	            upload: function upload(params, options, callback) {
	                if (typeof options === "function" && callback === undefined) {
	                    callback = options;
	                    options = null;
	                }
	                options = options || {};
	                options = AWS.util.merge(options || {}, {
	                    service: this,
	                    params: params
	                });
	                var uploader = new AWS.S3.ManagedUpload(options);
	                if (typeof callback === "function") uploader.send(callback);
	                return uploader;
	            }
	        });
	    }, {
	        "../core": 24,
	        "../s3/managed_upload": 59
	    } ],
	    59: [ function(require, module, exports) {
	        (function(Buffer) {
	            var AWS = require("../core");
	            var byteLength = AWS.util.string.byteLength;
	            AWS.S3.ManagedUpload = AWS.util.inherit({
	                constructor: function ManagedUpload(options) {
	                    var self = this;
	                    AWS.SequentialExecutor.call(self);
	                    self.body = null;
	                    self.sliceFn = null;
	                    self.callback = null;
	                    self.parts = {};
	                    self.completeInfo = [];
	                    self.fillQueue = function() {
	                        self.callback(new Error("Unsupported body payload " + typeof self.body));
	                    };
	                    self.configure(options);
	                },
	                configure: function configure(options) {
	                    options = options || {};
	                    this.partSize = this.minPartSize;
	                    if (options.queueSize) this.queueSize = options.queueSize;
	                    if (options.partSize) this.partSize = options.partSize;
	                    if (options.leavePartsOnError) this.leavePartsOnError = true;
	                    if (this.partSize < this.minPartSize) {
	                        throw new Error("partSize must be greater than " + this.minPartSize);
	                    }
	                    this.service = options.service;
	                    this.bindServiceObject(options.params);
	                    this.validateBody();
	                    this.adjustTotalBytes();
	                },
	                leavePartsOnError: false,
	                queueSize: 4,
	                partSize: null,
	                minPartSize: 1024 * 1024 * 5,
	                maxTotalParts: 1e4,
	                send: function(callback) {
	                    var self = this;
	                    self.failed = false;
	                    self.callback = callback || function(err) {
	                        if (err) throw err;
	                    };
	                    var runFill = true;
	                    if (self.sliceFn) {
	                        self.fillQueue = self.fillBuffer;
	                    } else if (AWS.util.isNode()) {
	                        var Stream = AWS.util.nodeRequire("stream").Stream;
	                        if (self.body instanceof Stream) {
	                            runFill = false;
	                            self.fillQueue = self.fillStream;
	                            self.partBuffers = [];
	                            self.body.on("readable", function() {
	                                self.fillQueue();
	                            }).on("end", function() {
	                                self.isDoneChunking = true;
	                                self.numParts = self.totalPartNumbers;
	                                self.fillQueue.call(self);
	                            });
	                        }
	                    }
	                    if (runFill) self.fillQueue.call(self);
	                },
	                abort: function() {
	                    this.cleanup(AWS.util.error(new Error("Request aborted by user"), {
	                        code: "RequestAbortedError",
	                        retryable: false
	                    }));
	                },
	                validateBody: function validateBody() {
	                    var self = this;
	                    self.body = self.service.config.params.Body;
	                    if (!self.body) throw new Error("params.Body is required");
	                    if (typeof self.body === "string") {
	                        self.body = new AWS.util.Buffer(self.body);
	                    }
	                    self.sliceFn = AWS.util.arraySliceFn(self.body);
	                },
	                bindServiceObject: function bindServiceObject(params) {
	                    params = params || {};
	                    var self = this;
	                    if (!self.service) {
	                        self.service = new AWS.S3({
	                            params: params
	                        });
	                    } else {
	                        var config = AWS.util.copy(self.service.config);
	                        self.service = new self.service.constructor.__super__(config);
	                        self.service.config.params = AWS.util.merge(self.service.config.params || {}, params);
	                    }
	                },
	                adjustTotalBytes: function adjustTotalBytes() {
	                    var self = this;
	                    try {
	                        self.totalBytes = byteLength(self.body);
	                    } catch (e) {}
	                    if (self.totalBytes) {
	                        var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
	                        if (newPartSize > self.partSize) self.partSize = newPartSize;
	                    } else {
	                        self.totalBytes = undefined;
	                    }
	                },
	                isDoneChunking: false,
	                partPos: 0,
	                totalChunkedBytes: 0,
	                totalUploadedBytes: 0,
	                totalBytes: undefined,
	                numParts: 0,
	                totalPartNumbers: 0,
	                activeParts: 0,
	                doneParts: 0,
	                parts: null,
	                completeInfo: null,
	                failed: false,
	                multipartReq: null,
	                partBuffers: null,
	                partBufferLength: 0,
	                fillBuffer: function fillBuffer() {
	                    var self = this;
	                    var bodyLen = byteLength(self.body);
	                    if (bodyLen === 0) {
	                        self.isDoneChunking = true;
	                        self.numParts = 1;
	                        self.nextChunk(self.body);
	                        return;
	                    }
	                    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
	                        var endPos = Math.min(self.partPos + self.partSize, bodyLen);
	                        var buf = self.sliceFn.call(self.body, self.partPos, endPos);
	                        self.partPos += self.partSize;
	                        if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
	                            self.isDoneChunking = true;
	                            self.numParts = self.totalPartNumbers + 1;
	                        }
	                        self.nextChunk(buf);
	                    }
	                },
	                fillStream: function fillStream() {
	                    var self = this;
	                    if (self.activeParts >= self.queueSize) return;
	                    var buf = self.body.read(self.partSize - self.partBufferLength) || self.body.read();
	                    if (buf) {
	                        self.partBuffers.push(buf);
	                        self.partBufferLength += buf.length;
	                        self.totalChunkedBytes += buf.length;
	                    }
	                    if (self.partBufferLength >= self.partSize) {
	                        var pbuf = self.partBuffers.length === 1 ? self.partBuffers[0] : Buffer.concat(self.partBuffers);
	                        self.partBuffers = [];
	                        self.partBufferLength = 0;
	                        if (pbuf.length > self.partSize) {
	                            var rest = pbuf.slice(self.partSize);
	                            self.partBuffers.push(rest);
	                            self.partBufferLength += rest.length;
	                            pbuf = pbuf.slice(0, self.partSize);
	                        }
	                        self.nextChunk(pbuf);
	                    }
	                    if (self.isDoneChunking && !self.isDoneSending) {
	                        pbuf = self.partBuffers.length === 1 ? self.partBuffers[0] : Buffer.concat(self.partBuffers);
	                        self.partBuffers = [];
	                        self.partBufferLength = 0;
	                        self.totalBytes = self.totalChunkedBytes;
	                        self.isDoneSending = true;
	                        if (self.numParts === 0 || pbuf.length > 0) {
	                            self.numParts++;
	                            self.nextChunk(pbuf);
	                        }
	                    }
	                    self.body.read(0);
	                },
	                nextChunk: function nextChunk(chunk) {
	                    var self = this;
	                    if (self.failed) return null;
	                    var partNumber = ++self.totalPartNumbers;
	                    if (self.isDoneChunking && partNumber === 1) {
	                        var req = self.service.putObject({
	                            Body: chunk
	                        });
	                        req._managedUpload = self;
	                        req.on("httpUploadProgress", self.progress).send(self.finishSinglePart);
	                        return null;
	                    } else if (self.service.config.params.ContentMD5) {
	                        var err = AWS.util.error(new Error("The Content-MD5 you specified is invalid for multi-part uploads."), {
	                            code: "InvalidDigest",
	                            retryable: false
	                        });
	                        self.cleanup(err);
	                        return null;
	                    }
	                    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
	                        return null;
	                    }
	                    self.activeParts++;
	                    if (!self.service.config.params.UploadId) {
	                        if (!self.multipartReq) {
	                            self.multipartReq = self.service.createMultipartUpload();
	                            self.multipartReq.on("success", function(resp) {
	                                self.service.config.params.UploadId = resp.data.UploadId;
	                                self.multipartReq = null;
	                            });
	                            self.queueChunks(chunk, partNumber);
	                            self.multipartReq.on("error", function(err) {
	                                self.cleanup(err);
	                            });
	                            self.multipartReq.send();
	                        } else {
	                            self.queueChunks(chunk, partNumber);
	                        }
	                    } else {
	                        self.uploadPart(chunk, partNumber);
	                    }
	                },
	                uploadPart: function uploadPart(chunk, partNumber) {
	                    var self = this;
	                    var partParams = {
	                        Body: chunk,
	                        ContentLength: AWS.util.string.byteLength(chunk),
	                        PartNumber: partNumber
	                    };
	                    var partInfo = {
	                        ETag: null,
	                        PartNumber: partNumber
	                    };
	                    self.completeInfo[partNumber] = partInfo;
	                    var req = self.service.uploadPart(partParams);
	                    self.parts[partNumber] = req;
	                    req._lastUploadedBytes = 0;
	                    req._managedUpload = self;
	                    req.on("httpUploadProgress", self.progress);
	                    req.send(function(err, data) {
	                        delete self.parts[partParams.PartNumber];
	                        self.activeParts--;
	                        if (!err && (!data || !data.ETag)) {
	                            var message = "No access to ETag property on response.";
	                            if (AWS.util.isBrowser()) {
	                                message += " Check CORS configuration to expose ETag header.";
	                            }
	                            err = AWS.util.error(new Error(message), {
	                                code: "ETagMissing",
	                                retryable: false
	                            });
	                        }
	                        if (err) return self.cleanup(err);
	                        partInfo.ETag = data.ETag;
	                        self.doneParts++;
	                        if (self.isDoneChunking && self.doneParts === self.numParts) {
	                            self.finishMultiPart();
	                        } else {
	                            self.fillQueue.call(self);
	                        }
	                    });
	                },
	                queueChunks: function queueChunks(chunk, partNumber) {
	                    var self = this;
	                    self.multipartReq.on("success", function() {
	                        self.uploadPart(chunk, partNumber);
	                    });
	                },
	                cleanup: function cleanup(err) {
	                    var self = this;
	                    if (self.failed) return;
	                    if (typeof self.body.removeAllListeners === "function" && typeof self.body.resume === "function") {
	                        self.body.removeAllListeners("readable");
	                        self.body.removeAllListeners("end");
	                        self.body.resume();
	                    }
	                    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
	                        self.service.abortMultipartUpload().send();
	                    }
	                    AWS.util.each(self.parts, function(partNumber, part) {
	                        part.removeAllListeners("complete");
	                        part.abort();
	                    });
	                    self.activeParts = 0;
	                    self.partPos = 0;
	                    self.numParts = 0;
	                    self.totalPartNumbers = 0;
	                    self.parts = {};
	                    self.failed = true;
	                    self.callback(err);
	                },
	                finishMultiPart: function finishMultiPart() {
	                    var self = this;
	                    var completeParams = {
	                        MultipartUpload: {
	                            Parts: self.completeInfo.slice(1)
	                        }
	                    };
	                    self.service.completeMultipartUpload(completeParams, function(err, data) {
	                        if (err) return self.cleanup(err); else self.callback(err, data);
	                    });
	                },
	                finishSinglePart: function finishSinglePart(err, data) {
	                    var upload = this.request._managedUpload;
	                    var httpReq = this.request.httpRequest;
	                    var endpoint = httpReq.endpoint;
	                    if (err) return upload.callback(err);
	                    data.Location = [ endpoint.protocol, "//", endpoint.host, httpReq.path ].join("");
	                    data.key = this.request.params.Key;
	                    data.Key = this.request.params.Key;
	                    data.Bucket = this.request.params.Bucket;
	                    upload.callback(err, data);
	                },
	                progress: function progress(info) {
	                    var upload = this._managedUpload;
	                    if (this.operation === "putObject") {
	                        info.part = 1;
	                        info.key = this.params.Key;
	                    } else {
	                        upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
	                        this._lastUploadedBytes = info.loaded;
	                        info = {
	                            loaded: upload.totalUploadedBytes,
	                            total: upload.totalBytes,
	                            part: this.params.PartNumber,
	                            key: this.params.Key
	                        };
	                    }
	                    upload.emit("httpUploadProgress", [ info ]);
	                }
	            });
	            AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);
	            module.exports = AWS.S3.ManagedUpload;
	        }).call(this, require("buffer").Buffer);
	    }, {
	        "../core": 24,
	        buffer: 1
	    } ]
	}, {}, [ 72 ]);AWS.apiLoader.services["s3"]["2006-03-01"] = {
	    version: "2.0",
	    metadata: {
	        apiVersion: "2006-03-01",
	        checksumFormat: "md5",
	        endpointPrefix: "s3",
	        globalEndpoint: "s3.amazonaws.com",
	        protocol: "rest-xml",
	        serviceAbbreviation: "Amazon S3",
	        serviceFullName: "Amazon Simple Storage Service",
	        signatureVersion: "s3",
	        timestampFormat: "rfc822"
	    },
	    operations: {
	        AbortMultipartUpload: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key", "UploadId" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    UploadId: {
	                        location: "querystring",
	                        locationName: "uploadId"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        CompleteMultipartUpload: {
	            http: {
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key", "UploadId" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    MultipartUpload: {
	                        locationName: "CompleteMultipartUpload",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            Parts: {
	                                locationName: "Part",
	                                type: "list",
	                                member: {
	                                    type: "structure",
	                                    members: {
	                                        ETag: {},
	                                        PartNumber: {
	                                            type: "integer"
	                                        }
	                                    }
	                                },
	                                flattened: true
	                            }
	                        }
	                    },
	                    UploadId: {
	                        location: "querystring",
	                        locationName: "uploadId"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                },
	                payload: "MultipartUpload"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Location: {},
	                    Bucket: {},
	                    Key: {},
	                    Expiration: {
	                        location: "header",
	                        locationName: "x-amz-expiration"
	                    },
	                    ETag: {},
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        CopyObject: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "CopySource", "Key" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CacheControl: {
	                        location: "header",
	                        locationName: "Cache-Control"
	                    },
	                    ContentDisposition: {
	                        location: "header",
	                        locationName: "Content-Disposition"
	                    },
	                    ContentEncoding: {
	                        location: "header",
	                        locationName: "Content-Encoding"
	                    },
	                    ContentLanguage: {
	                        location: "header",
	                        locationName: "Content-Language"
	                    },
	                    ContentType: {
	                        location: "header",
	                        locationName: "Content-Type"
	                    },
	                    CopySource: {
	                        location: "header",
	                        locationName: "x-amz-copy-source"
	                    },
	                    CopySourceIfMatch: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-match"
	                    },
	                    CopySourceIfModifiedSince: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-modified-since",
	                        type: "timestamp"
	                    },
	                    CopySourceIfNoneMatch: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-none-match"
	                    },
	                    CopySourceIfUnmodifiedSince: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-unmodified-since",
	                        type: "timestamp"
	                    },
	                    Expires: {
	                        location: "header",
	                        locationName: "Expires",
	                        type: "timestamp"
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    Metadata: {
	                        shape: "S11",
	                        location: "headers",
	                        locationName: "x-amz-meta-"
	                    },
	                    MetadataDirective: {
	                        location: "header",
	                        locationName: "x-amz-metadata-directive"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    StorageClass: {
	                        location: "header",
	                        locationName: "x-amz-storage-class"
	                    },
	                    WebsiteRedirectLocation: {
	                        location: "header",
	                        locationName: "x-amz-website-redirect-location"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    CopySourceSSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-algorithm"
	                    },
	                    CopySourceSSECustomerKey: {
	                        shape: "S1b",
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-key"
	                    },
	                    CopySourceSSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-key-MD5"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    CopyObjectResult: {
	                        type: "structure",
	                        members: {
	                            ETag: {},
	                            LastModified: {
	                                type: "timestamp"
	                            }
	                        }
	                    },
	                    Expiration: {
	                        location: "header",
	                        locationName: "x-amz-expiration"
	                    },
	                    CopySourceVersionId: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-version-id"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                },
	                payload: "CopyObjectResult"
	            },
	            alias: "PutObjectCopy"
	        },
	        CreateBucket: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CreateBucketConfiguration: {
	                        locationName: "CreateBucketConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            LocationConstraint: {}
	                        }
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWrite: {
	                        location: "header",
	                        locationName: "x-amz-grant-write"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    }
	                },
	                payload: "CreateBucketConfiguration"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Location: {
	                        location: "header",
	                        locationName: "Location"
	                    }
	                }
	            },
	            alias: "PutBucket"
	        },
	        CreateMultipartUpload: {
	            http: {
	                requestUri: "/{Bucket}/{Key+}?uploads"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CacheControl: {
	                        location: "header",
	                        locationName: "Cache-Control"
	                    },
	                    ContentDisposition: {
	                        location: "header",
	                        locationName: "Content-Disposition"
	                    },
	                    ContentEncoding: {
	                        location: "header",
	                        locationName: "Content-Encoding"
	                    },
	                    ContentLanguage: {
	                        location: "header",
	                        locationName: "Content-Language"
	                    },
	                    ContentType: {
	                        location: "header",
	                        locationName: "Content-Type"
	                    },
	                    Expires: {
	                        location: "header",
	                        locationName: "Expires",
	                        type: "timestamp"
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    Metadata: {
	                        shape: "S11",
	                        location: "headers",
	                        locationName: "x-amz-meta-"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    StorageClass: {
	                        location: "header",
	                        locationName: "x-amz-storage-class"
	                    },
	                    WebsiteRedirectLocation: {
	                        location: "header",
	                        locationName: "x-amz-website-redirect-location"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    AbortDate: {
	                        location: "header",
	                        locationName: "x-amz-abort-date",
	                        type: "timestamp"
	                    },
	                    AbortRuleId: {
	                        location: "header",
	                        locationName: "x-amz-abort-rule-id"
	                    },
	                    Bucket: {
	                        locationName: "Bucket"
	                    },
	                    Key: {},
	                    UploadId: {},
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            },
	            alias: "InitiateMultipartUpload"
	        },
	        DeleteBucket: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketCors: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?cors"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketLifecycle: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?lifecycle"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketPolicy: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?policy"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketReplication: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?replication"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketTagging: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?tagging"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteBucketWebsite: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}?website"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        DeleteObject: {
	            http: {
	                method: "DELETE",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    MFA: {
	                        location: "header",
	                        locationName: "x-amz-mfa"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    DeleteMarker: {
	                        location: "header",
	                        locationName: "x-amz-delete-marker",
	                        type: "boolean"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        DeleteObjects: {
	            http: {
	                requestUri: "/{Bucket}?delete"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Delete" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Delete: {
	                        locationName: "Delete",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "Objects" ],
	                        members: {
	                            Objects: {
	                                locationName: "Object",
	                                type: "list",
	                                member: {
	                                    type: "structure",
	                                    required: [ "Key" ],
	                                    members: {
	                                        Key: {},
	                                        VersionId: {}
	                                    }
	                                },
	                                flattened: true
	                            },
	                            Quiet: {
	                                type: "boolean"
	                            }
	                        }
	                    },
	                    MFA: {
	                        location: "header",
	                        locationName: "x-amz-mfa"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                },
	                payload: "Delete"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Deleted: {
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                Key: {},
	                                VersionId: {},
	                                DeleteMarker: {
	                                    type: "boolean"
	                                },
	                                DeleteMarkerVersionId: {}
	                            }
	                        },
	                        flattened: true
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    },
	                    Errors: {
	                        locationName: "Error",
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                Key: {},
	                                VersionId: {},
	                                Code: {},
	                                Message: {}
	                            }
	                        },
	                        flattened: true
	                    }
	                }
	            },
	            alias: "DeleteMultipleObjects"
	        },
	        GetBucketAccelerateConfiguration: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?accelerate"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Status: {}
	                }
	            }
	        },
	        GetBucketAcl: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?acl"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Owner: {
	                        shape: "S2k"
	                    },
	                    Grants: {
	                        shape: "S2n",
	                        locationName: "AccessControlList"
	                    }
	                }
	            }
	        },
	        GetBucketCors: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?cors"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    CORSRules: {
	                        shape: "S2w",
	                        locationName: "CORSRule"
	                    }
	                }
	            }
	        },
	        GetBucketLifecycle: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?lifecycle"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Rules: {
	                        shape: "S39",
	                        locationName: "Rule"
	                    }
	                }
	            },
	            deprecated: true
	        },
	        GetBucketLifecycleConfiguration: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?lifecycle"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Rules: {
	                        shape: "S3p",
	                        locationName: "Rule"
	                    }
	                }
	            }
	        },
	        GetBucketLocation: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?location"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    LocationConstraint: {}
	                }
	            }
	        },
	        GetBucketLogging: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?logging"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    LoggingEnabled: {
	                        shape: "S3x"
	                    }
	                }
	            }
	        },
	        GetBucketNotification: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?notification"
	            },
	            input: {
	                shape: "S43"
	            },
	            output: {
	                shape: "S44"
	            },
	            deprecated: true
	        },
	        GetBucketNotificationConfiguration: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?notification"
	            },
	            input: {
	                shape: "S43"
	            },
	            output: {
	                shape: "S4f"
	            }
	        },
	        GetBucketPolicy: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?policy"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Policy: {}
	                },
	                payload: "Policy"
	            }
	        },
	        GetBucketReplication: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?replication"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    ReplicationConfiguration: {
	                        shape: "S4y"
	                    }
	                },
	                payload: "ReplicationConfiguration"
	            }
	        },
	        GetBucketRequestPayment: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?requestPayment"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Payer: {}
	                }
	            }
	        },
	        GetBucketTagging: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?tagging"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                required: [ "TagSet" ],
	                members: {
	                    TagSet: {
	                        shape: "S59"
	                    }
	                }
	            }
	        },
	        GetBucketVersioning: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?versioning"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Status: {},
	                    MFADelete: {
	                        locationName: "MfaDelete"
	                    }
	                }
	            }
	        },
	        GetBucketWebsite: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?website"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    RedirectAllRequestsTo: {
	                        shape: "S5i"
	                    },
	                    IndexDocument: {
	                        shape: "S5l"
	                    },
	                    ErrorDocument: {
	                        shape: "S5n"
	                    },
	                    RoutingRules: {
	                        shape: "S5o"
	                    }
	                }
	            }
	        },
	        GetObject: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    IfMatch: {
	                        location: "header",
	                        locationName: "If-Match"
	                    },
	                    IfModifiedSince: {
	                        location: "header",
	                        locationName: "If-Modified-Since",
	                        type: "timestamp"
	                    },
	                    IfNoneMatch: {
	                        location: "header",
	                        locationName: "If-None-Match"
	                    },
	                    IfUnmodifiedSince: {
	                        location: "header",
	                        locationName: "If-Unmodified-Since",
	                        type: "timestamp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    Range: {
	                        location: "header",
	                        locationName: "Range"
	                    },
	                    ResponseCacheControl: {
	                        location: "querystring",
	                        locationName: "response-cache-control"
	                    },
	                    ResponseContentDisposition: {
	                        location: "querystring",
	                        locationName: "response-content-disposition"
	                    },
	                    ResponseContentEncoding: {
	                        location: "querystring",
	                        locationName: "response-content-encoding"
	                    },
	                    ResponseContentLanguage: {
	                        location: "querystring",
	                        locationName: "response-content-language"
	                    },
	                    ResponseContentType: {
	                        location: "querystring",
	                        locationName: "response-content-type"
	                    },
	                    ResponseExpires: {
	                        location: "querystring",
	                        locationName: "response-expires",
	                        type: "timestamp"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Body: {
	                        streaming: true,
	                        type: "blob"
	                    },
	                    DeleteMarker: {
	                        location: "header",
	                        locationName: "x-amz-delete-marker",
	                        type: "boolean"
	                    },
	                    AcceptRanges: {
	                        location: "header",
	                        locationName: "accept-ranges"
	                    },
	                    Expiration: {
	                        location: "header",
	                        locationName: "x-amz-expiration"
	                    },
	                    Restore: {
	                        location: "header",
	                        locationName: "x-amz-restore"
	                    },
	                    LastModified: {
	                        location: "header",
	                        locationName: "Last-Modified",
	                        type: "timestamp"
	                    },
	                    ContentLength: {
	                        location: "header",
	                        locationName: "Content-Length",
	                        type: "long"
	                    },
	                    ETag: {
	                        location: "header",
	                        locationName: "ETag"
	                    },
	                    MissingMeta: {
	                        location: "header",
	                        locationName: "x-amz-missing-meta",
	                        type: "integer"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    CacheControl: {
	                        location: "header",
	                        locationName: "Cache-Control"
	                    },
	                    ContentDisposition: {
	                        location: "header",
	                        locationName: "Content-Disposition"
	                    },
	                    ContentEncoding: {
	                        location: "header",
	                        locationName: "Content-Encoding"
	                    },
	                    ContentLanguage: {
	                        location: "header",
	                        locationName: "Content-Language"
	                    },
	                    ContentRange: {
	                        location: "header",
	                        locationName: "Content-Range"
	                    },
	                    ContentType: {
	                        location: "header",
	                        locationName: "Content-Type"
	                    },
	                    Expires: {
	                        location: "header",
	                        locationName: "Expires",
	                        type: "timestamp"
	                    },
	                    WebsiteRedirectLocation: {
	                        location: "header",
	                        locationName: "x-amz-website-redirect-location"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    Metadata: {
	                        shape: "S11",
	                        location: "headers",
	                        locationName: "x-amz-meta-"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    StorageClass: {
	                        location: "header",
	                        locationName: "x-amz-storage-class"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    },
	                    ReplicationStatus: {
	                        location: "header",
	                        locationName: "x-amz-replication-status"
	                    }
	                },
	                payload: "Body"
	            }
	        },
	        GetObjectAcl: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}/{Key+}?acl"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Owner: {
	                        shape: "S2k"
	                    },
	                    Grants: {
	                        shape: "S2n",
	                        locationName: "AccessControlList"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        GetObjectTorrent: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}/{Key+}?torrent"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Body: {
	                        streaming: true,
	                        type: "blob"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                },
	                payload: "Body"
	            }
	        },
	        HeadBucket: {
	            http: {
	                method: "HEAD",
	                requestUri: "/{Bucket}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    }
	                }
	            }
	        },
	        HeadObject: {
	            http: {
	                method: "HEAD",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    IfMatch: {
	                        location: "header",
	                        locationName: "If-Match"
	                    },
	                    IfModifiedSince: {
	                        location: "header",
	                        locationName: "If-Modified-Since",
	                        type: "timestamp"
	                    },
	                    IfNoneMatch: {
	                        location: "header",
	                        locationName: "If-None-Match"
	                    },
	                    IfUnmodifiedSince: {
	                        location: "header",
	                        locationName: "If-Unmodified-Since",
	                        type: "timestamp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    Range: {
	                        location: "header",
	                        locationName: "Range"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    DeleteMarker: {
	                        location: "header",
	                        locationName: "x-amz-delete-marker",
	                        type: "boolean"
	                    },
	                    AcceptRanges: {
	                        location: "header",
	                        locationName: "accept-ranges"
	                    },
	                    Expiration: {
	                        location: "header",
	                        locationName: "x-amz-expiration"
	                    },
	                    Restore: {
	                        location: "header",
	                        locationName: "x-amz-restore"
	                    },
	                    LastModified: {
	                        location: "header",
	                        locationName: "Last-Modified",
	                        type: "timestamp"
	                    },
	                    ContentLength: {
	                        location: "header",
	                        locationName: "Content-Length",
	                        type: "long"
	                    },
	                    ETag: {
	                        location: "header",
	                        locationName: "ETag"
	                    },
	                    MissingMeta: {
	                        location: "header",
	                        locationName: "x-amz-missing-meta",
	                        type: "integer"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    CacheControl: {
	                        location: "header",
	                        locationName: "Cache-Control"
	                    },
	                    ContentDisposition: {
	                        location: "header",
	                        locationName: "Content-Disposition"
	                    },
	                    ContentEncoding: {
	                        location: "header",
	                        locationName: "Content-Encoding"
	                    },
	                    ContentLanguage: {
	                        location: "header",
	                        locationName: "Content-Language"
	                    },
	                    ContentType: {
	                        location: "header",
	                        locationName: "Content-Type"
	                    },
	                    Expires: {
	                        location: "header",
	                        locationName: "Expires",
	                        type: "timestamp"
	                    },
	                    WebsiteRedirectLocation: {
	                        location: "header",
	                        locationName: "x-amz-website-redirect-location"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    Metadata: {
	                        shape: "S11",
	                        location: "headers",
	                        locationName: "x-amz-meta-"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    StorageClass: {
	                        location: "header",
	                        locationName: "x-amz-storage-class"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    },
	                    ReplicationStatus: {
	                        location: "header",
	                        locationName: "x-amz-replication-status"
	                    }
	                }
	            }
	        },
	        ListBuckets: {
	            http: {
	                method: "GET"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Buckets: {
	                        type: "list",
	                        member: {
	                            locationName: "Bucket",
	                            type: "structure",
	                            members: {
	                                Name: {},
	                                CreationDate: {
	                                    type: "timestamp"
	                                }
	                            }
	                        }
	                    },
	                    Owner: {
	                        shape: "S2k"
	                    }
	                }
	            },
	            alias: "GetService"
	        },
	        ListMultipartUploads: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?uploads"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Delimiter: {
	                        location: "querystring",
	                        locationName: "delimiter"
	                    },
	                    EncodingType: {
	                        location: "querystring",
	                        locationName: "encoding-type"
	                    },
	                    KeyMarker: {
	                        location: "querystring",
	                        locationName: "key-marker"
	                    },
	                    MaxUploads: {
	                        location: "querystring",
	                        locationName: "max-uploads",
	                        type: "integer"
	                    },
	                    Prefix: {
	                        location: "querystring",
	                        locationName: "prefix"
	                    },
	                    UploadIdMarker: {
	                        location: "querystring",
	                        locationName: "upload-id-marker"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Bucket: {},
	                    KeyMarker: {},
	                    UploadIdMarker: {},
	                    NextKeyMarker: {},
	                    Prefix: {},
	                    Delimiter: {},
	                    NextUploadIdMarker: {},
	                    MaxUploads: {
	                        type: "integer"
	                    },
	                    IsTruncated: {
	                        type: "boolean"
	                    },
	                    Uploads: {
	                        locationName: "Upload",
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                UploadId: {},
	                                Key: {},
	                                Initiated: {
	                                    type: "timestamp"
	                                },
	                                StorageClass: {},
	                                Owner: {
	                                    shape: "S2k"
	                                },
	                                Initiator: {
	                                    shape: "S75"
	                                }
	                            }
	                        },
	                        flattened: true
	                    },
	                    CommonPrefixes: {
	                        shape: "S76"
	                    },
	                    EncodingType: {}
	                }
	            }
	        },
	        ListObjectVersions: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?versions"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Delimiter: {
	                        location: "querystring",
	                        locationName: "delimiter"
	                    },
	                    EncodingType: {
	                        location: "querystring",
	                        locationName: "encoding-type"
	                    },
	                    KeyMarker: {
	                        location: "querystring",
	                        locationName: "key-marker"
	                    },
	                    MaxKeys: {
	                        location: "querystring",
	                        locationName: "max-keys",
	                        type: "integer"
	                    },
	                    Prefix: {
	                        location: "querystring",
	                        locationName: "prefix"
	                    },
	                    VersionIdMarker: {
	                        location: "querystring",
	                        locationName: "version-id-marker"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    IsTruncated: {
	                        type: "boolean"
	                    },
	                    KeyMarker: {},
	                    VersionIdMarker: {},
	                    NextKeyMarker: {},
	                    NextVersionIdMarker: {},
	                    Versions: {
	                        locationName: "Version",
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                ETag: {},
	                                Size: {
	                                    type: "integer"
	                                },
	                                StorageClass: {},
	                                Key: {},
	                                VersionId: {},
	                                IsLatest: {
	                                    type: "boolean"
	                                },
	                                LastModified: {
	                                    type: "timestamp"
	                                },
	                                Owner: {
	                                    shape: "S2k"
	                                }
	                            }
	                        },
	                        flattened: true
	                    },
	                    DeleteMarkers: {
	                        locationName: "DeleteMarker",
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                Owner: {
	                                    shape: "S2k"
	                                },
	                                Key: {},
	                                VersionId: {},
	                                IsLatest: {
	                                    type: "boolean"
	                                },
	                                LastModified: {
	                                    type: "timestamp"
	                                }
	                            }
	                        },
	                        flattened: true
	                    },
	                    Name: {},
	                    Prefix: {},
	                    Delimiter: {},
	                    MaxKeys: {
	                        type: "integer"
	                    },
	                    CommonPrefixes: {
	                        shape: "S76"
	                    },
	                    EncodingType: {}
	                }
	            },
	            alias: "GetBucketObjectVersions"
	        },
	        ListObjects: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Delimiter: {
	                        location: "querystring",
	                        locationName: "delimiter"
	                    },
	                    EncodingType: {
	                        location: "querystring",
	                        locationName: "encoding-type"
	                    },
	                    Marker: {
	                        location: "querystring",
	                        locationName: "marker"
	                    },
	                    MaxKeys: {
	                        location: "querystring",
	                        locationName: "max-keys",
	                        type: "integer"
	                    },
	                    Prefix: {
	                        location: "querystring",
	                        locationName: "prefix"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    IsTruncated: {
	                        type: "boolean"
	                    },
	                    Marker: {},
	                    NextMarker: {},
	                    Contents: {
	                        shape: "S7o"
	                    },
	                    Name: {},
	                    Prefix: {},
	                    Delimiter: {},
	                    MaxKeys: {
	                        type: "integer"
	                    },
	                    CommonPrefixes: {
	                        shape: "S76"
	                    },
	                    EncodingType: {}
	                }
	            },
	            alias: "GetBucket"
	        },
	        ListObjectsV2: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}?list-type=2"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Delimiter: {
	                        location: "querystring",
	                        locationName: "delimiter"
	                    },
	                    EncodingType: {
	                        location: "querystring",
	                        locationName: "encoding-type"
	                    },
	                    MaxKeys: {
	                        location: "querystring",
	                        locationName: "max-keys",
	                        type: "integer"
	                    },
	                    Prefix: {
	                        location: "querystring",
	                        locationName: "prefix"
	                    },
	                    ContinuationToken: {
	                        location: "querystring",
	                        locationName: "continuation-token"
	                    },
	                    FetchOwner: {
	                        location: "querystring",
	                        locationName: "fetch-owner",
	                        type: "boolean"
	                    },
	                    StartAfter: {
	                        location: "querystring",
	                        locationName: "start-after"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    IsTruncated: {
	                        type: "boolean"
	                    },
	                    Contents: {
	                        shape: "S7o"
	                    },
	                    Name: {},
	                    Prefix: {},
	                    Delimiter: {},
	                    MaxKeys: {
	                        type: "integer"
	                    },
	                    CommonPrefixes: {
	                        shape: "S76"
	                    },
	                    EncodingType: {},
	                    KeyCount: {
	                        type: "integer"
	                    },
	                    ContinuationToken: {},
	                    NextContinuationToken: {},
	                    StartAfter: {}
	                }
	            }
	        },
	        ListParts: {
	            http: {
	                method: "GET",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key", "UploadId" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    MaxParts: {
	                        location: "querystring",
	                        locationName: "max-parts",
	                        type: "integer"
	                    },
	                    PartNumberMarker: {
	                        location: "querystring",
	                        locationName: "part-number-marker",
	                        type: "integer"
	                    },
	                    UploadId: {
	                        location: "querystring",
	                        locationName: "uploadId"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    AbortDate: {
	                        location: "header",
	                        locationName: "x-amz-abort-date",
	                        type: "timestamp"
	                    },
	                    AbortRuleId: {
	                        location: "header",
	                        locationName: "x-amz-abort-rule-id"
	                    },
	                    Bucket: {},
	                    Key: {},
	                    UploadId: {},
	                    PartNumberMarker: {
	                        type: "integer"
	                    },
	                    NextPartNumberMarker: {
	                        type: "integer"
	                    },
	                    MaxParts: {
	                        type: "integer"
	                    },
	                    IsTruncated: {
	                        type: "boolean"
	                    },
	                    Parts: {
	                        locationName: "Part",
	                        type: "list",
	                        member: {
	                            type: "structure",
	                            members: {
	                                PartNumber: {
	                                    type: "integer"
	                                },
	                                LastModified: {
	                                    type: "timestamp"
	                                },
	                                ETag: {},
	                                Size: {
	                                    type: "integer"
	                                }
	                            }
	                        },
	                        flattened: true
	                    },
	                    Initiator: {
	                        shape: "S75"
	                    },
	                    Owner: {
	                        shape: "S2k"
	                    },
	                    StorageClass: {},
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        PutBucketAccelerateConfiguration: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?accelerate"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "AccelerateConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    AccelerateConfiguration: {
	                        locationName: "AccelerateConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            Status: {}
	                        }
	                    }
	                },
	                payload: "AccelerateConfiguration"
	            }
	        },
	        PutBucketAcl: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?acl"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    AccessControlPolicy: {
	                        shape: "S88",
	                        locationName: "AccessControlPolicy",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        }
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWrite: {
	                        location: "header",
	                        locationName: "x-amz-grant-write"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    }
	                },
	                payload: "AccessControlPolicy"
	            }
	        },
	        PutBucketCors: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?cors"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "CORSConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CORSConfiguration: {
	                        locationName: "CORSConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "CORSRules" ],
	                        members: {
	                            CORSRules: {
	                                shape: "S2w",
	                                locationName: "CORSRule"
	                            }
	                        }
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    }
	                },
	                payload: "CORSConfiguration"
	            }
	        },
	        PutBucketLifecycle: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?lifecycle"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    LifecycleConfiguration: {
	                        locationName: "LifecycleConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "Rules" ],
	                        members: {
	                            Rules: {
	                                shape: "S39",
	                                locationName: "Rule"
	                            }
	                        }
	                    }
	                },
	                payload: "LifecycleConfiguration"
	            },
	            deprecated: true
	        },
	        PutBucketLifecycleConfiguration: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?lifecycle"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    LifecycleConfiguration: {
	                        locationName: "LifecycleConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "Rules" ],
	                        members: {
	                            Rules: {
	                                shape: "S3p",
	                                locationName: "Rule"
	                            }
	                        }
	                    }
	                },
	                payload: "LifecycleConfiguration"
	            }
	        },
	        PutBucketLogging: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?logging"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "BucketLoggingStatus" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    BucketLoggingStatus: {
	                        locationName: "BucketLoggingStatus",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            LoggingEnabled: {
	                                shape: "S3x"
	                            }
	                        }
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    }
	                },
	                payload: "BucketLoggingStatus"
	            }
	        },
	        PutBucketNotification: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?notification"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "NotificationConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    NotificationConfiguration: {
	                        shape: "S44",
	                        locationName: "NotificationConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        }
	                    }
	                },
	                payload: "NotificationConfiguration"
	            },
	            deprecated: true
	        },
	        PutBucketNotificationConfiguration: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?notification"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "NotificationConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    NotificationConfiguration: {
	                        shape: "S4f",
	                        locationName: "NotificationConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        }
	                    }
	                },
	                payload: "NotificationConfiguration"
	            }
	        },
	        PutBucketPolicy: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?policy"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Policy" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    Policy: {}
	                },
	                payload: "Policy"
	            }
	        },
	        PutBucketReplication: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?replication"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "ReplicationConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    ReplicationConfiguration: {
	                        shape: "S4y",
	                        locationName: "ReplicationConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        }
	                    }
	                },
	                payload: "ReplicationConfiguration"
	            }
	        },
	        PutBucketRequestPayment: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?requestPayment"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "RequestPaymentConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    RequestPaymentConfiguration: {
	                        locationName: "RequestPaymentConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "Payer" ],
	                        members: {
	                            Payer: {}
	                        }
	                    }
	                },
	                payload: "RequestPaymentConfiguration"
	            }
	        },
	        PutBucketTagging: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?tagging"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Tagging" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    Tagging: {
	                        locationName: "Tagging",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "TagSet" ],
	                        members: {
	                            TagSet: {
	                                shape: "S59"
	                            }
	                        }
	                    }
	                },
	                payload: "Tagging"
	            }
	        },
	        PutBucketVersioning: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?versioning"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "VersioningConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    MFA: {
	                        location: "header",
	                        locationName: "x-amz-mfa"
	                    },
	                    VersioningConfiguration: {
	                        locationName: "VersioningConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            MFADelete: {
	                                locationName: "MfaDelete"
	                            },
	                            Status: {}
	                        }
	                    }
	                },
	                payload: "VersioningConfiguration"
	            }
	        },
	        PutBucketWebsite: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}?website"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "WebsiteConfiguration" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    WebsiteConfiguration: {
	                        locationName: "WebsiteConfiguration",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        members: {
	                            ErrorDocument: {
	                                shape: "S5n"
	                            },
	                            IndexDocument: {
	                                shape: "S5l"
	                            },
	                            RedirectAllRequestsTo: {
	                                shape: "S5i"
	                            },
	                            RoutingRules: {
	                                shape: "S5o"
	                            }
	                        }
	                    }
	                },
	                payload: "WebsiteConfiguration"
	            }
	        },
	        PutObject: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    Body: {
	                        streaming: true,
	                        type: "blob"
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CacheControl: {
	                        location: "header",
	                        locationName: "Cache-Control"
	                    },
	                    ContentDisposition: {
	                        location: "header",
	                        locationName: "Content-Disposition"
	                    },
	                    ContentEncoding: {
	                        location: "header",
	                        locationName: "Content-Encoding"
	                    },
	                    ContentLanguage: {
	                        location: "header",
	                        locationName: "Content-Language"
	                    },
	                    ContentLength: {
	                        location: "header",
	                        locationName: "Content-Length",
	                        type: "long"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    ContentType: {
	                        location: "header",
	                        locationName: "Content-Type"
	                    },
	                    Expires: {
	                        location: "header",
	                        locationName: "Expires",
	                        type: "timestamp"
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    Metadata: {
	                        shape: "S11",
	                        location: "headers",
	                        locationName: "x-amz-meta-"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    StorageClass: {
	                        location: "header",
	                        locationName: "x-amz-storage-class"
	                    },
	                    WebsiteRedirectLocation: {
	                        location: "header",
	                        locationName: "x-amz-website-redirect-location"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                },
	                payload: "Body"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    Expiration: {
	                        location: "header",
	                        locationName: "x-amz-expiration"
	                    },
	                    ETag: {
	                        location: "header",
	                        locationName: "ETag"
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    VersionId: {
	                        location: "header",
	                        locationName: "x-amz-version-id"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        PutObjectAcl: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}/{Key+}?acl"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    ACL: {
	                        location: "header",
	                        locationName: "x-amz-acl"
	                    },
	                    AccessControlPolicy: {
	                        shape: "S88",
	                        locationName: "AccessControlPolicy",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        }
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    GrantFullControl: {
	                        location: "header",
	                        locationName: "x-amz-grant-full-control"
	                    },
	                    GrantRead: {
	                        location: "header",
	                        locationName: "x-amz-grant-read"
	                    },
	                    GrantReadACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-read-acp"
	                    },
	                    GrantWrite: {
	                        location: "header",
	                        locationName: "x-amz-grant-write"
	                    },
	                    GrantWriteACP: {
	                        location: "header",
	                        locationName: "x-amz-grant-write-acp"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    }
	                },
	                payload: "AccessControlPolicy"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        RestoreObject: {
	            http: {
	                requestUri: "/{Bucket}/{Key+}?restore"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    VersionId: {
	                        location: "querystring",
	                        locationName: "versionId"
	                    },
	                    RestoreRequest: {
	                        locationName: "RestoreRequest",
	                        xmlNamespace: {
	                            uri: "http://s3.amazonaws.com/doc/2006-03-01/"
	                        },
	                        type: "structure",
	                        required: [ "Days" ],
	                        members: {
	                            Days: {
	                                type: "integer"
	                            }
	                        }
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                },
	                payload: "RestoreRequest"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            },
	            alias: "PostObjectRestore"
	        },
	        UploadPart: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "Key", "PartNumber", "UploadId" ],
	                members: {
	                    Body: {
	                        streaming: true,
	                        type: "blob"
	                    },
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    ContentLength: {
	                        location: "header",
	                        locationName: "Content-Length",
	                        type: "long"
	                    },
	                    ContentMD5: {
	                        location: "header",
	                        locationName: "Content-MD5"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    PartNumber: {
	                        location: "querystring",
	                        locationName: "partNumber",
	                        type: "integer"
	                    },
	                    UploadId: {
	                        location: "querystring",
	                        locationName: "uploadId"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                },
	                payload: "Body"
	            },
	            output: {
	                type: "structure",
	                members: {
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    ETag: {
	                        location: "header",
	                        locationName: "ETag"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                }
	            }
	        },
	        UploadPartCopy: {
	            http: {
	                method: "PUT",
	                requestUri: "/{Bucket}/{Key+}"
	            },
	            input: {
	                type: "structure",
	                required: [ "Bucket", "CopySource", "Key", "PartNumber", "UploadId" ],
	                members: {
	                    Bucket: {
	                        location: "uri",
	                        locationName: "Bucket"
	                    },
	                    CopySource: {
	                        location: "header",
	                        locationName: "x-amz-copy-source"
	                    },
	                    CopySourceIfMatch: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-match"
	                    },
	                    CopySourceIfModifiedSince: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-modified-since",
	                        type: "timestamp"
	                    },
	                    CopySourceIfNoneMatch: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-none-match"
	                    },
	                    CopySourceIfUnmodifiedSince: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-if-unmodified-since",
	                        type: "timestamp"
	                    },
	                    CopySourceRange: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-range"
	                    },
	                    Key: {
	                        location: "uri",
	                        locationName: "Key"
	                    },
	                    PartNumber: {
	                        location: "querystring",
	                        locationName: "partNumber",
	                        type: "integer"
	                    },
	                    UploadId: {
	                        location: "querystring",
	                        locationName: "uploadId"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKey: {
	                        shape: "S18",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    CopySourceSSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-algorithm"
	                    },
	                    CopySourceSSECustomerKey: {
	                        shape: "S1b",
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-key"
	                    },
	                    CopySourceSSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-server-side-encryption-customer-key-MD5"
	                    },
	                    RequestPayer: {
	                        location: "header",
	                        locationName: "x-amz-request-payer"
	                    }
	                }
	            },
	            output: {
	                type: "structure",
	                members: {
	                    CopySourceVersionId: {
	                        location: "header",
	                        locationName: "x-amz-copy-source-version-id"
	                    },
	                    CopyPartResult: {
	                        type: "structure",
	                        members: {
	                            ETag: {},
	                            LastModified: {
	                                type: "timestamp"
	                            }
	                        }
	                    },
	                    ServerSideEncryption: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption"
	                    },
	                    SSECustomerAlgorithm: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-algorithm"
	                    },
	                    SSECustomerKeyMD5: {
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-customer-key-MD5"
	                    },
	                    SSEKMSKeyId: {
	                        shape: "Sj",
	                        location: "header",
	                        locationName: "x-amz-server-side-encryption-aws-kms-key-id"
	                    },
	                    RequestCharged: {
	                        location: "header",
	                        locationName: "x-amz-request-charged"
	                    }
	                },
	                payload: "CopyPartResult"
	            }
	        }
	    },
	    shapes: {
	        Sj: {
	            type: "string",
	            sensitive: true
	        },
	        S11: {
	            type: "map",
	            key: {},
	            value: {}
	        },
	        S18: {
	            type: "blob",
	            sensitive: true
	        },
	        S1b: {
	            type: "blob",
	            sensitive: true
	        },
	        S2k: {
	            type: "structure",
	            members: {
	                DisplayName: {},
	                ID: {}
	            }
	        },
	        S2n: {
	            type: "list",
	            member: {
	                locationName: "Grant",
	                type: "structure",
	                members: {
	                    Grantee: {
	                        shape: "S2p"
	                    },
	                    Permission: {}
	                }
	            }
	        },
	        S2p: {
	            type: "structure",
	            required: [ "Type" ],
	            members: {
	                DisplayName: {},
	                EmailAddress: {},
	                ID: {},
	                Type: {
	                    locationName: "xsi:type",
	                    xmlAttribute: true
	                },
	                URI: {}
	            },
	            xmlNamespace: {
	                prefix: "xsi",
	                uri: "http://www.w3.org/2001/XMLSchema-instance"
	            }
	        },
	        S2w: {
	            type: "list",
	            member: {
	                type: "structure",
	                required: [ "AllowedMethods", "AllowedOrigins" ],
	                members: {
	                    AllowedHeaders: {
	                        locationName: "AllowedHeader",
	                        type: "list",
	                        member: {},
	                        flattened: true
	                    },
	                    AllowedMethods: {
	                        locationName: "AllowedMethod",
	                        type: "list",
	                        member: {},
	                        flattened: true
	                    },
	                    AllowedOrigins: {
	                        locationName: "AllowedOrigin",
	                        type: "list",
	                        member: {},
	                        flattened: true
	                    },
	                    ExposeHeaders: {
	                        locationName: "ExposeHeader",
	                        type: "list",
	                        member: {},
	                        flattened: true
	                    },
	                    MaxAgeSeconds: {
	                        type: "integer"
	                    }
	                }
	            },
	            flattened: true
	        },
	        S39: {
	            type: "list",
	            member: {
	                type: "structure",
	                required: [ "Prefix", "Status" ],
	                members: {
	                    Expiration: {
	                        shape: "S3b"
	                    },
	                    ID: {},
	                    Prefix: {},
	                    Status: {},
	                    Transition: {
	                        shape: "S3h"
	                    },
	                    NoncurrentVersionTransition: {
	                        shape: "S3j"
	                    },
	                    NoncurrentVersionExpiration: {
	                        shape: "S3k"
	                    },
	                    AbortIncompleteMultipartUpload: {
	                        shape: "S3l"
	                    }
	                }
	            },
	            flattened: true
	        },
	        S3b: {
	            type: "structure",
	            members: {
	                Date: {
	                    shape: "S3c"
	                },
	                Days: {
	                    type: "integer"
	                },
	                ExpiredObjectDeleteMarker: {
	                    type: "boolean"
	                }
	            }
	        },
	        S3c: {
	            type: "timestamp",
	            timestampFormat: "iso8601"
	        },
	        S3h: {
	            type: "structure",
	            members: {
	                Date: {
	                    shape: "S3c"
	                },
	                Days: {
	                    type: "integer"
	                },
	                StorageClass: {}
	            }
	        },
	        S3j: {
	            type: "structure",
	            members: {
	                NoncurrentDays: {
	                    type: "integer"
	                },
	                StorageClass: {}
	            }
	        },
	        S3k: {
	            type: "structure",
	            members: {
	                NoncurrentDays: {
	                    type: "integer"
	                }
	            }
	        },
	        S3l: {
	            type: "structure",
	            members: {
	                DaysAfterInitiation: {
	                    type: "integer"
	                }
	            }
	        },
	        S3p: {
	            type: "list",
	            member: {
	                type: "structure",
	                required: [ "Prefix", "Status" ],
	                members: {
	                    Expiration: {
	                        shape: "S3b"
	                    },
	                    ID: {},
	                    Prefix: {},
	                    Status: {},
	                    Transitions: {
	                        locationName: "Transition",
	                        type: "list",
	                        member: {
	                            shape: "S3h"
	                        },
	                        flattened: true
	                    },
	                    NoncurrentVersionTransitions: {
	                        locationName: "NoncurrentVersionTransition",
	                        type: "list",
	                        member: {
	                            shape: "S3j"
	                        },
	                        flattened: true
	                    },
	                    NoncurrentVersionExpiration: {
	                        shape: "S3k"
	                    },
	                    AbortIncompleteMultipartUpload: {
	                        shape: "S3l"
	                    }
	                }
	            },
	            flattened: true
	        },
	        S3x: {
	            type: "structure",
	            members: {
	                TargetBucket: {},
	                TargetGrants: {
	                    type: "list",
	                    member: {
	                        locationName: "Grant",
	                        type: "structure",
	                        members: {
	                            Grantee: {
	                                shape: "S2p"
	                            },
	                            Permission: {}
	                        }
	                    }
	                },
	                TargetPrefix: {}
	            }
	        },
	        S43: {
	            type: "structure",
	            required: [ "Bucket" ],
	            members: {
	                Bucket: {
	                    location: "uri",
	                    locationName: "Bucket"
	                }
	            }
	        },
	        S44: {
	            type: "structure",
	            members: {
	                TopicConfiguration: {
	                    type: "structure",
	                    members: {
	                        Id: {},
	                        Events: {
	                            shape: "S47",
	                            locationName: "Event"
	                        },
	                        Event: {
	                            deprecated: true
	                        },
	                        Topic: {}
	                    }
	                },
	                QueueConfiguration: {
	                    type: "structure",
	                    members: {
	                        Id: {},
	                        Event: {
	                            deprecated: true
	                        },
	                        Events: {
	                            shape: "S47",
	                            locationName: "Event"
	                        },
	                        Queue: {}
	                    }
	                },
	                CloudFunctionConfiguration: {
	                    type: "structure",
	                    members: {
	                        Id: {},
	                        Event: {
	                            deprecated: true
	                        },
	                        Events: {
	                            shape: "S47",
	                            locationName: "Event"
	                        },
	                        CloudFunction: {},
	                        InvocationRole: {}
	                    }
	                }
	            }
	        },
	        S47: {
	            type: "list",
	            member: {},
	            flattened: true
	        },
	        S4f: {
	            type: "structure",
	            members: {
	                TopicConfigurations: {
	                    locationName: "TopicConfiguration",
	                    type: "list",
	                    member: {
	                        type: "structure",
	                        required: [ "TopicArn", "Events" ],
	                        members: {
	                            Id: {},
	                            TopicArn: {
	                                locationName: "Topic"
	                            },
	                            Events: {
	                                shape: "S47",
	                                locationName: "Event"
	                            },
	                            Filter: {
	                                shape: "S4i"
	                            }
	                        }
	                    },
	                    flattened: true
	                },
	                QueueConfigurations: {
	                    locationName: "QueueConfiguration",
	                    type: "list",
	                    member: {
	                        type: "structure",
	                        required: [ "QueueArn", "Events" ],
	                        members: {
	                            Id: {},
	                            QueueArn: {
	                                locationName: "Queue"
	                            },
	                            Events: {
	                                shape: "S47",
	                                locationName: "Event"
	                            },
	                            Filter: {
	                                shape: "S4i"
	                            }
	                        }
	                    },
	                    flattened: true
	                },
	                LambdaFunctionConfigurations: {
	                    locationName: "CloudFunctionConfiguration",
	                    type: "list",
	                    member: {
	                        type: "structure",
	                        required: [ "LambdaFunctionArn", "Events" ],
	                        members: {
	                            Id: {},
	                            LambdaFunctionArn: {
	                                locationName: "CloudFunction"
	                            },
	                            Events: {
	                                shape: "S47",
	                                locationName: "Event"
	                            },
	                            Filter: {
	                                shape: "S4i"
	                            }
	                        }
	                    },
	                    flattened: true
	                }
	            }
	        },
	        S4i: {
	            type: "structure",
	            members: {
	                Key: {
	                    locationName: "S3Key",
	                    type: "structure",
	                    members: {
	                        FilterRules: {
	                            locationName: "FilterRule",
	                            type: "list",
	                            member: {
	                                type: "structure",
	                                members: {
	                                    Name: {},
	                                    Value: {}
	                                }
	                            },
	                            flattened: true
	                        }
	                    }
	                }
	            }
	        },
	        S4y: {
	            type: "structure",
	            required: [ "Role", "Rules" ],
	            members: {
	                Role: {},
	                Rules: {
	                    locationName: "Rule",
	                    type: "list",
	                    member: {
	                        type: "structure",
	                        required: [ "Prefix", "Status", "Destination" ],
	                        members: {
	                            ID: {},
	                            Prefix: {},
	                            Status: {},
	                            Destination: {
	                                type: "structure",
	                                required: [ "Bucket" ],
	                                members: {
	                                    Bucket: {},
	                                    StorageClass: {}
	                                }
	                            }
	                        }
	                    },
	                    flattened: true
	                }
	            }
	        },
	        S59: {
	            type: "list",
	            member: {
	                locationName: "Tag",
	                type: "structure",
	                required: [ "Key", "Value" ],
	                members: {
	                    Key: {},
	                    Value: {}
	                }
	            }
	        },
	        S5i: {
	            type: "structure",
	            required: [ "HostName" ],
	            members: {
	                HostName: {},
	                Protocol: {}
	            }
	        },
	        S5l: {
	            type: "structure",
	            required: [ "Suffix" ],
	            members: {
	                Suffix: {}
	            }
	        },
	        S5n: {
	            type: "structure",
	            required: [ "Key" ],
	            members: {
	                Key: {}
	            }
	        },
	        S5o: {
	            type: "list",
	            member: {
	                locationName: "RoutingRule",
	                type: "structure",
	                required: [ "Redirect" ],
	                members: {
	                    Condition: {
	                        type: "structure",
	                        members: {
	                            HttpErrorCodeReturnedEquals: {},
	                            KeyPrefixEquals: {}
	                        }
	                    },
	                    Redirect: {
	                        type: "structure",
	                        members: {
	                            HostName: {},
	                            HttpRedirectCode: {},
	                            Protocol: {},
	                            ReplaceKeyPrefixWith: {},
	                            ReplaceKeyWith: {}
	                        }
	                    }
	                }
	            }
	        },
	        S75: {
	            type: "structure",
	            members: {
	                ID: {},
	                DisplayName: {}
	            }
	        },
	        S76: {
	            type: "list",
	            member: {
	                type: "structure",
	                members: {
	                    Prefix: {}
	                }
	            },
	            flattened: true
	        },
	        S7o: {
	            type: "list",
	            member: {
	                type: "structure",
	                members: {
	                    Key: {},
	                    LastModified: {
	                        type: "timestamp"
	                    },
	                    ETag: {},
	                    Size: {
	                        type: "integer"
	                    },
	                    StorageClass: {},
	                    Owner: {
	                        shape: "S2k"
	                    }
	                }
	            },
	            flattened: true
	        },
	        S88: {
	            type: "structure",
	            members: {
	                Grants: {
	                    shape: "S2n",
	                    locationName: "AccessControlList"
	                },
	                Owner: {
	                    shape: "S2k"
	                }
	            }
	        }
	    },
	    paginators: {
	        ListBuckets: {
	            result_key: "Buckets"
	        },
	        ListMultipartUploads: {
	            limit_key: "MaxUploads",
	            more_results: "IsTruncated",
	            output_token: [ "NextKeyMarker", "NextUploadIdMarker" ],
	            input_token: [ "KeyMarker", "UploadIdMarker" ],
	            result_key: [ "Uploads", "CommonPrefixes" ]
	        },
	        ListObjectVersions: {
	            more_results: "IsTruncated",
	            limit_key: "MaxKeys",
	            output_token: [ "NextKeyMarker", "NextVersionIdMarker" ],
	            input_token: [ "KeyMarker", "VersionIdMarker" ],
	            result_key: [ "Versions", "DeleteMarkers", "CommonPrefixes" ]
	        },
	        ListObjects: {
	            more_results: "IsTruncated",
	            limit_key: "MaxKeys",
	            output_token: "NextMarker || Contents[-1].Key",
	            input_token: "Marker",
	            result_key: [ "Contents", "CommonPrefixes" ]
	        },
	        ListObjectsV2: {
	            limit_key: "MaxKeys",
	            output_token: "NextContinuationToken",
	            input_token: "ContinuationToken",
	            result_key: [ "Contents", "CommonPrefixes" ]
	        },
	        ListParts: {
	            more_results: "IsTruncated",
	            limit_key: "MaxParts",
	            output_token: "NextPartNumberMarker",
	            input_token: "PartNumberMarker",
	            result_key: "Parts"
	        }
	    },
	    waiters: {
	        BucketExists: {
	            delay: 5,
	            operation: "HeadBucket",
	            maxAttempts: 20,
	            acceptors: [ {
	                expected: 200,
	                matcher: "status",
	                state: "success"
	            }, {
	                expected: 301,
	                matcher: "status",
	                state: "success"
	            }, {
	                expected: 403,
	                matcher: "status",
	                state: "success"
	            }, {
	                expected: 404,
	                matcher: "status",
	                state: "retry"
	            } ]
	        },
	        BucketNotExists: {
	            delay: 5,
	            operation: "HeadBucket",
	            maxAttempts: 20,
	            acceptors: [ {
	                expected: 404,
	                matcher: "status",
	                state: "success"
	            } ]
	        },
	        ObjectExists: {
	            delay: 5,
	            operation: "HeadObject",
	            maxAttempts: 20,
	            acceptors: [ {
	                expected: 200,
	                matcher: "status",
	                state: "success"
	            }, {
	                expected: 404,
	                matcher: "status",
	                state: "retry"
	            } ]
	        },
	        ObjectNotExists: {
	            delay: 5,
	            operation: "HeadObject",
	            maxAttempts: 20,
	            acceptors: [ {
	                expected: 404,
	                matcher: "status",
	                state: "success"
	            } ]
	        }
	    }
	};AWS.apiLoader.services["sts"] = {};
	
	AWS.STS = AWS.Service.defineService("sts", [ "2011-06-15" ]);
	
	_xamzrequire = function e(t, n, r) {
	    function s(o, u) {
	        if (!n[o]) {
	            if (!t[o]) {
	                var a = typeof _xamzrequire == "function" && _xamzrequire;
	                if (!u && a) return a(o, !0);
	                if (i) return i(o, !0);
	                var f = new Error("Cannot find module '" + o + "'");
	                throw f.code = "MODULE_NOT_FOUND", f;
	            }
	            var l = n[o] = {
	                exports: {}
	            };
	            t[o][0].call(l.exports, function(e) {
	                var n = t[o][1][e];
	                return s(n ? n : e);
	            }, l, l.exports, e, t, n, r);
	        }
	        return n[o].exports;
	    }
	    var i = typeof _xamzrequire == "function" && _xamzrequire;
	    for (var o = 0; o < r.length; o++) s(r[o]);
	    return s;
	}({
	    74: [ function(require, module, exports) {
	        var AWS = require("../core");
	        AWS.util.update(AWS.STS.prototype, {
	            credentialsFrom: function credentialsFrom(data, credentials) {
	                if (!data) return null;
	                if (!credentials) credentials = new AWS.TemporaryCredentials();
	                credentials.expired = false;
	                credentials.accessKeyId = data.Credentials.AccessKeyId;
	                credentials.secretAccessKey = data.Credentials.SecretAccessKey;
	                credentials.sessionToken = data.Credentials.SessionToken;
	                credentials.expireTime = data.Credentials.Expiration;
	                return credentials;
	            },
	            assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
	                return this.makeUnauthenticatedRequest("assumeRoleWithWebIdentity", params, callback);
	            },
	            assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
	                return this.makeUnauthenticatedRequest("assumeRoleWithSAML", params, callback);
	            }
	        });
	    }, {
	        "../core": 24
	    } ]
	}, {}, [ 74 ]);AWS.apiLoader.services["sts"]["2011-06-15"] = {
	    version: "2.0",
	    metadata: {
	        apiVersion: "2011-06-15",
	        endpointPrefix: "sts",
	        globalEndpoint: "sts.amazonaws.com",
	        protocol: "query",
	        serviceAbbreviation: "AWS STS",
	        serviceFullName: "AWS Security Token Service",
	        signatureVersion: "v4",
	        xmlNamespace: "https://sts.amazonaws.com/doc/2011-06-15/"
	    },
	    operations: {
	        AssumeRole: {
	            input: {
	                type: "structure",
	                required: [ "RoleArn", "RoleSessionName" ],
	                members: {
	                    RoleArn: {},
	                    RoleSessionName: {},
	                    Policy: {},
	                    DurationSeconds: {
	                        type: "integer"
	                    },
	                    ExternalId: {},
	                    SerialNumber: {},
	                    TokenCode: {}
	                }
	            },
	            output: {
	                resultWrapper: "AssumeRoleResult",
	                type: "structure",
	                members: {
	                    Credentials: {
	                        shape: "Sa"
	                    },
	                    AssumedRoleUser: {
	                        shape: "Sf"
	                    },
	                    PackedPolicySize: {
	                        type: "integer"
	                    }
	                }
	            },
	            http: {}
	        },
	        AssumeRoleWithSAML: {
	            input: {
	                type: "structure",
	                required: [ "RoleArn", "PrincipalArn", "SAMLAssertion" ],
	                members: {
	                    RoleArn: {},
	                    PrincipalArn: {},
	                    SAMLAssertion: {},
	                    Policy: {},
	                    DurationSeconds: {
	                        type: "integer"
	                    }
	                }
	            },
	            output: {
	                resultWrapper: "AssumeRoleWithSAMLResult",
	                type: "structure",
	                members: {
	                    Credentials: {
	                        shape: "Sa"
	                    },
	                    AssumedRoleUser: {
	                        shape: "Sf"
	                    },
	                    PackedPolicySize: {
	                        type: "integer"
	                    },
	                    Subject: {},
	                    SubjectType: {},
	                    Issuer: {},
	                    Audience: {},
	                    NameQualifier: {}
	                }
	            },
	            http: {}
	        },
	        AssumeRoleWithWebIdentity: {
	            input: {
	                type: "structure",
	                required: [ "RoleArn", "RoleSessionName", "WebIdentityToken" ],
	                members: {
	                    RoleArn: {},
	                    RoleSessionName: {},
	                    WebIdentityToken: {},
	                    ProviderId: {},
	                    Policy: {},
	                    DurationSeconds: {
	                        type: "integer"
	                    }
	                }
	            },
	            output: {
	                resultWrapper: "AssumeRoleWithWebIdentityResult",
	                type: "structure",
	                members: {
	                    Credentials: {
	                        shape: "Sa"
	                    },
	                    SubjectFromWebIdentityToken: {},
	                    AssumedRoleUser: {
	                        shape: "Sf"
	                    },
	                    PackedPolicySize: {
	                        type: "integer"
	                    },
	                    Provider: {},
	                    Audience: {}
	                }
	            },
	            http: {}
	        },
	        DecodeAuthorizationMessage: {
	            input: {
	                type: "structure",
	                required: [ "EncodedMessage" ],
	                members: {
	                    EncodedMessage: {}
	                }
	            },
	            output: {
	                resultWrapper: "DecodeAuthorizationMessageResult",
	                type: "structure",
	                members: {
	                    DecodedMessage: {}
	                }
	            },
	            http: {}
	        },
	        GetCallerIdentity: {
	            input: {
	                type: "structure",
	                members: {}
	            },
	            output: {
	                resultWrapper: "GetCallerIdentityResult",
	                type: "structure",
	                members: {
	                    UserId: {},
	                    Account: {},
	                    Arn: {}
	                }
	            },
	            http: {}
	        },
	        GetFederationToken: {
	            input: {
	                type: "structure",
	                required: [ "Name" ],
	                members: {
	                    Name: {},
	                    Policy: {},
	                    DurationSeconds: {
	                        type: "integer"
	                    }
	                }
	            },
	            output: {
	                resultWrapper: "GetFederationTokenResult",
	                type: "structure",
	                members: {
	                    Credentials: {
	                        shape: "Sa"
	                    },
	                    FederatedUser: {
	                        type: "structure",
	                        required: [ "FederatedUserId", "Arn" ],
	                        members: {
	                            FederatedUserId: {},
	                            Arn: {}
	                        }
	                    },
	                    PackedPolicySize: {
	                        type: "integer"
	                    }
	                }
	            },
	            http: {}
	        },
	        GetSessionToken: {
	            input: {
	                type: "structure",
	                members: {
	                    DurationSeconds: {
	                        type: "integer"
	                    },
	                    SerialNumber: {},
	                    TokenCode: {}
	                }
	            },
	            output: {
	                resultWrapper: "GetSessionTokenResult",
	                type: "structure",
	                members: {
	                    Credentials: {
	                        shape: "Sa"
	                    }
	                }
	            },
	            http: {}
	        }
	    },
	    shapes: {
	        Sa: {
	            type: "structure",
	            required: [ "AccessKeyId", "SecretAccessKey", "SessionToken", "Expiration" ],
	            members: {
	                AccessKeyId: {},
	                SecretAccessKey: {},
	                SessionToken: {},
	                Expiration: {
	                    type: "timestamp"
	                }
	            }
	        },
	        Sf: {
	            type: "structure",
	            required: [ "AssumedRoleId", "Arn" ],
	            members: {
	                AssumedRoleId: {},
	                Arn: {}
	            }
	        }
	    }
	};
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = AWS;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(109).Buffer))

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banners":"_31fwC","banner":"_3H2J0","enter":"_3lli-","enterActive":"_1p9aM","leave":"_2Yx82","leaveActive":"E8KpZ"};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_386_k","item":"_3ZgHh","itemChecked":"vtrdd _3ZgHh","checkbox":"HnFwd","checkboxChecked":"_2tDub HnFwd","tick":"_21fwO","title":"_20nUa","subtitle":"_3ckh0"};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"confirmButton":"_1dN-N","buttons":"_3dWzB","button":"_233b0 _1dN-N","cancelButton":"_2Y4CS _1dN-N"};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_234kA","closed":"mzcIB _234kA","open":"_21kVG _234kA","fixed":"_1mv8Z","item":"_1BNHV","headingItem":"_2ulV2 _1BNHV","link":"_3VIli","linkWithExtra":"_3PiBD _3VIli","overlay":"_3AjGZ","overlayActive":"B14av _3AjGZ","extra":"f_ztM"};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"x0qsW","heading":"_24dBH"};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3Rrfw","message":"_3Pw4V"};

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_3oqLy","input":"_1sOIF","autoComplete":"sJubR","autoCompleteHeading":"jjnt0","autoCompleteItem":"EDwbt","autoCompleteButton":"_24NYV","meta":"_3x40i","clearButton":"_1dLU-"};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"nUASj","header":"_1qkOk","headerLogin":"xyyMy","headerHome":"QNaRd _1qkOk","headerAlbum":"_3enRQ _1qkOk","headerAlbumEdit":"_3XHvi _1qkOk","headerPlaylists":"pubCt _1qkOk","headerQueues":"_1Ouym _1qkOk","headerChannels":"_11Sgl _1qkOk","icon":"_1J9If","backIcon":"_2pC1r _1J9If"};

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"-qjgj","list":"_1TJRV","keyword":"_1-oY8","keywordClickable":"_1_4E1 _1-oY8"};

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spinner":"_1a_tg","spinnerShowing":"_389k_ _1a_tg","square":"_3fnBP","fade":"_1p31a","white":"_2m1Ab","topLeft":"_5rydd _3fnBP","topRight":"_3DNCi _3fnBP","bottomLeft":"_3Ee-f _3fnBP","bottomRight":"rBMZz _3fnBP"};

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_3STD3","closed":"_2bl8g _3STD3","open":"_1c88H _3STD3","item":"_5qhMB","link":"n7CC9"};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_30xrv","wrapperOpen":"RrC9I _30xrv","nav":"_3SNVo","navOpen":"_3Yosj _3SNVo","heading":"_15utz","list":"wIlFu","link":"_2W2-y"};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3J0jI","wrapper":"_1FI9U","share":"_2T_67","downloadLabel":"_2VZUx","buttonContainer":"_1ikoY","code":"_1l4d-","orchestraCode":"_16Rwh","info":"_1p5Yl"};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"star":"_1YiJS","starOutline":"U-1lg _1YiJS","clicked":"_1TvMy","clickable":"PC1Dv","flag":"og6pB","flagged":"_1jXTf","white":"_3uxLD","info":"_2R17G"};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"period":"_5vVd5","subperiod":"_2rXaX _5vVd5","title":"_3I11s","link":"qeWXg","expandButton":"_3TO5O","count":"Ic3WE","thumbnails":"_3xKJx","thumbnail":"_2ZmAg"};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"_1yd8q","wrapChecked":"dOWur _1yd8q","dot":"_2pz-W","dotChecked":"LLIBN _2pz-W"};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_3qSFU","wrapperOpen":"_3GLkZ _3qSFU","button":"_36XLA","description":"_1Or9q","filledIndicator":"_3b6qm"};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_3_JlX","album":"_3wPN7","thumb":"_1b85g","name":"_3zv4i","info":"_3H8mD","button":"_2OfIj"};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumbs":"b13c5","breadcrumb":"_2LEz-"};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_2qlei","title":"_1mfwT","subtitle":"krru5","bottomLeft":"_8vGZO","bottomRight":"_3Tuyc","iconButton":"_2U02s","infoButton":"_2wlz5 _2U02s","active":"_3CLjg","shareInfo":"_3vSMp","slider":"fzEBe","fixedIcon":"B9SIp","fixedTitle":"GYLzM"};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_1oHfJ","toolButton":"_3gCze","page":"_3EsOi","lockToggle":"_3Rqg8","info":"_1muzq","cover":"_2_rpT"};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_3xlyh","item":"Jucul","link":"_3enT9","moreLink":"_1m-sg _3enT9","addLink":"_3Gp6g","addLinkIcon":"I-P1x","moreCount":"_26SPT","moreText":"_28Agx","title":"_2KfVQ","titleLocked":"_35XYh _2KfVQ","info":"_1erut","icons":"_3WIHN","lock":"_2AHgD"};

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tabs":"_3ljvB","tab":"_29ikZ","openTab":"_2VLXy _29ikZ","fullWidthTab":"_2p3bZ _29ikZ","bubble":"_3TK8x","bubbleButton":"_1KJXP _3TK8x","panel":"hnga5","flex":"_3oc2q","scheduleInput":"_1LGDV"};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"thumbnails":"BSaJR","heading":"_2Sfet","stars":"_3YtVL","iconButton":"a1crJ","favButton":"_2DvUR a1crJ","flagButton":"_3Qd0q a1crJ","infoOverlay":"_1fNCV","controls":"_3yDyM","controlsShown":"_17oZO _3yDyM","controlsHidden":"oNG8W _3yDyM"};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"thumbnail":"vMFrl","selectedOverlay":"_1rbCb","selectedOverlayActive":"_71hSy _1rbCb","image":"_24-jx","imageLoaded":"_1TZR0 _24-jx","infoLink":"_2jjpJ"};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"album":"_24v4r","cover":"_1nQTl","coverLoaded":"_2J16o _1nQTl","title":"_15r4j","name":"_3TFoa"};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_2X2lU","wrapper":"_1tFDr","window":"CouOt","biggerMargin":"_1nCRP","text":"_3lZ71","logo":"_1wfPs","logoOverlay":"_2yQwR","backButton":"_2vL6r"};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_3p2S-"};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_2Dz9e","item":"cvQty","itemSpinner":"_2m32r cvQty","spin":"_1VoQY","link":"_3psus","linkDisabled":"_1xFhV _3psus"};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3QpD0","info":"_3iRaz"};

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"ai_mX","modal":"_1z6oM","close":"QUxrM"};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"prefList":"_3C33Z","slider":"_3mRZq","sliderButton":"_2Dadk","numberInput":"_29r04","prefHelpText":"_2YPLq"};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"doneButton":"_3w7-6","createAlbumButton":"_1eHr-","page":"_1x-TX","intro":"_15AfZ","numberInput":"_1g9eO","dateInput":"_3LAvH"};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_2Co3d","greyButton":"sZd_K _2Co3d"};

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"numberInput":"_3vEbD","note":"_236RT","toggle":"_2rPNG","title":"_1IxMl"};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"yVQyz","page":"bKWnT","heading":"_3EFZG","playlist":"_2GiV2","cancelButton":"kEx6t yVQyz","deleteButton":"_X0Xj kEx6t yVQyz","showSettingsButton":"_2cUYU","settings":"_3X25f","timeInput":"_6i05L","conflict":"G8z5H","cover":"_3KTiT","linkButton":"lky2_","pickerWrapper":"_2V7nZ","previewButton":"j5I7k"};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bar":"_2Cugl","barMuted":"_2IV6Z _2Cugl","title":"_14-pE","subtitle":"k7uNT","button":"ClbQp","muteButton":"_1H62d","thumb":"_6vYOl","outerHandle":"IHqdC","rightLink":"_2j9RB","menu":"_1Pq86","menuOpen":"p1qib _1Pq86","menuButton":"_1PdeD"};

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_3WTk0","frontend":"_1HaQM","playing":"_3MVJY","skipped":"_3gx45","skippedDue":"_12FC0","skippedReasons":"_2qyBW","error":"SWRH5","conflict":"_2Yz-h"};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_2mWNL","paddedWrapper":"_1VOOS _2mWNL","object":"_3HBgm","objectActive":"_1XrXB _3HBgm","title":"sFyEF","info":"q1AV_","reason":"_4HHUx","conflict":"_2Nz0z _4HHUx","tools":"_2y5B3","heading":"_2TdKm","mainHeading":"_13Dz9 _2TdKm","album":"_1Yceo","albumInfo":"wXLcI","albumThumb":"_1D-aT","albumCount":"_1fAyM"};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"info":"yOxLd"};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"_3i-L-","float":"_3pEZJ"};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"K8yf_","imageTopLeft":"_3_RuR K8yf_","topLeft":"_1_qg1","imageTopRight":"_1xGwz K8yf_","topRight":"_3GJLb","imageBottomLeft":"_3IPgA K8yf_","bottomLeft":"rKwv2","imageBottomRight":"S0i3t K8yf_","bottomRight":"_1xs6x","enter":"plCyj","enterActive":"_3aAwp","leave":"Eo1iq","leaveActive":"_2-2rV"};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form":"_13BNz","select":"_1SKlP","optionValue":"_1QXQq","slider":"Ak9vL"};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"debugButton":"_2gLMD","wrapper":"_Zvde","controls":"_2dbFT","controlsHidden":"qnItg _2dbFT","bar":"_2frap","topBar":"_3hG7G _2frap","bottomBar":"Z6CS0 _2frap","button":"_3zeWB","controlButton":"_1XUa4 _3zeWB","progress":"_22fji","settingsButton":"G-buD _3zeWB","settingsButtonCorner":"_1NOiL G-buD _3zeWB","closeButton":"_3vM_8 _3zeWB","tools":"aqCrm","stars":"_6vlqm","info":"_3q521","imageInfoOverlay":"_2zm9Y","imageInfo":"_3zr5s","infoButton":"_3tcNq _2gLMD","debugModal":"_30hDQ"};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_2Pkuq","item":"_1pa01","heading":"_2lA0c","button":"_2Vnbe","buttonActive":"_2OjGx _2Vnbe","match":"WzSzF","parentNotice":"IsTKi"};

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"activeButton":"_38z9g","picker":"_2CGEX","button":"_22iPi _38z9g"};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"setDateButton":"_1Z6z-","picker":"_2KABg","column":"_2SxJd","numberInput":"DIt5r","noBottomMargin":"_3fqMj","todayPlaceholder":"_2cSr4"};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"range":"XQfQl","percentage":"_3nwCF"};

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3kZFK","buttonSelected":"AwxHF _3kZFK","buttonExcluded":"_1wIZM AwxHF _3kZFK"};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fixedWrapper":"_1R32s","termRow":"gT3KU","termRowDarker":"_1qfHl gT3KU","queryRow":"_14tFc gT3KU","queryRowDarker":"_1GWQy gT3KU","queryLeft":"_1PZCw","queryTitle":"_3AZwg","queryButton":"ZihuQ","queryCloseButton":"hAC5I ZihuQ","termButton":"_1nV1M ZihuQ _1PZCw","termIcon":"_2DBVP","operatorButton":"_3jMi7 ZihuQ"};

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dropdownButton":"_1c1ow","wrapper":"GWIwU","wrapperDisabled":"_2twQY GWIwU","text":"_2FrOz","textInput":"_2zre2","textInputDisabled":"_3Sjmq _2zre2","searchIcon":"_25i-b","inputTools":"_1b-VL","inputButton":"_2Llxx","cancelButton":"_3zgar _2Llxx","dropdown":"_3u3Yg","dropdownButtons":"ap1Op","addQueryButton":"en7C1 _1c1ow"};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_2niFI","buttons":"_1O2z0","greyButton":"_2iwzv _2niFI","tool":"_24LiT _2niFI"};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"picker":"_2UUu3","star":"_3YMj5","starOutline":"_2DON9 _3YMj5","nullButton":"_31wW-","nullButtonSelected":"_2ddyT _31wW-"};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerTitle":"_1o5a0","header":"_1JzqO","search":"_1_DXP","count":"_34bYI","unsaved":"_3ddaP","saveSuccess":"TfH_M _3ddaP","sortLink":"_1M0jS","selectHeader":"_2UUZs _1JzqO","headerTitleLeft":"_24VMI","headerButtons":"_3Lqp_","headerButtonsLeft":"omjfV _3Lqp_","headerButtonsRight":"_3CRWq _3Lqp_","slider":"_1dkw8"};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"createButton":"GCfGD","renameButton":"_14_B4","addButton":"_2RBDs","page":"_14_8l","heading":"_238-g","createInput":"_1TEgb","renameInput":"_17ll0","cancelButton":"_2ArYT _14_B4","refreshButton":"_75xtx _2RBDs","channel":"_3oshv","channelName":"_3oAgz","iconButton":"_37zh0","channelInfo":"_3Q5uy","controls":"_2jF9R","controlButtons":"MhxgO","control":"_3KUrn","controlDisabled":"_2QmSn _3KUrn","controlActive":"_1U19W _3KUrn","client":"_1_ddM","notes":"_3t2nY","linkButton":"at_k7","linkButtonLineBreak":"_1fExN","buttons":"_1QS7n","tools":"_1gnyc","tool":"_2tj-y","progressWrapper":"_3otlh","progressBar":"_7DuI8 _3otlh","external":"_1J-MD","channelQueue":"_1TI_f","channelQueueName":"_10UBh","channelQueueDuration":"_1yXiH","channelQueueTopRight":"_1BqXO","channelQueueBottomRight":"_1s3pc","timeRemaining":"_1BUyC","playingNow":"_2Z5ax","addQueueSelect":"_1yJoR","addQueueButton":"_1008N","inlineLabel":"_36O4h","channelToggle":"_1VIyR","disableToggle":"Lo-zU"};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"createButton":"_153Av","createSubmit":"_1evi_","page":"_8xloE","createForm":"_3Xa9Q","iconButton":"_3S1XG","condition":"_26Nti","keywords":"_1g047","tools":"_2svAp","intro":"_12LDY","addAnotherButton":"_3ovM3"};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_3IB87","heading":"_2EsDX"};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"-QxZH","title":"_21OR_","heading":"_3vy_C","editListsLink":"_1Ex8g","fakeHeader":"_33AEI","loadingWrapper":"_5zenH"};

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_1JHqy","page":"_3NN5u","thumb":"_1F5wU","info":"_2j33D","icons":"_22zIg","iconButton":"I6jda","outline":"_3XEpn","image":"_3-gzl","keyword":"_1fpDy","infoList":"mqgfC"};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"createButton":"_3Ne7h","page":"iCYqO","table":"_3mLSf","iconButton":"_1XX4L","nowrap":"Kcae_","input":"_1L97B","heading":"Dlf-z","existing":"B_YIV","error":"_10j35"};

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"kH2_-","album":"_2OPoY","thumb":"u8mZz","name":"_6DqMA","info":"_1Raxk","button":"jcmuH","editButton":"_23yvT"};

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"submit":"_1q63l","wrapper":"_2C4EA","form":"_2Pf8o","heading":"TEF9y","error":"_17Fd9"};

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"smallButton":"_1MBxY","page":"_2dGRs","orchestraPageFlexContainer":"_28-cr","scenePreferencesPanel":"_3hnES","sceneArrangePanel":"_1je6G","react-resizable":"q_-Li","react-resizable-handle":"_2DTqu","orchestraAdminHelpText":"Zpf9G","smallButtonActive":"_1U-Ed _1MBxY","sceneTypeDescription":"_3irsI"};

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_2lEqW","page":"H_0k-","heading":"_1pPye","playlist":"_2RV8x","name":"jvg5P","description":"_1GPo-","cover":"RmSWx","fixedLists":"_3GaPK"};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3PyXU","blackOverlay":"_3jijs"};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_13-p4","page":"l0jC7","heading":"_1qE1A","queue":"BXD4-","name":"_1BI8W","info":"_7PNLO","playlist":"JiGBM"};

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_2jVar","red":"_36K25"};

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"smallButton":"_2E1BI","submit":"_2qNW1","page":"_1SVp-","header":"_3jmlD","note":"_1pmup","label":"_2sYbQ","smallButtonActive":"_1z8pS _2E1BI","reset":"_3DeAJ _2qNW1"};

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_3zMYE","breadcrumbs":"_1LM0I","breadcrumb":"_1WZf8","periods":"_4Tm02","gap":"_3QA-y","button":"J8w3H"};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_3xlQE","createButton":"s7J_4","page":"eByZ5","user":"_4tU6W","userDisabled":"_3Vl-3 _4tU6W","name":"FcscJ","email":"jWLCk","permList":"_3QzN4","perm":"_2YGHN","permSuperAdmin":"_2AxPl _2YGHN","heading":"_2CY4E","notes":"_3v89W"};

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(872);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(882);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var createArrayFromMixed = __webpack_require__(875);
	var getMarkupWrap = __webpack_require__(877);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(879);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(881);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bf2a63762fcaa016a1d6b26f38e4aaa3.jpg";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/d2f1ffd0df4fdda164d2a1d979be4e48.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/43c69cea44be80be1b3faae6b5c32e0b.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(1252) !== null) && (__webpack_require__(1253) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Fuzzy
	 * https://github.com/myork/fuzzy
	 *
	 * Copyright (c) 2012 Matt York
	 * Licensed under the MIT license.
	 */
	
	(function() {
	
	var root = this;
	
	var fuzzy = {};
	
	// Use in node or in browser
	if (true) {
	  module.exports = fuzzy;
	} else {
	  root.fuzzy = fuzzy;
	}
	
	// Return all elements of `array` that have a fuzzy
	// match against `pattern`.
	fuzzy.simpleFilter = function(pattern, array) {
	  return array.filter(function(str) {
	    return fuzzy.test(pattern, str);
	  });
	};
	
	// Does `pattern` fuzzy match `str`?
	fuzzy.test = function(pattern, str) {
	  return fuzzy.match(pattern, str) !== null;
	};
	
	// If `pattern` matches `str`, wrap each matching character
	// in `opts.pre` and `opts.post`. If no match, return null
	fuzzy.match = function(pattern, str, opts) {
	  opts = opts || {};
	  var patternIdx = 0
	    , result = []
	    , len = str.length
	    , totalScore = 0
	    , currScore = 0
	    // prefix
	    , pre = opts.pre || ''
	    // suffix
	    , post = opts.post || ''
	    // String to compare against. This might be a lowercase version of the
	    // raw string
	    , compareString =  opts.caseSensitive && str || str.toLowerCase()
	    , ch;
	
	  pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
	
	  // For each character in the string, either add it to the result
	  // or wrap in template if it's the next string in the pattern
	  for(var idx = 0; idx < len; idx++) {
	    ch = str[idx];
	    if(compareString[idx] === pattern[patternIdx]) {
	      ch = pre + ch + post;
	      patternIdx += 1;
	
	      // consecutive characters should increase the score more than linearly
	      currScore += 1 + currScore;
	    } else {
	      currScore = 0;
	    }
	    totalScore += currScore;
	    result[result.length] = ch;
	  }
	
	  // return rendered string if we have a match for every char
	  if(patternIdx === pattern.length) {
	    // if the string is an exact match with pattern, totalScore should be maxed
	    totalScore = (compareString === pattern) ? Infinity : totalScore;
	    return {rendered: result.join(''), score: totalScore};
	  }
	
	  return null;
	};
	
	// The normal entry point. Filters `arr` for matches against `pattern`.
	// It returns an array with matching values of the type:
	//
	//     [{
	//         string:   '<b>lah' // The rendered string
	//       , index:    2        // The index of the element in `arr`
	//       , original: 'blah'   // The original element in `arr`
	//     }]
	//
	// `opts` is an optional argument bag. Details:
	//
	//    opts = {
	//        // string to put before a matching character
	//        pre:     '<b>'
	//
	//        // string to put after matching character
	//      , post:    '</b>'
	//
	//        // Optional function. Input is an entry in the given arr`,
	//        // output should be the string to test `pattern` against.
	//        // In this example, if `arr = [{crying: 'koala'}]` we would return
	//        // 'koala'.
	//      , extract: function(arg) { return arg.crying; }
	//    }
	fuzzy.filter = function(pattern, arr, opts) {
	  if(!arr || arr.length === 0) {
	    return [];
	  }
	  if (typeof pattern !== 'string') {
	    return arr;
	  }
	  opts = opts || {};
	  return arr
	    .reduce(function(prev, element, idx, arr) {
	      var str = element;
	      if(opts.extract) {
	        str = opts.extract(element);
	      }
	      var rendered = fuzzy.match(pattern, str, opts);
	      if(rendered != null) {
	        prev[prev.length] = {
	            string: rendered.rendered
	          , score: rendered.score
	          , index: idx
	          , original: element
	        };
	      }
	      return prev;
	    }, [])
	
	    // Sort by score. Browsers are inconsistent wrt stable/unstable
	    // sorting, so force stable by using the index in the case of tie.
	    // See http://ofb.net/~sethml/is-sort-stable.html
	    .sort(function(a,b) {
	      var compare = b.score - a.score;
	      if(compare) return compare;
	      return a.index - b.index;
	    });
	};
	
	
	}());
	


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),
/* 890 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(245);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(115);
	
	var _DOMUtils = __webpack_require__(175);
	
	var _DOMStateStorage = __webpack_require__(246);
	
	var _PathUtils = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(245);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(115);
	
	var _PathUtils = __webpack_require__(82);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(247);
	
	var _BrowserProtocol = __webpack_require__(245);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(892);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(175);
	
	var _createHistory = __webpack_require__(248);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(247);
	
	var _DOMUtils = __webpack_require__(175);
	
	var _HashProtocol = __webpack_require__(891);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(248);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(115);
	
	var _PathUtils = __webpack_require__(82);
	
	var _createHistory = __webpack_require__(248);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	var scheduleDrain;
	
	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {
	
	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();
	
	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}
	
	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}
	
	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(1038);
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	
	var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	
	/**
	 * Create a worker that uses pako to inflate/deflate.
	 * @constructor
	 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
	 * @param {Object} options the options to use when (de)compressing.
	 */
	function FlateWorker(action, options) {
	    GenericWorker.call(this, "FlateWorker/" + action);
	
	    this._pako = null;
	    this._pakoAction = action;
	    this._pakoOptions = options;
	    // the `meta` object from the last chunk received
	    // this allow this worker to pass around metadata
	    this.meta = {};
	}
	
	utils.inherits(FlateWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	FlateWorker.prototype.processChunk = function (chunk) {
	    this.meta = chunk.meta;
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	FlateWorker.prototype.flush = function () {
	    GenericWorker.prototype.flush.call(this);
	    if (this._pako === null) {
	        this._createPako();
	    }
	    this._pako.push([], true);
	};
	/**
	 * @see GenericWorker.cleanUp
	 */
	FlateWorker.prototype.cleanUp = function () {
	    GenericWorker.prototype.cleanUp.call(this);
	    this._pako = null;
	};
	
	/**
	 * Create the _pako object.
	 * TODO: lazy-loading this object isn't the best solution but it's the
	 * quickest. The best solution is to lazy-load the worker list. See also the
	 * issue #446.
	 */
	FlateWorker.prototype._createPako = function () {
	    this._pako = new pako[this._pakoAction]({
	        raw: true,
	        level: this._pakoOptions.level || -1 // default compression
	    });
	    var self = this;
	    this._pako.onData = function(data) {
	        self.push({
	            data : data,
	            meta : self.meta
	        });
	    };
	};
	
	exports.compressWorker = function (compressionOptions) {
	    return new FlateWorker("Deflate", compressionOptions);
	};
	exports.uncompressWorker = function () {
	    return new FlateWorker("Inflate", {});
	};


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	var utf8 = __webpack_require__(117);
	var crc32 = __webpack_require__(253);
	var signature = __webpack_require__(375);
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "", i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {
	
	    // the dir flag is already set for compatibility
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {Object} streamInfo the hash with information about the compressed file.
	 * @param {Boolean} streamedContent is the content streamed ?
	 * @param {Boolean} streamingEnded is the stream finished ?
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {Object} the zip parts.
	 */
	var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
	    var file = streamInfo['file'],
	    compression = streamInfo['compression'],
	    useCustomEncoding = encodeFileName !== utf8.utf8encode,
	    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	    comment = file.comment,
	    encodedComment = utils.transformTo("string", encodeFileName(comment)),
	    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	    useUTF8ForComment = utfEncodedComment.length !== comment.length,
	    dosTime,
	    dosDate,
	    extraFields = "",
	    unicodePathExtraField = "",
	    unicodeCommentExtraField = "",
	    dir = file.dir,
	    date = file.date;
	
	
	    var dataInfo = {
	        crc32 : 0,
	        compressedSize : 0,
	        uncompressedSize : 0
	    };
	
	    // if the content is streamed, the sizes/crc32 are only available AFTER
	    // the end of the stream.
	    if (!streamedContent || streamingEnded) {
	        dataInfo.crc32 = streamInfo['crc32'];
	        dataInfo.compressedSize = streamInfo['compressedSize'];
	        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
	    }
	
	    var bitflag = 0;
	    if (streamedContent) {
	        // Bit 3: the sizes/crc32 are set to zero in the local header.
	        // The correct values are put in the data descriptor immediately
	        // following the compressed data.
	        bitflag |= 0x0008;
	    }
	    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
	        // Bit 11: Language encoding flag (EFS).
	        bitflag |= 0x0800;
	    }
	
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getUTCHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getUTCMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getUTCSeconds() / 2;
	
	    dosDate = date.getUTCFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getUTCMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getUTCDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    header += decToHex(bitflag, 2);
	    // compression method
	    header += compression.magic;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(dataInfo.crc32, 4);
	    // compressed size
	    header += decToHex(dataInfo.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(dataInfo.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	        // version made by (00: DOS)
	        decToHex(versionMadeBy, 2) +
	        // file header (common to file and central directory)
	        header +
	        // file comment length
	        decToHex(encodedComment.length, 2) +
	        // disk number start
	        "\x00\x00" +
	        // internal file attributes TODO
	        "\x00\x00" +
	        // external file attributes
	        decToHex(extFileAttr, 4) +
	        // relative offset of local header
	        decToHex(offset, 4) +
	        // file name
	        encodedFileName +
	        // extra field
	        extraFields +
	        // file comment
	        encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord
	    };
	};
	
	/**
	 * Generate the EOCD record.
	 * @param {Number} entriesCount the number of entries in the zip file.
	 * @param {Number} centralDirLength the length (in bytes) of the central dir.
	 * @param {Number} localDirLength the length (in bytes) of the local dir.
	 * @param {String} comment the zip file comment as a binary string.
	 * @param {Function} encodeFileName the function to encode the comment.
	 * @return {String} the EOCD record.
	 */
	var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
	    var dirEnd = "";
	    var encodedComment = utils.transformTo("string", encodeFileName(comment));
	
	    // end of central dir signature
	    dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(entriesCount, 2) +
	        // total number of entries in the central directory
	        decToHex(entriesCount, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	    return dirEnd;
	};
	
	/**
	 * Generate data descriptors for a file entry.
	 * @param {Object} streamInfo the hash generated by a worker, containing information
	 * on the file entry.
	 * @return {String} the data descriptors.
	 */
	var generateDataDescriptors = function (streamInfo) {
	    var descriptor = "";
	    descriptor = signature.DATA_DESCRIPTOR +
	        // crc-32                          4 bytes
	        decToHex(streamInfo['crc32'], 4) +
	        // compressed size                 4 bytes
	        decToHex(streamInfo['compressedSize'], 4) +
	        // uncompressed size               4 bytes
	        decToHex(streamInfo['uncompressedSize'], 4);
	
	    return descriptor;
	};
	
	
	/**
	 * A worker to concatenate other workers to create a zip file.
	 * @param {Boolean} streamFiles `true` to stream the content of the files,
	 * `false` to accumulate it.
	 * @param {String} comment the comment to use.
	 * @param {String} platform the platform to use, "UNIX" or "DOS".
	 * @param {Function} encodeFileName the function to encode file names and comments.
	 */
	function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
	    GenericWorker.call(this, "ZipFileWorker");
	    // The number of bytes written so far. This doesn't count accumulated chunks.
	    this.bytesWritten = 0;
	    // The comment of the zip file
	    this.zipComment = comment;
	    // The platform "generating" the zip file.
	    this.zipPlatform = platform;
	    // the function to encode file names and comments.
	    this.encodeFileName = encodeFileName;
	    // Should we stream the content of the files ?
	    this.streamFiles = streamFiles;
	    // If `streamFiles` is false, we will need to accumulate the content of the
	    // files to calculate sizes / crc32 (and write them *before* the content).
	    // This boolean indicates if we are accumulating chunks (it will change a lot
	    // during the lifetime of this worker).
	    this.accumulate = false;
	    // The buffer receiving chunks when accumulating content.
	    this.contentBuffer = [];
	    // The list of generated directory records.
	    this.dirRecords = [];
	    // The offset (in bytes) from the beginning of the zip file for the current source.
	    this.currentSourceOffset = 0;
	    // The total number of entries in this zip file.
	    this.entriesCount = 0;
	    // the name of the file currently being added, null when handling the end of the zip file.
	    // Used for the emitted metadata.
	    this.currentFile = null;
	
	
	
	    this._sources = [];
	}
	utils.inherits(ZipFileWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.push
	 */
	ZipFileWorker.prototype.push = function (chunk) {
	
	    var currentFilePercent = chunk.meta.percent || 0;
	    var entriesCount = this.entriesCount;
	    var remainingFiles = this._sources.length;
	
	    if(this.accumulate) {
	        this.contentBuffer.push(chunk);
	    } else {
	        this.bytesWritten += chunk.data.length;
	
	        GenericWorker.prototype.push.call(this, {
	            data : chunk.data,
	            meta : {
	                currentFile : this.currentFile,
	                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
	            }
	        });
	    }
	};
	
	/**
	 * The worker started a new source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the new source.
	 */
	ZipFileWorker.prototype.openedSource = function (streamInfo) {
	    this.currentSourceOffset = this.bytesWritten;
	    this.currentFile = streamInfo['file'].name;
	
	    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
	
	    // don't stream folders (because they don't have any content)
	    if(streamedContent) {
	        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	    } else {
	        // we need to wait for the whole file before pushing anything
	        this.accumulate = true;
	    }
	};
	
	/**
	 * The worker finished a source (an other worker).
	 * @param {Object} streamInfo the streamInfo object from the finished source.
	 */
	ZipFileWorker.prototype.closedSource = function (streamInfo) {
	    this.accumulate = false;
	    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
	    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
	
	    this.dirRecords.push(record.dirRecord);
	    if(streamedContent) {
	        // after the streamed file, we put data descriptors
	        this.push({
	            data : generateDataDescriptors(streamInfo),
	            meta : {percent:100}
	        });
	    } else {
	        // the content wasn't streamed, we need to push everything now
	        // first the file record, then the content
	        this.push({
	            data : record.fileRecord,
	            meta : {percent:0}
	        });
	        while(this.contentBuffer.length) {
	            this.push(this.contentBuffer.shift());
	        }
	    }
	    this.currentFile = null;
	};
	
	/**
	 * @see GenericWorker.flush
	 */
	ZipFileWorker.prototype.flush = function () {
	
	    var localDirLength = this.bytesWritten;
	    for(var i = 0; i < this.dirRecords.length; i++) {
	        this.push({
	            data : this.dirRecords[i],
	            meta : {percent:100}
	        });
	    }
	    var centralDirLength = this.bytesWritten - localDirLength;
	
	    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
	
	    this.push({
	        data : dirEnd,
	        meta : {percent:100}
	    });
	};
	
	/**
	 * Prepare the next source to be read.
	 */
	ZipFileWorker.prototype.prepareNextSource = function () {
	    this.previous = this._sources.shift();
	    this.openedSource(this.previous.streamInfo);
	    if (this.isPaused) {
	        this.previous.pause();
	    } else {
	        this.previous.resume();
	    }
	};
	
	/**
	 * @see GenericWorker.registerPrevious
	 */
	ZipFileWorker.prototype.registerPrevious = function (previous) {
	    this._sources.push(previous);
	    var self = this;
	
	    previous.on('data', function (chunk) {
	        self.processChunk(chunk);
	    });
	    previous.on('end', function () {
	        self.closedSource(self.previous.streamInfo);
	        if(self._sources.length) {
	            self.prepareNextSource();
	        } else {
	            self.end();
	        }
	    });
	    previous.on('error', function (e) {
	        self.error(e);
	    });
	    return this;
	};
	
	/**
	 * @see GenericWorker.resume
	 */
	ZipFileWorker.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if (!this.previous && this._sources.length) {
	        this.prepareNextSource();
	        return true;
	    }
	    if (!this.previous && !this._sources.length && !this.generatedError) {
	        this.end();
	        return true;
	    }
	};
	
	/**
	 * @see GenericWorker.error
	 */
	ZipFileWorker.prototype.error = function (e) {
	    var sources = this._sources;
	    if(!GenericWorker.prototype.error.call(this, e)) {
	        return false;
	    }
	    for(var i = 0; i < sources.length; i++) {
	        try {
	            sources[i].error(e);
	        } catch(e) {
	            // the `error` exploded, nothing to do
	        }
	    }
	    return true;
	};
	
	/**
	 * @see GenericWorker.lock
	 */
	ZipFileWorker.prototype.lock = function () {
	    GenericWorker.prototype.lock.call(this);
	    var sources = this._sources;
	    for(var i = 0; i < sources.length; i++) {
	        sources[i].lock();
	    }
	};
	
	module.exports = ZipFileWorker;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var compressions = __webpack_require__(368);
	var ZipFileWorker = __webpack_require__(900);
	
	/**
	 * Find the compression to use.
	 * @param {String} fileCompression the compression defined at the file level, if any.
	 * @param {String} zipCompression the compression defined at the load() level.
	 * @return {Object} the compression object to use.
	 */
	var getCompression = function (fileCompression, zipCompression) {
	
	    var compressionName = fileCompression || zipCompression;
	    var compression = compressions[compressionName];
	    if (!compression) {
	        throw new Error(compressionName + " is not a valid compression method !");
	    }
	    return compression;
	};
	
	/**
	 * Create a worker to generate a zip file.
	 * @param {JSZip} zip the JSZip instance at the right root level.
	 * @param {Object} options to generate the zip file.
	 * @param {String} comment the comment to use.
	 */
	exports.generateWorker = function (zip, options, comment) {
	
	    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
	    var entriesCount = 0;
	    try {
	
	        zip.forEach(function (relativePath, file) {
	            entriesCount++;
	            var compression = getCompression(file.options.compression, options.compression);
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	            var dir = file.dir, date = file.date;
	
	            file._compressWorker(compression, compressionOptions)
	            .withStreamInfo("file", {
	                name : relativePath,
	                dir : dir,
	                date : date,
	                comment : file.comment || "",
	                unixPermissions : file.unixPermissions,
	                dosPermissions : file.dosPermissions
	            })
	            .pipe(zipFileWorker);
	        });
	        zipFileWorker.entriesCount = entriesCount;
	    } catch (e) {
	        zipFileWorker.error(e);
	    }
	
	    return zipFileWorker;
	};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 */
	function JSZip() {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) {
	        return new JSZip();
	    }
	
	    if(arguments.length) {
	        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
	    }
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(906);
	JSZip.prototype.loadAsync = __webpack_require__(903);
	JSZip.support = __webpack_require__(83);
	JSZip.defaults = __webpack_require__(369);
	
	// TODO find a better way to handle this version,
	// a require('package.json').version doesn't work with webpack, see #327
	JSZip.version = "3.5.0";
	
	JSZip.loadAsync = function (content, options) {
	    return new JSZip().loadAsync(content, options);
	};
	
	JSZip.external = __webpack_require__(136);
	module.exports = JSZip;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(25);
	var external = __webpack_require__(136);
	var utf8 = __webpack_require__(117);
	var utils = __webpack_require__(25);
	var ZipEntries = __webpack_require__(910);
	var Crc32Probe = __webpack_require__(376);
	var nodejsUtils = __webpack_require__(176);
	
	/**
	 * Check the CRC32 of an entry.
	 * @param {ZipEntry} zipEntry the zip entry to check.
	 * @return {Promise} the result.
	 */
	function checkEntryCRC32(zipEntry) {
	    return new external.Promise(function (resolve, reject) {
	        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
	        worker.on("error", function (e) {
	            reject(e);
	        })
	        .on("end", function () {
	            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
	                reject(new Error("Corrupted zip : CRC32 mismatch"));
	            } else {
	                resolve();
	            }
	        })
	        .resume();
	    });
	}
	
	module.exports = function(data, options) {
	    var zip = this;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString: false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	
	    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
	    }
	
	    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
	    .then(function(data) {
	        var zipEntries = new ZipEntries(options);
	        zipEntries.load(data);
	        return zipEntries;
	    }).then(function checkCRC32(zipEntries) {
	        var promises = [external.Promise.resolve(zipEntries)];
	        var files = zipEntries.files;
	        if (options.checkCRC32) {
	            for (var i = 0; i < files.length; i++) {
	                promises.push(checkEntryCRC32(files[i]));
	            }
	        }
	        return external.Promise.all(promises);
	    }).then(function addFiles(results) {
	        var zipEntries = results.shift();
	        var files = zipEntries.files;
	        for (var i = 0; i < files.length; i++) {
	            var input = files[i];
	            zip.file(input.fileNameStr, input.decompressed, {
	                binary: true,
	                optimizedBinaryString: true,
	                date: input.date,
	                dir: input.dir,
	                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
	                unixPermissions : input.unixPermissions,
	                dosPermissions : input.dosPermissions,
	                createFolders: options.createFolders
	            });
	        }
	        if (zipEntries.zipComment.length) {
	            zip.comment = zipEntries.zipComment;
	        }
	
	        return zip;
	    });
	};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	
	/**
	 * A worker that use a nodejs stream as source.
	 * @constructor
	 * @param {String} filename the name of the file entry for this stream.
	 * @param {Readable} stream the nodejs stream.
	 */
	function NodejsStreamInputAdapter(filename, stream) {
	    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
	    this._upstreamEnded = false;
	    this._bindStream(stream);
	}
	
	utils.inherits(NodejsStreamInputAdapter, GenericWorker);
	
	/**
	 * Prepare the stream and bind the callbacks on it.
	 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
	 * @param {Stream} stream the nodejs stream to use.
	 */
	NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
	    var self = this;
	    this._stream = stream;
	    stream.pause();
	    stream
	    .on("data", function (chunk) {
	        self.push({
	            data: chunk,
	            meta : {
	                percent : 0
	            }
	        });
	    })
	    .on("error", function (e) {
	        if(self.isPaused) {
	            this.generatedError = e;
	        } else {
	            self.error(e);
	        }
	    })
	    .on("end", function () {
	        if(self.isPaused) {
	            self._upstreamEnded = true;
	        } else {
	            self.end();
	        }
	    });
	};
	NodejsStreamInputAdapter.prototype.pause = function () {
	    if(!GenericWorker.prototype.pause.call(this)) {
	        return false;
	    }
	    this._stream.pause();
	    return true;
	};
	NodejsStreamInputAdapter.prototype.resume = function () {
	    if(!GenericWorker.prototype.resume.call(this)) {
	        return false;
	    }
	
	    if(this._upstreamEnded) {
	        this.end();
	    } else {
	        this._stream.resume();
	    }
	
	    return true;
	};
	
	module.exports = NodejsStreamInputAdapter;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Readable = __webpack_require__(370).Readable;
	
	var utils = __webpack_require__(25);
	utils.inherits(NodejsStreamOutputAdapter, Readable);
	
	/**
	* A nodejs stream using a worker as source.
	* @see the SourceWrapper in http://nodejs.org/api/stream.html
	* @constructor
	* @param {StreamHelper} helper the helper wrapping the worker
	* @param {Object} options the nodejs stream options
	* @param {Function} updateCb the update callback.
	*/
	function NodejsStreamOutputAdapter(helper, options, updateCb) {
	    Readable.call(this, options);
	    this._helper = helper;
	
	    var self = this;
	    helper.on("data", function (data, meta) {
	        if (!self.push(data)) {
	            self._helper.pause();
	        }
	        if(updateCb) {
	            updateCb(meta);
	        }
	    })
	    .on("error", function(e) {
	        self.emit('error', e);
	    })
	    .on("end", function () {
	        self.push(null);
	    });
	}
	
	
	NodejsStreamOutputAdapter.prototype._read = function() {
	    this._helper.resume();
	};
	
	module.exports = NodejsStreamOutputAdapter;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utf8 = __webpack_require__(117);
	var utils = __webpack_require__(25);
	var GenericWorker = __webpack_require__(48);
	var StreamHelper = __webpack_require__(379);
	var defaults = __webpack_require__(369);
	var CompressedObject = __webpack_require__(252);
	var ZipObject = __webpack_require__(912);
	var generate = __webpack_require__(901);
	var nodejsUtils = __webpack_require__(176);
	var NodejsStreamInputAdapter = __webpack_require__(904);
	
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} originalOptions the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, originalOptions) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	
	    /*
	     * Correct options.
	     */
	
	    var o = utils.extend(originalOptions || {}, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) {
	        o.compression = o.compression.toUpperCase();
	    }
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
	    if (!originalOptions || typeof originalOptions.binary === "undefined") {
	        o.binary = !isUnicodeString;
	    }
	
	
	    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;
	
	    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
	        o.base64 = false;
	        o.binary = true;
	        data = "";
	        o.compression = "STORE";
	        dataType = "string";
	    }
	
	    /*
	     * Convert content to fit.
	     */
	
	    var zipObjectContent = null;
	    if (data instanceof CompressedObject || data instanceof GenericWorker) {
	        zipObjectContent = data;
	    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
	        zipObjectContent = new NodejsStreamInputAdapter(name, data);
	    } else {
	        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
	    }
	
	    var object = new ZipObject(name, zipObjectContent, o);
	    this.files[name] = object;
	    /*
	    TODO: we can't throw an exception because we have async promises
	    (we can have a promise of a Date() for example) but returning a
	    promise is useless because file(name, data) returns the JSZip
	    object for chaining. Should we break that to allow the user
	    to catch the error ?
	
	    return external.Promise.resolve(zipObjectContent)
	    .then(function () {
	        return object;
	    });
	    */
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) === '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) !== "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	function isRegExp(object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	}
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * @see loadAsync
	     */
	    load: function() {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	
	    /**
	     * Call a callback function for each entry at this folder level.
	     * @param {Function} cb the callback function:
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     */
	    forEach: function(cb) {
	        var filename, relativePath, file;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
	                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
	            }
	        }
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [];
	        this.forEach(function (relativePath, entry) {
	            if (search(relativePath, entry)) { // the file matches the function
	                result.push(entry);
	            }
	
	        });
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                var obj = this.files[this.root + name];
	                if (obj && !obj.dir) {
	                    return obj;
	                } else {
	                    return null;
	                }
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) !== "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	    },
	
	    /**
	     * Generate the complete zip file as an internal stream.
	     * @param {Object} options the options to generate the zip file :
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {StreamHelper} the streamed zip file.
	     */
	    generateInternalStream: function(options) {
	      var worker, opts = {};
	      try {
	          opts = utils.extend(options || {}, {
	              streamFiles: false,
	              compression: "STORE",
	              compressionOptions : null,
	              type: "",
	              platform: "DOS",
	              comment: null,
	              mimeType: 'application/zip',
	              encodeFileName: utf8.utf8encode
	          });
	
	          opts.type = opts.type.toLowerCase();
	          opts.compression = opts.compression.toUpperCase();
	
	          // "binarystring" is preferred but the internals use "string".
	          if(opts.type === "binarystring") {
	            opts.type = "string";
	          }
	
	          if (!opts.type) {
	            throw new Error("No output type specified.");
	          }
	
	          utils.checkSupport(opts.type);
	
	          // accept nodejs `process.platform`
	          if(
	              opts.platform === 'darwin' ||
	              opts.platform === 'freebsd' ||
	              opts.platform === 'linux' ||
	              opts.platform === 'sunos'
	          ) {
	              opts.platform = "UNIX";
	          }
	          if (opts.platform === 'win32') {
	              opts.platform = "DOS";
	          }
	
	          var comment = opts.comment || this.comment || "";
	          worker = generate.generateWorker(this, opts, comment);
	      } catch (e) {
	        worker = new GenericWorker("error");
	        worker.error(e);
	      }
	      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateAsync: function(options, onUpdate) {
	        return this.generateInternalStream(options).accumulate(onUpdate);
	    },
	    /**
	     * Generate the complete zip file asynchronously.
	     * @see generateInternalStream
	     */
	    generateNodeStream: function(options, onUpdate) {
	        options = options || {};
	        if (!options.type) {
	            options.type = "nodebuffer";
	        }
	        return this.generateInternalStream(options).toNodejsStream(onUpdate);
	    }
	};
	module.exports = out;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(373);
	var utils = __webpack_require__(25);
	
	function NodeBufferReader(data) {
	    Uint8ArrayReader.call(this, data);
	}
	utils.inherits(NodeBufferReader, Uint8ArrayReader);
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(372);
	var utils = __webpack_require__(25);
	
	function StringReader(data) {
	    DataReader.call(this, data);
	}
	utils.inherits(StringReader, DataReader);
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readAndCheckSignature
	 */
	StringReader.prototype.readAndCheckSignature = function (sig) {
	    var data = this.readData(4);
	    return sig === data;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GenericWorker = __webpack_require__(48);
	var utils = __webpack_require__(25);
	
	/**
	 * A worker which convert chunks to a specified type.
	 * @constructor
	 * @param {String} destType the destination type.
	 */
	function ConvertWorker(destType) {
	    GenericWorker.call(this, "ConvertWorker to " + destType);
	    this.destType = destType;
	}
	utils.inherits(ConvertWorker, GenericWorker);
	
	/**
	 * @see GenericWorker.processChunk
	 */
	ConvertWorker.prototype.processChunk = function (chunk) {
	    this.push({
	        data : utils.transformTo(this.destType, chunk.data),
	        meta : chunk.meta
	    });
	};
	module.exports = ConvertWorker;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var readerFor = __webpack_require__(374);
	var utils = __webpack_require__(25);
	var sig = __webpack_require__(375);
	var ZipEntry = __webpack_require__(911);
	var utf8 = __webpack_require__(117);
	var support = __webpack_require__(83);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the specified signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        if (!this.reader.readAndCheckSignature(expectedSignature)) {
	            this.reader.index -= 4;
	            var signature = this.reader.readString(4);
	            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.reader.skip(4);
	        // this.versionMadeBy = this.reader.readString(2);
	        // this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readData(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip: can't find end of central directory");
	            }
	
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        this.reader = readerFor(data);
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var readerFor = __webpack_require__(374);
	var utils = __webpack_require__(25);
	var CompressedObject = __webpack_require__(252);
	var crc32fn = __webpack_require__(253);
	var utf8 = __webpack_require__(117);
	var compressions = __webpack_require__(368);
	var support = __webpack_require__(83);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	var findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
	        }
	
	        compression = findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        reader.skip(2);
	        // this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        var fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        // will be read in the local part, see the comments there
	        reader.skip(fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = readerFor(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var end = reader.index + this.extraFieldsLength,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        if (!this.extraFields) {
	            this.extraFields = {};
	        }
	
	        while (reader.index + 4 < end) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readData(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	
	        reader.setIndex(end);
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = utf8.utf8decode(this.fileName);
	            this.fileCommentStr = utf8.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                // ASCII text or unsupported code page
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                // ASCII text or unsupported code page
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = readerFor(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = readerFor(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var StreamHelper = __webpack_require__(379);
	var DataWorker = __webpack_require__(378);
	var utf8 = __webpack_require__(117);
	var CompressedObject = __webpack_require__(252);
	var GenericWorker = __webpack_require__(48);
	
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this._dataBinary = options.binary;
	    // keep only the compression
	    this.options = {
	        compression : options.compression,
	        compressionOptions : options.compressionOptions
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Create an internal stream for the content of this object.
	     * @param {String} type the type of each chunk.
	     * @return StreamHelper the stream.
	     */
	    internalStream: function (type) {
	        var result = null, outputType = "string";
	        try {
	            if (!type) {
	                throw new Error("No output type specified.");
	            }
	            outputType = type.toLowerCase();
	            var askUnicodeString = outputType === "string" || outputType === "text";
	            if (outputType === "binarystring" || outputType === "text") {
	                outputType = "string";
	            }
	            result = this._decompressWorker();
	
	            var isUnicodeString = !this._dataBinary;
	
	            if (isUnicodeString && !askUnicodeString) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            if (!isUnicodeString && askUnicodeString) {
	                result = result.pipe(new utf8.Utf8DecodeWorker());
	            }
	        } catch (e) {
	            result = new GenericWorker("error");
	            result.error(e);
	        }
	
	        return new StreamHelper(result, outputType, "");
	    },
	
	    /**
	     * Prepare the content in the asked type.
	     * @param {String} type the type of the result.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Promise the promise of the result.
	     */
	    async: function (type, onUpdate) {
	        return this.internalStream(type).accumulate(onUpdate);
	    },
	
	    /**
	     * Prepare the content as a nodejs stream.
	     * @param {String} type the type of each chunk.
	     * @param {Function} onUpdate a function to call on each internal update.
	     * @return Stream the stream.
	     */
	    nodeStream: function (type, onUpdate) {
	        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
	    },
	
	    /**
	     * Return a worker for the compressed content.
	     * @private
	     * @param {Object} compression the compression object to use.
	     * @param {Object} compressionOptions the options to use when compressing.
	     * @return Worker the worker.
	     */
	    _compressWorker: function (compression, compressionOptions) {
	        if (
	            this._data instanceof CompressedObject &&
	            this._data.compression.magic === compression.magic
	        ) {
	            return this._data.getCompressedWorker();
	        } else {
	            var result = this._decompressWorker();
	            if(!this._dataBinary) {
	                result = result.pipe(new utf8.Utf8EncodeWorker());
	            }
	            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
	        }
	    },
	    /**
	     * Return a worker for the decompressed content.
	     * @private
	     * @return Worker the worker.
	     */
	    _decompressWorker : function () {
	        if (this._data instanceof CompressedObject) {
	            return this._data.getContentWorker();
	        } else if (this._data instanceof GenericWorker) {
	            return this._data;
	        } else {
	            return new DataWorker(this._data);
	        }
	    }
	};
	
	var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
	var removedFn = function () {
	    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
	};
	
	for(var i = 0; i < removedMethods.length; i++) {
	    ZipObject.prototype[removedMethods[i]] = removedFn;
	}
	module.exports = ZipObject;


/***/ }),
/* 913 */
/***/ (function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(913);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(914);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var immediate = __webpack_require__(897);
	
	/* istanbul ignore next */
	function INTERNAL() {}
	
	var handlers = {};
	
	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];
	
	module.exports = Promise;
	
	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}
	
	Promise.prototype["finally"] = function (callback) {
	  if (typeof callback !== 'function') {
	    return this;
	  }
	  var p = this.constructor;
	  return this.then(resolve, reject);
	
	  function resolve(value) {
	    function yes () {
	      return value;
	    }
	    return p.resolve(callback()).then(yes);
	  }
	  function reject(reason) {
	    function no () {
	      throw reason;
	    }
	    return p.resolve(callback()).then(no);
	  }
	};
	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }
	
	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};
	
	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}
	
	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;
	
	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};
	
	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}
	
	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }
	
	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }
	
	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }
	
	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}
	
	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}
	
	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}
	
	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}
	
	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}
	
	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }
	
	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }
	
	  var i = -1;
	  var promise = new this(INTERNAL);
	
	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Helpers
	
	// Merge objects
	//
	function assign(obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	
	  sources.forEach(function (source) {
	    if (!source) { return; }
	
	    Object.keys(source).forEach(function (key) {
	      obj[key] = source[key];
	    });
	  });
	
	  return obj;
	}
	
	function _class(obj) { return Object.prototype.toString.call(obj); }
	function isString(obj) { return _class(obj) === '[object String]'; }
	function isObject(obj) { return _class(obj) === '[object Object]'; }
	function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
	function isFunction(obj) { return _class(obj) === '[object Function]'; }
	
	
	function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }
	
	////////////////////////////////////////////////////////////////////////////////
	
	
	var defaultOptions = {
	  fuzzyLink: true,
	  fuzzyEmail: true,
	  fuzzyIP: false
	};
	
	
	function isOptionsObj(obj) {
	  return Object.keys(obj || {}).reduce(function (acc, k) {
	    return acc || defaultOptions.hasOwnProperty(k);
	  }, false);
	}
	
	
	var defaultSchemas = {
	  'http:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.http) {
	        // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.http =  new RegExp(
	          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
	        );
	      }
	      if (self.re.http.test(tail)) {
	        return tail.match(self.re.http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'https:':  'http:',
	  'ftp:':    'http:',
	  '//':      {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.no_http) {
	      // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.no_http =  new RegExp(
	          '^' +
	          self.re.src_auth +
	          // Don't allow single-level domains, because of false positives like '//test'
	          // with code comments
	          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
	          self.re.src_port +
	          self.re.src_host_terminator +
	          self.re.src_path,
	
	          'i'
	        );
	      }
	
	      if (self.re.no_http.test(tail)) {
	        // should not be `://` & `///`, that protects from errors in protocol name
	        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
	        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
	        return tail.match(self.re.no_http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'mailto:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.mailto) {
	        self.re.mailto =  new RegExp(
	          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
	        );
	      }
	      if (self.re.mailto.test(tail)) {
	        return tail.match(self.re.mailto)[0].length;
	      }
	      return 0;
	    }
	  }
	};
	
	/*eslint-disable max-len*/
	
	// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
	var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
	
	// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
	var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
	
	/*eslint-enable max-len*/
	
	////////////////////////////////////////////////////////////////////////////////
	
	function resetScanCache(self) {
	  self.__index__ = -1;
	  self.__text_cache__   = '';
	}
	
	function createValidator(re) {
	  return function (text, pos) {
	    var tail = text.slice(pos);
	
	    if (re.test(tail)) {
	      return tail.match(re)[0].length;
	    }
	    return 0;
	  };
	}
	
	function createNormalizer() {
	  return function (match, self) {
	    self.normalize(match);
	  };
	}
	
	// Schemas compiler. Build regexps.
	//
	function compile(self) {
	
	  // Load & clone RE patterns.
	  var re = self.re = __webpack_require__(918)(self.__opts__);
	
	  // Define dynamic patterns
	  var tlds = self.__tlds__.slice();
	
	  self.onCompile();
	
	  if (!self.__tlds_replaced__) {
	    tlds.push(tlds_2ch_src_re);
	  }
	  tlds.push(re.src_xn);
	
	  re.src_tlds = tlds.join('|');
	
	  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }
	
	  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
	  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
	  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
	  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
	
	  //
	  // Compile each schema
	  //
	
	  var aliases = [];
	
	  self.__compiled__ = {}; // Reset compiled data
	
	  function schemaError(name, val) {
	    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
	  }
	
	  Object.keys(self.__schemas__).forEach(function (name) {
	    var val = self.__schemas__[name];
	
	    // skip disabled methods
	    if (val === null) { return; }
	
	    var compiled = { validate: null, link: null };
	
	    self.__compiled__[name] = compiled;
	
	    if (isObject(val)) {
	      if (isRegExp(val.validate)) {
	        compiled.validate = createValidator(val.validate);
	      } else if (isFunction(val.validate)) {
	        compiled.validate = val.validate;
	      } else {
	        schemaError(name, val);
	      }
	
	      if (isFunction(val.normalize)) {
	        compiled.normalize = val.normalize;
	      } else if (!val.normalize) {
	        compiled.normalize = createNormalizer();
	      } else {
	        schemaError(name, val);
	      }
	
	      return;
	    }
	
	    if (isString(val)) {
	      aliases.push(name);
	      return;
	    }
	
	    schemaError(name, val);
	  });
	
	  //
	  // Compile postponed aliases
	  //
	
	  aliases.forEach(function (alias) {
	    if (!self.__compiled__[self.__schemas__[alias]]) {
	      // Silently fail on missed schemas to avoid errons on disable.
	      // schemaError(alias, self.__schemas__[alias]);
	      return;
	    }
	
	    self.__compiled__[alias].validate =
	      self.__compiled__[self.__schemas__[alias]].validate;
	    self.__compiled__[alias].normalize =
	      self.__compiled__[self.__schemas__[alias]].normalize;
	  });
	
	  //
	  // Fake record for guessed links
	  //
	  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };
	
	  //
	  // Build schema condition
	  //
	  var slist = Object.keys(self.__compiled__)
	                      .filter(function (name) {
	                        // Filter disabled & fake schemas
	                        return name.length > 0 && self.__compiled__[name];
	                      })
	                      .map(escapeRE)
	                      .join('|');
	  // (?!_) cause 1.5x slowdown
	  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
	  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
	
	  self.re.pretest = RegExp(
	    '(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@',
	    'i'
	  );
	
	  //
	  // Cleanup
	  //
	
	  resetScanCache(self);
	}
	
	/**
	 * class Match
	 *
	 * Match result. Single element of array, returned by [[LinkifyIt#match]]
	 **/
	function Match(self, shift) {
	  var start = self.__index__,
	      end   = self.__last_index__,
	      text  = self.__text_cache__.slice(start, end);
	
	  /**
	   * Match#schema -> String
	   *
	   * Prefix (protocol) for matched string.
	   **/
	  this.schema    = self.__schema__.toLowerCase();
	  /**
	   * Match#index -> Number
	   *
	   * First position of matched string.
	   **/
	  this.index     = start + shift;
	  /**
	   * Match#lastIndex -> Number
	   *
	   * Next position after matched string.
	   **/
	  this.lastIndex = end + shift;
	  /**
	   * Match#raw -> String
	   *
	   * Matched string.
	   **/
	  this.raw       = text;
	  /**
	   * Match#text -> String
	   *
	   * Notmalized text of matched string.
	   **/
	  this.text      = text;
	  /**
	   * Match#url -> String
	   *
	   * Normalized url of matched string.
	   **/
	  this.url       = text;
	}
	
	function createMatch(self, shift) {
	  var match = new Match(self, shift);
	
	  self.__compiled__[match.schema].normalize(match, self);
	
	  return match;
	}
	
	
	/**
	 * class LinkifyIt
	 **/
	
	/**
	 * new LinkifyIt(schemas, options)
	 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Creates new linkifier instance with optional additional schemas.
	 * Can be called without `new` keyword for convenience.
	 *
	 * By default understands:
	 *
	 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
	 * - "fuzzy" links and emails (example.com, foo@bar.com).
	 *
	 * `schemas` is an object, where each key/value describes protocol/rule:
	 *
	 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
	 *   for example). `linkify-it` makes shure that prefix is not preceeded with
	 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
	 * - __value__ - rule to check tail after link prefix
	 *   - _String_ - just alias to existing rule
	 *   - _Object_
	 *     - _validate_ - validator function (should return matched length on success),
	 *       or `RegExp`.
	 *     - _normalize_ - optional function to normalize text & url of matched result
	 *       (for example, for @twitter mentions).
	 *
	 * `options`:
	 *
	 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
	 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
	 *   like version numbers. Default `false`.
	 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
	 *
	 **/
	function LinkifyIt(schemas, options) {
	  if (!(this instanceof LinkifyIt)) {
	    return new LinkifyIt(schemas, options);
	  }
	
	  if (!options) {
	    if (isOptionsObj(schemas)) {
	      options = schemas;
	      schemas = {};
	    }
	  }
	
	  this.__opts__           = assign({}, defaultOptions, options);
	
	  // Cache last tested result. Used to skip repeating steps on next `match` call.
	  this.__index__          = -1;
	  this.__last_index__     = -1; // Next scan position
	  this.__schema__         = '';
	  this.__text_cache__     = '';
	
	  this.__schemas__        = assign({}, defaultSchemas, schemas);
	  this.__compiled__       = {};
	
	  this.__tlds__           = tlds_default;
	  this.__tlds_replaced__  = false;
	
	  this.re = {};
	
	  compile(this);
	}
	
	
	/** chainable
	 * LinkifyIt#add(schema, definition)
	 * - schema (String): rule name (fixed pattern prefix)
	 * - definition (String|RegExp|Object): schema definition
	 *
	 * Add new rule definition. See constructor description for details.
	 **/
	LinkifyIt.prototype.add = function add(schema, definition) {
	  this.__schemas__[schema] = definition;
	  compile(this);
	  return this;
	};
	
	
	/** chainable
	 * LinkifyIt#set(options)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Set recognition options for links without schema.
	 **/
	LinkifyIt.prototype.set = function set(options) {
	  this.__opts__ = assign(this.__opts__, options);
	  return this;
	};
	
	
	/**
	 * LinkifyIt#test(text) -> Boolean
	 *
	 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
	 **/
	LinkifyIt.prototype.test = function test(text) {
	  // Reset scan cache
	  this.__text_cache__ = text;
	  this.__index__      = -1;
	
	  if (!text.length) { return false; }
	
	  var m, ml, me, len, shift, next, re, tld_pos, at_pos;
	
	  // try to scan for link with schema - that's the most simple rule
	  if (this.re.schema_test.test(text)) {
	    re = this.re.schema_search;
	    re.lastIndex = 0;
	    while ((m = re.exec(text)) !== null) {
	      len = this.testSchemaAt(text, m[2], re.lastIndex);
	      if (len) {
	        this.__schema__     = m[2];
	        this.__index__      = m.index + m[1].length;
	        this.__last_index__ = m.index + m[0].length + len;
	        break;
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
	    // guess schemaless links
	    tld_pos = text.search(this.re.host_fuzzy_test);
	    if (tld_pos >= 0) {
	      // if tld is located after found link - no need to check fuzzy pattern
	      if (this.__index__ < 0 || tld_pos < this.__index__) {
	        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
	
	          shift = ml.index + ml[1].length;
	
	          if (this.__index__ < 0 || shift < this.__index__) {
	            this.__schema__     = '';
	            this.__index__      = shift;
	            this.__last_index__ = ml.index + ml[0].length;
	          }
	        }
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
	    // guess schemaless emails
	    at_pos = text.indexOf('@');
	    if (at_pos >= 0) {
	      // We can't skip this check, because this cases are possible:
	      // 192.168.1.1@gmail.com, my.in@example.com
	      if ((me = text.match(this.re.email_fuzzy)) !== null) {
	
	        shift = me.index + me[1].length;
	        next  = me.index + me[0].length;
	
	        if (this.__index__ < 0 || shift < this.__index__ ||
	            (shift === this.__index__ && next > this.__last_index__)) {
	          this.__schema__     = 'mailto:';
	          this.__index__      = shift;
	          this.__last_index__ = next;
	        }
	      }
	    }
	  }
	
	  return this.__index__ >= 0;
	};
	
	
	/**
	 * LinkifyIt#pretest(text) -> Boolean
	 *
	 * Very quick check, that can give false positives. Returns true if link MAY BE
	 * can exists. Can be used for speed optimization, when you need to check that
	 * link NOT exists.
	 **/
	LinkifyIt.prototype.pretest = function pretest(text) {
	  return this.re.pretest.test(text);
	};
	
	
	/**
	 * LinkifyIt#testSchemaAt(text, name, position) -> Number
	 * - text (String): text to scan
	 * - name (String): rule (schema) name
	 * - position (Number): text offset to check from
	 *
	 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
	 * at given position. Returns length of found pattern (0 on fail).
	 **/
	LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
	  // If not supported schema check requested - terminate
	  if (!this.__compiled__[schema.toLowerCase()]) {
	    return 0;
	  }
	  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
	};
	
	
	/**
	 * LinkifyIt#match(text) -> Array|null
	 *
	 * Returns array of found link descriptions or `null` on fail. We strongly
	 * recommend to use [[LinkifyIt#test]] first, for best speed.
	 *
	 * ##### Result match description
	 *
	 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
	 *   protocol-neutral  links.
	 * - __index__ - offset of matched text
	 * - __lastIndex__ - index of next char after mathch end
	 * - __raw__ - matched text
	 * - __text__ - normalized text
	 * - __url__ - link, generated from matched text
	 **/
	LinkifyIt.prototype.match = function match(text) {
	  var shift = 0, result = [];
	
	  // Try to take previous element from cache, if .test() called before
	  if (this.__index__ >= 0 && this.__text_cache__ === text) {
	    result.push(createMatch(this, shift));
	    shift = this.__last_index__;
	  }
	
	  // Cut head if cache was used
	  var tail = shift ? text.slice(shift) : text;
	
	  // Scan string until end reached
	  while (this.test(tail)) {
	    result.push(createMatch(this, shift));
	
	    tail = tail.slice(this.__last_index__);
	    shift += this.__last_index__;
	  }
	
	  if (result.length) {
	    return result;
	  }
	
	  return null;
	};
	
	
	/** chainable
	 * LinkifyIt#tlds(list [, keepOld]) -> this
	 * - list (Array): list of tlds
	 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
	 *
	 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
	 * to avoid false positives. By default this algorythm used:
	 *
	 * - hostname with any 2-letter root zones are ok.
	 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
	 *   are ok.
	 * - encoded (`xn--...`) root zones are ok.
	 *
	 * If list is replaced, then exact match for 2-chars root zones will be checked.
	 **/
	LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
	  list = Array.isArray(list) ? list : [ list ];
	
	  if (!keepOld) {
	    this.__tlds__ = list.slice();
	    this.__tlds_replaced__ = true;
	    compile(this);
	    return this;
	  }
	
	  this.__tlds__ = this.__tlds__.concat(list)
	                                  .sort()
	                                  .filter(function (el, idx, arr) {
	                                    return el !== arr[idx - 1];
	                                  })
	                                  .reverse();
	
	  compile(this);
	  return this;
	};
	
	/**
	 * LinkifyIt#normalize(match)
	 *
	 * Default normalizer (if schema does not define it's own).
	 **/
	LinkifyIt.prototype.normalize = function normalize(match) {
	
	  // Do minimal possible changes by default. Need to collect feedback prior
	  // to move forward https://github.com/markdown-it/linkify-it/issues/1
	
	  if (!match.schema) { match.url = 'http://' + match.url; }
	
	  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
	    match.url = 'mailto:' + match.url;
	  }
	};
	
	
	/**
	 * LinkifyIt#onCompile()
	 *
	 * Override to modify basic RegExp-s.
	 **/
	LinkifyIt.prototype.onCompile = function onCompile() {
	};
	
	
	module.exports = LinkifyIt;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	module.exports = function (opts) {
	  var re = {};
	
	  // Use direct extract instead of `regenerate` to reduse browserified size
	  re.src_Any = __webpack_require__(1246).source;
	  re.src_Cc  = __webpack_require__(1243).source;
	  re.src_Z   = __webpack_require__(1245).source;
	  re.src_P   = __webpack_require__(1244).source;
	
	  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
	  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');
	
	  // \p{\Z\Cc} (white spaces + control)
	  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');
	
	  // Experimental. List of chars, completely prohibited in links
	  // because can separate it from other part of text
	  var text_separators = '[><\uff5c]';
	
	  // All possible word characters (everything without punctuation, spaces & controls)
	  // Defined via punctuation & spaces to save space
	  // Should be something like \p{\L\N\S\M} (\w but without `_`)
	  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
	  // The same as abothe but without [0-9]
	  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
	
	  ////////////////////////////////////////////////////////////////////////////////
	
	  re.src_ip4 =
	
	    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
	
	  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
	  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
	
	  re.src_port =
	
	    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
	
	  re.src_host_terminator =
	
	    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
	
	  re.src_path =
	
	    '(?:' +
	      '[/?#]' +
	        '(?:' +
	          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
	          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
	          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
	          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
	          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
	          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
	          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
	          '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
	                                     // google has .... in links (issue #66)
	                                     // Restrict to
	                                     // - english
	                                     // - percent-encoded
	                                     // - parts of file path
	                                     // until more examples found.
	          '\\.(?!' + re.src_ZCc + '|[.]).|' +
	          (opts && opts['---'] ?
	            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
	            :
	            '\\-+|'
	          ) +
	          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
	          '\\!(?!' + re.src_ZCc + '|[!]).|' +
	          '\\?(?!' + re.src_ZCc + '|[?]).' +
	        ')+' +
	      '|\\/' +
	    ')?';
	
	  // Allow anything in markdown spec, forbid quote (") at the first position
	  // because emails enclosed in quotes are far more common
	  re.src_email_name =
	
	    '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
	
	  re.src_xn =
	
	    'xn--[a-z0-9\\-]{1,59}';
	
	  // More to read about domain names
	  // http://serverfault.com/questions/638260/
	
	  re.src_domain_root =
	
	    // Allow letters & digits (http://test1)
	    '(?:' +
	      re.src_xn +
	      '|' +
	      re.src_pseudo_letter + '{1,63}' +
	    ')';
	
	  re.src_domain =
	
	    '(?:' +
	      re.src_xn +
	      '|' +
	      '(?:' + re.src_pseudo_letter + ')' +
	      '|' +
	      '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
	    ')';
	
	  re.src_host =
	
	    '(?:' +
	    // Don't need IP check, because digits are already allowed in normal domain names
	    //   src_ip4 +
	    // '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
	    ')';
	
	  re.tpl_host_fuzzy =
	
	    '(?:' +
	      re.src_ip4 +
	    '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
	    ')';
	
	  re.tpl_host_no_ip_fuzzy =
	
	    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
	
	  re.src_host_strict =
	
	    re.src_host + re.src_host_terminator;
	
	  re.tpl_host_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_host_terminator;
	
	  re.src_host_port_strict =
	
	    re.src_host + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_no_ip_fuzzy_strict =
	
	    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
	
	
	  ////////////////////////////////////////////////////////////////////////////////
	  // Main rules
	
	  // Rude test fuzzy links by host, for quick deny
	  re.tpl_host_fuzzy_test =
	
	    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
	
	  re.tpl_email_fuzzy =
	
	      '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' +
	      '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
	
	  re.tpl_link_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
	
	  re.tpl_link_no_ip_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
	
	  return re;
	};


/***/ }),
/* 919 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = difference;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (nonEnumShadows || isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEmpty;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(975),
	    hashDelete = __webpack_require__(976),
	    hashGet = __webpack_require__(977),
	    hashHas = __webpack_require__(978),
	    hashSet = __webpack_require__(979);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(256),
	    setCacheAdd = __webpack_require__(1005),
	    setCacheHas = __webpack_require__(1006);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(39);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(938);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(953),
	    isArguments = __webpack_require__(263),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(417),
	    isIndex = __webpack_require__(183),
	    isTypedArray = __webpack_require__(420);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(402);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(390),
	    createBaseEach = __webpack_require__(958);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(388),
	    isFlattenable = __webpack_require__(981);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(959);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(388),
	    isArray = __webpack_require__(40);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 937 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(933),
	    baseIsNaN = __webpack_require__(942),
	    strictIndexOf = __webpack_require__(1013);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(385),
	    equalArrays = __webpack_require__(403),
	    equalByTag = __webpack_require__(963),
	    equalObjects = __webpack_require__(964),
	    getTag = __webpack_require__(971),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(417),
	    isTypedArray = __webpack_require__(420);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(385),
	    baseIsEqual = __webpack_require__(179);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(418),
	    isMasked = __webpack_require__(985),
	    isObject = __webpack_require__(64),
	    toSource = __webpack_require__(416);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isLength = __webpack_require__(265),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(986),
	    nativeKeys = __webpack_require__(1000);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(941),
	    getMatchData = __webpack_require__(967),
	    matchesStrictComparable = __webpack_require__(407);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(179),
	    get = __webpack_require__(1019),
	    hasIn = __webpack_require__(1020),
	    isKey = __webpack_require__(261),
	    isStrictComparable = __webpack_require__(406),
	    matchesStrictComparable = __webpack_require__(407),
	    toKey = __webpack_require__(139);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(391);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1016),
	    defineProperty = __webpack_require__(402),
	    identity = __webpack_require__(185);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(932);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(137),
	    arrayMap = __webpack_require__(387),
	    isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(140);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 955 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(39);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(264);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 959 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(180),
	    root = __webpack_require__(39);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(257),
	    createCtor = __webpack_require__(180),
	    createHybrid = __webpack_require__(399),
	    createRecurry = __webpack_require__(400),
	    getHolder = __webpack_require__(181),
	    replaceHolders = __webpack_require__(138),
	    root = __webpack_require__(39);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(257),
	    createCtor = __webpack_require__(180),
	    root = __webpack_require__(39);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(137),
	    Uint8Array = __webpack_require__(926),
	    eq = __webpack_require__(262),
	    equalArrays = __webpack_require__(403),
	    mapToArray = __webpack_require__(997),
	    setToArray = __webpack_require__(1007);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(965);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(936),
	    getSymbols = __webpack_require__(970),
	    keys = __webpack_require__(266);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1003);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(406),
	    keys = __webpack_require__(266);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(410);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(137);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(928),
	    stubArray = __webpack_require__(1029);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(921),
	    Map = __webpack_require__(255),
	    Promise = __webpack_require__(923),
	    Set = __webpack_require__(924),
	    WeakMap = __webpack_require__(386),
	    baseGetTag = __webpack_require__(84),
	    toSource = __webpack_require__(416);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(396),
	    isArguments = __webpack_require__(263),
	    isArray = __webpack_require__(40),
	    isIndex = __webpack_require__(183),
	    isLength = __webpack_require__(265),
	    toKey = __webpack_require__(139);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(184);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(184);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(184);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(184);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(137),
	    isArguments = __webpack_require__(263),
	    isArray = __webpack_require__(40);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(262),
	    isArrayLike = __webpack_require__(264),
	    isIndex = __webpack_require__(183),
	    isObject = __webpack_require__(64);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 983 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    getData = __webpack_require__(405),
	    getFuncName = __webpack_require__(966),
	    lodash = __webpack_require__(1034);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(956);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 986 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 987 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(178);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(922),
	    ListCache = __webpack_require__(177),
	    Map = __webpack_require__(255);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(182);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(182);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(182);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(182);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1025);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(397),
	    composeArgsRight = __webpack_require__(398),
	    replaceHolders = __webpack_require__(138);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(410);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(257);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(260),
	    isIndex = __webpack_require__(183);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(177),
	    Map = __webpack_require__(255),
	    MapCache = __webpack_require__(256);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(927),
	    arrayIncludes = __webpack_require__(929);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    LodashWrapper = __webpack_require__(384),
	    copyArray = __webpack_require__(260);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(268);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(934);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(391);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(937),
	    hasPath = __webpack_require__(974);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(179);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(179);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(944),
	    baseUnary = __webpack_require__(395),
	    nodeUtil = __webpack_require__(409);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(84),
	    isArray = __webpack_require__(40),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(256);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(393),
	    createWrap = __webpack_require__(401),
	    getHolder = __webpack_require__(181),
	    replaceHolders = __webpack_require__(138);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(949),
	    basePropertyDeep = __webpack_require__(950),
	    isKey = __webpack_require__(261),
	    toKey = __webpack_require__(139);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(389),
	    baseIteratee = __webpack_require__(392),
	    baseSome = __webpack_require__(952),
	    isArray = __webpack_require__(40),
	    isIterateeCall = __webpack_require__(982);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1033);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1031);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(64),
	    isSymbol = __webpack_require__(140);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(254),
	    LodashWrapper = __webpack_require__(384),
	    baseLodash = __webpack_require__(259),
	    isArray = __webpack_require__(40),
	    isObjectLike = __webpack_require__(72),
	    wrapperClone = __webpack_require__(1015);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(783),
	      utf8 = __webpack_require__(314).utf8,
	      isBuffer = __webpack_require__(898),
	      bin = __webpack_require__(314).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EntitySchema = function () {
	  function EntitySchema(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('A string non-empty key is required');
	    }
	
	    this._key = key;
	    this._assignEntity = options.assignEntity;
	
	    var idAttribute = options.idAttribute || 'id';
	    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
	      return x[idAttribute];
	    };
	    this._idAttribute = idAttribute;
	    this._meta = options.meta;
	    this._defaults = options.defaults;
	  }
	
	  _createClass(EntitySchema, [{
	    key: 'getAssignEntity',
	    value: function getAssignEntity() {
	      return this._assignEntity;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return this._key;
	    }
	  }, {
	    key: 'getId',
	    value: function getId(entity, key) {
	      return this._getId(entity, key);
	    }
	  }, {
	    key: 'getIdAttribute',
	    value: function getIdAttribute() {
	      return this._idAttribute;
	    }
	  }, {
	    key: 'getMeta',
	    value: function getMeta(prop) {
	      if (!prop || typeof prop !== 'string') {
	        throw new Error('A string non-empty property name is required');
	      }
	      return this._meta && this._meta[prop];
	    }
	  }, {
	    key: 'getDefaults',
	    value: function getDefaults() {
	      return this._defaults;
	    }
	  }, {
	    key: 'define',
	    value: function define(nestedSchema) {
	      for (var key in nestedSchema) {
	        if (nestedSchema.hasOwnProperty(key)) {
	          this[key] = nestedSchema[key];
	        }
	      }
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	exports.default = EntitySchema;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(64);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _UnionSchema = __webpack_require__(422);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArraySchema = function () {
	  function ArraySchema(itemSchema) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, ArraySchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('ArraySchema requires item schema to be an object.');
	    }
	
	    if (options.schemaAttribute) {
	      var schemaAttribute = options.schemaAttribute;
	      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
	    } else {
	      this._itemSchema = itemSchema;
	    }
	  }
	
	  _createClass(ArraySchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }]);
	
	  return ArraySchema;
	}();
	
	exports.default = ArraySchema;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(85).assign;
	
	var deflate   = __webpack_require__(1039);
	var inflate   = __webpack_require__(1040);
	var constants = __webpack_require__(425);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(1041);
	var utils        = __webpack_require__(85);
	var strings      = __webpack_require__(423);
	var msg          = __webpack_require__(269);
	var ZStream      = __webpack_require__(427);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(1044);
	var utils        = __webpack_require__(85);
	var strings      = __webpack_require__(423);
	var c            = __webpack_require__(425);
	var msg          = __webpack_require__(269);
	var ZStream      = __webpack_require__(427);
	var GZheader     = __webpack_require__(1042);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(85);
	var trees   = __webpack_require__(1046);
	var adler32 = __webpack_require__(424);
	var crc32   = __webpack_require__(426);
	var msg     = __webpack_require__(269);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(85);
	var adler32       = __webpack_require__(424);
	var crc32         = __webpack_require__(426);
	var inflate_fast  = __webpack_require__(1043);
	var inflate_table = __webpack_require__(1045);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(85);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = __webpack_require__(85);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
	* http://photoswipe.com
	* Copyright (c) 2019 Dmitry Semenov; */
	/**
	*
	* UI on top of main sliding area (caption, arrows, close button, etc.).
	* Built just using public methods/properties of PhotoSwipe.
	* 
	*/
	(function (root, factory) { 
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipeUI_Default = factory();
		}
	})(this, function () {
	
		'use strict';
	
	
	
	var PhotoSwipeUI_Default =
	 function(pswp, framework) {
	
		var ui = this;
		var _overlayUIUpdated = false,
			_controlsVisible = true,
			_fullscrenAPI,
			_controls,
			_captionContainer,
			_fakeCaptionContainer,
			_indexIndicator,
			_shareButton,
			_shareModal,
			_shareModalHidden = true,
			_initalCloseOnScrollValue,
			_isIdle,
			_listen,
	
			_loadingIndicator,
			_loadingIndicatorHidden,
			_loadingIndicatorTimeout,
	
			_galleryHasOneSlide,
	
			_options,
			_defaultUIOptions = {
				barsSize: {top:44, bottom:'auto'},
				closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'], 
				timeToIdle: 4000, 
				timeToIdleOutside: 1000,
				loadingIndicatorDelay: 1000, // 2s
				
				addCaptionHTMLFn: function(item, captionEl /*, isFake */) {
					if(!item.title) {
						captionEl.children[0].innerHTML = '';
						return false;
					}
					captionEl.children[0].innerHTML = item.title;
					return true;
				},
	
				closeEl:true,
				captionEl: true,
				fullscreenEl: true,
				zoomEl: true,
				shareEl: true,
				counterEl: true,
				arrowEl: true,
				preloaderEl: true,
	
				tapToClose: false,
				tapToToggleControls: true,
	
				clickToCloseNonZoomable: true,
	
				shareButtons: [
					{id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
					{id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
					{id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/'+
														'?url={{url}}&media={{image_url}}&description={{text}}'},
					{id:'download', label:'Download image', url:'{{raw_image_url}}', download:true}
				],
				getImageURLForShare: function( /* shareButtonData */ ) {
					return pswp.currItem.src || '';
				},
				getPageURLForShare: function( /* shareButtonData */ ) {
					return window.location.href;
				},
				getTextForShare: function( /* shareButtonData */ ) {
					return pswp.currItem.title || '';
				},
					
				indexIndicatorSep: ' / ',
				fitControlsWidth: 1200
	
			},
			_blockControlsTap,
			_blockControlsTapTimeout;
	
	
	
		var _onControlsTap = function(e) {
				if(_blockControlsTap) {
					return true;
				}
	
	
				e = e || window.event;
	
				if(_options.timeToIdle && _options.mouseUsed && !_isIdle) {
					// reset idle timer
					_onIdleMouseMove();
				}
	
	
				var target = e.target || e.srcElement,
					uiElement,
					clickedClass = target.getAttribute('class') || '',
					found;
	
				for(var i = 0; i < _uiElements.length; i++) {
					uiElement = _uiElements[i];
					if(uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name ) > -1 ) {
						uiElement.onTap();
						found = true;
	
					}
				}
	
				if(found) {
					if(e.stopPropagation) {
						e.stopPropagation();
					}
					_blockControlsTap = true;
	
					// Some versions of Android don't prevent ghost click event 
					// when preventDefault() was called on touchstart and/or touchend.
					// 
					// This happens on v4.3, 4.2, 4.1, 
					// older versions strangely work correctly, 
					// but just in case we add delay on all of them)	
					var tapDelay = framework.features.isOldAndroid ? 600 : 30;
					_blockControlsTapTimeout = setTimeout(function() {
						_blockControlsTap = false;
					}, tapDelay);
				}
	
			},
			_fitControlsInViewport = function() {
				return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
			},
			_togglePswpClass = function(el, cName, add) {
				framework[ (add ? 'add' : 'remove') + 'Class' ](el, 'pswp__' + cName);
			},
	
			// add class when there is just one item in the gallery
			// (by default it hides left/right arrows and 1ofX counter)
			_countNumItems = function() {
				var hasOneSlide = (_options.getNumItemsFn() === 1);
	
				if(hasOneSlide !== _galleryHasOneSlide) {
					_togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
					_galleryHasOneSlide = hasOneSlide;
				}
			},
			_toggleShareModalClass = function() {
				_togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
			},
			_toggleShareModal = function() {
	
				_shareModalHidden = !_shareModalHidden;
				
				
				if(!_shareModalHidden) {
					_toggleShareModalClass();
					setTimeout(function() {
						if(!_shareModalHidden) {
							framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
						}
					}, 30);
				} else {
					framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
					setTimeout(function() {
						if(_shareModalHidden) {
							_toggleShareModalClass();
						}
					}, 300);
				}
				
				if(!_shareModalHidden) {
					_updateShareURLs();
				}
				return false;
			},
	
			_openWindowPopup = function(e) {
				e = e || window.event;
				var target = e.target || e.srcElement;
	
				pswp.shout('shareLinkClick', e, target);
	
				if(!target.href) {
					return false;
				}
	
				if( target.hasAttribute('download') ) {
					return true;
				}
	
				window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,'+
											'location=yes,width=550,height=420,top=100,left=' + 
											(window.screen ? Math.round(screen.width / 2 - 275) : 100)  );
	
				if(!_shareModalHidden) {
					_toggleShareModal();
				}
				
				return false;
			},
			_updateShareURLs = function() {
				var shareButtonOut = '',
					shareButtonData,
					shareURL,
					image_url,
					page_url,
					share_text;
	
				for(var i = 0; i < _options.shareButtons.length; i++) {
					shareButtonData = _options.shareButtons[i];
	
					image_url = _options.getImageURLForShare(shareButtonData);
					page_url = _options.getPageURLForShare(shareButtonData);
					share_text = _options.getTextForShare(shareButtonData);
	
					shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url) )
										.replace('{{image_url}}', encodeURIComponent(image_url) )
										.replace('{{raw_image_url}}', image_url )
										.replace('{{text}}', encodeURIComponent(share_text) );
	
					shareButtonOut += '<a href="' + shareURL + '" target="_blank" '+
										'class="pswp__share--' + shareButtonData.id + '"' +
										(shareButtonData.download ? 'download' : '') + '>' + 
										shareButtonData.label + '</a>';
	
					if(_options.parseShareButtonOut) {
						shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
					}
				}
				_shareModal.children[0].innerHTML = shareButtonOut;
				_shareModal.children[0].onclick = _openWindowPopup;
	
			},
			_hasCloseClass = function(target) {
				for(var  i = 0; i < _options.closeElClasses.length; i++) {
					if( framework.hasClass(target, 'pswp__' + _options.closeElClasses[i]) ) {
						return true;
					}
				}
			},
			_idleInterval,
			_idleTimer,
			_idleIncrement = 0,
			_onIdleMouseMove = function() {
				clearTimeout(_idleTimer);
				_idleIncrement = 0;
				if(_isIdle) {
					ui.setIdle(false);
				}
			},
			_onMouseLeaveWindow = function(e) {
				e = e ? e : window.event;
				var from = e.relatedTarget || e.toElement;
				if (!from || from.nodeName === 'HTML') {
					clearTimeout(_idleTimer);
					_idleTimer = setTimeout(function() {
						ui.setIdle(true);
					}, _options.timeToIdleOutside);
				}
			},
			_setupFullscreenAPI = function() {
				if(_options.fullscreenEl && !framework.features.isOldAndroid) {
					if(!_fullscrenAPI) {
						_fullscrenAPI = ui.getFullscreenAPI();
					}
					if(_fullscrenAPI) {
						framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
						ui.updateFullscreen();
						framework.addClass(pswp.template, 'pswp--supports-fs');
					} else {
						framework.removeClass(pswp.template, 'pswp--supports-fs');
					}
				}
			},
			_setupLoadingIndicator = function() {
				// Setup loading indicator
				if(_options.preloaderEl) {
				
					_toggleLoadingIndicator(true);
	
					_listen('beforeChange', function() {
	
						clearTimeout(_loadingIndicatorTimeout);
	
						// display loading indicator with delay
						_loadingIndicatorTimeout = setTimeout(function() {
	
							if(pswp.currItem && pswp.currItem.loading) {
	
								if( !pswp.allowProgressiveImg() || (pswp.currItem.img && !pswp.currItem.img.naturalWidth)  ) {
									// show preloader if progressive loading is not enabled, 
									// or image width is not defined yet (because of slow connection)
									_toggleLoadingIndicator(false); 
									// items-controller.js function allowProgressiveImg
								}
								
							} else {
								_toggleLoadingIndicator(true); // hide preloader
							}
	
						}, _options.loadingIndicatorDelay);
						
					});
					_listen('imageLoadComplete', function(index, item) {
						if(pswp.currItem === item) {
							_toggleLoadingIndicator(true);
						}
					});
	
				}
			},
			_toggleLoadingIndicator = function(hide) {
				if( _loadingIndicatorHidden !== hide ) {
					_togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
					_loadingIndicatorHidden = hide;
				}
			},
			_applyNavBarGaps = function(item) {
				var gap = item.vGap;
	
				if( _fitControlsInViewport() ) {
					
					var bars = _options.barsSize; 
					if(_options.captionEl && bars.bottom === 'auto') {
						if(!_fakeCaptionContainer) {
							_fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
							_fakeCaptionContainer.appendChild( framework.createEl('pswp__caption__center') );
							_controls.insertBefore(_fakeCaptionContainer, _captionContainer);
							framework.addClass(_controls, 'pswp__ui--fit');
						}
						if( _options.addCaptionHTMLFn(item, _fakeCaptionContainer, true) ) {
	
							var captionSize = _fakeCaptionContainer.clientHeight;
							gap.bottom = parseInt(captionSize,10) || 44;
						} else {
							gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
						}
					} else {
						gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
					}
					
					// height of top bar is static, no need to calculate it
					gap.top = bars.top;
				} else {
					gap.top = gap.bottom = 0;
				}
			},
			_setupIdle = function() {
				// Hide controls when mouse is used
				if(_options.timeToIdle) {
					_listen('mouseUsed', function() {
						
						framework.bind(document, 'mousemove', _onIdleMouseMove);
						framework.bind(document, 'mouseout', _onMouseLeaveWindow);
	
						_idleInterval = setInterval(function() {
							_idleIncrement++;
							if(_idleIncrement === 2) {
								ui.setIdle(true);
							}
						}, _options.timeToIdle / 2);
					});
				}
			},
			_setupHidingControlsDuringGestures = function() {
	
				// Hide controls on vertical drag
				_listen('onVerticalDrag', function(now) {
					if(_controlsVisible && now < 0.95) {
						ui.hideControls();
					} else if(!_controlsVisible && now >= 0.95) {
						ui.showControls();
					}
				});
	
				// Hide controls when pinching to close
				var pinchControlsHidden;
				_listen('onPinchClose' , function(now) {
					if(_controlsVisible && now < 0.9) {
						ui.hideControls();
						pinchControlsHidden = true;
					} else if(pinchControlsHidden && !_controlsVisible && now > 0.9) {
						ui.showControls();
					}
				});
	
				_listen('zoomGestureEnded', function() {
					pinchControlsHidden = false;
					if(pinchControlsHidden && !_controlsVisible) {
						ui.showControls();
					}
				});
	
			};
	
	
	
		var _uiElements = [
			{ 
				name: 'caption', 
				option: 'captionEl',
				onInit: function(el) {  
					_captionContainer = el; 
				} 
			},
			{ 
				name: 'share-modal', 
				option: 'shareEl',
				onInit: function(el) {  
					_shareModal = el;
				},
				onTap: function() {
					_toggleShareModal();
				} 
			},
			{ 
				name: 'button--share', 
				option: 'shareEl',
				onInit: function(el) { 
					_shareButton = el;
				},
				onTap: function() {
					_toggleShareModal();
				} 
			},
			{ 
				name: 'button--zoom', 
				option: 'zoomEl',
				onTap: pswp.toggleDesktopZoom
			},
			{ 
				name: 'counter', 
				option: 'counterEl',
				onInit: function(el) {  
					_indexIndicator = el;
				} 
			},
			{ 
				name: 'button--close', 
				option: 'closeEl',
				onTap: pswp.close
			},
			{ 
				name: 'button--arrow--left', 
				option: 'arrowEl',
				onTap: pswp.prev
			},
			{ 
				name: 'button--arrow--right', 
				option: 'arrowEl',
				onTap: pswp.next
			},
			{ 
				name: 'button--fs', 
				option: 'fullscreenEl',
				onTap: function() {  
					if(_fullscrenAPI.isFullscreen()) {
						_fullscrenAPI.exit();
					} else {
						_fullscrenAPI.enter();
					}
				} 
			},
			{ 
				name: 'preloader', 
				option: 'preloaderEl',
				onInit: function(el) {  
					_loadingIndicator = el;
				} 
			}
	
		];
	
		var _setupUIElements = function() {
			var item,
				classAttr,
				uiElement;
	
			var loopThroughChildElements = function(sChildren) {
				if(!sChildren) {
					return;
				}
	
				var l = sChildren.length;
				for(var i = 0; i < l; i++) {
					item = sChildren[i];
					classAttr = item.className;
	
					for(var a = 0; a < _uiElements.length; a++) {
						uiElement = _uiElements[a];
	
						if(classAttr.indexOf('pswp__' + uiElement.name) > -1  ) {
	
							if( _options[uiElement.option] ) { // if element is not disabled from options
								
								framework.removeClass(item, 'pswp__element--disabled');
								if(uiElement.onInit) {
									uiElement.onInit(item);
								}
								
								//item.style.display = 'block';
							} else {
								framework.addClass(item, 'pswp__element--disabled');
								//item.style.display = 'none';
							}
						}
					}
				}
			};
			loopThroughChildElements(_controls.children);
	
			var topBar =  framework.getChildByClass(_controls, 'pswp__top-bar');
			if(topBar) {
				loopThroughChildElements( topBar.children );
			}
		};
	
	
		
	
		ui.init = function() {
	
			// extend options
			framework.extend(pswp.options, _defaultUIOptions, true);
	
			// create local link for fast access
			_options = pswp.options;
	
			// find pswp__ui element
			_controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');
	
			// create local link
			_listen = pswp.listen;
	
	
			_setupHidingControlsDuringGestures();
	
			// update controls when slides change
			_listen('beforeChange', ui.update);
	
			// toggle zoom on double-tap
			_listen('doubleTap', function(point) {
				var initialZoomLevel = pswp.currItem.initialZoomLevel;
				if(pswp.getZoomLevel() !== initialZoomLevel) {
					pswp.zoomTo(initialZoomLevel, point, 333);
				} else {
					pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
				}
			});
	
			// Allow text selection in caption
			_listen('preventDragEvent', function(e, isDown, preventObj) {
				var t = e.target || e.srcElement;
				if(
					t && 
					t.getAttribute('class') && e.type.indexOf('mouse') > -1 && 
					( t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName) ) 
				) {
					preventObj.prevent = false;
				}
			});
	
			// bind events for UI
			_listen('bindEvents', function() {
				framework.bind(_controls, 'pswpTap click', _onControlsTap);
				framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
	
				if(!pswp.likelyTouchDevice) {
					framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
				}
			});
	
			// unbind events for UI
			_listen('unbindEvents', function() {
				if(!_shareModalHidden) {
					_toggleShareModal();
				}
	
				if(_idleInterval) {
					clearInterval(_idleInterval);
				}
				framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
				framework.unbind(document, 'mousemove', _onIdleMouseMove);
				framework.unbind(_controls, 'pswpTap click', _onControlsTap);
				framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
				framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
	
				if(_fullscrenAPI) {
					framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
					if(_fullscrenAPI.isFullscreen()) {
						_options.hideAnimationDuration = 0;
						_fullscrenAPI.exit();
					}
					_fullscrenAPI = null;
				}
			});
	
	
			// clean up things when gallery is destroyed
			_listen('destroy', function() {
				if(_options.captionEl) {
					if(_fakeCaptionContainer) {
						_controls.removeChild(_fakeCaptionContainer);
					}
					framework.removeClass(_captionContainer, 'pswp__caption--empty');
				}
	
				if(_shareModal) {
					_shareModal.children[0].onclick = null;
				}
				framework.removeClass(_controls, 'pswp__ui--over-close');
				framework.addClass( _controls, 'pswp__ui--hidden');
				ui.setIdle(false);
			});
			
	
			if(!_options.showAnimationDuration) {
				framework.removeClass( _controls, 'pswp__ui--hidden');
			}
			_listen('initialZoomIn', function() {
				if(_options.showAnimationDuration) {
					framework.removeClass( _controls, 'pswp__ui--hidden');
				}
			});
			_listen('initialZoomOut', function() {
				framework.addClass( _controls, 'pswp__ui--hidden');
			});
	
			_listen('parseVerticalMargin', _applyNavBarGaps);
			
			_setupUIElements();
	
			if(_options.shareEl && _shareButton && _shareModal) {
				_shareModalHidden = true;
			}
	
			_countNumItems();
	
			_setupIdle();
	
			_setupFullscreenAPI();
	
			_setupLoadingIndicator();
		};
	
		ui.setIdle = function(isIdle) {
			_isIdle = isIdle;
			_togglePswpClass(_controls, 'ui--idle', isIdle);
		};
	
		ui.update = function() {
			// Don't update UI if it's hidden
			if(_controlsVisible && pswp.currItem) {
				
				ui.updateIndexIndicator();
	
				if(_options.captionEl) {
					_options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
	
					_togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
				}
	
				_overlayUIUpdated = true;
	
			} else {
				_overlayUIUpdated = false;
			}
	
			if(!_shareModalHidden) {
				_toggleShareModal();
			}
	
			_countNumItems();
		};
	
		ui.updateFullscreen = function(e) {
	
			if(e) {
				// some browsers change window scroll position during the fullscreen
				// so PhotoSwipe updates it just in case
				setTimeout(function() {
					pswp.setScrollOffset( 0, framework.getScrollY() );
				}, 50);
			}
			
			// toogle pswp--fs class on root element
			framework[ (_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class' ](pswp.template, 'pswp--fs');
		};
	
		ui.updateIndexIndicator = function() {
			if(_options.counterEl) {
				_indexIndicator.innerHTML = (pswp.getCurrentIndex()+1) + 
											_options.indexIndicatorSep + 
											_options.getNumItemsFn();
			}
		};
		
		ui.onGlobalTap = function(e) {
			e = e || window.event;
			var target = e.target || e.srcElement;
	
			if(_blockControlsTap) {
				return;
			}
	
			if(e.detail && e.detail.pointerType === 'mouse') {
	
				// close gallery if clicked outside of the image
				if(_hasCloseClass(target)) {
					pswp.close();
					return;
				}
	
				if(framework.hasClass(target, 'pswp__img')) {
					if(pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
						if(_options.clickToCloseNonZoomable) {
							pswp.close();
						}
					} else {
						pswp.toggleDesktopZoom(e.detail.releasePoint);
					}
				}
				
			} else {
	
				// tap anywhere (except buttons) to toggle visibility of controls
				if(_options.tapToToggleControls) {
					if(_controlsVisible) {
						ui.hideControls();
					} else {
						ui.showControls();
					}
				}
	
				// tap to close gallery
				if(_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target)) ) {
					pswp.close();
					return;
				}
				
			}
		};
		ui.onMouseOver = function(e) {
			e = e || window.event;
			var target = e.target || e.srcElement;
	
			// add class when mouse is over an element that should close the gallery
			_togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
		};
	
		ui.hideControls = function() {
			framework.addClass(_controls,'pswp__ui--hidden');
			_controlsVisible = false;
		};
	
		ui.showControls = function() {
			_controlsVisible = true;
			if(!_overlayUIUpdated) {
				ui.update();
			}
			framework.removeClass(_controls,'pswp__ui--hidden');
		};
	
		ui.supportsFullscreen = function() {
			var d = document;
			return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
		};
	
		ui.getFullscreenAPI = function() {
			var dE = document.documentElement,
				api,
				tF = 'fullscreenchange';
	
			if (dE.requestFullscreen) {
				api = {
					enterK: 'requestFullscreen',
					exitK: 'exitFullscreen',
					elementK: 'fullscreenElement',
					eventK: tF
				};
	
			} else if(dE.mozRequestFullScreen ) {
				api = {
					enterK: 'mozRequestFullScreen',
					exitK: 'mozCancelFullScreen',
					elementK: 'mozFullScreenElement',
					eventK: 'moz' + tF
				};
	
				
	
			} else if(dE.webkitRequestFullscreen) {
				api = {
					enterK: 'webkitRequestFullscreen',
					exitK: 'webkitExitFullscreen',
					elementK: 'webkitFullscreenElement',
					eventK: 'webkit' + tF
				};
	
			} else if(dE.msRequestFullscreen) {
				api = {
					enterK: 'msRequestFullscreen',
					exitK: 'msExitFullscreen',
					elementK: 'msFullscreenElement',
					eventK: 'MSFullscreenChange'
				};
			}
	
			if(api) {
				api.enter = function() { 
					// disable close-on-scroll in fullscreen
					_initalCloseOnScrollValue = _options.closeOnScroll; 
					_options.closeOnScroll = false; 
	
					if(this.enterK === 'webkitRequestFullscreen') {
						pswp.template[this.enterK]( Element.ALLOW_KEYBOARD_INPUT );
					} else {
						return pswp.template[this.enterK](); 
					}
				};
				api.exit = function() { 
					_options.closeOnScroll = _initalCloseOnScrollValue;
	
					return document[this.exitK](); 
	
				};
				api.isFullscreen = function() { return document[this.elementK]; };
			}
	
			return api;
		};
	
	
	
	};
	return PhotoSwipeUI_Default;
	
	
	});


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe - v4.1.3 - 2019-01-08
	* http://photoswipe.com
	* Copyright (c) 2019 Dmitry Semenov; */
	(function (root, factory) { 
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.PhotoSwipe = factory();
		}
	})(this, function () {
	
		'use strict';
		var PhotoSwipe = function(template, UiClass, items, options){
	
	/*>>framework-bridge*/
	/**
	 *
	 * Set of generic functions used by gallery.
	 * 
	 * You're free to modify anything here as long as functionality is kept.
	 * 
	 */
	var framework = {
		features: null,
		bind: function(target, type, listener, unbind) {
			var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
			type = type.split(' ');
			for(var i = 0; i < type.length; i++) {
				if(type[i]) {
					target[methodName]( type[i], listener, false);
				}
			}
		},
		isArray: function(obj) {
			return (obj instanceof Array);
		},
		createEl: function(classes, tag) {
			var el = document.createElement(tag || 'div');
			if(classes) {
				el.className = classes;
			}
			return el;
		},
		getScrollY: function() {
			var yOffset = window.pageYOffset;
			return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
		},
		unbind: function(target, type, listener) {
			framework.bind(target,type,listener,true);
		},
		removeClass: function(el, className) {
			var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
			el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, ''); 
		},
		addClass: function(el, className) {
			if( !framework.hasClass(el,className) ) {
				el.className += (el.className ? ' ' : '') + className;
			}
		},
		hasClass: function(el, className) {
			return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
		},
		getChildByClass: function(parentEl, childClassName) {
			var node = parentEl.firstChild;
			while(node) {
				if( framework.hasClass(node, childClassName) ) {
					return node;
				}
				node = node.nextSibling;
			}
		},
		arraySearch: function(array, value, key) {
			var i = array.length;
			while(i--) {
				if(array[i][key] === value) {
					return i;
				} 
			}
			return -1;
		},
		extend: function(o1, o2, preventOverwrite) {
			for (var prop in o2) {
				if (o2.hasOwnProperty(prop)) {
					if(preventOverwrite && o1.hasOwnProperty(prop)) {
						continue;
					}
					o1[prop] = o2[prop];
				}
			}
		},
		easing: {
			sine: {
				out: function(k) {
					return Math.sin(k * (Math.PI / 2));
				},
				inOut: function(k) {
					return - (Math.cos(Math.PI * k) - 1) / 2;
				}
			},
			cubic: {
				out: function(k) {
					return --k * k * k + 1;
				}
			}
			/*
				elastic: {
					out: function ( k ) {
	
						var s, a = 0.1, p = 0.4;
						if ( k === 0 ) return 0;
						if ( k === 1 ) return 1;
						if ( !a || a < 1 ) { a = 1; s = p / 4; }
						else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
						return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
	
					},
				},
				back: {
					out: function ( k ) {
						var s = 1.70158;
						return --k * k * ( ( s + 1 ) * k + s ) + 1;
					}
				}
			*/
		},
	
		/**
		 * 
		 * @return {object}
		 * 
		 * {
		 *  raf : request animation frame function
		 *  caf : cancel animation frame function
		 *  transfrom : transform property key (with vendor), or null if not supported
		 *  oldIE : IE8 or below
		 * }
		 * 
		 */
		detectFeatures: function() {
			if(framework.features) {
				return framework.features;
			}
			var helperEl = framework.createEl(),
				helperStyle = helperEl.style,
				vendor = '',
				features = {};
	
			// IE8 and below
			features.oldIE = document.all && !document.addEventListener;
	
			features.touch = 'ontouchstart' in window;
	
			if(window.requestAnimationFrame) {
				features.raf = window.requestAnimationFrame;
				features.caf = window.cancelAnimationFrame;
			}
	
			features.pointerEvent = !!(window.PointerEvent) || navigator.msPointerEnabled;
	
			// fix false-positive detection of old Android in new IE
			// (IE11 ua string contains "Android 4.0")
			
			if(!features.pointerEvent) { 
	
				var ua = navigator.userAgent;
	
				// Detect if device is iPhone or iPod and if it's older than iOS 8
				// http://stackoverflow.com/a/14223920
				// 
				// This detection is made because of buggy top/bottom toolbars
				// that don't trigger window.resize event.
				// For more info refer to _isFixedPosition variable in core.js
	
				if (/iP(hone|od)/.test(navigator.platform)) {
					var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
					if(v && v.length > 0) {
						v = parseInt(v[1], 10);
						if(v >= 1 && v < 8 ) {
							features.isOldIOSPhone = true;
						}
					}
				}
	
				// Detect old Android (before KitKat)
				// due to bugs related to position:fixed
				// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
				
				var match = ua.match(/Android\s([0-9\.]*)/);
				var androidversion =  match ? match[1] : 0;
				androidversion = parseFloat(androidversion);
				if(androidversion >= 1 ) {
					if(androidversion < 4.4) {
						features.isOldAndroid = true; // for fixed position bug & performance
					}
					features.androidVersion = androidversion; // for touchend bug
				}	
				features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
	
				// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
			}
			
			var styleChecks = ['transform', 'perspective', 'animationName'],
				vendors = ['', 'webkit','Moz','ms','O'],
				styleCheckItem,
				styleName;
	
			for(var i = 0; i < 4; i++) {
				vendor = vendors[i];
	
				for(var a = 0; a < 3; a++) {
					styleCheckItem = styleChecks[a];
	
					// uppercase first letter of property name, if vendor is present
					styleName = vendor + (vendor ? 
											styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : 
											styleCheckItem);
				
					if(!features[styleCheckItem] && styleName in helperStyle ) {
						features[styleCheckItem] = styleName;
					}
				}
	
				if(vendor && !features.raf) {
					vendor = vendor.toLowerCase();
					features.raf = window[vendor+'RequestAnimationFrame'];
					if(features.raf) {
						features.caf = window[vendor+'CancelAnimationFrame'] || 
										window[vendor+'CancelRequestAnimationFrame'];
					}
				}
			}
				
			if(!features.raf) {
				var lastTime = 0;
				features.raf = function(fn) {
					var currTime = new Date().getTime();
					var timeToCall = Math.max(0, 16 - (currTime - lastTime));
					var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
					lastTime = currTime + timeToCall;
					return id;
				};
				features.caf = function(id) { clearTimeout(id); };
			}
	
			// Detect SVG support
			features.svg = !!document.createElementNS && 
							!!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
	
			framework.features = features;
	
			return features;
		}
	};
	
	framework.detectFeatures();
	
	// Override addEventListener for old versions of IE
	if(framework.features.oldIE) {
	
		framework.bind = function(target, type, listener, unbind) {
			
			type = type.split(' ');
	
			var methodName = (unbind ? 'detach' : 'attach') + 'Event',
				evName,
				_handleEv = function() {
					listener.handleEvent.call(listener);
				};
	
			for(var i = 0; i < type.length; i++) {
				evName = type[i];
				if(evName) {
	
					if(typeof listener === 'object' && listener.handleEvent) {
						if(!unbind) {
							listener['oldIE' + evName] = _handleEv;
						} else {
							if(!listener['oldIE' + evName]) {
								return false;
							}
						}
	
						target[methodName]( 'on' + evName, listener['oldIE' + evName]);
					} else {
						target[methodName]( 'on' + evName, listener);
					}
	
				}
			}
		};
		
	}
	
	/*>>framework-bridge*/
	
	/*>>core*/
	//function(template, UiClass, items, options)
	
	var self = this;
	
	/**
	 * Static vars, don't change unless you know what you're doing.
	 */
	var DOUBLE_TAP_RADIUS = 25, 
		NUM_HOLDERS = 3;
	
	/**
	 * Options
	 */
	var _options = {
		allowPanToNext:true,
		spacing: 0.12,
		bgOpacity: 1,
		mouseUsed: false,
		loop: true,
		pinchToClose: true,
		closeOnScroll: true,
		closeOnVerticalDrag: true,
		verticalDragRange: 0.75,
		hideAnimationDuration: 333,
		showAnimationDuration: 333,
		showHideOpacity: false,
		focus: true,
		escKey: true,
		arrowKeys: true,
		mainScrollEndFriction: 0.35,
		panEndFriction: 0.35,
		isClickableElement: function(el) {
	        return el.tagName === 'A';
	    },
	    getDoubleTapZoom: function(isMouseClick, item) {
	    	if(isMouseClick) {
	    		return 1;
	    	} else {
	    		return item.initialZoomLevel < 0.7 ? 1 : 1.33;
	    	}
	    },
	    maxSpreadZoom: 1.33,
		modal: true,
	
		// not fully implemented yet
		scaleMode: 'fit' // TODO
	};
	framework.extend(_options, options);
	
	
	/**
	 * Private helper variables & functions
	 */
	
	var _getEmptyPoint = function() { 
			return {x:0,y:0}; 
		};
	
	var _isOpen,
		_isDestroying,
		_closedByScroll,
		_currentItemIndex,
		_containerStyle,
		_containerShiftIndex,
		_currPanDist = _getEmptyPoint(),
		_startPanOffset = _getEmptyPoint(),
		_panOffset = _getEmptyPoint(),
		_upMoveEvents, // drag move, drag end & drag cancel events array
		_downEvents, // drag start events array
		_globalEventHandlers,
		_viewportSize = {},
		_currZoomLevel,
		_startZoomLevel,
		_translatePrefix,
		_translateSufix,
		_updateSizeInterval,
		_itemsNeedUpdate,
		_currPositionIndex = 0,
		_offset = {},
		_slideSize = _getEmptyPoint(), // size of slide area, including spacing
		_itemHolders,
		_prevItemIndex,
		_indexDiff = 0, // difference of indexes since last content update
		_dragStartEvent,
		_dragMoveEvent,
		_dragEndEvent,
		_dragCancelEvent,
		_transformKey,
		_pointerEventEnabled,
		_isFixedPosition = true,
		_likelyTouchDevice,
		_modules = [],
		_requestAF,
		_cancelAF,
		_initalClassName,
		_initalWindowScrollY,
		_oldIE,
		_currentWindowScrollY,
		_features,
		_windowVisibleSize = {},
		_renderMaxResolution = false,
		_orientationChangeTimeout,
	
	
		// Registers PhotoSWipe module (History, Controller ...)
		_registerModule = function(name, module) {
			framework.extend(self, module.publicMethods);
			_modules.push(name);
		},
	
		_getLoopedId = function(index) {
			var numSlides = _getNumItems();
			if(index > numSlides - 1) {
				return index - numSlides;
			} else  if(index < 0) {
				return numSlides + index;
			}
			return index;
		},
		
		// Micro bind/trigger
		_listeners = {},
		_listen = function(name, fn) {
			if(!_listeners[name]) {
				_listeners[name] = [];
			}
			return _listeners[name].push(fn);
		},
		_shout = function(name) {
			var listeners = _listeners[name];
	
			if(listeners) {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
	
				for(var i = 0; i < listeners.length; i++) {
					listeners[i].apply(self, args);
				}
			}
		},
	
		_getCurrentTime = function() {
			return new Date().getTime();
		},
		_applyBgOpacity = function(opacity) {
			_bgOpacity = opacity;
			self.bg.style.opacity = opacity * _options.bgOpacity;
		},
	
		_applyZoomTransform = function(styleObj,x,y,zoom,item) {
			if(!_renderMaxResolution || (item && item !== self.currItem) ) {
				zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);	
			}
				
			styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
		},
		_applyCurrentZoomPan = function( allowRenderResolution ) {
			if(_currZoomElementStyle) {
	
				if(allowRenderResolution) {
					if(_currZoomLevel > self.currItem.fitRatio) {
						if(!_renderMaxResolution) {
							_setImageSize(self.currItem, false, true);
							_renderMaxResolution = true;
						}
					} else {
						if(_renderMaxResolution) {
							_setImageSize(self.currItem);
							_renderMaxResolution = false;
						}
					}
				}
				
	
				_applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
			}
		},
		_applyZoomPanToItem = function(item) {
			if(item.container) {
	
				_applyZoomTransform(item.container.style, 
									item.initialPosition.x, 
									item.initialPosition.y, 
									item.initialZoomLevel,
									item);
			}
		},
		_setTranslateX = function(x, elStyle) {
			elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
		},
		_moveMainScroll = function(x, dragging) {
	
			if(!_options.loop && dragging) {
				var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
					delta = Math.round(x - _mainScrollPos.x);
	
				if( (newSlideIndexOffset < 0 && delta > 0) || 
					(newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
					x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
				} 
			}
			
			_mainScrollPos.x = x;
			_setTranslateX(x, _containerStyle);
		},
		_calculatePanOffset = function(axis, zoomLevel) {
			var m = _midZoomPoint[axis] - _offset[axis];
			return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
		},
		
		_equalizePoints = function(p1, p2) {
			p1.x = p2.x;
			p1.y = p2.y;
			if(p2.id) {
				p1.id = p2.id;
			}
		},
		_roundPoint = function(p) {
			p.x = Math.round(p.x);
			p.y = Math.round(p.y);
		},
	
		_mouseMoveTimeout = null,
		_onFirstMouseMove = function() {
			// Wait until mouse move event is fired at least twice during 100ms
			// We do this, because some mobile browsers trigger it on touchstart
			if(_mouseMoveTimeout ) { 
				framework.unbind(document, 'mousemove', _onFirstMouseMove);
				framework.addClass(template, 'pswp--has_mouse');
				_options.mouseUsed = true;
				_shout('mouseUsed');
			}
			_mouseMoveTimeout = setTimeout(function() {
				_mouseMoveTimeout = null;
			}, 100);
		},
	
		_bindEvents = function() {
			framework.bind(document, 'keydown', self);
	
			if(_features.transform) {
				// don't bind click event in browsers that don't support transform (mostly IE8)
				framework.bind(self.scrollWrap, 'click', self);
			}
			
	
			if(!_options.mouseUsed) {
				framework.bind(document, 'mousemove', _onFirstMouseMove);
			}
	
			framework.bind(window, 'resize scroll orientationchange', self);
	
			_shout('bindEvents');
		},
	
		_unbindEvents = function() {
			framework.unbind(window, 'resize scroll orientationchange', self);
			framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
			framework.unbind(document, 'keydown', self);
			framework.unbind(document, 'mousemove', _onFirstMouseMove);
	
			if(_features.transform) {
				framework.unbind(self.scrollWrap, 'click', self);
			}
	
			if(_isDragging) {
				framework.unbind(window, _upMoveEvents, self);
			}
	
			clearTimeout(_orientationChangeTimeout);
	
			_shout('unbindEvents');
		},
		
		_calculatePanBounds = function(zoomLevel, update) {
			var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
			if(update) {
				_currPanBounds = bounds;
			}
			return bounds;
		},
		
		_getMinZoomLevel = function(item) {
			if(!item) {
				item = self.currItem;
			}
			return item.initialZoomLevel;
		},
		_getMaxZoomLevel = function(item) {
			if(!item) {
				item = self.currItem;
			}
			return item.w > 0 ? _options.maxSpreadZoom : 1;
		},
	
		// Return true if offset is out of the bounds
		_modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
			if(destZoomLevel === self.currItem.initialZoomLevel) {
				destPanOffset[axis] = self.currItem.initialPosition[axis];
				return true;
			} else {
				destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel); 
	
				if(destPanOffset[axis] > destPanBounds.min[axis]) {
					destPanOffset[axis] = destPanBounds.min[axis];
					return true;
				} else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
					destPanOffset[axis] = destPanBounds.max[axis];
					return true;
				}
			}
			return false;
		},
	
		_setupTransforms = function() {
	
			if(_transformKey) {
				// setup 3d transforms
				var allow3dTransform = _features.perspective && !_likelyTouchDevice;
				_translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
				_translateSufix = _features.perspective ? ', 0px)' : ')';	
				return;
			}
	
			// Override zoom/pan/move functions in case old browser is used (most likely IE)
			// (so they use left/top/width/height, instead of CSS transform)
		
			_transformKey = 'left';
			framework.addClass(template, 'pswp--ie');
	
			_setTranslateX = function(x, elStyle) {
				elStyle.left = x + 'px';
			};
			_applyZoomPanToItem = function(item) {
	
				var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					s = item.container.style,
					w = zoomRatio * item.w,
					h = zoomRatio * item.h;
	
				s.width = w + 'px';
				s.height = h + 'px';
				s.left = item.initialPosition.x + 'px';
				s.top = item.initialPosition.y + 'px';
	
			};
			_applyCurrentZoomPan = function() {
				if(_currZoomElementStyle) {
	
					var s = _currZoomElementStyle,
						item = self.currItem,
						zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
						w = zoomRatio * item.w,
						h = zoomRatio * item.h;
	
					s.width = w + 'px';
					s.height = h + 'px';
	
	
					s.left = _panOffset.x + 'px';
					s.top = _panOffset.y + 'px';
				}
				
			};
		},
	
		_onKeyDown = function(e) {
			var keydownAction = '';
			if(_options.escKey && e.keyCode === 27) { 
				keydownAction = 'close';
			} else if(_options.arrowKeys) {
				if(e.keyCode === 37) {
					keydownAction = 'prev';
				} else if(e.keyCode === 39) { 
					keydownAction = 'next';
				}
			}
	
			if(keydownAction) {
				// don't do anything if special key pressed to prevent from overriding default browser actions
				// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
				if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
					if(e.preventDefault) {
						e.preventDefault();
					} else {
						e.returnValue = false;
					} 
					self[keydownAction]();
				}
			}
		},
	
		_onGlobalClick = function(e) {
			if(!e) {
				return;
			}
	
			// don't allow click event to pass through when triggering after drag or some other gesture
			if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
	
		_updatePageScrollOffset = function() {
			self.setScrollOffset(0, framework.getScrollY());		
		};
		
	
	
		
	
	
	
	// Micro animation engine
	var _animations = {},
		_numAnimations = 0,
		_stopAnimation = function(name) {
			if(_animations[name]) {
				if(_animations[name].raf) {
					_cancelAF( _animations[name].raf );
				}
				_numAnimations--;
				delete _animations[name];
			}
		},
		_registerStartAnimation = function(name) {
			if(_animations[name]) {
				_stopAnimation(name);
			}
			if(!_animations[name]) {
				_numAnimations++;
				_animations[name] = {};
			}
		},
		_stopAllAnimations = function() {
			for (var prop in _animations) {
	
				if( _animations.hasOwnProperty( prop ) ) {
					_stopAnimation(prop);
				} 
				
			}
		},
		_animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
			var startAnimTime = _getCurrentTime(), t;
			_registerStartAnimation(name);
	
			var animloop = function(){
				if ( _animations[name] ) {
					
					t = _getCurrentTime() - startAnimTime; // time diff
					//b - beginning (start prop)
					//d - anim duration
	
					if ( t >= d ) {
						_stopAnimation(name);
						onUpdate(endProp);
						if(onComplete) {
							onComplete();
						}
						return;
					}
					onUpdate( (endProp - b) * easingFn(t/d) + b );
	
					_animations[name].raf = _requestAF(animloop);
				}
			};
			animloop();
		};
		
	
	
	var publicMethods = {
	
		// make a few local variables and functions public
		shout: _shout,
		listen: _listen,
		viewportSize: _viewportSize,
		options: _options,
	
		isMainScrollAnimating: function() {
			return _mainScrollAnimating;
		},
		getZoomLevel: function() {
			return _currZoomLevel;
		},
		getCurrentIndex: function() {
			return _currentItemIndex;
		},
		isDragging: function() {
			return _isDragging;
		},	
		isZooming: function() {
			return _isZooming;
		},
		setScrollOffset: function(x,y) {
			_offset.x = x;
			_currentWindowScrollY = _offset.y = y;
			_shout('updateScrollOffset', _offset);
		},
		applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {
			_panOffset.x = panX;
			_panOffset.y = panY;
			_currZoomLevel = zoomLevel;
			_applyCurrentZoomPan( allowRenderResolution );
		},
	
		init: function() {
	
			if(_isOpen || _isDestroying) {
				return;
			}
	
			var i;
	
			self.framework = framework; // basic functionality
			self.template = template; // root DOM element of PhotoSwipe
			self.bg = framework.getChildByClass(template, 'pswp__bg');
	
			_initalClassName = template.className;
			_isOpen = true;
					
			_features = framework.detectFeatures();
			_requestAF = _features.raf;
			_cancelAF = _features.caf;
			_transformKey = _features.transform;
			_oldIE = _features.oldIE;
			
			self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
			self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
	
			_containerStyle = self.container.style; // for fast access
	
			// Objects that hold slides (there are only 3 in DOM)
			self.itemHolders = _itemHolders = [
				{el:self.container.children[0] , wrap:0, index: -1},
				{el:self.container.children[1] , wrap:0, index: -1},
				{el:self.container.children[2] , wrap:0, index: -1}
			];
	
			// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
			_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
	
			_setupTransforms();
	
			// Setup global events
			_globalEventHandlers = {
				resize: self.updateSize,
	
				// Fixes: iOS 10.3 resize event
				// does not update scrollWrap.clientWidth instantly after resize
				// https://github.com/dimsemenov/PhotoSwipe/issues/1315
				orientationchange: function() {
					clearTimeout(_orientationChangeTimeout);
					_orientationChangeTimeout = setTimeout(function() {
						if(_viewportSize.x !== self.scrollWrap.clientWidth) {
							self.updateSize();
						}
					}, 500);
				},
				scroll: _updatePageScrollOffset,
				keydown: _onKeyDown,
				click: _onGlobalClick
			};
	
			// disable show/hide effects on old browsers that don't support CSS animations or transforms, 
			// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
			var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
			if(!_features.animationName || !_features.transform || oldPhone) {
				_options.showAnimationDuration = _options.hideAnimationDuration = 0;
			}
	
			// init modules
			for(i = 0; i < _modules.length; i++) {
				self['init' + _modules[i]]();
			}
			
			// init
			if(UiClass) {
				var ui = self.ui = new UiClass(self, framework);
				ui.init();
			}
	
			_shout('firstUpdate');
			_currentItemIndex = _currentItemIndex || _options.index || 0;
			// validate index
			if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
				_currentItemIndex = 0;
			}
			self.currItem = _getItemAt( _currentItemIndex );
	
			
			if(_features.isOldIOSPhone || _features.isOldAndroid) {
				_isFixedPosition = false;
			}
			
			template.setAttribute('aria-hidden', 'false');
			if(_options.modal) {
				if(!_isFixedPosition) {
					template.style.position = 'absolute';
					template.style.top = framework.getScrollY() + 'px';
				} else {
					template.style.position = 'fixed';
				}
			}
	
			if(_currentWindowScrollY === undefined) {
				_shout('initialLayout');
				_currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
			}
			
			// add classes to root element of PhotoSwipe
			var rootClasses = 'pswp--open ';
			if(_options.mainClass) {
				rootClasses += _options.mainClass + ' ';
			}
			if(_options.showHideOpacity) {
				rootClasses += 'pswp--animate_opacity ';
			}
			rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
			rootClasses += _features.animationName ? ' pswp--css_animation' : '';
			rootClasses += _features.svg ? ' pswp--svg' : '';
			framework.addClass(template, rootClasses);
	
			self.updateSize();
	
			// initial update
			_containerShiftIndex = -1;
			_indexDiff = null;
			for(i = 0; i < NUM_HOLDERS; i++) {
				_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
			}
	
			if(!_oldIE) {
				framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
			}	
	
			_listen('initialZoomInEnd', function() {
				self.setContent(_itemHolders[0], _currentItemIndex-1);
				self.setContent(_itemHolders[2], _currentItemIndex+1);
	
				_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
	
				if(_options.focus) {
					// focus causes layout, 
					// which causes lag during the animation, 
					// that's why we delay it untill the initial zoom transition ends
					template.focus();
				}
				 
	
				_bindEvents();
			});
	
			// set content for center slide (first time)
			self.setContent(_itemHolders[1], _currentItemIndex);
			
			self.updateCurrItem();
	
			_shout('afterInit');
	
			if(!_isFixedPosition) {
	
				// On all versions of iOS lower than 8.0, we check size of viewport every second.
				// 
				// This is done to detect when Safari top & bottom bars appear, 
				// as this action doesn't trigger any events (like resize). 
				// 
				// On iOS8 they fixed this.
				// 
				// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
				
				_updateSizeInterval = setInterval(function() {
					if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
						self.updateSize();
					}
				}, 1000);
			}
	
			framework.addClass(template, 'pswp--visible');
		},
	
		// Close the gallery, then destroy it
		close: function() {
			if(!_isOpen) {
				return;
			}
	
			_isOpen = false;
			_isDestroying = true;
			_shout('close');
			_unbindEvents();
	
			_showOrHide(self.currItem, null, true, self.destroy);
		},
	
		// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
		destroy: function() {
			_shout('destroy');
	
			if(_showOrHideTimeout) {
				clearTimeout(_showOrHideTimeout);
			}
			
			template.setAttribute('aria-hidden', 'true');
			template.className = _initalClassName;
	
			if(_updateSizeInterval) {
				clearInterval(_updateSizeInterval);
			}
	
			framework.unbind(self.scrollWrap, _downEvents, self);
	
			// we unbind scroll event at the end, as closing animation may depend on it
			framework.unbind(window, 'scroll', self);
	
			_stopDragUpdateLoop();
	
			_stopAllAnimations();
	
			_listeners = null;
		},
	
		/**
		 * Pan image to position
		 * @param {Number} x     
		 * @param {Number} y     
		 * @param {Boolean} force Will ignore bounds if set to true.
		 */
		panTo: function(x,y,force) {
			if(!force) {
				if(x > _currPanBounds.min.x) {
					x = _currPanBounds.min.x;
				} else if(x < _currPanBounds.max.x) {
					x = _currPanBounds.max.x;
				}
	
				if(y > _currPanBounds.min.y) {
					y = _currPanBounds.min.y;
				} else if(y < _currPanBounds.max.y) {
					y = _currPanBounds.max.y;
				}
			}
			
			_panOffset.x = x;
			_panOffset.y = y;
			_applyCurrentZoomPan();
		},
		
		handleEvent: function (e) {
			e = e || window.event;
			if(_globalEventHandlers[e.type]) {
				_globalEventHandlers[e.type](e);
			}
		},
	
	
		goTo: function(index) {
	
			index = _getLoopedId(index);
	
			var diff = index - _currentItemIndex;
			_indexDiff = diff;
	
			_currentItemIndex = index;
			self.currItem = _getItemAt( _currentItemIndex );
			_currPositionIndex -= diff;
			
			_moveMainScroll(_slideSize.x * _currPositionIndex);
			
	
			_stopAllAnimations();
			_mainScrollAnimating = false;
	
			self.updateCurrItem();
		},
		next: function() {
			self.goTo( _currentItemIndex + 1);
		},
		prev: function() {
			self.goTo( _currentItemIndex - 1);
		},
	
		// update current zoom/pan objects
		updateCurrZoomItem: function(emulateSetContent) {
			if(emulateSetContent) {
				_shout('beforeChange', 0);
			}
	
			// itemHolder[1] is middle (current) item
			if(_itemHolders[1].el.children.length) {
				var zoomElement = _itemHolders[1].el.children[0];
				if( framework.hasClass(zoomElement, 'pswp__zoom-wrap') ) {
					_currZoomElementStyle = zoomElement.style;
				} else {
					_currZoomElementStyle = null;
				}
			} else {
				_currZoomElementStyle = null;
			}
			
			_currPanBounds = self.currItem.bounds;	
			_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
	
			_panOffset.x = _currPanBounds.center.x;
			_panOffset.y = _currPanBounds.center.y;
	
			if(emulateSetContent) {
				_shout('afterChange');
			}
		},
	
	
		invalidateCurrItems: function() {
			_itemsNeedUpdate = true;
			for(var i = 0; i < NUM_HOLDERS; i++) {
				if( _itemHolders[i].item ) {
					_itemHolders[i].item.needsUpdate = true;
				}
			}
		},
	
		updateCurrItem: function(beforeAnimation) {
	
			if(_indexDiff === 0) {
				return;
			}
	
			var diffAbs = Math.abs(_indexDiff),
				tempHolder;
	
			if(beforeAnimation && diffAbs < 2) {
				return;
			}
	
	
			self.currItem = _getItemAt( _currentItemIndex );
			_renderMaxResolution = false;
			
			_shout('beforeChange', _indexDiff);
	
			if(diffAbs >= NUM_HOLDERS) {
				_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
				diffAbs = NUM_HOLDERS;
			}
			for(var i = 0; i < diffAbs; i++) {
				if(_indexDiff > 0) {
					tempHolder = _itemHolders.shift();
					_itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last
	
					_containerShiftIndex++;
					_setTranslateX( (_containerShiftIndex+2) * _slideSize.x, tempHolder.el.style);
					self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
				} else {
					tempHolder = _itemHolders.pop();
					_itemHolders.unshift( tempHolder ); // move last to first
	
					_containerShiftIndex--;
					_setTranslateX( _containerShiftIndex * _slideSize.x, tempHolder.el.style);
					self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
				}
				
			}
	
			// reset zoom/pan on previous item
			if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
	
				var prevItem = _getItemAt(_prevItemIndex);
				if(prevItem.initialZoomLevel !== _currZoomLevel) {
					_calculateItemSize(prevItem , _viewportSize );
					_setImageSize(prevItem);
					_applyZoomPanToItem( prevItem ); 				
				}
	
			}
	
			// reset diff after update
			_indexDiff = 0;
	
			self.updateCurrZoomItem();
	
			_prevItemIndex = _currentItemIndex;
	
			_shout('afterChange');
			
		},
	
	
	
		updateSize: function(force) {
			
			if(!_isFixedPosition && _options.modal) {
				var windowScrollY = framework.getScrollY();
				if(_currentWindowScrollY !== windowScrollY) {
					template.style.top = windowScrollY + 'px';
					_currentWindowScrollY = windowScrollY;
				}
				if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
					return;
				}
				_windowVisibleSize.x = window.innerWidth;
				_windowVisibleSize.y = window.innerHeight;
	
				//template.style.width = _windowVisibleSize.x + 'px';
				template.style.height = _windowVisibleSize.y + 'px';
			}
	
	
	
			_viewportSize.x = self.scrollWrap.clientWidth;
			_viewportSize.y = self.scrollWrap.clientHeight;
	
			_updatePageScrollOffset();
	
			_slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
			_slideSize.y = _viewportSize.y;
	
			_moveMainScroll(_slideSize.x * _currPositionIndex);
	
			_shout('beforeResize'); // even may be used for example to switch image sources
	
	
			// don't re-calculate size on inital size update
			if(_containerShiftIndex !== undefined) {
	
				var holder,
					item,
					hIndex;
	
				for(var i = 0; i < NUM_HOLDERS; i++) {
					holder = _itemHolders[i];
					_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, holder.el.style);
	
					hIndex = _currentItemIndex+i-1;
	
					if(_options.loop && _getNumItems() > 2) {
						hIndex = _getLoopedId(hIndex);
					}
	
					// update zoom level on items and refresh source (if needsUpdate)
					item = _getItemAt( hIndex );
	
					// re-render gallery item if `needsUpdate`,
					// or doesn't have `bounds` (entirely new slide object)
					if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {
	
						self.cleanSlide( item );
						
						self.setContent( holder, hIndex );
	
						// if "center" slide
						if(i === 1) {
							self.currItem = item;
							self.updateCurrZoomItem(true);
						}
	
						item.needsUpdate = false;
	
					} else if(holder.index === -1 && hIndex >= 0) {
						// add content first time
						self.setContent( holder, hIndex );
					}
					if(item && item.container) {
						_calculateItemSize(item, _viewportSize);
						_setImageSize(item);
						_applyZoomPanToItem( item );
					}
					
				}
				_itemsNeedUpdate = false;
			}	
	
			_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
			_currPanBounds = self.currItem.bounds;
	
			if(_currPanBounds) {
				_panOffset.x = _currPanBounds.center.x;
				_panOffset.y = _currPanBounds.center.y;
				_applyCurrentZoomPan( true );
			}
			
			_shout('resize');
		},
		
		// Zoom current item to
		zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
			/*
				if(destZoomLevel === 'fit') {
					destZoomLevel = self.currItem.fitRatio;
				} else if(destZoomLevel === 'fill') {
					destZoomLevel = self.currItem.fillRatio;
				}
			*/
	
			if(centerPoint) {
				_startZoomLevel = _currZoomLevel;
				_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
				_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
				_equalizePoints(_startPanOffset, _panOffset);
			}
	
			var destPanBounds = _calculatePanBounds(destZoomLevel, false),
				destPanOffset = {};
	
			_modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
			_modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
	
			var initialZoomLevel = _currZoomLevel;
			var initialPanOffset = {
				x: _panOffset.x,
				y: _panOffset.y
			};
	
			_roundPoint(destPanOffset);
	
			var onUpdate = function(now) {
				if(now === 1) {
					_currZoomLevel = destZoomLevel;
					_panOffset.x = destPanOffset.x;
					_panOffset.y = destPanOffset.y;
				} else {
					_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
					_panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
					_panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
				}
	
				if(updateFn) {
					updateFn(now);
				}
	
				_applyCurrentZoomPan( now === 1 );
			};
	
			if(speed) {
				_animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
			} else {
				onUpdate(1);
			}
		}
	
	
	};
	
	
	/*>>core*/
	
	/*>>gestures*/
	/**
	 * Mouse/touch/pointer event handlers.
	 * 
	 * separated from @core.js for readability
	 */
	
	var MIN_SWIPE_DISTANCE = 30,
		DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
	
	var _gestureStartTime,
		_gestureCheckSpeedTime,
	
		// pool of objects that are used during dragging of zooming
		p = {}, // first point
		p2 = {}, // second point (for zoom gesture)
		delta = {},
		_currPoint = {},
		_startPoint = {},
		_currPointers = [],
		_startMainScrollPos = {},
		_releaseAnimData,
		_posPoints = [], // array of points during dragging, used to determine type of gesture
		_tempPoint = {},
	
		_isZoomingIn,
		_verticalDragInitiated,
		_oldAndroidTouchEndTimeout,
		_currZoomedItemIndex = 0,
		_centerPoint = _getEmptyPoint(),
		_lastReleaseTime = 0,
		_isDragging, // at least one pointer is down
		_isMultitouch, // at least two _pointers are down
		_zoomStarted, // zoom level changed during zoom gesture
		_moved,
		_dragAnimFrame,
		_mainScrollShifted,
		_currentPoints, // array of current touch points
		_isZooming,
		_currPointsDistance,
		_startPointsDistance,
		_currPanBounds,
		_mainScrollPos = _getEmptyPoint(),
		_currZoomElementStyle,
		_mainScrollAnimating, // true, if animation after swipe gesture is running
		_midZoomPoint = _getEmptyPoint(),
		_currCenterPoint = _getEmptyPoint(),
		_direction,
		_isFirstMove,
		_opacityChanged,
		_bgOpacity,
		_wasOverInitialZoom,
	
		_isEqualPoints = function(p1, p2) {
			return p1.x === p2.x && p1.y === p2.y;
		},
		_isNearbyPoints = function(touch0, touch1) {
			return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
		},
		_calculatePointsDistance = function(p1, p2) {
			_tempPoint.x = Math.abs( p1.x - p2.x );
			_tempPoint.y = Math.abs( p1.y - p2.y );
			return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
		},
		_stopDragUpdateLoop = function() {
			if(_dragAnimFrame) {
				_cancelAF(_dragAnimFrame);
				_dragAnimFrame = null;
			}
		},
		_dragUpdateLoop = function() {
			if(_isDragging) {
				_dragAnimFrame = _requestAF(_dragUpdateLoop);
				_renderMovement();
			}
		},
		_canPan = function() {
			return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
		},
		
		// find the closest parent DOM element
		_closestElement = function(el, fn) {
		  	if(!el || el === document) {
		  		return false;
		  	}
	
		  	// don't search elements above pswp__scroll-wrap
		  	if(el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1 ) {
		  		return false;
		  	}
	
		  	if( fn(el) ) {
		  		return el;
		  	}
	
		  	return _closestElement(el.parentNode, fn);
		},
	
		_preventObj = {},
		_preventDefaultEventBehaviour = function(e, isDown) {
		    _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
	
			_shout('preventDragEvent', e, isDown, _preventObj);
			return _preventObj.prevent;
	
		},
		_convertTouchToPoint = function(touch, p) {
			p.x = touch.pageX;
			p.y = touch.pageY;
			p.id = touch.identifier;
			return p;
		},
		_findCenterOfPoints = function(p1, p2, pCenter) {
			pCenter.x = (p1.x + p2.x) * 0.5;
			pCenter.y = (p1.y + p2.y) * 0.5;
		},
		_pushPosPoint = function(time, x, y) {
			if(time - _gestureCheckSpeedTime > 50) {
				var o = _posPoints.length > 2 ? _posPoints.shift() : {};
				o.x = x;
				o.y = y; 
				_posPoints.push(o);
				_gestureCheckSpeedTime = time;
			}
		},
	
		_calculateVerticalDragOpacityRatio = function() {
			var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
			return 1 -  Math.abs( yOffset / (_viewportSize.y / 2)  );
		},
	
		
		// points pool, reused during touch events
		_ePoint1 = {},
		_ePoint2 = {},
		_tempPointsArr = [],
		_tempCounter,
		_getTouchPoints = function(e) {
			// clean up previous points, without recreating array
			while(_tempPointsArr.length > 0) {
				_tempPointsArr.pop();
			}
	
			if(!_pointerEventEnabled) {
				if(e.type.indexOf('touch') > -1) {
	
					if(e.touches && e.touches.length > 0) {
						_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
						if(e.touches.length > 1) {
							_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
						}
					}
					
				} else {
					_ePoint1.x = e.pageX;
					_ePoint1.y = e.pageY;
					_ePoint1.id = '';
					_tempPointsArr[0] = _ePoint1;//_ePoint1;
				}
			} else {
				_tempCounter = 0;
				// we can use forEach, as pointer events are supported only in modern browsers
				_currPointers.forEach(function(p) {
					if(_tempCounter === 0) {
						_tempPointsArr[0] = p;
					} else if(_tempCounter === 1) {
						_tempPointsArr[1] = p;
					}
					_tempCounter++;
	
				});
			}
			return _tempPointsArr;
		},
	
		_panOrMoveMainScroll = function(axis, delta) {
	
			var panFriction,
				overDiff = 0,
				newOffset = _panOffset[axis] + delta[axis],
				startOverDiff,
				dir = delta[axis] > 0,
				newMainScrollPosition = _mainScrollPos.x + delta.x,
				mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
				newPanPos,
				newMainScrollPos;
	
			// calculate fdistance over the bounds and friction
			if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
				panFriction = _options.panEndFriction;
				// Linear increasing of friction, so at 1/4 of viewport it's at max value. 
				// Looks not as nice as was expected. Left for history.
				// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
			} else {
				panFriction = 1;
			}
			
			newOffset = _panOffset[axis] + delta[axis] * panFriction;
	
			// move main scroll or start panning
			if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
	
	
				if(!_currZoomElementStyle) {
					
					newMainScrollPos = newMainScrollPosition;
	
				} else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {
					
					if(dir) {
						if(newOffset > _currPanBounds.min[axis]) {
							panFriction = _options.panEndFriction;
							overDiff = _currPanBounds.min[axis] - newOffset;
							startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
						}
						
						// drag right
						if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
							newMainScrollPos = newMainScrollPosition;
							if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
								newMainScrollPos = _startMainScrollPos.x;
							}
						} else {
							if(_currPanBounds.min.x !== _currPanBounds.max.x) {
								newPanPos = newOffset;
							}
							
						}
	
					} else {
	
						if(newOffset < _currPanBounds.max[axis] ) {
							panFriction =_options.panEndFriction;
							overDiff = newOffset - _currPanBounds.max[axis];
							startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
						}
	
						if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
							newMainScrollPos = newMainScrollPosition;
	
							if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
								newMainScrollPos = _startMainScrollPos.x;
							}
	
						} else {
							if(_currPanBounds.min.x !== _currPanBounds.max.x) {
								newPanPos = newOffset;
							}
						}
	
					}
	
	
					//
				}
	
				if(axis === 'x') {
	
					if(newMainScrollPos !== undefined) {
						_moveMainScroll(newMainScrollPos, true);
						if(newMainScrollPos === _startMainScrollPos.x) {
							_mainScrollShifted = false;
						} else {
							_mainScrollShifted = true;
						}
					}
	
					if(_currPanBounds.min.x !== _currPanBounds.max.x) {
						if(newPanPos !== undefined) {
							_panOffset.x = newPanPos;
						} else if(!_mainScrollShifted) {
							_panOffset.x += delta.x * panFriction;
						}
					}
	
					return newMainScrollPos !== undefined;
				}
	
			}
	
			if(!_mainScrollAnimating) {
				
				if(!_mainScrollShifted) {
					if(_currZoomLevel > self.currItem.fitRatio) {
						_panOffset[axis] += delta[axis] * panFriction;
					
					}
				}
	
				
			}
			
		},
	
		// Pointerdown/touchstart/mousedown handler
		_onDragStart = function(e) {
	
			// Allow dragging only via left mouse button.
			// As this handler is not added in IE8 - we ignore e.which
			// 
			// http://www.quirksmode.org/js/events_properties.html
			// https://developer.mozilla.org/en-US/docs/Web/API/event.button
			if(e.type === 'mousedown' && e.button > 0  ) {
				return;
			}
	
			if(_initialZoomRunning) {
				e.preventDefault();
				return;
			}
	
			if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
				return;
			}
	
			if(_preventDefaultEventBehaviour(e, true)) {
				e.preventDefault();
			}
	
	
	
			_shout('pointerDown');
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				if(pointerIndex < 0) {
					pointerIndex = _currPointers.length;
				}
				_currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, id: e.pointerId};
			}
			
	
	
			var startPointsList = _getTouchPoints(e),
				numPoints = startPointsList.length;
	
			_currentPoints = null;
	
			_stopAllAnimations();
	
			// init drag
			if(!_isDragging || numPoints === 1) {
	
				
	
				_isDragging = _isFirstMove = true;
				framework.bind(window, _upMoveEvents, self);
	
				_isZoomingIn = 
					_wasOverInitialZoom = 
					_opacityChanged = 
					_verticalDragInitiated = 
					_mainScrollShifted = 
					_moved = 
					_isMultitouch = 
					_zoomStarted = false;
	
				_direction = null;
	
				_shout('firstTouchStart', startPointsList);
	
				_equalizePoints(_startPanOffset, _panOffset);
	
				_currPanDist.x = _currPanDist.y = 0;
				_equalizePoints(_currPoint, startPointsList[0]);
				_equalizePoints(_startPoint, _currPoint);
	
				//_equalizePoints(_startMainScrollPos, _mainScrollPos);
				_startMainScrollPos.x = _slideSize.x * _currPositionIndex;
	
				_posPoints = [{
					x: _currPoint.x,
					y: _currPoint.y
				}];
	
				_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
	
				//_mainScrollAnimationEnd(true);
				_calculatePanBounds( _currZoomLevel, true );
				
				// Start rendering
				_stopDragUpdateLoop();
				_dragUpdateLoop();
				
			}
	
			// init zoom
			if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
				_startZoomLevel = _currZoomLevel;
				_zoomStarted = false; // true if zoom changed at least once
	
				_isZooming = _isMultitouch = true;
				_currPanDist.y = _currPanDist.x = 0;
	
				_equalizePoints(_startPanOffset, _panOffset);
	
				_equalizePoints(p, startPointsList[0]);
				_equalizePoints(p2, startPointsList[1]);
	
				_findCenterOfPoints(p, p2, _currCenterPoint);
	
				_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
				_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
				_currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
			}
	
	
		},
	
		// Pointermove/touchmove/mousemove handler
		_onDragMove = function(e) {
	
			e.preventDefault();
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				if(pointerIndex > -1) {
					var p = _currPointers[pointerIndex];
					p.x = e.pageX;
					p.y = e.pageY; 
				}
			}
	
			if(_isDragging) {
				var touchesList = _getTouchPoints(e);
				if(!_direction && !_moved && !_isZooming) {
	
					if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
						// if main scroll position is shifted – direction is always horizontal
						_direction = 'h';
					} else {
						var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
						// check the direction of movement
						if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
							_direction = diff > 0 ? 'h' : 'v';
							_currentPoints = touchesList;
						}
					}
					
				} else {
					_currentPoints = touchesList;
				}
			}	
		},
		// 
		_renderMovement =  function() {
	
			if(!_currentPoints) {
				return;
			}
	
			var numPoints = _currentPoints.length;
	
			if(numPoints === 0) {
				return;
			}
	
			_equalizePoints(p, _currentPoints[0]);
	
			delta.x = p.x - _currPoint.x;
			delta.y = p.y - _currPoint.y;
	
			if(_isZooming && numPoints > 1) {
				// Handle behaviour for more than 1 point
	
				_currPoint.x = p.x;
				_currPoint.y = p.y;
			
				// check if one of two points changed
				if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
					return;
				}
	
				_equalizePoints(p2, _currentPoints[1]);
	
	
				if(!_zoomStarted) {
					_zoomStarted = true;
					_shout('zoomGestureStarted');
				}
				
				// Distance between two points
				var pointsDistance = _calculatePointsDistance(p,p2);
	
				var zoomLevel = _calculateZoomLevel(pointsDistance);
	
				// slightly over the of initial zoom level
				if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
					_wasOverInitialZoom = true;
				}
	
				// Apply the friction if zoom level is out of the bounds
				var zoomFriction = 1,
					minZoomLevel = _getMinZoomLevel(),
					maxZoomLevel = _getMaxZoomLevel();
	
				if ( zoomLevel < minZoomLevel ) {
					
					if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
						// fade out background if zooming out
						var minusDiff = minZoomLevel - zoomLevel;
						var percent = 1 - minusDiff / (minZoomLevel / 1.2);
	
						_applyBgOpacity(percent);
						_shout('onPinchClose', percent);
						_opacityChanged = true;
					} else {
						zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
						if(zoomFriction > 1) {
							zoomFriction = 1;
						}
						zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
					}
					
				} else if ( zoomLevel > maxZoomLevel ) {
					// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
					zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
					if(zoomFriction > 1) {
						zoomFriction = 1;
					}
					zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
				}
	
				if(zoomFriction < 0) {
					zoomFriction = 0;
				}
	
				// distance between touch points after friction is applied
				_currPointsDistance = pointsDistance;
	
				// _centerPoint - The point in the middle of two pointers
				_findCenterOfPoints(p, p2, _centerPoint);
			
				// paning with two pointers pressed
				_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
				_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
				_equalizePoints(_currCenterPoint, _centerPoint);
	
				_panOffset.x = _calculatePanOffset('x', zoomLevel);
				_panOffset.y = _calculatePanOffset('y', zoomLevel);
	
				_isZoomingIn = zoomLevel > _currZoomLevel;
				_currZoomLevel = zoomLevel;
				_applyCurrentZoomPan();
	
			} else {
	
				// handle behaviour for one point (dragging or panning)
	
				if(!_direction) {
					return;
				}
	
				if(_isFirstMove) {
					_isFirstMove = false;
	
					// subtract drag distance that was used during the detection direction  
	
					if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
						delta.x -= _currentPoints[0].x - _startPoint.x;
					}
					
					if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
						delta.y -= _currentPoints[0].y - _startPoint.y;
					}
				}
	
				_currPoint.x = p.x;
				_currPoint.y = p.y;
	
				// do nothing if pointers position hasn't changed
				if(delta.x === 0 && delta.y === 0) {
					return;
				}
	
				if(_direction === 'v' && _options.closeOnVerticalDrag) {
					if(!_canPan()) {
						_currPanDist.y += delta.y;
						_panOffset.y += delta.y;
	
						var opacityRatio = _calculateVerticalDragOpacityRatio();
	
						_verticalDragInitiated = true;
						_shout('onVerticalDrag', opacityRatio);
	
						_applyBgOpacity(opacityRatio);
						_applyCurrentZoomPan();
						return ;
					}
				}
	
				_pushPosPoint(_getCurrentTime(), p.x, p.y);
	
				_moved = true;
				_currPanBounds = self.currItem.bounds;
				
				var mainScrollChanged = _panOrMoveMainScroll('x', delta);
				if(!mainScrollChanged) {
					_panOrMoveMainScroll('y', delta);
	
					_roundPoint(_panOffset);
					_applyCurrentZoomPan();
				}
	
			}
	
		},
		
		// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
		_onDragRelease = function(e) {
	
			if(_features.isOldAndroid ) {
	
				if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
					return;
				}
	
				// on Android (v4.1, 4.2, 4.3 & possibly older) 
				// ghost mousedown/up event isn't preventable via e.preventDefault,
				// which causes fake mousedown event
				// so we block mousedown/up for 600ms
				if( e.type.indexOf('touch') > -1 ) {
					clearTimeout(_oldAndroidTouchEndTimeout);
					_oldAndroidTouchEndTimeout = setTimeout(function() {
						_oldAndroidTouchEndTimeout = 0;
					}, 600);
				}
				
			}
	
			_shout('pointerUp');
	
			if(_preventDefaultEventBehaviour(e, false)) {
				e.preventDefault();
			}
	
			var releasePoint;
	
			if(_pointerEventEnabled) {
				var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
				
				if(pointerIndex > -1) {
					releasePoint = _currPointers.splice(pointerIndex, 1)[0];
	
					if(navigator.msPointerEnabled) {
						var MSPOINTER_TYPES = {
							4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
							2: 'touch', // event.MSPOINTER_TYPE_TOUCH 
							3: 'pen' // event.MSPOINTER_TYPE_PEN
						};
						releasePoint.type = MSPOINTER_TYPES[e.pointerType];
	
						if(!releasePoint.type) {
							releasePoint.type = e.pointerType || 'mouse';
						}
					} else {
						releasePoint.type = e.pointerType || 'mouse';
					}
	
				}
			}
	
			var touchList = _getTouchPoints(e),
				gestureType,
				numPoints = touchList.length;
	
			if(e.type === 'mouseup') {
				numPoints = 0;
			}
	
			// Do nothing if there were 3 touch points or more
			if(numPoints === 2) {
				_currentPoints = null;
				return true;
			}
	
			// if second pointer released
			if(numPoints === 1) {
				_equalizePoints(_startPoint, touchList[0]);
			}				
	
	
			// pointer hasn't moved, send "tap release" point
			if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
				if(!releasePoint) {
					if(e.type === 'mouseup') {
						releasePoint = {x: e.pageX, y: e.pageY, type:'mouse'};
					} else if(e.changedTouches && e.changedTouches[0]) {
						releasePoint = {x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type:'touch'};
					}		
				}
	
				_shout('touchRelease', e, releasePoint);
			}
	
			// Difference in time between releasing of two last touch points (zoom gesture)
			var releaseTimeDiff = -1;
	
			// Gesture completed, no pointers left
			if(numPoints === 0) {
				_isDragging = false;
				framework.unbind(window, _upMoveEvents, self);
	
				_stopDragUpdateLoop();
	
				if(_isZooming) {
					// Two points released at the same time
					releaseTimeDiff = 0;
				} else if(_lastReleaseTime !== -1) {
					releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
				}
			}
			_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
			
			if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
				gestureType = 'zoom';
			} else {
				gestureType = 'swipe';
			}
	
			if(_isZooming && numPoints < 2) {
				_isZooming = false;
	
				// Only second point released
				if(numPoints === 1) {
					gestureType = 'zoomPointerUp';
				}
				_shout('zoomGestureEnded');
			}
	
			_currentPoints = null;
			if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
				// nothing to animate
				return;
			}
		
			_stopAllAnimations();
	
			
			if(!_releaseAnimData) {
				_releaseAnimData = _initDragReleaseAnimationData();
			}
			
			_releaseAnimData.calculateSwipeSpeed('x');
	
	
			if(_verticalDragInitiated) {
	
				var opacityRatio = _calculateVerticalDragOpacityRatio();
	
				if(opacityRatio < _options.verticalDragRange) {
					self.close();
				} else {
					var initalPanY = _panOffset.y,
						initialBgOpacity = _bgOpacity;
	
					_animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
						
						_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
	
						_applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
						_applyCurrentZoomPan();
					});
	
					_shout('onVerticalDrag', 1);
				}
	
				return;
			}
	
	
			// main scroll 
			if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
				var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
				if(itemChanged) {
					return;
				}
				gestureType = 'zoomPointerUp';
			}
	
			// prevent zoom/pan animation when main scroll animation runs
			if(_mainScrollAnimating) {
				return;
			}
			
			// Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
			if(gestureType !== 'swipe') {
				_completeZoomGesture();
				return;
			}
		
			// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
			if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
				_completePanGesture(_releaseAnimData);
			}
		},
	
	
		// Returns object with data about gesture
		// It's created only once and then reused
		_initDragReleaseAnimationData  = function() {
			// temp local vars
			var lastFlickDuration,
				tempReleasePos;
	
			// s = this
			var s = {
				lastFlickOffset: {},
				lastFlickDist: {},
				lastFlickSpeed: {},
				slowDownRatio:  {},
				slowDownRatioReverse:  {},
				speedDecelerationRatio:  {},
				speedDecelerationRatioAbs:  {},
				distanceOffset:  {},
				backAnimDestination: {},
				backAnimStarted: {},
				calculateSwipeSpeed: function(axis) {
					
	
					if( _posPoints.length > 1) {
						lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
						tempReleasePos = _posPoints[_posPoints.length-2][axis];
					} else {
						lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
						tempReleasePos = _startPoint[axis];
					}
					s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
					s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
					if(s.lastFlickDist[axis] > 20) {
						s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
					} else {
						s.lastFlickSpeed[axis] = 0;
					}
					if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
						s.lastFlickSpeed[axis] = 0;
					}
					
					s.slowDownRatio[axis] = 0.95;
					s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
					s.speedDecelerationRatio[axis] = 1;
				},
	
				calculateOverBoundsAnimOffset: function(axis, speed) {
					if(!s.backAnimStarted[axis]) {
	
						if(_panOffset[axis] > _currPanBounds.min[axis]) {
							s.backAnimDestination[axis] = _currPanBounds.min[axis];
							
						} else if(_panOffset[axis] < _currPanBounds.max[axis]) {
							s.backAnimDestination[axis] = _currPanBounds.max[axis];
						}
	
						if(s.backAnimDestination[axis] !== undefined) {
							s.slowDownRatio[axis] = 0.7;
							s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
							if(s.speedDecelerationRatioAbs[axis] < 0.05) {
	
								s.lastFlickSpeed[axis] = 0;
								s.backAnimStarted[axis] = true;
	
								_animateProp('bounceZoomPan'+axis,_panOffset[axis], 
									s.backAnimDestination[axis], 
									speed || 300, 
									framework.easing.sine.out, 
									function(pos) {
										_panOffset[axis] = pos;
										_applyCurrentZoomPan();
									}
								);
	
							}
						}
					}
				},
	
				// Reduces the speed by slowDownRatio (per 10ms)
				calculateAnimOffset: function(axis) {
					if(!s.backAnimStarted[axis]) {
						s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + 
													s.slowDownRatioReverse[axis] - 
													s.slowDownRatioReverse[axis] * s.timeDiff / 10);
	
						s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
						s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
						_panOffset[axis] += s.distanceOffset[axis];
	
					}
				},
	
				panAnimLoop: function() {
					if ( _animations.zoomPan ) {
						_animations.zoomPan.raf = _requestAF(s.panAnimLoop);
	
						s.now = _getCurrentTime();
						s.timeDiff = s.now - s.lastNow;
						s.lastNow = s.now;
						
						s.calculateAnimOffset('x');
						s.calculateAnimOffset('y');
	
						_applyCurrentZoomPan();
						
						s.calculateOverBoundsAnimOffset('x');
						s.calculateOverBoundsAnimOffset('y');
	
	
						if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
	
							// round pan position
							_panOffset.x = Math.round(_panOffset.x);
							_panOffset.y = Math.round(_panOffset.y);
							_applyCurrentZoomPan();
							
							_stopAnimation('zoomPan');
							return;
						}
					}
	
				}
			};
			return s;
		},
	
		_completePanGesture = function(animData) {
			// calculate swipe speed for Y axis (paanning)
			animData.calculateSwipeSpeed('y');
	
			_currPanBounds = self.currItem.bounds;
			
			animData.backAnimDestination = {};
			animData.backAnimStarted = {};
	
			// Avoid acceleration animation if speed is too low
			if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
				animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
	
				// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
				animData.calculateOverBoundsAnimOffset('x');
				animData.calculateOverBoundsAnimOffset('y');
				return true;
			}
	
			// Animation loop that controls the acceleration after pan gesture ends
			_registerStartAnimation('zoomPan');
			animData.lastNow = _getCurrentTime();
			animData.panAnimLoop();
		},
	
	
		_finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
			var itemChanged;
			if(!_mainScrollAnimating) {
				_currZoomedItemIndex = _currentItemIndex;
			}
	
	
			
			var itemsDiff;
	
			if(gestureType === 'swipe') {
				var totalShiftDist = _currPoint.x - _startPoint.x,
					isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
	
				// if container is shifted for more than MIN_SWIPE_DISTANCE, 
				// and last flick gesture was in right direction
				if(totalShiftDist > MIN_SWIPE_DISTANCE && 
					(isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
					// go to prev item
					itemsDiff = -1;
				} else if(totalShiftDist < -MIN_SWIPE_DISTANCE && 
					(isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
					// go to next item
					itemsDiff = 1;
				}
			}
	
			var nextCircle;
	
			if(itemsDiff) {
				
				_currentItemIndex += itemsDiff;
	
				if(_currentItemIndex < 0) {
					_currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
					nextCircle = true;
				} else if(_currentItemIndex >= _getNumItems()) {
					_currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
					nextCircle = true;
				}
	
				if(!nextCircle || _options.loop) {
					_indexDiff += itemsDiff;
					_currPositionIndex -= itemsDiff;
					itemChanged = true;
				}
				
	
				
			}
	
			var animateToX = _slideSize.x * _currPositionIndex;
			var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
			var finishAnimDuration;
	
	
			if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
				// "return to current" duration, e.g. when dragging from slide 0 to -1
				finishAnimDuration = 333; 
			} else {
				finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? 
										animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 
										333;
	
				finishAnimDuration = Math.min(finishAnimDuration, 400);
				finishAnimDuration = Math.max(finishAnimDuration, 250);
			}
	
			if(_currZoomedItemIndex === _currentItemIndex) {
				itemChanged = false;
			}
			
			_mainScrollAnimating = true;
			
			_shout('mainScrollAnimStart');
	
			_animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, 
				_moveMainScroll,
				function() {
					_stopAllAnimations();
					_mainScrollAnimating = false;
					_currZoomedItemIndex = -1;
					
					if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
						self.updateCurrItem();
					}
					
					_shout('mainScrollAnimComplete');
				}
			);
	
			if(itemChanged) {
				self.updateCurrItem(true);
			}
	
			return itemChanged;
		},
	
		_calculateZoomLevel = function(touchesDistance) {
			return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
		},
	
		// Resets zoom if it's out of bounds
		_completeZoomGesture = function() {
			var destZoomLevel = _currZoomLevel,
				minZoomLevel = _getMinZoomLevel(),
				maxZoomLevel = _getMaxZoomLevel();
	
			if ( _currZoomLevel < minZoomLevel ) {
				destZoomLevel = minZoomLevel;
			} else if ( _currZoomLevel > maxZoomLevel ) {
				destZoomLevel = maxZoomLevel;
			}
	
			var destOpacity = 1,
				onUpdate,
				initialOpacity = _bgOpacity;
	
			if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
				//_closedByScroll = true;
				self.close();
				return true;
			}
	
			if(_opacityChanged) {
				onUpdate = function(now) {
					_applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
				};
			}
	
			self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
			return true;
		};
	
	
	_registerModule('Gestures', {
		publicMethods: {
	
			initGestures: function() {
	
				// helper function that builds touch/pointer/mouse events
				var addEventNames = function(pref, down, move, up, cancel) {
					_dragStartEvent = pref + down;
					_dragMoveEvent = pref + move;
					_dragEndEvent = pref + up;
					if(cancel) {
						_dragCancelEvent = pref + cancel;
					} else {
						_dragCancelEvent = '';
					}
				};
	
				_pointerEventEnabled = _features.pointerEvent;
				if(_pointerEventEnabled && _features.touch) {
					// we don't need touch events, if browser supports pointer events
					_features.touch = false;
				}
	
				if(_pointerEventEnabled) {
					if(navigator.msPointerEnabled) {
						// IE10 pointer events are case-sensitive
						addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
					} else {
						addEventNames('pointer', 'down', 'move', 'up', 'cancel');
					}
				} else if(_features.touch) {
					addEventNames('touch', 'start', 'move', 'end', 'cancel');
					_likelyTouchDevice = true;
				} else {
					addEventNames('mouse', 'down', 'move', 'up');	
				}
	
				_upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
				_downEvents = _dragStartEvent;
	
				if(_pointerEventEnabled && !_likelyTouchDevice) {
					_likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
				}
				// make variable public
				self.likelyTouchDevice = _likelyTouchDevice; 
				
				_globalEventHandlers[_dragStartEvent] = _onDragStart;
				_globalEventHandlers[_dragMoveEvent] = _onDragMove;
				_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
	
				if(_dragCancelEvent) {
					_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
				}
	
				// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
				if(_features.touch) {
					_downEvents += ' mousedown';
					_upMoveEvents += ' mousemove mouseup';
					_globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
					_globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
					_globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
				}
	
				if(!_likelyTouchDevice) {
					// don't allow pan to next slide from zoomed state on Desktop
					_options.allowPanToNext = false;
				}
			}
	
		}
	});
	
	
	/*>>gestures*/
	
	/*>>show-hide-transition*/
	/**
	 * show-hide-transition.js:
	 *
	 * Manages initial opening or closing transition.
	 *
	 * If you're not planning to use transition for gallery at all,
	 * you may set options hideAnimationDuration and showAnimationDuration to 0,
	 * and just delete startAnimation function.
	 * 
	 */
	
	
	var _showOrHideTimeout,
		_showOrHide = function(item, img, out, completeFn) {
	
			if(_showOrHideTimeout) {
				clearTimeout(_showOrHideTimeout);
			}
	
			_initialZoomRunning = true;
			_initialContentSet = true;
			
			// dimensions of small thumbnail {x:,y:,w:}.
			// Height is optional, as calculated based on large image.
			var thumbBounds; 
			if(item.initialLayout) {
				thumbBounds = item.initialLayout;
				item.initialLayout = null;
			} else {
				thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
			}
	
			var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
	
			var onComplete = function() {
				_stopAnimation('initialZoom');
				if(!out) {
					_applyBgOpacity(1);
					if(img) {
						img.style.display = 'block';
					}
					framework.addClass(template, 'pswp--animated-in');
					_shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
				} else {
					self.template.removeAttribute('style');
					self.bg.removeAttribute('style');
				}
	
				if(completeFn) {
					completeFn();
				}
				_initialZoomRunning = false;
			};
	
			// if bounds aren't provided, just open gallery without animation
			if(!duration || !thumbBounds || thumbBounds.x === undefined) {
	
				_shout('initialZoom' + (out ? 'Out' : 'In') );
	
				_currZoomLevel = item.initialZoomLevel;
				_equalizePoints(_panOffset,  item.initialPosition );
				_applyCurrentZoomPan();
	
				template.style.opacity = out ? 0 : 1;
				_applyBgOpacity(1);
	
				if(duration) {
					setTimeout(function() {
						onComplete();
					}, duration);
				} else {
					onComplete();
				}
	
				return;
			}
	
			var startAnimation = function() {
				var closeWithRaf = _closedByScroll,
					fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
				
				// apply hw-acceleration to image
				if(item.miniImg) {
					item.miniImg.style.webkitBackfaceVisibility = 'hidden';
				}
	
				if(!out) {
					_currZoomLevel = thumbBounds.w / item.w;
					_panOffset.x = thumbBounds.x;
					_panOffset.y = thumbBounds.y - _initalWindowScrollY;
	
					self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
					_applyCurrentZoomPan();
				}
	
				_registerStartAnimation('initialZoom');
				
				if(out && !closeWithRaf) {
					framework.removeClass(template, 'pswp--animated-in');
				}
	
				if(fadeEverything) {
					if(out) {
						framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'pswp--animate_opacity');
					} else {
						setTimeout(function() {
							framework.addClass(template, 'pswp--animate_opacity');
						}, 30);
					}
				}
	
				_showOrHideTimeout = setTimeout(function() {
	
					_shout('initialZoom' + (out ? 'Out' : 'In') );
					
	
					if(!out) {
	
						// "in" animation always uses CSS transitions (instead of rAF).
						// CSS transition work faster here, 
						// as developer may also want to animate other things, 
						// like ui on top of sliding area, which can be animated just via CSS
						
						_currZoomLevel = item.initialZoomLevel;
						_equalizePoints(_panOffset,  item.initialPosition );
						_applyCurrentZoomPan();
						_applyBgOpacity(1);
	
						if(fadeEverything) {
							template.style.opacity = 1;
						} else {
							_applyBgOpacity(1);
						}
	
						_showOrHideTimeout = setTimeout(onComplete, duration + 20);
					} else {
	
						// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
						var destZoomLevel = thumbBounds.w / item.w,
							initialPanOffset = {
								x: _panOffset.x,
								y: _panOffset.y
							},
							initialZoomLevel = _currZoomLevel,
							initalBgOpacity = _bgOpacity,
							onUpdate = function(now) {
								
								if(now === 1) {
									_currZoomLevel = destZoomLevel;
									_panOffset.x = thumbBounds.x;
									_panOffset.y = thumbBounds.y  - _currentWindowScrollY;
								} else {
									_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
									_panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
									_panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
								}
								
								_applyCurrentZoomPan();
								if(fadeEverything) {
									template.style.opacity = 1 - now;
								} else {
									_applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
								}
							};
	
						if(closeWithRaf) {
							_animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
						} else {
							onUpdate(1);
							_showOrHideTimeout = setTimeout(onComplete, duration + 20);
						}
					}
				
				}, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
						// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
						// Which avoids lag at the beginning of scale transition.
			};
			startAnimation();
	
			
		};
	
	/*>>show-hide-transition*/
	
	/*>>items-controller*/
	/**
	*
	* Controller manages gallery items, their dimensions, and their content.
	* 
	*/
	
	var _items,
		_tempPanAreaSize = {},
		_imagesToAppendPool = [],
		_initialContentSet,
		_initialZoomRunning,
		_controllerDefaultOptions = {
			index: 0,
			errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
			forceProgressiveLoading: false, // TODO
			preload: [1,1],
			getNumItemsFn: function() {
				return _items.length;
			}
		};
	
	
	var _getItemAt,
		_getNumItems,
		_initialIsLoop,
		_getZeroBounds = function() {
			return {
				center:{x:0,y:0}, 
				max:{x:0,y:0}, 
				min:{x:0,y:0}
			};
		},
		_calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {
			var bounds = item.bounds;
	
			// position of element when it's centered
			bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
			bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
	
			// maximum pan position
			bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ? 
								Math.round(_tempPanAreaSize.x - realPanElementW) : 
								bounds.center.x;
			
			bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ? 
								Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : 
								bounds.center.y;
			
			// minimum pan position
			bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? 0 : bounds.center.x;
			bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
		},
		_calculateItemSize = function(item, viewportSize, zoomLevel) {
	
			if (item.src && !item.loadError) {
				var isInitial = !zoomLevel;
				
				if(isInitial) {
					if(!item.vGap) {
						item.vGap = {top:0,bottom:0};
					}
					// allows overriding vertical margin for individual items
					_shout('parseVerticalMargin', item);
				}
	
	
				_tempPanAreaSize.x = viewportSize.x;
				_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
	
				if (isInitial) {
					var hRatio = _tempPanAreaSize.x / item.w;
					var vRatio = _tempPanAreaSize.y / item.h;
	
					item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
					//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
	
					var scaleMode = _options.scaleMode;
	
					if (scaleMode === 'orig') {
						zoomLevel = 1;
					} else if (scaleMode === 'fit') {
						zoomLevel = item.fitRatio;
					}
	
					if (zoomLevel > 1) {
						zoomLevel = 1;
					}
	
					item.initialZoomLevel = zoomLevel;
					
					if(!item.bounds) {
						// reuse bounds object
						item.bounds = _getZeroBounds(); 
					}
				}
	
				if(!zoomLevel) {
					return;
				}
	
				_calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
	
				if (isInitial && zoomLevel === item.initialZoomLevel) {
					item.initialPosition = item.bounds.center;
				}
	
				return item.bounds;
			} else {
				item.w = item.h = 0;
				item.initialZoomLevel = item.fitRatio = 1;
				item.bounds = _getZeroBounds();
				item.initialPosition = item.bounds.center;
	
				// if it's not image, we return zero bounds (content is not zoomable)
				return item.bounds;
			}
			
		},
	
		
	
	
		_appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
			
	
			if(item.loadError) {
				return;
			}
	
			if(img) {
	
				item.imageAppended = true;
				_setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );
				
				baseDiv.appendChild(img);
	
				if(keepPlaceholder) {
					setTimeout(function() {
						if(item && item.loaded && item.placeholder) {
							item.placeholder.style.display = 'none';
							item.placeholder = null;
						}
					}, 500);
				}
			}
		},
		
	
	
		_preloadImage = function(item) {
			item.loading = true;
			item.loaded = false;
			var img = item.img = framework.createEl('pswp__img', 'img');
			var onComplete = function() {
				item.loading = false;
				item.loaded = true;
	
				if(item.loadComplete) {
					item.loadComplete(item);
				} else {
					item.img = null; // no need to store image object
				}
				img.onload = img.onerror = null;
				img = null;
			};
			img.onload = onComplete;
			img.onerror = function() {
				item.loadError = true;
				onComplete();
			};		
	
			img.src = item.src;// + '?a=' + Math.random();
	
			return img;
		},
		_checkForError = function(item, cleanUp) {
			if(item.src && item.loadError && item.container) {
	
				if(cleanUp) {
					item.container.innerHTML = '';
				}
	
				item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
				return true;
				
			}
		},
		_setImageSize = function(item, img, maxRes) {
			if(!item.src) {
				return;
			}
	
			if(!img) {
				img = item.container.lastChild;
			}
	
			var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
				h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
			
			if(item.placeholder && !item.loaded) {
				item.placeholder.style.width = w + 'px';
				item.placeholder.style.height = h + 'px';
			}
	
			img.style.width = w + 'px';
			img.style.height = h + 'px';
		},
		_appendImagesPool = function() {
	
			if(_imagesToAppendPool.length) {
				var poolItem;
	
				for(var i = 0; i < _imagesToAppendPool.length; i++) {
					poolItem = _imagesToAppendPool[i];
					if( poolItem.holder.index === poolItem.index ) {
						_appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
					}
				}
				_imagesToAppendPool = [];
			}
		};
		
	
	
	_registerModule('Controller', {
	
		publicMethods: {
	
			lazyLoadItem: function(index) {
				index = _getLoopedId(index);
				var item = _getItemAt(index);
	
				if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
					return;
				}
	
				_shout('gettingData', index, item);
	
				if (!item.src) {
					return;
				}
	
				_preloadImage(item);
			},
			initController: function() {
				framework.extend(_options, _controllerDefaultOptions, true);
				self.items = _items = items;
				_getItemAt = self.getItemAt;
				_getNumItems = _options.getNumItemsFn; //self.getNumItems;
	
	
	
				_initialIsLoop = _options.loop;
				if(_getNumItems() < 3) {
					_options.loop = false; // disable loop if less then 3 items
				}
	
				_listen('beforeChange', function(diff) {
	
					var p = _options.preload,
						isNext = diff === null ? true : (diff >= 0),
						preloadBefore = Math.min(p[0], _getNumItems() ),
						preloadAfter = Math.min(p[1], _getNumItems() ),
						i;
	
	
					for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
						self.lazyLoadItem(_currentItemIndex+i);
					}
					for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
						self.lazyLoadItem(_currentItemIndex-i);
					}
				});
	
				_listen('initialLayout', function() {
					self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
				});
	
				_listen('mainScrollAnimComplete', _appendImagesPool);
				_listen('initialZoomInEnd', _appendImagesPool);
	
	
	
				_listen('destroy', function() {
					var item;
					for(var i = 0; i < _items.length; i++) {
						item = _items[i];
						// remove reference to DOM elements, for GC
						if(item.container) {
							item.container = null; 
						}
						if(item.placeholder) {
							item.placeholder = null;
						}
						if(item.img) {
							item.img = null;
						}
						if(item.preloader) {
							item.preloader = null;
						}
						if(item.loadError) {
							item.loaded = item.loadError = false;
						}
					}
					_imagesToAppendPool = null;
				});
			},
	
	
			getItemAt: function(index) {
				if (index >= 0) {
					return _items[index] !== undefined ? _items[index] : false;
				}
				return false;
			},
	
			allowProgressiveImg: function() {
				// 1. Progressive image loading isn't working on webkit/blink 
				//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
				//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
				//    
				// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
				//    That's why it's disabled on touch devices (mainly because of swipe transition)
				//    
				// 3. Progressive image loading sometimes doesn't work in IE (up to 11).
	
				// Don't allow progressive loading on non-large touch devices
				return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200; 
				// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
			},
	
			setContent: function(holder, index) {
	
				if(_options.loop) {
					index = _getLoopedId(index);
				}
	
				var prevItem = self.getItemAt(holder.index);
				if(prevItem) {
					prevItem.container = null;
				}
		
				var item = self.getItemAt(index),
					img;
				
				if(!item) {
					holder.el.innerHTML = '';
					return;
				}
	
				// allow to override data
				_shout('gettingData', index, item);
	
				holder.index = index;
				holder.item = item;
	
				// base container DIV is created only once for each of 3 holders
				var baseDiv = item.container = framework.createEl('pswp__zoom-wrap'); 
	
				
	
				if(!item.src && item.html) {
					if(item.html.tagName) {
						baseDiv.appendChild(item.html);
					} else {
						baseDiv.innerHTML = item.html;
					}
				}
	
				_checkForError(item);
	
				_calculateItemSize(item, _viewportSize);
				
				if(item.src && !item.loadError && !item.loaded) {
	
					item.loadComplete = function(item) {
	
						// gallery closed before image finished loading
						if(!_isOpen) {
							return;
						}
	
						// check if holder hasn't changed while image was loading
						if(holder && holder.index === index ) {
							if( _checkForError(item, true) ) {
								item.loadComplete = item.img = null;
								_calculateItemSize(item, _viewportSize);
								_applyZoomPanToItem(item);
	
								if(holder.index === _currentItemIndex) {
									// recalculate dimensions
									self.updateCurrZoomItem();
								}
								return;
							}
							if( !item.imageAppended ) {
								if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
									_imagesToAppendPool.push({
										item:item,
										baseDiv:baseDiv,
										img:item.img,
										index:index,
										holder:holder,
										clearPlaceholder:true
									});
								} else {
									_appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
								}
							} else {
								// remove preloader & mini-img
								if(!_initialZoomRunning && item.placeholder) {
									item.placeholder.style.display = 'none';
									item.placeholder = null;
								}
							}
						}
	
						item.loadComplete = null;
						item.img = null; // no need to store image element after it's added
	
						_shout('imageLoadComplete', index, item);
					};
	
					if(framework.features.transform) {
						
						var placeholderClassName = 'pswp__img pswp__img--placeholder'; 
						placeholderClassName += (item.msrc ? '' : ' pswp__img--placeholder--blank');
	
						var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
						if(item.msrc) {
							placeholder.src = item.msrc;
						}
						
						_setImageSize(item, placeholder);
	
						baseDiv.appendChild(placeholder);
						item.placeholder = placeholder;
	
					}
					
	
					
	
					if(!item.loading) {
						_preloadImage(item);
					}
	
	
					if( self.allowProgressiveImg() ) {
						// just append image
						if(!_initialContentSet && _features.transform) {
							_imagesToAppendPool.push({
								item:item, 
								baseDiv:baseDiv, 
								img:item.img, 
								index:index, 
								holder:holder
							});
						} else {
							_appendImage(index, item, baseDiv, item.img, true, true);
						}
					}
					
				} else if(item.src && !item.loadError) {
					// image object is created every time, due to bugs of image loading & delay when switching images
					img = framework.createEl('pswp__img', 'img');
					img.style.opacity = 1;
					img.src = item.src;
					_setImageSize(item, img);
					_appendImage(index, item, baseDiv, img, true);
				}
				
	
				if(!_initialContentSet && index === _currentItemIndex) {
					_currZoomElementStyle = baseDiv.style;
					_showOrHide(item, (img ||item.img) );
				} else {
					_applyZoomPanToItem(item);
				}
	
				holder.el.innerHTML = '';
				holder.el.appendChild(baseDiv);
			},
	
			cleanSlide: function( item ) {
				if(item.img ) {
					item.img.onload = item.img.onerror = null;
				}
				item.loaded = item.loading = item.img = item.imageAppended = false;
			}
	
		}
	});
	
	/*>>items-controller*/
	
	/*>>tap*/
	/**
	 * tap.js:
	 *
	 * Displatches tap and double-tap events.
	 * 
	 */
	
	var tapTimer,
		tapReleasePoint = {},
		_dispatchTapEvent = function(origEvent, releasePoint, pointerType) {		
			var e = document.createEvent( 'CustomEvent' ),
				eDetail = {
					origEvent:origEvent, 
					target:origEvent.target, 
					releasePoint: releasePoint, 
					pointerType:pointerType || 'touch'
				};
	
			e.initCustomEvent( 'pswpTap', true, true, eDetail );
			origEvent.target.dispatchEvent(e);
		};
	
	_registerModule('Tap', {
		publicMethods: {
			initTap: function() {
				_listen('firstTouchStart', self.onTapStart);
				_listen('touchRelease', self.onTapRelease);
				_listen('destroy', function() {
					tapReleasePoint = {};
					tapTimer = null;
				});
			},
			onTapStart: function(touchList) {
				if(touchList.length > 1) {
					clearTimeout(tapTimer);
					tapTimer = null;
				}
			},
			onTapRelease: function(e, releasePoint) {
				if(!releasePoint) {
					return;
				}
	
				if(!_moved && !_isMultitouch && !_numAnimations) {
					var p0 = releasePoint;
					if(tapTimer) {
						clearTimeout(tapTimer);
						tapTimer = null;
	
						// Check if taped on the same place
						if ( _isNearbyPoints(p0, tapReleasePoint) ) {
							_shout('doubleTap', p0);
							return;
						}
					}
	
					if(releasePoint.type === 'mouse') {
						_dispatchTapEvent(e, releasePoint, 'mouse');
						return;
					}
	
					var clickedTagName = e.target.tagName.toUpperCase();
					// avoid double tap delay on buttons and elements that have class pswp__single-tap
					if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap') ) {
						_dispatchTapEvent(e, releasePoint);
						return;
					}
	
					_equalizePoints(tapReleasePoint, p0);
	
					tapTimer = setTimeout(function() {
						_dispatchTapEvent(e, releasePoint);
						tapTimer = null;
					}, 300);
				}
			}
		}
	});
	
	/*>>tap*/
	
	/*>>desktop-zoom*/
	/**
	 *
	 * desktop-zoom.js:
	 *
	 * - Binds mousewheel event for paning zoomed image.
	 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
	 *   (which are used for cursors and zoom icon)
	 * - Adds toggleDesktopZoom function.
	 * 
	 */
	
	var _wheelDelta;
		
	_registerModule('DesktopZoom', {
	
		publicMethods: {
	
			initDesktopZoom: function() {
	
				if(_oldIE) {
					// no zoom for old IE (<=8)
					return;
				}
	
				if(_likelyTouchDevice) {
					// if detected hardware touch support, we wait until mouse is used,
					// and only then apply desktop-zoom features
					_listen('mouseUsed', function() {
						self.setupDesktopZoom();
					});
				} else {
					self.setupDesktopZoom(true);
				}
	
			},
	
			setupDesktopZoom: function(onInit) {
	
				_wheelDelta = {};
	
				var events = 'wheel mousewheel DOMMouseScroll';
				
				_listen('bindEvents', function() {
					framework.bind(template, events,  self.handleMouseWheel);
				});
	
				_listen('unbindEvents', function() {
					if(_wheelDelta) {
						framework.unbind(template, events, self.handleMouseWheel);
					}
				});
	
				self.mouseZoomedIn = false;
	
				var hasDraggingClass,
					updateZoomable = function() {
						if(self.mouseZoomedIn) {
							framework.removeClass(template, 'pswp--zoomed-in');
							self.mouseZoomedIn = false;
						}
						if(_currZoomLevel < 1) {
							framework.addClass(template, 'pswp--zoom-allowed');
						} else {
							framework.removeClass(template, 'pswp--zoom-allowed');
						}
						removeDraggingClass();
					},
					removeDraggingClass = function() {
						if(hasDraggingClass) {
							framework.removeClass(template, 'pswp--dragging');
							hasDraggingClass = false;
						}
					};
	
				_listen('resize' , updateZoomable);
				_listen('afterChange' , updateZoomable);
				_listen('pointerDown', function() {
					if(self.mouseZoomedIn) {
						hasDraggingClass = true;
						framework.addClass(template, 'pswp--dragging');
					}
				});
				_listen('pointerUp', removeDraggingClass);
	
				if(!onInit) {
					updateZoomable();
				}
				
			},
	
			handleMouseWheel: function(e) {
	
				if(_currZoomLevel <= self.currItem.fitRatio) {
					if( _options.modal ) {
	
						if (!_options.closeOnScroll || _numAnimations || _isDragging) {
							e.preventDefault();
						} else if(_transformKey && Math.abs(e.deltaY) > 2) {
							// close PhotoSwipe
							// if browser supports transforms & scroll changed enough
							_closedByScroll = true;
							self.close();
						}
	
					}
					return true;
				}
	
				// allow just one event to fire
				e.stopPropagation();
	
				// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
				_wheelDelta.x = 0;
	
				if('deltaX' in e) {
					if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
						// 18 - average line height
						_wheelDelta.x = e.deltaX * 18;
						_wheelDelta.y = e.deltaY * 18;
					} else {
						_wheelDelta.x = e.deltaX;
						_wheelDelta.y = e.deltaY;
					}
				} else if('wheelDelta' in e) {
					if(e.wheelDeltaX) {
						_wheelDelta.x = -0.16 * e.wheelDeltaX;
					}
					if(e.wheelDeltaY) {
						_wheelDelta.y = -0.16 * e.wheelDeltaY;
					} else {
						_wheelDelta.y = -0.16 * e.wheelDelta;
					}
				} else if('detail' in e) {
					_wheelDelta.y = e.detail;
				} else {
					return;
				}
	
				_calculatePanBounds(_currZoomLevel, true);
	
				var newPanX = _panOffset.x - _wheelDelta.x,
					newPanY = _panOffset.y - _wheelDelta.y;
	
				// only prevent scrolling in nonmodal mode when not at edges
				if (_options.modal ||
					(
					newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
					newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
					) ) {
					e.preventDefault();
				}
	
				// TODO: use rAF instead of mousewheel?
				self.panTo(newPanX, newPanY);
			},
	
			toggleDesktopZoom: function(centerPoint) {
				centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };
	
				var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
				var zoomOut = _currZoomLevel === doubleTapZoomLevel;
				
				self.mouseZoomedIn = !zoomOut;
	
				self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
				framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
			}
	
		}
	});
	
	
	/*>>desktop-zoom*/
	
	/*>>history*/
	/**
	 *
	 * history.js:
	 *
	 * - Back button to close gallery.
	 * 
	 * - Unique URL for each slide: example.com/&pid=1&gid=3
	 *   (where PID is picture index, and GID and gallery index)
	 *   
	 * - Switch URL when slides change.
	 * 
	 */
	
	
	var _historyDefaultOptions = {
		history: true,
		galleryUID: 1
	};
	
	var _historyUpdateTimeout,
		_hashChangeTimeout,
		_hashAnimCheckTimeout,
		_hashChangedByScript,
		_hashChangedByHistory,
		_hashReseted,
		_initialHash,
		_historyChanged,
		_closedFromURL,
		_urlChangedOnce,
		_windowLoc,
	
		_supportsPushState,
	
		_getHash = function() {
			return _windowLoc.hash.substring(1);
		},
		_cleanHistoryTimeouts = function() {
	
			if(_historyUpdateTimeout) {
				clearTimeout(_historyUpdateTimeout);
			}
	
			if(_hashAnimCheckTimeout) {
				clearTimeout(_hashAnimCheckTimeout);
			}
		},
	
		// pid - Picture index
		// gid - Gallery index
		_parseItemIndexFromURL = function() {
			var hash = _getHash(),
				params = {};
	
			if(hash.length < 5) { // pid=1
				return params;
			}
	
			var i, vars = hash.split('&');
			for (i = 0; i < vars.length; i++) {
				if(!vars[i]) {
					continue;
				}
				var pair = vars[i].split('=');	
				if(pair.length < 2) {
					continue;
				}
				params[pair[0]] = pair[1];
			}
			if(_options.galleryPIDs) {
				// detect custom pid in hash and search for it among the items collection
				var searchfor = params.pid;
				params.pid = 0; // if custom pid cannot be found, fallback to the first item
				for(i = 0; i < _items.length; i++) {
					if(_items[i].pid === searchfor) {
						params.pid = i;
						break;
					}
				}
			} else {
				params.pid = parseInt(params.pid,10)-1;
			}
			if( params.pid < 0 ) {
				params.pid = 0;
			}
			return params;
		},
		_updateHash = function() {
	
			if(_hashAnimCheckTimeout) {
				clearTimeout(_hashAnimCheckTimeout);
			}
	
	
			if(_numAnimations || _isDragging) {
				// changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
				// that's why we update hash only when no animations running
				_hashAnimCheckTimeout = setTimeout(_updateHash, 500);
				return;
			}
			
			if(_hashChangedByScript) {
				clearTimeout(_hashChangeTimeout);
			} else {
				_hashChangedByScript = true;
			}
	
	
			var pid = (_currentItemIndex + 1);
			var item = _getItemAt( _currentItemIndex );
			if(item.hasOwnProperty('pid')) {
				// carry forward any custom pid assigned to the item
				pid = item.pid;
			}
			var newHash = _initialHash + '&'  +  'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
	
			if(!_historyChanged) {
				if(_windowLoc.hash.indexOf(newHash) === -1) {
					_urlChangedOnce = true;
				}
				// first time - add new hisory record, then just replace
			}
	
			var newURL = _windowLoc.href.split('#')[0] + '#' +  newHash;
	
			if( _supportsPushState ) {
	
				if('#' + newHash !== window.location.hash) {
					history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
				}
	
			} else {
				if(_historyChanged) {
					_windowLoc.replace( newURL );
				} else {
					_windowLoc.hash = newHash;
				}
			}
			
			
	
			_historyChanged = true;
			_hashChangeTimeout = setTimeout(function() {
				_hashChangedByScript = false;
			}, 60);
		};
	
	
	
		
	
	_registerModule('History', {
	
		
	
		publicMethods: {
			initHistory: function() {
	
				framework.extend(_options, _historyDefaultOptions, true);
	
				if( !_options.history ) {
					return;
				}
	
	
				_windowLoc = window.location;
				_urlChangedOnce = false;
				_closedFromURL = false;
				_historyChanged = false;
				_initialHash = _getHash();
				_supportsPushState = ('pushState' in history);
	
	
				if(_initialHash.indexOf('gid=') > -1) {
					_initialHash = _initialHash.split('&gid=')[0];
					_initialHash = _initialHash.split('?gid=')[0];
				}
				
	
				_listen('afterChange', self.updateURL);
				_listen('unbindEvents', function() {
					framework.unbind(window, 'hashchange', self.onHashChange);
				});
	
	
				var returnToOriginal = function() {
					_hashReseted = true;
					if(!_closedFromURL) {
	
						if(_urlChangedOnce) {
							history.back();
						} else {
	
							if(_initialHash) {
								_windowLoc.hash = _initialHash;
							} else {
								if (_supportsPushState) {
	
									// remove hash from url without refreshing it or scrolling to top
									history.pushState('', document.title,  _windowLoc.pathname + _windowLoc.search );
								} else {
									_windowLoc.hash = '';
								}
							}
						}
						
					}
	
					_cleanHistoryTimeouts();
				};
	
	
				_listen('unbindEvents', function() {
					if(_closedByScroll) {
						// if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
						// this is done to keep the scroll position
						returnToOriginal();
					}
				});
				_listen('destroy', function() {
					if(!_hashReseted) {
						returnToOriginal();
					}
				});
				_listen('firstUpdate', function() {
					_currentItemIndex = _parseItemIndexFromURL().pid;
				});
	
				
	
				
				var index = _initialHash.indexOf('pid=');
				if(index > -1) {
					_initialHash = _initialHash.substring(0, index);
					if(_initialHash.slice(-1) === '&') {
						_initialHash = _initialHash.slice(0, -1);
					}
				}
				
	
				setTimeout(function() {
					if(_isOpen) { // hasn't destroyed yet
						framework.bind(window, 'hashchange', self.onHashChange);
					}
				}, 40);
				
			},
			onHashChange: function() {
	
				if(_getHash() === _initialHash) {
	
					_closedFromURL = true;
					self.close();
					return;
				}
				if(!_hashChangedByScript) {
	
					_hashChangedByHistory = true;
					self.goTo( _parseItemIndexFromURL().pid );
					_hashChangedByHistory = false;
				}
				
			},
			updateURL: function() {
	
				// Delay the update of URL, to avoid lag during transition, 
				// and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
				
				_cleanHistoryTimeouts();
				
	
				if(_hashChangedByHistory) {
					return;
				}
	
				if(!_historyChanged) {
					_updateHash(); // first time
				} else {
					_historyUpdateTimeout = setTimeout(_updateHash, 800);
				}
			}
		
		}
	});
	
	
	/*>>history*/
		framework.extend(self, publicMethods); };
		return PhotoSwipe;
	});

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(429);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(194);
	var assign = __webpack_require__(19);
	
	var ReactPropTypesSecret = __webpack_require__(429);
	var checkPropTypes = __webpack_require__(1049);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1052);
	exports.encode = exports.stringify = __webpack_require__(1053);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(32));
		else if(typeof define === 'function' && define.amd)
			define(["React", "ReactDOM"], factory);
		else if(typeof exports === 'object')
			exports["react-anything-sortable"] = factory(require("react"), require("react-dom"));
		else
			root["react-anything-sortable"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_15__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * @file react-anything-sortable
		 * @author jasonslyvia
		 */
	
		/* eslint new-cap:0, consistent-return: 0, react/prefer-es6-class: 0, react/sort-comp: 0 */
		/**
		 * @dependency
		 */
		'use strict';
	
		exports.__esModule = true;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _createReactClass = __webpack_require__(11);
	
		var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
		var _reactDom = __webpack_require__(15);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _utils = __webpack_require__(16);
	
		var _SortableItemMixin = __webpack_require__(17);
	
		var _SortableItemMixin2 = _interopRequireDefault(_SortableItemMixin);
	
		var doc = typeof window === 'object' ? window.document : {};
	
		var STACK_SIZE = 6;
		var getSortTarget = function getSortTarget(child) {
		  // `onSortableItemReadyToMove` only exist when using mixins or decorators
		  return child && child.props && _utils.isFunction(child.props.onSortableItemReadyToMove);
		};
	
		/**
		 * @class Sortable
		 */
		var Sortable = _createReactClass2['default']({
		  propTypes: {
		    /**
		     * callback fires after sort operation finish
		     * function (dataSet){
		     *   //dataSet sorted
		     * }
		     */
		    onSort: _propTypes2['default'].func,
		    className: _propTypes2['default'].string,
		    sortHandle: _propTypes2['default'].string,
		    containment: _propTypes2['default'].bool,
		    dynamic: _propTypes2['default'].bool,
		    direction: _propTypes2['default'].string,
		    children: _propTypes2['default'].arrayOf(_propTypes2['default'].node)
		  },
	
		  setArrays: function setArrays(currentChildren) {
		    var children = Array.isArray(currentChildren) ? currentChildren : [currentChildren];
	
		    var sortChildren = children.filter(getSortTarget);
		    this.sortChildren = sortChildren;
	
		    // keep tracking the dimension and coordinates of all children
		    this._dimensionArr = sortChildren.map(function () {
		      return {};
		    });
	
		    // keep tracking the order of all children
		    this._orderArr = [];
		    var i = 0;
		    while (i < this._dimensionArr.length) {
		      this._orderArr.push(i++);
		    }
		  },
	
		  getInitialState: function getInitialState() {
		    this.setArrays(this.props.children);
	
		    return {
		      isDragging: false,
		      placeHolderIndex: null,
		      left: null,
		      top: null
		    };
		  },
	
		  componentDidUpdate: function componentDidUpdate() {
		    var container = _reactDom2['default'].findDOMNode(this);
		    var rect = container.getBoundingClientRect();
	
		    var scrollTop = doc.documentElement && doc.documentElement.scrollTop || doc.body.scrollTop;
		    var scrollLeft = doc.documentElement && doc.documentElement.scrollLeft || doc.body.scrollLeft;
	
		    this._top = rect.top + scrollTop;
		    this._left = rect.left + scrollLeft;
		    this._bottom = this._top + rect.height;
		    this._right = this._left + rect.width;
		  },
	
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    var _props = this.props;
		    var children = _props.children;
		    var dynamic = _props.dynamic;
	
		    if (dynamic && nextProps.children !== children) {
		      this.setArrays(nextProps.children);
		    }
		  },
	
		  componentWillUnmount: function componentWillUnmount() {
		    this.unbindEvent();
		  },
	
		  bindEvent: function bindEvent() {
		    var _this = this;
	
		    // so that the focus won't be lost if cursor moving too fast
		    this.__mouseMoveHandler = function (e) {
		      /**
		       * Since Chrome may trigger redundant mousemove event evne if
		       * we didn't really move the mouse, we should make sure that
		       * mouse coordinates really changed then respond to mousemove
		       * event
		       * @see https://code.google.com/p/chromium/issues/detail?id=327114
		       */
		      if ((e.pageX || e.clientX) === _this._prevX && (e.pageY || e.clientY) === _this._prevY || _this._prevX === null && _this._prevY === null) {
		        return false;
		      }
	
		      _this.handleMouseMove.call(_this, e);
		    };
	
		    this.__mouseUpHandler = function (e) {
		      _this.handleMouseUp.call(_this, e);
		    };
	
		    this.__touchMoveHandler = function (e) {
		      // blocks the default scrolling as we sort an element
		      e.preventDefault();
	
		      _this.handleMouseMove.call(_this, {
		        target: e.target,
		        clientX: e.touches[0].clientX,
		        clientY: e.touches[0].clientY,
		        pageX: e.touches[0].pageX,
		        pageY: e.touches[0].pageY
		      });
		    };
	
		    this.__touchEndOrCancelHandler = function (e) {
		      _this.handleMouseUp.call(_this, e);
		    };
	
		    _utils.on(doc, 'touchmove', this.__touchMoveHandler);
		    _utils.on(doc, 'touchend', this.__touchEndOrCancelHandler);
		    _utils.on(doc, 'touchcancel', this.__touchEndOrCancelHandler);
		    _utils.on(doc, 'mousemove', this.__mouseMoveHandler);
		    _utils.on(doc, 'mouseup', this.__mouseUpHandler);
		  },
	
		  unbindEvent: function unbindEvent() {
		    _utils.off(doc, 'touchmove', this.__touchMoveHandler);
		    _utils.off(doc, 'touchend', this.__touchEndOrCancelHandler);
		    _utils.off(doc, 'touchcancel', this.__touchEndOrCancelHandler);
		    _utils.off(doc, 'mousemove', this.__mouseMoveHandler);
		    _utils.off(doc, 'mouseup', this.__mouseUpHandler);
	
		    this.__mouseMoveHandler = null;
		    this.__mouseUpHandler = null;
		    this.__touchMoveHandler = null;
		    this.__touchEndOrCancelHandler = null;
		  },
	
		  /**
		   * getting ready for dragging
		   * @param  {object} e     React event
		   * @param  {index} index of pre-dragging item
		   */
		  handleMouseDown: function handleMouseDown(e, index) {
		    this._draggingIndex = index;
		    this._prevX = e.pageX || e.clientX;
		    this._prevY = e.pageY || e.clientY;
		    this._initOffset = e.offset;
		    this._isReadyForDragging = true;
		    this._hasInitDragging = false;
	
		    // start listening mousemove and mouseup
		    this.bindEvent();
		  },
	
		  /**
		   * `add` a dragging item and re-calculating position of placeholder
		   * @param  {object} e     React event
		   */
		  handleMouseMove: function handleMouseMove(e) {
		    this._isMouseMoving = true;
	
		    if (!this._isReadyForDragging) {
		      return false;
		    }
	
		    if (!this._hasInitDragging) {
		      this._dimensionArr[this._draggingIndex].isPlaceHolder = true;
		      this._hasInitDragging = true;
		    }
	
		    if (this.props.containment) {
		      var x = e.pageX || e.clientX;
		      var y = e.pageY || e.clientY;
	
		      if (x < this._left || x > this._right || y < this._top || y > this._bottom) {
		        return false;
		      }
		    }
	
		    var newOffset = this.calculateNewOffset(e);
		    var newIndex = this.calculateNewIndex(e);
	
		    this._draggingIndex = newIndex;
	
		    this.setState({
		      isDragging: true,
		      top: this.props.direction === 'horizontal' ? this._initOffset.top : newOffset.top,
		      left: this.props.direction === 'vertical' ? this._initOffset.left : newOffset.left,
		      placeHolderIndex: newIndex
		    });
	
		    this._prevX = e.pageX || e.clientX;
		    this._prevY = e.pageY || e.clientY;
		  },
	
		  /**
		   * replace placeholder with dragging item
		   */
		  handleMouseUp: function handleMouseUp() {
		    var _hasMouseMoved = this._isMouseMoving;
		    this.unbindEvent();
	
		    var draggingIndex = this._draggingIndex;
		    // reset temp lets
		    this._draggingIndex = null;
		    this._isReadyForDragging = false;
		    this._isMouseMoving = false;
		    this._initOffset = null;
		    this._prevX = null;
		    this._prevY = null;
	
		    if (this.state.isDragging) {
		      this._dimensionArr[this.state.placeHolderIndex].isPlaceHolder = false;
	
		      if (_hasMouseMoved) {
		        this.setState({
		          isDragging: false,
		          placeHolderIndex: null,
		          left: null,
		          top: null
		        });
		      }
	
		      // sort finished, callback fires
		      if (_utils.isFunction(this.props.onSort)) {
		        var sortData = this.getSortData();
		        this.props.onSort(sortData, sortData[draggingIndex], draggingIndex);
		      }
		    }
		  },
	
		  /**
		   * when children mounted, return its size(handled by SortableItemMixin)
		   * @param  {object} offset {top:1, left:2}
		   * @param  {number} width
		   * @param  {number} height
		   * @param  {number} fullWidth  (with margin)
		   * @param  {number} fullHeight (with margin)
		   * @param  {number} index
		   */
		  handleChildUpdate: function handleChildUpdate(offset, width, height, fullWidth, fullHeight, index) {
		    _utils.assign(this._dimensionArr[index], {
		      top: offset.top,
		      left: offset.left,
		      width: width,
		      height: height,
		      fullWidth: fullWidth,
		      fullHeight: fullHeight
		    });
		  },
	
		  /**
		   * get new index of all items by cursor position
		   * @param {object} offset {left: 12, top: 123}
		   * @param {string} direction cursor moving direction, used to aviod blinking when
		   *                 interchanging position of different width elements
		   * @return {number}
		   */
		  getIndexByOffset: function getIndexByOffset(offset, direction) {
		    if (!offset || !_utils.isNumeric(offset.top) || !_utils.isNumeric(offset.left)) {
		      return 0;
		    }
	
		    var _dimensionArr = this._dimensionArr;
		    var offsetX = offset.left;
		    var offsetY = offset.top;
		    var prevIndex = this.state.placeHolderIndex !== null ? this.state.placeHolderIndex : this._draggingIndex;
		    var newIndex = undefined;
	
		    _dimensionArr.every(function (item, index) {
		      var relativeLeft = offsetX - item.left;
		      var relativeTop = offsetY - item.top;
	
		      if (relativeLeft < item.fullWidth && relativeTop < item.fullHeight) {
		        if (relativeLeft < item.fullWidth / 2 && direction === 'left') {
		          newIndex = index;
		        } else if (relativeLeft > item.fullWidth / 2 && direction === 'right') {
		          newIndex = Math.min(index + 1, _dimensionArr.length - 1);
		        } else if (relativeTop < item.fullHeight / 2 && direction === 'up') {
		          newIndex = index;
		        } else if (relativeTop > item.fullHeight / 2 && direction === 'down') {
		          newIndex = Math.min(index + 1, _dimensionArr.length - 1);
		        } else {
		          return true;
		        }
	
		        return false;
		      }
		      return true;
		    });
	
		    return newIndex !== undefined ? newIndex : prevIndex;
		  },
	
		  /**
		   * untility function
		   * @param  {array} arr
		   * @param  {number} src
		   * @param  {number} to
		   * @return {array}
		   */
		  swapArrayItemPosition: function swapArrayItemPosition(arr, src, to) {
		    if (!arr || !_utils.isNumeric(src) || !_utils.isNumeric(to)) {
		      return arr;
		    }
	
		    var srcEl = arr.splice(src, 1)[0];
		    arr.splice(to, 0, srcEl);
		    return arr;
		  },
	
		  /**
		   * calculate new offset
		   * @param  {object} e MouseMove event
		   * @return {object}   {left: 1, top: 1}
		   */
		  calculateNewOffset: function calculateNewOffset(e) {
		    var deltaX = this._prevX - (e.pageX || e.clientX);
		    var deltaY = this._prevY - (e.pageY || e.clientY);
	
		    var prevLeft = this.state.left !== null ? this.state.left : this._initOffset.left;
		    var prevTop = this.state.top !== null ? this.state.top : this._initOffset.top;
		    var newLeft = prevLeft - deltaX;
		    var newTop = prevTop - deltaY;
	
		    return {
		      left: newLeft,
		      top: newTop
		    };
		  },
	
		  /**
		   * calculate new index and do swapping
		   * @param  {object} e MouseMove event
		   * @return {number}
		   */
		  calculateNewIndex: function calculateNewIndex(e) {
		    var placeHolderIndex = this.state.placeHolderIndex !== null ? this.state.placeHolderIndex : this._draggingIndex;
	
		    // Since `mousemove` is listened on document, when cursor move too fast,
		    // `e.target` may be `body` or some other stuff instead of
		    // `.ui-sortable-item`
		    var target = _utils.get('.ui-sortable-dragging') || _utils.closest(e.target || e.srcElement, '.ui-sortable-item');
		    var offset = _utils.position(target);
	
		    var currentX = e.pageX || e.clientX;
		    var currentY = e.pageY || e.clientY;
	
		    var deltaX = Math.abs(this._prevX - currentX);
		    var deltaY = Math.abs(this._prevY - currentY);
	
		    var direction = undefined;
		    if (deltaX > deltaY) {
		      // tend to move left/right
		      direction = this._prevX > currentX ? 'left' : 'right';
		    } else {
		      // tend to move up/down
		      direction = this._prevY > currentY ? 'up' : 'down';
		    }
	
		    var newIndex = this.getIndexByOffset(offset, this.getPossibleDirection(direction));
		    if (newIndex !== placeHolderIndex) {
		      this._dimensionArr = this.swapArrayItemPosition(this._dimensionArr, placeHolderIndex, newIndex);
		      this._orderArr = this.swapArrayItemPosition(this._orderArr, placeHolderIndex, newIndex);
		    }
	
		    return newIndex;
		  },
	
		  getSortData: function getSortData() {
		    var _this2 = this;
	
		    return this._orderArr.map(function (itemIndex) {
		      var item = _this2.sortChildren[itemIndex];
		      if (!item) {
		        return undefined;
		      }
	
		      return item.props.sortData;
		    });
		  },
	
		  getPossibleDirection: function getPossibleDirection(direction) {
		    this._stack = this._stack || [];
		    this._stack.push(direction);
		    if (this._stack.length > STACK_SIZE) {
		      this._stack.shift();
		    }
	
		    if (this._stack.length < STACK_SIZE) {
		      return direction;
		    }
	
		    return _utils.findMostOften(this._stack);
		  },
	
		  /**
		   * render all sortable children which mixined with SortableItemMixin
		   */
		  renderItems: function renderItems() {
		    var _this3 = this;
	
		    var _dimensionArr = this._dimensionArr;
		    var _orderArr = this._orderArr;
	
		    var draggingItem = undefined;
	
		    var items = _orderArr.map(function (itemIndex, index) {
		      var item = _this3.sortChildren[itemIndex];
		      if (!item) {
		        return;
		      }
	
		      if (index === _this3._draggingIndex && _this3.state.isDragging) {
		        draggingItem = _this3.renderDraggingItem(item);
		      }
	
		      var isPlaceHolder = _dimensionArr[index].isPlaceHolder;
		      var itemClassName = 'ui-sortable-item\n                             ' + (isPlaceHolder && 'ui-sortable-placeholder') + '\n                             ' + (_this3.state.isDragging && isPlaceHolder && 'visible');
	
		      var sortableProps = {
		        sortableClassName: item.props.className + ' ' + itemClassName,
		        sortableIndex: index,
		        onSortableItemReadyToMove: isPlaceHolder ? undefined : function (e) {
		          _this3.handleMouseDown.call(_this3, e, index);
		        },
		        onSortableItemMount: _this3.handleChildUpdate,
		        sortHandle: _this3.props.sortHandle
		      };
	
		      if (item.key === undefined) {
		        sortableProps.key = index;
		      }
	
		      return _react2['default'].cloneElement(item, sortableProps);
		    });
	
		    var children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
	
		    var result = children.map(function (child) {
		      if (getSortTarget(child)) {
		        return items.shift();
		      }
		      return child;
		    }).concat([draggingItem]);
	
		    return result;
		  },
	
		  /**
		   * render the item that being dragged
		   * @param  {object} item a reference of this.props.children
		   */
		  renderDraggingItem: function renderDraggingItem(item) {
		    if (!item) {
		      return;
		    }
	
		    var style = {
		      top: this.state.top,
		      left: this.state.left,
		      width: this._dimensionArr[this._draggingIndex].width,
		      height: this._dimensionArr[this._draggingIndex].height
		    };
		    return _react2['default'].cloneElement(item, {
		      sortableClassName: item.props.className + ' ui-sortable-item ui-sortable-dragging',
		      key: '_dragging',
		      sortableStyle: style,
		      isDragging: true,
		      sortHandle: this.props.sortHandle
		    });
		  },
	
		  render: function render() {
		    var className = 'ui-sortable ' + (this.props.className || '');
	
		    return _react2['default'].createElement(
		      'div',
		      { className: className },
		      this.renderItems()
		    );
		  }
		});
	
		var SortableContainer = function SortableContainer(_ref) {
		  var className = _ref.className;
		  var style = _ref.style;
		  var onMouseDown = _ref.onMouseDown;
		  var onTouchStart = _ref.onTouchStart;
		  var children = _ref.children;
	
		  if (_react2['default'].isValidElement(children)) {
		    return _react2['default'].cloneElement(children, {
		      className: className, style: style, onMouseDown: onMouseDown, onTouchStart: onTouchStart
		    });
		  } else {
		    return _react2['default'].createElement('div', {
		      className: className, style: style, onMouseDown: onMouseDown, onTouchStart: onTouchStart, children: children
		    });
		  }
		};
	
		Sortable.SortableItemMixin = _SortableItemMixin2['default']();
		Sortable.sortable = _SortableItemMixin2['default'];
		Sortable.SortableContainer = _SortableItemMixin2['default'](SortableContainer);
	
		exports['default'] = Sortable;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (process.env.NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(4)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(10)();
		}
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
	
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
	
		var cachedSetTimeout;
		var cachedClearTimeout;
	
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
	
	
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
	
	
	
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
	
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
	
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
	
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
	
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
	
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
	
		function noop() {}
	
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
	
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
	
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		var warning = __webpack_require__(7);
	
		var ReactPropTypesSecret = __webpack_require__(8);
		var checkPropTypes = __webpack_require__(9);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (process.env.NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (process.env.NODE_ENV !== 'production') {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		if (process.env.NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(6);
		  var warning = __webpack_require__(7);
		  var ReactPropTypesSecret = __webpack_require__(8);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (process.env.NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
	
		module.exports = function() {
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  function shim() {
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var React = __webpack_require__(1);
		var factory = __webpack_require__(12);
	
		// Hack to grab NoopUpdateQueue from isomorphic React
		var ReactNoopUpdateQueue = new React.Component().updater;
	
		module.exports = factory(
		  React.Component,
		  React.isValidElement,
		  ReactNoopUpdateQueue
		);
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(13);
	
		var emptyObject = __webpack_require__(14);
		var _invariant = __webpack_require__(6);
	
		if (process.env.NODE_ENV !== 'production') {
		  var warning = __webpack_require__(7);
		}
	
		var MIXINS_KEY = 'mixins';
	
		// Helper function to allow the creation of anonymous functions which do not
		// have .name set to the name of the variable being assigned to.
		function identity(fn) {
		  return fn;
		}
	
		var ReactPropTypeLocationNames;
		if (process.env.NODE_ENV !== 'production') {
		  ReactPropTypeLocationNames = {
		    prop: 'prop',
		    context: 'context',
		    childContext: 'child context',
		  };
		} else {
		  ReactPropTypeLocationNames = {};
		}
	
		function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
		  /**
		   * Policies that describe methods in `ReactClassInterface`.
		   */
	
	
		  var injectedMixins = [];
	
		  /**
		   * Composite components are higher-level components that compose other composite
		   * or host components.
		   *
		   * To create a new type of `ReactClass`, pass a specification of
		   * your new class to `React.createClass`. The only requirement of your class
		   * specification is that you implement a `render` method.
		   *
		   *   var MyComponent = React.createClass({
		   *     render: function() {
		   *       return <div>Hello World</div>;
		   *     }
		   *   });
		   *
		   * The class specification supports a specific protocol of methods that have
		   * special meaning (e.g. `render`). See `ReactClassInterface` for
		   * more the comprehensive protocol. Any other properties and methods in the
		   * class specification will be available on the prototype.
		   *
		   * @interface ReactClassInterface
		   * @internal
		   */
		  var ReactClassInterface = {
	
		    /**
		     * An array of Mixin objects to include when defining your component.
		     *
		     * @type {array}
		     * @optional
		     */
		    mixins: 'DEFINE_MANY',
	
		    /**
		     * An object containing properties and methods that should be defined on
		     * the component's constructor instead of its prototype (static methods).
		     *
		     * @type {object}
		     * @optional
		     */
		    statics: 'DEFINE_MANY',
	
		    /**
		     * Definition of prop types for this component.
		     *
		     * @type {object}
		     * @optional
		     */
		    propTypes: 'DEFINE_MANY',
	
		    /**
		     * Definition of context types for this component.
		     *
		     * @type {object}
		     * @optional
		     */
		    contextTypes: 'DEFINE_MANY',
	
		    /**
		     * Definition of context types this component sets for its children.
		     *
		     * @type {object}
		     * @optional
		     */
		    childContextTypes: 'DEFINE_MANY',
	
		    // ==== Definition methods ====
	
		    /**
		     * Invoked when the component is mounted. Values in the mapping will be set on
		     * `this.props` if that prop is not specified (i.e. using an `in` check).
		     *
		     * This method is invoked before `getInitialState` and therefore cannot rely
		     * on `this.state` or use `this.setState`.
		     *
		     * @return {object}
		     * @optional
		     */
		    getDefaultProps: 'DEFINE_MANY_MERGED',
	
		    /**
		     * Invoked once before the component is mounted. The return value will be used
		     * as the initial value of `this.state`.
		     *
		     *   getInitialState: function() {
		     *     return {
		     *       isOn: false,
		     *       fooBaz: new BazFoo()
		     *     }
		     *   }
		     *
		     * @return {object}
		     * @optional
		     */
		    getInitialState: 'DEFINE_MANY_MERGED',
	
		    /**
		     * @return {object}
		     * @optional
		     */
		    getChildContext: 'DEFINE_MANY_MERGED',
	
		    /**
		     * Uses props from `this.props` and state from `this.state` to render the
		     * structure of the component.
		     *
		     * No guarantees are made about when or how often this method is invoked, so
		     * it must not have side effects.
		     *
		     *   render: function() {
		     *     var name = this.props.name;
		     *     return <div>Hello, {name}!</div>;
		     *   }
		     *
		     * @return {ReactComponent}
		     * @nosideeffects
		     * @required
		     */
		    render: 'DEFINE_ONCE',
	
		    // ==== Delegate methods ====
	
		    /**
		     * Invoked when the component is initially created and about to be mounted.
		     * This may have side effects, but any external subscriptions or data created
		     * by this method must be cleaned up in `componentWillUnmount`.
		     *
		     * @optional
		     */
		    componentWillMount: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component has been mounted and has a DOM representation.
		     * However, there is no guarantee that the DOM node is in the document.
		     *
		     * Use this as an opportunity to operate on the DOM when the component has
		     * been mounted (initialized and rendered) for the first time.
		     *
		     * @param {DOMElement} rootNode DOM element representing the component.
		     * @optional
		     */
		    componentDidMount: 'DEFINE_MANY',
	
		    /**
		     * Invoked before the component receives new props.
		     *
		     * Use this as an opportunity to react to a prop transition by updating the
		     * state using `this.setState`. Current props are accessed via `this.props`.
		     *
		     *   componentWillReceiveProps: function(nextProps, nextContext) {
		     *     this.setState({
		     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
		     *     });
		     *   }
		     *
		     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
		     * transition may cause a state change, but the opposite is not true. If you
		     * need it, you are probably looking for `componentWillUpdate`.
		     *
		     * @param {object} nextProps
		     * @optional
		     */
		    componentWillReceiveProps: 'DEFINE_MANY',
	
		    /**
		     * Invoked while deciding if the component should be updated as a result of
		     * receiving new props, state and/or context.
		     *
		     * Use this as an opportunity to `return false` when you're certain that the
		     * transition to the new props/state/context will not require a component
		     * update.
		     *
		     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
		     *     return !equal(nextProps, this.props) ||
		     *       !equal(nextState, this.state) ||
		     *       !equal(nextContext, this.context);
		     *   }
		     *
		     * @param {object} nextProps
		     * @param {?object} nextState
		     * @param {?object} nextContext
		     * @return {boolean} True if the component should update.
		     * @optional
		     */
		    shouldComponentUpdate: 'DEFINE_ONCE',
	
		    /**
		     * Invoked when the component is about to update due to a transition from
		     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
		     * and `nextContext`.
		     *
		     * Use this as an opportunity to perform preparation before an update occurs.
		     *
		     * NOTE: You **cannot** use `this.setState()` in this method.
		     *
		     * @param {object} nextProps
		     * @param {?object} nextState
		     * @param {?object} nextContext
		     * @param {ReactReconcileTransaction} transaction
		     * @optional
		     */
		    componentWillUpdate: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component's DOM representation has been updated.
		     *
		     * Use this as an opportunity to operate on the DOM when the component has
		     * been updated.
		     *
		     * @param {object} prevProps
		     * @param {?object} prevState
		     * @param {?object} prevContext
		     * @param {DOMElement} rootNode DOM element representing the component.
		     * @optional
		     */
		    componentDidUpdate: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component is about to be removed from its parent and have
		     * its DOM representation destroyed.
		     *
		     * Use this as an opportunity to deallocate any external resources.
		     *
		     * NOTE: There is no `componentDidUnmount` since your component will have been
		     * destroyed by that point.
		     *
		     * @optional
		     */
		    componentWillUnmount: 'DEFINE_MANY',
	
		    // ==== Advanced methods ====
	
		    /**
		     * Updates the component's currently mounted DOM representation.
		     *
		     * By default, this implements React's rendering and reconciliation algorithm.
		     * Sophisticated clients may wish to override this.
		     *
		     * @param {ReactReconcileTransaction} transaction
		     * @internal
		     * @overridable
		     */
		    updateComponent: 'OVERRIDE_BASE'
	
		  };
	
		  /**
		   * Mapping from class specification keys to special processing functions.
		   *
		   * Although these are declared like instance properties in the specification
		   * when defining classes using `React.createClass`, they are actually static
		   * and are accessible on the constructor instead of the prototype. Despite
		   * being static, they must be defined outside of the "statics" key under
		   * which all other static methods are defined.
		   */
		  var RESERVED_SPEC_KEYS = {
		    displayName: function (Constructor, displayName) {
		      Constructor.displayName = displayName;
		    },
		    mixins: function (Constructor, mixins) {
		      if (mixins) {
		        for (var i = 0; i < mixins.length; i++) {
		          mixSpecIntoComponent(Constructor, mixins[i]);
		        }
		      }
		    },
		    childContextTypes: function (Constructor, childContextTypes) {
		      if (process.env.NODE_ENV !== 'production') {
		        validateTypeDef(Constructor, childContextTypes, 'childContext');
		      }
		      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
		    },
		    contextTypes: function (Constructor, contextTypes) {
		      if (process.env.NODE_ENV !== 'production') {
		        validateTypeDef(Constructor, contextTypes, 'context');
		      }
		      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
		    },
		    /**
		     * Special case getDefaultProps which should move into statics but requires
		     * automatic merging.
		     */
		    getDefaultProps: function (Constructor, getDefaultProps) {
		      if (Constructor.getDefaultProps) {
		        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
		      } else {
		        Constructor.getDefaultProps = getDefaultProps;
		      }
		    },
		    propTypes: function (Constructor, propTypes) {
		      if (process.env.NODE_ENV !== 'production') {
		        validateTypeDef(Constructor, propTypes, 'prop');
		      }
		      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
		    },
		    statics: function (Constructor, statics) {
		      mixStaticSpecIntoComponent(Constructor, statics);
		    },
		    autobind: function () {} };
	
		  function validateTypeDef(Constructor, typeDef, location) {
		    for (var propName in typeDef) {
		      if (typeDef.hasOwnProperty(propName)) {
		        // use a warning instead of an _invariant so components
		        // don't show up in prod but only in __DEV__
		        process.env.NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
		      }
		    }
		  }
	
		  function validateMethodOverride(isAlreadyDefined, name) {
		    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
		    // Disallow overriding of base class methods unless explicitly allowed.
		    if (ReactClassMixin.hasOwnProperty(name)) {
		      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
		    }
	
		    // Disallow defining methods more than once unless explicitly allowed.
		    if (isAlreadyDefined) {
		      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
		    }
		  }
	
		  /**
		   * Mixin helper which handles policy validation and reserved
		   * specification keys when building React classes.
		   */
		  function mixSpecIntoComponent(Constructor, spec) {
		    if (!spec) {
		      if (process.env.NODE_ENV !== 'production') {
		        var typeofSpec = typeof spec;
		        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
		        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
		      }
	
		      return;
		    }
	
		    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
		    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
		    var proto = Constructor.prototype;
		    var autoBindPairs = proto.__reactAutoBindPairs;
	
		    // By handling mixins before any other properties, we ensure the same
		    // chaining order is applied to methods with DEFINE_MANY policy, whether
		    // mixins are listed before or after these methods in the spec.
		    if (spec.hasOwnProperty(MIXINS_KEY)) {
		      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
		    }
	
		    for (var name in spec) {
		      if (!spec.hasOwnProperty(name)) {
		        continue;
		      }
	
		      if (name === MIXINS_KEY) {
		        // We have already handled mixins in a special case above.
		        continue;
		      }
	
		      var property = spec[name];
		      var isAlreadyDefined = proto.hasOwnProperty(name);
		      validateMethodOverride(isAlreadyDefined, name);
	
		      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
		        RESERVED_SPEC_KEYS[name](Constructor, property);
		      } else {
		        // Setup methods on prototype:
		        // The following member methods should not be automatically bound:
		        // 1. Expected ReactClass methods (in the "interface").
		        // 2. Overridden methods (that were mixed in).
		        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
		        var isFunction = typeof property === 'function';
		        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
		        if (shouldAutoBind) {
		          autoBindPairs.push(name, property);
		          proto[name] = property;
		        } else {
		          if (isAlreadyDefined) {
		            var specPolicy = ReactClassInterface[name];
	
		            // These cases should already be caught by validateMethodOverride.
		            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
		            // For methods which are defined more than once, call the existing
		            // methods before calling the new property, merging if appropriate.
		            if (specPolicy === 'DEFINE_MANY_MERGED') {
		              proto[name] = createMergedResultFunction(proto[name], property);
		            } else if (specPolicy === 'DEFINE_MANY') {
		              proto[name] = createChainedFunction(proto[name], property);
		            }
		          } else {
		            proto[name] = property;
		            if (process.env.NODE_ENV !== 'production') {
		              // Add verbose displayName to the function, which helps when looking
		              // at profiling tools.
		              if (typeof property === 'function' && spec.displayName) {
		                proto[name].displayName = spec.displayName + '_' + name;
		              }
		            }
		          }
		        }
		      }
		    }
		  }
	
		  function mixStaticSpecIntoComponent(Constructor, statics) {
		    if (!statics) {
		      return;
		    }
		    for (var name in statics) {
		      var property = statics[name];
		      if (!statics.hasOwnProperty(name)) {
		        continue;
		      }
	
		      var isReserved = name in RESERVED_SPEC_KEYS;
		      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
		      var isInherited = name in Constructor;
		      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
		      Constructor[name] = property;
		    }
		  }
	
		  /**
		   * Merge two objects, but throw if both contain the same key.
		   *
		   * @param {object} one The first object, which is mutated.
		   * @param {object} two The second object
		   * @return {object} one after it has been mutated to contain everything in two.
		   */
		  function mergeIntoWithNoDuplicateKeys(one, two) {
		    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
		    for (var key in two) {
		      if (two.hasOwnProperty(key)) {
		        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
		        one[key] = two[key];
		      }
		    }
		    return one;
		  }
	
		  /**
		   * Creates a function that invokes two functions and merges their return values.
		   *
		   * @param {function} one Function to invoke first.
		   * @param {function} two Function to invoke second.
		   * @return {function} Function that invokes the two argument functions.
		   * @private
		   */
		  function createMergedResultFunction(one, two) {
		    return function mergedResult() {
		      var a = one.apply(this, arguments);
		      var b = two.apply(this, arguments);
		      if (a == null) {
		        return b;
		      } else if (b == null) {
		        return a;
		      }
		      var c = {};
		      mergeIntoWithNoDuplicateKeys(c, a);
		      mergeIntoWithNoDuplicateKeys(c, b);
		      return c;
		    };
		  }
	
		  /**
		   * Creates a function that invokes two functions and ignores their return vales.
		   *
		   * @param {function} one Function to invoke first.
		   * @param {function} two Function to invoke second.
		   * @return {function} Function that invokes the two argument functions.
		   * @private
		   */
		  function createChainedFunction(one, two) {
		    return function chainedFunction() {
		      one.apply(this, arguments);
		      two.apply(this, arguments);
		    };
		  }
	
		  /**
		   * Binds a method to the component.
		   *
		   * @param {object} component Component whose method is going to be bound.
		   * @param {function} method Method to be bound.
		   * @return {function} The bound method.
		   */
		  function bindAutoBindMethod(component, method) {
		    var boundMethod = method.bind(component);
		    if (process.env.NODE_ENV !== 'production') {
		      boundMethod.__reactBoundContext = component;
		      boundMethod.__reactBoundMethod = method;
		      boundMethod.__reactBoundArguments = null;
		      var componentName = component.constructor.displayName;
		      var _bind = boundMethod.bind;
		      boundMethod.bind = function (newThis) {
		        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		          args[_key - 1] = arguments[_key];
		        }
	
		        // User is trying to bind() an autobound method; we effectively will
		        // ignore the value of "this" that the user is trying to use, so
		        // let's warn.
		        if (newThis !== component && newThis !== null) {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
		        } else if (!args.length) {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
		          return boundMethod;
		        }
		        var reboundMethod = _bind.apply(boundMethod, arguments);
		        reboundMethod.__reactBoundContext = component;
		        reboundMethod.__reactBoundMethod = method;
		        reboundMethod.__reactBoundArguments = args;
		        return reboundMethod;
		      };
		    }
		    return boundMethod;
		  }
	
		  /**
		   * Binds all auto-bound methods in a component.
		   *
		   * @param {object} component Component whose method is going to be bound.
		   */
		  function bindAutoBindMethods(component) {
		    var pairs = component.__reactAutoBindPairs;
		    for (var i = 0; i < pairs.length; i += 2) {
		      var autoBindKey = pairs[i];
		      var method = pairs[i + 1];
		      component[autoBindKey] = bindAutoBindMethod(component, method);
		    }
		  }
	
		  var IsMountedMixin = {
		    componentDidMount: function () {
		      this.__isMounted = true;
		    },
		    componentWillUnmount: function () {
		      this.__isMounted = false;
		    }
		  };
	
		  /**
		   * Add more to the ReactClass base class. These are all legacy features and
		   * therefore not already part of the modern ReactComponent.
		   */
		  var ReactClassMixin = {
	
		    /**
		     * TODO: This will be deprecated because state should always keep a consistent
		     * type signature and the only use case for this, is to avoid that.
		     */
		    replaceState: function (newState, callback) {
		      this.updater.enqueueReplaceState(this, newState, callback);
		    },
	
		    /**
		     * Checks whether or not this composite component is mounted.
		     * @return {boolean} True if mounted, false otherwise.
		     * @protected
		     * @final
		     */
		    isMounted: function () {
		      if (process.env.NODE_ENV !== 'production') {
		        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
		        this.__didWarnIsMounted = true;
		      }
		      return !!this.__isMounted;
		    }
		  };
	
		  var ReactClassComponent = function () {};
		  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
		  /**
		   * Creates a composite component class given a class specification.
		   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
		   *
		   * @param {object} spec Class specification (which must define `render`).
		   * @return {function} Component constructor function.
		   * @public
		   */
		  function createClass(spec) {
		    // To keep our warnings more understandable, we'll use a little hack here to
		    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
		    // unnecessarily identify a class without displayName as 'Constructor'.
		    var Constructor = identity(function (props, context, updater) {
		      // This constructor gets overridden by mocks. The argument is used
		      // by mocks to assert on what gets mounted.
	
		      if (process.env.NODE_ENV !== 'production') {
		        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
		      }
	
		      // Wire up auto-binding
		      if (this.__reactAutoBindPairs.length) {
		        bindAutoBindMethods(this);
		      }
	
		      this.props = props;
		      this.context = context;
		      this.refs = emptyObject;
		      this.updater = updater || ReactNoopUpdateQueue;
	
		      this.state = null;
	
		      // ReactClasses doesn't have constructors. Instead, they use the
		      // getInitialState and componentWillMount methods for initialization.
	
		      var initialState = this.getInitialState ? this.getInitialState() : null;
		      if (process.env.NODE_ENV !== 'production') {
		        // We allow auto-mocks to proceed as if they're returning null.
		        if (initialState === undefined && this.getInitialState._isMockFunction) {
		          // This is probably bad practice. Consider warning here and
		          // deprecating this convenience.
		          initialState = null;
		        }
		      }
		      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
		      this.state = initialState;
		    });
		    Constructor.prototype = new ReactClassComponent();
		    Constructor.prototype.constructor = Constructor;
		    Constructor.prototype.__reactAutoBindPairs = [];
	
		    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
		    mixSpecIntoComponent(Constructor, IsMountedMixin);
		    mixSpecIntoComponent(Constructor, spec);
	
		    // Initialize the defaultProps property after all mixins have been merged.
		    if (Constructor.getDefaultProps) {
		      Constructor.defaultProps = Constructor.getDefaultProps();
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      // This is a tag to indicate that the use of these method names is ok,
		      // since it's used with createClass. If it's not, then it's likely a
		      // mistake so we'll warn you to use the static property, property
		      // initializer or constructor respectively.
		      if (Constructor.getDefaultProps) {
		        Constructor.getDefaultProps.isReactClassApproved = {};
		      }
		      if (Constructor.prototype.getInitialState) {
		        Constructor.prototype.getInitialState.isReactClassApproved = {};
		      }
		    }
	
		    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
		    }
	
		    // Reduce time spent doing lookups by setting these on the prototype.
		    for (var methodName in ReactClassInterface) {
		      if (!Constructor.prototype[methodName]) {
		        Constructor.prototype[methodName] = null;
		      }
		    }
	
		    return Constructor;
		  }
	
		  return createClass;
		}
	
		module.exports = factory;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyObject = {};
	
		if (process.env.NODE_ENV !== 'production') {
		  Object.freeze(emptyObject);
		}
	
		module.exports = emptyObject;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_15__;
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		/**
		 * @fileOverview jQuery replacement
		 * @author jasonslyvia
		 */
		'use strict';
	
		exports.__esModule = true;
		exports.on = on;
		exports.off = off;
		exports.isFunction = isFunction;
		exports.isNumeric = isNumeric;
		exports.position = position;
		exports.width = width;
		exports.height = height;
		exports.outerWidthWithMargin = outerWidthWithMargin;
		exports.outerHeightWithMargin = outerHeightWithMargin;
		exports.closest = closest;
		exports.assign = assign;
		exports.get = get;
		exports.findMostOften = findMostOften;
	
		function on(el, eventName, callback) {
		  if (el.addEventListener) {
		    el.addEventListener(eventName, callback, false);
		  } else if (el.attachEvent) {
		    el.attachEvent('on' + eventName, function (e) {
		      callback.call(el, e || window.event);
		    });
		  }
		}
	
		function off(el, eventName, callback) {
		  if (el.removeEventListener) {
		    el.removeEventListener(eventName, callback);
		  } else if (el.detachEvent) {
		    el.detachEvent('on' + eventName, callback);
		  }
		}
	
		function isFunction(func) {
		  return typeof func === 'function';
		}
	
		function isNumeric(num) {
		  return !isNaN(parseFloat(num)) && isFinite(num);
		}
	
		function position(el) {
		  if (!el) {
		    return {
		      left: 0,
		      top: 0
		    };
		  }
	
		  return {
		    left: el.offsetLeft,
		    top: el.offsetTop
		  };
		}
	
		function width(el) {
		  return el.offsetWidth;
		}
	
		function height(el) {
		  return el.offsetHeight;
		}
	
		function outerWidthWithMargin(el) {
		  var _width = el.offsetWidth;
		  var style = el.currentStyle || getComputedStyle(el);
	
		  _width += (parseInt(style.marginLeft, 10) || 0) + (parseInt(style.marginRight, 10) || 0);
		  return _width;
		}
	
		function outerHeightWithMargin(el) {
		  var _height = el.offsetHeight;
		  var style = el.currentStyle || getComputedStyle(el);
	
		  _height += (parseInt(style.marginLeft, 10) || 0) + (parseInt(style.marginRight, 10) || 0);
		  return _height;
		}
	
		function hasClass(elClassName, className) {
		  return (' ' + elClassName + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + className + ' ') > -1;
		}
	
		function closest(el, className) {
		  className = className.replace(/^[\b\.]/, '');
	
		  var finder = function finder(_x, _x2) {
		    var _again = true;
	
		    _function: while (_again) {
		      var _el = _x,
		          _className = _x2;
		      _again = false;
	
		      var _elClassName = typeof _el.className === 'object' ? _el.className.baseVal : _el.className;
		      if (_elClassName && hasClass(_elClassName, _className)) {
		        return _el;
		      } else if (_el.parentNode === null) {
		        // matches document
		        return null;
		      }
	
		      _x = _el.parentNode;
		      _x2 = _className;
		      _again = true;
		      _elClassName = undefined;
		      continue _function;
		    }
		  };
	
		  return finder(el, className);
		}
	
		function assign(target) {
		  if (target === undefined || target === null) {
		    throw new TypeError('Cannot convert first argument to object');
		  }
	
		  var to = Object(target);
		  for (var i = 1; i < arguments.length; i++) {
		    var nextSource = arguments[i];
		    if (nextSource === undefined || nextSource === null) {
		      continue;
		    }
	
		    var keysArray = Object.keys(Object(nextSource));
		    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
		      var nextKey = keysArray[nextIndex];
		      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
		      if (desc !== undefined && desc.enumerable) {
		        to[nextKey] = nextSource[nextKey];
		      }
		    }
		  }
		  return to;
		}
	
		function get(selector) {
		  return document.querySelector(selector);
		}
	
		function findMostOften(arr) {
		  var obj = {};
		  arr.forEach(function (i) {
		    obj[i] = obj[i] ? obj[i] + 1 : 1;
		  });
	
		  return Object.keys(obj).sort(function (a, b) {
		    return obj[b] - obj[a];
		  })[0];
		}
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _reactDom = __webpack_require__(15);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _utils = __webpack_require__(16);
	
		function _handleSortableItemReadyToMove(e) {
		  // if sort handle is defined then only handle sort if the target matches the sort handle
		  if (this.props.sortHandle && _utils.closest(e.target || e.srcElement, this.props.sortHandle) === null) {
		    return;
		  }
	
		  var target = _utils.closest(e.target || e.srcElement, '.ui-sortable-item');
		  var evt = {
		    pageX: e.pageX || e.clientX || e.touches[0].pageX,
		    pageY: e.pageY || e.clientY || e.touches[0].pageY,
		    offset: _utils.position(target)
		  };
	
		  if (this.props.onSortableItemReadyToMove) {
		    this.props.onSortableItemReadyToMove(evt, this.props.sortableIndex);
		  }
		}
	
		function handleComponentDidMount() {
		  var node = _reactDom2['default'].findDOMNode(this);
	
		  // Prevent odd behaviour in legacy IE when dragging
		  if (window.attachEvent && !document.body.style['-ms-user-select']) {
		    _utils.on(node, 'selectstart', function (e) {
		      if (e.preventDefault) {
		        e.preventDefault();
		      } else {
		        e.returnValue = false;
		      }
		    });
		  }
	
		  if (_utils.isFunction(this.props.onSortableItemMount)) {
		    this.props.onSortableItemMount(_utils.position(node), _utils.width(node), _utils.height(node), _utils.outerWidthWithMargin(node), _utils.outerHeightWithMargin(node), this.props.sortableIndex);
		  }
		}
	
		function handleComponentDidUpdate() {
		  var node = _reactDom2['default'].findDOMNode(this);
	
		  if (_utils.isFunction(this.props.onSortableItemMount)) {
		    this.props.onSortableItemMount(_utils.position(node), _utils.width(node), _utils.height(node), _utils.outerWidthWithMargin(node), _utils.outerHeightWithMargin(node), this.props.sortableIndex);
		  }
		}
	
		var _defaultProps = {
		  sortableClassName: '',
		  sortableStyle: {},
		  onSortableItemMount: function onSortableItemMount() {},
		  onSortableItemReadyToMove: function onSortableItemReadyToMove() {}
		};
	
		/**
		 * @class A factory for generating either mixin or High Order Component
		 *        depending if there is an argument passed in
		 *
		 * @param {React} Component An optinal argument for creating HOCs, leave it
		 *                blank if you'd like old mixin
		 */
	
		exports['default'] = function (Component) {
		  if (Component) {
		    return (function (_React$Component) {
		      _inherits(SortableItem, _React$Component);
	
		      function SortableItem() {
		        _classCallCheck(this, SortableItem);
	
		        _React$Component.apply(this, arguments);
		      }
	
		      SortableItem.prototype.handleSortableItemReadyToMove = function handleSortableItemReadyToMove(e) {
		        _handleSortableItemReadyToMove.call(this, e);
		      };
	
		      SortableItem.prototype.componentDidMount = function componentDidMount() {
		        handleComponentDidMount.call(this);
		      };
	
		      SortableItem.prototype.componentDidUpdate = function componentDidUpdate() {
		        handleComponentDidUpdate.call(this);
		      };
	
		      SortableItem.prototype.render = function render() {
		        var _props = this.props;
		        var sortableClassName = _props.sortableClassName;
		        var sortableStyle = _props.sortableStyle;
		        var sortableIndex = _props.sortableIndex;
		        var sortHandle = _props.sortHandle;
		        var className = _props.className;
	
		        var rest = _objectWithoutProperties(_props, ['sortableClassName', 'sortableStyle', 'sortableIndex', 'sortHandle', 'className']);
	
		        return _react2['default'].createElement(Component, _extends({}, rest, {
		          sortable: true,
		          className: sortableClassName,
		          style: sortableStyle,
		          sortHandle: sortHandle,
		          onMouseDown: this.handleSortableItemReadyToMove.bind(this),
		          onTouchStart: this.handleSortableItemReadyToMove.bind(this)
		        }));
		      };
	
		      _createClass(SortableItem, null, [{
		        key: 'defaultProps',
		        value: _defaultProps,
		        enumerable: true
		      }, {
		        key: 'propTypes',
		        value: {
		          sortableClassName: _propTypes2['default'].string,
		          sortableStyle: _propTypes2['default'].object,
		          sortableIndex: _propTypes2['default'].number,
		          sortHandle: _propTypes2['default'].string
		        },
		        enumerable: true
		      }]);
	
		      return SortableItem;
		    })(_react2['default'].Component);
		  }
	
		  return {
		    propTypes: {
		      sortableClassName: _propTypes2['default'].string,
		      sortableStyle: _propTypes2['default'].object,
		      sortableIndex: _propTypes2['default'].number,
		      sortHandle: _propTypes2['default'].string
		    },
	
		    getDefaultProps: function getDefaultProps() {
		      return _defaultProps;
		    },
	
		    handleSortableItemReadyToMove: _handleSortableItemReadyToMove,
	
		    componentDidMount: handleComponentDidMount,
	
		    componentDidUpdate: handleComponentDidUpdate,
	
		    renderWithSortable: function renderWithSortable(item) {
		      return _react2['default'].cloneElement(item, {
		        className: this.props.sortableClassName,
		        style: this.props.sortableStyle,
		        sortHandle: this.props.sortHandle,
		        onMouseDown: this.handleSortableItemReadyToMove,
		        onTouchStart: this.handleSortableItemReadyToMove
		      });
		    }
		  };
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(28);
	
	var focusNode = __webpack_require__(360);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(35);
	var FallbackCompositionState = __webpack_require__(1064);
	var SyntheticCompositionEvent = __webpack_require__(1101);
	var SyntheticInputEvent = __webpack_require__(1104);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(432);
	var ExecutionEnvironment = __webpack_require__(35);
	var ReactInstrumentation = __webpack_require__(58);
	
	var camelizeStyleName = __webpack_require__(873);
	var dangerousStyleValue = __webpack_require__(1110);
	var hyphenateStyleName = __webpack_require__(880);
	var memoizeStringOnly = __webpack_require__(883);
	var warning = __webpack_require__(15);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(141);
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(65);
	var SyntheticEvent = __webpack_require__(74);
	
	var inputValueTracking = __webpack_require__(448);
	var getEventTarget = __webpack_require__(283);
	var isEventSupported = __webpack_require__(284);
	var isTextInputElement = __webpack_require__(450);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var DOMLazyTree = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(35);
	
	var createNodesFromMarkup = __webpack_require__(876);
	var emptyFunction = __webpack_require__(57);
	var invariant = __webpack_require__(7);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(142);
	var ReactDOMComponentTree = __webpack_require__(28);
	var SyntheticMouseEvent = __webpack_require__(190);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var PooledClass = __webpack_require__(104);
	
	var getTextContentAccessor = __webpack_require__(447);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(120);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(121);
	
	var instantiateReactComponent = __webpack_require__(449);
	var KeyEscapeUtils = __webpack_require__(275);
	var shouldUpdateReactComponent = __webpack_require__(285);
	var traverseAllChildren = __webpack_require__(452);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(473);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(271);
	var ReactDOMIDOperations = __webpack_require__(1074);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var React = __webpack_require__(124);
	var ReactComponentEnvironment = __webpack_require__(277);
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactErrorUtils = __webpack_require__(278);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactInstrumentation = __webpack_require__(58);
	var ReactNodeTypes = __webpack_require__(442);
	var ReactReconciler = __webpack_require__(121);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(172);
	var invariant = __webpack_require__(7);
	var shallowEqual = __webpack_require__(173);
	var shouldUpdateReactComponent = __webpack_require__(285);
	var warning = __webpack_require__(15);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactDefaultInjection = __webpack_require__(1082);
	var ReactMount = __webpack_require__(441);
	var ReactReconciler = __webpack_require__(121);
	var ReactUpdates = __webpack_require__(65);
	var ReactVersion = __webpack_require__(1095);
	
	var findDOMNode = __webpack_require__(1111);
	var getHostComponentFromComposite = __webpack_require__(446);
	var renderSubtreeIntoContainer = __webpack_require__(1118);
	var warning = __webpack_require__(15);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var AutoFocusUtils = __webpack_require__(1057);
	var CSSPropertyOperations = __webpack_require__(1059);
	var DOMLazyTree = __webpack_require__(119);
	var DOMNamespaces = __webpack_require__(272);
	var DOMProperty = __webpack_require__(120);
	var DOMPropertyOperations = __webpack_require__(434);
	var EventPluginHub = __webpack_require__(141);
	var EventPluginRegistry = __webpack_require__(273);
	var ReactBrowserEventEmitter = __webpack_require__(189);
	var ReactDOMComponentFlags = __webpack_require__(435);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactDOMInput = __webpack_require__(1075);
	var ReactDOMOption = __webpack_require__(1076);
	var ReactDOMSelect = __webpack_require__(436);
	var ReactDOMTextarea = __webpack_require__(1079);
	var ReactInstrumentation = __webpack_require__(58);
	var ReactMultiChild = __webpack_require__(1088);
	var ReactServerRenderingTransaction = __webpack_require__(1093);
	
	var emptyFunction = __webpack_require__(57);
	var escapeTextContentForBrowser = __webpack_require__(192);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(284);
	var shallowEqual = __webpack_require__(173);
	var inputValueTracking = __webpack_require__(448);
	var validateDOMNesting = __webpack_require__(286);
	var warning = __webpack_require__(15);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(286);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var DOMLazyTree = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(28);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(271);
	var ReactDOMComponentTree = __webpack_require__(28);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var DOMPropertyOperations = __webpack_require__(434);
	var LinkedValueUtils = __webpack_require__(276);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var React = __webpack_require__(124);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactDOMSelect = __webpack_require__(436);
	
	var warning = __webpack_require__(15);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var getNodeForCharacterOffset = __webpack_require__(1115);
	var getTextContentAccessor = __webpack_require__(447);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var DOMChildrenOperations = __webpack_require__(271);
	var DOMLazyTree = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(28);
	
	var escapeTextContentForBrowser = __webpack_require__(192);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(286);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(19);
	
	var LinkedValueUtils = __webpack_require__(276);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var ReactUpdates = __webpack_require__(65);
	var Transaction = __webpack_require__(191);
	
	var emptyFunction = __webpack_require__(57);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1056);
	var BeforeInputEventPlugin = __webpack_require__(1058);
	var ChangeEventPlugin = __webpack_require__(1060);
	var DefaultEventPluginOrder = __webpack_require__(1062);
	var EnterLeaveEventPlugin = __webpack_require__(1063);
	var HTMLDOMPropertyConfig = __webpack_require__(1065);
	var ReactComponentBrowserEnvironment = __webpack_require__(1067);
	var ReactDOMComponent = __webpack_require__(1070);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactDOMEmptyComponent = __webpack_require__(1072);
	var ReactDOMTreeTraversal = __webpack_require__(1080);
	var ReactDOMTextComponent = __webpack_require__(1078);
	var ReactDefaultBatchingStrategy = __webpack_require__(1081);
	var ReactEventListener = __webpack_require__(1085);
	var ReactInjection = __webpack_require__(1086);
	var ReactReconcileTransaction = __webpack_require__(1091);
	var SVGDOMPropertyConfig = __webpack_require__(1096);
	var SelectEventPlugin = __webpack_require__(1097);
	var SimpleEventPlugin = __webpack_require__(1098);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(141);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var EventListener = __webpack_require__(359);
	var ExecutionEnvironment = __webpack_require__(35);
	var PooledClass = __webpack_require__(104);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(65);
	
	var getEventTarget = __webpack_require__(283);
	var getUnboundedScrollPosition = __webpack_require__(878);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(120);
	var EventPluginHub = __webpack_require__(141);
	var EventPluginUtils = __webpack_require__(274);
	var ReactComponentEnvironment = __webpack_require__(277);
	var ReactEmptyComponent = __webpack_require__(437);
	var ReactBrowserEventEmitter = __webpack_require__(189);
	var ReactHostComponent = __webpack_require__(439);
	var ReactUpdates = __webpack_require__(65);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1109);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactComponentEnvironment = __webpack_require__(277);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactInstrumentation = __webpack_require__(58);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactReconciler = __webpack_require__(121);
	var ReactChildReconciler = __webpack_require__(1066);
	
	var emptyFunction = __webpack_require__(57);
	var flattenChildren = __webpack_require__(1112);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var CallbackQueue = __webpack_require__(433);
	var PooledClass = __webpack_require__(104);
	var ReactBrowserEventEmitter = __webpack_require__(189);
	var ReactInputSelection = __webpack_require__(440);
	var ReactInstrumentation = __webpack_require__(58);
	var Transaction = __webpack_require__(191);
	var ReactUpdateQueue = __webpack_require__(279);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1089);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(19);
	
	var PooledClass = __webpack_require__(104);
	var Transaction = __webpack_require__(191);
	var ReactInstrumentation = __webpack_require__(58);
	var ReactServerUpdateQueue = __webpack_require__(1094);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(279);
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactInputSelection = __webpack_require__(440);
	var SyntheticEvent = __webpack_require__(74);
	
	var getActiveElement = __webpack_require__(361);
	var isTextInputElement = __webpack_require__(450);
	var shallowEqual = __webpack_require__(173);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var EventListener = __webpack_require__(359);
	var EventPropagators = __webpack_require__(142);
	var ReactDOMComponentTree = __webpack_require__(28);
	var SyntheticAnimationEvent = __webpack_require__(1099);
	var SyntheticClipboardEvent = __webpack_require__(1100);
	var SyntheticEvent = __webpack_require__(74);
	var SyntheticFocusEvent = __webpack_require__(1103);
	var SyntheticKeyboardEvent = __webpack_require__(1105);
	var SyntheticMouseEvent = __webpack_require__(190);
	var SyntheticDragEvent = __webpack_require__(1102);
	var SyntheticTouchEvent = __webpack_require__(1106);
	var SyntheticTransitionEvent = __webpack_require__(1107);
	var SyntheticUIEvent = __webpack_require__(144);
	var SyntheticWheelEvent = __webpack_require__(1108);
	
	var emptyFunction = __webpack_require__(57);
	var getEventCharCode = __webpack_require__(281);
	var invariant = __webpack_require__(7);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(190);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	var getEventCharCode = __webpack_require__(281);
	var getEventKey = __webpack_require__(1113);
	var getEventModifierState = __webpack_require__(282);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	var getEventModifierState = __webpack_require__(282);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(74);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(190);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(432);
	var warning = __webpack_require__(15);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(28);
	var ReactInstanceMap = __webpack_require__(143);
	
	var getHostComponentFromComposite = __webpack_require__(446);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(15);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(275);
	var traverseAllChildren = __webpack_require__(452);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(473);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(281);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(192);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(441);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var RegExpPropType = __webpack_require__(1120);
	var escapeStringRegexp = __webpack_require__(794);
	var blacklist = __webpack_require__(581);
	var createReactClass = __webpack_require__(56);
	var PropTypes = __webpack_require__(22);
	
	var Highlighter = createReactClass({displayName: "Highlighter",
	  count: 0,
	
	  propTypes: {
	    search: PropTypes.oneOfType([
	      PropTypes.string,
	      PropTypes.number,
	      PropTypes.bool,
	      RegExpPropType
	    ]).isRequired,
	    caseSensitive: PropTypes.bool,
	    matchElement: PropTypes.string,
	    matchClass: PropTypes.string,
	    matchStyle: PropTypes.object
	  },
	
	  getDefaultProps: function() {
	    return {
	      caseSensitive: false,
	      matchElement: 'strong',
	      matchClass: 'highlight',
	      matchStyle: {}
	    }
	  },
	
	  render: function() {
	    var props = blacklist(this.props, 'search', 'caseSensitive', 'matchElement', 'matchClass', 'matchStyle');
	
	    return React.createElement('span', props, this.renderElement(this.props.children));
	  },
	
	  /**
	   * A wrapper to the highlight method to determine when the highlighting
	   * process should occur.
	   *
	   * @param  {string} subject
	   *   The body of text that will be searched for highlighted words.
	   *
	   * @return {Array}
	   *   An array of ReactElements
	   */
	  renderElement: function(subject) {
	    if (this.isScalar() && this.hasSearch()) {
	      var search = this.getSearch();
	      return this.highlightChildren(subject, search);
	    }
	
	    return this.props.children;
	  },
	
	  /**
	   * Determine if props are valid types for processing.
	   *
	   * @return {Boolean}
	   */
	  isScalar: function() {
	    return (/string|number|boolean/).test(typeof this.props.children);
	  },
	
	  /**
	   * Determine if required search prop is defined and valid.
	   *
	   * @return {Boolean}
	   */
	  hasSearch: function() {
	    return (typeof this.props.search !== 'undefined') && this.props.search;
	  },
	
	  /**
	   * Get the search prop, but always in the form of a regular expression. Use
	   * this as a proxy to this.props.search for consistency.
	   *
	   * @return {RegExp}
	   */
	  getSearch: function() {
	    if (this.props.search instanceof RegExp) {
	      return this.props.search;
	    }
	
	    var flags = '';
	    if (!this.props.caseSensitive) {
	      flags +='i';
	    }
	
	    var search = this.props.search;
	    if (typeof this.props.search === 'string') {
	      search = escapeStringRegexp(search);
	    }
	
	    return new RegExp(search, flags);
	  },
	
	  /**
	   * Get the indexes of the first and last characters of the matched string.
	   *
	   * @param  {string} subject
	   *   The string to search against.
	   *
	   * @param  {RegExp} search
	   *   The regex search query.
	   *
	   * @return {Object}
	   *   An object consisting of "first" and "last" properties representing the
	   *   indexes of the first and last characters of a matching string.
	   */
	  getMatchBoundaries: function(subject, search) {
	    var matches = search.exec(subject);
	    if (matches) {
	      return {
	        first: matches.index,
	        last: matches.index + matches[0].length
	      };
	    }
	  },
	
	  /**
	   * Determines which strings of text should be highlighted or not.
	   *
	   * @param  {string} subject
	   *   The body of text that will be searched for highlighted words.
	   * @param  {string} search
	   *   The search used to search for highlighted words.
	   *
	   * @return {Array}
	   *   An array of ReactElements
	   */
	  highlightChildren: function(subject, search) {
	    var children = [];
	    var matchElement = this.props.matchElement;
	    var remaining = subject;
	
	    while (remaining) {
	      if (!search.test(remaining)) {
	        children.push(this.renderPlain(remaining));
	        return children;
	      }
	
	      var boundaries = this.getMatchBoundaries(remaining, search);
	
	      // Capture the string that leads up to a match...
	      var nonMatch = remaining.slice(0, boundaries.first);
	      if (nonMatch) {
	        children.push(this.renderPlain(nonMatch));
	      }
	
	      // Now, capture the matching string...
	      var match = remaining.slice(boundaries.first, boundaries.last);
	      if (match) {
	        children.push(this.renderHighlight(match, matchElement));
	      }
	
	      // And if there's anything left over, recursively run this method again.
	      remaining = remaining.slice(boundaries.last);
	
	    }
	
	    return children;
	  },
	
	  /**
	   * Responsible for rending a non-highlighted element.
	   *
	   * @param  {string} string
	   *   A string value to wrap an element around.
	   *
	   * @return {ReactElement}
	   */
	  renderPlain: function(string) {
	    this.count++;
	    return React.DOM.span({'key': this.count}, string);
	  },
	
	  /**
	   * Responsible for rending a highlighted element.
	   *
	   * @param  {string} string
	   *   A string value to wrap an element around.
	   *
	   * @return {ReactElement}
	   */
	  renderHighlight: function(string) {
	    this.count++;
	    return React.DOM[this.props.matchElement]({
	      key: this.count,
	      className: this.props.matchClass,
	      style: this.props.matchStyle
	    }, string);
	  }
	});
	
	module.exports = Highlighter;


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	var regExpPropType = function (props, propName, componentName, location) {
	  if (!(props[propName] instanceof RegExp)) {
	    var propType = typeof props[propName];
	
	    return new Error(
	      ("Invalid " + location + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `RegExp`.")
	    );
	  }
	};
	
	module.exports = regExpPropType;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1124)


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(1123);
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prop-types */
	
	var React = __webpack_require__(1);
	
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(1125);
	} else {
	  module.exports = require('./index.dev');
	}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__(1122);

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkify = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linkifyIt = __webpack_require__(917);
	
	var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
	
	var _tlds = __webpack_require__(1241);
	
	var _tlds2 = _interopRequireDefault(_tlds);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkify = exports.linkify = new _linkifyIt2.default();
	linkify.tlds(_tlds2.default);
	
	var Linkify = function (_React$Component) {
	  _inherits(Linkify, _React$Component);
	
	  function Linkify() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Linkify);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Linkify, [{
	    key: 'getMatches',
	    value: function getMatches(string) {
	      return linkify.match(string);
	    }
	  }, {
	    key: 'parseString',
	    value: function parseString(string) {
	      var _this2 = this;
	
	      var elements = [];
	      if (string === '') {
	        return elements;
	      }
	
	      var matches = this.getMatches(string);
	      if (!matches) {
	        return string;
	      }
	
	      var lastIndex = 0;
	      matches.forEach(function (match, idx) {
	        // Push the preceding text if there is any
	        if (match.index > lastIndex) {
	          elements.push(string.substring(lastIndex, match.index));
	        }
	        // Shallow update values that specified the match
	        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
	        for (var key in _this2.props.properties) {
	          var val = _this2.props.properties[key];
	          if (val === Linkify.MATCH) {
	            val = match.url;
	          }
	
	          props[key] = val;
	        }
	        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
	        lastIndex = match.lastIndex;
	      });
	
	      if (lastIndex < string.length) {
	        elements.push(string.substring(lastIndex));
	      }
	
	      return elements.length === 1 ? elements[0] : elements;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(children) {
	      var _this3 = this;
	
	      var parsed = children;
	
	      if (typeof children === 'string') {
	        parsed = this.parseString(children);
	      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
	        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
	      } else if (children instanceof Array) {
	        parsed = children.map(function (child) {
	          return _this3.parse(child);
	        });
	      }
	
	      return parsed;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.parseCounter = 0;
	      var parsedChildren = this.parse(this.props.children);
	
	      return _react2.default.createElement(
	        'span',
	        { className: this.props.className },
	        parsedChildren
	      );
	    }
	  }]);
	
	  return Linkify;
	}(_react2.default.Component);
	
	Linkify.MATCH = 'LINKIFY_MATCH';
	Linkify.propTypes = {
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.any,
	  properties: _propTypes2.default.object,
	  urlRegex: _propTypes2.default.object,
	  emailRegex: _propTypes2.default.object
	};
	Linkify.defaultProps = {
	  className: 'Linkify',
	  component: 'a',
	  properties: {}
	};
	exports.default = Linkify;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(198);
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(297));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(22));
	
	var _PropTypes = __webpack_require__(455);
	
	var _warning = _interopRequireDefault(__webpack_require__(288));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(197));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(199));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(453));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(1137));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1130));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1131));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1132));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1133));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(106);
	
	var _wrapMapToProps = __webpack_require__(454);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(454);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(197));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(456));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(199));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1134));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(31);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(288));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Resizable = __webpack_require__(457);
	
	var _Resizable2 = _interopRequireDefault(_Resizable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// An example use of Resizable.
	var ResizableBox = function (_React$Component) {
	  _inherits(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizableBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      width: _this.props.width,
	      height: _this.props.height
	    }, _this.onResize = function (e, data) {
	      var size = data.size;
	      var width = size.width,
	          height = size.height;
	
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	        _this.setState(size, function () {
	          return _this.props.onResize && _this.props.onResize(e, data);
	        });
	      } else {
	        _this.setState(size);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResizableBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  ResizableBox.prototype.render = function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _props = this.props,
	        handleSize = _props.handleSize,
	        onResize = _props.onResize,
	        onResizeStart = _props.onResizeStart,
	        onResizeStop = _props.onResizeStop,
	        draggableOpts = _props.draggableOpts,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        width = _props.width,
	        height = _props.height,
	        props = _objectWithoutProperties(_props, ['handleSize', 'onResize', 'onResizeStart', 'onResizeStop', 'draggableOpts', 'minConstraints', 'maxConstraints', 'lockAspectRatio', 'axis', 'width', 'height']);
	
	    return _react2.default.createElement(
	      _Resizable2.default,
	      {
	        handleSize: handleSize,
	        width: this.state.width,
	        height: this.state.height,
	        onResizeStart: onResizeStart,
	        onResize: this.onResize,
	        onResizeStop: onResizeStop,
	        draggableOpts: draggableOpts,
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        lockAspectRatio: lockAspectRatio,
	        axis: axis
	      },
	      _react2.default.createElement('div', _extends({ style: { width: this.state.width + 'px', height: this.state.height + 'px' } }, props))
	    );
	  };
	
	  return ResizableBox;
	}(_react2.default.Component);
	
	ResizableBox.propTypes = {
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number
	};
	ResizableBox.defaultProps = {
	  handleSize: [20, 20]
	};
	exports.default = ResizableBox;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	module.exports = function cloneElement(element, props) {
	  if (props.style && element.props.style) {
	    props.style = _extends({}, element.props.style, props.style);
	  }
	  if (props.className && element.props.className) {
	    props.className = element.props.className + ' ' + props.className;
	  }
	  return _react2.default.cloneElement(element, props);
	};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(457).default;
	module.exports.ResizableBox = __webpack_require__(1138).default;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(458);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(459);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StateStorage = __webpack_require__(1144);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  createScrollBehavior: _propTypes2.default.func.isRequired,
	  routerProps: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	    var router = routerProps.router;
	
	
	    _this.scrollBehavior = props.createScrollBehavior({
	      addTransitionHook: router.listenBefore,
	      stateStorage: new _StateStorage2.default(router),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.routerProps.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior._stateStorage.
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DOMStateStorage = __webpack_require__(246);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STATE_KEY_PREFIX = '@@scroll|';
	
	var StateStorage = function () {
	  function StateStorage(router) {
	    _classCallCheck(this, StateStorage);
	
	    this.getFallbackLocationKey = router.createPath;
	  }
	
	  StateStorage.prototype.read = function read(location, key) {
	    return (0, _DOMStateStorage.readState)(this.getStateKey(location, key));
	  };
	
	  StateStorage.prototype.save = function save(location, key, value) {
	    (0, _DOMStateStorage.saveState)(this.getStateKey(location, key), value);
	  };
	
	  StateStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var locationKey = location.key || this.getFallbackLocationKey(location);
	    var stateKeyBase = '' + STATE_KEY_PREFIX + locationKey;
	    return key == null ? stateKeyBase : stateKeyBase + '|' + key;
	  };
	
	  return StateStorage;
	}();
	
	exports.default = StateStorage;
	module.exports = exports['default'];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollBehavior = __webpack_require__(1231);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _ScrollBehaviorContext = __webpack_require__(1143);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultCreateScrollBehavior(config) {
	  return new _scrollBehavior2.default(config);
	}
	
	function useScroll(shouldUpdateScrollOrConfig) {
	  var shouldUpdateScroll = void 0;
	  var createScrollBehavior = void 0;
	
	  if (!shouldUpdateScrollOrConfig || typeof shouldUpdateScrollOrConfig === 'function') {
	    shouldUpdateScroll = shouldUpdateScrollOrConfig;
	    createScrollBehavior = defaultCreateScrollBehavior;
	  } else {
	    shouldUpdateScroll = shouldUpdateScrollOrConfig.shouldUpdateScroll;
	    var _shouldUpdateScrollOr = shouldUpdateScrollOrConfig.createScrollBehavior;
	    createScrollBehavior = _shouldUpdateScrollOr === undefined ? defaultCreateScrollBehavior : _shouldUpdateScrollOr;
	  }
	
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          createScrollBehavior: createScrollBehavior,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(460);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(462);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(86);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(86);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(22);
	
	var _createTransitionManager2 = __webpack_require__(466);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(145);
	
	var _RouterContext = __webpack_require__(292);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(86);
	
	var _RouterUtils = __webpack_require__(463);
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(289);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(292);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(893);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(465);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(122);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(289);
	
	var _PromiseUtils = __webpack_require__(461);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(122);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(894);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(465);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(122);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(174);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(464);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(466);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(86);
	
	var _RouterUtils = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(289);
	
	var _PromiseUtils = __webpack_require__(461);
	
	var _PatternUtils = __webpack_require__(122);
	
	var _routerWarning = __webpack_require__(123);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(56);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(364);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(290);
	
	var _PropTypes = __webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _channel = __webpack_require__(468);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_React$Component) {
	  _inherits(Container, _React$Component);
	
	  function Container(props) {
	    _classCallCheck(this, Container);
	
	    var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));
	
	    _this.updateOffset = function (_ref) {
	      var inherited = _ref.inherited,
	          offset = _ref.offset;
	
	      _this.channel.update(function (data) {
	        data.inherited = inherited + offset;
	      });
	    };
	
	    _this.channel = new _channel2.default({ inherited: 0, offset: 0, node: null });
	    return _this;
	  }
	
	  _createClass(Container, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { 'sticky-channel': this.channel };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var parentChannel = this.context['sticky-channel'];
	      if (parentChannel) parentChannel.subscribe(this.updateOffset);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var node = _reactDom2.default.findDOMNode(this);
	      this.channel.update(function (data) {
	        data.node = node;
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.channel.update(function (data) {
	        data.node = null;
	      });
	
	      var parentChannel = this.context['sticky-channel'];
	      if (parentChannel) parentChannel.unsubscribe(this.updateOffset);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Container;
	}(_react2.default.Component);
	
	Container.contextTypes = {
	  'sticky-channel': _propTypes2.default.any
	};
	Container.childContextTypes = {
	  'sticky-channel': _propTypes2.default.any
	};
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_React$Component) {
	  _inherits(Sticky, _React$Component);
	
	  function Sticky(props) {
	    _classCallCheck(this, Sticky);
	
	    var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));
	
	    _this.updateContext = function (_ref) {
	      var inherited = _ref.inherited,
	          node = _ref.node;
	
	      _this.containerNode = node;
	      _this.setState({
	        containerOffset: inherited,
	        distanceFromBottom: _this.getDistanceFromBottom()
	      });
	    };
	
	    _this.recomputeState = function () {
	      var isSticky = _this.isSticky();
	      var height = _this.getHeight();
	      var width = _this.getWidth();
	      var xOffset = _this.getXOffset();
	      var distanceFromBottom = _this.getDistanceFromBottom();
	      var hasChanged = _this.state.isSticky !== isSticky;
	
	      _this.setState({ isSticky: isSticky, height: height, width: width, xOffset: xOffset, distanceFromBottom: distanceFromBottom });
	
	      if (hasChanged) {
	        if (_this.channel) {
	          _this.channel.update(function (data) {
	            data.offset = isSticky ? _this.state.height : 0;
	          });
	        }
	
	        _this.props.onStickyStateChange(isSticky);
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Sticky, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.channel = this.context['sticky-channel'];
	      this.channel.subscribe(this.updateContext);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.on(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
	      this.recomputeState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.recomputeState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.off(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
	      this.channel.unsubscribe(this.updateContext);
	    }
	  }, {
	    key: 'getXOffset',
	    value: function getXOffset() {
	      return this.refs.placeholder.getBoundingClientRect().left;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.refs.placeholder.getBoundingClientRect().width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return _reactDom2.default.findDOMNode(this.refs.children).getBoundingClientRect().height;
	    }
	  }, {
	    key: 'getDistanceFromTop',
	    value: function getDistanceFromTop() {
	      return this.refs.placeholder.getBoundingClientRect().top;
	    }
	  }, {
	    key: 'getDistanceFromBottom',
	    value: function getDistanceFromBottom() {
	      if (!this.containerNode) return 0;
	      return this.containerNode.getBoundingClientRect().bottom;
	    }
	  }, {
	    key: 'isSticky',
	    value: function isSticky() {
	      if (!this.props.isActive) return false;
	
	      var fromTop = this.getDistanceFromTop();
	      var fromBottom = this.getDistanceFromBottom();
	
	      var topBreakpoint = this.state.containerOffset - this.props.topOffset;
	      var bottomBreakpoint = this.state.containerOffset + this.props.bottomOffset;
	
	      return fromTop <= topBreakpoint && fromBottom >= bottomBreakpoint;
	    }
	  }, {
	    key: 'on',
	    value: function on(events, callback) {
	      events.forEach(function (evt) {
	        window.addEventListener(evt, callback);
	      });
	    }
	  }, {
	    key: 'off',
	    value: function off(events, callback) {
	      events.forEach(function (evt) {
	        window.removeEventListener(evt, callback);
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(newProps, newState) {
	      var _this2 = this;
	
	      // Have we changed the number of props?
	      var propNames = Object.keys(this.props);
	      if (Object.keys(newProps).length != propNames.length) return true;
	
	      // Have we changed any prop values?
	      var valuesMatch = propNames.every(function (key) {
	        return newProps.hasOwnProperty(key) && newProps[key] === _this2.props[key];
	      });
	      if (!valuesMatch) return true;
	
	      // Have we changed any state that will always impact rendering?
	      var state = this.state;
	      if (newState.isSticky !== state.isSticky) return true;
	
	      // If we are sticky, have we changed any state that will impact rendering?
	      if (state.isSticky) {
	        if (newState.height !== state.height) return true;
	        if (newState.width !== state.width) return true;
	        if (newState.xOffset !== state.xOffset) return true;
	        if (newState.containerOffset !== state.containerOffset) return true;
	        if (newState.distanceFromBottom !== state.distanceFromBottom) return true;
	      }
	
	      return false;
	    }
	
	    /*
	     * The special sauce.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var placeholderStyle = { paddingBottom: 0 };
	      var className = this.props.className;
	
	      // To ensure that this component becomes sticky immediately on mobile devices instead
	      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
	      // to 'kick' rendering of this element to the GPU
	      // @see http://stackoverflow.com/questions/32875046
	      var style = _extends({}, { transform: 'translateZ(0)' }, this.props.style);
	
	      if (this.state.isSticky) {
	        var _stickyStyle = {
	          position: 'fixed',
	          top: this.state.containerOffset,
	          left: this.state.xOffset,
	          width: this.state.width
	        };
	
	        var bottomLimit = this.state.distanceFromBottom - this.state.height - this.props.bottomOffset;
	        if (this.state.containerOffset > bottomLimit) {
	          _stickyStyle.top = bottomLimit;
	        }
	
	        placeholderStyle.paddingBottom = this.state.height;
	
	        className += ' ' + this.props.stickyClassName;
	        style = _extends({}, style, _stickyStyle, this.props.stickyStyle);
	      }
	
	      var _props = this.props,
	          topOffset = _props.topOffset,
	          isActive = _props.isActive,
	          stickyClassName = _props.stickyClassName,
	          stickyStyle = _props.stickyStyle,
	          bottomOffset = _props.bottomOffset,
	          onStickyStateChange = _props.onStickyStateChange,
	          props = _objectWithoutProperties(_props, ['topOffset', 'isActive', 'stickyClassName', 'stickyStyle', 'bottomOffset', 'onStickyStateChange']);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: 'placeholder', style: placeholderStyle }),
	        _react2.default.createElement(
	          'div',
	          _extends({}, props, { ref: 'children', className: className, style: style }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react2.default.Component);
	
	Sticky.propTypes = {
	  isActive: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  stickyClassName: _propTypes2.default.string,
	  stickyStyle: _propTypes2.default.object,
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  onStickyStateChange: _propTypes2.default.func
	};
	Sticky.defaultProps = {
	  isActive: true,
	  className: '',
	  style: {},
	  stickyClassName: 'sticky',
	  stickyStyle: {},
	  topOffset: 0,
	  bottomOffset: 0,
	  onStickyStateChange: function onStickyStateChange() {}
	};
	Sticky.contextTypes = {
	  'sticky-channel': _propTypes2.default.any
	};
	exports.default = Sticky;
	module.exports = exports['default'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable vars-on-top, no-var, prefer-template */
	var isRegExp = __webpack_require__(1023);
	var escapeRegExp = __webpack_require__(1017);
	var isString = __webpack_require__(1024);
	var flatten = __webpack_require__(1018);
	
	/**
	 * Given a string, replace every substring that is matched by the `match` regex
	 * with the result of calling `fn` on matched substring. The result will be an
	 * array with all odd indexed elements containing the replacements. The primary
	 * use case is similar to using String.prototype.replace except for React.
	 *
	 * React will happily render an array as children of a react element, which
	 * makes this approach very useful for tasks like surrounding certain text
	 * within a string with react elements.
	 *
	 * Example:
	 * matchReplace(
	 *   'Emphasize all phone numbers like 884-555-4443.',
	 *   /([\d|-]+)/g,
	 *   (number, i) => <strong key={i}>{number}</strong>
	 * );
	 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
	 *
	 * @param {string} str
	 * @param {regexp|str} match Must contain a matching group
	 * @param {function} fn
	 * @return {array}
	 */
	function replaceString(str, match, fn) {
	  var curCharStart = 0;
	  var curCharLen = 0;
	
	  if (str === '') {
	    return str;
	  } else if (!str || !isString(str)) {
	    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
	  }
	
	  var re = match;
	
	  if (!isRegExp(re)) {
	    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
	  }
	
	  var result = str.split(re);
	
	  // Apply fn to all odd elements
	  for (var i = 1, length = result.length; i < length; i += 2) {
	    curCharLen = result[i].length;
	    curCharStart += result[i - 1].length;
	    result[i] = fn(result[i], i, curCharStart);
	    curCharStart += curCharLen;
	  }
	
	  return result;
	}
	
	module.exports = function reactStringReplace(source, match, fn) {
	  if (!Array.isArray(source)) source = [source];
	
	  return flatten(source.map(function(x) {
	    return isString(x) ? replaceString(x, match, fn) : x;
	  }));
	};


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	function getPinchProps(touches) {
		return {
			touches: Array.prototype.map.call(touches, function copyTouch(touch) {
				return { identifier: touch.identifier, pageX: touch.pageX, pageY: touch.pageY };
			}),
			center: { x: (touches[0].pageX + touches[1].pageX) / 2, y: (touches[0].pageY + touches[1].pageY) / 2 },
			angle: Math.atan() * (touches[1].pageY - touches[0].pageY) / (touches[1].pageX - touches[0].pageX) * 180 / Math.PI,
			distance: Math.sqrt(Math.pow(Math.abs(touches[1].pageX - touches[0].pageX), 2) + Math.pow(Math.abs(touches[1].pageY - touches[0].pageY), 2))
		};
	}
	
	var Mixin = {
		propTypes: {
			onPinchStart: React.PropTypes.func, // fires when a pinch gesture is started
			onPinchMove: React.PropTypes.func, // fires on every touch-move when a pinch action is active
			onPinchEnd: React.PropTypes.func // fires when a pinch action ends
		},
	
		onPinchStart: function onPinchStart(event) {
			// in case the two touches didn't start exactly at the same time
			if (this._initialTouch) {
				this.endTouch();
			}
			var touches = event.touches;
			this._initialPinch = getPinchProps(touches);
			this._initialPinch = _extends(this._initialPinch, {
				displacement: { x: 0, y: 0 },
				displacementVelocity: { x: 0, y: 0 },
				rotation: 0,
				rotationVelocity: 0,
				zoom: 1,
				zoomVelocity: 0,
				time: Date.now()
			});
			this._lastPinch = this._initialPinch;
			this.props.onPinchStart && this.props.onPinchStart(this._initialPinch, event);
		},
	
		onPinchMove: function onPinchMove(event) {
			if (this._initialTouch) {
				this.endTouch();
			}
			var touches = event.touches;
			if (touches.length !== 2) {
				return this.onPinchEnd(event); // bail out before disaster
			}
	
			var currentPinch = touches[0].identifier === this._initialPinch.touches[0].identifier && touches[1].identifier === this._initialPinch.touches[1].identifier ? getPinchProps(touches) // the touches are in the correct order
			: touches[1].identifier === this._initialPinch.touches[0].identifier && touches[0].identifier === this._initialPinch.touches[1].identifier ? getPinchProps(touches.reverse()) // the touches have somehow changed order
			: getPinchProps(touches); // something is wrong, but we still have two touch-points, so we try not to fail
	
			currentPinch.displacement = {
				x: currentPinch.center.x - this._initialPinch.center.x,
				y: currentPinch.center.y - this._initialPinch.center.y
			};
	
			currentPinch.time = Date.now();
			var timeSinceLastPinch = currentPinch.time - this._lastPinch.time;
	
			currentPinch.displacementVelocity = {
				x: (currentPinch.displacement.x - this._lastPinch.displacement.x) / timeSinceLastPinch,
				y: (currentPinch.displacement.y - this._lastPinch.displacement.y) / timeSinceLastPinch
			};
	
			currentPinch.rotation = currentPinch.angle - this._initialPinch.angle;
			currentPinch.rotationVelocity = currentPinch.rotation - this._lastPinch.rotation / timeSinceLastPinch;
	
			currentPinch.zoom = currentPinch.distance / this._initialPinch.distance;
			currentPinch.zoomVelocity = (currentPinch.zoom - this._lastPinch.zoom) / timeSinceLastPinch;
	
			this.props.onPinchMove && this.props.onPinchMove(currentPinch, event);
	
			this._lastPinch = currentPinch;
		},
	
		onPinchEnd: function onPinchEnd(event) {
			// TODO use helper to order touches by identifier and use actual values on touchEnd.
			var currentPinch = _extends({}, this._lastPinch);
			currentPinch.time = Date.now();
	
			if (currentPinch.time - this._lastPinch.time > 16) {
				currentPinch.displacementVelocity = 0;
				currentPinch.rotationVelocity = 0;
				currentPinch.zoomVelocity = 0;
			}
	
			this.props.onPinchEnd && this.props.onPinchEnd(currentPinch, event);
	
			this._initialPinch = this._lastPinch = null;
	
			// If one finger is still on screen, it should start a new touch event for swiping etc
			// But it should never fire an onTap or onPress event.
			// Since there is no support swipes yet, this should be disregarded for now
			// if (event.touches.length === 1) {
			// 	this.onTouchStart(event);
			// }
		}
	};
	
	module.exports = Mixin;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(32);
	
	var SPACE_KEY = 32;
	var ENTER_KEY = 13;
	
	function getTouchProps(touch) {
		if (!touch) return {};
		return {
			pageX: touch.pageX,
			pageY: touch.pageY,
			clientX: touch.clientX,
			clientY: touch.clientY
		};
	}
	
	var Mixin = {
		propTypes: {
			moveThreshold: React.PropTypes.number, // pixels to move before cancelling tap
			activeDelay: React.PropTypes.number, // ms to wait before adding the `-active` class
			pressDelay: React.PropTypes.number, // ms to wait before detecting a press
			pressMoveThreshold: React.PropTypes.number, // pixels to move before cancelling press
			preventDefault: React.PropTypes.bool, // whether to preventDefault on all events
			stopPropagation: React.PropTypes.bool, // whether to stopPropagation on all events
	
			onTap: React.PropTypes.func, // fires when a tap is detected
			onPress: React.PropTypes.func, // fires when a press is detected
			onTouchStart: React.PropTypes.func, // pass-through touch event
			onTouchMove: React.PropTypes.func, // pass-through touch event
			onTouchEnd: React.PropTypes.func, // pass-through touch event
			onMouseDown: React.PropTypes.func, // pass-through mouse event
			onMouseUp: React.PropTypes.func, // pass-through mouse event
			onMouseMove: React.PropTypes.func, // pass-through mouse event
			onMouseOut: React.PropTypes.func, // pass-through mouse event
			onKeyDown: React.PropTypes.func, // pass-through key event
			onKeyUp: React.PropTypes.func },
	
		// pass-through key event
		getDefaultProps: function getDefaultProps() {
			return {
				activeDelay: 0,
				moveThreshold: 100,
				pressDelay: 1000,
				pressMoveThreshold: 5
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				isActive: false,
				touchActive: false,
				pinchActive: false
			};
		},
	
		componentWillUnmount: function componentWillUnmount() {
			this.cleanupScrollDetection();
			this.cancelPressDetection();
			this.clearActiveTimeout();
		},
	
		processEvent: function processEvent(event) {
			if (this.props.preventDefault) event.preventDefault();
			if (this.props.stopPropagation) event.stopPropagation();
		},
	
		onTouchStart: function onTouchStart(event) {
			if (this.props.onTouchStart && this.props.onTouchStart(event) === false) return;
			this.processEvent(event);
			window._blockMouseEvents = true;
			if (event.touches.length === 1) {
				this._initialTouch = this._lastTouch = getTouchProps(event.touches[0]);
				this.initScrollDetection();
				this.initPressDetection(event, this.endTouch);
				this.initTouchmoveDetection();
				this._activeTimeout = setTimeout(this.makeActive, this.props.activeDelay);
			} else if (this.onPinchStart && (this.props.onPinchStart || this.props.onPinchMove || this.props.onPinchEnd) && event.touches.length === 2) {
				this.onPinchStart(event);
			}
		},
	
		makeActive: function makeActive() {
			if (!this.isMounted()) return;
			this.clearActiveTimeout();
			this.setState({
				isActive: true
			});
		},
	
		clearActiveTimeout: function clearActiveTimeout() {
			clearTimeout(this._activeTimeout);
			this._activeTimeout = false;
		},
	
		initScrollDetection: function initScrollDetection() {
			this._scrollPos = { top: 0, left: 0 };
			this._scrollParents = [];
			this._scrollParentPos = [];
			var node = ReactDOM.findDOMNode(this);
	
			while (node) {
				if (node.scrollHeight > node.offsetHeight || node.scrollWidth > node.offsetWidth) {
					this._scrollParents.push(node);
					this._scrollParentPos.push(node.scrollTop + node.scrollLeft);
					this._scrollPos.top += node.scrollTop;
					this._scrollPos.left += node.scrollLeft;
				}
	
				node = node.parentNode;
			}
		},
	
		initTouchmoveDetection: function initTouchmoveDetection() {
			this._touchmoveTriggeredTimes = 0;
		},
	
		cancelTouchmoveDetection: function cancelTouchmoveDetection() {
			if (this._touchmoveDetectionTimeout) {
				clearTimeout(this._touchmoveDetectionTimeout);
				this._touchmoveDetectionTimeout = null;
				this._touchmoveTriggeredTimes = 0;
			}
		},
	
		calculateMovement: function calculateMovement(touch) {
			return {
				x: Math.abs(touch.clientX - this._initialTouch.clientX),
				y: Math.abs(touch.clientY - this._initialTouch.clientY)
			};
		},
	
		detectScroll: function detectScroll() {
			var currentScrollPos = { top: 0, left: 0 };
			for (var i = 0; i < this._scrollParents.length; i++) {
				currentScrollPos.top += this._scrollParents[i].scrollTop;
				currentScrollPos.left += this._scrollParents[i].scrollLeft;
			}
			return !(currentScrollPos.top === this._scrollPos.top && currentScrollPos.left === this._scrollPos.left);
		},
	
		cleanupScrollDetection: function cleanupScrollDetection() {
			this._scrollParents = undefined;
			this._scrollPos = undefined;
		},
	
		initPressDetection: function initPressDetection(event, callback) {
			if (!this.props.onPress) return;
			this._pressTimeout = setTimeout((function () {
				this.props.onPress(event);
				callback();
			}).bind(this), this.props.pressDelay);
		},
	
		cancelPressDetection: function cancelPressDetection() {
			clearTimeout(this._pressTimeout);
		},
	
		onTouchMove: function onTouchMove(event) {
			if (this._initialTouch) {
				this.processEvent(event);
	
				if (this.detectScroll()) {
					return this.endTouch(event);
				} else {
					if (this._touchmoveTriggeredTimes++ === 0) {
						this._touchmoveDetectionTimeout = setTimeout((function () {
							if (this._touchmoveTriggeredTimes === 1) {
								this.endTouch(event);
							}
						}).bind(this), 64);
					}
				}
	
				this.props.onTouchMove && this.props.onTouchMove(event);
				this._lastTouch = getTouchProps(event.touches[0]);
				var movement = this.calculateMovement(this._lastTouch);
				if (movement.x > this.props.pressMoveThreshold || movement.y > this.props.pressMoveThreshold) {
					this.cancelPressDetection();
				}
				if (movement.x > this.props.moveThreshold || movement.y > this.props.moveThreshold) {
					if (this.state.isActive) {
						this.setState({
							isActive: false
						});
					} else if (this._activeTimeout) {
						this.clearActiveTimeout();
					}
				} else {
					if (!this.state.isActive && !this._activeTimeout) {
						this.setState({
							isActive: true
						});
					}
				}
			} else if (this._initialPinch && event.touches.length === 2 && this.onPinchMove) {
				this.onPinchMove(event);
				event.preventDefault();
			}
		},
	
		onTouchEnd: function onTouchEnd(event) {
			var _this = this;
	
			if (this._initialTouch) {
				this.processEvent(event);
				var afterEndTouch;
				var movement = this.calculateMovement(this._lastTouch);
				if (movement.x <= this.props.moveThreshold && movement.y <= this.props.moveThreshold && this.props.onTap) {
					event.preventDefault();
					afterEndTouch = function () {
						var finalParentScrollPos = _this._scrollParents.map(function (node) {
							return node.scrollTop + node.scrollLeft;
						});
						var stoppedMomentumScroll = _this._scrollParentPos.some(function (end, i) {
							return end !== finalParentScrollPos[i];
						});
						if (!stoppedMomentumScroll) {
							_this.props.onTap(event);
						}
					};
				}
				this.endTouch(event, afterEndTouch);
			} else if (this.onPinchEnd && this._initialPinch && event.touches.length + event.changedTouches.length === 2) {
				this.onPinchEnd(event);
				event.preventDefault();
			}
		},
	
		endTouch: function endTouch(event, callback) {
			this.cancelTouchmoveDetection();
			this.cancelPressDetection();
			this.clearActiveTimeout();
			if (event && this.props.onTouchEnd) {
				this.props.onTouchEnd(event);
			}
			this._initialTouch = null;
			this._lastTouch = null;
			if (callback) {
				callback();
			}
			if (this.state.isActive) {
				this.setState({
					isActive: false
				});
			}
		},
	
		onMouseDown: function onMouseDown(event) {
			if (window._blockMouseEvents) {
				window._blockMouseEvents = false;
				return;
			}
			if (this.props.onMouseDown && this.props.onMouseDown(event) === false) return;
			this.processEvent(event);
			this.initPressDetection(event, this.endMouseEvent);
			this._mouseDown = true;
			this.setState({
				isActive: true
			});
		},
	
		onMouseMove: function onMouseMove(event) {
			if (window._blockMouseEvents || !this._mouseDown) return;
			this.processEvent(event);
			this.props.onMouseMove && this.props.onMouseMove(event);
		},
	
		onMouseUp: function onMouseUp(event) {
			if (window._blockMouseEvents || !this._mouseDown) return;
			this.processEvent(event);
			this.props.onMouseUp && this.props.onMouseUp(event);
			this.props.onTap && this.props.onTap(event);
			this.endMouseEvent();
		},
	
		onMouseOut: function onMouseOut(event) {
			if (window._blockMouseEvents || !this._mouseDown) return;
			this.processEvent(event);
			this.props.onMouseOut && this.props.onMouseOut(event);
			this.endMouseEvent();
		},
	
		endMouseEvent: function endMouseEvent() {
			this.cancelPressDetection();
			this._mouseDown = false;
			this.setState({
				isActive: false
			});
		},
	
		onKeyUp: function onKeyUp(event) {
			if (!this._keyDown) return;
			this.processEvent(event);
			this.props.onKeyUp && this.props.onKeyUp(event);
			this.props.onTap && this.props.onTap(event);
			this._keyDown = false;
			this.cancelPressDetection();
			this.setState({
				isActive: false
			});
		},
	
		onKeyDown: function onKeyDown(event) {
			if (this.props.onKeyDown && this.props.onKeyDown(event) === false) return;
			if (event.which !== SPACE_KEY && event.which !== ENTER_KEY) return;
			if (this._keyDown) return;
			this.initPressDetection(event, this.endKeyEvent);
			this.processEvent(event);
			this._keyDown = true;
			this.setState({
				isActive: true
			});
		},
	
		endKeyEvent: function endKeyEvent() {
			this.cancelPressDetection();
			this._keyDown = false;
			this.setState({
				isActive: false
			});
		},
	
		cancelTap: function cancelTap() {
			this.endTouch();
			this._mouseDown = false;
		},
	
		handlers: function handlers() {
			return {
				onTouchStart: this.onTouchStart,
				onTouchMove: this.onTouchMove,
				onTouchEnd: this.onTouchEnd,
				onMouseDown: this.onMouseDown,
				onMouseUp: this.onMouseUp,
				onMouseMove: this.onMouseMove,
				onMouseOut: this.onMouseOut,
				onKeyDown: this.onKeyDown,
				onKeyUp: this.onKeyUp
			};
		}
	};
	
	module.exports = Mixin;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var touchStyles = __webpack_require__(470);
	
	/**
	 * Tappable Component
	 * ==================
	 */
	module.exports = function (mixins) {
		return React.createClass({
			displayName: 'Tappable',
	
			mixins: mixins,
	
			propTypes: {
				component: React.PropTypes.any, // component to create
				className: React.PropTypes.string, // optional className
				classBase: React.PropTypes.string, // base for generated classNames
				classes: React.PropTypes.object, // object containing the active and inactive class names
				style: React.PropTypes.object, // additional style properties for the component
				disabled: React.PropTypes.bool // only applies to buttons
			},
	
			getDefaultProps: function getDefaultProps() {
				return {
					component: 'span',
					classBase: 'Tappable'
				};
			},
	
			render: function render() {
				var props = this.props;
				var className = props.classBase + (this.state.isActive ? '-active' : '-inactive');
	
				if (props.className) {
					className += ' ' + props.className;
				}
	
				if (props.classes) {
					className += ' ' + (this.state.isActive ? props.classes.active : props.classes.inactive);
				}
	
				var style = {};
				_extends(style, touchStyles, props.style);
	
				var newComponentProps = _extends({}, props, {
					style: style,
					className: className,
					disabled: props.disabled,
					handlers: this.handlers
				}, this.handlers());
	
				delete newComponentProps.activeDelay;
				delete newComponentProps.classBase;
				delete newComponentProps.classes;
				delete newComponentProps.handlers;
				delete newComponentProps.onTap;
				delete newComponentProps.onPress;
				delete newComponentProps.onPinchStart;
				delete newComponentProps.onPinchMove;
				delete newComponentProps.onPinchEnd;
				delete newComponentProps.moveThreshold;
				delete newComponentProps.pressDelay;
				delete newComponentProps.pressMoveThreshold;
				delete newComponentProps.preventDefault;
				delete newComponentProps.stopPropagation;
				delete newComponentProps.component;
	
				return React.createElement(props.component, newComponentProps, props.children);
			}
		});
	};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1170);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1169);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(784);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(786);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(353);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(791);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(32);
	
	var _PropTypes = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(582);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(77);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(146);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1173);
	var ReactElement = __webpack_require__(125);
	
	var emptyFunction = __webpack_require__(57);
	var traverseAllChildren = __webpack_require__(1183);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(125);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(125),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(428);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(472),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(125),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(475);
	var factory = __webpack_require__(351);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(146);
	
	var ReactElement = __webpack_require__(125);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(146);
	
	var ReactCurrentOwner = __webpack_require__(75);
	var REACT_ELEMENT_TYPE = __webpack_require__(474);
	
	var getIteratorFn = __webpack_require__(1179);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(1172);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(105);


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(478);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(135));
	util.inherits = __webpack_require__(116);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(196).Buffer;
	var util = __webpack_require__(1256);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(295).PassThrough


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(295).Transform


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(294);


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.RedBoxError = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(22);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(32);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _style = __webpack_require__(1192);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _errorStackParser = __webpack_require__(792);
	
	var _errorStackParser2 = _interopRequireDefault(_errorStackParser);
	
	var _objectAssign = __webpack_require__(19);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _lib = __webpack_require__(1191);
	
	var _sourcemappedStacktrace = __webpack_require__(1235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedBoxError = exports.RedBoxError = function (_get__2) {
	  _inherits(RedBoxError, _get__2);
	
	  function RedBoxError(props) {
	    _classCallCheck(this, RedBoxError);
	
	    var _this = _possibleConstructorReturn(this, (RedBoxError.__proto__ || Object.getPrototypeOf(RedBoxError)).call(this, props));
	
	    _this.state = {
	      error: null,
	      mapped: false
	    };
	
	    _this.mapOnConstruction(props.error);
	    return _this;
	  }
	
	  // State is used to store the error mapped to the source map.
	
	
	  _createClass(RedBoxError, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.state.mapped) this.mapError(this.props.error);
	    }
	
	    // Try to map the error when the component gets constructed, this is possible
	    // in some cases like evals.
	
	  }, {
	    key: 'mapOnConstruction',
	    value: function mapOnConstruction(error) {
	      var stackLines = error.stack.split('\n');
	
	      // There's no stack, only the error message.
	      if (stackLines.length < 2) {
	        this.state = { error: error, mapped: true };
	        return;
	      }
	
	      // Using the “eval” setting on webpack already gives the correct location.
	      var isWebpackEval = stackLines[1].search(/\(webpack:\/{3}/) !== -1;
	      if (isWebpackEval) {
	        // No changes are needed here.
	        this.state = { error: error, mapped: true };
	        return;
	      }
	
	      // Other eval follow a specific pattern and can be easily parsed.
	      var isEval = stackLines[1].search(/\(eval at/) !== -1;
	      if (!isEval) {
	        // mapping will be deferred until `componentDidMount`
	        this.state = { error: error, mapped: false };
	        return;
	      }
	
	      // The first line is the error message.
	      var fixedLines = [stackLines.shift()];
	      // The rest needs to be fixed.
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = stackLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var stackLine = _step.value;
	
	          var evalStackLine = stackLine.match(/(.+)\(eval at (.+) \(.+?\), .+(\:[0-9]+\:[0-9]+)\)/);
	          if (evalStackLine) {
	            var _evalStackLine = _slicedToArray(evalStackLine, 4),
	                atSomething = _evalStackLine[1],
	                file = _evalStackLine[2],
	                rowColumn = _evalStackLine[3];
	
	            fixedLines.push(atSomething + ' (' + file + rowColumn + ')');
	          } else {
	            // TODO: When stack frames of different types are detected, try to load the additional source maps
	            fixedLines.push(stackLine);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      error.stack = fixedLines.join('\n');
	      this.state = { error: error, mapped: true };
	    }
	  }, {
	    key: 'mapError',
	    value: function mapError(error) {
	      var _this2 = this;
	
	      _get__('mapStackTrace')(error.stack, function (mappedStack) {
	        error.stack = mappedStack.join('\n');
	        _this2.setState({ error: error, mapped: true });
	      });
	    }
	  }, {
	    key: 'renderFrames',
	    value: function renderFrames(frames) {
	      var _props = this.props,
	          filename = _props.filename,
	          editorScheme = _props.editorScheme,
	          useLines = _props.useLines,
	          useColumns = _props.useColumns;
	
	      var _get__3 = _get__('assign')({}, _get__('style'), this.props.style),
	          frame = _get__3.frame,
	          file = _get__3.file,
	          linkToFile = _get__3.linkToFile;
	
	      return frames.map(function (f, index) {
	        var text = void 0;
	        var url = void 0;
	
	        if (index === 0 && filename && !_get__('isFilenameAbsolute')(f.fileName)) {
	          url = _get__('makeUrl')(filename, editorScheme);
	          text = _get__('makeLinkText')(filename);
	        } else {
	          var lines = useLines ? f.lineNumber : null;
	          var columns = useColumns ? f.columnNumber : null;
	          url = _get__('makeUrl')(f.fileName, editorScheme, lines, columns);
	          text = _get__('makeLinkText')(f.fileName, lines, columns);
	        }
	
	        return _get__('React').createElement(
	          'div',
	          { style: frame, key: index },
	          _get__('React').createElement(
	            'div',
	            null,
	            f.functionName
	          ),
	          _get__('React').createElement(
	            'div',
	            { style: file },
	            _get__('React').createElement(
	              'a',
	              { href: url, style: linkToFile },
	              text
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // The error is received as a property to initialize state.error, which may
	      // be updated when it is mapped to the source map.
	      var error = this.state.error;
	      var className = this.props.className;
	
	      var _get__4 = _get__('assign')({}, _get__('style'), this.props.style),
	          redbox = _get__4.redbox,
	          message = _get__4.message,
	          stack = _get__4.stack,
	          frame = _get__4.frame;
	
	      var frames = void 0;
	      var parseError = void 0;
	      try {
	        frames = _get__('ErrorStackParser').parse(error);
	      } catch (e) {
	        parseError = new Error('Failed to parse stack trace. Stack trace information unavailable.');
	      }
	
	      if (parseError) {
	        frames = _get__('React').createElement(
	          'div',
	          { style: frame, key: 0 },
	          _get__('React').createElement(
	            'div',
	            null,
	            parseError.message
	          )
	        );
	      } else {
	        frames = this.renderFrames(frames);
	      }
	
	      return _get__('React').createElement(
	        'div',
	        { style: redbox, className: className },
	        _get__('React').createElement(
	          'div',
	          { style: message },
	          error.name,
	          ': ',
	          error.message
	        ),
	        _get__('React').createElement(
	          'div',
	          { style: stack },
	          frames
	        )
	      );
	    }
	  }]);
	
	  return RedBoxError;
	}(_get__('Component'));
	
	// "Portal" component for actual RedBoxError component to
	// render to (directly under body). Prevents bugs as in #27.
	
	
	RedBoxError.propTypes = {
	  error: _get__('PropTypes').instanceOf(Error).isRequired,
	  filename: _get__('PropTypes').string,
	  editorScheme: _get__('PropTypes').string,
	  useLines: _get__('PropTypes').bool,
	  useColumns: _get__('PropTypes').bool,
	  style: _get__('PropTypes').object,
	  className: _get__('PropTypes').string
	};
	RedBoxError.displayName = 'RedBoxError';
	RedBoxError.defaultProps = {
	  useLines: true,
	  useColumns: true };
	
	var RedBox = function (_get__5) {
	  _inherits(RedBox, _get__5);
	
	  function RedBox() {
	    _classCallCheck(this, RedBox);
	
	    return _possibleConstructorReturn(this, (RedBox.__proto__ || Object.getPrototypeOf(RedBox)).apply(this, arguments));
	  }
	
	  _createClass(RedBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.el = document.createElement('div');
	      document.body.appendChild(this.el);
	      this.renderRedBoxError();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderRedBoxError();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _get__('ReactDOM').unmountComponentAtNode(this.el);
	      document.body.removeChild(this.el);
	      this.el = null;
	    }
	  }, {
	    key: 'renderRedBoxError',
	    value: function renderRedBoxError() {
	      _get__('ReactDOM').render(_get__('React').createElement(_get__('RedBoxError'), this.props), this.el);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RedBox;
	}(_get__('Component'));
	
	RedBox.propTypes = {
	  error: _get__('PropTypes').instanceOf(Error).isRequired
	};
	RedBox.displayName = 'RedBox';
	exports.default = RedBox;
	
	var _RewiredData__ = Object.create(null);
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = _RewiredData__[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'PropTypes':
	      return _propTypes2.default;
	
	    case 'mapStackTrace':
	      return _sourcemappedStacktrace.mapStackTrace;
	
	    case 'assign':
	      return _objectAssign2.default;
	
	    case 'style':
	      return _style2.default;
	
	    case 'isFilenameAbsolute':
	      return _lib.isFilenameAbsolute;
	
	    case 'makeUrl':
	      return _lib.makeUrl;
	
	    case 'makeLinkText':
	      return _lib.makeLinkText;
	
	    case 'ErrorStackParser':
	      return _errorStackParser2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'ReactDOM':
	      return _reactDom2.default;
	
	    case 'React':
	      return _react2.default;
	
	    case 'RedBoxError':
	      return RedBoxError;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return _RewiredData__[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      _RewiredData__[name] = variableName[name];
	    });
	  } else {
	    if (value === undefined) {
	      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      _RewiredData__[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  delete _RewiredData__[variableName];
	}
	
	function _with__(object) {
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      _RewiredData__[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = _RewiredData__[variableName];
	      _RewiredData__[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof RedBox === 'undefined' ? 'undefined' : _typeof(RedBox);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(RedBox, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(RedBox)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}
	
	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var filenameWithoutLoaders = exports.filenameWithoutLoaders = function filenameWithoutLoaders() {
	  var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var index = filename.lastIndexOf('!');
	
	  return index < 0 ? filename : filename.substr(index + 1);
	};
	
	var filenameHasLoaders = exports.filenameHasLoaders = function filenameHasLoaders(filename) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  return actualFilename !== filename;
	};
	
	var filenameHasSchema = exports.filenameHasSchema = function filenameHasSchema(filename) {
	  return (/^[\w]+\:/.test(filename)
	  );
	};
	
	var isFilenameAbsolute = exports.isFilenameAbsolute = function isFilenameAbsolute(filename) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  if (actualFilename.indexOf('/') === 0) {
	    return true;
	  }
	
	  return false;
	};
	
	var makeUrl = exports.makeUrl = function makeUrl(filename, scheme, line, column) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  if (_get__('filenameHasSchema')(filename)) {
	    return actualFilename;
	  }
	
	  var url = 'file://' + actualFilename;
	
	  if (scheme === 'vscode') {
	    url = scheme + '://file/' + url;
	    url = url.replace(/file:\/\/\//, ''); // visual studio code does not need file:/// in its scheme
	    if (line && actualFilename === filename) {
	      url = url + ':' + line;
	
	      if (column) {
	        url = url + ':' + column;
	      }
	    }
	  } else if (scheme) {
	    url = scheme + '://open?url=' + url;
	
	    if (line && actualFilename === filename) {
	      url = url + '&line=' + line;
	
	      if (column) {
	        url = url + '&column=' + column;
	      }
	    }
	  }
	
	  return url;
	};
	
	var makeLinkText = exports.makeLinkText = function makeLinkText(filename, line, column) {
	  var text = _get__('filenameWithoutLoaders')(filename);
	
	  if (line && text === filename) {
	    text = text + ':' + line;
	
	    if (column) {
	      text = text + ':' + column;
	    }
	  }
	
	  return text;
	};
	
	var _RewiredData__ = Object.create(null);
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = _RewiredData__[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'filenameWithoutLoaders':
	      return filenameWithoutLoaders;
	
	    case 'filenameHasSchema':
	      return filenameHasSchema;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return _RewiredData__[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      _RewiredData__[name] = variableName[name];
	    });
	  } else {
	    if (value === undefined) {
	      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      _RewiredData__[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  delete _RewiredData__[variableName];
	}
	
	function _with__(object) {
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      _RewiredData__[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = _RewiredData__[variableName];
	      _RewiredData__[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _DefaultExportValue = {
	  redbox: {
	    boxSizing: 'border-box',
	    fontFamily: 'sans-serif',
	    position: 'fixed',
	    padding: 10,
	    top: '0px',
	    left: '0px',
	    bottom: '0px',
	    right: '0px',
	    width: '100%',
	    background: 'rgb(204, 0, 0)',
	    color: 'white',
	    zIndex: 2147483647,
	    textAlign: 'left',
	    fontSize: '16px',
	    lineHeight: 1.2,
	    overflow: 'auto'
	  },
	  message: {
	    fontWeight: 'bold'
	  },
	  stack: {
	    fontFamily: 'monospace',
	    marginTop: '2em'
	  },
	  frame: {
	    marginTop: '1em'
	  },
	  file: {
	    fontSize: '0.8em',
	    color: 'rgba(255, 255, 255, 0.7)'
	  },
	  linkToFile: {
	    textDecoration: 'none',
	    color: 'rgba(255, 255, 255, 0.7)'
	  }
	};
	exports.default = _DefaultExportValue;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserAuthWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1196);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(4);
	
	var _hoistNonReactStatics = __webpack_require__(1194);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _lodash = __webpack_require__(920);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _url = __webpack_require__(1248);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  LoadingComponent: function LoadingComponent() {
	    return null;
	  }, // dont render anything while authenticating
	  failureRedirectPath: '/login',
	  FailureComponent: undefined,
	  redirectQueryParamName: 'redirect',
	  wrapperDisplayName: 'AuthWrapper',
	  predicate: function predicate(x) {
	    return !(0, _lodash2.default)(x);
	  },
	  authenticatingSelector: function authenticatingSelector() {
	    return false;
	  },
	  allowRedirectBack: true,
	  propMapper: function propMapper(_ref) {
	    var redirect = _ref.redirect,
	        authData = _ref.authData,
	        isAuthenticating = _ref.isAuthenticating,
	        failureRedirectPath = _ref.failureRedirectPath,
	        otherProps = _objectWithoutProperties(_ref, ['redirect', 'authData', 'isAuthenticating', 'failureRedirectPath']);
	
	    return _extends({ authData: authData }, otherProps);
	  } // eslint-disable-line no-unused-vars
	};
	
	var UserAuthWrapper = exports.UserAuthWrapper = function UserAuthWrapper(args) {
	  var _defaults$args = _extends({}, defaults, args),
	      authSelector = _defaults$args.authSelector,
	      authenticatingSelector = _defaults$args.authenticatingSelector,
	      LoadingComponent = _defaults$args.LoadingComponent,
	      failureRedirectPath = _defaults$args.failureRedirectPath,
	      FailureComponent = _defaults$args.FailureComponent,
	      wrapperDisplayName = _defaults$args.wrapperDisplayName,
	      predicate = _defaults$args.predicate,
	      allowRedirectBack = _defaults$args.allowRedirectBack,
	      redirectAction = _defaults$args.redirectAction,
	      redirectQueryParamName = _defaults$args.redirectQueryParamName,
	      propMapper = _defaults$args.propMapper;
	
	  var isAuthorized = function isAuthorized(authData) {
	    return predicate(authData);
	  };
	
	  var createRedirect = function createRedirect(location, redirect, redirectPath) {
	    var redirectLoc = _url2.default.parse(redirectPath, true);
	
	    var query = void 0;
	    var canRedirect = typeof allowRedirectBack === 'function' ? allowRedirectBack(location, redirectPath) : allowRedirectBack;
	
	    if (canRedirect) {
	      query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search + location.hash);
	    } else {
	      query = {};
	    }
	
	    query = _extends({}, query, redirectLoc.query);
	
	    redirect({
	      pathname: redirectLoc.pathname,
	      hash: redirectLoc.hash,
	      query: query
	    });
	  };
	
	  var shouldRedirect = FailureComponent === undefined;
	  var locationShape = _propTypes2.default.shape({
	    pathname: _propTypes2.default.string.isRequired,
	    search: _propTypes2.default.string.isRequired
	  });
	
	  // Wraps the component that needs the auth enforcement
	  function wrapComponent(DecoratedComponent) {
	    var _dec, _class, _class2, _temp2;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	      if (redirectAction !== undefined) {
	        return { redirect: function redirect(args) {
	            return dispatch(redirectAction(args));
	          } };
	      } else {
	        return {};
	      }
	    };
	
	    var UserAuthWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	      return {
	        authData: authSelector(state, ownProps),
	        failureRedirectPath: typeof failureRedirectPath === 'function' ? failureRedirectPath(state, ownProps) : failureRedirectPath,
	        isAuthenticating: authenticatingSelector(state, ownProps)
	      };
	    }, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
	      _inherits(UserAuthWrapper, _Component);
	
	      function UserAuthWrapper() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, UserAuthWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.getRedirectFunc = function (_ref3) {
	          var redirect = _ref3.redirect;
	
	          if (redirect) {
	            return redirect;
	          } else {
	            if (!_this.context.router.replace) {
	              /* istanbul ignore next sanity */
	              throw new Error('You must provide a router context (or use React-Router 2.x) if not passing a redirectAction to ' + wrapperDisplayName);
	            } else {
	              return _this.context.router.replace;
	            }
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(UserAuthWrapper, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          if (!this.props.isAuthenticating && !isAuthorized(this.props.authData) && shouldRedirect) {
	            createRedirect(this.props.location, this.getRedirectFunc(this.props), this.props.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var willBeAuthorized = isAuthorized(nextProps.authData);
	          var willbeAuthenticating = nextProps.isAuthenticating;
	          var wasAuthorized = isAuthorized(this.props.authData);
	          var wasAuthenticating = this.props.isAuthenticating;
	
	          // Don't bother to redirect if:
	          // 1. currently authenticating or FailureComponent is set
	          if (willbeAuthenticating || !shouldRedirect) return;
	
	          // Redirect if:
	          if ( // 1. Was authorized, but no longer
	          wasAuthorized && !willBeAuthorized ||
	          // 2. Was not authorized and authenticating
	          wasAuthenticating && !willBeAuthorized) {
	            createRedirect(nextProps.location, this.getRedirectFunc(nextProps), nextProps.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          // Allow everything but the replace aciton creator to be passed down
	          // Includes route props from React-Router and authData
	          var _props = this.props,
	              authData = _props.authData,
	              isAuthenticating = _props.isAuthenticating;
	
	          if (isAuthorized(authData)) {
	            return _react2.default.createElement(DecoratedComponent, propMapper(this.props));
	          } else if (isAuthenticating) {
	            return _react2.default.createElement(LoadingComponent, propMapper(this.props));
	          } else {
	            // Display FailureComponent or nothing if FailureComponent is null
	            // If FailureComponent is undefined user will never see this because
	            // they will be redirected to failureRedirectPath
	            return FailureComponent ? _react2.default.createElement(FailureComponent, propMapper(this.props)) : null;
	          }
	        }
	      }]);
	
	      return UserAuthWrapper;
	    }(_react.Component), _class2.displayName = wrapperDisplayName + '(' + displayName + ')', _class2.propTypes = {
	      failureRedirectPath: _propTypes2.default.string.isRequired,
	      location: shouldRedirect ? locationShape.isRequired : locationShape,
	      redirect: _propTypes2.default.func,
	      authData: _propTypes2.default.object
	    }, _class2.contextTypes = {
	      // Only used if no redirectAction specified
	      router: _propTypes2.default.object
	    }, _temp2)) || _class);
	
	
	    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
	  }
	
	  if (shouldRedirect) {
	    wrapComponent.onEnter = function (store, nextState, replace) {
	      var authData = authSelector(store.getState(), nextState);
	      var isAuthenticating = authenticatingSelector(store.getState(), nextState);
	
	      if (!isAuthorized(authData) && !isAuthenticating) {
	        var redirectPath = typeof failureRedirectPath === 'function' ? failureRedirectPath(store.getState(), nextState) : failureRedirectPath;
	        createRedirect(nextState.location, replace, redirectPath);
	      }
	    };
	  }
	
	  return wrapComponent;
	};

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(57);
	var invariant = __webpack_require__(7);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1195)();
	}


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(267);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _partial2 = __webpack_require__(186);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(4);
	
	var _createFieldProps = __webpack_require__(1204);
	
	var _createFieldProps2 = _interopRequireDefault(_createFieldProps);
	
	var _plain = __webpack_require__(147);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createConnectedField = function createConnectedField(_ref, _ref2, name) {
	  var asyncValidate = _ref.asyncValidate;
	  var blur = _ref.blur;
	  var change = _ref.change;
	  var focus = _ref.focus;
	  var getFormState = _ref.getFormState;
	  var initialValues = _ref.initialValues;
	  var deepEqual = _ref2.deepEqual;
	  var getIn = _ref2.getIn;
	
	
	  var propInitialValue = initialValues && getIn(initialValues, name);
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField() {
	      _classCallCheck(this, ConnectedField);
	
	      return _possibleConstructorReturn(this, Object.getPrototypeOf(ConnectedField).apply(this, arguments));
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !deepEqual(this.props, nextProps);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props;
	        var component = _props.component;
	        var defaultValue = _props.defaultValue;
	        var withRef = _props.withRef;
	
	        var rest = _objectWithoutProperties(_props, ['component', 'defaultValue', 'withRef']);
	
	        var props = (0, _createFieldProps2.default)(getIn, name, rest, this.syncError, defaultValue, asyncValidate);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'syncError',
	      get: function get() {
	        var getSyncErrors = this.context._reduxForm.getSyncErrors;
	
	        var error = _plain2.default.getIn(getSyncErrors(), name);
	        // Because the error for this field might not be at a level in the error structure where
	        // it can be set directly, it might need to be unwrapped from the _error property
	        return error && error._error ? error._error : error;
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    defaultValue: _react.PropTypes.any,
	    props: _react.PropTypes.object
	  };
	
	  ConnectedField.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  var actions = (0, _mapValues3.default)({ blur: blur, change: change, focus: focus }, function (actionCreator) {
	    return (0, _partial3.default)(actionCreator, name);
	  });
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var initial = getIn(getFormState(state), 'initial.' + name) || propInitialValue;
	    var value = getIn(getFormState(state), 'values.' + name);
	    var pristine = value === initial;
	    return {
	      asyncError: getIn(getFormState(state), 'asyncErrors.' + name),
	      asyncValidating: getIn(getFormState(state), 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(getFormState(state), 'fields.' + name),
	      submitError: getIn(getFormState(state), 'submitErrors.' + name),
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, actions, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(267);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _partial2 = __webpack_require__(186);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(4);
	
	var _createFieldArrayProps = __webpack_require__(1203);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(147);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _reactAddonsShallowCompare = __webpack_require__(270);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createConnectedFieldArray = function createConnectedFieldArray(_ref, _ref2, name) {
	  var arrayInsert = _ref.arrayInsert;
	  var arrayPop = _ref.arrayPop;
	  var arrayPush = _ref.arrayPush;
	  var arrayRemove = _ref.arrayRemove;
	  var arrayShift = _ref.arrayShift;
	  var arraySplice = _ref.arraySplice;
	  var arraySwap = _ref.arraySwap;
	  var arrayUnshift = _ref.arrayUnshift;
	  var asyncValidate = _ref.asyncValidate;
	  var blur = _ref.blur;
	  var change = _ref.change;
	  var focus = _ref.focus;
	  var getFormState = _ref.getFormState;
	  var initialValues = _ref.initialValues;
	  var deepEqual = _ref2.deepEqual;
	  var getIn = _ref2.getIn;
	  var size = _ref2.size;
	
	
	  var propInitialValue = initialValues && getIn(initialValues, name);
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      _classCallCheck(this, ConnectedFieldArray);
	
	      return _possibleConstructorReturn(this, Object.getPrototypeOf(ConnectedFieldArray).apply(this, arguments));
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _reactAddonsShallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props;
	        var component = _props.component;
	        var withRef = _props.withRef;
	
	        var rest = _objectWithoutProperties(_props, ['component', 'withRef']);
	
	        var props = (0, _createFieldArrayProps2.default)(getIn, size, name, rest, this.syncError);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'syncError',
	      get: function get() {
	        var getSyncErrors = this.context._reduxForm.getSyncErrors;
	
	        return _plain2.default.getIn(getSyncErrors(), name + '._error');
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    defaultValue: _react.PropTypes.any,
	    props: _react.PropTypes.object
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  var actions = (0, _mapValues3.default)({
	    arrayInsert: arrayInsert,
	    arrayPop: arrayPop,
	    arrayPush: arrayPush,
	    arrayRemove: arrayRemove,
	    arrayShift: arrayShift,
	    arraySplice: arraySplice,
	    arraySwap: arraySwap,
	    arrayUnshift: arrayUnshift
	  }, function (actionCreator) {
	    return (0, _partial3.default)(actionCreator, name);
	  });
	  var connector = (0, _reactRedux.connect)(function (state) {
	    var initial = getIn(getFormState(state), 'initial.' + name) || propInitialValue;
	    var value = getIn(getFormState(state), 'values.' + name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(getFormState(state), 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      submitError: getIn(getFormState(state), 'submitErrors.' + name + '._error'),
	      value: value
	    };
	  }, actions, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(1197);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _reactAddonsShallowCompare = __webpack_require__(270);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(_ref) {
	  var deepEqual = _ref.deepEqual;
	  var getIn = _ref.getIn;
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Field).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	      _this.ConnectedField = (0, _ConnectedField2.default)(context._reduxForm, { deepEqual: deepEqual, getIn: getIn }, props.name);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _reactAddonsShallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.context._reduxForm.register(this.name, 'Field');
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // name changed, regenerate connected field
	          this.ConnectedField = (0, _ConnectedField2.default)(this.context._reduxForm, { deepEqual: deepEqual, getIn: getIn }, nextProps.name);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(this.ConnectedField, _extends({}, this.props, {
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return this.props.name;
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    defaultValue: _react.PropTypes.any,
	    props: _react.PropTypes.object
	  };
	  Field.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(1198);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _reactAddonsShallowCompare = __webpack_require__(270);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createFieldArray = function createFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual;
	  var getIn = _ref.getIn;
	  var size = _ref.size;
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FieldArray).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      _this.ConnectedFieldArray = (0, _ConnectedFieldArray2.default)(context._reduxForm, { deepEqual: deepEqual, getIn: getIn, size: size }, props.name);
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _reactAddonsShallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.context._reduxForm.register(this.name, 'FieldArray');
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // name changed, regenerate connected field
	          this.ConnectedFieldArray = (0, _ConnectedFieldArray2.default)(this.context._reduxForm, { deepEqual: deepEqual, getIn: getIn, size: size }, nextProps.name);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(this.ConnectedFieldArray, _extends({}, this.props, {
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return this.props.name;
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.func.isRequired,
	    props: _react.PropTypes.object
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(250);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(1217);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reduxForm = __webpack_require__(1218);
	
	var _reduxForm2 = _interopRequireDefault(_reduxForm);
	
	var _Field = __webpack_require__(1199);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _FieldArray = __webpack_require__(1200);
	
	var _FieldArray2 = _interopRequireDefault(_FieldArray);
	
	var _formValueSelector = __webpack_require__(1212);
	
	var _formValueSelector2 = _interopRequireDefault(_formValueSelector);
	
	var _values = __webpack_require__(1224);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _SubmissionError = __webpack_require__(481);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	var _propTypes = __webpack_require__(1216);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(482);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(296);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAll = function createAll(structure) {
	  return _extends({
	    // separate out field actions
	    actionTypes: actionTypes
	  }, actions, {
	    Field: (0, _Field2.default)(structure),
	    FieldArray: (0, _FieldArray2.default)(structure),
	    formValueSelector: (0, _formValueSelector2.default)(structure),
	    propTypes: _propTypes2.default,
	    reduxForm: (0, _reduxForm2.default)(structure),
	    reducer: (0, _reducer2.default)(structure),
	    SubmissionError: _SubmissionError2.default,
	    values: (0, _values2.default)(structure)
	  });
	};
	
	exports.default = createAll;

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(getIn, size, name, _ref, syncError) {
	  var arrayInsert = _ref.arrayInsert;
	  var arrayMove = _ref.arrayMove;
	  var arrayPop = _ref.arrayPop;
	  var arrayPush = _ref.arrayPush;
	  var arrayRemove = _ref.arrayRemove;
	  var arrayRemoveAll = _ref.arrayRemoveAll;
	  var arrayShift = _ref.arrayShift;
	  var arraySplice = _ref.arraySplice;
	  var arraySwap = _ref.arraySwap;
	  var arrayUnshift = _ref.arrayUnshift;
	  var asyncError = _ref.asyncError;
	  var dirty = _ref.dirty;
	  var pristine = _ref.pristine;
	  var state = _ref.state;
	  var submitError = _ref.submitError;
	  var submitFailed = _ref.submitFailed;
	  var value = _ref.value;
	  var props = _ref.props;
	
	  var rest = _objectWithoutProperties(_ref, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "pristine", "state", "submitError", "submitFailed", "value", "props"]);
	
	  var error = syncError || asyncError || submitError;
	  var length = size(value);
	  return _extends({
	    fields: {
	      dirty: dirty,
	      error: error,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(name + "[" + index + "]", index);
	        });
	      },
	      insert: arrayInsert,
	      invalid: !!error,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(name + "[" + index + "]", index);
	        });
	      },
	      move: arrayMove,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, length - 1);
	      },
	      pristine: pristine,
	      push: arrayPush,
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, 0);
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift,
	      valid: !error
	    }
	  }, props, rest);
	};
	
	exports.default = createFieldArrayProps;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(421);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _partial2 = __webpack_require__(186);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(1207);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(1208);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(483);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(1209);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(1210);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(props, _value) {
	  var type = props.type;
	  var value = props.value;
	
	  var rest = _objectWithoutProperties(props, ['type', 'value']);
	
	  if (type === 'checkbox') {
	    return _extends({}, rest, {
	      checked: !!value,
	      type: type
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, rest, {
	      checked: value === _value,
	      type: type,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, rest, {
	      type: type,
	      value: value || []
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(getIn, name, _ref, syncError) {
	  var asyncError = _ref.asyncError;
	  var blur = _ref.blur;
	  var change = _ref.change;
	  var dirty = _ref.dirty;
	  var focus = _ref.focus;
	  var pristine = _ref.pristine;
	  var state = _ref.state;
	  var submitError = _ref.submitError;
	  var value = _ref.value;
	  var _value = _ref._value;
	  var props = _ref.props;
	
	  var rest = _objectWithoutProperties(_ref, ['asyncError', 'blur', 'change', 'dirty', 'focus', 'pristine', 'state', 'submitError', 'value', '_value', 'props']);
	
	  var defaultValue = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];
	  var asyncValidate = arguments.length <= 5 || arguments[5] === undefined ? _noop3.default : arguments[5];
	
	  var error = syncError || asyncError || submitError;
	  var onChange = (0, _createOnChange2.default)(change);
	  return processProps(_extends({
	    active: state && !!getIn(state, 'active'),
	    dirty: dirty,
	    error: error,
	    invalid: !!error,
	    name: name,
	    onBlur: (0, _createOnBlur2.default)(blur, (0, _partial3.default)(asyncValidate, name)),
	    onChange: onChange,
	    onDragStart: (0, _createOnDragStart2.default)(name, value),
	    onDrop: (0, _createOnDrop2.default)(name, change),
	    onFocus: (0, _createOnFocus2.default)(name, focus),
	    onUpdate: onChange,
	    pristine: pristine,
	    touched: !!(state && getIn(state, 'touched')),
	    valid: !error,
	    value: value == null ? defaultValue : value,
	    visited: state && !!getIn(state, 'visited')
	  }, props, rest), _value);
	};
	
	exports.default = createFieldProps;

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized;
	  var trigger = _ref.trigger;
	  var
	  // blurredField,  // not used in default implementation
	  pristine = _ref.pristine;
	  var syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	
	exports.default = defaultShouldAsyncValidate;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(187);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual;
	  var empty = _ref.empty;
	  var getIn = _ref.getIn;
	  var deleteIn = _ref.deleteIn;
	  var setIn = _ref.setIn;
	
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path, undefined) : state;
	    }
	    var result = deleteIn(state, path);
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	};
	
	exports.default = createDeleteInWithCleanUp;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(484);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(487);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(blur, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, _isReactNative2.default);
	    blur(value);
	    if (afterBlur) {
	      afterBlur(value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(484);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(487);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(change) {
	  return function (event) {
	    return change((0, _getValue2.default)(event, _isReactNative2.default));
	  };
	};
	
	exports.default = createOnChange;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createOnDragStart = __webpack_require__(483);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(486);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(30);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(147);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length <= 1 || arguments[1] === undefined ? function (state) {
	      return getIn(state, 'form');
	    } : arguments[1];
	
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ?
	      // only selecting one field, so return its value
	      getIn(getFormState(state), form + '.values.' + fields[0]) :
	      // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(getFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(250);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(481);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch;
	  var startSubmit = props.startSubmit;
	  var stopSubmit = props.stopSubmit;
	  var setSubmitFailed = props.setSubmitFailed;
	  var syncErrors = props.syncErrors;
	  var returnRejectedSubmitPromise = props.returnRejectedSubmitPromise;
	  var touch = props.touch;
	  var values = props.values;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          return submitResult;
	        }).catch(function (submitError) {
	          stopSubmit(submitError instanceof _SubmissionError2.default ? submitError.errors : undefined);
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(doSubmit, function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (returnRejectedSubmitPromise) {
	          return Promise.reject(asyncErrors);
	        }
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	
	    if (returnRejectedSubmitPromise) {
	      return Promise.reject(syncErrors);
	    }
	  }
	};
	
	exports.default = handleSubmit;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIn = __webpack_require__(488);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getErrorKey = function getErrorKey(name, type) {
	  switch (type) {
	    case 'Field':
	      return name;
	    case 'FieldArray':
	      return name + '._error';
	  }
	};
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	    var errorKey = getErrorKey(name, type);
	    var syncError = (0, _getIn2.default)(syncErrors, errorKey);
	    if (syncError && typeof syncError === 'string') {
	      return true;
	    }
	    var asyncError = getIn(asyncErrors, errorKey);
	    if (asyncError && typeof asyncError === 'string') {
	      return true;
	    }
	    var submitError = getIn(submitErrors, errorKey);
	    if (submitError && typeof submitError === 'string') {
	      return true;
	    }
	
	    return false;
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasErrors = function createHasErrors(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasErrors = function hasErrors(errors) {
	    if (!errors) {
	      return false;
	    }
	    var globalError = getIn(errors, '_error');
	    if (globalError) {
	      return true;
	    }
	    if (typeof errors === 'string') {
	      return !!errors;
	    }
	    return false;
	  };
	  return hasErrors;
	};
	
	exports.default = createHasErrors;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var any = _react.PropTypes.any;
	var bool = _react.PropTypes.bool;
	var func = _react.PropTypes.func;
	var propTypes = exports.propTypes = {
	  // State:
	  asyncValidating: bool.isRequired, // true if async validation is running
	  autofilled: bool, // true if set programmatically by autofill
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  invalid: bool.isRequired, // true if there are any validation errors
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  valid: bool.isRequired, // true if there are no validation errors
	
	  // Actions:
	  asyncValidate: func.isRequired, // function to trigger async validation
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  untouch: func.isRequired // action to mark fields as untouched
	};

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(296);
	
	var _deleteInWithCleanUp = __webpack_require__(1206);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createReducer = function createReducer(structure) {
	  var _behaviors;
	
	  var splice = structure.splice;
	  var empty = structure.empty;
	  var getIn = structure.getIn;
	  var setIn = structure.setIn;
	  var deleteIn = structure.deleteIn;
	  var fromJS = structure.fromJS;
	  var size = structure.size;
	  var some = structure.some;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, empty);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, empty);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, empty);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta;
	    var field = _ref$meta.field;
	    var index = _ref$meta.index;
	    var payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta;
	    var field = _ref2$meta.field;
	    var from = _ref2$meta.from;
	    var to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field;
	    var payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta;
	    var field = _ref5$meta.field;
	    var index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta;
	    var field = _ref8$meta.field;
	    var index = _ref8$meta.index;
	    var removeNum = _ref8$meta.removeNum;
	    var payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta;
	    var field = _ref9$meta.field;
	    var indexA = _ref9$meta.indexA;
	    var indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field;
	    var payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref11) {
	    var _ref11$meta = _ref11.meta;
	    var field = _ref11$meta.field;
	    var touch = _ref11$meta.touch;
	    var payload = _ref11.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta;
	    var field = _ref12$meta.field;
	    var touch = _ref12$meta.touch;
	    var payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref13) {
	    var field = _ref13.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref14) {
	    var payload = _ref14.payload;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    result = setIn(result, 'values', mapData);
	    result = setIn(result, 'initial', mapData);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref15) {
	    var _ref15$payload = _ref15.payload;
	    var name = _ref15$payload.name;
	    var type = _ref15$payload.type;
	
	    var result = state;
	    var registeredFields = getIn(result, 'registeredFields');
	    if (some(registeredFields, function (field) {
	      return getIn(field, 'name') === name;
	    })) {
	      return state;
	    }
	
	    var mapData = fromJS({ name: name, type: type });
	    result = setIn(state, 'registeredFields', splice(registeredFields, size(registeredFields), 0, mapData));
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref16) {
	    var field = _ref16.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref17) {
	    var payload = _ref17.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error;
	
	      var fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'asyncErrors');
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref18) {
	    var payload = _ref18.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error;
	
	      var fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref19) {
	    var fields = _ref19.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref20) {
	    var fields = _ref20.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref21) {
	    var name = _ref21.payload.name;
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    // in case the form was destroyed and registeredFields no longer exists
	    if (!registeredFields) {
	      return state;
	    }
	
	    var fieldIndex = registeredFields.findIndex(function (value) {
	      return getIn(value, 'name') === name;
	    });
	    if (size(registeredFields) <= 1 && fieldIndex >= 0) {
	      return deleteInWithCleanUp(state, 'registeredFields');
	    }
	    return setIn(state, 'registeredFields', splice(registeredFields, fieldIndex, 1));
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? empty : arguments[0];
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length <= 0 || arguments[0] === undefined ? empty : arguments[0];
	      var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var form = action && action.meta && action.meta.form;
	      if (!form) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY) {
	        return deleteInWithCleanUp(state, action.meta.form);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length <= 0 || arguments[0] === undefined ? empty : arguments[0];
	        var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action);
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	};
	
	exports.default = createReducer;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(1026);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _partial2 = __webpack_require__(186);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _mapValues2 = __webpack_require__(267);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _hoistNonReactStatics = __webpack_require__(1225);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactRedux = __webpack_require__(4);
	
	var _redux = __webpack_require__(106);
	
	var _isPromise = __webpack_require__(250);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _getDisplayName = __webpack_require__(1223);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _actions = __webpack_require__(482);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _handleSubmit = __webpack_require__(1213);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _silenceEvent = __webpack_require__(486);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(1211);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _asyncValidation = __webpack_require__(1201);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _hasErrors = __webpack_require__(1215);
	
	var _hasErrors2 = _interopRequireDefault(_hasErrors);
	
	var _hasError = __webpack_require__(1214);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	var _defaultShouldAsyncValidate = __webpack_require__(1205);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _plain = __webpack_require__(147);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	var arrayInsert = importedActions.arrayInsert;
	var arrayPop = importedActions.arrayPop;
	var arrayPush = importedActions.arrayPush;
	var arrayRemove = importedActions.arrayRemove;
	var arrayShift = importedActions.arrayShift;
	var arraySplice = importedActions.arraySplice;
	var arraySwap = importedActions.arraySwap;
	var arrayUnshift = importedActions.arrayUnshift;
	var blur = importedActions.blur;
	var change = importedActions.change;
	var focus = importedActions.focus;
	
	var formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialized', 'initialValues', 'syncErrors', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual;
	  var empty = structure.empty;
	  var getIn = structure.getIn;
	  var setIn = structure.setIn;
	  var fromJS = structure.fromJS;
	  var some = structure.some;
	
	  var hasErrors = (0, _hasErrors2.default)(structure);
	  var hasError = (0, _hasError2.default)(structure);
	  var plainHasErrors = (0, _hasErrors2.default)(_plain2.default);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, initialConfig);
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form(props) {
	          _classCallCheck(this, Form);
	
	          var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Form).call(this, props));
	
	          _this.submit = _this.submit.bind(_this);
	          _this.reset = _this.reset.bind(_this);
	          _this.asyncValidate = _this.asyncValidate.bind(_this);
	          _this.getSyncErrors = _this.getSyncErrors.bind(_this);
	          _this.register = _this.register.bind(_this);
	          _this.unregister = _this.unregister.bind(_this);
	          _this.submitCompleted = _this.submitCompleted.bind(_this);
	          return _this;
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getSyncErrors: this.getSyncErrors,
	                register: this.register,
	                unregister: this.unregister
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(_ref) {
	            var initialize = _ref.initialize;
	            var initialized = _ref.initialized;
	            var initialValues = _ref.initialValues;
	
	            if (initialValues && !initialized) {
	              initialize(initialValues);
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded(this.props);
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              return ! ~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props = this.props;
	            var destroyOnUnmount = _props.destroyOnUnmount;
	            var destroy = _props.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'getSyncErrors',
	          value: function getSyncErrors() {
	            return this.props.syncErrors;
	          }
	        }, {
	          key: 'register',
	          value: function register(name, type) {
	            this.props.registerField(name, type);
	          }
	        }, {
	          key: 'unregister',
	          value: function unregister(name) {
	            if (!this.destroyed) {
	              this.props.unregisterField(name);
	            }
	          }
	        }, {
	          key: 'asyncValidate',
	          value: function asyncValidate(name, value) {
	            var _this4 = this;
	
	            var _props2 = this.props;
	            var asyncBlurFields = _props2.asyncBlurFields;
	            var asyncErrors = _props2.asyncErrors;
	            var asyncValidate = _props2.asyncValidate;
	            var dispatch = _props2.dispatch;
	            var initialized = _props2.initialized;
	            var pristine = _props2.pristine;
	            var shouldAsyncValidate = _props2.shouldAsyncValidate;
	            var startAsyncValidation = _props2.startAsyncValidation;
	            var stopAsyncValidation = _props2.stopAsyncValidation;
	            var syncErrors = _props2.syncErrors;
	            var values = _props2.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var _ret = function () {
	                var valuesToValidate = submitting ? values : setIn(values, name, value);
	                var syncValidationPasses = submitting || !getIn(syncErrors, name);
	                var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	                if ((isBlurredField || submitting) && shouldAsyncValidate({
	                  asyncErrors: asyncErrors,
	                  initialized: initialized,
	                  trigger: submitting ? 'submit' : 'blur',
	                  blurredField: name,
	                  pristine: pristine,
	                  syncValidationPasses: syncValidationPasses
	                })) {
	                  return {
	                    v: (0, _asyncValidation2.default)(function () {
	                      return asyncValidate(valuesToValidate, dispatch, _this4.props);
	                    }, startAsyncValidation, stopAsyncValidation, name)
	                  };
	                }
	              }();
	
	              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            }
	          }
	        }, {
	          key: 'submitCompleted',
	          value: function submitCompleted(result) {
	            delete this.submitPromise;
	            return result;
	          }
	        }, {
	          key: 'listenToSubmit',
	          value: function listenToSubmit(promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            this.submitPromise = promise;
	            return promise.then(this.submitCompleted, this.submitCompleted);
	          }
	        }, {
	          key: 'submit',
	          value: function submit(submitOrEvent) {
	            var _this5 = this;
	
	            var onSubmit = this.props.onSubmit;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!this.submitPromise) {
	                return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), this.props, this.valid, this.asyncValidate, this.fieldList));
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this5.submitPromise && _this5.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _this5.props, _this5.valid, _this5.asyncValidate, _this5.fieldList));
	              });
	            }
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            this.props.reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            var _props3 = this.props;
	            var arrayInsert = _props3.arrayInsert;
	            var arrayPop = _props3.arrayPop;
	            var arrayPush = _props3.arrayPush;
	            var arrayRemove = _props3.arrayRemove;
	            var arrayShift = _props3.arrayShift;
	            var arraySplice = _props3.arraySplice;
	            var arraySwap = _props3.arraySwap;
	            var arrayUnshift = _props3.arrayUnshift;
	            var asyncErrors = _props3.asyncErrors;
	            var reduxMountPoint = _props3.reduxMountPoint;
	            var destroyOnUnmount = _props3.destroyOnUnmount;
	            var getFormState = _props3.getFormState;
	            var touchOnBlur = _props3.touchOnBlur;
	            var touchOnChange = _props3.touchOnChange;
	            var syncErrors = _props3.syncErrors;
	            var values = _props3.values;
	            var registerField = _props3.registerField;
	            var unregisterField = _props3.unregisterField;
	
	            var passableProps = _objectWithoutProperties(_props3, ['arrayInsert', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'reduxMountPoint', 'destroyOnUnmount', 'getFormState', 'touchOnBlur', 'touchOnChange', 'syncErrors', 'values', 'registerField', 'unregisterField']); // eslint-disable-line no-redeclare
	
	
	            if (isClassComponent(WrappedComponent)) {
	              passableProps.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, _extends({}, passableProps, {
	              handleSubmit: this.submit
	            }));
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.props.values;
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.props.valid;
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return this.props.invalid;
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return this.props.dirty;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.props.pristine;
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            return this.props.registeredFields.map(function (field) {
	              return getIn(field, 'name');
	            });
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _react.PropTypes.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _react.PropTypes.bool,
	        form: _react.PropTypes.string.isRequired,
	        initialValues: _react.PropTypes.object,
	        getFormState: _react.PropTypes.func,
	        validate: _react.PropTypes.func,
	        touchOnBlur: _react.PropTypes.bool,
	        touchOnChange: _react.PropTypes.bool,
	        registeredFields: _react.PropTypes.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form;
	        var getFormState = props.getFormState;
	        var initialValues = props.initialValues;
	        var validate = props.validate;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initial = initialValues || stateInitial || empty;
	        var values = getIn(formState, 'values') || initial;
	        var pristine = deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var submitErrors = getIn(formState, 'submitErrors');
	        var syncErrors = validate && validate(values, props) || {};
	        var hasSyncErrors = plainHasErrors(syncErrors);
	        var hasAsyncErrors = hasErrors(asyncErrors);
	        var hasSubmitErrors = hasErrors(submitErrors);
	        var valid = !hasSyncErrors && !hasAsyncErrors && !hasSubmitErrors && !some(getIn(formState, 'registeredFields'), function (field) {
	          return hasError(field, syncErrors, asyncErrors, submitErrors);
	        });
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var error = getIn(formState, 'error');
	        var registeredFields = getIn(formState, 'registeredFields');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating'),
	          dirty: !pristine,
	          error: error,
	          initialized: !!stateInitial,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          syncErrors: syncErrors,
	          values: values,
	          valid: valid
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return (0, _partial3.default)(actionCreator, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = (0, _partialRight3.default)(bindForm(blur), !!initialProps.touchOnBlur);
	        var boundChange = (0, _partialRight3.default)(bindForm(change), !!initialProps.touchOnChange);
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, Object.getPrototypeOf(ReduxForm).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props4 = this.props;
	            var initialValues = _props4.initialValues;
	
	            var rest = _objectWithoutProperties(_props4, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().valid;
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().invalid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().pristine;
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().dirty;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().values;
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().fieldList;
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testing
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(1022);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj == other) return true;
	  if (obj == null && other === '') return true;
	  if (obj === '' && other == null) return true;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(187);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var deleteInWithPath = function deleteInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (state === undefined || first === undefined) {
	    return state;
	  }
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (first < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	        if (result !== state[first]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[first] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array');
	    }
	    if (first < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(first, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	};
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(187);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var setInWithPath = function setInWithPath(state, value, first) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  if (first === undefined) {
	    return value;
	  }
	  var next = setInWithPath.apply(undefined, [state && state[first], value].concat(rest));
	  if (!state) {
	    var initialized = isNaN(first) ? {} : [];
	    initialized[first] = next;
	    return initialized;
	  }
	  if (Array.isArray(state)) {
	    var copy = [].concat(_toConsumableArray(state));
	    copy[first] = next;
	    return copy;
	  }
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath.apply(undefined, [state, value].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = setIn;

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice() {
	  var array = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	  var index = arguments[1];
	  var removeNum = arguments[2];
	  var value = arguments[3];
	
	  var copy = [].concat(_toConsumableArray(array));
	  if (removeNum) {
	    copy.splice(index, removeNum); // removing
	  } else {
	      if (index < copy.length) {
	        copy.splice(index, 0, value); // adding
	      } else {
	          copy[index] = value; // outside range, so just set it
	        }
	    }
	  return copy;
	};
	
	exports.default = splice;

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config);
	
	    var form = _prop$getFormState$co.form;
	    var prop = _prop$getFormState$co.prop;
	    var getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }, function () {
	      return {};
	    } // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(489);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(490);
	
	var _isPlainObject = __webpack_require__(419);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(491);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _off = _interopRequireDefault(__webpack_require__(787));
	
	var _on = _interopRequireDefault(__webpack_require__(788));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(789));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(790));
	
	var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(353));
	
	var _invariant = _interopRequireDefault(__webpack_require__(30));
	
	var _utils = __webpack_require__(1232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable no-underscore-dangle */
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = /*#__PURE__*/function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    this._restoreScrollRestoration = function () {
	      /* istanbul ignore if: not supported by any browsers on Travis */
	      if (_this._oldScrollRestoration) {
	        try {
	          window.history.scrollRestoration = _this._oldScrollRestoration;
	        } catch (e) {
	          /* silence */
	        }
	      }
	    };
	
	    this._onWindowScroll = function () {
	      if (_this._ignoreScrollEvents) {
	        // Don't save the scroll position until the transition is complete
	        return;
	      } // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	
	
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _this$_windowScrollTa = _this._windowScrollTarget,
	            xTarget = _this$_windowScrollTa[0],
	            yTarget = _this$_windowScrollTa[1];
	        var x = (0, _scrollLeft["default"])(window);
	        var y = (0, _scrollTop["default"])(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null; // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	
	      /* istanbul ignore if: paranoid guard */
	
	      if (!_this._windowScrollTarget) {
	        return Promise.resolve();
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	      /* istanbul ignore if: paranoid guard */
	
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        // This might happen if the scroll position was already set to the target
	        _this._windowScrollTarget = null;
	        return Promise.resolve();
	      }
	
	      return new Promise(function (resolve) {
	        _this._checkWindowScrollHandle = (0, _requestAnimationFrame["default"])(function () {
	          return resolve(_this._checkWindowScrollPosition());
	        });
	      });
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll; // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	
	    /* istanbul ignore else: Travis browsers all support this */
	
	    if ('scrollRestoration' in window.history && // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	
	      try {
	        window.history.scrollRestoration = 'manual'; // Scroll restoration persists across page reloads. We want to reset
	        // this to the original value, so that we can let the browser handle
	        // restoring the initial scroll position on server-rendered pages.
	
	        (0, _on["default"])(window, 'beforeunload', this._restoreScrollRestoration);
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	    this._ignoreScrollEvents = false;
	    this._scrollElements = {}; // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	
	    (0, _on["default"])(window, 'scroll', this._onWindowScroll);
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame["default"].cancel(_this._saveWindowPositionHandle);
	
	      _this._saveWindowPositionHandle = null;
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	
	        _requestAnimationFrame["default"].cancel(scrollElement.savePositionHandle);
	
	        scrollElement.savePositionHandle = null; // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	
	        if (!_this._ignoreScrollEvents) {
	          _this._saveElementPosition(key);
	        }
	      });
	    });
	  }
	
	  var _proto = ScrollBehavior.prototype;
	
	  _proto.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : invariant(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle && !_this2._ignoreScrollEvents) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	        }
	      }
	    }; // In case no scrolling occurs, save the initial position
	
	    if (!scrollElement.savePositionHandle && !this._ignoreScrollEvents) {
	      scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	    }
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on["default"])(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  _proto.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : invariant(false) : void 0;
	    var _this$_scrollElements = this._scrollElements[key],
	        element = _this$_scrollElements.element,
	        onScroll = _this$_scrollElements.onScroll,
	        savePositionHandle = _this$_scrollElements.savePositionHandle;
	    (0, _off["default"])(element, 'scroll', onScroll);
	
	    _requestAnimationFrame["default"].cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  _proto.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context).then(function () {
	      // Save the position immediately after a transition so that if no
	      // scrolling occurs, there is still a saved position
	      if (!_this3._saveWindowPositionHandle) {
	        _this3._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this3._saveWindowPosition);
	      }
	    });
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  _proto.stop = function stop() {
	    this._restoreScrollRestoration();
	
	    (0, _off["default"])(window, 'scroll', this._onWindowScroll);
	
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  _proto.startIgnoringScrollEvents = function startIgnoringScrollEvents() {
	    this._ignoreScrollEvents = true;
	  };
	
	  _proto.stopIgnoringScrollEvents = function stopIgnoringScrollEvents() {
	    this._ignoreScrollEvents = false;
	  };
	
	  _proto._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame["default"].cancel(this._checkWindowScrollHandle);
	
	    this._checkWindowScrollHandle = null;
	  };
	
	  _proto._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  _proto._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft["default"])(element), (0, _scrollTop["default"])(element)]);
	  };
	
	  _proto._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context); // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	
	    this._numWindowScrollAttempts = 0;
	    return this._checkWindowScrollPosition();
	  };
	
	  _proto._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _this$_scrollElements2 = this._scrollElements[key],
	        element = _this$_scrollElements2.element,
	        shouldUpdateScroll = _this$_scrollElements2.shouldUpdateScroll;
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	
	    if (!scrollTarget) {
	      return;
	    } // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	
	
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  _proto._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	
	    return [0, 0];
	  };
	
	  _proto._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  _proto._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  _proto.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      } // Fallback to scrolling to top when target fragment doesn't exist.
	
	
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	    (0, _scrollLeft["default"])(element, left);
	    (0, _scrollTop["default"])(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports["default"] = ScrollBehavior;
	module.exports = exports.default;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	
	function isMobileSafari() {
	  return /iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent);
	}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	module.exports = typeof setImmediate === 'function' ? setImmediate :
		function setImmediate() {
			var args = [].slice.apply(arguments);
			args.splice(1, 0, 0);
			setTimeout.apply(null, args);
		};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(495).setImmediate))

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["sourceMappedStackTrace"] = factory();
		else
			root["sourceMappedStackTrace"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
		 * sourcemapped-stacktrace.js
		 * created by James Salter <iteration@gmail.com> (2014)
		 *
		 * https://github.com/novocaine/sourcemapped-stacktrace
		 *
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		/*global define */
	
		// note we only include source-map-consumer, not the whole source-map library,
		// which includes gear for generating source maps that we don't need
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(source_map_consumer) {
	
		  var global_mapForUri = {};
	
		  /**
		   * Re-map entries in a stacktrace using sourcemaps if available.
		   *
		   * @param {str} stack - The stacktrace from the browser.
		   * @param {function} done - Callback invoked with the transformed stacktrace
		   *                          (an Array of Strings) passed as the first
		   *                          argument
		   * @param {Object} [opts] - Optional options object.
		   * @param {Function} [opts.filter] - Filter function applied to each stackTrace line.
		   *                                   Lines which do not pass the filter won't be processesd.
		   * @param {boolean} [opts.cacheGlobally] - Whether to cache sourcemaps globally across multiple calls.
		   * @param {boolean} [opts.sync] - Whether to use synchronous ajax to load the sourcemaps.
		   * @param {string} [opts.traceFormat] - If `error.stack` is formatted according to chrome or
		   *                                      Firefox's style.  Can be either `"chrome"`, `"firefox"`
		   *                                      or `undefined` (default).  If `undefined`, this library
		   *                                      will guess based on `navigator.userAgent`.
		   */
		  var mapStackTrace = function(stack, done, opts) {
		    var lines;
		    var line;
		    var mapForUri = {};
		    var rows = {};
		    var fields;
		    var uri;
		    var expected_fields;
		    var regex;
		    var skip_lines;
	
		    var fetcher = new Fetcher(opts);
	
		    var traceFormat = opts && opts.traceFormat;
		    if (traceFormat !== "chrome" && traceFormat !== "firefox") {
		      if (traceFormat) {
		        throw new Error("unknown traceFormat \"" + traceFormat + "\" :(");
		      } else if (isChromeOrEdge() || isIE11Plus()) {
		        traceFormat = "chrome";
		      } else if (isFirefox() || isSafari()) {
		        traceFormat = "firefox";
		      } else {
		        throw new Error("unknown browser :(");
		      }
		    }
	
		    if (traceFormat === "chrome") {
		      regex = /^ +at.+\((.*):([0-9]+):([0-9]+)/;
		      expected_fields = 4;
		      // (skip first line containing exception message)
		      skip_lines = 1;
		    } else {
		      regex = /@(.*):([0-9]+):([0-9]+)/;
		      expected_fields = 4;
		      skip_lines = 0;
		    }
	
		    lines = stack.split("\n").slice(skip_lines);
	
		    for (var i=0; i < lines.length; i++) {
		      line = lines[i];
		      if ( opts && opts.filter && !opts.filter(line) ) continue;
		      
		      fields = line.match(regex);
		      if (fields && fields.length === expected_fields) {
		        rows[i] = fields;
		        uri = fields[1];
		        if (!uri.match(/<anonymous>/)) {
		          fetcher.fetchScript(uri);
		        }
		      }
		    }
	
		    fetcher.sem.whenReady(function() {
		      var result = processSourceMaps(lines, rows, fetcher.mapForUri, traceFormat);
		      done(result);
		    });
		  };
	
		  var isChromeOrEdge = function() {
		    return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
		  };
	
		  var isFirefox = function() {
		    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
		  };  
	
		  var isSafari = function() {
		    return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
		  };
				
		  var isIE11Plus = function() {
		   	return document.documentMode && document.documentMode >= 11;
		  };
	
	
		  var Semaphore = function() {
		    this.count = 0;
		    this.pending = [];
		  };
	
		  Semaphore.prototype.incr = function() {
		    this.count++;
		  };
	
		  Semaphore.prototype.decr = function() {
		    this.count--;
		    this.flush();
		  };
	
		  Semaphore.prototype.whenReady = function(fn) {
		    this.pending.push(fn);
		    this.flush();
		  };
	
		  Semaphore.prototype.flush = function() {
		    if (this.count === 0) {
		        this.pending.forEach(function(fn) { fn(); });
		        this.pending = [];
		    }
		  };
	
	
		  var Fetcher = function(opts) {
		    this.sem = new Semaphore();
		    this.sync = opts && opts.sync;
		    this.mapForUri = opts && opts.cacheGlobally ? global_mapForUri : {};
		  };
	
		  Fetcher.prototype.ajax = function(uri, callback) {
		    var xhr = createXMLHTTPObject();
		    var that = this;
		    xhr.onreadystatechange = function() {
		      if (xhr.readyState == 4) {
		        callback.call(that, xhr, uri);
		      }
		    };
		    xhr.open("GET", uri, !this.sync);
		    xhr.send();
		  }
	
		  Fetcher.prototype.fetchScript = function(uri) {
		    if (!(uri in this.mapForUri)) {
		      this.sem.incr();
		      this.mapForUri[uri] = null;
		    } else {
		      return;
		    }
	
		    this.ajax(uri, this.onScriptLoad);
		  };
	
		  var absUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
	
		  Fetcher.prototype.onScriptLoad = function(xhr, uri) {
		    if (xhr.status === 200 || (uri.slice(0, 7) === "file://" && xhr.status === 0)) {
		      // find .map in file.
		      //
		      // attempt to find it at the very end of the file, but tolerate trailing
		      // whitespace inserted by some packers.
		      var match = xhr.responseText.match("//# [s]ourceMappingURL=(.*)[\\s]*$", "m");
		      if (match && match.length === 2) {
		        // get the map
		        var mapUri = match[1];
	
		        var embeddedSourceMap = mapUri.match("data:application/json;(charset=[^;]+;)?base64,(.*)");
	
		        if (embeddedSourceMap && embeddedSourceMap[2]) {
		          this.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(atob(embeddedSourceMap[2]));
		          this.sem.decr();
		        } else {
		          if (!absUrlRegex.test(mapUri)) {
		            // relative url; according to sourcemaps spec is 'source origin'
		            var origin;
		            var lastSlash = uri.lastIndexOf('/');
		            if (lastSlash !== -1) {
		              origin = uri.slice(0, lastSlash + 1);
		              mapUri = origin + mapUri;
		              // note if lastSlash === -1, actual script uri has no slash
		              // somehow, so no way to use it as a prefix... we give up and try
		              // as absolute
		            }
		          }
	
		          this.ajax(mapUri, function(xhr) {
		            if (xhr.status === 200 || (mapUri.slice(0, 7) === "file://" && xhr.status === 0)) {
		              this.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(xhr.responseText);
		            }
		            this.sem.decr();
		          });
		        }
		      } else {
		        // no map
		        this.sem.decr();
		      }
		    } else {
		      // HTTP error fetching uri of the script
		      this.sem.decr();
		    }
		  };
	
		  var processSourceMaps = function(lines, rows, mapForUri, traceFormat) {
		    var result = [];
		    var map;
		    var origName = traceFormat === "chrome" ? origNameChrome : origNameFirefox;
		    for (var i=0; i < lines.length; i++) {
		      var row = rows[i];
		      if (row) {
		        var uri = row[1];
		        var line = parseInt(row[2], 10);
		        var column = parseInt(row[3], 10);
		        map = mapForUri[uri];
	
		        if (map) {
		          // we think we have a map for that uri. call source-map library
		          var origPos = map.originalPositionFor(
		            { line: line, column: column });
		          result.push(formatOriginalPosition(origPos.source,
		            origPos.line, origPos.column, origPos.name || origName(lines[i])));
		        } else {
		          // we can't find a map for that url, but we parsed the row.
		          // reformat unchanged line for consistency with the sourcemapped
		          // lines.
		          result.push(formatOriginalPosition(uri, line, column, origName(lines[i])));
		        }
		      } else {
		        // we weren't able to parse the row, push back what we were given
		        result.push(lines[i]);
		      }
		    }
	
		    return result;
		  };
	
		  function origNameChrome(origLine) {
		    var match = / +at +([^ ]*).*/.exec(origLine);
		    return match && match[1];
		  }
	
		  function origNameFirefox(origLine) {
		    var match = /([^@]*)@.*/.exec(origLine);
		    return match && match[1];
		  }
	
		  var formatOriginalPosition = function(source, line, column, name) {
		    // mimic chrome's format
		    return "    at " + (name ? name : "(unknown)") +
		      " (" + source + ":" + line + ":" + column + ")";
		  };
	
		  // xmlhttprequest boilerplate
		  var XMLHttpFactories = [
			function () {return new XMLHttpRequest();},
			function () {return new ActiveXObject("Msxml2.XMLHTTP");},
			function () {return new ActiveXObject("Msxml3.XMLHTTP");},
			function () {return new ActiveXObject("Microsoft.XMLHTTP");}
		  ];
	
		  function createXMLHTTPObject() {
		      var xmlhttp = false;
		      for (var i=0;i<XMLHttpFactories.length;i++) {
		          try {
		              xmlhttp = XMLHttpFactories[i]();
		          }
		          catch (e) {
		              continue;
		          }
		          break;
		      }
		      return xmlhttp;
		  }
	
		  return {
		    mapStackTrace: mapStackTrace
		  }
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(2);
		var binarySearch = __webpack_require__(3);
		var ArraySet = __webpack_require__(4).ArraySet;
		var base64VLQ = __webpack_require__(5);
		var quickSort = __webpack_require__(7).quickSort;
	
		function SourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  return sourceMap.sections != null
		    ? new IndexedSourceMapConsumer(sourceMap)
		    : new BasicSourceMapConsumer(sourceMap);
		}
	
		SourceMapConsumer.fromSourceMap = function(aSourceMap) {
		  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
		}
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		SourceMapConsumer.prototype._version = 3;
	
		// `__generatedMappings` and `__originalMappings` are arrays that hold the
		// parsed mapping coordinates from the source map's "mappings" attribute. They
		// are lazily instantiated, accessed via the `_generatedMappings` and
		// `_originalMappings` getters respectively, and we only parse the mappings
		// and create these arrays once queried for a source location. We jump through
		// these hoops because there can be many thousands of mappings, and parsing
		// them is expensive, so we only want to do it if we must.
		//
		// Each object in the arrays is of the form:
		//
		//     {
		//       generatedLine: The line number in the generated code,
		//       generatedColumn: The column number in the generated code,
		//       source: The path to the original source file that generated this
		//               chunk of code,
		//       originalLine: The line number in the original source that
		//                     corresponds to this chunk of generated code,
		//       originalColumn: The column number in the original source that
		//                       corresponds to this chunk of generated code,
		//       name: The name of the original symbol which generated this chunk of
		//             code.
		//     }
		//
		// All properties except for `generatedLine` and `generatedColumn` can be
		// `null`.
		//
		// `_generatedMappings` is ordered by the generated positions.
		//
		// `_originalMappings` is ordered by the original positions.
	
		SourceMapConsumer.prototype.__generatedMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
		  get: function () {
		    if (!this.__generatedMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__generatedMappings;
		  }
		});
	
		SourceMapConsumer.prototype.__originalMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
		  get: function () {
		    if (!this.__originalMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__originalMappings;
		  }
		});
	
		SourceMapConsumer.prototype._charIsMappingSeparator =
		  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
		    var c = aStr.charAt(index);
		    return c === ";" || c === ",";
		  };
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		SourceMapConsumer.prototype._parseMappings =
		  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    throw new Error("Subclasses must implement _parseMappings");
		  };
	
		SourceMapConsumer.GENERATED_ORDER = 1;
		SourceMapConsumer.ORIGINAL_ORDER = 2;
	
		SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
		SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Iterate over each mapping between an original source/line/column and a
		 * generated line/column in this source map.
		 *
		 * @param Function aCallback
		 *        The function that is called with each mapping.
		 * @param Object aContext
		 *        Optional. If specified, this object will be the value of `this` every
		 *        time that `aCallback` is called.
		 * @param aOrder
		 *        Either `SourceMapConsumer.GENERATED_ORDER` or
		 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
		 *        iterate over the mappings sorted by the generated file's line/column
		 *        order or the original's source/line/column order, respectively. Defaults to
		 *        `SourceMapConsumer.GENERATED_ORDER`.
		 */
		SourceMapConsumer.prototype.eachMapping =
		  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
		    var context = aContext || null;
		    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
		    var mappings;
		    switch (order) {
		    case SourceMapConsumer.GENERATED_ORDER:
		      mappings = this._generatedMappings;
		      break;
		    case SourceMapConsumer.ORIGINAL_ORDER:
		      mappings = this._originalMappings;
		      break;
		    default:
		      throw new Error("Unknown order of iteration.");
		    }
	
		    var sourceRoot = this.sourceRoot;
		    mappings.map(function (mapping) {
		      var source = mapping.source === null ? null : this._sources.at(mapping.source);
		      if (source != null && sourceRoot != null) {
		        source = util.join(sourceRoot, source);
		      }
		      return {
		        source: source,
		        generatedLine: mapping.generatedLine,
		        generatedColumn: mapping.generatedColumn,
		        originalLine: mapping.originalLine,
		        originalColumn: mapping.originalColumn,
		        name: mapping.name === null ? null : this._names.at(mapping.name)
		      };
		    }, this).forEach(aCallback, context);
		  };
	
		/**
		 * Returns all generated line and column information for the original source,
		 * line, and column provided. If no column is provided, returns all mappings
		 * corresponding to a either the line we are searching for or the next
		 * closest line that has any mappings. Otherwise, returns all mappings
		 * corresponding to the given line and either the column we are searching for
		 * or the next closest column that has any offsets.
		 *
		 * The only argument is an object with the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: Optional. the column number in the original source.
		 *
		 * and an array of objects is returned, each with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		SourceMapConsumer.prototype.allGeneratedPositionsFor =
		  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
		    var line = util.getArg(aArgs, 'line');
	
		    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
		    // returns the index of the closest mapping less than the needle. By
		    // setting needle.originalColumn to 0, we thus find the last mapping for
		    // the given line, provided such a mapping exists.
		    var needle = {
		      source: util.getArg(aArgs, 'source'),
		      originalLine: line,
		      originalColumn: util.getArg(aArgs, 'column', 0)
		    };
	
		    if (this.sourceRoot != null) {
		      needle.source = util.relative(this.sourceRoot, needle.source);
		    }
		    if (!this._sources.has(needle.source)) {
		      return [];
		    }
		    needle.source = this._sources.indexOf(needle.source);
	
		    var mappings = [];
	
		    var index = this._findMapping(needle,
		                                  this._originalMappings,
		                                  "originalLine",
		                                  "originalColumn",
		                                  util.compareByOriginalPositions,
		                                  binarySearch.LEAST_UPPER_BOUND);
		    if (index >= 0) {
		      var mapping = this._originalMappings[index];
	
		      if (aArgs.column === undefined) {
		        var originalLine = mapping.originalLine;
	
		        // Iterate until either we run out of mappings, or we run into
		        // a mapping for a different line than the one we found. Since
		        // mappings are sorted, this is guaranteed to find all mappings for
		        // the line we found.
		        while (mapping && mapping.originalLine === originalLine) {
		          mappings.push({
		            line: util.getArg(mapping, 'generatedLine', null),
		            column: util.getArg(mapping, 'generatedColumn', null),
		            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		          });
	
		          mapping = this._originalMappings[++index];
		        }
		      } else {
		        var originalColumn = mapping.originalColumn;
	
		        // Iterate until either we run out of mappings, or we run into
		        // a mapping for a different line than the one we were searching for.
		        // Since mappings are sorted, this is guaranteed to find all mappings for
		        // the line we are searching for.
		        while (mapping &&
		               mapping.originalLine === line &&
		               mapping.originalColumn == originalColumn) {
		          mappings.push({
		            line: util.getArg(mapping, 'generatedLine', null),
		            column: util.getArg(mapping, 'generatedColumn', null),
		            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		          });
	
		          mapping = this._originalMappings[++index];
		        }
		      }
		    }
	
		    return mappings;
		  };
	
		exports.SourceMapConsumer = SourceMapConsumer;
	
		/**
		 * A BasicSourceMapConsumer instance represents a parsed source map which we can
		 * query for information about the original file positions by giving it a file
		 * position in the generated source.
		 *
		 * The only parameter is the raw source map (either as a JSON string, or
		 * already parsed to an object). According to the spec, source maps have the
		 * following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - sources: An array of URLs to the original source files.
		 *   - names: An array of identifiers which can be referrenced by individual mappings.
		 *   - sourceRoot: Optional. The URL root from which all sources are relative.
		 *   - sourcesContent: Optional. An array of contents of the original source files.
		 *   - mappings: A string of base64 VLQs which contain the actual mappings.
		 *   - file: Optional. The generated file this source map is associated with.
		 *
		 * Here is an example source map, taken from the source map spec[0]:
		 *
		 *     {
		 *       version : 3,
		 *       file: "out.js",
		 *       sourceRoot : "",
		 *       sources: ["foo.js", "bar.js"],
		 *       names: ["src", "maps", "are", "fun"],
		 *       mappings: "AA,AB;;ABCDE;"
		 *     }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
		 */
		function BasicSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sources = util.getArg(sourceMap, 'sources');
		  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
		  // requires the array) to play nice here.
		  var names = util.getArg(sourceMap, 'names', []);
		  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
		  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
		  var mappings = util.getArg(sourceMap, 'mappings');
		  var file = util.getArg(sourceMap, 'file', null);
	
		  // Once again, Sass deviates from the spec and supplies the version as a
		  // string rather than a number, so we use loose equality checking here.
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  sources = sources
		    .map(String)
		    // Some source maps produce relative source paths like "./foo.js" instead of
		    // "foo.js".  Normalize these first so that future comparisons will succeed.
		    // See bugzil.la/1090768.
		    .map(util.normalize)
		    // Always ensure that absolute sources are internally stored relative to
		    // the source root, if the source root is absolute. Not doing this would
		    // be particularly problematic when the source root is a prefix of the
		    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
		    .map(function (source) {
		      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
		        ? util.relative(sourceRoot, source)
		        : source;
		    });
	
		  // Pass `true` below to allow duplicate names and sources. While source maps
		  // are intended to be compressed and deduplicated, the TypeScript compiler
		  // sometimes generates source maps with duplicates in them. See Github issue
		  // #72 and bugzil.la/889492.
		  this._names = ArraySet.fromArray(names.map(String), true);
		  this._sources = ArraySet.fromArray(sources, true);
	
		  this.sourceRoot = sourceRoot;
		  this.sourcesContent = sourcesContent;
		  this._mappings = mappings;
		  this.file = file;
		}
	
		BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
		/**
		 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
		 *
		 * @param SourceMapGenerator aSourceMap
		 *        The source map that will be consumed.
		 * @returns BasicSourceMapConsumer
		 */
		BasicSourceMapConsumer.fromSourceMap =
		  function SourceMapConsumer_fromSourceMap(aSourceMap) {
		    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
		    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
		    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
		    smc.sourceRoot = aSourceMap._sourceRoot;
		    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
		                                                            smc.sourceRoot);
		    smc.file = aSourceMap._file;
	
		    // Because we are modifying the entries (by converting string sources and
		    // names to indices into the sources and names ArraySets), we have to make
		    // a copy of the entry or else bad things happen. Shared mutable state
		    // strikes again! See github issue #191.
	
		    var generatedMappings = aSourceMap._mappings.toArray().slice();
		    var destGeneratedMappings = smc.__generatedMappings = [];
		    var destOriginalMappings = smc.__originalMappings = [];
	
		    for (var i = 0, length = generatedMappings.length; i < length; i++) {
		      var srcMapping = generatedMappings[i];
		      var destMapping = new Mapping;
		      destMapping.generatedLine = srcMapping.generatedLine;
		      destMapping.generatedColumn = srcMapping.generatedColumn;
	
		      if (srcMapping.source) {
		        destMapping.source = sources.indexOf(srcMapping.source);
		        destMapping.originalLine = srcMapping.originalLine;
		        destMapping.originalColumn = srcMapping.originalColumn;
	
		        if (srcMapping.name) {
		          destMapping.name = names.indexOf(srcMapping.name);
		        }
	
		        destOriginalMappings.push(destMapping);
		      }
	
		      destGeneratedMappings.push(destMapping);
		    }
	
		    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
		    return smc;
		  };
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		BasicSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
		  get: function () {
		    return this._sources.toArray().map(function (s) {
		      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
		    }, this);
		  }
		});
	
		/**
		 * Provide the JIT with a nice shape / hidden class.
		 */
		function Mapping() {
		  this.generatedLine = 0;
		  this.generatedColumn = 0;
		  this.source = null;
		  this.originalLine = null;
		  this.originalColumn = null;
		  this.name = null;
		}
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		BasicSourceMapConsumer.prototype._parseMappings =
		  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    var generatedLine = 1;
		    var previousGeneratedColumn = 0;
		    var previousOriginalLine = 0;
		    var previousOriginalColumn = 0;
		    var previousSource = 0;
		    var previousName = 0;
		    var length = aStr.length;
		    var index = 0;
		    var cachedSegments = {};
		    var temp = {};
		    var originalMappings = [];
		    var generatedMappings = [];
		    var mapping, str, segment, end, value;
	
		    while (index < length) {
		      if (aStr.charAt(index) === ';') {
		        generatedLine++;
		        index++;
		        previousGeneratedColumn = 0;
		      }
		      else if (aStr.charAt(index) === ',') {
		        index++;
		      }
		      else {
		        mapping = new Mapping();
		        mapping.generatedLine = generatedLine;
	
		        // Because each offset is encoded relative to the previous one,
		        // many segments often have the same encoding. We can exploit this
		        // fact by caching the parsed variable length fields of each segment,
		        // allowing us to avoid a second parse if we encounter the same
		        // segment again.
		        for (end = index; end < length; end++) {
		          if (this._charIsMappingSeparator(aStr, end)) {
		            break;
		          }
		        }
		        str = aStr.slice(index, end);
	
		        segment = cachedSegments[str];
		        if (segment) {
		          index += str.length;
		        } else {
		          segment = [];
		          while (index < end) {
		            base64VLQ.decode(aStr, index, temp);
		            value = temp.value;
		            index = temp.rest;
		            segment.push(value);
		          }
	
		          if (segment.length === 2) {
		            throw new Error('Found a source, but no line and column');
		          }
	
		          if (segment.length === 3) {
		            throw new Error('Found a source and line, but no column');
		          }
	
		          cachedSegments[str] = segment;
		        }
	
		        // Generated column.
		        mapping.generatedColumn = previousGeneratedColumn + segment[0];
		        previousGeneratedColumn = mapping.generatedColumn;
	
		        if (segment.length > 1) {
		          // Original source.
		          mapping.source = previousSource + segment[1];
		          previousSource += segment[1];
	
		          // Original line.
		          mapping.originalLine = previousOriginalLine + segment[2];
		          previousOriginalLine = mapping.originalLine;
		          // Lines are stored 0-based
		          mapping.originalLine += 1;
	
		          // Original column.
		          mapping.originalColumn = previousOriginalColumn + segment[3];
		          previousOriginalColumn = mapping.originalColumn;
	
		          if (segment.length > 4) {
		            // Original name.
		            mapping.name = previousName + segment[4];
		            previousName += segment[4];
		          }
		        }
	
		        generatedMappings.push(mapping);
		        if (typeof mapping.originalLine === 'number') {
		          originalMappings.push(mapping);
		        }
		      }
		    }
	
		    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
		    this.__generatedMappings = generatedMappings;
	
		    quickSort(originalMappings, util.compareByOriginalPositions);
		    this.__originalMappings = originalMappings;
		  };
	
		/**
		 * Find the mapping that best matches the hypothetical "needle" mapping that
		 * we are searching for in the given "haystack" of mappings.
		 */
		BasicSourceMapConsumer.prototype._findMapping =
		  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
		                                         aColumnName, aComparator, aBias) {
		    // To return the position we are searching for, we must first find the
		    // mapping for the given position and then return the opposite position it
		    // points to. Because the mappings are sorted, we can use binary search to
		    // find the best mapping.
	
		    if (aNeedle[aLineName] <= 0) {
		      throw new TypeError('Line must be greater than or equal to 1, got '
		                          + aNeedle[aLineName]);
		    }
		    if (aNeedle[aColumnName] < 0) {
		      throw new TypeError('Column must be greater than or equal to 0, got '
		                          + aNeedle[aColumnName]);
		    }
	
		    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
		  };
	
		/**
		 * Compute the last column for each generated mapping. The last column is
		 * inclusive.
		 */
		BasicSourceMapConsumer.prototype.computeColumnSpans =
		  function SourceMapConsumer_computeColumnSpans() {
		    for (var index = 0; index < this._generatedMappings.length; ++index) {
		      var mapping = this._generatedMappings[index];
	
		      // Mappings do not contain a field for the last generated columnt. We
		      // can come up with an optimistic estimate, however, by assuming that
		      // mappings are contiguous (i.e. given two consecutive mappings, the
		      // first mapping ends where the second one starts).
		      if (index + 1 < this._generatedMappings.length) {
		        var nextMapping = this._generatedMappings[index + 1];
	
		        if (mapping.generatedLine === nextMapping.generatedLine) {
		          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
		          continue;
		        }
		      }
	
		      // The last mapping for each line spans the entire line.
		      mapping.lastGeneratedColumn = Infinity;
		    }
		  };
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		BasicSourceMapConsumer.prototype.originalPositionFor =
		  function SourceMapConsumer_originalPositionFor(aArgs) {
		    var needle = {
		      generatedLine: util.getArg(aArgs, 'line'),
		      generatedColumn: util.getArg(aArgs, 'column')
		    };
	
		    var index = this._findMapping(
		      needle,
		      this._generatedMappings,
		      "generatedLine",
		      "generatedColumn",
		      util.compareByGeneratedPositionsDeflated,
		      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
		    );
	
		    if (index >= 0) {
		      var mapping = this._generatedMappings[index];
	
		      if (mapping.generatedLine === needle.generatedLine) {
		        var source = util.getArg(mapping, 'source', null);
		        if (source !== null) {
		          source = this._sources.at(source);
		          if (this.sourceRoot != null) {
		            source = util.join(this.sourceRoot, source);
		          }
		        }
		        var name = util.getArg(mapping, 'name', null);
		        if (name !== null) {
		          name = this._names.at(name);
		        }
		        return {
		          source: source,
		          line: util.getArg(mapping, 'originalLine', null),
		          column: util.getArg(mapping, 'originalColumn', null),
		          name: name
		        };
		      }
		    }
	
		    return {
		      source: null,
		      line: null,
		      column: null,
		      name: null
		    };
		  };
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
		  function BasicSourceMapConsumer_hasContentsOfAllSources() {
		    if (!this.sourcesContent) {
		      return false;
		    }
		    return this.sourcesContent.length >= this._sources.size() &&
		      !this.sourcesContent.some(function (sc) { return sc == null; });
		  };
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		BasicSourceMapConsumer.prototype.sourceContentFor =
		  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		    if (!this.sourcesContent) {
		      return null;
		    }
	
		    if (this.sourceRoot != null) {
		      aSource = util.relative(this.sourceRoot, aSource);
		    }
	
		    if (this._sources.has(aSource)) {
		      return this.sourcesContent[this._sources.indexOf(aSource)];
		    }
	
		    var url;
		    if (this.sourceRoot != null
		        && (url = util.urlParse(this.sourceRoot))) {
		      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
		      // many users. We can help them out when they expect file:// URIs to
		      // behave like it would if they were running a local HTTP server. See
		      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
		      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
		      if (url.scheme == "file"
		          && this._sources.has(fileUriAbsPath)) {
		        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
		      }
	
		      if ((!url.path || url.path == "/")
		          && this._sources.has("/" + aSource)) {
		        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
		      }
		    }
	
		    // This function is used recursively from
		    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
		    // don't want to throw if we can't find the source - we just want to
		    // return null, so we provide a flag to exit gracefully.
		    if (nullOnMissing) {
		      return null;
		    }
		    else {
		      throw new Error('"' + aSource + '" is not in the SourceMap.');
		    }
		  };
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		BasicSourceMapConsumer.prototype.generatedPositionFor =
		  function SourceMapConsumer_generatedPositionFor(aArgs) {
		    var source = util.getArg(aArgs, 'source');
		    if (this.sourceRoot != null) {
		      source = util.relative(this.sourceRoot, source);
		    }
		    if (!this._sources.has(source)) {
		      return {
		        line: null,
		        column: null,
		        lastColumn: null
		      };
		    }
		    source = this._sources.indexOf(source);
	
		    var needle = {
		      source: source,
		      originalLine: util.getArg(aArgs, 'line'),
		      originalColumn: util.getArg(aArgs, 'column')
		    };
	
		    var index = this._findMapping(
		      needle,
		      this._originalMappings,
		      "originalLine",
		      "originalColumn",
		      util.compareByOriginalPositions,
		      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
		    );
	
		    if (index >= 0) {
		      var mapping = this._originalMappings[index];
	
		      if (mapping.source === needle.source) {
		        return {
		          line: util.getArg(mapping, 'generatedLine', null),
		          column: util.getArg(mapping, 'generatedColumn', null),
		          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		        };
		      }
		    }
	
		    return {
		      line: null,
		      column: null,
		      lastColumn: null
		    };
		  };
	
		exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
		/**
		 * An IndexedSourceMapConsumer instance represents a parsed source map which
		 * we can query for information. It differs from BasicSourceMapConsumer in
		 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
		 * input.
		 *
		 * The only parameter is a raw source map (either as a JSON string, or already
		 * parsed to an object). According to the spec for indexed source maps, they
		 * have the following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - file: Optional. The generated file this source map is associated with.
		 *   - sections: A list of section definitions.
		 *
		 * Each value under the "sections" field has two fields:
		 *   - offset: The offset into the original specified at which this section
		 *       begins to apply, defined as an object with a "line" and "column"
		 *       field.
		 *   - map: A source map definition. This source map could also be indexed,
		 *       but doesn't have to be.
		 *
		 * Instead of the "map" field, it's also possible to have a "url" field
		 * specifying a URL to retrieve a source map from, but that's currently
		 * unsupported.
		 *
		 * Here's an example source map, taken from the source map spec[0], but
		 * modified to omit a section which uses the "url" field.
		 *
		 *  {
		 *    version : 3,
		 *    file: "app.js",
		 *    sections: [{
		 *      offset: {line:100, column:10},
		 *      map: {
		 *        version : 3,
		 *        file: "section.js",
		 *        sources: ["foo.js", "bar.js"],
		 *        names: ["src", "maps", "are", "fun"],
		 *        mappings: "AAAA,E;;ABCDE;"
		 *      }
		 *    }],
		 *  }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
		 */
		function IndexedSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sections = util.getArg(sourceMap, 'sections');
	
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  this._sources = new ArraySet();
		  this._names = new ArraySet();
	
		  var lastOffset = {
		    line: -1,
		    column: 0
		  };
		  this._sections = sections.map(function (s) {
		    if (s.url) {
		      // The url field will require support for asynchronicity.
		      // See https://github.com/mozilla/source-map/issues/16
		      throw new Error('Support for url field in sections not implemented.');
		    }
		    var offset = util.getArg(s, 'offset');
		    var offsetLine = util.getArg(offset, 'line');
		    var offsetColumn = util.getArg(offset, 'column');
	
		    if (offsetLine < lastOffset.line ||
		        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
		      throw new Error('Section offsets must be ordered and non-overlapping.');
		    }
		    lastOffset = offset;
	
		    return {
		      generatedOffset: {
		        // The offset fields are 0-based, but we use 1-based indices when
		        // encoding/decoding from VLQ.
		        generatedLine: offsetLine + 1,
		        generatedColumn: offsetColumn + 1
		      },
		      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
		    }
		  });
		}
	
		IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		IndexedSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
		  get: function () {
		    var sources = [];
		    for (var i = 0; i < this._sections.length; i++) {
		      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
		        sources.push(this._sections[i].consumer.sources[j]);
		      }
		    }
		    return sources;
		  }
		});
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		IndexedSourceMapConsumer.prototype.originalPositionFor =
		  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
		    var needle = {
		      generatedLine: util.getArg(aArgs, 'line'),
		      generatedColumn: util.getArg(aArgs, 'column')
		    };
	
		    // Find the section containing the generated position we're trying to map
		    // to an original position.
		    var sectionIndex = binarySearch.search(needle, this._sections,
		      function(needle, section) {
		        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
		        if (cmp) {
		          return cmp;
		        }
	
		        return (needle.generatedColumn -
		                section.generatedOffset.generatedColumn);
		      });
		    var section = this._sections[sectionIndex];
	
		    if (!section) {
		      return {
		        source: null,
		        line: null,
		        column: null,
		        name: null
		      };
		    }
	
		    return section.consumer.originalPositionFor({
		      line: needle.generatedLine -
		        (section.generatedOffset.generatedLine - 1),
		      column: needle.generatedColumn -
		        (section.generatedOffset.generatedLine === needle.generatedLine
		         ? section.generatedOffset.generatedColumn - 1
		         : 0),
		      bias: aArgs.bias
		    });
		  };
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
		  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
		    return this._sections.every(function (s) {
		      return s.consumer.hasContentsOfAllSources();
		    });
		  };
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		IndexedSourceMapConsumer.prototype.sourceContentFor =
		  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
	
		      var content = section.consumer.sourceContentFor(aSource, true);
		      if (content) {
		        return content;
		      }
		    }
		    if (nullOnMissing) {
		      return null;
		    }
		    else {
		      throw new Error('"' + aSource + '" is not in the SourceMap.');
		    }
		  };
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		IndexedSourceMapConsumer.prototype.generatedPositionFor =
		  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
	
		      // Only consider this section if the requested source is in the list of
		      // sources of the consumer.
		      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
		        continue;
		      }
		      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
		      if (generatedPosition) {
		        var ret = {
		          line: generatedPosition.line +
		            (section.generatedOffset.generatedLine - 1),
		          column: generatedPosition.column +
		            (section.generatedOffset.generatedLine === generatedPosition.line
		             ? section.generatedOffset.generatedColumn - 1
		             : 0)
		        };
		        return ret;
		      }
		    }
	
		    return {
		      line: null,
		      column: null
		    };
		  };
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		IndexedSourceMapConsumer.prototype._parseMappings =
		  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    this.__generatedMappings = [];
		    this.__originalMappings = [];
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
		      var sectionMappings = section.consumer._generatedMappings;
		      for (var j = 0; j < sectionMappings.length; j++) {
		        var mapping = sectionMappings[j];
	
		        var source = section.consumer._sources.at(mapping.source);
		        if (section.consumer.sourceRoot !== null) {
		          source = util.join(section.consumer.sourceRoot, source);
		        }
		        this._sources.add(source);
		        source = this._sources.indexOf(source);
	
		        var name = section.consumer._names.at(mapping.name);
		        this._names.add(name);
		        name = this._names.indexOf(name);
	
		        // The mappings coming from the consumer for the section have
		        // generated positions relative to the start of the section, so we
		        // need to offset them to be relative to the start of the concatenated
		        // generated file.
		        var adjustedMapping = {
		          source: source,
		          generatedLine: mapping.generatedLine +
		            (section.generatedOffset.generatedLine - 1),
		          generatedColumn: mapping.generatedColumn +
		            (section.generatedOffset.generatedLine === mapping.generatedLine
		            ? section.generatedOffset.generatedColumn - 1
		            : 0),
		          originalLine: mapping.originalLine,
		          originalColumn: mapping.originalColumn,
		          name: name
		        };
	
		        this.__generatedMappings.push(adjustedMapping);
		        if (typeof adjustedMapping.originalLine === 'number') {
		          this.__originalMappings.push(adjustedMapping);
		        }
		      }
		    }
	
		    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
		    quickSort(this.__originalMappings, util.compareByOriginalPositions);
		  };
	
		exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		/**
		 * This is a helper function for getting values from parameter/options
		 * objects.
		 *
		 * @param args The object we are extracting values from
		 * @param name The name of the property we are getting.
		 * @param defaultValue An optional value to return if the property is missing
		 * from the object. If this is not specified and the property is missing, an
		 * error will be thrown.
		 */
		function getArg(aArgs, aName, aDefaultValue) {
		  if (aName in aArgs) {
		    return aArgs[aName];
		  } else if (arguments.length === 3) {
		    return aDefaultValue;
		  } else {
		    throw new Error('"' + aName + '" is a required argument.');
		  }
		}
		exports.getArg = getArg;
	
		var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
		var dataUrlRegexp = /^data:.+\,.+$/;
	
		function urlParse(aUrl) {
		  var match = aUrl.match(urlRegexp);
		  if (!match) {
		    return null;
		  }
		  return {
		    scheme: match[1],
		    auth: match[2],
		    host: match[3],
		    port: match[4],
		    path: match[5]
		  };
		}
		exports.urlParse = urlParse;
	
		function urlGenerate(aParsedUrl) {
		  var url = '';
		  if (aParsedUrl.scheme) {
		    url += aParsedUrl.scheme + ':';
		  }
		  url += '//';
		  if (aParsedUrl.auth) {
		    url += aParsedUrl.auth + '@';
		  }
		  if (aParsedUrl.host) {
		    url += aParsedUrl.host;
		  }
		  if (aParsedUrl.port) {
		    url += ":" + aParsedUrl.port
		  }
		  if (aParsedUrl.path) {
		    url += aParsedUrl.path;
		  }
		  return url;
		}
		exports.urlGenerate = urlGenerate;
	
		/**
		 * Normalizes a path, or the path portion of a URL:
		 *
		 * - Replaces consecutive slashes with one slash.
		 * - Removes unnecessary '.' parts.
		 * - Removes unnecessary '<dir>/..' parts.
		 *
		 * Based on code in the Node.js 'path' core module.
		 *
		 * @param aPath The path or url to normalize.
		 */
		function normalize(aPath) {
		  var path = aPath;
		  var url = urlParse(aPath);
		  if (url) {
		    if (!url.path) {
		      return aPath;
		    }
		    path = url.path;
		  }
		  var isAbsolute = exports.isAbsolute(path);
	
		  var parts = path.split(/\/+/);
		  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
		    part = parts[i];
		    if (part === '.') {
		      parts.splice(i, 1);
		    } else if (part === '..') {
		      up++;
		    } else if (up > 0) {
		      if (part === '') {
		        // The first part is blank if the path is absolute. Trying to go
		        // above the root is a no-op. Therefore we can remove all '..' parts
		        // directly after the root.
		        parts.splice(i + 1, up);
		        up = 0;
		      } else {
		        parts.splice(i, 2);
		        up--;
		      }
		    }
		  }
		  path = parts.join('/');
	
		  if (path === '') {
		    path = isAbsolute ? '/' : '.';
		  }
	
		  if (url) {
		    url.path = path;
		    return urlGenerate(url);
		  }
		  return path;
		}
		exports.normalize = normalize;
	
		/**
		 * Joins two paths/URLs.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be joined with the root.
		 *
		 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
		 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
		 *   first.
		 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
		 *   is updated with the result and aRoot is returned. Otherwise the result
		 *   is returned.
		 *   - If aPath is absolute, the result is aPath.
		 *   - Otherwise the two paths are joined with a slash.
		 * - Joining for example 'http://' and 'www.example.com' is also supported.
		 */
		function join(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
		  if (aPath === "") {
		    aPath = ".";
		  }
		  var aPathUrl = urlParse(aPath);
		  var aRootUrl = urlParse(aRoot);
		  if (aRootUrl) {
		    aRoot = aRootUrl.path || '/';
		  }
	
		  // `join(foo, '//www.example.org')`
		  if (aPathUrl && !aPathUrl.scheme) {
		    if (aRootUrl) {
		      aPathUrl.scheme = aRootUrl.scheme;
		    }
		    return urlGenerate(aPathUrl);
		  }
	
		  if (aPathUrl || aPath.match(dataUrlRegexp)) {
		    return aPath;
		  }
	
		  // `join('http://', 'www.example.com')`
		  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
		    aRootUrl.host = aPath;
		    return urlGenerate(aRootUrl);
		  }
	
		  var joined = aPath.charAt(0) === '/'
		    ? aPath
		    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
		  if (aRootUrl) {
		    aRootUrl.path = joined;
		    return urlGenerate(aRootUrl);
		  }
		  return joined;
		}
		exports.join = join;
	
		exports.isAbsolute = function (aPath) {
		  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
		};
	
		/**
		 * Make a path relative to a URL or another path.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be made relative to aRoot.
		 */
		function relative(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
	
		  aRoot = aRoot.replace(/\/$/, '');
	
		  // It is possible for the path to be above the root. In this case, simply
		  // checking whether the root is a prefix of the path won't work. Instead, we
		  // need to remove components from the root one by one, until either we find
		  // a prefix that fits, or we run out of components to remove.
		  var level = 0;
		  while (aPath.indexOf(aRoot + '/') !== 0) {
		    var index = aRoot.lastIndexOf("/");
		    if (index < 0) {
		      return aPath;
		    }
	
		    // If the only part of the root that is left is the scheme (i.e. http://,
		    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
		    // have exhausted all components, so the path is not relative to the root.
		    aRoot = aRoot.slice(0, index);
		    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
		      return aPath;
		    }
	
		    ++level;
		  }
	
		  // Make sure we add a "../" for each component we removed from the root.
		  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
		}
		exports.relative = relative;
	
		var supportsNullProto = (function () {
		  var obj = Object.create(null);
		  return !('__proto__' in obj);
		}());
	
		function identity (s) {
		  return s;
		}
	
		/**
		 * Because behavior goes wacky when you set `__proto__` on objects, we
		 * have to prefix all the strings in our set with an arbitrary character.
		 *
		 * See https://github.com/mozilla/source-map/pull/31 and
		 * https://github.com/mozilla/source-map/issues/30
		 *
		 * @param String aStr
		 */
		function toSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return '$' + aStr;
		  }
	
		  return aStr;
		}
		exports.toSetString = supportsNullProto ? identity : toSetString;
	
		function fromSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return aStr.slice(1);
		  }
	
		  return aStr;
		}
		exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
		function isProtoString(s) {
		  if (!s) {
		    return false;
		  }
	
		  var length = s.length;
	
		  if (length < 9 /* "__proto__".length */) {
		    return false;
		  }
	
		  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
		      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
		      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
		      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
		      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
		      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 9) !== 95  /* '_' */) {
		    return false;
		  }
	
		  for (var i = length - 10; i >= 0; i--) {
		    if (s.charCodeAt(i) !== 36 /* '$' */) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		/**
		 * Comparator between two mappings where the original positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same original source/line/column, but different generated
		 * line and column the same. Useful when searching for a mapping with a
		 * stubbed out mapping.
		 */
		function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
		  var cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0 || onlyCompareOriginal) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByOriginalPositions = compareByOriginalPositions;
	
		/**
		 * Comparator between two mappings with deflated source and name indices where
		 * the generated positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same generated line and column, but different
		 * source/name/original line and column the same. Useful when searching for a
		 * mapping with a stubbed out mapping.
		 */
		function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0 || onlyCompareGenerated) {
		    return cmp;
		  }
	
		  cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
		function strcmp(aStr1, aStr2) {
		  if (aStr1 === aStr2) {
		    return 0;
		  }
	
		  if (aStr1 > aStr2) {
		    return 1;
		  }
	
		  return -1;
		}
	
		/**
		 * Comparator between two mappings with inflated source and name strings where
		 * the generated positions are compared.
		 */
		function compareByGeneratedPositionsInflated(mappingA, mappingB) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = strcmp(mappingA.source, mappingB.source);
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return strcmp(mappingA.name, mappingB.name);
		}
		exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		exports.GREATEST_LOWER_BOUND = 1;
		exports.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Recursive implementation of binary search.
		 *
		 * @param aLow Indices here and lower do not contain the needle.
		 * @param aHigh Indices here and higher do not contain the needle.
		 * @param aNeedle The element being searched for.
		 * @param aHaystack The non-empty array being searched.
		 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 */
		function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
		  // This function terminates when one of the following is true:
		  //
		  //   1. We find the exact element we are looking for.
		  //
		  //   2. We did not find the exact element, but we can return the index of
		  //      the next-closest element.
		  //
		  //   3. We did not find the exact element, and there is no next-closest
		  //      element than the one we are searching for, so we return -1.
		  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
		  var cmp = aCompare(aNeedle, aHaystack[mid], true);
		  if (cmp === 0) {
		    // Found the element we are looking for.
		    return mid;
		  }
		  else if (cmp > 0) {
		    // Our needle is greater than aHaystack[mid].
		    if (aHigh - mid > 1) {
		      // The element is in the upper half.
		      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // The exact needle element was not found in this haystack. Determine if
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return aHigh < aHaystack.length ? aHigh : -1;
		    } else {
		      return mid;
		    }
		  }
		  else {
		    // Our needle is less than aHaystack[mid].
		    if (mid - aLow > 1) {
		      // The element is in the lower half.
		      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return mid;
		    } else {
		      return aLow < 0 ? -1 : aLow;
		    }
		  }
		}
	
		/**
		 * This is an implementation of binary search which will always try and return
		 * the index of the closest element if there is no exact hit. This is because
		 * mappings between original and generated line/col pairs are single points,
		 * and there is an implicit region between each of them, so a miss just means
		 * that you aren't on the very start of a region.
		 *
		 * @param aNeedle The element you are looking for.
		 * @param aHaystack The array that is being searched.
		 * @param aCompare A function which takes the needle and an element in the
		 *     array and returns -1, 0, or 1 depending on whether the needle is less
		 *     than, equal to, or greater than the element, respectively.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
		 */
		exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
		  if (aHaystack.length === 0) {
		    return -1;
		  }
	
		  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
		                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
		  if (index < 0) {
		    return -1;
		  }
	
		  // We have found either the exact element, or the next-closest element than
		  // the one we are searching for. However, there may be more than one such
		  // element. Make sure we always return the smallest of these.
		  while (index - 1 >= 0) {
		    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
		      break;
		    }
		    --index;
		  }
	
		  return index;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(2);
		var has = Object.prototype.hasOwnProperty;
	
		/**
		 * A data structure which is a combination of an array and a set. Adding a new
		 * member is O(1), testing for membership is O(1), and finding the index of an
		 * element is O(1). Removing elements from the set is not supported. Only
		 * strings are supported for membership.
		 */
		function ArraySet() {
		  this._array = [];
		  this._set = Object.create(null);
		}
	
		/**
		 * Static method for creating ArraySet instances from an existing array.
		 */
		ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
		  var set = new ArraySet();
		  for (var i = 0, len = aArray.length; i < len; i++) {
		    set.add(aArray[i], aAllowDuplicates);
		  }
		  return set;
		};
	
		/**
		 * Return how many unique items are in this ArraySet. If duplicates have been
		 * added, than those do not count towards the size.
		 *
		 * @returns Number
		 */
		ArraySet.prototype.size = function ArraySet_size() {
		  return Object.getOwnPropertyNames(this._set).length;
		};
	
		/**
		 * Add the given string to this set.
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
		  var sStr = util.toSetString(aStr);
		  var isDuplicate = has.call(this._set, sStr);
		  var idx = this._array.length;
		  if (!isDuplicate || aAllowDuplicates) {
		    this._array.push(aStr);
		  }
		  if (!isDuplicate) {
		    this._set[sStr] = idx;
		  }
		};
	
		/**
		 * Is the given string a member of this set?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.has = function ArraySet_has(aStr) {
		  var sStr = util.toSetString(aStr);
		  return has.call(this._set, sStr);
		};
	
		/**
		 * What is the index of the given string in the array?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
		  var sStr = util.toSetString(aStr);
		  if (has.call(this._set, sStr)) {
		    return this._set[sStr];
		  }
		  throw new Error('"' + aStr + '" is not in the set.');
		};
	
		/**
		 * What is the element at the given index?
		 *
		 * @param Number aIdx
		 */
		ArraySet.prototype.at = function ArraySet_at(aIdx) {
		  if (aIdx >= 0 && aIdx < this._array.length) {
		    return this._array[aIdx];
		  }
		  throw new Error('No element indexed by ' + aIdx);
		};
	
		/**
		 * Returns the array representation of this set (which has the proper indices
		 * indicated by indexOf). Note that this is a copy of the internal array used
		 * for storing the members so that no one can mess with internal state.
		 */
		ArraySet.prototype.toArray = function ArraySet_toArray() {
		  return this._array.slice();
		};
	
		exports.ArraySet = ArraySet;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 *
		 * Based on the Base 64 VLQ implementation in Closure Compiler:
		 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
		 *
		 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
		 * Redistribution and use in source and binary forms, with or without
		 * modification, are permitted provided that the following conditions are
		 * met:
		 *
		 *  * Redistributions of source code must retain the above copyright
		 *    notice, this list of conditions and the following disclaimer.
		 *  * Redistributions in binary form must reproduce the above
		 *    copyright notice, this list of conditions and the following
		 *    disclaimer in the documentation and/or other materials provided
		 *    with the distribution.
		 *  * Neither the name of Google Inc. nor the names of its
		 *    contributors may be used to endorse or promote products derived
		 *    from this software without specific prior written permission.
		 *
		 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
		 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
		 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
		 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
		 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
		 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
		 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
		 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
		 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
		 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		 */
	
		var base64 = __webpack_require__(6);
	
		// A single base 64 digit can contain 6 bits of data. For the base 64 variable
		// length quantities we use in the source map spec, the first bit is the sign,
		// the next four bits are the actual value, and the 6th bit is the
		// continuation bit. The continuation bit tells us whether there are more
		// digits in this value following this digit.
		//
		//   Continuation
		//   |    Sign
		//   |    |
		//   V    V
		//   101011
	
		var VLQ_BASE_SHIFT = 5;
	
		// binary: 100000
		var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
		// binary: 011111
		var VLQ_BASE_MASK = VLQ_BASE - 1;
	
		// binary: 100000
		var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
		/**
		 * Converts from a two-complement value to a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
		 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
		 */
		function toVLQSigned(aValue) {
		  return aValue < 0
		    ? ((-aValue) << 1) + 1
		    : (aValue << 1) + 0;
		}
	
		/**
		 * Converts to a two-complement value from a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
		 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
		 */
		function fromVLQSigned(aValue) {
		  var isNegative = (aValue & 1) === 1;
		  var shifted = aValue >> 1;
		  return isNegative
		    ? -shifted
		    : shifted;
		}
	
		/**
		 * Returns the base 64 VLQ encoded value.
		 */
		exports.encode = function base64VLQ_encode(aValue) {
		  var encoded = "";
		  var digit;
	
		  var vlq = toVLQSigned(aValue);
	
		  do {
		    digit = vlq & VLQ_BASE_MASK;
		    vlq >>>= VLQ_BASE_SHIFT;
		    if (vlq > 0) {
		      // There are still more digits in this value, so we must make sure the
		      // continuation bit is marked.
		      digit |= VLQ_CONTINUATION_BIT;
		    }
		    encoded += base64.encode(digit);
		  } while (vlq > 0);
	
		  return encoded;
		};
	
		/**
		 * Decodes the next base 64 VLQ value from the given string and returns the
		 * value and the rest of the string via the out parameter.
		 */
		exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
		  var strLen = aStr.length;
		  var result = 0;
		  var shift = 0;
		  var continuation, digit;
	
		  do {
		    if (aIndex >= strLen) {
		      throw new Error("Expected more digits in base 64 VLQ value.");
		    }
	
		    digit = base64.decode(aStr.charCodeAt(aIndex++));
		    if (digit === -1) {
		      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
		    }
	
		    continuation = !!(digit & VLQ_CONTINUATION_BIT);
		    digit &= VLQ_BASE_MASK;
		    result = result + (digit << shift);
		    shift += VLQ_BASE_SHIFT;
		  } while (continuation);
	
		  aOutParam.value = fromVLQSigned(result);
		  aOutParam.rest = aIndex;
		};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
		/**
		 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
		 */
		exports.encode = function (number) {
		  if (0 <= number && number < intToCharMap.length) {
		    return intToCharMap[number];
		  }
		  throw new TypeError("Must be between 0 and 63: " + number);
		};
	
		/**
		 * Decode a single base 64 character code digit to an integer. Returns -1 on
		 * failure.
		 */
		exports.decode = function (charCode) {
		  var bigA = 65;     // 'A'
		  var bigZ = 90;     // 'Z'
	
		  var littleA = 97;  // 'a'
		  var littleZ = 122; // 'z'
	
		  var zero = 48;     // '0'
		  var nine = 57;     // '9'
	
		  var plus = 43;     // '+'
		  var slash = 47;    // '/'
	
		  var littleOffset = 26;
		  var numberOffset = 52;
	
		  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
		  if (bigA <= charCode && charCode <= bigZ) {
		    return (charCode - bigA);
		  }
	
		  // 26 - 51: abcdefghijklmnopqrstuvwxyz
		  if (littleA <= charCode && charCode <= littleZ) {
		    return (charCode - littleA + littleOffset);
		  }
	
		  // 52 - 61: 0123456789
		  if (zero <= charCode && charCode <= nine) {
		    return (charCode - zero + numberOffset);
		  }
	
		  // 62: +
		  if (charCode == plus) {
		    return 62;
		  }
	
		  // 63: /
		  if (charCode == slash) {
		    return 63;
		  }
	
		  // Invalid base64 digit.
		  return -1;
		};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		// It turns out that some (most?) JavaScript engines don't self-host
		// `Array.prototype.sort`. This makes sense because C++ will likely remain
		// faster than JS when doing raw CPU-intensive sorting. However, when using a
		// custom comparator function, calling back and forth between the VM's C++ and
		// JIT'd JS is rather slow *and* loses JIT type information, resulting in
		// worse generated code for the comparator function than would be optimal. In
		// fact, when sorting with a comparator, these costs outweigh the benefits of
		// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
		// a ~3500ms mean speed-up in `bench/bench.html`.
	
		/**
		 * Swap the elements indexed by `x` and `y` in the array `ary`.
		 *
		 * @param {Array} ary
		 *        The array.
		 * @param {Number} x
		 *        The index of the first item.
		 * @param {Number} y
		 *        The index of the second item.
		 */
		function swap(ary, x, y) {
		  var temp = ary[x];
		  ary[x] = ary[y];
		  ary[y] = temp;
		}
	
		/**
		 * Returns a random integer within the range `low .. high` inclusive.
		 *
		 * @param {Number} low
		 *        The lower bound on the range.
		 * @param {Number} high
		 *        The upper bound on the range.
		 */
		function randomIntInRange(low, high) {
		  return Math.round(low + (Math.random() * (high - low)));
		}
	
		/**
		 * The Quick Sort algorithm.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 * @param {Number} p
		 *        Start index of the array
		 * @param {Number} r
		 *        End index of the array
		 */
		function doQuickSort(ary, comparator, p, r) {
		  // If our lower bound is less than our upper bound, we (1) partition the
		  // array into two pieces and (2) recurse on each half. If it is not, this is
		  // the empty array and our base case.
	
		  if (p < r) {
		    // (1) Partitioning.
		    //
		    // The partitioning chooses a pivot between `p` and `r` and moves all
		    // elements that are less than or equal to the pivot to the before it, and
		    // all the elements that are greater than it after it. The effect is that
		    // once partition is done, the pivot is in the exact place it will be when
		    // the array is put in sorted order, and it will not need to be moved
		    // again. This runs in O(n) time.
	
		    // Always choose a random pivot so that an input array which is reverse
		    // sorted does not cause O(n^2) running time.
		    var pivotIndex = randomIntInRange(p, r);
		    var i = p - 1;
	
		    swap(ary, pivotIndex, r);
		    var pivot = ary[r];
	
		    // Immediately after `j` is incremented in this loop, the following hold
		    // true:
		    //
		    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
		    //
		    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
		    for (var j = p; j < r; j++) {
		      if (comparator(ary[j], pivot) <= 0) {
		        i += 1;
		        swap(ary, i, j);
		      }
		    }
	
		    swap(ary, i + 1, j);
		    var q = i + 1;
	
		    // (2) Recurse on each half.
	
		    doQuickSort(ary, comparator, p, q - 1);
		    doQuickSort(ary, comparator, q + 1, r);
		  }
		}
	
		/**
		 * Sort the given array in-place with the given comparator function.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 */
		exports.quickSort = function (ary, comparator) {
		  doQuickSort(ary, comparator, 0, ary.length - 1);
		};
	
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function () {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
	        if (functionName !== undefined) {
	            this.setFunctionName(functionName);
	        }
	        if (args !== undefined) {
	            this.setArgs(args);
	        }
	        if (fileName !== undefined) {
	            this.setFileName(fileName);
	        }
	        if (lineNumber !== undefined) {
	            this.setLineNumber(lineNumber);
	        }
	        if (columnNumber !== undefined) {
	            this.setColumnNumber(columnNumber);
	        }
	        if (source !== undefined) {
	            this.setSource(source);
	        }
	    }
	
	    StackFrame.prototype = {
	        getFunctionName: function () {
	            return this.functionName;
	        },
	        setFunctionName: function (v) {
	            this.functionName = String(v);
	        },
	
	        getArgs: function () {
	            return this.args;
	        },
	        setArgs: function (v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        // NOTE: Property name may be misleading as it includes the path,
	        // but it somewhat mirrors V8's JavaScriptStackTraceApi
	        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
	        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
	        getFileName: function () {
	            return this.fileName;
	        },
	        setFileName: function (v) {
	            this.fileName = String(v);
	        },
	
	        getLineNumber: function () {
	            return this.lineNumber;
	        },
	        setLineNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Line Number must be a Number');
	            }
	            this.lineNumber = Number(v);
	        },
	
	        getColumnNumber: function () {
	            return this.columnNumber;
	        },
	        setColumnNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Column Number must be a Number');
	            }
	            this.columnNumber = Number(v);
	        },
	
	        getSource: function () {
	            return this.source;
	        },
	        setSource: function (v) {
	            this.source = String(v);
	        },
	
	        toString: function() {
	            var functionName = this.getFunctionName() || '{anonymous}';
	            var args = '(' + (this.getArgs() || []).join(',') + ')';
	            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
	            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
	            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
	            return functionName + args + fileName + lineNumber + columnNumber;
	        }
	    };
	
	    return StackFrame;
	}));


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(241).EventEmitter;
	var inherits = __webpack_require__(116);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(295);
	Stream.Writable = __webpack_require__(1189);
	Stream.Duplex = __webpack_require__(1184);
	Stream.Transform = __webpack_require__(1188);
	Stream.PassThrough = __webpack_require__(1187);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1240);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	module.exports = [
	  "aaa",
	  "aarp",
	  "abarth",
	  "abb",
	  "abbott",
	  "abbvie",
	  "abc",
	  "able",
	  "abogado",
	  "abudhabi",
	  "ac",
	  "academy",
	  "accenture",
	  "accountant",
	  "accountants",
	  "aco",
	  "actor",
	  "ad",
	  "adac",
	  "ads",
	  "adult",
	  "ae",
	  "aeg",
	  "aero",
	  "aetna",
	  "af",
	  "afamilycompany",
	  "afl",
	  "africa",
	  "ag",
	  "agakhan",
	  "agency",
	  "ai",
	  "aig",
	  "airbus",
	  "airforce",
	  "airtel",
	  "akdn",
	  "al",
	  "alfaromeo",
	  "alibaba",
	  "alipay",
	  "allfinanz",
	  "allstate",
	  "ally",
	  "alsace",
	  "alstom",
	  "am",
	  "amazon",
	  "americanexpress",
	  "americanfamily",
	  "amex",
	  "amfam",
	  "amica",
	  "amsterdam",
	  "analytics",
	  "android",
	  "anquan",
	  "anz",
	  "ao",
	  "aol",
	  "apartments",
	  "app",
	  "apple",
	  "aq",
	  "aquarelle",
	  "ar",
	  "arab",
	  "aramco",
	  "archi",
	  "army",
	  "arpa",
	  "art",
	  "arte",
	  "as",
	  "asda",
	  "asia",
	  "associates",
	  "at",
	  "athleta",
	  "attorney",
	  "au",
	  "auction",
	  "audi",
	  "audible",
	  "audio",
	  "auspost",
	  "author",
	  "auto",
	  "autos",
	  "avianca",
	  "aw",
	  "aws",
	  "ax",
	  "axa",
	  "az",
	  "azure",
	  "ba",
	  "baby",
	  "baidu",
	  "banamex",
	  "bananarepublic",
	  "band",
	  "bank",
	  "bar",
	  "barcelona",
	  "barclaycard",
	  "barclays",
	  "barefoot",
	  "bargains",
	  "baseball",
	  "basketball",
	  "bauhaus",
	  "bayern",
	  "bb",
	  "bbc",
	  "bbt",
	  "bbva",
	  "bcg",
	  "bcn",
	  "bd",
	  "be",
	  "beats",
	  "beauty",
	  "beer",
	  "bentley",
	  "berlin",
	  "best",
	  "bestbuy",
	  "bet",
	  "bf",
	  "bg",
	  "bh",
	  "bharti",
	  "bi",
	  "bible",
	  "bid",
	  "bike",
	  "bing",
	  "bingo",
	  "bio",
	  "biz",
	  "bj",
	  "black",
	  "blackfriday",
	  "blockbuster",
	  "blog",
	  "bloomberg",
	  "blue",
	  "bm",
	  "bms",
	  "bmw",
	  "bn",
	  "bnpparibas",
	  "bo",
	  "boats",
	  "boehringer",
	  "bofa",
	  "bom",
	  "bond",
	  "boo",
	  "book",
	  "booking",
	  "bosch",
	  "bostik",
	  "boston",
	  "bot",
	  "boutique",
	  "box",
	  "br",
	  "bradesco",
	  "bridgestone",
	  "broadway",
	  "broker",
	  "brother",
	  "brussels",
	  "bs",
	  "bt",
	  "budapest",
	  "bugatti",
	  "build",
	  "builders",
	  "business",
	  "buy",
	  "buzz",
	  "bv",
	  "bw",
	  "by",
	  "bz",
	  "bzh",
	  "ca",
	  "cab",
	  "cafe",
	  "cal",
	  "call",
	  "calvinklein",
	  "cam",
	  "camera",
	  "camp",
	  "cancerresearch",
	  "canon",
	  "capetown",
	  "capital",
	  "capitalone",
	  "car",
	  "caravan",
	  "cards",
	  "care",
	  "career",
	  "careers",
	  "cars",
	  "casa",
	  "case",
	  "caseih",
	  "cash",
	  "casino",
	  "cat",
	  "catering",
	  "catholic",
	  "cba",
	  "cbn",
	  "cbre",
	  "cbs",
	  "cc",
	  "cd",
	  "ceb",
	  "center",
	  "ceo",
	  "cern",
	  "cf",
	  "cfa",
	  "cfd",
	  "cg",
	  "ch",
	  "chanel",
	  "channel",
	  "charity",
	  "chase",
	  "chat",
	  "cheap",
	  "chintai",
	  "christmas",
	  "chrome",
	  "church",
	  "ci",
	  "cipriani",
	  "circle",
	  "cisco",
	  "citadel",
	  "citi",
	  "citic",
	  "city",
	  "cityeats",
	  "ck",
	  "cl",
	  "claims",
	  "cleaning",
	  "click",
	  "clinic",
	  "clinique",
	  "clothing",
	  "cloud",
	  "club",
	  "clubmed",
	  "cm",
	  "cn",
	  "co",
	  "coach",
	  "codes",
	  "coffee",
	  "college",
	  "cologne",
	  "com",
	  "comcast",
	  "commbank",
	  "community",
	  "company",
	  "compare",
	  "computer",
	  "comsec",
	  "condos",
	  "construction",
	  "consulting",
	  "contact",
	  "contractors",
	  "cooking",
	  "cookingchannel",
	  "cool",
	  "coop",
	  "corsica",
	  "country",
	  "coupon",
	  "coupons",
	  "courses",
	  "cpa",
	  "cr",
	  "credit",
	  "creditcard",
	  "creditunion",
	  "cricket",
	  "crown",
	  "crs",
	  "cruise",
	  "cruises",
	  "csc",
	  "cu",
	  "cuisinella",
	  "cv",
	  "cw",
	  "cx",
	  "cy",
	  "cymru",
	  "cyou",
	  "cz",
	  "dabur",
	  "dad",
	  "dance",
	  "data",
	  "date",
	  "dating",
	  "datsun",
	  "day",
	  "dclk",
	  "dds",
	  "de",
	  "deal",
	  "dealer",
	  "deals",
	  "degree",
	  "delivery",
	  "dell",
	  "deloitte",
	  "delta",
	  "democrat",
	  "dental",
	  "dentist",
	  "desi",
	  "design",
	  "dev",
	  "dhl",
	  "diamonds",
	  "diet",
	  "digital",
	  "direct",
	  "directory",
	  "discount",
	  "discover",
	  "dish",
	  "diy",
	  "dj",
	  "dk",
	  "dm",
	  "dnp",
	  "do",
	  "docs",
	  "doctor",
	  "dog",
	  "domains",
	  "dot",
	  "download",
	  "drive",
	  "dtv",
	  "dubai",
	  "duck",
	  "dunlop",
	  "dupont",
	  "durban",
	  "dvag",
	  "dvr",
	  "dz",
	  "earth",
	  "eat",
	  "ec",
	  "eco",
	  "edeka",
	  "edu",
	  "education",
	  "ee",
	  "eg",
	  "email",
	  "emerck",
	  "energy",
	  "engineer",
	  "engineering",
	  "enterprises",
	  "epson",
	  "equipment",
	  "er",
	  "ericsson",
	  "erni",
	  "es",
	  "esq",
	  "estate",
	  "et",
	  "etisalat",
	  "eu",
	  "eurovision",
	  "eus",
	  "events",
	  "exchange",
	  "expert",
	  "exposed",
	  "express",
	  "extraspace",
	  "fage",
	  "fail",
	  "fairwinds",
	  "faith",
	  "family",
	  "fan",
	  "fans",
	  "farm",
	  "farmers",
	  "fashion",
	  "fast",
	  "fedex",
	  "feedback",
	  "ferrari",
	  "ferrero",
	  "fi",
	  "fiat",
	  "fidelity",
	  "fido",
	  "film",
	  "final",
	  "finance",
	  "financial",
	  "fire",
	  "firestone",
	  "firmdale",
	  "fish",
	  "fishing",
	  "fit",
	  "fitness",
	  "fj",
	  "fk",
	  "flickr",
	  "flights",
	  "flir",
	  "florist",
	  "flowers",
	  "fly",
	  "fm",
	  "fo",
	  "foo",
	  "food",
	  "foodnetwork",
	  "football",
	  "ford",
	  "forex",
	  "forsale",
	  "forum",
	  "foundation",
	  "fox",
	  "fr",
	  "free",
	  "fresenius",
	  "frl",
	  "frogans",
	  "frontdoor",
	  "frontier",
	  "ftr",
	  "fujitsu",
	  "fujixerox",
	  "fun",
	  "fund",
	  "furniture",
	  "futbol",
	  "fyi",
	  "ga",
	  "gal",
	  "gallery",
	  "gallo",
	  "gallup",
	  "game",
	  "games",
	  "gap",
	  "garden",
	  "gay",
	  "gb",
	  "gbiz",
	  "gd",
	  "gdn",
	  "ge",
	  "gea",
	  "gent",
	  "genting",
	  "george",
	  "gf",
	  "gg",
	  "ggee",
	  "gh",
	  "gi",
	  "gift",
	  "gifts",
	  "gives",
	  "giving",
	  "gl",
	  "glade",
	  "glass",
	  "gle",
	  "global",
	  "globo",
	  "gm",
	  "gmail",
	  "gmbh",
	  "gmo",
	  "gmx",
	  "gn",
	  "godaddy",
	  "gold",
	  "goldpoint",
	  "golf",
	  "goo",
	  "goodyear",
	  "goog",
	  "google",
	  "gop",
	  "got",
	  "gov",
	  "gp",
	  "gq",
	  "gr",
	  "grainger",
	  "graphics",
	  "gratis",
	  "green",
	  "gripe",
	  "grocery",
	  "group",
	  "gs",
	  "gt",
	  "gu",
	  "guardian",
	  "gucci",
	  "guge",
	  "guide",
	  "guitars",
	  "guru",
	  "gw",
	  "gy",
	  "hair",
	  "hamburg",
	  "hangout",
	  "haus",
	  "hbo",
	  "hdfc",
	  "hdfcbank",
	  "health",
	  "healthcare",
	  "help",
	  "helsinki",
	  "here",
	  "hermes",
	  "hgtv",
	  "hiphop",
	  "hisamitsu",
	  "hitachi",
	  "hiv",
	  "hk",
	  "hkt",
	  "hm",
	  "hn",
	  "hockey",
	  "holdings",
	  "holiday",
	  "homedepot",
	  "homegoods",
	  "homes",
	  "homesense",
	  "honda",
	  "horse",
	  "hospital",
	  "host",
	  "hosting",
	  "hot",
	  "hoteles",
	  "hotels",
	  "hotmail",
	  "house",
	  "how",
	  "hr",
	  "hsbc",
	  "ht",
	  "hu",
	  "hughes",
	  "hyatt",
	  "hyundai",
	  "ibm",
	  "icbc",
	  "ice",
	  "icu",
	  "id",
	  "ie",
	  "ieee",
	  "ifm",
	  "ikano",
	  "il",
	  "im",
	  "imamat",
	  "imdb",
	  "immo",
	  "immobilien",
	  "in",
	  "inc",
	  "industries",
	  "infiniti",
	  "info",
	  "ing",
	  "ink",
	  "institute",
	  "insurance",
	  "insure",
	  "int",
	  "intel",
	  "international",
	  "intuit",
	  "investments",
	  "io",
	  "ipiranga",
	  "iq",
	  "ir",
	  "irish",
	  "is",
	  "ismaili",
	  "ist",
	  "istanbul",
	  "it",
	  "itau",
	  "itv",
	  "iveco",
	  "jaguar",
	  "java",
	  "jcb",
	  "jcp",
	  "je",
	  "jeep",
	  "jetzt",
	  "jewelry",
	  "jio",
	  "jll",
	  "jm",
	  "jmp",
	  "jnj",
	  "jo",
	  "jobs",
	  "joburg",
	  "jot",
	  "joy",
	  "jp",
	  "jpmorgan",
	  "jprs",
	  "juegos",
	  "juniper",
	  "kaufen",
	  "kddi",
	  "ke",
	  "kerryhotels",
	  "kerrylogistics",
	  "kerryproperties",
	  "kfh",
	  "kg",
	  "kh",
	  "ki",
	  "kia",
	  "kim",
	  "kinder",
	  "kindle",
	  "kitchen",
	  "kiwi",
	  "km",
	  "kn",
	  "koeln",
	  "komatsu",
	  "kosher",
	  "kp",
	  "kpmg",
	  "kpn",
	  "kr",
	  "krd",
	  "kred",
	  "kuokgroup",
	  "kw",
	  "ky",
	  "kyoto",
	  "kz",
	  "la",
	  "lacaixa",
	  "lamborghini",
	  "lamer",
	  "lancaster",
	  "lancia",
	  "land",
	  "landrover",
	  "lanxess",
	  "lasalle",
	  "lat",
	  "latino",
	  "latrobe",
	  "law",
	  "lawyer",
	  "lb",
	  "lc",
	  "lds",
	  "lease",
	  "leclerc",
	  "lefrak",
	  "legal",
	  "lego",
	  "lexus",
	  "lgbt",
	  "li",
	  "lidl",
	  "life",
	  "lifeinsurance",
	  "lifestyle",
	  "lighting",
	  "like",
	  "lilly",
	  "limited",
	  "limo",
	  "lincoln",
	  "linde",
	  "link",
	  "lipsy",
	  "live",
	  "living",
	  "lixil",
	  "lk",
	  "llc",
	  "llp",
	  "loan",
	  "loans",
	  "locker",
	  "locus",
	  "loft",
	  "lol",
	  "london",
	  "lotte",
	  "lotto",
	  "love",
	  "lpl",
	  "lplfinancial",
	  "lr",
	  "ls",
	  "lt",
	  "ltd",
	  "ltda",
	  "lu",
	  "lundbeck",
	  "lupin",
	  "luxe",
	  "luxury",
	  "lv",
	  "ly",
	  "ma",
	  "macys",
	  "madrid",
	  "maif",
	  "maison",
	  "makeup",
	  "man",
	  "management",
	  "mango",
	  "map",
	  "market",
	  "marketing",
	  "markets",
	  "marriott",
	  "marshalls",
	  "maserati",
	  "mattel",
	  "mba",
	  "mc",
	  "mckinsey",
	  "md",
	  "me",
	  "med",
	  "media",
	  "meet",
	  "melbourne",
	  "meme",
	  "memorial",
	  "men",
	  "menu",
	  "merckmsd",
	  "metlife",
	  "mg",
	  "mh",
	  "miami",
	  "microsoft",
	  "mil",
	  "mini",
	  "mint",
	  "mit",
	  "mitsubishi",
	  "mk",
	  "ml",
	  "mlb",
	  "mls",
	  "mm",
	  "mma",
	  "mn",
	  "mo",
	  "mobi",
	  "mobile",
	  "moda",
	  "moe",
	  "moi",
	  "mom",
	  "monash",
	  "money",
	  "monster",
	  "mormon",
	  "mortgage",
	  "moscow",
	  "moto",
	  "motorcycles",
	  "mov",
	  "movie",
	  "mp",
	  "mq",
	  "mr",
	  "ms",
	  "msd",
	  "mt",
	  "mtn",
	  "mtr",
	  "mu",
	  "museum",
	  "mutual",
	  "mv",
	  "mw",
	  "mx",
	  "my",
	  "mz",
	  "na",
	  "nab",
	  "nagoya",
	  "name",
	  "nationwide",
	  "natura",
	  "navy",
	  "nba",
	  "nc",
	  "ne",
	  "nec",
	  "net",
	  "netbank",
	  "netflix",
	  "network",
	  "neustar",
	  "new",
	  "newholland",
	  "news",
	  "next",
	  "nextdirect",
	  "nexus",
	  "nf",
	  "nfl",
	  "ng",
	  "ngo",
	  "nhk",
	  "ni",
	  "nico",
	  "nike",
	  "nikon",
	  "ninja",
	  "nissan",
	  "nissay",
	  "nl",
	  "no",
	  "nokia",
	  "northwesternmutual",
	  "norton",
	  "now",
	  "nowruz",
	  "nowtv",
	  "np",
	  "nr",
	  "nra",
	  "nrw",
	  "ntt",
	  "nu",
	  "nyc",
	  "nz",
	  "obi",
	  "observer",
	  "off",
	  "office",
	  "okinawa",
	  "olayan",
	  "olayangroup",
	  "oldnavy",
	  "ollo",
	  "om",
	  "omega",
	  "one",
	  "ong",
	  "onl",
	  "online",
	  "onyourside",
	  "ooo",
	  "open",
	  "oracle",
	  "orange",
	  "org",
	  "organic",
	  "origins",
	  "osaka",
	  "otsuka",
	  "ott",
	  "ovh",
	  "pa",
	  "page",
	  "panasonic",
	  "paris",
	  "pars",
	  "partners",
	  "parts",
	  "party",
	  "passagens",
	  "pay",
	  "pccw",
	  "pe",
	  "pet",
	  "pf",
	  "pfizer",
	  "pg",
	  "ph",
	  "pharmacy",
	  "phd",
	  "philips",
	  "phone",
	  "photo",
	  "photography",
	  "photos",
	  "physio",
	  "pics",
	  "pictet",
	  "pictures",
	  "pid",
	  "pin",
	  "ping",
	  "pink",
	  "pioneer",
	  "pizza",
	  "pk",
	  "pl",
	  "place",
	  "play",
	  "playstation",
	  "plumbing",
	  "plus",
	  "pm",
	  "pn",
	  "pnc",
	  "pohl",
	  "poker",
	  "politie",
	  "porn",
	  "post",
	  "pr",
	  "pramerica",
	  "praxi",
	  "press",
	  "prime",
	  "pro",
	  "prod",
	  "productions",
	  "prof",
	  "progressive",
	  "promo",
	  "properties",
	  "property",
	  "protection",
	  "pru",
	  "prudential",
	  "ps",
	  "pt",
	  "pub",
	  "pw",
	  "pwc",
	  "py",
	  "qa",
	  "qpon",
	  "quebec",
	  "quest",
	  "qvc",
	  "racing",
	  "radio",
	  "raid",
	  "re",
	  "read",
	  "realestate",
	  "realtor",
	  "realty",
	  "recipes",
	  "red",
	  "redstone",
	  "redumbrella",
	  "rehab",
	  "reise",
	  "reisen",
	  "reit",
	  "reliance",
	  "ren",
	  "rent",
	  "rentals",
	  "repair",
	  "report",
	  "republican",
	  "rest",
	  "restaurant",
	  "review",
	  "reviews",
	  "rexroth",
	  "rich",
	  "richardli",
	  "ricoh",
	  "ril",
	  "rio",
	  "rip",
	  "rmit",
	  "ro",
	  "rocher",
	  "rocks",
	  "rodeo",
	  "rogers",
	  "room",
	  "rs",
	  "rsvp",
	  "ru",
	  "rugby",
	  "ruhr",
	  "run",
	  "rw",
	  "rwe",
	  "ryukyu",
	  "sa",
	  "saarland",
	  "safe",
	  "safety",
	  "sakura",
	  "sale",
	  "salon",
	  "samsclub",
	  "samsung",
	  "sandvik",
	  "sandvikcoromant",
	  "sanofi",
	  "sap",
	  "sarl",
	  "sas",
	  "save",
	  "saxo",
	  "sb",
	  "sbi",
	  "sbs",
	  "sc",
	  "sca",
	  "scb",
	  "schaeffler",
	  "schmidt",
	  "scholarships",
	  "school",
	  "schule",
	  "schwarz",
	  "science",
	  "scjohnson",
	  "scot",
	  "sd",
	  "se",
	  "search",
	  "seat",
	  "secure",
	  "security",
	  "seek",
	  "select",
	  "sener",
	  "services",
	  "ses",
	  "seven",
	  "sew",
	  "sex",
	  "sexy",
	  "sfr",
	  "sg",
	  "sh",
	  "shangrila",
	  "sharp",
	  "shaw",
	  "shell",
	  "shia",
	  "shiksha",
	  "shoes",
	  "shop",
	  "shopping",
	  "shouji",
	  "show",
	  "showtime",
	  "shriram",
	  "si",
	  "silk",
	  "sina",
	  "singles",
	  "site",
	  "sj",
	  "sk",
	  "ski",
	  "skin",
	  "sky",
	  "skype",
	  "sl",
	  "sling",
	  "sm",
	  "smart",
	  "smile",
	  "sn",
	  "sncf",
	  "so",
	  "soccer",
	  "social",
	  "softbank",
	  "software",
	  "sohu",
	  "solar",
	  "solutions",
	  "song",
	  "sony",
	  "soy",
	  "space",
	  "sport",
	  "spot",
	  "spreadbetting",
	  "sr",
	  "srl",
	  "ss",
	  "st",
	  "stada",
	  "staples",
	  "star",
	  "statebank",
	  "statefarm",
	  "stc",
	  "stcgroup",
	  "stockholm",
	  "storage",
	  "store",
	  "stream",
	  "studio",
	  "study",
	  "style",
	  "su",
	  "sucks",
	  "supplies",
	  "supply",
	  "support",
	  "surf",
	  "surgery",
	  "suzuki",
	  "sv",
	  "swatch",
	  "swiftcover",
	  "swiss",
	  "sx",
	  "sy",
	  "sydney",
	  "systems",
	  "sz",
	  "tab",
	  "taipei",
	  "talk",
	  "taobao",
	  "target",
	  "tatamotors",
	  "tatar",
	  "tattoo",
	  "tax",
	  "taxi",
	  "tc",
	  "tci",
	  "td",
	  "tdk",
	  "team",
	  "tech",
	  "technology",
	  "tel",
	  "temasek",
	  "tennis",
	  "teva",
	  "tf",
	  "tg",
	  "th",
	  "thd",
	  "theater",
	  "theatre",
	  "tiaa",
	  "tickets",
	  "tienda",
	  "tiffany",
	  "tips",
	  "tires",
	  "tirol",
	  "tj",
	  "tjmaxx",
	  "tjx",
	  "tk",
	  "tkmaxx",
	  "tl",
	  "tm",
	  "tmall",
	  "tn",
	  "to",
	  "today",
	  "tokyo",
	  "tools",
	  "top",
	  "toray",
	  "toshiba",
	  "total",
	  "tours",
	  "town",
	  "toyota",
	  "toys",
	  "tr",
	  "trade",
	  "trading",
	  "training",
	  "travel",
	  "travelchannel",
	  "travelers",
	  "travelersinsurance",
	  "trust",
	  "trv",
	  "tt",
	  "tube",
	  "tui",
	  "tunes",
	  "tushu",
	  "tv",
	  "tvs",
	  "tw",
	  "tz",
	  "ua",
	  "ubank",
	  "ubs",
	  "ug",
	  "uk",
	  "unicom",
	  "university",
	  "uno",
	  "uol",
	  "ups",
	  "us",
	  "uy",
	  "uz",
	  "va",
	  "vacations",
	  "vana",
	  "vanguard",
	  "vc",
	  "ve",
	  "vegas",
	  "ventures",
	  "verisign",
	  "versicherung",
	  "vet",
	  "vg",
	  "vi",
	  "viajes",
	  "video",
	  "vig",
	  "viking",
	  "villas",
	  "vin",
	  "vip",
	  "virgin",
	  "visa",
	  "vision",
	  "viva",
	  "vivo",
	  "vlaanderen",
	  "vn",
	  "vodka",
	  "volkswagen",
	  "volvo",
	  "vote",
	  "voting",
	  "voto",
	  "voyage",
	  "vu",
	  "vuelos",
	  "wales",
	  "walmart",
	  "walter",
	  "wang",
	  "wanggou",
	  "watch",
	  "watches",
	  "weather",
	  "weatherchannel",
	  "webcam",
	  "weber",
	  "website",
	  "wed",
	  "wedding",
	  "weibo",
	  "weir",
	  "wf",
	  "whoswho",
	  "wien",
	  "wiki",
	  "williamhill",
	  "win",
	  "windows",
	  "wine",
	  "winners",
	  "wme",
	  "wolterskluwer",
	  "woodside",
	  "work",
	  "works",
	  "world",
	  "wow",
	  "ws",
	  "wtc",
	  "wtf",
	  "xbox",
	  "xerox",
	  "xfinity",
	  "xihuan",
	  "xin",
	  "कॉम", // xn--11b4c3d
	  "セール", // xn--1ck2e1b
	  "佛山", // xn--1qqw23a
	  "ಭಾರತ", // xn--2scrj9c
	  "慈善", // xn--30rr7y
	  "集团", // xn--3bst00m
	  "在线", // xn--3ds443g
	  "한국", // xn--3e0b707e
	  "ଭାରତ", // xn--3hcrj9c
	  "大众汽车", // xn--3oq18vl8pn36a
	  "点看", // xn--3pxu8k
	  "คอม", // xn--42c2d9a
	  "ভাৰত", // xn--45br5cyl
	  "ভারত", // xn--45brj9c
	  "八卦", // xn--45q11c
	  "موقع", // xn--4gbrim
	  "বাংলা", // xn--54b7fta0cc
	  "公益", // xn--55qw42g
	  "公司", // xn--55qx5d
	  "香格里拉", // xn--5su34j936bgsg
	  "网站", // xn--5tzm5g
	  "移动", // xn--6frz82g
	  "我爱你", // xn--6qq986b3xl
	  "москва", // xn--80adxhks
	  "қаз", // xn--80ao21a
	  "католик", // xn--80aqecdr1a
	  "онлайн", // xn--80asehdb
	  "сайт", // xn--80aswg
	  "联通", // xn--8y0a063a
	  "срб", // xn--90a3ac
	  "бг", // xn--90ae
	  "бел", // xn--90ais
	  "קום", // xn--9dbq2a
	  "时尚", // xn--9et52u
	  "微博", // xn--9krt00a
	  "淡马锡", // xn--b4w605ferd
	  "ファッション", // xn--bck1b9a5dre4c
	  "орг", // xn--c1avg
	  "नेट", // xn--c2br7g
	  "ストア", // xn--cck2b3b
	  "アマゾン", // xn--cckwcxetd
	  "삼성", // xn--cg4bki
	  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
	  "商标", // xn--czr694b
	  "商店", // xn--czrs0t
	  "商城", // xn--czru2d
	  "дети", // xn--d1acj3b
	  "мкд", // xn--d1alf
	  "ею", // xn--e1a4c
	  "ポイント", // xn--eckvdtc9d
	  "新闻", // xn--efvy88h
	  "家電", // xn--fct429k
	  "كوم", // xn--fhbei
	  "中文网", // xn--fiq228c5hs
	  "中信", // xn--fiq64b
	  "中国", // xn--fiqs8s
	  "中國", // xn--fiqz9s
	  "娱乐", // xn--fjq720a
	  "谷歌", // xn--flw351e
	  "భారత్", // xn--fpcrj9c3d
	  "ලංකා", // xn--fzc2c9e2c
	  "電訊盈科", // xn--fzys8d69uvgm
	  "购物", // xn--g2xx48c
	  "クラウド", // xn--gckr3f0f
	  "ભારત", // xn--gecrj9c
	  "通販", // xn--gk3at1e
	  "भारतम्", // xn--h2breg3eve
	  "भारत", // xn--h2brj9c
	  "भारोत", // xn--h2brj9c8c
	  "网店", // xn--hxt814e
	  "संगठन", // xn--i1b6b1a6a2e
	  "餐厅", // xn--imr513n
	  "网络", // xn--io0a7i
	  "ком", // xn--j1aef
	  "укр", // xn--j1amh
	  "香港", // xn--j6w193g
	  "亚马逊", // xn--jlq480n2rg
	  "诺基亚", // xn--jlq61u9w7b
	  "食品", // xn--jvr189m
	  "飞利浦", // xn--kcrx77d1x4a
	  "台湾", // xn--kprw13d
	  "台灣", // xn--kpry57d
	  "手机", // xn--kput3i
	  "мон", // xn--l1acc
	  "الجزائر", // xn--lgbbat1ad8j
	  "عمان", // xn--mgb9awbf
	  "ارامكو", // xn--mgba3a3ejt
	  "ایران", // xn--mgba3a4f16a
	  "العليان", // xn--mgba7c0bbn0a
	  "اتصالات", // xn--mgbaakc7dvf
	  "امارات", // xn--mgbaam7a8h
	  "بازار", // xn--mgbab2bd
	  "موريتانيا", // xn--mgbah1a3hjkrd
	  "پاکستان", // xn--mgbai9azgqp6j
	  "الاردن", // xn--mgbayh7gpa
	  "بارت", // xn--mgbbh1a
	  "بھارت", // xn--mgbbh1a71e
	  "المغرب", // xn--mgbc0a9azcg
	  "ابوظبي", // xn--mgbca7dzdo
	  "البحرين", // xn--mgbcpq6gpa1a
	  "السعودية", // xn--mgberp4a5d4ar
	  "ڀارت", // xn--mgbgu82a
	  "كاثوليك", // xn--mgbi4ecexp
	  "سودان", // xn--mgbpl2fh
	  "همراه", // xn--mgbt3dhd
	  "عراق", // xn--mgbtx2b
	  "مليسيا", // xn--mgbx4cd0ab
	  "澳門", // xn--mix891f
	  "닷컴", // xn--mk1bu44c
	  "政府", // xn--mxtq1m
	  "شبكة", // xn--ngbc5azd
	  "بيتك", // xn--ngbe9e0a
	  "عرب", // xn--ngbrx
	  "გე", // xn--node
	  "机构", // xn--nqv7f
	  "组织机构", // xn--nqv7fs00ema
	  "健康", // xn--nyqy26a
	  "ไทย", // xn--o3cw4h
	  "سورية", // xn--ogbpf8fl
	  "招聘", // xn--otu796d
	  "рус", // xn--p1acf
	  "рф", // xn--p1ai
	  "تونس", // xn--pgbs0dh
	  "大拿", // xn--pssy2u
	  "ລາວ", // xn--q7ce6a
	  "みんな", // xn--q9jyb4c
	  "グーグル", // xn--qcka1pmc
	  "ευ", // xn--qxa6a
	  "ελ", // xn--qxam
	  "世界", // xn--rhqv96g
	  "書籍", // xn--rovu88b
	  "ഭാരതം", // xn--rvc1e0am3e
	  "ਭਾਰਤ", // xn--s9brj9c
	  "网址", // xn--ses554g
	  "닷넷", // xn--t60b56a
	  "コム", // xn--tckwe
	  "天主教", // xn--tiq49xqyj
	  "游戏", // xn--unup4y
	  "vermögensberater", // xn--vermgensberater-ctb
	  "vermögensberatung", // xn--vermgensberatung-pwb
	  "企业", // xn--vhquv
	  "信息", // xn--vuq861b
	  "嘉里大酒店", // xn--w4r85el8fhu5dnra
	  "嘉里", // xn--w4rs40l
	  "مصر", // xn--wgbh1c
	  "قطر", // xn--wgbl6a
	  "广东", // xn--xhq521b
	  "இலங்கை", // xn--xkc2al3hye2a
	  "இந்தியா", // xn--xkc2dl3a5ee0h
	  "հայ", // xn--y9a3aq
	  "新加坡", // xn--yfro4i67o
	  "فلسطين", // xn--ygbi2ammx
	  "政务", // xn--zfr164b
	  "xxx",
	  "xyz",
	  "yachts",
	  "yahoo",
	  "yamaxun",
	  "yandex",
	  "ye",
	  "yodobashi",
	  "yoga",
	  "yokohama",
	  "you",
	  "youtube",
	  "yt",
	  "yun",
	  "za",
	  "zappos",
	  "zara",
	  "zero",
	  "zip",
	  "zm",
	  "zone",
	  "zuerich",
	  "zw"
	];


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	var traverse = module.exports = function (obj) {
	    return new Traverse(obj);
	};
	
	function Traverse (obj) {
	    this.value = obj;
	}
	
	Traverse.prototype.get = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            node = undefined;
	            break;
	        }
	        node = node[key];
	    }
	    return node;
	};
	
	Traverse.prototype.has = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            return false;
	        }
	        node = node[key];
	    }
	    return true;
	};
	
	Traverse.prototype.set = function (ps, value) {
	    var node = this.value;
	    for (var i = 0; i < ps.length - 1; i ++) {
	        var key = ps[i];
	        if (!hasOwnProperty.call(node, key)) node[key] = {};
	        node = node[key];
	    }
	    node[ps[i]] = value;
	    return value;
	};
	
	Traverse.prototype.map = function (cb) {
	    return walk(this.value, cb, true);
	};
	
	Traverse.prototype.forEach = function (cb) {
	    this.value = walk(this.value, cb, false);
	    return this.value;
	};
	
	Traverse.prototype.reduce = function (cb, init) {
	    var skip = arguments.length === 1;
	    var acc = skip ? this.value : init;
	    this.forEach(function (x) {
	        if (!this.isRoot || !skip) {
	            acc = cb.call(this, acc, x);
	        }
	    });
	    return acc;
	};
	
	Traverse.prototype.paths = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.path); 
	    });
	    return acc;
	};
	
	Traverse.prototype.nodes = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.node);
	    });
	    return acc;
	};
	
	Traverse.prototype.clone = function () {
	    var parents = [], nodes = [];
	    
	    return (function clone (src) {
	        for (var i = 0; i < parents.length; i++) {
	            if (parents[i] === src) {
	                return nodes[i];
	            }
	        }
	        
	        if (typeof src === 'object' && src !== null) {
	            var dst = copy(src);
	            
	            parents.push(src);
	            nodes.push(dst);
	            
	            forEach(objectKeys(src), function (key) {
	                dst[key] = clone(src[key]);
	            });
	            
	            parents.pop();
	            nodes.pop();
	            return dst;
	        }
	        else {
	            return src;
	        }
	    })(this.value);
	};
	
	function walk (root, cb, immutable) {
	    var path = [];
	    var parents = [];
	    var alive = true;
	    
	    return (function walker (node_) {
	        var node = immutable ? copy(node_) : node_;
	        var modifiers = {};
	        
	        var keepGoing = true;
	        
	        var state = {
	            node : node,
	            node_ : node_,
	            path : [].concat(path),
	            parent : parents[parents.length - 1],
	            parents : parents,
	            key : path.slice(-1)[0],
	            isRoot : path.length === 0,
	            level : path.length,
	            circular : null,
	            update : function (x, stopHere) {
	                if (!state.isRoot) {
	                    state.parent.node[state.key] = x;
	                }
	                state.node = x;
	                if (stopHere) keepGoing = false;
	            },
	            'delete' : function (stopHere) {
	                delete state.parent.node[state.key];
	                if (stopHere) keepGoing = false;
	            },
	            remove : function (stopHere) {
	                if (isArray(state.parent.node)) {
	                    state.parent.node.splice(state.key, 1);
	                }
	                else {
	                    delete state.parent.node[state.key];
	                }
	                if (stopHere) keepGoing = false;
	            },
	            keys : null,
	            before : function (f) { modifiers.before = f },
	            after : function (f) { modifiers.after = f },
	            pre : function (f) { modifiers.pre = f },
	            post : function (f) { modifiers.post = f },
	            stop : function () { alive = false },
	            block : function () { keepGoing = false }
	        };
	        
	        if (!alive) return state;
	        
	        function updateState() {
	            if (typeof state.node === 'object' && state.node !== null) {
	                if (!state.keys || state.node_ !== state.node) {
	                    state.keys = objectKeys(state.node)
	                }
	                
	                state.isLeaf = state.keys.length == 0;
	                
	                for (var i = 0; i < parents.length; i++) {
	                    if (parents[i].node_ === node_) {
	                        state.circular = parents[i];
	                        break;
	                    }
	                }
	            }
	            else {
	                state.isLeaf = true;
	                state.keys = null;
	            }
	            
	            state.notLeaf = !state.isLeaf;
	            state.notRoot = !state.isRoot;
	        }
	        
	        updateState();
	        
	        // use return values to update if defined
	        var ret = cb.call(state, state.node);
	        if (ret !== undefined && state.update) state.update(ret);
	        
	        if (modifiers.before) modifiers.before.call(state, state.node);
	        
	        if (!keepGoing) return state;
	        
	        if (typeof state.node == 'object'
	        && state.node !== null && !state.circular) {
	            parents.push(state);
	            
	            updateState();
	            
	            forEach(state.keys, function (key, i) {
	                path.push(key);
	                
	                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
	                
	                var child = walker(state.node[key]);
	                if (immutable && hasOwnProperty.call(state.node, key)) {
	                    state.node[key] = child.node;
	                }
	                
	                child.isLast = i == state.keys.length - 1;
	                child.isFirst = i == 0;
	                
	                if (modifiers.post) modifiers.post.call(state, child);
	                
	                path.pop();
	            });
	            parents.pop();
	        }
	        
	        if (modifiers.after) modifiers.after.call(state, state.node);
	        
	        return state;
	    })(root).node;
	}
	
	function copy (src) {
	    if (typeof src === 'object' && src !== null) {
	        var dst;
	        
	        if (isArray(src)) {
	            dst = [];
	        }
	        else if (isDate(src)) {
	            dst = new Date(src.getTime ? src.getTime() : src);
	        }
	        else if (isRegExp(src)) {
	            dst = new RegExp(src);
	        }
	        else if (isError(src)) {
	            dst = { message: src.message };
	        }
	        else if (isBoolean(src)) {
	            dst = new Boolean(src);
	        }
	        else if (isNumber(src)) {
	            dst = new Number(src);
	        }
	        else if (isString(src)) {
	            dst = new String(src);
	        }
	        else if (Object.create && Object.getPrototypeOf) {
	            dst = Object.create(Object.getPrototypeOf(src));
	        }
	        else if (src.constructor === Object) {
	            dst = {};
	        }
	        else {
	            var proto =
	                (src.constructor && src.constructor.prototype)
	                || src.__proto__
	                || {}
	            ;
	            var T = function () {};
	            T.prototype = proto;
	            dst = new T;
	        }
	        
	        forEach(objectKeys(src), function (key) {
	            dst[key] = src[key];
	        });
	        return dst;
	    }
	    else return src;
	}
	
	var objectKeys = Object.keys || function keys (obj) {
	    var res = [];
	    for (var key in obj) res.push(key)
	    return res;
	};
	
	function toS (obj) { return Object.prototype.toString.call(obj) }
	function isDate (obj) { return toS(obj) === '[object Date]' }
	function isRegExp (obj) { return toS(obj) === '[object RegExp]' }
	function isError (obj) { return toS(obj) === '[object Error]' }
	function isBoolean (obj) { return toS(obj) === '[object Boolean]' }
	function isNumber (obj) { return toS(obj) === '[object Number]' }
	function isString (obj) { return toS(obj) === '[object String]' }
	
	var isArray = Array.isArray || function isArray (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	var forEach = function (xs, fn) {
	    if (xs.forEach) return xs.forEach(fn)
	    else for (var i = 0; i < xs.length; i++) {
	        fn(xs[i], i, xs);
	    }
	};
	
	forEach(objectKeys(Traverse.prototype), function (key) {
	    traverse[key] = function (obj) {
	        var args = [].slice.call(arguments, 1);
	        var t = new Traverse(obj);
	        return t[key].apply(t, args);
	    };
	});
	
	var hasOwnProperty = Object.hasOwnProperty || function (obj, key) {
	    return key in obj;
	};


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	module.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	module.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)(module), (function() { return this; }())))

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(1247);
	var util = __webpack_require__(1249);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1054);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
	O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
	function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
	function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
	ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
	d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
	var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
	Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js